webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(1218);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Api = exports.fetch = exports.buildUrl = undefined;

var _omniCommonUi = __webpack_require__(0);

var buildUrl = exports.buildUrl = _omniCommonUi.buildUrl;
var fetch = exports.fetch = _omniCommonUi.fetch;
var Api = exports.Api = { fetch: fetch, buildUrl: buildUrl };
exports.default = Api;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  MarkAttendance: {
    ViewDayView: 'P020101',
    MarkDayView: 'P020102',
    ViewCourseView: 'P020103',
    MarkCourseView: 'P020104',
    MarkNotApplicable: 'P020105',
    ViewHistory: 'P020106',
    IgnoreFinanceDate: 'P020107'
  },
  ProgressTest: {
    View: 'P020201',
    Edit: 'P020202',
    ReTake: 'P020206',
    ViewHistory: 'P020208',
    EditAppSkillScores: 'P020209'
  },
  ProgressReport: {
    View: 'P020501',
    Publish: 'P020502',
    AddComment: 'P020503',
    ApproveComment: 'P020504',
    Export: 'P020506',
    UpdatePublishedProgressReport: 'P020507'
  },
  Homework: {
    View: 'P020301',
    ViewAssignments: 'P020302',
    Mark: 'P020303'
  },
  AssignHomework: {
    View: 'P020701',
    ManageOwn: 'P020702', // previously: Add
    Publish: 'P020703',
    EditAny: 'P020704' // previously: EditOthers
  },
  GroupDashboard: {
    ViewGroupDashboard: 'P020601',
    ViewGroupBasicInfo: 'P020602',
    ViewGroupMemberInfo: 'P020603',
    ViewStaffTasksInformation: 'P020604'
  },
  CoveredInClass: {
    ViewCoveredInClass: 'P020401',
    MarkAndPublish: 'P020402',
    AddCommentToInternal: 'P020404',
    PrintCoveredInClass: 'P020405'
  },
  IndividualDevelopmentPlan: {
    View: 'P020801',
    Manage: 'P020802',
    ApproveComment: 'P020803'
  },
  AcademicInfo: {
    View: 'P020901',
    AddStudentNotes: 'P022401'
  },
  GroupTask: {
    CancelGroupTask: 'P021101'
  }
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = exports.Group = exports.reducer = exports.routes = undefined;

var _routes2 = __webpack_require__(1220);

var _routes3 = _interopRequireDefault(_routes2);

var _reducer2 = __webpack_require__(2069);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(838);

var _model2 = _interopRequireDefault(_model);

var _actions2 = __webpack_require__(158);

var _actions = _interopRequireWildcard(_actions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
var reducer = exports.reducer = _reducer3.default;
var Group = exports.Group = _model2.default;
var actions = exports.actions = _actions;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupMember = exports.reducer = exports.accessors = exports.actions = undefined;

var _actions2 = __webpack_require__(194);

var _actions = _interopRequireWildcard(_actions2);

var _accessors2 = __webpack_require__(195);

var _accessors = _interopRequireWildcard(_accessors2);

var _reducer2 = __webpack_require__(1226);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(278);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var accessors = exports.accessors = _accessors;
var reducer = exports.reducer = _reducer3.default;
var GroupMember = exports.GroupMember = _model2.default;

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabCodes = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TabCodes2 = __webpack_require__(1224);

var _TabCodes3 = _interopRequireDefault(_TabCodes2);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TabSwitcher = function () {
  function TabSwitcher() {
    _classCallCheck(this, TabSwitcher);
  }

  _createClass(TabSwitcher, null, [{
    key: 'isTabEnabled',
    value: function isTabEnabled(state, groupId, tabCode) {
      var group = state.get('rootReducer').get('groups').get(groupId);
      // Let it get api response then do checking
      if (!group || !group.data) return true;
      var enabledTabCodes = group.data && group.data.enabledModuleCodes;

      // Preserve backward compatibility
      if (_is_js2.default.undefined(enabledTabCodes)) return true;

      return enabledTabCodes.includes(tabCode);
    }
  }]);

  return TabSwitcher;
}();

exports.default = TabSwitcher;


TabSwitcher.TabCodes = _TabCodes3.default;

var TabCodes = exports.TabCodes = _TabCodes3.default;

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessors = exports.actions = exports.idpParticipation = exports.idpApprovalList = exports.individualDevelopmentPlan = exports.individualDevelopmentPlanList = undefined;

var _actions2 = __webpack_require__(168);

var _actions = _interopRequireWildcard(_actions2);

var _reducer = __webpack_require__(1739);

var _accessors2 = __webpack_require__(1758);

var _accessors = _interopRequireWildcard(_accessors2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var individualDevelopmentPlanList = exports.individualDevelopmentPlanList = _reducer.individualDevelopmentPlanList;
var individualDevelopmentPlan = exports.individualDevelopmentPlan = _reducer.individualDevelopmentPlan;
var idpApprovalList = exports.idpApprovalList = _reducer.idpApprovalList;
var idpParticipation = exports.idpParticipation = _reducer.idpParticipation;
var actions = exports.actions = _actions;
var accessors = exports.accessors = _accessors;

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(629);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1385);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsavedChangesTrackingPageComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import { withRouter } from 'react-router';


var ONBEFOREUNLOAD_MSG = 'Changes you made will not be saved unless you click "Save".';

var UnsavedChangesTrackingPageComponent = exports.UnsavedChangesTrackingPageComponent = function (_Component) {
  _inherits(UnsavedChangesTrackingPageComponent, _Component);

  function UnsavedChangesTrackingPageComponent(props) {
    _classCallCheck(this, UnsavedChangesTrackingPageComponent);

    var _this = _possibleConstructorReturn(this, (UnsavedChangesTrackingPageComponent.__proto__ || Object.getPrototypeOf(UnsavedChangesTrackingPageComponent)).call(this, props));

    _this.state = _is_js2.default.object(_this.state) ? _this.state : {};
    Object.assign(_this.state, {
      // these are set in this._forcePushRoute() and observed in routerWillLeave()
      allowRouteLeave: false,
      isRouterLeaveConfirmed: false,
      routerLeaveNextLocation: null
    });
    return _this;
  }

  _createClass(UnsavedChangesTrackingPageComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._bindRouterWillLeaveHook();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.location && prevProps.location.pathname === this.props.location.pathname) return;
      // we're in a different route but the same component is mounted; bind the hook again
      this._bindRouterWillLeaveHook();
    }
  }, {
    key: '_bindRouterWillLeaveHook',
    value: function _bindRouterWillLeaveHook() {
      if (!this.props.router || !this.props.route) {
        _omniCommonUi.log.error('`router` or `route` props not available in UnsavedChangesTrackingPageComponent!');
        return;
      }
      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
    }

    // override this if needed

  }, {
    key: '_isChangesPresent',
    value: function _isChangesPresent() {
      return this.props.marking;
    }
  }, {
    key: '_isNavigationWithChangesRequested',
    value: function _isNavigationWithChangesRequested() {
      return !!this.state.routerLeaveNextLocation;
    }
  }, {
    key: '_clearRequestedLocation',
    value: function _clearRequestedLocation() {
      this.setState({ routerLeaveNextLocation: null });
    }
  }, {
    key: '_forcePushRoute',
    value: function _forcePushRoute(route) {
      var _this2 = this;

      var otherState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var stateNavMutexKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'allowRouteLeave';

      this.setState(Object.assign({}, otherState, _defineProperty({}, stateNavMutexKey, true)), function () {
        _this2.props.pushRoute(route);
        _this2.setState(_defineProperty({}, stateNavMutexKey, false));
      });
    }
  }, {
    key: '_forcePushRequestedLocation',
    value: function _forcePushRequestedLocation() {
      var routerLeaveNextLocation = this.state.routerLeaveNextLocation;

      this._forcePushRoute(routerLeaveNextLocation, {
        routerLeaveNextLocation: null
      }, 'isRouterLeaveConfirmed');
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave(nextLocation) {
      if (!this.state.isRouterLeaveConfirmed && !this.state.allowRouteLeave && this._isChangesPresent()) {
        this.setState({ routerLeaveNextLocation: nextLocation });
        if (!nextLocation) {
          // During the beforeunload event routerWillLeave does not receive a location object
          // because it isn't possible for it to know the location we're transitioning to.
          return ONBEFOREUNLOAD_MSG;
        }
        return false;
      }
    }
  }]);

  return UnsavedChangesTrackingPageComponent;
}(_react.Component);

UnsavedChangesTrackingPageComponent.propTypes = Object.freeze({
  route: _propTypes2.default.any.isRequired,
  router: _propTypes2.default.any.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  marking: _propTypes2.default.bool
});

// export default withRouter(UnsavedChangesTrackingPageComponent);  // does not seem to work
exports.default = UnsavedChangesTrackingPageComponent;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(1395);

var _component2 = _interopRequireDefault(_component);

var _TableWithExpandablePanel = __webpack_require__(201);

var _TableWithExpandablePanel2 = _interopRequireDefault(_TableWithExpandablePanel);

var _Body = __webpack_require__(637);

var _Body2 = _interopRequireDefault(_Body);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_component2.default.Header = _TableWithExpandablePanel2.default.Header;
_component2.default.Body = _Body2.default;
_component2.default.Row = _TableWithExpandablePanel2.default.Row;
_component2.default.Cell = _TableWithExpandablePanel2.default.Cell;

exports.default = _component2.default;

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateDefaultSession = calculateDefaultSession;
exports.calculateDefaultUnitSession = calculateDefaultUnitSession;
exports.getDefaultSession = getDefaultSession;
exports.getDefaultUnits = getDefaultUnits;
exports.getDefaultUnitSession = getDefaultUnitSession;
exports.findNextUnitSession = findNextUnitSession;
exports.findPreviousUnitSession = findPreviousUnitSession;
exports.getPreviousUnitIdBySessionId = getPreviousUnitIdBySessionId;
exports.getNextUnitIdBySessionId = getNextUnitIdBySessionId;
exports.getSessions = getSessions;
exports.getOrderSessions = getOrderSessions;
exports.getSession = getSession;
exports.getFirstUnitOfSession = getFirstUnitOfSession;
exports.getFirstSessionOfUnit = getFirstSessionOfUnit;
exports.isFutureSession = isFutureSession;
exports.isMarkable = isMarkable;
exports.calculatePreviousSession = calculatePreviousSession;
exports.getPreviousSession = getPreviousSession;
exports.getNextSession = getNextSession;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _omniCommonUi = __webpack_require__(0);

var _immutable = __webpack_require__(3);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _FinancialClosingMoment = __webpack_require__(279);

var _FinancialClosingMoment2 = _interopRequireDefault(_FinancialClosingMoment);

var _Group = __webpack_require__(13);

var _status = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calculateDefaultSession(sessionPlansArg) {
  var nowArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _omniCommonUi.moment)();

  var now = _omniCommonUi.moment.parseZone(nowArg);
  var sessionPlans = new _immutable.List(sessionPlansArg);
  var defaultSession = findDefaultSession(sessionPlans, now);

  if (_is_js2.default.undefined(defaultSession)) {
    defaultSession = sessionPlans.get(0);
  }

  return defaultSession;
}

function calculateDefaultUnitSession(sessionPlansArg) {
  var nowArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _omniCommonUi.moment)();

  var now = _omniCommonUi.moment.parseZone(nowArg);
  var sessionPlans = new _immutable.List(sessionPlansArg);
  var defaultSession = findDefaultUnitSession(sessionPlans, now);

  if (_is_js2.default.undefined(defaultSession)) {
    defaultSession = sessionPlans.find(function (sessionPlan) {
      return Array.isArray(sessionPlan.unitIds) && sessionPlan.unitIds.length > 0;
    });
    return _is_js2.default.undefined(defaultSession) ? sessionPlans.get(0) : defaultSession;
  }

  return defaultSession;
}

function getDefaultSession(state, groupId) {
  (0, _invariant2.default)(_is_js2.default.truthy(groupId), 'expecting a groupId argument');
  var now = (0, _omniCommonUi.moment)();
  var sessionPlans = state.get('rootReducer').get('sessionPlans').toList().filter(function (plan) {
    return plan.groupId === groupId;
  }).sortBy(function (plan) {
    return plan.index;
  });
  var defaultSession = findDefaultSession(sessionPlans, now);
  if (_is_js2.default.undefined(defaultSession)) {
    defaultSession = sessionPlans.get(0);
  }

  return defaultSession;
}

function getDefaultUnits(state, groupId) {
  var defaultSession = getDefaultSession(state, groupId);

  return defaultSession.unitIds;
}

function getDefaultUnitSession(state, groupId) {
  (0, _invariant2.default)(_is_js2.default.truthy(groupId), 'expecting a groupId argument');
  var now = (0, _omniCommonUi.moment)();
  var sessionPlans = state.get('rootReducer').get('sessionPlans').toList().filter(function (plan) {
    return plan.groupId === groupId;
  }).sortBy(function (plan) {
    return plan.index;
  });
  return findDefaultUnitSession(sessionPlans, now);
}

function findNextUnitSession(sessionPlans, units, currentSessionId) {
  var unitId = getNextOrPreviousUnitBySessionId(sessionPlans, units, currentSessionId, true);
  if (_is_js2.default.existy(unitId)) {
    return sessionPlans.find(function (sessionPlan) {
      return sessionPlan.unitId === unitId;
    });
  }
  return getNextOrPreviousSessionWithoutUnitId(sessionPlans, units, currentSessionId, true);
}

function findPreviousUnitSession(sessionPlans, units, currentSessionId) {
  var unitId = getNextOrPreviousUnitBySessionId(sessionPlans, units, currentSessionId, false);
  if (_is_js2.default.existy(unitId)) {
    return sessionPlans.find(function (sessionPlan) {
      return sessionPlan.unitId === unitId;
    });
  }
  return getNextOrPreviousSessionWithoutUnitId(sessionPlans, units, currentSessionId, false);
}

// ----- //

function findDefaultSession(sessionPlans, now) {
  return sessionPlans.findLast(function (plan) {
    if (now.isSameOrAfter(plan.period.start)) {
      return true;
    }
    return false;
  });
}

function getPreviousUnitIdBySessionId(state, groupId, currentSessionId) {
  var sessions = getOrderSessions(state, groupId);
  var currentSessionIndex = sessions.findIndex(function (session) {
    return session.id === currentSessionId;
  });
  var previousUnitSession = sessions.findLast(function (session, index) {
    return Array.isArray(session.unitIds) && session.unitIds.length > 0 && index < currentSessionIndex;
  });
  return previousUnitSession && previousUnitSession.unitIds[0];
}

function getNextUnitIdBySessionId(state, groupId, currentSessionId) {
  var sessions = getOrderSessions(state, groupId);
  var currentSessionIndex = sessions.findIndex(function (session) {
    return session.id === currentSessionId;
  });
  var nextUnitSession = sessions.find(function (session, index) {
    return Array.isArray(session.unitIds) && session.unitIds.length > 0 && index > currentSessionIndex;
  });
  return nextUnitSession && nextUnitSession.unitIds[0];
}

function getNextOrPreviousSessionWithoutUnitId(sessionPlans, units, currentSessionId, next) {
  var sessionList = sessionPlans.toList();
  var currentSessionIndex = sessionList.findIndex(function (session) {
    return session.id === currentSessionId;
  });
  var nextUnitSession = sessionList.find(function (session, index) {
    return session.unitId && index > currentSessionIndex;
  });
  var previousUnitSession = sessionList.findLast(function (session, index) {
    return session.unitId && index < currentSessionIndex;
  });
  var unitId = next ? nextUnitSession && nextUnitSession.unitId : previousUnitSession && previousUnitSession.unitId;
  if (nextUnitSession && previousUnitSession && nextUnitSession.unitId && nextUnitSession.unitId === previousUnitSession.unitId) {
    unitId = getNextOrPreviousUnit(units, nextUnitSession.unitId, next);
  }
  return sessionPlans.find(function (sessionPlan) {
    return sessionPlan.unitId === unitId;
  });
}

function findDefaultUnitSession(sessionPlans, now) {
  return sessionPlans.findLast(function (plan) {
    if (now.isSameOrAfter(plan.period.start) && Array.isArray(plan.unitIds) && plan.unitIds.length > 0) {
      return true;
    }
    return false;
  });
}

function getNextOrPreviousUnitBySessionId(sessionPlans, unitInfo, currentSessionId, next) {
  if (sessionPlans && unitInfo) {
    var currentUnitIds = sessionPlans.find(function (session) {
      return session.id === currentSessionId;
    }).unitIds;
    var currentUnitId = Array.isArray(currentUnitIds) ? currentUnitIds[0] : currentUnitIds;
    if (_is_js2.default.existy(currentUnitId)) {
      return getNextOrPreviousUnit(unitInfo, currentUnitId, next);
    }
  }
}

function getNextOrPreviousUnit(unitInfo, unitId, next) {
  var units = unitInfo && unitInfo.toList();
  var currentUnitIndex = units.findIndex(function (unit) {
    return unit && unit.id === '' + unitId;
  });
  var unitIndex = next ? currentUnitIndex + 1 : currentUnitIndex - 1;
  if (unitIndex < 0 || unitIndex >= units.size) {
    return unitIndex < 0 ? units.get(0) : units.get(units.size - 1);
  }
  return units.get(unitIndex).id;
}

function getSessions(state, groupId) {
  return state.get('rootReducer').get('sessionPlans') && state.get('rootReducer').get('sessionPlans').filter(function (session) {
    return session.groupId === groupId;
  });
}

function getOrderSessions(state, groupId) {
  return getSessions(state, groupId).filter(function (session) {
    return session.groupId === groupId;
  }).toList().sortBy(function (session) {
    return session.index;
  });
}

function getSession(state, sessionId) {
  return state.get('rootReducer').get('sessionPlans').get(sessionId);
}

function getFirstUnitOfSession(state, sessionId) {
  var session = getSession(state, sessionId);
  if (session && Array.isArray(session.unitIds) && session.unitIds.length > 0) {
    return session.unitIds[0];
  }
  return 0;
}

function getFirstSessionOfUnit(state, groupId, unitId) {
  return getOrderSessions(state, groupId).filter(function (session) {
    return Array.isArray(session.unitIds) && session.unitIds.includes(unitId);
  }).get(0);
}

function isFutureSession(state, sessionId) {
  var session = getSession(state, sessionId);
  (0, _invariant2.default)(session, 'Invalid session id.');
  return (0, _omniCommonUi.moment)().isBefore(session.period.start);
}

function isMarkable(state, groupId, currentSessionId) {
  var markable = null;
  var group = _Group.actions.getGroup(state, groupId);
  var sessions = getSessions(state, groupId);
  if (_immutable.Map.isMap(sessions) && sessions.size !== 0) {
    var currentSession = sessions.find(function (plan) {
      return plan.id === currentSessionId;
    });
    var attendanceId = currentSession.attendanceId;

    if ((0, _omniCommonUi.moment)().isBefore(currentSession.period.start)) {
      markable = false; // future session
    } else if (_is_js2.default.existy(attendanceId)) {
      var financialClosingMoment = _FinancialClosingMoment2.default.nextFrom(currentSession.period.start);
      var financialCheck = (0, _omniCommonUi.moment)().isBefore(financialClosingMoment) || _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.MarkAttendance.IgnoreFinanceDate);
      markable = financialCheck && (0, _status.isActive)(group.status);
    }
  }
  return markable;
}

function calculatePreviousSession(sessionPlansArg) {
  var nowArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _omniCommonUi.moment)();

  var now = _omniCommonUi.moment.parseZone(nowArg);
  var sessionPlans = new _immutable.List(sessionPlansArg);
  var defaultSession = findDefaultSession(sessionPlans, now);

  var previousSession = void 0;
  if (_is_js2.default.undefined(defaultSession)) {
    previousSession = sessionPlans.get(0);
  } else {
    previousSession = findPreviousSession(sessionPlans, defaultSession);
  }
  previousSession = previousSession || sessionPlans.get(0);

  return previousSession;
}

function getPreviousSession(state, groupId) {
  (0, _invariant2.default)(_is_js2.default.truthy(groupId), 'expecting a groupId argument');
  var now = (0, _omniCommonUi.moment)();
  var sessionPlans = state.get('rootReducer').get('sessionPlans').toList().filter(function (plan) {
    return plan.groupId === groupId;
  }).sortBy(function (plan) {
    return plan.index;
  });
  var defaultSession = findDefaultSession(sessionPlans, now);

  var previousSession = void 0;
  if (_is_js2.default.undefined(defaultSession)) {
    previousSession = sessionPlans.get(0);
  } else {
    previousSession = findPreviousSession(sessionPlans, defaultSession);
  }
  previousSession = previousSession || sessionPlans.get(0);

  return previousSession;
}

function getNextSession(state, groupId, currentSessionId) {
  var sessionPlans = getOrderSessions(state, groupId);
  var currentSession = getSession(state, currentSessionId);

  var nextSession = void 0;
  if (_is_js2.default.undefined(currentSession)) {
    nextSession = sessionPlans.last();
  } else {
    nextSession = findNextSession(sessionPlans, currentSession);
  }
  nextSession = nextSession || sessionPlans.last();

  return nextSession;
}

function findPreviousSession(sessionPlans, defaultSession) {
  return sessionPlans.findLast(function (plan) {
    if (_omniCommonUi.moment.parseZone(plan.period.end).isBefore(defaultSession.period.start)) {
      return true;
    }
    return false;
  });
}

function findNextSession(sessionPlans, defaultSession) {
  return sessionPlans.filter(function (plan) {
    if (_omniCommonUi.moment.parseZone(plan.period.start).isAfter(defaultSession.period.end)) {
      return true;
    }
    return false;
  }).first();
}

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1251);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ExpansionButton = function ExpansionButton(props) {
  var _classnames;

  var className = props.className,
      isExpand = props.isExpand,
      onExpansionButtonClick = props.onExpansionButtonClick;

  var expandDescription = isExpand ? 'VIEW LESS' : 'VIEW MORE';
  var classes = (0, _classnames3.default)(className, _style2.default.ExpansionButton, (_classnames = {}, _defineProperty(_classnames, _style2.default.__expanded, isExpand), _defineProperty(_classnames, (0, _omniCommonUi.testClass)('expanded'), isExpand), _defineProperty(_classnames, (0, _omniCommonUi.testClass)('collapsed'), !isExpand), _classnames));

  return _react2.default.createElement(
    'div',
    { className: classes, onClick: onExpansionButtonClick },
    expandDescription,
    _react2.default.createElement(_omniCommonUi.Icon, { id: 'chevron-small-down', className: _style2.default.ExpansionButton_arrow })
  );
};

ExpansionButton.propTypes = {
  className: _propTypes2.default.string,
  isExpand: _propTypes2.default.bool.isRequired,
  onExpansionButtonClick: _propTypes2.default.func.isRequired
};

exports.default = ExpansionButton;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsavedChangesWarning = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnsavedChangesWarning = exports.UnsavedChangesWarning = function (_Component) {
  _inherits(UnsavedChangesWarning, _Component);

  function UnsavedChangesWarning() {
    _classCallCheck(this, UnsavedChangesWarning);

    return _possibleConstructorReturn(this, (UnsavedChangesWarning.__proto__ || Object.getPrototypeOf(UnsavedChangesWarning)).apply(this, arguments));
  }

  _createClass(UnsavedChangesWarning, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          isOpen = _props.isOpen,
          isSaving = _props.isSaving,
          onSaved = _props.onSaved;

      if (isOpen && isSaving && !nextProps.isSaving) {
        onSaved && onSaved();
      }
    }
  }, {
    key: '_getDialogText',
    value: function _getDialogText() {
      return this.props.dialogText || 'Do you want to save your changes?';
    }
  }, {
    key: '_getPrimaryButtonLabel',
    value: function _getPrimaryButtonLabel() {
      return this.props.primaryButtonLabel || 'Save';
    }
  }, {
    key: '_getSecondaryButtonLabel',
    value: function _getSecondaryButtonLabel() {
      return this.props.secondaryButtonLabel || 'Discard';
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: _is_js2.default.function(props.isOpen) ? props.isOpen() : !!props.isOpen,
          isLoading: _is_js2.default.function(props.isSaving) ? props.isSaving() : !!props.isSaving,
          primaryButtonContent: this._getPrimaryButtonLabel(),
          secondaryButtonContent: this._getSecondaryButtonLabel(),
          onPrimaryClick: function onPrimaryClick() {
            return props.onSaveClicked && props.onSaveClicked();
          },
          onSecondaryClick: function onSecondaryClick() {
            return props.onDiscardClicked && props.onDiscardClicked();
          },
          onRequestClose: function onRequestClose() {
            return props.onCloseClicked && props.onCloseClicked();
          } },
        _react2.default.createElement(
          'span',
          null,
          this._getDialogText()
        )
      );
    }
  }]);

  return UnsavedChangesWarning;
}(_react.Component);

UnsavedChangesWarning.propTypes = {
  dialogText: _propTypes2.default.string,
  primaryButtonLabel: _propTypes2.default.string,
  secondaryButtonLabel: _propTypes2.default.string,
  isOpen: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  isSaving: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  onDiscardClicked: _propTypes2.default.func,
  onCloseClicked: _propTypes2.default.func,
  onSaveClicked: _propTypes2.default.func,
  onSaved: _propTypes2.default.func
};

exports.default = UnsavedChangesWarning;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressTest = exports.reducer = exports.accessors = exports.actions = undefined;

var _actions2 = __webpack_require__(624);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1363);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(628);

var _model2 = _interopRequireDefault(_model);

var _accessors2 = __webpack_require__(1384);

var _accessors = _interopRequireWildcard(_accessors2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

_model2.default.actions = _actions;
_model2.default.accessors = _accessors;

var actions = exports.actions = _actions;
var accessors = exports.accessors = _accessors;
var reducer = exports.reducer = _reducer3.default;
var ProgressTest = exports.ProgressTest = _model2.default;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNextUnit = getNextUnit;
exports.getPreviousUnit = getPreviousUnit;
exports.getUnitList = getUnitList;
exports.getUnitNumberById = getUnitNumberById;
function getUnitIndex(unitList, unitId) {
  return unitList.findIndex(function (unit) {
    return unit.id === unitId;
  });
}

function getNextUnit(state, unitId, groupId) {
  var unitList = getUnitList(state, groupId).toList();
  var index = getUnitIndex(unitList, unitId);
  return index < unitList.size - 1 ? unitList.get(index + 1) : undefined;
}

function getPreviousUnit(state, unitId, groupId) {
  var unitList = getUnitList(state, groupId).toList();
  var index = getUnitIndex(unitList, unitId);
  return index > 0 ? unitList.get(index - 1) : undefined;
}

function getUnitList(state, groupId) {
  var units = state.get('rootReducer').get('unit');
  if (!units) return;
  var unitsByGroup = units.get(groupId);
  if (!unitsByGroup) return;
  return unitsByGroup.sortBy(function (unit) {
    return unit.orderingSequence;
  });
}

function getUnitNumberById(units, unitId) {
  return units.get(unitId) && units.get(unitId).orderingSequence || 0;
}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentReportSummary = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(200);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1356);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(289);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

_model2.default.actions = _actions;

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var StudentReportSummary = exports.StudentReportSummary = _model2.default;

/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessors = exports.SessionPlan = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(159);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(593);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(280);

var _model2 = _interopRequireDefault(_model);

var _accessors2 = __webpack_require__(36);

var _accessors = _interopRequireWildcard(_accessors2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var SessionPlan = exports.SessionPlan = _model2.default;
var accessors = exports.accessors = _accessors;

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewNav = exports.fnToValue = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1408);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _ViewNavBig = __webpack_require__(1410);

var _ViewNavBig2 = _interopRequireDefault(_ViewNavBig);

var _ViewNavSmall = __webpack_require__(1413);

var _ViewNavSmall2 = _interopRequireDefault(_ViewNavSmall);

var _ViewNavButton = __webpack_require__(290);

var _ViewNavButton2 = _interopRequireDefault(_ViewNavButton);

var _ViewNavExtra = __webpack_require__(291);

var _ViewNavExtra2 = _interopRequireDefault(_ViewNavExtra);

var _omniCommonUi = __webpack_require__(0);

var _immutable = __webpack_require__(3);

var _UiState = __webpack_require__(30);

var _classnames3 = __webpack_require__(7);

var _classnames4 = _interopRequireDefault(_classnames3);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EDIT_MODE_MATCH_REGEXP = new RegExp("^edit$", "i");

// ViewNav per-route settings may be supplied as functions
var fnToValue = exports.fnToValue = function fnToValue(any, props) {
  if (_is_js2.default.function(any)) {
    return any(props);
  }
  return any;
};

var ViewNav = exports.ViewNav = function (_Component) {
  _inherits(ViewNav, _Component);

  function ViewNav(props) {
    _classCallCheck(this, ViewNav);

    var _this = _possibleConstructorReturn(this, (ViewNav.__proto__ || Object.getPrototypeOf(ViewNav)).call(this, props));

    _this._queryListener = _this._queryListener.bind(_this);
    _this._query = (0, _omniCommonUi.mediaQuery)("(min-width: 639px)");
    _this._setButtonsToDisplay(_this.props);
    _this.state = { big: _this._query.matches };
    return _this;
  }

  _createClass(ViewNav, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._query.addListener(this._queryListener);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      this._setButtonsToDisplay(props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._query.removeListener(this._queryListener);
    }
  }, {
    key: "_queryListener",
    value: function _queryListener(mql) {
      this.setState({ big: mql.matches });
    }
  }, {
    key: "_setButtonsToDisplay",
    value: function _setButtonsToDisplay(props) {
      var currentRoute = ViewNav.getCurrentRouteSegment(props);
      var currentModeName = props.params && props.params.mode && props.params.mode.length ? props.params.mode : "default";

      // do not show action buttons in `edit` mode - the save bar does that for us
      if (EDIT_MODE_MATCH_REGEXP.test(currentModeName)) {
        this._buttons = new _immutable.Map();
        return;
      }

      var actionButtonsMap = {};
      var actionButtonsForMode = void 0;
      if (currentRoute.actionButtons && currentRoute.actionButtons[currentModeName]) {
        actionButtonsForMode = currentRoute.actionButtons[currentModeName];
        Object.assign(actionButtonsMap, actionButtonsForMode);
      }

      var buttonsToDisplay = Object.keys(actionButtonsMap).filter(function (buttonLabel) {
        var buttonDescriptor = actionButtonsMap[buttonLabel];
        try {
          if (_is_js2.default.function(buttonDescriptor.visibleWhen)) {
            if (buttonDescriptor.visibleWhen.length < 2) {
              return buttonDescriptor.visibleWhen(props);
              // handle the older form of this method where there are two args - state and props
            } else if (!buttonDescriptor.visibleWhen(props.state, props)) {
              return false;
            }
          }
        } catch (err) {
          _omniCommonUi.log.warn("Error in `visibleWhen` in route `" + currentRoute.path + "`", err);
        }
        return true;
      });

      this._buttons = new _immutable.Map(actionButtonsMap).filter(function (v, key) {
        return buttonsToDisplay.indexOf(key) >= 0;
      });
    }
  }, {
    key: "_getIsDisabled",
    value: function _getIsDisabled(buttonDescriptor) {
      var props = this.props;
      try {
        if (_is_js2.default.function(buttonDescriptor.disableWhen)) {
          if (buttonDescriptor.disableWhen.length < 2) {
            return buttonDescriptor.disableWhen(props);
            // handle the older form of this method where there are two args - state and props
          } else if (buttonDescriptor.disableWhen(props.state, props)) {
            return true;
          }
        }
      } catch (err) {
        var currentRoute = ViewNav.getCurrentRouteSegment(this.props);
        _omniCommonUi.log.warn("Error in `disableWhen` in route `" + currentRoute.path + "`", err);
      }
      return false;
    }
  }, {
    key: "_getOnClickHandler",
    value: function _getOnClickHandler(buttonDescriptor, buttonLabel) {
      var _this2 = this;

      if (buttonDescriptor.onClick) {
        return function () {
          registerClick();
          return buttonDescriptor.onClick.call(_this2, _this2.props.state, _this2.props);
        };
      }

      return buttonDescriptor.route && function () {
        registerClick();
        return _this2._redirect(fnToValue(buttonDescriptor.route, _this2.props));
      };

      function registerClick() {
        _reactGa2.default.event({
          category: "Navigation",
          action: "Clicked action button",
          label: "Clicked " + buttonLabel + " in the top toolbar"
        });
      }
    }
  }, {
    key: "_redirect",
    value: function _redirect(param) {
      var _props = this.props,
          pushRoute = _props.pushRoute,
          buildRoute = _props.buildRoute;

      pushRoute(buildRoute(param));
    }
  }, {
    key: "_hasButtons",
    value: function _hasButtons() {
      return this._buttons.size > 0;
    }
  }, {
    key: "_hasExtra",
    value: function _hasExtra() {
      var _ref = ViewNav.getCurrentRouteSegment(this.props) || {},
          settings = _ref.sessionNav;

      if (this.props.showExpandable) {
        return true;
      }
      return this.props.hideExpandable !== true && (!settings || settings.noUnitSessionNavigation !== true);
    }
  }, {
    key: "_renderExpandIcon",
    value: function _renderExpandIcon() {
      var _props2 = this.props,
          showNavigationBar = _props2.showNavigationBar,
          toggleNavigation = _props2.toggleNavigation;


      if (!this._hasExtra()) {
        return null;
      }

      var iconClass = (0, _classnames4.default)(_style2.default.ViewNav_expandIcon, _defineProperty({}, _style2.default.__reverse, showNavigationBar), _defineProperty({}, _style2.default.__sticky, this.state.stickToTop));

      return _react2.default.createElement(
        _ViewNavExtra2.default,
        null,
        _react2.default.createElement(_omniCommonUi.Icon, {
          id: "chevron-fat-down",
          className: iconClass,
          onClick: toggleNavigation
        })
      );
    }
  }, {
    key: "_renderButtons",
    value: function _renderButtons() {
      var _this3 = this;

      return this._buttons.map(function (buttonDescriptor, buttonLabel) {
        var title = _is_js2.default.function(buttonDescriptor.label) ? buttonDescriptor.label(_this3.props) : buttonLabel;
        var className = (0, _omniCommonUi.testClass)("viewnav-button-" + title.replace(/\s+/g, "-").toLowerCase());
        // eslint-disable-next-line react/no-array-index-key
        return _react2.default.createElement(_ViewNavButton2.default, {
          key: buttonLabel,
          title: title,
          className: className,
          isPrimary: buttonDescriptor.isPrimary,
          disabled: _this3._getIsDisabled(buttonDescriptor),
          onClick: _this3._getOnClickHandler(buttonDescriptor, buttonLabel),
          newTab: buttonDescriptor.newTab,
          linkHref: fnToValue(buttonDescriptor.linkHref, _this3.props)
        });
      }).toArray();
    }
  }, {
    key: "_renderContent",
    value: function _renderContent() {
      var ViewNavImpl = this.state.big ? _ViewNavBig2.default : _ViewNavSmall2.default;
      return _react2.default.createElement(
        ViewNavImpl,
        null,
        this._renderButtons(),
        this._renderExpandIcon()
      );
    }
  }, {
    key: "render",
    value: function render() {
      var currentRoute = ViewNav.getCurrentRouteSegment(this.props);
      if (currentRoute && currentRoute.actionButtons && currentRoute.actionButtons.hidden === true) {
        return null;
      }
      if (!this._hasButtons() && !this._hasExtra()) {
        return null;
      }
      var ViewNavImpl = this.state.big ? _ViewNavBig2.default : _ViewNavSmall2.default;
      return _react2.default.createElement(
        ViewNavImpl,
        null,
        this._renderButtons(),
        this._renderExpandIcon()
      );
    }
  }]);

  return ViewNav;
}(_react.Component);

ViewNav.getCurrentRouteSegment = function (_ref2) {
  var routes = _ref2.routes;
  return routes ? routes[routes.length - 1] : {};
};

ViewNav.propTypes = {
  isMarkable: _propTypes2.default.bool,
  state: _propTypes2.default.object,
  routes: _propTypes2.default.array.isRequired,
  location: _propTypes2.default.object.isRequired,
  params: _propTypes2.default.object.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  toggleNavigation: _propTypes2.default.func.isRequired,
  showNavigationBar: _propTypes2.default.bool.isRequired,
  hideExpandable: _propTypes2.default.bool,
  showExpandable: _propTypes2.default.bool
};

function mapStateToProps(state) {
  var showNavigationBar = _UiState.actions.getShowNavigationBar(state);
  return { showNavigationBar: showNavigationBar };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_UiState.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(ViewNav);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayName = getDisplayName;
var languageCodeNameMapping = exports.languageCodeNameMapping = {
  'zh-CN': '中文',
  'en-US': 'English',
  'id-ID': 'Bahasa Indonesia',
  'vi-VN': 'Tiếng Việt',
  'ru-RU': 'Pусский'
};

function getDisplayName(languageCode) {
  if (!languageCode) return '';
  return languageCodeNameMapping[languageCode];
}

var Languages = {
  getDisplayName: getDisplayName,
  mapping: languageCodeNameMapping,
  defaultLanguageCode: 'en-US'
};

exports.default = Languages;

/***/ }),
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exporter = undefined;

var _isomorphicFetch = __webpack_require__(569);

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function downloadFile(filename, blob) {
  if (navigator.appVersion.toString().indexOf('.NET') > 0 || navigator.appVersion.toString().indexOf('Edge') > 0) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    var link = document.createElement('a');
    link.setAttribute('href', window.URL.createObjectURL(blob));
    link.setAttribute('download', filename);
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
  }
  return Promise.resolve(filename);
}

function getBlob(response) {
  return response.blob();
}

function getTokenHeader(acceptType) {
  var user = _omniCommonUi.Store.get().getState().get('singleSignOn').get('user') || {};
  var token = user.get('access_token');
  var headers = {
    Accept: acceptType,
    Authorization: 'Bearer ' + token,
    'Content-Type': 'application/json'
  };
  return headers;
}

var fetchWithBlob = function fetchWithBlob(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var acceptType = arguments[2];

  var _options = Object.assign(options);
  _options.headers = options.headers || {};
  Object.assign(_options.headers, getTokenHeader(acceptType));
  return (0, _isomorphicFetch2.default)(url, _options);
};

var exporter = exports.exporter = {
  get: function get(url, filename, body, acceptType) {
    var method = body ? 'post' : 'get';
    var bodyString = body ? JSON.stringify(body) : undefined;
    var options = {
      method: method,
      body: bodyString
    };

    return fetchWithBlob(url, options, acceptType).then(checkResponseStatus).then(getBlob).then(downloadFile.bind(undefined, filename));
  }
};

function checkResponseStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  var error = new Error(response.statusText);
  error.response = response;
  throw error;
}

exports.default = exporter;

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldDisabledSkillName = undefined;
exports.getProgressTestPlanFromIndex = getProgressTestPlanFromIndex;
exports.getDefaultProgressTest = getDefaultProgressTest;
exports.getDefaultProgressTestIndex = getDefaultProgressTestIndex;
exports.getDefaultProgressReportId = getDefaultProgressReportId;
exports.isMarkable = isMarkable;
exports.checkIsUnitQuiz = checkIsUnitQuiz;
exports.getViewerLink = getViewerLink;
exports.hasMidtermOrFinalExam = hasMidtermOrFinalExam;
exports.isCNOWNCentre = isCNOWNCentre;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _SessionPlans = __webpack_require__(44);

var _status = __webpack_require__(196);

var _Group = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shouldDisabledSkillName = exports.shouldDisabledSkillName = 'Speaking';

function getProgressTestPlanFromIndex(state, groupId, progressTestIndex, isUnitQuiz) {
  var currentProgressTestPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId) && state.get('rootReducer').get('progressTestsPlan').get(groupId).data && state.get('rootReducer').get('progressTestsPlan').get(groupId).data.find(function (ptp) {
    return ptp.isUnitQuiz === isUnitQuiz && ptp.index === Number.parseInt(progressTestIndex, 10);
  });
  return currentProgressTestPlan;
}

function getDefaultProgressTest(state, groupId, isUnitQuiz) {
  try {
    var progressTestsPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId).data;
    return progressTestsPlan.find(function (ptp) {
      return ptp.isUnitQuiz === isUnitQuiz && ptp.isCurrentProgressTest;
    });
  } catch (e) {
    return null;
  }
}

function getDefaultProgressTestIndex(state, groupId, isUnitQuiz) {
  var progressTest = getDefaultProgressTest(state, groupId, isUnitQuiz);
  return progressTest && progressTest.index;
}

function getDefaultProgressReportId(state, groupId) {
  try {
    return getDefaultProgressTest(state, groupId, true).progressReportId;
  } catch (e) {
    return null;
  }
}

function isMarkable(state, groupId, progressTestIndex, isUnitQuiz) {
  var group = state.get('rootReducer').get('groups').get(groupId) && state.get('rootReducer').get('groups').get(groupId).data;
  var progressTestPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId);
  var currentProgressTestPlan = progressTestPlan && progressTestPlan.data && progressTestPlan.data.find(function (ptp) {
    return ptp.isUnitQuiz === isUnitQuiz && ptp.index === Number.parseInt(progressTestIndex, 10);
  });

  if (!_is_js2.default.existy(group) || !_is_js2.default.existy(progressTestPlan) || !_is_js2.default.existy(currentProgressTestPlan)) {
    return false;
  }
  var status = group.status;
  var sessionPlans = group.sessionPlans;

  sessionPlans = sessionPlans.update('data', function (data) {
    return data.map(function (sessionPlanId) {
      return state.get('rootReducer').get('sessionPlans').get(sessionPlanId);
    });
  });
  sessionPlans = sessionPlans.update('data', function (data) {
    return new _immutable.List(data);
  });
  var defaultSession = _SessionPlans.actions.getDefaultSession(state, groupId);

  if (!(0, _status.isActive)(status)) {
    return false;
  }

  if (!isUnitQuiz) {
    return true;
  }

  if (defaultSession.isFuture()) {
    return false;
  }

  var unitSessions = sessionPlans.data.filter(function (sp) {
    return Array.isArray(sp.unitIds) && currentProgressTestPlan.unitIds.includes(sp.unitIds[0]);
  });

  var startedSessions = unitSessions && unitSessions.filter(function (sp) {
    return sp.index <= defaultSession.index;
  });

  return startedSessions && startedSessions.size !== 0;
}

function checkIsUnitQuiz(currentLocationPathName) {
  return currentLocationPathName && currentLocationPathName.search('progress-test') >= 0;
}

function getViewerLink(state, progressTestId) {
  return state.get('rootReducer').get('progressTestViewLink') && state.get('rootReducer').get('progressTestViewLink').get('' + progressTestId);
}

function hasMidtermOrFinalExam(state, groupId) {
  var progressTestsPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId);

  return progressTestsPlan && progressTestsPlan.data && progressTestsPlan.data.find(function (ptp) {
    return ptp.isUnitQuiz === false;
  });
}

function isCNOWNCentre(state, groupId) {
  var _groupActions$getCent = _Group.actions.getCentre(state, groupId),
      countryCode = _groupActions$getCent.countryCode,
      businessLineCode = _groupActions$getCent.businessLineCode;

  if (_is_js2.default.not.string(countryCode) || _is_js2.default.not.string(businessLineCode)) {
    return false;
  }

  return countryCode.concat(businessLineCode).toUpperCase() === 'CNOWN';
}

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonTd = exports.TextTd = exports.DetailLinkTd = exports.HeaderTd = exports.ProgressBarTd = exports.StatusTd = exports.ProgressCardTd = exports.MemberCardTd = exports.NormalTd = exports.TableViewTr = exports.TableView = undefined;

var _TableView2 = __webpack_require__(1265);

var _TableView3 = _interopRequireDefault(_TableView2);

var _TableViewTr2 = __webpack_require__(1271);

var _TableViewTr3 = _interopRequireDefault(_TableViewTr2);

var _NormalTd2 = __webpack_require__(160);

var _NormalTd3 = _interopRequireDefault(_NormalTd2);

var _MemberCardTd2 = __webpack_require__(1276);

var _MemberCardTd3 = _interopRequireDefault(_MemberCardTd2);

var _ProgressCardTd2 = __webpack_require__(1279);

var _ProgressCardTd3 = _interopRequireDefault(_ProgressCardTd2);

var _StatusTd2 = __webpack_require__(1284);

var _StatusTd3 = _interopRequireDefault(_StatusTd2);

var _ProgressBarTd2 = __webpack_require__(1287);

var _ProgressBarTd3 = _interopRequireDefault(_ProgressBarTd2);

var _HeaderTd2 = __webpack_require__(1290);

var _HeaderTd3 = _interopRequireDefault(_HeaderTd2);

var _DetailLinkTd2 = __webpack_require__(1293);

var _DetailLinkTd3 = _interopRequireDefault(_DetailLinkTd2);

var _TextTd2 = __webpack_require__(1296);

var _TextTd3 = _interopRequireDefault(_TextTd2);

var _ButtonTd2 = __webpack_require__(1297);

var _ButtonTd3 = _interopRequireDefault(_ButtonTd2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableView = exports.TableView = _TableView3.default;
var TableViewTr = exports.TableViewTr = _TableViewTr3.default;
var NormalTd = exports.NormalTd = _NormalTd3.default;
var MemberCardTd = exports.MemberCardTd = _MemberCardTd3.default;
var ProgressCardTd = exports.ProgressCardTd = _ProgressCardTd3.default;
var StatusTd = exports.StatusTd = _StatusTd3.default;
var ProgressBarTd = exports.ProgressBarTd = _ProgressBarTd3.default;
var HeaderTd = exports.HeaderTd = _HeaderTd3.default;
var DetailLinkTd = exports.DetailLinkTd = _DetailLinkTd3.default;
var TextTd = exports.TextTd = _TextTd3.default;
var ButtonTd = exports.ButtonTd = _ButtonTd3.default;

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Unit = exports.reducer = exports.actions = exports.hasMidtermOrFinalExam = exports.getDefaultProgressTestIndex = exports.isMarkable = exports.getDefaultProgressReportId = undefined;

var _accessors = __webpack_require__(52);

Object.defineProperty(exports, 'getDefaultProgressReportId', {
    enumerable: true,
    get: function get() {
        return _accessors.getDefaultProgressReportId;
    }
});
Object.defineProperty(exports, 'isMarkable', {
    enumerable: true,
    get: function get() {
        return _accessors.isMarkable;
    }
});
Object.defineProperty(exports, 'getDefaultProgressTestIndex', {
    enumerable: true,
    get: function get() {
        return _accessors.getDefaultProgressTestIndex;
    }
});
Object.defineProperty(exports, 'hasMidtermOrFinalExam', {
    enumerable: true,
    get: function get() {
        return _accessors.hasMidtermOrFinalExam;
    }
});

var _actions2 = __webpack_require__(602);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1241);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(603);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var Unit = exports.Unit = _model2.default;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserCard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1348);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _omniCommonUi = __webpack_require__(0);

var _Users = __webpack_require__(82);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserCardPlaceholder = __webpack_require__(622);

var _UserCardPlaceholder2 = _interopRequireDefault(_UserCardPlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserCard = exports.UserCard = function (_Component) {
  _inherits(UserCard, _Component);

  function UserCard() {
    _classCallCheck(this, UserCard);

    return _possibleConstructorReturn(this, (UserCard.__proto__ || Object.getPrototypeOf(UserCard)).apply(this, arguments));
  }

  _createClass(UserCard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setUp(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this._setUp(props);
    }
  }, {
    key: '_setUp',
    value: function _setUp(props) {
      if (_is_js2.default.not.empty(props.id)) {
        props.fetchUserIfNeeded(props.id);
      }
    }
  }, {
    key: '_renderDate',
    value: function _renderDate(dateStr) {
      if (_is_js2.default.existy(dateStr)) {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.UserCard_date },
          dateStr
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          getLines = _props.getLines,
          user = _props.user,
          dateStr = _props.dateStr,
          className = _props.className,
          isLoading = _props.isLoading;


      if (!(user instanceof _Users.User)) {
        return _react2.default.createElement(_UserCardPlaceholder2.default, { className: className,
          isLoading: isLoading });
      }

      return _react2.default.createElement(
        _omniCommonUi.Person,
        { className: (0, _classnames2.default)(_style2.default.UserCard, this.props.className) },
        getLines(this.props),
        this._renderDate(dateStr)
      );
    }
  }]);

  return UserCard;
}(_react.Component);

UserCard.propTypes = {
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  fetchUserIfNeeded: _propTypes2.default.func,
  isLoading: _propTypes2.default.bool,
  user: _propTypes2.default.shape(),
  dateStr: _propTypes2.default.string,
  avatarClassName: _propTypes2.default.string,
  getLines: _propTypes2.default.func.isRequired
};

UserCard.defaultProps = {
  getLines: function getLines(_ref) {
    var user = _ref.user,
        avatarClassName = _ref.avatarClassName;
    return [_react2.default.createElement(_omniCommonUi.AdultPicture, { className: (0, _classnames2.default)(_style2.default.UserCard_picture, avatarClassName),
      src: user.avatarUrl,
      gender: user.gender,
      key: 'UserCard#pic0' }), _react2.default.createElement(
      'div',
      { key: 'UserCard#item0' },
      user.firstName,
      ' ',
      user.lastName
    )];
  }
};

function mapStateToProps(state, ownProps) {
  var callState = _Users.actions.getApiCallState(state, ownProps.id);
  return {
    user: _Users.accessors.getUserByUserId(state, ownProps.id),
    isLoading: _omniCommonUi.ApiCall.State.isValue(callState) && _omniCommonUi.ApiCall.State.isLoading(callState)
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_Users.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(UserCard);

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1462);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoContentMessage = function NoContentMessage(props) {
  var noContentMessageClass = (0, _classnames2.default)(_style2.default.NoContentMessage, (0, _omniCommonUi.testClass)('no-content-message'));
  var className = _is_js2.default.existy(props.className) ? (0, _classnames2.default)(noContentMessageClass, props.className) : noContentMessageClass;
  return _react2.default.createElement(
    'div',
    { className: className },
    props.text
  );
};

NoContentMessage.propTypes = {
  text: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string
};

exports.default = NoContentMessage;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1474);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _ScrollPageToHereNow = __webpack_require__(657);

var _ScrollPageToHereNow2 = _interopRequireDefault(_ScrollPageToHereNow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SAVE = 'SAVE';
var DISCARD = 'DISCARD';

var AddInternalNoteControl = function (_Component) {
  _inherits(AddInternalNoteControl, _Component);

  function AddInternalNoteControl(props) {
    _classCallCheck(this, AddInternalNoteControl);

    var _this = _possibleConstructorReturn(this, (AddInternalNoteControl.__proto__ || Object.getPrototypeOf(AddInternalNoteControl)).call(this, props));

    _this.state = { text: props.text };
    return _this;
  }

  _createClass(AddInternalNoteControl, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({ text: props.text });
    }
  }, {
    key: 'forceSave',
    value: function forceSave() {
      if (this._isSaveButtonDisabled()) {
        return;
      }
      return this._onSaveClick();
    }
  }, {
    key: '_onTextareaValueChanged',
    value: function _onTextareaValueChanged(text) {
      this.props.onChange && this.props.onChange(text);
      this.setState({ text: text });
    }
  }, {
    key: '_onSaveClick',
    value: function _onSaveClick() {
      if (_is_js2.default.undefined(this.state.text) || this.state.text.trim() === '') {
        return;
      }
      this.props.onSaveClick && this.props.onSaveClick(this.state.text.trim());
    }
  }, {
    key: '_isSaveButtonDisabled',
    value: function _isSaveButtonDisabled() {
      return _is_js2.default.undefined(this.state.text) || this.state.text.trim() === '';
    }
  }, {
    key: '_renderCharacterLimitReadout',
    value: function _renderCharacterLimitReadout(maxCharacters) {
      var _state$text = this.state.text,
          text = _state$text === undefined ? '' : _state$text;

      if (_is_js2.default.not.string(text)) return null;
      var textLength = text.length;
      return _react2.default.createElement(
        'aside',
        { className: _style2.default.AddInternalNoteControl_charactersUsed },
        textLength,
        '/',
        maxCharacters,
        ' characters'
      );
    }
  }, {
    key: '_shouldShowSaveDiscardButtons',
    value: function _shouldShowSaveDiscardButtons() {
      return !!this.props.onDiscardClick || this.props.onSaveClick;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          noteDescription = _props.noteDescription,
          onDiscardClick = _props.onDiscardClick,
          maxCharacters = _props.maxCharacters,
          isMissing = _props.isMissing;


      var classTextArea = (0, _classnames3.default)(_style2.default.AddInternalNoteControl_textarea, _defineProperty({}, _style2.default.AddInternalNoteControl_textarea_missing, isMissing));
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames3.default)(_style2.default.AddInternalNoteControl, (0, _omniCommonUi.testClass)('note')) },
        !this.props.noAutoScroll && _react2.default.createElement(_ScrollPageToHereNow2.default, { offset: -350 }),
        _react2.default.createElement(_omniCommonUi.TextArea, _extends({ className: classTextArea,
          onChange: function onChange(e) {
            return _this2._onTextareaValueChanged(e.target.value);
          },
          maxLength: maxCharacters,
          value: this.state.text
        }, this.props.textAreaProps)),
        _is_js2.default.number(maxCharacters) ? this._renderCharacterLimitReadout(maxCharacters) : null,
        _is_js2.default.string(noteDescription) ? _react2.default.createElement(
          'p',
          { className: _style2.default.AddInternalNoteControl_description },
          noteDescription
        ) : null,
        this._shouldShowSaveDiscardButtons() && _react2.default.createElement(
          _omniCommonUi.Button.Container,
          { className: _style2.default.AddInternalNoteControl_buttonWrapper,
            align: 'right' },
          _react2.default.createElement(
            _omniCommonUi.Button,
            { className: (0, _classnames3.default)(_style2.default.AddInternalNoteControl_buttonWrapper_button, (0, _omniCommonUi.testClass)('note-save')),
              type: _omniCommonUi.Button.Type.primary,
              onClick: function onClick() {
                return _this2._onSaveClick();
              },
              disabled: this._isSaveButtonDisabled() },
            SAVE
          ),
          _react2.default.createElement(
            _omniCommonUi.Button,
            { className: (0, _classnames3.default)(_style2.default.AddInternalNoteControl_buttonWrapper_button, (0, _omniCommonUi.testClass)('note-cancel')),
              type: _omniCommonUi.Button.Type.default,
              onClick: function onClick() {
                return onDiscardClick && onDiscardClick();
              } },
            DISCARD
          )
        )
      );
    }
  }]);

  return AddInternalNoteControl;
}(_react.Component);

AddInternalNoteControl.propTypes = {
  text: _propTypes2.default.string,
  maxCharacters: _propTypes2.default.number,
  noteDescription: _propTypes2.default.string,
  onDiscardClick: _propTypes2.default.func,
  onSaveClick: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  textAreaProps: _propTypes2.default.shape(),
  noAutoScroll: _propTypes2.default.bool,
  isMissing: _propTypes2.default.bool
};

exports.default = AddInternalNoteControl;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdpStatus = undefined;

var _style = __webpack_require__(1766);

var _style2 = _interopRequireDefault(_style);

var _omniCommonUi = __webpack_require__(0);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IdpStatus = exports.IdpStatus = {
  PROOFREADING: 'proofreading',
  SENT_TO_DOS: 'senttodos',
  PUBLISHED: 'published',
  INCOMPLETE: 'incomplete',
  COMPLETED: 'completed',
  READY: 'ready',
  REJECTED: 'rejected'
};
var STATUS_PROOFREADING = IdpStatus.PROOFREADING;
var STATUS_SENT_TO_DOS = IdpStatus.SENT_TO_DOS;
var STATUS_PUBLISHED = IdpStatus.PUBLISHED;
var STATUS_COMPLETED = IdpStatus.COMPLETED;
var STATUS_INCOMPLETE = IdpStatus.INCOMPLETE;
var STATUS_READY = IdpStatus.READY;
var STATUS_REJECTED = IdpStatus.REJECTED;

var IndividualDevelopmentPlanStatus = function IndividualDevelopmentPlanStatus(props) {
  var _classnames;

  var status = props.status,
      className = props.className;


  var lowercaseStatus = status.toLowerCase();

  var containerClasses = (0, _classnames3.default)(_style2.default.IndividualDevelopmentPlanStatus, className);
  var statusClasses = (0, _classnames3.default)(_style2.default.IndividualDevelopmentPlanStatus_inner, (_classnames = {}, _defineProperty(_classnames, _style2.default.__sent, lowercaseStatus === STATUS_SENT_TO_DOS || lowercaseStatus === STATUS_PROOFREADING), _defineProperty(_classnames, _style2.default.__published, lowercaseStatus === STATUS_PUBLISHED || lowercaseStatus === STATUS_COMPLETED), _defineProperty(_classnames, _style2.default.__missing, lowercaseStatus === STATUS_INCOMPLETE), _defineProperty(_classnames, _style2.default.__ready, lowercaseStatus === STATUS_READY), _defineProperty(_classnames, _style2.default.__rejected, lowercaseStatus === STATUS_REJECTED), _classnames), (0, _omniCommonUi.testClass)('status'));

  var statusToDisplay = void 0;
  switch (lowercaseStatus) {
    case STATUS_SENT_TO_DOS:
      statusToDisplay = 'Sent to DoS';
      break;
    default:
      statusToDisplay = status;
  }

  return _react2.default.createElement(
    'div',
    { className: containerClasses },
    _react2.default.createElement(
      'div',
      { className: statusClasses },
      statusToDisplay
    )
  );
};

IndividualDevelopmentPlanStatus.propTypes = {
  className: _propTypes2.default.string,
  status: _propTypes2.default.string
};

exports.default = IndividualDevelopmentPlanStatus;

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseProductionStatus = undefined;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var statuses = {
  studying: { initial: 's', fullName: 'Studying' },
  transin: { initial: 't', fullName: 'Trans In' },
  returning: { initial: 'r', fullName: 'Returning' },
  continuing: { initial: 'c', fullName: 'Continuing' },
  new: { initial: 'n', fullName: 'New' },
  onhold: { initial: 'h', fullName: 'On Hold' },
  dropout: { initial: 'd', fullName: 'Drop Out' },
  waiting: { initial: 'w', fullName: 'Waiting' },
  finished: { initial: 'f', fullName: 'Finished' },
  transout: { initial: 't', fullName: 'Trans Out' },
  removed: { initial: 'r', fullName: 'Removed' },
  activated: { initial: 'a', fullName: 'Activated' },
  pending: { initial: 'p', fullName: 'Pending' },
  suspended: { initial: 's', fullName: 'Suspended' },
  swapped: { initial: 's', fullName: 'Swapped' },
  completed: { initial: 'c', fullName: 'Completed' },
  cancelled: { initial: 'c', fullName: 'Cancelled' },
  unknown: { initial: 'u', fullName: 'Unknown' }
};

var parseProductionStatus = exports.parseProductionStatus = function parseProductionStatus(code) {
  if (_is_js2.default.undefined(code)) return statuses.unknown;
  return statuses[code.toLowerCase()] || statuses.unknown;
};

exports.default = { parseProductionStatus: parseProductionStatus };

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1525);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanguageRadio = function (_PureComponent) {
  _inherits(LanguageRadio, _PureComponent);

  function LanguageRadio() {
    _classCallCheck(this, LanguageRadio);

    return _possibleConstructorReturn(this, (LanguageRadio.__proto__ || Object.getPrototypeOf(LanguageRadio)).apply(this, arguments));
  }

  _createClass(LanguageRadio, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          choosedLanguageCode = _props.choosedLanguageCode,
          languageCode = _props.languageCode;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_style2.default.LanguageRadio, this.props.className) },
        _is_js2.default.existy(this.props.title) && _react2.default.createElement(
          'div',
          null,
          this.props.title
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_omniCommonUi.SolidRadio, { name: this.props.name,
            id: this.props.name + '-1',
            value: languageCode,
            isChecked: choosedLanguageCode === languageCode,
            onChange: this.props.onChecked }),
          _Languages2.default.getDisplayName(languageCode)
        ),
        languageCode === 'id-ID' && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_omniCommonUi.SolidRadio, { name: this.props.name,
            id: this.props.name + '-2',
            value: 'zh-CN',
            isChecked: choosedLanguageCode === 'zh-CN',
            onChange: this.props.onChecked }),
          _Languages2.default.getDisplayName('zh-CN')
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_omniCommonUi.SolidRadio, { name: this.props.name,
            id: this.props.name + '-3',
            value: _Languages2.default.defaultLanguageCode,
            isChecked: choosedLanguageCode === _Languages2.default.defaultLanguageCode,
            onChange: this.props.onChecked }),
          _Languages2.default.getDisplayName(_Languages2.default.defaultLanguageCode)
        )
      );
    }
  }]);

  return LanguageRadio;
}(_react.PureComponent);

LanguageRadio.propTypes = {
  title: _propTypes2.default.string,
  languageCode: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  onChecked: _propTypes2.default.func.isRequired,
  choosedLanguageCode: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string
};

exports.default = LanguageRadio;

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Interval = undefined;

var _model = __webpack_require__(1227);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1228);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Interval = exports.Interval = _model2.default;

Interval.create = _create2.default;

exports.default = Interval;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.User = exports.reducer = exports.accessors = exports.actions = undefined;

var _actions2 = __webpack_require__(598);

var _actions = _interopRequireWildcard(_actions2);

var _accessors2 = __webpack_require__(1237);

var _accessors = _interopRequireWildcard(_accessors2);

var _reducer2 = __webpack_require__(1238);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(599);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

_model2.default.actions = _actions;
_model2.default.accessors = _accessors;

var actions = exports.actions = _actions;
var accessors = exports.accessors = _accessors;
var reducer = exports.reducer = _reducer3.default;
var User = exports.User = _model2.default;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttendanceStatusColorMappings = exports.AttendanceStatusBackendNames = exports.AttendanceStatusDisplayName = exports.AttendanceStatus = exports.DefaultAttendanceStatus = undefined;

var _AttendanceStatusDisp, _AttendanceStatusColo;

exports.getDisplayName = getDisplayName;
exports.convertBackendAttendanceStatusToAttendanceStatus = convertBackendAttendanceStatusToAttendanceStatus;
exports.validateAttendanceStatus = validateAttendanceStatus;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DefaultAttendanceStatus = exports.DefaultAttendanceStatus = 'unmarked';

var AttendanceStatus = exports.AttendanceStatus = {
  present: 'present',
  absent: 'absent',
  late: 'late',
  unmarked: 'unmarked',
  notapplicable: 'notapplicable'
};

var AttendanceStatusDisplayName = exports.AttendanceStatusDisplayName = (_AttendanceStatusDisp = {}, _defineProperty(_AttendanceStatusDisp, AttendanceStatus.present, 'Present'), _defineProperty(_AttendanceStatusDisp, AttendanceStatus.absent, 'Absent'), _defineProperty(_AttendanceStatusDisp, AttendanceStatus.late, 'Late'), _defineProperty(_AttendanceStatusDisp, AttendanceStatus.unmarked, 'Unmarked'), _defineProperty(_AttendanceStatusDisp, AttendanceStatus.notapplicable, 'Not Applicable'), _AttendanceStatusDisp);

var AttendanceStatusBackendNames = exports.AttendanceStatusBackendNames = {
  present: AttendanceStatus.present,
  absent: AttendanceStatus.absent,
  late: AttendanceStatus.late,
  unmarked: AttendanceStatus.unmarked,
  notapplicable: AttendanceStatus.notapplicable
};

var AttendanceStatusColorMappings = exports.AttendanceStatusColorMappings = (_AttendanceStatusColo = {}, _defineProperty(_AttendanceStatusColo, AttendanceStatus.present, 'green'), _defineProperty(_AttendanceStatusColo, AttendanceStatus.absent, 'red'), _defineProperty(_AttendanceStatusColo, AttendanceStatus.late, 'amber'), _AttendanceStatusColo);

function getDisplayName(attendanceStatus) {
  return AttendanceStatusDisplayName[attendanceStatus];
}

function convertBackendAttendanceStatusToAttendanceStatus(backendAttendanceStatus, isMarking) {
  var backendAttendanceStatusLower = _is_js2.default.string(backendAttendanceStatus) ? backendAttendanceStatus.toLowerCase() : null;
  if (isMarking && (!backendAttendanceStatus || AttendanceStatusBackendNames[backendAttendanceStatusLower] === AttendanceStatus.unmarked)) {
    return AttendanceStatus.present;
  }
  return AttendanceStatusBackendNames[backendAttendanceStatusLower] || AttendanceStatus.unmarked;
}

function validateAttendanceStatus(status) {
  if (AttendanceStatus[status]) {
    return true;
  }
  throw new Error('Status "' + status + '" is not valid! Use the Status object provided');
}

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1334);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(16);

var _redux = __webpack_require__(10);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _accessors = __webpack_require__(197);

var studentAccessors = _interopRequireWildcard(_accessors);

var _actions = __webpack_require__(198);

var studentActions = _interopRequireWildcard(_actions);

var _UserCardPlaceholder = __webpack_require__(622);

var _UserCardPlaceholder2 = _interopRequireDefault(_UserCardPlaceholder);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentCardProfile = function (_PureComponent) {
  _inherits(StudentCardProfile, _PureComponent);

  function StudentCardProfile() {
    _classCallCheck(this, StudentCardProfile);

    return _possibleConstructorReturn(this, (StudentCardProfile.__proto__ || Object.getPrototypeOf(StudentCardProfile)).apply(this, arguments));
  }

  _createClass(StudentCardProfile, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._loadIfNeeded(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this._loadIfNeeded(props);
    }
  }, {
    key: '_loadIfNeeded',
    value: function _loadIfNeeded(_ref) {
      var studentId = _ref.studentId;

      this.props.fetchStudentIfNeeded(studentId);
    }
  }, {
    key: '_getStudentAcademicLinkHref',
    value: function _getStudentAcademicLinkHref() {
      var studentId = this.props.studentId;

      return this.props.buildRoute('/student/' + studentId);
    }
  }, {
    key: '_renderNameNode',
    value: function _renderNameNode() {
      var student = this.props.student;

      if (!student) return '…';
      return _react2.default.createElement(
        _reactRouter.Link,
        { to: this._getStudentAcademicLinkHref() },
        student.firstName,
        ' ',
        student.lastName
      );
    }
  }, {
    key: '_renderLocalNameNode',
    value: function _renderLocalNameNode() {
      var student = this.props.student;

      if (!student) return null;
      return _react2.default.createElement(
        'span',
        null,
        student.localName
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          student = _props.student,
          status = _props.status,
          statusHighlighted = _props.statusHighlighted,
          useLowerLevelPersonComponent = _props.useLowerLevelPersonComponent;


      var studentInfo = student ? student.toJS() : null;

      if (useLowerLevelPersonComponent) {
        if (!student) {
          return _react2.default.createElement(_UserCardPlaceholder2.default, { className: (0, _classnames2.default)(className, _style2.default.__placeholder),
            isLoading: true });
        }

        return _react2.default.createElement(_omniCommonUi.StudentCard.Person, _extends({ backgroundless: true,
          className: className
        }, studentInfo, {
          nameLink: this._getStudentAcademicLinkHref(),
          nameNode: _react2.default.createElement(
            _reactRouter.Link,
            { to: this._getStudentAcademicLinkHref() },
            studentInfo.firstName,
            ' ',
            studentInfo.lastName
          ),
          localNameNode: _react2.default.createElement(
            'span',
            null,
            studentInfo.localName
          ),
          status: status,
          statusHighlighted: statusHighlighted }));
      }

      if (!studentInfo) {
        return _react2.default.createElement(_omniCommonUi.StudentCard.Profile, _extends({ isPlaceholder: true
        }, this.props, studentInfo));
      }

      return _react2.default.createElement(_omniCommonUi.StudentCard.Profile, _extends({ nameLink: this._getStudentAcademicLinkHref(),
        name: studentInfo.firstName,
        surname: studentInfo.lastName
      }, this.props, studentInfo));
    }
  }]);

  return StudentCardProfile;
}(_react.PureComponent);

StudentCardProfile.propTypes = {
  className: _propTypes2.default.string,
  studentId: _propTypes2.default.string,
  student: _propTypes2.default.object,
  status: _propTypes2.default.string,
  statusHighlighted: _propTypes2.default.string,
  buildRoute: _propTypes2.default.func.isRequired,
  fetchStudentIfNeeded: _propTypes2.default.func.isRequired,
  useLowerLevelPersonComponent: _propTypes2.default.bool
};

function mapStateToProps(state, _ref2) {
  var studentId = _ref2.studentId;

  return {
    student: studentAccessors.getStudentById(state, '' + studentId)
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(studentActions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(StudentCardProfile);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1491);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(16);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardActionIcons = function CardActionIcons(props) {
  var hideEditIcon = props.hideEditIcon,
      hideDeleteIcon = props.hideDeleteIcon,
      className = props.className,
      onEditClick = props.onEditClick,
      onDeleteClick = props.onDeleteClick,
      editHref = props.editHref,
      deleteHref = props.deleteHref;

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_style2.default.CardActionIcons, className) },
    !hideEditIcon && _react2.default.createElement(
      _omniCommonUi.Tooltip,
      { className: _style2.default.CardActionIcons_item,
        text: 'Edit',
        placement: 'top',
        trigger: ['hover'] },
      _react2.default.createElement(
        _reactRouter.Link,
        { to: editHref,
          onClick: onEditClick,
          role: 'button',
          tabIndex: '0' },
        _react2.default.createElement(_omniCommonUi.Icon, { className: (0, _omniCommonUi.testClass)('edit-icon'), id: 'edit' })
      )
    ),
    !hideDeleteIcon && _react2.default.createElement(
      _omniCommonUi.Tooltip,
      { className: _style2.default.CardActionIcons_item,
        text: 'Delete',
        placement: 'top',
        trigger: ['hover'] },
      _react2.default.createElement(
        _reactRouter.Link,
        { to: deleteHref,
          onClick: onDeleteClick,
          role: 'button',
          tabIndex: '0' },
        _react2.default.createElement(_omniCommonUi.Icon, { id: 'trash' })
      )
    )
  );
};

CardActionIcons.propTypes = {
  editHref: _propTypes2.default.string,
  deleteHref: _propTypes2.default.string,
  onEditClick: _propTypes2.default.func,
  onDeleteClick: _propTypes2.default.func,
  hideEditIcon: _propTypes2.default.bool,
  hideDeleteIcon: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

exports.default = CardActionIcons;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Essay = exports.status = exports.accessors = exports.commentsActions = exports.activityActions = exports.shortAnswerReducer = exports.shortAnswerActions = exports.essayReducer = exports.coreReducer = exports.spinReducer = exports.essayActions = exports.coreActions = exports.spinActions = undefined;

var _SPIN = __webpack_require__(1845);

var _CoreAndCatchUp = __webpack_require__(1849);

var _Essay2 = __webpack_require__(1852);

var _ShortAnswer = __webpack_require__(1854);

var _actions = __webpack_require__(1860);

var _activityActions = _interopRequireWildcard(_actions);

var _actions2 = __webpack_require__(1861);

var _commentsActions = _interopRequireWildcard(_actions2);

var _accessors2 = __webpack_require__(1862);

var _accessors = _interopRequireWildcard(_accessors2);

var _status2 = __webpack_require__(798);

var _status3 = _interopRequireDefault(_status2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var spinActions = exports.spinActions = _SPIN.actions;
var coreActions = exports.coreActions = _CoreAndCatchUp.actions;
var essayActions = exports.essayActions = _Essay2.actions;
var spinReducer = exports.spinReducer = _SPIN.reducer;
var coreReducer = exports.coreReducer = _CoreAndCatchUp.reducer;
var essayReducer = exports.essayReducer = _Essay2.reducer;
var shortAnswerActions = exports.shortAnswerActions = _ShortAnswer.actions;
var shortAnswerReducer = exports.shortAnswerReducer = _ShortAnswer.reducer;
var activityActions = exports.activityActions = _activityActions;
var commentsActions = exports.commentsActions = _commentsActions;
var accessors = exports.accessors = _accessors;
var status = exports.status = _status3.default;
var Essay = exports.Essay = _Essay2.Essay;

/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressReport = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(292);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(639);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(640);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

_model2.default.actions = _actions;

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var ProgressReport = exports.ProgressReport = _model2.default;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CoveredInClass = exports.reducer = exports.actions = exports.accessors = undefined;

var _accessors2 = __webpack_require__(304);

var _accessors = _interopRequireWildcard(_accessors2);

var _actions2 = __webpack_require__(676);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1549);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(305);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var accessors = exports.accessors = _accessors;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var CoveredInClass = exports.CoveredInClass = _model2.default;

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentGeneralInfo = undefined;

var _model = __webpack_require__(1229);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1230);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudentGeneralInfo = exports.StudentGeneralInfo = _model2.default;

StudentGeneralInfo.create = _create2.default;

exports.default = StudentGeneralInfo;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(630);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _reactRouter = __webpack_require__(16);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _classnames7 = __webpack_require__(7);

var _classnames8 = _interopRequireDefault(_classnames7);

var _CSSTransitionGroup = __webpack_require__(427);

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseSessionNav = function (_Component) {
  _inherits(BaseSessionNav, _Component);

  function BaseSessionNav() {
    _classCallCheck(this, BaseSessionNav);

    return _possibleConstructorReturn(this, (BaseSessionNav.__proto__ || Object.getPrototypeOf(BaseSessionNav)).apply(this, arguments));
  }

  _createClass(BaseSessionNav, [{
    key: '_hasNext',

    // these methods are overridden by the implementing class!
    /* eslint-disable class-methods-use-this */

    value: function _hasNext() {
      return true;
    }
  }, {
    key: '_hasPrevious',
    value: function _hasPrevious() {
      return true;
    }
  }, {
    key: '_hasNextUnit',
    value: function _hasNextUnit() {
      return true;
    }
  }, {
    key: '_hasPreviousUnit',
    value: function _hasPreviousUnit() {
      return true;
    }
  }, {
    key: '_getHeadingText',
    value: function _getHeadingText() {
      return 'Heading Text';
    }
  }, {
    key: '_getAdditionalChildren',
    value: function _getAdditionalChildren() {
      return _react2.default.createElement('div', null);
    }
  }, {
    key: '_getNextUnitText',
    value: function _getNextUnitText() {
      return 'NEXT';
    }
  }, {
    key: '_getPreviousUnitText',
    value: function _getPreviousUnitText() {
      return 'PREVIOUS';
    }
  }, {
    key: '_renderPreviousButton',
    value: function _renderPreviousButton() {
      var className = (0, _classnames8.default)(_style2.default.BaseSessionNav_previous, _defineProperty({}, _style2.default.__disabled, !this._hasPrevious()));

      var wrapperClassName = (0, _classnames8.default)((0, _omniCommonUi.testClass)('nav-previous'), _defineProperty({}, _style2.default.BaseSessionNav_disabled, !this._hasPrevious()));

      return _react2.default.createElement(
        'span',
        { className: wrapperClassName },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: className,
            to: this.props.previousSessionLinkHref,
            draggable: false },
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'chevron-thin-left' })
        )
      );
    }
  }, {
    key: '_renderPreviousUnit',
    value: function _renderPreviousUnit() {
      if (!this.props.showUnitNav) {
        return null;
      }

      var isFirst = this._hasPreviousUnit() !== true;
      var isLast = this._hasNextUnit() !== true;
      var className = (0, _classnames8.default)(_style2.default.BaseSessionNav_units_btn, _style2.default.__previous, _defineProperty({}, _style2.default.__isLast, isLast));

      return _react2.default.createElement(
        _omniCommonUi.Button,
        { className: className,
          type: _omniCommonUi.Button.Type.default,
          disabled: isFirst,
          linkTo: this.props.previousUnitLinkHref },
        _react2.default.createElement(_omniCommonUi.Icon, { id: 'chevron-small-left' }),
        isFirst || this._getPreviousUnitText()
      );
    }
  }, {
    key: '_renderNextButton',
    value: function _renderNextButton() {
      var className = (0, _classnames8.default)(_style2.default.BaseSessionNav_next, _defineProperty({}, _style2.default.__disabled, !this._hasNext()));

      var wrapperClassName = (0, _classnames8.default)((0, _omniCommonUi.testClass)('nav-next'), _defineProperty({}, _style2.default.BaseSessionNav_disabled, !this._hasNext()));

      return _react2.default.createElement(
        'span',
        { className: wrapperClassName },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: className,
            to: this.props.nextSessionLinkHref,
            draggable: false },
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'chevron-thin-right' })
        )
      );
    }
  }, {
    key: '_renderNextUnit',
    value: function _renderNextUnit() {
      if (!this.props.showUnitNav) {
        return null;
      }

      var isLast = this._hasNextUnit() !== true;
      var classes = (0, _classnames8.default)(_style2.default.BaseSessionNav_units_btn, _style2.default.__next);

      return _react2.default.createElement(
        _omniCommonUi.Button,
        { className: classes,
          type: _omniCommonUi.Button.Type.default,
          disabled: isLast,
          linkTo: this.props.nextUnitLinkHref },
        isLast || this._getNextUnitText(),
        _react2.default.createElement(_omniCommonUi.Icon, { id: 'chevron-small-right' })
      );
    }
  }, {
    key: '_renderUnits',
    value: function _renderUnits() {
      return _react2.default.createElement(
        'div',
        { className: _style2.default.BaseSessionNav_units },
        this._renderPreviousUnit(),
        this._renderNextUnit()
      );
    }
  }, {
    key: '_renderCurrent',
    value: function _renderCurrent() {
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames8.default)(_style2.default.BaseSessionNav_current, _defineProperty({}, _style2.default.__populated, !!this.props.showCurrentNav)) },
        _is_js2.default.existy(this.props.currentLinkHref) ? _react2.default.createElement(
          _omniCommonUi.Button,
          { linkTo: this.props.currentLinkHref, type: _omniCommonUi.Button.Type.primary },
          'Current'
        ) : null
      );
    }
  }, {
    key: '_renderUnitSessionNavigation',
    value: function _renderUnitSessionNavigation() {
      return _react2.default.createElement(
        'div',
        { className: _style2.default.BaseSessionNav },
        this._renderCurrent(),
        _react2.default.createElement(
          'nav',
          { className: _style2.default.BaseSessionNav_navigator },
          this._renderPreviousButton(),
          _react2.default.createElement(
            'div',
            { className: _style2.default.BaseSessionNav_content },
            _react2.default.createElement(
              'div',
              { className: _style2.default.BaseSessionNav_content_line },
              _react2.default.createElement(
                'h1',
                { className: _style2.default.BaseSessionNav_content_line_heading },
                this._getHeadingText()
              ),
              this._getAdditionalChildren()
            )
          ),
          this._renderNextButton()
        ),
        this._renderUnits()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = BaseSessionNav.getCurrentRouteSegment(this.props) || {},
          settings = _ref.sessionNav;

      if (settings && settings.hidden === true) {
        return null;
      }

      return _react2.default.createElement(
        _CSSTransitionGroup2.default,
        { transitionName: 'session-nav', transitionAppear: true },
        (!settings || !settings.noUnitSessionNavigation) && !this.props.isHide && _react2.default.createElement(
          'div',
          { className: _style2.default.BaseSessionNav_navWrapper },
          this._renderUnitSessionNavigation()
        )
      );
    }
  }]);

  return BaseSessionNav;
}(_react.Component);

BaseSessionNav.getCurrentRouteSegment = function (props) {
  return props.routes && props.routes[props.routes.length - 1];
};

BaseSessionNav.propTypes = {
  routes: _propTypes2.default.array,
  showCurrentNav: _propTypes2.default.bool,
  showUnitNav: _propTypes2.default.bool,
  isHide: _propTypes2.default.bool,
  nextSessionLinkHref: _propTypes2.default.string,
  previousSessionLinkHref: _propTypes2.default.string,
  nextUnitLinkHref: _propTypes2.default.string,
  previousUnitLinkHref: _propTypes2.default.string,
  currentLinkHref: _propTypes2.default.string,
  buildRoute: _propTypes2.default.func.isRequired
};

exports.default = BaseSessionNav;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaperbasedHomeworkStatusColorMappins = exports.PaperbasedHomeworkStatusBackendNames = exports.PaperbasedHomeworkStatus = exports.DefaultPaperbasedHomeworkStatus = undefined;

var _PaperbasedHomeworkSt;

exports.covertBackendPaperBasedHomeworkStatusToHomeworkStatus = covertBackendPaperBasedHomeworkStatusToHomeworkStatus;
exports.validateHomeworkStatus = validateHomeworkStatus;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DefaultPaperbasedHomeworkStatus = exports.DefaultPaperbasedHomeworkStatus = 'unmarked';

var PaperbasedHomeworkStatus = exports.PaperbasedHomeworkStatus = {
  complete: 'Complete',
  incomplete: 'Incomplete',
  unmarked: 'UnMarked',
  notapplicable: 'NotApplicable',
  partialcomplete: 'PartialComplete'
};

var PaperbasedHomeworkStatusBackendNames = exports.PaperbasedHomeworkStatusBackendNames = {
  complete: PaperbasedHomeworkStatus.complete,
  incomplete: PaperbasedHomeworkStatus.incomplete,
  unmarked: PaperbasedHomeworkStatus.unmarked,
  partialcomplete: PaperbasedHomeworkStatus.partialcomplete,
  notapplicable: PaperbasedHomeworkStatus.notapplicable
};

var PaperbasedHomeworkStatusColorMappins = exports.PaperbasedHomeworkStatusColorMappins = (_PaperbasedHomeworkSt = {}, _defineProperty(_PaperbasedHomeworkSt, PaperbasedHomeworkStatus.complete, 'green'), _defineProperty(_PaperbasedHomeworkSt, PaperbasedHomeworkStatus.incomplete, 'red'), _defineProperty(_PaperbasedHomeworkSt, PaperbasedHomeworkStatus.partialcomplete, 'amber'), _PaperbasedHomeworkSt);

function covertBackendPaperBasedHomeworkStatusToHomeworkStatus(backendPaperBasedHomeworkStatus, isMarking) {
  var backendStatusLower = _is_js2.default.string(backendPaperBasedHomeworkStatus) ? backendPaperBasedHomeworkStatus.toLowerCase() : null;
  if (isMarking && (!backendPaperBasedHomeworkStatus || PaperbasedHomeworkStatusBackendNames[backendStatusLower] === PaperbasedHomeworkStatus.unmarked)) {
    return PaperbasedHomeworkStatus.complete;
  }
  return PaperbasedHomeworkStatusBackendNames[backendStatusLower] || PaperbasedHomeworkStatus.unmarked;
}

function validateHomeworkStatus(status) {
  if (PaperbasedHomeworkStatus[status]) {
    return true;
  }
  throw new Error('Status "' + status + '" is not valid! Use the Status object provided');
}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHfv4BandForScore = exports.HFV4_SCORE_BANDS = exports.USE_LOCAL_HFV4_SCORE_BANDS = undefined;

var _hfv4BandColors = __webpack_require__(815);

var _hfv4BandColors2 = _interopRequireDefault(_hfv4BandColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Fixed HFv4 score band data; mirrors backend ScoreBand model shape.
// To re-enable backend data, set USE_LOCAL_HFV4_SCORE_BANDS to false in this file
// and restore the fetchScoreBandIfNeeded call in StudentReportView/component.jsx.
var USE_LOCAL_HFV4_SCORE_BANDS = exports.USE_LOCAL_HFV4_SCORE_BANDS = true;

var HFV4_SCORE_BANDS = exports.HFV4_SCORE_BANDS = [{
  scorePercentageFrom: 0,
  scorePercentageTo: 59,
  name: 'Needs Improvement',
  color: _hfv4BandColors2.default.colorNeedsImprovement,
  interpretation: 'Your child is finding it difficult to understand and use the language and skills taught in this unit. They need extra support to practise key vocabulary and structures and to build confidence in using what they have learned.'
}, {
  scorePercentageFrom: 60,
  scorePercentageTo: 79,
  name: 'Developing',
  interpretation: 'Your child is making progress with the language and skills from this unit and is beginning to use them with some success. They are close to meeting expectations but may still need support or reminders to use new vocabulary and structures accurately and consistently.'
}, {
  scorePercentageFrom: 80,
  scorePercentageTo: 89,
  name: 'On Track',
  interpretation: 'Your child shows a good understanding of the language and skills taught in this unit and meets the expected learning goals. They can use the key vocabulary and structures independently in familiar activities, with only occasional mistakes.'
}, {
  scorePercentageFrom: 90,
  scorePercentageTo: 100,
  name: 'Outstanding',
  interpretation: 'Your child shows an excellent understanding of the language and skills taught in this unit and uses what they have learned confidently and accurately. They apply the unit\'s vocabulary and structures effectively in a range of activities and may use them flexibly or make clear connections with other learning.'
}];

var getHfv4BandForScore = exports.getHfv4BandForScore = function getHfv4BandForScore(score) {
  return HFV4_SCORE_BANDS.find(function (b) {
    return score >= b.scorePercentageFrom && score <= b.scorePercentageTo;
  });
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MERGED_SPEAKING_NAME = undefined;
exports.formatSkillScore = formatSkillScore;
exports.calculateQuizAverageScore = calculateQuizAverageScore;
exports.mergeSpeakingSkillResults = mergeSpeakingSkillResults;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolveSkillPercentage(skillResult) {
  var layeredScore = skillResult.layeredScore,
      layeredFullMark = skillResult.layeredFullMark;

  if (_is_js2.default.number(layeredScore) && _is_js2.default.number(layeredFullMark) && layeredFullMark > 0) {
    return layeredScore / layeredFullMark * 100;
  }
  if (_is_js2.default.number(skillResult.score)) return skillResult.score * 100;
  return null;
} // Pure HFv4 skill-score math. Call from ProgressReportHFv4 containers, not from
// `accessors.js` — that module is shared with legacy IDP views.
// Import as a namespace (`import * as skillScoreHFv4`) — these names deliberately
// mirror their non-HFv4 counterparts in `accessors.js`.
function formatSkillScore(skillResult) {
  var defaultText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '–';

  var percentage = resolveSkillPercentage(skillResult);
  if (percentage === null) return defaultText;
  return Math.round(percentage) + '%';
}

function calculateQuizAverageScore(skillResults) {
  if (!skillResults || skillResults.size <= 0) return null;

  var totalScore = 0;
  var scoreCount = 0;
  skillResults.forEach(function (skillResult) {
    var percentage = resolveSkillPercentage(skillResult);
    if (percentage !== null) {
      totalScore += Math.min(100, percentage);
      scoreCount += 1;
    }
  });

  if (scoreCount === 0) return null;
  return Math.round(totalScore / scoreCount);
}

var SPEAKING_1 = 'Speaking 1';
var SPEAKING_2 = 'Speaking 2';
var MERGED_SPEAKING_NAME = exports.MERGED_SPEAKING_NAME = 'Speaking 1 & 2';

function isSplitSpeaking(skillResult) {
  return skillResult.name === SPEAKING_1 || skillResult.name === SPEAKING_2;
}

// HFv4 units report Speaking 1 alone (unit 6 / unit 12) or Speaking 1 + Speaking 2.
// Both shapes are presented as a single Speaking 1 & 2 score, averaged when both are scored.
function mergeSpeakingSkillResults(skillResults) {
  if (!skillResults || !skillResults.size) return skillResults;

  var firstSpeakingIndex = skillResults.findIndex(isSplitSpeaking);
  if (firstSpeakingIndex < 0) return skillResults;

  var speakingResults = skillResults.filter(isSplitSpeaking);
  var percentages = speakingResults.map(resolveSkillPercentage).filter(function (percentage) {
    return percentage !== null;
  });
  var averagePercentage = percentages.size > 0 ? percentages.reduce(function (total, percentage) {
    return total + percentage;
  }, 0) / percentages.size : null;
  var hasScore = averagePercentage !== null;

  var mergedSpeaking = speakingResults.first().set('name', MERGED_SPEAKING_NAME).set('score', hasScore ? averagePercentage / 100 : null).set('layeredScore', hasScore ? averagePercentage : null).set('layeredFullMark', hasScore ? 100 : null);

  return skillResults.filterNot(isSplitSpeaking).insert(firstSpeakingIndex, mergedSpeaking);
}

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessors = exports.reducer = exports.actions = exports.Note = undefined;

var _component = __webpack_require__(623);

var _component2 = _interopRequireDefault(_component);

var _actions2 = __webpack_require__(199);

var _actions = _interopRequireWildcard(_actions2);

var _accessors2 = __webpack_require__(1350);

var _accessors = _interopRequireWildcard(_accessors2);

var _reducer2 = __webpack_require__(1351);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Note = exports.Note = _component2.default;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var accessors = exports.accessors = _accessors;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _ClassroomSessionNav = __webpack_require__(1387);

var _ClassroomSessionNav2 = _interopRequireDefault(_ClassroomSessionNav);

var _SessionPlans = __webpack_require__(44);

var _ = __webpack_require__(13);

var _UiState = __webpack_require__(30);

var _accessors = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SessionNav = function (_PureComponent) {
  _inherits(SessionNav, _PureComponent);

  function SessionNav() {
    _classCallCheck(this, SessionNav);

    return _possibleConstructorReturn(this, (SessionNav.__proto__ || Object.getPrototypeOf(SessionNav)).apply(this, arguments));
  }

  _createClass(SessionNav, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentSession = _props.currentSession,
          timeZone = _props.timeZone;


      if (!_is_js2.default.existy(currentSession) || !_is_js2.default.existy(timeZone)) {
        return null;
      }
      return _react2.default.createElement(_ClassroomSessionNav2.default, { currentLinkHref: this.props.currentLinkHref,
        currentSessionStartDate: currentSession.period.start.clone().tz(timeZone),
        currentSessionEndDate: currentSession.period.end.clone().tz(timeZone),
        currentSessionNumber: this.props.currentSessionIndex + 1,
        currentSessionType: currentSession.sessionType,
        currentGroupName: this.props.groupName,
        currentSessionId: this.props.currentSessionId,
        currentUnit: this.props.currentUnit,
        nextSessionLinkHref: this.props.nextSessionLinkHref,
        nextUnitLinkHref: this.props.nextUnitLinkHref,
        nextUnitText: this.props.nextUnitText,
        previousSessionLinkHref: this.props.previousSessionLinkHref,
        previousUnitLinkHref: this.props.previousUnitLinkHref,
        previousUnitText: this.props.previousUnitText,
        sessionCount: this.props.sessionCount,
        isHide: !this.props.showNavigationBar,
        showCurrentNav: true,
        shouldShowTime: this.props.shouldShowTime,
        showUnitNav: this.props.shouldShowUnitNav });
    }
  }]);

  return SessionNav;
}(_react.PureComponent);

SessionNav.propTypes = {
  groupName: _propTypes2.default.string,
  timeZone: _propTypes2.default.string,
  currentLinkHref: _propTypes2.default.string,
  currentSession: _propTypes2.default.object,
  currentSessionIndex: _propTypes2.default.number,
  currentUnit: _propTypes2.default.string,
  currentSessionId: _propTypes2.default.string,
  nextSessionLinkHref: _propTypes2.default.string,
  nextUnitLinkHref: _propTypes2.default.string,
  nextUnitText: _propTypes2.default.string,
  previousSessionLinkHref: _propTypes2.default.string,
  previousUnitLinkHref: _propTypes2.default.string,
  previousUnitText: _propTypes2.default.string,
  shouldShowUnitNav: _propTypes2.default.bool,
  sessionCount: _propTypes2.default.number,
  showNavigationBar: _propTypes2.default.bool,
  shouldShowTime: _propTypes2.default.bool
};

function getSessionLinkHref(sessionPlan, buildRoute) {
  var sessionPlanId = sessionPlan && sessionPlan.id;
  var unitId = sessionPlanId && Array.isArray(sessionPlan.unitIds) && sessionPlan.unitIds[0];

  var params = _is_js2.default.existy(unitId) ? { unitId: unitId, sessionPlanId: sessionPlanId, mode: '' } : { unitId: 0, sessionPlanId: sessionPlanId, mode: '' };
  return sessionPlanId && buildRoute(params);
}

function getPreviousOrNextSession(sessionList, currentSessionIndex, previous) {
  var previousOrNextSession = sessionList.get(previous ? currentSessionIndex - 1 : currentSessionIndex + 1);
  return previousOrNextSession;
}

function getUnitLinkHref(session, unitId, buildRoute) {
  return unitId && session && buildRoute({
    unitId: unitId,
    sessionPlanId: session.id,
    mode: ''
  });
}

function isSessionContainsUnit(session, unitId) {
  if (_is_js2.default.existy(unitId)) {
    session.unitIds.includes(unitId);
  }
  return false;
}

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      currentSessionId = _ownProps$params.sessionPlanId;

  if (!_is_js2.default.existy(groupId) || !_is_js2.default.existy(currentSessionId)) {
    return;
  }
  var buildRoute = ownProps.buildRoute;

  var group = state.get('rootReducer').get('groups').get(groupId) && state.get('rootReducer').get('groups').get(groupId).data;
  var sessions = _SessionPlans.actions.getSessions(state, groupId);
  var units = (0, _accessors.getUnitList)(state, groupId);
  if (_is_js2.default.existy(group) && _is_js2.default.existy(sessions) && sessions.size !== 0 && _is_js2.default.existy(units)) {
    var _Group$getCentre = _.actions.getCentre(state, groupId),
        timeZone = _Group$getCentre.timeZone;

    var sessionList = _SessionPlans.actions.getOrderSessions(state, groupId);
    var currentUnitId = _is_js2.default.existy(ownProps.params.unitId) ? ownProps.params.unitId : _SessionPlans.actions.getFirstUnitOfSession(state, currentSessionId);
    var defaultSession = _SessionPlans.actions.getDefaultSession(state, groupId);
    var currentSession = sessions.get(currentSessionId);
    var currentSessionIndex = currentSession.index - 1;
    var previousSession = getPreviousOrNextSession(sessionList, currentSessionIndex, true);
    var nextSession = getPreviousOrNextSession(sessionList, currentSessionIndex, false);
    var nextUnitId = currentUnitId > 0 ? (0, _accessors.getNextUnit)(state, currentUnitId, groupId) && (0, _accessors.getNextUnit)(state, currentUnitId, groupId).id : _SessionPlans.actions.getNextUnitIdBySessionId(state, groupId, currentSessionId);
    var previousUnitId = currentUnitId > 0 ? (0, _accessors.getPreviousUnit)(state, currentUnitId, groupId) && (0, _accessors.getPreviousUnit)(state, currentUnitId, groupId).id : _SessionPlans.actions.getPreviousUnitIdBySessionId(state, groupId, currentSessionId);
    var nextUnitHref = isSessionContainsUnit(currentSession, nextUnitId) ? getUnitLinkHref(currentSession, nextUnitId, buildRoute) : getUnitLinkHref(_SessionPlans.actions.getFirstSessionOfUnit(state, groupId, nextUnitId), nextUnitId, buildRoute);
    var previousUnitHref = isSessionContainsUnit(currentSession, previousUnitId) ? getUnitLinkHref(currentSession, previousUnitId, buildRoute) : getUnitLinkHref(_SessionPlans.actions.getFirstSessionOfUnit(state, groupId, previousUnitId), previousUnitId, buildRoute);
    var nextUnit = units.get(nextUnitId);
    var previousUnit = units.get(previousUnitId);
    var nextUnitText = nextUnit && 'U ' + nextUnit.orderingSequence;
    var previousUnitText = previousUnit && 'U ' + previousUnit.orderingSequence;
    var shouldShowUnitNav = !!(units && units.size !== 0);
    var currentUnit = units.get(currentUnitId);
    return {
      shouldShowTime: ownProps.shouldShowTime,
      timeZone: timeZone,
      currentLinkHref: getSessionLinkHref(defaultSession, buildRoute),
      currentSession: currentSession,
      currentSessionIndex: currentSessionIndex,
      groupName: group.name,
      currentSessionId: currentSessionId,
      currentUnit: currentUnit,
      nextSessionLinkHref: getSessionLinkHref(nextSession, buildRoute),
      nextUnitLinkHref: nextUnitHref,
      nextUnitText: nextUnitText,
      previousSessionLinkHref: getSessionLinkHref(previousSession, buildRoute),
      previousUnitLinkHref: previousUnitHref,
      previousUnitText: previousUnitText,
      shouldShowUnitNav: shouldShowUnitNav,
      sessionCount: sessions.size,
      showNavigationBar: _UiState.actions.getShowNavigationBar(state)
    };
  }
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null)(SessionNav);

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(1402);

var _component2 = _interopRequireDefault(_component);

var _Header = __webpack_require__(633);

var _Header2 = _interopRequireDefault(_Header);

var _Body = __webpack_require__(634);

var _Body2 = _interopRequireDefault(_Body);

var _Row = __webpack_require__(635);

var _Row2 = _interopRequireDefault(_Row);

var _Cell = __webpack_require__(636);

var _Cell2 = _interopRequireDefault(_Cell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_component2.default.Header = _Header2.default;
_component2.default.Body = _Body2.default;
_component2.default.Row = _Row2.default;
_component2.default.Cell = _Cell2.default;

exports.default = _component2.default;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1472);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _omniCommonUi = __webpack_require__(0);

var _model = __webpack_require__(289);

var _model2 = _interopRequireDefault(_model);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var STATUS_MISSING = _model2.default.Status.ScoresMissing.toLowerCase();
var STATUS_READY = _model2.default.Status.Ready.toLowerCase();
var STATUS_SENT_TO_DOS = _model2.default.Status.SentToDoS.toLowerCase();
var STATUS_COMPLETED = _model2.default.Status.Completed.toLowerCase();
var STATUS_PUBLISHED = _model2.default.Status.Published.toLowerCase();
var STATUS_REJECTED = _model2.default.Status.Rejected.toLowerCase();

var ProgressReportStatus = function ProgressReportStatus(props) {
  var _classnames;

  var status = props.status,
      className = props.className;


  var lowercaseStatus = status.toLowerCase();

  var containerClasses = (0, _classnames3.default)(_style2.default.ProgressReportStatus, className, (0, _omniCommonUi.testClass)('progress-report-status'));
  var statusClasses = (0, _classnames3.default)(_style2.default.ProgressReportStatus_inner, (_classnames = {}, _defineProperty(_classnames, _style2.default.__ready, lowercaseStatus === STATUS_READY), _defineProperty(_classnames, _style2.default.__sent, lowercaseStatus === STATUS_SENT_TO_DOS), _defineProperty(_classnames, _style2.default.__published, lowercaseStatus === STATUS_COMPLETED || lowercaseStatus === STATUS_PUBLISHED), _defineProperty(_classnames, _style2.default.__missing, lowercaseStatus === STATUS_MISSING), _defineProperty(_classnames, _style2.default.__rejected, lowercaseStatus === STATUS_REJECTED), _classnames));

  var statusToDisplay = void 0;
  switch (lowercaseStatus) {
    case STATUS_MISSING:
      statusToDisplay = 'Scores Missing';
      break;
    case STATUS_SENT_TO_DOS:
      statusToDisplay = 'Sent to DoS';
      break;
    default:
      statusToDisplay = status;
  }

  return _react2.default.createElement(
    'div',
    { className: containerClasses },
    _react2.default.createElement(
      'div',
      { className: statusClasses },
      statusToDisplay
    )
  );
};

ProgressReportStatus.propTypes = {
  className: _propTypes2.default.string,
  status: _propTypes2.default.string
};

exports.default = ProgressReportStatus;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessors = exports.Status = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(661);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1497);

var _reducer3 = _interopRequireDefault(_reducer2);

var _status = __webpack_require__(109);

var _Status = _interopRequireWildcard(_status);

var _accessors2 = __webpack_require__(209);

var _accessors = _interopRequireWildcard(_accessors2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var Status = exports.Status = _Status;
var accessors = exports.accessors = _accessors;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalisedHomework = exports.reducer = exports.accessors = exports.actions = undefined;

var _actions2 = __webpack_require__(744);

var _actions = _interopRequireWildcard(_actions2);

var _accessors2 = __webpack_require__(1711);

var _accessors = _interopRequireWildcard(_accessors2);

var _reducer2 = __webpack_require__(1712);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(320);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

_model2.default.actions = _actions;
_model2.default.accessors = _accessors;

var actions = exports.actions = _actions;
var accessors = exports.accessors = _accessors;
var reducer = exports.reducer = _reducer3.default;
var PersonalisedHomework = exports.PersonalisedHomework = _model2.default;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessors = exports.status = exports.reducer = exports.actions = exports.Homework = undefined;

var _actions2 = __webpack_require__(745);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1708);

var _reducer3 = _interopRequireDefault(_reducer2);

var _status2 = __webpack_require__(746);

var _status3 = _interopRequireDefault(_status2);

var _model = __webpack_require__(1710);

var _model2 = _interopRequireDefault(_model);

var _accessors2 = __webpack_require__(747);

var _accessors = _interopRequireWildcard(_accessors2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

_model2.default.Status = _status3.default;
_model2.default.accessors = _accessors;

var Homework = exports.Homework = _model2.default;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var status = exports.status = _status3.default;
var accessors = exports.accessors = _accessors;

/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SYNC_GROUP_FAILURE = exports.SYNC_GROUP_SUCCESS = exports.SYNC_GROUP_REQUEST = exports.FETCH_GROUP_FAILURE = exports.FETCH_GROUP_SUCCESS = exports.FETCH_GROUP_REQUEST = undefined;
exports.getGroup = getGroup;
exports.getCentre = getCentre;
exports.isCNGroup = isCNGroup;
exports.isIDGroup = isIDGroup;
exports.isGlobalGroup = isGlobalGroup;
exports.isTBCourseTypeGroup = isTBCourseTypeGroup;
exports.isTBv3Group = isTBv3Group;
exports.isNotTBv3Group = isNotTBv3Group;
exports.isHFCourseTypeGroup = isHFCourseTypeGroup;
exports.isHFV4CourseTypeGroup = isHFV4CourseTypeGroup;
exports.isSSCourseTypeGroup = isSSCourseTypeGroup;
exports.isSSV3Group = isSSV3Group;
exports.hasPaperBasedHomework = hasPaperBasedHomework;
exports.isFRCourseTypeGroup = isFRCourseTypeGroup;
exports.isFRV2CourseTypeGroup = isFRV2CourseTypeGroup;
exports.isDisabledReportActions = isDisabledReportActions;
exports.isSupportPTExportActions = isSupportPTExportActions;
exports.isSupportPTRetaken = isSupportPTRetaken;
exports.isSupportStudyReport = isSupportStudyReport;
exports.isSupportUnitReport = isSupportUnitReport;
exports.isGrammarProGroup = isGrammarProGroup;
exports.isKETCourseTypeGroup = isKETCourseTypeGroup;
exports.isRAv2CourseTypeGroup = isRAv2CourseTypeGroup;
exports.hasContentPath = hasContentPath;
exports.shouldEnableMarkAttendance = shouldEnableMarkAttendance;
exports.shouldShowAch = shouldShowAch;
exports.isAutoPublishHomework = isAutoPublishHomework;
exports.isAutoPublishCIC = isAutoPublishCIC;
exports.fetchGroupIfNeeded = fetchGroupIfNeeded;
exports.fetchGroup = fetchGroup;
exports.syncGroupInfo = syncGroupInfo;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _CourseType = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_GROUP_REQUEST = exports.FETCH_GROUP_REQUEST = 'FETCH_GROUP_REQUEST';
var FETCH_GROUP_SUCCESS = exports.FETCH_GROUP_SUCCESS = 'FETCH_GROUP_SUCCESS';
var FETCH_GROUP_FAILURE = exports.FETCH_GROUP_FAILURE = 'FETCH_GROUP_FAILURE';
var SYNC_GROUP_REQUEST = exports.SYNC_GROUP_REQUEST = 'SYNC_GROUP_REQUEST';
var SYNC_GROUP_SUCCESS = exports.SYNC_GROUP_SUCCESS = 'SYNC_GROUP_SUCCESS';
var SYNC_GROUP_FAILURE = exports.SYNC_GROUP_FAILURE = 'SYNC_GROUP_FAILURE';

function getGroup(state, groupId) {
  return state.get('rootReducer').get('groups').get(groupId) && state.get('rootReducer').get('groups').get(groupId).data;
}

function getCentre(state, groupId) {
  var group = state.get('rootReducer').get('groups').get(groupId);
  if (!group || !group.data) return {};
  return state.get('rootReducer').get('centres').get(group.data.centreId) || {};
}

function isCNGroup(state, groupId) {
  var centre = getCentre(state, groupId);
  return !_is_js2.default.undefined(centre.countryCode) && centre.countryCode.toUpperCase() === 'CN';
}

function isIDGroup(state, groupId) {
  var centre = getCentre(state, groupId);
  return !_is_js2.default.undefined(centre.countryCode) && centre.countryCode.toUpperCase() === 'ID';
}

function isGlobalGroup(state, groupId) {
  var centre = getCentre(state, groupId);
  if (_is_js2.default.undefined(centre.countryCode)) return false;
  return centre.countryCode.toUpperCase() === 'RU' || centre.countryCode.toUpperCase() === 'ID';
}

function isTBCourseTypeGroup(state, groupId) {
  return checkCurrentGroupCourseType(state, groupId, 'TB');
}

function isTBv3Group(state, groupId) {
  return checkCurrentGroupCourseTypeAndVersion(state, groupId, 'TB', 'v3');
}

function isNotTBv3Group(state, groupId) {
  return checkCurrentGroupCourseType(state, groupId, 'TB') && !checkCurrentGroupCourseTypeAndVersion(state, groupId, 'TB', 'v3');
}

function isHFCourseTypeGroup(state, groupId) {
  return checkCurrentGroupCourseType(state, groupId, 'HF');
}

function isHFV4CourseTypeGroup(state, groupId) {
  return checkCurrentGroupCourseTypeAndVersion(state, groupId, 'HF', 'V4');
}

function isSSCourseTypeGroup(state, groupId) {
  return checkCurrentGroupCourseType(state, groupId, 'SS');
}

function isSSV3Group(state, groupId) {
  return checkCurrentGroupCourseTypeAndVersion(state, groupId, 'SS', 'V3');
}

function hasPaperBasedHomework(state, groupId) {
  return isHFCourseTypeGroup(state, groupId) && !isHFV4CourseTypeGroup(state, groupId) || isSSCourseTypeGroup(state, groupId);
}

function isFRCourseTypeGroup(state, groupId) {
  return checkCurrentGroupCourseType(state, groupId, 'FR');
}

function isFRV2CourseTypeGroup(state, groupId) {
  return checkCurrentGroupCourseType(state, groupId, 'FR') && checkCurrentGroupCourseTypeAndVersion(state, groupId, 'FR', 'v2');
}

function isDisabledReportActions(state, groupId) {
  return isCNGroup(state, groupId) && (isTBCourseTypeGroup(state, groupId) || isSSCourseTypeGroup(state, groupId) || isHFCourseTypeGroup(state, groupId) && !isHFV4CourseTypeGroup(state, groupId));
}

function isSupportPTExportActions(state, groupId) {
  return isCNGroup(state, groupId) && (isTBv3Group(state, groupId) || isHFCourseTypeGroup(state, groupId) && !isHFV4CourseTypeGroup(state, groupId));
}

function isSupportPTRetaken(state, groupId) {
  return isTBv3Group(state, groupId) || isHFCourseTypeGroup(state, groupId) && !isHFV4CourseTypeGroup(state, groupId) || isFRCourseTypeGroup(state, groupId);
}

function isSupportStudyReport(state, groupId) {
  return isTBv3Group(state, groupId) || isFRCourseTypeGroup(state, groupId) || isHFCourseTypeGroup(state, groupId) && !isHFV4CourseTypeGroup(state, groupId) && hasContentPath(state, groupId);
}

function isSupportUnitReport(state, groupId) {
  return (isSSCourseTypeGroup(state, groupId) || isTBv3Group(state, groupId) || isHFCourseTypeGroup(state, groupId) && !isHFV4CourseTypeGroup(state, groupId) || isFRCourseTypeGroup(state, groupId)) && !isSupportStudyReport(state, groupId);
}

function isGrammarProGroup(state, groupId) {
  return checkCurrentGroupCourseType(state, groupId, 'GP');
}

function isKETCourseTypeGroup(state, groupId) {
  return checkCurrentGroupCourseType(state, groupId, 'KET');
}

function isRAv2CourseTypeGroup(state, groupId) {
  var group = state.get('rootReducer').get('groups').get(groupId);
  if (!group || !group.data || !group.data.courseTypeLevelId) return false;
  return _CourseType.RAV2_COURSE_TYPE_LEVEL_IDS.includes(group.data.courseTypeLevelId);
}

function hasContentPath(state, groupId) {
  var group = state.get('rootReducer').get('groups').get(groupId);
  if (!group || !group.data) return;
  return !!group.data.hasContentPath;
}

function checkCurrentGroupCourseType(state, groupId, courseTypeCode) {
  var group = state.get('rootReducer').get('groups').get(groupId);
  if (!group || !group.data || !group.data.courseTypeCode) return;
  return group.data.courseTypeCode.toLowerCase() === courseTypeCode.toLowerCase();
}

function checkCurrentGroupCourseTypeAndVersion(state, groupId, courseTypeCode, version) {
  var group = state.get('rootReducer').get('groups').get(groupId);
  if (!group || !group.data || !group.data.courseTypeCode || !group.data.courseTypeLevelCode) {
    return;
  }
  return group.data.courseTypeCode.toLowerCase() === courseTypeCode.toLowerCase() && group.data.courseTypeLevelCode.toLowerCase().startsWith(version.toLowerCase());
}

function shouldEnableMarkAttendance(state, groupId) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var shouldEnable = isFromOdin(state, groupId);
  if (_is_js2.default.undefined(shouldEnable)) return defaultValue;
  return !!shouldEnable;
}

function shouldShowAch(state, groupId) {
  var shouldShow = isFromOdin(state, groupId);
  if (_is_js2.default.undefined(shouldShow)) return true;
  return !!shouldShow;
}

function isFromOdin(state, groupId) {
  var group = state.get('rootReducer').get('groups').get(groupId);
  if (!group || !group.data) return;
  return !!group.data.isFromOdin;
}

function isAutoPublishHomework(state, groupId) {
  var group = state.get('rootReducer').get('groups').get(groupId);
  if (!group || !group.data) return;
  return group.data.autoPublishContent && group.data.autoPublishContent.includes('Assign Homework');
}

function isAutoPublishCIC(state, groupId) {
  var group = state.get('rootReducer').get('groups').get(groupId);
  if (!group || !group.data) return;
  return group.data.autoPublishContent && group.data.autoPublishContent.includes('CiC');
}

var buildGroupUrl = function buildGroupUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId);
};
var method = 'GET';

function fetchGroupIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: method, url: buildGroupUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchGroup(groupId));
  };
}

function fetchGroup(id) {
  return function (dispatch) {
    var url = buildGroupUrl(id);
    return dispatch(fetchGroupRequest(id)).payload.then(function (response) {
      return dispatch(fetchGroupSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchGroupFailure(error));
    });

    function fetchGroupRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUP_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        id: id
      });
    }

    function fetchGroupSuccess(group) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUP_SUCCESS,
        payload: group,
        url: url,
        method: method,
        id: id
      });
    }

    function fetchGroupFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUP_FAILURE,
        error: error,
        url: url,
        method: method,
        id: id
      });
    }
  };
}

function syncGroupInfo(id) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/groups/' + id + '/refresh');

    return dispatch(syncGroupRequest()).payload.then(function (response) {
      return dispatch(syncGroupSuccess(response));
    }).catch(function (error) {
      return dispatch(syncGroupFailure(error));
    });

    function syncGroupRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: SYNC_GROUP_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method
      });
    }

    function syncGroupSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: SYNC_GROUP_SUCCESS,
        payload: response,
        url: url,
        method: method
      });
    }

    function syncGroupFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SYNC_GROUP_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_SESSION_PLANS_FAILURE = exports.FETCH_SESSION_PLANS_SUCCESS = exports.FETCH_SESSION_PLANS_REQUEST = undefined;

var _accessors = __webpack_require__(36);

Object.keys(_accessors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _accessors[key];
    }
  });
});
exports.fetchSessionPlansIfNeeded = fetchSessionPlansIfNeeded;
exports.fetchSessionPlans = fetchSessionPlans;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_SESSION_PLANS_REQUEST = exports.FETCH_SESSION_PLANS_REQUEST = 'FETCH_SESSION_PLANS_REQUEST';

// accessors were previously here
var FETCH_SESSION_PLANS_SUCCESS = exports.FETCH_SESSION_PLANS_SUCCESS = 'FETCH_SESSION_PLANS_SUCCESS';
var FETCH_SESSION_PLANS_FAILURE = exports.FETCH_SESSION_PLANS_FAILURE = 'FETCH_SESSION_PLANS_FAILURE';

var buildSessionPlansUrl = function buildSessionPlansUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/sessions');
};
var method = 'GET';

function fetchSessionPlansIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: method, url: buildSessionPlansUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchSessionPlans(groupId));
  };
}

function fetchSessionPlans(groupId) {
  return function (dispatch) {
    var url = buildSessionPlansUrl(groupId);

    return dispatch(fetchSessionPlansRequest()).payload.then(function (response) {
      return dispatch(fetchSessionPlansSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchSessionPlansFailure(error));
    });

    function fetchSessionPlansRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_SESSION_PLANS_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchSessionPlansSuccess(sessions) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_SESSION_PLANS_SUCCESS,
        payload: sessions,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchSessionPlansFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_SESSION_PLANS_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _style = __webpack_require__(1274);

var _style2 = _interopRequireDefault(_style);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NormalTd = function NormalTd(props) {
  return _react2.default.createElement(
    'td',
    _extends({}, props, { className: (0, _classnames2.default)(_style2.default.NormalTd, props.className) }),
    props.children
  );
};

NormalTd.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

exports.default = NormalTd;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Status = exports.SessionAttendance = exports.actions = exports.reducer = undefined;

var _actions2 = __webpack_require__(621);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1324);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(287);

var _model2 = _interopRequireDefault(_model);

var _status = __webpack_require__(83);

var _Status = _interopRequireWildcard(_status);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var reducer = exports.reducer = _reducer3.default;
var actions = exports.actions = _actions;
var SessionAttendance = exports.SessionAttendance = _model2.default;
var Status = exports.Status = _Status;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuickSummary = exports.Type = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1354);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _Note = __webpack_require__(131);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _ProgressTests = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Type = exports.Type = {
  attendance: _Note.actions.STUDENT_NOTE_CATEGORY_ATTENDANCE,
  progressTest: _Note.actions.STUDENT_NOTE_CATEGORY_PROGRESS_TEST
};

var QuickSummary = exports.QuickSummary = function (_PureComponent) {
  _inherits(QuickSummary, _PureComponent);

  function QuickSummary() {
    _classCallCheck(this, QuickSummary);

    return _possibleConstructorReturn(this, (QuickSummary.__proto__ || Object.getPrototypeOf(QuickSummary)).apply(this, arguments));
  }

  _createClass(QuickSummary, [{
    key: '_renderUnitInfo',
    value: function _renderUnitInfo() {
      if (_is_js2.default.existy(this.props.currentUnit)) {
        return ', ' + this.props.currentUnit.name;
      }
      return '';
    }
  }, {
    key: '_renderAttendance',
    value: function _renderAttendance() {
      if (_is_js2.default.existy(this.props.currentSession)) {
        var _props$currentSession = this.props.currentSession,
            sessionType = _props$currentSession.sessionType,
            sessionIndex = _props$currentSession.index;

        return _react2.default.createElement(
          'span',
          { className: (0, _classnames2.default)(_style2.default.QuickSummary, this.props.className) },
          sessionIndex + '/' + this.props.sessionNumber,
          _react2.default.createElement(
            'span',
            null,
            ' (',
            _react2.default.createElement(
              'span',
              { className: _style2.default.QuickSummary_unit },
              sessionType
            ),
            ')'
          ),
          this._renderUnitInfo()
        );
      }
      return null;
    }
  }, {
    key: '_renderProgressTest',
    value: function _renderProgressTest() {
      if (_is_js2.default.existy(this.props.currentProgressTest)) {
        return _react2.default.createElement(
          'span',
          { className: _style2.default.QuickSummary },
          _ProgressTests.accessors.getPTName(this.props.currentProgressTest.name, this.props.isSSV3Group)
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      switch (this.props.type) {
        case Type.attendance:
          return this._renderAttendance();
        case Type.progressTest:
          return this._renderProgressTest();
        default:
          return null;
      }
    }
  }]);

  return QuickSummary;
}(_react.PureComponent);

QuickSummary.propTypes = {
  className: _propTypes2.default.string,
  entityId: _propTypes2.default.string,
  type: _propTypes2.default.string,
  currentSession: _propTypes2.default.object,
  currentUnit: _propTypes2.default.object,
  sessionNumber: _propTypes2.default.number,
  currentProgressTest: _propTypes2.default.object,
  isSSV3Group: _propTypes2.default.bool
};

QuickSummary.Type = Type;

function mapStateToProps(state, ownProps) {
  if (ownProps.type === Type.attendance) {
    var entityId = ownProps.entityId;

    var sessions = state.get('rootReducer').get('sessionPlans');
    var currentSession = sessions.get(entityId);
    return {
      currentSession: currentSession,
      sessionNumber: ownProps.sessionCount
    };
  }
  if (ownProps.type === Type.progressTest) {
    var progressTestPlan = state.get('rootReducer').get('progressTestsPlan');
    var currentProgressTest = void 0;
    if (_is_js2.default.existy(progressTestPlan)) {
      progressTestPlan.forEach(function (groupPlan) {
        if (groupPlan && groupPlan.data) {
          currentProgressTest = groupPlan.data.find(function (plan) {
            return plan.id === ownProps.entityId;
          });
          if (currentProgressTest) return false;
        }
      });
    }

    return {
      isSSV3Group: ownProps.isSSV3Group,
      currentProgressTest: currentProgressTest
    };
  }
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null)(QuickSummary);

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1401);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProgressReport = getProgressReport;
exports.getCombinedUnitSummariesText = getCombinedUnitSummariesText;
exports.getProgressReportById = getProgressReportById;
exports.getProgressReportIdBySessionId = getProgressReportIdBySessionId;

var _immutable = __webpack_require__(3);

function getProgressReport(state) {
  return state.get('rootReducer').get('progressReports');
}

/**
 * Concatenates non-empty `summary` strings from a progress report's `units`
 * (GET /groups/:groupId/unit-reports payload).
 */
function getCombinedUnitSummariesText(progressReport) {
  if (!progressReport) {
    return '';
  }

  var rawUnits = void 0;
  if (progressReport.get && typeof progressReport.get === 'function') {
    rawUnits = progressReport.get('units');
  } else {
    rawUnits = progressReport.units;
  }

  if (!rawUnits) {
    return '';
  }

  var unitsArray = void 0;
  if (_immutable.List.isList(rawUnits)) {
    unitsArray = rawUnits.toArray();
  } else if (Array.isArray(rawUnits)) {
    unitsArray = rawUnits;
  } else {
    unitsArray = [];
  }

  return unitsArray.map(function (unit) {
    if (!unit) {
      return '';
    }
    var summary = void 0;
    if (unit.get && typeof unit.get === 'function') {
      summary = unit.get('summary');
    } else {
      summary = unit.summary;
    }
    return summary && String(summary).trim();
  }).filter(function (s) {
    return s;
  }).join('\n\n');
}

function getProgressReportById(state, id) {
  return getProgressReport(state) && getProgressReport(state).get(id);
}

function getProgressReportIdBySessionId(state, sessionId) {
  var sessionPlans = state.get('rootReducer').get('sessionPlans');
  var progressReports = state.get('rootReducer').get('progressReports');

  var _sessionPlans$get = sessionPlans.get(sessionId),
      unitIds = _sessionPlans$get.unitIds;

  progressReports = progressReports.filter(function (progressReport) {
    return progressReport.units.reduce(function (isCurrentPR, unit) {
      return unitIds.includes('' + unit.get('id')) || isCurrentPR;
    }, false);
  });
  return progressReports.map(function (pr) {
    return pr.id;
  });
}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScoreBand = exports.reducer = exports.accessors = exports.actions = undefined;

var _actions2 = __webpack_require__(664);

var _actions = _interopRequireWildcard(_actions2);

var _accessors2 = __webpack_require__(1501);

var _accessors = _interopRequireWildcard(_accessors2);

var _reducer2 = __webpack_require__(1502);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(665);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

_model2.default.actions = _actions;
_model2.default.accessors = _accessors;

var actions = exports.actions = _actions;
var accessors = exports.accessors = _accessors;
var reducer = exports.reducer = _reducer3.default;
var ScoreBand = exports.ScoreBand = _model2.default;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _reducer2 = __webpack_require__(1558);

var _reducer3 = _interopRequireDefault(_reducer2);

var _actions2 = __webpack_require__(677);

var _actions = _interopRequireWildcard(_actions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _create = __webpack_require__(1709);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HomeworkContentItemRecord = (0, _immutable.Record)({
  homeworkContentId: undefined,
  name: undefined,
  description: undefined,
  isAssigned: undefined,
  homeworkType: undefined,
  isDeleted: undefined
});

var HomeworkContentRecord = (0, _immutable.Record)({
  unitId: undefined,
  unitOrderingSequence: undefined,
  lessonNumber: undefined,
  contentItems: new _immutable.OrderedMap()
});

var HomeworkContentItem = function (_HomeworkContentItemR) {
  _inherits(HomeworkContentItem, _HomeworkContentItemR);

  function HomeworkContentItem() {
    _classCallCheck(this, HomeworkContentItem);

    return _possibleConstructorReturn(this, (HomeworkContentItem.__proto__ || Object.getPrototypeOf(HomeworkContentItem)).apply(this, arguments));
  }

  return HomeworkContentItem;
}(HomeworkContentItemRecord);

var HomeworkContent = function (_HomeworkContentRecor) {
  _inherits(HomeworkContent, _HomeworkContentRecor);

  function HomeworkContent() {
    _classCallCheck(this, HomeworkContent);

    return _possibleConstructorReturn(this, (HomeworkContent.__proto__ || Object.getPrototypeOf(HomeworkContent)).apply(this, arguments));
  }

  return HomeworkContent;
}(HomeworkContentRecord);

HomeworkContentItem.create = function (data) {
  // lazy reviver
  var newData = new _immutable.Map(data);
  newData = newData.set('homeworkContentId', '' + data.homeworkContentId); // stringify
  return new HomeworkContentItem(newData);
};

HomeworkContent.serialize = function (model) {
  return (// eslint-disable-line no-confusing-arrow
    Array.isArray(model) ? model : model.map(function (lesson) {
      return lesson.update('contentItems', function (contentItems) {
        return contentItems.toArray();
      });
    }).toArray()
  );
};

HomeworkContent.Item = HomeworkContentItem;
HomeworkContent.create = _create2.default;

exports.default = HomeworkContent;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REJECT_STUDENT_IDP_REPORT_FAILURE = exports.REJECT_STUDENT_IDP_REPORT_SUCCESS = exports.REJECT_STUDENT_IDP_REPORT_REQUEST = exports.FETCH_IDP_PARTICIPATION_FAILURE = exports.FETCH_IDP_PARTICIPATION_SUCCESS = exports.FETCH_IDP_PARTICIPATION_REQUEST = exports.APPROVE_STUDENT_IDP_REPORT_FAILURE = exports.APPROVE_STUDENT_IDP_REPORT_SUCCESS = exports.APPROVE_STUDENT_IDP_REPORT_REQUEST = exports.FETCH_IDP_APPROVAL_LIST_FAILURE = exports.FETCH_IDP_APPROVAL_LIST_SUCCESS = exports.FETCH_IDP_APPROVAL_LIST_REQUEST = exports.SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_FAILURE = exports.SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_SUCCESS = exports.SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_REQUEST = exports.SUBMIT_IDP_PERIOD_FAILURE = exports.SUBMIT_IDP_PERIOD_SUCCESS = exports.SUBMIT_IDP_PERIOD_REQUEST = exports.SUBMIT_IDP_FEEDBACK_SUGGESTIONS_FAILURE = exports.SUBMIT_IDP_FEEDBACK_SUGGESTIONS_SUCCESS = exports.SUBMIT_IDP_FEEDBACK_SUGGESTIONS_REQUEST = exports.FETCH_IDP_FEEDBACK_SUGGESTIONS_FAILURE = exports.FETCH_IDP_FEEDBACK_SUGGESTIONS_SUCCESS = exports.FETCH_IDP_FEEDBACK_SUGGESTIONS_REQUEST = exports.FETCH_IDP_CHECK_FAILURE = exports.FETCH_IDP_CHECK_SUCCESS = exports.FETCH_IDP_CHECK_REQUEST = exports.FETCH_IDP_LEARNING_RESULT_FAILURE = exports.FETCH_IDP_LEARNING_RESULT_SUCCESS = exports.FETCH_IDP_LEARNING_RESULT_REQUEST = exports.GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE = exports.GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS = exports.GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST = exports.FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE = exports.FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS = exports.FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST = exports.FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE = exports.FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS = exports.FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST = undefined;
exports.fetchIndividualDevelopmentPlanListIfNeeded = fetchIndividualDevelopmentPlanListIfNeeded;
exports.fetchIndividualDevelopmentPlanList = fetchIndividualDevelopmentPlanList;
exports.fetchGroupIndividualDevelopmentPlanListIfNeeded = fetchGroupIndividualDevelopmentPlanListIfNeeded;
exports.fetchGroupIndividualDevelopmentPlanList = fetchGroupIndividualDevelopmentPlanList;
exports.generateIndividualDevelopmentList = generateIndividualDevelopmentList;
exports.fetchIdpCheck = fetchIdpCheck;
exports.fetchIdpLearningResultIfNeeded = fetchIdpLearningResultIfNeeded;
exports.fetchIdpLearningResult = fetchIdpLearningResult;
exports.fetchIdpFeedbackSuggestionsIfNeeded = fetchIdpFeedbackSuggestionsIfNeeded;
exports.fetchIdpFeedbackSuggestions = fetchIdpFeedbackSuggestions;
exports.submitIdpFeedbackSuggestions = submitIdpFeedbackSuggestions;
exports.submitIdpPeriod = submitIdpPeriod;
exports.submitIndividualDevelopmentPlan = submitIndividualDevelopmentPlan;
exports.fetchIdpApprovalListIfNeeded = fetchIdpApprovalListIfNeeded;
exports.fetchIdpApprovalList = fetchIdpApprovalList;
exports.approveStudentIdpReport = approveStudentIdpReport;
exports.rejectStudentIdpReport = rejectStudentIdpReport;
exports.fetchIdpParticipationIfNeeded = fetchIdpParticipationIfNeeded;
exports.fetchIdpParticipation = fetchIdpParticipation;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var _actions = __webpack_require__(324);

var odActions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST = exports.FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST = 'FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST';
var FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS = exports.FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS = 'FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS';
var FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE = exports.FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE = 'FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE';

var FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST = exports.FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST = 'FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST';
var FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS = exports.FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS = 'FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS';
var FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE = exports.FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE = 'FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE';

var GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST = exports.GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST = 'GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST';
var GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS = exports.GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS = 'GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS';
var GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE = exports.GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE = 'GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE';

var FETCH_IDP_LEARNING_RESULT_REQUEST = exports.FETCH_IDP_LEARNING_RESULT_REQUEST = 'FETCH_IDP_LEARNING_RESULT_REQUEST';
var FETCH_IDP_LEARNING_RESULT_SUCCESS = exports.FETCH_IDP_LEARNING_RESULT_SUCCESS = 'FETCH_IDP_LEARNING_RESULT_SUCCESS';
var FETCH_IDP_LEARNING_RESULT_FAILURE = exports.FETCH_IDP_LEARNING_RESULT_FAILURE = 'FETCH_IDP_LEARNING_RESULT_FAILURE';

var FETCH_IDP_CHECK_REQUEST = exports.FETCH_IDP_CHECK_REQUEST = 'FETCH_IDP_CHECK_REQUEST';
var FETCH_IDP_CHECK_SUCCESS = exports.FETCH_IDP_CHECK_SUCCESS = 'FETCH_IDP_CHECK_SUCCESS';
var FETCH_IDP_CHECK_FAILURE = exports.FETCH_IDP_CHECK_FAILURE = 'FETCH_IDP_CHECK_FAILURE';

var FETCH_IDP_FEEDBACK_SUGGESTIONS_REQUEST = exports.FETCH_IDP_FEEDBACK_SUGGESTIONS_REQUEST = 'FETCH_IDP_FEEDBACK_SUGGESTIONS_REQUEST';
var FETCH_IDP_FEEDBACK_SUGGESTIONS_SUCCESS = exports.FETCH_IDP_FEEDBACK_SUGGESTIONS_SUCCESS = 'FETCH_IDP_FEEDBACK_SUGGESTIONS_SUCCESS';
var FETCH_IDP_FEEDBACK_SUGGESTIONS_FAILURE = exports.FETCH_IDP_FEEDBACK_SUGGESTIONS_FAILURE = 'FETCH_IDP_FEEDBACK_SUGGESTIONS_FAILURE';

var SUBMIT_IDP_FEEDBACK_SUGGESTIONS_REQUEST = exports.SUBMIT_IDP_FEEDBACK_SUGGESTIONS_REQUEST = 'SUBMIT_IDP_FEEDBACK_SUGGESTIONS_REQUEST';
var SUBMIT_IDP_FEEDBACK_SUGGESTIONS_SUCCESS = exports.SUBMIT_IDP_FEEDBACK_SUGGESTIONS_SUCCESS = 'SUBMIT_IDP_FEEDBACK_SUGGESTIONS_SUCCESS';
var SUBMIT_IDP_FEEDBACK_SUGGESTIONS_FAILURE = exports.SUBMIT_IDP_FEEDBACK_SUGGESTIONS_FAILURE = 'SUBMIT_IDP_FEEDBACK_SUGGESTIONS_FAILURE';

var SUBMIT_IDP_PERIOD_REQUEST = exports.SUBMIT_IDP_PERIOD_REQUEST = 'SUBMIT_IDP_PERIOD_REQUEST';
var SUBMIT_IDP_PERIOD_SUCCESS = exports.SUBMIT_IDP_PERIOD_SUCCESS = 'SUBMIT_IDP_PERIOD_SUCCESS';
var SUBMIT_IDP_PERIOD_FAILURE = exports.SUBMIT_IDP_PERIOD_FAILURE = 'SUBMIT_IDP_PERIOD_FAILURE';

var SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_REQUEST = exports.SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_REQUEST = 'SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_REQUEST';
var SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_SUCCESS = exports.SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_SUCCESS = 'SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_SUCCESS';
var SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_FAILURE = exports.SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_FAILURE = 'SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_FAILURE';

var FETCH_IDP_APPROVAL_LIST_REQUEST = exports.FETCH_IDP_APPROVAL_LIST_REQUEST = 'FETCH_IDP_APPROVAL_LIST_REQUEST';
var FETCH_IDP_APPROVAL_LIST_SUCCESS = exports.FETCH_IDP_APPROVAL_LIST_SUCCESS = 'FETCH_IDP_APPROVAL_LIST_SUCCESS';
var FETCH_IDP_APPROVAL_LIST_FAILURE = exports.FETCH_IDP_APPROVAL_LIST_FAILURE = 'FETCH_IDP_APPROVAL_LIST_FAILURE';

var APPROVE_STUDENT_IDP_REPORT_REQUEST = exports.APPROVE_STUDENT_IDP_REPORT_REQUEST = 'APPROVE_STUDENT_IDP_REPORT_REQUEST';
var APPROVE_STUDENT_IDP_REPORT_SUCCESS = exports.APPROVE_STUDENT_IDP_REPORT_SUCCESS = 'APPROVE_STUDENT_IDP_REPORT_SUCCESS';
var APPROVE_STUDENT_IDP_REPORT_FAILURE = exports.APPROVE_STUDENT_IDP_REPORT_FAILURE = 'APPROVE_STUDENT_IDP_REPORT_FAILURE';

var FETCH_IDP_PARTICIPATION_REQUEST = exports.FETCH_IDP_PARTICIPATION_REQUEST = 'FETCH_IDP_PARTICIPATION_REQUEST';
var FETCH_IDP_PARTICIPATION_SUCCESS = exports.FETCH_IDP_PARTICIPATION_SUCCESS = 'FETCH_IDP_PARTICIPATION_SUCCESS';
var FETCH_IDP_PARTICIPATION_FAILURE = exports.FETCH_IDP_PARTICIPATION_FAILURE = 'FETCH_IDP_PARTICIPATION_FAILURE';

var REJECT_STUDENT_IDP_REPORT_REQUEST = exports.REJECT_STUDENT_IDP_REPORT_REQUEST = 'REJECT_STUDENT_IDP_REPORT_REQUEST';
var REJECT_STUDENT_IDP_REPORT_SUCCESS = exports.REJECT_STUDENT_IDP_REPORT_SUCCESS = 'REJECT_STUDENT_IDP_REPORT_SUCCESS';
var REJECT_STUDENT_IDP_REPORT_FAILURE = exports.REJECT_STUDENT_IDP_REPORT_FAILURE = 'REJECT_STUDENT_IDP_REPORT_FAILURE';

var buildIdpListUrl = function buildIdpListUrl(groupIdpId) {
  return (0, _Api.buildUrl)('/group-compulsory-idps/' + groupIdpId);
};

function fetchIndividualDevelopmentPlanListIfNeeded(groupIdpId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildIdpListUrl(groupIdpId) })) {
      return false;
    }

    return dispatch(fetchIndividualDevelopmentPlanList(groupIdpId));
  };
}

function fetchIndividualDevelopmentPlanList(groupIdpId) {
  return function (dispatch) {
    var method = 'GET';
    var url = buildIdpListUrl(groupIdpId);

    return dispatch(fetchIndividualDevelopmentPlanListRequest()).payload.then(function (response) {
      return dispatch(fetchIndividualDevelopmentPlanListSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchIndividualDevelopmentPlanListFailure(error));
    });

    function fetchIndividualDevelopmentPlanListRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST,
        payload: (0, _Api.fetch)(url),
        method: method,
        url: url
      });
    }

    function fetchIndividualDevelopmentPlanListSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS,
        payload: response,
        groupIdpId: parseInt(groupIdpId, 10),
        method: method,
        url: url
      });
    }

    function fetchIndividualDevelopmentPlanListFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

var buildGroupIdpListUrl = function buildGroupIdpListUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/group-compulsory-idps');
};

function fetchGroupIndividualDevelopmentPlanListIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildGroupIdpListUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchGroupIndividualDevelopmentPlanList(groupId));
  };
}

function fetchGroupIndividualDevelopmentPlanList(groupId) {
  return function (dispatch) {
    var method = 'GET';
    var url = buildGroupIdpListUrl(groupId);

    return dispatch(fetchGroupIndividualDevelopmentPlanListRequest()).payload.then(function (response) {
      return dispatch(fetchGroupIndividualDevelopmentPlanListSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchGroupIndividualDevelopmentPlanListFailure(error));
    });

    function fetchGroupIndividualDevelopmentPlanListRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST,
        payload: (0, _Api.fetch)(url),
        method: method,
        url: url
      });
    }

    function fetchGroupIndividualDevelopmentPlanListSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS,
        payload: response,
        groupId: groupId,
        method: method,
        url: url
      });
    }

    function fetchGroupIndividualDevelopmentPlanListFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

function generateIndividualDevelopmentList(groupIdpId) {
  return function (dispatch) {
    var method = 'POST';
    var url = (0, _Api.buildUrl)('/group-compulsory-idps/' + groupIdpId);

    return dispatch(generateIndividualDevelopmentListRequest()).payload.then(function (response) {
      return dispatch(generateIndividualDevelopmentListSuccess(response));
    }).catch(function (error) {
      return dispatch(generateIndividualDevelopmentListFailure(error));
    }).then(function () {
      return dispatch(fetchIndividualDevelopmentPlanList(groupIdpId));
    });

    function generateIndividualDevelopmentListRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST,
        payload: (0, _Api.fetch)(url, { method: method }),
        method: method,
        url: url
      });
    }

    function generateIndividualDevelopmentListSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS,
        payload: response,
        method: method,
        url: url
      });
    }

    function generateIndividualDevelopmentListFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

var buildIdpCheckUrl = function buildIdpCheckUrl(idpId) {
  return (0, _Api.buildUrl)('/student-idps/' + idpId + '/check');
};

function fetchIdpCheck(idpId) {
  return function (dispatch) {
    var method = 'GET';
    var url = buildIdpCheckUrl(idpId);

    return dispatch(fetchIdpCheckRequest()).payload.then(function (response) {
      return dispatch(fetchIdpCheckSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchIdpCheckFailure(error));
    });

    function fetchIdpCheckRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_IDP_CHECK_REQUEST,
        payload: (0, _Api.fetch)(url),
        method: method,
        url: url
      });
    }

    function fetchIdpCheckSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_IDP_CHECK_SUCCESS,
        payload: response,
        idpId: idpId,
        method: method,
        url: url
      });
    }

    function fetchIdpCheckFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_IDP_CHECK_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

var buildIdpLearningResultUrl = function buildIdpLearningResultUrl(idpId) {
  return (0, _Api.buildUrl)('/student-idps/' + idpId + '/learning-result');
};

function fetchIdpLearningResultIfNeeded(idpId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildIdpLearningResultUrl(idpId) })) {
      return false;
    }

    return dispatch(fetchIdpLearningResult(idpId));
  };
}

function fetchIdpLearningResult(idpId) {
  return function (dispatch) {
    var method = 'GET';
    var url = buildIdpLearningResultUrl(idpId);

    return dispatch(fetchIdpLearningResultRequest()).payload.then(function (response) {
      return dispatch(fetchIdpLearningResultSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchIdpLearningResultFailure(error));
    });

    function fetchIdpLearningResultRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_IDP_LEARNING_RESULT_REQUEST,
        payload: (0, _Api.fetch)(url),
        method: method,
        url: url
      });
    }

    function fetchIdpLearningResultSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_IDP_LEARNING_RESULT_SUCCESS,
        payload: response,
        idpId: idpId,
        method: method,
        url: url
      });
    }

    function fetchIdpLearningResultFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_IDP_LEARNING_RESULT_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

var buildIdpFeedbackSuggestionsUrl = function buildIdpFeedbackSuggestionsUrl(idpId) {
  return (0, _Api.buildUrl)('/student-idps/' + idpId + '/feedback-suggestions');
};

function fetchIdpFeedbackSuggestionsIfNeeded(idpId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildIdpFeedbackSuggestionsUrl(idpId) })) {
      return false;
    }

    return dispatch(fetchIdpFeedbackSuggestions(idpId));
  };
}

function fetchIdpFeedbackSuggestions(idpId) {
  return function (dispatch) {
    var method = 'GET';
    var url = buildIdpFeedbackSuggestionsUrl(idpId);

    return dispatch(fetchIdpFeedbackSuggestionsRequest()).payload.then(function (response) {
      return dispatch(fetchIdpFeedbackSuggestionsSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchIdpFeedbackSuggestionsFailure(error));
    });

    function fetchIdpFeedbackSuggestionsRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_IDP_FEEDBACK_SUGGESTIONS_REQUEST,
        payload: (0, _Api.fetch)(url),
        method: method,
        url: url
      });
    }

    function fetchIdpFeedbackSuggestionsSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_IDP_FEEDBACK_SUGGESTIONS_SUCCESS,
        payload: response,
        idpId: idpId,
        method: method,
        url: url
      });
    }

    function fetchIdpFeedbackSuggestionsFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_IDP_FEEDBACK_SUGGESTIONS_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

function submitIdpFeedbackSuggestions(idpId, suggestions, groupIdpId) {
  return function (dispatch) {
    var method = 'PUT';
    var url = (0, _Api.buildUrl)('/student-idps/' + idpId + '/feedback-suggestions');
    suggestions.skillSuggestions && suggestions.skillSuggestions.forEach(function (skillSuggestion) {
      // eslint-disable-next-line no-param-reassign
      skillSuggestion.selectedRecommendationList = skillSuggestion.selectedRecommendationList.map(function (id) {
        return parseInt(id, 10);
      });
    });
    return dispatch(submitIdpFeedbackSuggestionsRequest()).payload.then(function (response) {
      return dispatch(submitIdpFeedbackSuggestionsSuccess(response));
    }).catch(function (error) {
      return dispatch(submitIdpFeedbackSuggestionsFailure(error));
    }).then(function () {
      return dispatch(fetchIdpFeedbackSuggestions(idpId));
    }).then(function () {
      return dispatch(fetchIndividualDevelopmentPlanList(groupIdpId));
    });

    function submitIdpFeedbackSuggestionsRequest() {
      var body = JSON.stringify(suggestions);
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_IDP_FEEDBACK_SUGGESTIONS_REQUEST,
        payload: (0, _Api.fetch)(url, { method: method, body: body }),
        method: method,
        url: url
      });
    }

    function submitIdpFeedbackSuggestionsSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_IDP_FEEDBACK_SUGGESTIONS_SUCCESS,
        payload: response,
        method: method,
        url: url
      });
    }

    function submitIdpFeedbackSuggestionsFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_IDP_FEEDBACK_SUGGESTIONS_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

function submitIdpPeriod(idpId, period, groupIdpId) {
  return function (dispatch) {
    var method = 'PUT';
    var url = (0, _Api.buildUrl)('/student-idps/' + idpId);

    return dispatch(submitIdpPeriodRequest()).payload.then(function (response) {
      return dispatch(submitIdpPeriodSuccess(response));
    }).catch(function (error) {
      return dispatch(submitIdpPeriodFailure(error));
    }).then(function () {
      return dispatch(fetchIndividualDevelopmentPlanList(groupIdpId));
    }).then(function () {
      return dispatch(fetchIdpLearningResult(idpId));
    }).then(function () {
      return dispatch(fetchIdpFeedbackSuggestions(idpId));
    }).then(function () {
      return dispatch(odActions.fetchOverallDevelopmentTemplate(idpId));
    }).then(function () {
      return dispatch(odActions.fetchOverallDevelopmentResult(idpId));
    });

    function submitIdpPeriodRequest() {
      var body = JSON.stringify(period);
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_IDP_PERIOD_REQUEST,
        payload: (0, _Api.fetch)(url, { method: method, body: body }),
        method: method,
        url: url
      });
    }

    function submitIdpPeriodSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_IDP_PERIOD_SUCCESS,
        payload: response,
        method: method,
        url: url
      });
    }

    function submitIdpPeriodFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_IDP_PERIOD_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

function submitIndividualDevelopmentPlan(idpId, groupIdpId) {
  return function (dispatch) {
    var method = 'PUT';
    var url = (0, _Api.buildUrl)('/student-idps/' + idpId + '/submit');

    return dispatch(submitIndividualDevelopmentPlanRequest()).payload.then(function (response) {
      return dispatch(submitIndividualDevelopmentPlanSuccess(response));
    }).catch(function (error) {
      return dispatch(submitIndividualDevelopmentPlanFailure(error));
    }).then(function () {
      return dispatch(fetchIndividualDevelopmentPlanList(groupIdpId));
    });

    function submitIndividualDevelopmentPlanRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_REQUEST,
        payload: (0, _Api.fetch)(url, { method: method }),
        method: method,
        url: url
      });
    }

    function submitIndividualDevelopmentPlanSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_SUCCESS,
        payload: response,
        method: method,
        url: url
      });
    }

    function submitIndividualDevelopmentPlanFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

var buildIdpApprovalListUrl = function buildIdpApprovalListUrl(groupIdpId) {
  return (0, _Api.buildUrl)('/group-compulsory-idps/' + groupIdpId + '/dos-approval');
};

function fetchIdpApprovalListIfNeeded(groupIdpId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildIdpApprovalListUrl(groupIdpId) })) {
      return false;
    }

    return dispatch(fetchIdpApprovalList(groupIdpId));
  };
}

function fetchIdpApprovalList(groupIdpId) {
  return function (dispatch) {
    var method = 'GET';
    var url = buildIdpApprovalListUrl(groupIdpId);

    return dispatch(fetchIdpApprovalListRequest()).payload.then(function (response) {
      response.forEach(function (idpApproval) {
        return dispatch(fetchIdpFeedbackSuggestions(idpApproval.studentIDPId.toString()));
      });
      return dispatch(fetchIdpApprovalListSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchIdpApprovalListFailure(error));
    }).then(function () {
      return dispatch(fetchIndividualDevelopmentPlanList(groupIdpId));
    });

    function fetchIdpApprovalListRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_IDP_APPROVAL_LIST_REQUEST,
        payload: (0, _Api.fetch)(url),
        method: method,
        url: url
      });
    }

    function fetchIdpApprovalListSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_IDP_APPROVAL_LIST_SUCCESS,
        payload: response,
        groupIdpId: groupIdpId,
        method: method,
        url: url
      });
    }

    function fetchIdpApprovalListFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_IDP_APPROVAL_LIST_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

function approveStudentIdpReport(idpId, groupIdpId) {
  return function (dispatch) {
    var method = 'PUT';
    var url = (0, _Api.buildUrl)('/student-idps/' + idpId + '/dos-approve');

    return dispatch(approveStudentIdpReportRequest()).payload.then(function (response) {
      return dispatch(approveStudentIdpReportSuccess(response));
    }).catch(function (error) {
      return dispatch(approveStudentIdpReportFailure(error));
    }).then(function () {
      return dispatch(fetchIdpApprovalList(groupIdpId));
    }).then(function () {
      return dispatch(fetchIndividualDevelopmentPlanList(groupIdpId));
    });

    function approveStudentIdpReportRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: APPROVE_STUDENT_IDP_REPORT_REQUEST,
        payload: (0, _Api.fetch)(url, { method: method }),
        method: method,
        url: url
      });
    }

    function approveStudentIdpReportSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: APPROVE_STUDENT_IDP_REPORT_SUCCESS,
        payload: response,
        method: method,
        url: url
      });
    }

    function approveStudentIdpReportFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: APPROVE_STUDENT_IDP_REPORT_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

function rejectStudentIdpReport(idpId, groupIdpId, rejectedComment) {
  return function (dispatch) {
    var method = 'PUT';
    var url = (0, _Api.buildUrl)('/student-idps/' + idpId + '/dos-reject?rejectedComment=' + rejectedComment);

    return dispatch(rejectStudentIdpReportRequest()).payload.then(function (response) {
      return dispatch(rejectStudentIdpReportSuccess(response));
    }).catch(function (error) {
      return dispatch(rejectStudentIdpReportFailure(error));
    }).then(function () {
      return dispatch(fetchIdpApprovalList(groupIdpId));
    }).then(function () {
      return dispatch(fetchIndividualDevelopmentPlanList(groupIdpId));
    });

    function rejectStudentIdpReportRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: REJECT_STUDENT_IDP_REPORT_REQUEST,
        payload: (0, _Api.fetch)(url, { method: method }),
        method: method,
        url: url
      });
    }

    function rejectStudentIdpReportSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: REJECT_STUDENT_IDP_REPORT_SUCCESS,
        payload: response,
        method: method,
        url: url
      });
    }

    function rejectStudentIdpReportFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: REJECT_STUDENT_IDP_REPORT_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

var buildIdpParticipationUrl = (0, _Api.buildUrl)('/student-idps/participation');

function fetchIdpParticipationIfNeeded() {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildIdpParticipationUrl })) {
      return false;
    }

    return dispatch(fetchIdpParticipation());
  };
}

function fetchIdpParticipation() {
  return function (dispatch) {
    var method = 'GET';
    var url = buildIdpParticipationUrl;
    return dispatch(fetchIdpParticipationRequest()).payload.then(function (response) {
      return dispatch(fetchIdpParticipationSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchIdpParticipationFailure(error));
    });

    function fetchIdpParticipationRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_IDP_PARTICIPATION_REQUEST,
        payload: (0, _Api.fetch)(url),
        method: method,
        url: url
      });
    }

    function fetchIdpParticipationSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_IDP_PARTICIPATION_SUCCESS,
        payload: response,
        method: method,
        url: url
      });
    }

    function fetchIdpParticipationFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_IDP_PARTICIPATION_FAILURE,
        error: error,
        method: method,
        url: url
      });
    }
  };
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modes = undefined;

var _component = __webpack_require__(776);

var _component2 = _interopRequireDefault(_component);

var _IndividualDevelopmentPlanStatus = __webpack_require__(68);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _omniCommonUi = __webpack_require__(0);

var _immutable = __webpack_require__(3);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _StudentSelect = __webpack_require__(1798);

var _StudentSelect2 = _interopRequireDefault(_StudentSelect);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Modes = exports.Modes = {
  SUBMIT: 'submit',
  EXPORT: 'export',
  EDIT_COMMENTS: 'edit-comments',
  EDIT_STUDY_PLAN: 'edit-study-plan',
  EDIT_OVERALL_DEVELOPMENT: 'edit-overall-development'
};

function isStudyPlanComplete(studyPlan) {
  return studyPlan && studyPlan.some(function (sp) {
    return sp.coreCourseId;
  });
}

function isOverallDevelopmentCompleted(template, results) {
  return template && results && results.items.size > 0 && (template.strengths.some(function (st) {
    return st.items.size > 0;
  }) ? results.items.filter(function (result) {
    return result.typeCode === 'ST';
  }).size > 0 : true) && (template.improvementsModes.some(
  // (st) => st.items.size > 0) ?
  function (st) {
    return st.items.filter(function (od) {
      return !results.items.some(function (ri) {
        return od.unitId === ri.unitId && ri.typeCode === 'NA' && od.id === ri.subSkillId;
      });
    }).size > 0;
  }) ? results.items.filter(function (result) {
    return result.typeCode === 'IM';
  }).size > 0 : true) && (template.needAttentions.some(function (st) {
    return st.items.filter(function (od) {
      return !results.items.some(function (ri) {
        return od.unitId === ri.unitId && ri.typeCode === 'IM' && od.id === ri.subSkillId;
      });
    }).size > 0;
  }) ? results.items.filter(function (result) {
    return result.typeCode === 'NA';
  }).size > 0 : true);
}

var shouldDisableSubmit = function shouldDisableSubmit(getState, props) {
  var _props$params = props.params,
      groupId = _props$params.groupId,
      groupIdpId = _props$params.groupIdpId,
      studentId = _props$params.studentId,
      mode = _props$params.mode;


  var isSSv3Group = _.actions.isSSV3Group(getState(), groupId);
  var idpId = _IndividualDevelopmentPlans.accessors.getIdpId(getState(), groupIdpId, studentId);
  var idpStatus = _IndividualDevelopmentPlans.accessors.getIdpStatus(getState(), idpId);
  var studyPlan = getState().get('rootReducer').get('studyPlan').get(idpId);
  var studyPlanResult = studyPlan && studyPlan.get('result');
  var isSPComplete = isStudyPlanComplete(studyPlanResult);
  var overallDevelopment = getState().get('rootReducer').get('overallDevelopment').get(idpId);
  var overallDevelopmentResult = overallDevelopment && overallDevelopment.get('result');
  var overallDevelopmentTemplate = overallDevelopment && overallDevelopment.get('template');
  var isODCompleted = isOverallDevelopmentCompleted(overallDevelopmentTemplate, overallDevelopmentResult);
  var isSuggestionsInfoComplete = _IndividualDevelopmentPlans.accessors.isSuggestionsInfoComplete(getState(), props);

  return !isSPComplete || !isSuggestionsInfoComplete || Modes.SUBMIT === mode || Modes.EDIT_COMMENTS === mode || Modes.EDIT_STUDY_PLAN === mode || isSSv3Group && (Modes.EDIT_OVERALL_DEVELOPMENT === mode || !isODCompleted) || !idpStatus || idpStatus.toLowerCase() !== _IndividualDevelopmentPlanStatus.IdpStatus.READY.toLowerCase() || isAnyApiCallSaving(getState());
};

var shouldDisableExport = function shouldDisableExport(getState, props) {
  var _props$params2 = props.params,
      groupIdpId = _props$params2.groupIdpId,
      studentId = _props$params2.studentId,
      mode = _props$params2.mode;


  var idpId = _IndividualDevelopmentPlans.accessors.getIdpId(getState(), groupIdpId, studentId);
  var idpStatus = _IndividualDevelopmentPlans.accessors.getIdpStatus(getState(), idpId);
  return [].concat(_toConsumableArray(Object.values(Modes))).includes(mode) || !idpStatus || idpStatus.toLowerCase() !== _IndividualDevelopmentPlanStatus.IdpStatus.COMPLETED.toLowerCase();
};

var actionButtons = function actionButtons(getState) {
  return {
    Submit: {
      isPrimary: true,
      route: './submit',
      disableWhen: function disableWhen(props) {
        return shouldDisableSubmit(getState, props);
      },
      visibleWhen: function visibleWhen(_ref) {
        var params = _ref.params;
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.Manage) && !_.actions.isDisabledReportActions(getState(), params.groupId);
      }
    },
    Export: {
      isPrimary: false,
      route: './export',
      disableWhen: function disableWhen(props) {
        return shouldDisableExport(getState, props);
      },
      visibleWhen: function visibleWhen() {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.Manage);
      }
    }
  };
};

exports.default = function (_ref2) {
  var _actionButtons;

  var getState = _ref2.getState;
  return {
    appBars: {
      sticky: {
        'student-select': {
          component: _StudentSelect2.default,
          order: 1
        },
        'view-nav': {
          component: _ViewNav2.default,
          props: {
            showExpandable: true
          },
          order: 2
        }
      }
    },
    path: ':groupIdpId/student/:studentId(/:mode)',
    component: _component2.default,
    canAccess: function canAccess(props) {
      if (!_component2.default.isInEditCommentsMode(props) && !_component2.default.isInEditStudyPlanMode(props) && !_component2.default.isInEditOverallDevelopmentMode(props)) return true;

      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.Manage);
    },
    breadcrumbLabels: 'student report',
    actionButtons: (_actionButtons = {
      default: actionButtons(getState)
    }, _defineProperty(_actionButtons, Modes.SUBMIT, actionButtons(getState)), _defineProperty(_actionButtons, Modes.EDIT_COMMENTS, actionButtons(getState)), _defineProperty(_actionButtons, Modes.EDIT_STUDY_PLAN, actionButtons(getState)), _defineProperty(_actionButtons, Modes.EDIT_OVERALL_DEVELOPMENT, actionButtons(getState)), _defineProperty(_actionButtons, Modes.EXPORT, actionButtons(getState)), _actionButtons)
  };
};

function isAnyApiCallSaving(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST', 'DELETE'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modes = exports.SHOW_EXPORT_LANGUAGE = exports.SHOW_EXPORT = undefined;

var _component = __webpack_require__(828);

var _component2 = _interopRequireDefault(_component);

var _IndividualDevelopmentPlanStatus = __webpack_require__(68);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _omniCommonUi = __webpack_require__(0);

var _immutable = __webpack_require__(3);

var _ViewNav = __webpack_require__(822);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _StudentSelect = __webpack_require__(2012);

var _StudentSelect2 = _interopRequireDefault(_StudentSelect);

var _ = __webpack_require__(13);

var _exportFlags = __webpack_require__(823);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.SHOW_EXPORT = _exportFlags.SHOW_EXPORT;
exports.SHOW_EXPORT_LANGUAGE = _exportFlags.SHOW_EXPORT_LANGUAGE;
var Modes = exports.Modes = {
  SUBMIT: 'submit',
  EXPORT: 'export',
  EDIT_COMMENTS: 'edit-comments',
  EDIT_STUDY_PLAN: 'edit-study-plan',
  EDIT_OVERALL_DEVELOPMENT: 'edit-overall-development'
};

function isOverallDevelopmentCompleted(template, results) {
  return template && results && results.items.size > 0 && (template.strengths.some(function (st) {
    return st.items.size > 0;
  }) ? results.items.filter(function (result) {
    return result.typeCode === 'ST';
  }).size > 0 : true) && (template.improvementsModes.some(
  // (st) => st.items.size > 0) ?
  function (st) {
    return st.items.filter(function (od) {
      return !results.items.some(function (ri) {
        return od.unitId === ri.unitId && ri.typeCode === 'NA' && od.id === ri.subSkillId;
      });
    }).size > 0;
  }) ? results.items.filter(function (result) {
    return result.typeCode === 'IM';
  }).size > 0 : true) && (template.needAttentions.some(function (st) {
    return st.items.filter(function (od) {
      return !results.items.some(function (ri) {
        return od.unitId === ri.unitId && ri.typeCode === 'IM' && od.id === ri.subSkillId;
      });
    }).size > 0;
  }) ? results.items.filter(function (result) {
    return result.typeCode === 'NA';
  }).size > 0 : true);
}

var shouldDisableSubmit = function shouldDisableSubmit(getState, props) {
  var _props$params = props.params,
      groupIdpId = _props$params.groupIdpId,
      studentId = _props$params.studentId,
      mode = _props$params.mode;


  var idpId = _IndividualDevelopmentPlans.accessors.getIdpId(getState(), groupIdpId, studentId);
  var idpStatus = _IndividualDevelopmentPlans.accessors.getIdpStatus(getState(), idpId);

  return Modes.SUBMIT === mode || Modes.EDIT_COMMENTS === mode || !idpStatus || idpStatus.toLowerCase() !== _IndividualDevelopmentPlanStatus.IdpStatus.READY.toLowerCase() || isAnyApiCallSaving(getState());
};

var shouldDisableExport = function shouldDisableExport(props) {
  return props.params.mode === Modes.EXPORT;
};

var actionButtons = function actionButtons(getState) {
  return {
    Submit: {
      isPrimary: true,
      route: './submit',
      disableWhen: function disableWhen(props) {
        return shouldDisableSubmit(getState, props);
      },
      visibleWhen: function visibleWhen(_ref) {
        var params = _ref.params;
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.Manage) && !_.actions.isDisabledReportActions(getState(), params.groupId);
      }
    },
    Export: {
      isPrimary: false,
      route: './export',
      disableWhen: function disableWhen(props) {
        return shouldDisableExport(props);
      },
      visibleWhen: function visibleWhen() {
        return _exportFlags.SHOW_EXPORT && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.View);
      }
    }
  };
};

exports.default = function (_ref2) {
  var _actionButtons;

  var getState = _ref2.getState;
  return {
    appBars: {
      sticky: {
        'student-select': {
          component: _StudentSelect2.default,
          order: 1
        },
        'view-nav': {
          component: _ViewNav2.default,
          props: {
            hideExpandable: true
          },
          order: 2
        }
      }
    },
    path: ':groupIdpId/student/:studentId(/:mode)',
    component: _component2.default,
    canAccess: function canAccess(props) {
      if (!_component2.default.isInEditCommentsMode(props) && !_component2.default.isInEditStudyPlanMode(props) && !_component2.default.isInEditOverallDevelopmentMode(props)) return true;

      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.Manage);
    },
    breadcrumbLabels: 'student report',
    actionButtons: (_actionButtons = {
      default: actionButtons(getState)
    }, _defineProperty(_actionButtons, Modes.SUBMIT, actionButtons(getState)), _defineProperty(_actionButtons, Modes.EDIT_COMMENTS, actionButtons(getState)), _defineProperty(_actionButtons, Modes.EDIT_STUDY_PLAN, actionButtons(getState)), _defineProperty(_actionButtons, Modes.EDIT_OVERALL_DEVELOPMENT, actionButtons(getState)), _defineProperty(_actionButtons, Modes.EXPORT, actionButtons(getState)), _actionButtons)
  };
};

function isAnyApiCallSaving(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST', 'DELETE'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KET_EXAM_TYPE_REAL = exports.KET_EXAM_TYPE_MOCK = exports.KetStudentResult = exports.KetSkill = exports.KetExam = exports.reducer = exports.accessors = exports.actions = undefined;

var _actions2 = __webpack_require__(836);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(2051);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(338);

var _model2 = _interopRequireDefault(_model);

var _accessors2 = __webpack_require__(2052);

var _accessors = _interopRequireWildcard(_accessors2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

_model2.default.actions = _actions;
_model2.default.accessors = _accessors;

var actions = exports.actions = _actions;
var accessors = exports.accessors = _accessors;
var reducer = exports.reducer = _reducer3.default;
var KetExam = exports.KetExam = _model2.default;
exports.KetSkill = _model.KetSkill;
exports.KetStudentResult = _model.KetStudentResult;
exports.KET_EXAM_TYPE_MOCK = _model.KET_EXAM_TYPE_MOCK;
exports.KET_EXAM_TYPE_REAL = _model.KET_EXAM_TYPE_REAL;

/***/ }),
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RAV2_COURSE_TYPE_LEVEL_IDS = undefined;
exports.getRAv2LevelNumber = getRAv2LevelNumber;
exports.isHFv4CourseTypeLevelCode = isHFv4CourseTypeLevelCode;
exports.getExamBasePath = getExamBasePath;
exports.getUnitReportBasePath = getUnitReportBasePath;
exports.getProgressReportBasePath = getProgressReportBasePath;

var _ExamRouteVariant = __webpack_require__(591);

var RAV2_COURSE_TYPE_LEVEL_IDS = exports.RAV2_COURSE_TYPE_LEVEL_IDS = ['102001', '102002', '102003', '102004', '102005', '102006', '102007'];

function getRAv2LevelNumber(courseTypeLevelId) {
  var index = RAV2_COURSE_TYPE_LEVEL_IDS.indexOf(courseTypeLevelId);
  return index >= 0 ? index + 1 : undefined;
}

function isHFv4CourseTypeLevelCode(fullCourseTypeLevelCode) {
  return typeof fullCourseTypeLevelCode === 'string' && fullCourseTypeLevelCode.toLowerCase().startsWith('hfv4');
}

function getExamBasePath() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      fullCourseTypeLevelCode = _ref.fullCourseTypeLevelCode;

  return isHFv4CourseTypeLevelCode(fullCourseTypeLevelCode) ? (0, _ExamRouteVariant.getExamPathSegmentByVariantId)('hfv4') : _ExamRouteVariant.BASE_EXAM_PATH;
}

function getUnitReportBasePath() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      fullCourseTypeLevelCode = _ref2.fullCourseTypeLevelCode;

  return isHFv4CourseTypeLevelCode(fullCourseTypeLevelCode) ? 'unit-report-hfv4' : 'unit-report';
}

function getProgressReportBasePath() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      fullCourseTypeLevelCode = _ref3.fullCourseTypeLevelCode;

  return isHFv4CourseTypeLevelCode(fullCourseTypeLevelCode) ? 'progress-report-hfv4' : 'progress-report';
}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLoadingMembers = exports.getMemberById = exports.getMembersByGroup = exports.FETCH_GROUP_MEMBERS_FAILURE = exports.FETCH_GROUP_MEMBERS_SUCCESS = exports.FETCH_GROUP_MEMBERS_REQUEST = undefined;
exports.fetchGroupMembersIfNeeded = fetchGroupMembersIfNeeded;
exports.fetchGroupMembers = fetchGroupMembers;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var _accessors = __webpack_require__(195);

var accessors = _interopRequireWildcard(_accessors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var FETCH_GROUP_MEMBERS_REQUEST = exports.FETCH_GROUP_MEMBERS_REQUEST = 'FETCH_GROUP_MEMBERS_REQUEST';
var FETCH_GROUP_MEMBERS_SUCCESS = exports.FETCH_GROUP_MEMBERS_SUCCESS = 'FETCH_GROUP_MEMBERS_SUCCESS';
var FETCH_GROUP_MEMBERS_FAILURE = exports.FETCH_GROUP_MEMBERS_FAILURE = 'FETCH_GROUP_MEMBERS_FAILURE';

var buildMembersUrl = function buildMembersUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/members');
};

var getMembersByGroup = accessors.getMembersByGroup,
    getMemberById = accessors.getMemberById,
    isLoadingMembers = accessors.isLoadingMembers;
exports.getMembersByGroup = getMembersByGroup;
exports.getMemberById = getMemberById;
exports.isLoadingMembers = isLoadingMembers;
function fetchGroupMembersIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildMembersUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchGroupMembers(groupId));
  };
}

function fetchGroupMembers(groupId) {
  return function (dispatch) {
    var url = buildMembersUrl(groupId);
    var method = 'GET';

    return dispatch(fetchMembersRequest()).payload.then(function (response) {
      return dispatch(fetchMembersSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchMembersFailure(error));
    });

    function fetchMembersRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUP_MEMBERS_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchMembersSuccess(members) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUP_MEMBERS_SUCCESS,
        payload: members,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchMembersFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUP_MEMBERS_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMembersByGroup = getMembersByGroup;
exports.getDefaultMember = getDefaultMember;
exports.getMemberById = getMemberById;
exports.isLoadingMembers = isLoadingMembers;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var _sort = __webpack_require__(1225);

var _sort2 = _interopRequireDefault(_sort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildMembersUrl = function buildMembersUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/members');
};

function getMembersByGroup(state, groupId) {
  return state.get('rootReducer').get('groupMembers').filter(function (member) {
    return member.groupId === groupId;
  }).toList().sort(_sort2.default);
}

function getDefaultMember(state, groupId) {
  var members = getMembersByGroup(state, groupId);
  if (_is_js2.default.existy(members) && members.size !== 0) {
    return members.get(0);
  }
}

function getMemberById(state, id) {
  return state.get('rootReducer').get('groupMembers').get(id);
}

function isLoadingMembers(state, groupId) {
  var callState = _omniCommonUi.ApiCall.find(state, { method: 'GET', url: buildMembersUrl(groupId) });
  return _omniCommonUi.ApiCall.State.isValue(callState) && _omniCommonUi.ApiCall.State.isLoading(callState);
}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GroupStatus = {
  active: 'Active',
  forming: 'Forming',
  closed: 'Closed'
};

var isActive = exports.isActive = function isActive(status) {
  return status === GroupStatus.active;
};

exports.default = { isActive: isActive };

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStudentById = exports.getStudents = undefined;

var _immutableCursor = __webpack_require__(577);

var _immutableCursor2 = _interopRequireDefault(_immutableCursor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PATH = ['rootReducer', 'student'];

var getStudents = exports.getStudents = function getStudents(state) {
  return _immutableCursor2.default.from(state, PATH).deref();
};

var getStudentById = exports.getStudentById = function getStudentById(state, studentId) {
  return getStudents(state).get(studentId);
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_STUDENT_FAILURE = exports.FETCH_STUDENT_SUCCESS = exports.FETCH_STUDENT_REQUEST = undefined;
exports.getApiCallState = getApiCallState;
exports.fetchStudentIfNeeded = fetchStudentIfNeeded;
exports.fetchStudent = fetchStudent;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var _accessors = __webpack_require__(197);

var accessors = _interopRequireWildcard(_accessors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_STUDENT_REQUEST = exports.FETCH_STUDENT_REQUEST = 'FETCH_STUDENT_REQUEST';
var FETCH_STUDENT_SUCCESS = exports.FETCH_STUDENT_SUCCESS = 'FETCH_STUDENT_SUCCESS';
var FETCH_STUDENT_FAILURE = exports.FETCH_STUDENT_FAILURE = 'FETCH_STUDENT_FAILURE';

var buildStudentUrl = function buildStudentUrl(studentId) {
  return (0, _Api.buildUrl)('/students/' + studentId);
};

function getApiCallState(state, studentId) {
  return _omniCommonUi.ApiCall.find(state, { method: 'GET', url: buildStudentUrl(studentId) });
}

function fetchStudentIfNeeded(studentId) {
  return function (dispatch, getState) {
    var state = getState();
    if (_is_js2.default.existy(accessors.getStudentById(state, studentId)) || !_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildStudentUrl(studentId) })) {
      return false;
    }

    return dispatch(fetchStudent(studentId));
  };
}

function fetchStudent(studentId) {
  return function (dispatch) {
    var url = buildStudentUrl(studentId);
    var method = 'GET';

    return dispatch(fetchStudentRequest()).payload.then(function (response) {
      return dispatch(fetchStudentSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchStudentFailure(error));
    });

    function fetchStudentRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        studentId: studentId,
        disableDefault: true
      });
    }

    function fetchStudentSuccess(student) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_SUCCESS,
        payload: student,
        url: url,
        method: method,
        studentId: studentId
      });
    }

    function fetchStudentFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_FAILURE,
        error: error,
        url: url,
        method: method,
        studentId: studentId
      });
    }
  };
}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STUDENT_NOTE_CATEGORY_PROGRESS_TEST = exports.STUDENT_NOTE_CATEGORY_ATTENDANCE = exports.SUBMIT_STUDENT_NOTE_FAILURE = exports.SUBMIT_STUDENT_NOTE_SUCCESS = exports.SUBMIT_STUDENT_NOTE_REQUEST = exports.FETCH_STUDENT_NOTES_FAILURE = exports.FETCH_STUDENT_NOTES_SUCCESS = exports.FETCH_STUDENT_NOTES_REQUEST = exports.FETCH_SINGLE_STUDENT_NOTE_FAILURE = exports.FETCH_SINGLE_STUDENT_NOTE_SUCCESS = exports.FETCH_SINGLE_STUDENT_NOTE_REQUEST = undefined;
exports.getApiCallState = getApiCallState;
exports.fetchSingleStudentNoteIfNeeded = fetchSingleStudentNoteIfNeeded;
exports.fetchSingleStudentNote = fetchSingleStudentNote;
exports.fetchStudentNotesIfNeeded = fetchStudentNotesIfNeeded;
exports.fetchStudentNotes = fetchStudentNotes;
exports.submitStudentNote = submitStudentNote;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_SINGLE_STUDENT_NOTE_REQUEST = exports.FETCH_SINGLE_STUDENT_NOTE_REQUEST = 'FETCH_SINGLE_STUDENT_NOTE_REQUEST';
var FETCH_SINGLE_STUDENT_NOTE_SUCCESS = exports.FETCH_SINGLE_STUDENT_NOTE_SUCCESS = 'FETCH_SINGLE_STUDENT_NOTE_SUCCESS';
var FETCH_SINGLE_STUDENT_NOTE_FAILURE = exports.FETCH_SINGLE_STUDENT_NOTE_FAILURE = 'FETCH_SINGLE_STUDENT_NOTE_FAILURE';
var FETCH_STUDENT_NOTES_REQUEST = exports.FETCH_STUDENT_NOTES_REQUEST = 'FETCH_STUDENT_NOTES_REQUEST';
var FETCH_STUDENT_NOTES_SUCCESS = exports.FETCH_STUDENT_NOTES_SUCCESS = 'FETCH_STUDENT_NOTES_SUCCESS';
var FETCH_STUDENT_NOTES_FAILURE = exports.FETCH_STUDENT_NOTES_FAILURE = 'FETCH_STUDENT_NOTES_FAILURE';
var SUBMIT_STUDENT_NOTE_REQUEST = exports.SUBMIT_STUDENT_NOTE_REQUEST = 'SUBMIT_STUDENT_NOTE_REQUEST';
var SUBMIT_STUDENT_NOTE_SUCCESS = exports.SUBMIT_STUDENT_NOTE_SUCCESS = 'SUBMIT_STUDENT_NOTE_SUCCESS';
var SUBMIT_STUDENT_NOTE_FAILURE = exports.SUBMIT_STUDENT_NOTE_FAILURE = 'SUBMIT_STUDENT_NOTE_FAILURE';

var STUDENT_NOTE_CATEGORY_ATTENDANCE = exports.STUDENT_NOTE_CATEGORY_ATTENDANCE = 'attendance';
var STUDENT_NOTE_CATEGORY_PROGRESS_TEST = exports.STUDENT_NOTE_CATEGORY_PROGRESS_TEST = 'progressTest';

/* --- */

var DISABLE_DEFAULT_ACTION_EXTRAS = { disableDefault: true };

var buildSingleStudentNoteUrl = function buildSingleStudentNoteUrl(noteId) {
  return (0, _Api.buildUrl)('/notes/' + noteId);
};

function getApiCallState(state, noteId) {
  return _omniCommonUi.ApiCall.find(state, { method: 'GET', url: buildSingleStudentNoteUrl(noteId) });
}

function fetchSingleStudentNoteIfNeeded(noteId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, {
      method: 'GET',
      url: buildSingleStudentNoteUrl(noteId)
    })) {
      return false;
    }
    return dispatch(fetchSingleStudentNote(noteId));
  };
}

var createFetchSingleStudentNoteActionCreators = (0, _omniCommonUi.createApiActionCreator)('SINGLE_STUDENT_NOTE');

function fetchSingleStudentNote(noteId) {
  var url = buildSingleStudentNoteUrl(noteId);
  return createFetchSingleStudentNoteActionCreators(url, 'GET',
  // `disableDefault` in request, success, failure
  DISABLE_DEFAULT_ACTION_EXTRAS, DISABLE_DEFAULT_ACTION_EXTRAS, DISABLE_DEFAULT_ACTION_EXTRAS);
}

/* --- */

var buildStudentNotesUrl = function buildStudentNotesUrl(studentId) {
  return (0, _Api.buildUrl)('/students/' + studentId + '/notes');
};

function fetchStudentNotesIfNeeded(studentId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, {
      method: 'GET',
      url: buildStudentNotesUrl(studentId)
    })) {
      return false;
    }
    return dispatch(fetchStudentNotes(studentId));
  };
}

function fetchStudentNotes(studentId) {
  return function (dispatch) {
    var url = buildStudentNotesUrl(studentId);
    var method = 'GET';

    return dispatch(fetchStudentNotesRequest()).payload.then(function (response) {
      return dispatch(fetchStudentNotesSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchStudentNotesFailure(error));
    });

    function fetchStudentNotesRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_NOTES_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        studentId: studentId,
        disableDefault: true
      });
    }

    function fetchStudentNotesSuccess(notes) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_NOTES_SUCCESS,
        payload: notes,
        url: url,
        method: method,
        studentId: studentId
      });
    }

    function fetchStudentNotesFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_NOTES_FAILURE,
        error: error,
        url: url,
        method: method,
        studentId: studentId
      });
    }
  };
}

function submitStudentNote(studentId, model) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/students/' + studentId + '/notes');
    var method = 'POST';
    return dispatch(submitStudentNoteRequest()).payload.then(function (response) {
      return dispatch(submitStudentNoteSuccess(response));
    }).catch(function (error) {
      return dispatch(submitStudentNoteFailure(error));
    }).then(function () {
      return dispatch(fetchStudentNotes(studentId));
    });

    function submitStudentNoteRequest() {
      var request = (0, _Api.fetch)(url, {
        method: method,
        body: JSON.stringify(model)
      });
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_STUDENT_NOTE_REQUEST,
        payload: request,
        url: url,
        method: method,
        studentId: studentId,
        model: model
      });
    }

    function submitStudentNoteSuccess() {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_STUDENT_NOTE_SUCCESS,
        url: url,
        method: method
      });
    }

    function submitStudentNoteFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_STUDENT_NOTE_FAILURE,
        url: url,
        method: method,
        error: error
      });
    }
  };
}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_FAILURE = exports.SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_SUCCESS = exports.SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_REQUEST = exports.FETCH_STUDENT_REPORT_SUMMARIES_FAILURE = exports.FETCH_STUDENT_REPORT_SUMMARIES_SUCCESS = exports.FETCH_STUDENT_REPORT_SUMMARIES_REQUEST = exports.FETCH_STUDENT_REPORT_SUMMARY_FAILURE = exports.FETCH_STUDENT_REPORT_SUMMARY_SUCCESS = exports.FETCH_STUDENT_REPORT_SUMMARY_REQUEST = undefined;
exports.fetchStudentReportSummaryIfNeeded = fetchStudentReportSummaryIfNeeded;
exports.fetchStudentReportSummary = fetchStudentReportSummary;
exports.fetchStudentReportSummaries = fetchStudentReportSummaries;
exports.submitStudentReportSummaryTeacherPublish = submitStudentReportSummaryTeacherPublish;

var _immutable = __webpack_require__(3);

var _Api = __webpack_require__(11);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _ProgressTests = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_STUDENT_REPORT_SUMMARY_REQUEST = exports.FETCH_STUDENT_REPORT_SUMMARY_REQUEST = 'FETCH_STUDENT_REPORT_SUMMARY_REQUEST';
var FETCH_STUDENT_REPORT_SUMMARY_SUCCESS = exports.FETCH_STUDENT_REPORT_SUMMARY_SUCCESS = 'FETCH_STUDENT_REPORT_SUMMARY_SUCCESS';
var FETCH_STUDENT_REPORT_SUMMARY_FAILURE = exports.FETCH_STUDENT_REPORT_SUMMARY_FAILURE = 'FETCH_STUDENT_REPORT_SUMMARY_FAILURE';
var FETCH_STUDENT_REPORT_SUMMARIES_REQUEST = exports.FETCH_STUDENT_REPORT_SUMMARIES_REQUEST = 'FETCH_STUDENT_REPORT_SUMMARIES_REQUEST';
var FETCH_STUDENT_REPORT_SUMMARIES_SUCCESS = exports.FETCH_STUDENT_REPORT_SUMMARIES_SUCCESS = 'FETCH_STUDENT_REPORT_SUMMARIES_SUCCESS';
var FETCH_STUDENT_REPORT_SUMMARIES_FAILURE = exports.FETCH_STUDENT_REPORT_SUMMARIES_FAILURE = 'FETCH_STUDENT_REPORT_SUMMARIES_FAILURE';
var SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_REQUEST = exports.SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_REQUEST = 'SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_REQUEST';
var SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_SUCCESS = exports.SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_SUCCESS = 'SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_SUCCESS';
var SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_FAILURE = exports.SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_FAILURE = 'SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_FAILURE';

var buildFetchSummaryUrl = function buildFetchSummaryUrl(progressReportId, studentId) {
  return (0, _Api.buildUrl)('/unit-reports/' + progressReportId + '/students/' + studentId);
};

function fetchStudentReportSummaryIfNeeded(progressReportId, studentId) {
  return function (dispatch, getState) {
    var url = buildFetchSummaryUrl(progressReportId, studentId);
    var method = 'GET';
    if (!_omniCommonUi.ApiCall.shouldPerform(getState(), { url: url, method: method })) {
      return false;
    }

    return fetchStudentReportSummary(progressReportId, studentId);
  };
}

function fetchStudentReportSummary(progressReportId, studentId) {
  return function (dispatch) {
    var url = buildFetchSummaryUrl(progressReportId, studentId);
    var method = 'GET';

    return dispatch(fetchStudentReportSummaryRequest()).payload.then(function (response) {
      return dispatch(fetchStudentReportSummarySuccess(response));
    }).catch(function (error) {
      return dispatch(fetchStudentReportSummaryFailure(error));
    });

    function fetchStudentReportSummaryRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_REPORT_SUMMARY_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        progressReportId: progressReportId,
        studentId: studentId
      });
    }

    function fetchStudentReportSummarySuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_REPORT_SUMMARY_SUCCESS,
        payload: payload,
        url: url,
        method: method,
        progressReportId: progressReportId,
        studentId: studentId
      });
    }

    function fetchStudentReportSummaryFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_REPORT_SUMMARY_FAILURE,
        error: error,
        url: url,
        method: method,
        progressReportId: progressReportId,
        studentId: studentId
      });
    }
  };
}

function fetchStudentReportSummaries(progressReportId) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/unit-reports/' + progressReportId + '/student-reports');
    var method = 'GET';

    return dispatch(fetchStudentReportSummariesRequest()).payload.then(function (response) {
      return dispatch(fetchStudentReportSummariesSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchStudentReportSummariesFailure(error));
    });

    function fetchStudentReportSummariesRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_REPORT_SUMMARIES_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        progressReportId: progressReportId
      });
    }

    function fetchStudentReportSummariesSuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_REPORT_SUMMARIES_SUCCESS,
        payload: payload,
        url: url,
        method: method,
        progressReportId: progressReportId
      });
    }

    function fetchStudentReportSummariesFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_REPORT_SUMMARIES_FAILURE,
        error: error,
        url: url,
        method: method,
        progressReportId: progressReportId
      });
    }
  };
}

function submitStudentReportSummaryTeacherPublish(progressReportId, groupId) {
  var readyToSubmitStudentReportIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var studentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

  return function (dispatch, getState) {
    var url = (0, _Api.buildUrl)('/unit-reports/' + progressReportId + '/teacher-submits');
    var method = 'PUT';

    var user = getState().get('singleSignOn').get('user');
    var userId = user ? user.get('profile').sub : 1;
    var progressTestPlan = getState().get('rootReducer').get('progressTestsPlan').get(groupId).data.find(function (plan) {
      return plan.progressReportId === progressReportId;
    });

    return dispatch(submitStudentReportSummaryTeacherPublishRequest()).payload.then(function (response) {
      return dispatch(submitStudentReportSummaryTeacherPublishSuccess(response));
    }).catch(function (error) {
      return dispatch(submitStudentReportSummaryTeacherPublishFailure(error));
    }).then(function () {
      if (_is_js2.default.undefined(studentId)) {
        return dispatch(fetchStudentReportSummaries(progressReportId));
      }
      return dispatch(fetchStudentReportSummary(progressReportId, studentId));
    }).then(function () {
      if (!_is_js2.default.existy(progressTestPlan)) {
        return;
      }
      return dispatch(_ProgressTests.actions.fetchProgressTest(groupId, progressTestPlan));
    });

    function submitStudentReportSummaryTeacherPublishRequest() {
      if (!_immutable.List.isList(readyToSubmitStudentReportIds)) {
        throw new Error('`readyToSubmitStudentReportIds` must be an Immutable.List!');
      }

      var request = (0, _Api.fetch)(url, {
        method: method,
        body: JSON.stringify({
          submittedByUserId: userId,
          readyToSubmitStudentReportIds: readyToSubmitStudentReportIds.map(function (id) {
            return Number.parseInt(id, 10);
          })
        })
      });
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_REQUEST,
        payload: request,
        url: url,
        method: method,
        progressReportId: progressReportId,
        readyToSubmitStudentReportIds: readyToSubmitStudentReportIds
      });
    }

    function submitStudentReportSummaryTeacherPublishSuccess() {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_SUCCESS,
        url: url,
        method: method
      });
    }

    function submitStudentReportSummaryTeacherPublishFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(1398);

var _component2 = _interopRequireDefault(_component);

var _SimpleTable = __webpack_require__(133);

var _SimpleTable2 = _interopRequireDefault(_SimpleTable);

var _Panel = __webpack_require__(632);

var _Panel2 = _interopRequireDefault(_Panel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_component2.default.Panel = _Panel2.default;
_component2.default.Header = _SimpleTable2.default.Header;
_component2.default.Body = _SimpleTable2.default.Body;
_component2.default.Row = _SimpleTable2.default.Row;
_component2.default.Cell = _SimpleTable2.default.Cell;

exports.default = _component2.default;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1433);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Detailsboard = function Detailsboard(props) {
  var classesBoard = (0, _classnames2.default)(_style2.default.Detailsboard_board);
  var classesH5 = (0, _classnames2.default)(_style2.default.Detailsboard_h5);
  var classesP = (0, _classnames2.default)(_style2.default.Detailsboard_p);

  return _react2.default.createElement(
    'div',
    { className: classesBoard },
    _react2.default.createElement(
      'h5',
      { className: classesH5 },
      props.boardTitle
    ),
    _react2.default.createElement(
      'p',
      { className: classesP },
      judgeValue(props.boardValue)
    )
  );

  function judgeValue(boardValue) {
    if (!_is_js2.default.not.undefined(boardValue) || !boardValue || boardValue === '') {
      return '_';
    }
    return boardValue;
  }
};

Detailsboard.propTypes = {
  boardTitle: _propTypes2.default.string.isRequired,
  boardValue: _propTypes2.default.string.isRequired
};

exports.default = Detailsboard;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(254)))

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions2 = __webpack_require__(1469);

var _actions = _interopRequireWildcard(_actions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var studentReportCommentActions = _actions;
exports.default = studentReportCommentActions;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1483);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RejectNotePopup = function (_PureComponent) {
  _inherits(RejectNotePopup, _PureComponent);

  function RejectNotePopup(props) {
    _classCallCheck(this, RejectNotePopup);

    var _this = _possibleConstructorReturn(this, (RejectNotePopup.__proto__ || Object.getPrototypeOf(RejectNotePopup)).call(this, props));

    _this.state = { note: null };
    _this._updateNote = _this._updateNote.bind(_this);
    _this._onSaveClicked = _this._onSaveClicked.bind(_this);
    return _this;
  }

  _createClass(RejectNotePopup, [{
    key: '_updateNote',
    value: function _updateNote(e) {
      this.setState({ note: e.target.value });
    }
  }, {
    key: '_onSaveClicked',
    value: function _onSaveClicked() {
      this.props.onSave(this.state.note);
    }
  }, {
    key: '_isNoteEmpty',
    value: function _isNoteEmpty() {
      if (_is_js2.default.not.string(this.state.note)) {
        return true;
      }

      return _is_js2.default.empty(this.state.note.trim());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpen = _props.isOpen,
          isLoading = _props.isLoading;

      return _react2.default.createElement(
        _omniCommonUi.Dialog,
        { isOpen: isOpen, isLoading: isLoading, className: _style2.default.RejectNotePopup, paddingless: true },
        _react2.default.createElement(
          'div',
          { className: _style2.default.RejectNotePopup_title },
          _react2.default.createElement(
            'span',
            { className: _style2.default.RejectNotePopup_title_text },
            'Reject Notes'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.RejectNotePopup_content },
          _react2.default.createElement(_omniCommonUi.TextArea, { value: this.state.note, onChange: this._updateNote, maxLength: 1000 }),
          _react2.default.createElement(
            'div',
            { className: _style2.default.RejectNotePopup_content_info },
            _react2.default.createElement(_omniCommonUi.Icon, { id: 'info', className: _style2.default.RejectNotePopup_content_info_icon }),
            _react2.default.createElement(
              'span',
              null,
              'This note will not be published to EF Parents.'
            )
          ),
          _react2.default.createElement(
            _omniCommonUi.Button.Container,
            { className: _style2.default.RejectNotePopup_buttons },
            _react2.default.createElement(
              _omniCommonUi.Button,
              { className: (0, _omniCommonUi.testClass)('button-save'),
                type: _omniCommonUi.Button.Type.primary,
                onClick: this._onSaveClicked,
                disabled: this._isNoteEmpty() || isLoading },
              'Save & Reject'
            ),
            _react2.default.createElement(
              _omniCommonUi.Button,
              { className: (0, _omniCommonUi.testClass)('button-cancel'),
                onClick: this.props.onCancel,
                disabled: isLoading },
              'Cancel'
            )
          )
        )
      );
    }
  }]);

  return RejectNotePopup;
}(_react.PureComponent);

RejectNotePopup.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  onSave: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool,
  onCancel: _propTypes2.default.func.isRequired
};

exports.default = RejectNotePopup;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1489);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _CardActionIcons = __webpack_require__(85);

var _CardActionIcons2 = _interopRequireDefault(_CardActionIcons);

var _UserCard = __webpack_require__(65);

var _UserCard2 = _interopRequireDefault(_UserCard);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InternalNoteView = function InternalNoteView(props) {
  var showBottomLine = props.showBottomLine,
      canOperate = props.canOperate,
      note = props.note,
      onEditButtonClick = props.onEditButtonClick,
      onDeleteButtonClick = props.onDeleteButtonClick,
      hideActionButtons = props.hideActionButtons;


  var dateStr = _is_js2.default.existy(note.date) && _is_js2.default.existy(note.timeZone) ? _omniCommonUi.moment.parseZone(note.date).clone().tz(note.timeZone).format('YYYY-MM-DD') : '';
  return _react2.default.createElement(
    'div',
    { className: _style2.default.InternalNoteView },
    _react2.default.createElement(
      'div',
      { className: _style2.default.InternalNoteView_header },
      hideActionButtons || !canOperate ? null : _react2.default.createElement(_CardActionIcons2.default, { className: _style2.default.InternalNoteView_header_actions,
        onEditClick: function onEditClick() {
          return onEditButtonClick();
        },
        onDeleteClick: function onDeleteClick() {
          return onDeleteButtonClick();
        } }),
      _react2.default.createElement(
        'div',
        { className: _style2.default.InternalNoteView_header_info },
        _react2.default.createElement(_UserCard2.default, { id: note.userId, dateStr: dateStr })
      )
    ),
    _react2.default.createElement(
      'p',
      { className: (0, _classnames2.default)(_style2.default.InternalNoteView_note, (0, _omniCommonUi.testClass)('note-content')) },
      note.note
    ),
    showBottomLine && _react2.default.createElement('div', { className: _style2.default.InternalNoteView_noteWithBottomLine })
  );
};

InternalNoteView.propTypes = {
  canOperate: _propTypes2.default.bool,
  showBottomLine: _propTypes2.default.bool,
  note: _propTypes2.default.object.isRequired,
  onEditButtonClick: _propTypes2.default.func,
  onDeleteButtonClick: _propTypes2.default.func,
  hideActionButtons: _propTypes2.default.bool
};

exports.default = InternalNoteView;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnlineHomework = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(659);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1493);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(303);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1496);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

_model2.default.actions = _actions;
_model2.default.create = _create2.default;

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var OnlineHomework = exports.OnlineHomework = _model2.default;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentPaperBasedHomework = getCurrentPaperBasedHomework;
exports.isMarkable = isMarkable;
exports.getHomeworkStudentList = getHomeworkStudentList;

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _GroupMembers = __webpack_require__(14);

var _accessors = __webpack_require__(41);

var _accessors2 = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCurrentPaperBasedHomework(state, sessionPlanId) {
  var currentPaperBasedHomework = state.get('rootReducer').get('paperBasedHomework').get(sessionPlanId);
  return currentPaperBasedHomework;
}

function isMarkable(state, groupId, sessionPlanId) {
  var currentPaperBasedHomework = getCurrentPaperBasedHomework(state, sessionPlanId);
  var nextSession = (0, _accessors2.getNextSession)(state, groupId, sessionPlanId);
  var isFutrueSession = (0, _accessors2.isFutureSession)(state, sessionPlanId);
  var isFutureNextSession = (0, _accessors2.isFutureSession)(state, nextSession.id);
  return !isFutrueSession && !isFutureNextSession && currentPaperBasedHomework && _immutable.List.isList(currentPaperBasedHomework) && currentPaperBasedHomework.size > 0 && currentPaperBasedHomework.some(function (homework) {
    return homework.studentPaperBasedHomeworks.size > 0;
  });
}

function getHomeworkStudentList(state, sessionPlan, groupId) {
  var groupMembers = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var sessionPlanId = sessionPlan.id;

  var currentSessionHomeworks = state.get('rootReducer').get('paperBasedHomework').get(sessionPlanId);
  var units = (0, _accessors.getUnitList)(state, groupId);
  if (!!currentSessionHomeworks && !!units) {
    currentSessionHomeworks = currentSessionHomeworks.map(function (lessonHomework) {
      return lessonHomework.set('unitOrderingSequence', (0, _accessors.getUnitNumberById)(units, '' + lessonHomework.unitId));
    });

    currentSessionHomeworks = currentSessionHomeworks.map(function (lessonHomework) {
      return lessonHomework.update('studentPaperBasedHomeworks', function (studentPaperBaseds) {
        return studentPaperBaseds.map(function (student) {
          var studentId = student.studentId;
          var groupMember = groupMembers.find(function (member) {
            return member.studentGeneralInfo.id === studentId;
          });
          if (_is_js2.default.undefined(groupMember)) {
            return student;
          }
          return student.set('isInProduction', groupMember.isInProduction).set('studentStatus', groupMember.status).set('studentGeneralInfo', groupMember.studentGeneralInfo);
        });
      });
    });

    currentSessionHomeworks = currentSessionHomeworks.map(function (lessonHomework) {
      return lessonHomework.update('studentTutorialHomeworks', function (studentTutorials) {
        return studentTutorials.map(function (student) {
          var studentId = student.studentId;
          var groupMember = groupMembers.find(function (member) {
            return member.studentGeneralInfo.id === studentId;
          });
          if (_is_js2.default.undefined(groupMember)) {
            return student;
          }
          return student.set('isInProduction', groupMember.isInProduction).set('studentStatus', groupMember.status).set('studentGeneralInfo', groupMember.studentGeneralInfo);
        });
      });
    });
  }
  return currentSessionHomeworks;
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1503);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _UserCard = __webpack_require__(65);

var _UserCard2 = _interopRequireDefault(_UserCard);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RejectNote = function (_PureComponent) {
  _inherits(RejectNote, _PureComponent);

  function RejectNote() {
    _classCallCheck(this, RejectNote);

    return _possibleConstructorReturn(this, (RejectNote.__proto__ || Object.getPrototypeOf(RejectNote)).apply(this, arguments));
  }

  _createClass(RejectNote, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          note = _props.note,
          teacherId = _props.teacherId,
          timeZone = _props.timeZone,
          rejectTime = _props.rejectTime;

      var dateStr = _is_js2.default.existy(rejectTime) && _is_js2.default.existy(timeZone) ? _omniCommonUi.moment.parseZone(rejectTime).clone().tz(timeZone).format('YYYY-MM-DD') : '';
      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        null,
        _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Reject Notes' }),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          null,
          _react2.default.createElement(
            'div',
            null,
            teacherId && _react2.default.createElement(_UserCard2.default, { id: teacherId.toString(),
              dateStr: dateStr })
          ),
          _react2.default.createElement(
            'p',
            { className: _style2.default.RejectNote_content },
            note || '–'
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.RejectNote_content_info },
            _react2.default.createElement(_omniCommonUi.Icon, { id: 'info', className: _style2.default.RejectNote_content_info_icon }),
            _react2.default.createElement(
              'span',
              null,
              'This note will not be published to EF Parents.'
            )
          )
        )
      );
    }
  }]);

  return RejectNote;
}(_react.PureComponent);

RejectNote.propTypes = {
  note: _propTypes2.default.string.isRequired,
  teacherId: _propTypes2.default.number.isRequired,
  timeZone: _propTypes2.default.string,
  rejectTime: _propTypes2.default.string
};

exports.default = RejectNote;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMonthName = getMonthName;
exports.getMonthAbbr = getMonthAbbr;
var month = {
  0: {
    abbr: 'Jan',
    fullName: 'January'
  },
  1: {
    abbr: 'Feb',
    fullName: 'February'
  },
  2: {
    abbr: 'Mar',
    fullName: 'March'
  },
  3: {
    abbr: 'Apr',
    fullName: 'April'
  },
  4: {
    abbr: 'May',
    fullName: 'May'
  },
  5: {
    abbr: 'Jun',
    fullName: 'June'
  },
  6: {
    abbr: 'Jul',
    fullName: 'July'
  },
  7: {
    abbr: 'Aug',
    fullName: 'August'
  },
  8: {
    abbr: 'Sep',
    fullName: 'September'
  },
  9: {
    abbr: 'Oct',
    fullName: 'October'
  },
  10: {
    abbr: 'Nov',
    fullName: 'November'
  },
  11: {
    abbr: 'Dec',
    fullName: 'December'
  }
};

function getMonthName(i) {
  return month['' + i % 12].fullName;
}

function getMonthAbbr(i) {
  return month['' + i % 12].abbr;
}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.accessors = exports.actions = undefined;

var _actions2 = __webpack_require__(748);

var _actions = _interopRequireWildcard(_actions2);

var _accessors2 = __webpack_require__(1716);

var _accessors = _interopRequireWildcard(_accessors2);

var _reducer2 = __webpack_require__(1717);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(749);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

_model2.default.actions = _actions;
_model2.default.accessors = _accessors;

var actions = exports.actions = _actions;
var accessors = exports.accessors = _accessors;
var reducer = exports.reducer = _reducer3.default;
var HomeworkType = _model2.default;
exports.default = HomeworkType;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1785).default;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.inherits = inherits;
function inherits(parent, child) {
	var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	var extended = Object.create(parent.prototype);
	for (var p in props) {
		extended[p] = props[p];
	}
	extended.constructor = child;
	child.prototype = extended;
	return child;
}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1807);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CardActionButtons = function (_PureComponent) {
  _inherits(CardActionButtons, _PureComponent);

  function CardActionButtons() {
    _classCallCheck(this, CardActionButtons);

    return _possibleConstructorReturn(this, (CardActionButtons.__proto__ || Object.getPrototypeOf(CardActionButtons)).apply(this, arguments));
  }

  _createClass(CardActionButtons, [{
    key: '_renderButtons',
    value: function _renderButtons() {
      var _this2 = this;

      return [_react2.default.createElement(
        _omniCommonUi.Button,
        { type: _omniCommonUi.Button.Type.primary,
          key: 'save',
          onClick: function onClick() {
            return _this2.props.onPrimaryClick && _this2.props.onPrimaryClick();
          },
          disabled: this.props.isPrimaryDisabled },
        'save'
      ), _react2.default.createElement(
        _omniCommonUi.Button,
        { type: _omniCommonUi.Button.Type.default,
          key: 'discard',
          onClick: function onClick() {
            return _this2.props.onSecondaryClick && _this2.props.onSecondaryClick();
          },
          disabled: this.props.isSecondaryDisabled },
        'discard'
      )];
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _omniCommonUi.Button.Container,
        { className: (0, _classnames2.default)(_style2.default.BottomButtons, this.props.className),
          align: 'right' },
        this._renderButtons()
      );
    }
  }]);

  return CardActionButtons;
}(_react.PureComponent);

CardActionButtons.propTypes = {
  buttons: _propTypes2.default.array,
  onPrimaryClick: _propTypes2.default.func,
  onSecondaryClick: _propTypes2.default.func,
  isPrimaryDisabled: _propTypes2.default.bool,
  isSecondaryDisabled: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

exports.default = CardActionButtons;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTabActive = exports.isSpinWritingAssignmentEnabled = exports.TABS = exports.LESSON_CATEGORY = exports.writingAssignmentRootPath = undefined;

var _TABS;

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _CoreAndCatchUp = __webpack_require__(1841);

var _SpinListView = __webpack_require__(1863);

var _StudentWritingAssignment = __webpack_require__(1867);

var _component = __webpack_require__(802);

var _component2 = _interopRequireDefault(_component);

var _WritingAssignment = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var writingAssignmentRootPath = exports.writingAssignmentRootPath = 'writing-assignment';

var LESSON_CATEGORY = exports.LESSON_CATEGORY = {
  CORE_CATCH_UP: 'coreCatchUp',
  SPIN: 'spin'
};

var TABS = exports.TABS = (_TABS = {}, _defineProperty(_TABS, LESSON_CATEGORY.CORE_CATCH_UP, 'core-catch'), _defineProperty(_TABS, LESSON_CATEGORY.SPIN, 'spin'), _TABS);

var isSpinWritingAssignmentEnabled = exports.isSpinWritingAssignmentEnabled = function isSpinWritingAssignmentEnabled() {
  return _omniCommonUi.Config.get('enableSpinWritingAssignment');
};

var isTabActive = exports.isTabActive = function isTabActive(props, lessonCategory) {
  var pathname = props.location.pathname,
      _props$params = props.params,
      lessonSeq = _props$params.lessonSeq,
      activityId = _props$params.activityId;

  var currentLessonCategory = _WritingAssignment.accessors.getLessonCategory({ lessonSeq: lessonSeq, activityId: activityId });
  return pathname.includes(TABS[lessonCategory]) || lessonCategory === currentLessonCategory;
};

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: writingAssignmentRootPath,
    component: _component2.default,
    breadcrumbLabels: function breadcrumbLabels(props) {
      var groupId = props.params.groupId,
          buildRoute = props.buildRoute;

      return {
        label: 'writing assignment',
        href: buildRoute('/group/' + groupId + '/writing-assignment')
      };
    },
    canAccess: function canAccess(_ref2) {
      var params = _ref2.params;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.AssignHomework.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.WritingAssignment);
    },
    secondLevelTabs: function secondLevelTabs(props) {
      if (!isSpinWritingAssignmentEnabled()) {
        return [];
      }
      var pathname = props.location.pathname,
          buildRoute = props.buildRoute,
          push = props.push,
          params = props.params;

      if (!pathname.includes(writingAssignmentRootPath)) return [];
      return [{
        text: 'Core & Catch-up',
        onClick: function onClick() {
          return push(buildRoute('/group/:groupId/' + writingAssignmentRootPath + '/' + TABS[LESSON_CATEGORY.CORE_CATCH_UP], params));
        },
        isActive: isTabActive(props, LESSON_CATEGORY.CORE_CATCH_UP)
      }, {
        text: 'Spin',
        onClick: function onClick() {
          return push(buildRoute('/group/:groupId/' + writingAssignmentRootPath + '/' + TABS[LESSON_CATEGORY.SPIN], params));
        },
        isActive: isTabActive(props, LESSON_CATEGORY.SPIN)
      }];
    },
    tab: {
      label: 'Writing Assignment',
      order: 11,
      isVisible: function isVisible(params) {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.AssignHomework.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.WritingAssignment);
      }
    },
    childRoutes: [_CoreAndCatchUp.routes, isSpinWritingAssignmentEnabled() && _SpinListView.routes, _StudentWritingAssignment.coreCatchUpWritingAssignment, _StudentWritingAssignment.spinWritingAssignment]
  };
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.accessors = exports.actions = undefined;

var _actions2 = __webpack_require__(804);

var _actions = _interopRequireWildcard(_actions2);

var _accessors2 = __webpack_require__(1883);

var _accessors = _interopRequireWildcard(_accessors2);

var _reducer2 = __webpack_require__(1884);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var accessors = exports.accessors = _accessors;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Member = undefined;

var _model = __webpack_require__(592);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1231);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Member = exports.Member = _model2.default;

Member.create = _create2.default;

exports.default = Member;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.nextFrom = undefined;

var _omniCommonUi = __webpack_require__(0);

var nextFrom = exports.nextFrom = function nextFrom(aMoment) {
    var paramMoment = _omniCommonUi.moment.parseZone(aMoment).clone();
    return paramMoment.clone().startOf('day').add(1, 'month').date(4);
};

exports.default = { nextFrom: nextFrom };

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionPlan = undefined;

var _model = __webpack_require__(1232);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1233);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SessionPlan = exports.SessionPlan = _model2.default;

SessionPlan.create = _create2.default;

exports.default = SessionPlan;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Unit = exports.reducer = exports.actions = exports.accessors = undefined;

var _accessors2 = __webpack_require__(41);

var _accessors = _interopRequireWildcard(_accessors2);

var _actions2 = __webpack_require__(594);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1234);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(595);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var accessors = exports.accessors = _accessors;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var Unit = exports.Unit = _model2.default;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessors = exports.Centre = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(600);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1239);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(601);

var _model2 = _interopRequireDefault(_model);

var _accessors2 = __webpack_require__(1240);

var _accessors = _interopRequireWildcard(_accessors2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var Centre = exports.Centre = _model2.default;
var accessors = exports.accessors = _accessors;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _style = __webpack_require__(1282);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRadialProgressSansAnimation = __webpack_require__(284);

var _reactRadialProgressSansAnimation2 = _interopRequireDefault(_reactRadialProgressSansAnimation);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isScoreInInclusiveRange = function isScoreInInclusiveRange(percent, start, end) {
  return percent >= start && (percent < end || !_is_js2.default.number(end));
};

var getColorForScore = function getColorForScore(percent) {
  var _isScoreInRangeInclusive = isScoreInInclusiveRange.bind(undefined, percent);
  if (_isScoreInRangeInclusive(0, 60)) return _style2.default.colorExperiencingDifficulty;
  if (_isScoreInRangeInclusive(60, 70)) return _style2.default.colorNeedsImprovement;
  if (_isScoreInRangeInclusive(70, 80)) return _style2.default.colorOnTrack;
  if (_isScoreInRangeInclusive(80, 90)) return _style2.default.colorStrong;
  if (_isScoreInRangeInclusive(90)) return _style2.default.colorOutstanding;
  return _style2.default.colorUnknown;
};

var RadialScoreDisplay = function RadialScoreDisplay(props) {
  var color = _style2.default.colorUnknown;
  var value = _is_js2.default.number(props.percent) ? props.percent : props.value;
  if (_is_js2.default.number(props.percent) || props.unit === 'percent') {
    color = getColorForScore(value);
  }
  return _react2.default.createElement(
    'div',
    { className: props.className },
    _react2.default.createElement(_reactRadialProgressSansAnimation2.default, _extends({}, props, {
      progressStroke: color,
      value: props.percent || props.value }))
  );
};

RadialScoreDisplay.propTypes = {
  unit: _propTypes2.default.string,
  value: _propTypes2.default.number,
  percent: _propTypes2.default.number,
  className: _propTypes2.default.string
};

exports.default = RadialScoreDisplay;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RadialProgress = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
}

var RadialProgress = exports.RadialProgress = function (_React$Component) {
    _inherits(RadialProgress, _React$Component);

    function RadialProgress(props) {
        _classCallCheck(this, RadialProgress);

        var _this = _possibleConstructorReturn(this, (RadialProgress.__proto__ || Object.getPrototypeOf(RadialProgress)).call(this, props));

        _this.generatePath = _this.generatePath.bind(_this);
        _this.state = { value: props.value || 0 };
        return _this;
    }

    _createClass(RadialProgress, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.animated) clearInterval(this.interval);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var _ref$value = _ref.value;
            var value = _ref$value === undefined ? 0 : _ref$value;

            this.setState({ value: value });
        }
    }, {
        key: 'generatePath',
        value: function generatePath(degrees) {
            var radius = this.props.radius;
            var radians = degrees * Math.PI / 180;
            var x = Math.sin(radians) * radius;
            var y = Math.cos(radians) * -radius;
            var halfEdgeSize = this.props.edgeSize / 2;
            x += halfEdgeSize;
            y += halfEdgeSize;
            var largeArcSweepFlag = degrees > 180 ? 1 : 0;
            var startX = halfEdgeSize;
            var startY = halfEdgeSize - radius;
            return 'M' + startX + ',' + startY + ' A' + radius + ',' + radius + ' 0 ' + largeArcSweepFlag + ' 1 ' + x + ',' + y + ' ';
        }
    }, {
        key: 'render',
        value: function render() {
            var center = this.props.edgeSize / 2;
            var radius = this.props.radius;
            var degrees = void 0,
                text = '';
            if (this.props.unit === 'percent') {
                var percent = clamp(this.state.value, 0, 100);
                degrees = percent / 100 * 360;
                degrees = clamp(degrees, 0, 359.9);
                text = this.props.formatText(percent);
            } else {
                degrees = this.state.value;
                degrees = clamp(degrees, 0, 359.9);
                text = this.props.formatText(degrees);
            }

            var pathDescription = this.generatePath(degrees);

            return _react2.default.createElement(
                'svg',
                { height: this.props.edgeSize, width: this.props.edgeSize },
                _react2.default.createElement('circle', { cx: center, cy: center, r: radius,
                    stroke: this.props.circleStroke,
                    strokeWidth: this.props.circleStrokeWidth,
                    fill: this.props.circleFill }),
                _react2.default.createElement('path', { d: pathDescription,
                    fill: 'transparent',
                    stroke: this.props.progressStroke,
                    strokeWidth: this.props.circleStrokeWidth }),
                this.props.displayText && _react2.default.createElement(
                    'text',
                    { x: center, y: this.props.forcedTextY || center, textAnchor: 'middle' },
                    text
                )
            );
        }
    }]);

    return RadialProgress;
}(_react2.default.Component);

RadialProgress.defaultProps = {
    edgeSize: 100,
    radius: 45,
    circleStrokeWidth: 4,
    circleStroke: '#D8D8D8',
    circleFill: 'transparent',
    progressStroke: 'black',
    unit: 'degrees',
    displayText: true,
    formatText: function formatText(value) {
        return value;
    },
    forcedTextY: 0
};

RadialProgress.propTypes = {
    edgeSize: _react2.default.PropTypes.number.isRequired,
    radius: _react2.default.PropTypes.number.isRequired,
    circleStrokeWidth: _react2.default.PropTypes.number.isRequired,
    circleStroke: _react2.default.PropTypes.string.isRequired,
    circleFill: _react2.default.PropTypes.string.isRequired,
    progressStroke: _react2.default.PropTypes.string.isRequired,
    value: _react2.default.PropTypes.number.isRequired,
    unit: _react2.default.PropTypes.oneOf(['degrees', 'percent']).isRequired,
    displayText: _react2.default.PropTypes.bool.isRequired,
    formatText: _react2.default.PropTypes.func,
    forcedTextY: _react2.default.PropTypes.number.isRequired
};

exports.default = RadialProgress;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1304);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RAv2HomeworkResultSummaryRecord = (0, _immutable.Record)({
  studentId: undefined,
  avgCompletion: 0,
  avgAccuracy: 0,
  totalRecorded: 0,
  totalStoryRead: 0
});

var RAv2HomeworkResultSummary = function (_RAv2HomeworkResultSu) {
  _inherits(RAv2HomeworkResultSummary, _RAv2HomeworkResultSu);

  function RAv2HomeworkResultSummary() {
    _classCallCheck(this, RAv2HomeworkResultSummary);

    return _possibleConstructorReturn(this, (RAv2HomeworkResultSummary.__proto__ || Object.getPrototypeOf(RAv2HomeworkResultSummary)).apply(this, arguments));
  }

  return RAv2HomeworkResultSummary;
}(RAv2HomeworkResultSummaryRecord);

var toNumber = function toNumber(value) {
  var numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

RAv2HomeworkResultSummary.create = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new RAv2HomeworkResultSummary({
    studentId: data.studentId,
    avgCompletion: toNumber(data.avgCompletion),
    avgAccuracy: toNumber(data.avgAccuracy),
    totalRecorded: toNumber(data.totalRecorded),
    totalStoryRead: toNumber(data.totalStoryRead)
  });
};

exports.default = RAv2HomeworkResultSummary;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionAttendance = undefined;

var _model = __webpack_require__(1325);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1326);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SessionAttendance = exports.SessionAttendance = _model2.default;

SessionAttendance.create = _create2.default;

exports.default = SessionAttendance;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1338);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewNotePopup = function (_PureComponent) {
  _inherits(NewNotePopup, _PureComponent);

  function NewNotePopup(props) {
    _classCallCheck(this, NewNotePopup);

    var _this = _possibleConstructorReturn(this, (NewNotePopup.__proto__ || Object.getPrototypeOf(NewNotePopup)).call(this, props));

    _this.state = { note: null };
    _this._updateNote = _this._updateNote.bind(_this);
    _this._onSaveClicked = _this._onSaveClicked.bind(_this);
    return _this;
  }

  _createClass(NewNotePopup, [{
    key: '_updateNote',
    value: function _updateNote(e) {
      this.setState({ note: e.target.value });
    }
  }, {
    key: '_onSaveClicked',
    value: function _onSaveClicked() {
      this.props.onSave(this.state.note);
    }
  }, {
    key: '_isNoteEmpty',
    value: function _isNoteEmpty() {
      if (_is_js2.default.not.string(this.state.note)) {
        return true;
      }

      return _is_js2.default.empty(this.state.note.trim());
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _omniCommonUi.Dialog,
        { isOpen: true, paddingless: true, className: _style2.default.NewNotePopup },
        _react2.default.createElement(
          'div',
          { className: _style2.default.NewNotePopup_titleBar },
          _react2.default.createElement(
            'h1',
            { className: _style2.default.NewNotePopup_title },
            _react2.default.createElement(
              'span',
              null,
              'New Note '
            ),
            _react2.default.createElement(
              'span',
              { className: _style2.default.NewNotePopup_title_group },
              '(',
              this.props.titleGroup,
              ')'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_style2.default.NewNotePopup_content, (0, _omniCommonUi.testClass)('new-note-content')) },
          _react2.default.createElement(
            'div',
            { className: _style2.default.NewNotePopup_info },
            _react2.default.createElement(
              'span',
              null,
              this.props.studentName
            ),
            this.props.extraInfo && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                null,
                ' | '
              ),
              _react2.default.createElement(
                'span',
                null,
                this.props.extraInfo
              )
            )
          ),
          this.props.category && _react2.default.createElement(
            'div',
            { className: _style2.default.NewNotePopup_category },
            this.props.category
          ),
          _react2.default.createElement(_omniCommonUi.TextArea, { value: this.state.note, onChange: this._updateNote, maxLength: 1000 }),
          _react2.default.createElement(
            _omniCommonUi.Button.Container,
            { className: _style2.default.NewNotePopup_buttons },
            _react2.default.createElement(
              _omniCommonUi.Button,
              { className: (0, _omniCommonUi.testClass)('button-save'),
                type: _omniCommonUi.Button.Type.primary,
                onClick: this._onSaveClicked,
                disabled: this._isNoteEmpty() },
              'Save & Notify'
            ),
            _react2.default.createElement(
              _omniCommonUi.Button,
              { className: (0, _omniCommonUi.testClass)('button-cancel'),
                onClick: this.props.onCancel },
              'Cancel'
            )
          )
        )
      );
    }
  }]);

  return NewNotePopup;
}(_react.PureComponent);

NewNotePopup.propTypes = {
  titleGroup: _propTypes2.default.string.isRequired,
  studentName: _propTypes2.default.string.isRequired,
  extraInfo: _propTypes2.default.string,
  category: _propTypes2.default.string,
  onSave: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired
};

exports.default = NewNotePopup;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _PaperBasedHomeworkResult = __webpack_require__(1357);

var _PaperBasedHomeworkResult2 = _interopRequireDefault(_PaperBasedHomeworkResult);

var _OnlineHomeworkResult = __webpack_require__(1359);

var _OnlineHomeworkResult2 = _interopRequireDefault(_OnlineHomeworkResult);

var _DosRejectedComment = __webpack_require__(1361);

var _DosRejectedComment2 = _interopRequireDefault(_DosRejectedComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentReportSummaryRecord = (0, _immutable.Record)({
  id: undefined,
  studentId: undefined,
  isPTSessionMember: undefined,
  unitSummary: undefined,
  comments: undefined,
  commentedByUserId: undefined,
  publishedByUserId: undefined,
  overWrittenByUserId: undefined,
  publishedTimeUtc: undefined,
  commentedTimeUtc: undefined,
  overWrittenTimeUtc: undefined,
  paperBasedHomeworkResult: new _PaperBasedHomeworkResult2.default(),
  dosRejectedComment: undefined,
  onlineHomeworkResult: undefined,
  status: undefined
});

var StudentReportSummary = function (_StudentReportSummary) {
  _inherits(StudentReportSummary, _StudentReportSummary);

  function StudentReportSummary() {
    _classCallCheck(this, StudentReportSummary);

    return _possibleConstructorReturn(this, (StudentReportSummary.__proto__ || Object.getPrototypeOf(StudentReportSummary)).apply(this, arguments));
  }

  return StudentReportSummary;
}(StudentReportSummaryRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  switch (key) {
    case 'id':
    case 'studentId':
      return [key, '' + val]; // stringify
    case 'isPTSessionMember':
      return [key, Boolean(val)];
    case 'onlineHomeworkResult':
      return [key, _OnlineHomeworkResult2.default.create(val)];
    case 'paperBasedHomeworkResult':
      return [key, _PaperBasedHomeworkResult2.default.create(val)];
    case 'dosRejectedComment':
      {
        if (!val) return [key, val];
        return [key, _DosRejectedComment2.default.create(val)];
      }
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

StudentReportSummary.Status = Object.freeze({
  ScoresMissing: 'ScoresMissing',
  Ready: 'Ready',
  SentToDoS: 'SentToDoS',
  Completed: 'Completed',
  Published: 'Published',
  Rejected: 'Rejected'
});

StudentReportSummary.create = function (data) {
  return (
    // navigating to a future report can return an empty response.
    // the `|| {}` bit below will make this code work in that case.
    new StudentReportSummary(data || {}).mapEntries(reviver)
  );
};

exports.default = StudentReportSummary;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewNavButton = function ViewNavButton(_ref) {
  var title = _ref.title,
      isPrimary = _ref.isPrimary,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      linkHref = _ref.linkHref,
      newTab = _ref.newTab,
      className = _ref.className;
  return _react2.default.createElement(
    _omniCommonUi.Button,
    { autoWidth: true,
      type: isPrimary ? _omniCommonUi.Button.Type.primary : _omniCommonUi.Button.Type.default,
      disabled: disabled,
      onClick: onClick,
      newTab: newTab,
      className: className,
      linkHref: linkHref },
    title
  );
};

ViewNavButton.propTypes = {
  title: _propTypes2.default.string,
  isPrimary: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  linkHref: _propTypes2.default.string,
  newTab: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

exports.default = ViewNavButton;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewNavExtra = function ViewNavExtra(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    null,
    children
  );
};

ViewNavExtra.propTypes = {
  children: _propTypes2.default.node
};

exports.default = ViewNavExtra;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_PROGRESS_REPORTS_FAILURE = exports.FETCH_PROGRESS_REPORTS_SUCCESS = exports.FETCH_PROGRESS_REPORTS_REQUEST = undefined;
exports.fetchProgressReport = fetchProgressReport;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_PROGRESS_REPORTS_REQUEST = exports.FETCH_PROGRESS_REPORTS_REQUEST = 'FETCH_PROGRESS_REPORTS_REQUEST';
var FETCH_PROGRESS_REPORTS_SUCCESS = exports.FETCH_PROGRESS_REPORTS_SUCCESS = 'FETCH_PROGRESS_REPORTS_SUCCESS';
var FETCH_PROGRESS_REPORTS_FAILURE = exports.FETCH_PROGRESS_REPORTS_FAILURE = 'FETCH_PROGRESS_REPORTS_FAILURE';

function fetchProgressReport(groupId) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/groups/' + groupId + '/unit-reports');
    var method = 'GET';

    return dispatch(fetchProgressReportRequest()).payload.then(function (response) {
      return dispatch(fetchProgressReportSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchProgressReportFailure(error));
    });

    function fetchProgressReportRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PROGRESS_REPORTS_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchProgressReportSuccess(sessions) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PROGRESS_REPORTS_SUCCESS,
        payload: sessions,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchProgressReportFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PROGRESS_REPORTS_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _routes2 = __webpack_require__(1421);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = {};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildProgressTestViewLinkUrl = exports.FETCH_PROGRESS_TEST_VIEW_LINK_FAILURE = exports.FETCH_PROGRESS_TEST_VIEW_LINK_SUCCESS = exports.FETCH_PROGRESS_TEST_VIEW_LINK_REQUEST = undefined;
exports.fetchProgressTestViewLinkIfNeeded = fetchProgressTestViewLinkIfNeeded;
exports.fetchProgressTestViewLink = fetchProgressTestViewLink;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _Api = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_PROGRESS_TEST_VIEW_LINK_REQUEST = exports.FETCH_PROGRESS_TEST_VIEW_LINK_REQUEST = 'FETCH_PROGRESS_TEST_VIEW_LINK_REQUEST';
var FETCH_PROGRESS_TEST_VIEW_LINK_SUCCESS = exports.FETCH_PROGRESS_TEST_VIEW_LINK_SUCCESS = 'FETCH_PROGRESS_TEST_VIEW_LINK_SUCCESS';
var FETCH_PROGRESS_TEST_VIEW_LINK_FAILURE = exports.FETCH_PROGRESS_TEST_VIEW_LINK_FAILURE = 'FETCH_PROGRESS_TEST_VIEW_LINK_FAILURE';

var buildProgressTestViewLinkUrl = exports.buildProgressTestViewLinkUrl = function buildProgressTestViewLinkUrl(progressTestId) {
  return (0, _Api.buildUrl)('/progress-tests/' + progressTestId + '/results-viewlink');
};

function fetchProgressTestViewLinkIfNeeded(progressTestId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, {
      method: 'GET',
      url: buildProgressTestViewLinkUrl(progressTestId)
    })) {
      return false;
    }

    return dispatch(fetchProgressTestViewLink(progressTestId));
  };
}

function fetchProgressTestViewLink(progressTestId) {
  return function (dispatch) {
    var url = buildProgressTestViewLinkUrl(progressTestId);
    var method = 'GET';

    return dispatch(fetchProgressTestViewLinkRequest()).payload
    // OMO-1879 fire a request to the given URL to ensure it's not bogus
    .then(function (response) {
      // skip extended check in polyfilled browsers like INTERNET EXPLORER
      // the `fetch` polyfill does not support the `redirect` param  https://git.io/vHmEq
      if (window.fetch.polyfill || _is_js2.default.existy(response.url)) {
        return dispatch(fetchProgressTestViewLinkSuccess(response));
      }
      (0, _Api.fetch)(response.url, {
        method: 'HEAD',
        // mode: 'no-cors',  // https://developer.mozilla.org/en-US/docs/Web/API/Request/mode
        redirect: 'manual' // https://fetch.spec.whatwg.org/#concept-request-redirect-mode
      }).then(function () {
        return dispatch(fetchProgressTestViewLinkSuccess(response));
      }).catch(function (error) {
        // `opaqueredirect` comes through as an error. catch it, make it a success
        if (error.type === 'opaqueredirect' || // new browsers - outbound redirect ok.
        error.name === 'TypeMismatchError') {
          // and EDGE < v15.15063
          return dispatch(fetchProgressTestViewLinkSuccess(response));
        }
        return dispatch(fetchProgressTestViewLinkFailure(error));
      });
    }).catch(function (error) {
      return dispatch(fetchProgressTestViewLinkFailure(error));
    });

    function fetchProgressTestViewLinkRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_VIEW_LINK_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        progressTestId: progressTestId,
        disableDefault: true
      });
    }

    function fetchProgressTestViewLinkSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_VIEW_LINK_SUCCESS,
        payload: response,
        url: url,
        method: method,
        progressTestId: progressTestId
      });
    }

    function fetchProgressTestViewLinkFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_VIEW_LINK_FAILURE,
        error: error,
        url: url,
        method: method,
        progressTestId: progressTestId,
        disableDefault: true // suppress error
      });
    }
  };
}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _style = __webpack_require__(1435);

var _style2 = _interopRequireDefault(_style);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfoDialog = function InfoDialog(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      onOKClick = _ref.onOKClick;
  return _react2.default.createElement(
    _omniCommonUi.Dialog,
    { isOpen: isOpen },
    _react2.default.createElement(
      'div',
      { className: _style2.default.InfoDialog },
      children,
      _react2.default.createElement(
        _omniCommonUi.Button.Container,
        { align: 'center' },
        _react2.default.createElement(
          _omniCommonUi.Button,
          { type: _omniCommonUi.Button.Type.primary,
            onClick: function onClick() {
              return onOKClick();
            } },
          'OK'
        )
      )
    )
  );
};

InfoDialog.propTypes = {
  isOpen: _propTypes2.default.bool,
  onOKClick: _propTypes2.default.func,
  children: _propTypes2.default.node
};

exports.default = InfoDialog;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(204)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function() {
  root.requestAnimationFrame = raf
  root.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressTestRubricView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1451);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouter = __webpack_require__(16);

var _reactRouterRedux = __webpack_require__(15);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _omniCommonUi = __webpack_require__(0);

var _ConfirmationPrompt = __webpack_require__(646);

var _Detailsboard = __webpack_require__(202);

var _Detailsboard2 = _interopRequireDefault(_Detailsboard);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _InfoDialog = __webpack_require__(295);

var _InfoDialog2 = _interopRequireDefault(_InfoDialog);

var _GroupMembers = __webpack_require__(14);

var _ProgressTests = __webpack_require__(40);

var _speakingSubSkillOrderHFv = __webpack_require__(1453);

var speakingSubSkillOrderHFv4 = _interopRequireWildcard(_speakingSubSkillOrderHFv);

var _accessors = __webpack_require__(52);

var _RubricSkillTable = __webpack_require__(1454);

var _RubricSkillTable2 = _interopRequireDefault(_RubricSkillTable);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MARKING = "edit";

var toMap = function toMap(arr, key) {
  return arr.reduce(function (obj, item) {
    // eslint-disable-next-line no-param-reassign
    obj[item[key]] = item;
    return obj;
  }, {});
};

var ProgressTestRubricView = exports.ProgressTestRubricView = function (_UnsavedChangesTracki) {
  _inherits(ProgressTestRubricView, _UnsavedChangesTracki);

  function ProgressTestRubricView(props) {
    _classCallCheck(this, ProgressTestRubricView);

    var _this = _possibleConstructorReturn(this, (ProgressTestRubricView.__proto__ || Object.getPrototypeOf(ProgressTestRubricView)).call(this, props));

    _this._queryListener = _this._queryListener.bind(_this);
    _this._queryIsLg = (0, _omniCommonUi.mediaQuery)("(min-width: 980px)");
    _this.state = {
      lg: _this._queryIsLg.matches,
      targetLanguagePopup: {
        isOpen: false,
        skillId: ""
      }
    };
    _this.scrollers = [];
    Object.assign(_this.state, {
      expandedInstructionTextsSubSkillIds: new _immutable.Map(),
      subSkillsToSkillIds: new _immutable.Map()
    });

    _this._renderSkills = _this._renderSkills.bind(_this);
    return _this;
  }

  _createClass(ProgressTestRubricView, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this._buildSubSkillsToAbilityIdsMap(this.props);
      _get(ProgressTestRubricView.prototype.__proto__ || Object.getPrototypeOf(ProgressTestRubricView.prototype), "componentWillMount", this).call(this);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._queryIsLg.addListener(this._queryListener);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          params = _props.params,
          progressTest = _props.progressTest;
      var nextParams = nextProps.params,
          nextProgressTest = nextProps.progressTest;

      if (nextParams.studentId !== params.studentId || !progressTest && nextProgressTest) {
        this._buildSubSkillsToAbilityIdsMap(nextProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._queryIsLg.removeListener(this._queryListener);
    }
  }, {
    key: "routerWillLeave",
    value: function routerWillLeave(nextLocation) {
      var that = this;
      var subSkillsToAbilityIds = this.state.subSkillsToAbilityIds;


      var returnToView = function returnToView() {
        var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return that._forcePushRoute(that.props.buildRoute({ mode: mode }));
      };

      if (nextLocation && nextLocation.pathname.endsWith("/save")) {
        if (this._checkCanSave()) {
          setTimeout(function () {
            return that._handleSave(subSkillsToAbilityIds);
          }, 0);
          returnToView();
        } else {
          returnToView("edit");
        }
      } else if (nextLocation && nextLocation.pathname.endsWith("/discard")) {
        this._buildSubSkillsToAbilityIdsMap(this.props);
        returnToView();
      } else {
        return _get(ProgressTestRubricView.prototype.__proto__ || Object.getPrototypeOf(ProgressTestRubricView.prototype), "routerWillLeave", this).call(this, nextLocation);
      }
    }
  }, {
    key: "_queryListener",
    value: function _queryListener(mql) {
      this.setState({ lg: mql.matches });
    }
  }, {
    key: "_onScrollReady",
    value: function _onScrollReady(scroll) {
      this.scrollers.push(scroll);
    }
  }, {
    key: "_isChangesPresent",
    value: function _isChangesPresent() {
      return ProgressTestRubricView.isInMarkingRoute(this.props) && this.state.originalSubSkillsToSkillIds && this.state.originalSubSkillsToSkillIds !== this.state.subSkillsToSkillIds;
    }
  }, {
    key: "_buildSubSkillsToAbilityIdsMap",
    value: function _buildSubSkillsToAbilityIdsMap(props) {
      var rubricSkills = props.rubricSkills,
          currentMember = props.currentMember,
          progressTest = props.progressTest;

      if (_is_js2.default.undefined(currentMember)) {
        return;
      }
      var studentId = currentMember.studentGeneralInfo.id;


      if (!progressTest) return;

      var subSkillsToSkillIds = rubricSkills.reduce(function (map, rubricSkill) {
        var subSkillsToAbilityIds = {};
        var studentSubSkillResults = (progressTest.studentProgressTestResults.get(studentId).skillResults.find(function (skr) {
          return skr.skillId === rubricSkill.skillId;
        }) || {}).subSkillResults || [];
        var subSkillResultsMap = toMap(studentSubSkillResults, "subSkillId");
        rubricSkill.subSkills.forEach(function (subSkill) {
          var subSkillId = subSkill.subSkillId;

          subSkillsToAbilityIds[subSkillId] = subSkillResultsMap[subSkillId] && subSkillResultsMap[subSkillId].currentResultAbilityId;
        });
        return map.set("" + rubricSkill.skillId, new _immutable.Map(subSkillsToAbilityIds));
      }, new _immutable.Map());

      this.setState({
        subSkillsToSkillIds: subSkillsToSkillIds,
        originalSubSkillsToSkillIds: subSkillsToSkillIds
      });
    }
  }, {
    key: "_checkCanSave",
    value: function _checkCanSave() {
      var subSkillsToSkillIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.subSkillsToSkillIds;
      var rubricSkills = this.props.rubricSkills;


      var isCompelte = rubricSkills.every(function (rubricSkill) {
        var numberOfSelectedAbilityPoints = subSkillsToSkillIds.get(rubricSkill.skillId).map(function (v) {
          return v;
        }).size;
        return numberOfSelectedAbilityPoints === rubricSkill.subSkills.size;
      });

      if (!isCompelte) {
        _ConfirmationPrompt.ConfirmationPrompt.showReminder("Incomplete Skill", "Please select an ability point for each of the sub-skills before saving.");
        return false;
      }
      return true;
    }
  }, {
    key: "_handleSave",
    value: function _handleSave() {
      var subSkillsToSkillIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.subSkillsToSkillIds;
      var _props2 = this.props,
          rubricSkills = _props2.rubricSkills,
          currentMember = _props2.currentMember,
          currentProgressTestId = _props2.currentProgressTestId,
          submitProgressTestResults = _props2.submitProgressTestResults,
          progressReportId = _props2.progressReportId,
          params = _props2.params,
          isUnitQuiz = _props2.isUnitQuiz;


      var progressTest = _ProgressTests.ProgressTest.serialize(_ProgressTests.ProgressTest.create({
        studentProgressTestResults: [{
          studentId: currentMember.studentGeneralInfo.id,
          skillResults: rubricSkills.map(function (rubricSkill) {
            return {
              skillId: rubricSkill.skillId,
              subSkillResults: rubricSkill.subSkills.map(function (_ref) {
                var subSkillId = _ref.subSkillId;
                return {
                  subSkillId: subSkillId,
                  currentResultAbilityId: subSkillsToSkillIds.get(rubricSkill.skillId).get(subSkillId) || null
                };
              }).toArray()
            };
          }).toArray()
        }]
      }));
      return isUnitQuiz ? submitProgressTestResults(params.groupId, currentProgressTestId, progressTest, progressReportId, true) : submitProgressTestResults(params.groupId, currentProgressTestId, progressTest);
    }
  }, {
    key: "_onInstructionTextExpandCollapseClicked",
    value: function _onInstructionTextExpandCollapseClicked(skillId, subSkillId) {
      var _this2 = this;

      var expandedInstructionTextsSubSkillIds = this.state.expandedInstructionTextsSubSkillIds;


      var action = expandedInstructionTextsSubSkillIds.getIn([skillId, subSkillId]) ? "collapse" : "expand";
      _reactGa2.default.event({
        category: "Progress Tests",
        action: "Clicked " + action + " scoring criteria",
        label: "Clicked " + action + " scoring criteria for sub skill " + subSkillId + " in skill " + skillId
      });

      this.setState({
        expandedInstructionTextsSubSkillIds: expandedInstructionTextsSubSkillIds.updateIn([skillId, subSkillId], function (currentToggleState) {
          return !currentToggleState;
        })
      }, function () {
        _this2.scrollers.forEach(function (scroll) {
          scroll.refresh();
        });
      });
    }
  }, {
    key: "_onIndividualAbilityButtonClicked",
    value: function _onIndividualAbilityButtonClicked(subSkillId, resultAbilityId, skillId) {
      var subSkillsToSkillIds = this.state.subSkillsToSkillIds;


      _reactGa2.default.event({
        category: "Progress Tests",
        action: "Clicked score button",
        label: "Clicked score button " + resultAbilityId + " for skill " + skillId + " and sub skill " + subSkillId
      });
      this.setState({
        subSkillsToSkillIds: subSkillsToSkillIds.setIn([skillId, subSkillId], resultAbilityId)
      });
    }
  }, {
    key: "_onCheckAllAbility",
    value: function _onCheckAllAbility(skillId, checked, abilityId) {
      var subSkillsToSkillIds = this.state.subSkillsToSkillIds;

      if (checked) {
        this.setState({
          subSkillsToSkillIds: subSkillsToSkillIds.update(skillId, function (subSkillsToAbilityIds) {
            return subSkillsToAbilityIds.map(function () {
              return abilityId;
            });
          })
        });
      }
    }
  }, {
    key: "_renderSkills",
    value: function _renderSkills(skills) {
      var _this3 = this;

      var _state = this.state,
          subSkillsToSkillIds = _state.subSkillsToSkillIds,
          expandedInstructionTextsSubSkillIds = _state.expandedInstructionTextsSubSkillIds;

      var onIntructionToggleClick = function onIntructionToggleClick() {
        return _this3._onInstructionTextExpandCollapseClicked.apply(_this3, arguments);
      };
      return skills.map(function (rubricSkill) {
        return _react2.default.createElement(_RubricSkillTable2.default, {
          isMarking: ProgressTestRubricView.isInMarkingRoute(_this3.props),
          isUnitQuiz: _this3.props.isUnitQuiz,
          rubricSkill: speakingSubSkillOrderHFv4.orderSpeakingSubSkillsIfNeeded(rubricSkill),
          showInstructionsFor: expandedInstructionTextsSubSkillIds,
          subSkillsToAbilityIds: subSkillsToSkillIds.get("" + rubricSkill.skillId),
          onCheckAllAbility: function onCheckAllAbility() {
            return _this3._onCheckAllAbility.apply(_this3, arguments);
          },
          onIntructionToggleClick: onIntructionToggleClick,
          onTargetLanguageButtonClick: function onTargetLanguageButtonClick(skillId) {
            return _this3._onTargetLanguageButtonClick(skillId);
          },
          onScoreClick: function onScoreClick() {
            return _this3._onIndividualAbilityButtonClicked.apply(_this3, arguments);
          }
        });
      });
    }
  }, {
    key: "_renderView",
    value: function _renderView() {
      var _props3 = this.props,
          rubricSkills = _props3.rubricSkills,
          progressTest = _props3.progressTest;


      if (!progressTest) return null;

      var multiColumns = !!(this.state.lg && rubricSkills && rubricSkills.size > 4);
      var masonryClass = (0, _classnames3.default)(_style2.default.Masonry, _defineProperty({}, _style2.default.Masonry_multi, multiColumns));

      var listStart = [];
      var listEnd = [];
      if (multiColumns) {
        listStart = rubricSkills.filter(function (rubricSkill, index) {
          return index % 2 === 0;
        });
        listEnd = rubricSkills.filterNot(function (rubricSkill, index) {
          return index % 2 === 0;
        });
      }

      return _react2.default.createElement(
        "div",
        { className: _style2.default.ProgressTestRubricView },
        _react2.default.createElement(
          "div",
          { className: masonryClass },
          multiColumns ? [_react2.default.createElement(
            "div",
            { className: _style2.default.Masonry_flow },
            this._renderSkills(listStart)
          ), _react2.default.createElement(
            "div",
            { className: _style2.default.Masonry_flow },
            this._renderSkills(listEnd)
          )] : this._renderSkills(rubricSkills)
        )
      );
    }
  }, {
    key: "_renderUnsavedChangesWarningDialog",
    value: function _renderUnsavedChangesWarningDialog() {
      var _this4 = this;

      var isSaving = false;
      return _react2.default.createElement(_UnsavedChangesWarning2.default, {
        isOpen: !!this._isNavigationWithChangesRequested(),
        isSaving: this.props.isAnyApiCallSaving || isSaving,
        onSaveClicked: function onSaveClicked() {
          isSaving = true;
          _this4._handleSave().then(function () {
            isSaving = false;
            _this4._forcePushRequestedLocation();
          });
        },
        onDiscardClicked: function onDiscardClicked() {
          _this4._buildSubSkillsToAbilityIdsMap(_this4.props);
          _this4._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this4._clearRequestedLocation();
        }
      });
    }
  }, {
    key: "_onTargetLanguagePopupOKClick",
    value: function _onTargetLanguagePopupOKClick() {
      this.setState({
        targetLanguagePopup: {
          isOpen: false
        }
      });
    }
  }, {
    key: "_onTargetLanguageButtonClick",
    value: function _onTargetLanguageButtonClick(skillId) {
      this.setState({
        targetLanguagePopup: {
          isOpen: true,
          skillId: skillId
        }
      });
    }
  }, {
    key: "_renderTargetLanguagePopup",
    value: function _renderTargetLanguagePopup() {
      var _this5 = this;

      var rubricSkills = this.props.rubricSkills;
      var targetLanguagePopup = this.state.targetLanguagePopup;

      var currentSkill = rubricSkills.find(function (skill) {
        return skill.skillId === targetLanguagePopup.skillId;
      });
      return _react2.default.createElement(
        _InfoDialog2.default,
        {
          isOpen: targetLanguagePopup.isOpen,
          onOKClick: function onOKClick() {
            return _this5._onTargetLanguagePopupOKClick();
          }
        },
        _react2.default.createElement(
          "h3",
          null,
          "Target Language"
        ),
        _is_js2.default.existy(currentSkill) && _is_js2.default.existy(currentSkill.targetLanguageCategories) && currentSkill.targetLanguageCategories.map(function (tlc) {
          return _react2.default.createElement(_Detailsboard2.default, {
            key: tlc.title,
            boardTitle: tlc.title,
            boardValue: tlc.items.join("\n")
          });
        })
      );
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        this._renderView(),
        this._renderUnsavedChangesWarningDialog(),
        this._renderTargetLanguagePopup()
      );
    }
  }]);

  return ProgressTestRubricView;
}(_UnsavedChangesTrackingPageComponent2.default);

ProgressTestRubricView.isInMarkingRoute = function (props) {
  return props.params && props.params.mode === MARKING;
};

ProgressTestRubricView.propTypes = Object.assign({}, _UnsavedChangesTrackingPageComponent2.default.propTypes, {
  progressTest: _propTypes2.default.object.isRequired,
  currentMember: _propTypes2.default.object.isRequired,
  currentProgressTestId: _propTypes2.default.string.isRequired,
  currentProgressTestIndex: _propTypes2.default.number.isRequired,
  studyingMembers: _propTypes2.default.object.isRequired,
  rubricSkills: _propTypes2.default.objectOf(_immutable.List),
  submitProgressTestResults: _propTypes2.default.func.isRequired,
  params: _propTypes2.default.object.isRequired,
  route: _propTypes2.default.any.isRequired,
  buildRoute: _propTypes2.default.func,
  pushRoute: _propTypes2.default.func,
  pathName: _propTypes2.default.string,
  progressReportId: _propTypes2.default.string,
  isAnyApiCallSaving: _propTypes2.default.bool,
  isUnitQuiz: _propTypes2.default.bool.isRequired
});

function mapStateToProps(state, ownProps) {
  var isUnitQuiz = (0, _accessors.checkIsUnitQuiz)(ownProps.location.pathname);
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      studentId = _ownProps$params.studentId;

  var currentProgressTestIndex = Number.parseInt(ownProps.params.progressTestIndex, 10);
  var currentProgressTestId = (0, _accessors.getProgressTestPlanFromIndex)(state, groupId, currentProgressTestIndex, isUnitQuiz).id;
  var progressTest = getCurrentProgressTest(state, currentProgressTestId);
  var pathName = ownProps.location.pathname;
  var studyingMembers = _GroupMembers.actions.getMembersByGroup(state, groupId).filter(function (member) {
    return member.isInProduction;
  });
  var currentMember = _GroupMembers.actions.getMemberById(state, studentId);
  var progressReportId = isUnitQuiz ? _ProgressTests.ProgressTest.actions.getProgressReportId(state, groupId, currentProgressTestId) : undefined;

  var rubricSkills = _omniCommonUi.ApiResponseHelper.hasSucceeded(progressTest) && progressTest.data.skills.filter(function (skill) {
    return skill.isRubric;
  });
  return {
    studyingMembers: studyingMembers,
    currentMember: currentMember,
    rubricSkills: rubricSkills || new _immutable.List(),
    progressTest: progressTest.data,
    currentProgressTestId: currentProgressTestId,
    currentProgressTestIndex: currentProgressTestIndex,
    progressReportId: progressReportId,
    pathName: pathName,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state),
    isUnitQuiz: isUnitQuiz
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_ProgressTests.ProgressTest.actions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !!(state.get("apiCalls") || new _immutable.List()).filter(function (call, key) {
    return ["PUT", "POST"].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

function getCurrentProgressTest(state, progressTestId) {
  var progressTests = state.get("rootReducer").get("progressTests");
  if (!_immutable.Map.isMap(progressTests)) {
    return;
  }
  return progressTests.get(progressTestId);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(ProgressTestRubricView));

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(654);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1467);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 302 */
/***/ (function(module, exports) {

/**
 * toString ref.
 */

var toString = Object.prototype.toString;

/**
 * Return the type of `val`.
 *
 * @param {Mixed} val
 * @return {String}
 * @api public
 */

module.exports = function(val){
  switch (toString.call(val)) {
    case '[object Date]': return 'date';
    case '[object RegExp]': return 'regexp';
    case '[object Arguments]': return 'arguments';
    case '[object Array]': return 'array';
    case '[object Error]': return 'error';
  }

  if (val === null) return 'null';
  if (val === undefined) return 'undefined';
  if (val !== val) return 'nan';
  if (val && val.nodeType === 1) return 'element';

  val = val.valueOf
    ? val.valueOf()
    : Object.prototype.valueOf.apply(val)

  return typeof val;
};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnlineHomeworkRecord = (0, _immutable.Record)({
  lessonNumber: undefined,
  sessionId: undefined,
  unitId: undefined,
  unitOrderingSequence: undefined,
  onlineHomeworkKey: undefined,
  studentOnlineHomeworkResults: undefined
});

var OnlineHomework = function (_OnlineHomeworkRecord) {
  _inherits(OnlineHomework, _OnlineHomeworkRecord);

  function OnlineHomework() {
    _classCallCheck(this, OnlineHomework);

    return _possibleConstructorReturn(this, (OnlineHomework.__proto__ || Object.getPrototypeOf(OnlineHomework)).apply(this, arguments));
  }

  return OnlineHomework;
}(OnlineHomeworkRecord);

exports.default = OnlineHomework;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCoveredInClassObject = getCoveredInClassObject;
exports.getCoveredInClassTemplate = getCoveredInClassTemplate;
exports.isAllCategoryItemsChecked = isAllCategoryItemsChecked;
exports.filterUncheckItems = filterUncheckItems;
exports.isAllCategoryItemsUnchecked = isAllCategoryItemsUnchecked;
exports.toggleCategoryItemsCheckedState = toggleCategoryItemsCheckedState;
exports.getCurrentSessionNumber = getCurrentSessionNumber;
exports.hasWronglyResult = hasWronglyResult;
exports.isNotFutureSession = isNotFutureSession;
exports.hasSaved = hasSaved;
exports.isNotPublished = isNotPublished;
exports.hasCIC = hasCIC;
exports.hasCICTemplate = hasCICTemplate;
exports.getCurrentSessionDate = getCurrentSessionDate;
exports.mergeCategoriesByName = mergeCategoriesByName;
exports.categoryDeepMerge = categoryDeepMerge;
exports.activityDeepMerge = activityDeepMerge;

var _omniCommonUi = __webpack_require__(0);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCoveredInClassObject(state, sessionPlanId) {
  return state.get('rootReducer').get('coveredInClassContent').get(sessionPlanId);
}

function getCoveredInClassTemplate(state, sessionPlanId) {
  return state.get('rootReducer').get('coveredInClassTemplate').get(sessionPlanId);
}

function isAllCategoryItemsChecked(coveredInClassContent) {
  return coveredInClassContent && coveredInClassContent.reduce(function (isCheck, coveredInClass) {
    return isCheck && coveredInClass.cicCategories.every(function (_ref) {
      var cicCategoryItems = _ref.cicCategoryItems;
      return cicCategoryItems.every(function (_ref2) {
        var isChecked = _ref2.isChecked;
        return isChecked;
      });
    }) && coveredInClass.cicActivities.every(function (_ref3) {
      var cicActivityItems = _ref3.cicActivityItems;
      return cicActivityItems.every(function (_ref4) {
        var isChecked = _ref4.isChecked;
        return isChecked;
      });
    });
  }, true);
}

function filterUncheckItems(coveredInClassContent) {
  return coveredInClassContent.map(function (coveredInClass) {
    return coveredInClass.update('cicActivities', function (cicActivities) {
      return cicActivities.map(function (cicActivity) {
        return cicActivity.update('cicActivityItems', function (cicActivityItems) {
          return cicActivityItems.filter(function (cicActivityItem) {
            return cicActivityItem.isChecked;
          });
        });
      });
    }).update('cicCategories', function (cicCategories) {
      return cicCategories.map(function (cicCategory) {
        return cicCategory.update('cicCategoryItems', function (cicCategoryItems) {
          return cicCategoryItems.filter(function (cicCategoryItem) {
            return cicCategoryItem.isChecked;
          });
        });
      });
    });
  });
}

function isAllCategoryItemsUnchecked(coveredInClassContent) {
  if (!coveredInClassContent || coveredInClassContent.size === 0) return true;
  return coveredInClassContent.reduce(function (isCheck, coveredInClass) {
    return isCheck && coveredInClass.cicCategories.every(function (_ref5) {
      var cicCategoryItems = _ref5.cicCategoryItems;
      return cicCategoryItems.every(function (_ref6) {
        var isChecked = _ref6.isChecked;
        return !isChecked;
      });
    }) && coveredInClass.cicActivities.every(function (_ref7) {
      var cicActivityItems = _ref7.cicActivityItems;
      return cicActivityItems.every(function (_ref8) {
        var isChecked = _ref8.isChecked;
        return !isChecked;
      });
    });
  }, true);
}

function toggleCategoryItemsCheckedState(coveredInClassContent) {
  if (!coveredInClassContent) {
    return;
  }
  var newIsChecked = !isAllCategoryItemsChecked(coveredInClassContent);
  return coveredInClassContent.map(function (coveredInClass) {
    return coveredInClass.update('cicCategories', function (cicCategories) {
      return cicCategories.map(function (cicCategory) {
        return cicCategory.update('cicCategoryItems', function (cicCategoryItems) {
          return cicCategoryItems.map(function (cicCategoryItem) {
            return cicCategoryItem.set('isChecked', newIsChecked);
          });
        });
      });
    }).update('cicActivities', function (cicActivities) {
      return cicActivities.map(function (cicActivity) {
        return cicActivity.update('cicActivityItems', function (cicActivityItems) {
          return cicActivityItems.map(function (cicActivityItem) {
            return cicActivityItem.set('isChecked', newIsChecked);
          });
        });
      });
    });
  });
}

function getCurrentSessionNumber(state, _ref9) {
  var _ref9$params = _ref9.params,
      groupId = _ref9$params.groupId,
      sessionPlanId = _ref9$params.sessionPlanId;

  var group = state.get('rootReducer').get('groups').get(groupId);
  group = group && group.data;
  return group && group.sessionPlans.data && group.sessionPlans.data.indexOf(sessionPlanId) + 1;
}

function hasWronglyResult(state, sessionPlanId) {
  var result = getCoveredInClassObject(state, sessionPlanId);
  var template = getCoveredInClassTemplate(state, sessionPlanId);
  if (_is_js2.default.existy(result) && _is_js2.default.existy(template)) {
    if (result.size !== template.size) {
      return true;
    }
    return template.size !== template.filter(function (t) {
      return result.some(function (r) {
        return r.unitId === t.unitId && r.lessonNumber === t.lessonNumber;
      });
    }).size;
  }

  return undefined;
}

function isNotFutureSession(state, params) {
  var currentSessionDate = getCurrentSessionDate(state, params);
  return (0, _omniCommonUi.moment)().isAfter(currentSessionDate);
}

function hasSaved(state, sessionPlanId) {
  var result = getCoveredInClassObject(state, sessionPlanId);
  var template = getCoveredInClassTemplate(state, sessionPlanId);
  if (_is_js2.default.existy(template) && _is_js2.default.existy(result)) {
    return result.size !== 0;
  }
  return undefined;
}

function isNotPublished(state, _ref10) {
  var sessionPlanId = _ref10.sessionPlanId;

  var coveredInClassObject = getCoveredInClassObject(state, sessionPlanId);
  return !coveredInClassObject || coveredInClassObject.size === 0 || coveredInClassObject.some(function (cic) {
    return cic && cic.cicStatus !== 'Published';
  });
}

function hasCIC(state, _ref11) {
  var sessionPlanId = _ref11.sessionPlanId;

  var coveredInClassObject = getCoveredInClassObject(state, sessionPlanId);
  return hasCICItems(coveredInClassObject);
}

function hasCICTemplate(state, _ref12) {
  var sessionPlanId = _ref12.sessionPlanId;

  var coveredInClassTemplate = getCoveredInClassTemplate(state, sessionPlanId);
  return hasCICItems(coveredInClassTemplate);
}

function hasCICItems(coveredInClass) {
  return coveredInClass && coveredInClass.some(function (cic) {
    return cic && cic.cicActivities && cic.cicActivities.size > 0 || cic && cic.cicCategories && cic.cicCategories.size > 0;
  });
}

function getCurrentSessionDate(state, _ref13) {
  var groupId = _ref13.groupId,
      sessionPlanId = _ref13.sessionPlanId;

  var group = state.get('rootReducer').get('groups').get(groupId).data;
  var sessionPlanIds = group.sessionPlans;

  var currentSessionPlanId = sessionPlanId;
  var sessionPlansInfo = state.get('rootReducer').get('sessionPlans');
  var sessionPlans = sessionPlanIds.update('data', function (data) {
    return new _immutable.List(data);
  }).update('data', function (data) {
    return data.map(function (planId) {
      return sessionPlansInfo.get(planId);
    });
  });
  var currentSessionIndex = sessionPlans.data.findIndex(function (plan) {
    return plan.id === currentSessionPlanId;
  });
  var currentSession = sessionPlans.data.get(currentSessionIndex);
  var currentSessionDate = currentSession.period.start;
  return currentSessionDate;
}

function mergeCategoriesByName(categories) {
  var mergedCategories = new _immutable.List();
  var newCategories = categories.map(function (category) {
    var newCicCategoryItems = category.cicCategoryItems.map(function (cicCategoryItem) {
      return (0, _immutable.Record)({
        cicCategoryItemId: undefined,
        cicCategoryItemName: undefined,
        isChecked: undefined,
        cicCategoryId: undefined
      })(Object.assign({}, cicCategoryItem.toJS(), { cicCategoryId: category.cicCategoryId }));
    });

    return (0, _immutable.Record)({
      cicCategoryName: undefined,
      cicCategoryItems: undefined,
      cicCategoryId: undefined
    })({
      cicCategoryName: category.cicCategoryName,
      cicCategoryItems: newCicCategoryItems,
      cicCategoryId: category.cicCategoryId
    });
  });

  newCategories.forEach(function (newCategory) {
    var existingCategory = mergedCategories.findEntry(_isSameCategory);
    existingCategory = existingCategory && existingCategory[1];
    if (!existingCategory) {
      mergedCategories = mergedCategories.push(newCategory);
    } else {
      mergedCategories = mergedCategories.map(function (mergedCategory) {
        if (mergedCategory.cicCategoryName === existingCategory.cicCategoryName) {
          return mergedCategory.update('cicCategoryItems', _mergedCategoryItems);
        }
        return mergedCategory;
      });
    }

    function _mergedCategoryItems(cicCategoryItems) {
      return cicCategoryItems.concat(newCategory.cicCategoryItems);
    }

    function _isSameCategory(mergedCategory) {
      return mergedCategory.cicCategoryName === newCategory.cicCategoryName;
    }
  });

  return mergedCategories;
}

function listToMap(list, keyField) {
  return list.reduce(function (map, item) {
    return map.set(item[keyField], item);
  }, new _immutable.OrderedMap({}));
}

function categoryToOrderMap(list) {
  return list.reduce(function (map, item) {
    return map.set(item.cicCategoryName, item.update('cicCategoryItems', function (cicCategoryItems) {
      return listToMap(cicCategoryItems, 'cicCategoryItemId');
    }));
  }, new _immutable.OrderedMap({}));
}

function activityToOrderMap(list) {
  return list.reduce(function (map, item) {
    return map.set(item.cicActivityId, item.update('cicActivityItems', function (cicActivityItems) {
      return listToMap(cicActivityItems, 'cicActivityItemId');
    }));
  }, new _immutable.OrderedMap({}));
}

function categoryDeepMerge(template, categories) {
  var templateMap = categoryToOrderMap(template);
  var categoriesMap = categoryToOrderMap(categories);
  var result = templateMap.mergeDeep(categoriesMap);
  return result.map(function (item) {
    return item.update('cicCategoryItems', function (map) {
      return map.toList();
    });
  });
}

function activityDeepMerge(template, activities) {
  var templateMap = activityToOrderMap(template);
  var activitiesMap = activityToOrderMap(activities);
  var result = templateMap.mergeDeep(activitiesMap);
  return result.map(function (item) {
    return item.update('cicActivityItems', function (map) {
      return map.toList();
    });
  });
}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _Category = __webpack_require__(1550);

var _Category2 = _interopRequireDefault(_Category);

var _Activity = __webpack_require__(1554);

var _Activity2 = _interopRequireDefault(_Activity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CoveredInClassRecord = (0, _immutable.Record)({
  lessonNumber: undefined,
  unitId: undefined,
  unitOrderingSequence: undefined,
  cicStatus: undefined,
  cicCategories: new _immutable.List(),
  cicActivities: new _immutable.List()
});

var CoveredInClass = function (_CoveredInClassRecord) {
  _inherits(CoveredInClass, _CoveredInClassRecord);

  function CoveredInClass() {
    _classCallCheck(this, CoveredInClass);

    return _possibleConstructorReturn(this, (CoveredInClass.__proto__ || Object.getPrototypeOf(CoveredInClass)).apply(this, arguments));
  }

  return CoveredInClass;
}(CoveredInClassRecord);

var receiver = function receiver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'cicStatus':
      return [key, '' + val];
    case 'cicActivities':
      return [key, new _immutable.List(val.map(_Activity2.default.create))];
    case 'cicCategories':
      return [key, new _immutable.List(val.map(_Category2.default.create))];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

CoveredInClass.create = function (data) {
  return new CoveredInClass(data).mapEntries(receiver);
};

exports.default = CoveredInClass;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(678);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1559);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InternalNote = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(680);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1563);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(1564);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var InternalNote = exports.InternalNote = _model2.default;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isInEditNoteMode = isInEditNoteMode;

var _component = __webpack_require__(671);

var _component2 = _interopRequireDefault(_component);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _omniCommonUi = __webpack_require__(0);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _SessionNav = __webpack_require__(132);

var _SessionNav2 = _interopRequireDefault(_SessionNav);

var _accessors = __webpack_require__(36);

var _CoveredInClass = __webpack_require__(95);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Modes = exports.Modes = {
  PUBLISH: 'publish-to-ef-p',
  EXPORT: 'export',
  ADD_NOTES: 'add-notes',
  EDIT_NOTES: 'edit-notes',
  DELETE_NOTES: 'delete-notes',
  ADD_FREE_TEXT: 'add-free-text',
  CLEAR: 'clear'
};

var actionButtons = function actionButtons(getState) {
  return {
    PUBLISH: {
      isPrimary: true,
      route: './' + Modes.PUBLISH,
      visibleWhen: function visibleWhen(_ref) {
        var params = _ref.params;
        return !_.actions.isAutoPublishCIC(getState(), params.groupId) && !_.actions.isHFV4CourseTypeGroup(getState(), params.groupId) && _CoveredInClass.accessors.isNotPublished(getState(), params) && _CoveredInClass.accessors.isNotFutureSession(getState(), params);
      },
      disableWhen: function disableWhen(_ref2) {
        var _ref2$params = _ref2.params,
            mode = _ref2$params.mode,
            sessionPlanId = _ref2$params.sessionPlanId;

        var coveredInClassObject = _CoveredInClass.accessors.getCoveredInClassObject(getState(), sessionPlanId);
        var hasPrivilege = _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.MarkAndPublish);
        // OMO-2376: Publish button is disabled if all items are unchecked
        return !hasPrivilege || isInEditNoteMode(mode) || _CoveredInClass.accessors.isAllCategoryItemsUnchecked(coveredInClassObject);
      }
    },
    EXPORT: {
      isPrimary: false,
      route: './' + Modes.EXPORT,
      visibleWhen: function visibleWhen(_ref3) {
        var params = _ref3.params;
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.PrintCoveredInClass) && !_.actions.isNotTBv3Group(getState(), params.groupId) && !_.actions.isHFV4CourseTypeGroup(getState(), params.groupId) && _CoveredInClass.accessors.isNotFutureSession(getState(), params) && _CoveredInClass.accessors.hasCICTemplate(getState(), params);
      },
      disableWhen: function disableWhen(_ref4) {
        var mode = _ref4.params.mode;
        return isInEditNoteMode(mode);
      }
    },
    'ADD NOTES': {
      isPrimary: false,
      route: './' + Modes.ADD_NOTES,
      visibleWhen: function visibleWhen() {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.AddCommentToInternal);
      },
      disableWhen: function disableWhen(_ref5) {
        var mode = _ref5.params.mode;
        return isInEditNoteMode(mode);
      }
    },
    'ADD FREE TEXT': {
      isPrimary: false,
      route: './' + Modes.ADD_FREE_TEXT,
      visibleWhen: function visibleWhen(_ref6) {
        var params = _ref6.params;
        return !_.actions.isAutoPublishCIC(getState(), params.groupId) && !_.actions.isHFV4CourseTypeGroup(getState(), params.groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.AddCommentToInternal) && _CoveredInClass.accessors.isNotPublished(getState(), params) && _CoveredInClass.accessors.isNotFutureSession(getState(), params);
      },
      disableWhen: function disableWhen(_ref7) {
        var mode = _ref7.params.mode;
        return isInEditNoteMode(mode);
      }
    },
    CLEAR: {
      isPrimary: false,
      route: './' + Modes.CLEAR,
      visibleWhen: function visibleWhen(_ref8) {
        var params = _ref8.params;
        return !_CoveredInClass.accessors.isNotPublished(getState(), params) && _CoveredInClass.accessors.hasWronglyResult(getState(), params.sessionPlanId);
      }
    }
  };
};

exports.default = function (_ref9) {
  var _actionButtons;

  var getState = _ref9.getState;
  return {
    appBars: {
      sticky: {
        'session-nav': {
          component: _SessionNav2.default,
          order: 1
        },
        'view-nav': {
          component: _ViewNav2.default,
          order: 2
        }
      }
    },
    path: 'session/:sessionPlanId(/unit/:unitId)/covered-in-class(/:mode)(/:index)',
    component: _component2.default,
    canAccess: function canAccess(_ref10) {
      var params = _ref10.params;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.ViewCoveredInClass) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.CoveredInClass);
    },
    tab: {
      label: 'Covered in Class',
      order: 5,
      isVisible: function isVisible(params) {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.ViewCoveredInClass) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.CoveredInClass);
      },
      params: function params(currentParams) {
        var defaultSession = (0, _accessors.getDefaultSession)(getState(), currentParams.groupId);
        var sessionPlanId = defaultSession && defaultSession.id;
        return _extends({}, currentParams, {
          sessionPlanId: sessionPlanId,
          unitId: (0, _accessors.getFirstUnitOfSession)(getState(), sessionPlanId),
          mode: ''
        });
      }
    },
    breadcrumbLabels: function breadcrumbLabels(props) {
      return [{
        label: 'Covered in Class',
        clickable: false
      }, 'Session ' + (_CoveredInClass.accessors.getCurrentSessionNumber(getState(), props) || '')];
    },
    actionButtons: (_actionButtons = {
      default: actionButtons(getState)
    }, _defineProperty(_actionButtons, Modes.ADD_NOTES, actionButtons(getState)), _defineProperty(_actionButtons, Modes.EDIT_NOTES, actionButtons(getState)), _defineProperty(_actionButtons, Modes.ADD_FREE_TEXT, actionButtons(getState)), _defineProperty(_actionButtons, Modes.CLEAR, actionButtons(getState)), _actionButtons)
  };
};

function isInEditNoteMode(mode) {
  return mode === Modes.ADD_NOTES || mode === Modes.EDIT_NOTES || mode === Modes.ADD_FREE_TEXT;
}

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RAv2Cic = exports.reducer = exports.actions = exports.accessors = undefined;

var _accessors2 = __webpack_require__(1570);

var _accessors = _interopRequireWildcard(_accessors2);

var _actions2 = __webpack_require__(683);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1571);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(684);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var accessors = exports.accessors = _accessors;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var RAv2Cic = exports.RAv2Cic = _model2.default;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentTasks = exports.accessors = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(688);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1579);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(311);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1582);

var _create2 = _interopRequireDefault(_create);

var _accessors2 = __webpack_require__(1583);

var _accessors = _interopRequireWildcard(_accessors2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

_model2.default.actions = _actions;
_model2.default.create = _create2.default;

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var accessors = exports.accessors = _accessors;
var StudentTasks = exports.StudentTasks = _model2.default;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentTasksRecord = (0, _immutable.Record)({
  lessonNumber: undefined,
  sessionId: undefined,
  unitId: undefined,
  unitOrderingSequence: undefined,
  studentTaskResults: undefined
});

var StudentTasks = function (_StudentTasksRecord) {
  _inherits(StudentTasks, _StudentTasksRecord);

  function StudentTasks() {
    _classCallCheck(this, StudentTasks);

    return _possibleConstructorReturn(this, (StudentTasks.__proto__ || Object.getPrototypeOf(StudentTasks)).apply(this, arguments));
  }

  return StudentTasks;
}(StudentTasksRecord);

exports.default = StudentTasks;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_GROUP_LESSON_AWARDS_FAILURE = exports.FETCH_GROUP_LESSON_AWARDS_SUCCESS = exports.FETCH_GROUP_LESSON_AWARDS_REQUEST = undefined;
exports.fetchGroupLessonAwardsIfNeeded = fetchGroupLessonAwardsIfNeeded;
exports.fetchGroupLessonAwards = fetchGroupLessonAwards;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_GROUP_LESSON_AWARDS_REQUEST = exports.FETCH_GROUP_LESSON_AWARDS_REQUEST = 'FETCH_GROUP_LESSON_AWARDS_REQUEST';
var FETCH_GROUP_LESSON_AWARDS_SUCCESS = exports.FETCH_GROUP_LESSON_AWARDS_SUCCESS = 'FETCH_GROUP_LESSON_AWARDS_SUCCESS';
var FETCH_GROUP_LESSON_AWARDS_FAILURE = exports.FETCH_GROUP_LESSON_AWARDS_FAILURE = 'FETCH_GROUP_LESSON_AWARDS_FAILURE';

var buildSessionAwardsUrl = function buildSessionAwardsUrl(sessionId) {
  return (0, _Api.buildUrl)('/sessions/' + sessionId + '/hf-v4-awards');
};

var HTTP_METHOD_GET = 'GET';

function fetchGroupLessonAwardsIfNeeded(sessionId) {
  return function (dispatch, getState) {
    var state = getState();
    var url = buildSessionAwardsUrl(sessionId);
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: HTTP_METHOD_GET, url: url })) {
      return false;
    }

    return dispatch(fetchGroupLessonAwards(sessionId));
  };
}

function fetchGroupLessonAwards(sessionId) {
  return function (dispatch) {
    var url = buildSessionAwardsUrl(sessionId);
    var method = HTTP_METHOD_GET;

    return dispatch(createRequestAction({ sessionId: sessionId, method: method, url: url })).payload.then(function (response) {
      return dispatch(createSuccessAction({ response: response, sessionId: sessionId, method: method, url: url }));
    }).catch(function (error) {
      if (error.response && error.response.code === 404) {
        return dispatch(createSuccessAction({ sessionId: sessionId, method: method, url: url }));
      }

      return dispatch(createFailureAction({ error: error, sessionId: sessionId, method: method, url: url }));
    });
  };
}

function createRequestAction(_ref) {
  var sessionId = _ref.sessionId,
      method = _ref.method,
      url = _ref.url;

  return _omniCommonUi.ApiCall.createAction({
    type: FETCH_GROUP_LESSON_AWARDS_REQUEST,
    payload: (0, _Api.fetch)(url),
    url: url,
    method: method,
    sessionId: sessionId
  });
}

function createSuccessAction(_ref2) {
  var response = _ref2.response,
      sessionId = _ref2.sessionId,
      method = _ref2.method,
      url = _ref2.url;

  return _omniCommonUi.ApiCall.createAction({
    type: FETCH_GROUP_LESSON_AWARDS_SUCCESS,
    payload: response,
    url: url,
    method: method,
    sessionId: sessionId
  });
}

function createFailureAction(_ref3) {
  var error = _ref3.error,
      sessionId = _ref3.sessionId,
      method = _ref3.method,
      url = _ref3.url;

  return _omniCommonUi.ApiCall.createAction({
    type: FETCH_GROUP_LESSON_AWARDS_FAILURE,
    payload: error,
    url: url,
    method: method,
    sessionId: sessionId
  });
}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewNavButton = function ViewNavButton(_ref) {
  var title = _ref.title,
      isPrimary = _ref.isPrimary,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      linkHref = _ref.linkHref,
      newTab = _ref.newTab,
      className = _ref.className;
  return _react2.default.createElement(
    _omniCommonUi.Button,
    { autoWidth: true,
      type: isPrimary ? _omniCommonUi.Button.Type.primary : _omniCommonUi.Button.Type.default,
      disabled: disabled,
      onClick: onClick,
      newTab: newTab,
      className: className,
      linkHref: linkHref },
    title
  );
};

ViewNavButton.propTypes = {
  title: _propTypes2.default.string,
  isPrimary: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  linkHref: _propTypes2.default.string,
  newTab: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

exports.default = ViewNavButton;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewNavExtra = function ViewNavExtra(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    null,
    children
  );
};

ViewNavExtra.propTypes = {
  children: _propTypes2.default.node
};

exports.default = ViewNavExtra;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResourceResult = exports.ResourceDisplayCategory = exports.ResourceStatus = exports.ResourceLabels = exports.ResourceColumnOrder = exports.ResourceTypes = undefined;

var _ResourceLabels;

exports.getResourceDisplayCategory = getResourceDisplayCategory;
exports.buildUnitResourcesKey = buildUnitResourcesKey;
exports.toStudentUnitResourcesList = toStudentUnitResourcesList;

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ResourceTypes = exports.ResourceTypes = {
  StoryVideo: 'StoryVideo',
  Songs: 'Songs',
  UnitReader: 'UnitReader',
  PhonicsReader: 'PhonicsReader',
  VocabularyPlayPart1: 'VocabularyPlayPart1',
  VocabularyPlayPart2: 'VocabularyPlayPart2',
  ChallengeReader: 'ChallengeReader',
  PhonicsVideo: 'PhonicsVideo'
};

// Column display order in the table (req #2)
var ResourceColumnOrder = exports.ResourceColumnOrder = [ResourceTypes.StoryVideo, ResourceTypes.Songs, ResourceTypes.UnitReader, ResourceTypes.PhonicsReader, ResourceTypes.VocabularyPlayPart1, ResourceTypes.VocabularyPlayPart2, ResourceTypes.ChallengeReader, ResourceTypes.PhonicsVideo];

var ResourceLabels = exports.ResourceLabels = (_ResourceLabels = {}, _defineProperty(_ResourceLabels, ResourceTypes.StoryVideo, 'Story Video'), _defineProperty(_ResourceLabels, ResourceTypes.Songs, 'Songs'), _defineProperty(_ResourceLabels, ResourceTypes.UnitReader, 'Unit Reader'), _defineProperty(_ResourceLabels, ResourceTypes.PhonicsReader, 'Phonics Reader'), _defineProperty(_ResourceLabels, ResourceTypes.VocabularyPlayPart1, 'Vocabulary Play - Part 1'), _defineProperty(_ResourceLabels, ResourceTypes.VocabularyPlayPart2, 'Vocabulary Play - Part 2'), _defineProperty(_ResourceLabels, ResourceTypes.ChallengeReader, 'Challenge Reader'), _defineProperty(_ResourceLabels, ResourceTypes.PhonicsVideo, 'Phonics Video'), _ResourceLabels);

var ResourceStatus = exports.ResourceStatus = {
  NotStarted: 'NotStarted',
  Completed: 'Completed',
  CompletedLate: 'CompletedLate',
  Expired: 'Expired'
};

var ResourceDisplayCategory = exports.ResourceDisplayCategory = {
  SingleIcon: 'SingleIcon',
  Progress: 'Progress',
  ChallengeReader: 'ChallengeReader'
};

var PROGRESS_TYPES = [ResourceTypes.VocabularyPlayPart1, ResourceTypes.VocabularyPlayPart2, ResourceTypes.PhonicsVideo];

function getResourceDisplayCategory(resourceType) {
  if (resourceType === ResourceTypes.ChallengeReader) {
    return ResourceDisplayCategory.ChallengeReader;
  }
  if (PROGRESS_TYPES.indexOf(resourceType) !== -1) {
    return ResourceDisplayCategory.Progress;
  }
  return ResourceDisplayCategory.SingleIcon;
}

function buildUnitResourcesKey(groupId, unitId) {
  return groupId + '-' + unitId;
}

var toNumber = function toNumber(value) {
  var numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

var ResourceResultRecord = (0, _immutable.Record)({
  resourceType: undefined,
  status: undefined,
  progress: 0,
  totalProgress: 0,
  extraCount: 0,
  readCount: 0,
  totalBooks: 0
});

var ResourceResult = exports.ResourceResult = function (_ResourceResultRecord) {
  _inherits(ResourceResult, _ResourceResultRecord);

  function ResourceResult() {
    _classCallCheck(this, ResourceResult);

    return _possibleConstructorReturn(this, (ResourceResult.__proto__ || Object.getPrototypeOf(ResourceResult)).apply(this, arguments));
  }

  return ResourceResult;
}(ResourceResultRecord);

ResourceResult.create = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new ResourceResult({
    resourceType: data.resourceType,
    status: data.status,
    progress: toNumber(data.progress),
    totalProgress: toNumber(data.totalProgress),
    extraCount: toNumber(data.extraCount),
    readCount: toNumber(data.readCount),
    totalBooks: toNumber(data.totalBooks)
  });
};

var StudentUnitResourcesRecord = (0, _immutable.Record)({
  studentId: undefined,
  resources: new _immutable.Map()
});

var StudentUnitResources = function (_StudentUnitResources) {
  _inherits(StudentUnitResources, _StudentUnitResources);

  function StudentUnitResources() {
    _classCallCheck(this, StudentUnitResources);

    return _possibleConstructorReturn(this, (StudentUnitResources.__proto__ || Object.getPrototypeOf(StudentUnitResources)).apply(this, arguments));
  }

  return StudentUnitResources;
}(StudentUnitResourcesRecord);

StudentUnitResources.create = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var resources = Array.isArray(data.resources) ? data.resources.reduce(function (map, resource) {
    return map.set(resource.resourceType, ResourceResult.create(resource));
  }, new _immutable.Map()) : new _immutable.Map();

  return new StudentUnitResources({
    studentId: data.studentId,
    resources: resources
  });
};

function toStudentUnitResourcesList(payload) {
  var students = payload && payload.students || [];
  if (!Array.isArray(students)) {
    return new _immutable.List();
  }
  return new _immutable.List(students.filter(function (student) {
    return student && student.studentId != null;
  }).map(StudentUnitResources.create));
}

exports.default = StudentUnitResources;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnitQuiz = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _GroupMembers = __webpack_require__(14);

var _UnitQuiz = __webpack_require__(701);

var _SessionPlans = __webpack_require__(44);

var _accessors = __webpack_require__(41);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var skills = ['Reading', 'Listening', 'Phonics', 'Total'];

var UnitQuiz = exports.UnitQuiz = function (_Component) {
  _inherits(UnitQuiz, _Component);

  function UnitQuiz() {
    _classCallCheck(this, UnitQuiz);

    return _possibleConstructorReturn(this, (UnitQuiz.__proto__ || Object.getPrototypeOf(UnitQuiz)).apply(this, arguments));
  }

  _createClass(UnitQuiz, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.fetchUnitQuizResultsIfNeeded(this.props.groupId);
    }
  }, {
    key: '_getHighlightedColumns',
    value: function _getHighlightedColumns() {
      var _props = this.props,
          units = _props.units,
          defaultUnits = _props.defaultUnits;


      if (_is_js2.default.undefined(units)) {
        return [0];
      }

      var unitIds = units.valueSeq().toArray().map(function (u) {
        return u.id;
      });

      return _is_js2.default.undefined(defaultUnits) ? [0] : defaultUnits.map(function (u) {
        return unitIds.indexOf(u);
      });
    }
  }, {
    key: '_renderUnitColumns',
    value: function _renderUnitColumns(units) {
      var cellItems = [];

      if (_is_js2.default.undefined(units) || units.size === 0) {
        return cellItems;
      }

      cellItems.push(units.valueSeq().toArray().map(function (unit) {
        return _react2.default.createElement(
          _CourseViewTable2.default.Cell,
          { key: '' + unit.id,
            columnId: unit.id,
            small: true },
          unit.name
        );
      }));

      return cellItems;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          members = _props2.members,
          units = _props2.units,
          studentUnitQuizResults = _props2.studentUnitQuizResults;


      if (_is_js2.default.undefined(members) || members.size === 0) {
        return null;
      }

      var rows = members.map(function (member) {
        return skills.map(function (skill) {
          return member.set('skill', skill);
        });
      }).reduce(function (a, b) {
        return a.concat(b);
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _CourseViewTable2.default,
          { students: rows, showSkill: true, highlightedColumns: this._getHighlightedColumns() },
          _react2.default.createElement(
            _CourseViewTable2.default.Header,
            null,
            _react2.default.createElement(
              _CourseViewTable2.default.Row,
              null,
              this._renderUnitColumns(units)
            )
          ),
          _react2.default.createElement(
            _CourseViewTable2.default.Body,
            null,
            function (member, column) {
              if (_is_js2.default.undefined(studentUnitQuizResults)) {
                return null;
              }

              var content = void 0;
              var studentUnitQuizResult = studentUnitQuizResults.filter(function (r) {
                return r.studentId === member.studentGeneralInfo.id;
              }).first();
              var unitQuizResult = _is_js2.default.undefined(studentUnitQuizResult) ? undefined : studentUnitQuizResult.unitQuizResults.filter(function (r) {
                return r.unitId === column;
              }).first();

              if (member.skill === 'Total') {
                content = _is_js2.default.undefined(unitQuizResult) ? null : unitQuizResult.totalScore + '%';
              } else {
                var skillResult = _is_js2.default.undefined(unitQuizResult) ? undefined : unitQuizResult.skillResults.filter(function (r) {
                  return r.skill.toUpperCase() === member.skill.toUpperCase();
                }).first();

                content = _is_js2.default.undefined(skillResult) ? null : skillResult.score + '/' + skillResult.totalScore;
              }

              return _react2.default.createElement(
                'div',
                null,
                content
              );
            }
          )
        )
      );
    }
  }]);

  return UnitQuiz;
}(_react.Component);

UnitQuiz.propTypes = {
  groupId: _propTypes2.default.string.isRequired,
  members: _propTypes2.default.object,
  units: _propTypes2.default.object,
  defaultUnits: _propTypes2.default.object,
  studentUnitQuizResults: _propTypes2.default.object,
  fetchUnitQuizResultsIfNeeded: _propTypes2.default.func
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var units = (0, _accessors.getUnitList)(state, groupId);
  var defaultUnits = _SessionPlans.actions.getDefaultUnits(state, groupId);
  var studentUnitQuizResults = state.get('rootReducer').get('unitQuizResult').get(groupId);

  return {
    groupId: groupId,
    members: members,
    units: units,
    defaultUnits: defaultUnits,
    studentUnitQuizResults: studentUnitQuizResults
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign((0, _redux.bindActionCreators)(_UnitQuiz.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(UnitQuiz);

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnlineusageRecord = (0, _immutable.Record)({
  studentId: undefined,
  spinProcess: undefined,
  unitOnlineUsages: undefined,
  selectedCourse: new _immutable.List()
});

var OnlineUsage = function (_OnlineusageRecord) {
  _inherits(OnlineUsage, _OnlineusageRecord);

  function OnlineUsage() {
    _classCallCheck(this, OnlineUsage);

    return _possibleConstructorReturn(this, (OnlineUsage.__proto__ || Object.getPrototypeOf(OnlineUsage)).apply(this, arguments));
  }

  return OnlineUsage;
}(OnlineusageRecord);

exports.default = OnlineUsage;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1703);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentItem = function ContentItem(props) {
  var classesBoard = (0, _classnames2.default)(_style2.default.ContentItem_board, props.className, (0, _omniCommonUi.testClass)('content-item'));

  return _react2.default.createElement(
    'div',
    { className: classesBoard },
    _react2.default.createElement(
      'div',
      { className: _style2.default.ContentItem_title },
      _is_js2.default.existy(props.homeworkType) ? _react2.default.createElement(
        'label',
        { className: _style2.default.ContentItem_label },
        props.homeworkType
      ) : null,
      _is_js2.default.existy(props.boardTitle) ? _react2.default.createElement(
        'h5',
        { className: _style2.default.ContentItem_h5 },
        props.boardTitle
      ) : null
    ),
    _is_js2.default.existy(props.boardValue) ? _react2.default.createElement(
      'p',
      { className: _style2.default.ContentItem_p },
      judgeValue(props.boardValue)
    ) : null
  );

  function judgeValue(boardValue) {
    if (!_is_js2.default.not.undefined(boardValue) || !boardValue || boardValue === '') {
      return '_';
    }
    return boardValue;
  }
};

ContentItem.propTypes = {
  className: _propTypes2.default.string,
  homeworkType: _propTypes2.default.string,
  boardTitle: _propTypes2.default.string.isRequired,
  boardValue: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]).isRequired
};

exports.default = ContentItem;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _create = __webpack_require__(1706);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnlineHomeworkContentItemRecord = (0, _immutable.Record)({
  name: undefined,
  description: undefined
});

var OnlineHomeworkContentRecord = (0, _immutable.Record)({
  unitId: undefined,
  unitOrderingSequence: undefined,
  lessonNumber: undefined,
  contentItems: new _immutable.OrderedMap()
});

var OnlineHomeworkContentItem = function (_OnlineHomeworkConten) {
  _inherits(OnlineHomeworkContentItem, _OnlineHomeworkConten);

  function OnlineHomeworkContentItem() {
    _classCallCheck(this, OnlineHomeworkContentItem);

    return _possibleConstructorReturn(this, (OnlineHomeworkContentItem.__proto__ || Object.getPrototypeOf(OnlineHomeworkContentItem)).apply(this, arguments));
  }

  return OnlineHomeworkContentItem;
}(OnlineHomeworkContentItemRecord);

var OnlineHomeworkContent = function (_OnlineHomeworkConten2) {
  _inherits(OnlineHomeworkContent, _OnlineHomeworkConten2);

  function OnlineHomeworkContent() {
    _classCallCheck(this, OnlineHomeworkContent);

    return _possibleConstructorReturn(this, (OnlineHomeworkContent.__proto__ || Object.getPrototypeOf(OnlineHomeworkContent)).apply(this, arguments));
  }

  return OnlineHomeworkContent;
}(OnlineHomeworkContentRecord);

OnlineHomeworkContent.Item = OnlineHomeworkContentItem;
OnlineHomeworkContent.create = _create2.default;

exports.default = OnlineHomeworkContent;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _Homework = __webpack_require__(137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PersonalisedHomeworkItemRecord = (0, _immutable.Record)({
  type: undefined,
  homeworkTypeId: undefined,
  content: undefined
});

var PersonalisedHomeworkRecord = (0, _immutable.Record)({
  id: undefined,
  sessionId: undefined,
  homeworkId: undefined,
  contents: undefined,
  createdByUserId: undefined,
  studentIds: new _immutable.Set(), // necessary
  status: _Homework.status.NEW,
  homeworkType: undefined
});

var PersonalisedHomeworkItem = function (_PersonalisedHomework) {
  _inherits(PersonalisedHomeworkItem, _PersonalisedHomework);

  function PersonalisedHomeworkItem() {
    _classCallCheck(this, PersonalisedHomeworkItem);

    return _possibleConstructorReturn(this, (PersonalisedHomeworkItem.__proto__ || Object.getPrototypeOf(PersonalisedHomeworkItem)).apply(this, arguments));
  }

  return PersonalisedHomeworkItem;
}(PersonalisedHomeworkItemRecord);

var PersonalisedHomework = function (_PersonalisedHomework2) {
  _inherits(PersonalisedHomework, _PersonalisedHomework2);

  function PersonalisedHomework() {
    _classCallCheck(this, PersonalisedHomework);

    return _possibleConstructorReturn(this, (PersonalisedHomework.__proto__ || Object.getPrototypeOf(PersonalisedHomework)).apply(this, arguments));
  }

  return PersonalisedHomework;
}(PersonalisedHomeworkRecord);

PersonalisedHomework.Item = PersonalisedHomeworkItem;

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      item = _ref2[1];

  if (!item) return [key, item];
  switch (key) {
    case 'id':
    case 'sessionId':
    case 'homeworkId':
    case 'createdByUserId':
      return [key, '' + item];
    case 'studentIds':
      return [key, new _immutable.Set(item.map(function (i) {
        return i.toString();
      }))];
    case 'contents':
      return [key, new _immutable.List(item.map(function (i) {
        return new PersonalisedHomeworkItem(i);
      }))];
    default:
      return [key, _immutable2.default.fromJS(item)];
  }
};

var serializer = function serializer(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      item = _ref4[1];

  switch (key) {
    case 'id':
    case 'sessionId':
    case 'homeworkId':
      return [key, Number.parseInt(item, 10)];
    // the server sets these; remove them when serializing
    case 'createdByUserId':
      return [key, undefined];
    default:
      return [key, item];
  }
};

PersonalisedHomework.create = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!data.contents) {
    data.contents = [{}]; // eslint-disable-line
  }
  return new PersonalisedHomework(data).mapEntries(reviver);
};

PersonalisedHomework.serialize = function (model) {
  var serializedModel = model;
  if (serializedModel instanceof PersonalisedHomework) {
    // toMap() because https://github.com/facebook/immutable-js/issues/574
    serializedModel = serializedModel.toMap().mapEntries(serializer);
    serializedModel = serializedModel.filter(function (val) {
      return _is_js2.default.not.nan(val) && _is_js2.default.existy(val);
    }).toObject();
  }
  serializedModel.studentIds = serializedModel.studentIds.toArray().map(function (id) {
    return Number.parseInt(id, 10);
  });
  return serializedModel;
};

PersonalisedHomework.validate = function (model) {
  return !!(model instanceof PersonalisedHomework && _immutable.List.isList(model.contents) && model.studentIds.size && model.contents.size && model.contents.every(PersonalisedHomeworkItem.validate));
};

PersonalisedHomeworkItem.validate = function (model) {
  return !!(model instanceof PersonalisedHomeworkItem && model.homeworkTypeId && model.content && model.content.length);
};

exports.default = PersonalisedHomework;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ASSIGN_HOMEWORK_FAILURE = exports.ASSIGN_HOMEWORK_SUCCESS = exports.ASSIGN_HOMEWORK_REQUEST = exports.FETCH_HOMEWORK_CONTENT_FAILURE = exports.FETCH_HOMEWORK_CONTENT_SUCCESS = exports.FETCH_HOMEWORK_CONTENT_REQUEST = undefined;
exports.fetchHomeworkContentIfNeeded = fetchHomeworkContentIfNeeded;
exports.fetchHomeworkContent = fetchHomeworkContent;
exports.assignHomeworkContent = assignHomeworkContent;

var _omniCommonUi = __webpack_require__(0);

var _Api = __webpack_require__(11);

var _model = __webpack_require__(167);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_HOMEWORK_CONTENT_REQUEST = exports.FETCH_HOMEWORK_CONTENT_REQUEST = 'FETCH_HOMEWORK_CONTENT_REQUEST';
var FETCH_HOMEWORK_CONTENT_SUCCESS = exports.FETCH_HOMEWORK_CONTENT_SUCCESS = 'FETCH_HOMEWORK_CONTENT_SUCCESS';
var FETCH_HOMEWORK_CONTENT_FAILURE = exports.FETCH_HOMEWORK_CONTENT_FAILURE = 'FETCH_HOMEWORK_CONTENT_FAILURE';
var ASSIGN_HOMEWORK_REQUEST = exports.ASSIGN_HOMEWORK_REQUEST = 'ASSIGN_HOMEWORK_REQUEST';
var ASSIGN_HOMEWORK_SUCCESS = exports.ASSIGN_HOMEWORK_SUCCESS = 'ASSIGN_HOMEWORK_SUCCESS';
var ASSIGN_HOMEWORK_FAILURE = exports.ASSIGN_HOMEWORK_FAILURE = 'ASSIGN_HOMEWORK_FAILURE';

var buildHomeworkContentUrl = function buildHomeworkContentUrl(sessionId) {
  return (0, _Api.buildUrl)('/sessions/' + sessionId + '/homework-content');
};

function fetchHomeworkContentIfNeeded(sessionId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildHomeworkContentUrl(sessionId) })) {
      return false;
    }

    return dispatch(fetchHomeworkContent(sessionId));
  };
}

function fetchHomeworkContent(sessionId) {
  return function (dispatch) {
    var url = buildHomeworkContentUrl(sessionId);
    var method = 'GET';

    return dispatch(fetchHomeworkContentRequest()).payload.then(function (response) {
      return dispatch(fetchHomeworkContentSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchHomeworkContenttFailure(error));
    });

    function fetchHomeworkContentRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_HOMEWORK_CONTENT_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchHomeworkContentSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_HOMEWORK_CONTENT_SUCCESS,
        payload: response,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchHomeworkContenttFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_HOMEWORK_CONTENT_FAILURE,
        url: url,
        method: method,
        sessionId: sessionId,
        error: error
      });
    }
  };
}

function assignHomeworkContent(sessionId, editedGroupHomeworkItems) {
  return function (dispatch) {
    var url = buildHomeworkContentUrl(sessionId);
    var method = 'PUT';

    return dispatch(assignHomeworkContentRequest()).payload.then(function () {
      return dispatch(assignHomeworkContentSuccess());
    }).catch(function (error) {
      return dispatch(assignHomeworkContentFailure(error));
    });

    function assignHomeworkContentRequest() {
      var request = (0, _Api.fetch)(url, {
        method: method,
        body: JSON.stringify(_model2.default.serialize(editedGroupHomeworkItems))
      });
      return _omniCommonUi.ApiCall.createAction({
        type: ASSIGN_HOMEWORK_REQUEST,
        payload: request,
        url: url,
        method: method,
        sessionId: sessionId,
        editedGroupHomeworkItems: editedGroupHomeworkItems
      });
    }

    function assignHomeworkContentSuccess() {
      return _omniCommonUi.ApiCall.createAction({
        type: ASSIGN_HOMEWORK_SUCCESS,
        url: url,
        method: method,
        sessionId: sessionId,
        editedGroupHomeworkItems: editedGroupHomeworkItems
      });
    }

    function assignHomeworkContentFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: ASSIGN_HOMEWORK_FAILURE,
        url: url,
        method: method,
        error: error,
        sessionId: sessionId,
        editedGroupHomeworkItems: editedGroupHomeworkItems
      });
    }
  };
}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _create = __webpack_require__(1734);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnlockHomeworkRecord = new _immutable.Record({
  studentId: undefined,
  latestUnlockedSequence: undefined,
  totalLessonAmount: undefined,
  sessionNumber: undefined,
  unitNumber: undefined,
  lessonNumber: undefined,
  manualLessonSequence: undefined
});

var UnlockHomework = function (_UnlockHomeworkRecord) {
  _inherits(UnlockHomework, _UnlockHomeworkRecord);

  function UnlockHomework() {
    _classCallCheck(this, UnlockHomework);

    return _possibleConstructorReturn(this, (UnlockHomework.__proto__ || Object.getPrototypeOf(UnlockHomework)).apply(this, arguments));
  }

  return UnlockHomework;
}(UnlockHomeworkRecord);

UnlockHomework.crete = _create2.default;

exports.default = UnlockHomework;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BottomButtons = exports.routes = undefined;

var _component = __webpack_require__(758);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(772);

var _routes3 = _interopRequireDefault(_routes2);

var _IndividualDevelopmentPlanDetailView = __webpack_require__(775);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
var BottomButtons = exports.BottomButtons = _IndividualDevelopmentPlanDetailView.BottomButtons;

exports.default = _component2.default;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_OVERALL_DEVELOPMENT_TEMPLATE_FAILURE = exports.FETCH_OVERALL_DEVELOPMENT_TEMPLATE_SUCCESS = exports.FETCH_OVERALL_DEVELOPMENT_TEMPLATE_REQUEST = exports.FETCH_OVERALL_DEVELOPMENT_RESULT_FAILURE = exports.FETCH_OVERALL_DEVELOPMENT_RESULT_SUCCESS = exports.FETCH_OVERALL_DEVELOPMENT_RESULT_REQUEST = exports.SAVE_OVERALL_DEVELOPMENT_FAILURE = exports.SAVE_OVERALL_DEVELOPMENT_SUCCESS = exports.SAVE_OVERALL_DEVELOPMENT_REQUEST = undefined;
exports.fetchOverallDevelopmentTemplateIfNeeded = fetchOverallDevelopmentTemplateIfNeeded;
exports.fetchOverallDevelopmentResultIfNeeded = fetchOverallDevelopmentResultIfNeeded;
exports.fetchOverallDevelopmentTemplate = fetchOverallDevelopmentTemplate;
exports.fetchOverallDevelopmentResult = fetchOverallDevelopmentResult;
exports.saveOverallDevelopment = saveOverallDevelopment;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var _actions = __webpack_require__(168);

var idpActions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var SAVE_OVERALL_DEVELOPMENT_REQUEST = exports.SAVE_OVERALL_DEVELOPMENT_REQUEST = 'FETCH_OVERALL_DEVELOPMENT_RESULT_REQUEST';
var SAVE_OVERALL_DEVELOPMENT_SUCCESS = exports.SAVE_OVERALL_DEVELOPMENT_SUCCESS = 'FETCH_OVERALL_DEVELOPMENT_RESULT_SUCCESS';
var SAVE_OVERALL_DEVELOPMENT_FAILURE = exports.SAVE_OVERALL_DEVELOPMENT_FAILURE = 'FETCH_OVERALL_DEVELOPMENT_RESULT_FAILURE';
var FETCH_OVERALL_DEVELOPMENT_RESULT_REQUEST = exports.FETCH_OVERALL_DEVELOPMENT_RESULT_REQUEST = 'FETCH_OVERALL_DEVELOPMENT_RESULT_REQUEST';
var FETCH_OVERALL_DEVELOPMENT_RESULT_SUCCESS = exports.FETCH_OVERALL_DEVELOPMENT_RESULT_SUCCESS = 'FETCH_OVERALL_DEVELOPMENT_RESULT_SUCCESS';
var FETCH_OVERALL_DEVELOPMENT_RESULT_FAILURE = exports.FETCH_OVERALL_DEVELOPMENT_RESULT_FAILURE = 'FETCH_OVERALL_DEVELOPMENT_RESULT_FAILURE';
var FETCH_OVERALL_DEVELOPMENT_TEMPLATE_REQUEST = exports.FETCH_OVERALL_DEVELOPMENT_TEMPLATE_REQUEST = 'FETCH_OVERALL_DEVELOPMENT_TEMPLATE_REQUEST';
var FETCH_OVERALL_DEVELOPMENT_TEMPLATE_SUCCESS = exports.FETCH_OVERALL_DEVELOPMENT_TEMPLATE_SUCCESS = 'FETCH_OVERALL_DEVELOPMENT_TEMPLATE_SUCCESS';
var FETCH_OVERALL_DEVELOPMENT_TEMPLATE_FAILURE = exports.FETCH_OVERALL_DEVELOPMENT_TEMPLATE_FAILURE = 'FETCH_OVERALL_DEVELOPMENT_TEMPLATE_FAILURE';

var buildSaveOverallDevelopmentUrl = function buildSaveOverallDevelopmentUrl(idpId) {
  return (0, _Api.buildUrl)('/student-idps/' + idpId + '/overall-development-result');
};
var buildFetchOverallDevelopmentResultUrl = function buildFetchOverallDevelopmentResultUrl(idpId) {
  return (0, _Api.buildUrl)('/student-idps/' + idpId + '/overall-development-result');
};
var buildFetchOverallDevelopmentTemplateUrl = function buildFetchOverallDevelopmentTemplateUrl(idpId) {
  return (0, _Api.buildUrl)('/student-idps/' + idpId + '/overall-development-template');
};

function fetchOverallDevelopmentTemplateIfNeeded(idpId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchOverallDevelopmentTemplateUrl(idpId) })) {
      return false;
    }

    return dispatch(fetchOverallDevelopmentTemplate(idpId));
  };
}

function fetchOverallDevelopmentResultIfNeeded(idpId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchOverallDevelopmentResultUrl(idpId) })) {
      return false;
    }

    return dispatch(fetchOverallDevelopmentResult(idpId));
  };
}

function fetchOverallDevelopmentTemplate(idpId) {
  return function (dispatch) {
    var url = buildFetchOverallDevelopmentTemplateUrl(idpId);
    var method = 'GET';

    return dispatch(fetchOverallDevelopmentTemplateRequest()).payload.then(function (response) {
      return dispatch(fetchOverallDevelopmentTemplateSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchOverallDevelopmentTemplateFailure(error));
    });

    function fetchOverallDevelopmentTemplateRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_OVERALL_DEVELOPMENT_TEMPLATE_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        idpId: idpId
      });
    }

    function fetchOverallDevelopmentTemplateSuccess(templates) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_OVERALL_DEVELOPMENT_TEMPLATE_SUCCESS,
        payload: templates,
        url: url,
        method: method,
        idpId: idpId
      });
    }

    function fetchOverallDevelopmentTemplateFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_OVERALL_DEVELOPMENT_TEMPLATE_FAILURE,
        error: error,
        url: url,
        method: method,
        idpId: idpId
      });
    }
  };
}

function fetchOverallDevelopmentResult(idpId) {
  return function (dispatch) {
    var url = buildFetchOverallDevelopmentResultUrl(idpId);
    var method = 'GET';

    return dispatch(fetchOverallDevelopmentResultRequest()).payload.then(function (response) {
      return dispatch(fetchOverallDevelopmentResultSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchOverallDevelopmentResultFailure(error));
    });

    function fetchOverallDevelopmentResultRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_OVERALL_DEVELOPMENT_RESULT_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        idpId: idpId
      });
    }

    function fetchOverallDevelopmentResultSuccess(results) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_OVERALL_DEVELOPMENT_RESULT_SUCCESS,
        payload: results,
        url: url,
        method: method,
        idpId: idpId
      });
    }

    function fetchOverallDevelopmentResultFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_OVERALL_DEVELOPMENT_RESULT_FAILURE,
        error: error,
        url: url,
        method: method,
        idpId: idpId
      });
    }
  };
}

function saveOverallDevelopment(idpId, overallDevelopment, groupIdpId) {
  return function (dispatch) {
    var url = buildSaveOverallDevelopmentUrl(idpId);
    var method = 'PUT';
    var request = (0, _Api.fetch)(url, {
      method: method, body: JSON.stringify(overallDevelopment)
    });

    return dispatch(saveOverallDevelopmentRequest()).payload.then(function (response) {
      return dispatch(saveOverallDevelopmentSuccess(response));
    }).then(function () {
      return dispatch(fetchOverallDevelopmentResult(idpId));
    }).catch(function (error) {
      return dispatch(saveOverallDevelopmentFailure(error));
    }).then(function () {
      return dispatch(idpActions.fetchIndividualDevelopmentPlanList(groupIdpId));
    });

    function saveOverallDevelopmentRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: SAVE_OVERALL_DEVELOPMENT_REQUEST,
        payload: request,
        url: url,
        method: method,
        idpId: idpId
      });
    }

    function saveOverallDevelopmentSuccess() {
      return _omniCommonUi.ApiCall.createAction({
        type: SAVE_OVERALL_DEVELOPMENT_SUCCESS,
        url: url,
        method: method,
        overallDevelopment: overallDevelopment
      });
    }

    function saveOverallDevelopmentFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SAVE_OVERALL_DEVELOPMENT_FAILURE,
        error: error,
        url: url,
        method: method,
        idpId: idpId
      });
    }
  };
}

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = exports.reducer = exports.SkillRecommendation = undefined;

var _actions2 = __webpack_require__(770);

var _actions = _interopRequireWildcard(_actions2);

var _model = __webpack_require__(326);

var _model2 = _interopRequireDefault(_model);

var _reducer2 = __webpack_require__(1762);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var SkillRecommendation = exports.SkillRecommendation = _model2.default;
var reducer = exports.reducer = _reducer3.default;
var actions = exports.actions = _actions;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _create = __webpack_require__(1759);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SkillRecommendationRecord = (0, _immutable.Record)({
  skillId: undefined,
  skillRecommendationItems: undefined
});

var SkillRecommendation = function (_SkillRecommendationR) {
  _inherits(SkillRecommendation, _SkillRecommendationR);

  function SkillRecommendation() {
    _classCallCheck(this, SkillRecommendation);

    return _possibleConstructorReturn(this, (SkillRecommendation.__proto__ || Object.getPrototypeOf(SkillRecommendation)).apply(this, arguments));
  }

  return SkillRecommendation;
}(SkillRecommendationRecord);

SkillRecommendation.create = _create2.default;

exports.default = SkillRecommendation;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AMPERSAND = exports.CLOSEPAREN = exports.CLOSEANGLEBRACKET = exports.CLOSEBRACKET = exports.CLOSEBRACE = exports.OPENPAREN = exports.OPENANGLEBRACKET = exports.OPENBRACKET = exports.OPENBRACE = exports.WS = exports.TLD = exports.SYM = exports.UNDERSCORE = exports.SLASH = exports.MAILTO = exports.PROTOCOL = exports.QUERY = exports.POUND = exports.PLUS = exports.NUM = exports.NL = exports.LOCALHOST = exports.PUNCTUATION = exports.DOT = exports.COLON = exports.AT = exports.DOMAIN = exports.Base = undefined;

var _createTokenClass = __webpack_require__(779);

var _class = __webpack_require__(214);

/******************************************************************************
	Text Tokens
	Tokens composed of strings
******************************************************************************/

/**
	Abstract class used for manufacturing text tokens.
	Pass in the value this token represents

	@class TextToken
	@abstract
*/
var TextToken = (0, _createTokenClass.createTokenClass)();
TextToken.prototype = {
	toString: function toString() {
		return this.v + '';
	}
};

function inheritsToken(value) {
	var props = value ? { v: value } : {};
	return (0, _class.inherits)(TextToken, (0, _createTokenClass.createTokenClass)(), props);
}

/**
	A valid domain token
	@class DOMAIN
	@extends TextToken
*/
var DOMAIN = inheritsToken();

/**
	@class AT
	@extends TextToken
*/
var AT = inheritsToken('@');

/**
	Represents a single colon `:` character

	@class COLON
	@extends TextToken
*/
var COLON = inheritsToken(':');

/**
	@class DOT
	@extends TextToken
*/
var DOT = inheritsToken('.');

/**
	A character class that can surround the URL, but which the URL cannot begin
	or end with. Does not include certain English punctuation like parentheses.

	@class PUNCTUATION
	@extends TextToken
*/
var PUNCTUATION = inheritsToken();

/**
	The word localhost (by itself)
	@class LOCALHOST
	@extends TextToken
*/
var LOCALHOST = inheritsToken();

/**
	Newline token
	@class NL
	@extends TextToken
*/
var NL = inheritsToken('\n');

/**
	@class NUM
	@extends TextToken
*/
var NUM = inheritsToken();

/**
	@class PLUS
	@extends TextToken
*/
var PLUS = inheritsToken('+');

/**
	@class POUND
	@extends TextToken
*/
var POUND = inheritsToken('#');

/**
	Represents a web URL protocol. Supported types include

	* `http:`
	* `https:`
	* `ftp:`
	* `ftps:`

	@class PROTOCOL
	@extends TextToken
*/
var PROTOCOL = inheritsToken();

/**
	Represents the start of the email URI protocol

	@class MAILTO
	@extends TextToken
*/
var MAILTO = inheritsToken('mailto:');

/**
	@class QUERY
	@extends TextToken
*/
var QUERY = inheritsToken('?');

/**
	@class SLASH
	@extends TextToken
*/
var SLASH = inheritsToken('/');

/**
	@class UNDERSCORE
	@extends TextToken
*/
var UNDERSCORE = inheritsToken('_');

/**
	One ore more non-whitespace symbol.
	@class SYM
	@extends TextToken
*/
var SYM = inheritsToken();

/**
	@class TLD
	@extends TextToken
*/
var TLD = inheritsToken();

/**
	Represents a string of consecutive whitespace characters

	@class WS
	@extends TextToken
*/
var WS = inheritsToken();

/**
	Opening/closing bracket classes
*/

var OPENBRACE = inheritsToken('{');
var OPENBRACKET = inheritsToken('[');
var OPENANGLEBRACKET = inheritsToken('<');
var OPENPAREN = inheritsToken('(');
var CLOSEBRACE = inheritsToken('}');
var CLOSEBRACKET = inheritsToken(']');
var CLOSEANGLEBRACKET = inheritsToken('>');
var CLOSEPAREN = inheritsToken(')');

var AMPERSAND = inheritsToken('&');

exports.Base = TextToken;
exports.DOMAIN = DOMAIN;
exports.AT = AT;
exports.COLON = COLON;
exports.DOT = DOT;
exports.PUNCTUATION = PUNCTUATION;
exports.LOCALHOST = LOCALHOST;
exports.NL = NL;
exports.NUM = NUM;
exports.PLUS = PLUS;
exports.POUND = POUND;
exports.QUERY = QUERY;
exports.PROTOCOL = PROTOCOL;
exports.MAILTO = MAILTO;
exports.SLASH = SLASH;
exports.UNDERSCORE = UNDERSCORE;
exports.SYM = SYM;
exports.TLD = TLD;
exports.WS = WS;
exports.OPENBRACE = OPENBRACE;
exports.OPENBRACKET = OPENBRACKET;
exports.OPENANGLEBRACKET = OPENANGLEBRACKET;
exports.OPENPAREN = OPENPAREN;
exports.CLOSEBRACE = CLOSEBRACE;
exports.CLOSEBRACKET = CLOSEBRACKET;
exports.CLOSEANGLEBRACKET = CLOSEANGLEBRACKET;
exports.CLOSEPAREN = CLOSEPAREN;
exports.AMPERSAND = AMPERSAND;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = exports.reducer = undefined;

var _actions2 = __webpack_require__(783);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1812);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var reducer = exports.reducer = _reducer3.default;
var actions = exports.actions = _actions;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = exports.reducer = undefined;

var _actions2 = __webpack_require__(324);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1819);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var reducer = exports.reducer = _reducer3.default;
var actions = exports.actions = _actions;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SPINRecord = (0, _immutable.Record)({
  examType: undefined,
  studentActivities: undefined
});

var SPIN = function (_SPINRecord) {
  _inherits(SPIN, _SPINRecord);

  function SPIN() {
    _classCallCheck(this, SPIN);

    return _possibleConstructorReturn(this, (SPIN.__proto__ || Object.getPrototypeOf(SPIN)).apply(this, arguments));
  }

  return SPIN;
}(SPINRecord);

exports.default = SPIN;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CoreAndCatchUpRecord = (0, _immutable.Record)({
  unitNo: undefined,
  lessonCategory: undefined,
  lessonNo: undefined,
  studentActivities: undefined
});

var CoreAndCatchUp = function (_CoreAndCatchUpRecord) {
  _inherits(CoreAndCatchUp, _CoreAndCatchUpRecord);

  function CoreAndCatchUp() {
    _classCallCheck(this, CoreAndCatchUp);

    return _possibleConstructorReturn(this, (CoreAndCatchUp.__proto__ || Object.getPrototypeOf(CoreAndCatchUp)).apply(this, arguments));
  }

  return CoreAndCatchUp;
}(CoreAndCatchUpRecord);

exports.default = CoreAndCatchUp;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modes = exports.CATEGORY_GRAMMAR_PRO = exports.CATEGORY_FEEDBACK = undefined;

var _omniCommonUi = __webpack_require__(0);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _component = __webpack_require__(803);

var _component2 = _interopRequireDefault(_component);

var _SessionNav = __webpack_require__(132);

var _SessionNav2 = _interopRequireDefault(_SessionNav);

var _actions = __webpack_require__(158);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _CoveredInClass = __webpack_require__(95);

var _Feedback = __webpack_require__(217);

var _StudentSelect = __webpack_require__(1886);

var _StudentSelect2 = _interopRequireDefault(_StudentSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROOT_PATH = 'session-report';
var CATEGORY_FEEDBACK = exports.CATEGORY_FEEDBACK = 'feedback';
var CATEGORY_GRAMMAR_PRO = exports.CATEGORY_GRAMMAR_PRO = 'grammar-pro';
var Modes = exports.Modes = {
  ADD_NOTES: 'add-notes',
  EDIT_NOTES: 'edit-notes',
  DELETE_NOTES: 'delete-notes',
  EXPORT: 'export',
  SAVE: 'save'
};

// add priveledge check later
var isAccessable = function isAccessable(state, groupId) {
  return _TabSwitcher2.default.isTabEnabled(state, groupId, _TabSwitcher.TabCodes.SessionReport) && _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.CoveredInClass.ViewCoveredInClass);
};

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    actionButtons: {
      default: {
        'Add Notes': {
          route: './' + Modes.ADD_NOTES,
          visibleWhen: function visibleWhen(_ref2) {
            var params = _ref2.params;
            return params.category === CATEGORY_GRAMMAR_PRO && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.AddCommentToInternal);
          }
        },
        Publish: {
          isPrimary: true,
          route: './' + Modes.SAVE,
          visibleWhen: function visibleWhen(_ref3) {
            var params = _ref3.params;
            var groupId = params.groupId,
                sessionPlanId = params.sessionPlanId;

            var isNotFuture = _CoveredInClass.accessors.isNotFutureSession(getState(), { groupId: groupId, sessionPlanId: sessionPlanId });
            var hasSaved = _CoveredInClass.accessors.hasSaved(getState(), params.sessionPlanId);
            return _is_js2.default.existy(hasSaved) && !hasSaved && isNotFuture && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.MarkAndPublish);
          }
        },
        Export: {
          route: './' + Modes.EXPORT,
          visibleWhen: function visibleWhen(_ref4) {
            var params = _ref4.params;
            var sessionPlanId = params.sessionPlanId,
                studentId = params.studentId;

            var hasCICSaved = _CoveredInClass.accessors.hasSaved(getState(), sessionPlanId);
            var hasFeedbackSaved = _Feedback.accessors.hasFeedbackSaved(getState(), sessionPlanId, studentId);
            return hasCICSaved && hasFeedbackSaved;
          }
        }
      }
    },
    appBars: function appBars(_ref5) {
      var params = _ref5.params;
      var category = params.category;

      return {
        sticky: Object.assign({
          'session-nav': {
            component: _SessionNav2.default,
            order: 1,
            props: {
              shouldShowTime: (0, _actions.isGrammarProGroup)(getState(), params.groupId)
            }
          },
          'view-nav': {
            component: _ViewNav2.default,
            order: 3
          }
        }, category === CATEGORY_FEEDBACK ? {
          'student-select': {
            component: _StudentSelect2.default,
            order: 2
          }
        } : {})
      };
    },
    path: ROOT_PATH + '(/session/:sessionPlanId)(/unit/:unitId)(/student/:studentId)(/category/:category)(/:mode)(/:index)',
    component: _component2.default,
    breadcrumbLabels: function breadcrumbLabels(props) {
      var groupId = props.params.groupId,
          buildRoute = props.buildRoute;

      return {
        label: 'session report',
        href: buildRoute('/group/' + groupId + '/' + ROOT_PATH)
      };
    },
    canAccess: function canAccess(_ref6) {
      var groupId = _ref6.params.groupId;
      return isAccessable(getState(), groupId);
    },
    tab: {
      label: 'Session Report',
      // make this into a constant later
      order: 12,
      isVisible: function isVisible(_ref7) {
        var groupId = _ref7.groupId;
        return isAccessable(getState(), groupId);
      }
    },
    secondLevelTabs: function secondLevelTabs(props) {
      var pathname = props.location.pathname,
          buildRoute = props.buildRoute,
          push = props.push;

      if (!pathname.includes(ROOT_PATH)) return [];
      return [{
        text: 'GRAMMAR PRO COVERED IN CLASS',
        onClick: function onClick() {
          return push(buildRoute({ category: CATEGORY_GRAMMAR_PRO }));
        }
      }, {
        text: 'Feedback',
        onClick: function onClick() {
          return push(buildRoute({ category: CATEGORY_FEEDBACK }));
        }
      }];
    }
  };
};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewNavButton = function ViewNavButton(_ref) {
  var title = _ref.title,
      isPrimary = _ref.isPrimary,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      linkHref = _ref.linkHref,
      newTab = _ref.newTab,
      className = _ref.className;
  return _react2.default.createElement(
    _omniCommonUi.Button,
    { autoWidth: true,
      type: isPrimary ? _omniCommonUi.Button.Type.primary : _omniCommonUi.Button.Type.default,
      disabled: disabled,
      onClick: onClick,
      newTab: newTab,
      className: className,
      linkHref: linkHref },
    title
  );
};

ViewNavButton.propTypes = {
  title: _propTypes2.default.string,
  isPrimary: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  linkHref: _propTypes2.default.string,
  newTab: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

exports.default = ViewNavButton;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewNavExtra = function ViewNavExtra(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    null,
    children
  );
};

ViewNavExtra.propTypes = {
  children: _propTypes2.default.node
};

exports.default = ViewNavExtra;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getAssessmentPlanFromState = getAssessmentPlanFromState;
exports.getAssessmentProgressTestFromState = getAssessmentProgressTestFromState;
exports.calculateAssessmentAverage = calculateAssessmentAverage;
exports.buildAssessmentScoreMap = buildAssessmentScoreMap;
exports.normalizeAssessmentSkillLabels = normalizeAssessmentSkillLabels;
exports.getAssessmentScoresForStudent = getAssessmentScoresForStudent;
exports.getAssessmentResultsCardInfo = getAssessmentResultsCardInfo;
exports.getStudentAssessmentScores = getStudentAssessmentScores;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _skillScoreHFv = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var SPEAKING_1 = 'Speaking 1';
var SPEAKING_2 = 'Speaking 2';

var ASSESSMENT_SKILL_DISPLAY_ORDER = ['Vocabulary', 'Grammar', 'Phonics', 'Reading', 'Listening', 'Writing', _skillScoreHFv.MERGED_SPEAKING_NAME];

function getAssessmentPlanFromState(state, groupId) {
  var progressTestsPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId);
  if (!progressTestsPlan || !progressTestsPlan.data) return null;

  var assessmentExams = progressTestsPlan.data.filter(function (ptp) {
    return ptp.isUnitQuiz === false;
  }).toList().sortBy(function (ptp) {
    return ptp.index;
  });

  return assessmentExams.last() || null;
}

function getAssessmentProgressTestFromState(state, assessmentPlan) {
  if (!assessmentPlan) return null;
  return state.get('rootReducer').get('progressTests').get(assessmentPlan.id);
}

function calculateAssessmentAverage(skillScorePercentages) {
  if (!skillScorePercentages || skillScorePercentages.size <= 0) return null;

  var total = 0;
  var count = 0;
  skillScorePercentages.forEach(function (percentage) {
    if (_is_js2.default.number(percentage)) {
      total += Math.min(100, percentage);
      count += 1;
    }
  });

  if (count === 0) return null;
  return Math.round(total / count);
}

function buildAssessmentScoreMap(idpList, assessmentData) {
  if (!idpList || !idpList.size || !assessmentData) return null;

  var studentProgressTestResults = assessmentData.studentProgressTestResults,
      skills = assessmentData.skills;

  if (!skills || !skills.size) return null;

  var result = {};

  idpList.forEach(function (idp) {
    var studentId = '' + idp.studentId;
    var studentResult = studentProgressTestResults.get(studentId);
    if (!studentResult || !studentResult.totalScore) return;

    var skillScorePercentages = studentResult.totalScore.skillScorePercentages;

    if (!skillScorePercentages) return;

    var studentScores = {};
    skills.forEach(function (skill) {
      var assessmentPercentage = skillScorePercentages.get('' + skill.skillId);
      if (_is_js2.default.number(assessmentPercentage)) {
        studentScores[skill.name] = assessmentPercentage + '%';
      }
    });

    if (Object.keys(studentScores).length > 0) {
      result[studentId] = studentScores;
    }
  });

  return Object.keys(result).length > 0 ? result : null;
}

function normalizeAssessmentSkillLabels(scores) {
  if (!scores) return {};

  var normalized = _extends({}, scores);
  var speakingScore = normalized[SPEAKING_1] || normalized[SPEAKING_2];

  delete normalized[SPEAKING_1];
  delete normalized[SPEAKING_2];

  if (speakingScore) {
    normalized[_skillScoreHFv.MERGED_SPEAKING_NAME] = speakingScore;
  }

  return normalized;
}

function getAssessmentScoresForStudent(studentId, idpList, assessmentData) {
  var scoreMap = buildAssessmentScoreMap(idpList, assessmentData);
  if (!scoreMap) return null;

  var studentScores = scoreMap['' + studentId];
  if (!studentScores) return null;

  return normalizeAssessmentSkillLabels(studentScores);
}

function sortSkillResults(skillResults) {
  var getSortIndex = function getSortIndex(name) {
    var index = ASSESSMENT_SKILL_DISPLAY_ORDER.indexOf(name);
    return index === -1 ? ASSESSMENT_SKILL_DISPLAY_ORDER.length : index;
  };

  return [].concat(_toConsumableArray(skillResults)).sort(function (a, b) {
    return getSortIndex(a.name) - getSortIndex(b.name);
  });
}

function getAssessmentResultsCardInfo(state, _ref) {
  var groupId = _ref.groupId,
      groupIdpId = _ref.groupIdpId,
      studentId = _ref.studentId;

  var groupIdpList = state.get('rootReducer').get('individualDevelopmentPlanList');
  var idpList = _IndividualDevelopmentPlans.accessors.getIdpList(groupIdpList, groupIdpId);
  if (!idpList || !idpList.size) return null;

  var assessmentPlan = getAssessmentPlanFromState(state, groupId);
  var assessmentProgressTest = getAssessmentProgressTestFromState(state, assessmentPlan);

  if (!_omniCommonUi.ApiResponseHelper.hasSucceeded(assessmentProgressTest)) return null;

  var studentScores = getAssessmentScoresForStudent(studentId, idpList, assessmentProgressTest.data);
  if (!studentScores || Object.keys(studentScores).length === 0) return null;

  var idp = idpList.find(function (item) {
    return '' + item.studentId === '' + studentId;
  });
  if (!idp) return null;

  var studentResult = assessmentProgressTest.data.studentProgressTestResults.get('' + studentId);
  var skillScorePercentages = studentResult && studentResult.totalScore && studentResult.totalScore.skillScorePercentages;
  var average = calculateAssessmentAverage(skillScorePercentages);

  var skillResults = sortSkillResults(Object.keys(studentScores).map(function (name) {
    return {
      name: name,
      score: studentScores[name]
    };
  }));

  return {
    totalScore: _is_js2.default.number(average) ? average + '%' : '–',
    skillResults: skillResults
  };
}

function getStudentAssessmentScores(idpList, assessmentData) {
  var scores = new Map();
  if (!idpList || idpList.size <= 0 || !assessmentData) return scores;

  var studentProgressTestResults = assessmentData.studentProgressTestResults;


  idpList.forEach(function (idp) {
    var studentId = '' + idp.studentId;
    var studentResult = studentProgressTestResults.get(studentId);
    if (!studentResult || !studentResult.totalScore) return;

    var skillScorePercentages = studentResult.totalScore.skillScorePercentages;

    var avg = calculateAssessmentAverage(skillScorePercentages);
    if (_is_js2.default.number(avg)) {
      scores = scores.set(studentId, avg);
    }
  });

  return scores;
}

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1993);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ReadOnlyField = function ReadOnlyField(props) {
  var classesBoard = (0, _classnames3.default)(_style2.default.ReadOnlyField_board, _defineProperty({}, _style2.default.ReadOnlyField_board___noDivider, props.hideDivider), props.className);
  var classesH5 = (0, _classnames3.default)(_style2.default.ReadOnlyField_h5, (0, _omniCommonUi.testClass)('field-title'));
  var classesP = (0, _classnames3.default)(_style2.default.ReadOnlyField_p, (0, _omniCommonUi.testClass)('field-value'));

  return _react2.default.createElement(
    'div',
    { className: classesBoard },
    _react2.default.createElement(
      'h5',
      { className: classesH5 },
      props.boardTitle
    ),
    _react2.default.createElement(
      'p',
      { className: classesP },
      judgeValue(props.boardValue)
    )
  );

  function judgeValue(boardValue) {
    if (!_is_js2.default.not.undefined(boardValue) || !boardValue || boardValue === '') {
      return '–';
    }
    return boardValue;
  }
};

ReadOnlyField.propTypes = {
  boardTitle: _propTypes2.default.string.isRequired,
  boardValue: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  hideDivider: _propTypes2.default.bool
};

exports.default = ReadOnlyField;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KetExam = exports.DEFAULT_MOCK_INDEX = exports.MOCK_EXAM_COUNT = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(2049);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(10);

var _omniCommonUi = __webpack_require__(0);

var _KetExams = __webpack_require__(171);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MOCK_EXAM_COUNT = exports.MOCK_EXAM_COUNT = 2;
var DEFAULT_MOCK_INDEX = exports.DEFAULT_MOCK_INDEX = '1';

var KetExam = exports.KetExam = function (_Component) {
  _inherits(KetExam, _Component);

  function KetExam() {
    _classCallCheck(this, KetExam);

    return _possibleConstructorReturn(this, (KetExam.__proto__ || Object.getPrototypeOf(KetExam)).apply(this, arguments));
  }

  _createClass(KetExam, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._load(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._load(nextProps);
    }
  }, {
    key: '_load',
    value: function _load(props) {
      var groupId = props.params.groupId;

      props.fetchKetExamsPlanIfNeeded(groupId);

      var currentExamPlan = props.currentExamPlan,
          exam = props.exam;

      if (currentExamPlan && _omniCommonUi.ApiResponseHelper.shouldFetch(exam)) {
        props.fetchKetExam(groupId, currentExamPlan.get('ketExamId'));
      }

      if (props.examType === _KetExams.KET_EXAM_TYPE_REAL) {
        (props.mockExams || []).forEach(function (mockExam) {
          if (mockExam.ketExamId && _omniCommonUi.ApiResponseHelper.shouldFetch(mockExam.exam)) {
            props.fetchKetExam(groupId, mockExam.ketExamId);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          examType = _props.examType,
          children = _props.children,
          currentExamPlan = _props.currentExamPlan,
          exam = _props.exam,
          mockExams = _props.mockExams;

      return _react2.default.createElement(
        'div',
        { className: _style2.default.KetExam },
        _react2.default.createElement(
          'div',
          { className: _style2.default.KetExam_content },
          children && _react2.default.cloneElement(children, {
            examType: examType,
            currentExamPlan: currentExamPlan,
            exam: exam,
            mockExams: mockExams
          })
        )
      );
    }
  }]);

  return KetExam;
}(_react.Component);

KetExam.propTypes = {
  children: _propTypes2.default.node,
  params: _propTypes2.default.object.isRequired,
  examType: _propTypes2.default.string.isRequired,
  currentExamPlan: _propTypes2.default.object,
  exam: _propTypes2.default.object,
  mockExams: _propTypes2.default.array,
  fetchKetExamsPlanIfNeeded: _propTypes2.default.func.isRequired,
  fetchKetExam: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      mockIndexParam = _ownProps$params.mockIndex;

  var examType = ownProps.route.examType;
  var mockIndex = examType === _KetExams.KET_EXAM_TYPE_MOCK ? mockIndexParam || DEFAULT_MOCK_INDEX : undefined;
  var currentExamPlan = _KetExams.accessors.getKetExamPlanByType(state, groupId, examType, mockIndex);
  var exam = currentExamPlan && _KetExams.accessors.getKetExam(state, '' + currentExamPlan.get('ketExamId'));

  var mockExams = void 0;
  if (examType === _KetExams.KET_EXAM_TYPE_REAL) {
    mockExams = [];
    for (var index = 1; index <= MOCK_EXAM_COUNT; index += 1) {
      var mockPlan = _KetExams.accessors.getKetExamPlanByType(state, groupId, _KetExams.KET_EXAM_TYPE_MOCK, '' + index);
      var ketExamId = mockPlan && '' + mockPlan.get('ketExamId');
      mockExams.push({
        mockIndex: index,
        ketExamId: ketExamId,
        exam: ketExamId && _KetExams.accessors.getKetExam(state, ketExamId)
      });
    }
  }

  return {
    examType: examType,
    mockIndex: mockIndex,
    currentExamPlan: currentExamPlan,
    exam: exam,
    mockExams: mockExams
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_KetExams.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(KetExam);

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KetStudentResult = exports.KetSkill = exports.KET_EXAM_TYPE_REAL = exports.KET_EXAM_TYPE_MOCK = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KET_EXAM_TYPE_MOCK = exports.KET_EXAM_TYPE_MOCK = 'mock';
var KET_EXAM_TYPE_REAL = exports.KET_EXAM_TYPE_REAL = 'real';

var KetSkillRecord = (0, _immutable.Record)({
  skillId: undefined,
  name: undefined,
  maxMark: undefined,
  orderingSequence: undefined,
  markToScaleMappings: new _immutable.List() // List<Map{ mark, scale }>
});

var KetSkill = exports.KetSkill = function (_KetSkillRecord) {
  _inherits(KetSkill, _KetSkillRecord);

  function KetSkill() {
    _classCallCheck(this, KetSkill);

    return _possibleConstructorReturn(this, (KetSkill.__proto__ || Object.getPrototypeOf(KetSkill)).apply(this, arguments));
  }

  return KetSkill;
}(KetSkillRecord);

KetSkill.create = function (data) {
  return new KetSkill(data).mapEntries(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    if (!val) return [key, val];
    switch (key) {
      case 'skillId':
        return [key, '' + val]; // stringify
      case 'markToScaleMappings':
        return [key, _immutable2.default.fromJS(val)];
      default:
        return [key, val];
    }
  });
};

var KetStudentResultRecord = (0, _immutable.Record)({
  studentId: undefined,
  status: undefined,
  // key: skillId, value: Map{ mark, scale, grade, level, markedBy, markedTime }
  skillResults: new _immutable.Map(),
  finalScore: undefined,
  passType: undefined,
  cefrLevel: undefined,
  markedBy: undefined,
  markedTime: undefined
});

var KetStudentResult = exports.KetStudentResult = function (_KetStudentResultReco) {
  _inherits(KetStudentResult, _KetStudentResultReco);

  function KetStudentResult() {
    _classCallCheck(this, KetStudentResult);

    return _possibleConstructorReturn(this, (KetStudentResult.__proto__ || Object.getPrototypeOf(KetStudentResult)).apply(this, arguments));
  }

  return KetStudentResult;
}(KetStudentResultRecord);

KetStudentResult.create = function (data) {
  return new KetStudentResult(data).mapEntries(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        val = _ref4[1];

    if (!val) return [key, val];
    switch (key) {
      case 'studentId':
        return [key, '' + val]; // stringify
      case 'skillResults':
        {
          if (_immutable.Map.isMap(val)) return [key, val];
          return [key, new _immutable.Map(val.map(function (skillResult) {
            return ['' + skillResult.skillId, _immutable2.default.fromJS(skillResult)];
          }))];
        }
      default:
        return [key, _immutable2.default.fromJS(val)];
    }
  });
};

var KetExamRecord = (0, _immutable.Record)({
  ketExamId: undefined,
  groupId: undefined,
  examType: undefined, // 'mock' | 'real'
  mockIndex: undefined, // 1 | 2 (mock only)
  name: undefined,
  skills: new _immutable.List(), // List<KetSkill>
  scaleBandings: new _immutable.List(), // List<Map{ scaleFrom, scaleTo, grade, cefrLevel }>
  studentResults: new _immutable.OrderedMap() // key: studentId
});

var KetExam = function (_KetExamRecord) {
  _inherits(KetExam, _KetExamRecord);

  function KetExam() {
    _classCallCheck(this, KetExam);

    return _possibleConstructorReturn(this, (KetExam.__proto__ || Object.getPrototypeOf(KetExam)).apply(this, arguments));
  }

  return KetExam;
}(KetExamRecord);

var reviver = function reviver(_ref5) {
  var _ref6 = _slicedToArray(_ref5, 2),
      key = _ref6[0],
      val = _ref6[1];

  if (!val) return [key, val];
  switch (key) {
    case 'ketExamId':
    case 'groupId':
      return [key, '' + val]; // stringify
    case 'skills':
      return [key, new _immutable.List(val.map(KetSkill.create))];
    case 'scaleBandings':
      return [key, _immutable2.default.fromJS(val)];
    case 'studentResults':
      {
        if (_immutable.OrderedMap.isOrderedMap(val)) return [key, val];
        return [key, new _immutable.OrderedMap(val.map(function (item) {
          var studentResult = KetStudentResult.create(item);
          return [studentResult.studentId, studentResult];
        }))];
      }
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

KetExam.create = function (data) {
  return new KetExam(data).mapEntries(reviver);
};

exports.default = KetExam;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.taskStatisticResult = exports.taskStatisticActions = exports.accessors = exports.actions = exports.taskTypes = exports.taskCentres = exports.taskOwnersResult = exports.dosTaskFilterResult = exports.reducer = undefined;

var _reducer2 = __webpack_require__(2079);

var _reducer3 = _interopRequireDefault(_reducer2);

var _actions2 = __webpack_require__(843);

var _actions = _interopRequireWildcard(_actions2);

var _accessors2 = __webpack_require__(2084);

var _accessors = _interopRequireWildcard(_accessors2);

var _TaskStatistic = __webpack_require__(2085);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reducer = exports.reducer = _reducer3.default;
var dosTaskFilterResult = exports.dosTaskFilterResult = _reducer2.dosTaskFilterResult;
var taskOwnersResult = exports.taskOwnersResult = _reducer2.taskOwnersResult;
var taskCentres = exports.taskCentres = _reducer2.taskCentres;
var taskTypes = exports.taskTypes = _reducer2.taskTypes;
var actions = exports.actions = _actions;
var accessors = exports.accessors = _accessors;
var taskStatisticActions = exports.taskStatisticActions = _TaskStatistic.actions;
var taskStatisticResult = exports.taskStatisticResult = _TaskStatistic.reducer;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONCERNS = exports.ALL_GROUPS = exports.TODAY = undefined;

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _component = __webpack_require__(848);

var _component2 = _interopRequireDefault(_component);

var _AcademicInfoGroups = __webpack_require__(2094);

var _Concerns = __webpack_require__(2115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TODAY = exports.TODAY = 'today';
var ALL_GROUPS = exports.ALL_GROUPS = 'all-groups';
var CONCERNS = exports.CONCERNS = 'concerns';

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: '/academic-info',
    component: _component2.default,
    indexRoute: {
      onEnter: function onEnter(_ref2, replace) {
        var location = _ref2.location,
            params = _ref2.params;
        return replace(withoutTrailingSlash(location.pathname) + '/' + TODAY);
      }
    },
    canAccess: function canAccess() {
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.AcademicInfo.View);
    },
    tab: {
      label: 'ACADEMIC INFO',
      order: 2,
      isVisible: function isVisible() {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.AcademicInfo.View);
      }
    },
    secondLevelTabs: function secondLevelTabs(_ref3) {
      var pathname = _ref3.location.pathname,
          push = _ref3.push,
          buildRoute = _ref3.buildRoute;
      return [{
        text: 'TODAY\'S GROUPS',
        onClick: function onClick() {
          return push(buildRoute('/academic-info/' + TODAY));
        },
        isActive: pathname.indexOf(TODAY) > 0
      }, {
        text: 'ALL GROUPS',
        onClick: function onClick() {
          return push(buildRoute('/academic-info/' + ALL_GROUPS));
        },
        isActive: pathname.indexOf(ALL_GROUPS) > 0
      }, {
        text: 'CONCERNS',
        onClick: function onClick() {
          return push(buildRoute('/academic-info/' + CONCERNS));
        },
        isActive: pathname.indexOf(CONCERNS) > 0
      }];
    },
    childRoutes: [_AcademicInfoGroups.routes, _Concerns.routes]
  };
};

function withoutTrailingSlash(path) {
  var out = path;
  if (path.substr(path.length - 1) === '/') {
    out = path.substr(0, path.length - 1);
  }
  return out;
}

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.academicInfoConcernsStudentSkills = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(850);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(2097);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var academicInfoConcernsStudentSkills = exports.academicInfoConcernsStudentSkills = _reducer2.academicInfoConcernsStudentSkills;

/***/ }),
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXAM_ROUTE_VARIANTS = exports.BASE_EXAM_PATH = undefined;
exports.resolveExamRouteVariant = resolveExamRouteVariant;
exports.rewriteBaseExamPath = rewriteBaseExamPath;
exports.getExamPathSegmentByVariantId = getExamPathSegmentByVariantId;

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BASE_EXAM_PATH = exports.BASE_EXAM_PATH = 'exam';

/**
 * Special-program exam route variants.
 * Base exam (`/exam`) is shared by most programs; only special programs
 * (e.g. HFv4, future TB v4) define a custom pathSegment here.
 */
var EXAM_ROUTE_VARIANTS = exports.EXAM_ROUTE_VARIANTS = [{
  id: 'hfv4',
  tabCode: _TabSwitcher.TabCodes.AssessmentHFv4,
  pathSegment: 'exam-hfv4',
  // Only redirect when base MFE tab is off (avoids fighting dual-enabled groups).
  whenBaseDisabled: _TabSwitcher.TabCodes.MidtermAndFinalExam
}];

function resolveExamRouteVariant(state, groupId) {
  return EXAM_ROUTE_VARIANTS.find(function (_ref) {
    var tabCode = _ref.tabCode,
        whenBaseDisabled = _ref.whenBaseDisabled;

    if (!_TabSwitcher2.default.isTabEnabled(state, groupId, tabCode)) {
      return false;
    }

    if (whenBaseDisabled) {
      return !_TabSwitcher2.default.isTabEnabled(state, groupId, whenBaseDisabled);
    }

    return true;
  });
}

function rewriteBaseExamPath(pathname, pathSegment) {
  return pathname.replace(new RegExp('/' + BASE_EXAM_PATH + '(?=/|$)'), '/' + pathSegment);
}

function getExamPathSegmentByVariantId(variantId) {
  var variant = EXAM_ROUTE_VARIANTS.find(function (_ref2) {
    var id = _ref2.id;
    return id === variantId;
  });
  return variant ? variant.pathSegment : BASE_EXAM_PATH;
}

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACH = undefined;

var _immutable = __webpack_require__(3);

var _Interval = __webpack_require__(81);

var _StudentGeneralInfo = __webpack_require__(107);

var _StudentGeneralInfo2 = _interopRequireDefault(_StudentGeneralInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ACHRecord = (0, _immutable.Record)({
  produced: 0,
  present: 0
});

var ACH = exports.ACH = function (_ACHRecord) {
  _inherits(ACH, _ACHRecord);

  function ACH() {
    _classCallCheck(this, ACH);

    return _possibleConstructorReturn(this, (ACH.__proto__ || Object.getPrototypeOf(ACH)).apply(this, arguments));
  }

  return ACH;
}(ACHRecord);

var MemberRecord = (0, _immutable.Record)({
  studentGeneralInfo: new _StudentGeneralInfo2.default(),
  period: new _Interval.Interval(),
  ach: new ACH(),
  status: undefined,
  isInProduction: undefined,
  groupId: undefined,
  skill: undefined
});

var Member = function (_MemberRecord) {
  _inherits(Member, _MemberRecord);

  function Member() {
    _classCallCheck(this, Member);

    return _possibleConstructorReturn(this, (Member.__proto__ || Object.getPrototypeOf(Member)).apply(this, arguments));
  }

  return Member;
}(MemberRecord);

exports.default = Member;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sessions;
exports.updateGroupSessionPlansAttribute = updateGroupSessionPlansAttribute;

var _actions = __webpack_require__(159);

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(280);

var _model2 = _interopRequireDefault(_model);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sessions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_SESSION_PLANS_REQUEST:
      return state;
    case _actions.FETCH_SESSION_PLANS_SUCCESS:
      return onSuccess(state, action);
    case _actions.FETCH_SESSION_PLANS_FAILURE:
      return state;
    default:
      return state;
  }
}

function onSuccess(state, action) {
  var newState = state;
  action.payload.forEach(function (sessionPlan, index) {
    var from = Object.assign({}, sessionPlan, { index: index + 1, groupId: action.groupId });
    var sessionModel = _model2.default.create(from);
    newState = newState.set(sessionModel.id, sessionModel);
  });

  return newState;
}

function updateGroupSessionPlansAttribute(sessionPlans, action) {
  switch (action.type) {
    case _actions.FETCH_SESSION_PLANS_REQUEST:
      return _omniCommonUi.ApiResponseHelper.create({ loading: true });
    case _actions.FETCH_SESSION_PLANS_SUCCESS:
      return onSessionPlansSuccess(sessionPlans, action);
    case _actions.FETCH_SESSION_PLANS_FAILURE:
      return _omniCommonUi.ApiResponseHelper.create(action.error);
    default:
      return sessionPlans;
  }
}

function onSessionPlansSuccess(sessionPlans, action) {
  var sessionPlansIds = action.payload.filter(function (sessionPlan) {
    return !sessionPlan.isCancelled;
  }).map(function (sessionPlan) {
    return '' + sessionPlan.id;
  }); // stringify
  return _omniCommonUi.ApiResponseHelper.create(sessionPlansIds);
}

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_UNITS_FAILURE = exports.FETCH_UNITS_SUCCESS = exports.FETCH_UNITS_REQUEST = undefined;
exports.fetchUnitIfNeeded = fetchUnitIfNeeded;
exports.fetchUnits = fetchUnits;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_UNITS_REQUEST = exports.FETCH_UNITS_REQUEST = 'FETCH_UNITS_REQUEST';
var FETCH_UNITS_SUCCESS = exports.FETCH_UNITS_SUCCESS = 'FETCH_UNITS_SUCCESS';
var FETCH_UNITS_FAILURE = exports.FETCH_UNITS_FAILURE = 'FETCH_UNITS_FAILURE';

var buildUnitUrl = function buildUnitUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/units');
};

function fetchUnitIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildUnitUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchUnits(groupId));
  };
}

function fetchUnits(groupId) {
  return function (dispatch) {
    var url = buildUnitUrl(groupId);
    var method = 'GET';

    return dispatch(fetchUnitsRequest()).payload.then(function (response) {
      return dispatch(fetchUnitsSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchUnitsFailure(error));
    });

    function fetchUnitsRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_UNITS_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchUnitsSuccess(units) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_UNITS_SUCCESS,
        payload: units,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchUnitsFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_UNITS_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Unit = undefined;

var _model = __webpack_require__(1235);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Unit = exports.Unit = _model2.default;

exports.default = Unit;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(597);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1236);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addApiError = addApiError;
exports.removeApiError = removeApiError;
var ADD_ERROR = exports.ADD_ERROR = 'ADD_ERROR';
var REMOVE_ERROR = exports.REMOVE_ERROR = 'REMOVE_ERROR';

function addApiError(pathName, error) {
  return function (dispatch) {
    return dispatch(addError(pathName, error));
  };
}

function removeApiError(pathName) {
  return function (dispatch) {
    return dispatch(removeError(pathName));
  };
}

function addError(pathName, error) {
  return {
    type: ADD_ERROR,
    payload: error,
    pathName: pathName
  };
}

function removeError(pathName) {
  return {
    type: REMOVE_ERROR,
    pathName: pathName
  };
}

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_USER_FAILURE = exports.FETCH_USER_SUCCESS = exports.FETCH_USER_REQUEST = undefined;
exports.getApiCallState = getApiCallState;
exports.fetchUserIfNeeded = fetchUserIfNeeded;
exports.fetchUser = fetchUser;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_USER_REQUEST = exports.FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
var FETCH_USER_SUCCESS = exports.FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
var FETCH_USER_FAILURE = exports.FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';

var buildUserUrl = function buildUserUrl(userId) {
  return (0, _Api.buildUrl)('/users/' + userId);
};

function getApiCallState(state, userId) {
  return _omniCommonUi.ApiCall.find(state, { method: 'GET', url: buildUserUrl(userId) });
}

function fetchUserIfNeeded(userId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildUserUrl(userId) })) {
      return false;
    }

    return dispatch(fetchUser(userId));
  };
}

function fetchUser(userId) {
  return function (dispatch) {
    var url = buildUserUrl(userId);
    var method = 'GET';

    return dispatch(fetchUserRequest()).payload.then(function (response) {
      return dispatch(fetchUserSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchUserFailure(error));
    });

    function fetchUserRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_USER_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        userId: userId,
        disableDefault: true
      });
    }

    function fetchUserSuccess(user) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_USER_SUCCESS,
        payload: user,
        url: url,
        method: method,
        userId: userId
      });
    }

    function fetchUserFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_USER_FAILURE,
        error: error,
        url: url,
        method: method,
        userId: userId,
        disableDefault: true
      });
    }
  };
}

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'id':
      return [key, '' + val];
    case 'gender':
      return [key, _omniCommonUi.Gender.parse(val)];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

var UserRecord = (0, _immutable.Record)({
  avatarUrl: undefined,
  id: undefined,
  userName: undefined,
  userEmail: undefined,
  firstName: undefined,
  middleName: undefined,
  lastName: undefined,
  firstNameLocal: undefined,
  middleNameLocal: undefined,
  lastNameLocal: undefined,
  gender: undefined
});

var User = function (_UserRecord) {
  _inherits(User, _UserRecord);

  function User() {
    _classCallCheck(this, User);

    return _possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).apply(this, arguments));
  }

  _createClass(User, null, [{
    key: 'create',
    value: function create(data) {
      return new User(data).mapEntries(reviver);
    }
  }]);

  return User;
}(UserRecord);

exports.default = User;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_CENTRE_FAILURE = exports.FETCH_CENTRE_SUCCESS = exports.FETCH_CENTRE_REQUEST = undefined;
exports.fetchCentreIfNeeded = fetchCentreIfNeeded;
exports.fetchCentre = fetchCentre;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_CENTRE_REQUEST = exports.FETCH_CENTRE_REQUEST = 'FETCH_CENTRE_REQUEST';
var FETCH_CENTRE_SUCCESS = exports.FETCH_CENTRE_SUCCESS = 'FETCH_CENTRE_SUCCESS';
var FETCH_CENTRE_FAILURE = exports.FETCH_CENTRE_FAILURE = 'FETCH_CENTRE_FAILURE';

var buildFetchCentreUrl = function buildFetchCentreUrl(centreId) {
  return (0, _Api.buildUrl)('/centres/' + centreId);
};
var method = 'GET';

function fetchCentreIfNeeded(centreId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: method, url: buildFetchCentreUrl(centreId) })) {
      return false;
    }

    return dispatch(fetchCentre(centreId));
  };
}

function fetchCentre(centreId) {
  return function (dispatch) {
    var url = buildFetchCentreUrl(centreId);

    return dispatch(fetchCentreRequest()).payload.then(function (response) {
      return dispatch(fetchCentreSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchCentreFailure(error));
    });

    function fetchCentreRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_CENTRE_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        centreId: centreId
      });
    }

    function fetchCentreSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_CENTRE_SUCCESS,
        payload: response,
        url: url,
        method: method,
        centreId: centreId
      });
    }

    function fetchCentreFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_CENTRE_FAILURE,
        error: error,
        url: url,
        method: method,
        centreId: centreId
      });
    }
  };
}

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Centre = function (_Record) {
  _inherits(Centre, _Record);

  function Centre() {
    _classCallCheck(this, Centre);

    return _possibleConstructorReturn(this, (Centre.__proto__ || Object.getPrototypeOf(Centre)).apply(this, arguments));
  }

  return Centre;
}((0, _immutable.Record)({
  id: undefined,
  timeZone: undefined,
  name: undefined,
  countryCode: undefined,
  businessLineCode: undefined
}));

exports.default = Centre;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_PROGRESS_TESTS_PLAN_FAILURE = exports.FETCH_PROGRESS_TESTS_PLAN_SUCCESS = exports.FETCH_PROGRESS_TESTS_PLAN_REQUEST = undefined;
exports.fetchProgressTestPlanIfNeeded = fetchProgressTestPlanIfNeeded;
exports.fetchProgressTestsPlan = fetchProgressTestsPlan;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_PROGRESS_TESTS_PLAN_REQUEST = exports.FETCH_PROGRESS_TESTS_PLAN_REQUEST = 'FETCH_PROGRESS_TESTS_PLAN_REQUEST';
var FETCH_PROGRESS_TESTS_PLAN_SUCCESS = exports.FETCH_PROGRESS_TESTS_PLAN_SUCCESS = 'FETCH_PROGRESS_TESTS_PLAN_SUCCESS';
var FETCH_PROGRESS_TESTS_PLAN_FAILURE = exports.FETCH_PROGRESS_TESTS_PLAN_FAILURE = 'FETCH_PROGRESS_TESTS_PLAN_FAILURE';

var buildProgressTestPlanUrl = function buildProgressTestPlanUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/progress-tests');
};

function fetchProgressTestPlanIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildProgressTestPlanUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchProgressTestsPlan(groupId));
  };
}

function fetchProgressTestsPlan(groupId) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/groups/' + groupId + '/progress-tests');
    var method = 'GET';

    return dispatch(fetchProgressTestsPlanRequest()).payload.then(function (response) {
      return dispatch(fetchProgressTestsPlanSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchProgressTestsPlanFailure(error));
    });

    function fetchProgressTestsPlanRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PROGRESS_TESTS_PLAN_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchProgressTestsPlanSuccess(plan) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PROGRESS_TESTS_PLAN_SUCCESS,
        payload: plan,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchProgressTestsPlanFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PROGRESS_TESTS_PLAN_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Unit = undefined;

var _model = __webpack_require__(1242);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Unit = exports.Unit = _model2.default;

exports.default = Unit;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CourseEvent = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(605);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1244);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(606);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var CourseEvent = exports.CourseEvent = _model2.default;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_COURSE_PROGRESS_FAILURE = exports.FETCH_COURSE_PROGRESS_SUCCESS = exports.FETCH_COURSE_PROGRESS_REQUEST = undefined;
exports.fetchCourseProgressIfNeeded = fetchCourseProgressIfNeeded;
exports.fetchCourseProgress = fetchCourseProgress;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_COURSE_PROGRESS_REQUEST = exports.FETCH_COURSE_PROGRESS_REQUEST = 'FETCH_COURSE_PROGRESS_REQUEST';
var FETCH_COURSE_PROGRESS_SUCCESS = exports.FETCH_COURSE_PROGRESS_SUCCESS = 'FETCH_COURSE_PROGRESS_SUCCESS';
var FETCH_COURSE_PROGRESS_FAILURE = exports.FETCH_COURSE_PROGRESS_FAILURE = 'FETCH_COURSE_PROGRESS_FAILURE';

var buildCourseProgressUrl = function buildCourseProgressUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/course-progress');
};

function fetchCourseProgressIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildCourseProgressUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchCourseProgress(groupId));
  };
}

function fetchCourseProgress(groupId) {
  return function (dispatch) {
    var url = buildCourseProgressUrl(groupId);
    var method = 'GET';

    return dispatch(fetchCourseProgressRequest()).payload.then(function (response) {
      return dispatch(fetchCourseProgressSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchCourseProgressFailure(error));
    });

    function fetchCourseProgressRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_COURSE_PROGRESS_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchCourseProgressSuccess(courseProgresses) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_COURSE_PROGRESS_SUCCESS,
        payload: courseProgresses,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchCourseProgressFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_COURSE_PROGRESS_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CourseEventRecord = _immutable2.default.Record({
  sessionId: undefined,
  plannedPeriod: undefined,
  actualPeriod: undefined,
  sessionType: undefined,
  sessionTypeCode: undefined,
  isHighLight: undefined,
  isMostRecent: undefined,
  hasProgressTest: undefined,
  progressTestName: undefined
});

var CourseEvent = function (_CourseEventRecord) {
  _inherits(CourseEvent, _CourseEventRecord);

  function CourseEvent() {
    _classCallCheck(this, CourseEvent);

    return _possibleConstructorReturn(this, (CourseEvent.__proto__ || Object.getPrototypeOf(CourseEvent)).apply(this, arguments));
  }

  return CourseEvent;
}(CourseEventRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      item = _ref2[1];

  if (!item) return [key, item];
  switch (key) {

    case 'actualPeriod':
    case 'plannedPeriod':
      return [key, {
        startDate: item.startDate,
        endDate: item.endDate
      }];
    default:
      return [key, _immutable2.default.fromJS(item)];
  }
};

CourseEvent.create = function (data) {
  var sessions = [];
  var groupId = '';
  var startWeekCode = '';
  var endWeekCode = '';
  var groupStartDate = '';
  var groupEndDate = '';
  var groupProgress = '';

  if (data) {
    groupId = data.groupId;
    startWeekCode = data.startWeekCode;
    endWeekCode = data.endWeekCode;
    groupStartDate = data.groupStartDate;
    groupEndDate = data.groupEndDate;
    groupProgress = data.groupProgress;

    data.sessions.map(function (SessionObject) {
      sessions.push(new CourseEvent(SessionObject).mapEntries(reviver));
      return false;
    });
  }

  return {
    groupId: groupId,
    startWeekCode: startWeekCode,
    endWeekCode: endWeekCode,
    sessions: sessions,
    groupStartDate: groupStartDate,
    groupEndDate: groupEndDate,
    groupProgress: groupProgress
  };
};

exports.default = CourseEvent;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupPerformance = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(608);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1245);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(609);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var GroupPerformance = exports.GroupPerformance = _model2.default;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_GROUPPERFORMANCE_FAILURE = exports.FETCH_GROUPPERFORMANCE_SUCCESS = exports.FETCH_GROUPPERFORMANCE_REQUEST = undefined;
exports.getGroupPerformanceByGroupId = getGroupPerformanceByGroupId;
exports.isLoadingGroupPerformance = isLoadingGroupPerformance;
exports.fetchGroupPerformanceIfNeeded = fetchGroupPerformanceIfNeeded;
exports.fetchGroupPerformance = fetchGroupPerformance;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_GROUPPERFORMANCE_REQUEST = exports.FETCH_GROUPPERFORMANCE_REQUEST = 'FETCH_GROUPPERFORMANCE_REQUEST';
var FETCH_GROUPPERFORMANCE_SUCCESS = exports.FETCH_GROUPPERFORMANCE_SUCCESS = 'FETCH_GROUPPERFORMANCE_SUCCESS';
var FETCH_GROUPPERFORMANCE_FAILURE = exports.FETCH_GROUPPERFORMANCE_FAILURE = 'FETCH_GROUPPERFORMANCE_FAILURE';

var buildPerformanceUrl = function buildPerformanceUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/students-performance');
};
var method = 'GET';

function getGroupPerformanceByGroupId(state, groupId) {
  return state.get('rootReducer').get('groupPerformance').get(groupId);
}

function isLoadingGroupPerformance(state, groupId) {
  var callState = _omniCommonUi.ApiCall.find(state, { method: 'GET', url: buildPerformanceUrl(groupId) });
  return _omniCommonUi.ApiCall.State.isValue(callState) && _omniCommonUi.ApiCall.State.isLoading(callState);
}

function fetchGroupPerformanceIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: method, url: buildPerformanceUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchGroupPerformance(groupId));
  };
}

function fetchGroupPerformance(groupId) {
  return function (dispatch) {
    var url = buildPerformanceUrl(groupId);

    return dispatch(fetchGroupPerformanceRequest()).payload.then(function (response) {
      return dispatch(fetchGroupPerformanceSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchGroupPerformanceFailure(error));
    });

    function fetchGroupPerformanceRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUPPERFORMANCE_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchGroupPerformanceSuccess(groupPerformance) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUPPERFORMANCE_SUCCESS,
        payload: groupPerformance,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchGroupPerformanceFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUPPERFORMANCE_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _StudentPerformance = __webpack_require__(610);

var _StudentPerformance2 = _interopRequireDefault(_StudentPerformance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GroupPerformanceRecord = _immutable2.default.Record({
  startUnitNumber: undefined,
  endUnitNumber: undefined,
  studentsPerformance: new _immutable.List()
});

var GroupPerformance = function (_GroupPerformanceReco) {
  _inherits(GroupPerformance, _GroupPerformanceReco);

  function GroupPerformance() {
    _classCallCheck(this, GroupPerformance);

    return _possibleConstructorReturn(this, (GroupPerformance.__proto__ || Object.getPrototypeOf(GroupPerformance)).apply(this, arguments));
  }

  return GroupPerformance;
}(GroupPerformanceRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      seq = _ref2[1];

  if (!seq) return [key, seq];
  switch (key) {
    case 'studentsPerformance':
      return [key, new _immutable.List(seq.map(_StudentPerformance2.default.create))];
    default:
      return [key, _immutable2.default.fromJS(seq)];
  }
};

GroupPerformance.create = function (data) {
  return new GroupPerformance(data).mapEntries(reviver);
};

exports.default = GroupPerformance;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentPerformance = undefined;

var _model = __webpack_require__(611);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1247);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudentPerformance = exports.StudentPerformance = _model2.default;

StudentPerformance.create = _create2.default;

exports.default = StudentPerformance;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACH = undefined;

var _immutable = __webpack_require__(3);

var _StudentGeneralInfo = __webpack_require__(107);

var _StudentGeneralInfo2 = _interopRequireDefault(_StudentGeneralInfo);

var _Rewards = __webpack_require__(1246);

var _Rewards2 = _interopRequireDefault(_Rewards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ACHRecord = (0, _immutable.Record)({
  produced: 0,
  present: 0
});

var ACH = exports.ACH = function (_ACHRecord) {
  _inherits(ACH, _ACHRecord);

  function ACH() {
    _classCallCheck(this, ACH);

    return _possibleConstructorReturn(this, (ACH.__proto__ || Object.getPrototypeOf(ACH)).apply(this, arguments));
  }

  return ACH;
}(ACHRecord);

var StudentPerformanceRecord = (0, _immutable.Record)({
  studentGeneralInfo: new _StudentGeneralInfo2.default(),
  status: undefined,
  isInProduction: undefined,
  averageSkillScores: undefined,
  averageTotalScore: undefined,
  averagePaperBasedHomeworkCompletion: undefined,
  averageOnlineHomeworkCompletion: undefined,
  averageOnlineHomeworkAccuracy: undefined,
  averageOnlineHomeworkBestAccuracy: undefined,
  ach: new ACH(),
  rewards: new _Rewards2.default()
});

var StudentPerformance = function (_StudentPerformanceRe) {
  _inherits(StudentPerformance, _StudentPerformanceRe);

  function StudentPerformance() {
    _classCallCheck(this, StudentPerformance);

    return _possibleConstructorReturn(this, (StudentPerformance.__proto__ || Object.getPrototypeOf(StudentPerformance)).apply(this, arguments));
  }

  return StudentPerformance;
}(StudentPerformanceRecord);

exports.default = StudentPerformance;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RewardsRecord = (0, _immutable.Record)({
  completedClasses: undefined,
  totalClasses: undefined,
  classesCompletedPercent: undefined,
  completedHomeworks: undefined,
  totalHomeworks: undefined,
  homeworksCompletedPercent: undefined,
  completedWords: undefined,
  totalWords: undefined,
  wordsCompletedPercent: undefined,
  completedReaders: undefined,
  totalReaders: undefined,
  readersCompletedPercent: undefined,
  completedUnitQuiz: undefined,
  totalUnitQuiz: undefined,
  unitQuizCompletedPercent: undefined
});

var Rewards = function (_RewardsRecord) {
  _inherits(Rewards, _RewardsRecord);

  function Rewards() {
    _classCallCheck(this, Rewards);

    return _possibleConstructorReturn(this, (Rewards.__proto__ || Object.getPrototypeOf(Rewards)).apply(this, arguments));
  }

  return Rewards;
}(RewardsRecord);

Rewards.create = function (data) {
  return new Rewards(data);
};

exports.default = Rewards;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RAv2HomeworkResultSummary = exports.reducer = exports.actions = exports.accessors = undefined;

var _accessors2 = __webpack_require__(1310);

var _accessors = _interopRequireWildcard(_accessors2);

var _actions2 = __webpack_require__(614);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1311);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(286);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var accessors = exports.accessors = _accessors;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var RAv2HomeworkResultSummary = exports.RAv2HomeworkResultSummary = _model2.default;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_FAILURE = exports.FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_SUCCESS = exports.FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_REQUEST = undefined;
exports.fetchRAv2HomeworkResultSummaryIfNeeded = fetchRAv2HomeworkResultSummaryIfNeeded;
exports.fetchRAv2HomeworkResultSummary = fetchRAv2HomeworkResultSummary;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_REQUEST = exports.FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_REQUEST = 'FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_REQUEST';
var FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_SUCCESS = exports.FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_SUCCESS = 'FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_SUCCESS';
var FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_FAILURE = exports.FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_FAILURE = 'FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_FAILURE';

var method = 'GET';
var buildRAv2HomeworkResultSummaryUrl = function buildRAv2HomeworkResultSummaryUrl(groupId) {
  return (0, _Api.buildUrl)('/ra-v2-groups/' + groupId + '/homework-result-summary');
};

function fetchRAv2HomeworkResultSummaryIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, {
      method: method,
      url: buildRAv2HomeworkResultSummaryUrl(groupId)
    })) {
      return false;
    }

    return dispatch(fetchRAv2HomeworkResultSummary(groupId));
  };
}

function fetchRAv2HomeworkResultSummary(groupId) {
  return function (dispatch) {
    var url = buildRAv2HomeworkResultSummaryUrl(groupId);

    return dispatch(fetchRAv2HomeworkResultSummaryRequest()).payload.then(function (response) {
      return dispatch(fetchRAv2HomeworkResultSummarySuccess(response));
    }).catch(function (error) {
      if (error.response && error.response.code === 404) {
        return dispatch(fetchRAv2HomeworkResultSummarySuccess([]));
      }

      return dispatch(fetchRAv2HomeworkResultSummaryFailure(error));
    });

    function fetchRAv2HomeworkResultSummaryRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchRAv2HomeworkResultSummarySuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_SUCCESS,
        payload: payload,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchRAv2HomeworkResultSummaryFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.path = undefined;

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _ = __webpack_require__(13);

var _AttendanceHistory = __webpack_require__(1313);

var _MarkAttendance = __webpack_require__(1321);

var _component = __webpack_require__(1416);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var path = exports.path = 'attendance';

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: path,
    component: _component2.default,
    canAccess: function canAccess(_ref2) {
      var params = _ref2.params;
      return _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.MarkAttendance) && _.actions.shouldEnableMarkAttendance(getState(), params.groupId, true);
    },
    tab: {
      label: 'Attendance',
      order: 1,
      isVisible: function isVisible(params) {
        return _.actions.shouldEnableMarkAttendance(getState(), params.groupId) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.MarkAttendance) && (_omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.MarkAttendance.ViewDayView) || _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.MarkAttendance.ViewCourseView));
      },
      query: function query() {
        return (// redirect to the course view in `onEnter` if we are currently in one
          location.pathname.endsWith('/course') ? 'course' : null
        );
      }
    },
    breadcrumbLabels: 'Attendance',
    childRoutes: [_AttendanceHistory.routes, _MarkAttendance.routes]
  };
};

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessors = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(617);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1316);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(618);

var _model2 = _interopRequireDefault(_model);

var _accessors2 = __webpack_require__(1318);

var _accessors = _interopRequireWildcard(_accessors2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = _model2.default;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var accessors = exports.accessors = _accessors;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_ATTENDANCE_HISTORY_FAILURE = exports.FETCH_ATTENDANCE_HISTORY_SUCCESS = exports.FETCH_ATTENDANCE_HISTORY_REQUEST = undefined;
exports.fetchAttendanceHistory = fetchAttendanceHistory;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_ATTENDANCE_HISTORY_REQUEST = exports.FETCH_ATTENDANCE_HISTORY_REQUEST = 'FETCH_ATTENDANCE_HISTORY_REQUEST';
var FETCH_ATTENDANCE_HISTORY_SUCCESS = exports.FETCH_ATTENDANCE_HISTORY_SUCCESS = 'FETCH_ATTENDANCE_HISTORY_SUCCESS';
var FETCH_ATTENDANCE_HISTORY_FAILURE = exports.FETCH_ATTENDANCE_HISTORY_FAILURE = 'FETCH_ATTENDANCE_HISTORY_FAILURE';

function fetchAttendanceHistory(filterParams) {
  return function (dispatch) {
    var method = 'GET';
    var url = (0, _Api.buildUrl)('/attendance/groups/' + filterParams.groupId + '/histories\n?pageSize=' + filterParams.pageSize + '&pageNumber=' + filterParams.pageNumber);

    return dispatch(fetchAttendanceHistoryRequest()).payload.then(function (response) {
      return dispatch(fetchAttendanceHistorySuccess(response));
    }).catch(function (error) {
      return dispatch(fetchAttendanceHistoryFailure(error));
    });

    function fetchAttendanceHistoryRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ATTENDANCE_HISTORY_REQUEST,
        payload: (0, _Api.fetch)(url),
        method: method,
        url: url
      });
    }

    function fetchAttendanceHistorySuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ATTENDANCE_HISTORY_SUCCESS,
        payload: response,
        method: method,
        url: url
      });
    }

    function fetchAttendanceHistoryFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ATTENDANCE_HISTORY_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(619);

var _create = __webpack_require__(1317);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AttendanceHistory = _model.AttendanceHistoryTable;

AttendanceHistory.create = _create2.default;

exports.default = AttendanceHistory;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttendanceHistoryTable = exports.AttendanceHistoryItems = undefined;

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AttendanceHistoryItemsRecord = _immutable2.default.Record({
  action: undefined,
  studentName: undefined,
  sessionDuration: undefined,
  previousStatus: undefined,
  currentStatus: undefined,
  editedByName: undefined,
  actionTime: undefined
});

var AttendanceHistoryItems = exports.AttendanceHistoryItems = function (_AttendanceHistoryIte) {
  _inherits(AttendanceHistoryItems, _AttendanceHistoryIte);

  function AttendanceHistoryItems() {
    _classCallCheck(this, AttendanceHistoryItems);

    return _possibleConstructorReturn(this, (AttendanceHistoryItems.__proto__ || Object.getPrototypeOf(AttendanceHistoryItems)).apply(this, arguments));
  }

  return AttendanceHistoryItems;
}(AttendanceHistoryItemsRecord);

var AttendanceHistoryTableRecord = _immutable2.default.Record({
  studentAttendanceHistories: undefined,
  totalPages: undefined,
  pageNumber: undefined,
  totalRecords: undefined
});

var AttendanceHistoryTable = exports.AttendanceHistoryTable = function (_AttendanceHistoryTab) {
  _inherits(AttendanceHistoryTable, _AttendanceHistoryTab);

  function AttendanceHistoryTable() {
    _classCallCheck(this, AttendanceHistoryTable);

    return _possibleConstructorReturn(this, (AttendanceHistoryTable.__proto__ || Object.getPrototypeOf(AttendanceHistoryTable)).apply(this, arguments));
  }

  return AttendanceHistoryTable;
}(AttendanceHistoryTableRecord);

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkAttendanceDayView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

exports.mapStateToProps = mapStateToProps;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _FinancialClosingMoment = __webpack_require__(279);

var _FinancialClosingMoment2 = _interopRequireDefault(_FinancialClosingMoment);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _status = __webpack_require__(83);

var _GroupMembers = __webpack_require__(14);

var _SessionsAttendance = __webpack_require__(161);

var SessionsAttendance = _interopRequireWildcard(_SessionsAttendance);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _Student = __webpack_require__(1327);

var _status2 = __webpack_require__(196);

var _UiState = __webpack_require__(30);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentRecord = (0, _immutable.Record)({
  studentGeneralInfo: undefined,
  period: undefined,
  ach: undefined,
  status: undefined,
  isInProduction: undefined,
  sessionId: undefined,
  attendanceStatus: undefined
});

var MARKING = "edit";

var MarkAttendanceDayView = exports.MarkAttendanceDayView = function (_UnsavedChangesTracki) {
  _inherits(MarkAttendanceDayView, _UnsavedChangesTracki);

  function MarkAttendanceDayView() {
    _classCallCheck(this, MarkAttendanceDayView);

    return _possibleConstructorReturn(this, (MarkAttendanceDayView.__proto__ || Object.getPrototypeOf(MarkAttendanceDayView)).apply(this, arguments));
  }

  _createClass(MarkAttendanceDayView, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (_immutable.List.isList(this.props.students)) {
        this.setState({ students: this.props.students });
      }
      this._fetchDataIfNeeded(this.props);
      _get(MarkAttendanceDayView.prototype.__proto__ || Object.getPrototypeOf(MarkAttendanceDayView.prototype), "componentWillMount", this).call(this); // for unsaved changes tracking
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var students = nextProps.students;
      // TODO: Revisit this hack, which prevents loss of changes on nav expand/collapse

      if (this.props.location.pathname === nextProps.location.pathname && this.props.currentSession && // attendance data is mapped
      _immutable.List.isList(this.props.currentSession.data)) {
        return;
      }
      this.setState({ students: students });
      this._fetchDataIfNeeded(nextProps);
    }
  }, {
    key: "_fetchDataIfNeeded",
    value: function _fetchDataIfNeeded(props) {
      if (_is_js2.default.not.string(props.attendanceId)) {
        return;
      }

      props.fetchSessionAttendanceIfNeeded(props.attendanceId);
    }
  }, {
    key: "_isChangesPresent",
    value: function _isChangesPresent() {
      // override
      return this.props.marking && this.state.students !== this.props.students; // has local changes?
    }
  }, {
    key: "_handleSaveAttendance",
    value: function _handleSaveAttendance() {
      var _this2 = this;

      var students = this.state.students;


      students = students.map(function (student) {
        return student.set("attendanceStatus", _status.AttendanceStatus[student.attendanceStatus]);
      });

      this.props.submitSessionAttendance(this.props.attendanceId, students).then(function () {
        _this2.props.fetchGroupMembers(_this2.props.groupId);
      });

      this._forcePushRoute(this.props.buildRoute(".."));
    }
  }, {
    key: "_gaChangeAttendance",
    value: function _gaChangeAttendance(student, previousAttendance, nextAttendance) {
      _reactGa2.default.event({
        category: "Attendance",
        action: "Changed attendance",
        label: "Changed attendance from " + previousAttendance + " to " + nextAttendance
      });
    }
  }, {
    key: "_handleMarkPresent",
    value: function _handleMarkPresent(i) {
      var students = this.state.students;

      this._gaChangeAttendance(students.get(i).id, students.get(i).attendanceStatus, _status.AttendanceStatus.present);
      students = students.update(i, function (student) {
        return student.set("attendanceStatus", _status.AttendanceStatus.present);
      });
      this.setState({ students: students });
    }
  }, {
    key: "_handleMarkAbsent",
    value: function _handleMarkAbsent(i) {
      var students = this.state.students;

      this._gaChangeAttendance(students.get(i).id, students.get(i).attendanceStatus, _status.AttendanceStatus.absent);
      students = students.update(i, function (student) {
        return student.set("attendanceStatus", _status.AttendanceStatus.absent);
      });
      this.setState({ students: students });
    }
  }, {
    key: "_handleMarkLate",
    value: function _handleMarkLate(i) {
      var students = this.state.students;

      this._gaChangeAttendance(students.get(i).id, students.get(i).attendanceStatus, _status.AttendanceStatus.late);
      students = students.update(i, function (student) {
        return student.set("attendanceStatus", _status.AttendanceStatus.late);
      });
      this.setState({ students: students });
    }
  }, {
    key: "routerWillLeave",
    value: function routerWillLeave(nextLocation) {
      if (nextLocation && nextLocation.pathname.endsWith("/save")) {
        this._handleSaveAttendance();
      } else if (nextLocation && nextLocation.pathname.endsWith("/discard")) {
        this._forcePushRoute(this.props.buildRoute({ mode: "" }), {
          students: this.props.students
        });
      } else {
        return _get(MarkAttendanceDayView.prototype.__proto__ || Object.getPrototypeOf(MarkAttendanceDayView.prototype), "routerWillLeave", this).call(this, nextLocation);
      }
    }
  }, {
    key: "_setSessionCourseSwitchMode",
    value: function _setSessionCourseSwitchMode() {
      this.props.toggleViewMode("day");
    }
  }, {
    key: "_renderStudents",
    value: function _renderStudents(students, marking) {
      var _this3 = this;

      return students.map(function (student, index) {
        return _react2.default.createElement(
          _omniCommonUi.Grid.Item,
          {
            key: student.studentGeneralInfo.id,
            xs: 12,
            sm: 6,
            md: 4,
            lg: 3
          },
          _react2.default.createElement(_Student.Student, {
            name: student.studentGeneralInfo.firstName,
            surname: student.studentGeneralInfo.lastName,
            avatarUrl: student.studentGeneralInfo.avatarUrl,
            status: student.attendanceStatus || _status.AttendanceStatus.unmarked,
            productionStatus: student.status,
            isInProduction: student.isInProduction,
            gender: student.studentGeneralInfo.gender,
            localname: student.studentGeneralInfo.localName,
            studentId: student.studentGeneralInfo.id,
            groupNumber: _this3.props.groupNumber,
            sessionInfo: null,
            sessionId: _this3.props.sessionId,
            groupId: _this3.props.groupId,
            marking: marking,
            onMarkPresent: function onMarkPresent() {
              return _this3._handleMarkPresent(index);
            },
            onMarkAbsent: function onMarkAbsent() {
              return _this3._handleMarkAbsent(index);
            },
            onMarkLate: function onMarkLate() {
              return _this3._handleMarkLate(index);
            }
          })
        );
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var students = this.state.students;

      if (!_is_js2.default.existy(students)) {
        return null;
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          _omniCommonUi.Grid,
          { outerMargin: true },
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            this._renderStudents(students, this.props.marking)
          )
        ),
        _react2.default.createElement(_UnsavedChangesWarning2.default, {
          isOpen: !!this._isNavigationWithChangesRequested(),
          isSaving: this.props.isAnyApiCallSaving,
          onSaveClicked: function onSaveClicked() {
            _this4._handleSaveAttendance();
          },
          onDiscardClicked: function onDiscardClicked() {
            _this4._forcePushRequestedLocation();
          },
          onCloseClicked: function onCloseClicked() {
            _this4._setSessionCourseSwitchMode();
            _this4._clearRequestedLocation();
          },
          onSaved: function onSaved() {
            _this4._forcePushRequestedLocation();
          }
        })
      );
    }
  }]);

  return MarkAttendanceDayView;
}(_UnsavedChangesTrackingPageComponent2.default);

MarkAttendanceDayView.isInMarkingRoute = function (props) {
  return props.params && props.params.mode === MARKING;
};

MarkAttendanceDayView.propTypes = Object.assign({}, _UnsavedChangesTrackingPageComponent2.default.propTypes, {
  params: _propTypes2.default.object.isRequired,
  location: _propTypes2.default.object.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  replace: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node,
  fetchGroupMembers: _propTypes2.default.func.isRequired,
  fetchSessionAttendance: _propTypes2.default.func.isRequired,
  submitSessionAttendance: _propTypes2.default.func.isRequired,
  attendanceId: _propTypes2.default.string,
  groupId: _propTypes2.default.string.isRequired,
  currentSession: _propTypes2.default.object,
  markable: _propTypes2.default.bool.isRequired,
  students: _propTypes2.default.object.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  isAnyApiCallSaving: _propTypes2.default.bool.isRequired,
  groupNumber: _propTypes2.default.string.isRequired
});

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      sessionPlanId = _ownProps$params.sessionPlanId;

  var sessionPlan = state.get("rootReducer").get("sessionPlans").get(sessionPlanId);
  var attendanceId = sessionPlan.attendanceId;

  var group = state.get("rootReducer").get("groups").get(groupId).data;

  var markable = false;

  var students = _GroupMembers.actions.getMembersByGroup(state, groupId);

  var currentSession = void 0;
  if (_is_js2.default.existy(attendanceId)) {
    currentSession = state.get("rootReducer").get("sessionsAttendance").get(attendanceId);
    if (currentSession && _immutable.List.isList(currentSession.data)) {
      var attendance = currentSession.data;

      // this part sets default attendance statuses when entering marking mode
      // TODO: refactor this
      if (MarkAttendanceDayView.isInMarkingRoute(ownProps)) {
        attendance = attendance.map(function (student) {
          return student.set("attendanceStatus", (0, _status.convertBackendAttendanceStatusToAttendanceStatus)(student.attendanceStatus, true));
        });
      }

      students = attendance.map(function (student) {
        var id = student.studentGeneralInfo.id;
        var groupMember = students.find(function (member) {
          return member.studentGeneralInfo.id === id;
        });
        if (_is_js2.default.undefined(groupMember)) {
          return student;
        }
        return new StudentRecord(Object.assign(student.toObject(), {
          isInProduction: groupMember.isInProduction,
          status: groupMember.status,
          studentGeneralInfo: groupMember.studentGeneralInfo
        }));
      });
      var financialClosingMoment = _FinancialClosingMoment2.default.nextFrom(sessionPlan.period.start);
      var financialCheck = (0, _omniCommonUi.moment)().isBefore(financialClosingMoment) || _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.MarkAttendance.IgnoreFinanceDate);
      markable = financialCheck && (0, _status2.isActive)(group.status);
    }
  } else {
    students = students.filter(function (member) {
      return sessionPlan.sessionMembers.includes(member.studentGeneralInfo.id);
    });
  }

  students = new _immutable.List(students);

  return {
    groupNumber: group.number,
    attendanceId: attendanceId,
    markable: markable,
    groupId: ownProps.params.groupId,
    sessionId: ownProps.params.sessionPlanId,
    marking: markable && MarkAttendanceDayView.isInMarkingRoute(ownProps),
    students: students,
    currentSession: currentSession,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_GroupMembers.actions, dispatch), (0, _redux.bindActionCreators)(_UiState.actions, dispatch), (0, _redux.bindActionCreators)(SessionsAttendance.actions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !!(state.get("apiCalls") || new _immutable.List()).filter(function (call, key) {
    return ["PUT", "POST"].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(MarkAttendanceDayView));

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBMIT_SESSION_ATTENDANCE_FAILURE = exports.SUBMIT_SESSION_ATTENDANCE_SUCCESS = exports.SUBMIT_SESSION_ATTENDANCE_REQUEST = exports.FETCH_GROUP_ATTENDANCE_FAILURE = exports.FETCH_GROUP_ATTENDANCE_SUCCESS = exports.FETCH_GROUP_ATTENDANCE_REQUEST = exports.FETCH_SESSION_ATTENDANCE_FAILURE = exports.FETCH_SESSION_ATTENDANCE_SUCCESS = exports.FETCH_SESSION_ATTENDANCE_REQUEST = undefined;
exports.fetchSessionAttendanceIfNeeded = fetchSessionAttendanceIfNeeded;
exports.fetchSessionAttendance = fetchSessionAttendance;
exports.fetchGroupAttendanceIfNeeded = fetchGroupAttendanceIfNeeded;
exports.fetchGroupAttendance = fetchGroupAttendance;
exports.submitSessionAttendance = submitSessionAttendance;

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _Api = __webpack_require__(11);

var _status = __webpack_require__(83);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_SESSION_ATTENDANCE_REQUEST = exports.FETCH_SESSION_ATTENDANCE_REQUEST = 'FETCH_SESSION_ATTENDANCE_REQUEST';
var FETCH_SESSION_ATTENDANCE_SUCCESS = exports.FETCH_SESSION_ATTENDANCE_SUCCESS = 'FETCH_SESSION_ATTENDANCE_SUCCESS';
var FETCH_SESSION_ATTENDANCE_FAILURE = exports.FETCH_SESSION_ATTENDANCE_FAILURE = 'FETCH_SESSION_ATTENDANCE_FAILURE';
var FETCH_GROUP_ATTENDANCE_REQUEST = exports.FETCH_GROUP_ATTENDANCE_REQUEST = 'FETCH_GROUP_ATTENDANCE_REQUEST';
var FETCH_GROUP_ATTENDANCE_SUCCESS = exports.FETCH_GROUP_ATTENDANCE_SUCCESS = 'FETCH_GROUP_ATTENDANCE_SUCCESS';
var FETCH_GROUP_ATTENDANCE_FAILURE = exports.FETCH_GROUP_ATTENDANCE_FAILURE = 'FETCH_GROUP_ATTENDANCE_FAILURE';
var SUBMIT_SESSION_ATTENDANCE_REQUEST = exports.SUBMIT_SESSION_ATTENDANCE_REQUEST = 'SUBMIT_SESSION_ATTENDANCE_REQUEST';
var SUBMIT_SESSION_ATTENDANCE_SUCCESS = exports.SUBMIT_SESSION_ATTENDANCE_SUCCESS = 'SUBMIT_SESSION_ATTENDANCE_SUCCESS';
var SUBMIT_SESSION_ATTENDANCE_FAILURE = exports.SUBMIT_SESSION_ATTENDANCE_FAILURE = 'SUBMIT_SESSION_ATTENDANCE_FAILURE';

var buildFetchSessionAttendanceUrl = function buildFetchSessionAttendanceUrl(id) {
  return (0, _Api.buildUrl)('/attendance/' + id);
};

function fetchSessionAttendanceIfNeeded(id) {
  (0, _invariant2.default)(id && id.length, 'id should exist and be non-empty');
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchSessionAttendanceUrl(id) })) {
      return false;
    }

    return dispatch(fetchSessionAttendance(id));
  };
}

function fetchSessionAttendance(id) {
  return function (dispatch) {
    var url = buildFetchSessionAttendanceUrl(id);
    var method = 'GET';

    return dispatch(fetchSessionAttendanceRequest()).payload.then(function (response) {
      return dispatch(fetchSessionAttendanceSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchSessionAttendanceFailure(error));
    });

    function fetchSessionAttendanceRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_SESSION_ATTENDANCE_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        id: id
      });
    }

    function fetchSessionAttendanceSuccess(session) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_SESSION_ATTENDANCE_SUCCESS,
        payload: session,
        url: url,
        method: method,
        id: id
      });
    }

    function fetchSessionAttendanceFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_SESSION_ATTENDANCE_FAILURE,
        error: error,
        url: url,
        method: method,
        id: id
      });
    }
  };
}

var buildFetchGroupAttendanceUrl = function buildFetchGroupAttendanceUrl(id) {
  return (0, _Api.buildUrl)('/groups/' + id + '/student-attendances');
};

function fetchGroupAttendanceIfNeeded(id) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchGroupAttendanceUrl(id) })) {
      return false;
    }

    return dispatch(fetchGroupAttendance(id));
  };
}

function fetchGroupAttendance(id) {
  return function (dispatch) {
    var url = buildFetchGroupAttendanceUrl(id);
    var method = 'GET';

    return dispatch(fetchGroupAttendanceRequest()).payload.then(function (response) {
      return dispatch(fetchGroupAttendanceSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchGroupAttendanceFailure(error));
    });

    function fetchGroupAttendanceRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUP_ATTENDANCE_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method
      });
    }

    function fetchGroupAttendanceSuccess(session) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUP_ATTENDANCE_SUCCESS,
        payload: session,
        url: url,
        method: method
      });
    }

    function fetchGroupAttendanceFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUP_ATTENDANCE_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

function submitSessionAttendance(id, originalAttendance) {
  var attendance = originalAttendance;
  if (_immutable.List.isList(attendance)) {
    attendance = attendance.toArray();
  }

  attendance = attendance.map(function (student) {
    return {
      studentId: student.studentGeneralInfo.id,
      attendanceStatus: _status.AttendanceStatus[student.attendanceStatus]
    };
  });

  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/attendance/' + id);
    var method = 'PUT';

    return dispatch(submitSessionAttendanceRequest()).payload.then(function (response) {
      return dispatch(submitSessionAttendanceSuccess(response));
    }).catch(function (error) {
      return dispatch(submitSessionAttendanceFailure(error));
    }).then(function () {
      return dispatch(fetchSessionAttendance(id));
    });

    function submitSessionAttendanceRequest() {
      var request = (0, _Api.fetch)(url, {
        method: method,
        body: JSON.stringify(attendance)
      });
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_SESSION_ATTENDANCE_REQUEST,
        payload: request,
        url: url,
        method: method,
        id: id,
        attendance: attendance
      });
    }

    function submitSessionAttendanceSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_SESSION_ATTENDANCE_SUCCESS,
        url: url,
        method: method,
        payload: response
      });
    }

    function submitSessionAttendanceFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_SESSION_ATTENDANCE_FAILURE,
        url: url,
        method: method,
        error: error
      });
    }
  };
}

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1336);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UserCardPlaceholder = function UserCardPlaceholder(_ref) {
  var className = _ref.className,
      isLoading = _ref.isLoading;

  var classes = (0, _classnames3.default)(_style2.default.UserCardPlaceholder, className, _defineProperty({}, _style2.default.__loading, isLoading));
  return _react2.default.createElement(
    _omniCommonUi.Person,
    { className: classes },
    _react2.default.createElement(_omniCommonUi.AdultPicture, { className: _style2.default.UserCard_picture }),
    _react2.default.createElement(
      'div',
      { className: _style2.default.UserCardPlaceholder_placeholderText },
      '\xA0'
    ),
    _react2.default.createElement(
      'div',
      { className: _style2.default.UserCardPlaceholder_placeholderText },
      '\xA0'
    )
  );
};

UserCardPlaceholder.propTypes = {
  className: _propTypes2.default.string,
  isLoading: _propTypes2.default.bool
};

exports.default = UserCardPlaceholder;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Note = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getSummary = getSummary;
exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1340);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(10);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _ExpansionGridItem = __webpack_require__(1342);

var _ExpansionGridItem2 = _interopRequireDefault(_ExpansionGridItem);

var _IndividualNote = __webpack_require__(1345);

var _IndividualNote2 = _interopRequireDefault(_IndividualNote);

var _actions = __webpack_require__(199);

var studentNotesActions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Note = exports.Note = function (_PureComponent) {
  _inherits(Note, _PureComponent);

  function Note() {
    _classCallCheck(this, Note);

    return _possibleConstructorReturn(this, (Note.__proto__ || Object.getPrototypeOf(Note)).apply(this, arguments));
  }

  _createClass(Note, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.fetchStudentNotesIfNeeded(this.props.studentId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.props.fetchStudentNotesIfNeeded(nextProps.studentId);
    }
  }, {
    key: '_renderNotes',
    value: function _renderNotes() {
      var _this2 = this;

      if (_is_js2.default.existy(this.props.studentNotes)) {
        return this.props.studentNotesSummary.sort(function (a, b) {
          if (a.noteTime.isBefore(b.noteTime)) {
            return 1;
          }
          return -1;
        }).map(function (summary, stamp) {
          var ids = summary.ids;

          var noteSummary = ids.length === 1 ? '1 Note' : ids.length + ' Notes';
          return _react2.default.createElement(
            _ExpansionGridItem2.default,
            { title: stamp, summary: noteSummary },
            ids.map(function (id) {
              return _react2.default.createElement(_IndividualNote2.default, { key: id, note: _this2.props.studentNotes.get(id) });
            })
          );
        });
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { className: _style2.default.Note },
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          { className: _style2.default.Note_wrapper },
          _react2.default.createElement(
            _omniCommonUi.Grid.Item,
            null,
            _react2.default.createElement(
              _omniCommonUi.PageCard,
              null,
              _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Notes', stackMode: 'horizontal' }),
              _react2.default.createElement(
                _omniCommonUi.PageCard.Content,
                { className: _style2.default.Note_card },
                this._renderNotes()
              )
            )
          )
        )
      );
    }
  }]);

  return Note;
}(_react.PureComponent);

Note.propTypes = {
  studentId: _propTypes2.default.string,
  studentNotes: _propTypes2.default.object,
  studentNotesSummary: _propTypes2.default.object,
  fetchStudentNotesIfNeeded: _propTypes2.default.func
};

function getSummary(notes) {
  var summary = new _immutable.Map();
  if (_immutable.Map.isMap(notes) && notes.size !== 0) {
    notes.forEach(function (note) {
      var notedStamp = _omniCommonUi.moment.utc(note.notedDateTimeUtc).local().format('YYYY-MM');
      if (summary.get(notedStamp)) {
        summary = summary.set(notedStamp, {
          ids: [].concat(_toConsumableArray(summary.get(notedStamp).ids), [note.id]),
          stamp: notedStamp,
          noteTime: note.notedDateTimeUtc
        });
      } else {
        summary = summary.set(notedStamp, {
          ids: [note.id],
          stamp: notedStamp,
          noteTime: note.notedDateTimeUtc
        });
      }
    });
  }
  return summary.map(function (group) {
    var orderGroup = {
      stamp: group.stamp,
      ids: group.ids.sort(function (a, b) {
        if (notes.get(a).notedDateTimeUtc.isBefore(notes.get(b).notedDateTimeUtc)) {
          return 1;
        }
        return -1;
      }),
      noteTime: group.noteTime
    };
    return orderGroup;
  });
}

function mapStateToProps(state, ownProps) {
  var studentId = ownProps.studentId;
  var studentNotes = state.get('rootReducer').get('studentNotes').filter(function (note) {
    return note.studentId === studentId;
  });
  var studentNotesSummary = getSummary(studentNotes);
  return {
    studentId: studentId,
    studentNotes: studentNotes,
    studentNotesSummary: studentNotesSummary
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(studentNotesActions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(Note);

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RETAKE_PROGRESS_TEST_FAILURE = exports.RETAKE_PROGRESS_TEST_SUCCESS = exports.RETAKE_PROGRESS_TEST_REQUEST = exports.SUBMIT_PROGRESS_TEST_RESULTS_FAILURE = exports.SUBMIT_PROGRESS_TEST_RESULTS_SUCCESS = exports.SUBMIT_PROGRESS_TEST_RESULTS_REQUEST = exports.FETCH_PROGRESS_TEST_FAILURE = exports.FETCH_PROGRESS_TEST_SUCCESS = exports.FETCH_PROGRESS_TEST_REQUEST = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.fetchProgressTest = fetchProgressTest;
exports.getProgressReportId = getProgressReportId;
exports.enabledExportPT = enabledExportPT;
exports.submitProgressTestResults = submitProgressTestResults;
exports.retakeProgressTest = retakeProgressTest;

var _Api = __webpack_require__(11);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _StudentReportSummaries = __webpack_require__(42);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_PROGRESS_TEST_REQUEST = exports.FETCH_PROGRESS_TEST_REQUEST = 'FETCH_PROGRESS_TEST_REQUEST';
var FETCH_PROGRESS_TEST_SUCCESS = exports.FETCH_PROGRESS_TEST_SUCCESS = 'FETCH_PROGRESS_TEST_SUCCESS';
var FETCH_PROGRESS_TEST_FAILURE = exports.FETCH_PROGRESS_TEST_FAILURE = 'FETCH_PROGRESS_TEST_FAILURE';
var SUBMIT_PROGRESS_TEST_RESULTS_REQUEST = exports.SUBMIT_PROGRESS_TEST_RESULTS_REQUEST = 'SUBMIT_PROGRESS_TEST_RESULTS_REQUEST';
var SUBMIT_PROGRESS_TEST_RESULTS_SUCCESS = exports.SUBMIT_PROGRESS_TEST_RESULTS_SUCCESS = 'SUBMIT_PROGRESS_TEST_RESULTS_SUCCESS';
var SUBMIT_PROGRESS_TEST_RESULTS_FAILURE = exports.SUBMIT_PROGRESS_TEST_RESULTS_FAILURE = 'SUBMIT_PROGRESS_TEST_RESULTS_FAILURE';

var RETAKE_PROGRESS_TEST_REQUEST = exports.RETAKE_PROGRESS_TEST_REQUEST = 'RETAKE_PROGRESS_TEST_REQUEST';
var RETAKE_PROGRESS_TEST_SUCCESS = exports.RETAKE_PROGRESS_TEST_SUCCESS = 'RETAKE_PROGRESS_TEST_SUCCESS';
var RETAKE_PROGRESS_TEST_FAILURE = exports.RETAKE_PROGRESS_TEST_FAILURE = 'RETAKE_PROGRESS_TEST_FAILURE';

function fetchProgressTest(groupId, _ref) {
  var name = _ref.name,
      id = _ref.id;

  var progressTestId = id;
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/progress-tests/' + progressTestId + '/content');
    var method = 'GET';

    return dispatch(fetchProgressTestRequest()).payload.then(function (response) {
      return dispatch(fetchProgressTestSuccess(response, name));
    }).catch(function (error) {
      return dispatch(fetchProgressTestFailure(error));
    });

    function fetchProgressTestRequest() {
      var content = (0, _Api.fetch)(url);
      var results = (0, _Api.fetch)((0, _Api.buildUrl)('/progress-tests/' + progressTestId + '/results'));
      var payload = Promise.all([content, results]).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            contentResp = _ref3[0],
            resultsResp = _ref3[1];

        return _extends({}, contentResp, resultsResp, {
          skills: contentResp.skills || resultsResp.skills
        });
      });
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_REQUEST,
        url: url,
        method: method,
        payload: payload,
        groupId: groupId,
        progressTestId: progressTestId
      });
    }

    function fetchProgressTestSuccess(content, progressTestName) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_SUCCESS,
        payload: content,
        url: url,
        method: method,
        groupId: groupId,
        progressTestId: progressTestId,
        name: progressTestName
      });
    }

    function fetchProgressTestFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId,
        progressTestId: progressTestId
      });
    }
  };
}

function getProgressReportId(state, groupId, progressTestId) {
  if (_is_js2.default.undefined(progressTestId)) return undefined; // prevent test from crash
  var progressTestsPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId).data;
  return progressTestsPlan.get(progressTestId).progressReportId;
}

function enabledExportPT(progressTest) {
  return progressTest && progressTest.startTime && progressTest.startTime > '2023-04-01';
}

function submitProgressTestResults(groupId, progressTestId, model, progressReportId, needToFetchStudentReport) {
  return function (dispatch, getState) {
    var url = (0, _Api.buildUrl)('/progress-tests/' + progressTestId + '/results');
    var method = 'PUT';
    return dispatch(submitProgressTestResultsRequest()).payload.then(function (response) {
      return dispatch(submitProgressTestResultsSuccess(response));
    }).catch(function (error) {
      return dispatch(submitProgressTestResultsFailure(error));
    }).then(function () {
      return dispatch(fetchProgressTest(groupId, { id: progressTestId }));
    }).then(function () {
      if (needToFetchStudentReport && progressReportId && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.View)) {
        dispatch(_StudentReportSummaries.actions.fetchStudentReportSummaries(progressReportId));
      }
    });

    function submitProgressTestResultsRequest() {
      var request = (0, _Api.fetch)(url, {
        method: method,
        body: JSON.stringify(model)
      });
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_PROGRESS_TEST_RESULTS_REQUEST,
        payload: request,
        url: url,
        method: method,
        groupId: groupId,
        progressTestId: progressTestId,
        model: model
      });
    }

    function submitProgressTestResultsSuccess() {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_PROGRESS_TEST_RESULTS_SUCCESS,
        url: url,
        method: method
      });
    }

    function submitProgressTestResultsFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_PROGRESS_TEST_RESULTS_FAILURE,
        url: url,
        method: method,
        error: error
      });
    }
  };
}

function retakeProgressTest(groupId, _ref4, progressReportId) {
  var progressTestId = _ref4.progressTestId,
      studentId = _ref4.studentId;

  return function (dispatch, getState) {
    var url = (0, _Api.buildUrl)('/progress-tests/' + progressTestId + '/retake/' + studentId);
    var method = 'GET';

    return dispatch(retakeProgressTestRequest()).payload.then(function (response) {
      return dispatch(retakeProgressTestSuccess(response, name));
    }).catch(function (error) {
      return dispatch(retakeProgressTestFailure(error));
    }).then(function () {
      return dispatch(fetchProgressTest(groupId, { id: progressTestId }));
    }).then(function () {
      if (progressReportId && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.View)) {
        dispatch(_StudentReportSummaries.actions.fetchStudentReportSummaries(progressReportId));
      }
    });

    function retakeProgressTestRequest() {
      var result = (0, _Api.fetch)(url);
      var payload = Promise.all([result]).then(function (responses) {
        return Object.assign.apply({}, responses);
      });
      return _omniCommonUi.ApiCall.createAction({
        type: RETAKE_PROGRESS_TEST_REQUEST,
        url: url,
        method: method,
        payload: payload,
        groupId: groupId,
        progressTestId: progressTestId,
        studentId: studentId
      });
    }

    function retakeProgressTestSuccess(content, progressTestName) {
      return _omniCommonUi.ApiCall.createAction({
        type: RETAKE_PROGRESS_TEST_SUCCESS,
        payload: content,
        url: url,
        method: method,
        groupId: groupId,
        progressTestId: progressTestId,
        name: progressTestName,
        studentId: studentId
      });
    }

    function retakeProgressTestFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: RETAKE_PROGRESS_TEST_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId,
        progressTestId: progressTestId,
        studentId: studentId
      });
    }
  };
}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaperBasedHomeworkResultRecord = (0, _immutable.Record)({
  completedAssignments: 0,
  totalAssignments: 0
});

var PaperBasedHomeworkResult = function (_PaperBasedHomeworkRe) {
  _inherits(PaperBasedHomeworkResult, _PaperBasedHomeworkRe);

  function PaperBasedHomeworkResult() {
    _classCallCheck(this, PaperBasedHomeworkResult);

    return _possibleConstructorReturn(this, (PaperBasedHomeworkResult.__proto__ || Object.getPrototypeOf(PaperBasedHomeworkResult)).apply(this, arguments));
  }

  return PaperBasedHomeworkResult;
}(PaperBasedHomeworkResultRecord);

exports.default = PaperBasedHomeworkResult;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnlineHomeworkResultRecord = (0, _immutable.Record)({
  averageScorePercentage: undefined,
  completedAssignments: undefined,
  totalAssignments: undefined
});

var OnlineHomeworkResult = function (_OnlineHomeworkResult) {
  _inherits(OnlineHomeworkResult, _OnlineHomeworkResult);

  function OnlineHomeworkResult() {
    _classCallCheck(this, OnlineHomeworkResult);

    return _possibleConstructorReturn(this, (OnlineHomeworkResult.__proto__ || Object.getPrototypeOf(OnlineHomeworkResult)).apply(this, arguments));
  }

  return OnlineHomeworkResult;
}(OnlineHomeworkResultRecord);

exports.default = OnlineHomeworkResult;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DosRejectedCommentRecord = (0, _immutable.Record)({
  rejectedBy: undefined,
  rejectedComment: undefined,
  rejectedDate: undefined
});

var DosRejectedComment = function (_DosRejectedCommentRe) {
  _inherits(DosRejectedComment, _DosRejectedCommentRe);

  function DosRejectedComment() {
    _classCallCheck(this, DosRejectedComment);

    return _possibleConstructorReturn(this, (DosRejectedComment.__proto__ || Object.getPrototypeOf(DosRejectedComment)).apply(this, arguments));
  }

  return DosRejectedComment;
}(DosRejectedCommentRecord);

exports.default = DosRejectedComment;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _Skills = __webpack_require__(1364);

var _Skills2 = _interopRequireDefault(_Skills);

var _Units = __webpack_require__(1374);

var _Units2 = _interopRequireDefault(_Units);

var _StudentProgressTestResults = __webpack_require__(1376);

var _StudentProgressTestResults2 = _interopRequireDefault(_StudentProgressTestResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressTestRecord = (0, _immutable.Record)({
  groupId: undefined,
  progressTestId: undefined,
  progressReportId: undefined,
  courseTypeLevelCode: undefined,
  name: undefined,
  progressTestSession: undefined,
  units: new _immutable.List(), // content map only
  skills: new _immutable.List(),
  studentProgressTestResults: new _immutable.OrderedMap() // key: studentId
});

var ProgressTest = function (_ProgressTestRecord) {
  _inherits(ProgressTest, _ProgressTestRecord);

  function ProgressTest() {
    _classCallCheck(this, ProgressTest);

    return _possibleConstructorReturn(this, (ProgressTest.__proto__ || Object.getPrototypeOf(ProgressTest)).apply(this, arguments));
  }

  return ProgressTest;
}(ProgressTestRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'groupId':
    case 'progressTestId':
    case 'progressReportId':
      return [key, '' + val]; // stringify
    case 'units':
      return [key, new _immutable.List(val.map(_Units2.default.create))];
    case 'skills':
      return [key, new _immutable.List(val.map(_Skills2.default.create))];
    case 'studentProgressTestResults':
      // if we've constructed this using an existing OrderedMap, keep it
      if (_immutable.OrderedMap.isOrderedMap(val)) return [key, val];
      // ordering of the StudentProgressTestResults might be important
      return [key, new _immutable.OrderedMap(val.map(function (item) {
        var studentProgressTestResults = _StudentProgressTestResults2.default.create(item);
        return [studentProgressTestResults.studentId, studentProgressTestResults];
      }))];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

ProgressTest.create = function (data) {
  return new ProgressTest(data).mapEntries(reviver);
};

ProgressTest.serialize = function (progressTest) {
  var serializedModel = progressTest.toObject();
  var studentProgressTestResults = serializedModel.studentProgressTestResults;

  if (!_StudentProgressTestResults2.default.isSerialized(studentProgressTestResults)) {
    serializedModel.studentProgressTestResults = _StudentProgressTestResults2.default.serialize(studentProgressTestResults);
  }
  return serializedModel;
};

exports.default = ProgressTest;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShowNavigationBar = getShowNavigationBar;
exports.getViewMode = getViewMode;
exports.getCICDisplayLanguage = getCICDisplayLanguage;
exports.toggleNavigation = toggleNavigation;
exports.toggleViewMode = toggleViewMode;
exports.setCICDisplayLanguage = setCICDisplayLanguage;
var TOGGLE_NAVIGATION = exports.TOGGLE_NAVIGATION = 'TOGGLE_NAVIGATION';
var TOGGLE_VIEW_MODE = exports.TOGGLE_VIEW_MODE = 'TOGGLE_VIEW_MODE';
var SET_CIC_DISPLAY_LANGUAGE = exports.SET_CIC_DISPLAY_LANGUAGE = 'SET_CIC_DISPLAY_LANGUAGE';

var SHOW_NAVIGATION_BAR = exports.SHOW_NAVIGATION_BAR = 'showNavigationBar';
var VIEW_MODE = exports.VIEW_MODE = 'viewMode';
var CIC_DISPLAY_LANGUAGE = exports.CIC_DISPLAY_LANGUAGE = 'cicDisplayLanguage';

function getShowNavigationBar(state) {
  return state.get('rootReducer').get('uiState').get(SHOW_NAVIGATION_BAR);
}

function getViewMode(state) {
  return state.get('rootReducer').get('uiState').get(VIEW_MODE);
}

function getCICDisplayLanguage(state) {
  return state.get('rootReducer').get('uiState').get(CIC_DISPLAY_LANGUAGE);
}

function toggleNavigation() {
  return {
    type: TOGGLE_NAVIGATION
  };
}

function toggleViewMode(viewMode) {
  return {
    type: TOGGLE_VIEW_MODE,
    viewMode: viewMode
  };
}

function setCICDisplayLanguage(languageCode) {
  return {
    type: SET_CIC_DISPLAY_LANGUAGE,
    languageCode: languageCode
  };
}

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1388);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkAttendanceCourseView = exports.NO_ACTIVE_MARKING_POPUP_TOKEN = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1390);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _SessionsAttendance = __webpack_require__(161);

var SessionsAttendance = _interopRequireWildcard(_SessionsAttendance);

var _GroupMembers = __webpack_require__(14);

var _AttendanceCell = __webpack_require__(1392);

var _AttendanceCell2 = _interopRequireDefault(_AttendanceCell);

var _actions = __webpack_require__(159);

var _ = __webpack_require__(13);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _FinancialClosingMoment = __webpack_require__(279);

var _FinancialClosingMoment2 = _interopRequireDefault(_FinancialClosingMoment);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _Exporter = __webpack_require__(50);

var _Exporter2 = _interopRequireDefault(_Exporter);

var _Api = __webpack_require__(11);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _status = __webpack_require__(83);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MARKING = "edit";
var EXPORT = "export";
var EXPORT_MIME_TYPE = "application/vnd.ms-excel";
var NO_ACTIVE_MARKING_POPUP_TOKEN = exports.NO_ACTIVE_MARKING_POPUP_TOKEN = -1;

var MarkAttendanceCourseView = exports.MarkAttendanceCourseView = function (_PureComponent) {
  _inherits(MarkAttendanceCourseView, _PureComponent);

  function MarkAttendanceCourseView(props) {
    _classCallCheck(this, MarkAttendanceCourseView);

    var _this = _possibleConstructorReturn(this, (MarkAttendanceCourseView.__proto__ || Object.getPrototypeOf(MarkAttendanceCourseView)).call(this, props));

    _this._cellOptions = _this._cellOptions.bind(_this);
    _this._renderCell = _this._renderCell.bind(_this);
    _this.state = {
      activeMarkingButtonsToken: NO_ACTIVE_MARKING_POPUP_TOKEN
    };
    return _this;
  }

  _createClass(MarkAttendanceCourseView, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this._fetchAttendance(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      this._fetchAttendance(newProps);
      if (newProps.params && newProps.params.mode !== MARKING) {
        this.setState({
          activeMarkingButtonsToken: NO_ACTIVE_MARKING_POPUP_TOKEN
        });
      }
    }
  }, {
    key: "_fetchAttendance",
    value: function _fetchAttendance(props) {
      var fetchGroupAttendanceIfNeeded = props.fetchGroupAttendanceIfNeeded;

      fetchGroupAttendanceIfNeeded(this.props.params.groupId);
    }
  }, {
    key: "_handleShowCellMarkingButtons",
    value: function _handleShowCellMarkingButtons(activeMarkingButtonsToken) {
      this.setState({
        activeMarkingButtonsToken: activeMarkingButtonsToken
      });
    }
  }, {
    key: "_handleAttendanceSaved",
    value: function _handleAttendanceSaved() {
      this.props.fetchGroupMembers(this.props.params.groupId);
    }
  }, {
    key: "_handleCloseCellMarkingButtons",
    value: function _handleCloseCellMarkingButtons() {
      this.setState({
        activeMarkingButtonsToken: NO_ACTIVE_MARKING_POPUP_TOKEN
      });
    }
  }, {
    key: "_gaChangeAttendance",
    value: function _gaChangeAttendance(studentId, currentStatus, nextStatus) {
      _reactGa2.default.event({
        category: "Attendance",
        action: "Changed attendance",
        label: "Changed attendance from " + currentStatus + " to " + nextStatus
      });
    }
  }, {
    key: "_changeStudentAttendanceStatus",
    value: function _changeStudentAttendanceStatus(member, attendance, newStatus) {
      var _this2 = this;

      this._gaChangeAttendance(member.studentGeneralInfo.id, attendance.attendanceStatus, newStatus);
      var submitSessionAttendance = this.props.submitSessionAttendance;

      var modifiedAttendance = void 0;
      if (attendance.attendanceStatus !== newStatus) {
        modifiedAttendance = attendance.set("attendanceStatus", _status.AttendanceStatus[newStatus]);
        var modifiedAttendanceList = new _immutable.List([modifiedAttendance]);
        if (_is_js2.default.function(submitSessionAttendance)) {
          submitSessionAttendance(attendance.id, modifiedAttendanceList).then(function () {
            return _this2._handleAttendanceSaved();
          });
        }
      }
      this.setState({
        isShowingMarkingButtons: false,
        modifiedAttendance: modifiedAttendance
      });
    }
  }, {
    key: "_cellOptions",
    value: function _cellOptions(member, _ref) {
      var _this3 = this;

      var plan = _ref.plan,
          attendance = _ref.attendance;

      var isMarkable = this.props.ignoreFinancialClosing || (0, _omniCommonUi.moment)().isBefore(_FinancialClosingMoment2.default.nextFrom(plan.period.start));
      if (!isMarkable || !MarkAttendanceCourseView.isInMarkingRoute(this.props) || !attendance) {
        return;
      }

      var studentAttendance = attendance.find(function (att) {
        return att.studentGeneralInfo.id === member.studentGeneralInfo.id;
      });
      if (!studentAttendance) {
        return; // Fix for OMO-1280: No student attendance -> not markable
      }

      return Object.assign({
        present: {
          label: "Present",
          onClick: function onClick() {
            return _this3._changeStudentAttendanceStatus(member, studentAttendance, _status.AttendanceStatus.present);
          }
        },
        absent: {
          label: "Absent",
          onClick: function onClick() {
            return _this3._changeStudentAttendanceStatus(member, studentAttendance, _status.AttendanceStatus.absent);
          }
        },
        late: {
          label: "Late",
          onClick: function onClick() {
            return _this3._changeStudentAttendanceStatus(member, studentAttendance, _status.AttendanceStatus.late);
          }
        }
      }, this.props.canSeeNotApplicable && {
        notApplicable: {
          label: "Not Applicable",
          onClick: function onClick() {
            return _this3._changeStudentAttendanceStatus(member, studentAttendance, _status.AttendanceStatus.notapplicable);
          }
        }
      });
    }
  }, {
    key: "_renderCell",
    value: function _renderCell(member, _ref2) {
      var cellAttendance = _ref2.attendance,
          plan = _ref2.plan;

      var studentAttendance = cellAttendance && cellAttendance.find(function (att) {
        return att.studentGeneralInfo.id === member.studentGeneralInfo.id;
      });
      var attendanceStatus = studentAttendance && studentAttendance.attendanceStatus;
      return _react2.default.createElement(_AttendanceCell2.default, {
        attendanceStatus: attendanceStatus,
        isFutureSession: plan.isFuture(),
        key: member.studentGeneralInfo.id + "-" + plan.id
      });
    }
  }, {
    key: "_handleExport",
    value: function _handleExport() {
      if (!MarkAttendanceCourseView.isInExportRoute(this.props)) return;
      var _props = this.props,
          replace = _props.replace,
          buildRoute = _props.buildRoute,
          params = _props.params,
          groupCode = _props.groupCode;

      var url = (0, _Api.buildUrl)("/groups/" + params.groupId + "/attendances/export");
      var exportDate = (0, _omniCommonUi.moment)().format("YYYY-MM-DD");
      var fileName = groupCode + "_attendance_" + exportDate + ".xls";

      _Exporter2.default.get(url, fileName, null, EXPORT_MIME_TYPE);
      replace(buildRoute({ mode: "" }));
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          members = _props2.members,
          sessionPlans = _props2.sessionPlans,
          attendance = _props2.attendance,
          timeZone = _props2.timeZone;

      if (!_immutable.List.isList(members) || !_immutable.List.isList(sessionPlans) || !timeZone) {
        return null;
      }

      var defaultSession = (0, _actions.calculateDefaultSession)(sessionPlans);
      var defaultSessionIndex = sessionPlans.findIndex(function (plan) {
        return plan.id === defaultSession.id;
      });

      this._handleExport();

      return _react2.default.createElement(
        "div",
        { className: _style2.default.MarkAttendanceCourseView },
        _react2.default.createElement(
          _CourseViewTable2.default,
          {
            students: members,
            highlightedColumns: [defaultSessionIndex],
            showAch: true
          },
          _react2.default.createElement(
            _CourseViewTable2.default.Header,
            null,
            _react2.default.createElement(
              _CourseViewTable2.default.Row,
              null,
              sessionPlans.map(function (plan, index) {
                var columnId = {
                  plan: plan,
                  index: index,
                  attendance: attendance.find(function (att, id) {
                    return id === plan.attendanceId;
                  })
                };
                return _react2.default.createElement(
                  _CourseViewTable2.default.Cell,
                  { columnId: columnId, small: true, key: plan.id },
                  index + 1
                );
              })
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Row,
              null,
              sessionPlans.map(function (plan) {
                var date = _omniCommonUi.moment.parseZone(plan.period.start).clone().tz(timeZone);
                return _react2.default.createElement(
                  _CourseViewTable2.default.Cell,
                  { key: plan.id },
                  _react2.default.createElement(
                    "time",
                    { dateTime: date.format("YYYY-MM-DD") },
                    date.format("ddd"),
                    _react2.default.createElement("br", null),
                    date.format("D"),
                    "\xA0",
                    date.format("MMM")
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            _CourseViewTable2.default.Body,
            { cellOptions: this._cellOptions },
            this._renderCell
          )
        )
      );
    }
  }]);

  return MarkAttendanceCourseView;
}(_react.PureComponent);

MarkAttendanceCourseView.isInMarkingRoute = function (props) {
  return props.params && props.params.mode === MARKING;
};
MarkAttendanceCourseView.isInExportRoute = function (props) {
  return props.params && props.params.mode === EXPORT;
};

MarkAttendanceCourseView.propTypes = {
  timeZone: _propTypes2.default.string.isRequired,
  groupCode: _propTypes2.default.string.isRequired,
  members: _propTypes2.default.shape().isRequired,
  sessionPlans: _propTypes2.default.shape().isRequired,
  attendance: _propTypes2.default.shape().isRequired,
  params: _propTypes2.default.shape().isRequired,
  fetchGroupMembers: _propTypes2.default.func,
  ignoreFinancialClosing: _propTypes2.default.bool.isRequired,
  canSeeNotApplicable: _propTypes2.default.bool.isRequired,
  fetchGroupAttendanceIfNeeded: _propTypes2.default.func.isRequired,
  submitSessionAttendance: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  replace: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var group = state.get("rootReducer").get("groups").get(groupId);
  var sessionPlans = new _immutable.List(group.data.sessionPlans.data).map(function (id) {
    return state.get("rootReducer").get("sessionPlans").get(id);
  });

  return {
    timeZone: _.actions.getCentre(state, groupId).timeZone,
    members: _GroupMembers.actions.getMembersByGroup(state, groupId),
    groupCode: group.data.number,
    sessionPlans: sessionPlans,
    attendance: state.get("rootReducer").get("sessionsAttendance").filter(function (attendance, id) {
      return sessionPlans.find(function (session) {
        return session && "" + session.attendanceId === "" + id;
      });
    }).map(function (attendance) {
      return attendance && attendance.data;
    }).filter(function (attendance) {
      return !!attendance;
    }),
    ignoreFinancialClosing: _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.MarkAttendance.IgnoreFinanceDate),
    canSeeNotApplicable: _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.MarkAttendance.MarkNotApplicable)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign((0, _redux.bindActionCreators)(SessionsAttendance.actions, dispatch), (0, _redux.bindActionCreators)(_GroupMembers.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(MarkAttendanceCourseView);

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Panel = function Panel() {
  return null;
};

Panel.propTypes = {
  className: _propTypes2.default.string
};

exports.default = Panel;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(163);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_PureComponent) {
  _inherits(Header, _PureComponent);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { header: true };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'thead',
        { className: _style2.default.SimpleTable_header },
        this.props.children
      );
    }
  }]);

  return Header;
}(_react.PureComponent);

Header.propTypes = {
  children: _propTypes2.default.node
};

Header.childContextTypes = {
  header: _propTypes2.default.bool
};

exports.default = Header;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(100);

var Body = function Body() {
  return null;
};

exports.default = (0, _recompose.pure)(Body);

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(163);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _recompose = __webpack_require__(100);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Row = function Row(_ref) {
  var stripe = _ref.stripe,
      children = _ref.children,
      className = _ref.className;
  return _react2.default.createElement(
    'tr',
    { className: (0, _classnames3.default)(_style2.default.SimpleTable_row, (0, _omniCommonUi.testClass)('table-row'), className, _defineProperty({}, _style2.default.__stripe, !!stripe)) },
    children
  );
};

Row.propTypes = {
  stripe: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  className: _propTypes2.default.node
};

exports.default = (0, _recompose.pure)(Row);

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(163);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _recompose = __webpack_require__(100);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Cell = function Cell(props, _ref) {
  var _classnames;

  var header = _ref.header;
  var children = props.children,
      colSpan = props.colSpan,
      rowSpan = props.rowSpan,
      small = props.small,
      highlighted = props.highlighted,
      relativePosition = props.relativePosition,
      className = props.className,
      style = props.style,
      onlyRowDivider = props.onlyRowDivider;


  var highlightedClass = (0, _classnames3.default)(_style2.default.__highlighted, (0, _omniCommonUi.testClass)('highlighted'));
  var classes = (0, _classnames3.default)(_style2.default.SimpleTable_cell, (0, _omniCommonUi.testClass)('table-cell'), className, (_classnames = {}, _defineProperty(_classnames, _style2.default.__small, small), _defineProperty(_classnames, highlightedClass, highlighted), _defineProperty(_classnames, _style2.default.__relative, relativePosition), _defineProperty(_classnames, _style2.default.__onlyRowDivider, onlyRowDivider), _classnames));
  if (header === true) {
    return _react2.default.createElement(
      'th',
      { colSpan: colSpan,
        rowSpan: rowSpan,
        className: classes,
        style: style },
      children
    );
  }

  return _react2.default.createElement(
    'td',
    { colSpan: colSpan, rowSpan: rowSpan, className: classes, style: style },
    children
  );
};

Cell.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  colSpan: _propTypes2.default.number,
  rowSpan: _propTypes2.default.number,
  small: _propTypes2.default.bool,
  highlighted: _propTypes2.default.bool,
  onlyRowDivider: _propTypes2.default.bool,
  relativePosition: _propTypes2.default.bool,
  style: _propTypes2.default.shape()
};

Cell.contextTypes = {
  header: _propTypes2.default.bool
};

exports.default = (0, _recompose.pure)(Cell);

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(100);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Body = function Body() {
  return null;
};

Body.propTypes = {
  children: _propTypes2.default.node,
  cellOptions: _propTypes2.default.func
};

exports.default = (0, _recompose.pure)(Body);

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressTest = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1418);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _ProgressTests = __webpack_require__(40);

var _ProgressReports = __webpack_require__(94);

var _ProgressTestsPlan = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressTest = exports.ProgressTest = function (_Component) {
  _inherits(ProgressTest, _Component);

  function ProgressTest() {
    _classCallCheck(this, ProgressTest);

    return _possibleConstructorReturn(this, (ProgressTest.__proto__ || Object.getPrototypeOf(ProgressTest)).apply(this, arguments));
  }

  _createClass(ProgressTest, [{
    key: 'componentWillMount',

    // triggered on first load
    value: function componentWillMount() {
      this._loadIfNeed(this.props);
      this._fetchProgressTestModels(this.props);
      this._redirectToCourseView(this.props);
      this._checkIsMarkableInMarkMode(this.props);
      this._checkIsCanBeOverwriteInMarkMode(this.props);
    }

    // triggered on PT navigation

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._loadIfNeed(nextProps);
      this._fetchProgressTestModels(nextProps);
      this._redirectToCourseView(nextProps);
      this._checkIsMarkableInMarkMode(nextProps);
      this._checkIsCanBeOverwriteInMarkMode(nextProps);
    }
  }, {
    key: '_loadIfNeed',
    value: function _loadIfNeed(props) {
      var groupId = props.params.groupId;

      props.fetchProgressTestPlanIfNeeded(groupId);
    }
  }, {
    key: '_redirectToCourseView',
    value: function _redirectToCourseView(props) {
      var groupId = props.groupId,
          currentProgressTestIndex = props.currentProgressTestIndex,
          buildRoute = props.buildRoute,
          replace = props.replace;

      if (!(currentProgressTestIndex >= 0)) return;
      if (props.location.pathname.endsWith('progress-test')) {
        replace(buildRoute('/group/' + groupId + ('/progress-test/' + currentProgressTestIndex + '/course')));
      }
    }
  }, {
    key: '_fetchProgressTestModels',
    value: function _fetchProgressTestModels() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var progressTest = props.progressTest,
          progressReports = props.progressReports,
          currentProgressTestPlan = props.currentProgressTestPlan;

      if (!currentProgressTestPlan) return;
      var groupId = props.params.groupId;

      if (_omniCommonUi.ApiResponseHelper.shouldFetch(progressTest)) {
        props.fetchProgressTest(groupId, currentProgressTestPlan);
      }
      if (_omniCommonUi.ApiResponseHelper.shouldFetch(progressReports)) {
        props.fetchProgressReport(groupId);
      }
    }
  }, {
    key: '_checkIsMarkableInMarkMode',
    value: function _checkIsMarkableInMarkMode(props) {
      var markable = props.markable,
          params = props.params,
          buildRoute = props.buildRoute,
          replace = props.replace;


      if (_is_js2.default.boolean(markable) && !markable && params.mode === 'edit') {
        _omniCommonUi.log.warn('ProgressTest: not a markable test; leaving edit mode');
        return replace(buildRoute({ mode: '' }));
      }
    }
  }, {
    key: '_checkIsCanBeOverwriteInMarkMode',
    value: function _checkIsCanBeOverwriteInMarkMode(props) {
      var progressTest = props.progressTest,
          params = props.params,
          buildRoute = props.buildRoute,
          replace = props.replace;
      var studentId = params.studentId;

      if (!_omniCommonUi.ApiResponseHelper.hasSucceeded(progressTest) || !studentId) return;

      var _progressTest$data$st = progressTest.data.studentProgressTestResults.get(studentId),
          canBeOverwrite = _progressTest$data$st.canBeOverwrite;

      if (_is_js2.default.boolean(canBeOverwrite) && !canBeOverwrite && params.mode === 'edit') {
        _omniCommonUi.log.warn('ProgressTest: not an overwritable skill; leaving edit mode');
        return replace(buildRoute({ mode: '' }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          progressTestPlan = _props.progressTestPlan,
          progressTest = _props.progressTest;

      if (!progressTestPlan || !progressTest) return null;
      return _react2.default.createElement(
        'div',
        { className: _style2.default.ProgressTest },
        _react2.default.createElement(
          'div',
          { className: _style2.default.ProgressTest_content },
          this.props.children
        )
      );
    }
  }]);

  return ProgressTest;
}(_react.Component);

ProgressTest.getCurrentRouteSegment = function (props) {
  return props.routes[props.routes.length - 1];
};

ProgressTest.propTypes = {
  children: _propTypes2.default.node,
  progressTest: _propTypes2.default.object,
  progressReports: _propTypes2.default.object,
  progressTestPlan: _propTypes2.default.object.isRequired,
  params: _propTypes2.default.object.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  routes: _propTypes2.default.array.isRequired,
  location: _propTypes2.default.object.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  replace: _propTypes2.default.func.isRequired,
  markable: _propTypes2.default.bool.isRequired
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      progressTestIndex = _ownProps$params.progressTestIndex;

  var group = state.get('rootReducer').get('groups').get(groupId);
  var progressTestPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId); // string groupId
  var unitQuizPlans = progressTestPlan && progressTestPlan.data && progressTestPlan.data.filter(function (ptp) {
    return ptp.isUnitQuiz === true;
  });
  if (!progressTestPlan || !unitQuizPlans) {
    return;
  }
  var defaultProgressTestIndex = (0, _ProgressTestsPlan.getDefaultProgressTestIndex)(state, groupId, true);
  var currentProgressTestIndex = progressTestIndex || defaultProgressTestIndex;
  var currentProgressTestPlan = unitQuizPlans.toList().sortBy(function (progressTest) {
    return progressTest.index;
  }).get(currentProgressTestIndex);
  var currentProgressTestId = currentProgressTestPlan.id;
  var progressTest = state.get('rootReducer').get('progressTests').get(currentProgressTestId);

  return {
    groupId: groupId,
    progressTestPlan: progressTestPlan,
    currentProgressTestPlan: currentProgressTestPlan,
    progressTest: progressTest,
    currentProgressTestIndex: currentProgressTestIndex,
    progressReports: group && group.data.progressReports,
    markable: (0, _ProgressTestsPlan.isMarkable)(state, groupId, currentProgressTestIndex, true)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_ProgressTests.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressReports.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTestsPlan.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(ProgressTest);

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = progressReportsReducer;
exports.updateGroupProgressReportsAttribute = updateGroupProgressReportsAttribute;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(292);

var _model = __webpack_require__(640);

var _model2 = _interopRequireDefault(_model);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function progressReportsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_PROGRESS_REPORTS_REQUEST:
      return state;
    case _actions.FETCH_PROGRESS_REPORTS_SUCCESS:
      return onSuccess(state, action);
    case _actions.FETCH_PROGRESS_REPORTS_FAILURE:
    default:
      return state;
  }
}

function onSuccess(state, action) {
  var newState = state;
  action.payload.forEach(function (progressReport, index) {
    var progressReportModel = _model2.default.create(Object.assign(progressReport, { index: index }));
    newState = newState.set(progressReportModel.id, progressReportModel);
  });

  return newState;
}

function updateGroupProgressReportsAttribute(progressReports, action) {
  switch (action.type) {
    case _actions.FETCH_PROGRESS_REPORTS_REQUEST:
      return _omniCommonUi.ApiResponseHelper.create({ loading: true });
    case _actions.FETCH_PROGRESS_REPORTS_SUCCESS:
      return _omniCommonUi.ApiResponseHelper.create(onSuccess(new _immutable.Map(), action));
    case _actions.FETCH_PROGRESS_REPORTS_FAILURE:
      return _omniCommonUi.ApiResponseHelper.create(action.error);
    default:
      return progressReports;
  }
}

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressReportRecord = (0, _immutable.Record)({
  id: undefined,
  name: undefined,
  progressTestId: undefined,
  units: undefined,
  studentReportSummaries: _omniCommonUi.ApiResponseHelper.create(),
  index: undefined
});

var ProgressReport = function (_ProgressReportRecord) {
  _inherits(ProgressReport, _ProgressReportRecord);

  function ProgressReport() {
    _classCallCheck(this, ProgressReport);

    return _possibleConstructorReturn(this, (ProgressReport.__proto__ || Object.getPrototypeOf(ProgressReport)).apply(this, arguments));
  }

  return ProgressReport;
}(ProgressReportRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'id':
    case 'progressTestId':
      return [key, '' + val]; // stringify
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

ProgressReport.create = function (data) {
  return new ProgressReport(data).mapEntries(reviver);
};

exports.default = ProgressReport;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(642);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1428);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressTestCourseView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1422);

var _style2 = _interopRequireDefault(_style);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _reactRouter = __webpack_require__(16);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _classnames3 = __webpack_require__(7);

var _classnames4 = _interopRequireDefault(_classnames3);

var _immutable = __webpack_require__(3);

var _ = __webpack_require__(13);

var _accessors = __webpack_require__(52);

var _Api = __webpack_require__(11);

var _Exporter = __webpack_require__(50);

var _omniCommonUi = __webpack_require__(0);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _SessionsAttendance = __webpack_require__(161);

var SessionsAttendance = _interopRequireWildcard(_SessionsAttendance);

var _ProgressReports = __webpack_require__(94);

var _ProgressTests = __webpack_require__(40);

var _GroupMembers = __webpack_require__(14);

var _ViewLink = __webpack_require__(643);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _NewNotePopup = __webpack_require__(288);

var _NewNotePopup2 = _interopRequireDefault(_NewNotePopup);

var _QuickSummary = __webpack_require__(162);

var _QuickSummary2 = _interopRequireDefault(_QuickSummary);

var _Note = __webpack_require__(131);

var _EditableScoreCell = __webpack_require__(1425);

var _EditableScoreCell2 = _interopRequireDefault(_EditableScoreCell);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MARKING = "edit";
var EMPTY_HYPHEN = "-";
var AssessmentReportInstruction = "Assessment Report will be automatically published after all scores are saved/synced from EF Small Stars PT";

var ONLINE_SKILLS = ["grammar", "vocabulary", "listening", "reading"];

var ProgressTestCourseView = exports.ProgressTestCourseView = function (_UnsavedChangesTracki) {
  _inherits(ProgressTestCourseView, _UnsavedChangesTracki);

  function ProgressTestCourseView(props) {
    _classCallCheck(this, ProgressTestCourseView);

    var _this = _possibleConstructorReturn(this, (ProgressTestCourseView.__proto__ || Object.getPrototypeOf(ProgressTestCourseView)).call(this, props));

    _this._renderAddNoteDialog = _this._renderAddNoteDialog.bind(_this);
    _this._onAddNoteClicked = _this._onAddNoteClicked.bind(_this);
    _this._onCancelNoteClicked = _this._onCancelNoteClicked.bind(_this);
    _this._onSaveNoteClicked = _this._onSaveNoteClicked.bind(_this);

    _this.state = {
      // these are set in this._forcePushRoute() and observed in routerWillLeave()
      allowRouteLeave: false,
      isRouterLeaveConfirmed: false,
      studentProgressTestResult: new _immutable.Map(), // filled in _buildViewState()
      studentChanged: [], // todo: make this a set
      dialogOpen: false,
      retakePTConfirmDialog: false,
      showExportWarningDialog: false,
      isExportErrorOccurred: false,
      isExportInProgress: false,
      isExpandRemainingMember: true,
      isExpandMembersInScoreInfo: false
    };

    // for memoization of _onIndividualScoreEdited calls
    _this._onIndividualScoreEditedCache = {};
    return _this;
  }

  _createClass(ProgressTestCourseView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._buildViewState(this.props);
      this._fetchProgressTestModels();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.params.mode !== this.props.params.mode) {
        window.getSelection().removeAllRanges();
      }
      if (nextProps.progressTest && nextProps.progressTest.data) {
        this.props.fetchProgressTestViewLinkIfNeeded(nextProps.progressTest.data.progressTestId);
      }

      // TODO: Revisit this hack
      // It prevents loss of changes on notification or nav expand/collapse
      if (this.props.location.pathname === nextProps.location.pathname && this.state.studentProgressTestResult.size && nextProps.progressTest === this.props.progressTest) {
        return;
      }

      this._fetchProgressTestModels(nextProps);
      this._buildViewState(nextProps);
    }
  }, {
    key: "routerWillLeave",
    value: function routerWillLeave(nextLocation) {
      var that = this;
      var _state = this.state,
          studentProgressTestResult = _state.studentProgressTestResult,
          studentChanged = _state.studentChanged;

      var returnToView = function returnToView() {
        return that._forcePushRoute(that.props.buildRoute({ mode: "" }));
      };
      if (nextLocation && nextLocation.pathname.endsWith("/save")) {
        returnToView();
        setTimeout(function () {
          // /save sticks if we don't defer this
          if (studentChanged.length !== 0) {
            that._handleSave(studentProgressTestResult.filter(function (result) {
              return studentChanged.findIndex(function (studentId) {
                return studentId === result.studentId;
              }) !== -1;
            }));
          }
        }, 0);
      } else if (nextLocation && nextLocation.pathname.endsWith("/discard")) {
        returnToView();
      } else {
        // todo: this is a quick workaround; fix it later
        this.lastStateBeforeRouteChange = this.state.studentProgressTestResult;
        return _get(ProgressTestCourseView.prototype.__proto__ || Object.getPrototypeOf(ProgressTestCourseView.prototype), "routerWillLeave", this).call(this, nextLocation);
      }
    }
  }, {
    key: "_onAddNoteClicked",
    value: function _onAddNoteClicked(student) {
      this.setState({ dialogOpen: student });
    }
  }, {
    key: "_onCancelNoteClicked",
    value: function _onCancelNoteClicked() {
      this.setState({ dialogOpen: false });
    }
  }, {
    key: "_onSaveNoteClicked",
    value: function _onSaveNoteClicked(note) {
      var studentId = this.state.dialogOpen.studentGeneralInfo.id;
      this.props.submitStudentNote(studentId, {
        groupId: this.props.groupId,
        category: _Note.actions.STUDENT_NOTE_CATEGORY_PROGRESS_TEST,
        content: note,
        entityId: this.props.progressTestId
      });
      this.setState({ dialogOpen: false });
    }
  }, {
    key: "_buildViewState",
    value: function _buildViewState(props) {
      var extraState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!_omniCommonUi.ApiResponseHelper.hasSucceeded(props.progressTest)) {
        return;
      }
      this.setState(Object.assign({
        studentProgressTestResult: props.progressTest.data.studentProgressTestResults,
        studentChanged: [],
        wasAnEditMade: false
      }, extraState));
    }
  }, {
    key: "_wasAnAddReallyMade",
    value: function _wasAnAddReallyMade() {
      var _this2 = this;

      var getOriginalScore = function getOriginalScore(studentId, skillId) {
        return _this2.props.progressTest.data.studentProgressTestResults.get(studentId).skillResults.get(skillId).currentResult;
      };
      return this.state.studentProgressTestResult.some(function (studentProgressTestResult, studentId) {
        return studentProgressTestResult.skillResults.some(function (skillResult, skillId) {
          return _is_js2.default.number(skillResult.currentResult) && _is_js2.default.not.number(getOriginalScore(studentId, skillId));
        });
      });
    }
  }, {
    key: "_isChangesPresent",
    value: function _isChangesPresent() {
      // override
      return ProgressTestCourseView.isInMarkingRoute(this.props) && (this.state.wasAnEditMade || this._wasAnAddReallyMade()); // has local changes?
    }
  }, {
    key: "_handleSave",
    value: function _handleSave() {
      var studentProgressTestResults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.studentProgressTestResult;
      var _props = this.props,
          submitProgressTestResults = _props.submitProgressTestResults,
          currentProgressTestPlan = _props.currentProgressTestPlan,
          progressReportId = _props.progressReportId,
          params = _props.params,
          isUnitQuiz = _props.isUnitQuiz;

      var progressTest = _ProgressTests.ProgressTest.serialize(_ProgressTests.ProgressTest.create({
        studentProgressTestResults: studentProgressTestResults
      }));
      return submitProgressTestResults(params.groupId, currentProgressTestPlan.id, progressTest, progressReportId, isUnitQuiz);
    }
  }, {
    key: "_onRubricButtonClicked",
    value: function _onRubricButtonClicked(studentId, skillId) {
      var _props2 = this.props,
          pushRoute = _props2.pushRoute,
          buildRoute = _props2.buildRoute,
          progressTest = _props2.progressTest,
          currentProgressTestIndex = _props2.currentProgressTestIndex,
          groupId = _props2.params.groupId,
          isUnitQuiz = _props2.isUnitQuiz;

      var progressTestSkills = progressTest.data.skills;
      var skillIndex = progressTestSkills.findIndex(function (pt) {
        return pt.skillId === skillId;
      });
      pushRoute(buildRoute("/group/" + groupId + ("/" + (isUnitQuiz ? "progress-test" : "exam") + "/" + currentProgressTestIndex) + ("/student/" + studentId) + ("/skill/" + skillIndex)));
    }
  }, {
    key: "_onIndividualScoreEdited",
    value: function _onIndividualScoreEdited(studentId, skillId, fullMark, newScoreText) {
      // validation already happened in EditableScoreCell
      var originalScore = this.props.progressTest.data.studentProgressTestResults.get(studentId).skillResults.get(skillId).currentResult;
      var newScoreInt = Number.parseFloat(newScoreText);
      var newScoreNum = _is_js2.default.number(newScoreInt) ? newScoreInt : null;
      // change the state!
      var updatedStudentProgressTestResult = this.state.studentProgressTestResult.update(studentId, function (student) {
        return student.update("skillResults", function (skillResults) {
          return skillResults.update(skillId, function (skillResult) {
            return skillResult.set("currentResult", newScoreNum);
          });
        });
      });
      var newState = {
        studentProgressTestResult: updatedStudentProgressTestResult
      };
      // todo: use a set for this
      if (this.state.studentChanged.findIndex(function (ele) {
        return ele === studentId;
      }) === -1) {
        var studentChanged = this.state.studentChanged;
        studentChanged.push(studentId);
        newState.studentChanged = studentChanged;
      }
      // if the previous score was numeric then we'll flip `wasAnEditMade`
      if (_is_js2.default.number(originalScore)) {
        newState.wasAnEditMade = true;
      }
      this.setState(newState);
    }
  }, {
    key: "_getTotalAsPercentageOrHyphen",
    value: function _getTotalAsPercentageOrHyphen() {
      var resultsDescriptor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _resultsDescriptor$to = resultsDescriptor.totalScore,
          totalScore = _resultsDescriptor$to === undefined ? {} : _resultsDescriptor$to;

      if (!_is_js2.default.object(totalScore) || totalScore.isEmpty || totalScore.isNotApplicable) {
        return EMPTY_HYPHEN;
      }
      return totalScore.percentage;
    }
  }, {
    key: "_renderTotalsAsPercentages",
    value: function _renderTotalsAsPercentages(results) {
      var currentTotalPercentage = this._getTotalAsPercentageOrHyphen(results);
      return _react2.default.createElement(
        "div",
        {
          className: (0, _classnames4.default)(_style2.default.ProgressTestCourseView_scoreCell, (0, _omniCommonUi.testClass)("average-score"))
        },
        _react2.default.createElement(
          "div",
          { className: _style2.default.ProgressTestCourseView_scoreCell_currentScore },
          _is_js2.default.number(currentTotalPercentage) ? currentTotalPercentage + "%" : currentTotalPercentage
        )
      );
    }
  }, {
    key: "_exportAssessmentReport",
    value: function _exportAssessmentReport() {
      console.log("A_exportAssessmentReportss");
    }
  }, {
    key: "_gaLinkToReport",
    value: function _gaLinkToReport() {
      _reactGa2.default.event({
        category: "Progress Tests",
        action: "Clicked linked to progress report"
      });
    }
  }, {
    key: "_gaLinkToRetakePT",
    value: function _gaLinkToRetakePT() {
      _reactGa2.default.event({
        category: "Progress Tests",
        action: "Clicked button to retake PT"
      });
    }
  }, {
    key: "_renderScoresForSkill",
    value: function _renderScoresForSkill(result, progressTestSkill, studentId, canBeOverwrite) {
      var _this3 = this;

      var skillId = progressTestSkill.skillId;

      var isScoreEmpty = function isScoreEmpty(score) {
        return !_is_js2.default.number(score);
      };
      var renderScores = function renderScores(score, previousScore, fullMark) {
        var isEditableScore = ProgressTestCourseView.isInMarkingRoute(_this3.props) && !progressTestSkill.isRubric && canBeOverwrite;
        var editScoreCellClassName = progressTestSkill.isRubric ? "" : (0, _omniCommonUi.testClass)("non-rubric");
        if (!isEditableScore && isScoreEmpty(score)) {
          return _react2.default.createElement(
            "div",
            { className: _style2.default.ProgressTestCourseView_scoreCell },
            _react2.default.createElement(
              "div",
              {
                className: _style2.default.ProgressTestCourseView_scoreCell_currentScore
              },
              _this3.props.isHFV4 ? EMPTY_HYPHEN : "-/" + fullMark
            )
          );
        }
        if (!isEditableScore && _this3.props.isHFV4) {
          var percentage = Math.round(score / fullMark * 100);
          return _react2.default.createElement(
            "div",
            { className: _style2.default.ProgressTestCourseView_scoreCell },
            _react2.default.createElement(
              "div",
              {
                className: _style2.default.ProgressTestCourseView_scoreCell_currentScore
              },
              percentage + "%"
            )
          );
        }
        var onIndividualScoreEditedKey = studentId + "-" + skillId;
        var onIndividualScoreEdited = _this3._onIndividualScoreEditedCache[onIndividualScoreEditedKey] || (_this3._onIndividualScoreEditedCache[onIndividualScoreEditedKey] = _this3._onIndividualScoreEdited.bind(_this3, studentId, skillId, fullMark));
        return _react2.default.createElement(_EditableScoreCell2.default, {
          className: editScoreCellClassName,
          score: score,
          previousScore: previousScore,
          isEditableScore: isEditableScore,
          studentId: studentId,
          skillId: skillId,
          fullMark: fullMark,
          onChange: onIndividualScoreEdited
        });
      };
      var scoresReadout = renderScores(result.currentResult, result.previousResult, isScoreEmpty(result.fullMark) ? progressTestSkill.fullMark : result.fullMark);
      var rubricButtonClassNames = (0, _classnames4.default)(_style2.default.ProgressTestCourseView_scoreCell, _style2.default.__isRubric, (0, _omniCommonUi.testClass)("rubric-score"));
      if (progressTestSkill.isRubric) {
        return _react2.default.createElement(
          _omniCommonUi.Button,
          {
            className: rubricButtonClassNames,
            disabled: !this.props.isUnitQuiz && progressTestSkill.name === _accessors.shouldDisabledSkillName || !canBeOverwrite,
            onClick: function onClick() {
              return _this3._onRubricButtonClicked(studentId, result.skillId);
            },
            attrs: { tabIndex: "-1" }
          },
          scoresReadout,
          _react2.default.createElement(_omniCommonUi.Icon, {
            id: "arrow-right",
            className: _style2.default.ProgressTestCourseView_scoreCell_icon
          })
        );
      }
      return scoresReadout;
    }
  }, {
    key: "_renderScoresInfoForSkill",
    value: function _renderScoresInfoForSkill(skillResult) {
      if (!skillResult.isRubric && skillResult.currentResult) {
        var timeZone = this.props.timeZone;

        return _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "p",
            null,
            skillResult.markedBy ? "Marked by " + skillResult.markedBy : "Synced from PT App"
          ),
          _react2.default.createElement(
            "p",
            null,
            "On",
            " ",
            _omniCommonUi.moment.utc(skillResult.markedTime).clone().tz(timeZone).format("YYYY-MM-DD")
          )
        );
      }
      return _react2.default.createElement(
        "div",
        null,
        "-"
      );
    }
  }, {
    key: "_findProgressTestResultsForStudent",
    value: function _findProgressTestResultsForStudent(progressTestResults, studentId) {
      return progressTestResults.get(studentId);
    }
  }, {
    key: "_renderAssessmentReportInstruction",
    value: function _renderAssessmentReportInstruction() {
      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        {
          text: AssessmentReportInstruction,
          placement: "left",
          trigger: ["hover", "click", "focus"],
          className: _style2.default.ProgressTestCourseView_tooltip,
          overlayClassName: _style2.default.ProgressTestCourseView_tooltip_inner
        },
        _react2.default.createElement(_omniCommonUi.Icon, {
          id: "question",
          className: _style2.default.ProgressTestCourseView_tooltip_icon
        })
      );
    }
  }, {
    key: "_renderUnsavedChangesWarningDialog",
    value: function _renderUnsavedChangesWarningDialog() {
      var _this4 = this;

      var isSaving = false; // local to this method - it doesn't trigger a setState()
      return _react2.default.createElement(_UnsavedChangesWarning2.default, {
        isOpen: !!this._isNavigationWithChangesRequested()
        /* we need to check these two to get a full loading throbber experience */
        , isSaving: this.props.isAnyApiCallSaving || isSaving,
        onSaveClicked: function onSaveClicked() {
          isSaving = true;
          // todo: use of `lastStateBeforeRouteChange` is a workaround; make this better
          _this4._handleSave(_this4.lastStateBeforeRouteChange.filter(function (result) {
            return !!result.canBeOverwrite;
          })).then(function () {
            isSaving = false;
          });
          _this4._forcePushRequestedLocation();
        },
        onDiscardClicked: function onDiscardClicked() {
          _this4._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this4._clearRequestedLocation();
        }
      });
    }
  }, {
    key: "_fetchProgressTestModels",
    value: function _fetchProgressTestModels() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var progressTest = props.progressTest,
          progressReports = props.progressReports,
          currentProgressTestPlan = props.currentProgressTestPlan;

      if (!currentProgressTestPlan) return;
      var groupId = props.params.groupId;

      if (_omniCommonUi.ApiResponseHelper.shouldFetch(progressTest)) {
        props.fetchProgressTest(groupId, currentProgressTestPlan);
      }
      if (_omniCommonUi.ApiResponseHelper.shouldFetch(progressReports)) {
        props.fetchProgressReport(groupId);
      }
    }
  }, {
    key: "_renderCell",
    value: function _renderCell(member, column, isShowScoreInfo) {
      var progressTestResults = this._findProgressTestResultsForStudent(this.state.studentProgressTestResult, member.studentGeneralInfo.id);

      var skill = this.props.progressTest.data.skills.find(function (skillIt) {
        return skillIt.name === column;
      });

      if (_is_js2.default.undefined(progressTestResults)) {
        return null;
      }

      if (_is_js2.default.not.undefined(skill)) {
        var testResult = progressTestResults.skillResults.get(skill.skillId);
        if (isShowScoreInfo) {
          return this._renderScoresInfoForSkill(testResult);
        }
        return this._renderScoresForSkill(testResult, skill, member.studentGeneralInfo.id, progressTestResults.canBeOverwrite);
      }

      switch (column) {
        case "total":
          return this._renderTotalsAsPercentages(progressTestResults);
        case "export-pdf":
          return _react2.default.createElement(
            "div",
            { className: (0, _omniCommonUi.testClass)("report-link-cell") },
            this._renderExportLink(member, progressTestResults)
          );
        case "unit-report":
          return _react2.default.createElement(
            "div",
            { className: (0, _omniCommonUi.testClass)("report-link-cell") },
            this._renderReportLink(member)
          );
        case "retake":
          return _react2.default.createElement(
            "div",
            { className: (0, _omniCommonUi.testClass)("report-link-cell") },
            this._renderRetakeLink(member)
          );
        case "study-report":
          return _react2.default.createElement(
            "div",
            { className: (0, _omniCommonUi.testClass)("report-link-cell") },
            this._renderStudyReport(member)
          );
        default:
          throw new Error("Invalid column " + column);
      }
    }
  }, {
    key: "_renderAssessmentReportButton",
    value: function _renderAssessmentReportButton() {
      var _this5 = this;

      return _react2.default.createElement(
        _reactRouter.Link,
        { onClick: function onClick() {
            return _this5._exportAssessmentReport();
          } },
        _react2.default.createElement(_omniCommonUi.Icon, { id: "export" })
      );
    }
  }, {
    key: "_renderExportLink",
    value: function _renderExportLink(member, results) {
      var _this6 = this;

      var isOnlineCompleted = ONLINE_SKILLS.map(function (os) {
        var skill = _this6.props.progressTest.data.skills.find(function (s) {
          return os.toUpperCase() === s.name.toUpperCase();
        });
        return _is_js2.default.not.undefined(skill) ? skill.skillId : "-1";
      }).every(function (id) {
        var testResult = results.skillResults.get(id);
        return testResult && !testResult.markedBy && testResult.currentResult;
      });
      var className = (0, _classnames4.default)(_style2.default.GeneralLink, _defineProperty({}, _style2.default.__disabled, !isOnlineCompleted || this.state.isExportInProgress));
      return _react2.default.createElement(
        _reactRouter.Link,
        {
          className: className,
          draggable: false,
          onClick: function onClick() {
            return _this6._onExportLinkClicked(member, results, isOnlineCompleted);
          },
          tabIndex: "-1"
        },
        "Export"
      );
    }
  }, {
    key: "_onExportLinkClicked",
    value: function _onExportLinkClicked(member, results, isOnlineCompleted) {
      var _this7 = this;

      if (isOnlineCompleted) {
        this.setState({ isExportInProgress: true });
        (0, _Api.fetch)((0, _Api.buildUrl)("/progress-tests/" + this.props.progressTestId + "/students/" + member.studentGeneralInfo.id + "/pdf")).then(function (response) {
          _Exporter.exporter.get(response.url, response.name, false, "application/pdf").then(function () {
            _this7.setState({ isExportInProgress: false });
          }).catch(function () {
            _this7.setState({ isExportErrorOccurred: true });
            _this7.setState({ isExportInProgress: false });
          });
        }).catch(function () {
          _this7.setState({ isExportErrorOccurred: true });
          _this7.setState({ isExportInProgress: false });
        });
      } else {
        this.setState({ showExportWarningDialog: true });
      }
    }
  }, {
    key: "_renderExportWarningDialog",
    value: function _renderExportWarningDialog() {
      var _this8 = this;

      if (this.state.showExportWarningDialog) {
        return _react2.default.createElement(_omniCommonUi.AlertDialog, {
          isWarning: true,
          content2: "The quiz is not completed yet.",
          okButtonContent: "OK",
          onButtonClick: function onButtonClick() {
            _this8._onExportWarningClick();
          }
        });
      }
    }
  }, {
    key: "_renderExportGeneralErrorDialog",
    value: function _renderExportGeneralErrorDialog() {
      var _this9 = this;

      if (this.state.isExportErrorOccurred) {
        return _react2.default.createElement(_omniCommonUi.ErrorDialog, {
          isOpen: true,
          onConfirmClick: function onConfirmClick() {
            _this9._onEndExportWarningOrError();
          }
        });
      }
    }
  }, {
    key: "_onEndExportWarningOrError",
    value: function _onEndExportWarningOrError() {
      this.setState({ isExportErrorOccurred: false });
    }
  }, {
    key: "_onExportWarningClick",
    value: function _onExportWarningClick() {
      this.setState({ showExportWarningDialog: false });
    }
  }, {
    key: "_renderExportLoading",
    value: function _renderExportLoading() {
      if (this.state.isExportInProgress) {
        return _react2.default.createElement(_omniCommonUi.PageLoadingSpinner, { isHidden: !this.state.isExportInProgress });
      }
    }
  }, {
    key: "_hasOnlineSkillScore",
    value: function _hasOnlineSkillScore(results) {
      var onlineSkills = this.props.progressTest.data.skills.filter(function (skill) {
        return !skill.isRubric;
      });
      if (onlineSkills.length === 0) return false;
      return onlineSkills.some(function (skill) {
        var testResult = results.skillResults.get(skill.skillId);
        return testResult && _is_js2.default.number(testResult.currentResult);
      });
    }
  }, {
    key: "_renderRetakeLink",
    value: function _renderRetakeLink(member) {
      var _this10 = this;

      var results = this._findProgressTestResultsForStudent(this.state.studentProgressTestResult, member.studentGeneralInfo.id);

      var canRetake = _is_js2.default.not.undefined(results) && this._hasOnlineSkillScore(results);
      var className = (0, _classnames4.default)(_style2.default.ProgressReportLink, _defineProperty({}, _style2.default.ProgressReportLink_disabled, !canRetake));

      return _react2.default.createElement(
        _reactRouter.Link,
        {
          className: className,
          draggable: false,
          onClick: canRetake ? function () {
            return _this10._onRetakeLinkClicked(member);
          } : undefined,
          tabIndex: "-1"
        },
        "Retake Unit Quiz"
      );
    }
  }, {
    key: "_onRetakeLinkClicked",
    value: function _onRetakeLinkClicked(student) {
      this.setState({ retakePTConfirmDialog: student });
    }
  }, {
    key: "_onCancelRetakeClicked",
    value: function _onCancelRetakeClicked() {
      this.setState({ retakePTConfirmDialog: false });
    }
  }, {
    key: "_onOKRetakeClicked",
    value: function _onOKRetakeClicked() {
      this._gaLinkToRetakePT();
      var studentId = this.state.retakePTConfirmDialog.studentGeneralInfo.id;

      this.props.retakeProgressTest(this.props.groupId, { progressTestId: this.props.progressTestId, studentId: studentId }, this.props.progressReportId);
      this.setState({ retakePTConfirmDialog: false });
    }
  }, {
    key: "_renderReportLink",
    value: function _renderReportLink(member) {
      var _this11 = this;

      var _props3 = this.props,
          progressReportId = _props3.progressReportId,
          groupId = _props3.params.groupId,
          buildRoute = _props3.buildRoute;

      var memberId = member.studentGeneralInfo.id;

      var route = buildRoute("/group/" + groupId + "/unit-report/" + progressReportId + "/student/" + memberId, { mode: "" });
      return _react2.default.createElement(
        _reactRouter.Link,
        {
          className: _style2.default.ProgressReportLink,
          to: route,
          draggable: false,
          onClick: function onClick() {
            return _this11._gaLinkToReport();
          },
          tabIndex: "-1"
        },
        "Report",
        " ",
        _react2.default.createElement(_omniCommonUi.Icon, { id: "arrow-right", className: _style2.default.ProgressReportLink_icon })
      );
    }
  }, {
    key: "_renderStudyReport",
    value: function _renderStudyReport(member) {
      var _this12 = this;

      var memberId = member.studentGeneralInfo.id;

      return _react2.default.createElement(
        _reactRouter.Link,
        {
          className: _style2.default.ProgressReportLink,
          draggable: false,
          onClick: function onClick() {
            return _this12._redirectToStudyReport(memberId);
          },
          tabIndex: "-1"
        },
        "Study Results",
        " ",
        _react2.default.createElement(_omniCommonUi.Icon, { id: "arrow-right", className: _style2.default.ProgressReportLink_icon })
      );
    }
  }, {
    key: "_redirectToStudyReport",
    value: function _redirectToStudyReport(memberId) {
      var studyReportUrl = this.props.studyReportUrl;


      (0, _Api.fetch)((0, _Api.buildUrl)("/students/" + memberId + "/study-report-token")).then(function (response) {
        var redirectUrl = studyReportUrl + "?idTokenV2=" + response.idToken + "&accessTokenV2=" + response.accessToken + "&origin=learning";
        window.open(redirectUrl, "_blank", "noreferrer");
      }).catch(function () {
        // do nothing.
      });
    }
  }, {
    key: "_renderRetakePTConfirmDialog",
    value: function _renderRetakePTConfirmDialog() {
      var _this13 = this;

      if (!this.state.retakePTConfirmDialog) {
        return null;
      }

      var student = this.state.retakePTConfirmDialog;

      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        {
          isOpen: true,
          primaryButtonContent: "Confirm",
          secondaryButtonContent: "Cancel",
          onPrimaryClick: function onPrimaryClick() {
            return _this13._onOKRetakeClicked(student);
          },
          onSecondaryClick: function onSecondaryClick() {
            return _this13._onCancelRetakeClicked();
          },
          onRequestClose: function onRequestClose() {
            return _this13._onCancelRetakeClicked();
          }
        },
        _react2.default.createElement(
          "span",
          null,
          " ",
          "This will clear the student this online progress test result! Are you sure? ",
          _react2.default.createElement("br", null),
          "(note the cleared result/new result will take a while to be synced to here. ",
          _react2.default.createElement("br", null),
          "Until then this view will still show the last result)"
        )
      );
    }
  }, {
    key: "_renderAddNoteDialog",
    value: function _renderAddNoteDialog(student) {
      if (this.state.dialogOpen !== student) {
        return null;
      }

      return _react2.default.createElement(_NewNotePopup2.default, {
        titleGroup: this.props.groupNumber,
        studentName: student.studentGeneralInfo.firstName + " " + student.studentGeneralInfo.lastName,
        extraInfo: _react2.default.createElement(_QuickSummary2.default, {
          type: _QuickSummary2.default.Type.progressTest,
          entityId: this.props.progressTestId
        }),
        onSave: this._onSaveNoteClicked,
        onCancel: this._onCancelNoteClicked
      });
    }
  }, {
    key: "_renderExpandButtonForRemainingTable",
    value: function _renderExpandButtonForRemainingTable() {
      var _this14 = this;

      var isExpandRemainingMember = this.state.isExpandRemainingMember;


      return _react2.default.createElement(_ExpansionButton2.default, {
        isExpand: isExpandRemainingMember,
        onExpansionButtonClick: function onExpansionButtonClick() {
          return _this14.setState({ isExpandRemainingMember: !isExpandRemainingMember });
        },
        className: _style2.default.ProgressTestCourseView_expand
      });
    }
  }, {
    key: "_renderExpandButtonForSocreInfoTable",
    value: function _renderExpandButtonForSocreInfoTable() {
      var _this15 = this;

      var isExpandMembersInScoreInfo = this.state.isExpandMembersInScoreInfo;


      return _react2.default.createElement(_ExpansionButton2.default, {
        isExpand: isExpandMembersInScoreInfo,
        onExpansionButtonClick: function onExpansionButtonClick() {
          return _this15.setState({
            isExpandMembersInScoreInfo: !isExpandMembersInScoreInfo
          });
        },
        className: _style2.default.ProgressTestCourseView_expand
      });
    }
  }, {
    key: "_renderPTTable",
    value: function _renderPTTable(members) {
      var _this16 = this;

      var _props4 = this.props,
          isUnitQuiz = _props4.isUnitQuiz,
          canReTakeProgressTest = _props4.canReTakeProgressTest,
          canExportProgressTest = _props4.canExportProgressTest,
          canViewUnitReport = _props4.canViewUnitReport,
          canViewStudyReport = _props4.canViewStudyReport,
          studyReportUrl = _props4.studyReportUrl;


      return _react2.default.createElement(
        _CourseViewTable2.default,
        {
          students: members,
          onlyRowDivider: true,
          onAddNoteClicked: this.props.canAddStudentNotes ? this._onAddNoteClicked : undefined,
          renderAddNoteDialog: this._renderAddNoteDialog
        },
        _react2.default.createElement(
          _CourseViewTable2.default.Header,
          null,
          _react2.default.createElement(
            _CourseViewTable2.default.Row,
            null,
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: "total", small: true },
              "Total"
            ),
            this.props.progressTest.data.skills.map(function (skill) {
              return (isUnitQuiz || skill.name !== _accessors.shouldDisabledSkillName) && _react2.default.createElement(
                _CourseViewTable2.default.Cell,
                {
                  key: skill.name,
                  columnId: skill.name,
                  small: true
                },
                skill.name
              );
            }),
            isUnitQuiz && canExportProgressTest && _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: "export-pdf", small: true },
              _react2.default.createElement("span", { className: (0, _omniCommonUi.testClass)("report-link-header") })
            ),
            isUnitQuiz && canReTakeProgressTest && _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: "retake", small: true },
              _react2.default.createElement("span", { className: (0, _omniCommonUi.testClass)("report-link-header") })
            ),
            isUnitQuiz && canViewUnitReport && _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: "unit-report", small: true },
              _react2.default.createElement("span", { className: (0, _omniCommonUi.testClass)("report-link-header") })
            ),
            isUnitQuiz && canViewStudyReport && _is_js2.default.not.undefined(studyReportUrl) && _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: "study-report", small: true },
              _react2.default.createElement("span", { className: (0, _omniCommonUi.testClass)("report-link-header") })
            )
          )
        ),
        _react2.default.createElement(
          _CourseViewTable2.default.Body,
          null,
          function (member, column) {
            return _this16._renderCell(member, column, false);
          }
        )
      );
    }
  }, {
    key: "_renderPTScoreInfoTable",
    value: function _renderPTScoreInfoTable(members) {
      var _this17 = this;

      return _react2.default.createElement(
        _CourseViewTable2.default,
        {
          students: members,
          onlyRowDivider: true,
          onAddNoteClicked: this.props.canAddStudentNotes ? this._onAddNoteClicked : undefined,
          renderAddNoteDialog: this._renderAddNoteDialog
        },
        _react2.default.createElement(
          _CourseViewTable2.default.Header,
          null,
          _react2.default.createElement(
            _CourseViewTable2.default.Row,
            null,
            this.props.progressTest.data.skills.map(function (skill) {
              if (skill.isRubric) {
                return null;
              }
              return _react2.default.createElement(
                _CourseViewTable2.default.Cell,
                {
                  key: skill.name,
                  columnId: skill.name,
                  small: true
                },
                skill.name
              );
            })
          )
        ),
        _react2.default.createElement(
          _CourseViewTable2.default.Body,
          null,
          function (member, column) {
            return _this17._renderCell(member, column, true);
          }
        )
      );
    }
  }, {
    key: "render",
    value: function render() {
      if (!_immutable.List.isList(this.props.members) || !this.props.progressTest || !this.props.progressTest.data) {
        return null;
      }

      var remainingMembers = [];
      if (this.state.isExpandRemainingMember) {
        remainingMembers = this.props.remainingMembers;
      }

      var ptMembers = [];
      if (this.state.isExpandMembersInScoreInfo) {
        ptMembers = this.props.ptSessionMembers.concat(this.props.remainingMembers);
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(
            _omniCommonUi.PageCard.Heading,
            {
              text: this.props.isUnitQuiz ? "UQ Session Members" : "Exam Members",
              className: _style2.default.ProgressTestCourseView_cardHeader,
              titleClassName: _style2.default.ProgressTestCourseView_cardHeader_title
            },
            this.props.isUnitQuiz && _react2.default.createElement(
              _omniCommonUi.Tooltip,
              {
                text: "UQ Session: Last session of every unit",
                placement: "right",
                trigger: ["hover"],
                className: _style2.default.ProgressTestCourseView_cardHeader_tooltip
              },
              _react2.default.createElement(_omniCommonUi.Icon, { id: "question" })
            )
          ),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.ProgressTestCourseView_content },
            this._renderPTTable(this.props.ptSessionMembers)
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(_omniCommonUi.PageCard.Heading, {
            text: "Remaining Session Members",
            className: _style2.default.ProgressTestCourseView_cardHeader
          }),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.ProgressTestCourseView_content },
            this._renderPTTable(remainingMembers)
          ),
          this._renderExpandButtonForRemainingTable()
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(_omniCommonUi.PageCard.Heading, {
            text: this.props.isUnitQuiz ? "Unit Quiz Log" : "Exam Log",
            className: _style2.default.ProgressTestCourseView_cardHeader
          }),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.ProgressTestCourseView_content },
            this._renderPTScoreInfoTable(ptMembers)
          ),
          this._renderExpandButtonForSocreInfoTable()
        ),
        this._renderUnsavedChangesWarningDialog(),
        this._renderRetakePTConfirmDialog(),
        this._renderExportWarningDialog(),
        this._renderExportGeneralErrorDialog(),
        this._renderExportLoading()
      );
    }
  }]);

  return ProgressTestCourseView;
}(_UnsavedChangesTrackingPageComponent2.default);

ProgressTestCourseView.isInMarkingRoute = function (props) {
  return props.params && props.params.mode === MARKING;
};

ProgressTestCourseView.propTypes = {
  timeZone: _propTypes2.default.string.isRequired,
  contentMap: _propTypes2.default.object.isRequired,
  progressTest: _propTypes2.default.object.isRequired,
  currentProgressTestIndex: _propTypes2.default.number.isRequired,
  members: _propTypes2.default.object.isRequired,
  ptSessionMembers: _propTypes2.default.object.isRequired,
  remainingMembers: _propTypes2.default.object.isRequired,
  params: _propTypes2.default.object.isRequired,
  currentProgressTestPlan: _propTypes2.default.object.isRequired,
  progressReportId: _propTypes2.default.string,
  submitProgressTestResults: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func,
  pushRoute: _propTypes2.default.func,
  router: _propTypes2.default.any.isRequired,
  route: _propTypes2.default.any.isRequired,
  routes: _propTypes2.default.array.isRequired,
  pathName: _propTypes2.default.string,
  location: _propTypes2.default.object.isRequired,
  canViewUnitReport: _propTypes2.default.bool,
  canViewStudyReport: _propTypes2.default.bool,
  canReTakeProgressTest: _propTypes2.default.bool,
  canExportProgressTest: _propTypes2.default.bool,
  isAnyApiCallSaving: _propTypes2.default.bool,
  groupNumber: _propTypes2.default.string.isRequired,
  canAddStudentNotes: _propTypes2.default.bool,
  progressTestId: _propTypes2.default.string,
  studyReportUrl: _propTypes2.default.string,
  groupId: _propTypes2.default.string,
  progressTestResetted: _propTypes2.default.object.isRequired,
  isUnitQuiz: _propTypes2.default.bool.isRequired,
  isHFV4: _propTypes2.default.bool
};

function mapStateToProps(state, ownProps) {
  var isUnitQuiz = (0, _accessors.checkIsUnitQuiz)(ownProps.location.pathname);
  var groupId = ownProps.params.groupId;

  var _Group$getCentre = _.actions.getCentre(state, groupId),
      timeZone = _Group$getCentre.timeZone;

  var pathName = ownProps.location.pathname;
  var group = state.get("rootReducer").get("groups").get(ownProps.params.groupId).data;
  var currentProgressTestIndex = Number.parseInt(ownProps.params.progressTestIndex, 10);
  var currentProgressTestPlan = (0, _accessors.getProgressTestPlanFromIndex)(state, groupId, currentProgressTestIndex, isUnitQuiz);
  var progressTest = getCurrentProgressTest(state, currentProgressTestPlan && currentProgressTestPlan.id);
  var ptSessionStudentIds = progressTest && progressTest.data && progressTest.data.studentProgressTestResults.filter(function (studentProgressTestResult) {
    return studentProgressTestResult.isPTSessionMember;
  }).map(function (studentProgressTestResult) {
    return studentProgressTestResult.studentId;
  });
  var remainingStudentIds = progressTest && progressTest.data && progressTest.data.studentProgressTestResults.filter(function (studentProgressTestResult) {
    return !studentProgressTestResult.isPTSessionMember;
  }).map(function (studentProgressTestResult) {
    return studentProgressTestResult.studentId;
  });
  var progressReportId = _ProgressTests.ProgressTest.actions.getProgressReportId(state, groupId, currentProgressTestPlan && currentProgressTestPlan.id);
  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var ptSessionMembers = ptSessionStudentIds && members.filter(function (member) {
    return ptSessionStudentIds.includes(member.studentGeneralInfo.id);
  });
  var remainingMembers = remainingStudentIds && members.filter(function (member) {
    return remainingStudentIds.includes(member.studentGeneralInfo.id);
  });
  var canViewUnitReport = _.actions.isSupportUnitReport(state, groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.ProgressReport.View);
  var canViewStudyReport = _.actions.isSupportStudyReport(state, groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.ProgressReport.View);
  var canReTakeProgressTest = _.actions.isSupportPTRetaken(state, groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.ProgressTest.ReTake);
  var canAddStudentNotes = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.AcademicInfo.AddStudentNotes);
  var canExportProgressTest = _.actions.isSupportPTExportActions(state, groupId) && _ProgressTests.ProgressTest.actions.enabledExportPT(currentProgressTestPlan);
  var progressTestId = currentProgressTestPlan && currentProgressTestPlan.id;
  var progressTestResetted = state.get("rootReducer").get("isProgressTestResetted");
  var viewerLink = (0, _accessors.getViewerLink)(state, progressTestId);
  var studyReportUrl = viewerLink && viewerLink.studyReportUrl;

  return {
    groupId: groupId,
    timeZone: timeZone,
    groupNumber: group.number,
    members: members,
    ptSessionMembers: ptSessionMembers,
    remainingMembers: remainingMembers,
    progressTest: progressTest,
    currentProgressTestIndex: currentProgressTestIndex,
    currentProgressTestPlan: currentProgressTestPlan,
    progressReportId: progressReportId,
    pathName: pathName,
    canViewUnitReport: canViewUnitReport,
    canViewStudyReport: canViewStudyReport,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state),
    canAddStudentNotes: canAddStudentNotes,
    canReTakeProgressTest: canReTakeProgressTest,
    canExportProgressTest: canExportProgressTest,
    progressTestId: progressTestId,
    progressReports: group && group.progressReports,
    studyReportUrl: studyReportUrl,
    progressTestResetted: progressTestResetted,
    isUnitQuiz: isUnitQuiz,
    isHFV4: _.actions.isHFV4CourseTypeGroup(state, groupId)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_ViewLink.actions, dispatch), (0, _redux.bindActionCreators)(SessionsAttendance.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTests.ProgressTest.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTests.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressReports.actions, dispatch), (0, _redux.bindActionCreators)(_Note.actions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !!(state.get("apiCalls") || new _immutable.List()).filter(function (call, key) {
    return ["PUT", "POST"].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

function getCurrentProgressTest(state, progressTestId) {
  var progressTests = state.get("rootReducer").get("progressTests");
  if (!_immutable.Map.isMap(progressTests)) {
    return;
  }
  return progressTests.get(progressTestId);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(ProgressTestCourseView));

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(294);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1424);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(645);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1448);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressTestRubricView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1429);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouter = __webpack_require__(16);

var _reactRouterRedux = __webpack_require__(15);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _omniCommonUi = __webpack_require__(0);

var _ConfirmationPrompt = __webpack_require__(646);

var _Detailsboard = __webpack_require__(202);

var _Detailsboard2 = _interopRequireDefault(_Detailsboard);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _InfoDialog = __webpack_require__(295);

var _InfoDialog2 = _interopRequireDefault(_InfoDialog);

var _GroupMembers = __webpack_require__(14);

var _ProgressTests = __webpack_require__(40);

var _accessors = __webpack_require__(52);

var _RubricSkillTable = __webpack_require__(1437);

var _RubricSkillTable2 = _interopRequireDefault(_RubricSkillTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MARKING = "edit";

var toMap = function toMap(arr, key) {
  return arr.reduce(function (obj, item) {
    // eslint-disable-next-line no-param-reassign
    obj[item[key]] = item; // stringifies keys!
    return obj;
  }, {});
};

var ProgressTestRubricView = exports.ProgressTestRubricView = function (_UnsavedChangesTracki) {
  _inherits(ProgressTestRubricView, _UnsavedChangesTracki);

  function ProgressTestRubricView(props) {
    _classCallCheck(this, ProgressTestRubricView);

    var _this = _possibleConstructorReturn(this, (ProgressTestRubricView.__proto__ || Object.getPrototypeOf(ProgressTestRubricView)).call(this, props));

    _this._queryListener = _this._queryListener.bind(_this);
    _this._queryIsLg = (0, _omniCommonUi.mediaQuery)("(min-width: 980px)");
    _this.state = {
      lg: _this._queryIsLg.matches,
      targetLanguagePopup: {
        isOpen: false,
        skillId: ""
      }
    };
    _this.scrollers = [];
    Object.assign(_this.state, {
      // A map of skillIds whose expand buttons have been clicked to booleans
      expandedInstructionTextsSubSkillIds: new _immutable.Map(),

      // The internal subSkill to abilityId mapping - what we use to render the buttons
      subSkillsToSkillIds: new _immutable.Map()
    });

    _this._renderSkills = _this._renderSkills.bind(_this);
    return _this;
  }

  _createClass(ProgressTestRubricView, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this._buildSubSkillsToAbilityIdsMap(this.props);
      _get(ProgressTestRubricView.prototype.__proto__ || Object.getPrototypeOf(ProgressTestRubricView.prototype), "componentWillMount", this).call(this);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._queryIsLg.addListener(this._queryListener);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          params = _props.params,
          progressTest = _props.progressTest;
      var nextParams = nextProps.params,
          nextProgressTest = nextProps.progressTest;

      if (nextParams.studentId !== params.studentId || !progressTest && nextProgressTest) {
        this._buildSubSkillsToAbilityIdsMap(nextProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._queryIsLg.removeListener(this._queryListener);
    }
  }, {
    key: "routerWillLeave",
    value: function routerWillLeave(nextLocation) {
      var that = this;
      var subSkillsToAbilityIds = this.state.subSkillsToAbilityIds;


      var returnToView = function returnToView() {
        var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return that._forcePushRoute(that.props.buildRoute({ mode: mode }));
      };

      if (nextLocation && nextLocation.pathname.endsWith("/save")) {
        if (this._checkCanSave()) {
          setTimeout(function () {
            return (
              // /save sticks if we don't defer this
              that._handleSave(subSkillsToAbilityIds)
            );
          }, 0);
          returnToView();
        } else {
          returnToView("edit");
        }
      } else if (nextLocation && nextLocation.pathname.endsWith("/discard")) {
        this._buildSubSkillsToAbilityIdsMap(this.props);
        returnToView();
      } else {
        return _get(ProgressTestRubricView.prototype.__proto__ || Object.getPrototypeOf(ProgressTestRubricView.prototype), "routerWillLeave", this).call(this, nextLocation);
      }
    }
  }, {
    key: "_queryListener",
    value: function _queryListener(mql) {
      this.setState({ lg: mql.matches });
    }
  }, {
    key: "_onScrollReady",
    value: function _onScrollReady(scroll) {
      this.scrollers.push(scroll);
    }
  }, {
    key: "_isChangesPresent",
    value: function _isChangesPresent() {
      return ProgressTestRubricView.isInMarkingRoute(this.props) &&
      // if this is set and not the same as the hot copy then we have local changes!
      this.state.originalSubSkillsToSkillIds && this.state.originalSubSkillsToSkillIds !== this.state.subSkillsToSkillIds;
    }
  }, {
    key: "_buildSubSkillsToAbilityIdsMap",
    value: function _buildSubSkillsToAbilityIdsMap(props) {
      var rubricSkills = props.rubricSkills,
          currentMember = props.currentMember,
          progressTest = props.progressTest;

      if (_is_js2.default.undefined(currentMember)) {
        return;
      }
      var studentId = currentMember.studentGeneralInfo.id;

      // there's nothing to map yet if the progress test is undefined

      if (!progressTest) return;

      var subSkillsToSkillIds = rubricSkills.reduce(function (map, rubricSkill) {
        var subSkillsToAbilityIds = {};
        var studentSubSkillResults = (progressTest.studentProgressTestResults.get(studentId).skillResults.find(function (skr) {
          return skr.skillId === rubricSkill.skillId;
        }) || {}).subSkillResults || [];
        var subSkillResultsMap = toMap(studentSubSkillResults, "subSkillId");
        rubricSkill.subSkills.forEach(function (subSkill) {
          var subSkillId = subSkill.subSkillId;

          subSkillsToAbilityIds[subSkillId] = subSkillResultsMap[subSkillId] && subSkillResultsMap[subSkillId].currentResultAbilityId;
        });
        return map.set("" + rubricSkill.skillId, new _immutable.Map(subSkillsToAbilityIds));
      }, new _immutable.Map());

      this.setState({
        subSkillsToSkillIds: subSkillsToSkillIds,
        originalSubSkillsToSkillIds: subSkillsToSkillIds
      });
    }
  }, {
    key: "_checkCanSave",
    value: function _checkCanSave() {
      var subSkillsToSkillIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.subSkillsToSkillIds;
      var rubricSkills = this.props.rubricSkills;


      var isCompelte = rubricSkills.every(function (rubricSkill) {
        var numberOfSelectedAbilityPoints = subSkillsToSkillIds.get(rubricSkill.skillId).map(function (v) {
          return v;
        }).size;
        return numberOfSelectedAbilityPoints === rubricSkill.subSkills.size;
      });

      if (!isCompelte) {
        _ConfirmationPrompt.ConfirmationPrompt.showReminder("Incomplete Skill", "Please select an ability point for each of the sub-skills before saving.");
        return false;
      }
      return true;
    }
  }, {
    key: "_handleSave",
    value: function _handleSave() {
      var subSkillsToSkillIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.subSkillsToSkillIds;
      var _props2 = this.props,
          rubricSkills = _props2.rubricSkills,
          currentMember = _props2.currentMember,
          currentProgressTestId = _props2.currentProgressTestId,
          submitProgressTestResults = _props2.submitProgressTestResults,
          progressReportId = _props2.progressReportId,
          params = _props2.params,
          isUnitQuiz = _props2.isUnitQuiz;


      var progressTest = _ProgressTests.ProgressTest.serialize(_ProgressTests.ProgressTest.create({
        studentProgressTestResults: [{
          studentId: currentMember.studentGeneralInfo.id,
          skillResults: rubricSkills.map(function (rubricSkill) {
            return {
              skillId: rubricSkill.skillId,
              subSkillResults: rubricSkill.subSkills.map(function (_ref) {
                var subSkillId = _ref.subSkillId;
                return {
                  subSkillId: subSkillId,
                  currentResultAbilityId: subSkillsToSkillIds.get(rubricSkill.skillId).get(subSkillId) || null
                };
              }).toArray()
            };
          }).toArray()
        }]
      }));
      return submitProgressTestResults(params.groupId, currentProgressTestId, progressTest, progressReportId, isUnitQuiz);
    }
  }, {
    key: "_onInstructionTextExpandCollapseClicked",
    value: function _onInstructionTextExpandCollapseClicked(skillId, subSkillId) {
      var _this2 = this;

      var expandedInstructionTextsSubSkillIds = this.state.expandedInstructionTextsSubSkillIds;


      var action = expandedInstructionTextsSubSkillIds.getIn([skillId, subSkillId]) ? "collapse" : "expand";
      _reactGa2.default.event({
        category: "Progress Tests",
        action: "Clicked " + action + " scoring criteria",
        label: "Clicked " + action + " scoring criteria for sub skill " + subSkillId + " in skill " + skillId
      });

      this.setState({
        expandedInstructionTextsSubSkillIds: expandedInstructionTextsSubSkillIds.updateIn([skillId, subSkillId], function (currentToggleState) {
          return !currentToggleState;
        })
      }, function () {
        // make scrollers use the dimensions of the newly visible element (previously `display: none`)
        _this2.scrollers.forEach(function (scroll) {
          scroll.refresh();
        });
      });
    }
  }, {
    key: "_onIndividualAbilityButtonClicked",
    value: function _onIndividualAbilityButtonClicked(subSkillId, resultAbilityId, skillId) {
      var subSkillsToSkillIds = this.state.subSkillsToSkillIds;


      _reactGa2.default.event({
        category: "Progress Tests",
        action: "Clicked score button",
        label: "Clicked score button " + resultAbilityId + " for skill " + skillId + " and sub skill " + subSkillId
      });
      this.setState({
        subSkillsToSkillIds: subSkillsToSkillIds.setIn([skillId, subSkillId], resultAbilityId)
      });
    }
  }, {
    key: "_onCheckAllAbility",
    value: function _onCheckAllAbility(skillId, checked, abilityId) {
      var subSkillsToSkillIds = this.state.subSkillsToSkillIds;

      if (checked) {
        this.setState({
          subSkillsToSkillIds: subSkillsToSkillIds.update(skillId, function (subSkillsToAbilityIds) {
            return subSkillsToAbilityIds.map(function () {
              return abilityId;
            });
          })
        });
      }
    }
  }, {
    key: "_renderSkills",
    value: function _renderSkills(skills) {
      var _this3 = this;

      var _state = this.state,
          subSkillsToSkillIds = _state.subSkillsToSkillIds,
          expandedInstructionTextsSubSkillIds = _state.expandedInstructionTextsSubSkillIds;

      var onIntructionToggleClick = function onIntructionToggleClick() {
        return _this3._onInstructionTextExpandCollapseClicked.apply(_this3, arguments);
      };
      return skills.map(function (rubricSkill) {
        return _react2.default.createElement(_RubricSkillTable2.default, {
          isMarking: ProgressTestRubricView.isInMarkingRoute(_this3.props),
          isUnitQuiz: _this3.props.isUnitQuiz,
          rubricSkill: rubricSkill,
          showInstructionsFor: expandedInstructionTextsSubSkillIds,
          subSkillsToAbilityIds: subSkillsToSkillIds.get("" + rubricSkill.skillId),
          onCheckAllAbility: function onCheckAllAbility() {
            return _this3._onCheckAllAbility.apply(_this3, arguments);
          },
          onIntructionToggleClick: onIntructionToggleClick,
          onTargetLanguageButtonClick: function onTargetLanguageButtonClick(skillId) {
            return _this3._onTargetLanguageButtonClick(skillId);
          },
          onScoreClick: function onScoreClick() {
            return _this3._onIndividualAbilityButtonClicked.apply(_this3, arguments);
          }
        });
      });
    }
  }, {
    key: "_renderView",
    value: function _renderView() {
      var _props3 = this.props,
          rubricSkills = _props3.rubricSkills,
          progressTest = _props3.progressTest;

      // there's nothing to display yet if the progress test is undefined

      if (!progressTest) return null;

      var multiColumns = !!(this.state.lg && rubricSkills && rubricSkills.size > 4);
      var masonryClass = (0, _classnames3.default)(_style2.default.Masonry, _defineProperty({}, _style2.default.Masonry_multi, multiColumns));

      var listStart = [];
      var listEnd = [];
      if (multiColumns) {
        listStart = rubricSkills.filter(function (rubricSkill, index) {
          return index % 2 === 0;
        });
        listEnd = rubricSkills.filterNot(function (rubricSkill, index) {
          return index % 2 === 0;
        });
      }

      return _react2.default.createElement(
        "div",
        { className: _style2.default.ProgressTestRubricView },
        _react2.default.createElement(
          "div",
          { className: masonryClass },
          multiColumns ? [_react2.default.createElement(
            "div",
            { className: _style2.default.Masonry_flow },
            this._renderSkills(listStart)
          ), _react2.default.createElement(
            "div",
            { className: _style2.default.Masonry_flow },
            this._renderSkills(listEnd)
          )] : this._renderSkills(rubricSkills)
        )
      );
    }
  }, {
    key: "_renderUnsavedChangesWarningDialog",
    value: function _renderUnsavedChangesWarningDialog() {
      var _this4 = this;

      var isSaving = false; // local to this method - it doesn't trigger a setState()
      return _react2.default.createElement(_UnsavedChangesWarning2.default, {
        isOpen: !!this._isNavigationWithChangesRequested()
        /* we need to check these two to get a full loading throbber experience */
        , isSaving: this.props.isAnyApiCallSaving || isSaving,
        onSaveClicked: function onSaveClicked() {
          isSaving = true;
          _this4._handleSave().then(function () {
            isSaving = false;
            _this4._forcePushRequestedLocation();
          });
        },
        onDiscardClicked: function onDiscardClicked() {
          // trash view model (for browser 'back')
          _this4._buildSubSkillsToAbilityIdsMap(_this4.props);
          _this4._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this4._clearRequestedLocation();
        }
      });
    }
  }, {
    key: "_onTargetLanguagePopupOKClick",
    value: function _onTargetLanguagePopupOKClick() {
      this.setState({
        targetLanguagePopup: {
          isOpen: false
        }
      });
    }
  }, {
    key: "_onTargetLanguageButtonClick",
    value: function _onTargetLanguageButtonClick(skillId) {
      this.setState({
        targetLanguagePopup: {
          isOpen: true,
          skillId: skillId
        }
      });
    }
  }, {
    key: "_renderTargetLanguagePopup",
    value: function _renderTargetLanguagePopup() {
      var _this5 = this;

      var rubricSkills = this.props.rubricSkills;
      var targetLanguagePopup = this.state.targetLanguagePopup;

      var currentSkill = rubricSkills.find(function (skill) {
        return skill.skillId === targetLanguagePopup.skillId;
      });
      return _react2.default.createElement(
        _InfoDialog2.default,
        {
          isOpen: targetLanguagePopup.isOpen,
          onOKClick: function onOKClick() {
            return _this5._onTargetLanguagePopupOKClick();
          }
        },
        _react2.default.createElement(
          "h3",
          null,
          "Target Language"
        ),
        _is_js2.default.existy(currentSkill) && _is_js2.default.existy(currentSkill.targetLanguageCategories) && currentSkill.targetLanguageCategories.map(function (tlc) {
          return _react2.default.createElement(_Detailsboard2.default, {
            key: tlc.title,
            boardTitle: tlc.title,
            boardValue: tlc.items.join("\n")
          });
        })
      );
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        this._renderView(),
        this._renderUnsavedChangesWarningDialog(),
        this._renderTargetLanguagePopup()
      );
    }
  }]);

  return ProgressTestRubricView;
}(_UnsavedChangesTrackingPageComponent2.default);

ProgressTestRubricView.isInMarkingRoute = function (props) {
  return props.params && props.params.mode === MARKING;
};

ProgressTestRubricView.propTypes = Object.assign({}, _UnsavedChangesTrackingPageComponent2.default.propTypes, {
  progressTest: _propTypes2.default.object.isRequired,
  currentMember: _propTypes2.default.object.isRequired,
  currentProgressTestId: _propTypes2.default.string.isRequired,
  currentProgressTestIndex: _propTypes2.default.number.isRequired,
  studyingMembers: _propTypes2.default.object.isRequired,
  rubricSkills: _propTypes2.default.objectOf(_immutable.List),
  submitProgressTestResults: _propTypes2.default.func.isRequired,
  params: _propTypes2.default.object.isRequired,
  route: _propTypes2.default.any.isRequired,
  buildRoute: _propTypes2.default.func,
  pushRoute: _propTypes2.default.func,
  pathName: _propTypes2.default.string,
  progressReportId: _propTypes2.default.string,
  isAnyApiCallSaving: _propTypes2.default.bool,
  isUnitQuiz: _propTypes2.default.bool.isRequired
});

function mapStateToProps(state, ownProps) {
  var isUnitQuiz = (0, _accessors.checkIsUnitQuiz)(ownProps.location.pathname);
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      studentId = _ownProps$params.studentId;

  var currentProgressTestIndex = Number.parseInt(ownProps.params.progressTestIndex, 10);
  var currentProgressTestId = (0, _accessors.getProgressTestPlanFromIndex)(state, groupId, currentProgressTestIndex, isUnitQuiz).id;
  var progressTest = getCurrentProgressTest(state, currentProgressTestId);
  var pathName = ownProps.location.pathname;
  var studyingMembers = _GroupMembers.actions.getMembersByGroup(state, groupId).filter(function (member) {
    return member.isInProduction;
  });
  var currentMember = _GroupMembers.actions.getMemberById(state, studentId);
  var progressReportId = _ProgressTests.ProgressTest.actions.getProgressReportId(state, groupId, currentProgressTestId);

  var rubricSkills = _omniCommonUi.ApiResponseHelper.hasSucceeded(progressTest) && progressTest.data.skills.filter(function (skill) {
    return skill.isRubric;
  });
  return {
    studyingMembers: studyingMembers,
    currentMember: currentMember,
    rubricSkills: rubricSkills || new _immutable.List(),
    progressTest: progressTest.data,
    currentProgressTestId: currentProgressTestId,
    currentProgressTestIndex: currentProgressTestIndex,
    progressReportId: progressReportId,
    pathName: pathName,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state),
    isUnitQuiz: isUnitQuiz
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_ProgressTests.ProgressTest.actions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !!(state.get("apiCalls") || new _immutable.List()).filter(function (call, key) {
    return ["PUT", "POST"].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

function getCurrentProgressTest(state, progressTestId) {
  var progressTests = state.get("rootReducer").get("progressTests");
  if (!_immutable.Map.isMap(progressTests)) {
    return;
  }
  return progressTests.get(progressTestId);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(ProgressTestRubricView));

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmationPrompt = undefined;

var _alertifyjs = __webpack_require__(576);

var _alertifyjs2 = _interopRequireDefault(_alertifyjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1431);

var CONFIRM_TITLE = 'Unsaved Changes';
var CONFIRM_MESSAGE = 'Continue without saving? Your changes will be lost.';

// alertifyjs behaves a bit weirdly with undefined callbacks. set default noops.
var NOOP = function NOOP() {};

var showReminder = function showReminder() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CONFIRM_TITLE;
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CONFIRM_MESSAGE;
  var onOkCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : NOOP;
  var onCancelCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : NOOP;

  _alertifyjs2.default.confirm(title, message, onOkCallback, onCancelCallback).set('movable', false).set('transition', 'fade');
};

var showUnsavedChangesReminder = function showUnsavedChangesReminder(onOkCallback, onCancelCallback) {
  return showReminder(CONFIRM_TITLE, CONFIRM_MESSAGE, onOkCallback, onCancelCallback);
};

var ConfirmationPrompt = exports.ConfirmationPrompt = { showReminder: showReminder, showUnsavedChangesReminder: showUnsavedChangesReminder };

exports.default = ConfirmationPrompt;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(648),
    Collapse = _require.Collapse;

var _require2 = __webpack_require__(1447),
    UnmountClosed = _require2.UnmountClosed;

UnmountClosed.Collapse = Collapse;
UnmountClosed.UnmountClosed = UnmountClosed;

module.exports = UnmountClosed;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMotion = __webpack_require__(1440);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SPRING_PRECISION = 1;

var WAITING = 'WAITING';
var RESIZING = 'RESIZING';
var RESTING = 'RESTING';
var IDLING = 'IDLING';

var noop = function noop() {
  return null;
};
var css = {
  collapse: 'ReactCollapse--collapse',
  content: 'ReactCollapse--content'
};

var Collapse = exports.Collapse = function (_React$PureComponent) {
  _inherits(Collapse, _React$PureComponent);

  function Collapse(props) {
    _classCallCheck(this, Collapse);

    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      currentState: IDLING,
      from: 0,
      to: 0
    };
    return _this;
  }

  _createClass(Collapse, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          isOpened = _props.isOpened,
          forceInitialAnimation = _props.forceInitialAnimation,
          onRest = _props.onRest;

      if (isOpened) {
        var to = this.getTo();
        if (forceInitialAnimation) {
          var from = this.wrapper.clientHeight;
          this.setState({ currentState: RESIZING, from: from, to: to });
        } else {
          this.setState({ currentState: IDLING, from: to, to: to });
        }
      }
      onRest();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hasNestedCollapse) {
        // For nested collapses we do not need to change to waiting state
        // and should keep `height:auto`
        // Because children will be animated and height will not jump anyway
        // See https://github.com/nkbt/react-collapse/issues/76 for more details
        if (nextProps.isOpened !== this.props.isOpened) {
          // Still go to WAITING state if own isOpened was changed
          this.setState({ currentState: WAITING });
        }
      } else if (this.state.currentState === IDLING && (nextProps.isOpened || this.props.isOpened)) {
        this.setState({ currentState: WAITING });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_, prevState) {
      var _props2 = this.props,
          isOpened = _props2.isOpened,
          onRest = _props2.onRest,
          onMeasure = _props2.onMeasure;


      if (this.state.currentState === IDLING) {
        onRest();
        return;
      }

      if (prevState.to !== this.state.to) {
        onMeasure({ height: this.state.to, width: this.content.clientWidth });
      }

      var from = this.wrapper.clientHeight;
      var to = isOpened ? this.getTo() : 0;

      if (from !== to) {
        this.setState({ currentState: RESIZING, from: from, to: to });
        return;
      }

      if (this.state.currentState === RESTING || this.state.currentState === WAITING) {
        this.setState({ currentState: IDLING, from: from, to: to });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      cancelAnimationFrame(this.raf);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_reactMotion.Motion, _extends({}, this.getMotionProps(), {
        onRest: this.onRest,
        children: this.renderContent }));
    }
  }]);

  return Collapse;
}(_react2.default.PureComponent);

Collapse.propTypes = {
  isOpened: _propTypes2.default.bool.isRequired,
  springConfig: _propTypes2.default.objectOf(_propTypes2.default.number),
  forceInitialAnimation: _propTypes2.default.bool,

  hasNestedCollapse: _propTypes2.default.bool,

  fixedHeight: _propTypes2.default.number,

  theme: _propTypes2.default.objectOf(_propTypes2.default.string),
  style: _propTypes2.default.object,

  onRender: _propTypes2.default.func,
  onRest: _propTypes2.default.func,
  onMeasure: _propTypes2.default.func,

  children: _propTypes2.default.node.isRequired
};
Collapse.defaultProps = {
  forceInitialAnimation: false,
  hasNestedCollapse: false,
  fixedHeight: -1,
  style: {},
  theme: css,
  onRender: noop,
  onRest: noop,
  onMeasure: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onContentRef = function (content) {
    _this2.content = content;
  };

  this.onWrapperRef = function (wrapper) {
    _this2.wrapper = wrapper;
  };

  this.onRest = function () {
    _this2.raf = requestAnimationFrame(_this2.setResting);
  };

  this.setResting = function () {
    _this2.setState({ currentState: RESTING });
  };

  this.getTo = function () {
    var fixedHeight = _this2.props.fixedHeight;

    return fixedHeight > -1 ? fixedHeight : _this2.content.clientHeight;
  };

  this.getWrapperStyle = function (height) {
    if (_this2.state.currentState === IDLING && _this2.state.to) {
      var fixedHeight = _this2.props.fixedHeight;

      if (fixedHeight > -1) {
        return { overflow: 'hidden', height: fixedHeight };
      }
      return { height: 'auto' };
    }

    if (_this2.state.currentState === WAITING && !_this2.state.to) {
      return { overflow: 'hidden', height: 0 };
    }

    return { overflow: 'hidden', height: Math.max(0, height) };
  };

  this.getMotionProps = function () {
    var springConfig = _this2.props.springConfig;


    return _this2.state.currentState === IDLING ? {
      // When completely stable, instantly jump to the position
      defaultStyle: { height: _this2.state.to },
      style: { height: _this2.state.to }
    } : {
      // Otherwise, animate
      defaultStyle: { height: _this2.state.from },
      style: { height: (0, _reactMotion.spring)(_this2.state.to, _extends({ precision: SPRING_PRECISION }, springConfig)) }
    };
  };

  this.renderContent = function (_ref) {
    var height = _ref.height;

    // eslint-disable-line
    var _props3 = _this2.props,
        _isOpened = _props3.isOpened,
        _springConfig = _props3.springConfig,
        _forceInitialAnimation = _props3.forceInitialAnimation,
        _hasNestedCollapse = _props3.hasNestedCollapse,
        _fixedHeight = _props3.fixedHeight,
        theme = _props3.theme,
        style = _props3.style,
        onRender = _props3.onRender,
        _onRest = _props3.onRest,
        _onMeasure = _props3.onMeasure,
        children = _props3.children,
        props = _objectWithoutProperties(_props3, ['isOpened', 'springConfig', 'forceInitialAnimation', 'hasNestedCollapse', 'fixedHeight', 'theme', 'style', 'onRender', 'onRest', 'onMeasure', 'children']);

    var _state = _this2.state,
        from = _state.from,
        to = _state.to;

    // DANGEROUS, use with caution, never do setState with it

    onRender({ current: height, from: from, to: to });

    return _react2.default.createElement(
      'div',
      _extends({
        ref: _this2.onWrapperRef,
        className: theme.collapse,
        style: _extends({}, _this2.getWrapperStyle(Math.max(0, height)), style)
      }, props),
      _react2.default.createElement(
        'div',
        { ref: _this2.onContentRef, className: theme.content },
        children
      )
    );
  };
};

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentHorizontalSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1449);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UiState = __webpack_require__(30);

var _omniCommonUi = __webpack_require__(0);

var _GroupMembers = __webpack_require__(14);

var _ProgressTests = __webpack_require__(40);

var _accessors = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentHorizontalSelect = exports.StudentHorizontalSelect = function (_Component) {
  _inherits(StudentHorizontalSelect, _Component);

  function StudentHorizontalSelect(props) {
    _classCallCheck(this, StudentHorizontalSelect);

    // used in horizontalselect - kept here to avoid recreating it
    var _this = _possibleConstructorReturn(this, (StudentHorizontalSelect.__proto__ || Object.getPrototypeOf(StudentHorizontalSelect)).call(this, props));

    _this._getLinkHrefForValue = function (studentId) {
      return _this.props.buildRoute({
        studentId: studentId,
        skillIndex: _this.props.skillIndex,
        mode: ''
      });
    };
    return _this;
  }

  _createClass(StudentHorizontalSelect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._buildStudentSelectOptions();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._buildStudentSelectOptions(nextProps);
    }
  }, {
    key: '_buildStudentSelectOptions',
    value: function _buildStudentSelectOptions() {
      var _this2 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var studyingMembers = props.studyingMembers,
          currentMember = props.currentMember,
          currentSkill = props.currentSkill,
          progressTest = props.progressTest;

      if (_is_js2.default.existy(this._studentSelectOptions) && studyingMembers === this.props.studyingMembers) {
        // cache this - do not recreate each time
        return;
      }
      if (studyingMembers && studyingMembers.size > 0 && currentMember && currentSkill && progressTest) {
        this._studentSelectOptions = studyingMembers.map(function (member) {
          var studentGeneralInfo = member.studentGeneralInfo;

          var optionHtml = _react2.default.createElement(
            _omniCommonUi.StudentCard,
            { vertical: true,
              borderless: true,
              backgroundless: true },
            _react2.default.createElement(_omniCommonUi.StudentCard.Profile, { name: studentGeneralInfo.firstName,
              surname: studentGeneralInfo.lastName,
              localName: studentGeneralInfo.localName,
              avatarUrl: studentGeneralInfo.avatarUrl,
              gender: studentGeneralInfo.gender }),
            _this2._getStudentScore(studentGeneralInfo.id, props)
          );
          return {
            html: optionHtml,
            value: studentGeneralInfo.id,
            className: _style2.default.StudentHorizontalSelect_options
          };
        });
      }
    }
  }, {
    key: '_getStudentScore',
    value: function _getStudentScore(studentId) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var studentProgressTestResults = props.progressTest.studentProgressTestResults,
          skillId = props.currentSkill.skillId;

      var studentProgressTestResult = studentProgressTestResults.find(function (result) {
        return result.studentId === studentId;
      });
      var studentResultForCurrentSkillPercentage = studentProgressTestResult && studentProgressTestResult.totalScore.skillScorePercentages.get(skillId);

      var score = _is_js2.default.number(studentResultForCurrentSkillPercentage) ? studentResultForCurrentSkillPercentage + '%' : '-';
      var scoreClassName = _style2.default.StudentHorizontalSelect_options_score;
      return _react2.default.createElement(
        _omniCommonUi.StudentCard.Content,
        null,
        _react2.default.createElement(
          _omniCommonUi.Card.Content,
          { className: scoreClassName },
          score
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentMember = _props.currentMember,
          studyingMembers = _props.studyingMembers,
          currentSkill = _props.currentSkill,
          isHide = _props.isHide;

      if (currentMember && currentSkill && studyingMembers.size && studyingMembers.size > 0) {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.StudentHorizontalSelect },
          _react2.default.createElement(_omniCommonUi.HorizontalSelect, { options: this._studentSelectOptions,
            isHide: isHide,
            value: currentMember.studentGeneralInfo.id,
            getLinkHrefForValue: this._getLinkHrefForValue })
        );
      }
      return null;
    }
  }]);

  return StudentHorizontalSelect;
}(_react.Component);

StudentHorizontalSelect.propTypes = {
  progressTest: _propTypes2.default.object,
  currentMember: _propTypes2.default.object,
  currentSkill: _propTypes2.default.object,
  studyingMembers: _propTypes2.default.object,
  buildRoute: _propTypes2.default.func,
  pushRoute: _propTypes2.default.func,
  isHide: _propTypes2.default.func,
  skillIndex: _propTypes2.default.string,
  isUnitQuiz: _propTypes2.default.bool
};

function mapStateToProps(state, ownProps) {
  var isUnitQuiz = (0, _accessors.checkIsUnitQuiz)(ownProps.location.pathname);
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      studentId = _ownProps$params.studentId,
      skillIndex = _ownProps$params.skillIndex,
      progressTestIndex = _ownProps$params.progressTestIndex;
  var buildRoute = ownProps.buildRoute,
      pushRoute = ownProps.pushRoute;

  var currentProgressTestId = (0, _accessors.getProgressTestPlanFromIndex)(state, groupId, progressTestIndex, isUnitQuiz) && (0, _accessors.getProgressTestPlanFromIndex)(state, groupId, progressTestIndex, isUnitQuiz).id;
  var progressTest = getCurrentProgressTest(state, currentProgressTestId);
  if (currentProgressTestId && progressTest) {
    var progressTestStudentIds = progressTest.data && progressTest.data.studentProgressTestResults.map(function (studentProgressTestResult) {
      return studentProgressTestResult.studentId;
    });
    var studyingMembers = progressTestStudentIds && _GroupMembers.actions.getMembersByGroup(state, groupId).filter(function (member) {
      return progressTestStudentIds.includes(member.studentGeneralInfo.id);
    });
    var currentMember = _GroupMembers.actions.getMemberById(state, studentId);
    return {
      studyingMembers: studyingMembers,
      currentMember: currentMember,
      progressTest: progressTest.data,
      currentSkill: progressTest.data && progressTest.data.skills.get(skillIndex),
      buildRoute: buildRoute,
      pushRoute: pushRoute,
      isHide: !_UiState.actions.getShowNavigationBar(state),
      skillIndex: skillIndex,
      isUnitQuiz: isUnitQuiz
    };
  }
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, (0, _redux.bindActionCreators)(_ProgressTests.ProgressTest.actions, dispatch));
}

function getCurrentProgressTest(state, progressTestId) {
  var progressTests = state.get('rootReducer').get('progressTests');
  if (!_immutable.Map.isMap(progressTests) || !_is_js2.default.existy(progressTestId)) {
    return;
  }
  return progressTests.get(progressTestId);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(StudentHorizontalSelect);

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _BaseSessionNav2 = __webpack_require__(108);

var _BaseSessionNav3 = _interopRequireDefault(_BaseSessionNav2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _QuickSummary = __webpack_require__(162);

var _QuickSummary2 = _interopRequireDefault(_QuickSummary);

var _omniCommonUi = __webpack_require__(0);

var _accessors = __webpack_require__(52);

var _UiState = __webpack_require__(30);

var _Group = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressTestSessionNav = function (_BaseSessionNav) {
  _inherits(ProgressTestSessionNav, _BaseSessionNav);

  function ProgressTestSessionNav() {
    _classCallCheck(this, ProgressTestSessionNav);

    return _possibleConstructorReturn(this, (ProgressTestSessionNav.__proto__ || Object.getPrototypeOf(ProgressTestSessionNav)).apply(this, arguments));
  }

  _createClass(ProgressTestSessionNav, [{
    key: '_hasNext',
    value: function _hasNext() {
      return this.props.currentProgressTestIndex < this.props.progressTestCount - 1;
    }
  }, {
    key: '_hasPrevious',
    value: function _hasPrevious() {
      return this.props.currentProgressTestIndex > 0;
    }
  }, {
    key: '_hasNextUnit',
    value: function _hasNextUnit() {
      return this.props.currentProgressTestIndex < this.props.progressTestCount - 1;
    }
  }, {
    key: '_hasPreviousUnit',
    value: function _hasPreviousUnit() {
      return this.props.currentProgressTestIndex > 0;
    }
  }, {
    key: '_getHeadingText',
    value: function _getHeadingText() {
      return this.props.currentGroupName;
    }
  }, {
    key: '_getPreviousUnitText',
    value: function _getPreviousUnitText() {
      return '< UNIT ' + this.props.currentProgressTestIndex;
    }
  }, {
    key: '_getNextUnitText',
    value: function _getNextUnitText() {
      return 'UNIT ' + (this.props.currentProgressTestIndex + 2) + ' >';
    }
  }, {
    key: '_getAdditionalChildren',
    value: function _getAdditionalChildren() {
      return _react2.default.createElement(
        'h2',
        null,
        _react2.default.createElement(_QuickSummary2.default, { type: _QuickSummary2.default.Type.progressTest,
          entityId: this.props.currentProgressTestId,
          isSSV3Group: this.props.isSSV3Group })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.currentProgressTestId) {
        return _get(ProgressTestSessionNav.prototype.__proto__ || Object.getPrototypeOf(ProgressTestSessionNav.prototype), 'render', this).call(this);
      }
      return null;
    }
  }]);

  return ProgressTestSessionNav;
}(_BaseSessionNav3.default);

ProgressTestSessionNav.propTypes = Object.assign({
  isSSV3Group: _propTypes2.default.bool,
  currentGroupName: _propTypes2.default.string,
  currentProgressTestIndex: _propTypes2.default.number.isRequired,
  currentProgressTestId: _propTypes2.default.string,
  progressTestCount: _propTypes2.default.number.isRequired,
  onNextClicked: _propTypes2.default.func,
  onPreviousClicked: _propTypes2.default.func,
  getProgressTestPlanFromIndex: _propTypes2.default.func,
  isUnitQuiz: _propTypes2.default.bool.isRequired
}, _BaseSessionNav3.default.propTypes);

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      progressTestIndex = _ownProps$params.progressTestIndex;

  if (!progressTestIndex) return;
  var buildRoute = ownProps.buildRoute,
      routes = ownProps.routes,
      isUnitQuiz = ownProps.isUnitQuiz;

  var group = state.get('rootReducer').get('groups').get(groupId) && state.get('rootReducer').get('groups').get(groupId).data;
  var progressTestsPlans = state.get('rootReducer').get('progressTestsPlan').get(groupId);
  var progressTestsPlan = progressTestsPlans && progressTestsPlans.data && progressTestsPlans.data.filter(function (ptp) {
    return ptp.isUnitQuiz === isUnitQuiz;
  });
  var currentProgressTestPlan = (0, _accessors.getProgressTestPlanFromIndex)(state, groupId, progressTestIndex, isUnitQuiz);
  if (group && progressTestsPlan) {
    var currentRoute = routes[routes.length - 1];
    return {
      isSSV3Group: !!_Group.actions.isSSV3Group(state, groupId),
      currentProgressTestId: currentProgressTestPlan.id,
      currentGroupName: group.name,
      progressTestCount: progressTestsPlan.size,
      currentProgressTestIndex: progressTestIndex,
      nextSessionLinkHref: getNextProgressTestLinkHref(progressTestIndex, currentRoute, buildRoute),
      previousSessionLinkHref: getNextProgressTestLinkHref(progressTestIndex, currentRoute, buildRoute, true),
      isHide: !_UiState.actions.getShowNavigationBar(state)
    };
  }
}

function getNextProgressTestLinkHref(index, currentRoute, buildRoute) {
  var previous = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var progressTestIndex = Number.parseInt(index, 10) + (previous ? -1 : 1);
  var sessionNavConfig = currentRoute.sessionNavConfig;

  var newRouteParams = {
    progressTestIndex: progressTestIndex
  };
  // this allows us to leave `edit` mode in the day view when displaying a new session
  if (_is_js2.default.object(sessionNavConfig) && _is_js2.default.string(sessionNavConfig.setModeOnNavigate)) {
    newRouteParams.mode = sessionNavConfig.setModeOnNavigate;
  }
  var tempRoute = buildRoute(newRouteParams);
  return buildRoute('' + tempRoute);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null)(ProgressTestSessionNav);

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1458);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _ProgressTests = __webpack_require__(40);

var _ProgressReports = __webpack_require__(94);

var _StudentReportSummaries = __webpack_require__(42);

var _ProgressTestsPlan = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressReport = function (_Component) {
  _inherits(ProgressReport, _Component);

  function ProgressReport(props) {
    _classCallCheck(this, ProgressReport);

    var _this = _possibleConstructorReturn(this, (ProgressReport.__proto__ || Object.getPrototypeOf(ProgressReport)).call(this, props));

    _this.state = {};
    return _this;
  }

  // triggered on first load


  _createClass(ProgressReport, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._fetchProgressTestAndReportModels();
      this._redirectToProgressReportList(this.props);
    }

    // triggered on PT navigation

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._fetchProgressTestAndReportModels(nextProps);
      this._redirectToProgressReportList(nextProps);
    }
  }, {
    key: '_redirectToProgressReportList',
    value: function _redirectToProgressReportList(props) {
      var groupId = props.groupId,
          defaultProgressReportId = props.defaultProgressReportId,
          buildRoute = props.buildRoute,
          replace = props.replace;

      if (!defaultProgressReportId) return;
      if (props.location.pathname.endsWith('unit-report')) {
        replace(buildRoute('/group/' + groupId + ('/unit-report/' + defaultProgressReportId)));
      }
    }
  }, {
    key: '_fetchProgressTestAndReportModels',
    value: function _fetchProgressTestAndReportModels() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var progressTest = props.progressTest,
          progressReports = props.progressReports,
          studentReportSummaries = props.studentReportSummaries,
          progressTestId = props.currentProgressTestId,
          progressReportId = props.currentProgressReportId;
      var groupId = props.params.groupId;

      props.fetchProgressTestPlanIfNeeded(groupId);
      if (!progressReportId) return;
      if (_omniCommonUi.ApiResponseHelper.shouldFetch(studentReportSummaries)) {
        props.fetchStudentReportSummaries(progressReportId);
      }
      if (_omniCommonUi.ApiResponseHelper.shouldFetch(progressReports)) {
        props.fetchProgressReport(groupId);
      } else if (_omniCommonUi.ApiResponseHelper.hasSucceeded(progressReports) && _omniCommonUi.ApiResponseHelper.shouldFetch(progressTest)) {
        props.fetchProgressTest(groupId, { id: progressTestId });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          progressTest = _props.progressTest,
          progressReport = _props.progressReport,
          progressReports = _props.progressReports,
          params = _props.params;


      if (!progressReport || !progressReports.data || !progressTest || !progressTest.data || !params.progressReportId) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: _style2.default.ProgressReport_content },
          this.props.children
        )
      );
    }
  }]);

  return ProgressReport;
}(_react.Component);

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var group = state.get('rootReducer').get('groups').get(groupId).data;
  var progressReports = group.get('progressReports');
  var defaultProgressReportId = (0, _ProgressTestsPlan.getDefaultProgressReportId)(state, groupId);
  if (!defaultProgressReportId) return;
  var currentProgressReportId = ownProps.params.progressReportId;
  if (!currentProgressReportId) {
    currentProgressReportId = (0, _ProgressTestsPlan.getDefaultProgressReportId)(state, groupId);
  }
  var studentReportSummaries = state.get('rootReducer').get('studentReportSummaries').get(currentProgressReportId);
  var progressTest = void 0;
  var progressReport = void 0;
  var currentProgressTestId = void 0;

  if (_omniCommonUi.ApiResponseHelper.hasSucceeded(progressReports)) {
    progressReport = progressReports.data.get(currentProgressReportId);
    currentProgressTestId = progressReport.progressTestId;
    progressTest = state.get('rootReducer').get('progressTests').get(currentProgressTestId);
  }

  return {
    groupId: groupId,
    groupName: group.name,
    currentProgressTestId: currentProgressTestId,
    defaultProgressReportId: defaultProgressReportId,
    currentProgressReportId: currentProgressReportId,
    progressReports: progressReports,
    progressReport: progressReport,
    progressTest: progressTest,
    studentReportSummaries: studentReportSummaries,
    params: ownProps.params
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_ProgressTests.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressReports.actions, dispatch), (0, _redux.bindActionCreators)(_StudentReportSummaries.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTestsPlan.actions, dispatch));
}

ProgressReport.getCurrentRouteSegment = function (props) {
  return props.routes[props.routes.length - 1];
};

ProgressReport.propTypes = {
  children: _propTypes2.default.node,
  progressReports: _propTypes2.default.object.isRequired,
  progressReport: _propTypes2.default.object,
  progressTest: _propTypes2.default.object,
  fetchProgressTest: _propTypes2.default.func.isRequired,
  fetchProgressReport: _propTypes2.default.func.isRequired,
  fetchStudentReportSummaries: _propTypes2.default.func.isRequired,
  params: _propTypes2.default.object.isRequired
};

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(ProgressReport);

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _StudentReportSummaries = __webpack_require__(42);

var _GroupMembers = __webpack_require__(14);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _NoContentMessage = __webpack_require__(66);

var _NoContentMessage2 = _interopRequireDefault(_NoContentMessage);

var _DosApprovalCard = __webpack_require__(1464);

var _DosApprovalCard2 = _interopRequireDefault(_DosApprovalCard);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FILTER_BY_REPORT_STATUS = 'SentToDoS';

var DosApprovalList = function (_UnsavedChangesTracki) {
  _inherits(DosApprovalList, _UnsavedChangesTracki);

  function DosApprovalList() {
    _classCallCheck(this, DosApprovalList);

    return _possibleConstructorReturn(this, (DosApprovalList.__proto__ || Object.getPrototypeOf(DosApprovalList)).apply(this, arguments));
  }

  _createClass(DosApprovalList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          fetchStudentReportSummaries = _props.fetchStudentReportSummaries,
          approvalList = _props.approvalList,
          params = _props.params;
      var progressReportId = params.progressReportId;

      if (_omniCommonUi.ApiResponseHelper.shouldFetch(approvalList)) {
        fetchStudentReportSummaries(progressReportId);
      }
      this.setState({
        cardsInEditingModeCount: 0,
        shouldTriggerSaveAllComments: false,
        isAnyCommentChanged: false
      });
      _get(DosApprovalList.prototype.__proto__ || Object.getPrototypeOf(DosApprovalList.prototype), 'componentWillMount', this).call(this);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setState({
        cardsInEditingModeCount: 0,
        shouldTriggerSaveAllComments: false,
        isAnyCommentChanged: false
      });
    }
  }, {
    key: '_isChangesPresent',
    value: function _isChangesPresent() {
      return this.state.cardsInEditingModeCount > 0 && this.state.isAnyCommentChanged;
    }
  }, {
    key: '_onCardEnterOrLeaveEditMode',
    value: function _onCardEnterOrLeaveEditMode(isLeaving) {
      var inc = isLeaving ? -1 : 1;
      this.setState(function (_ref) {
        var cardsInEditingModeCount = _ref.cardsInEditingModeCount;
        return {
          cardsInEditingModeCount: cardsInEditingModeCount + inc
        };
      });
    }
  }, {
    key: '_renderCards',
    value: function _renderCards() {
      var _this2 = this;

      var _props2 = this.props,
          approvalList = _props2.approvalList,
          approvalListForGroup = _props2.approvalListForGroup,
          params = _props2.params;
      var progressReportId = params.progressReportId;


      if (!_omniCommonUi.ApiResponseHelper.hasSucceeded(approvalList)) {
        return null;
      }

      if (approvalListForGroup.size === 0) {
        return _react2.default.createElement(_NoContentMessage2.default, { className: (0, _omniCommonUi.testClass)('empty'),
          text: 'There are no reports waiting for approval at this time.' });
      }

      return _react2.default.createElement(
        _omniCommonUi.Grid,
        null,
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          approvalListForGroup.map(function (studentReport) {
            return _react2.default.createElement(_DosApprovalCard2.default, { key: studentReport.id,
              groupId: params.groupId,
              progressReportId: progressReportId,
              studentId: studentReport.studentId,
              buildRoute: _this2.props.buildRoute,
              location: _this2.props.location,
              shouldTriggerSaveAllComments: _this2.state.shouldTriggerSaveAllComments,
              onEnterEditMode: function onEnterEditMode() {
                _this2._onCardEnterOrLeaveEditMode();
              },
              onLeaveEditMode: function onLeaveEditMode() {
                _this2._onCardEnterOrLeaveEditMode(true);
              },
              onCommentChanged: function onCommentChanged() {
                _this2.state.isAnyCommentChanged || _this2.setState({
                  isAnyCommentChanged: true
                });
              } });
          }).toArray()
        )
      );
    }
  }, {
    key: '_renderUnsavedChangesWarningDialog',
    value: function _renderUnsavedChangesWarningDialog() {
      var _this3 = this;

      return _react2.default.createElement(_UnsavedChangesWarning2.default, { isOpen: !!this._isNavigationWithChangesRequested(),
        isSaving: this.props.isAnyApiCallSaving,
        onDiscardClicked: function onDiscardClicked() {
          _this3._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this3._clearRequestedLocation();
        },
        onSaveClicked: function onSaveClicked() {
          _this3.setState({ shouldTriggerSaveAllComments: true });
        },
        onSaved: function onSaved() {
          _this3._forcePushRequestedLocation();
        } });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this._renderCards(),
        this._renderUnsavedChangesWarningDialog()
      );
    }
  }]);

  return DosApprovalList;
}(_UnsavedChangesTrackingPageComponent2.default);

DosApprovalList.propTypes = {
  fetchStudentReportSummaries: _propTypes2.default.func.isRequired,
  approvalList: _propTypes2.default.instanceOf(_omniCommonUi.ApiResponse),
  approvalListForGroup: _propTypes2.default.objectOf(_immutable.List),
  params: _propTypes2.default.shape({
    progressReportId: _propTypes2.default.string.isRequired,
    groupId: _propTypes2.default.string.isRequired
  }).isRequired,
  location: _propTypes2.default.object.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  isAnyApiCallSaving: _propTypes2.default.bool,
  route: _propTypes2.default.any.isRequired,
  router: _propTypes2.default.any.isRequired
};

function mapStateToProps(state, _ref2) {
  var params = _ref2.params;
  var progressReportId = params.progressReportId;


  var groupMemberIds = _GroupMembers.actions.getMembersByGroup(state, params.groupId).map(function (member) {
    return member.studentGeneralInfo.id;
  });

  var approvalList = state.get('rootReducer').get('studentReportSummaries').get(progressReportId);

  // we might have students who aren't in our group. filter them out.
  // we'll also take the reports with a status of "SentToDoS" here.
  var approvalListForGroup = null;
  if (_omniCommonUi.ApiResponseHelper.hasSucceeded(approvalList)) {
    approvalListForGroup = approvalList.update('data', function (data) {
      return data.filter(function (sr) {
        return sr.status === FILTER_BY_REPORT_STATUS && groupMemberIds.indexOf(sr.studentId) !== -1;
      });
    }).data;
  }

  return {
    approvalList: approvalList,
    approvalListForGroup: approvalListForGroup,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_StudentReportSummaries.actions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(DosApprovalList));

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APPROVE_STUDENT_REPORT_FAILURE = exports.APPROVE_STUDENT_REPORT_SUCCESS = exports.APPROVE_STUDENT_REPORT_REQUEST = undefined;
exports.approveStudentReport = approveStudentReport;

var _Api = __webpack_require__(11);

var _actions = __webpack_require__(200);

var _omniCommonUi = __webpack_require__(0);

var APPROVE_STUDENT_REPORT_REQUEST = exports.APPROVE_STUDENT_REPORT_REQUEST = 'APPROVE_STUDENT_REPORT_REQUEST';
var APPROVE_STUDENT_REPORT_SUCCESS = exports.APPROVE_STUDENT_REPORT_SUCCESS = 'APPROVE_STUDENT_REPORT_SUCCESS';
var APPROVE_STUDENT_REPORT_FAILURE = exports.APPROVE_STUDENT_REPORT_FAILURE = 'APPROVE_STUDENT_REPORT_FAILURE';

function approveStudentReport(progressReportId, studentReportId) {
  return function (dispatch, getState) {
    var userId = getState().get('singleSignOn').get('user').get('profile').sub;
    var url = (0, _Api.buildUrl)('/unit-reports/' + progressReportId + '/dos-submits');
    var method = 'PUT';

    return dispatch(approveStudentReportRequest()).payload.then(function (response) {
      return dispatch(approveStudentReportSuccess(response));
    }
    // So that the report summary information gets updated
    ).then(function () {
      return dispatch((0, _actions.fetchStudentReportSummaryIfNeeded)(progressReportId, studentReportId));
    }).catch(function (error) {
      return dispatch(approveStudentReportFailure(error));
    });

    function approveStudentReportRequest() {
      var payload = (0, _Api.fetch)(url, {
        method: method,
        body: JSON.stringify({
          studentReportId: Number.parseInt(studentReportId, 10),
          approvedBy: Number.parseInt(userId, 10)
        })
      });

      return _omniCommonUi.ApiCall.createAction({
        type: APPROVE_STUDENT_REPORT_REQUEST,
        payload: payload,
        url: url,
        method: method,
        progressReportId: progressReportId,
        studentReportId: studentReportId
      });
    }

    function approveStudentReportSuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: APPROVE_STUDENT_REPORT_SUCCESS,
        payload: payload,
        progressReportId: progressReportId,
        studentReportId: studentReportId,
        url: url,
        method: method
      });
    }

    function approveStudentReportFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: APPROVE_STUDENT_REPORT_FAILURE,
        error: error,
        progressReportId: progressReportId,
        studentReportId: studentReportId,
        url: url,
        method: method
      });
    }
  };
}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions2 = __webpack_require__(1468);

var _actions = _interopRequireWildcard(_actions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = _actions;
exports.default = actions;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _style = __webpack_require__(1470);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withoutClassName = function withoutClassName(props) {
  var newProps = Object.assign({}, props);
  delete newProps.className;
  return newProps;
};

var ArrowLink = function ArrowLink(props) {
  return _react2.default.createElement(
    _reactRouter.Link,
    _extends({ className: (0, _classnames2.default)(_style2.default.ArrowLink, props.className),
      draggable: false
    }, withoutClassName(props)),
    props.children,
    _react2.default.createElement(_omniCommonUi.Icon, { id: 'arrow-right', className: _style2.default.ArrowLink_arrow })
  );
};

ArrowLink.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  to: _propTypes2.default.string
};

exports.default = ArrowLink;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollToElement = __webpack_require__(1476);

var _scrollToElement2 = _interopRequireDefault(_scrollToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollPageToHereNow = function (_PureComponent) {
  _inherits(ScrollPageToHereNow, _PureComponent);

  function ScrollPageToHereNow() {
    _classCallCheck(this, ScrollPageToHereNow);

    return _possibleConstructorReturn(this, (ScrollPageToHereNow.__proto__ || Object.getPrototypeOf(ScrollPageToHereNow)).apply(this, arguments));
  }

  _createClass(ScrollPageToHereNow, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._scrollPageToNode();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._scrollPageToNode();
    }
  }, {
    key: '_scrollPageToNode',
    value: function _scrollPageToNode() {
      if (!this.node) return;
      (0, _scrollToElement2.default)(this.node, {
        offset: this.props.offset,
        ease: 'in-out-quad'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('div', { ref: function ref(_ref) {
          _this2.node = _ref;
        } });
    }
  }]);

  return ScrollPageToHereNow;
}(_react.PureComponent);

ScrollPageToHereNow.propTypes = {
  offset: _propTypes2.default.number
};

ScrollPageToHereNow.defaultProps = {
  offset: 0
};

exports.default = ScrollPageToHereNow;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentReportView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1487);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _InternalNoteView = __webpack_require__(207);

var _InternalNoteView2 = _interopRequireDefault(_InternalNoteView);

var _AddInternalNoteControl = __webpack_require__(67);

var _AddInternalNoteControl2 = _interopRequireDefault(_AddInternalNoteControl);

var _StudentReportComment = __webpack_require__(205);

var _StudentReportComment2 = _interopRequireDefault(_StudentReportComment);

var _OnlineHomework = __webpack_require__(208);

var _StudentReportSummaries = __webpack_require__(42);

var _accessors = __webpack_require__(164);

var _PaperBasedHomework = __webpack_require__(135);

var _accessors2 = __webpack_require__(41);

var _ = __webpack_require__(13);

var _GroupMembers = __webpack_require__(14);

var _ScoreBand = __webpack_require__(165);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _RejectNote = __webpack_require__(210);

var _RejectNote2 = _interopRequireDefault(_RejectNote);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _ReportStudentCard = __webpack_require__(1505);

var _ProgressTestCard = __webpack_require__(1508);

var _OverallDevelopmentCard = __webpack_require__(1513);

var _OverallDevelopmentCard2 = _interopRequireDefault(_OverallDevelopmentCard);

var _HomeworkCard = __webpack_require__(1516);

var _SkillScoreCard = __webpack_require__(1519);

var _UserCard = __webpack_require__(65);

var _UserCard2 = _interopRequireDefault(_UserCard);

var _ExportDialog = __webpack_require__(1522);

var _ExportDialog2 = _interopRequireDefault(_ExportDialog);

var _routes = __webpack_require__(668);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentReportView = exports.StudentReportView = function (_UnsavedChangesTracki) {
  _inherits(StudentReportView, _UnsavedChangesTracki);

  function StudentReportView(props) {
    _classCallCheck(this, StudentReportView);

    var _this = _possibleConstructorReturn(this, (StudentReportView.__proto__ || Object.getPrototypeOf(StudentReportView)).call(this, props));

    _this.state = { wasCommentEditMade: false };
    return _this;
  }

  _createClass(StudentReportView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.fetchOnlineHomeworkIfNeeded(this.props.groupId);
      this.props.fetchGroupPaperBasedHomeworkIfNeeded(this.props.groupId);
      this.props.fetchScoreBandIfNeeded(this.props.language);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setState({ wasCommentEditMade: false });
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave(nextLocation) {
      var _props = this.props,
          progressReportId = _props.progressReportId,
          studentReportSummary = _props.studentReportSummary,
          studentId = _props.studentId,
          submitStudentReportSummaryTeacherPublish = _props.submitStudentReportSummaryTeacherPublish,
          groupId = _props.groupId;

      if (nextLocation && nextLocation.pathname.endsWith('/publish')) {
        var studentReportSummaryIds = new _immutable.List([studentReportSummary.id]);
        submitStudentReportSummaryTeacherPublish(progressReportId, groupId, studentReportSummaryIds, studentId);
        // we want the changes dialog to show for this new route, so we won't use _forcePushRoute
        this.props.pushRoute(this.props.buildRoute({ mode: '' }));
      } else {
        return _get(StudentReportView.prototype.__proto__ || Object.getPrototypeOf(StudentReportView.prototype), 'routerWillLeave', this).call(this, nextLocation);
      }
    }
  }, {
    key: '_isChangesPresent',
    value: function _isChangesPresent() {
      var studentReportComment = this.props.studentReportComment;

      if (StudentReportView.isInAddCommentMode(this.props)) {
        return this.state.comment && this.state.comment.length;
      } else if (StudentReportView.isInEditCommentMode(this.props)) {
        return !!this.state.wasCommentEditMade || studentReportComment !== this.state.comment;
      }
      return false;
    }
  }, {
    key: '_goToViewModeAfterSaveOrDiscard',
    value: function _goToViewModeAfterSaveOrDiscard() {
      this._forcePushRoute(this.props.buildRoute({ mode: '' }), {
        comment: undefined
      });
    }
  }, {
    key: '_onDiscardCommentClick',
    value: function _onDiscardCommentClick() {
      _reactGa2.default.event({
        category: 'Progress Reports',
        action: 'Clicked "Discard"'
      });

      this._goToViewModeAfterSaveOrDiscard();
    }
  }, {
    key: '_onSaveComment',
    value: function _onSaveComment(text) {
      _reactGa2.default.event({
        category: 'Progress Reports',
        action: 'Clicked "Save"'
      });

      this._goToViewModeAfterSaveOrDiscard();
      var _props2 = this.props,
          progressReportId = _props2.progressReportId,
          studentReportId = _props2.studentReportId,
          submitStudentReportComment = _props2.submitStudentReportComment,
          fetchStudentReportSummary = _props2.fetchStudentReportSummary,
          studentId = _props2.studentId;

      submitStudentReportComment(progressReportId, studentReportId, text, studentId).then(function () {
        return fetchStudentReportSummary(progressReportId, studentId);
      });
    }
  }, {
    key: '_onCommentChanged',
    value: function _onCommentChanged(text) {
      this.setState({
        comment: text,
        wasCommentEditMade: true
      });
    }
  }, {
    key: '_isCommentEmpty',
    value: function _isCommentEmpty() {
      return !this.state.comment || _is_js2.default.empty(this.state.comment.trim());
    }
  }, {
    key: '_onDeleteComment',
    value: function _onDeleteComment() {
      _reactGa2.default.event({
        category: 'Progress Reports',
        action: 'Clicked "Delete"'
      });

      this._openDeleteCommentConfirmation();
    }
  }, {
    key: '_onDeleteCommentCancelled',
    value: function _onDeleteCommentCancelled() {
      _reactGa2.default.event({
        category: 'Progress Reports',
        action: 'Clicked "Cancel"'
      });

      this._closeDeleteCommentConfirmation();
    }
  }, {
    key: '_onDeleteCommentConfirmed',
    value: function _onDeleteCommentConfirmed() {
      _reactGa2.default.event({
        category: 'Progress Reports',
        action: 'Clicked "Delete"'
      });

      this._closeDeleteCommentConfirmation();
      var _props3 = this.props,
          progressReportId = _props3.progressReportId,
          studentReportId = _props3.studentReportId,
          deleteStudentReportComment = _props3.deleteStudentReportComment,
          fetchStudentReportSummary = _props3.fetchStudentReportSummary,
          studentId = _props3.studentId;

      deleteStudentReportComment(progressReportId, studentReportId, studentId).then(function () {
        return fetchStudentReportSummary(progressReportId, studentId);
      });
    }
  }, {
    key: '_openDeleteCommentConfirmation',
    value: function _openDeleteCommentConfirmation() {
      this.setState({ showDeleteConfirm: true }, function () {
        _reactGa2.default.send({
          hitType: 'pageview',
          page: window.location.pathname,
          location: window.location.href,
          title: document.title,
          modal: 'delete-report-comment-confirmation'
        });
      });
    }
  }, {
    key: '_closeDeleteCommentConfirmation',
    value: function _closeDeleteCommentConfirmation() {
      this.setState({ showDeleteConfirm: false }, function () {
        _reactGa2.default.send({
          hitType: 'pageview',
          page: window.location.pathname,
          location: window.location.href,
          title: document.title
        });
      });
    }
  }, {
    key: '_onEditComment',
    value: function _onEditComment(comment) {
      _reactGa2.default.event({
        category: 'Progress Reports',
        action: 'Clicked "Edit"'
      });

      this.setState({ comment: comment });
      this.props.pushRoute(this.props.buildRoute({ mode: 'edit-comment' }));
    }
  }, {
    key: '_isCommentEditable',
    value: function _isCommentEditable(reportStatus) {
      return this.props.canAddComment && (!_is_js2.default.undefined(reportStatus) && reportStatus !== _StudentReportSummaries.StudentReportSummary.Status.SentToDoS && reportStatus !== _StudentReportSummaries.StudentReportSummary.Status.Completed && reportStatus !== _StudentReportSummaries.StudentReportSummary.Status.Published || this.props.canUpdatePublishedProgressReport);
    }
  }, {
    key: '_renderExportDialog',
    value: function _renderExportDialog() {
      var _props4 = this.props,
          buildRoute = _props4.buildRoute,
          pushRoute = _props4.pushRoute,
          languageCode = _props4.languageCode,
          progressReportId = _props4.progressReportId,
          studentReportSummary = _props4.studentReportSummary,
          studentId = _props4.studentId;

      var isInExportRoute = this.props.params.mode === _routes.Modes.EXPORT;
      return isInExportRoute && _react2.default.createElement(_ExportDialog2.default, {
        progressReportId: progressReportId,
        languageCode: languageCode,
        pushRoute: pushRoute,
        buildRoute: buildRoute,
        studentReportSummary: studentReportSummary,
        studentId: studentId
      });
    }
  }, {
    key: '_renderCommentsViewMode',
    value: function _renderCommentsViewMode(comment, reportStatus) {
      var _props5 = this.props,
          studentReportSummary = _props5.studentReportSummary,
          timeZone = _props5.timeZone;

      var commentViewMode = {
        note: comment,
        userId: studentReportSummary && studentReportSummary.commentedByUserId,
        date: studentReportSummary && studentReportSummary.commentedTimeUtc,
        timeZone: timeZone
      };
      return _react2.default.createElement(_InternalNoteView2.default, {
        note: commentViewMode,
        canOperate: this._isCommentEditable(reportStatus),
        hideActionButtons: true
      });
    }
  }, {
    key: '_renderCommentsEditor',
    value: function _renderCommentsEditor() {
      var _this2 = this;

      return _react2.default.createElement(_AddInternalNoteControl2.default, {
        text: this.state.comment,
        maxCharacters: 500,
        onChange: function onChange(text) {
          return _this2._onCommentChanged(text);
        },
        onDiscardClick: function onDiscardClick() {
          return _this2._onDiscardCommentClick();
        },
        onSaveClick: function onSaveClick(text) {
          return _this2._onSaveComment(text);
        }
      });
    }
  }, {
    key: '_renderActionIcons',
    value: function _renderActionIcons(reportStatus, studentReportComment) {
      var _this3 = this;

      if (!this._isCommentEditable(reportStatus) || StudentReportView.isInAddCommentMode(this.props) || StudentReportView.isInEditCommentMode(this.props)) {
        return null;
      }

      return [_react2.default.createElement(
        _omniCommonUi.Tooltip,
        {
          className: _style2.default.StudentReportView_card_icon,
          text: 'Edit',
          placement: 'top',
          trigger: ['hover']
        },
        _react2.default.createElement(_omniCommonUi.Icon, {
          id: 'edit',
          onClick: function onClick() {
            return _this3._onEditComment(studentReportComment);
          }
        })
      ), _react2.default.createElement(
        _omniCommonUi.Tooltip,
        {
          className: _style2.default.StudentReportView_card_icon,
          text: 'Delete',
          placement: 'top',
          trigger: ['hover']
        },
        _react2.default.createElement(_omniCommonUi.Icon, {
          id: 'trash',
          title: 'Delete',
          onClick: function onClick() {
            return _this3._onDeleteComment();
          }
        })
      )];
    }
  }, {
    key: '_renderStudentReportComment',
    value: function _renderStudentReportComment(comment, reportStatus) {
      if (StudentReportView.isInAddCommentMode(this.props) || StudentReportView.isInEditCommentMode(this.props)) {
        return this._renderCommentsEditor(comment);
      }
      return this._renderCommentsViewMode(comment, reportStatus);
    }
  }, {
    key: '_renderUnitSummary',
    value: function _renderUnitSummary() {
      var progressReportUnitSummary = this.props.progressReportUnitSummary;

      if (!progressReportUnitSummary) {
        return null;
      }

      return _react2.default.createElement(
        _omniCommonUi.Grid.Item,
        { xs: 12, sm: 12, md: 12, lg: 12 },
        _react2.default.createElement(
          _omniCommonUi.PageCard,
          { className: (0, _classnames2.default)(_style2.default.StudentReportView_card) },
          _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Unit Summary' }),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.StudentReportView_unitSummary_body },
            progressReportUnitSummary
          )
        )
      );
    }
  }, {
    key: '_renderTeacherCommentsGridItem',
    value: function _renderTeacherCommentsGridItem(studentReportComment, reportStatus) {
      if (StudentReportView.isInAddCommentMode(this.props)) {
        return _react2.default.createElement(
          _omniCommonUi.Grid.Item,
          { xs: 12, sm: 12, md: 12, lg: 12 },
          _react2.default.createElement(
            _omniCommonUi.PageCard,
            { className: (0, _classnames2.default)(_style2.default.StudentReportView_card) },
            _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Teacher\'s Comment' }),
            _react2.default.createElement(
              _omniCommonUi.PageCard.Content,
              null,
              this._renderStudentReportComment()
            )
          )
        );
      }

      if (studentReportComment && studentReportComment.length > 0) {
        return _react2.default.createElement(
          _omniCommonUi.Grid.Item,
          { xs: 12, sm: 12, md: 12, lg: 12 },
          _react2.default.createElement(
            _omniCommonUi.PageCard,
            { className: (0, _classnames2.default)(_style2.default.StudentReportView_card) },
            _react2.default.createElement(
              _omniCommonUi.PageCard.Heading,
              { text: 'Teacher\'s Comment', stackMode: 'horizontal' },
              this._renderActionIcons(reportStatus, studentReportComment)
            ),
            _react2.default.createElement(
              _omniCommonUi.PageCard.Content,
              null,
              this._renderStudentReportComment(studentReportComment, reportStatus)
            )
          )
        );
      }

      return null;
    }
  }, {
    key: '_renderProgressTestCardGridItem',
    value: function _renderProgressTestCardGridItem(percentage, publishedDateStr, name, isSSCourseTypeGroup, isSSV3Group) {
      if (_is_js2.default.not.number(percentage) || isSSV3Group) {
        return null;
      }

      return _react2.default.createElement(
        _omniCommonUi.Grid.Item,
        { xs: 12, sm: 12, md: 6, lg: 6 },
        _react2.default.createElement(_ProgressTestCard.ProgressTestCard, {
          className: _style2.default.StudentReportView_card,
          percentage: percentage,
          publishedDateStr: publishedDateStr,
          name: name,
          isSSCourseTypeGroup: isSSCourseTypeGroup
        })
      );
    }
  }, {
    key: '_shouldShowPaperBasedInHomeworkCard',
    value: function _shouldShowPaperBasedInHomeworkCard() {
      return !!this.props.hasPaperBasedHomework;
    }
  }, {
    key: '_renderHomeworkCardGridItem',
    value: function _renderHomeworkCardGridItem() {
      var _props6 = this.props,
          onlineHomeworkResult = _props6.onlineHomeworkResult,
          paperBasedHomeworkResult = _props6.paperBasedHomeworkResult;

      if (_is_js2.default.undefined(this.props.onlineHomeworkResult)) {
        return null;
      }

      return _react2.default.createElement(
        _omniCommonUi.Grid.Item,
        { xs: 12, sm: 12, md: 6, lg: 6 },
        _react2.default.createElement(_HomeworkCard.HomeworkCard, {
          className: _style2.default.StudentReportView_card,
          averageScorePercentage: onlineHomeworkResult.averageScorePercentage,
          completedAssignments: onlineHomeworkResult.completedAssignments,
          totalAssignments: onlineHomeworkResult.totalAssignments,
          shouldShowPaperBased: this._shouldShowPaperBasedInHomeworkCard(),
          completedPaperBased: paperBasedHomeworkResult.completedAssignments,
          totalPaperBased: paperBasedHomeworkResult.totalAssignments
        })
      );
    }
  }, {
    key: '_renderOverallDevelopmentCard',
    value: function _renderOverallDevelopmentCard(studentProgressTestResult, progressTestSkills, isSSV3CourseTypeGroup) {
      if (!isSSV3CourseTypeGroup) {
        return null;
      }

      var rubricSkills = progressTestSkills.filter(function (s) {
        return s.isRubric;
      });
      var rubricSkillResults = studentProgressTestResult.skillResults.filter(function (sr) {
        return sr.isRubric;
      });
      return _react2.default.createElement(
        _omniCommonUi.Grid.Item,
        { xs: 12, sm: 12, md: 12, lg: 12 },
        _react2.default.createElement(_OverallDevelopmentCard2.default, {
          className: _style2.default.StudentReportView_card,
          skills: rubricSkills,
          skillResults: rubricSkillResults
        })
      );
    }
  }, {
    key: '_renderSkillScoreCardGridItems',
    value: function _renderSkillScoreCardGridItems(studentProgressTestResult, progressTestSkills, isSSCourseTypeGroup, isSSV3Group) {
      var getStudentResultForSkill = function getStudentResultForSkill(skillId) {
        return studentProgressTestResult.skillResults.find(function (sr) {
          return sr.skillId === skillId;
        });
      };

      var items = progressTestSkills.filter(function (skill) {
        var studentResultForSkill = getStudentResultForSkill(skill.skillId);
        if (isSSV3Group && studentResultForSkill.isRubric) {
          return false;
        }
        return _is_js2.default.number(studentResultForSkill.currentResult);
      }).map(function (skill) {
        var studentResultForSkill = getStudentResultForSkill(skill.skillId);
        var percentage = Number.parseInt(studentResultForSkill.currentResult / studentResultForSkill.fullMark * 100, 10);
        return _react2.default.createElement(
          _omniCommonUi.Grid.Item,
          { key: skill.skillId, xs: 12, sm: 12, md: 6, lg: 6 },
          _react2.default.createElement(_SkillScoreCard.SkillScoreCard, {
            skillName: skill.name,
            skillDescription: skill.description,
            scorePercentage: percentage,
            isSSCourseTypeGroup: isSSCourseTypeGroup,
            studentResultForSkill: studentResultForSkill
          })
        );
      });
      return items;
    }
  }, {
    key: '_renderDeleteCommentDialog',
    value: function _renderDeleteCommentDialog() {
      var _this4 = this;

      return _react2.default.createElement(_omniCommonUi.ConfirmDialog, {
        isOpen: this.state.showDeleteConfirm,
        content: 'Are you sure you want to delete this comment?',
        primaryButtonContent: 'CANCEL',
        secondaryButtonContent: 'DELETE',
        onPrimaryClick: function onPrimaryClick() {
          return _this4._onDeleteCommentCancelled();
        },
        onSecondaryClick: function onSecondaryClick() {
          return _this4._onDeleteCommentConfirmed();
        }
      });
    }
  }, {
    key: '_renderUnsavedChangesWarningDialog',
    value: function _renderUnsavedChangesWarningDialog() {
      var _this5 = this;

      if (StudentReportView.isInEditCommentMode(this.props) && this._isCommentEmpty()) {
        return _react2.default.createElement(_omniCommonUi.ConfirmDialog, {
          isOpen: !!this._isNavigationWithChangesRequested(),
          primaryButtonContent: 'Stay',
          secondaryButtonContent: 'Leave',
          content: 'Are you sure you want to leave this page and lose unsaved changes?',
          onPrimaryClick: function onPrimaryClick() {
            _this5._clearRequestedLocation();
          },
          onSecondaryClick: function onSecondaryClick() {
            _this5._forcePushRequestedLocation();
          },
          onRequestClose: function onRequestClose() {
            _this5._clearRequestedLocation();
          }
        });
      }
      return _react2.default.createElement(_UnsavedChangesWarning2.default, {
        isOpen: !!this._isNavigationWithChangesRequested(),
        isSaving: this.props.isAnyApiCallSaving,
        onSaveClicked: function onSaveClicked() {
          var text = _this5.state.comment;

          _this5._onSaveComment(text);
        },
        onDiscardClicked: function onDiscardClicked() {
          _this5._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this5._clearRequestedLocation();
        },
        onSaved: function onSaved() {
          _this5._forcePushRequestedLocation();
        }
      });
    }
  }, {
    key: '_renderRjectNote',
    value: function _renderRjectNote() {
      var _props7 = this.props,
          _props7$studentReport = _props7.studentReportSummary,
          studentReportSummary = _props7$studentReport === undefined ? {} : _props7$studentReport,
          timeZone = _props7.timeZone;

      var reportStatus = studentReportSummary.status || '';
      var dosRejectedComment = studentReportSummary && studentReportSummary.dosRejectedComment;

      return dosRejectedComment && reportStatus.toLowerCase() === _StudentReportSummaries.StudentReportSummary.Status.Rejected.toLowerCase() && _react2.default.createElement(_RejectNote2.default, {
        note: dosRejectedComment.rejectedComment,
        rejectTime: dosRejectedComment.rejectedDate,
        timeZone: timeZone,
        teacherId: dosRejectedComment.rejectedBy
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props8 = this.props,
          group = _props8.group,
          member = _props8.member,
          progressTest = _props8.progressTest,
          progressTestUnitName = _props8.progressTestUnitName,
          studentProgressTestResult = _props8.studentProgressTestResult,
          studentReportComment = _props8.studentReportComment,
          studentReportSummary = _props8.studentReportSummary,
          isSSCourseTypeGroup = _props8.isSSCourseTypeGroup,
          isSSV3Group = _props8.isSSV3Group,
          timeZone = _props8.timeZone;
      var progressTestSkills = progressTest.data.skills;


      if (_is_js2.default.undefined(member)) {
        return null;
      }
      var studentGeneralInfo = member.studentGeneralInfo;

      var studentName = studentGeneralInfo.firstName + ' ' + studentGeneralInfo.lastName;
      var teachers = group.get('teachers');

      var reportStatus = void 0;
      var reportPublishedDateStr = null;
      if (!_is_js2.default.undefined(studentReportSummary)) {
        reportStatus = studentReportSummary.status;
        reportPublishedDateStr = studentReportSummary.publishedTimeUtc ? _omniCommonUi.moment.utc(studentReportSummary.publishedTimeUtc).clone().tz(timeZone).format('YYYY-MM-DD') : null;
      }

      return _react2.default.createElement(
        'div',
        null,
        this._renderExportDialog(),
        this._renderUnsavedChangesWarningDialog(),
        this._renderDeleteCommentDialog(),
        _react2.default.createElement(
          _omniCommonUi.Grid,
          null,
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12, sm: 12, md: 12, lg: 12 },
              this._renderRjectNote()
            ),
            this._renderUnitSummary(),
            _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12, sm: 12, md: 6, lg: 6 },
              _react2.default.createElement(_ReportStudentCard.ReportStudentCard, {
                studentName: studentName,
                studentGeneralInfo: studentGeneralInfo,
                member: member,
                reportStatus: _is_js2.default.undefined(reportStatus) ? '-' : reportStatus,
                submittedDate: reportPublishedDateStr
              })
            ),
            _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12, sm: 12, md: 6, lg: 6 },
              _react2.default.createElement(
                _omniCommonUi.PageCard,
                {
                  className: (0, _classnames2.default)(_style2.default.StudentReportView_card, _style2.default.StudentReportView_teachers_card)
                },
                _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Teachers' }),
                _react2.default.createElement(
                  _omniCommonUi.PageCard.Content,
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: _style2.default.StudentReportView_teachers_list },
                    teachers.map(function (teacher) {
                      return _react2.default.createElement(_UserCard2.default, {
                        id: '' + teacher.get('userId'),
                        key: 'user-' + teacher.get('userId'),
                        className: _style2.default.StudentReportView_teachers_item
                      });
                    })
                  )
                )
              )
            ),
            this._renderProgressTestCardGridItem(studentProgressTestResult.totalScore.percentage, reportPublishedDateStr, progressTestUnitName, isSSCourseTypeGroup, isSSV3Group),
            this._renderHomeworkCardGridItem(),
            this._renderTeacherCommentsGridItem(studentReportComment, reportStatus)
          ),
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            this._renderOverallDevelopmentCard(studentProgressTestResult, progressTestSkills, isSSV3Group),
            this._renderSkillScoreCardGridItems(studentProgressTestResult, progressTestSkills, isSSCourseTypeGroup, isSSV3Group)
          )
        )
      );
    }
  }]);

  return StudentReportView;
}(_UnsavedChangesTrackingPageComponent2.default);

StudentReportView.isInAddCommentMode = function (props) {
  return props.params && props.params.mode === 'add-comment';
};

StudentReportView.isInEditCommentMode = function (props) {
  return props.params && props.params.mode === 'edit-comment';
};

StudentReportView.propTypes = {
  group: _propTypes2.default.object,
  member: _propTypes2.default.object.isRequired,
  timeZone: _propTypes2.default.string.isRequired,
  hasPaperBasedHomework: _propTypes2.default.bool,
  progressReportId: _propTypes2.default.string,
  progressTestUnitName: _propTypes2.default.string,
  progressTest: _propTypes2.default.object,
  studentProgressTestResult: _propTypes2.default.object,
  studentReportSummary: _propTypes2.default.object,
  studentId: _propTypes2.default.string,
  studentReportId: _propTypes2.default.string,
  groupId: _propTypes2.default.string,
  studentReportComment: _propTypes2.default.object,
  progressReportUnitSummary: _propTypes2.default.string,
  pushRoute: _propTypes2.default.func,
  deleteStudentReportComment: _propTypes2.default.func,
  fetchStudentReportComment: _propTypes2.default.func,
  fetchStudentReportSummary: _propTypes2.default.func,
  fetchOnlineHomeworkIfNeeded: _propTypes2.default.func,
  fetchGroupPaperBasedHomeworkIfNeeded: _propTypes2.default.func,
  submitStudentReportComment: _propTypes2.default.func,
  submitStudentReportSummaryTeacherPublish: _propTypes2.default.func,
  onlineHomeworkResult: _propTypes2.default.object,
  paperBasedHomeworkResult: _propTypes2.default.object,
  buildRoute: _propTypes2.default.func.isRequired,
  router: _propTypes2.default.any.isRequired,
  routes: _propTypes2.default.array.isRequired,
  route: _propTypes2.default.any.isRequired,
  location: _propTypes2.default.any.isRequired,
  canAddComment: _propTypes2.default.bool,
  canUpdatePublishedProgressReport: _propTypes2.default.bool,
  isAnyApiCallSaving: _propTypes2.default.bool,
  isSSCourseTypeGroup: _propTypes2.default.bool,
  isSSV3Group: _propTypes2.default.bool,
  language: _propTypes2.default.string,
  languageCode: _propTypes2.default.string
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      studentId = _ownProps$params.studentId,
      progressReportId = _ownProps$params.progressReportId;

  var _Group$getCentre = _.actions.getCentre(state, groupId),
      timeZone = _Group$getCentre.timeZone;

  var hasPaperBasedHomework = _.actions.hasPaperBasedHomework(state, groupId);
  var canAddComment = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.ProgressReport.AddComment);
  var canUpdatePublishedProgressReport = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.ProgressReport.UpdatePublishedProgressReport);
  var group = state.get('rootReducer').get('groups').get(groupId).data;
  var member = _GroupMembers.actions.getMemberById(state, studentId);
  var studentReportSummaries = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data;
  var progressTestsPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId).data;
  var studentReportSummary = studentReportSummaries && studentReportSummaries.get('' + studentId);
  var studentReportComment = studentReportSummary && studentReportSummary.comments;
  var progressReportRecord = group.progressReports.data.get(progressReportId);
  var progressReportUnitSummary = (0, _accessors.getCombinedUnitSummariesText)(progressReportRecord);
  var progressTestId = progressReportRecord.progressTestId;

  var progressTest = state.get('rootReducer').get('progressTests').get(progressTestId);
  var studentProgressTestResult = void 0;
  if (_omniCommonUi.ApiResponseHelper.hasSucceeded(progressTest)) {
    studentProgressTestResult = progressTest.data.studentProgressTestResults.get(studentId);
  }

  var currentUnits = progressTestsPlan.find(function (plan) {
    return plan.progressReportId === progressReportId;
  }).unitIds;
  var units = (0, _accessors2.getUnitList)(state, groupId) || [];
  var progressTestUnit = units.filter(function (unit) {
    return currentUnits.includes(unit.id);
  }).toList().get(0);
  var onlineHomeworkResult = studentReportSummary && studentReportSummary.onlineHomeworkResult;
  var paperBasedHomeworkResult = studentReportSummary && studentReportSummary.paperBasedHomeworkResult;

  var language = state.get('rootReducer').get('language');
  var languageCode = group.languageCode;
  return {
    group: group,
    timeZone: timeZone,
    hasPaperBasedHomework: hasPaperBasedHomework,
    member: member,
    progressReportId: progressReportId,
    progressTestUnitName: progressTestUnit && progressTestUnit.name,
    progressTest: progressTest,
    studentProgressTestResult: studentProgressTestResult,
    studentReportSummary: studentReportSummary,
    studentReportId: studentReportSummary && studentReportSummary.id,
    studentId: studentId,
    groupId: groupId,
    studentReportComment: studentReportComment,
    progressReportUnitSummary: progressReportUnitSummary,
    canAddComment: canAddComment,
    canUpdatePublishedProgressReport: canUpdatePublishedProgressReport,
    onlineHomeworkResult: onlineHomeworkResult,
    paperBasedHomeworkResult: paperBasedHomeworkResult,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state),
    isSSCourseTypeGroup: !!_.actions.isSSCourseTypeGroup(state, groupId),
    isSSV3Group: !!_.actions.isSSV3Group(state, groupId),
    language: language,
    languageCode: languageCode
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_StudentReportSummaries.actions, dispatch), (0, _redux.bindActionCreators)(_StudentReportComment2.default, dispatch), (0, _redux.bindActionCreators)(_OnlineHomework.actions, dispatch), (0, _redux.bindActionCreators)(_ScoreBand.actions, dispatch), (0, _redux.bindActionCreators)(_PaperBasedHomework.actions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(StudentReportView));

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_ONLINE_HOMEWORK_FAILURE = exports.FETCH_ONLINE_HOMEWORK_SUCCESS = exports.FETCH_ONLINE_HOMEWORK_REQUEST = undefined;
exports.fetchOnlineHomeworkIfNeeded = fetchOnlineHomeworkIfNeeded;
exports.fetchOnlineHomework = fetchOnlineHomework;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_ONLINE_HOMEWORK_REQUEST = exports.FETCH_ONLINE_HOMEWORK_REQUEST = 'FETCH_ONLINE_HOMEWORK_REQUEST';
var FETCH_ONLINE_HOMEWORK_SUCCESS = exports.FETCH_ONLINE_HOMEWORK_SUCCESS = 'FETCH_ONLINE_HOMEWORK_SUCCESS';
var FETCH_ONLINE_HOMEWORK_FAILURE = exports.FETCH_ONLINE_HOMEWORK_FAILURE = 'FETCH_ONLINE_HOMEWORK_FAILURE';

var buildHomeworkUrl = function buildHomeworkUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/online-homework-results');
};

function fetchOnlineHomeworkIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildHomeworkUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchOnlineHomework(groupId));
  };
}

function fetchOnlineHomework(groupId) {
  return function (dispatch) {
    var url = buildHomeworkUrl(groupId);
    var method = 'GET';

    return dispatch(fetchOnlineHomeworkRequest()).payload.then(function (response) {
      return dispatch(fetchOnlineHomeworkSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchOnlineHomeworkFailure(error));
    });

    function fetchOnlineHomeworkRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ONLINE_HOMEWORK_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchOnlineHomeworkSuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ONLINE_HOMEWORK_SUCCESS,
        payload: payload,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchOnlineHomeworkFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ONLINE_HOMEWORK_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentOnlineHomeworkRecord = (0, _immutable.Record)({
  accuracy: undefined,
  completion: undefined,
  sessionId: undefined,
  studentId: undefined
});

var StudentOnlineHomework = function (_StudentOnlineHomewor) {
  _inherits(StudentOnlineHomework, _StudentOnlineHomewor);

  function StudentOnlineHomework() {
    _classCallCheck(this, StudentOnlineHomework);

    return _possibleConstructorReturn(this, (StudentOnlineHomework.__proto__ || Object.getPrototypeOf(StudentOnlineHomework)).apply(this, arguments));
  }

  return StudentOnlineHomework;
}(StudentOnlineHomeworkRecord);

exports.default = StudentOnlineHomework;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBMIT_PAPERBASE_HOMEWORK_FAILURE = exports.SUBMIT_PAPERBASE_HOMEWORK_SUCCESS = exports.SUBMIT_PAPERBASE_HOMEWORK_REQUEST = exports.FETCH_GROUP_PAPERBASE_HOMEWORK_FAILURE = exports.FETCH_GROUP_PAPERBASE_HOMEWORK_SUCCESS = exports.FETCH_GROUP_PAPERBASE_HOMEWORK_REQUEST = exports.FETCH_PAPERBASE_HOMEWORK_FAILURE = exports.FETCH_PAPERBASE_HOMEWORK_SUCCESS = exports.FETCH_PAPERBASE_HOMEWORK_REQUEST = undefined;
exports.fetchPaperBasedHomeworkIfNeeded = fetchPaperBasedHomeworkIfNeeded;
exports.fetchPaperBasedHomework = fetchPaperBasedHomework;
exports.fetchGroupPaperBasedHomeworkIfNeeded = fetchGroupPaperBasedHomeworkIfNeeded;
exports.fetchGroupPaperBasedHomework = fetchGroupPaperBasedHomework;
exports.submitMarkPaperBasedHomework = submitMarkPaperBasedHomework;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _immutable = __webpack_require__(3);

var _StudentReportSummaries = __webpack_require__(42);

var _accessors = __webpack_require__(164);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var FETCH_PAPERBASE_HOMEWORK_REQUEST = exports.FETCH_PAPERBASE_HOMEWORK_REQUEST = 'FETCH_PAPERBASE_HOMEWORK_REQUEST';
var FETCH_PAPERBASE_HOMEWORK_SUCCESS = exports.FETCH_PAPERBASE_HOMEWORK_SUCCESS = 'FETCH_PAPERBASE_HOMEWORK_SUCCESS';
var FETCH_PAPERBASE_HOMEWORK_FAILURE = exports.FETCH_PAPERBASE_HOMEWORK_FAILURE = 'FETCH_PAPERBASE_HOMEWORK_FAILURE';
var FETCH_GROUP_PAPERBASE_HOMEWORK_REQUEST = exports.FETCH_GROUP_PAPERBASE_HOMEWORK_REQUEST = 'FETCH_GROUP_PAPERBASE_HOMEWORK_REQUEST';
var FETCH_GROUP_PAPERBASE_HOMEWORK_SUCCESS = exports.FETCH_GROUP_PAPERBASE_HOMEWORK_SUCCESS = 'FETCH_GROUP_PAPERBASE_HOMEWORK_SUCCESS';
var FETCH_GROUP_PAPERBASE_HOMEWORK_FAILURE = exports.FETCH_GROUP_PAPERBASE_HOMEWORK_FAILURE = 'FETCH_GROUP_PAPERBASE_HOMEWORK_FAILURE';
var SUBMIT_PAPERBASE_HOMEWORK_REQUEST = exports.SUBMIT_PAPERBASE_HOMEWORK_REQUEST = 'SUBMIT_PAPERBASE_HOMEWORK_REQUEST';
var SUBMIT_PAPERBASE_HOMEWORK_SUCCESS = exports.SUBMIT_PAPERBASE_HOMEWORK_SUCCESS = 'SUBMIT_PAPERBASE_HOMEWORK_SUCCESS';
var SUBMIT_PAPERBASE_HOMEWORK_FAILURE = exports.SUBMIT_PAPERBASE_HOMEWORK_FAILURE = 'SUBMIT_PAPERBASE_HOMEWORK_FAILURE';

var buildFetchPaperBasedHomeworkUrl = function buildFetchPaperBasedHomeworkUrl(id) {
  return (0, _Api.buildUrl)('/sessions/' + id + '/student-homework-result');
};

function fetchPaperBasedHomeworkIfNeeded(id) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchPaperBasedHomeworkUrl(id) })) {
      return false;
    }

    return dispatch(fetchPaperBasedHomework(id));
  };
}

function fetchPaperBasedHomework(id) {
  return function (dispatch) {
    var url = buildFetchPaperBasedHomeworkUrl(id);
    var method = 'GET';

    return dispatch(fetchPaperBasedHomeworkRequest()).payload.then(function (response) {
      return dispatch(fetchPaperBasedHomeworkSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchPaperBasedHomeworkFailure(error));
    });

    function fetchPaperBasedHomeworkRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PAPERBASE_HOMEWORK_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        id: id
      });
    }

    function fetchPaperBasedHomeworkSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PAPERBASE_HOMEWORK_SUCCESS,
        payload: response,
        url: url,
        method: method,
        id: id
      });
    }

    function fetchPaperBasedHomeworkFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PAPERBASE_HOMEWORK_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

var buildFetchGroupPaperBasedHomeworkUrl = function buildFetchGroupPaperBasedHomeworkUrl(id) {
  return (0, _Api.buildUrl)('/groups/' + id + '/student-homework-result');
};

function fetchGroupPaperBasedHomeworkIfNeeded(id) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchGroupPaperBasedHomeworkUrl(id) })) {
      return false;
    }

    return dispatch(fetchGroupPaperBasedHomework(id));
  };
}

function fetchGroupPaperBasedHomework(id) {
  return function (dispatch) {
    var url = buildFetchGroupPaperBasedHomeworkUrl(id);
    var method = 'GET';

    return dispatch(fetchGroupPaperBasedHomeworkRequest()).payload.then(function (response) {
      return dispatch(fetchGroupPaperBasedHomeworkSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchGroupPaperBasedHomeworkFailure(error));
    });

    function fetchGroupPaperBasedHomeworkRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUP_PAPERBASE_HOMEWORK_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method
      });
    }

    function fetchGroupPaperBasedHomeworkSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUP_PAPERBASE_HOMEWORK_SUCCESS,
        payload: response,
        url: url,
        method: method
      });
    }

    function fetchGroupPaperBasedHomeworkFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_GROUP_PAPERBASE_HOMEWORK_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

function submitMarkPaperBasedHomework(id, paperBasedList) {
  var homework = paperBasedList;
  if (_immutable.List.isList(homework)) {
    homework = homework.toArray();
  }
  homework = homework.map(function (paperBased) {
    return {
      lessonNumber: Number(paperBased.lessonNumber),
      sessionId: Number(id),
      unitId: Number(paperBased.unitId),
      studentPaperBasedHomeworks: paperBased.studentPaperBasedHomeworks.reduce(function (arr, hw) {
        return [].concat(_toConsumableArray(arr), [{
          homeworkStatus: hw.homeworkStatus,
          studentId: hw.studentId
        }]);
      }, []),
      studentTutorialHomeworks: paperBased.studentTutorialHomeworks.reduce(function (arr, hw) {
        return [].concat(_toConsumableArray(arr), [{
          homeworkStatus: hw.homeworkStatus,
          studentId: hw.studentId
        }]);
      }, [])
    };
  });
  return function (dispatch, getState) {
    var url = (0, _Api.buildUrl)('/sessions/' + id + '/student-homework-result');
    var method = 'PUT';
    var progressReportIds = (0, _accessors.getProgressReportIdBySessionId)(getState(), id);
    return dispatch(submitMarkPaperBasedHomeworkRequest()).payload.then(function (response) {
      return dispatch(submitMarkPaperBasedHomeworkSuccess(response));
    }).catch(function (error) {
      return dispatch(submitMarkPaperBasedHomeworkFailure(error));
    }).then(function () {
      return dispatch(fetchPaperBasedHomework(id));
    }).then(function () {
      if (_omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.View)) {
        progressReportIds.forEach(function (progressReportId) {
          return dispatch(_StudentReportSummaries.actions.fetchStudentReportSummaries(progressReportId));
        });
      }
    });

    function submitMarkPaperBasedHomeworkRequest() {
      var request = (0, _Api.fetch)(url, {
        method: method,
        body: JSON.stringify(homework)
      });
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_PAPERBASE_HOMEWORK_REQUEST,
        payload: request,
        url: url,
        method: method,
        id: id,
        homework: homework
      });
    }

    function submitMarkPaperBasedHomeworkSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_PAPERBASE_HOMEWORK_SUCCESS,
        payload: response,
        url: url,
        method: method
      });
    }

    function submitMarkPaperBasedHomeworkFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_PAPERBASE_HOMEWORK_FAILURE,
        url: url,
        method: method,
        error: error
      });
    }
  };
}

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _create = __webpack_require__(1498);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaperBasedHomeworkRecord = (0, _immutable.Record)({
  sessionId: undefined,
  sessionIndex: undefined,
  unitId: undefined,
  unitOrderingSequence: undefined,
  lessonNumber: undefined,
  studentPaperBasedHomeworks: undefined,
  studentTutorialHomeworks: undefined
});

var PaperBasedHomework = function (_PaperBasedHomeworkRe) {
  _inherits(PaperBasedHomework, _PaperBasedHomeworkRe);

  function PaperBasedHomework() {
    _classCallCheck(this, PaperBasedHomework);

    return _possibleConstructorReturn(this, (PaperBasedHomework.__proto__ || Object.getPrototypeOf(PaperBasedHomework)).apply(this, arguments));
  }

  return PaperBasedHomework;
}(PaperBasedHomeworkRecord);

PaperBasedHomework.create = _create2.default;

exports.default = PaperBasedHomework;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentPaperBasedHomeworkRecord = (0, _immutable.Record)({
  studentId: undefined,
  studentGeneralInfo: undefined,
  isInProduction: undefined,
  studentStatus: undefined,
  homeworkStatus: undefined
});

var StudentPaperBasedHomework = function (_StudentPaperBasedHom) {
  _inherits(StudentPaperBasedHomework, _StudentPaperBasedHom);

  function StudentPaperBasedHomework() {
    _classCallCheck(this, StudentPaperBasedHomework);

    return _possibleConstructorReturn(this, (StudentPaperBasedHomework.__proto__ || Object.getPrototypeOf(StudentPaperBasedHomework)).apply(this, arguments));
  }

  return StudentPaperBasedHomework;
}(StudentPaperBasedHomeworkRecord);

exports.default = StudentPaperBasedHomework;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_SCORE_BAND_FAILURE = exports.FETCH_SCORE_BAND_SUCCESS = exports.FETCH_SCORE_BAND_REQUEST = undefined;
exports.getApiCallState = getApiCallState;
exports.fetchScoreBandIfNeeded = fetchScoreBandIfNeeded;
exports.fetchScoreBand = fetchScoreBand;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_SCORE_BAND_REQUEST = exports.FETCH_SCORE_BAND_REQUEST = 'FETCH_SCORE_BAND_REQUEST';
var FETCH_SCORE_BAND_SUCCESS = exports.FETCH_SCORE_BAND_SUCCESS = 'FETCH_SCORE_BAND_SUCCESS';
var FETCH_SCORE_BAND_FAILURE = exports.FETCH_SCORE_BAND_FAILURE = 'FETCH_SCORE_BAND_FAILURE';

var buildScoreBandUrl = function buildScoreBandUrl(languageCode) {
  return (0, _Api.buildUrl)('/score-bands/languages/' + languageCode);
};

function getApiCallState(state, languageCode) {
  return _omniCommonUi.ApiCall.find(state, { method: 'GET', url: buildScoreBandUrl(languageCode) });
}

function fetchScoreBandIfNeeded(languageCode) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildScoreBandUrl(languageCode) })) {
      return false;
    }

    return dispatch(fetchScoreBand(languageCode));
  };
}

function fetchScoreBand(languageCode) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/score-bands/languages/' + languageCode);
    var method = 'GET';

    var promise = dispatch(fetchScoreBandRequest()).payload.then(function (response) {
      return dispatch(fetchScoreBandSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchScoreBandFailure(error));
    });

    function fetchScoreBandRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_SCORE_BAND_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        languageCode: languageCode
      });
    }

    function fetchScoreBandSuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_SCORE_BAND_SUCCESS,
        payload: payload,
        url: url,
        method: method,
        languageCode: languageCode
      });
    }

    function fetchScoreBandFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_SCORE_BAND_FAILURE,
        error: error,
        url: url,
        method: method,
        languageCode: languageCode
      });
    }

    return promise;
  };
}

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScoreBandRecord = (0, _immutable.Record)({
  id: undefined,
  name: undefined,
  scorePercentageFrom: undefined,
  scorePercentageTo: undefined,
  interpretation: undefined,
  language: undefined
});

var ScoreBand = function (_ScoreBandRecord) {
  _inherits(ScoreBand, _ScoreBandRecord);

  function ScoreBand() {
    _classCallCheck(this, ScoreBand);

    return _possibleConstructorReturn(this, (ScoreBand.__proto__ || Object.getPrototypeOf(ScoreBand)).apply(this, arguments));
  }

  return ScoreBand;
}(ScoreBandRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'id':
      return [key, '' + val];
    default:
      return [key, val];
  }
};

ScoreBand.create = function (data) {
  return new ScoreBand(data).mapEntries(reviver);
};

exports.default = ScoreBand;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _ScoreBand = __webpack_require__(165);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScoreBand = function ScoreBand(props) {
  if (_is_js2.default.undefined(props.band)) {
    return null;
  }
  var band = props.textKey ? props.band[props.textKey] : props.band.interpretation;
  return _react2.default.createElement(
    'p',
    { className: props.className },
    band
  );
};

ScoreBand.propTypes = {
  className: _propTypes2.default.string,
  band: _propTypes2.default.object,
  textKey: _propTypes2.default.string
};

function mapStateToProps(state, ownProps) {
  var score = ownProps.score;

  var scoreBand = state.get('rootReducer').get('scoreBand');
  var language = state.get('rootReducer').get('language');
  var band = _ScoreBand.accessors.getBandByScore(score, language, scoreBand);
  return { band: band };
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null)(ScoreBand);

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScoreStar = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _style = __webpack_require__(1511);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScoreStar = exports.ScoreStar = function ScoreStar(props) {
  var fullMark = props.fullMark,
      currentResult = props.currentResult;

  var level = getLevelByPercentage(percentage(currentResult, fullMark));
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_style2.default.ScoreStar, props.className) },
    renderStarsByLevel(level)
  );
};

function fraction() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var max = arguments[1];

  if (_is_js2.default.number(max)) {
    return value / max;
  }

  if (value > 100) {
    value = 100; // eslint-disable-line
  }

  return value / 100;
}

function clamp(fract) {
  return Math.min(1, Math.max(0, fract));
}

function percentage(value, max) {
  return Math.round(clamp(fraction(value, max)) * 100);
}

function getLevelByPercentage(percent) {
  if (percent >= 1 && percent < 30) return 1;else if (percent >= 30 && percent < 60) return 2;else if (percent >= 60 && percent < 70) return 3;else if (percent >= 70 && percent < 80) return 4;else if (percent >= 80 && percent <= 100) return 5;
  return 0;
}

function calcStarNumberByLevel(level) {
  if (level === 0) {
    return 0;
  }
  return level / 2 + 0.5;
}

function renderStarsByLevel(level) {
  var stars = [];
  var starNumber = calcStarNumberByLevel(level);
  var starFullNumber = parseInt(starNumber, 10);

  for (var i = 0; i < 3; i++) {
    if (i < starFullNumber) {
      stars.push(_react2.default.createElement(_omniCommonUi.Icon, { className: _style2.default.ScoreStar_starIcon, key: 'star-full' + i, id: 'star-full' }));
    } else if (i === starFullNumber && starNumber % 1 !== 0) {
      stars.push(_react2.default.createElement(_omniCommonUi.Icon, { className: _style2.default.ScoreStar_starIcon, key: 'star-half' + i, id: 'star-half' }));
    } else {
      stars.push(_react2.default.createElement(_omniCommonUi.Icon, { className: _style2.default.ScoreStar_starIcon, key: 'star-empty' + i, id: 'star-empty' }));
    }
  }
  return stars;
}

ScoreStar.propTypes = {
  className: _propTypes2.default.string,
  currentResult: _propTypes2.default.number,
  fullMark: _propTypes2.default.number
};

exports.default = ScoreStar;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modes = undefined;

var _component = __webpack_require__(658);

var _component2 = _interopRequireDefault(_component);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _StudentReportSummaries = __webpack_require__(42);

var _StudentSelect = __webpack_require__(1527);

var _StudentSelect2 = _interopRequireDefault(_StudentSelect);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var actionButtons = function actionButtons(getState) {
  return {
    Submit: {
      isPrimary: true,
      route: './publish',
      label: function label(_ref) {
        var _ref$params = _ref.params,
            progressReportId = _ref$params.progressReportId,
            studentId = _ref$params.studentId;

        try {
          // meh.
          return isCommentExist(getState(), progressReportId, studentId) ? 'Submit for Approval' : 'Submit';
        } catch (e) {
          return 'Submit';
        }
      },
      disableWhen: function disableWhen(_ref2) {
        var _ref2$params = _ref2.params,
            progressReportId = _ref2$params.progressReportId,
            studentId = _ref2$params.studentId,
            mode = _ref2$params.mode;
        return mode && mode.length || // disable when in `edit` or `add` modes
        !isPublishable(getState(), progressReportId, studentId);
      },
      visibleWhen: function visibleWhen(_ref3) {
        var _ref3$params = _ref3.params,
            groupId = _ref3$params.groupId,
            progressReportId = _ref3$params.progressReportId,
            studentId = _ref3$params.studentId;
        return !_.actions.isDisabledReportActions(getState(), groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.Publish) && !isFuture(getState(), progressReportId, studentId);
      }
    },
    Export: {
      route: './export',
      visibleWhen: function visibleWhen(_ref4) {
        var _ref4$params = _ref4.params,
            groupId = _ref4$params.groupId,
            progressReportId = _ref4$params.progressReportId,
            studentId = _ref4$params.studentId;
        return !_.actions.isHFV4CourseTypeGroup(getState(), groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.Export) && !isFuture(getState(), progressReportId, studentId);
      },
      disableWhen: function disableWhen(_ref5) {
        var _ref5$params = _ref5.params,
            progressReportId = _ref5$params.progressReportId,
            studentId = _ref5$params.studentId,
            mode = _ref5$params.mode;
        return mode && mode.length || !isExportable(getState(), progressReportId, studentId);
      }
    },
    'Add Comment': {
      route: './add-comment',
      disableWhen: function disableWhen(_ref6) {
        var _ref6$params = _ref6.params,
            progressReportId = _ref6$params.progressReportId,
            studentId = _ref6$params.studentId,
            mode = _ref6$params.mode;
        return mode && mode.length || // disable when in `edit` or `add` modes
        !isPublishable(getState(), progressReportId, studentId);
      },
      visibleWhen: function visibleWhen(_ref7) {
        var _ref7$params = _ref7.params,
            groupId = _ref7$params.groupId,
            progressReportId = _ref7$params.progressReportId,
            studentId = _ref7$params.studentId;
        return !_.actions.isDisabledReportActions(getState(), groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.AddComment) && (!isFuture(getState(), progressReportId, studentId) && !isCommentExist(getState(), progressReportId, studentId) && !isCommentPublished(getState(), progressReportId, studentId) || _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.UpdatePublishedProgressReport));
      }
    }
  };
};

var Modes = exports.Modes = {
  EXPORT: 'export'
};

exports.default = function (_ref8) {
  var getState = _ref8.getState;
  return {
    path: 'student/:studentId(/:mode)',
    component: _component2.default,
    canAccess: function canAccess(_ref9) {
      var pathname = _ref9.location.pathname;

      var isEditMode = pathname.endsWith('/add-comment') || pathname.endsWith('/edit-comment');
      if (!isEditMode) {
        return true;
      }
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.AddComment);
    },
    breadcrumbLabels: 'Student Report',
    actionButtons: _defineProperty({
      default: actionButtons(getState),
      'add-comment': actionButtons(getState),
      'edit-comment': actionButtons(getState)
    }, Modes.EXPORT, actionButtons(getState)),
    appBars: {
      sticky: {
        'student-select': {
          component: _StudentSelect2.default,
          order: 2
        }
      }
    }
  };
};

function isFuture(state, progressReportId, studentId) {
  var studentReportSummary = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data.get('' + studentId);
  return _is_js2.default.undefined(studentReportSummary) || _is_js2.default.falsy(studentReportSummary.status);
}

function isPublishable(state, progressReportId, studentId) {
  var studentReportSummary = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data.get('' + studentId);
  return studentReportSummary && studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.Ready;
}
function isExportable(state, progressReportId, studentId) {
  var studentReportSummary = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data.get('' + studentId);
  return studentReportSummary && (studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.SentToDoS || studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.Completed || studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.Published || studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.Ready);
}
function isCommentPublished(state, progressReportId, studentId) {
  var studentReportSummary = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data.get('' + studentId);
  return studentReportSummary && (studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.SentToDoS || studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.Completed || studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.Published);
}

function isCommentExist(state, progressReportId, studentId) {
  var studentReportSummary = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data.get('' + studentId);
  if (studentReportSummary && studentReportSummary.comments) {
    return !_is_js2.default.falsy(studentReportSummary.comments) && studentReportSummary.comments.length > 0;
  }
  return false;
}

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateActionButtons = undefined;

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateActionButtons = exports.generateActionButtons = function generateActionButtons(getState) {
  return {
    Submit: {
      isPrimary: true,
      route: './publish-all',
      label: function label(_ref) {
        var progressReportId = _ref.params.progressReportId;

        try {
          // meh.
          return isAnyCommentExist(getState(), progressReportId) ? 'Submit All for Approval' : 'Submit All';
        } catch (e) {
          return 'Submit All';
        }
      },
      visibleWhen: function visibleWhen(_ref2) {
        var _ref2$params = _ref2.params,
            groupId = _ref2$params.groupId,
            progressReportId = _ref2$params.progressReportId;
        return !_.actions.isDisabledReportActions(getState(), groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.Publish) && !isFuture(getState(), progressReportId);
      },
      disableWhen: function disableWhen(_ref3) {
        var progressReportId = _ref3.params.progressReportId;
        return !isAnyPublishable(getState(), progressReportId);
      }
    },
    'Export All': {
      route: './export-all',
      visibleWhen: function visibleWhen(_ref4) {
        var _ref4$params = _ref4.params,
            groupId = _ref4$params.groupId,
            progressReportId = _ref4$params.progressReportId;
        return !_.actions.isHFV4CourseTypeGroup(getState(), groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.Export) && !isFuture(getState(), progressReportId);
      },
      disableWhen: function disableWhen(_ref5) {
        var progressReportId = _ref5.params.progressReportId;
        return !isAnyExportable(getState(), progressReportId);
      }
    }
  };
};

function isFuture(state, progressReportId) {
  var studentReportSummaries = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data;
  return studentReportSummaries && studentReportSummaries.size === 0;
}

function isAnyExportable(state, progressReportId) {
  var studentReports = state.get('rootReducer').get('studentReportSummaries').get(progressReportId);
  if (!_immutable.Map.isMap(studentReports.data)) {
    return false;
  }
  return !!studentReports.data.some(function (report) {
    return report.status && report.status !== 'ScoresMissing';
  });
}

function isAnyPublishable(state, progressReportId) {
  var studentReports = state.get('rootReducer').get('studentReportSummaries').get(progressReportId);
  if (!_immutable.Map.isMap(studentReports.data)) {
    return false;
  }
  return !!studentReports.data.some(function (report) {
    return report.status === 'Ready';
  });
}

function isAnyCommentExist(state, progressReportId) {
  return state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data.some(function (studentReportSummary) {
    if (studentReportSummary && studentReportSummary.comments) {
      return !_is_js2.default.falsy(studentReportSummary.comments) && studentReportSummary.comments.length > 0;
    }
    return false;
  });
}

exports.default = {
  generateActionButtons: generateActionButtons
};

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseSessionNav2 = __webpack_require__(108);

var _BaseSessionNav3 = _interopRequireDefault(_BaseSessionNav2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _UiState = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressReportSessionNav = function (_BaseSessionNav) {
  _inherits(ProgressReportSessionNav, _BaseSessionNav);

  function ProgressReportSessionNav() {
    _classCallCheck(this, ProgressReportSessionNav);

    return _possibleConstructorReturn(this, (ProgressReportSessionNav.__proto__ || Object.getPrototypeOf(ProgressReportSessionNav)).apply(this, arguments));
  }

  _createClass(ProgressReportSessionNav, [{
    key: '_hasNext',
    value: function _hasNext() {
      return this.props.currentProgressReportIndex < this.props.progressReportCount - 1;
    }
  }, {
    key: '_hasPrevious',
    value: function _hasPrevious() {
      return this.props.currentProgressReportIndex > 0;
    }
  }, {
    key: '_hasNextUnit',
    value: function _hasNextUnit() {
      return this.props.currentUnitIndex < this.props.unitCount - 1;
    }
  }, {
    key: '_hasPreviousUnit',
    value: function _hasPreviousUnit() {
      return this.props.currentUnitIndex > 0;
    }
  }, {
    key: '_getNextUnitText',
    value: function _getNextUnitText() {
      return this.props.nextUnitName;
    }
  }, {
    key: '_getPreviousUnitText',
    value: function _getPreviousUnitText() {
      return this.props.previousUnitName;
    }
  }, {
    key: '_getHeadingText',
    value: function _getHeadingText() {
      return this.props.currentGroupName;
    }
  }, {
    key: '_getAdditionalChildren',
    value: function _getAdditionalChildren() {
      var _props = this.props,
          currentProgressReportName = _props.currentProgressReportName,
          currentUnitName = _props.currentUnitName;

      return _react2.default.createElement(
        'h2',
        null,
        currentProgressReportName + ', ' + currentUnitName
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (_is_js2.default.existy(this.props.currentGroupName) && this.props.currentProgressReportName) {
        return _get(ProgressReportSessionNav.prototype.__proto__ || Object.getPrototypeOf(ProgressReportSessionNav.prototype), 'render', this).call(this);
      }
      return null;
    }
  }]);

  return ProgressReportSessionNav;
}(_BaseSessionNav3.default);

ProgressReportSessionNav.propTypes = Object.assign({
  previousUnitName: _propTypes2.default.string,
  nextUnitName: _propTypes2.default.string,
  currentGroupName: _propTypes2.default.string,
  currentUnitName: _propTypes2.default.string,
  currentUnitIndex: _propTypes2.default.number,
  currentProgressReportIndex: _propTypes2.default.number.isRequired,
  currentProgressReportName: _propTypes2.default.string.isRequired,
  progressReportCount: _propTypes2.default.number.isRequired,
  unitCount: _propTypes2.default.number
}, _BaseSessionNav3.default.propTypes);

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      progressReportId = _ownProps$params.progressReportId;

  if (!progressReportId) return;
  var group = state.get('rootReducer').get('groups').get(groupId) && state.get('rootReducer').get('groups').get(groupId).data;
  var progressReports = group && group.get('progressReports') && group.get('progressReports').data;

  if (group && progressReports) {
    var progressReport = progressReports.get(progressReportId);
    var previousPR = progressReports.find(function (pr) {
      return pr.index === progressReport.index - 1;
    });
    var nextPR = progressReports.find(function (pr) {
      return pr.index === progressReport.index + 1;
    });
    var currentUnitName = progressReport.units.map(function (unit) {
      return unit.get('name');
    }).reduce(function (unitName, nextUnitName) {
      return unitName + ' & ' + nextUnitName;
    });
    return {
      currentGroupName: group.name,
      currentProgressReportName: progressReport.name,
      currentUnitName: currentUnitName,
      progressReportCount: progressReports.size,
      currentProgressReportIndex: progressReport.index,
      previousSessionLinkHref: previousPR && ownProps.buildRoute({
        progressReportId: previousPR.id,
        mode: ''
      }),
      nextSessionLinkHref: nextPR && ownProps.buildRoute({
        progressReportId: nextPR.id,
        mode: ''
      }),
      isHide: !_UiState.actions.getShowNavigationBar(state)
    };
  }
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null)(ProgressReportSessionNav);

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CoveredInClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _style = __webpack_require__(672);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _PageActivitiesPart = __webpack_require__(673);

var _PageActivitiesPart2 = _interopRequireDefault(_PageActivitiesPart);

var _CoveredInClassCategoryView = __webpack_require__(674);

var _CoveredInClassCategoryView2 = _interopRequireDefault(_CoveredInClassCategoryView);

var _reactRouterRedux = __webpack_require__(15);

var _SessionPlans = __webpack_require__(44);

var _redux = __webpack_require__(10);

var _CoveredInClass = __webpack_require__(95);

var _Template = __webpack_require__(166);

var _CategoryTemplate = __webpack_require__(306);

var _InternalNotesPart = __webpack_require__(679);

var _InternalNotesPart2 = _interopRequireDefault(_InternalNotesPart);

var _reactRouter = __webpack_require__(16);

var _Exporter = __webpack_require__(50);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

var _ = __webpack_require__(13);

var _UiState = __webpack_require__(30);

var _accessors = __webpack_require__(41);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _NoContentMessage = __webpack_require__(66);

var _NoContentMessage2 = _interopRequireDefault(_NoContentMessage);

var _LanguageRadio = __webpack_require__(74);

var _LanguageRadio2 = _interopRequireDefault(_LanguageRadio);

var _AddFreeTextDialog = __webpack_require__(681);

var _AddFreeTextDialog2 = _interopRequireDefault(_AddFreeTextDialog);

var _routes = __webpack_require__(308);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXPORT = 'EXPORT';
var CANCEL = 'CANCEL';
var EXPORT_OPTION_ONE = 'one';
var EXPORT_OPTION_UNIT = 'unit';
var EXPORT_OPTION_ALL = 'all';
var TITLE_EXPORT_OPTIONS = 'Export Options';
var NAME_EXPORT_OPTIONS = 'export';
var DESCRIPTION_EXPORT_OPTIONS = 'Export Covered in Class for…';

var CoveredInClass = exports.CoveredInClass = function (_UnsavedChangesTracki) {
  _inherits(CoveredInClass, _UnsavedChangesTracki);

  function CoveredInClass(props) {
    _classCallCheck(this, CoveredInClass);

    var _this = _possibleConstructorReturn(this, (CoveredInClass.__proto__ || Object.getPrototypeOf(CoveredInClass)).call(this, props));

    _this._onChecked = _this._onChecked.bind(_this);
    return _this;
  }

  _createClass(CoveredInClass, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.state = {
        allowRouteLeave: false,
        isChanged: false,
        isExportInProgress: false,
        isExportErrorOccurred: false,
        isNotFoundSessions: false,
        isShowExportOptions: false,
        selectedExportValue: EXPORT_OPTION_ONE
      };
      this._fetchData(this.props);
      _get(CoveredInClass.prototype.__proto__ || Object.getPrototypeOf(CoveredInClass.prototype), 'componentWillMount', this).call(this);
      this._initChoosedLanguage();
      this._initCICContent();
      this._initCICCategory();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (this.props.currentSessionIndex !== props.currentSessionIndex) {
        this.setState({
          allowRouteLeave: false,
          isChanged: false
        });
      }
      this._fetchData(props);
      this._initCICContent();
    }
  }, {
    key: '_fetchData',
    value: function _fetchData(props) {
      this.props.fetchSessionPlansIfNeeded(props.params.groupId);
      this.props.fetchCoveredInClassTemplateIfNeeded(props.params.sessionPlanId);
      this.props.fetchCoveredInClassIfNeeded(props.params.sessionPlanId);
    }
  }, {
    key: '_initCICCategory',
    value: function _initCICCategory() {
      var groupId = this.props.params.groupId;

      this.props.fetchCICCategoriesIfNeeded(groupId);
    }
  }, {
    key: '_initCICContent',
    value: function _initCICContent() {
      var _props = this.props,
          coveredInClassTemplate = _props.coveredInClassTemplate,
          coveredInClassContent = _props.coveredInClassContent,
          hasCICTemplate = _props.hasCICTemplate,
          hasCIC = _props.hasCIC,
          isNotPublished = _props.isNotPublished;

      if (!coveredInClassContent || !hasCICTemplate || hasCIC || !isNotPublished) {
        return;
      }
      if (this.props.isAnyApiCalling) {
        return;
      }
      var coveredInClassObject = void 0;
      if (this._canCICEdit()) {
        coveredInClassObject = coveredInClassContent;
        coveredInClassObject = coveredInClassObject.map(function (coveredInClass, key) {
          return coveredInClass.set('cicActivities', coveredInClassTemplate.get(key).cicActivities).set('cicCategories', coveredInClassTemplate.get(key).cicCategories);
        });
      } else if (!this._isNotFutureSession()) {
        coveredInClassObject = coveredInClassTemplate;
      } else {
        coveredInClassObject = coveredInClassContent;
        // coveredInClassObject = coveredInClassObject.map((coveredInClass, key) =>
        //     coveredInClass.update('cicActivities', coveredInClassTemplate.get(key).cicActivities)
        //       .set('cicCategories', coveredInClassTemplate.get(key).cicCategories));
      }
      this.props.changeCoveredInClassObject(coveredInClassObject, this.props.params.sessionPlanId);
    }
  }, {
    key: '_isChangesPresent',
    value: function _isChangesPresent() {
      // do not worry about notes - we will auto-save these on leaving
      return !!this.state.isChanged;
    }
  }, {
    key: '_isInCoveredInClassEditMode',
    value: function _isInCoveredInClassEditMode(pathname) {
      var sessionPlanId = this.props.params.sessionPlanId;

      return Object.values(_routes.Modes).some(function (mode) {
        return pathname.endsWith(sessionPlanId + '/covered-in-class/' + mode);
      });
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave(nextLocation) {
      if (nextLocation && nextLocation.pathname.endsWith('/' + _routes.Modes.EXPORT)) {
        this._onBeginExport();
        return false;
      } else if (nextLocation && nextLocation.pathname.endsWith('/' + _routes.Modes.PUBLISH)) {
        this._publishCIC();
        return false;
        // OMO-1254: user navigates away while editing a note; auto-save it
        // TODO: clean up fuzzy detection of whether we're staying on the same page
      } else if (nextLocation && nextLocation.pathname.endsWith('/' + _routes.Modes.CLEAR)) {
        this._clearCIC();
      } else if (this._willRemainOnCurrentPage(nextLocation)) return;

      this._autoSaveNotes();
      return _get(CoveredInClass.prototype.__proto__ || Object.getPrototypeOf(CoveredInClass.prototype), 'routerWillLeave', this).call(this, nextLocation);
    }
  }, {
    key: '_autoSaveNotes',
    value: function _autoSaveNotes() {
      if (!this.internalNotesPartComponent) return;
      this.internalNotesPartComponent.autoSaveNotesIfNeeded();
    }
  }, {
    key: '_willRemainOnCurrentPage',
    value: function _willRemainOnCurrentPage(nextLocation) {
      var currentPath = this.props.buildRoute({ mode: '', index: '' });
      return nextLocation && nextLocation.pathname.indexOf(currentPath) >= 0;
    }
  }, {
    key: '_pageActivitiesChanged',
    value: function _pageActivitiesChanged(newPageActivities, unitId, lessonNumber) {
      this.setState({ isChanged: true });
      var _props2 = this.props,
          coveredInClassContent = _props2.coveredInClassContent,
          params = _props2.params;

      var newCoveredInClassContent = coveredInClassContent.update(unitId + '-' + lessonNumber, function (cic) {
        return cic.set('cicActivities', newPageActivities);
      });
      this.props.changeCoveredInClassObject(newCoveredInClassContent, params.sessionPlanId);
    }
  }, {
    key: '_categoriesChanged',
    value: function _categoriesChanged(newCategories, unitId, lessonNumber) {
      this.setState({ isChanged: true });
      var _props3 = this.props,
          coveredInClassContent = _props3.coveredInClassContent,
          params = _props3.params;


      var newCoveredInClassContent = coveredInClassContent.update(unitId + '-' + lessonNumber, function (cic) {
        return cic.set('cicCategories', newCategories);
      });
      this.props.changeCoveredInClassObject(newCoveredInClassContent, params.sessionPlanId);
    }
  }, {
    key: '_getModeAndIndex',
    value: function _getModeAndIndex() {
      return { mode: this.props.params.mode, index: this.props.params.index };
    }
  }, {
    key: '_onChangeMode',
    value: function _onChangeMode(modeAndIndex) {
      var mode = modeAndIndex.mode,
          _modeAndIndex$index = modeAndIndex.index,
          index = _modeAndIndex$index === undefined ? '' : _modeAndIndex$index;

      this._forcePushRoute(this.props.buildRoute({ mode: mode, index: index }));
    }
  }, {
    key: '_onBeginExport',
    value: function _onBeginExport() {
      this.setState({
        isShowExportOptions: true,
        selectedExportValue: EXPORT_OPTION_ONE
      });
      this._initChoosedLanguage();
    }
  }, {
    key: '_onEndExport',
    value: function _onEndExport() {
      this.setState({ isShowExportOptions: false });
    }
  }, {
    key: '_onBeginGeneralError',
    value: function _onBeginGeneralError() {
      this.setState({ isExportErrorOccurred: true });
    }
  }, {
    key: '_onBeginExportWarning',
    value: function _onBeginExportWarning() {
      this.setState({ isNotFoundSessions: true });
    }
  }, {
    key: '_onEndExportWarningOrError',
    value: function _onEndExportWarningOrError() {
      this.setState({
        isNotFoundSessions: false,
        isExportErrorOccurred: false
      });
    }
  }, {
    key: '_renderExportOptionDialog',
    value: function _renderExportOptionDialog() {
      var _this2 = this;

      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: this.state.isShowExportOptions,
          isLoading: this.state.isExportInProgress,
          title: TITLE_EXPORT_OPTIONS,
          primaryButtonContent: EXPORT,
          secondaryButtonContent: CANCEL,
          onRequestClose: function onRequestClose() {
            _this2._onEndExport();
          },
          onPrimaryClick: function onPrimaryClick() {
            _this2._handleConfirmExport();
          },
          onSecondaryClick: function onSecondaryClick() {
            _this2._onEndExport();
          } },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            null,
            DESCRIPTION_EXPORT_OPTIONS
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.CoveredInClass_exportOptions },
            _react2.default.createElement(
              'div',
              { className: _style2.default.CoveredInClass_exportOption },
              _react2.default.createElement(_omniCommonUi.SolidRadio, { id: '1',
                value: EXPORT_OPTION_ONE,
                name: NAME_EXPORT_OPTIONS,
                isChecked: this.state.selectedExportValue === EXPORT_OPTION_ONE,
                onChange: function onChange(value) {
                  return _this2._handleExportChange(value);
                } }),
              'current session'
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default.CoveredInClass_exportOption },
              _react2.default.createElement(_omniCommonUi.SolidRadio, { id: '2',
                value: EXPORT_OPTION_UNIT,
                name: NAME_EXPORT_OPTIONS,
                isChecked: this.state.selectedExportValue === EXPORT_OPTION_UNIT,
                onChange: function onChange(value) {
                  return _this2._handleExportChange(value);
                } }),
              'current unit'
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default.CoveredInClass_exportOption },
              _react2.default.createElement(_omniCommonUi.SolidRadio, { id: '3',
                value: EXPORT_OPTION_ALL,
                name: NAME_EXPORT_OPTIONS,
                isChecked: this.state.selectedExportValue === EXPORT_OPTION_ALL,
                onChange: function onChange(value) {
                  return _this2._handleExportChange(value);
                } }),
              'all taught sessions'
            )
          ),
          this._renderLanguagePicker()
        )
      );
    }
  }, {
    key: '_renderLanguagePicker',
    value: function _renderLanguagePicker() {
      if (this._isDefaultLanguage()) return;
      return [_react2.default.createElement('div', { className: _style2.default.CoveredInClass_exportOptionsDivider,
        key: 'CoveredInClass_exportOptionsDivider' }), _react2.default.createElement(
        'div',
        { className: _style2.default.CoveredInClass_languagePicker,
          key: 'CoveredInClass_languagePicker' },
        _react2.default.createElement(_LanguageRadio2.default, { title: 'Choose Language:',
          languageCode: this.props.languageCode,
          name: 'CICLanguagePicker',
          onChecked: this._onChecked,
          choosedLanguageCode: this.state.choosedLanguage })
      )];
    }
  }, {
    key: '_initChoosedLanguage',
    value: function _initChoosedLanguage() {
      this.setState({ choosedLanguage: this.props.languageCode });
    }
  }, {
    key: '_isDefaultLanguage',
    value: function _isDefaultLanguage() {
      if (!this.props.languageCode) return true;
      return this.props.languageCode === _Languages2.default.defaultLanguageCode;
    }
  }, {
    key: '_onChecked',
    value: function _onChecked(checkedLanguage) {
      this.setState({ choosedLanguage: checkedLanguage });
    }
  }, {
    key: '_handleExportChange',
    value: function _handleExportChange(value) {
      this.setState({ selectedExportValue: value });
    }
  }, {
    key: '_handleConfirmExport',
    value: function _handleConfirmExport() {
      var _props$params = this.props.params,
          sessionPlanId = _props$params.sessionPlanId,
          groupId = _props$params.groupId;

      var sourceUrl = '';
      var languageQueryString = '?languageCode=' + (this.state.choosedLanguage || _Languages2.default.defaultLanguageCode);
      switch (this.state.selectedExportValue) {
        case EXPORT_OPTION_ONE:
          sourceUrl = '/sessions/' + sessionPlanId + '/cic-printing' + languageQueryString;
          this._beginExport(_omniCommonUi.Config.get('apiBase').concat(sourceUrl));
          break;
        case EXPORT_OPTION_UNIT:
          sourceUrl = '/sessions/' + sessionPlanId + '/unit-sessions/cic-printing' + languageQueryString;
          this._beginExport(_omniCommonUi.Config.get('apiBase').concat(sourceUrl));
          break;
        case EXPORT_OPTION_ALL:
          sourceUrl = '/groups/' + groupId + '/sessions/cic-printing' + languageQueryString;
          this._beginExport(_omniCommonUi.Config.get('apiBase').concat(sourceUrl));
          break;
        default:
          break;
      }
    }
  }, {
    key: '_handleExportError',
    value: function _handleExportError(error) {
      this.setState({
        isExportInProgress: false,
        isShowExportOptions: false
      });
      if (error.response.status === 404) {
        this._onBeginExportWarning();
        return;
      }
      this._onBeginGeneralError();
    }
  }, {
    key: '_beginExport',
    value: function _beginExport(url) {
      var _this3 = this;

      this.setState({
        isExportInProgress: true
      });
      _Exporter.exporter.get(url, this.props.groupCode.concat('.pdf'), false, 'application/pdf').then(function () {
        _this3.setState({
          isExportInProgress: false,
          isShowExportOptions: false
        });
      }).catch(function (err) {
        _this3._handleExportError(err);
      });
    }
  }, {
    key: '_renderExportNoSessionsFoundWarningDialog',
    value: function _renderExportNoSessionsFoundWarningDialog() {
      var _this4 = this;

      if (this.state.isNotFoundSessions) {
        return _react2.default.createElement(_omniCommonUi.ConfirmDialog, { isOpen: true,
          content: 'No sessions are available for printing.',
          primaryButtonContent: 'OK',
          onPrimaryClick: function onPrimaryClick() {
            return _this4._onEndExportWarningOrError();
          } });
      }
    }
  }, {
    key: '_renderExportGeneralErrorDialog',
    value: function _renderExportGeneralErrorDialog() {
      var _this5 = this;

      if (this.state.isExportErrorOccurred) {
        return _react2.default.createElement(_omniCommonUi.ErrorDialog, { isOpen: true,
          onConfirmClick: function onConfirmClick() {
            _this5._onEndExportWarningOrError();
          } });
      }
    }
  }, {
    key: '_canCICEdit',
    value: function _canCICEdit() {
      var isNotPublished = this.props.isNotPublished;

      return isNotPublished && this._isNotFutureSession();
    }
  }, {
    key: '_isNotFutureSession',
    value: function _isNotFutureSession() {
      var _props4 = this.props,
          sessionPlans = _props4.sessionPlans,
          currentSessionIndex = _props4.currentSessionIndex;

      var currentSession = sessionPlans.data.get(currentSessionIndex);
      var currentSessionDate = currentSession.period.start;
      return (0, _omniCommonUi.moment)().isAfter(currentSessionDate);
    }
  }, {
    key: '_publishCIC',
    value: function _publishCIC() {
      this.setState({ isChanged: false });
      var _props5 = this.props,
          sessionPlanId = _props5.params.sessionPlanId,
          publishCoveredInClass = _props5.publishCoveredInClass,
          fetchCoveredInClass = _props5.fetchCoveredInClass;
      var coveredInClassContent = this.props.coveredInClassContent;


      return coveredInClassContent && publishCoveredInClass(_CoveredInClass.accessors.filterUncheckItems(coveredInClassContent).toArray(), sessionPlanId).then(function () {
        return fetchCoveredInClass(sessionPlanId);
      });
    }
  }, {
    key: '_clearCIC',
    value: function _clearCIC() {
      this.setState({ isChanged: false });
      var _props6 = this.props,
          sessionPlanId = _props6.params.sessionPlanId,
          clearCoveredInClass = _props6.clearCoveredInClass,
          fetchCoveredInClass = _props6.fetchCoveredInClass;


      this._onChangeMode({ mode: '', index: '' });
      return clearCoveredInClass(sessionPlanId).then(function () {
        return fetchCoveredInClass(sessionPlanId);
      });
    }
  }, {
    key: '_renderUnsavedChangesWarningDialog',
    value: function _renderUnsavedChangesWarningDialog() {
      var _this6 = this;

      var _props7 = this.props,
          coveredInClassContent = _props7.coveredInClassContent,
          isNotPublished = _props7.isNotPublished;


      if (this.props.isAnyApiCalling) {
        return null;
      }
      if (isNotPublished && _CoveredInClass.accessors.isAllCategoryItemsUnchecked(coveredInClassContent)) {
        return _react2.default.createElement(_omniCommonUi.ConfirmDialog, { isOpen: !!this._isNavigationWithChangesRequested(),
          primaryButtonContent: 'Stay',
          secondaryButtonContent: 'Leave',
          content: 'Are you sure you want to leave this page and lose unsaved changes?',
          onPrimaryClick: function onPrimaryClick() {
            _this6._clearRequestedLocation();
          },
          onSecondaryClick: function onSecondaryClick() {
            _this6.props.resetCoveredInClass(_this6.props.params.sessionPlanId);
            _this6._forcePushRequestedLocation();
          },
          onRequestClose: function onRequestClose() {
            _this6._clearRequestedLocation();
          } });
      }
      return _react2.default.createElement(_UnsavedChangesWarning2.default, { isOpen: !!this._isNavigationWithChangesRequested(),
        dialogText: 'Do you want to publish Covered in Class?',
        primaryButtonLabel: 'Publish to EF P',
        secondaryButtonContent: 'Discard',
        isSaving: this.props.isAnyApiCalling,
        onSaveClicked: function onSaveClicked() {
          _this6._publishCIC().then(function () {
            _this6._forcePushRequestedLocation();
          });
        },
        onDiscardClicked: function onDiscardClicked() {
          _this6.props.resetCoveredInClass(_this6.props.params.sessionPlanId);
          _this6._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this6._clearRequestedLocation();
        } });
    }
  }, {
    key: '_renderContent',
    value: function _renderContent() {
      var _this7 = this;

      var _props8 = this.props,
          canEditCoveredInClass = _props8.canEditCoveredInClass,
          changeCoveredInClassObject = _props8.changeCoveredInClassObject,
          coveredInClassContent = _props8.coveredInClassContent,
          sessionPlanId = _props8.params.sessionPlanId,
          hasCIC = _props8.hasCIC,
          hasCICTemplate = _props8.hasCICTemplate,
          isNotPublished = _props8.isNotPublished;


      if (coveredInClassContent && coveredInClassContent.loading) {
        return null;
      }
      // internal notes should be visible in all cases - even when there's no CIC content to show.
      var internalNotesPart = _react2.default.createElement(_InternalNotesPart2.default, { onComponentMounted: function onComponentMounted(_cmpnt) {
          _this7.internalNotesPartComponent = _cmpnt;
        },
        modeAndIndex: this._getModeAndIndex(),
        onChangeMode: function onChangeMode(modeAndIndex) {
          return _this7._onChangeMode(modeAndIndex);
        },
        timeZone: this.props.timeZone,
        sessionPlanId: this.props.params.sessionPlanId });

      if (!hasCICTemplate && !hasCIC) {
        return _react2.default.createElement(
          _omniCommonUi.Grid,
          { outerMargin: true },
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            internalNotesPart,
            _react2.default.createElement(_NoContentMessage2.default, { text: 'No new course content was covered.' })
          )
        );
      }
      var isEdit = this._canCICEdit() && canEditCoveredInClass;

      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { outerMargin: true },
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          (isEdit || !isNotPublished) && _react2.default.createElement(
            'div',
            { className: _style2.default.CoveredInClass_header },
            isEdit ? _react2.default.createElement(
              'label',
              { className: _style2.default.CoveredInClass_header_checkAll },
              _react2.default.createElement(_omniCommonUi.Checkbox, { name: 'check-all',
                id: 'check-all',
                checked: _CoveredInClass.accessors.isAllCategoryItemsChecked(coveredInClassContent),
                onChange: function onChange() {
                  _this7.setState({ isChanged: true });
                  var newCoveredInClassObject = _CoveredInClass.accessors.toggleCategoryItemsCheckedState(coveredInClassContent);
                  changeCoveredInClassObject(newCoveredInClassObject, sessionPlanId);
                } }),
              _react2.default.createElement(
                'span',
                null,
                'Check All'
              )
            ) : _react2.default.createElement('lablel', { className: _style2.default.CoveredInClass_header_checkAll }),
            !isNotPublished && _react2.default.createElement(_omniCommonUi.ColourLabel, { text: 'published', colour: 'green' })
          ),
          internalNotesPart,
          this._renderLesson(coveredInClassContent, isEdit)
        ),
        this._renderExportOptionDialog(),
        this._renderExportNoSessionsFoundWarningDialog(),
        this._renderExportGeneralErrorDialog()
      );
    }
  }, {
    key: '_renderLesson',
    value: function _renderLesson(coveredInClassObject, isEdit) {
      var _this8 = this;

      var coveredInClassTemplate = this.props.coveredInClassTemplate;

      var unchekedTemplate = _CoveredInClass.accessors.toggleCategoryItemsCheckedState(coveredInClassTemplate);
      if (coveredInClassObject) {
        return coveredInClassObject.map(function (coveredInClass, key) {
          return _react2.default.createElement(
            'div',
            null,
            coveredInClass.unitOrderingSequence && coveredInClass.lessonNumber ? _react2.default.createElement(
              'h2',
              null,
              'Unit ',
              coveredInClass.unitOrderingSequence,
              ', Lesson ',
              coveredInClass.lessonNumber
            ) : '',
            _react2.default.createElement(_CoveredInClassCategoryView2.default, { isEdit: isEdit,
              categories: coveredInClass.cicCategories,
              template: unchekedTemplate && unchekedTemplate.get(key) && unchekedTemplate.get(key).cicCategories,
              onCategoriesChanged: function onCategoriesChanged(newCategories) {
                return _this8._categoriesChanged(newCategories, coveredInClass.unitId, coveredInClass.lessonNumber);
              } }),
            _react2.default.createElement(_PageActivitiesPart2.default, { pageActivities: coveredInClass.cicActivities,
              template: unchekedTemplate && unchekedTemplate.get(key) && unchekedTemplate.get(key).cicActivities,
              isEditMode: isEdit,
              onPageActivitiesChanged: function onPageActivitiesChanged(newPageActivities) {
                return _this8._pageActivitiesChanged(newPageActivities, coveredInClass.unitId, coveredInClass.lessonNumber);
              } })
          );
        });
      }
      return null;
    }
  }, {
    key: '_closeFreeTextPopup',
    value: function _closeFreeTextPopup() {
      this._onChangeMode({ mode: '', index: '' });
    }
  }, {
    key: '_addFreeText',
    value: function _addFreeText(CICKey, categoryId, freeText) {
      this.setState({ isChanged: true });
      var _props9 = this.props,
          cicCategoryTemplate = _props9.cicCategoryTemplate,
          params = _props9.params;

      var cicKey = CICKey;
      var coveredInClassContent = this.props.coveredInClassContent;

      if (!coveredInClassContent) {
        var unitId = params.unitId || 0;
        cicKey = unitId + '-0';
        coveredInClassContent = new _immutable.Map();
        coveredInClassContent = coveredInClassContent.set(unitId + '-0', _CoveredInClass.CoveredInClass.create({
          cicCategories: [],
          cicActivities: [],
          unitId: unitId,
          lessonNumber: 0
        }));
      }
      var cicCategories = coveredInClassContent.get(cicKey) && coveredInClassContent.get(cicKey).get('cicCategories');

      if (!cicCategories || cicCategories.findIndex(function (x) {
        return x.get('cicCategoryId') === categoryId;
      }) < 0) {
        if (!cicCategories) {
          cicCategories = new _immutable.List();
        }
        var selectCategory = cicCategoryTemplate.find(function (x) {
          return x.get('cicCategoryId') === categoryId;
        });
        cicCategories = cicCategories.push((0, _immutable.Record)({
          cicCategoryId: undefined,
          cicCategoryItems: undefined,
          cicCategoryName: undefined
        })({
          cicCategoryId: categoryId,
          cicCategoryItems: new _immutable.List(),
          cicCategoryName: selectCategory.get('cicCategoryName')
        }));
      }

      cicCategories = cicCategories && cicCategories.update(cicCategories.findIndex(function (x) {
        return x.get('cicCategoryId') === categoryId;
      }), function (category) {
        return category.update('cicCategoryItems', function (cicCategoryItems) {
          var freeTextIndex = cicCategoryItems.findIndex(function (item) {
            return item.cicCategoryItemId === 0;
          });
          if (freeTextIndex >= 0) {
            return cicCategoryItems.update(freeTextIndex, function (item) {
              return item.update('cicCategoryItemName', function (cicCategoryItemName) {
                return cicCategoryItemName + '\n' + freeText;
              });
            });
          }
          return cicCategoryItems.push((0, _immutable.Record)({
            cicCategoryItemId: undefined,
            cicCategoryItemName: undefined,
            isChecked: undefined
          })({
            cicCategoryItemId: 0,
            cicCategoryItemName: freeText,
            isChecked: true
          }));
        });
      });

      var newCoveredInClassContent = new _immutable.List();
      if (!coveredInClassContent) {
        newCoveredInClassContent = newCoveredInClassContent.push((0, _immutable.Record)({
          UnitId: undefined,
          cicCategories: undefined,
          cicActivities: undefined
        })({
          cicCategories: cicCategories,
          cicActivities: new _immutable.List()
        }));
      } else {
        newCoveredInClassContent = coveredInClassContent && coveredInClassContent.update(cicKey, function (cic) {
          return cic.set('cicCategories', cicCategories);
        });
      }

      this.props.changeCoveredInClassObject(newCoveredInClassContent, params.sessionPlanId);
      this._closeFreeTextPopup();
    }
  }, {
    key: '_renderFreeTextPopup',
    value: function _renderFreeTextPopup() {
      var _this9 = this;

      var _props10 = this.props,
          cicCategoryTemplate = _props10.cicCategoryTemplate,
          coveredInClassContent = _props10.coveredInClassContent;

      var shouldShowFreeTextPopup = this.props.params.mode && this.props.params.mode === _routes.Modes.ADD_FREE_TEXT;
      return shouldShowFreeTextPopup && _react2.default.createElement(_AddFreeTextDialog2.default, { categoryOptions: cicCategoryTemplate,
        onCancel: function onCancel() {
          return _this9._closeFreeTextPopup();
        },
        coveredInClassContent: coveredInClassContent,
        onSave: function onSave(cicKey, categoryId, freeText) {
          return _this9._addFreeText(cicKey, categoryId, freeText);
        } });
    }
  }, {
    key: 'render',
    value: function render() {
      var sessionPlans = this.props.sessionPlans;


      if (!sessionPlans || !sessionPlans.data) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: _style2.default.CoveredInClass },
        this._renderUnsavedChangesWarningDialog(),
        this._renderContent(),
        this._renderFreeTextPopup()
      );
    }
  }]);

  return CoveredInClass;
}(_UnsavedChangesTrackingPageComponent2.default);

CoveredInClass.getCurrentRouteSegment = function (props) {
  return props.routes[props.routes.length - 1];
};

CoveredInClass.propTypes = {
  children: _propTypes2.default.node,
  timeZone: _propTypes2.default.string,
  groupName: _propTypes2.default.string,
  groupCode: _propTypes2.default.string,
  languageCode: _propTypes2.default.string,
  sessionPlans: _propTypes2.default.object.isRequired,
  params: _propTypes2.default.object.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  currentSessionIndex: _propTypes2.default.number,
  fetchSessionPlansIfNeeded: _propTypes2.default.func,
  state: _propTypes2.default.object.isRequired,
  router: _propTypes2.default.any.isRequired,
  route: _propTypes2.default.any.isRequired,
  routes: _propTypes2.default.array.isRequired,
  location: _propTypes2.default.object.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  fetchCoveredInClassIfNeeded: _propTypes2.default.func.isRequired,
  fetchCoveredInClassTemplateIfNeeded: _propTypes2.default.func.isRequired,
  coveredInClassObject: _propTypes2.default.object,
  fetchCoveredInClass: _propTypes2.default.func,
  changeCoveredInClassObject: _propTypes2.default.func,
  publishCoveredInClass: _propTypes2.default.func,
  clearCoveredInClass: _propTypes2.default.func,
  canEditCoveredInClass: _propTypes2.default.bool.isRequired,
  sessions: _propTypes2.default.object,
  currentSessionId: _propTypes2.default.string.isRequired,
  showNavigationBar: _propTypes2.default.bool.isRequired,
  isAnyApiCalling: _propTypes2.default.bool,
  isNotPublished: _propTypes2.default.bool,
  hasCICTemplate: _propTypes2.default.bool.isRequired,
  cicCategoryTemplate: _propTypes2.default.object,
  fetchCICCategoriesIfNeeded: _propTypes2.default.func
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      sessionPlanId = _ownProps$params.sessionPlanId;

  var group = state.get('rootReducer').get('groups').get(groupId).data;

  var _Group$getCentre = _.actions.getCentre(state, group.id),
      timeZone = _Group$getCentre.timeZone;

  var languageCode = group.get('languageCode');
  var groupName = group.name;
  var groupCode = group.number;

  var sessionPlanIds = group.sessionPlans;

  if (_is_js2.default.undefined(sessionPlanIds.data)) {
    return { timeZone: timeZone, groupName: groupName, sessionPlans: sessionPlanIds };
  }
  var isNotPublished = _CoveredInClass.accessors.isNotPublished(state, ownProps.params);
  var hasCICTemplate = _CoveredInClass.accessors.hasCICTemplate(state, ownProps.params);
  var hasCIC = _CoveredInClass.accessors.hasCIC(state, ownProps.params);
  var sessionPlansInfo = state.get('rootReducer').get('sessionPlans').filter(function (session) {
    return session.groupId === group.id;
  });
  var units = (0, _accessors.getUnitList)(state, groupId);
  var currentSessionPlanId = sessionPlanId;
  var sessionPlans = sessionPlanIds.update('data', function (data) {
    return new _immutable.List(data);
  }).update('data', function (data) {
    return data.map(function (planId) {
      return sessionPlansInfo.get(planId);
    });
  });
  var currentSessionIndex = sessionPlans.data.findIndex(function (plan) {
    return plan.id === currentSessionPlanId;
  });

  var cicCategoryTemplate = state.get('rootReducer').get('cicCategoryTemplate').get(groupId);

  var canEditCoveredInClass = !_.actions.isAutoPublishCIC(state, groupId) && !_.actions.isHFV4CourseTypeGroup(state, groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.CoveredInClass.MarkAndPublish);

  var coveredInClassContent = state.get('rootReducer').get('coveredInClassContent').get(currentSessionPlanId);

  var coveredInClassTemplate = state.get('rootReducer').get('coveredInClassTemplate').get(currentSessionPlanId);
  coveredInClassTemplate = hasCICTemplate && coveredInClassTemplate.map(function (CIC) {
    return CIC.set('unitOrderingSequence', (0, _accessors.getUnitNumberById)(units, '' + CIC.unitId));
  }).sort(sortCoverdInClass);

  if (hasCIC || !isNotPublished) {
    coveredInClassContent = coveredInClassContent.map(function (CIC) {
      return CIC.set('unitOrderingSequence', (0, _accessors.getUnitNumberById)(units, '' + CIC.unitId));
    }).sort(sortCoverdInClass);
  } else {
    coveredInClassContent = coveredInClassTemplate;
  }

  var showNavigationBar = _UiState.actions.getShowNavigationBar(state);
  return {
    state: state,
    timeZone: timeZone,
    groupName: groupName,
    groupCode: groupCode,
    languageCode: languageCode,
    sessionPlans: sessionPlans,
    currentSessionIndex: currentSessionIndex,
    coveredInClassContent: coveredInClassContent,
    coveredInClassTemplate: coveredInClassTemplate,
    canEditCoveredInClass: canEditCoveredInClass,
    sessions: sessionPlansInfo,
    isNotPublished: isNotPublished,
    hasCICTemplate: hasCICTemplate,
    hasCIC: hasCIC,
    currentSessionId: currentSessionPlanId,
    showNavigationBar: showNavigationBar,
    isAnyApiCalling: !!isAnyApiCalling(state),
    cicCategoryTemplate: cicCategoryTemplate
  };
}

function sortCoverdInClass(a, b) {
  if (a.unitOrderingSequence !== b.unitOrderingSequence) {
    return a.unitOrderingSequence - b.unitOrderingSequence;
  }
  return a.lessonNumber - b.lessonNumber;
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_SessionPlans.actions, dispatch), (0, _redux.bindActionCreators)(_CoveredInClass.actions, dispatch), (0, _redux.bindActionCreators)(_Template.actions, dispatch), (0, _redux.bindActionCreators)(_CategoryTemplate.actions, dispatch));
}

function isAnyApiCalling(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST', 'GET'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(CoveredInClass));

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1538);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1539);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _PageActivitiesSelector = __webpack_require__(1541);

var _PageActivitiesSelector2 = _interopRequireDefault(_PageActivitiesSelector);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _accessors = __webpack_require__(304);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageActivitiesPart = function PageActivitiesPart(props) {
  var isEditMode = props.isEditMode,
      pageActivities = props.pageActivities,
      template = props.template;

  var renderActivities = pageActivities;

  if (!isEditMode && template) {
    renderActivities = (0, _accessors.activityDeepMerge)(template, pageActivities);
  }

  if (!renderActivities || renderActivities.size === 0) {
    return _react2.default.createElement('div', null);
  }

  return _react2.default.createElement(
    _omniCommonUi.PageCard,
    { className: _style2.default.PageActivitiesPart },
    _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Pages & Activities' }),
    _react2.default.createElement(
      _omniCommonUi.PageCard.Content,
      null,
      renderPageActivitiesContent()
    )
  );

  function renderPageActivitiesContent() {
    if (isEditMode) {
      return _react2.default.createElement(
        _omniCommonUi.Grid,
        null,
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          pageActivities.map(function (pageActivitiesItem, index) {
            return _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12, sm: 6, md: 4 },
              _react2.default.createElement(_PageActivitiesSelector2.default, { title: pageActivitiesItem.cicActivityName,
                onActivityChecked: function onActivityChecked(ChangedItemIndex, activities) {
                  return onPageActivitiesChanged(ChangedItemIndex, activities);
                },
                activities: pageActivitiesItem.cicActivityItems,
                index: index,
                isEditMode: true })
            );
          })
        )
      );
    }

    return _react2.default.createElement(
      'div',
      { className: _style2.default.PageActivitiesPart_container_view },
      _react2.default.createElement(
        _omniCommonUi.Grid,
        null,
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          renderActivities.map(function (pageActivitiesItem) {
            return _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12, sm: 6, md: 4 },
              _react2.default.createElement(_PageActivitiesSelector2.default, { title: pageActivitiesItem.cicActivityName,
                activities: pageActivitiesItem.cicActivityItems })
            );
          })
        )
      )
    );
  }

  function onPageActivitiesChanged(ChangedItemIndex, activities) {
    var pageActivitiesItem = pageActivities.get(ChangedItemIndex);
    var newPageActivities = pageActivities.set(ChangedItemIndex, pageActivitiesItem.set('cicActivityItems', activities));
    props.onPageActivitiesChanged(newPageActivities);
  }
};

PageActivitiesPart.propTypes = {
  isEditMode: _propTypes2.default.bool,
  pageActivities: _propTypes2.default.object.isRequired,
  template: _propTypes2.default.object,
  onPageActivitiesChanged: _propTypes2.default.func
};

exports.default = PageActivitiesPart;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1544);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _immutable = __webpack_require__(3);

var _CICCategoryCard = __webpack_require__(675);

var _CICCategoryCard2 = _interopRequireDefault(_CICCategoryCard);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _accessors = __webpack_require__(304);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoveredInClassCategoryView = function CoveredInClassCategoryView(props) {
  var categories = props.categories,
      isEdit = props.isEdit,
      template = props.template,
      onCategoriesChanged = props.onCategoriesChanged;

  var renderedCategories = categories;
  if (!isEdit && template) {
    renderedCategories = (0, _accessors.categoryDeepMerge)(template, categories);
  }

  function renderCategories() {
    var mergedCategories = (0, _accessors.mergeCategoriesByName)(renderedCategories);
    if (mergedCategories.size > 0) {
      return _react2.default.createElement(
        _omniCommonUi.Grid,
        null,
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          mergedCategories.map(function (categoryObject) {
            var lastIsOdd = mergedCategories.size % 2 !== 0;
            if (lastIsOdd && mergedCategories.indexOf(categoryObject) === mergedCategories.size - 1) {
              return _react2.default.createElement(
                _omniCommonUi.Grid.Item,
                { xs: 12,
                  sm: 12,
                  md: 12,
                  key: categoryObject.cicCategoryName },
                _react2.default.createElement(
                  'div',
                  { className: _style2.default.CoveredInClassCategoryView_categoryCardContainer_lastodd },
                  _react2.default.createElement(_CICCategoryCard2.default, { title: categoryObject.cicCategoryName,
                    isEdit: isEdit,
                    categoriesList: categoryObject.cicCategoryItems,
                    onFreeTextChange: function onFreeTextChange(freeText) {
                      return handleFreeTextChange(freeText, categoryObject.cicCategoryId);
                    },
                    onItemCheck: function onItemCheck(categoryId, itemId, value) {
                      return handleItemChecked(categoryId, itemId, value);
                    } })
                )
              );
            }
            return _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12, sm: 12, md: 6 },
              _react2.default.createElement(
                'div',
                { className: _style2.default.CoveredInClassCategoryView_categoryCardContainer },
                _react2.default.createElement(_CICCategoryCard2.default, { title: categoryObject.cicCategoryName,
                  isEdit: isEdit,
                  categoriesList: categoryObject.cicCategoryItems,
                  onFreeTextChange: function onFreeTextChange(freeText) {
                    return handleFreeTextChange(freeText, categoryObject.cicCategoryId);
                  },
                  onItemCheck: function onItemCheck(categoryId, itemId, value) {
                    return handleItemChecked(categoryId, itemId, value);
                  } })
              )
            );
          })
        )
      );
    }
  }

  function handleItemChecked(categoryId, categoryItemId, isChecked) {
    var newCategories = getNewCategories(categoryId, categoryItemId, isChecked);
    onCategoriesChanged(newCategories);
  }

  function handleFreeTextChange(freeText, categoryId) {
    var newCategories = getNewCategoriesForFreeText(freeText, categoryId);
    onCategoriesChanged(newCategories);
  }

  function getNewCategoriesForFreeText(freeText, categoryId) {
    var newCategoriesArray = new _immutable.List();
    if (categories) {
      newCategoriesArray = categories.map(function (categoryObject) {
        if (categoryObject.cicCategoryId === categoryId) {
          return categoryObject.update('cicCategoryItems', function (cicCategoryItems) {
            var freeTextIndex = cicCategoryItems.findIndex(function (item) {
              return item.cicCategoryItemId === 0;
            });
            if (freeTextIndex >= 0) {
              if (_is_js2.default.string(freeText) && _is_js2.default.not.empty(freeText)) {
                return cicCategoryItems.update(freeTextIndex, function (item) {
                  return item.set('cicCategoryItemName', freeText);
                });
              }
              return cicCategoryItems.delete(freeTextIndex);
            }
          });
        }
        return categoryObject;
      });
    }
    return newCategoriesArray;
  }

  function getNewCategories(categoryId, itemId, isChecked) {
    var newCategoriesArray = new _immutable.List();
    if (categories) {
      categories.map(function (categoryObject) {
        if (categoryObject.cicCategoryId === categoryId && categoryObject.cicCategoryItems) {
          var newItems = getNewCagetoryItems(categoryObject.cicCategoryItems, itemId, isChecked);
          newCategoriesArray = newCategoriesArray.push(categoryObject.set('cicCategoryItems', newItems));
        } else {
          newCategoriesArray = newCategoriesArray.push(categoryObject);
        }
        return false;
      });
    }

    return newCategoriesArray;
  }

  function getNewCagetoryItems(oldItems, itemId, isChecked) {
    var newItems = new _immutable.List();
    oldItems.map(function (oldItem) {
      if (oldItem.cicCategoryItemId === itemId) {
        var newItem = oldItem;
        newItems = newItems.push(newItem.set('isChecked', isChecked));
      } else {
        newItems = newItems.push(oldItem);
      }

      return false;
    });

    return newItems;
  }
  return _react2.default.createElement(
    'div',
    { className: _style2.default.CoveredInClassCategoryView },
    renderCategories()
  );
};

CoveredInClassCategoryView.propTypes = {
  isEdit: _propTypes2.default.bool.isRequired,
  lessons: _propTypes2.default.array,
  categories: _propTypes2.default.shape({
    map: _propTypes2.default.func
  }).isRequired,
  template: _propTypes2.default.shape({
    map: _propTypes2.default.func
  }).isRequired,
  onCategoriesChanged: _propTypes2.default.func.isRequired
};

exports.default = CoveredInClassCategoryView;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1546);

var _style2 = _interopRequireDefault(_style);

var _dompurify = __webpack_require__(1548);

var _dompurify2 = _interopRequireDefault(_dompurify);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = __webpack_require__(7);

var _classnames4 = _interopRequireDefault(_classnames3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CICCategoryCard = function (_Component) {
  _inherits(CICCategoryCard, _Component);

  function CICCategoryCard(props) {
    _classCallCheck(this, CICCategoryCard);

    var _this = _possibleConstructorReturn(this, (CICCategoryCard.__proto__ || Object.getPrototypeOf(CICCategoryCard)).call(this, props));

    _this.state = {
      isFreeTextInEdit: false,
      tempFreeText: null
    };
    return _this;
  }

  _createClass(CICCategoryCard, [{
    key: "_changeFreeText",
    value: function _changeFreeText(val) {
      this.setState({ tempFreeText: val });
    }
  }, {
    key: "_editFreeText",
    value: function _editFreeText(freeText) {
      this.setState({ isFreeTextInEdit: true, tempFreeText: freeText });
    }
  }, {
    key: "_onBlureFreeText",
    value: function _onBlureFreeText() {
      var tempFreeText = this.state.tempFreeText;

      this.props.onFreeTextChange(tempFreeText);
      this.setState({ isFreeTextInEdit: false });
    }
  }, {
    key: "_renderFreeText",
    value: function _renderFreeText(item) {
      var _this2 = this;

      var isEdit = this.props.isEdit;
      var _state = this.state,
          tempFreeText = _state.tempFreeText,
          isFreeTextInEdit = _state.isFreeTextInEdit;


      var itemClassName = isEdit ? _style2.default.CICCategoryCard_categoryItem_edit : _style2.default.CICCategoryCard_categoryItem;

      var headerClassName = (0, _classnames4.default)(_style2.default.CICCategoryCard_freeText_header, _defineProperty({}, _style2.default.CICCategoryCard_freeText_header_edit, isEdit));

      var checkBoxId = item.cicCategoryId + "-" + item.cicCategoryItemId;

      return _react2.default.createElement(
        "div",
        { className: _style2.default.CICCategoryCard_freeText },
        _react2.default.createElement(
          "div",
          { className: headerClassName },
          _react2.default.createElement(
            "div",
            { className: _style2.default.CICCategoryCard_freeText_header_title },
            "Free Text"
          ),
          isEdit && !isFreeTextInEdit && _react2.default.createElement(_omniCommonUi.Icon, {
            id: "edit",
            onClick: function onClick() {
              return _this2._editFreeText(item.cicCategoryItemName);
            }
          })
        ),
        _react2.default.createElement(
          "label",
          { className: itemClassName, key: checkBoxId, htmlFor: checkBoxId },
          isEdit ? _react2.default.createElement(_omniCommonUi.Checkbox, {
            id: checkBoxId,
            checked: item.isChecked,
            onChange: function onChange(checkBoxStatus) {
              return _this2._handleCheckBoxChecked(item.cicCategoryId, item.cicCategoryItemId, checkBoxStatus);
            }
          }) : "",
          isFreeTextInEdit ? _react2.default.createElement(_omniCommonUi.TextArea, {
            value: tempFreeText,
            onChange: function onChange(e) {
              return _this2._changeFreeText(e.target.value);
            },
            maxLength: 1000,
            onBlur: function onBlur() {
              return _this2._onBlureFreeText();
            },
            autoFocus: true
          }) : _react2.default.createElement(
            "span",
            { className: _style2.default.CICCategoryCard_categoryItem_content },
            item.cicCategoryItemName
          )
        )
      );
    }
  }, {
    key: "_renderCategories",
    value: function _renderCategories() {
      var _this3 = this;

      if (this.props.categoriesList) {
        return _react2.default.createElement(
          "div",
          { className: _style2.default.CICCategoryCard_categories },
          this.props.categoriesList.map(function (categoryItem) {
            if (categoryItem.cicCategoryItemId === 0) {
              return _this3._renderFreeText(categoryItem);
            }
            return _this3._renderCategoryItem(categoryItem);
          })
        );
      }
    }
  }, {
    key: "_renderCategoryItem",
    value: function _renderCategoryItem(item) {
      var _this4 = this;

      var isEdit = this.props.isEdit;

      var id = item.cicCategoryId;
      var itemClassName = isEdit ? _style2.default.CICCategoryCard_categoryItem_edit : _style2.default.CICCategoryCard_categoryItem;
      var itemSpanClassName = (0, _classnames4.default)(_style2.default.CICCategoryCard_categoryItem_content, _defineProperty({}, _style2.default.CICCategoryCard_categoryItem_content_uncheck, !isEdit && !item.isChecked));
      var checkBoxId = id + "-" + item.cicCategoryItemId;
      return _react2.default.createElement(
        "label",
        { className: itemClassName, key: checkBoxId, htmlFor: checkBoxId },
        isEdit ? _react2.default.createElement(_omniCommonUi.Checkbox, {
          id: checkBoxId,
          checked: item.isChecked,
          onChange: function onChange(checkBoxStatus) {
            return _this4._handleCheckBoxChecked(id, item.cicCategoryItemId, checkBoxStatus);
          }
        }) : "",
        _react2.default.createElement("span", { className: itemSpanClassName,
          dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(item.cicCategoryItemName) } })
      );
    }
  }, {
    key: "_handleCheckBoxChecked",
    value: function _handleCheckBoxChecked(id, itemId, checkBoxStatus) {
      _reactGa2.default.event({
        category: "Covered in Class",
        action: "Clicked checkbox",
        label: "Clicked checkbox for " + itemId
      });
      this.props.onItemCheck(id, itemId, checkBoxStatus);
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        {
          className: (0, _classnames4.default)(_style2.default.CICCategoryCard, (0, _omniCommonUi.testClass)("cic-category-card"))
        },
        _react2.default.createElement(
          _omniCommonUi.PageCard,
          { className: _style2.default.CICCategoryCard_card },
          _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: this.props.title }),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            null,
            _react2.default.createElement(
              "div",
              { className: _style2.default.CICCategoryCard_container },
              this._renderCategories()
            )
          )
        )
      );
    }
  }]);

  return CICCategoryCard;
}(_react.Component);

CICCategoryCard.propTypes = {
  title: _propTypes2.default.string.isRequired,
  categoriesList: _propTypes2.default.shape({
    map: _propTypes2.default.func.isRequired
  }).isRequired,
  isEdit: _propTypes2.default.bool,
  id: _propTypes2.default.number,
  onItemCheck: _propTypes2.default.func,
  onFreeTextChange: _propTypes2.default.func
};

exports.default = CICCategoryCard;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESET_COVERED_IN_CLASS_OBJECT = exports.CHANGE_COVERED_IN_CLASS_OBJECT = exports.CLEAR_CIC_FAILURE = exports.CLEAR_CIC_SUCCESS = exports.CLEAR_CIC_REQUEST = exports.PUBLISH_CIC_FAILURE = exports.PUBLISH_CIC_SUCCESS = exports.PUBLISH_CIC_REQUEST = exports.FETCH_COVERED_IN_CLASS_CONTENT_FAILURE = exports.FETCH_COVERED_IN_CLASS_CONTENT_SUCCESS = exports.FETCH_COVERED_IN_CLASS_CONTENT_REQUEST = undefined;
exports.fetchCoveredInClassIfNeeded = fetchCoveredInClassIfNeeded;
exports.fetchCoveredInClass = fetchCoveredInClass;
exports.publishCoveredInClass = publishCoveredInClass;
exports.clearCoveredInClass = clearCoveredInClass;
exports.changeCoveredInClassObject = changeCoveredInClassObject;
exports.resetCoveredInClass = resetCoveredInClass;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_COVERED_IN_CLASS_CONTENT_REQUEST = exports.FETCH_COVERED_IN_CLASS_CONTENT_REQUEST = 'FETCH_COVERED_IN_CLASS_CONTENT_REQUEST';
var FETCH_COVERED_IN_CLASS_CONTENT_SUCCESS = exports.FETCH_COVERED_IN_CLASS_CONTENT_SUCCESS = 'FETCH_COVERED_IN_CLASS_CONTENT_SUCCESS';
var FETCH_COVERED_IN_CLASS_CONTENT_FAILURE = exports.FETCH_COVERED_IN_CLASS_CONTENT_FAILURE = 'FETCH_COVERED_IN_CLASS_CONTENT_FAILURE';
var PUBLISH_CIC_REQUEST = exports.PUBLISH_CIC_REQUEST = 'PUBLISH_CIC_REQUEST';
var PUBLISH_CIC_SUCCESS = exports.PUBLISH_CIC_SUCCESS = 'PUBLISH_CIC_SUCCESS';
var PUBLISH_CIC_FAILURE = exports.PUBLISH_CIC_FAILURE = 'PUBLISH_CIC_FAILURE';
var CLEAR_CIC_REQUEST = exports.CLEAR_CIC_REQUEST = 'CLEAR_CIC_REQUEST';
var CLEAR_CIC_SUCCESS = exports.CLEAR_CIC_SUCCESS = 'CLEAR_CIC_SUCCESS';
var CLEAR_CIC_FAILURE = exports.CLEAR_CIC_FAILURE = 'CLEAR_CIC_FAILURE';
var CHANGE_COVERED_IN_CLASS_OBJECT = exports.CHANGE_COVERED_IN_CLASS_OBJECT = 'CHANGE_COVERED_IN_CLASS_OBJECT';
var RESET_COVERED_IN_CLASS_OBJECT = exports.RESET_COVERED_IN_CLASS_OBJECT = 'RESET_COVERED_IN_CLASS_OBJECT';

var buildCoveredInClassUrl = function buildCoveredInClassUrl(sessionId) {
  return (0, _Api.buildUrl)('/sessions/' + sessionId + '/covered-in-classes');
};

function fetchCoveredInClassIfNeeded(sessionId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildCoveredInClassUrl(sessionId) })) {
      return false;
    }

    return dispatch(fetchCoveredInClass(sessionId));
  };
}

function fetchCoveredInClass(sessionId) {
  return function (dispatch) {
    var url = buildCoveredInClassUrl(sessionId);
    var method = 'GET';

    return dispatch(fetchCoveredInClassRequest()).payload.then(function (response) {
      return dispatch(fetchCoveredInClassSuccess(response));
    }).catch(function (error) {
      if (error.response.code === 404) {
        return dispatch(fetchCoveredInClassSuccess());
      }

      return dispatch(fetchCoveredInClassFailure(error));
    });

    function fetchCoveredInClassRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_CONTENT_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchCoveredInClassSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_CONTENT_SUCCESS,
        payload: response,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchCoveredInClassFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_CONTENT_FAILURE,
        error: error,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }
  };
}

function publishCoveredInClass(coveredInClassObject, sessionId) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/sessions/' + sessionId + '/cic-publish');
    var method = 'PUT';

    return dispatch(publishCoveredInClassRequest()).payload.then(function (response) {
      return dispatch(publishCoveredInClassSuccess(response));
    }).catch(function (error) {
      return dispatch(publishCoveredInClassFailure(error));
    });

    function publishCoveredInClassRequest() {
      var param = {
        method: method,
        body: JSON.stringify(coveredInClassObject)
      };
      return _omniCommonUi.ApiCall.createAction({
        type: PUBLISH_CIC_REQUEST,
        payload: (0, _Api.fetch)(url, param),
        url: url,
        method: method,
        disableDefault: true
      });
    }

    function publishCoveredInClassSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: PUBLISH_CIC_SUCCESS,
        payload: response,
        url: url,
        method: method,
        disableDefault: true
      });
    }

    function publishCoveredInClassFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: PUBLISH_CIC_FAILURE,
        error: error,
        url: url,
        method: method,
        disableDefault: true
      });
    }
  };
}

function clearCoveredInClass(sessionId) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/sessions/' + sessionId + '/cic-clear');
    var method = 'DELETE';

    return dispatch(clearCoveredInClassRequest()).payload.then(function (response) {
      return dispatch(clearCoveredInClassSuccess(response));
    }).catch(function (error) {
      return dispatch(clearCoveredInClassFailure(error));
    });

    function clearCoveredInClassRequest() {
      var param = { method: method };
      return _omniCommonUi.ApiCall.createAction({
        type: CLEAR_CIC_REQUEST,
        payload: (0, _Api.fetch)(url, param),
        url: url,
        method: method,
        disableDefault: true
      });
    }

    function clearCoveredInClassSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: CLEAR_CIC_SUCCESS,
        payload: response,
        url: url,
        method: method,
        disableDefault: true
      });
    }

    function clearCoveredInClassFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: CLEAR_CIC_FAILURE,
        error: error,
        url: url,
        method: method,
        disableDefault: true
      });
    }
  };
}

function changeCoveredInClassObject(newObject, sessionId) {
  return {
    type: CHANGE_COVERED_IN_CLASS_OBJECT,
    payload: newObject,
    sessionId: sessionId
  };
}

function resetCoveredInClass(sessionId) {
  return {
    type: RESET_COVERED_IN_CLASS_OBJECT,
    sessionId: sessionId
  };
}

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_COVERED_IN_CLASS_TEMPLATE_FAILURE = exports.FETCH_COVERED_IN_CLASS_TEMPLATE_SUCCESS = exports.FETCH_COVERED_IN_CLASS_TEMPLATE_REQUEST = undefined;
exports.fetchHFv4CICTemplateIfNeeded = fetchHFv4CICTemplateIfNeeded;
exports.fetchHFv4CICTemplate = fetchHFv4CICTemplate;
exports.fetchCoveredInClassTemplateIfNeeded = fetchCoveredInClassTemplateIfNeeded;
exports.fetchCoveredInClassTemplate = fetchCoveredInClassTemplate;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_COVERED_IN_CLASS_TEMPLATE_REQUEST = exports.FETCH_COVERED_IN_CLASS_TEMPLATE_REQUEST = 'FETCH_COVERED_IN_CLASS_TEMPLATE_REQUEST';
var FETCH_COVERED_IN_CLASS_TEMPLATE_SUCCESS = exports.FETCH_COVERED_IN_CLASS_TEMPLATE_SUCCESS = 'FETCH_COVERED_IN_CLASS_TEMPLATE_SUCCESS';
var FETCH_COVERED_IN_CLASS_TEMPLATE_FAILURE = exports.FETCH_COVERED_IN_CLASS_TEMPLATE_FAILURE = 'FETCH_COVERED_IN_CLASS_TEMPLATE_FAILURE';

var buildCICTemplateUrl = function buildCICTemplateUrl(sessionId) {
  return (0, _Api.buildUrl)('/sessions/' + sessionId + '/cic-template');
};
var buildHFv4CICTemplateUrl = function buildHFv4CICTemplateUrl(sessionId, language) {
  return (0, _Api.buildUrl)('/sessions/' + sessionId + '/hf-v4-cic-template' + (language ? '?language=' + language : ''));
};

function fetchHFv4CICTemplateIfNeeded(sessionId, language) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildHFv4CICTemplateUrl(sessionId, language) })) {
      return false;
    }

    return dispatch(fetchHFv4CICTemplate(sessionId, language));
  };
}

function fetchHFv4CICTemplate(sessionId, language) {
  return function (dispatch) {
    var url = buildHFv4CICTemplateUrl(sessionId, language);
    var method = 'GET';

    return dispatch(fetchHFv4CICTemplateRequest()).payload.then(function (response) {
      return dispatch(fetchHFv4CICTemplateSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchHFv4CICTemplateFailure(error));
    });

    function fetchHFv4CICTemplateRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_TEMPLATE_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchHFv4CICTemplateSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_TEMPLATE_SUCCESS,
        payload: response,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchHFv4CICTemplateFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_TEMPLATE_FAILURE,
        error: error,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }
  };
}

function fetchCoveredInClassTemplateIfNeeded(sessionId, isDefaultUnchecked) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildCICTemplateUrl(sessionId) })) {
      return false;
    }

    return dispatch(fetchCoveredInClassTemplate(sessionId, isDefaultUnchecked));
  };
}

function fetchCoveredInClassTemplate(sessionId, isDefaultUnchecked) {
  return function (dispatch) {
    var url = buildCICTemplateUrl(sessionId);
    var method = 'GET';

    return dispatch(fetchCICTemplateRequest()).payload.then(function (response) {
      return dispatch(fetchCICTemplateSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchCICTemplateFailure(error));
    });

    function fetchCICTemplateRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_TEMPLATE_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchCICTemplateSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_TEMPLATE_SUCCESS,
        payload: response,
        url: url,
        method: method,
        sessionId: sessionId,
        isDefaultUnchecked: isDefaultUnchecked
      });
    }

    function fetchCICTemplateFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_TEMPLATE_FAILURE,
        error: error,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }
  };
}

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_CIC_CATEGORIES_FAILURE = exports.FETCH_CIC_CATEGORIES_SUCCESS = exports.FETCH_CIC_CATEGORIES_REQUEST = undefined;
exports.fetchCICCategoriesIfNeeded = fetchCICCategoriesIfNeeded;
exports.fetchCICCategories = fetchCICCategories;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var DISABLE_DEFAULT_ACTION_EXTRAS = { disableDefault: true };

var ACTION_OBJECT_NAME = 'CIC_CATEGORIES';

var FETCH_CIC_CATEGORIES_REQUEST = exports.FETCH_CIC_CATEGORIES_REQUEST = 'FETCH_' + ACTION_OBJECT_NAME + '_REQUEST';
var FETCH_CIC_CATEGORIES_SUCCESS = exports.FETCH_CIC_CATEGORIES_SUCCESS = 'FETCH_' + ACTION_OBJECT_NAME + '_SUCCESS';
var FETCH_CIC_CATEGORIES_FAILURE = exports.FETCH_CIC_CATEGORIES_FAILURE = 'FETCH_' + ACTION_OBJECT_NAME + '_FAILURE';

var buildCICCategoriesURL = function buildCICCategoriesURL(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/cic-category');
};

function fetchCICCategoriesIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildCICCategoriesURL(groupId) })) {
      return false;
    }
    return dispatch(fetchCICCategories(groupId));
  };
}

function fetchCICCategories(groupId) {
  return (0, _omniCommonUi.createApiActionCreator)(ACTION_OBJECT_NAME, buildCICCategoriesURL(groupId), 'GET', DISABLE_DEFAULT_ACTION_EXTRAS, { groupId: groupId });
}

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1561);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _InternalNoteView = __webpack_require__(207);

var _InternalNoteView2 = _interopRequireDefault(_InternalNoteView);

var _omniCommonUi = __webpack_require__(0);

var _redux = __webpack_require__(10);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _InternalNotes = __webpack_require__(307);

var _AddInternalNoteControl = __webpack_require__(67);

var _AddInternalNoteControl2 = _interopRequireDefault(_AddInternalNoteControl);

var _Users = __webpack_require__(82);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _routes = __webpack_require__(308);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MESSAGE_DISCARD_FORM = "Are you sure you want to delete this note?";
var CANCEL = "CANCEL";
var DELETE = "DELETE";

var InternalNotesPart = function (_Component) {
  _inherits(InternalNotesPart, _Component);

  function InternalNotesPart(props) {
    _classCallCheck(this, InternalNotesPart);

    var _this = _possibleConstructorReturn(this, (InternalNotesPart.__proto__ || Object.getPrototypeOf(InternalNotesPart)).call(this, props));

    _this.isAutoSaving = false;
    return _this;
  }

  _createClass(InternalNotesPart, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this._fetchData(this.props);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_is_js2.default.function(this.props.onComponentMounted)) {
        return;
      }
      this.props.onComponentMounted(this);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps() {
      this._fetchData(this.props);
    }
  }, {
    key: "_fetchData",
    value: function _fetchData(props) {
      var sessionPlanId = this.props.sessionPlanId;

      if (_is_js2.default.undefined(sessionPlanId)) {
        return;
      }

      props.fetchInternalNotesIfNeeded(sessionPlanId);
    }
  }, {
    key: "_onEditButtonClick",
    value: function _onEditButtonClick(index) {
      _reactGa2.default.event({
        category: "Covered in Class",
        action: 'Clicked "Edit"'
      });

      this.props.onChangeMode({ mode: _routes.Modes.EDIT_NOTES, index: index });
    }
  }, {
    key: "_onDeleteButtonClick",
    value: function _onDeleteButtonClick(index) {
      _reactGa2.default.event({
        category: "Covered in Class",
        action: 'Clicked "Delete"'
      });

      var internalNote = this.props.internalNotes.data[index];
      this.props.deleteInternalNote(this.props.sessionPlanId, index, internalNote);
      this.props.deleteInternalNoteFromServer(this.props.sessionPlanId, internalNote);
    }
  }, {
    key: "_onDeleteIconClick",
    value: function _onDeleteIconClick(index) {
      this.props.onChangeMode({ mode: _routes.Modes.DELETE_NOTES, index: index });
    }
  }, {
    key: "_onEndEditNote",
    value: function _onEndEditNote() {
      this.props.onChangeMode({ mode: "", index: "" });
    }
  }, {
    key: "_onDiscardEditClick",
    value: function _onDiscardEditClick() {
      _reactGa2.default.event({
        category: "Covered in Class",
        action: 'Clicked "Discard"'
      });

      this._onEndEditNote();
    }
  }, {
    key: "_isAddNote",
    value: function _isAddNote() {
      return this.props.modeAndIndex.mode === _routes.Modes.ADD_NOTES;
    }
  }, {
    key: "_isEditNote",
    value: function _isEditNote() {
      return this.props.modeAndIndex.mode === _routes.Modes.EDIT_NOTES;
    }
  }, {
    key: "_isAddingOrEditingNote",
    value: function _isAddingOrEditingNote() {
      return this._isAddNote() || this._isEditNote();
    }
  }, {
    key: "autoSaveNotesIfNeeded",
    value: function autoSaveNotesIfNeeded() {
      if (!this.addInternalNoteControlComponent) return;
      if (!this._isAddingOrEditingNote()) return;

      this.isAutoSaving = true;
      this.addInternalNoteControlComponent.forceSave();
      this.isAutoSaving = false;
    }
  }, {
    key: "_renderNotes",
    value: function _renderNotes() {
      var _this2 = this;

      var _props = this.props,
          state = _props.state,
          internalNotes = _props.internalNotes,
          currentUserId = _props.currentUserId,
          modeAndIndex = _props.modeAndIndex,
          timeZone = _props.timeZone;

      return internalNotes.data.map(function (note, index) {
        var showBottomLine = index + 1 !== internalNotes.data.length || _this2._isAddNote();
        if (parseInt(modeAndIndex.index, 10) === index && _this2._isEditNote()) {
          return _react2.default.createElement(
            "div",
            { className: _style2.default.InternalNotesPart_addNote },
            _react2.default.createElement(_AddInternalNoteControl2.default, {
              ref: function ref(_cmpnt) {
                _this2.addInternalNoteControlComponent = _cmpnt;
              },
              maxCharacters: 500,
              text: note.note,
              onDiscardClick: function onDiscardClick() {
                return _this2._onDiscardEditClick();
              },
              onSaveClick: function onSaveClick(text) {
                return _this2._onSaveNotes(index, text);
              },
              onChange: function onChange() {}
            }),
            showBottomLine && _react2.default.createElement("div", { className: _style2.default.InternalNotesPart_line })
          );
        }
        var canOperate = currentUserId === note.userId && _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.CoveredInClass.AddCommentToInternal);
        var noteViewMode = {
          note: note.note,
          userId: note.userId,
          date: note.updateDateTimeUtc,
          timeZone: timeZone
        };
        return _react2.default.createElement(_InternalNoteView2.default, {
          index: index,
          note: noteViewMode,
          showBottomLine: showBottomLine,
          canOperate: canOperate,
          onEditButtonClick: function onEditButtonClick() {
            return _this2._onEditButtonClick(index);
          },
          onDeleteButtonClick: function onDeleteButtonClick() {
            return _this2._onDeleteIconClick(index);
          }
        });
      });
    }
  }, {
    key: "_onSaveNotes",
    value: function _onSaveNotes(index, text) {
      var isAdding = index < 0;

      _reactGa2.default.event({
        category: "Covered in Class",
        action: 'Clicked "Save"'
      });

      if (!this.isAutoSaving) this._onEndEditNote();

      var newInternalNote = {
        note: text,
        userName: this.props.currentUserName,
        userId: this.props.currentUserId
      };
      if (isAdding) {
        this.props.addInternalNote(this.props.sessionPlanId, newInternalNote);
      } else {
        newInternalNote = this.props.internalNotes.data[index];
        newInternalNote.note = text;
        this.props.editInternalNote(this.props.sessionPlanId, index, newInternalNote);
      }
    }
  }, {
    key: "_renderAddNoteControl",
    value: function _renderAddNoteControl() {
      var _this3 = this;

      if (this._isAddNote()) {
        var index = -1;
        return _react2.default.createElement(
          "div",
          { className: _style2.default.InternalNotesPart_addNote },
          _react2.default.createElement(_AddInternalNoteControl2.default, {
            ref: function ref(_cmpnt) {
              _this3.addInternalNoteControlComponent = _cmpnt;
            },
            maxCharacters: 500,
            noteDescription: "This note will not be published to EF Parents.",
            onDiscardClick: function onDiscardClick() {
              return _this3._onEndEditNote();
            },
            onSaveClick: function onSaveClick(text) {
              return _this3._onSaveNotes(index, text);
            },
            onChange: function onChange() {}
          })
        );
      }
    }
  }, {
    key: "_renderConfirmDialog",
    value: function _renderConfirmDialog() {
      var _this4 = this;

      var modeAndIndex = this.props.modeAndIndex;

      if (modeAndIndex.mode !== _routes.Modes.DELETE_NOTES || parseInt(modeAndIndex.index, 10) < 0) {
        return;
      }

      return _react2.default.createElement(_omniCommonUi.ConfirmDialog, {
        isOpen: true,
        content: MESSAGE_DISCARD_FORM,
        primaryButtonContent: CANCEL,
        secondaryButtonContent: DELETE,
        onRequestClose: function onRequestClose() {
          return _this4._onEndEditNote();
        },
        onPrimaryClick: function onPrimaryClick() {
          return _this4._onEndEditNote();
        },
        onSecondaryClick: function onSecondaryClick() {
          _this4._onDeleteButtonClick(modeAndIndex.index);
          _this4._onEndEditNote();
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var internalNotes = this.props.internalNotes;

      if (_is_js2.default.undefined(this.props.sessionPlanId) || _is_js2.default.undefined(internalNotes) || _omniCommonUi.ApiResponseHelper.isLoading(internalNotes) || !_omniCommonUi.ApiResponseHelper.hasSucceeded(internalNotes) || internalNotes.data.length === 0 && !this._isAddNote()) {
        return null;
      }

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: _style2.default.InternalNotesPart },
        _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: "Internal notes" }),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          null,
          this._renderNotes(),
          this._renderAddNoteControl(),
          this._renderConfirmDialog()
        )
      );
    }
  }]);

  return InternalNotesPart;
}(_react.Component);

InternalNotesPart.propTypes = {
  state: _propTypes2.default.object.isRequired,
  modeAndIndex: _propTypes2.default.object.isRequired,
  currentUserId: _propTypes2.default.any,
  currentUserName: _propTypes2.default.string,
  sessionPlanId: _propTypes2.default.string.isRequired,
  internalNotes: _propTypes2.default.object,
  onChangeMode: _propTypes2.default.func,
  fetchInternalNotesIfNeeded: _propTypes2.default.func,
  editInternalNotes: _propTypes2.default.func,
  addInternalNote: _propTypes2.default.func,
  editInternalNote: _propTypes2.default.func,
  deleteInternalNote: _propTypes2.default.func,
  deleteInternalNoteFromServer: _propTypes2.default.func,
  // needed because `ref` from the parent returns connect() :(
  onComponentMounted: _propTypes2.default.func,
  timeZone: _propTypes2.default.string
};

function mapStateToProps(state, ownProps) {
  var internalNotes = state.get("rootReducer").get("internalNotes").get(ownProps.sessionPlanId);
  var currentUserId = _Users.accessors.getCurrentUserId(state);
  currentUserId = currentUserId && parseInt(currentUserId, 10);
  var currentUserName = _Users.accessors.getCurrentUserName(state);
  return {
    state: state,
    internalNotes: internalNotes,
    currentUserId: currentUserId,
    currentUserName: currentUserName,
    timeZone: ownProps.timeZone
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign((0, _redux.bindActionCreators)(_InternalNotes.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(InternalNotesPart);

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_INTERNAL_NOTE_FAILURE = exports.DELETE_INTERNAL_NOTE_SUCCESS = exports.DELETE_INTERNAL_NOTE_REQUEST = exports.DELETE_INTERNAL_NOTE = exports.EDIT_INTERNAL_NOTE_FAILURE = exports.EDIT_INTERNAL_NOTE_SUCCESS = exports.EDIT_INTERNAL_NOTE_REQUEST = exports.ADD_INTERNAL_NOTE_FAILURE = exports.ADD_INTERNAL_NOTE_SUCCESS = exports.ADD_INTERNAL_NOTE_REQUEST = exports.FETCH_INTERNAL_NOTES_FAILURE = exports.FETCH_INTERNAL_NOTES_SUCCESS = exports.FETCH_INTERNAL_NOTES_REQUEST = undefined;
exports.fetchInternalNotesIfNeeded = fetchInternalNotesIfNeeded;
exports.fetchInternalNotes = fetchInternalNotes;
exports.addInternalNote = addInternalNote;
exports.editInternalNote = editInternalNote;
exports.deleteInternalNote = deleteInternalNote;
exports.deleteInternalNoteFromServer = deleteInternalNoteFromServer;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_INTERNAL_NOTES_REQUEST = exports.FETCH_INTERNAL_NOTES_REQUEST = 'FETCH_INTERNAL_NOTES_REQUEST';
var FETCH_INTERNAL_NOTES_SUCCESS = exports.FETCH_INTERNAL_NOTES_SUCCESS = 'FETCH_INTERNAL_NOTES_SUCCESS';
var FETCH_INTERNAL_NOTES_FAILURE = exports.FETCH_INTERNAL_NOTES_FAILURE = 'FETCH_INTERNAL_NOTES_FAILURE';
var ADD_INTERNAL_NOTE_REQUEST = exports.ADD_INTERNAL_NOTE_REQUEST = 'ADD_INTERNAL_NOTE_REQUEST';
var ADD_INTERNAL_NOTE_SUCCESS = exports.ADD_INTERNAL_NOTE_SUCCESS = 'ADD_INTERNAL_NOTE_SUCCESS';
var ADD_INTERNAL_NOTE_FAILURE = exports.ADD_INTERNAL_NOTE_FAILURE = 'ADD_INTERNAL_NOTE_FAILURE';
var EDIT_INTERNAL_NOTE_REQUEST = exports.EDIT_INTERNAL_NOTE_REQUEST = 'EDIT_INTERNAL_NOTE_REQUEST';
var EDIT_INTERNAL_NOTE_SUCCESS = exports.EDIT_INTERNAL_NOTE_SUCCESS = 'EDIT_INTERNAL_NOTE_SUCCESS';
var EDIT_INTERNAL_NOTE_FAILURE = exports.EDIT_INTERNAL_NOTE_FAILURE = 'EDIT_INTERNAL_NOTE_FAILURE';
var DELETE_INTERNAL_NOTE = exports.DELETE_INTERNAL_NOTE = 'DELETE_INTERNAL_NOTE';
var DELETE_INTERNAL_NOTE_REQUEST = exports.DELETE_INTERNAL_NOTE_REQUEST = 'DELETE_INTERNAL_NOTE_REQUEST';
var DELETE_INTERNAL_NOTE_SUCCESS = exports.DELETE_INTERNAL_NOTE_SUCCESS = 'DELETE_INTERNAL_NOTE_SUCCESS';
var DELETE_INTERNAL_NOTE_FAILURE = exports.DELETE_INTERNAL_NOTE_FAILURE = 'DELETE_INTERNAL_NOTE_FAILURE';

var buildFetchInternalNotesUrl = function buildFetchInternalNotesUrl(sessionPlanId) {
  var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return (0, _Api.buildUrl)('/sessions/' + sessionPlanId + '/notes' + extra);
};

function fetchInternalNotesIfNeeded(sessionPlanId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchInternalNotesUrl(sessionPlanId) })) {
      return false;
    }

    return dispatch(fetchInternalNotes(sessionPlanId));
  };
}

function fetchInternalNotes(sessionPlanId) {
  return function (dispatch) {
    var url = buildFetchInternalNotesUrl(sessionPlanId);
    var method = 'GET';

    return dispatch(fetchInternalNotesRequest()).payload.then(function (response) {
      return dispatch(fetchInternalNotesSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchInternalNotesFailure(error));
    });

    function fetchInternalNotesRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_INTERNAL_NOTES_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        sessionPlanId: sessionPlanId
      });
    }

    function fetchInternalNotesSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_INTERNAL_NOTES_SUCCESS,
        payload: response,
        url: url,
        method: method,
        sessionPlanId: sessionPlanId
      });
    }

    function fetchInternalNotesFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_INTERNAL_NOTES_FAILURE,
        error: error,
        url: url,
        method: method,
        sessionPlanId: sessionPlanId
      });
    }
  };
}

function addInternalNote(sessionPlanId, internalNote) {
  return function (dispatch) {
    var url = buildFetchInternalNotesUrl(sessionPlanId);
    var method = 'POST';

    return dispatch(addInternalNoteRequest()).payload.then(function (response) {
      return dispatch(addInternalNoteSuccess(response));
    }).then(function () {
      return dispatch(fetchInternalNotes(sessionPlanId));
    }).catch(function (error) {
      return dispatch(addInternalNoteFailure(error));
    });

    function addInternalNoteRequest() {
      var param = {
        method: method,
        body: JSON.stringify(internalNote)
      };
      return _omniCommonUi.ApiCall.createAction({
        type: ADD_INTERNAL_NOTE_REQUEST,
        payload: (0, _Api.fetch)(url, param),
        url: url,
        method: method,
        sessionPlanId: sessionPlanId
      });
    }

    function addInternalNoteSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: ADD_INTERNAL_NOTE_SUCCESS,
        payload: response,
        url: url,
        method: method,
        sessionPlanId: sessionPlanId
      });
    }

    function addInternalNoteFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: ADD_INTERNAL_NOTE_FAILURE,
        error: error,
        url: url,
        method: method,
        sessionPlanId: sessionPlanId
      });
    }
  };
}

function editInternalNote(sessionPlanId, index, internalNote) {
  return function (dispatch) {
    var url = buildFetchInternalNotesUrl(sessionPlanId, '/' + internalNote.noteId);
    var method = 'PUT';

    return dispatch(editInternalNoteRequest()).payload.then(function (response) {
      return dispatch(editInternalNoteSuccess(response));
    }).catch(function (error) {
      return dispatch(editInternalNoteFailure(error));
    }).then(function () {
      return dispatch(fetchInternalNotes(sessionPlanId));
    });

    function editInternalNoteRequest() {
      var param = {
        method: method,
        body: JSON.stringify(internalNote)
      };
      return _omniCommonUi.ApiCall.createAction({
        type: EDIT_INTERNAL_NOTE_REQUEST,
        payload: (0, _Api.fetch)(url, param),
        url: url,
        method: method,
        sessionPlanId: sessionPlanId
      });
    }

    function editInternalNoteSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: EDIT_INTERNAL_NOTE_SUCCESS,
        payload: response,
        url: url,
        method: method,
        sessionPlanId: sessionPlanId,
        index: index,
        internalNote: internalNote
      });
    }

    function editInternalNoteFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: EDIT_INTERNAL_NOTE_FAILURE,
        error: error,
        url: url,
        method: method,
        sessionPlanId: sessionPlanId
      });
    }
  };
}

function deleteInternalNote(sessionPlanId, index, internalNote) {
  return {
    type: DELETE_INTERNAL_NOTE,
    sessionPlanId: sessionPlanId,
    index: index,
    internalNote: internalNote
  };
}

function deleteInternalNoteFromServer(sessionPlanId, _ref) {
  var noteId = _ref.noteId;

  return function (dispatch) {
    var url = buildFetchInternalNotesUrl(sessionPlanId, '/' + noteId);
    var method = 'DELETE';

    return dispatch(deleteInternalNoteRequest()).payload.then(function (response) {
      return dispatch(deleteInternalNoteSuccess(response));
    }).catch(function (error) {
      return dispatch(deleteInternalNoteFailure(error));
    });

    function deleteInternalNoteRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: DELETE_INTERNAL_NOTE_REQUEST,
        payload: (0, _Api.fetch)(url, { method: method }),
        url: url,
        method: method,
        sessionPlanId: sessionPlanId
      });
    }

    function deleteInternalNoteSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: DELETE_INTERNAL_NOTE_SUCCESS,
        payload: response,
        url: url,
        method: method,
        sessionPlanId: sessionPlanId
      });
    }

    function deleteInternalNoteFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: DELETE_INTERNAL_NOTE_FAILURE,
        error: error,
        url: url,
        method: method,
        sessionPlanId: sessionPlanId
      });
    }
  };
}

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1565);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddFreeTextDialog = function (_PureComponent) {
  _inherits(AddFreeTextDialog, _PureComponent);

  function AddFreeTextDialog(props) {
    _classCallCheck(this, AddFreeTextDialog);

    var _this = _possibleConstructorReturn(this, (AddFreeTextDialog.__proto__ || Object.getPrototypeOf(AddFreeTextDialog)).call(this, props));

    _this.state = {
      categoryId: null,
      freeText: null,
      cicKey: null
    };
    _this._updateFreeText = _this._updateFreeText.bind(_this);
    _this._onSaveClicked = _this._onSaveClicked.bind(_this);
    _this._changeCategiry = _this._changeCategiry.bind(_this);
    _this._changeLesson = _this._changeLesson.bind(_this);
    return _this;
  }

  _createClass(AddFreeTextDialog, [{
    key: '_updateFreeText',
    value: function _updateFreeText(e) {
      this.setState({ freeText: e.target.value });
    }
  }, {
    key: '_onSaveClicked',
    value: function _onSaveClicked() {
      var _state = this.state,
          freeText = _state.freeText,
          categoryId = _state.categoryId;

      this.props.onSave(this._getCICKey(), categoryId, freeText);
    }
  }, {
    key: '_getCICKey',
    value: function _getCICKey() {
      var coveredInClassContent = this.props.coveredInClassContent;
      var cicKey = this.state.cicKey;

      if (coveredInClassContent && coveredInClassContent.size === 1) {
        return coveredInClassContent.keySeq().first();
      }
      return cicKey;
    }
  }, {
    key: '_isFreeTextEmpty',
    value: function _isFreeTextEmpty() {
      var _state2 = this.state,
          freeText = _state2.freeText,
          categoryId = _state2.categoryId;

      if (_is_js2.default.string(freeText) && categoryId) {
        return _is_js2.default.empty(this.state.freeText.trim());
      }
      return true;
    }
  }, {
    key: '_changeCategiry',
    value: function _changeCategiry(val) {
      this.setState({ categoryId: val });
    }
  }, {
    key: '_changeLesson',
    value: function _changeLesson(val) {
      this.setState({ cicKey: val });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isLoading = _props.isLoading,
          categoryOptions = _props.categoryOptions,
          coveredInClassContent = _props.coveredInClassContent;
      var _state3 = this.state,
          categoryId = _state3.categoryId,
          freeText = _state3.freeText,
          cicKey = _state3.cicKey;

      var categoryOptionList = categoryOptions && categoryOptions.map(function (category) {
        return {
          label: category.cicCategoryName,
          value: category.cicCategoryId
        };
      });

      var lessonOptions = coveredInClassContent && coveredInClassContent.map(function (coveredInClass, key) {
        return {
          label: 'Unit ' + coveredInClass.unitOrderingSequence + ', Lesson ' + coveredInClass.lessonNumber,
          value: key
        };
      }).toList().toJS();
      return _react2.default.createElement(
        _omniCommonUi.Dialog,
        { className: _style2.default.AddFreeTextDialog, isLoading: isLoading, paddingless: true, isOpen: true },
        _react2.default.createElement(
          'div',
          { className: _style2.default.AddFreeTextDialog_title },
          _react2.default.createElement(
            'span',
            { className: _style2.default.AddFreeTextDialog_title_text },
            'Free Text Covered in Class'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.AddFreeTextDialog_content },
          lessonOptions && lessonOptions.length > 1 && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: _style2.default.AddFreeTextDialog_subTitle },
              _react2.default.createElement(
                'span',
                { className: _style2.default.AddFreeTextDialog_title_text },
                'Lesson'
              )
            ),
            _react2.default.createElement(
              _omniCommonUi.Form,
              null,
              _react2.default.createElement(_omniCommonUi.Form.Select, { name: 'lesson',
                options: lessonOptions,
                value: cicKey,
                setValue: this._changeLesson,
                clearable: false,
                searchable: false })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.AddFreeTextDialog_subTitle },
            _react2.default.createElement(
              'span',
              { className: _style2.default.AddFreeTextDialog_title_text },
              'Category'
            )
          ),
          _react2.default.createElement(
            _omniCommonUi.Form,
            null,
            _react2.default.createElement(_omniCommonUi.Form.Select, { name: 'free-text',
              options: categoryOptionList,
              value: categoryId,
              setValue: this._changeCategiry,
              clearable: false,
              searchable: false })
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.AddFreeTextDialog_subTitle },
            _react2.default.createElement(
              'span',
              { className: _style2.default.AddFreeTextDialog_title_text },
              'Free Text'
            )
          ),
          _react2.default.createElement(_omniCommonUi.TextArea, { value: freeText, onChange: this._updateFreeText, maxLength: 1000 }),
          _react2.default.createElement(
            'div',
            { className: _style2.default.AddFreeTextDialog_content_info },
            _react2.default.createElement(_omniCommonUi.Icon, { id: 'info', className: _style2.default.AddFreeTextDialog_content_info_icon }),
            _react2.default.createElement(
              'span',
              null,
              'This Free Text Covered in Class will be published to EF Parents.'
            )
          ),
          _react2.default.createElement(
            _omniCommonUi.Button.Container,
            { className: _style2.default.AddFreeTextDialog_buttons },
            _react2.default.createElement(
              _omniCommonUi.Button,
              { className: (0, _omniCommonUi.testClass)('button-save'),
                type: _omniCommonUi.Button.Type.primary,
                onClick: this._onSaveClicked,
                disabled: this._isFreeTextEmpty() || isLoading },
              'Save'
            ),
            _react2.default.createElement(
              _omniCommonUi.Button,
              { className: (0, _omniCommonUi.testClass)('button-cancel'),
                onClick: this.props.onCancel,
                disabled: isLoading },
              'Cancel'
            )
          )
        )
      );
    }
  }]);

  return AddFreeTextDialog;
}(_react.PureComponent);

AddFreeTextDialog.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  onSave: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool,
  onCancel: _propTypes2.default.func.isRequired,
  categoryOptions: _propTypes2.default.object.isRequired,
  coveredInClassContent: _propTypes2.default.object.isRequired
};

exports.default = AddFreeTextDialog;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1568);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _RAv2Cic = __webpack_require__(309);

var _redux = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * CoveredInClassRAv2 Component
 *
 * Displays Reading Academy v2.0 Covered in Class content including
 * Story Title, Lesson Focus, and Vocabulary sections.
 */
var CoveredInClassRAv2 = function (_React$Component) {
  _inherits(CoveredInClassRAv2, _React$Component);

  function CoveredInClassRAv2() {
    _classCallCheck(this, CoveredInClassRAv2);

    return _possibleConstructorReturn(this, (CoveredInClassRAv2.__proto__ || Object.getPrototypeOf(CoveredInClassRAv2)).apply(this, arguments));
  }

  _createClass(CoveredInClassRAv2, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._fetchData();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.params.sessionPlanId !== this.props.params.sessionPlanId) {
        this._fetchData(nextProps);
      }
    }
  }, {
    key: '_fetchData',
    value: function _fetchData() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var sessionPlanId = props.params.sessionPlanId;

      if (sessionPlanId) {
        props.fetchRAv2CicIfNeeded(sessionPlanId);
      }
    }
  }, {
    key: '_renderSection',
    value: function _renderSection(label, content) {
      if (!content) return null;
      return _react2.default.createElement(
        'div',
        { className: _style2.default.section },
        _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: label }),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            null,
            _react2.default.createElement(
              'div',
              { className: _style2.default.sectionContent },
              content
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var rav2Cic = this.props.rav2Cic;


      if (!rav2Cic) {
        return _react2.default.createElement(
          _omniCommonUi.Grid,
          { outerMargin: true },
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            _react2.default.createElement(
              'div',
              { className: _style2.default.empty },
              'No content available for this session.'
            )
          )
        );
      }

      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { outerMargin: true },
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          _react2.default.createElement(
            'div',
            { className: _style2.default.header },
            _react2.default.createElement(_omniCommonUi.ColourLabel, { text: 'published', colour: '#74d17f' })
          ),
          this._renderSection('Story Title', rav2Cic.storyTitle),
          this._renderSection('Lesson Focus', rav2Cic.lessonFocus),
          this._renderSection('Vocabulary', rav2Cic.vocabulary)
        )
      );
    }
  }]);

  return CoveredInClassRAv2;
}(_react2.default.Component);

CoveredInClassRAv2.propTypes = {
  params: _propTypes2.default.shape({
    groupId: _propTypes2.default.string.isRequired,
    sessionPlanId: _propTypes2.default.string,
    unitId: _propTypes2.default.string
  }).isRequired,
  rav2Cic: _propTypes2.default.object,
  fetchRAv2CicIfNeeded: _propTypes2.default.func.isRequired
};


function mapStateToProps(state, ownProps) {
  var sessionPlanId = ownProps.params.sessionPlanId;

  return {
    rav2Cic: sessionPlanId ? _RAv2Cic.accessors.getRAv2Cic(state, sessionPlanId) : null
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    fetchRAv2CicIfNeeded: _RAv2Cic.actions.fetchRAv2CicIfNeeded
  }, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(CoveredInClassRAv2);

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_RAV2_CIC_FAILURE = exports.FETCH_RAV2_CIC_SUCCESS = exports.FETCH_RAV2_CIC_REQUEST = undefined;
exports.fetchRAv2CicIfNeeded = fetchRAv2CicIfNeeded;
exports.fetchRAv2Cic = fetchRAv2Cic;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_RAV2_CIC_REQUEST = exports.FETCH_RAV2_CIC_REQUEST = 'FETCH_RAV2_CIC_REQUEST';
var FETCH_RAV2_CIC_SUCCESS = exports.FETCH_RAV2_CIC_SUCCESS = 'FETCH_RAV2_CIC_SUCCESS';
var FETCH_RAV2_CIC_FAILURE = exports.FETCH_RAV2_CIC_FAILURE = 'FETCH_RAV2_CIC_FAILURE';

var buildRAv2CicUrl = function buildRAv2CicUrl(sessionId) {
  return (0, _Api.buildUrl)('/sessions/' + sessionId + '/ra-cic');
};

function fetchRAv2CicIfNeeded(sessionId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildRAv2CicUrl(sessionId) })) {
      return false;
    }

    return dispatch(fetchRAv2Cic(sessionId));
  };
}

function fetchRAv2Cic(sessionId) {
  return function (dispatch) {
    var url = buildRAv2CicUrl(sessionId);
    var method = 'GET';

    return dispatch(fetchRAv2CicRequest()).payload.then(function (response) {
      return dispatch(fetchRAv2CicSuccess(response));
    }).catch(function (error) {
      if (error.response && error.response.code === 404) {
        return dispatch(fetchRAv2CicSuccess());
      }

      return dispatch(fetchRAv2CicFailure(error));
    });

    function fetchRAv2CicRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_RAV2_CIC_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchRAv2CicSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_RAV2_CIC_SUCCESS,
        payload: response,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchRAv2CicFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_RAV2_CIC_FAILURE,
        error: error,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }
  };
}

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RAv2CicRecord = (0, _immutable.Record)({
  sessionId: undefined,
  levelNumber: undefined,
  unitNumber: undefined,
  lessonNumber: undefined,
  storyTitle: undefined,
  vocabulary: undefined,
  lessonFocus: undefined
});

var RAv2Cic = function (_RAv2CicRecord) {
  _inherits(RAv2Cic, _RAv2CicRecord);

  function RAv2Cic() {
    _classCallCheck(this, RAv2Cic);

    return _possibleConstructorReturn(this, (RAv2Cic.__proto__ || Object.getPrototypeOf(RAv2Cic)).apply(this, arguments));
  }

  return RAv2Cic;
}(RAv2CicRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'sessionId':
    case 'levelNumber':
    case 'unitNumber':
    case 'lessonNumber':
      return [key, Number(val)];
    default:
      return [key, val];
  }
};

RAv2Cic.create = function (data) {
  return new RAv2Cic(data).mapEntries(reviver);
};

exports.default = RAv2Cic;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CoveredInClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _style = __webpack_require__(672);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _PageActivitiesPart = __webpack_require__(673);

var _PageActivitiesPart2 = _interopRequireDefault(_PageActivitiesPart);

var _CoveredInClassCategoryView = __webpack_require__(674);

var _CoveredInClassCategoryView2 = _interopRequireDefault(_CoveredInClassCategoryView);

var _reactRouterRedux = __webpack_require__(15);

var _SessionPlans = __webpack_require__(44);

var _redux = __webpack_require__(10);

var _CoveredInClass = __webpack_require__(95);

var _Template = __webpack_require__(166);

var _CategoryTemplate = __webpack_require__(306);

var _HF4Homework = __webpack_require__(686);

var _StudentTasks = __webpack_require__(310);

var _GroupLessonAwards = __webpack_require__(690);

var _InternalNotesPart = __webpack_require__(679);

var _InternalNotesPart2 = _interopRequireDefault(_InternalNotesPart);

var _reactRouter = __webpack_require__(16);

var _Exporter = __webpack_require__(50);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

var _ = __webpack_require__(13);

var _UiState = __webpack_require__(30);

var _accessors = __webpack_require__(41);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _NoContentMessage = __webpack_require__(66);

var _NoContentMessage2 = _interopRequireDefault(_NoContentMessage);

var _LanguageRadio = __webpack_require__(74);

var _LanguageRadio2 = _interopRequireDefault(_LanguageRadio);

var _AddFreeTextDialog = __webpack_require__(681);

var _AddFreeTextDialog2 = _interopRequireDefault(_AddFreeTextDialog);

var _routes = __webpack_require__(691);

var _actions = __webpack_require__(194);

var _extAsset = __webpack_require__(1597);

var _actions2 = __webpack_require__(312);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXPORT = 'EXPORT';
var CANCEL = 'CANCEL';
var EXPORT_OPTION_ONE = 'one';
var EXPORT_OPTION_UNIT = 'unit';
var EXPORT_OPTION_ALL = 'all';
var TITLE_EXPORT_OPTIONS = 'Export Options';
var NAME_EXPORT_OPTIONS = 'export';
var DESCRIPTION_EXPORT_OPTIONS = 'Export Covered in Class for…';

var CoveredInClass = exports.CoveredInClass = function (_UnsavedChangesTracki) {
  _inherits(CoveredInClass, _UnsavedChangesTracki);

  function CoveredInClass(props) {
    _classCallCheck(this, CoveredInClass);

    var _this = _possibleConstructorReturn(this, (CoveredInClass.__proto__ || Object.getPrototypeOf(CoveredInClass)).call(this, props));

    _this._onChecked = _this._onChecked.bind(_this);
    return _this;
  }

  _createClass(CoveredInClass, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.state = {
        allowRouteLeave: false,
        isChanged: false,
        isExportInProgress: false,
        isExportErrorOccurred: false,
        isNotFoundSessions: false,
        isShowExportOptions: false,
        selectedExportValue: EXPORT_OPTION_ONE,
        showAllPerformance: false
      };
      this._fetchData(this.props);
      _get(CoveredInClass.prototype.__proto__ || Object.getPrototypeOf(CoveredInClass.prototype), 'componentWillMount', this).call(this);
      this._initChoosedLanguage();
      this._initCICContent();
      this._initCICCategory();
      this.props.fetchGroupMembersIfNeeded(this.props.params.groupId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (this.props.currentSessionIndex !== props.currentSessionIndex) {
        this.setState({
          allowRouteLeave: false,
          isChanged: false
        });
      }
      var languageChanged = this.props.cicDisplayLanguage !== props.cicDisplayLanguage;
      if (languageChanged) {
        this._pendingLanguageSwitch = true;
      }
      this._fetchData(props, languageChanged);

      if (this._pendingLanguageSwitch && !languageChanged && !props.isAnyApiCalling && props.hasCICTemplate && props.isNotPublished) {
        this._pendingLanguageSwitch = false;
        this.props.changeCoveredInClassObject(props.coveredInClassTemplate, props.params.sessionPlanId);
      } else if (!this._pendingLanguageSwitch) {
        this._initCICContent();
      }
    }
  }, {
    key: '_fetchData',
    value: function _fetchData(props) {
      var shouldForceHFv4TemplateFetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.props.fetchSessionPlansIfNeeded(props.params.groupId);
      if (shouldForceHFv4TemplateFetch) {
        this.props.fetchHFv4CICTemplate(props.params.sessionPlanId, props.cicDisplayLanguage);
      } else {
        this.props.fetchHFv4CICTemplateIfNeeded(props.params.sessionPlanId, props.cicDisplayLanguage);
      }
      this.props.fetchCoveredInClassIfNeeded(props.params.sessionPlanId);
      this.props.fetchHF4HomeworkIfNeeded(props.params.sessionPlanId);
      this.props.fetchGroupLessonAwardsIfNeeded(props.params.sessionPlanId);
      if (props.isCNEnvironment) {
        this.props.fetchStudentTaskListIfNeeded(props.params.sessionPlanId, props.cicDisplayLanguage);
      }
    }
  }, {
    key: '_initCICCategory',
    value: function _initCICCategory() {
      var groupId = this.props.params.groupId;

      this.props.fetchCICCategoriesIfNeeded(groupId);
    }
  }, {
    key: '_initCICContent',
    value: function _initCICContent() {
      var _props = this.props,
          coveredInClassTemplate = _props.coveredInClassTemplate,
          coveredInClassContent = _props.coveredInClassContent,
          hasCICTemplate = _props.hasCICTemplate,
          hasCIC = _props.hasCIC,
          isNotPublished = _props.isNotPublished;

      if (!coveredInClassContent || !hasCICTemplate || hasCIC || !isNotPublished) {
        return;
      }
      if (this.props.isAnyApiCalling) {
        return;
      }
      var coveredInClassObject = void 0;
      if (this._canCICEdit()) {
        coveredInClassObject = coveredInClassContent;
        coveredInClassObject = coveredInClassObject.map(function (coveredInClass, key) {
          return coveredInClass.set('cicActivities', coveredInClassTemplate.get(key).cicActivities).set('cicCategories', coveredInClassTemplate.get(key).cicCategories);
        });
      } else if (!this._isNotFutureSession()) {
        coveredInClassObject = coveredInClassTemplate;
      } else {
        coveredInClassObject = coveredInClassContent;
        // coveredInClassObject = coveredInClassObject.map((coveredInClass, key) =>
        //     coveredInClass.update('cicActivities', coveredInClassTemplate.get(key).cicActivities)
        //       .set('cicCategories', coveredInClassTemplate.get(key).cicCategories));
      }
      this.props.changeCoveredInClassObject(coveredInClassObject, this.props.params.sessionPlanId);
    }
  }, {
    key: '_isChangesPresent',
    value: function _isChangesPresent() {
      // do not worry about notes - we will auto-save these on leaving
      return !!this.state.isChanged;
    }
  }, {
    key: '_isInCoveredInClassEditMode',
    value: function _isInCoveredInClassEditMode(pathname) {
      var sessionPlanId = this.props.params.sessionPlanId;

      return Object.values(_routes.Modes).some(function (mode) {
        return pathname.endsWith(sessionPlanId + '/covered-in-class/' + mode);
      });
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave(nextLocation) {
      if (nextLocation && nextLocation.pathname.endsWith('/' + _routes.Modes.EXPORT)) {
        this._onBeginExport();
        return false;
      } else if (nextLocation && nextLocation.pathname.endsWith('/' + _routes.Modes.PUBLISH)) {
        this._publishCIC();
        return false;
        // OMO-1254: user navigates away while editing a note; auto-save it
        // TODO: clean up fuzzy detection of whether we're staying on the same page
      } else if (nextLocation && nextLocation.pathname.endsWith('/' + _routes.Modes.CLEAR)) {
        this._clearCIC();
      } else if (this._willRemainOnCurrentPage(nextLocation)) return;

      this._autoSaveNotes();
      return _get(CoveredInClass.prototype.__proto__ || Object.getPrototypeOf(CoveredInClass.prototype), 'routerWillLeave', this).call(this, nextLocation);
    }
  }, {
    key: '_autoSaveNotes',
    value: function _autoSaveNotes() {
      if (!this.internalNotesPartComponent) return;
      this.internalNotesPartComponent.autoSaveNotesIfNeeded();
    }
  }, {
    key: '_willRemainOnCurrentPage',
    value: function _willRemainOnCurrentPage(nextLocation) {
      var currentPath = this.props.buildRoute({ mode: '', index: '' });
      return nextLocation && nextLocation.pathname.indexOf(currentPath) >= 0;
    }
  }, {
    key: '_pageActivitiesChanged',
    value: function _pageActivitiesChanged(newPageActivities, unitId, lessonNumber) {
      this.setState({ isChanged: true });
      var _props2 = this.props,
          coveredInClassContent = _props2.coveredInClassContent,
          params = _props2.params;

      var newCoveredInClassContent = coveredInClassContent.update(unitId + '-' + lessonNumber, function (cic) {
        return cic.set('cicActivities', newPageActivities);
      });
      this.props.changeCoveredInClassObject(newCoveredInClassContent, params.sessionPlanId);
    }
  }, {
    key: '_categoriesChanged',
    value: function _categoriesChanged(newCategories, unitId, lessonNumber) {
      this.setState({ isChanged: true });
      var _props3 = this.props,
          coveredInClassContent = _props3.coveredInClassContent,
          params = _props3.params;


      var newCoveredInClassContent = coveredInClassContent.update(unitId + '-' + lessonNumber, function (cic) {
        return cic.set('cicCategories', newCategories);
      });
      this.props.changeCoveredInClassObject(newCoveredInClassContent, params.sessionPlanId);
    }
  }, {
    key: '_getModeAndIndex',
    value: function _getModeAndIndex() {
      return { mode: this.props.params.mode, index: this.props.params.index };
    }
  }, {
    key: '_onChangeMode',
    value: function _onChangeMode(modeAndIndex) {
      var mode = modeAndIndex.mode,
          _modeAndIndex$index = modeAndIndex.index,
          index = _modeAndIndex$index === undefined ? '' : _modeAndIndex$index;

      this._forcePushRoute(this.props.buildRoute({ mode: mode, index: index }));
    }
  }, {
    key: '_onBeginExport',
    value: function _onBeginExport() {
      this.setState({
        isShowExportOptions: true,
        selectedExportValue: EXPORT_OPTION_ONE
      });
      this._initChoosedLanguage();
    }
  }, {
    key: '_onEndExport',
    value: function _onEndExport() {
      this.setState({ isShowExportOptions: false });
    }
  }, {
    key: '_onBeginGeneralError',
    value: function _onBeginGeneralError() {
      this.setState({ isExportErrorOccurred: true });
    }
  }, {
    key: '_onBeginExportWarning',
    value: function _onBeginExportWarning() {
      this.setState({ isNotFoundSessions: true });
    }
  }, {
    key: '_onEndExportWarningOrError',
    value: function _onEndExportWarningOrError() {
      this.setState({
        isNotFoundSessions: false,
        isExportErrorOccurred: false
      });
    }
  }, {
    key: '_renderExportOptionDialog',
    value: function _renderExportOptionDialog() {
      var _this2 = this;

      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: this.state.isShowExportOptions,
          isLoading: this.state.isExportInProgress,
          title: TITLE_EXPORT_OPTIONS,
          primaryButtonContent: EXPORT,
          secondaryButtonContent: CANCEL,
          onRequestClose: function onRequestClose() {
            _this2._onEndExport();
          },
          onPrimaryClick: function onPrimaryClick() {
            _this2._handleConfirmExport();
          },
          onSecondaryClick: function onSecondaryClick() {
            _this2._onEndExport();
          } },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            null,
            DESCRIPTION_EXPORT_OPTIONS
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.CoveredInClass_exportOptions },
            _react2.default.createElement(
              'div',
              { className: _style2.default.CoveredInClass_exportOption },
              _react2.default.createElement(_omniCommonUi.SolidRadio, { id: '1',
                value: EXPORT_OPTION_ONE,
                name: NAME_EXPORT_OPTIONS,
                isChecked: this.state.selectedExportValue === EXPORT_OPTION_ONE,
                onChange: function onChange(value) {
                  return _this2._handleExportChange(value);
                } }),
              'current session'
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default.CoveredInClass_exportOption },
              _react2.default.createElement(_omniCommonUi.SolidRadio, { id: '2',
                value: EXPORT_OPTION_UNIT,
                name: NAME_EXPORT_OPTIONS,
                isChecked: this.state.selectedExportValue === EXPORT_OPTION_UNIT,
                onChange: function onChange(value) {
                  return _this2._handleExportChange(value);
                } }),
              'current unit'
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default.CoveredInClass_exportOption },
              _react2.default.createElement(_omniCommonUi.SolidRadio, { id: '3',
                value: EXPORT_OPTION_ALL,
                name: NAME_EXPORT_OPTIONS,
                isChecked: this.state.selectedExportValue === EXPORT_OPTION_ALL,
                onChange: function onChange(value) {
                  return _this2._handleExportChange(value);
                } }),
              'all taught sessions'
            )
          ),
          this._renderLanguagePicker()
        )
      );
    }
  }, {
    key: '_renderLanguagePicker',
    value: function _renderLanguagePicker() {
      if (this._isDefaultLanguage()) return;
      return [_react2.default.createElement('div', { className: _style2.default.CoveredInClass_exportOptionsDivider,
        key: 'CoveredInClass_exportOptionsDivider' }), _react2.default.createElement(
        'div',
        { className: _style2.default.CoveredInClass_languagePicker,
          key: 'CoveredInClass_languagePicker' },
        _react2.default.createElement(_LanguageRadio2.default, { title: 'Choose Language:',
          languageCode: this.props.languageCode,
          name: 'CICLanguagePicker',
          onChecked: this._onChecked,
          choosedLanguageCode: this.state.choosedLanguage })
      )];
    }
  }, {
    key: '_initChoosedLanguage',
    value: function _initChoosedLanguage() {
      this.setState({ choosedLanguage: this.props.languageCode });
    }
  }, {
    key: '_isDefaultLanguage',
    value: function _isDefaultLanguage() {
      if (!this.props.languageCode) return true;
      return this.props.languageCode === _Languages2.default.defaultLanguageCode;
    }
  }, {
    key: '_onChecked',
    value: function _onChecked(checkedLanguage) {
      this.setState({ choosedLanguage: checkedLanguage });
    }
  }, {
    key: '_handleExportChange',
    value: function _handleExportChange(value) {
      this.setState({ selectedExportValue: value });
    }
  }, {
    key: '_handleConfirmExport',
    value: function _handleConfirmExport() {
      var _props$params = this.props.params,
          sessionPlanId = _props$params.sessionPlanId,
          groupId = _props$params.groupId;

      var sourceUrl = '';
      var languageQueryString = '?languageCode=' + (this.state.choosedLanguage || _Languages2.default.defaultLanguageCode);
      switch (this.state.selectedExportValue) {
        case EXPORT_OPTION_ONE:
          sourceUrl = '/sessions/' + sessionPlanId + '/cic-printing' + languageQueryString;
          this._beginExport(_omniCommonUi.Config.get('apiBase').concat(sourceUrl));
          break;
        case EXPORT_OPTION_UNIT:
          sourceUrl = '/sessions/' + sessionPlanId + '/unit-sessions/cic-printing' + languageQueryString;
          this._beginExport(_omniCommonUi.Config.get('apiBase').concat(sourceUrl));
          break;
        case EXPORT_OPTION_ALL:
          sourceUrl = '/groups/' + groupId + '/sessions/cic-printing' + languageQueryString;
          this._beginExport(_omniCommonUi.Config.get('apiBase').concat(sourceUrl));
          break;
        default:
          break;
      }
    }
  }, {
    key: '_handleExportError',
    value: function _handleExportError(error) {
      this.setState({
        isExportInProgress: false,
        isShowExportOptions: false
      });
      if (error.response.status === 404) {
        this._onBeginExportWarning();
        return;
      }
      this._onBeginGeneralError();
    }
  }, {
    key: '_beginExport',
    value: function _beginExport(url) {
      var _this3 = this;

      this.setState({
        isExportInProgress: true
      });
      _Exporter.exporter.get(url, this.props.groupCode.concat('.pdf'), false, 'application/pdf').then(function () {
        _this3.setState({
          isExportInProgress: false,
          isShowExportOptions: false
        });
      }).catch(function (err) {
        _this3._handleExportError(err);
      });
    }
  }, {
    key: '_getFirstCoveredInClassEntry',
    value: function _getFirstCoveredInClassEntry(coveredInClassContent) {
      if (!coveredInClassContent || !coveredInClassContent.first) {
        return { unitOrderingSequence: null, lessonNumber: null };
      }

      var firstEntry = coveredInClassContent.first();
      if (!firstEntry) {
        return { unitOrderingSequence: null, lessonNumber: null };
      }

      return {
        unitOrderingSequence: firstEntry.unitOrderingSequence,
        lessonNumber: firstEntry.lessonNumber
      };
    }
  }, {
    key: '_renderExportNoSessionsFoundWarningDialog',
    value: function _renderExportNoSessionsFoundWarningDialog() {
      var _this4 = this;

      if (this.state.isNotFoundSessions) {
        return _react2.default.createElement(_omniCommonUi.ConfirmDialog, { isOpen: true,
          content: 'No sessions are available for printing.',
          primaryButtonContent: 'OK',
          onPrimaryClick: function onPrimaryClick() {
            return _this4._onEndExportWarningOrError();
          } });
      }
    }
  }, {
    key: '_renderExportGeneralErrorDialog',
    value: function _renderExportGeneralErrorDialog() {
      var _this5 = this;

      if (this.state.isExportErrorOccurred) {
        return _react2.default.createElement(_omniCommonUi.ErrorDialog, { isOpen: true,
          onConfirmClick: function onConfirmClick() {
            _this5._onEndExportWarningOrError();
          } });
      }
    }
  }, {
    key: '_canCICEdit',
    value: function _canCICEdit() {
      var isNotPublished = this.props.isNotPublished;

      return isNotPublished && this._isNotFutureSession();
    }
  }, {
    key: '_isNotFutureSession',
    value: function _isNotFutureSession() {
      var _props4 = this.props,
          sessionPlans = _props4.sessionPlans,
          currentSessionIndex = _props4.currentSessionIndex;

      var currentSession = sessionPlans.data.get(currentSessionIndex);
      var currentSessionDate = currentSession.period.start;
      return (0, _omniCommonUi.moment)().isAfter(currentSessionDate);
    }
  }, {
    key: '_publishCIC',
    value: function _publishCIC() {
      this.setState({ isChanged: false });
      var _props5 = this.props,
          sessionPlanId = _props5.params.sessionPlanId,
          publishCoveredInClass = _props5.publishCoveredInClass,
          fetchCoveredInClass = _props5.fetchCoveredInClass;
      var coveredInClassContent = this.props.coveredInClassContent;


      return coveredInClassContent && publishCoveredInClass(_CoveredInClass.accessors.filterUncheckItems(coveredInClassContent).toArray(), sessionPlanId).then(function () {
        return fetchCoveredInClass(sessionPlanId);
      });
    }
  }, {
    key: '_clearCIC',
    value: function _clearCIC() {
      this.setState({ isChanged: false });
      var _props6 = this.props,
          sessionPlanId = _props6.params.sessionPlanId,
          clearCoveredInClass = _props6.clearCoveredInClass,
          fetchCoveredInClass = _props6.fetchCoveredInClass;


      this._onChangeMode({ mode: '', index: '' });
      return clearCoveredInClass(sessionPlanId).then(function () {
        return fetchCoveredInClass(sessionPlanId);
      });
    }
  }, {
    key: '_renderUnsavedChangesWarningDialog',
    value: function _renderUnsavedChangesWarningDialog() {
      var _this6 = this;

      var _props7 = this.props,
          coveredInClassContent = _props7.coveredInClassContent,
          isNotPublished = _props7.isNotPublished;


      if (this.props.isAnyApiCalling) {
        return null;
      }
      if (isNotPublished && _CoveredInClass.accessors.isAllCategoryItemsUnchecked(coveredInClassContent)) {
        return _react2.default.createElement(_omniCommonUi.ConfirmDialog, { isOpen: !!this._isNavigationWithChangesRequested(),
          primaryButtonContent: 'Stay',
          secondaryButtonContent: 'Leave',
          content: 'Are you sure you want to leave this page and lose unsaved changes?',
          onPrimaryClick: function onPrimaryClick() {
            _this6._clearRequestedLocation();
          },
          onSecondaryClick: function onSecondaryClick() {
            _this6.props.resetCoveredInClass(_this6.props.params.sessionPlanId);
            _this6._forcePushRequestedLocation();
          },
          onRequestClose: function onRequestClose() {
            _this6._clearRequestedLocation();
          } });
      }
      return _react2.default.createElement(_UnsavedChangesWarning2.default, { isOpen: !!this._isNavigationWithChangesRequested(),
        dialogText: 'Do you want to publish Covered in Class?',
        primaryButtonLabel: 'Publish to EF P',
        secondaryButtonContent: 'Discard',
        isSaving: this.props.isAnyApiCalling,
        onSaveClicked: function onSaveClicked() {
          _this6._publishCIC().then(function () {
            _this6._forcePushRequestedLocation();
          });
        },
        onDiscardClicked: function onDiscardClicked() {
          _this6.props.resetCoveredInClass(_this6.props.params.sessionPlanId);
          _this6._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this6._clearRequestedLocation();
        } });
    }
  }, {
    key: '_getTasksForLesson',
    value: function _getTasksForLesson(studentTaskList, unitNumber, lessonNumber) {
      if (!studentTaskList || !studentTaskList.get) {
        return null;
      }
      var data = studentTaskList.get('data');
      if (!data) {
        return null;
      }
      var match = data.find(function (entry) {
        return entry.unitNumber === unitNumber && entry.lessonNumber === lessonNumber;
      });
      if (!match || !match.tasks || match.tasks.length === 0) {
        return null;
      }
      return match.tasks.slice().sort(function (a, b) {
        return (a.displayOrder || 0) - (b.displayOrder || 0);
      });
    }
  }, {
    key: '_renderStudentTasksList',
    value: function _renderStudentTasksList(unitNumber, lessonNumber) {
      var studentTaskList = this.props.studentTaskList;

      var tasks = this._getTasksForLesson(studentTaskList, unitNumber, lessonNumber);
      if (!tasks) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: _style2.default.CoveredInClass_studentTasks },
        tasks.map(function (task, idx) {
          return _react2.default.createElement(
            'div',
            {
              key: 'task-' + unitNumber + '-' + lessonNumber + '-' + idx,
              className: _style2.default.CoveredInClass_taskItem
            },
            task.title
          );
        })
      );
    }
  }, {
    key: '_renderHomeworkSection',
    value: function _renderHomeworkSection() {
      var _this7 = this;

      var _props8 = this.props,
          hf4Homework = _props8.hf4Homework,
          coveredInClassContent = _props8.coveredInClassContent;

      if (!hf4Homework) return null;

      var _getFirstCoveredInCla = this._getFirstCoveredInClassEntry(coveredInClassContent),
          unitOrderingSequence = _getFirstCoveredInCla.unitOrderingSequence,
          lessonNumber = _getFirstCoveredInCla.lessonNumber;

      var hasHomeworkContent = lessonNumber || hf4Homework.paperHomeworkAssignment || hf4Homework.hasUnitQuiz || hf4Homework.hasMidtermExam || hf4Homework.hasFinalExam;

      if (!hasHomeworkContent) return null;

      var cardTitle = unitOrderingSequence && lessonNumber ? 'Unit ' + unitOrderingSequence + ' Lesson ' + lessonNumber : '';

      var homeworkItems = [{
        isVisible: !!lessonNumber,
        label: 'High Flyers APP',
        value: ' Lesson ' + lessonNumber,
        key: 'homework-hf-app'
      }, {
        isVisible: this.props.isCNEnvironment,
        label: 'Student Tasks',
        value: null,
        key: 'homework-student-tasks',
        isCustomRender: true,
        renderCustom: function renderCustom() {
          return _this7._renderStudentTasksList(unitOrderingSequence, lessonNumber);
        }
      }, {
        isVisible: !!hf4Homework.paperHomeworkAssignment,
        label: 'Practice Book',
        value: ' ' + hf4Homework.paperHomeworkAssignment,
        key: 'homework-paper-book'
      }, {
        isVisible: !!hf4Homework.hasUnitQuiz,
        label: 'Unit Quiz',
        key: 'homework-unit-quiz'
      }, {
        isVisible: !!(hf4Homework.hasMidtermExam || hf4Homework.hasFinalExam),
        label: 'Assessment',
        key: 'homework-assessment'
      }];

      return _react2.default.createElement(
        'div',
        { className: _style2.default.CoveredInClass_homeworkSection },
        _react2.default.createElement(
          'h2',
          { className: _style2.default.CoveredInClass_homeworkSectionTitle },
          'Homework'
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: cardTitle }),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            null,
            homeworkItems.map(function (homeworkItem) {
              if (!homeworkItem.isVisible) return null;
              if (homeworkItem.isCustomRender) {
                return homeworkItem.renderCustom();
              }
              return _react2.default.createElement(
                'div',
                { className: _style2.default.CoveredInClass_homeworkItem, key: homeworkItem.key },
                _react2.default.createElement(
                  'span',
                  { className: _style2.default.CoveredInClass_homeworkItemLabel },
                  homeworkItem.label
                ),
                homeworkItem.value
              );
            })
          )
        )
      );
    }
  }, {
    key: '_renderContent',
    value: function _renderContent() {
      var _this8 = this;

      var _props9 = this.props,
          canEditCoveredInClass = _props9.canEditCoveredInClass,
          changeCoveredInClassObject = _props9.changeCoveredInClassObject,
          coveredInClassContent = _props9.coveredInClassContent,
          sessionPlanId = _props9.params.sessionPlanId,
          hasCIC = _props9.hasCIC,
          hasCICTemplate = _props9.hasCICTemplate,
          isNotPublished = _props9.isNotPublished;


      if (coveredInClassContent && coveredInClassContent.loading) {
        return null;
      }
      // internal notes should be visible in all cases - even when there's no CIC content to show.
      var internalNotesPart = _react2.default.createElement(_InternalNotesPart2.default, { onComponentMounted: function onComponentMounted(_cmpnt) {
          _this8.internalNotesPartComponent = _cmpnt;
        },
        modeAndIndex: this._getModeAndIndex(),
        onChangeMode: function onChangeMode(modeAndIndex) {
          return _this8._onChangeMode(modeAndIndex);
        },
        timeZone: this.props.timeZone,
        sessionPlanId: this.props.params.sessionPlanId });

      if (!hasCICTemplate && !hasCIC) {
        return _react2.default.createElement(
          'div',
          null,
          this._renderHomeworkSection(),
          _react2.default.createElement(
            _omniCommonUi.Grid,
            { outerMargin: true },
            _react2.default.createElement(
              _omniCommonUi.Grid.Group,
              null,
              internalNotesPart,
              _react2.default.createElement(_NoContentMessage2.default, { text: 'No new course content was covered.' })
            )
          ),
          this._renderInClassPerformanceSection()
        );
      }
      var isEdit = this._canCICEdit() && canEditCoveredInClass;

      return _react2.default.createElement(
        'div',
        null,
        this._renderHomeworkSection(),
        _react2.default.createElement(
          _omniCommonUi.Grid,
          { outerMargin: true },
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            (isEdit || !isNotPublished) && _react2.default.createElement(
              'div',
              { className: _style2.default.CoveredInClass_header },
              isEdit ? _react2.default.createElement(
                'label',
                { className: _style2.default.CoveredInClass_header_checkAll },
                _react2.default.createElement(_omniCommonUi.Checkbox, { name: 'check-all',
                  id: 'check-all',
                  checked: _CoveredInClass.accessors.isAllCategoryItemsChecked(coveredInClassContent),
                  onChange: function onChange() {
                    _this8.setState({ isChanged: true });
                    var newCoveredInClassObject = _CoveredInClass.accessors.toggleCategoryItemsCheckedState(coveredInClassContent);
                    changeCoveredInClassObject(newCoveredInClassObject, sessionPlanId);
                  } }),
                _react2.default.createElement(
                  'span',
                  null,
                  'Check All'
                )
              ) : _react2.default.createElement('lablel', { className: _style2.default.CoveredInClass_header_checkAll }),
              !isNotPublished && _react2.default.createElement(_omniCommonUi.ColourLabel, { text: 'published', colour: 'green' })
            ),
            internalNotesPart,
            this._renderLesson(coveredInClassContent, isEdit)
          ),
          this._renderExportOptionDialog(),
          this._renderExportNoSessionsFoundWarningDialog(),
          this._renderExportGeneralErrorDialog()
        ),
        this._renderInClassPerformanceSection()
      );
    }
  }, {
    key: '_renderLesson',
    value: function _renderLesson(coveredInClassObject, isEdit) {
      var _this9 = this;

      var coveredInClassTemplate = this.props.coveredInClassTemplate;

      var unchekedTemplate = _CoveredInClass.accessors.toggleCategoryItemsCheckedState(coveredInClassTemplate);
      if (coveredInClassObject) {
        return coveredInClassObject.map(function (coveredInClass, key) {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h2',
              { className: _style2.default.CoveredInClass_homeworkSectionTitle },
              'Covered in Class'
            ),
            _react2.default.createElement(_CoveredInClassCategoryView2.default, { isEdit: isEdit,
              categories: coveredInClass.cicCategories,
              template: unchekedTemplate && unchekedTemplate.get(key) && unchekedTemplate.get(key).cicCategories,
              onCategoriesChanged: function onCategoriesChanged(newCategories) {
                return _this9._categoriesChanged(newCategories, coveredInClass.unitId, coveredInClass.lessonNumber);
              } }),
            _react2.default.createElement(_PageActivitiesPart2.default, { pageActivities: coveredInClass.cicActivities,
              template: unchekedTemplate && unchekedTemplate.get(key) && unchekedTemplate.get(key).cicActivities,
              isEditMode: isEdit,
              onPageActivitiesChanged: function onPageActivitiesChanged(newPageActivities) {
                return _this9._pageActivitiesChanged(newPageActivities, coveredInClass.unitId, coveredInClass.lessonNumber);
              } })
          );
        });
      }
      return null;
    }
  }, {
    key: '_renderInClassPerformanceSection',
    value: function _renderInClassPerformanceSection() {
      var _this10 = this;

      var _props10 = this.props,
          groupMembers = _props10.groupMembers,
          cicDisplayLanguage = _props10.cicDisplayLanguage,
          groupLessonAwards = _props10.groupLessonAwards;

      if (!groupMembers || groupMembers.size === 0) return null;
      if (!groupLessonAwards) return null;

      var students = groupLessonAwards.students || [];
      var hasAwards = students.some(function (s) {
        return s.points && s.points.length > 0 || s.badges && s.badges.length > 0;
      });

      if (!hasAwards) {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.CoveredInClass_homeworkSection },
          _react2.default.createElement(
            'h2',
            { className: _style2.default.CoveredInClass_homeworkSectionTitle },
            'In Class Performance'
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.CoveredInClass_performanceCard },
            _react2.default.createElement(
              'div',
              { className: _style2.default.CoveredInClass_performanceHeader },
              _react2.default.createElement(
                'span',
                null,
                'Performance'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default.CoveredInClass_performanceEmpty },
              'No awards given in this session.'
            )
          )
        );
      }

      var isChineseDisplay = cicDisplayLanguage && cicDisplayLanguage.startsWith('zh');

      // Match API response students with group members by studentId
      var performanceData = students.map(function (student) {
        var member = groupMembers.find(function (m) {
          return m.studentGeneralInfo && m.studentGeneralInfo.id === student.studentId;
        });
        return {
          studentInfo: member ? member.studentGeneralInfo : null,
          points: student.points || [],
          badges: student.badges || []
        };
      });

      return _react2.default.createElement(
        'div',
        { className: _style2.default.CoveredInClass_homeworkSection },
        _react2.default.createElement(
          'h2',
          { className: _style2.default.CoveredInClass_homeworkSectionTitle },
          'In Class Performance'
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.CoveredInClass_performanceCard },
          _react2.default.createElement(
            'div',
            { className: _style2.default.CoveredInClass_performanceHeader },
            _react2.default.createElement(
              'span',
              null,
              'Performance'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.CoveredInClass_performanceTable },
            _react2.default.createElement(
              'div',
              { className: _style2.default.CoveredInClass_performanceRow + ' ' + _style2.default.CoveredInClass_performanceRowHead },
              _react2.default.createElement(
                'div',
                { className: _style2.default.CoveredInClass_performanceColName },
                'Name'
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.CoveredInClass_performanceColStickers },
                'Stickers'
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.CoveredInClass_performanceColBadges },
                'Badges'
              )
            ),
            performanceData.map(function (studentPerf) {
              var studentInfo = studentPerf.studentInfo;
              var studentName = studentInfo ? ((studentInfo.firstName || '') + ' ' + (studentInfo.lastName || '')).trim() : 'Unknown';
              var avatarUrl = studentInfo && studentInfo.avatarUrl;
              var studentId = studentInfo && studentInfo.id;

              var pointSummary = {
                iconUrl: (0, _extAsset.findPointByUUID)(studentPerf.points[0] && studentPerf.points[0].contentUuid),
                amount: studentPerf.points.reduce(function (sum, it) {
                  return sum + it.count;
                }, 0)
              };
              var pointIcon = pointSummary.iconUrl && pointSummary.iconUrl.icon;

              return _react2.default.createElement(
                'div',
                { className: _style2.default.CoveredInClass_performanceRow, key: studentId },
                _react2.default.createElement(
                  'div',
                  { className: _style2.default.CoveredInClass_performanceColName },
                  _react2.default.createElement(
                    'div',
                    { className: _style2.default.CoveredInClass_performanceAvatar },
                    _react2.default.createElement(_omniCommonUi.StudentPicture, { src: avatarUrl, gender: studentInfo && studentInfo.gender })
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    studentName
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: _style2.default.CoveredInClass_performanceColStickers },
                  pointIcon && _react2.default.createElement(
                    'div',
                    { className: _style2.default.CoveredInClass_performanceSticker, 'data-tooltip': 'Sticker' },
                    _react2.default.createElement(
                      'div',
                      { className: _style2.default.CoveredInClass_performanceStickerContent },
                      _react2.default.createElement('img', { src: pointIcon, alt: '', className: _style2.default.CoveredInClass_performanceStickerIcon }),
                      _react2.default.createElement(
                        'span',
                        { className: _style2.default.CoveredInClass_performanceStickerCount },
                        pointSummary.amount,
                        ' stickers'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: _style2.default.CoveredInClass_performanceColBadges },
                  studentPerf.badges.map(function (badge, idx) {
                    var badgeInfo = (0, _extAsset.findBadgeByUUID)(badge.contentUuid);
                    if (!badgeInfo) return null;
                    var badgeIcon = isChineseDisplay ? badgeInfo.icon_cn : badgeInfo.icon_en;
                    var badgeName = isChineseDisplay ? badgeInfo.name_zh : badgeInfo.name_en;
                    return _react2.default.createElement(
                      'div',
                      { className: _style2.default.CoveredInClass_performanceBadge, 'data-tooltip': badgeName, key: idx },
                      _react2.default.createElement('img', { src: badgeIcon, alt: badgeName }),
                      badge.count > 1 && _react2.default.createElement(
                        'span',
                        { className: _style2.default.CoveredInClass_performanceBadgeCount },
                        'x',
                        badge.count
                      )
                    );
                  })
                )
              );
            }).slice(0, this.state.showAllPerformance ? undefined : 2),
            !this.state.showAllPerformance && performanceData.length > 2 && _react2.default.createElement(
              'div',
              {
                className: _style2.default.CoveredInClass_performanceShowMore,
                onClick: function onClick() {
                  return _this10.setState({ showAllPerformance: true });
                }
              },
              _react2.default.createElement(
                'span',
                null,
                'Show more'
              ),
              _react2.default.createElement(
                'svg',
                { width: '18', height: '18', viewBox: '0 0 18 18', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
                _react2.default.createElement('path', { d: 'M12.4425 6.22168L9 9.65668L5.5575 6.22168L4.5 7.27918L9 11.7792L13.5 7.27918L12.4425 6.22168Z', fill: 'currentColor' })
              )
            )
          )
        )
      );
    }
  }, {
    key: '_closeFreeTextPopup',
    value: function _closeFreeTextPopup() {
      this._onChangeMode({ mode: '', index: '' });
    }
  }, {
    key: '_addFreeText',
    value: function _addFreeText(CICKey, categoryId, freeText) {
      this.setState({ isChanged: true });
      var _props11 = this.props,
          cicCategoryTemplate = _props11.cicCategoryTemplate,
          params = _props11.params;

      var cicKey = CICKey;
      var coveredInClassContent = this.props.coveredInClassContent;

      if (!coveredInClassContent) {
        var unitId = params.unitId || 0;
        cicKey = unitId + '-0';
        coveredInClassContent = new _immutable.Map();
        coveredInClassContent = coveredInClassContent.set(unitId + '-0', _CoveredInClass.CoveredInClass.create({
          cicCategories: [],
          cicActivities: [],
          unitId: unitId,
          lessonNumber: 0
        }));
      }
      var cicCategories = coveredInClassContent.get(cicKey) && coveredInClassContent.get(cicKey).get('cicCategories');

      if (!cicCategories || cicCategories.findIndex(function (x) {
        return x.get('cicCategoryId') === categoryId;
      }) < 0) {
        if (!cicCategories) {
          cicCategories = new _immutable.List();
        }
        var selectCategory = cicCategoryTemplate.find(function (x) {
          return x.get('cicCategoryId') === categoryId;
        });
        cicCategories = cicCategories.push((0, _immutable.Record)({
          cicCategoryId: undefined,
          cicCategoryItems: undefined,
          cicCategoryName: undefined
        })({
          cicCategoryId: categoryId,
          cicCategoryItems: new _immutable.List(),
          cicCategoryName: selectCategory.get('cicCategoryName')
        }));
      }

      cicCategories = cicCategories && cicCategories.update(cicCategories.findIndex(function (x) {
        return x.get('cicCategoryId') === categoryId;
      }), function (category) {
        return category.update('cicCategoryItems', function (cicCategoryItems) {
          var freeTextIndex = cicCategoryItems.findIndex(function (item) {
            return item.cicCategoryItemId === 0;
          });
          if (freeTextIndex >= 0) {
            return cicCategoryItems.update(freeTextIndex, function (item) {
              return item.update('cicCategoryItemName', function (cicCategoryItemName) {
                return cicCategoryItemName + '\n' + freeText;
              });
            });
          }
          return cicCategoryItems.push((0, _immutable.Record)({
            cicCategoryItemId: undefined,
            cicCategoryItemName: undefined,
            isChecked: undefined
          })({
            cicCategoryItemId: 0,
            cicCategoryItemName: freeText,
            isChecked: true
          }));
        });
      });

      var newCoveredInClassContent = new _immutable.List();
      if (!coveredInClassContent) {
        newCoveredInClassContent = newCoveredInClassContent.push((0, _immutable.Record)({
          UnitId: undefined,
          cicCategories: undefined,
          cicActivities: undefined
        })({
          cicCategories: cicCategories,
          cicActivities: new _immutable.List()
        }));
      } else {
        newCoveredInClassContent = coveredInClassContent && coveredInClassContent.update(cicKey, function (cic) {
          return cic.set('cicCategories', cicCategories);
        });
      }

      this.props.changeCoveredInClassObject(newCoveredInClassContent, params.sessionPlanId);
      this._closeFreeTextPopup();
    }
  }, {
    key: '_renderFreeTextPopup',
    value: function _renderFreeTextPopup() {
      var _this11 = this;

      var _props12 = this.props,
          cicCategoryTemplate = _props12.cicCategoryTemplate,
          coveredInClassContent = _props12.coveredInClassContent;

      var shouldShowFreeTextPopup = this.props.params.mode && this.props.params.mode === _routes.Modes.ADD_FREE_TEXT;
      return shouldShowFreeTextPopup && _react2.default.createElement(_AddFreeTextDialog2.default, { categoryOptions: cicCategoryTemplate,
        onCancel: function onCancel() {
          return _this11._closeFreeTextPopup();
        },
        coveredInClassContent: coveredInClassContent,
        onSave: function onSave(cicKey, categoryId, freeText) {
          return _this11._addFreeText(cicKey, categoryId, freeText);
        } });
    }
  }, {
    key: 'render',
    value: function render() {
      var sessionPlans = this.props.sessionPlans;


      if (!sessionPlans || !sessionPlans.data) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: _style2.default.CoveredInClass },
        this._renderUnsavedChangesWarningDialog(),
        this._renderContent(),
        this._renderFreeTextPopup()
      );
    }
  }]);

  return CoveredInClass;
}(_UnsavedChangesTrackingPageComponent2.default);

CoveredInClass.getCurrentRouteSegment = function (props) {
  return props.routes[props.routes.length - 1];
};

CoveredInClass.propTypes = {
  children: _propTypes2.default.node,
  timeZone: _propTypes2.default.string,
  groupName: _propTypes2.default.string,
  groupCode: _propTypes2.default.string,
  languageCode: _propTypes2.default.string,
  cicDisplayLanguage: _propTypes2.default.string,
  sessionPlans: _propTypes2.default.object.isRequired,
  params: _propTypes2.default.object.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  currentSessionIndex: _propTypes2.default.number,
  fetchSessionPlansIfNeeded: _propTypes2.default.func,
  state: _propTypes2.default.object.isRequired,
  router: _propTypes2.default.any.isRequired,
  route: _propTypes2.default.any.isRequired,
  routes: _propTypes2.default.array.isRequired,
  location: _propTypes2.default.object.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  fetchCoveredInClassIfNeeded: _propTypes2.default.func.isRequired,
  fetchCoveredInClassTemplateIfNeeded: _propTypes2.default.func.isRequired,
  fetchHFv4CICTemplateIfNeeded: _propTypes2.default.func.isRequired,
  fetchHFv4CICTemplate: _propTypes2.default.func,
  coveredInClassObject: _propTypes2.default.object,
  fetchCoveredInClass: _propTypes2.default.func,
  changeCoveredInClassObject: _propTypes2.default.func,
  publishCoveredInClass: _propTypes2.default.func,
  clearCoveredInClass: _propTypes2.default.func,
  canEditCoveredInClass: _propTypes2.default.bool.isRequired,
  sessions: _propTypes2.default.object,
  currentSessionId: _propTypes2.default.string.isRequired,
  showNavigationBar: _propTypes2.default.bool.isRequired,
  isAnyApiCalling: _propTypes2.default.bool,
  isNotPublished: _propTypes2.default.bool,
  hasCICTemplate: _propTypes2.default.bool.isRequired,
  cicCategoryTemplate: _propTypes2.default.object,
  fetchCICCategoriesIfNeeded: _propTypes2.default.func,
  hf4Homework: _propTypes2.default.object,
  fetchHF4HomeworkIfNeeded: _propTypes2.default.func,
  studentTaskList: _propTypes2.default.object,
  fetchStudentTaskListIfNeeded: _propTypes2.default.func,
  isCNEnvironment: _propTypes2.default.bool
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      sessionPlanId = _ownProps$params.sessionPlanId;

  var group = state.get('rootReducer').get('groups').get(groupId).data;

  var _Group$getCentre = _.actions.getCentre(state, group.id),
      timeZone = _Group$getCentre.timeZone;

  var languageCode = group.get('languageCode');
  var groupName = group.name;
  var groupCode = group.number;

  var sessionPlanIds = group.sessionPlans;

  if (_is_js2.default.undefined(sessionPlanIds.data)) {
    return { timeZone: timeZone, groupName: groupName, sessionPlans: sessionPlanIds };
  }
  var isNotPublished = _CoveredInClass.accessors.isNotPublished(state, ownProps.params);
  var hasCICTemplate = _CoveredInClass.accessors.hasCICTemplate(state, ownProps.params);
  var hasCIC = _CoveredInClass.accessors.hasCIC(state, ownProps.params);
  var sessionPlansInfo = state.get('rootReducer').get('sessionPlans').filter(function (session) {
    return session.groupId === group.id;
  });
  var units = (0, _accessors.getUnitList)(state, groupId);
  var currentSessionPlanId = sessionPlanId;
  var sessionPlans = sessionPlanIds.update('data', function (data) {
    return new _immutable.List(data);
  }).update('data', function (data) {
    return data.map(function (planId) {
      return sessionPlansInfo.get(planId);
    });
  });
  var currentSessionIndex = sessionPlans.data.findIndex(function (plan) {
    return plan.id === currentSessionPlanId;
  });

  var cicCategoryTemplate = state.get('rootReducer').get('cicCategoryTemplate').get(groupId);

  var canEditCoveredInClass = !_.actions.isAutoPublishCIC(state, groupId) && !_.actions.isHFV4CourseTypeGroup(state, groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.CoveredInClass.MarkAndPublish);

  var coveredInClassContent = state.get('rootReducer').get('coveredInClassContent').get(currentSessionPlanId);

  var coveredInClassTemplate = state.get('rootReducer').get('coveredInClassTemplate').get(currentSessionPlanId);
  coveredInClassTemplate = hasCICTemplate && coveredInClassTemplate.map(function (CIC) {
    return CIC.set('unitOrderingSequence', (0, _accessors.getUnitNumberById)(units, '' + CIC.unitId));
  }).sort(sortCoverdInClass);

  if (hasCIC || !isNotPublished) {
    coveredInClassContent = coveredInClassContent.map(function (CIC) {
      return CIC.set('unitOrderingSequence', (0, _accessors.getUnitNumberById)(units, '' + CIC.unitId));
    }).sort(sortCoverdInClass);
  } else {
    coveredInClassContent = coveredInClassTemplate;
  }

  var showNavigationBar = _UiState.actions.getShowNavigationBar(state);
  var cicDisplayLanguage = _.actions.isIDGroup(state, groupId) ? _Languages2.default.defaultLanguageCode : _UiState.actions.getCICDisplayLanguage(state) || _Languages2.default.defaultLanguageCode;
  var hf4Homework = _HF4Homework.accessors.getHF4Homework(state, currentSessionPlanId);
  var groupMembers = (0, _actions.getMembersByGroup)(state, groupId);
  var studentTaskList = _StudentTasks.accessors.getStudentTaskList(state, currentSessionPlanId);

  var groupLessonAwards = _GroupLessonAwards.accessors.getGroupLessonAwards(state, currentSessionPlanId);

  return {
    state: state,
    timeZone: timeZone,
    groupName: groupName,
    groupCode: groupCode,
    languageCode: languageCode,
    cicDisplayLanguage: cicDisplayLanguage,
    sessionPlans: sessionPlans,
    currentSessionIndex: currentSessionIndex,
    coveredInClassContent: coveredInClassContent,
    coveredInClassTemplate: coveredInClassTemplate,
    canEditCoveredInClass: canEditCoveredInClass,
    sessions: sessionPlansInfo,
    isNotPublished: isNotPublished,
    hasCICTemplate: hasCICTemplate,
    hasCIC: hasCIC,
    currentSessionId: currentSessionPlanId,
    showNavigationBar: showNavigationBar,
    isAnyApiCalling: !!isAnyApiCalling(state),
    cicCategoryTemplate: cicCategoryTemplate,
    hf4Homework: hf4Homework,
    groupMembers: groupMembers,
    studentTaskList: studentTaskList,
    isCNEnvironment: !!_omniCommonUi.Config.get('isCNEnvironment'),
    groupLessonAwards: groupLessonAwards
  };
}

function sortCoverdInClass(a, b) {
  if (a.unitOrderingSequence !== b.unitOrderingSequence) {
    return a.unitOrderingSequence - b.unitOrderingSequence;
  }
  return a.lessonNumber - b.lessonNumber;
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_SessionPlans.actions, dispatch), (0, _redux.bindActionCreators)(_CoveredInClass.actions, dispatch), (0, _redux.bindActionCreators)(_Template.actions, dispatch), (0, _redux.bindActionCreators)(_CategoryTemplate.actions, dispatch), (0, _redux.bindActionCreators)(_HF4Homework.actions, dispatch), (0, _redux.bindActionCreators)(_StudentTasks.actions, dispatch), { fetchGroupMembersIfNeeded: function fetchGroupMembersIfNeeded(groupId) {
      return dispatch((0, _actions.fetchGroupMembersIfNeeded)(groupId));
    } }, { fetchGroupLessonAwardsIfNeeded: function fetchGroupLessonAwardsIfNeeded(sessionId) {
      return dispatch((0, _actions2.fetchGroupLessonAwardsIfNeeded)(sessionId));
    } });
}

function isAnyApiCalling(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST', 'GET'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(CoveredInClass));

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = exports.accessors = undefined;

var _accessors2 = __webpack_require__(1577);

var _accessors = _interopRequireWildcard(_accessors2);

var _actions2 = __webpack_require__(687);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1578);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var accessors = exports.accessors = _accessors;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_HF4_HOMEWORK_FAILURE = exports.FETCH_HF4_HOMEWORK_SUCCESS = exports.FETCH_HF4_HOMEWORK_REQUEST = undefined;
exports.fetchHF4HomeworkIfNeeded = fetchHF4HomeworkIfNeeded;
exports.fetchHF4Homework = fetchHF4Homework;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_HF4_HOMEWORK_REQUEST = exports.FETCH_HF4_HOMEWORK_REQUEST = 'FETCH_HF4_HOMEWORK_REQUEST';
var FETCH_HF4_HOMEWORK_SUCCESS = exports.FETCH_HF4_HOMEWORK_SUCCESS = 'FETCH_HF4_HOMEWORK_SUCCESS';
var FETCH_HF4_HOMEWORK_FAILURE = exports.FETCH_HF4_HOMEWORK_FAILURE = 'FETCH_HF4_HOMEWORK_FAILURE';

var buildHF4HomeworkUrl = function buildHF4HomeworkUrl(sessionId) {
  return (0, _Api.buildUrl)('/sessions/' + sessionId + '/hf4/homework');
};
var HTTP_METHOD_GET = 'GET';

function fetchHF4HomeworkIfNeeded(sessionId) {
  return function (dispatch, getState) {
    var state = getState();
    var url = buildHF4HomeworkUrl(sessionId);
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: HTTP_METHOD_GET, url: url })) {
      return false;
    }

    return dispatch(fetchHF4Homework(sessionId));
  };
}

function fetchHF4Homework(sessionId) {
  return function (dispatch) {
    var url = buildHF4HomeworkUrl(sessionId);
    var method = HTTP_METHOD_GET;

    return dispatch(createHF4HomeworkRequestAction({ sessionId: sessionId, method: method, url: url })).payload.then(function (response) {
      return dispatch(createHF4HomeworkSuccessAction({ response: response, sessionId: sessionId, method: method, url: url }));
    }).catch(function (error) {
      if (error.response && error.response.code === 404) {
        return dispatch(createHF4HomeworkSuccessAction({ sessionId: sessionId, method: method, url: url }));
      }

      return dispatch(createHF4HomeworkFailureAction({ error: error, sessionId: sessionId, method: method, url: url }));
    });
  };
}

function createHF4HomeworkRequestAction(_ref) {
  var sessionId = _ref.sessionId,
      method = _ref.method,
      url = _ref.url;

  return _omniCommonUi.ApiCall.createAction({
    type: FETCH_HF4_HOMEWORK_REQUEST,
    payload: (0, _Api.fetch)(url),
    url: url,
    method: method,
    sessionId: sessionId
  });
}

function createHF4HomeworkSuccessAction(_ref2) {
  var response = _ref2.response,
      sessionId = _ref2.sessionId,
      method = _ref2.method,
      url = _ref2.url;

  return _omniCommonUi.ApiCall.createAction({
    type: FETCH_HF4_HOMEWORK_SUCCESS,
    payload: response,
    url: url,
    method: method,
    sessionId: sessionId
  });
}

function createHF4HomeworkFailureAction(_ref3) {
  var error = _ref3.error,
      sessionId = _ref3.sessionId,
      method = _ref3.method,
      url = _ref3.url;

  return _omniCommonUi.ApiCall.createAction({
    type: FETCH_HF4_HOMEWORK_FAILURE,
    error: error,
    url: url,
    method: method,
    sessionId: sessionId
  });
}

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchStudentTasks = exports.fetchStudentTasksIfNeeded = exports.FETCH_STUDENT_TASK_LIST_FAILURE = exports.FETCH_STUDENT_TASK_LIST_SUCCESS = exports.FETCH_STUDENT_TASK_LIST_REQUEST = exports.FETCH_STUDENT_TASK_RESULTS_FAILURE = exports.FETCH_STUDENT_TASK_RESULTS_SUCCESS = exports.FETCH_STUDENT_TASK_RESULTS_REQUEST = undefined;
exports.fetchStudentTaskResultsIfNeeded = fetchStudentTaskResultsIfNeeded;
exports.fetchStudentTaskResults = fetchStudentTaskResults;
exports.fetchStudentTaskListIfNeeded = fetchStudentTaskListIfNeeded;
exports.fetchStudentTaskList = fetchStudentTaskList;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

// Task Results API (existing functionality)
var FETCH_STUDENT_TASK_RESULTS_REQUEST = exports.FETCH_STUDENT_TASK_RESULTS_REQUEST = 'FETCH_STUDENT_TASK_RESULTS_REQUEST';
var FETCH_STUDENT_TASK_RESULTS_SUCCESS = exports.FETCH_STUDENT_TASK_RESULTS_SUCCESS = 'FETCH_STUDENT_TASK_RESULTS_SUCCESS';
var FETCH_STUDENT_TASK_RESULTS_FAILURE = exports.FETCH_STUDENT_TASK_RESULTS_FAILURE = 'FETCH_STUDENT_TASK_RESULTS_FAILURE';

// Task List API (new functionality)
var FETCH_STUDENT_TASK_LIST_REQUEST = exports.FETCH_STUDENT_TASK_LIST_REQUEST = 'FETCH_STUDENT_TASK_LIST_REQUEST';
var FETCH_STUDENT_TASK_LIST_SUCCESS = exports.FETCH_STUDENT_TASK_LIST_SUCCESS = 'FETCH_STUDENT_TASK_LIST_SUCCESS';
var FETCH_STUDENT_TASK_LIST_FAILURE = exports.FETCH_STUDENT_TASK_LIST_FAILURE = 'FETCH_STUDENT_TASK_LIST_FAILURE';

var buildStudentTaskResultsUrl = function buildStudentTaskResultsUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/student-task-results');
};
var buildStudentTaskListUrl = function buildStudentTaskListUrl(sessionId, language) {
  return (0, _Api.buildUrl)('/sessions/' + sessionId + '/student-tasks' + (language ? '?language=' + language : ''));
};

// Fetch student task results (completion status)
function fetchStudentTaskResultsIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildStudentTaskResultsUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchStudentTaskResults(groupId));
  };
}

function fetchStudentTaskResults(groupId) {
  return function (dispatch) {
    var url = buildStudentTaskResultsUrl(groupId);
    var method = 'GET';

    return dispatch(fetchStudentTaskResultsRequest()).payload.then(function (response) {
      return dispatch(fetchStudentTaskResultsSuccess(response));
    }
    // the endpoint is not available in every environment yet, degrade to empty results
    ).catch(function () {
      return dispatch(fetchStudentTaskResultsSuccess([]));
    });

    function fetchStudentTaskResultsRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_TASK_RESULTS_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchStudentTaskResultsSuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_TASK_RESULTS_SUCCESS,
        payload: payload,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchStudentTaskResultsFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_TASK_RESULTS_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

// Fetch student task list (task definitions)
function fetchStudentTaskListIfNeeded(sessionId, language) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildStudentTaskListUrl(sessionId, language) })) {
      return false;
    }

    return dispatch(fetchStudentTaskList(sessionId, language));
  };
}

function fetchStudentTaskList(sessionId, language) {
  return function (dispatch) {
    var url = buildStudentTaskListUrl(sessionId, language);
    var method = 'GET';

    return dispatch(fetchStudentTaskListRequest()).payload.then(function (response) {
      return dispatch(fetchStudentTaskListSuccess(response, sessionId));
    }).catch(function (error) {
      return dispatch(fetchStudentTaskListFailure(error));
    });

    function fetchStudentTaskListRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_TASK_LIST_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchStudentTaskListSuccess(payload, sid) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_TASK_LIST_SUCCESS,
        payload: payload,
        url: url,
        method: method,
        sessionId: sid
      });
    }

    function fetchStudentTaskListFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_TASK_LIST_FAILURE,
        error: error,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }
  };
}

// Keep old function names for backward compatibility
var fetchStudentTasksIfNeeded = exports.fetchStudentTasksIfNeeded = fetchStudentTaskResultsIfNeeded;
var fetchStudentTasks = exports.fetchStudentTasks = fetchStudentTaskResults;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentTaskResultRecord = (0, _immutable.Record)({
  completion: undefined,
  sessionId: undefined,
  studentId: undefined
});

var StudentTaskResult = function (_StudentTaskResultRec) {
  _inherits(StudentTaskResult, _StudentTaskResultRec);

  function StudentTaskResult() {
    _classCallCheck(this, StudentTaskResult);

    return _possibleConstructorReturn(this, (StudentTaskResult.__proto__ || Object.getPrototypeOf(StudentTaskResult)).apply(this, arguments));
  }

  return StudentTaskResult;
}(StudentTaskResultRecord);

exports.default = StudentTaskResult;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = exports.accessors = undefined;

var _accessors2 = __webpack_require__(1584);

var _accessors = _interopRequireWildcard(_accessors2);

var _actions2 = __webpack_require__(312);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1585);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var accessors = exports.accessors = _accessors;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isInEditNoteMode = isInEditNoteMode;

var _component = __webpack_require__(685);

var _component2 = _interopRequireDefault(_component);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _omniCommonUi = __webpack_require__(0);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _SessionNav = __webpack_require__(132);

var _SessionNav2 = _interopRequireDefault(_SessionNav);

var _accessors = __webpack_require__(36);

var _CoveredInClass = __webpack_require__(95);

var _ViewNavCIC = __webpack_require__(1586);

var _ViewNavCIC2 = _interopRequireDefault(_ViewNavCIC);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Modes = exports.Modes = {
  PUBLISH: 'publish-to-ef-p',
  EXPORT: 'export',
  ADD_NOTES: 'add-notes',
  EDIT_NOTES: 'edit-notes',
  DELETE_NOTES: 'delete-notes',
  ADD_FREE_TEXT: 'add-free-text',
  CLEAR: 'clear'
};

var SHOW_ADD_NOTES = false;

var actionButtons = function actionButtons(getState) {
  return {
    PUBLISH: {
      isPrimary: true,
      route: './' + Modes.PUBLISH,
      visibleWhen: function visibleWhen(_ref) {
        var params = _ref.params;
        return !_.actions.isAutoPublishCIC(getState(), params.groupId) && !_.actions.isHFV4CourseTypeGroup(getState(), params.groupId) && _CoveredInClass.accessors.isNotPublished(getState(), params) && _CoveredInClass.accessors.isNotFutureSession(getState(), params);
      },
      disableWhen: function disableWhen(_ref2) {
        var _ref2$params = _ref2.params,
            mode = _ref2$params.mode,
            sessionPlanId = _ref2$params.sessionPlanId;

        var coveredInClassObject = _CoveredInClass.accessors.getCoveredInClassObject(getState(), sessionPlanId);
        var hasPrivilege = _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.MarkAndPublish);
        // OMO-2376: Publish button is disabled if all items are unchecked
        return !hasPrivilege || isInEditNoteMode(mode) || _CoveredInClass.accessors.isAllCategoryItemsUnchecked(coveredInClassObject);
      }
    },
    EXPORT: {
      isPrimary: false,
      route: './' + Modes.EXPORT,
      visibleWhen: function visibleWhen(_ref3) {
        var params = _ref3.params;
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.PrintCoveredInClass) && !_.actions.isNotTBv3Group(getState(), params.groupId) && !_.actions.isHFV4CourseTypeGroup(getState(), params.groupId) && _CoveredInClass.accessors.isNotFutureSession(getState(), params) && _CoveredInClass.accessors.hasCICTemplate(getState(), params);
      },
      disableWhen: function disableWhen(_ref4) {
        var mode = _ref4.params.mode;
        return isInEditNoteMode(mode);
      }
    },
    'ADD NOTES': {
      isPrimary: false,
      route: './' + Modes.ADD_NOTES,
      visibleWhen: function visibleWhen() {
        return SHOW_ADD_NOTES && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.AddCommentToInternal);
      },
      disableWhen: function disableWhen(_ref5) {
        var mode = _ref5.params.mode;
        return isInEditNoteMode(mode);
      }
    },
    'ADD FREE TEXT': {
      isPrimary: false,
      route: './' + Modes.ADD_FREE_TEXT,
      visibleWhen: function visibleWhen(_ref6) {
        var params = _ref6.params;
        return !_.actions.isAutoPublishCIC(getState(), params.groupId) && !_.actions.isHFV4CourseTypeGroup(getState(), params.groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.AddCommentToInternal) && _CoveredInClass.accessors.isNotPublished(getState(), params) && _CoveredInClass.accessors.isNotFutureSession(getState(), params);
      },
      disableWhen: function disableWhen(_ref7) {
        var mode = _ref7.params.mode;
        return isInEditNoteMode(mode);
      }
    },
    CLEAR: {
      isPrimary: false,
      route: './' + Modes.CLEAR,
      visibleWhen: function visibleWhen(_ref8) {
        var params = _ref8.params;
        return !_CoveredInClass.accessors.isNotPublished(getState(), params) && _CoveredInClass.accessors.hasWronglyResult(getState(), params.sessionPlanId);
      }
    }
  };
};

exports.default = function (_ref9) {
  var _actionButtons;

  var getState = _ref9.getState;
  return {
    appBars: {
      sticky: {
        'session-nav': {
          component: _SessionNav2.default,
          order: 1
        },
        'view-nav': {
          component: _ViewNavCIC2.default,
          order: 2
        }
      }
    },
    path: 'session/:sessionPlanId(/unit/:unitId)/covered-in-class-hfv4(/:mode)(/:index)',
    component: _component2.default,
    canAccess: function canAccess(_ref10) {
      var params = _ref10.params;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.ViewCoveredInClass) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.CoveredInClassAndHomeworkHFv4);
    },
    tab: {
      label: 'Homework & CIC',
      order: 2,
      isVisible: function isVisible(params) {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.ViewCoveredInClass) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.CoveredInClassAndHomeworkHFv4);
      },
      params: function params(currentParams) {
        var defaultSession = (0, _accessors.getDefaultSession)(getState(), currentParams.groupId);
        var sessionPlanId = defaultSession && defaultSession.id;
        return _extends({}, currentParams, {
          sessionPlanId: sessionPlanId,
          unitId: (0, _accessors.getFirstUnitOfSession)(getState(), sessionPlanId),
          mode: ''
        });
      }
    },
    breadcrumbLabels: function breadcrumbLabels(props) {
      return [{
        label: 'Homework & CIC',
        clickable: false
      }, 'Session ' + (_CoveredInClass.accessors.getCurrentSessionNumber(getState(), props) || '')];
    },
    actionButtons: (_actionButtons = {
      default: actionButtons(getState)
    }, _defineProperty(_actionButtons, Modes.ADD_NOTES, actionButtons(getState)), _defineProperty(_actionButtons, Modes.EDIT_NOTES, actionButtons(getState)), _defineProperty(_actionButtons, Modes.ADD_FREE_TEXT, actionButtons(getState)), _defineProperty(_actionButtons, Modes.CLEAR, actionButtons(getState)), _actionButtons)
  };
};

function isInEditNoteMode(mode) {
  return mode === Modes.ADD_NOTES || mode === Modes.EDIT_NOTES || mode === Modes.ADD_FREE_TEXT;
}

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHINESE_LANGUAGE = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1595);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CHINESE_LANGUAGE = exports.CHINESE_LANGUAGE = 'zh-CN';

var DEFAULT_LANGUAGES = [{
  code: CHINESE_LANGUAGE,
  label: '中文'
}, {
  code: _Languages2.default.defaultLanguageCode,
  label: 'EN'
}];

var LanguageSwitcher = function (_PureComponent) {
  _inherits(LanguageSwitcher, _PureComponent);

  function LanguageSwitcher() {
    _classCallCheck(this, LanguageSwitcher);

    return _possibleConstructorReturn(this, (LanguageSwitcher.__proto__ || Object.getPrototypeOf(LanguageSwitcher)).apply(this, arguments));
  }

  _createClass(LanguageSwitcher, [{
    key: '_handleLanguageChange',
    value: function _handleLanguageChange(languageCode) {
      if (languageCode === this.props.selectedLanguage) return;
      this.props.onLanguageChange(languageCode);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var selectedLanguage = this.props.selectedLanguage || _Languages2.default.defaultLanguageCode;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames3.default)(_style2.default.LanguageSwitcher, this.props.className) },
        this.props.languages.map(function (language) {
          var isSelected = language.code === selectedLanguage;
          return _react2.default.createElement(
            'button',
            { type: 'button',
              key: language.code,
              className: (0, _classnames3.default)(_style2.default.LanguageSwitcher_option, _defineProperty({}, _style2.default._selected, isSelected)),
              onClick: function onClick() {
                return _this2._handleLanguageChange(language.code);
              } },
            language.label
          );
        })
      );
    }
  }]);

  return LanguageSwitcher;
}(_react.PureComponent);

LanguageSwitcher.propTypes = {
  className: _propTypes2.default.string,
  languages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    code: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })),
  selectedLanguage: _propTypes2.default.string,
  onLanguageChange: _propTypes2.default.func.isRequired
};

LanguageSwitcher.defaultProps = {
  languages: DEFAULT_LANGUAGES,
  selectedLanguage: _Languages2.default.defaultLanguageCode
};

exports.default = LanguageSwitcher;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1599);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _redux = __webpack_require__(10);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RAv2HomeworkResultDetail = __webpack_require__(694);

var _SessionPlans = __webpack_require__(44);

var _CourseType = __webpack_require__(193);

var _ProductionStatus = __webpack_require__(73);

var _Month = __webpack_require__(211);

var _Weekday = __webpack_require__(697);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SUB_COLUMNS = ['Completion', 'Accuracy', 'Story Read', 'Recorded'];

function formatUnitLabel(unitInfo, groupLevel) {
  return 'Level ' + (groupLevel || unitInfo.unitSequenceId) + ', Story ' + unitInfo.unitSequenceId;
}

function formatUnitDate(dateStr) {
  if (!dateStr) return null;
  var d = new Date(dateStr);
  if (isNaN(d.getTime())) return null;
  return (0, _Weekday.getWeekdayAbbr)(d.getDay()) + ', ' + d.getDate() + ' ' + (0, _Month.getMonthAbbr)(d.getMonth()) + ' ' + d.getFullYear();
}

function formatPercentage(value) {
  return Math.round((value || 0) * 100) + '%';
}

var DigitalPracticeRAv2 = function (_Component) {
  _inherits(DigitalPracticeRAv2, _Component);

  function DigitalPracticeRAv2() {
    _classCallCheck(this, DigitalPracticeRAv2);

    return _possibleConstructorReturn(this, (DigitalPracticeRAv2.__proto__ || Object.getPrototypeOf(DigitalPracticeRAv2)).apply(this, arguments));
  }

  _createClass(DigitalPracticeRAv2, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var groupId = this.props.groupId;

      if (groupId) {
        this.props.fetchRAv2HomeworkResultDetailIfNeeded(groupId);
      }
      this._scheduleSyncRowHeights();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._syncRafId) {
        window.cancelAnimationFrame(this._syncRafId);
        this._syncRafId = null;
      }
    }
  }, {
    key: '_scheduleSyncRowHeights',
    value: function _scheduleSyncRowHeights() {
      var _this2 = this;

      if (this._syncRafId) {
        window.cancelAnimationFrame(this._syncRafId);
      }
      this._syncRafId = window.requestAnimationFrame(function () {
        _this2._syncRafId = null;
        _this2._syncRowHeights();
      });
    }
  }, {
    key: '_getUnitInfos',
    value: function _getUnitInfos() {
      var students = this.props.students;

      if (!students || students.size === 0) return [];

      var unitMap = {};
      students.forEach(function (student) {
        if (student.unitResults) {
          student.unitResults.forEach(function (unit) {
            if (!unitMap[unit.unitSequenceId]) {
              unitMap[unit.unitSequenceId] = {
                unitId: unit.unitId,
                unitSequenceId: unit.unitSequenceId,
                level: unit.level,
                storyNumber: unit.storyNumber,
                date: unit.date
              };
            }
          });
        }
      });

      return Object.values(unitMap).sort(function (a, b) {
        return a.unitSequenceId - b.unitSequenceId;
      });
    }
  }, {
    key: '_getUnitResultMap',
    value: function _getUnitResultMap(student) {
      var map = {};
      if (student.unitResults) {
        student.unitResults.forEach(function (unit) {
          map[unit.unitSequenceId] = unit;
        });
      }
      return map;
    }
  }, {
    key: '_renderInfoTooltip',
    value: function _renderInfoTooltip() {
      return _react2.default.createElement(
        'div',
        { className: _style2.default.DigitalPracticeRAv2_infoIcon },
        _react2.default.createElement(
          'svg',
          { width: '18', height: '18', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
          _react2.default.createElement('path', { d: 'M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z', fill: 'black' })
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.DigitalPracticeRAv2_tooltip },
          _react2.default.createElement(
            'h3',
            { className: _style2.default.DigitalPracticeRAv2_tooltip_title },
            'Performance Legends'
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.DigitalPracticeRAv2_tooltip_item },
            _react2.default.createElement(
              'strong',
              null,
              'Completion'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Completion rate records include completing Step2 activities'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.DigitalPracticeRAv2_tooltip_item },
            _react2.default.createElement(
              'strong',
              null,
              'Accuracy'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Accuracy rate is calculated based on the ratio of correct answers to total answers in the step 2 activities'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.DigitalPracticeRAv2_tooltip_item },
            _react2.default.createElement(
              'strong',
              null,
              'Story Read'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Reading completion is marked as achieved when the student listen to and read the entire story once'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.DigitalPracticeRAv2_tooltip_item },
            _react2.default.createElement(
              'strong',
              null,
              'Recorded'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Recordings are displayed based on how many times a student records the story, with each attempt contributing to the total count'
            )
          )
        )
      );
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._syncRowHeights();
    }
  }, {
    key: '_syncRowHeights',
    value: function _syncRowHeights() {
      if (!this._panelRef || !this._tableRef) return;
      var panelTrs = this._panelRef.querySelectorAll('tr');
      var tableTrs = this._tableRef.querySelectorAll('tr');
      var len = Math.min(panelTrs.length, tableTrs.length);
      for (var i = 0; i < len; i++) {
        panelTrs[i].style.height = '';
        tableTrs[i].style.height = '';
      }
      for (var _i = 0; _i < len; _i++) {
        var h = Math.max(panelTrs[_i].offsetHeight, tableTrs[_i].offsetHeight);
        panelTrs[_i].style.height = h + 'px';
        tableTrs[_i].style.height = h + 'px';
      }
    }
  }, {
    key: '_renderPanelHeader',
    value: function _renderPanelHeader() {
      return _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'th',
            { rowSpan: '2', className: _style2.default.DigitalPracticeRAv2_studentCol },
            'Student'
          ),
          _react2.default.createElement(
            'th',
            { rowSpan: '2', className: _style2.default.DigitalPracticeRAv2_statusCol },
            'Status'
          )
        ),
        _react2.default.createElement('tr', null)
      );
    }
  }, {
    key: '_isActiveUnit',
    value: function _isActiveUnit(unitId) {
      var defaultUnitIds = this.props.defaultUnitIds;

      if (!defaultUnitIds || defaultUnitIds.length === 0) return false;
      return defaultUnitIds.some(function (id) {
        return String(id) === String(unitId);
      });
    }
  }, {
    key: '_renderMainTableHeader',
    value: function _renderMainTableHeader(unitInfos) {
      var _this3 = this;

      return _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          null,
          unitInfos.map(function (unitInfo) {
            var isActive = _this3._isActiveUnit(unitInfo.unitId);
            var headerClass = isActive ? _style2.default.DigitalPracticeRAv2_unitHeader + ' ' + _style2.default.DigitalPracticeRAv2_unitHeaderActive : _style2.default.DigitalPracticeRAv2_unitHeader;
            var dateFormatted = formatUnitDate(unitInfo.date);
            return _react2.default.createElement(
              'th',
              { key: 'unit-' + unitInfo.unitSequenceId, colSpan: '4', className: headerClass },
              _react2.default.createElement(
                'div',
                null,
                formatUnitLabel(unitInfo, _this3.props.groupLevel)
              ),
              dateFormatted && _react2.default.createElement(
                'time',
                { className: _style2.default.DigitalPracticeRAv2_unitHeaderDate, dateTime: unitInfo.date },
                dateFormatted
              )
            );
          })
        ),
        _react2.default.createElement(
          'tr',
          null,
          unitInfos.map(function (unitInfo) {
            var isActive = _this3._isActiveUnit(unitInfo.unitId);
            return SUB_COLUMNS.map(function (col, colIndex) {
              var subHeaderClass = [_style2.default.DigitalPracticeRAv2_subHeader];
              if (colIndex === 0) subHeaderClass.push(_style2.default.DigitalPracticeRAv2_unitFirstCol);
              if (isActive) subHeaderClass.push(_style2.default.DigitalPracticeRAv2_subHeaderActive);
              return _react2.default.createElement(
                'th',
                {
                  key: 'sub-' + unitInfo.unitSequenceId + '-' + col,
                  className: subHeaderClass.join(' ') },
                col
              );
            });
          })
        )
      );
    }
  }, {
    key: '_renderPanelRow',
    value: function _renderPanelRow(student) {
      var info = student.studentGeneralInfo || {};
      var name = ((info.firstName || '') + ' ' + (info.lastName || '')).trim();
      var statusParsed = (0, _ProductionStatus.parseProductionStatus)(student.status);

      return _react2.default.createElement(
        'tr',
        { key: info.id },
        _react2.default.createElement(
          'td',
          { className: _style2.default.DigitalPracticeRAv2_studentCol },
          _react2.default.createElement(
            'div',
            { className: _style2.default.DigitalPracticeRAv2_studentCard },
            _react2.default.createElement(
              _omniCommonUi.StudentCard,
              { borderless: true, backgroundless: true },
              _react2.default.createElement(_omniCommonUi.StudentCard.Profile, {
                name: name,
                localName: info.localName,
                gender: info.gender,
                avatarUrl: info.avatarUrl })
            )
          )
        ),
        _react2.default.createElement(
          'td',
          { className: _style2.default.DigitalPracticeRAv2_statusCol },
          _react2.default.createElement(_omniCommonUi.ProductionStatus, { status: statusParsed.fullName, highlighted: student.isInProduction })
        )
      );
    }
  }, {
    key: '_renderMainTableRow',
    value: function _renderMainTableRow(student, unitInfos) {
      var _this4 = this;

      var info = student.studentGeneralInfo || {};
      var unitMap = this._getUnitResultMap(student);

      return _react2.default.createElement(
        'tr',
        { key: info.id },
        unitInfos.map(function (unitInfo) {
          var unit = unitMap[unitInfo.unitSequenceId] || {};
          var isActive = _this4._isActiveUnit(unitInfo.unitId);
          var firstColClass = isActive ? _style2.default.DigitalPracticeRAv2_unitFirstCol + ' ' + _style2.default.DigitalPracticeRAv2_cellActive : _style2.default.DigitalPracticeRAv2_unitFirstCol;
          var cellClass = isActive ? _style2.default.DigitalPracticeRAv2_cellActive : undefined;
          return [_react2.default.createElement(
            'td',
            { key: info.id + '-' + unitInfo.unitSequenceId + '-completion', className: firstColClass },
            unit.completion ? formatPercentage(unit.completion) : 'N/A'
          ), _react2.default.createElement(
            'td',
            { key: info.id + '-' + unitInfo.unitSequenceId + '-accuracy', className: cellClass },
            unit.completion ? formatPercentage(unit.accuracy) : 'N/A'
          ), _react2.default.createElement(
            'td',
            { key: info.id + '-' + unitInfo.unitSequenceId + '-storyRead', className: cellClass },
            unit.storyRead >= 1 ? _react2.default.createElement(
              'span',
              { className: _style2.default.DigitalPracticeRAv2_checkmark },
              '\u2713'
            ) : 'N/A'
          ), _react2.default.createElement(
            'td',
            { key: info.id + '-' + unitInfo.unitSequenceId + '-recorded', className: cellClass },
            unit.recorded ? unit.recorded : 'N/A'
          )];
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          students = _props.students,
          isLoading = _props.isLoading;

      var unitInfos = this._getUnitInfos();

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _omniCommonUi.testClass)('digital-practice-rav2') },
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          {
            text: 'Performance',
            className: _style2.default.DigitalPracticeRAv2_heading },
          this._renderInfoTooltip(),
          _react2.default.createElement(
            'div',
            { className: _style2.default.DigitalPracticeRAv2_headingActions },
            false ? _react2.default.createElement(
              'button',
              { className: _style2.default.DigitalPracticeRAv2_exportBtn, type: 'button' },
              'Export'
            ) : null
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.DigitalPracticeRAv2_content },
          (!students || students.size === 0) && !isLoading ? _react2.default.createElement(
            'div',
            { className: _style2.default.DigitalPracticeRAv2_empty },
            'No Results.'
          ) : _react2.default.createElement(
            'div',
            { className: _style2.default.DigitalPracticeRAv2_tableLayout },
            _react2.default.createElement(
              'div',
              { className: _style2.default.DigitalPracticeRAv2_panel,
                ref: function ref(c) {
                  _this5._panelRef = c;
                } },
              _react2.default.createElement(
                'table',
                { className: _style2.default.DigitalPracticeRAv2_table },
                this._renderPanelHeader(),
                _react2.default.createElement(
                  'tbody',
                  null,
                  students && students.map(function (student) {
                    return _this5._renderPanelRow(student);
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default.DigitalPracticeRAv2_tableContainer,
                ref: function ref(c) {
                  _this5._tableRef = c;
                } },
              _react2.default.createElement(
                'table',
                { className: _style2.default.DigitalPracticeRAv2_table },
                this._renderMainTableHeader(unitInfos),
                _react2.default.createElement(
                  'tbody',
                  null,
                  students && students.map(function (student) {
                    return _this5._renderMainTableRow(student, unitInfos);
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DigitalPracticeRAv2;
}(_react.Component);

DigitalPracticeRAv2.propTypes = {
  students: _propTypes2.default.object,
  isLoading: _propTypes2.default.bool,
  hideExportButton: _propTypes2.default.bool,
  groupId: _propTypes2.default.string,
  groupLevel: _propTypes2.default.number,
  defaultUnitIds: _propTypes2.default.array,
  fetchRAv2HomeworkResultDetailIfNeeded: _propTypes2.default.func.isRequired
};

DigitalPracticeRAv2.defaultProps = {
  hideExportButton: true
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var students = _RAv2HomeworkResultDetail.accessors.getRAv2HomeworkResultDetailByGroup(state, groupId);
  var isLoading = _RAv2HomeworkResultDetail.accessors.isLoadingRAv2HomeworkResultDetail(state, groupId);
  var defaultSession = _SessionPlans.actions.getDefaultSession(state, groupId);
  var defaultUnitIds = defaultSession && defaultSession.unitIds ? defaultSession.unitIds : [];
  var group = state.get('rootReducer').get('groups').get(groupId);
  var courseTypeLevelId = group && group.data && group.data.courseTypeLevelId;
  var groupLevel = (0, _CourseType.getRAv2LevelNumber)(courseTypeLevelId);
  return { students: students, isLoading: isLoading, groupId: groupId, groupLevel: groupLevel, defaultUnitIds: defaultUnitIds };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    fetchRAv2HomeworkResultDetailIfNeeded: _RAv2HomeworkResultDetail.actions.fetchRAv2HomeworkResultDetailIfNeeded
  }, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(DigitalPracticeRAv2);

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnitResult = exports.StudentHomeworkDetail = exports.reducer = exports.actions = exports.accessors = undefined;

var _accessors2 = __webpack_require__(1601);

var _accessors = _interopRequireWildcard(_accessors2);

var _actions2 = __webpack_require__(695);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1602);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(696);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var accessors = exports.accessors = _accessors;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var StudentHomeworkDetail = exports.StudentHomeworkDetail = _model2.default;
var UnitResult = exports.UnitResult = _model.UnitResult;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_RAV2_HOMEWORK_RESULT_DETAIL_FAILURE = exports.FETCH_RAV2_HOMEWORK_RESULT_DETAIL_SUCCESS = exports.FETCH_RAV2_HOMEWORK_RESULT_DETAIL_REQUEST = undefined;
exports.fetchRAv2HomeworkResultDetailIfNeeded = fetchRAv2HomeworkResultDetailIfNeeded;
exports.fetchRAv2HomeworkResultDetail = fetchRAv2HomeworkResultDetail;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_RAV2_HOMEWORK_RESULT_DETAIL_REQUEST = exports.FETCH_RAV2_HOMEWORK_RESULT_DETAIL_REQUEST = 'FETCH_RAV2_HOMEWORK_RESULT_DETAIL_REQUEST';
var FETCH_RAV2_HOMEWORK_RESULT_DETAIL_SUCCESS = exports.FETCH_RAV2_HOMEWORK_RESULT_DETAIL_SUCCESS = 'FETCH_RAV2_HOMEWORK_RESULT_DETAIL_SUCCESS';
var FETCH_RAV2_HOMEWORK_RESULT_DETAIL_FAILURE = exports.FETCH_RAV2_HOMEWORK_RESULT_DETAIL_FAILURE = 'FETCH_RAV2_HOMEWORK_RESULT_DETAIL_FAILURE';

var method = 'GET';
var buildRAv2HomeworkResultDetailUrl = function buildRAv2HomeworkResultDetailUrl(groupId) {
  return (0, _Api.buildUrl)('/ra-v2-groups/' + groupId + '/homework-result-detail');
};

function fetchRAv2HomeworkResultDetailIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, {
      method: method,
      url: buildRAv2HomeworkResultDetailUrl(groupId)
    })) {
      return false;
    }

    return dispatch(fetchRAv2HomeworkResultDetail(groupId));
  };
}

function fetchRAv2HomeworkResultDetail(groupId) {
  return function (dispatch) {
    var url = buildRAv2HomeworkResultDetailUrl(groupId);

    var payload = (0, _Api.fetch)(url);

    return dispatch(fetchRAv2HomeworkResultDetailRequest()).payload.then(function (response) {
      return dispatch(fetchRAv2HomeworkResultDetailSuccess(response));
    }).catch(function (error) {
      if (error.response && error.response.code === 404) {
        return dispatch(fetchRAv2HomeworkResultDetailSuccess([]));
      }

      return dispatch(fetchRAv2HomeworkResultDetailFailure(error));
    });

    function fetchRAv2HomeworkResultDetailRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_RAV2_HOMEWORK_RESULT_DETAIL_REQUEST,
        payload: payload,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchRAv2HomeworkResultDetailSuccess(successPayload) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_RAV2_HOMEWORK_RESULT_DETAIL_SUCCESS,
        payload: successPayload,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchRAv2HomeworkResultDetailFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_RAV2_HOMEWORK_RESULT_DETAIL_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnitResult = undefined;

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitResultRecord = (0, _immutable.Record)({
  unitId: undefined,
  unitSequenceId: undefined,
  level: undefined,
  storyNumber: undefined,
  date: undefined,
  completion: 0,
  accuracy: 0,
  storyRead: 0,
  recorded: 0
});

var UnitResult = function (_UnitResultRecord) {
  _inherits(UnitResult, _UnitResultRecord);

  function UnitResult() {
    _classCallCheck(this, UnitResult);

    return _possibleConstructorReturn(this, (UnitResult.__proto__ || Object.getPrototypeOf(UnitResult)).apply(this, arguments));
  }

  return UnitResult;
}(UnitResultRecord);

var toNumber = function toNumber(value) {
  var numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

UnitResult.create = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new UnitResult({
    unitId: data.unitId,
    unitSequenceId: data.unitSequenceId,
    level: data.level,
    storyNumber: data.storyNumber,
    date: data.unitDateTimeUtc || data.date,
    completion: toNumber(data.completion),
    accuracy: toNumber(data.accuracy),
    storyRead: toNumber(data.storyRead),
    recorded: toNumber(data.recorded)
  });
};

var StudentHomeworkDetailRecord = (0, _immutable.Record)({
  studentId: undefined,
  studentGeneralInfo: undefined,
  unitResults: new _immutable.List(),
  status: undefined,
  isInProduction: false
});

var StudentHomeworkDetail = function (_StudentHomeworkDetai) {
  _inherits(StudentHomeworkDetail, _StudentHomeworkDetai);

  function StudentHomeworkDetail() {
    _classCallCheck(this, StudentHomeworkDetail);

    return _possibleConstructorReturn(this, (StudentHomeworkDetail.__proto__ || Object.getPrototypeOf(StudentHomeworkDetail)).apply(this, arguments));
  }

  return StudentHomeworkDetail;
}(StudentHomeworkDetailRecord);

StudentHomeworkDetail.create = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var unitResults = Array.isArray(data.unitResults) ? new _immutable.List(data.unitResults.map(UnitResult.create)) : new _immutable.List();

  return new StudentHomeworkDetail({
    studentId: data.studentId,
    studentGeneralInfo: data.studentGeneralInfo || {},
    unitResults: unitResults,
    status: data.status,
    isInProduction: !!data.isInProduction
  });
};

exports.UnitResult = UnitResult;
exports.default = StudentHomeworkDetail;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWeekdayName = getWeekdayName;
exports.getWeekdayAbbr = getWeekdayAbbr;
var weekday = {
  0: {
    abbr: 'Sun',
    fullName: 'Sunday'
  },
  1: {
    abbr: 'Mon',
    fullName: 'Monday'
  },
  2: {
    abbr: 'Tue',
    fullName: 'Tuesday'
  },
  3: {
    abbr: 'Wed',
    fullName: 'Wednesday'
  },
  4: {
    abbr: 'Thu',
    fullName: 'Thursday'
  },
  5: {
    abbr: 'Fri',
    fullName: 'Friday'
  },
  6: {
    abbr: 'Sat',
    fullName: 'Saturday'
  }
};

function getWeekdayName(i) {
  return weekday['' + i % 7].fullName;
}

function getWeekdayAbbr(i) {
  return weekday['' + i % 7].abbr;
}

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1605);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(10);

var _omniCommonUi = __webpack_require__(0);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _UnitResources = __webpack_require__(699);

var _accessors = __webpack_require__(195);

var _grayCircle = __webpack_require__(1609);

var _grayCircle2 = _interopRequireDefault(_grayCircle);

var _greenTick = __webpack_require__(1610);

var _greenTick2 = _interopRequireDefault(_greenTick);

var _yellowTick = __webpack_require__(1611);

var _yellowTick2 = _interopRequireDefault(_yellowTick);

var _lateClock = __webpack_require__(1612);

var _lateClock2 = _interopRequireDefault(_lateClock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOURCE_TYPES = _UnitResources.ResourceColumnOrder;

var FILTERS = [{
  key: 'all',
  label: 'All',
  types: RESOURCE_TYPES,
  tooltip: null
}, {
  key: 'listening',
  label: 'Listening & Understanding',
  types: [_UnitResources.ResourceTypes.StoryVideo, _UnitResources.ResourceTypes.Songs],
  tooltip: 'Students occasionally watches story videos or song videos, which provide helpful ' + 'listening input, but usage is not yet consistent.'
}, {
  key: 'reading',
  label: 'Reading & Speaking Confidence',
  types: [_UnitResources.ResourceTypes.UnitReader, _UnitResources.ResourceTypes.ChallengeReader],
  tooltip: 'Unit readers and recording tasks are used infrequently. As a result, opportunities ' + 'to practice reading aloud and speaking at home are limited.'
}, {
  key: 'pronunciation',
  label: 'Pronunciation & Phonics',
  types: [_UnitResources.ResourceTypes.PhonicsReader, _UnitResources.ResourceTypes.PhonicsVideo],
  tooltip: 'Phonics videos and readers are available but not regularly used. These resources ' + 'are especially helpful for improving pronunciation at this age.'
}, {
  key: 'vocabulary',
  label: 'Vocabulary & Creative Use',
  types: [_UnitResources.ResourceTypes.VocabularyPlayPart1, _UnitResources.ResourceTypes.VocabularyPlayPart2],
  tooltip: 'Vocabulary or creative project - style activities are rarely explored. ' + 'These activities are designed to make word practice more fun and active.'
}];

var UnitResources = function (_Component) {
  _inherits(UnitResources, _Component);

  function UnitResources(props) {
    _classCallCheck(this, UnitResources);

    var _this = _possibleConstructorReturn(this, (UnitResources.__proto__ || Object.getPrototypeOf(UnitResources)).call(this, props));

    _this.state = { activeFilterKey: 'all' };
    return _this;
  }

  _createClass(UnitResources, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._fetchIfNeeded(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.unitId !== this.props.unitId) {
        this._fetchIfNeeded(nextProps);
      }
    }
  }, {
    key: '_fetchIfNeeded',
    value: function _fetchIfNeeded(props) {
      var groupId = props.groupId,
          unitId = props.unitId;

      if (groupId && unitId) {
        props.fetchUnitResourcesIfNeeded(groupId, unitId);
      }
    }
  }, {
    key: '_getActiveFilter',
    value: function _getActiveFilter() {
      var _this2 = this;

      return FILTERS.find(function (filter) {
        return filter.key === _this2.state.activeFilterKey;
      }) || FILTERS[0];
    }
  }, {
    key: '_getVisibleTypes',
    value: function _getVisibleTypes() {
      var activeFilter = this._getActiveFilter();
      return RESOURCE_TYPES.filter(function (type) {
        return activeFilter.types.indexOf(type) !== -1;
      });
    }
  }, {
    key: '_onFilterClick',
    value: function _onFilterClick(filterKey) {
      this.setState({ activeFilterKey: filterKey });
    }
  }, {
    key: '_renderFilterButtons',
    value: function _renderFilterButtons() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { className: _style2.default.UnitResources_filters },
        FILTERS.map(function (filter) {
          var isActive = filter.key === _this3.state.activeFilterKey;
          var buttonClass = isActive ? _style2.default.UnitResources_filterBtn + ' ' + _style2.default.UnitResources_filterBtnActive : _style2.default.UnitResources_filterBtn;
          var button = _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: buttonClass,
              onClick: function onClick() {
                return _this3._onFilterClick(filter.key);
              } },
            filter.label
          );

          if (!filter.tooltip) {
            return _react2.default.createElement(
              'span',
              { key: filter.key },
              button
            );
          }

          return _react2.default.createElement(
            _omniCommonUi.Tooltip,
            {
              key: filter.key,
              text: filter.tooltip,
              placement: 'bottom',
              trigger: ['hover'],
              className: _style2.default.UnitResources_filterTooltip,
              overlayClassName: _style2.default.UnitResources_filterTooltip_inner },
            button
          );
        })
      );
    }
  }, {
    key: '_renderDash',
    value: function _renderDash() {
      return _react2.default.createElement(
        'span',
        { className: _style2.default.UnitResources_dash },
        '\u2013'
      );
    }
  }, {
    key: '_renderIcon',
    value: function _renderIcon(src, alt) {
      return _react2.default.createElement('img', { className: _style2.default.UnitResources_icon, src: src, alt: alt });
    }
  }, {
    key: '_renderSingleIconCell',
    value: function _renderSingleIconCell(resource) {
      switch (resource.status) {
        case _UnitResources.ResourceStatus.Completed:
          return this._renderIcon(_greenTick2.default, 'Completed');
        case _UnitResources.ResourceStatus.CompletedLate:
          return _react2.default.createElement(
            _omniCommonUi.Tooltip,
            { text: 'Completed late', placement: 'top', trigger: ['hover'] },
            _react2.default.createElement(
              'span',
              { className: _style2.default.UnitResources_lateCell },
              this._renderIcon(_lateClock2.default, 'Completed late'),
              this._renderIcon(_yellowTick2.default, 'Completed late')
            )
          );
        case _UnitResources.ResourceStatus.NotStarted:
        default:
          return this._renderIcon(_grayCircle2.default, 'Not started');
      }
    }
  }, {
    key: '_renderProgressCell',
    value: function _renderProgressCell(resource) {
      var isComplete = resource.status === _UnitResources.ResourceStatus.Completed || resource.status === _UnitResources.ResourceStatus.CompletedLate;
      var completionIcon = this._renderIcon(_greenTick2.default, 'Completed');
      if (resource.status === _UnitResources.ResourceStatus.CompletedLate) {
        completionIcon = this._renderSingleIconCell(resource);
      }
      return _react2.default.createElement(
        'span',
        { className: _style2.default.UnitResources_progressCell },
        _react2.default.createElement(
          'span',
          { className: _style2.default.UnitResources_progress },
          resource.progress
        ),
        _react2.default.createElement(
          'span',
          { className: _style2.default.UnitResources_progressTotal },
          '/' + resource.totalProgress
        ),
        isComplete && completionIcon
      );
    }
  }, {
    key: '_renderChallengeReaderCell',
    value: function _renderChallengeReaderCell(resource) {
      var isCompleted = resource.status === _UnitResources.ResourceStatus.Completed || resource.status === _UnitResources.ResourceStatus.CompletedLate;
      var hasExtraCount = isCompleted && resource.extraCount > 0;
      var challengeCellClassName = hasExtraCount ? _style2.default.UnitResources_challengeCell + ' ' + _style2.default.UnitResources_challengeCellWithExtra : _style2.default.UnitResources_challengeCell;
      var completionIcon = this._renderIcon(_greenTick2.default, 'Completed');
      if (resource.status === _UnitResources.ResourceStatus.CompletedLate) {
        completionIcon = this._renderSingleIconCell(resource);
      }
      var cell = _react2.default.createElement(
        'span',
        { className: challengeCellClassName },
        hasExtraCount && _react2.default.createElement(
          'span',
          { className: _style2.default.UnitResources_extra },
          '+' + resource.extraCount
        ),
        isCompleted ? completionIcon : this._renderIcon(_grayCircle2.default, 'Not started')
      );

      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        {
          className: _style2.default.UnitResources_challengeTooltip,
          text: 'Total ' + resource.readCount + '/' + resource.totalBooks,
          placement: 'top',
          trigger: ['hover'] },
        cell
      );
    }
  }, {
    key: '_renderResourceCell',
    value: function _renderResourceCell(resourceType, resources) {
      var resource = resources && resources.get(resourceType);
      if (!resource) {
        return this._renderDash();
      }

      switch ((0, _UnitResources.getResourceDisplayCategory)(resourceType)) {
        case _UnitResources.ResourceDisplayCategory.Progress:
          return this._renderProgressCell(resource);
        case _UnitResources.ResourceDisplayCategory.ChallengeReader:
          return this._renderChallengeReaderCell(resource);
        case _UnitResources.ResourceDisplayCategory.SingleIcon:
        default:
          return this._renderSingleIconCell(resource);
      }
    }
  }, {
    key: '_renderTable',
    value: function _renderTable(members, visibleTypes) {
      var _this4 = this;

      var rows = members ? members.toArray() : [];

      return _react2.default.createElement(
        _CourseViewTable2.default,
        { students: rows, onlyRowDivider: true },
        _react2.default.createElement(
          _CourseViewTable2.default.Header,
          null,
          _react2.default.createElement(
            _CourseViewTable2.default.Row,
            null,
            visibleTypes.map(function (type) {
              return _react2.default.createElement(
                _CourseViewTable2.default.Cell,
                { key: type, columnId: type, small: true },
                _UnitResources.ResourceLabels[type]
              );
            })
          )
        ),
        _react2.default.createElement(
          _CourseViewTable2.default.Body,
          null,
          function (member, columnId) {
            return _this4._renderResourceCell(columnId, _this4.props.resourcesByStudentId[member.studentGeneralInfo.id]);
          }
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          members = _props.members,
          isLoading = _props.isLoading;

      var visibleTypes = this._getVisibleTypes();
      var hasMembers = members && members.size > 0;

      return _react2.default.createElement(
        'div',
        { className: _style2.default.UnitResources + ' ' + (0, _omniCommonUi.testClass)('unit-resources') },
        this._renderFilterButtons(),
        !hasMembers && !isLoading ? _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            null,
            _react2.default.createElement(
              'div',
              { className: _style2.default.UnitResources_empty },
              'No Results.'
            )
          )
        ) : _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.UnitResources_content },
            this._renderTable(members, visibleTypes)
          )
        )
      );
    }
  }]);

  return UnitResources;
}(_react.Component);

UnitResources.propTypes = {
  groupId: _propTypes2.default.string,
  unitId: _propTypes2.default.string,
  members: _propTypes2.default.object,
  resourcesByStudentId: _propTypes2.default.object,
  isLoading: _propTypes2.default.bool,
  fetchUnitResourcesIfNeeded: _propTypes2.default.func.isRequired
};

UnitResources.defaultProps = {
  resourcesByStudentId: {}
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      unitId = _ownProps$params.unitId;

  var members = (0, _accessors.getMembersByGroup)(state, groupId);
  var isLoading = _UnitResources.accessors.isLoadingUnitResources(state, groupId, unitId);
  var studentResources = _UnitResources.accessors.getUnitResources(state, groupId, unitId);

  var resourcesByStudentId = {};
  studentResources.forEach(function (student) {
    resourcesByStudentId[student.studentId] = student.resources;
  });

  return { groupId: groupId, unitId: unitId, members: members, resourcesByStudentId: resourcesByStudentId, isLoading: isLoading };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    fetchUnitResourcesIfNeeded: _UnitResources.actions.fetchUnitResourcesIfNeeded
  }, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(UnitResources);

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResourceDisplayCategory = exports.ResourceDisplayCategory = exports.ResourceColumnOrder = exports.ResourceStatus = exports.ResourceLabels = exports.ResourceTypes = exports.ResourceResult = exports.StudentUnitResources = exports.reducer = exports.actions = exports.accessors = undefined;

var _accessors2 = __webpack_require__(1607);

var _accessors = _interopRequireWildcard(_accessors2);

var _actions2 = __webpack_require__(700);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1608);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(315);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var accessors = exports.accessors = _accessors;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var StudentUnitResources = exports.StudentUnitResources = _model2.default;
var ResourceResult = exports.ResourceResult = _model.ResourceResult;
var ResourceTypes = exports.ResourceTypes = _model.ResourceTypes;
var ResourceLabels = exports.ResourceLabels = _model.ResourceLabels;
var ResourceStatus = exports.ResourceStatus = _model.ResourceStatus;
var ResourceColumnOrder = exports.ResourceColumnOrder = _model.ResourceColumnOrder;
var ResourceDisplayCategory = exports.ResourceDisplayCategory = _model.ResourceDisplayCategory;
var getResourceDisplayCategory = exports.getResourceDisplayCategory = _model.getResourceDisplayCategory;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_UNIT_RESOURCES_FAILURE = exports.FETCH_UNIT_RESOURCES_SUCCESS = exports.FETCH_UNIT_RESOURCES_REQUEST = undefined;
exports.fetchUnitResourcesIfNeeded = fetchUnitResourcesIfNeeded;
exports.fetchUnitResources = fetchUnitResources;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_UNIT_RESOURCES_REQUEST = exports.FETCH_UNIT_RESOURCES_REQUEST = 'FETCH_UNIT_RESOURCES_REQUEST';
var FETCH_UNIT_RESOURCES_SUCCESS = exports.FETCH_UNIT_RESOURCES_SUCCESS = 'FETCH_UNIT_RESOURCES_SUCCESS';
var FETCH_UNIT_RESOURCES_FAILURE = exports.FETCH_UNIT_RESOURCES_FAILURE = 'FETCH_UNIT_RESOURCES_FAILURE';

var method = 'GET';
var buildUnitResourcesUrl = function buildUnitResourcesUrl(groupId, unitId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/units/' + unitId + '/app-resources');
};

function fetchUnitResourcesIfNeeded(groupId, unitId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, {
      method: method,
      url: buildUnitResourcesUrl(groupId, unitId)
    })) {
      return false;
    }

    return dispatch(fetchUnitResources(groupId, unitId));
  };
}

function fetchUnitResources(groupId, unitId) {
  return function (dispatch) {
    var url = buildUnitResourcesUrl(groupId, unitId);
    var payload = (0, _Api.fetch)(url);

    return dispatch(fetchUnitResourcesRequest()).payload.then(function (response) {
      return dispatch(fetchUnitResourcesSuccess(response));
    }).catch(function (error) {
      if (error.response && error.response.code === 404) {
        return dispatch(fetchUnitResourcesSuccess({ unitId: unitId, students: [] }));
      }

      return dispatch(fetchUnitResourcesFailure(error));
    });

    function fetchUnitResourcesRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_UNIT_RESOURCES_REQUEST,
        payload: payload,
        url: url,
        method: method,
        groupId: groupId,
        unitId: unitId
      });
    }

    function fetchUnitResourcesSuccess(successPayload) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_UNIT_RESOURCES_SUCCESS,
        payload: successPayload,
        url: url,
        method: method,
        groupId: groupId,
        unitId: unitId
      });
    }

    function fetchUnitResourcesFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_UNIT_RESOURCES_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId,
        unitId: unitId
      });
    }
  };
}

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = exports.StudentUnitQuizResult = undefined;

var _model = __webpack_require__(702);

var _model2 = _interopRequireDefault(_model);

var _actions2 = __webpack_require__(706);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1622);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudentUnitQuizResult = exports.StudentUnitQuizResult = _model2.default;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(703);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1617);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentUnitQuizResultRecord = _immutable2.default.Record({
  studentId: undefined,
  unitQuizResults: undefined
});

var StudentUnitQuizResult = function (_StudentUnitQuizResul) {
  _inherits(StudentUnitQuizResult, _StudentUnitQuizResul);

  function StudentUnitQuizResult() {
    _classCallCheck(this, StudentUnitQuizResult);

    return _possibleConstructorReturn(this, (StudentUnitQuizResult.__proto__ || Object.getPrototypeOf(StudentUnitQuizResult)).apply(this, arguments));
  }

  return StudentUnitQuizResult;
}(StudentUnitQuizResultRecord);

exports.default = StudentUnitQuizResult;

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitQuizResultRecord = _immutable2.default.Record({
  unitId: undefined,
  totalScore: undefined,
  skillResults: undefined
});

var UnitQuizResult = function (_UnitQuizResultRecord) {
  _inherits(UnitQuizResult, _UnitQuizResultRecord);

  function UnitQuizResult() {
    _classCallCheck(this, UnitQuizResult);

    return _possibleConstructorReturn(this, (UnitQuizResult.__proto__ || Object.getPrototypeOf(UnitQuizResult)).apply(this, arguments));
  }

  return UnitQuizResult;
}(UnitQuizResultRecord);

exports.default = UnitQuizResult;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitQuizSkillResultRecord = _immutable2.default.Record({
  skill: undefined,
  score: undefined,
  totalScore: undefined
});

var UnitQuizSkillResult = function (_UnitQuizSkillResultR) {
  _inherits(UnitQuizSkillResult, _UnitQuizSkillResultR);

  function UnitQuizSkillResult() {
    _classCallCheck(this, UnitQuizSkillResult);

    return _possibleConstructorReturn(this, (UnitQuizSkillResult.__proto__ || Object.getPrototypeOf(UnitQuizSkillResult)).apply(this, arguments));
  }

  return UnitQuizSkillResult;
}(UnitQuizSkillResultRecord);

exports.default = UnitQuizSkillResult;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_UNIT_QUIZ_RESULTS_FAILURE = exports.FETCH_UNIT_QUIZ_RESULTS_SUCCESS = exports.FETCH_UNIT_QUIZ_RESULTS_REQUEST = undefined;
exports.fetchUnitQuizResultsIfNeeded = fetchUnitQuizResultsIfNeeded;
exports.fetchUnitQuizResultsContent = fetchUnitQuizResultsContent;

var _omniCommonUi = __webpack_require__(0);

var _Api = __webpack_require__(11);

var FETCH_UNIT_QUIZ_RESULTS_REQUEST = exports.FETCH_UNIT_QUIZ_RESULTS_REQUEST = 'FETCH_UNIT_QUIZ_RESULTS_REQUEST';
var FETCH_UNIT_QUIZ_RESULTS_SUCCESS = exports.FETCH_UNIT_QUIZ_RESULTS_SUCCESS = 'FETCH_UNIT_QUIZ_RESULTS_SUCCESS';
var FETCH_UNIT_QUIZ_RESULTS_FAILURE = exports.FETCH_UNIT_QUIZ_RESULTS_FAILURE = 'FETCH_UNIT_QUIZ_RESULTS_FAILURE';

var buildUnitQuizResultsUrl = function buildUnitQuizResultsUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/unit-quiz-results');
};

function fetchUnitQuizResultsIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildUnitQuizResultsUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchUnitQuizResultsContent(groupId));
  };
}

function fetchUnitQuizResultsContent(groupId) {
  return function (dispatch) {
    var url = buildUnitQuizResultsUrl(groupId);
    var method = 'GET';

    return dispatch(fetchUnitQuizResultsRequest()).payload.then(function (response) {
      return dispatch(fetchUnitQuizResultsSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchUnitQuizResultsFailure(error));
    });

    function fetchUnitQuizResultsRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_UNIT_QUIZ_RESULTS_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchUnitQuizResultsSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_UNIT_QUIZ_RESULTS_SUCCESS,
        payload: response,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchUnitQuizResultsFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_UNIT_QUIZ_RESULTS_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Homework = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(708);

var _style2 = _interopRequireDefault(_style);

var _redux = __webpack_require__(10);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(15);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _ = __webpack_require__(13);

var _SessionPlans = __webpack_require__(44);

var _routes = __webpack_require__(709);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Homework = exports.Homework = function (_Component) {
  _inherits(Homework, _Component);

  function Homework() {
    _classCallCheck(this, Homework);

    return _possibleConstructorReturn(this, (Homework.__proto__ || Object.getPrototypeOf(Homework)).apply(this, arguments));
  }

  _createClass(Homework, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.fetchSessionPlansIfNeeded(this.props.groupId);
      this._redirectByCourseType(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._redirectByCourseType(nextProps);
    }
  }, {
    key: '_redirectByCourseType',
    value: function _redirectByCourseType(props) {
      if (!props.location.pathname.endsWith('homework')) return;
      if (_is_js2.default.undefined(props.firstTabByCourseType)) return;
      this._redirectTo(props.firstTabByCourseType);
    }
  }, {
    key: '_redirectTo',
    value: function _redirectTo(pathname) {
      this.props.replacehRoute(this.props.buildRoute('/group/' + this.props.groupId + '/homework/' + pathname));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _style2.default.Homework },
        _react2.default.createElement(
          'div',
          { className: _style2.default.Homework_wrapper },
          this.props.children
        )
      );
    }
  }]);

  return Homework;
}(_react.Component);

Homework.propTypes = {
  groupId: _propTypes2.default.string,
  isHFCourseTypeGroup: _propTypes2.default.string,
  firstTabByCourseType: _propTypes2.default.string,
  isSSV3HomeworkTab: _propTypes2.default.func,
  isPracticePlayTab: _propTypes2.default.func,
  children: _propTypes2.default.node,
  fetchSessionPlansIfNeeded: _propTypes2.default.func,
  replacehRoute: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var isHFCourseTypeGroup = _.actions.isHFCourseTypeGroup(state, groupId);
  var firstTabByCourseType = (0, _routes.getCourseTypeFirstTab)(state, groupId);

  return {
    groupId: groupId,
    isHFCourseTypeGroup: isHFCourseTypeGroup,
    firstTabByCourseType: firstTabByCourseType
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ replacehRoute: function replacehRoute(path) {
      return dispatch((0, _reactRouterRedux.replace)(path));
    } }, (0, _redux.bindActionCreators)(_SessionPlans.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(Homework);

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1624);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VOCABULARY = exports.READING = exports.UNIT_QUIZ = exports.SMALL_STARS_APP = exports.ONLINE_USAGE = exports.PRACTICE_PLAY = exports.ONLINE = exports.TRAILBLAZERS_APP = undefined;

var _TAB_MODULE_MAPPING;

exports.getCourseTypeFirstTab = getCourseTypeFirstTab;

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _component = __webpack_require__(707);

var _component2 = _interopRequireDefault(_component);

var _Mentor = __webpack_require__(1625);

var _StudentApp = __webpack_require__(1629);

var _PracticePlay = __webpack_require__(1641);

var _OnlineUsage = __webpack_require__(1646);

var _UnitQuiz = __webpack_require__(1654);

var _Reader = __webpack_require__(1656);

var _Vocabulary = __webpack_require__(1665);

var _PaperBased = __webpack_require__(1672);

var _PaperBased2 = _interopRequireDefault(_PaperBased);

var _SessionPlans = __webpack_require__(44);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TRAILBLAZERS_APP = exports.TRAILBLAZERS_APP = 'trailblazers-app';
var MENTOR = 'mentor';
var PAPER_BASE = 'paper-based';
var ONLINE = exports.ONLINE = 'online';
var PRACTICE_PLAY = exports.PRACTICE_PLAY = 'practice-play';
var ONLINE_USAGE = exports.ONLINE_USAGE = 'online-usage';
var SMALL_STARS_APP = exports.SMALL_STARS_APP = 'small-stars-app';
var UNIT_QUIZ = exports.UNIT_QUIZ = 'unit-quiz';
var READING = exports.READING = 'reading';
var VOCABULARY = exports.VOCABULARY = 'vocabulary';

var TAB_MODULE_MAPPING = (_TAB_MODULE_MAPPING = {}, _defineProperty(_TAB_MODULE_MAPPING, TRAILBLAZERS_APP, _TabSwitcher.TabCodes.TrailblazersApp), _defineProperty(_TAB_MODULE_MAPPING, MENTOR, _TabSwitcher.TabCodes.Mentor), _defineProperty(_TAB_MODULE_MAPPING, PAPER_BASE, _TabSwitcher.TabCodes.PaperBased), _defineProperty(_TAB_MODULE_MAPPING, ONLINE, _TabSwitcher.TabCodes.Online), _defineProperty(_TAB_MODULE_MAPPING, PRACTICE_PLAY, _TabSwitcher.TabCodes.PracticePlay), _defineProperty(_TAB_MODULE_MAPPING, ONLINE_USAGE, _TabSwitcher.TabCodes.OnlineUsage), _defineProperty(_TAB_MODULE_MAPPING, SMALL_STARS_APP, _TabSwitcher.TabCodes.SmallStarsApp), _defineProperty(_TAB_MODULE_MAPPING, UNIT_QUIZ, _TabSwitcher.TabCodes.UnitQuiz), _defineProperty(_TAB_MODULE_MAPPING, READING, _TabSwitcher.TabCodes.Reader), _defineProperty(_TAB_MODULE_MAPPING, VOCABULARY, _TabSwitcher.TabCodes.Vocabulary), _TAB_MODULE_MAPPING);

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    appBars: {
      sticky: {
        'view-nav': {
          component: _ViewNav2.default,
          order: 2,
          props: {
            hideExpandable: true
          }
        }
      }
    },
    path: 'homework',
    component: _component2.default,
    canAccess: function canAccess(_ref2) {
      var params = _ref2.params;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.Homework.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.MarkHomework);
    },
    indexRoute: {
      isVisible: function isVisible() {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.Homework.View);
      }
    },
    breadcrumbLabels: {
      label: 'Practice',
      clickable: false
    },
    tab: {
      label: 'Digital Practice Results',
      order: 3,
      isVisible: function isVisible(params) {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.Homework.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.MarkHomework);
      }
    },
    secondLevelTabs: function secondLevelTabs(props) {
      var groupId = props.params.groupId;

      var currentCourseTypeTabs = getTabsByCourseType(getState(), groupId);
      return getSecondLevelTabs(getState(), groupId, props, currentCourseTypeTabs);
    },
    childRoutes: [_StudentApp.routes, _OnlineUsage.routes, _Mentor.routes, _PaperBased2.default, _PracticePlay.routes, _UnitQuiz.routes, _Reader.routes, _Vocabulary.routes]
  };
};

function getTabsByCourseType(state, groupId) {
  var courseTypeTabs = [];
  if (_.actions.isTBCourseTypeGroup(state, groupId)) {
    if (_.actions.hasContentPath(state, groupId)) {
      courseTypeTabs.push(TRAILBLAZERS_APP, READING, VOCABULARY, MENTOR);
    } else {
      courseTypeTabs.push(TRAILBLAZERS_APP, MENTOR);
    }
  }
  if (_.actions.isHFCourseTypeGroup(state, groupId)) {
    if (_.actions.hasContentPath(state, groupId)) {
      courseTypeTabs.push(ONLINE, READING, VOCABULARY, PAPER_BASE);
    } else {
      courseTypeTabs.push(ONLINE, PAPER_BASE);
    }
  }
  if (_.actions.isSSCourseTypeGroup(state, groupId)) {
    if (_.actions.hasContentPath(state, groupId)) {
      courseTypeTabs.push(PRACTICE_PLAY, SMALL_STARS_APP, READING, VOCABULARY, PAPER_BASE, UNIT_QUIZ);
    } else {
      courseTypeTabs.push(PRACTICE_PLAY, SMALL_STARS_APP, PAPER_BASE, UNIT_QUIZ);
    }
  }
  if (_.actions.isFRCourseTypeGroup(state, groupId)) {
    if (_.actions.hasContentPath(state, groupId)) {
      courseTypeTabs.push(ONLINE, VOCABULARY);
    } else {
      courseTypeTabs.push(ONLINE_USAGE);
    }
  }
  return courseTypeTabs;
}

function filterEnabledTabs(state, groupId, tabs) {
  return tabs.filter(function (tab) {
    return _TabSwitcher2.default.isTabEnabled(state, groupId, TAB_MODULE_MAPPING[tab]);
  });
}

function getCourseTypeFirstTab(state, groupId) {
  var currentCourseTypeTabs = getTabsByCourseType(state, groupId);
  return filterEnabledTabs(state, groupId, currentCourseTypeTabs)[0];
}

function getSecondLevelTabs(state, groupId, props, tabs) {
  var enabledTabs = filterEnabledTabs(state, groupId, tabs);
  var secondLevelTabs = enabledTabs.map(function (tab) {
    return getSecondLevelTab(state, props, tab);
  });
  if (secondLevelTabs.length < 2) return;
  return secondLevelTabs;
}

function getSecondLevelTab(state, _ref3, type) {
  var pathname = _ref3.location.pathname,
      buildRoute = _ref3.buildRoute,
      push = _ref3.push,
      params = _ref3.params;

  switch (type) {
    case TRAILBLAZERS_APP:
    case ONLINE:
    case MENTOR:
    case PRACTICE_PLAY:
    case SMALL_STARS_APP:
    case ONLINE_USAGE:
    case UNIT_QUIZ:
    case READING:
    case VOCABULARY:
      return {
        text: getHomeworkTabName(type),
        onClick: function onClick() {
          return push(buildRoute('/group/:groupId/homework/' + type, params));
        },
        isActive: pathname.indexOf(type) > 0
      };
    case PAPER_BASE:
      return {
        text: type,
        onClick: function onClick() {
          var groupId = params.groupId;

          var defaultSessionId = getPreviousSessionId(state, groupId);
          return push(buildRoute('/group/:groupId/homework/session/:sessionId/unit/:unitId/' + type, Object.assign({}, params, {
            sessionId: defaultSessionId,
            unitId: _SessionPlans.accessors.getFirstUnitOfSession(state, defaultSessionId)
          })));
        },
        isActive: pathname.indexOf(type) > 0
      };
    default:
      break;
  }
}

function getPreviousSessionId(state, groupId) {
  return _SessionPlans.accessors.getPreviousSession(state, groupId).id;
}

function getHomeworkTabName(type) {
  switch (type) {
    case PRACTICE_PLAY:
      return 'practice & play';
    case SMALL_STARS_APP:
      return 'ef small stars app';
    case TRAILBLAZERS_APP:
      return 'ef trailblazers app';
    case ONLINE_USAGE:
      return 'online usage';
    case UNIT_QUIZ:
      return 'small stars app quiz';
    default:
      return type;
  }
}

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MentorTable = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _omniCommonUi = __webpack_require__(0);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _Mentor = __webpack_require__(711);

var _GroupMembers = __webpack_require__(14);

var _SessionPlans = __webpack_require__(44);

var _accessors = __webpack_require__(41);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NOT_APPLICABLE = 'N/A';
var LOADING = '…';

var COLUMN_ASSIGNED = 'assigned';
var COLUMN_MASTERED = 'mastered';
var COLUMN_STUDYING = 'studying';

var MentorTable = exports.MentorTable = function (_Component) {
  _inherits(MentorTable, _Component);

  function MentorTable() {
    _classCallCheck(this, MentorTable);

    return _possibleConstructorReturn(this, (MentorTable.__proto__ || Object.getPrototypeOf(MentorTable)).apply(this, arguments));
  }

  _createClass(MentorTable, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.fetchMentorIfNeeded(this.props.groupId);
    }
  }, {
    key: '_getHighlightedColumns',
    value: function _getHighlightedColumns() {
      var _props = this.props,
          units = _props.units,
          defaultUnitId = _props.defaultUnitId;

      var defaultUnitIndex = units.toList().findIndex(function (unit) {
        return unit.id === defaultUnitId;
      }) * 3;
      if (defaultUnitIndex < 0) {
        return undefined;
      }

      return [defaultUnitIndex, defaultUnitIndex + 1, defaultUnitIndex + 2];
    }
  }, {
    key: '_renderScore',
    value: function _renderScore(score) {
      return _is_js2.default.undefined(score) ? NOT_APPLICABLE : score;
    }
  }, {
    key: '_renderUndefinedScore',
    value: function _renderUndefinedScore() {
      return this.props.isLoading ? NOT_APPLICABLE : LOADING;
    }
  }, {
    key: '_renderCell',
    value: function _renderCell(member, unit, column) {
      var _props2 = this.props,
          groupId = _props2.groupId,
          mentor = _props2.mentor;

      var memberMentorInfo = _is_js2.default.not.undefined(mentor) && _is_js2.default.not.undefined(mentor.data) && mentor.data.get(groupId + '-' + unit.id + '-' + member.studentGeneralInfo.id);

      if (!memberMentorInfo) {
        return LOADING;
      }

      switch (column) {
        case COLUMN_ASSIGNED:
          return this._renderScore(memberMentorInfo.wordsAssigned);
        case COLUMN_MASTERED:
          return this._renderScore(memberMentorInfo.wordsMastered);
        case COLUMN_STUDYING:
          return this._renderScore(memberMentorInfo.wordsStudying);
        default:
          throw new Error('Invalid column ' + column);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          units = _props3.units,
          members = _props3.members;

      if (!units) return null;
      return _react2.default.createElement(
        _CourseViewTable2.default,
        { students: members, highlightedColumns: this._getHighlightedColumns() },
        _react2.default.createElement(
          _CourseViewTable2.default.Header,
          null,
          _react2.default.createElement(
            _CourseViewTable2.default.Row,
            null,
            units.map(function (unit) {
              return _react2.default.createElement(
                _CourseViewTable2.default.Cell,
                { colSpan: 3, small: true },
                unit.name
              );
            })
          ),
          _react2.default.createElement(
            _CourseViewTable2.default.Row,
            null,
            units.map(function (unit) {
              return [_react2.default.createElement(
                _CourseViewTable2.default.Cell,
                { columnId: { unit: unit, column: COLUMN_ASSIGNED }, small: true },
                'Words Assigned'
              ), _react2.default.createElement(
                _CourseViewTable2.default.Cell,
                { columnId: { unit: unit, column: COLUMN_MASTERED }, small: true },
                'Words Mastered'
              ), _react2.default.createElement(
                _CourseViewTable2.default.Cell,
                { columnId: { unit: unit, column: COLUMN_STUDYING }, small: true },
                'Words Studying'
              )];
            })
          )
        ),
        _react2.default.createElement(
          _CourseViewTable2.default.Body,
          null,
          function (member, _ref) {
            var unit = _ref.unit,
                column = _ref.column;
            return _this2._renderCell(member, unit, column);
          }
        )
      );
    }
  }]);

  return MentorTable;
}(_react.Component);

MentorTable.propTypes = {
  defaultUnitId: _propTypes2.default.string.isRequired,
  groupId: _propTypes2.default.string.isRequired,
  units: _propTypes2.default.instanceOf(_immutable.OrderedMap).isRequired,
  mentor: _propTypes2.default.shape().isRequired,
  members: _propTypes2.default.instanceOf(_immutable.List).isRequired,
  fetchMentorIfNeeded: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool.isRequired
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var defaultSession = _SessionPlans.actions.getDefaultSession(state, groupId);
  var defaultUnitId = '' + defaultSession.unitIds[0];
  var units = (0, _accessors.getUnitList)(state, groupId);
  var mentor = state.get('rootReducer').get('mentor');
  return {
    defaultUnitId: defaultUnitId,
    groupId: groupId,
    units: units,
    mentor: mentor,
    members: members,
    isLoading: _Mentor.actions.isLoading(state, groupId)
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_Mentor.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(MentorTable);

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mentor = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(712);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1626);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(713);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var Mentor = exports.Mentor = _model2.default;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_MENTOR_FAILURE = exports.FETCH_MENTOR_SUCCESS = exports.FETCH_MENTOR_REQUEST = undefined;
exports.fetchMentorIfNeeded = fetchMentorIfNeeded;
exports.isLoading = isLoading;
exports.fetchMentor = fetchMentor;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_MENTOR_REQUEST = exports.FETCH_MENTOR_REQUEST = 'FETCH_MENTOR_REQUEST';
var FETCH_MENTOR_SUCCESS = exports.FETCH_MENTOR_SUCCESS = 'FETCH_MENTOR_SUCCESS';
var FETCH_MENTOR_FAILURE = exports.FETCH_MENTOR_FAILURE = 'FETCH_MENTOR_FAILURE';

var buildMentorUrl = function buildMentorUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/mentor-results');
};
var method = 'GET';

function fetchMentorIfNeeded(groupId) {
  return function (dispatch, getState) {
    if (!_omniCommonUi.ApiCall.shouldPerform(getState(), { method: method, url: buildMentorUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchMentor(groupId));
  };
}

function isLoading(state, groupId) {
  var apiState = _omniCommonUi.ApiCall.find(state, { method: method, url: buildMentorUrl(groupId) });
  return _omniCommonUi.ApiCall.State.isValue(apiState) && _omniCommonUi.ApiCall.State.isLoading(apiState);
}

function fetchMentor(groupId) {
  return function (dispatch) {
    var url = buildMentorUrl(groupId);
    return dispatch(fetchMentorRequest()).payload.then(function (response) {
      return dispatch(fetchMentorSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchMentorFailure(error));
    });

    function fetchMentorRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_MENTOR_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchMentorSuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_MENTOR_SUCCESS,
        payload: payload,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchMentorFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_MENTOR_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Unit = undefined;

var _model = __webpack_require__(1627);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Unit = exports.Unit = _model2.default;

exports.default = Unit;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentApp = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _redux = __webpack_require__(10);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _style = __webpack_require__(1630);

var _style2 = _interopRequireDefault(_style);

var _OnlineHomework = __webpack_require__(208);

var _StudentTasks = __webpack_require__(310);

var _TotalPoint = __webpack_require__(715);

var _HFUsage = __webpack_require__(718);

var _GroupMembers = __webpack_require__(14);

var _ = __webpack_require__(13);

var _SessionPlans = __webpack_require__(44);

var _accessors = __webpack_require__(41);

var _style3 = __webpack_require__(708);

var _style4 = _interopRequireDefault(_style3);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _hfUsage = __webpack_require__(1639);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NOT_APPLICABLE = 'N/A';
var TOTAL_POINTS = 'total-points';
var DATE_FORMAT = 'YYYY-MM-DD';
var DEFAULT_CELL = '';

var StudentApp = exports.StudentApp = function (_Component) {
  _inherits(StudentApp, _Component);

  function StudentApp(props) {
    _classCallCheck(this, StudentApp);

    var _this = _possibleConstructorReturn(this, (StudentApp.__proto__ || Object.getPrototypeOf(StudentApp)).call(this, props));

    _this._setUpData(props);
    return _this;
  }

  _createClass(StudentApp, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          onlineHomeworks = _props.onlineHomeworks,
          groupId = _props.groupId,
          isTBCourseTypeGroup = _props.isTBCourseTypeGroup,
          isHFCourseTypeGroup = _props.isHFCourseTypeGroup,
          isTaskCompletionVisible = _props.isTaskCompletionVisible,
          hasContentPath = _props.hasContentPath;

      if (_omniCommonUi.ApiResponseHelper.shouldFetch(onlineHomeworks)) {
        this.props.fetchOnlineHomework(groupId);
      }
      if (isTBCourseTypeGroup) {
        this.props.fetchStudentTotalPoints(groupId);
      }

      if (isHFCourseTypeGroup && !hasContentPath) {
        this.props.fetchOnlineHomeworkHFUsage(groupId);
      }

      if (isTaskCompletionVisible) {
        this.props.fetchStudentTasksIfNeeded(groupId);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this._setUpData(props);
    }
  }, {
    key: '_setUpData',
    value: function _setUpData(props) {
      var sessions = props.sessions,
          onlineHomeworks = props.onlineHomeworks;

      if (!sessions || !sessions.data || !onlineHomeworks || !onlineHomeworks.data) {
        this._sessions = [];
        return;
      }

      this._setSessions(props);
      this._setHighlightedColumnsNo(props);
    }
  }, {
    key: '_setSessions',
    value: function _setSessions(_ref) {
      var sessions = _ref.sessions,
          onlineHomeworks = _ref.onlineHomeworks;

      this._sessions = onlineHomeworks.data.filter(function (homeworkBySession) {
        return sessions.data.some(function (session) {
          return session.id === homeworkBySession.sessionId;
        });
      }).map(function (homeworkBySession) {
        return sessions.data.find(function (session) {
          return homeworkBySession.sessionId === session.id;
        }).set('lessonNumber', homeworkBySession.lessonNumber).set('unitOrderingSequence', homeworkBySession.unitOrderingSequence);
      }).sort(this._sortSessions);
    }
  }, {
    key: '_sortSessions',
    value: function _sortSessions(a, b) {
      if (a.index !== b.index) return a.index - b.index;
      if (a.unitOrderingSequence !== b.unitOrderingSequence) {
        return a.unitOrderingSequence - b.unitOrderingSequence;
      }
      return a.lessonNumber - b.lessonNumber;
    }
  }, {
    key: '_setHighlightedColumnsNo',
    value: function _setHighlightedColumnsNo(_ref2) {
      var defaultSessionId = _ref2.defaultSessionId,
          hasTotalPoints = _ref2.hasTotalPoints,
          isTaskCompletionVisible = _ref2.isTaskCompletionVisible;

      var columnsPerSession = isTaskCompletionVisible ? 3 : 2;
      var firstIndexOfHighlightedColumn = this._sessions.findIndex(function (session) {
        return session.id === defaultSessionId;
      }) * columnsPerSession;
      var highlightedColumnSize = this._sessions.filter(function (session) {
        return session.id === defaultSessionId;
      }).size * columnsPerSession;
      this._highlightedColumns = [];
      for (var i = 0; i < highlightedColumnSize; i++) {
        this._highlightedColumns[i] = hasTotalPoints ? firstIndexOfHighlightedColumn + i + 1 : firstIndexOfHighlightedColumn + i;
      }
    }
  }, {
    key: '_renderScore',
    value: function _renderScore(score, category) {
      if (_is_js2.default.not.undefined(score) && _is_js2.default.existy(score[category])) {
        return score[category] + '%';
      }
      return NOT_APPLICABLE;
    }
  }, {
    key: '_renderTaskCompletion',
    value: function _renderTaskCompletion(session, studentId) {
      var studentTasks = this.props.studentTasks;

      if (!studentTasks || !studentTasks.data) {
        return NOT_APPLICABLE;
      }

      var tasksBySession = studentTasks.data.find(function (tasks) {
        return tasks.sessionId === session.id && tasks.lessonNumber === session.lessonNumber;
      });
      var taskByStudent = tasksBySession && tasksBySession.studentTaskResults.find(function (task) {
        return task.studentId === studentId;
      });
      if (!taskByStudent || _is_js2.default.not.existy(taskByStudent.completion)) {
        return NOT_APPLICABLE;
      }
      return taskByStudent.completion + '%';
    }
  }, {
    key: '_renderSessionNumbers',
    value: function _renderSessionNumbers() {
      var _props2 = this.props,
          groupId = _props2.groupId,
          defaultSessionId = _props2.defaultSessionId,
          hasTotalPoints = _props2.hasTotalPoints,
          isHFCourseTypeGroup = _props2.isHFCourseTypeGroup,
          isHFV4CourseTypeGroup = _props2.isHFV4CourseTypeGroup,
          isFRV2CourseTypeGroup = _props2.isFRV2CourseTypeGroup,
          isTaskCompletionVisible = _props2.isTaskCompletionVisible,
          hasContentPath = _props2.hasContentPath,
          games = _props2.games,
          onlineHomeworks = _props2.onlineHomeworks;


      var getClassName = function getClassName(className) {
        return (0, _classnames2.default)(_style4.default.Homework_innerTable_Th, className, (0, _omniCommonUi.testClass)('session-lesson-column'));
      };
      var classes = function classes(session) {
        return getClassName(_defineProperty({}, _style4.default.Homework_innerTable_active, session.id === defaultSessionId));
      };

      var cellItems = [];
      cellItems.push(this._sessions.map(function (session) {
        var sessionHomework = onlineHomeworks.data.find(function (homeworkBySession) {
          return homeworkBySession.sessionId === session.id && homeworkBySession.lessonNumber === session.lessonNumber;
        });
        var completedResults = sessionHomework.studentOnlineHomeworkResults.filter(function (r) {
          return !!r.completion;
        });
        var homeworkViewLink = void 0;
        if (isFRV2CourseTypeGroup) {
          var fr2ViewerBaseUrl = _omniCommonUi.Config.get('fr2OnlineHomeworkViewerUrl');

          if (completedResults.size > 0) {
            var studentIds = completedResults.map(function (r) {
              return r.studentId;
            }).join(',');
            homeworkViewLink = fr2ViewerBaseUrl + '/?entrance=hw&students=' + studentIds + '&contentPath=' + sessionHomework.onlineHomeworkKey;
          } else {
            homeworkViewLink = fr2ViewerBaseUrl + '/?entrance=hw&contentPath=' + sessionHomework.onlineHomeworkKey;
          }
        } else if (isHFV4CourseTypeGroup) {
          var hf4ViewerBaseUrl = _omniCommonUi.Config.get('hf4OnlineHomeworkViewerUrl');
          homeworkViewLink = hf4ViewerBaseUrl + '/?type=hw&groupId=' + groupId + '&unit=' + session.unitOrderingSequence + '&lesson=' + session.lessonNumber;
        }
        return _react2.default.createElement(
          _CourseViewTable2.default.Cell,
          { className: classes(session),
            key: session.id + '-' + session.unitOrderingSequence + '-' + session.lessonNumber,
            colSpan: isTaskCompletionVisible ? 3 : 2,
            small: true },
          _react2.default.createElement(
            'span',
            null,
            'S' + session.index + ', U' + session.unitOrderingSequence + ', L' + session.lessonNumber
          ),
          homeworkViewLink && _react2.default.createElement(
            _reactRouter.Link,
            { className: _style2.default.LessonHomeworkViewerLink,
              to: homeworkViewLink,
              draggable: false,
              tabIndex: '-1',
              target: '_blank' },
            'Viewer ',
            _react2.default.createElement(_omniCommonUi.Icon, { id: 'arrow-right', className: _style2.default.LessonHomeworkViewerLink_icon })
          )
        );
      }));
      if (hasTotalPoints) {
        cellItems.unshift(_react2.default.createElement(_CourseViewTable2.default.Cell, null));
      }

      if (isHFCourseTypeGroup && !hasContentPath) {
        cellItems.push((0, _hfUsage.renderHFUsageHeader)(games));
      }

      return cellItems;
    }
  }, {
    key: '_renderDates',
    value: function _renderDates() {
      var _props3 = this.props,
          defaultSessionId = _props3.defaultSessionId,
          timeZone = _props3.timeZone,
          hasTotalPoints = _props3.hasTotalPoints,
          isTaskCompletionVisible = _props3.isTaskCompletionVisible;

      var getClassName = function getClassName(className) {
        return (0, _classnames2.default)(_style4.default.Homework_innerTable_Th, className);
      };
      var classes = function classes(session) {
        return getClassName(_defineProperty({}, _style4.default.Homework_innerTable_active, session.id === defaultSessionId));
      };

      var cellItems = [];
      cellItems.push(this._sessions.map(function (session) {
        return _react2.default.createElement(
          _CourseViewTable2.default.Cell,
          { className: classes,
            key: session.id + '-' + session.unitOrderingSequence + '-' + session.lessonNumber,
            colSpan: isTaskCompletionVisible ? 3 : 2,
            small: true },
          session.period.start.clone().tz(timeZone).format('ddd D MMM')
        );
      }));
      if (hasTotalPoints) {
        cellItems.unshift(_react2.default.createElement(_CourseViewTable2.default.Cell, null));
      }
      return cellItems;
    }
  }, {
    key: '_renderScoreCategoryRow',
    value: function _renderScoreCategoryRow() {
      var _props4 = this.props,
          hasTotalPoints = _props4.hasTotalPoints,
          isHFCourseTypeGroup = _props4.isHFCourseTypeGroup,
          isTaskCompletionVisible = _props4.isTaskCompletionVisible,
          hasContentPath = _props4.hasContentPath,
          games = _props4.games;


      var cellItems = [];
      cellItems.push(this._sessions.map(function (session) {
        return [_react2.default.createElement(
          _CourseViewTable2.default.Cell,
          { columnId: { session: session, column: 'completion' }, small: true },
          'Completion'
        ), _react2.default.createElement(
          _CourseViewTable2.default.Cell,
          { columnId: { session: session, column: 'accuracy' }, small: true },
          '1st Time Accuracy'
        )].concat(_toConsumableArray(isTaskCompletionVisible ? [_react2.default.createElement(
          _CourseViewTable2.default.Cell,
          { columnId: { session: session, column: 'taskCompletion' }, small: true },
          'Task Completion'
        )] : []));
      }));
      if (hasTotalPoints) {
        cellItems.unshift(_react2.default.createElement(
          _CourseViewTable2.default.Cell,
          { columnId: { column: TOTAL_POINTS }, small: true },
          'Total Points'
        ));
      }
      if (isHFCourseTypeGroup && !hasContentPath) {
        cellItems.push((0, _hfUsage.renderHFUsageSubHeader)(games));
      }
      return cellItems;
    }
  }, {
    key: '_renderHFUsageColumn',
    value: function _renderHFUsageColumn(column, studetnId, usageIndex) {
      var onlineHomeworkHFUsage = this.props.onlineHomeworkHFUsage;

      var HFUsage = onlineHomeworkHFUsage && onlineHomeworkHFUsage.get(studetnId);
      if (!HFUsage) return DEFAULT_CELL;
      var usage = HFUsage.onlineUsages && HFUsage.onlineUsages[usageIndex];
      switch (column) {
        case _hfUsage.EXTRA_COLUMNS.ACTIVITIES_COMPLETED:
        case _hfUsage.EXTRA_COLUMNS.GAME_COMPLETED:
          return this._renderUsage(usage);
        case _hfUsage.EXTRA_COLUMNS.LAST_ACTIVITIES_DATE:
        case _hfUsage.EXTRA_COLUMNS.GAME_COMPLETED_DATE:
          return this._renderDate(usage);
        case _hfUsage.EXTRA_COLUMNS.DIAMONDS:
          return HFUsage.gainedDiamonds + '/' + HFUsage.totalDiamonds;
        default:
          return DEFAULT_CELL;
      }
    }
  }, {
    key: '_renderUsage',
    value: function _renderUsage() {
      var usage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var completed = usage.completedCoreActivities || DEFAULT_CELL;
      var total = usage.allCoreActivities || DEFAULT_CELL;
      if (completed || total) {
        return completed + '/' + total;
      }
      return DEFAULT_CELL;
    }
  }, {
    key: '_renderDate',
    value: function _renderDate() {
      var usage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var dataString = usage.completedOn;
      if (dataString && this._getDateFomat(dataString)) {
        return _react2.default.createElement(
          'div',
          { style: { whiteSpace: 'nowrap' } },
          this._getDateFomat(dataString)
        );
      }
      return DEFAULT_CELL;
    }
  }, {
    key: '_getDateFomat',
    value: function _getDateFomat(dataString) {
      var _moment = _omniCommonUi.moment.utc(dataString).clone().tz(this.props.timeZone);
      if (!_moment) {
        _moment = _omniCommonUi.moment.utc(dataString);
      }
      return _moment.format(DATE_FORMAT);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props5 = this.props,
          members = _props5.members,
          onlineHomeworks = _props5.onlineHomeworks,
          studentTotalPoints = _props5.studentTotalPoints;


      if (!onlineHomeworks || !onlineHomeworks.data) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _CourseViewTable2.default,
          { students: members, highlightedColumns: this._highlightedColumns },
          _react2.default.createElement(
            _CourseViewTable2.default.Header,
            null,
            _react2.default.createElement(
              _CourseViewTable2.default.Row,
              null,
              this._renderSessionNumbers()
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Row,
              null,
              this._renderDates()
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Row,
              null,
              this._renderScoreCategoryRow()
            )
          ),
          _react2.default.createElement(
            _CourseViewTable2.default.Body,
            null,
            function (member, _ref3) {
              var session = _ref3.session,
                  column = _ref3.column,
                  usageIndex = _ref3.usageIndex;

              var studentId = member.studentGeneralInfo.id;
              if (column === TOTAL_POINTS) {
                var studentTotalPoint = studentTotalPoints && studentTotalPoints.find(function (totalPoint) {
                  return totalPoint.studentId === studentId;
                });
                var totalPoint = studentTotalPoint && studentTotalPoint.totalPoint;
                return totalPoint || '-';
              }

              if (Object.values(_hfUsage.EXTRA_COLUMNS).includes(column)) {
                return _this2._renderHFUsageColumn(column, studentId, usageIndex);
              }

              var onlineHomeworkCell = onlineHomeworks.data.find(function (homeworkBySession) {
                return homeworkBySession.sessionId === session.id && homeworkBySession.lessonNumber === session.lessonNumber;
              }).studentOnlineHomeworkResults.find(function (homeworkByStudent) {
                return homeworkByStudent.studentId === studentId;
              });

              if (column === 'accuracy') {
                return _this2._renderScore(onlineHomeworkCell, 'accuracy');
              }

              if (column === 'taskCompletion') {
                return _this2._renderTaskCompletion(session, studentId);
              }

              return _this2._renderScore(onlineHomeworkCell, 'completion');
            }
          )
        )
      );
    }
  }]);

  return StudentApp;
}(_react.Component);

StudentApp.propTypes = {
  groupId: _propTypes2.default.string.isRequired,
  timeZone: _propTypes2.default.string,
  defaultSessionId: _propTypes2.default.string,
  courseTypeCode: _propTypes2.default.string,
  fetchOnlineHomework: _propTypes2.default.func,
  fetchOnlineHomeworkHFUsage: _propTypes2.default.func,
  fetchStudentTasksIfNeeded: _propTypes2.default.func,
  fetchStudentTotalPoints: _propTypes2.default.func.isRequired,
  members: _propTypes2.default.object,
  sessions: _propTypes2.default.object,
  onlineHomeworks: _propTypes2.default.object,
  studentTasks: _propTypes2.default.object,
  state: _propTypes2.default.object.isRequired,
  isSessionHeadingClickable: _propTypes2.default.bool.isRequired,
  studentTotalPoints: _propTypes2.default.object,
  isTBCourseTypeGroup: _propTypes2.default.bool.isRequired,
  isHFCourseTypeGroup: _propTypes2.default.bool.isRequired,
  isHFV4CourseTypeGroup: _propTypes2.default.bool.isRequired,
  isFRV2CourseTypeGroup: _propTypes2.default.bool.isRequired,
  isTaskCompletionVisible: _propTypes2.default.bool,
  hasContentPath: _propTypes2.default.bool.isRequired,
  onlineHomeworkHFUsage: _propTypes2.default.object,
  hasTotalPoints: _propTypes2.default.bool.isRequired,
  games: _propTypes2.default.array
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var group = _.actions.getGroup(state, groupId);

  var _Group$getCentre = _.actions.getCentre(state, groupId),
      timeZone = _Group$getCentre.timeZone;

  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var sessions = getSessions(group, state);
  var units = (0, _accessors.getUnitList)(state, groupId);
  var onlineHomeworks = state.get('rootReducer').get('onlineHomework').get(groupId);
  var onlineHomeworksData = onlineHomeworks && onlineHomeworks.data && onlineHomeworks.data.map(function (onlineHomework) {
    return onlineHomework.set('unitOrderingSequence', (0, _accessors.getUnitNumberById)(units, onlineHomework.unitId));
  });
  onlineHomeworks = onlineHomeworks && onlineHomeworks.set('data', onlineHomeworksData);
  var studentTasks = _StudentTasks.accessors.getStudentTaskResults(state, groupId);
  var studentTasksData = studentTasks && studentTasks.data && studentTasks.data.map(function (studentTask) {
    return studentTask.set('unitOrderingSequence', (0, _accessors.getUnitNumberById)(units, studentTask.unitId));
  });
  studentTasks = studentTasks && studentTasks.set('data', studentTasksData);
  var defaultSession = _SessionPlans.actions.getDefaultSession(state, groupId);
  var isSessionHeadingClickable = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.Homework.ViewAssignments);
  var studentTotalPoints = state.get('rootReducer').get('studentTotalPoints').get(groupId);
  var isTBCourseTypeGroup = _.actions.isTBCourseTypeGroup(state, groupId);
  var isHFCourseTypeGroup = _.actions.isHFCourseTypeGroup(state, groupId);
  var isHFV4CourseTypeGroup = _.actions.isHFV4CourseTypeGroup(state, groupId);
  var isFRV2CourseTypeGroup = _.actions.isFRV2CourseTypeGroup(state, groupId);
  var isTaskCompletionVisible = isHFV4CourseTypeGroup && !!_omniCommonUi.Config.get('isCNEnvironment');

  var hasContentPath = _.actions.hasContentPath(state, groupId);

  var onlineHomeworkHFUsage = state.get('rootReducer').get('onlineHomeworkHFUsage').get(groupId);

  var hasTotalPoints = studentTotalPoints && studentTotalPoints.size > 0;
  var games = new Array(3);
  for (var i = 0; i < games.length; i++) {
    games[i] = {
      index: i + 1
    };
  }
  return {
    groupId: groupId,
    courseTypeCode: group.courseTypeCode,
    timeZone: timeZone,
    defaultSessionId: defaultSession.id,
    members: members,
    sessions: sessions,
    onlineHomeworks: onlineHomeworks,
    studentTasks: studentTasks,
    state: state,
    isSessionHeadingClickable: isSessionHeadingClickable,
    studentTotalPoints: studentTotalPoints,
    isTBCourseTypeGroup: isTBCourseTypeGroup,
    isHFCourseTypeGroup: isHFCourseTypeGroup,
    isHFV4CourseTypeGroup: isHFV4CourseTypeGroup,
    isFRV2CourseTypeGroup: isFRV2CourseTypeGroup,
    isTaskCompletionVisible: isTaskCompletionVisible,
    hasContentPath: hasContentPath,
    hasTotalPoints: hasTotalPoints,
    onlineHomeworkHFUsage: onlineHomeworkHFUsage,
    games: games
  };
}

function getSessions(group, state) {
  if (_is_js2.default.undefined(group.sessionPlans.data)) {
    return group.sessionPlans;
  }

  var getSession = function getSession(sessionId) {
    return state.get('rootReducer').get('sessionPlans').get(sessionId);
  };
  return group.sessionPlans.update('data', function (data) {
    return new _immutable.List(data);
  }).update('data', function (data) {
    return data.map(getSession);
  });
}

function mapDispatchToProps(dispatch) {
  return Object.assign((0, _redux.bindActionCreators)(_OnlineHomework.actions, dispatch), (0, _redux.bindActionCreators)(_StudentTasks.actions, dispatch), (0, _redux.bindActionCreators)(_TotalPoint.actions, dispatch), (0, _redux.bindActionCreators)(_HFUsage.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(StudentApp);

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(716);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1632);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_STUDENT_TOTAL_POINTS_FAILURE = exports.FETCH_STUDENT_TOTAL_POINTS_SUCCESS = exports.FETCH_STUDENT_TOTAL_POINTS_REQUEST = undefined;
exports.fetchStudentTotalPoints = fetchStudentTotalPoints;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_STUDENT_TOTAL_POINTS_REQUEST = exports.FETCH_STUDENT_TOTAL_POINTS_REQUEST = 'FETCH_STUDENT_TOTAL_POINTS_REQUEST';
var FETCH_STUDENT_TOTAL_POINTS_SUCCESS = exports.FETCH_STUDENT_TOTAL_POINTS_SUCCESS = 'FETCH_STUDENT_TOTAL_POINTS_SUCCESS';
var FETCH_STUDENT_TOTAL_POINTS_FAILURE = exports.FETCH_STUDENT_TOTAL_POINTS_FAILURE = 'FETCH_STUDENT_TOTAL_POINTS_FAILURE';

var buildHomeworkUrl = function buildHomeworkUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/student-total-point/');
};
function fetchStudentTotalPoints(groupId) {
  return function (dispatch) {
    var url = buildHomeworkUrl(groupId);
    var method = 'GET';

    return dispatch(fetchStudentTotalPointsRequest()).payload.then(function (response) {
      return dispatch(fetchStudentTotalPointsSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchStudentTotalPointsfailure(error));
    });

    function fetchStudentTotalPointsRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_TOTAL_POINTS_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchStudentTotalPointsSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_TOTAL_POINTS_SUCCESS,
        payload: response,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchStudentTotalPointsfailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDENT_TOTAL_POINTS_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _create = __webpack_require__(1633);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentTotalPointRecord = (0, _immutable.Record)({
  studentId: undefined,
  totalPoint: undefined
});

var StudentTotalPoint = function (_StudentTotalPointRec) {
  _inherits(StudentTotalPoint, _StudentTotalPointRec);

  function StudentTotalPoint() {
    _classCallCheck(this, StudentTotalPoint);

    return _possibleConstructorReturn(this, (StudentTotalPoint.__proto__ || Object.getPrototypeOf(StudentTotalPoint)).apply(this, arguments));
  }

  return StudentTotalPoint;
}(StudentTotalPointRecord);

StudentTotalPoint.create = _create2.default;

exports.default = StudentTotalPoint;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(719);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1634);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchOnlineHomeworkHFUsage = exports.FETCH_ONLINE_HOMEWORK_HF_USAGE_FAILURE = exports.FETCH_ONLINE_HOMEWORK_HF_USAGE_SUCCESS = exports.FETCH_ONLINE_HOMEWORK_HF_USAGE_REQUEST = undefined;

var _omniCommonUi = __webpack_require__(0);

var _Api = __webpack_require__(11);

var ACTION_OBJECT_NAME = 'ONLINE_HOMEWORK_HF_USAGE';
var FETCH_ONLINE_HOMEWORK_HF_USAGE_REQUEST = exports.FETCH_ONLINE_HOMEWORK_HF_USAGE_REQUEST = 'FETCH_' + ACTION_OBJECT_NAME + '_REQUEST';
var FETCH_ONLINE_HOMEWORK_HF_USAGE_SUCCESS = exports.FETCH_ONLINE_HOMEWORK_HF_USAGE_SUCCESS = 'FETCH_' + ACTION_OBJECT_NAME + '_SUCCESS';
var FETCH_ONLINE_HOMEWORK_HF_USAGE_FAILURE = exports.FETCH_ONLINE_HOMEWORK_HF_USAGE_FAILURE = 'FETCH_' + ACTION_OBJECT_NAME + '_FAILURE';

var DISABLE_DEFAULT_ACTION_EXTRAS = { disableDefault: true };

var buildOnlineHomeworkHFUsageURL = function buildOnlineHomeworkHFUsageURL(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/hf-online-usage');
};

var fetchOnlineHomeworkHFUsage = exports.fetchOnlineHomeworkHFUsage = function fetchOnlineHomeworkHFUsage(groupId) {
  return (0, _omniCommonUi.createApiActionCreator)(ACTION_OBJECT_NAME, buildOnlineHomeworkHFUsageURL(groupId), 'GET', DISABLE_DEFAULT_ACTION_EXTRAS, { groupId: groupId });
};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HFUsageRecord = (0, _immutable.Record)({
  studentId: undefined,
  gainedDiamonds: undefined,
  totalDiamonds: undefined,
  onlineUsages: undefined
});

var HFUsage = function (_HFUsageRecord) {
  _inherits(HFUsage, _HFUsageRecord);

  function HFUsage() {
    _classCallCheck(this, HFUsage);

    return _possibleConstructorReturn(this, (HFUsage.__proto__ || Object.getPrototypeOf(HFUsage)).apply(this, arguments));
  }

  return HFUsage;
}(HFUsageRecord);

exports.default = HFUsage;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UsageItemRecord = (0, _immutable.Record)({
  allCoreActivities: undefined,
  completedCoreActivities: undefined,
  completedOn: undefined
});

var UsageItem = function (_UsageItemRecord) {
  _inherits(UsageItem, _UsageItemRecord);

  function UsageItem() {
    _classCallCheck(this, UsageItem);

    return _possibleConstructorReturn(this, (UsageItem.__proto__ || Object.getPrototypeOf(UsageItem)).apply(this, arguments));
  }

  return UsageItem;
}(UsageItemRecord);

exports.default = UsageItem;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PracticePlay = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _PracticePlay = __webpack_require__(723);

var _GroupMembers = __webpack_require__(14);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PracticePlay = exports.PracticePlay = function (_PureComponent) {
  _inherits(PracticePlay, _PureComponent);

  function PracticePlay() {
    _classCallCheck(this, PracticePlay);

    return _possibleConstructorReturn(this, (PracticePlay.__proto__ || Object.getPrototypeOf(PracticePlay)).apply(this, arguments));
  }

  _createClass(PracticePlay, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._fetchPracticePlayIfNeeded(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this._fetchPracticePlayIfNeeded(props);
    }
  }, {
    key: '_fetchPracticePlayIfNeeded',
    value: function _fetchPracticePlayIfNeeded() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.props.fetchPracticePlayIfNeeded(props.groupId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          members = _props.members,
          practicePlayContent = _props.practicePlayContent;

      if (!practicePlayContent || practicePlayContent.size === 0 || members.size === 0) return null;

      return _react2.default.createElement(
        _CourseViewTable2.default,
        { students: members },
        _react2.default.createElement(
          _CourseViewTable2.default.Header,
          null,
          _react2.default.createElement(
            _CourseViewTable2.default.Row,
            null,
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: { column: 'completion' }, small: true },
              'Activities Completion'
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: { column: 'completedOn' }, small: true },
              'Last Activities Completed On'
            )
          )
        ),
        _react2.default.createElement(
          _CourseViewTable2.default.Body,
          null,
          function (member, _ref) {
            var column = _ref.column;

            var practicePlay = practicePlayContent.find(function (content) {
              return content.studentId === member.studentGeneralInfo.id;
            });

            if (column === 'completion') {
              var completion = practicePlay && _is_js2.default.existy(practicePlay.activitiesCompleted) ? practicePlay.activitiesCompleted + '/' + practicePlay.activitiesAmount : 'N/A';
              return completion;
            }

            var completedOn = practicePlay && practicePlay.lastActivitiesCompletedDate ? practicePlay.lastActivitiesCompletedDate.format('YYYY-MM-DD') : 'N/A';
            return completedOn;
          }
        )
      );
    }
  }]);

  return PracticePlay;
}(_react.PureComponent);

PracticePlay.propTypes = {
  groupId: _propTypes2.default.string.isRequired,
  members: _propTypes2.default.shape.isRequired,
  practicePlayContent: _propTypes2.default.shape,
  fetchPracticePlayIfNeeded: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var practicePlayContent = state.get('rootReducer').get('practicePlay').get(groupId);
  return { groupId: groupId, members: members, practicePlayContent: practicePlayContent };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_PracticePlay.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(PracticePlay);

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(724);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1642);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_PRACTICE_PLAY_SUCCESS = undefined;
exports.fetchPracticePlayIfNeeded = fetchPracticePlayIfNeeded;
exports.fetchPracticePlay = fetchPracticePlay;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_PRACTICE_PLAY_REQUEST = 'FETCH_PRACTICE_PLAY_REQUEST';
var FETCH_PRACTICE_PLAY_SUCCESS = exports.FETCH_PRACTICE_PLAY_SUCCESS = 'FETCH_PRACTICE_PLAY_SUCCESS';
var FETCH_PRACTICE_PLAY_FAILURE = 'FETCH_PRACTICE_PLAY_FAILURE';

var buildPracticePlayUrl = function buildPracticePlayUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/practice-play');
};

function fetchPracticePlayIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildPracticePlayUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchPracticePlay(groupId));
  };
}

function fetchPracticePlay(groupId) {
  return function (dispatch) {
    var url = buildPracticePlayUrl(groupId);
    var method = 'GET';

    return dispatch(fetchPracticePlayRequest()).payload.then(function (response) {
      return dispatch(fetchPracticePlaySuccess(response));
    }).then(function (error) {
      return fetchPracticePlayFailure(error);
    });

    function fetchPracticePlayRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PRACTICE_PLAY_REQUEST,
        payload: (0, _Api.fetch)(url),
        method: method,
        url: url
      });
    }

    function fetchPracticePlaySuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PRACTICE_PLAY_SUCCESS,
        payload: response,
        groupId: groupId,
        method: method,
        url: url
      });
    }

    function fetchPracticePlayFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PRACTICE_PLAY_FAILURE,
        error: error,
        method: method,
        url: url
      });
    }
  };
}

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PracticePlayRecord = _immutable2.default.Record({
  studentId: undefined,
  activitiesCompleted: undefined,
  activitiesAmount: undefined,
  lastActivitiesCompletedDate: undefined
});

var PracticePlay = function (_PracticePlayRecord) {
  _inherits(PracticePlay, _PracticePlayRecord);

  function PracticePlay() {
    _classCallCheck(this, PracticePlay);

    return _possibleConstructorReturn(this, (PracticePlay.__proto__ || Object.getPrototypeOf(PracticePlay)).apply(this, arguments));
  }

  return PracticePlay;
}(PracticePlayRecord);

exports.default = PracticePlay;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(16);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(15);

var _redux = __webpack_require__(10);

var _omniCommonUi = __webpack_require__(0);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _style = __webpack_require__(1647);

var _style2 = _interopRequireDefault(_style);

var _GroupMembers = __webpack_require__(14);

var _OnlineUsage = __webpack_require__(727);

var _SessionPlans = __webpack_require__(44);

var _accessors = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HEADER_COMPLETION = 'Completion';
var HEADER_CATCH_UPS_TAKE = 'CatchUpsTake';
var HEADER_UNIT_AVERAGE = 'Average';
var HEADER_SPIN_PROGRESS = 'SpinProgress';
var DEFAULT_CELL = 'N/A';

var OnlineUsage = function (_PureComponent) {
  _inherits(OnlineUsage, _PureComponent);

  function OnlineUsage(props) {
    _classCallCheck(this, OnlineUsage);

    var _this = _possibleConstructorReturn(this, (OnlineUsage.__proto__ || Object.getPrototypeOf(OnlineUsage)).call(this, props));

    _this._renderCell = _this._renderCell.bind(_this);
    _this._closeSpinProgressPopUp = _this._closeSpinProgressPopUp.bind(_this);
    return _this;
  }

  _createClass(OnlineUsage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.fetchOnlineUsageIfNeeded(this.props.groupId);
    }
  }, {
    key: '_getHighlightedColumns',
    value: function _getHighlightedColumns() {
      var _props = this.props,
          units = _props.units,
          defaultUnitId = _props.defaultUnitId;

      var defaultUnitIndex = units.toList().findIndex(function (unit) {
        return unit.id === defaultUnitId;
      }) * 3;
      if (defaultUnitIndex < 0) {
        return undefined;
      }
      return [defaultUnitIndex, defaultUnitIndex + 1, defaultUnitIndex + 2];
    }
  }, {
    key: '_closeSpinProgressPopUp',
    value: function _closeSpinProgressPopUp() {
      this.props.pushRoute(this.props.buildRoute({ mode: '', studentId: '' }));
    }
  }, {
    key: '_renderSpinProgressPopUp',
    value: function _renderSpinProgressPopUp() {
      var _props2 = this.props,
          studentId = _props2.studentId,
          onlineUsages = _props2.onlineUsages,
          selectedStudent = _props2.selectedStudent;

      if (!studentId) {
        return;
      }
      var studentOnlineUsages = onlineUsages.get(studentId);
      var selectedCourse = studentOnlineUsages.selectedCourse;
      var lableStyle = _style2.default.OnlineUsage_popup_name_label;
      var ulStyle = _style2.default.OnlineUsage_popup_ul;
      var nameStyle = _style2.default.OnlineUsage_popup_name;
      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: true,
          title: 'Selected SPIN Courses',
          primaryButtonContent: 'Ok',
          onPrimaryClick: this._closeSpinProgressPopUp },
        _react2.default.createElement(
          'div',
          { className: _style2.default.OnlineUsage_popup },
          _react2.default.createElement(
            'div',
            { className: nameStyle },
            _react2.default.createElement(
              'span',
              null,
              'English First Name:'
            ),
            _react2.default.createElement(
              'label',
              { className: lableStyle },
              selectedStudent.studentGeneralInfo.firstName
            )
          ),
          _react2.default.createElement(
            'div',
            { className: nameStyle },
            _react2.default.createElement(
              'span',
              null,
              'English Last Name:'
            ),
            _react2.default.createElement(
              'label',
              { className: lableStyle },
              selectedStudent.studentGeneralInfo.lastName
            )
          ),
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            'ul',
            { className: ulStyle },
            selectedCourse.map(function (spin) {
              return _react2.default.createElement(
                'li',
                null,
                spin
              );
            })
          )
        )
      );
    }
  }, {
    key: '_renderTableHeader',
    value: function _renderTableHeader() {
      var units = this.props.units;

      return _react2.default.createElement(
        _CourseViewTable2.default.Header,
        null,
        _react2.default.createElement(
          _CourseViewTable2.default.Row,
          null,
          units.map(function (unit) {
            return _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { key: unit.orderingSequence, colSpan: 3, small: true },
              unit.name
            );
          }),
          _react2.default.createElement(
            _CourseViewTable2.default.Cell,
            { key: units.size + 1, colSpan: 3, small: true },
            'SPIN Progress'
          )
        ),
        _react2.default.createElement(
          _CourseViewTable2.default.Row,
          null,
          units.map(function (unit) {
            return [_react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: { unit: unit, column: HEADER_COMPLETION }, small: true },
              'Activities Completion'
            ), _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: { unit: unit, column: HEADER_CATCH_UPS_TAKE }, small: true },
              'Catch\u2011ups Take'
            ), _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: { unit: unit, column: HEADER_UNIT_AVERAGE }, small: true },
              'Unit Average'
            )];
          }),
          _react2.default.createElement(
            _CourseViewTable2.default.Cell,
            { columnId: { column: HEADER_SPIN_PROGRESS }, colSpan: 3, small: true },
            'Completion'
          )
        )
      );
    }
  }, {
    key: '_getStudentSpinProgress',
    value: function _getStudentSpinProgress(studentId) {
      return this.props.buildRoute({ mode: 'spin-grogress', studentId: studentId });
    }
  }, {
    key: '_renderCell',
    value: function _renderCell(member, _ref) {
      var unit = _ref.unit,
          column = _ref.column;
      var onlineUsages = this.props.onlineUsages;

      var studentOnlineUsages = onlineUsages.get(member.studentGeneralInfo.id);
      if (!studentOnlineUsages || !studentOnlineUsages.unitOnlineUsages) {
        return 'N/A';
      }
      var unitOnlineUsage = void 0;
      if (unit) {
        unitOnlineUsage = studentOnlineUsages.unitOnlineUsages.get('' + unit.orderingSequence);
      }
      if (!unitOnlineUsage && column !== HEADER_SPIN_PROGRESS) return 'N/A';

      switch (column) {
        case HEADER_COMPLETION:
          return unitOnlineUsage.activitiesComplete || DEFAULT_CELL;
        case HEADER_CATCH_UPS_TAKE:
          return unitOnlineUsage.catchUpsTaken || DEFAULT_CELL;
        case HEADER_UNIT_AVERAGE:
          return unitOnlineUsage.unitAverage || DEFAULT_CELL;
        case HEADER_SPIN_PROGRESS:
          {
            return studentOnlineUsages.spinProcess ? _react2.default.createElement(
              _reactRouter.Link,
              { to: this._getStudentSpinProgress(member.studentGeneralInfo.id),
                className: _style2.default.OnlineUsage_spinLink },
              studentOnlineUsages.spinProcess
            ) : DEFAULT_CELL;
          }
        default:
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          members = _props3.members,
          onlineUsages = _props3.onlineUsages;

      if (onlineUsages && members) {
        return _react2.default.createElement(
          'div',
          { className: (0, _omniCommonUi.testClass)('test-courseviewTable') },
          _react2.default.createElement(
            _CourseViewTable2.default,
            { students: members, highlightedColumns: this._getHighlightedColumns() },
            this._renderTableHeader(),
            _react2.default.createElement(
              _CourseViewTable2.default.Body,
              null,
              this._renderCell
            )
          ),
          this._renderSpinProgressPopUp()
        );
      }
      return _react2.default.createElement('div', null);
    }
  }]);

  return OnlineUsage;
}(_react.PureComponent);

OnlineUsage.propTypes = {
  groupId: _propTypes2.default.string.isRequired,
  members: _propTypes2.default.array.isRequired,
  fetchOnlineUsageIfNeeded: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  defaultUnitId: _propTypes2.default.string,
  studentId: _propTypes2.default.string,
  onlineUsages: _propTypes2.default.object,
  selectedStudent: _propTypes2.default.object,
  units: _propTypes2.default.object,
  buildRoute: _propTypes2.default.func
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      studentId = _ownProps$params.studentId;

  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var onlineUsages = state.get('rootReducer').get('onlineUsage').get(groupId);
  var selectedStudent = _GroupMembers.actions.getMemberById(state, studentId);
  var units = (0, _accessors.getUnitList)(state, groupId);
  var defaultSession = _SessionPlans.actions.getDefaultSession(state, groupId);
  var defaultUnitId = '' + defaultSession.unitIds[0];
  return {
    groupId: groupId,
    studentId: studentId,
    selectedStudent: selectedStudent,
    defaultUnitId: defaultUnitId,
    members: members,
    units: units,
    onlineUsages: onlineUsages
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, { pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_OnlineUsage.actions, dispatch), (0, _redux.bindActionCreators)(_GroupMembers.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(OnlineUsage);

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = exports.OnlineUsage = undefined;

var _actions2 = __webpack_require__(728);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1649);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(317);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1650);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

_model2.default.create = _create2.default;

var OnlineUsage = exports.OnlineUsage = _model2.default;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_ONLINE_USAGE_FAILURE = exports.FETCH_ONLINE_USAGE_SUCCESS = exports.FETCH_ONLINE_USAGE_REQUEST = undefined;
exports.fetchOnlineUsageIfNeeded = fetchOnlineUsageIfNeeded;
exports.fetchOnlineUsage = fetchOnlineUsage;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_ONLINE_USAGE_REQUEST = exports.FETCH_ONLINE_USAGE_REQUEST = 'FETCH_ONLINE_USAGE_REQUEST';
var FETCH_ONLINE_USAGE_SUCCESS = exports.FETCH_ONLINE_USAGE_SUCCESS = 'FETCH_ONLINE_USAGE_SUCCESS';
var FETCH_ONLINE_USAGE_FAILURE = exports.FETCH_ONLINE_USAGE_FAILURE = 'FETCH_ONLINE_USAGE_FAILURE';

var buildOnlineUsageUrl = function buildOnlineUsageUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/fr-online-usage');
};

function fetchOnlineUsageIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildOnlineUsageUrl(groupId) })) {
      return false;
    }
    return dispatch(fetchOnlineUsage(groupId));
  };
}

function fetchOnlineUsage(groupId) {
  return function (dispatch) {
    var method = 'GET';
    var url = buildOnlineUsageUrl(groupId);
    return dispatch(fetchOnlineUsageRequest()).payload.then(function (response) {
      return dispatch(fetchOnlineUsageSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchOnlineUsageFailure(error));
    });

    function fetchOnlineUsageRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ONLINE_USAGE_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method
      });
    }

    function fetchOnlineUsageSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ONLINE_USAGE_SUCCESS,
        payload: response,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchOnlineUsageFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ONLINE_USAGE_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitOnlineUsageRecord = (0, _immutable.Record)({
  unitNo: undefined,
  activitiesComplete: undefined,
  catchUpsTaken: undefined,
  unitAverage: undefined
});

var UnitOnlineUsage = function (_UnitOnlineUsageRecor) {
  _inherits(UnitOnlineUsage, _UnitOnlineUsageRecor);

  function UnitOnlineUsage() {
    _classCallCheck(this, UnitOnlineUsage);

    return _possibleConstructorReturn(this, (UnitOnlineUsage.__proto__ || Object.getPrototypeOf(UnitOnlineUsage)).apply(this, arguments));
  }

  return UnitOnlineUsage;
}(UnitOnlineUsageRecord);

exports.default = UnitOnlineUsage;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Reader = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _style = __webpack_require__(1657);

var _style2 = _interopRequireDefault(_style);

var _accessors = __webpack_require__(41);

var _SessionPlans = __webpack_require__(44);

var _GroupMembers = __webpack_require__(14);

var _Reader = __webpack_require__(731);

var _ = __webpack_require__(13);

var _TableView = __webpack_require__(59);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NO_READER_RESULT = '-';

var Reader = exports.Reader = function (_Component) {
  _inherits(Reader, _Component);

  function Reader(props) {
    _classCallCheck(this, Reader);

    var _this = _possibleConstructorReturn(this, (Reader.__proto__ || Object.getPrototypeOf(Reader)).call(this, props));

    _this._setUpData(props);
    return _this;
  }

  _createClass(Reader, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          groupId = _props.groupId,
          reader = _props.reader;

      if (_omniCommonUi.ApiResponseHelper.shouldFetch(reader)) {
        this.props.fetchReaderIfNeeded(groupId);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this._setUpData(props);
    }
  }, {
    key: '_setUpData',
    value: function _setUpData(props) {
      var sessions = props.sessions,
          reader = props.reader;

      if (!sessions || !sessions.data || !reader || !reader.assignedReaderResults) {
        this._sessions = [];
        return;
      }

      this._setSessions(props);
      this._setHighlightedColumnsNo(props);
    }
  }, {
    key: '_setSessions',
    value: function _setSessions(_ref) {
      var sessions = _ref.sessions,
          reader = _ref.reader;

      this._sessions = reader.assignedReaderResults.filter(function (readerResultBySession) {
        return sessions.data.some(function (session) {
          return session.id === readerResultBySession.sessionId;
        });
      }).map(function (readerResultBySession) {
        return sessions.data.find(function (session) {
          return readerResultBySession.sessionId === session.id;
        }).set('lessonNumber', readerResultBySession.lessonNumber).set('unitOrderingSequence', readerResultBySession.unitOrderingSequence);
      }).sort(this._sortSessions);
    }
  }, {
    key: '_sortSessions',
    value: function _sortSessions(a, b) {
      if (a.index !== b.index) return a.index - b.index;
      if (a.unitOrderingSequence !== b.unitOrderingSequence) {
        return a.unitOrderingSequence - b.unitOrderingSequence;
      }
      return a.lessonNumber - b.lessonNumber;
    }
  }, {
    key: '_setHighlightedColumnsNo',
    value: function _setHighlightedColumnsNo(_ref2) {
      var defaultSessionId = _ref2.defaultSessionId;

      var firstIndexOfHighlightedColumn = this._sessions.findIndex(function (session) {
        return session.id === defaultSessionId;
      });
      var highlightedColumnSize = this._sessions.filter(function (session) {
        return session.id === defaultSessionId;
      }).size;
      this._highlightedColumns = [];
      for (var i = 0; i < highlightedColumnSize; i++) {
        this._highlightedColumns[i] = firstIndexOfHighlightedColumn + i;
      }
    }
  }, {
    key: '_renderSessionNumbers',
    value: function _renderSessionNumbers() {
      var cellItems = [];
      cellItems.push(this._sessions.map(function (session) {
        return _react2.default.createElement(
          _CourseViewTable2.default.Cell,
          { className: _style2.default.Reader_sessionNumberAndDate,
            key: session.id + '-' + session.unitOrderingSequence + '-' + session.lessonNumber,
            small: true },
          _react2.default.createElement(
            'span',
            null,
            'S' + session.index + ', U' + session.unitOrderingSequence + ', L' + session.lessonNumber
          )
        );
      }));

      return cellItems;
    }
  }, {
    key: '_renderDates',
    value: function _renderDates() {
      var cellItems = [];
      var timeZone = this.props.timeZone;

      cellItems.push(this._sessions.map(function (session) {
        return _react2.default.createElement(
          _CourseViewTable2.default.Cell,
          { className: _style2.default.Reader_sessionNumberAndDate,
            key: session.id + '-' + session.unitOrderingSequence + '-' + session.lessonNumber,
            columnId: { session: session, column: 'completion' },
            small: true },
          session.period.start.clone().tz(timeZone).format('ddd D MMM')
        );
      }));

      return cellItems;
    }
  }, {
    key: '_getHighlightedColumns',
    value: function _getHighlightedColumns() {
      var _props2 = this.props,
          units = _props2.units,
          defaultUnits = _props2.defaultUnits;


      if (_is_js2.default.undefined(units)) {
        return [0];
      }

      var unitIds = units.valueSeq().toArray().map(function (u) {
        return u.id;
      });

      return _is_js2.default.undefined(defaultUnits) ? [0] : defaultUnits.map(function (u) {
        return unitIds.indexOf(u);
      });
    }
  }, {
    key: '_renderUnitColumns',
    value: function _renderUnitColumns(units) {
      var cellItems = [];

      if (_is_js2.default.undefined(units) || units.size === 0) {
        return cellItems;
      }

      cellItems.push(units.valueSeq().toArray().map(function (unit) {
        return _react2.default.createElement(
          _CourseViewTable2.default.Cell,
          { key: '' + unit.id,
            className: _style2.default.Reader_sessionNumberAndDate,
            columnId: unit.id,
            small: true },
          unit.name
        );
      }));

      return cellItems;
    }
  }, {
    key: '_renderCompleteCell',
    value: function _renderCompleteCell() {
      var completedTooltip = 'The student read the Book of the Week or' + ' the Book of the Unit and completed all the activities for it.';

      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        { text: completedTooltip, overlayClassName: _style2.default.Reader_cell_tooltip },
        _react2.default.createElement(
          'div',
          { className: _style2.default.Reader_cell },
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'success', className: _style2.default.Reader_successIcon })
        )
      );
    }
  }, {
    key: '_renderInCompleteCell',
    value: function _renderInCompleteCell(progress) {
      var incompletedTooltip = progress > 0 ? 'The student has made progress but has not completed all activities' + ' for the Book of the Week or the Book of the Unit.' : 'The student has opened the page but has not done any reading activities yet.';

      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        { text: incompletedTooltip, overlayClassName: _style2.default.Reader_cell_tooltip },
        _react2.default.createElement(
          'div',
          { className: _style2.default.Reader_cell },
          _react2.default.createElement(
            'div',
            { className: _style2.default.Reader_cell_border },
            _react2.default.createElement(_TableView.ProgressBarTd, { isHideText: true,
              className: _style2.default.Reader_progressBarTd,
              percent: Math.round(progress) })
          )
        )
      );
    }
  }, {
    key: '_renderNoDataCell',
    value: function _renderNoDataCell() {
      var noDataTooltip = 'There is no data for this student.';

      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        { text: noDataTooltip, overlayClassName: _style2.default.Reader_cell_tooltip },
        _react2.default.createElement(
          'div',
          { className: _style2.default.Reader_cell },
          _react2.default.createElement(
            'div',
            { className: _style2.default.Reader_cell_border },
            NO_READER_RESULT
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          groupId = _props3.groupId,
          members = _props3.members,
          reader = _props3.reader,
          units = _props3.units;


      if (!reader || !reader.assignedReaderResults) {
        return null;
      }
      var state = _omniCommonUi.Store.get().getState();
      var isSSCourseTypeGroup = _.actions.isSSCourseTypeGroup(state, groupId);
      var isShowAssignedReader = _.actions.hasContentPath(state, groupId) && (isSSCourseTypeGroup || _.actions.isHFCourseTypeGroup(state, groupId));

      if (isSSCourseTypeGroup) {
        // The SS assigned reader is by unit.
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _CourseViewTable2.default,
            { students: members,
              extraInfo: reader.studentUnassignedReaderResults,
              highlightedColumns: this._getHighlightedColumns() },
            _react2.default.createElement(
              _CourseViewTable2.default.Header,
              null,
              _react2.default.createElement(
                _CourseViewTable2.default.Row,
                null,
                this._renderUnitColumns(units)
              )
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Body,
              null,
              function (member, column) {
                var studentId = member.studentGeneralInfo.id;
                var studentAssignedReaderResults = [];
                (reader.assignedReaderResults.filter(function (item) {
                  return item.unitId === column;
                }) || []).forEach(function (item) {
                  var studentAssignedReaderResult = item.studentAssignedReaderResults.find(function (assignedReaderResult) {
                    return assignedReaderResult.studentId === studentId && _is_js2.default.number(assignedReaderResult.completion);
                  });

                  if (_is_js2.default.object(studentAssignedReaderResult)) {
                    studentAssignedReaderResults.push(studentAssignedReaderResult.completion);
                  }
                });

                var readerCell = _is_js2.default.array(studentAssignedReaderResults) && studentAssignedReaderResults.length > 0 ? studentAssignedReaderResults.reduce(function (accumulator, currentValue) {
                  return accumulator + currentValue;
                }) / studentAssignedReaderResults.length : undefined;

                if (isShowAssignedReader && readerCell && _is_js2.default.number(readerCell)) {
                  if (readerCell >= 100) {
                    return _this2._renderCompleteCell();
                  }

                  return _this2._renderInCompleteCell(Math.round(readerCell));
                }

                return _this2._renderNoDataCell();
              }
            )
          )
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _CourseViewTable2.default,
          { students: members,
            extraInfo: reader.studentUnassignedReaderResults,
            highlightedColumns: this._highlightedColumns },
          _react2.default.createElement(
            _CourseViewTable2.default.Header,
            null,
            _react2.default.createElement(
              _CourseViewTable2.default.Row,
              null,
              this._renderSessionNumbers()
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Row,
              null,
              this._renderDates()
            )
          ),
          _react2.default.createElement(
            _CourseViewTable2.default.Body,
            null,
            function (member, _ref3) {
              var session = _ref3.session;

              var studentId = member.studentGeneralInfo.id;
              var readerCell = reader.assignedReaderResults.find(function (readerBySession) {
                return readerBySession.sessionId === session.id && readerBySession.lessonNumber === session.lessonNumber;
              }).studentAssignedReaderResults.find(function (readerByStudent) {
                return readerByStudent.studentId === studentId;
              });

              if (isShowAssignedReader && readerCell && _is_js2.default.number(readerCell.completion)) {
                if (readerCell.completion >= 100) {
                  return _this2._renderCompleteCell();
                }

                return _this2._renderInCompleteCell(Math.round(readerCell.completion));
              }

              return _this2._renderNoDataCell();
            }
          )
        )
      );
    }
  }]);

  return Reader;
}(_react.Component);

Reader.propTypes = {
  timeZone: _propTypes2.default.string,
  sessions: _propTypes2.default.object,
  defaultSessionId: _propTypes2.default.string,
  members: _propTypes2.default.object,
  groupId: _propTypes2.default.string.isRequired,
  reader: _propTypes2.default.object,
  fetchReaderIfNeeded: _propTypes2.default.func,
  units: _propTypes2.default.object,
  defaultUnits: _propTypes2.default.object
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var group = state.get('rootReducer').get('groups').get(groupId).data;

  var _Group$getCentre = _.actions.getCentre(state, groupId),
      timeZone = _Group$getCentre.timeZone;

  var units = (0, _accessors.getUnitList)(state, groupId);
  var defaultUnits = _SessionPlans.actions.getDefaultUnits(state, groupId);
  var sessions = getSessions(group, state);
  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var defaultSession = _SessionPlans.actions.getDefaultSession(state, groupId);
  var reader = state.get('rootReducer').get('reader') && state.get('rootReducer').get('reader').data;
  var assignedReaderData = reader && reader.assignedReaderResults && reader.assignedReaderResults.map(function (assignedReader) {
    return assignedReader.set('unitOrderingSequence', (0, _accessors.getUnitNumberById)(units, assignedReader.unitId));
  });
  reader = reader && reader.set('assignedReaderResults', assignedReaderData);

  return {
    groupId: groupId,
    members: members,
    sessions: sessions,
    reader: reader,
    timeZone: timeZone,
    defaultSessionId: defaultSession.id,
    units: units,
    defaultUnits: defaultUnits
  };
}

function getSessions(group, state) {
  if (_is_js2.default.undefined(group.sessionPlans.data)) {
    return group.sessionPlans;
  }

  var getSession = function getSession(sessionId) {
    return state.get('rootReducer').get('sessionPlans').get(sessionId);
  };
  return group.sessionPlans.update('data', function (data) {
    return new _immutable.List(data);
  }).update('data', function (data) {
    return data.map(getSession);
  });
}

function mapDispatchToProps(dispatch) {
  return Object.assign((0, _redux.bindActionCreators)(_Reader.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(Reader);

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = exports.Reader = undefined;

var _model = __webpack_require__(732);

var _model2 = _interopRequireDefault(_model);

var _actions2 = __webpack_require__(733);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1663);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.actions = _actions;

var Reader = exports.Reader = _model2.default;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _AssignedReader = __webpack_require__(1659);

var _AssignedReader2 = _interopRequireDefault(_AssignedReader);

var _UnassignedReader = __webpack_require__(1661);

var _UnassignedReader2 = _interopRequireDefault(_UnassignedReader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReaderRecord = (0, _immutable.Record)({
  assignedReaderResults: new _immutable.List(),
  studentUnassignedReaderResults: new _immutable.List()
});

var Reader = function (_ReaderRecord) {
  _inherits(Reader, _ReaderRecord);

  function Reader() {
    _classCallCheck(this, Reader);

    return _possibleConstructorReturn(this, (Reader.__proto__ || Object.getPrototypeOf(Reader)).apply(this, arguments));
  }

  return Reader;
}(ReaderRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      item = _ref2[1];

  if (!item) return [key, item];
  switch (key) {
    case 'assignedReaderResults':
      return [key, new _immutable.List(item.map(function (assignedReader) {
        return _AssignedReader2.default.create(assignedReader);
      }))];
    case 'studentUnassignedReaderResults':
      return [key, new _immutable.List(item.map(function (unassignedReader) {
        return _UnassignedReader2.default.create(unassignedReader);
      }))];
    default:
      return [key, item];
  }
};

Reader.create = function (data) {
  return new Reader(data).mapEntries(reviver);
};

exports.default = Reader;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_READER_RESULTS_FAILURE = exports.FETCH_READER_RESULTS_SUCCESS = exports.FETCH_READER_RESULTS_REQUEST = undefined;
exports.fetchReaderIfNeeded = fetchReaderIfNeeded;
exports.fetchReader = fetchReader;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_READER_RESULTS_REQUEST = exports.FETCH_READER_RESULTS_REQUEST = 'FETCH_READER_RESULTS_REQUEST';
var FETCH_READER_RESULTS_SUCCESS = exports.FETCH_READER_RESULTS_SUCCESS = 'FETCH_READER_RESULTS_SUCCESS';
var FETCH_READER_RESULTS_FAILURE = exports.FETCH_READER_RESULTS_FAILURE = 'FETCH_READER_RESULTS_FAILURE';

var buildReaderUrl = function buildReaderUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/reader-results');
};

function fetchReaderIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildReaderUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchReader(groupId));
  };
}

function fetchReader(groupId) {
  return function (dispatch) {
    var url = buildReaderUrl(groupId);
    var method = 'GET';

    return dispatch(fetchReaderRequest()).payload.then(function (response) {
      return dispatch(fetchReaderSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchReaderFailure(error));
    });

    function fetchReaderRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_READER_RESULTS_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchReaderSuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_READER_RESULTS_SUCCESS,
        payload: payload,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchReaderFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_READER_RESULTS_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vocabulary = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _style = __webpack_require__(1666);

var _style2 = _interopRequireDefault(_style);

var _Vocabulary = __webpack_require__(735);

var _GroupMembers = __webpack_require__(14);

var _SessionPlans = __webpack_require__(44);

var _accessors = __webpack_require__(41);

var _TableView = __webpack_require__(59);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NO_VOCABULARY_RESULT = '-';

var Vocabulary = exports.Vocabulary = function (_Component) {
  _inherits(Vocabulary, _Component);

  function Vocabulary() {
    _classCallCheck(this, Vocabulary);

    return _possibleConstructorReturn(this, (Vocabulary.__proto__ || Object.getPrototypeOf(Vocabulary)).apply(this, arguments));
  }

  _createClass(Vocabulary, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          groupId = _props.groupId,
          vocabulary = _props.vocabulary;


      if (_omniCommonUi.ApiResponseHelper.shouldFetch(vocabulary)) {
        this.props.fetchVocabularyIfNeeded(groupId);
      }
    }
  }, {
    key: '_getHighlightedColumns',
    value: function _getHighlightedColumns() {
      var _props2 = this.props,
          units = _props2.units,
          defaultUnits = _props2.defaultUnits;


      if (_is_js2.default.undefined(units)) {
        return [0];
      }

      var unitIds = units.valueSeq().toArray().map(function (u) {
        return u.id;
      });

      return _is_js2.default.undefined(defaultUnits) ? [0] : defaultUnits.map(function (u) {
        return unitIds.indexOf(u);
      });
    }
  }, {
    key: '_renderUnitColumns',
    value: function _renderUnitColumns(units) {
      var cellItems = [];

      if (_is_js2.default.undefined(units) || units.size === 0) {
        return cellItems;
      }

      cellItems.push(units.valueSeq().toArray().map(function (unit) {
        return _react2.default.createElement(
          _CourseViewTable2.default.Cell,
          { key: '' + unit.id,
            columnId: unit.id,
            small: true },
          unit.name
        );
      }));

      return cellItems;
    }
  }, {
    key: '_renderCompletedCell',
    value: function _renderCompletedCell(vocabularyByStudent) {
      var completedTooltip = 'The student has mastered all ' + vocabularyByStudent.totalWords + ' words' + (' assigned (9 activities x ' + vocabularyByStudent.totalWords + ' words') + (' = ' + vocabularyByStudent.totalWords * 9 + ' activities passed).');

      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        { text: completedTooltip, overlayClassName: _style2.default.Vocabulary_cell_tooltip },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_style2.default.Vocabulary_cell, _style2.default.Vocabulary_pureCell) },
          _react2.default.createElement(
            'div',
            { className: _style2.default.Vocabulary_pureCell_pureText },
            vocabularyByStudent.completedWords,
            '/',
            vocabularyByStudent.totalWords
          ),
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'success', className: _style2.default.Vocabulary_cell_successIcon })
        )
      );
    }
  }, {
    key: '_renderInCompletedCell',
    value: function _renderInCompletedCell(vocabularyByStudent) {
      var completedWords = vocabularyByStudent.completedWords;
      var activityProgress = Math.round(vocabularyByStudent.completedRatio * 100);
      var wordProgress = completedWords + '/' + vocabularyByStudent.totalWords;
      var wordsTooltip = wordProgress + ' means the student has' + ('' + (completedWords > 0 ? ' mastered ' + completedWords : ' not mastered any')) + (' of the ' + vocabularyByStudent.totalWords + ' words assigned.');
      var masteredDes = completedWords > 0 ? ' and has mastered ' + wordProgress + ' words assigned' : ' but has not yet mastered any of the words.';
      var progressTooltip = 'The student has finished activities in the Vocabulary Trainer' + (' (about ' + activityProgress + '% of the total activities)' + masteredDes) + ' This student should be encouraged to keep practicing the words to reach mastery.';

      return _react2.default.createElement(
        'div',
        { className: _style2.default.Vocabulary_cell },
        _react2.default.createElement(
          _omniCommonUi.Tooltip,
          { text: wordsTooltip,
            overlayClassName: _style2.default.Vocabulary_cell_tooltip },
          _react2.default.createElement(
            'div',
            { className: _style2.default.Vocabulary_cell_text },
            wordProgress
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.Tooltip,
          { text: progressTooltip,
            overlayClassName: _style2.default.Vocabulary_cell_tooltip,
            placement: 'bottom' },
          _react2.default.createElement(_TableView.ProgressBarTd, { isHideText: true,
            className: _style2.default.Vocabulary_cell_progressBarTd,
            percent: activityProgress })
        )
      );
    }
  }, {
    key: '_renderNoDataCell',
    value: function _renderNoDataCell() {
      var noDataTooltip = 'There is no data for this student.';

      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        { text: noDataTooltip,
          overlayClassName: _style2.default.Vocabulary_cell_tooltip },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_style2.default.Vocabulary_cell, _style2.default.Vocabulary_pureCell) },
          NO_VOCABULARY_RESULT
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          members = _props3.members,
          units = _props3.units,
          vocabulary = _props3.vocabulary;


      if (_is_js2.default.undefined(members) || members.size === 0) {
        return null;
      }

      var headerTooltip = 'Mastery of a word is reached when a student' + 'passes all 9 steps in the Vocabulary Trainer for that word.';

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        null,
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          { text: 'Vocabulary Mastery',
            className: _style2.default.Vocabulary_cardHeader,
            titleClassName: _style2.default.Vocabulary_cardHeader_title },
          _react2.default.createElement(
            _omniCommonUi.Tooltip,
            { text: headerTooltip,
              placement: 'right',
              className: _style2.default.Vocabulary_cardHeader_tooltip },
            _react2.default.createElement(_omniCommonUi.Icon, { id: 'question' })
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.Vocabulary_content },
          _react2.default.createElement(
            _CourseViewTable2.default,
            { students: members, highlightedColumns: this._getHighlightedColumns() },
            _react2.default.createElement(
              _CourseViewTable2.default.Header,
              null,
              _react2.default.createElement(
                _CourseViewTable2.default.Row,
                null,
                this._renderUnitColumns(units)
              )
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Body,
              null,
              function (member, column) {
                var vocabularyByUnit = vocabulary && vocabulary.find(function (item) {
                  return item.unitId === column;
                });
                var vocabularyByStudent = vocabularyByUnit && vocabularyByUnit.studentVocabularyResults && vocabularyByUnit.studentVocabularyResults.find(function (item) {
                  return item.studentId === member.studentGeneralInfo.id;
                });

                if (vocabularyByStudent && _is_js2.default.number(vocabularyByStudent.totalWords) && _is_js2.default.number(vocabularyByStudent.completedWords)) {

                  return vocabularyByStudent.completedRatio >= 1 ? _this2._renderCompletedCell(vocabularyByStudent) : _this2._renderInCompletedCell(vocabularyByStudent);
                }

                return _this2._renderNoDataCell();
              }
            )
          )
        )
      );
    }
  }]);

  return Vocabulary;
}(_react.Component);

Vocabulary.propTypes = {
  units: _propTypes2.default.object,
  members: _propTypes2.default.object,
  vocabulary: _propTypes2.default.object,
  defaultUnits: _propTypes2.default.object,
  groupId: _propTypes2.default.string.isRequired,
  fetchVocabularyIfNeeded: _propTypes2.default.func
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var units = (0, _accessors.getUnitList)(state, groupId);
  var defaultUnits = _SessionPlans.actions.getDefaultUnits(state, groupId);
  var vocabulary = state.get('rootReducer').get('vocabulary') && state.get('rootReducer').get('vocabulary').data;

  return {
    units: units,
    members: members,
    groupId: groupId,
    vocabulary: vocabulary,
    defaultUnits: defaultUnits
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign((0, _redux.bindActionCreators)(_Vocabulary.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(Vocabulary);

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = exports.Vocabulary = undefined;

var _model = __webpack_require__(736);

var _model2 = _interopRequireDefault(_model);

var _actions2 = __webpack_require__(737);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1670);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.actions = _actions;

var Vocabulary = exports.Vocabulary = _model2.default;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _VocabularyResult = __webpack_require__(1668);

var _VocabularyResult2 = _interopRequireDefault(_VocabularyResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VocabularyRecord = (0, _immutable.Record)({
  unitId: undefined,
  studentVocabularyResults: undefined
});

var Vocabulary = function (_VocabularyRecord) {
  _inherits(Vocabulary, _VocabularyRecord);

  function Vocabulary() {
    _classCallCheck(this, Vocabulary);

    return _possibleConstructorReturn(this, (Vocabulary.__proto__ || Object.getPrototypeOf(Vocabulary)).apply(this, arguments));
  }

  return Vocabulary;
}(VocabularyRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      item = _ref2[1];

  if (!item) return [key, item];
  switch (key) {
    case 'unitId':
      return [key, '' + item];
    case 'studentVocabularyResults':
      return [key, new _immutable.List(item.map(function (vocabulary) {
        return _VocabularyResult2.default.create(vocabulary);
      }))];
    default:
      return [key, item];
  }
};

Vocabulary.create = function (data) {
  return new Vocabulary(data).mapEntries(reviver);
};

exports.default = Vocabulary;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_VOCABULARY_RESULTS_FAILURE = exports.FETCH_VOCABULARY_RESULTS_SUCCESS = exports.FETCH_VOCABULARY_RESULTS_REQUEST = undefined;
exports.fetchVocabularyIfNeeded = fetchVocabularyIfNeeded;
exports.fetchVocabulary = fetchVocabulary;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_VOCABULARY_RESULTS_REQUEST = exports.FETCH_VOCABULARY_RESULTS_REQUEST = 'FETCH_VOCABULARY_RESULTS_REQUEST';
var FETCH_VOCABULARY_RESULTS_SUCCESS = exports.FETCH_VOCABULARY_RESULTS_SUCCESS = 'FETCH_VOCABULARY_RESULTS_SUCCESS';
var FETCH_VOCABULARY_RESULTS_FAILURE = exports.FETCH_VOCABULARY_RESULTS_FAILURE = 'FETCH_VOCABULARY_RESULTS_FAILURE';

var buildVocabularyUrl = function buildVocabularyUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/vocabulary-results');
};

function fetchVocabularyIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildVocabularyUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchVocabulary(groupId));
  };
}

function fetchVocabulary(groupId) {
  return function (dispatch) {
    var url = buildVocabularyUrl(groupId);
    var method = 'GET';

    return dispatch(fetchVocabularyRequest()).payload.then(function (response) {
      return dispatch(fetchVocabularySuccess(response));
    }).catch(function (error) {
      return dispatch(fetchVocabularyFailure(error));
    });

    function fetchVocabularyRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_VOCABULARY_RESULTS_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchVocabularySuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_VOCABULARY_RESULTS_SUCCESS,
        payload: payload,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchVocabularyFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_VOCABULARY_RESULTS_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkHomeworkDayView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(15);

var _redux = __webpack_require__(10);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _style = __webpack_require__(1675);

var _style2 = _interopRequireDefault(_style);

var _omniCommonUi = __webpack_require__(0);

var _Student = __webpack_require__(1677);

var _Student2 = _interopRequireDefault(_Student);

var _status = __webpack_require__(109);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _NoContentMessage = __webpack_require__(66);

var _NoContentMessage2 = _interopRequireDefault(_NoContentMessage);

var _PaperBasedHomework = __webpack_require__(135);

var _GroupMembers = __webpack_require__(14);

var _HomeworkContentPopup = __webpack_require__(1684);

var _HomeworkContentPopup2 = _interopRequireDefault(_HomeworkContentPopup);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _accessors = __webpack_require__(209);

var _UiState = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MARKING = 'edit';

var MarkHomeworkDayView = exports.MarkHomeworkDayView = function (_UnsavedChangesTracki) {
  _inherits(MarkHomeworkDayView, _UnsavedChangesTracki);

  function MarkHomeworkDayView(props) {
    _classCallCheck(this, MarkHomeworkDayView);

    var _this = _possibleConstructorReturn(this, (MarkHomeworkDayView.__proto__ || Object.getPrototypeOf(MarkHomeworkDayView)).call(this, props));

    Object.assign(_this.state, {
      students: props.students,
      homeworkContentPopupOpenForSessionId: null,
      isChangeMade: false
    });
    return _this;
  }

  _createClass(MarkHomeworkDayView, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._fetchDataIfNeeded(this.props);
      _get(MarkHomeworkDayView.prototype.__proto__ || Object.getPrototypeOf(MarkHomeworkDayView.prototype), 'componentWillMount', this).call(this);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var students = nextProps.students;

      if (nextProps.location.pathname.endsWith('/edit')) {
        var studentsWithLastChange = this.state.students || students;
        studentsWithLastChange = studentsWithLastChange && this._getStudentsViewModel(studentsWithLastChange);
        students = studentsWithLastChange;
      }
      this.setState({ students: students });
      this._fetchDataIfNeeded(nextProps);
      if (nextProps.location.pathname !== this.props.location.pathname) {
        this.setState({ isChangeMade: false });
      }
    }
  }, {
    key: '_getStudentsViewModel',
    value: function _getStudentsViewModel(studentsWithLastChange) {
      var models = studentsWithLastChange;
      models = models.map(function (lessonHomework) {
        return lessonHomework.update('studentPaperBasedHomeworks', function (studentPaperBasedHomeworks) {
          return studentPaperBasedHomeworks.map(function (studentPaperBasedHomework) {
            return studentPaperBasedHomework.set('homeworkStatus', (0, _status.covertBackendPaperBasedHomeworkStatusToHomeworkStatus)(studentPaperBasedHomework.homeworkStatus, true));
          });
        });
      });
      models = models.map(function (lessonHomework) {
        return lessonHomework.update('studentTutorialHomeworks', function (studentTutorialHomeworks) {
          return studentTutorialHomeworks.map(function (studentTutorialHomework) {
            return studentTutorialHomework.set('homeworkStatus', (0, _status.covertBackendPaperBasedHomeworkStatusToHomeworkStatus)(studentTutorialHomework.homeworkStatus, true));
          });
        });
      });
      return models;
    }
  }, {
    key: '_fetchDataIfNeeded',
    value: function _fetchDataIfNeeded(props) {
      var sessionPlanId = props.params.sessionPlanId;

      props.fetchPaperBasedHomeworkIfNeeded(sessionPlanId);
    }
  }, {
    key: '_handleMark',
    value: function _handleMark(studentId, level, unitId, lessonNumber, status) {
      var _this2 = this;

      var students = this.state.students;

      var updatedEntity = void 0;

      if (level === 'first') updatedEntity = 'studentPaperBasedHomeworks';else if (level === 'second') updatedEntity = 'studentTutorialHomeworks';

      var studentsMapperUpdate = function studentsMapperUpdate(entityType, update) {
        return students.map(function (lessonHomework) {
          if ('' + lessonHomework.unitId === '' + unitId && '' + lessonHomework.lessonNumber === '' + lessonNumber) {
            return lessonHomework.update(entityType, function (studentHomeworks) {
              return studentHomeworks.map(function (studentHomework) {
                return update(studentHomework);
              });
            });
          }
          return lessonHomework;
        });
      };

      students = studentsMapperUpdate(updatedEntity, function (studentHomework) {
        if (studentHomework.studentId === '' + studentId) {
          _this2._gaChangeHomeworkStatus(studentId, studentHomework.homeworkStatus, status);
          return studentHomework.set('homeworkStatus', status);
        }
        return studentHomework;
      });

      this.setState({ students: students, isChangeMade: true });
    }
  }, {
    key: '_handleSaveHomeworkStatus',
    value: function _handleSaveHomeworkStatus() {
      var _props = this.props,
          params = _props.params,
          groupId = _props.groupId,
          submitMarkPaperBasedHomework = _props.submitMarkPaperBasedHomework,
          fetchGroupMembers = _props.fetchGroupMembers;
      var sessionPlanId = params.sessionPlanId;
      var students = this.state.students;

      submitMarkPaperBasedHomework(sessionPlanId, students).then(function () {
        fetchGroupMembers(groupId);
      });
      this._forcePushRoute(this.props.buildRoute('..'));
    }
  }, {
    key: '_gaChangeHomeworkStatus',
    value: function _gaChangeHomeworkStatus(student, perviousStatus, nextStatus) {
      _reactGa2.default.event({
        category: 'PaperBasedHomeworkStatus',
        action: 'Changed status',
        label: 'Changed status for ' + student + ' from ' + perviousStatus + ' to ' + nextStatus
      });
    }
  }, {
    key: '_renderContentPopup',
    value: function _renderContentPopup() {
      var _this3 = this;

      var homeworkContentPopupOpenForSessionId = this.state.homeworkContentPopupOpenForSessionId;


      if (_is_js2.default.not.null(homeworkContentPopupOpenForSessionId)) {
        return _react2.default.createElement(_HomeworkContentPopup2.default, {
          title: 'Paper-based Practice',
          url: '/sessions/' + homeworkContentPopupOpenForSessionId + '/assigned-paper-based-homework',
          onOkButtonClicked: function onOkButtonClicked() {
            return _this3._onContentPopupOkClicked();
          }
        });
      }
      return null;
    }
  }, {
    key: '_onContentPopupOkClicked',
    value: function _onContentPopupOkClicked() {
      this.setState({ homeworkContentPopupOpenForSessionId: null });
      _reactGa2.default.send({
        hitType: 'pageview',
        page: window.location.pathname,
        location: window.location.href,
        title: document.title
      });
    }
  }, {
    key: '_isChangesPresent',
    value: function _isChangesPresent() {
      return this.props.marking && this.state.isChangeMade;
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave(nextLocation) {
      if (nextLocation && nextLocation.pathname.endsWith('/save')) {
        this._handleSaveHomeworkStatus();
      } else if (nextLocation && nextLocation.pathname.endsWith('/discard')) {
        this._forcePushRoute(this.props.buildRoute({ mode: '' }), {
          students: this.props.students
        });
      } else if (nextLocation && nextLocation.pathname.endsWith('/popup')) {
        this._forcePushRoute(this.props.buildRoute({ mode: '' }), {
          homeworkContentPopupOpenForSessionId: this.props.params.sessionPlanId
        });
      } else {
        return _get(MarkHomeworkDayView.prototype.__proto__ || Object.getPrototypeOf(MarkHomeworkDayView.prototype), 'routerWillLeave', this).call(this, nextLocation);
      }
    }
  }, {
    key: '_sortStudentMapByLesson',
    value: function _sortStudentMapByLesson(a, b) {
      if (a.unitOrderingSequence !== b.unitOrderingSequence) {
        return a.unitOrderingSequence - b.unitOrderingSequence;
      }
      return a.lessonNumber - b.lessonNumber;
    }
  }, {
    key: '_sortStudentInLessson',
    value: function _sortStudentInLessson(lessonHomework) {
      var students = lessonHomework.studentPaperBasedHomeworks;
      if (!students) {
        return;
      }
      var sortedStudents = students.sortBy(function (student) {
        return student.studentGeneralInfo.firstName.toLowerCase();
      });
      var inProductionStudents = [];
      var notInProductionStudents = [];
      sortedStudents.map(function (student) {
        if (student.isInProduction) {
          inProductionStudents.push(student);
        } else {
          notInProductionStudents.push(student);
        }
        return false;
      });
      return new _immutable.List(inProductionStudents.concat(notInProductionStudents));
    }
  }, {
    key: '_renderLessonNumber',
    value: function _renderLessonNumber() {
      var _this4 = this;

      var students = this.state.students;

      if (!students || students.size === 0 || students.some(function (student) {
        return student.studentPaperBasedHomeworks.some(function (homework) {
          return _is_js2.default.undefined(homework.studentGeneralInfo);
        });
      })) {
        return _react2.default.createElement(_NoContentMessage2.default, { text: 'No paper-based practice on this session.' });
      }
      return students.sort(this._sortStudentMapByLesson).map(function (lessonHomework) {
        var header = 'Unit ' + lessonHomework.unitOrderingSequence + ', Lesson ' + lessonHomework.lessonNumber;
        var studentHomeworks = _this4._sortStudentInLessson(lessonHomework);
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h2',
            { key: header },
            header
          ),
          studentHomeworks && studentHomeworks.size > 0 ? _react2.default.createElement(
            'div',
            { className: _style2.default.MarkHomeworkDayView_lessonHomework },
            _this4._renderStudent(studentHomeworks, lessonHomework.studentTutorialHomeworks, lessonHomework.unitId, lessonHomework.lessonNumber)
          ) : _react2.default.createElement(_NoContentMessage2.default, { text: 'No paper-based practice on this lesson.' })
        );
      });
    }
  }, {
    key: '_renderStudent',
    value: function _renderStudent(studentHomeworks, studentTutorialHomeworks, unitId, lessonNumber) {
      var _this5 = this;

      return studentHomeworks.map(function (studentHomeworkData) {
        var tutorialHomework = studentTutorialHomeworks.find(function (th) {
          return studentHomeworkData.studentId === th.studentId;
        });
        return _react2.default.createElement(
          _omniCommonUi.Grid.Item,
          {
            key: unitId + '-' + lessonNumber + '-' + studentHomeworkData.studentId,
            xs: 12,
            sm: 6,
            md: 4,
            lg: 3
          },
          _react2.default.createElement(_Student2.default, {
            name: studentHomeworkData.studentGeneralInfo.firstName,
            surname: studentHomeworkData.studentGeneralInfo.lastName,
            avatarUrl: studentHomeworkData.studentGeneralInfo.avatarUrl,
            firstStatus: studentHomeworkData.homeworkStatus || _status.PaperbasedHomeworkStatus.unmarked,
            secondStatus: tutorialHomework ? tutorialHomework.homeworkStatus : undefined,
            productionStatus: studentHomeworkData.studentStatus,
            isInProduction: studentHomeworkData.isInProduction,
            gender: studentHomeworkData.studentGeneralInfo.gender,
            localname: studentHomeworkData.studentGeneralInfo.localName,
            markable: _this5.props.marking,
            onMarkComplete: function onMarkComplete(level) {
              return _this5._handleMark(studentHomeworkData.studentId, level, unitId, lessonNumber, _status.PaperbasedHomeworkStatus.complete);
            },
            onMarkIncomplete: function onMarkIncomplete(level) {
              return _this5._handleMark(studentHomeworkData.studentId, level, unitId, lessonNumber, _status.PaperbasedHomeworkStatus.incomplete);
            },
            onMarkPartialComplete: function onMarkPartialComplete(level) {
              return _this5._handleMark(studentHomeworkData.studentId, level, unitId, lessonNumber, _status.PaperbasedHomeworkStatus.partialcomplete);
            },
            onMarkNA: function onMarkNA(level) {
              return _this5._handleMark(studentHomeworkData.studentId, level, unitId, lessonNumber, _status.PaperbasedHomeworkStatus.notapplicable);
            }
          })
        );
      });
    }
  }, {
    key: '_setSessionCourseSwitchMode',
    value: function _setSessionCourseSwitchMode() {
      this.props.toggleViewMode('day');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _omniCommonUi.Grid,
          null,
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            this._renderLessonNumber()
          )
        ),
        _react2.default.createElement(_UnsavedChangesWarning2.default, {
          isOpen: !!this._isNavigationWithChangesRequested(),
          isSaving: this.props.isAnyApiCallSaving,
          onSaveClicked: function onSaveClicked() {
            _this6._handleSaveHomeworkStatus();
          },
          onDiscardClicked: function onDiscardClicked() {
            _this6._forcePushRequestedLocation();
          },
          onCloseClicked: function onCloseClicked() {
            _this6._setSessionCourseSwitchMode();
            _this6._clearRequestedLocation();
          },
          onSaved: function onSaved() {
            _this6._forcePushRequestedLocation();
          }
        }),
        this._renderContentPopup()
      );
    }
  }]);

  return MarkHomeworkDayView;
}(_UnsavedChangesTrackingPageComponent2.default);

MarkHomeworkDayView.isInMarkingRoute = function (props) {
  return props.params && props.params.mode === MARKING;
};

MarkHomeworkDayView.propTypes = Object.assign({}, _UnsavedChangesTrackingPageComponent2.default.propTypes, {
  params: _propTypes2.default.object.isRequired,
  routes: _propTypes2.default.array.isRequired,
  route: _propTypes2.default.any.isRequired,
  location: _propTypes2.default.object.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  replace: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node,
  markable: _propTypes2.default.bool,
  students: _propTypes2.default.object,
  buildRoute: _propTypes2.default.func.isRequired,
  state: _propTypes2.default.object.isRequired,
  fetchPaperBasedHomeworkIfNeeded: _propTypes2.default.func,
  submitMarkPaperBasedHomework: _propTypes2.default.func,
  isAnyApiCallSaving: _propTypes2.default.func.isRequired,
  sessionType: _propTypes2.default.string
});

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      sessionPlanId = _ownProps$params.sessionPlanId;

  var sessionPlan = state.get('rootReducer').get('sessionPlans').get(sessionPlanId);
  var sessionType = sessionPlan.sessionType;

  var isInMarkingRoute = MarkHomeworkDayView.isInMarkingRoute(ownProps);
  var students = (0, _accessors.getHomeworkStudentList)(state, sessionPlan, groupId);
  var markable = (0, _accessors.isMarkable)(state, groupId, sessionPlanId);
  var viewMode = _UiState.actions.getViewMode(state);
  return {
    markable: markable,
    groupId: ownProps.params.groupId,
    marking: markable && isInMarkingRoute,
    students: students,
    state: state,
    sessionType: sessionType,
    viewMode: viewMode,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_GroupMembers.actions, dispatch), (0, _redux.bindActionCreators)(_UiState.actions, dispatch), (0, _redux.bindActionCreators)(_PaperBasedHomework.actions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(MarkHomeworkDayView);

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkHomeworkCourseView = exports.NO_ACTIVE_MARKING_POPUP_TOKEN = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _PaperBasedHomework = __webpack_require__(135);

var SessionsPaperBased = _interopRequireWildcard(_PaperBasedHomework);

var _GroupMembers = __webpack_require__(14);

var _PaperFolding = __webpack_require__(1689);

var _PaperFolding2 = _interopRequireDefault(_PaperFolding);

var _actions = __webpack_require__(159);

var _ = __webpack_require__(13);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _accessors = __webpack_require__(209);

var _status = __webpack_require__(109);

var _accessors2 = __webpack_require__(41);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _style = __webpack_require__(1692);

var _style2 = _interopRequireDefault(_style);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MARKING = 'edit';
var NO_ACTIVE_MARKING_POPUP_TOKEN = exports.NO_ACTIVE_MARKING_POPUP_TOKEN = -1;

var MarkHomeworkCourseView = exports.MarkHomeworkCourseView = function (_Component) {
  _inherits(MarkHomeworkCourseView, _Component);

  function MarkHomeworkCourseView(props) {
    _classCallCheck(this, MarkHomeworkCourseView);

    var _this = _possibleConstructorReturn(this, (MarkHomeworkCourseView.__proto__ || Object.getPrototypeOf(MarkHomeworkCourseView)).call(this, props));

    _this.state = {
      activeMarkingButtonsToken: NO_ACTIVE_MARKING_POPUP_TOKEN,
      homeworkContentPopupOpenForSessionId: null
    };
    return _this;
  }

  _createClass(MarkHomeworkCourseView, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._fetchPaperBased(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.params && newProps.params.mode !== MARKING) {
        this.setState({
          activeMarkingButtonsToken: NO_ACTIVE_MARKING_POPUP_TOKEN
        });
      }
    }
  }, {
    key: '_fetchPaperBased',
    value: function _fetchPaperBased(props) {
      var fetchGroupPaperBasedHomeworkIfNeeded = props.fetchGroupPaperBasedHomeworkIfNeeded;

      fetchGroupPaperBasedHomeworkIfNeeded(props.params.groupId);
    }
  }, {
    key: '_handleShowCellMarkingButtons',
    value: function _handleShowCellMarkingButtons(activeMarkingButtonsToken) {
      this.setState({
        activeMarkingButtonsToken: activeMarkingButtonsToken
      });
    }
  }, {
    key: '_handlePaperBasedSaved',
    value: function _handlePaperBasedSaved() {
      this.props.fetchGroupMembers(this.props.params.groupId);
    }
  }, {
    key: '_handleCloseCellMarkingButtons',
    value: function _handleCloseCellMarkingButtons() {
      this.setState({
        activeMarkingButtonsToken: NO_ACTIVE_MARKING_POPUP_TOKEN
      });
    }
  }, {
    key: '_gaChangePaperBased',
    value: function _gaChangePaperBased(studentId, currentStatus, nextStatus) {
      _reactGa2.default.event({
        category: 'PaperBasedHomework',
        action: 'Changed paper based homework',
        label: 'Changed paper based homework for ' + studentId + ' from ' + currentStatus + ' to ' + nextStatus
      });
    }
  }, {
    key: '_changeStudentPaperBasedStatus',
    value: function _changeStudentPaperBasedStatus(sessionId, member, paperBased, newStatus, isTutorial) {
      var _this2 = this;

      var submitMarkPaperBasedHomework = this.props.submitMarkPaperBasedHomework;

      var modifiedEntityType = isTutorial ? 'studentTutorialHomeworks' : 'studentPaperBasedHomeworks';
      var modifiedPaperBased = paperBased.update(modifiedEntityType, function (studentHomeworks) {
        return studentHomeworks.map(function (studentHomework) {
          if ('' + studentHomework.studentId === '' + member.studentGeneralInfo.id && studentHomework.homeworkStatus !== newStatus) {
            _this2._gaChangePaperBased(member.studentGeneralInfo.id, studentHomework.homeworkStatus, newStatus);
            return studentHomework.set('homeworkStatus', _status.PaperbasedHomeworkStatus[newStatus && newStatus.toLowerCase()]);
          }
          return studentHomework;
        });
      });
      if (_is_js2.default.function(submitMarkPaperBasedHomework) && modifiedPaperBased !== paperBased) {
        submitMarkPaperBasedHomework(sessionId, [modifiedPaperBased]).then(function () {
          return _this2._handlePaperBasedSaved();
        });
      }
      this.setState({
        isShowingMarkingButtons: false,
        modifiedPaperBased: modifiedPaperBased
      });
    }
  }, {
    key: '_cellOptions',
    value: function _cellOptions(member, _ref) {
      var _this3 = this;

      var sessionId = _ref.sessionId,
          paperBased = _ref.paperBased,
          markable = _ref.markable;

      if (!MarkHomeworkCourseView.isInMarkingRoute(this.props) || !paperBased) {
        return;
      }

      var studentPaperBased = paperBased.studentPaperBasedHomeworks.find(function (att) {
        return '' + att.studentId === '' + member.studentGeneralInfo.id;
      });
      if (!studentPaperBased || !markable) {
        return;
      }

      var studentTutorial = paperBased.studentTutorialHomeworks.find(function (att) {
        return '' + att.studentId === '' + member.studentGeneralInfo.id;
      });

      var paperBasedOptions = [{
        key: 'complete',
        value: {
          label: 'Complete',
          onClick: function onClick() {
            return _this3._changeStudentPaperBasedStatus(sessionId, member, paperBased, _status.PaperbasedHomeworkStatus.complete);
          }
        }
      }, {
        key: 'partialcomplete',
        value: {
          label: 'Partial Complete',
          onClick: function onClick() {
            return _this3._changeStudentPaperBasedStatus(sessionId, member, paperBased, _status.PaperbasedHomeworkStatus.partialcomplete);
          }
        }
      }, {
        key: 'incomplete',
        value: {
          label: 'Incomplete',
          onClick: function onClick() {
            return _this3._changeStudentPaperBasedStatus(sessionId, member, paperBased, _status.PaperbasedHomeworkStatus.incomplete);
          }
        }
      }, {
        key: 'notapplicable',
        value: {
          label: 'Not Applicable',
          onClick: function onClick() {
            return _this3._changeStudentPaperBasedStatus(sessionId, member, paperBased, _status.PaperbasedHomeworkStatus.notapplicable);
          }
        }
      }];

      if (studentTutorial && studentTutorial.size > 0) {
        var tutorialOptions = [{
          key: 'tcomplete',
          value: {
            label: 'Complete',
            onClick: function onClick() {
              return _this3._changeStudentPaperBasedStatus(sessionId, member, paperBased, _status.PaperbasedHomeworkStatus.complete, true);
            }
          }
        }, {
          key: 'tpartialcomplete',
          value: {
            label: 'Partial Complete',
            onClick: function onClick() {
              return _this3._changeStudentPaperBasedStatus(sessionId, member, paperBased, _status.PaperbasedHomeworkStatus.partialcomplete, true);
            }
          }
        }, {
          key: 'tincomplete',
          value: {
            label: 'Incomplete',
            onClick: function onClick() {
              return _this3._changeStudentPaperBasedStatus(sessionId, member, paperBased, _status.PaperbasedHomeworkStatus.incomplete, true);
            }
          }
        }, {
          key: 'tnotapplicable',
          value: {
            label: 'Not Applicable',
            onClick: function onClick() {
              return _this3._changeStudentPaperBasedStatus(sessionId, member, paperBased, _status.PaperbasedHomeworkStatus.notapplicable, true);
            }
          }
        }];

        tutorialOptions.forEach(function (item, index) {
          return paperBasedOptions.splice(2 * index + 1, 0, item);
        });
      }

      var options = {};
      paperBasedOptions.forEach(function (item) {
        options[item.key] = item.value;
      });

      return options;
    }
  }, {
    key: '_onHomeworkContentPopupOkClicked',
    value: function _onHomeworkContentPopupOkClicked() {
      this.setState({ homeworkContentPopupOpenForSessionId: null });
      _reactGa2.default.send({
        hitType: 'pageview',
        page: window.location.pathname,
        location: window.location.href,
        title: document.title
      });
    }
  }, {
    key: '_setHighlightedColumnsNo',
    value: function _setHighlightedColumnsNo(paperBased, defaultSession) {
      var firstIndexOfHighlightedColumn = paperBased.reduce(function (startIndex, sessionsPaperBased) {
        if (sessionsPaperBased.first().sessionIndex < defaultSession.index) {
          return startIndex + sessionsPaperBased.size;
        }
        return startIndex;
      }, 0);
      var highlightedColumnSize = paperBased.get('' + defaultSession.id) && paperBased.get('' + defaultSession.id).size;
      var highlightedColumns = [];
      for (var i = 0; i < highlightedColumnSize; i++) {
        highlightedColumns[i] = firstIndexOfHighlightedColumn + i;
      }
      return highlightedColumns;
    }
  }, {
    key: '_sortLesson',
    value: function _sortLesson(a, b) {
      if (a.unitOrderingSequence !== b.unitOrderingSequence) {
        return a.unitOrderingSequence - b.unitOrderingSequence;
      }
      return a.lessonNumber - b.lessonNumber;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          members = _props.members,
          sessionPlans = _props.sessionPlans,
          paperBased = _props.paperBased,
          markableSessionIds = _props.markableSessionIds;

      if (!_immutable.List.isList(members) || !_immutable.List.isList(sessionPlans)) {
        return null;
      }
      var defaultSession = (0, _actions.calculatePreviousSession)(sessionPlans);
      var defaultSessionIndex = paperBased && paperBased.size > 0 && this._setHighlightedColumnsNo(paperBased, defaultSession);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _CourseViewTable2.default,
          {
            students: members,
            highlightedColumns: defaultSessionIndex
          },
          _react2.default.createElement(
            _CourseViewTable2.default.Header,
            null,
            _react2.default.createElement(
              _CourseViewTable2.default.Row,
              null,
              paperBased.map(function (sessionPaperBased) {
                return sessionPaperBased.sort(_this4._sortLesson).map(function (lessonPaperBased) {
                  var columnId = {
                    sessionId: lessonPaperBased.sessionId,
                    paperBased: lessonPaperBased,
                    markable: markableSessionIds.includes(lessonPaperBased.sessionId)
                  };

                  return _react2.default.createElement(
                    _CourseViewTable2.default.Cell,
                    { columnId: columnId, small: true },
                    _react2.default.createElement(
                      'span',
                      { className: _style2.default.MarkHomeworkCourseView_header },
                      'S' + lessonPaperBased.sessionIndex + ', U' + lessonPaperBased.unitOrderingSequence + ', L' + lessonPaperBased.lessonNumber
                    )
                  );
                });
              })
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Row,
              null,
              paperBased.map(function (sessionPaperBased) {
                return sessionPaperBased.map(function (lessonPaperBased) {
                  var timeZone = _this4.props.timeZone;

                  var currentSessionPlan = sessionPlans.find(function (plan) {
                    return plan.id === lessonPaperBased.sessionId;
                  });
                  var date = _omniCommonUi.moment.parseZone(currentSessionPlan.period.start).clone().tz(timeZone);
                  return _react2.default.createElement(
                    _CourseViewTable2.default.Cell,
                    null,
                    _react2.default.createElement(
                      'time',
                      { dateTime: date.format('YYYY-MM-DD') },
                      date.format('ddd'),
                      _react2.default.createElement('br', null),
                      date.format('D'),
                      '\xA0',
                      date.format('MMM')
                    )
                  );
                });
              })
            )
          ),
          _react2.default.createElement(
            _CourseViewTable2.default.Body,
            {
              firstOptionHeader: 'Practice Book',
              secondOptionHeader: 'Tutorial Book',
              cellOptions: function cellOptions() {
                return _this4._cellOptions.apply(_this4, arguments);
              }
            },
            function (member, column) {
              var studentPaperBased = column.paperBased && column.paperBased.studentPaperBasedHomeworks && column.paperBased.studentPaperBasedHomeworks.find(function (att) {
                return '' + att.studentId === '' + member.studentGeneralInfo.id;
              });
              var studentTutorial = column.paperBased && column.paperBased.studentTutorialHomeworks && column.paperBased.studentTutorialHomeworks.find(function (att) {
                return '' + att.studentId === '' + member.studentGeneralInfo.id;
              });
              var paperBasedStatus = studentPaperBased && studentPaperBased.homeworkStatus;
              var tutorialStatus = studentTutorial && studentTutorial.homeworkStatus;
              return _react2.default.createElement(
                'div',
                { className: _style2.default.MarkHomeworkCourseView_content },
                column.markable || paperBasedStatus && paperBasedStatus !== 'UnMarked' ? _react2.default.createElement(_PaperFolding2.default, { paperBasedStatus: paperBasedStatus }) : '-',
                column.markable && tutorialStatus ? _react2.default.createElement(_PaperFolding2.default, { paperBasedStatus: tutorialStatus }) : null
              );
            }
          )
        )
      );
    }
  }]);

  return MarkHomeworkCourseView;
}(_react.Component);

MarkHomeworkCourseView.isInMarkingRoute = function (props) {
  return props.params && props.params.mode === MARKING;
};

MarkHomeworkCourseView.propTypes = {
  timeZone: _propTypes2.default.string.isRequired,
  members: _propTypes2.default.shape().isRequired,
  sessionPlans: _propTypes2.default.shape().isRequired,
  markableSessionIds: _propTypes2.default.shape().isRequired,
  paperBased: _propTypes2.default.shape().isRequired,
  params: _propTypes2.default.shape().isRequired,
  fetchGroupMembers: _propTypes2.default.func,
  fetchGroupPaperBasedHomeworkIfNeeded: _propTypes2.default.func.isRequired,
  submitMarkPaperBasedHomework: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var group = state.get('rootReducer').get('groups').get(groupId);
  var units = (0, _accessors2.getUnitList)(state, groupId);
  var sessionPlans = new _immutable.List(group.data.sessionPlans.data).map(function (id) {
    return state.get('rootReducer').get('sessionPlans').get(id);
  });
  var markableSessionIds = sessionPlans.filter(function (plan) {
    return (0, _accessors.isMarkable)(state, groupId, plan.id);
  }).map(function (plan) {
    return plan.id;
  });
  var paperBasedFilterByGoup = state.get('rootReducer').get('paperBasedHomework').filter(function (data, id) {
    return sessionPlans.find(function (session) {
      return session && '' + session.id === '' + id;
    }) && data.size > 0;
  });
  paperBasedFilterByGoup = paperBasedFilterByGoup.map(function (sessionPaperBased) {
    return sessionPaperBased.map(function (paperBased) {
      return paperBased.set('unitOrderingSequence', (0, _accessors2.getUnitNumberById)(units, '' + paperBased.unitId)).set('sessionIndex', sessionPlans.find(function (plan) {
        return plan.id === '' + paperBased.sessionId;
      }).index);
    });
  });
  return {
    timeZone: _.actions.getCentre(state, groupId).timeZone,
    members: _GroupMembers.actions.getMembersByGroup(state, groupId),
    sessionPlans: sessionPlans,
    markableSessionIds: markableSessionIds,
    paperBased: paperBasedFilterByGoup.sortBy(function (sessionPaperBased) {
      return sessionPaperBased.first().sessionIndex;
    })
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign((0, _redux.bindActionCreators)(SessionsPaperBased.actions, dispatch), (0, _redux.bindActionCreators)(_GroupMembers.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(MarkHomeworkCourseView);

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssignHomework = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _accessors = __webpack_require__(36);

var Session = _interopRequireWildcard(_accessors);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(15);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignHomework = exports.AssignHomework = function (_PureComponent) {
  _inherits(AssignHomework, _PureComponent);

  function AssignHomework() {
    _classCallCheck(this, AssignHomework);

    return _possibleConstructorReturn(this, (AssignHomework.__proto__ || Object.getPrototypeOf(AssignHomework)).apply(this, arguments));
  }

  _createClass(AssignHomework, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._redirectTo();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._redirectTo(nextProps);
    }
  }, {
    key: '_redirectTo',
    value: function _redirectTo() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var sessionPlanId = props.sessionPlanId,
          unitId = props.unitId;

      if (props.location.pathname.endsWith('assign-homework')) {
        props.push(props.buildRoute('session/' + sessionPlanId + '/(unit/' + unitId + ')'));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);

  return AssignHomework;
}(_react.PureComponent);

AssignHomework.propTypes = {
  children: _propTypes2.default.node.isRequired,
  groupId: _propTypes2.default.string.isRequired,
  push: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  unitId: _propTypes2.default.string.isRequired,
  sessionPlanId: _propTypes2.default.string.isRequired,
  location: _propTypes2.default.shape.isRequired
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var defaultSession = Session.getDefaultSession(state, groupId);
  var sessionPlanId = defaultSession && defaultSession.id;
  var unitId = Session.getFirstUnitOfSession(state, sessionPlanId);
  return {
    groupId: groupId,
    sessionPlanId: sessionPlanId,
    unitId: unitId
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, { replaceRoute: function replaceRoute(path) {
      return dispatch((0, _reactRouterRedux.replace)(path));
    } });
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(AssignHomework);

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Assignments = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1698);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _reactRouterRedux = __webpack_require__(15);

var _redux = __webpack_require__(10);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _GroupHomeworkCard = __webpack_require__(1700);

var _GroupHomeworkCard2 = _interopRequireDefault(_GroupHomeworkCard);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _DeleteWarning = __webpack_require__(1705);

var _DeleteWarning2 = _interopRequireDefault(_DeleteWarning);

var _NoContentMessage = __webpack_require__(66);

var _NoContentMessage2 = _interopRequireDefault(_NoContentMessage);

var _ = __webpack_require__(13);

var _GroupMembers = __webpack_require__(14);

var _Content = __webpack_require__(742);

var _Personalised = __webpack_require__(136);

var _UiState = __webpack_require__(30);

var _PaperBasedHomework = __webpack_require__(135);

var _Homework = __webpack_require__(137);

var _Users = __webpack_require__(82);

var _ContentItem = __webpack_require__(318);

var _ContentItem2 = _interopRequireDefault(_ContentItem);

var _PersonalisedHomeworkFormCard = __webpack_require__(1713);

var _PersonalisedHomeworkFormCard2 = _interopRequireDefault(_PersonalisedHomeworkFormCard);

var _PersonalisedHomeworkViewCard = __webpack_require__(1727);

var _PersonalisedHomeworkViewCard2 = _interopRequireDefault(_PersonalisedHomeworkViewCard);

var _Template = __webpack_require__(750);

var _Content2 = __webpack_require__(752);

var _accessors = __webpack_require__(41);

var _routes = __webpack_require__(753);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PUBLISHED = _Homework.status.PUBLISHED.toLowerCase();
var NEW = _Homework.status.NEW.toLowerCase();

var Assignments = exports.Assignments = function (_UnsavedChangesTracki) {
  _inherits(Assignments, _UnsavedChangesTracki);

  function Assignments() {
    _classCallCheck(this, Assignments);

    var _this = _possibleConstructorReturn(this, (Assignments.__proto__ || Object.getPrototypeOf(Assignments)).call(this));

    _this.state = {
      formModel: undefined,
      isFormSaveable: false,
      formSaveFunction: function formSaveFunction() {}
    };
    _this._onSubmitPersonalisedHomework = _this._onSubmitPersonalisedHomework.bind(_this);
    _this._onDiscardPersonalisedHomework = _this._onDiscardPersonalisedHomework.bind(_this);
    _this._onFormNowSaveable = _this._onFormNowSaveable.bind(_this);
    _this._onFormNotSaveable = _this._onFormNotSaveable.bind(_this);
    return _this;
  }

  _createClass(Assignments, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._fetchData(this.props);
      this._prepareEditor(this.props);
      _get(Assignments.prototype.__proto__ || Object.getPrototypeOf(Assignments.prototype), 'componentWillMount', this).call(this);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._fetchData(nextProps);
      this._prepareEditor(this.props);

      // when moving between modes the form will no longer be saveable (fo sho')
      if (nextProps.params.mode !== this.props.params.mode) {
        this.setState({ isFormSaveable: false, formSaveFunction: function formSaveFunction() {} });
      }
    }
  }, {
    key: '_fetchData',
    value: function _fetchData(props) {
      var currentSessionId = props.currentSessionId;

      this.props.fetchOnlineHomeworkContentIfNeeded(currentSessionId);
      if (this.props.hasGroupHomework) {
        this.props.fetchHomeworkContentIfNeeded(currentSessionId);
        this.props.fetchHomeworkTemplateIfNeeded(currentSessionId);
      }
      this.props.fetchHomeworkIfNeeded(currentSessionId);
    }
  }, {
    key: '_prepareEditor',
    value: function _prepareEditor() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var personalisedHomework = props.personalisedHomework,
          personalisedHomeworkViewModels = props.personalisedHomeworkViewModels,
          params = props.params;

      if (Assignments.isInAddPersonalisedHomeworkMode(props)) {
        this.setState({ formModel: _Personalised.PersonalisedHomework.create() });
      } else if (Assignments.isInEditPersonalisedHomeworkMode(props) && personalisedHomework) {
        var formModel = personalisedHomework.find(function (hw) {
          return hw.id === params.personalisedHomeworkId;
        });
        var viewModel = personalisedHomeworkViewModels.find(function (hw) {
          return hw.id === params.personalisedHomeworkId;
        });
        // FORM PRIVILEGE CHECK: Block edit if we don't have permission!
        if (!formModel || !viewModel.canEdit) return;
        this.setState({ formModel: formModel });
      } else if (this.state.formModel) {
        this.setState({ formModel: undefined });
      }
    }
  }, {
    key: '_isChangesPresent',
    value: function _isChangesPresent() {
      // TODO: add checks for update here as it's implemented
      return !!this.state.isFormSaveable && (Assignments.isInAddPersonalisedHomeworkMode(this.props) || Assignments.isInEditPersonalisedHomeworkMode(this.props) || Assignments.isInEditGroupHomeworkMode(this.props));
    }
  }, {
    key: '_onSubmitPersonalisedHomework',
    value: function _onSubmitPersonalisedHomework(model) {
      var _this2 = this;

      var shouldStayOnPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _props = this.props,
          currentSessionId = _props.currentSessionId,
          submitPersonalisedHomeworkModel = _props.submitPersonalisedHomeworkModel,
          userId = _props.userId,
          buildRoute = _props.buildRoute;
      // fill in missing bits to pretend we got this from the server :)

      var finalModel = model.merge({
        sessionId: currentSessionId,
        createdByUserId: userId
      });
      submitPersonalisedHomeworkModel(finalModel).then(function () {
        if (shouldStayOnPage) return;
        _this2._forcePushRoute(buildRoute({ mode: '', personalisedHomeworkId: '' }));
      });
    }
  }, {
    key: '_onDiscardPersonalisedHomework',
    value: function _onDiscardPersonalisedHomework() {
      var buildRoute = this.props.buildRoute;

      this._forcePushRoute(buildRoute({ mode: '', personalisedHomeworkId: '' }));
    }
  }, {
    key: '_onFormNowSaveable',
    value: function _onFormNowSaveable() {
      var that = this; // this is needed I don't know why
      this.setState({ isFormSaveable: true,
        formSaveFunction: function formSaveFunction() {
          that.personalisedHomeworkComponent.getWrappedInstance().forceSubmit(true);
        }
      });
    }
  }, {
    key: '_onFormNotSaveable',
    value: function _onFormNotSaveable() {
      this.setState({ isFormSaveable: false, formSaveFunction: function formSaveFunction() {} });
    }
  }, {
    key: '_getEditPersonalisedHomeworkLinkHref',
    value: function _getEditPersonalisedHomeworkLinkHref(personalisedHomeworkId) {
      var buildRoute = this.props.buildRoute;

      return buildRoute({
        mode: _routes.Modes.EDIT_PERSONALISED_HW,
        personalisedHomeworkId: personalisedHomeworkId
      });
    }
  }, {
    key: '_getDeletePersonalisedHomeworkLinkHref',
    value: function _getDeletePersonalisedHomeworkLinkHref(personalisedHomeworkId) {
      var buildRoute = this.props.buildRoute;

      return buildRoute({
        mode: _routes.Modes.DELETE_PERSONALISED_HW,
        personalisedHomeworkId: personalisedHomeworkId
      });
    }
  }, {
    key: '_renderPersonalisedHomeworkForm',
    value: function _renderPersonalisedHomeworkForm() {
      var _this3 = this;

      var formModel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.formModel;
      var _props2 = this.props,
          students = _props2.students,
          personalisedHomework = _props2.personalisedHomework,
          group = _props2.group;
      var courseTypeLevelId = group.courseTypeLevelId;

      var personalisedHomeworkIndex = personalisedHomework && personalisedHomework.indexOf(formModel);
      var formHeadingText = _is_js2.default.number(personalisedHomeworkIndex) && personalisedHomeworkIndex > -1 ? 'Personalised Practice ' + (personalisedHomeworkIndex + 1) : 'Personalised Practice';

      if (_is_js2.default.undefined(students)) {
        return null;
      }

      return _react2.default.createElement(_PersonalisedHomeworkFormCard2.default, { ref: function ref(_cmpnt) {
          _this3.personalisedHomeworkComponent = _cmpnt;
        },
        courseTypeLevelId: courseTypeLevelId,
        model: formModel,
        overrideHeadingText: formHeadingText,
        students: students,
        onSubmit: this._onSubmitPersonalisedHomework,
        onDiscard: this._onDiscardPersonalisedHomework,
        onNowSaveable: this._onFormNowSaveable,
        onNotSaveable: this._onFormNotSaveable });
    }
  }, {
    key: '_renderOnlineSection',
    value: function _renderOnlineSection(onlineHomeworkContent) {
      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _omniCommonUi.testClass)('assignHomework-online-content') },
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          { text: 'Online', stackMode: 'horizontal' },
          _react2.default.createElement(
            _omniCommonUi.Tooltip,
            { text: 'Locked',
              placement: 'top',
              trigger: ['hover'] },
            _react2.default.createElement(_omniCommonUi.Icon, { id: 'lock' })
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.AssignHomework_online_content },
          onlineHomeworkContent.map(function (content) {
            return (// eslint-disable-line no-confusing-arrow
              _is_js2.default.not.empty(content.contentItems) ? [_react2.default.createElement(
                'h4',
                { key: content.lessonNumber },
                'Unit ',
                content.unitOrderingSequence,
                ', Lesson ',
                content.lessonNumber
              ), content.contentItems.map(function (item) {
                return _react2.default.createElement(_ContentItem2.default, { key: content.lessonNumber + '-' + item.name,
                  boardTitle: item.name,
                  boardValue: item.description });
              })] : null
            );
          })
        )
      );
    }
  }, {
    key: '_renderOnlineHomeworkContent',
    value: function _renderOnlineHomeworkContent() {
      var onlineHomeworkContent = this.props.onlineHomeworkContent;

      if (!onlineHomeworkContent || onlineHomeworkContent.size === 0) return;
      return this._renderOnlineSection(onlineHomeworkContent);
    }
  }, {
    key: '_renderPersonalisedHomework',
    value: function _renderPersonalisedHomework() {
      var _this4 = this;

      var _props3 = this.props,
          group = _props3.group,
          personalisedHomework = _props3.personalisedHomework,
          personalisedHomeworkViewModels = _props3.personalisedHomeworkViewModels,
          students = _props3.students;
      var courseTypeLevelId = group.courseTypeLevelId;

      if (_is_js2.default.undefined(personalisedHomework) || personalisedHomework.size === 0) {
        return null;
      }

      return personalisedHomeworkViewModels.map(function (ph, index) {
        var phStudents = students && students.filter(function (s) {
          return ph.studentIds.includes(s.studentGeneralInfo.id);
        });
        if (_is_js2.default.falsy(phStudents)) {
          return null;
        }
        if (ph && _this4.state.formModel && ph.id === _this4.state.formModel.id) {
          return null;
        }
        return _react2.default.createElement(_PersonalisedHomeworkViewCard2.default, { key: ph.id,
          students: phStudents,
          index: index,
          contentClassName: _style2.default.AssignHomework_online_content,
          editPersonalisedHomeworkLinkHref: _this4._getEditPersonalisedHomeworkLinkHref(ph.id),
          deletePersonalisedHomeworkLinkHref: _this4._getDeletePersonalisedHomeworkLinkHref(ph.id),
          personalisedHomework: ph,
          courseTypeLevelId: courseTypeLevelId });
      });
    }
  }, {
    key: '_renderUnsavedChangesWarningDialog',
    value: function _renderUnsavedChangesWarningDialog() {
      var _this5 = this;

      return _react2.default.createElement(_UnsavedChangesWarning2.default, { isOpen: !!this._isNavigationWithChangesRequested(),
        isSaving: this.props.isAnyApiCallSaving,
        onSaveClicked: this.state.formSaveFunction,
        onDiscardClicked: function onDiscardClicked() {
          _this5._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this5._clearRequestedLocation();
        },
        onSaved: function onSaved() {
          _this5._forcePushRequestedLocation();
        } });
    }
  }, {
    key: '_renderDeleteWarningDialog',
    value: function _renderDeleteWarningDialog() {
      var _this6 = this;

      var _props4 = this.props,
          buildRoute = _props4.buildRoute,
          pushRoute = _props4.pushRoute,
          personalisedHomeworkId = _props4.params.personalisedHomeworkId,
          personalisedHomework = _props4.personalisedHomework,
          personalisedHomeworkViewModels = _props4.personalisedHomeworkViewModels;

      var viewModel = personalisedHomeworkViewModels && personalisedHomeworkViewModels.find(function (hw) {
        return hw.id === personalisedHomeworkId;
      });
      // DELETE PRIVILEGE CHECK: Block delete if we don't have permission!
      if (!viewModel || !viewModel.canEdit) return;
      var clearDeleteWarning = function clearDeleteWarning() {
        pushRoute(buildRoute({ mode: '', personalisedHomeworkId: null }));
      };
      var onDeleteClicked = function onDeleteClicked() {
        personalisedHomeworkId && _this6.props.deletePersonalisedHomework(personalisedHomeworkId);
        clearDeleteWarning();
      };
      var modelIndex = personalisedHomework.findIndex(function (hw) {
        return hw.id === personalisedHomeworkId;
      });
      return _react2.default.createElement(_DeleteWarning2.default, { isOpen: Assignments.isInDeletePersonalisedHomeworkMode(this.props),
        warningMessage: 'Are you sure you want to delete Personalised Homework ' + (modelIndex + 1) + '?',
        isDeleting: this.props.isAnyApiCallSaving,
        onDeleteClicked: onDeleteClicked,
        onDiscardClicked: clearDeleteWarning,
        onCloseClicked: clearDeleteWarning });
    }
  }, {
    key: '_renderPublishDialog',
    value: function _renderPublishDialog() {
      var _this7 = this;

      var _props5 = this.props,
          buildRoute = _props5.buildRoute,
          pushRoute = _props5.pushRoute,
          isHasPublishPrivilege = _props5.isHasPublishPrivilege;
      // PUBLISH PRIVILEGE CHECK: Don't show this dialog if we don't have permission!

      if (!isHasPublishPrivilege) return null;
      var returnToView = function returnToView() {
        pushRoute(buildRoute({ mode: '' }));
      };
      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: Assignments.isInPublishMode(this.props),
          isLoading: this.props.isAnyApiCallSaving,
          primaryButtonContent: 'Publish',
          secondaryButtonContent: 'Cancel',
          onPrimaryClick: function onPrimaryClick() {
            return _this7._publishHomework();
          },
          onSecondaryClick: returnToView,
          onRequestClose: returnToView },
        _react2.default.createElement(
          'span',
          null,
          'Content submitted cannot be edited.'
        )
      );
    }
  }, {
    key: '_renderClearDialog',
    value: function _renderClearDialog() {
      var _this8 = this;

      var _props6 = this.props,
          buildRoute = _props6.buildRoute,
          pushRoute = _props6.pushRoute;

      var returnToView = function returnToView() {
        pushRoute(buildRoute({ mode: '' }));
      };
      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: Assignments.isInClearMode(this.props),
          isLoading: this.props.isAnyApiCallSaving,
          primaryButtonContent: 'Continue',
          secondaryButtonContent: 'Cancel',
          onPrimaryClick: function onPrimaryClick() {
            return _this8._clearHomework();
          },
          onSecondaryClick: returnToView,
          onRequestClose: returnToView },
        _react2.default.createElement(
          'span',
          null,
          'Please note that clicking \'Continue\' will clear your assigned practice and clear the practice completion for this practice.'
        )
      );
    }
  }, {
    key: '_publishHomework',
    value: function _publishHomework() {
      var _props7 = this.props,
          buildRoute = _props7.buildRoute,
          pushRoute = _props7.pushRoute,
          publishHomework = _props7.publishHomework,
          homework = _props7.homework,
          publishPersonalisedHomework = _props7.publishPersonalisedHomework,
          personalisedHomework = _props7.personalisedHomework,
          currentSessionId = _props7.currentSessionId,
          fetchHomeworkContent = _props7.fetchHomeworkContent;

      Promise.all([publishHomework(homework.sessionId)].concat(personalisedHomework.filter(function (ph) {
        return ph.status && ph.status.toLowerCase() !== PUBLISHED;
      }).map(function (ph) {
        return publishPersonalisedHomework(ph.id);
      }))).then(function () {
        pushRoute(buildRoute({ mode: '' }));
      }).then(function () {
        return fetchHomeworkContent(currentSessionId);
      });
    }
  }, {
    key: '_clearHomework',
    value: function _clearHomework() {
      var _props8 = this.props,
          buildRoute = _props8.buildRoute,
          pushRoute = _props8.pushRoute,
          clearHomework = _props8.clearHomework,
          currentSessionId = _props8.currentSessionId,
          fetchHomeworkContent = _props8.fetchHomeworkContent,
          fetchPaperBasedHomework = _props8.fetchPaperBasedHomework;


      return clearHomework(currentSessionId).then(function () {
        pushRoute(buildRoute({ mode: '' }));
      }).then(function () {
        fetchHomeworkContent(currentSessionId);
        fetchPaperBasedHomework(currentSessionId);
      });
    }
  }, {
    key: '_getAssignedGroupHomework',
    value: function _getAssignedGroupHomework(editedGroupHomeworks) {
      var toSaveHomeworkItems = editedGroupHomeworks.map(function (homwork) {
        return homwork.update('contentItems', function (contentItems) {
          return contentItems.filter(function (item) {
            return !!item.isAssigned;
          });
        });
      });
      return toSaveHomeworkItems;
    }
  }, {
    key: '_renderGroupHomeworkContent',
    value: function _renderGroupHomeworkContent() {
      var _this9 = this;

      var _props9 = this.props,
          homework = _props9.homework,
          homeworkContent = _props9.homeworkContent,
          assignHomeworkContent = _props9.assignHomeworkContent,
          currentSessionId = _props9.currentSessionId,
          markable = _props9.markable,
          currentSessionDate = _props9.currentSessionDate,
          homeworkTemplate = _props9.homeworkTemplate,
          buildRoute = _props9.buildRoute;

      if (!homework || (!homeworkTemplate || homeworkTemplate.size === 0) && (!homeworkContent || homeworkContent.size === 0)) {
        return;
      }

      return _react2.default.createElement(_GroupHomeworkCard2.default, { homeworkContent: homeworkContent,
        homeworkTemplate: homeworkTemplate,
        isNewStatus: homework.homeworkResultStatus.toLowerCase() === NEW,
        editMode: Assignments.isInEditGroupHomeworkMode(this.props) && this.props.canEditHomework,
        onEditClick: function onEditClick() {
          _this9._forcePushRoute(buildRoute({ mode: _routes.Modes.EDIT_GROUP_HOMEWORK, personalisedHomeworkId: '' }));
        },
        onNowSaveable: function onNowSaveable(groupHomeworkItems) {
          return _this9.setState({ isFormSaveable: true,
            formSaveFunction: function formSaveFunction() {
              assignHomeworkContent(currentSessionId, _this9._getAssignedGroupHomework(groupHomeworkItems));
            } });
        },
        onSaveClick: function onSaveClick(groupHomeworkItems) {
          _this9.setState({ isFormSaveable: false, formSaveFunction: function formSaveFunction() {} });
          assignHomeworkContent(currentSessionId, groupHomeworkItems);
          _this9._forcePushRoute(buildRoute({ mode: '' }));
        },
        onDiscardClick: function onDiscardClick() {
          _this9.setState({ isFormSaveable: false, formSaveFunction: function formSaveFunction() {} });
          _this9._forcePushRoute(buildRoute({ mode: '' }));
        },
        canEdit: markable && (0, _omniCommonUi.moment)().isAfter(currentSessionDate) && !Assignments.isInAddPersonalisedHomeworkMode(this.props) && !Assignments.isInEditPersonalisedHomeworkMode(this.props) && !Assignments.isInPublishMode(this.props) && !Assignments.isInClearMode(this.props) && !Assignments.isInEditGroupHomeworkMode(this.props) && this.props.canEditHomework });
    }
  }, {
    key: '_renderContent',
    value: function _renderContent() {
      var _props10 = this.props,
          timeZone = _props10.timeZone,
          sessions = _props10.sessions,
          currentSessionId = _props10.currentSessionId,
          onlineHomeworkContent = _props10.onlineHomeworkContent,
          homeworkContent = _props10.homeworkContent,
          homeworkTemplate = _props10.homeworkTemplate,
          isAnyApiCallLoading = _props10.isAnyApiCallLoading,
          sessionHasPersonalisedHomework = _props10.sessionHasPersonalisedHomework,
          isCurrentHomeowrkPublished = _props10.isCurrentHomeowrkPublished;


      var hasContent = onlineHomeworkContent && onlineHomeworkContent.size > 0 || homeworkTemplate && homeworkTemplate.size > 0 || homeworkContent && homeworkContent.size > 0 || sessionHasPersonalisedHomework || this.state.formModel;

      if (!hasContent) {
        if (isAnyApiCallLoading) return; // loading?
        return _react2.default.createElement(
          _omniCommonUi.Grid,
          { outerMargin: true },
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            _react2.default.createElement(_NoContentMessage2.default, { text: 'No practice was assigned.' })
          )
        );
      }

      var currentSession = sessions.get(currentSessionId);
      var currentSessionIndex = currentSession.index - 1;
      var sessionList = sessions.toList().sortBy(function (session) {
        return session.index;
      });
      var nextSession = sessionList.get(currentSessionIndex + 1);

      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { outerMargin: true },
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          nextSession && _react2.default.createElement(
            'div',
            { className: _style2.default.AssignHomework_header },
            _react2.default.createElement(
              'span',
              { className: _style2.default.AssignHomework_header_duedate },
              'Due On ' + nextSession.period.start.clone().tz(timeZone).format('dddd DD of MMMM')
            ),
            isCurrentHomeowrkPublished && _react2.default.createElement(_omniCommonUi.ColourLabel, { text: 'published', colour: 'green' })
          ),
          this.state.formModel && this._renderPersonalisedHomeworkForm(this.state.formModel),
          this._renderOnlineHomeworkContent(),
          this.props.hasGroupHomework && this._renderGroupHomeworkContent(),
          this._renderPersonalisedHomework()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this._renderContent(),
        this._renderUnsavedChangesWarningDialog(),
        this._renderDeleteWarningDialog(),
        this._renderPublishDialog(),
        this._renderClearDialog()
      );
    }
  }]);

  return Assignments;
}(_UnsavedChangesTrackingPageComponent2.default);

Assignments.isInAddPersonalisedHomeworkMode = function (props) {
  return props.params.mode === _routes.Modes.CREATE_PERSONALISED_HW;
};

Assignments.isInEditPersonalisedHomeworkMode = function (props) {
  return props.params.mode === _routes.Modes.EDIT_PERSONALISED_HW;
};

Assignments.isInDeletePersonalisedHomeworkMode = function (props) {
  return props.params.mode === _routes.Modes.DELETE_PERSONALISED_HW;
};

Assignments.isInPublishMode = function (props) {
  return props.params.mode === _routes.Modes.PUBLISH;
};

Assignments.isInClearMode = function (props) {
  return props.params.mode === _routes.Modes.CLEAR;
};

Assignments.isInEditGroupHomeworkMode = function (props) {
  return props.params.mode === _routes.Modes.EDIT_GROUP_HOMEWORK;
};

Assignments.propTypes = {
  params: _propTypes2.default.shape({
    groupId: _propTypes2.default.string,
    sessionPlanId: _propTypes2.default.string
  }),
  isCurrentHomeowrkPublished: _propTypes2.default.bool,
  router: _propTypes2.default.any.isRequired,
  routes: _propTypes2.default.array.isRequired,
  route: _propTypes2.default.any.isRequired,
  location: _propTypes2.default.object.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  currentSessionId: _propTypes2.default.string,
  currentSessionDate: _propTypes2.default.object,
  showNavigationBar: _propTypes2.default.bool,
  sessions: _propTypes2.default.instanceOf(_immutable.Map),
  timeZone: _propTypes2.default.object,
  group: _propTypes2.default.object,
  hasGroupHomework: _propTypes2.default.bool.isRequired,
  students: _propTypes2.default.object,
  units: _propTypes2.default.instanceOf(_immutable.Map),
  onlineHomeworkContent: _propTypes2.default.shape({
    map: _propTypes2.default.func,
    size: _propTypes2.default.number
  }),
  homeworkTemplate: _propTypes2.default.shape({
    map: _propTypes2.default.func,
    size: _propTypes2.default.number
  }),
  homeworkContent: _propTypes2.default.shape({
    map: _propTypes2.default.func,
    size: _propTypes2.default.number
  }),
  homework: _propTypes2.default.object,
  sessionHasPersonalisedHomework: _propTypes2.default.bool,
  personalisedHomework: _propTypes2.default.object,
  personalisedHomeworkViewModels: _propTypes2.default.object,
  fetchOnlineHomeworkContentIfNeeded: _propTypes2.default.func,
  fetchHomeworkContentIfNeeded: _propTypes2.default.func,
  fetchHomeworkContent: _propTypes2.default.func,
  assignHomeworkContent: _propTypes2.default.func,
  fetchHomeworkIfNeeded: _propTypes2.default.func,
  fetchSessionAttendanceIfNeeded: _propTypes2.default.func,
  fetchHomeworkTemplateIfNeeded: _propTypes2.default.func,
  publishHomework: _propTypes2.default.func,
  clearHomework: _propTypes2.default.func,
  publishPersonalisedHomework: _propTypes2.default.func,
  submitPersonalisedHomeworkModel: _propTypes2.default.func,
  deletePersonalisedHomework: _propTypes2.default.func,
  fetchPaperBasedHomework: _propTypes2.default.func,
  markable: _propTypes2.default.bool,
  isAnyApiCallSaving: _propTypes2.default.bool,
  isHasPublishPrivilege: _propTypes2.default.bool,
  userId: _propTypes2.default.string,
  canEditHomework: _propTypes2.default.bool
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      sessionPlanId = _ownProps$params.sessionPlanId;

  var group = state.get('rootReducer').get('groups').get(groupId).data;
  var hasGroupHomework = _.actions.hasPaperBasedHomework(state, groupId);
  var groupMembers = _GroupMembers.actions.getMembersByGroup(state, group.id);
  var sessions = state.get('rootReducer').get('sessionPlans').filter(function (session) {
    return session.groupId === group.id;
  });
  var currentSessionMembers = sessions.get(sessionPlanId).sessionMembers;
  var currentSessionDate = sessions.get(sessionPlanId).period.start;
  var units = (0, _accessors.getUnitList)(state, groupId);

  var _Group$getCentre = _.actions.getCentre(state, groupId),
      timeZone = _Group$getCentre.timeZone;

  var showNavigationBar = _UiState.actions.getShowNavigationBar(state);
  var isCurrentHomeowrkPublished = _Homework.accessors.isExisty(state, sessionPlanId) && _Homework.accessors.isPublished(state, sessionPlanId);

  var homeworkTemplate = state.get('rootReducer').get('homeworkTemplate').get(sessionPlanId);
  homeworkTemplate = homeworkTemplate && homeworkTemplate.map(function (content) {
    return content.set('unitOrderingSequence', (0, _accessors.getUnitNumberById)(units, content.unitId));
  }).sort(sortHomeworkContent);
  var onlineHomeworkContent = state.get('rootReducer').get('onlineHomeworkContent').get(sessionPlanId);
  onlineHomeworkContent = onlineHomeworkContent && onlineHomeworkContent.map(function (content) {
    return content.set('unitOrderingSequence', (0, _accessors.getUnitNumberById)(units, content.unitId));
  }).sort(sortHomeworkContent);
  var homeworkContent = state.get('rootReducer').get('homeworkContent').get(sessionPlanId);
  homeworkContent = homeworkContent && homeworkContent.map(function (content) {
    return content.set('unitOrderingSequence', (0, _accessors.getUnitNumberById)(units, content.unitId));
  }).sort(sortHomeworkContent);
  var students = _is_js2.default.undefined(currentSessionMembers) ? undefined : groupMembers.filter(function (member) {
    return _is_js2.default.not.undefined(currentSessionMembers.find(function (currentSessionMember) {
      return currentSessionMember === member.studentGeneralInfo.id;
    }));
  });

  var homework = state.get('rootReducer').get('homework').get(sessionPlanId);
  var personalisedHomeworkState = state.get('rootReducer').get('personalisedHomework');
  var personalisedHomework = void 0;
  var personalisedHomeworkViewModels = void 0;
  if (_is_js2.default.not.undefined(homework)) {
    personalisedHomework = personalisedHomeworkState.filter(function (ph) {
      return '' + ph.sessionId === '' + sessionPlanId;
    });
    if (personalisedHomework) {
      personalisedHomework = personalisedHomework && personalisedHomework.toList().sortBy(function (ph) {
        return ph.id;
      });
      personalisedHomeworkViewModels = personalisedHomework.map(function (ph) {
        return _Personalised.accessors.getPersonalisedHomeworkViewModel(state, groupId, ph.id, Assignments.isInEditGroupHomeworkMode({ params: ownProps.params }));
      });
    }
  }
  var markable = _is_js2.default.existy(currentSessionMembers) && homework && checkPersonalisedHomeworkStatus(personalisedHomework, homework);
  var sessionHasPersonalisedHomework = personalisedHomework && !!personalisedHomework.size;
  return {
    currentSessionId: sessionPlanId,
    isCurrentHomeowrkPublished: isCurrentHomeowrkPublished,
    hasGroupHomework: hasGroupHomework,
    groupId: groupId,
    group: group,
    students: students,
    sessions: sessions,
    units: units,
    timeZone: timeZone,
    showNavigationBar: showNavigationBar,
    onlineHomeworkContent: onlineHomeworkContent,
    homeworkContent: homeworkContent,
    homeworkTemplate: homeworkTemplate,
    currentSessionDate: currentSessionDate,
    homework: homework,
    markable: markable,
    sessionHasPersonalisedHomework: sessionHasPersonalisedHomework,
    personalisedHomework: personalisedHomework,
    personalisedHomeworkViewModels: personalisedHomeworkViewModels,
    userId: _Users.accessors.getLoginUserId(state),
    isAnyApiCallLoading: !!isAnyApiCallLoading(state),
    isAnyApiCallSaving: !!isAnyApiCallSaving(state),
    isHasPublishPrivilege: _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.AssignHomework.Publish),
    canEditHomework: !_.actions.isAutoPublishHomework(state, groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.AssignHomework.EditAny)
  };
}

function sortHomeworkContent(a, b) {
  if (a.unitOrderingSequence !== b.unitOrderingSequence) {
    return a.unitOrderingSequence - b.unitOrderingSequence;
  }
  return a.lessonNumber - b.lessonNumber;
}

function checkPersonalisedHomeworkStatus(phs, hw) {
  var publishedPhs = phs.filter(function (ph) {
    return ph.status.toLowerCase() === PUBLISHED;
  });
  return (phs.size === 0 || phs.size !== publishedPhs.size) && hw.homeworkResultStatus.toLowerCase() !== PUBLISHED;
}

function isAnyApiCallLoading(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['GET'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

function isAnyApiCallSaving(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST', 'DELETE'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_Content.actions, dispatch), (0, _redux.bindActionCreators)(_Personalised.actions, dispatch), (0, _redux.bindActionCreators)(_Homework.actions, dispatch), (0, _redux.bindActionCreators)(_Content2.actions, dispatch), (0, _redux.bindActionCreators)(_Template.actions, dispatch), (0, _redux.bindActionCreators)(_PaperBasedHomework.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(Assignments));

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = exports.OnlineHomeworkContent = undefined;

var _model = __webpack_require__(319);

var _model2 = _interopRequireDefault(_model);

var _actions2 = __webpack_require__(743);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1707);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OnlineHomeworkContent = exports.OnlineHomeworkContent = _model2.default;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_ONLINE_HOMEWORK_CONTENT_FAILURE = exports.FETCH_ONLINE_HOMEWORK_CONTENT_SUCCESS = exports.FETCH_ONLINE_HOMEWORK_CONTENT_REQUEST = undefined;
exports.fetchOnlineHomeworkContentIfNeeded = fetchOnlineHomeworkContentIfNeeded;
exports.fetchOnlineHomeworkContent = fetchOnlineHomeworkContent;

var _omniCommonUi = __webpack_require__(0);

var _Api = __webpack_require__(11);

var FETCH_ONLINE_HOMEWORK_CONTENT_REQUEST = exports.FETCH_ONLINE_HOMEWORK_CONTENT_REQUEST = 'FETCH_ONLINE_HOMEWORK_CONTENT_REQUEST';
var FETCH_ONLINE_HOMEWORK_CONTENT_SUCCESS = exports.FETCH_ONLINE_HOMEWORK_CONTENT_SUCCESS = 'FETCH_ONLINE_HOMEWORK_CONTENT_SUCCESS';
var FETCH_ONLINE_HOMEWORK_CONTENT_FAILURE = exports.FETCH_ONLINE_HOMEWORK_CONTENT_FAILURE = 'FETCH_ONLINE_HOMEWORK_CONTENT_FAILURE';

var buildOnlineHomeworkContentUrl = function buildOnlineHomeworkContentUrl(sessionId) {
  return (0, _Api.buildUrl)('/sessions/' + sessionId + '/online-homework');
};

function fetchOnlineHomeworkContentIfNeeded(sessionId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildOnlineHomeworkContentUrl(sessionId) })) {
      return false;
    }

    return dispatch(fetchOnlineHomeworkContent(sessionId));
  };
}

function fetchOnlineHomeworkContent(sessionId) {
  return function (dispatch) {
    var url = buildOnlineHomeworkContentUrl(sessionId);
    var method = 'GET';

    return dispatch(fetchOnlineHomeworkContentRequest()).payload.then(function (response) {
      return dispatch(fetchOnlineHomeworkContentSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchOnlineHomeworkContentFailure(error));
    });

    function fetchOnlineHomeworkContentRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ONLINE_HOMEWORK_CONTENT_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchOnlineHomeworkContentSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ONLINE_HOMEWORK_CONTENT_SUCCESS,
        payload: response,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchOnlineHomeworkContentFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ONLINE_HOMEWORK_CONTENT_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PUBLISH_PERSONALISED_HOMEWORK_FAILURE = exports.PUBLISH_PERSONALISED_HOMEWORK_SUCCESS = exports.PUBLISH_PERSONALISED_HOMEWORK_REQUEST = exports.DELETE_PERSONALISED_HOMEWORK_FAILURE = exports.DELETE_PERSONALISED_HOMEWORK_SUCCESS = exports.DELETE_PERSONALISED_HOMEWORK_REQUEST = exports.SUBMIT_PERSONALISED_HOMEWORK_FAILURE = exports.SUBMIT_PERSONALISED_HOMEWORK_SUCCESS = exports.SUBMIT_PERSONALISED_HOMEWORK_REQUEST = exports.FETCH_PERSONALISED_HOMEWORK_FAILURE = exports.FETCH_PERSONALISED_HOMEWORK_SUCCESS = exports.FETCH_PERSONALISED_HOMEWORK_REQUEST = undefined;
exports.fetchPersonalisedHomeworkIfNeeded = fetchPersonalisedHomeworkIfNeeded;
exports.fetchPersonalisedHomework = fetchPersonalisedHomework;
exports.submitPersonalisedHomeworkModel = submitPersonalisedHomeworkModel;
exports.deletePersonalisedHomework = deletePersonalisedHomework;
exports.publishPersonalisedHomework = publishPersonalisedHomework;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _Api = __webpack_require__(11);

var _model = __webpack_require__(320);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_PERSONALISED_HOMEWORK_REQUEST = exports.FETCH_PERSONALISED_HOMEWORK_REQUEST = 'FETCH_PERSONALISED_HOMEWORK_REQUEST';
var FETCH_PERSONALISED_HOMEWORK_SUCCESS = exports.FETCH_PERSONALISED_HOMEWORK_SUCCESS = 'FETCH_PERSONALISED_HOMEWORK_SUCCESS';
var FETCH_PERSONALISED_HOMEWORK_FAILURE = exports.FETCH_PERSONALISED_HOMEWORK_FAILURE = 'FETCH_PERSONALISED_HOMEWORK_FAILURE';
var SUBMIT_PERSONALISED_HOMEWORK_REQUEST = exports.SUBMIT_PERSONALISED_HOMEWORK_REQUEST = 'SUBMIT_PERSONALISED_HOMEWORK_REQUEST';
var SUBMIT_PERSONALISED_HOMEWORK_SUCCESS = exports.SUBMIT_PERSONALISED_HOMEWORK_SUCCESS = 'SUBMIT_PERSONALISED_HOMEWORK_SUCCESS';
var SUBMIT_PERSONALISED_HOMEWORK_FAILURE = exports.SUBMIT_PERSONALISED_HOMEWORK_FAILURE = 'SUBMIT_PERSONALISED_HOMEWORK_FAILURE';
var DELETE_PERSONALISED_HOMEWORK_REQUEST = exports.DELETE_PERSONALISED_HOMEWORK_REQUEST = 'DELETE_PERSONALISED_HOMEWORK_REQUEST';
var DELETE_PERSONALISED_HOMEWORK_SUCCESS = exports.DELETE_PERSONALISED_HOMEWORK_SUCCESS = 'DELETE_PERSONALISED_HOMEWORK_SUCCESS';
var DELETE_PERSONALISED_HOMEWORK_FAILURE = exports.DELETE_PERSONALISED_HOMEWORK_FAILURE = 'DELETE_PERSONALISED_HOMEWORK_FAILURE';
var PUBLISH_PERSONALISED_HOMEWORK_REQUEST = exports.PUBLISH_PERSONALISED_HOMEWORK_REQUEST = 'PUBLISH_PERSONALISED_HOMEWORK_REQUEST';
var PUBLISH_PERSONALISED_HOMEWORK_SUCCESS = exports.PUBLISH_PERSONALISED_HOMEWORK_SUCCESS = 'PUBLISH_PERSONALISED_HOMEWORK_SUCCESS';
var PUBLISH_PERSONALISED_HOMEWORK_FAILURE = exports.PUBLISH_PERSONALISED_HOMEWORK_FAILURE = 'PUBLISH_PERSONALISED_HOMEWORK_FAILURE';

var buildApiTargetDescriptor = function buildApiTargetDescriptor(personalisedHomeworkId, isUpdate, isDelete) {
  var path = '/personalised-homework';
  if (_is_js2.default.existy(personalisedHomeworkId)) {
    path += '/' + personalisedHomeworkId;
  }
  var method = 'GET';
  if (isUpdate) {
    method = _is_js2.default.existy(personalisedHomeworkId) ? 'PUT' : 'POST';
  }
  if (isDelete) {
    method = 'DELETE';
  }
  return {
    url: (0, _Api.buildUrl)(path),
    method: method
  };
};

var buildPublishPersonalisedHomeworkUrl = function buildPublishPersonalisedHomeworkUrl(phId) {
  return (0, _Api.buildUrl)('/personalised-homework/' + phId + '/publish');
};

function fetchPersonalisedHomeworkIfNeeded(personalisedHomeworkId, status) {
  return function (dispatch, getState) {
    var state = getState();
    var target = buildApiTargetDescriptor(personalisedHomeworkId);
    if (!_omniCommonUi.ApiCall.shouldPerform(state, target)) {
      return false;
    }
    return dispatch(fetchPersonalisedHomework(personalisedHomeworkId, status));
  };
}

function fetchPersonalisedHomework(personalisedHomeworkId, status) {
  return function (dispatch) {
    var target = buildApiTargetDescriptor(personalisedHomeworkId);
    var url = target.url,
        method = target.method;


    return dispatch(fetchPersonalisedHomeworkRequest()).payload.then(function (response) {
      return dispatch(fetchPersonalisedHomeworkSuccess(response, status));
    }).catch(function (error) {
      return dispatch(fetchPersonalisedHomeworkFailure(error));
    });

    function fetchPersonalisedHomeworkRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PERSONALISED_HOMEWORK_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        personalisedHomeworkId: personalisedHomeworkId
      });
    }

    function fetchPersonalisedHomeworkSuccess(personalisedHomework) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PERSONALISED_HOMEWORK_SUCCESS,
        payload: personalisedHomework,
        url: url,
        method: method,
        personalisedHomeworkId: personalisedHomeworkId,
        status: status
      });
    }

    function fetchPersonalisedHomeworkFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PERSONALISED_HOMEWORK_FAILURE,
        error: error,
        url: url,
        method: method,
        personalisedHomeworkId: personalisedHomeworkId
      });
    }
  };
}

function submitPersonalisedHomeworkModel(model) {
  return function (dispatch) {
    var target = buildApiTargetDescriptor(model.id, true);
    var url = target.url,
        method = target.method;

    // will be update with a real fix by applying mutiple content

    var tempModel = {
      sessionId: model.sessionId,
      studentIds: model.studentIds,
      contents: model.contents
    };
    var request = (0, _Api.fetch)(url, {
      method: method,
      body: JSON.stringify(_model2.default.serialize(tempModel))
    });

    return dispatch(fetchPersonalisedHomeworkRequest()).payload.then(function (response) {
      return dispatch(fetchPersonalisedHomeworkSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchPersonalisedHomeworkFailure(error));
    });

    function fetchPersonalisedHomeworkRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_PERSONALISED_HOMEWORK_REQUEST,
        payload: request,
        url: url,
        method: method,
        model: model
      });
    }

    function fetchPersonalisedHomeworkSuccess(personalisedHomework) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_PERSONALISED_HOMEWORK_SUCCESS,
        payload: personalisedHomework,
        url: url,
        method: method,
        model: model
      });
    }

    function fetchPersonalisedHomeworkFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_PERSONALISED_HOMEWORK_FAILURE,
        error: error,
        url: url,
        method: method,
        model: model
      });
    }
  };
}

function deletePersonalisedHomework(personalisedHomeworkId) {
  return function (dispatch) {
    var target = buildApiTargetDescriptor(personalisedHomeworkId, false, true);
    var url = target.url,
        method = target.method;

    var request = (0, _Api.fetch)(url, {
      method: method
    });

    return dispatch(fetchPersonalisedHomeworkRequest()).payload.then(function (response) {
      return dispatch(fetchPersonalisedHomeworkSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchPersonalisedHomeworkFailure(error));
    });

    function fetchPersonalisedHomeworkRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: DELETE_PERSONALISED_HOMEWORK_REQUEST,
        payload: request,
        url: url,
        method: method,
        personalisedHomeworkId: personalisedHomeworkId
      });
    }

    function fetchPersonalisedHomeworkSuccess(personalisedHomework) {
      return _omniCommonUi.ApiCall.createAction({
        type: DELETE_PERSONALISED_HOMEWORK_SUCCESS,
        payload: personalisedHomework,
        url: url,
        method: method,
        personalisedHomeworkId: personalisedHomeworkId
      });
    }

    function fetchPersonalisedHomeworkFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: DELETE_PERSONALISED_HOMEWORK_FAILURE,
        error: error,
        url: url,
        method: method,
        personalisedHomeworkId: personalisedHomeworkId
      });
    }
  };
}

function publishPersonalisedHomework(phId) {
  return function (dispatch) {
    var url = buildPublishPersonalisedHomeworkUrl(phId);
    var method = 'PUT';
    var request = (0, _Api.fetch)(url, { method: method });

    return dispatch(publishPersonalisedHomeworkRequest()).payload.then(function (response) {
      return dispatch(publishPersonalisedHomeworkSuccess(response));
    }).catch(function (error) {
      return dispatch(publishPersonalisedHomeworkFailure(error));
    });

    function publishPersonalisedHomeworkRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: PUBLISH_PERSONALISED_HOMEWORK_REQUEST,
        payload: request,
        url: url,
        method: method,
        phId: phId
      });
    }

    function publishPersonalisedHomeworkSuccess() {
      return _omniCommonUi.ApiCall.createAction({
        type: PUBLISH_PERSONALISED_HOMEWORK_SUCCESS,
        url: url,
        method: method,
        phId: phId
      });
    }

    function publishPersonalisedHomeworkFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: PUBLISH_PERSONALISED_HOMEWORK_FAILURE,
        error: error,
        url: url,
        method: method,
        phId: phId
      });
    }
  };
}

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_HOMEWORK_FAILURE = exports.CLEAR_HOMEWORK_SUCCESS = exports.CLEAR_HOMEWORK_REQUEST = exports.PUBLISH_HOMEWORK_FAILURE = exports.PUBLISH_HOMEWORK_SUCCESS = exports.PUBLISH_HOMEWORK_REQUEST = exports.FETCH_HOMEWORK_FAILURE = exports.FETCH_HOMEWORK_SUCCESS = exports.FETCH_HOMEWORK_REQUEST = undefined;
exports.fetchHomeworkIfNeeded = fetchHomeworkIfNeeded;
exports.fetchHomework = fetchHomework;
exports.publishHomework = publishHomework;
exports.clearHomework = clearHomework;

var _omniCommonUi = __webpack_require__(0);

var _Api = __webpack_require__(11);

var _Personalised = __webpack_require__(136);

var FETCH_HOMEWORK_REQUEST = exports.FETCH_HOMEWORK_REQUEST = 'FETCH_HOMEWORK_REQUEST';
var FETCH_HOMEWORK_SUCCESS = exports.FETCH_HOMEWORK_SUCCESS = 'FETCH_HOMEWORK_SUCCESS';
var FETCH_HOMEWORK_FAILURE = exports.FETCH_HOMEWORK_FAILURE = 'FETCH_HOMEWORK_FAILURE';
var PUBLISH_HOMEWORK_REQUEST = exports.PUBLISH_HOMEWORK_REQUEST = 'PUBLISH_HOMEWORK_REQUEST';
var PUBLISH_HOMEWORK_SUCCESS = exports.PUBLISH_HOMEWORK_SUCCESS = 'PUBLISH_HOMEWORK_SUCCESS';
var PUBLISH_HOMEWORK_FAILURE = exports.PUBLISH_HOMEWORK_FAILURE = 'PUBLISH_HOMEWORK_FAILURE';
var CLEAR_HOMEWORK_REQUEST = exports.CLEAR_HOMEWORK_REQUEST = 'CLEAR_HOMEWORK_REQUEST';
var CLEAR_HOMEWORK_SUCCESS = exports.CLEAR_HOMEWORK_SUCCESS = 'CLEAR_HOMEWORK_SUCCESS';
var CLEAR_HOMEWORK_FAILURE = exports.CLEAR_HOMEWORK_FAILURE = 'CLEAR_HOMEWORK_FAILURE';

var buildGetHomeworkUrl = function buildGetHomeworkUrl(sessionId) {
  return (0, _Api.buildUrl)('/sessions/' + sessionId + '/homework');
};
var buildPublishHomeworkUrl = function buildPublishHomeworkUrl(sessionId) {
  return (0, _Api.buildUrl)('/sessions/' + sessionId + '/homework-publish');
};
var buildClearHomeworkUrl = function buildClearHomeworkUrl(sessionId) {
  return (0, _Api.buildUrl)('/sessions/' + sessionId + '/student-homework-clear');
};

function fetchHomeworkIfNeeded(sessionId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildGetHomeworkUrl(sessionId) })) {
      return false;
    }

    return dispatch(fetchHomework(sessionId));
  };
}

function fetchHomework(sessionId) {
  return function (dispatch) {
    var url = buildGetHomeworkUrl(sessionId);
    var method = 'GET';

    return dispatch(fetchHomeworkRequest()).payload.then(function (response) {
      return dispatch(fetchHomeworkSuccess(response));
    }).then(function (response) {
      response.payload.personalisedHomework && response.payload.personalisedHomework.forEach(function (ph) {
        return dispatch(_Personalised.actions.fetchPersonalisedHomeworkIfNeeded(ph.id, ph.status));
      });
    }).catch(function (error) {
      return dispatch(fetchHomeworkFailure(error));
    });

    function fetchHomeworkRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_HOMEWORK_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchHomeworkSuccess(homework) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_HOMEWORK_SUCCESS,
        payload: homework,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchHomeworkFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_HOMEWORK_FAILURE,
        error: error,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }
  };
}

function publishHomework(sessionId) {
  return function (dispatch) {
    var url = buildPublishHomeworkUrl(sessionId);
    var method = 'PUT'; // why PUT?
    var request = (0, _Api.fetch)(url, { method: method });

    return dispatch(fetchPersonalisedHomeworkRequest()).payload.then(function (response) {
      return dispatch(fetchPersonalisedHomeworkSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchPersonalisedHomeworkFailure(error));
    });

    function fetchPersonalisedHomeworkRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: PUBLISH_HOMEWORK_REQUEST,
        payload: request,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchPersonalisedHomeworkSuccess() {
      return _omniCommonUi.ApiCall.createAction({
        type: PUBLISH_HOMEWORK_SUCCESS,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchPersonalisedHomeworkFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: PUBLISH_HOMEWORK_FAILURE,
        error: error,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }
  };
}

function clearHomework(sessionId) {
  return function (dispatch) {
    var url = buildClearHomeworkUrl(sessionId);
    var method = 'DELETE';
    var request = (0, _Api.fetch)(url, { method: method });

    return dispatch(clearHomeworkRequest()).payload.then(function (response) {
      return dispatch(clearHomeworkSuccess(response));
    }).catch(function (error) {
      return dispatch(clearHomeworkFailure(error));
    });

    function clearHomeworkRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: CLEAR_HOMEWORK_REQUEST,
        payload: request,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function clearHomeworkSuccess() {
      return _omniCommonUi.ApiCall.createAction({
        type: CLEAR_HOMEWORK_SUCCESS,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function clearHomeworkFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: CLEAR_HOMEWORK_FAILURE,
        error: error,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }
  };
}

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var HomeworkStatus = exports.HomeworkStatus = {
  NEW: 'New',
  UPDATED: 'Updated',
  PUBLISHED: 'Published'
};

exports.default = HomeworkStatus;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHomeworkBySessionId = getHomeworkBySessionId;
exports.getHomeworkContentBySessionid = getHomeworkContentBySessionid;
exports.getHomeworkTemplateBySessionId = getHomeworkTemplateBySessionId;
exports.getOnlineHomeworkBySessionId = getOnlineHomeworkBySessionId;
exports.hasWronglyResult = hasWronglyResult;
exports.isPublished = isPublished;
exports.isExisty = isExisty;

var _status = __webpack_require__(746);

var _status2 = _interopRequireDefault(_status);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PUBLISHED = _status2.default.PUBLISHED.toLowerCase();

function getHomeworkBySessionId(state, sessionId) {
  return state.get('rootReducer').get('homework').get('' + sessionId);
}

function getHomeworkContentBySessionid(state, sessionId) {
  return state.get('rootReducer').get('homeworkContent').get(sessionId);
}

function getHomeworkTemplateBySessionId(state, sessionId) {
  return state.get('rootReducer').get('homeworkTemplate').get(sessionId);
}

function getOnlineHomeworkBySessionId(state, sessionId) {
  return state.get('rootReducer').get('onlineHomeworkContent').get(sessionId);
}

function hasWronglyResult(state, sessionId) {
  var homeworkContent = getHomeworkContentBySessionid(state, sessionId);
  var homeworkTemplate = getHomeworkTemplateBySessionId(state, sessionId);
  var onlineHomework = getOnlineHomeworkBySessionId(state, sessionId);
  if (_is_js2.default.existy(homeworkContent) && _is_js2.default.existy(homeworkTemplate) && _is_js2.default.existy(onlineHomework) && homeworkContent.size > 0) {
    return homeworkContent.size !== homeworkContent.filter(function (h) {
      return onlineHomework.some(function (o) {
        return o.unitId === h.unitId && o.lessonNumber === h.lessonNumber;
      }) || homeworkTemplate.some(function (t) {
        return t.unitId === h.unitId && t.lessonNumber === h.lessonNumber;
      });
    }).size;
  }

  return undefined;
}

function isPublished(state, sessionId) {
  var homework = getHomeworkBySessionId(state, sessionId);
  return homework.homeworkResultStatus.toLowerCase() === PUBLISHED;
}

function isExisty(state, sessionId) {
  var summary = state.get('rootReducer').get('homework').get('' + sessionId);
  return summary && summary.size > 0;
}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_HOMEWORK_CONTENT_TYPES_FAILURE = exports.FETCH_HOMEWORK_CONTENT_TYPES_SUCCESS = exports.FETCH_HOMEWORK_CONTENT_TYPES_REQUEST = undefined;
exports.fetchTypesIfNeeded = fetchTypesIfNeeded;
exports.fetchTypes = fetchTypes;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_HOMEWORK_CONTENT_TYPES_REQUEST = exports.FETCH_HOMEWORK_CONTENT_TYPES_REQUEST = 'FETCH_HOMEWORK_CONTENT_TYPES_REQUEST';
var FETCH_HOMEWORK_CONTENT_TYPES_SUCCESS = exports.FETCH_HOMEWORK_CONTENT_TYPES_SUCCESS = 'FETCH_HOMEWORK_CONTENT_TYPES_SUCCESS';
var FETCH_HOMEWORK_CONTENT_TYPES_FAILURE = exports.FETCH_HOMEWORK_CONTENT_TYPES_FAILURE = 'FETCH_HOMEWORK_CONTENT_TYPES_FAILURE';

var buildTypesUrl = function buildTypesUrl(courseTypeId) {
  return (0, _Api.buildUrl)('/course-type-levels/' + courseTypeId + '/homework-types');
};

function fetchTypesIfNeeded(courseTypeLevelId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildTypesUrl(courseTypeLevelId) })) {
      return false;
    }

    return dispatch(fetchTypes(courseTypeLevelId));
  };
}

function fetchTypes(courseTypeLevelId) {
  return function (dispatch) {
    var url = buildTypesUrl(courseTypeLevelId);
    var method = 'GET';

    var promise = dispatch(fetchTypesRequest()).payload.then(function (response) {
      return dispatch(fetchTypesSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchTypesFailure(error));
    });

    function fetchTypesRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_HOMEWORK_CONTENT_TYPES_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        courseTypeLevelId: courseTypeLevelId
      });
    }

    function fetchTypesSuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_HOMEWORK_CONTENT_TYPES_SUCCESS,
        payload: payload,
        url: url,
        method: method,
        courseTypeLevelId: courseTypeLevelId
      });
    }

    function fetchTypesFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_HOMEWORK_CONTENT_TYPES_FAILURE,
        error: error,
        url: url,
        method: method,
        courseTypeLevelId: courseTypeLevelId
      });
    }

    return promise;
  };
}

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO: For Let's Talk default content hack for OMO-2403
var LETS_TALK_TYPE_NAME = 'Let\'s Talk';
var LETS_TALK_DEFAULT_CONTENT = 'The student has been assigned to complete a short 30-90 second presentation on a topic given by the teacher.';

var HomeworkTypeRecord = (0, _immutable.Record)({
  id: undefined,
  name: undefined,
  courseTypeLevelId: undefined,
  description: undefined,
  courseTypeCode: undefined,
  defaultContent: undefined /* special - not sent through the API */
});

var HomeworkType = function (_HomeworkTypeRecord) {
  _inherits(HomeworkType, _HomeworkTypeRecord);

  function HomeworkType() {
    _classCallCheck(this, HomeworkType);

    return _possibleConstructorReturn(this, (HomeworkType.__proto__ || Object.getPrototypeOf(HomeworkType)).apply(this, arguments));
  }

  return HomeworkType;
}(HomeworkTypeRecord);

HomeworkType.create = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (Array.isArray(data) || _immutable.List.isList(data)) {
    return data.map(HomeworkType.create);
  }
  if (_immutable.Map.isMap(data)) {
    throw new Error('Map data unsupported in HomeworkType.create');
  }
  // TODO: For Let's Talk default content hack for OMO-2403
  if (_is_js2.default.object(data) && data.name === LETS_TALK_TYPE_NAME) {
    data.defaultContent = LETS_TALK_DEFAULT_CONTENT; // eslint-disable-line
  }
  return new HomeworkType(data);
};

exports.default = HomeworkType;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(751);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1730);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_HOMEWORK_TEMPLATE_FAILURE = exports.FETCH_HOMEWORK_TEMPLATE_SUCCESS = exports.FETCH_HOMEWORK_TEMPLATE_REQUEST = undefined;
exports.fetchHomeworkTemplateIfNeeded = fetchHomeworkTemplateIfNeeded;
exports.fetchHomeworkTemplate = fetchHomeworkTemplate;

var _omniCommonUi = __webpack_require__(0);

var _Api = __webpack_require__(11);

var FETCH_HOMEWORK_TEMPLATE_REQUEST = exports.FETCH_HOMEWORK_TEMPLATE_REQUEST = 'FETCH_HOMEWORK_TEMPLATE_REQUEST';
var FETCH_HOMEWORK_TEMPLATE_SUCCESS = exports.FETCH_HOMEWORK_TEMPLATE_SUCCESS = 'FETCH_HOMEWORK_TEMPLATE_SUCCESS';
var FETCH_HOMEWORK_TEMPLATE_FAILURE = exports.FETCH_HOMEWORK_TEMPLATE_FAILURE = 'FETCH_HOMEWORK_TEMPLATE_FAILURE';

var buildHomeworkTemplateUrl = function buildHomeworkTemplateUrl(sessionId) {
  return (0, _Api.buildUrl)('/sessions/' + sessionId + '/homework-template');
};

function fetchHomeworkTemplateIfNeeded(sessionId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildHomeworkTemplateUrl(sessionId) })) {
      return false;
    }

    return dispatch(fetchHomeworkTemplate(sessionId));
  };
}

function fetchHomeworkTemplate(sessionId) {
  return function (dispatch) {
    var url = buildHomeworkTemplateUrl(sessionId);
    var method = 'GET';

    return dispatch(fetchHomeworkTemplateRequest()).payload.then(function (response) {
      return dispatch(fetchHomeworkTemplateSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchHomeworkTemplateFailure(error));
    });

    function fetchHomeworkTemplateRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_HOMEWORK_TEMPLATE_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchHomeworkTemplateSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_HOMEWORK_TEMPLATE_SUCCESS,
        payload: response,
        url: url,
        method: method,
        sessionId: sessionId
      });
    }

    function fetchHomeworkTemplateFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_HOMEWORK_TEMPLATE_FAILURE,
        url: url,
        method: method,
        sessionId: sessionId,
        error: error
      });
    }
  };
}

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomeworkContent = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(321);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1731);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(167);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var HomeworkContent = exports.HomeworkContent = _model2.default;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modes = undefined;

var _omniCommonUi = __webpack_require__(0);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _component = __webpack_require__(741);

var _component2 = _interopRequireDefault(_component);

var _SessionNav = __webpack_require__(132);

var _SessionNav2 = _interopRequireDefault(_SessionNav);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _accessors = __webpack_require__(747);

var Homework = _interopRequireWildcard(_accessors);

var _Personalised = __webpack_require__(136);

var _accessors2 = __webpack_require__(36);

var Session = _interopRequireWildcard(_accessors2);

var _ = __webpack_require__(13);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Modes = exports.Modes = {
  CREATE_PERSONALISED_HW: 'create-personalised-hw',
  EDIT_PERSONALISED_HW: 'edit-personalised-hw',
  DELETE_PERSONALISED_HW: 'delete-personalised-hw',
  EDIT_GROUP_HOMEWORK: 'edit-group-homework',
  PUBLISH: 'publish',
  CLEAR: 'clear'
};

var actionButtons = function actionButtons(getState) {
  return {
    Publish: {
      route: { mode: Modes.PUBLISH, personalisedHomeworkId: null },
      isPrimary: true,
      visibleWhen: function visibleWhen(_ref) {
        var groupId = _ref.params.groupId;
        return !_.actions.isAutoPublishHomework(getState(), groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.AssignHomework.Publish);
      },
      disableWhen: function disableWhen(_ref2) {
        var _ref2$params = _ref2.params,
            mode = _ref2$params.mode,
            sessionPlanId = _ref2$params.sessionPlanId;
        return Session.isFutureSession(getState(), sessionPlanId) || _Personalised.accessors.isExisty(getState(), sessionPlanId) && _Personalised.accessors.isPublished(getState(), sessionPlanId) || !_Personalised.accessors.isExisty(getState(), sessionPlanId) && !canSubmitGroupHomework(getState(), sessionPlanId) || Homework.isExisty(getState(), sessionPlanId) && Homework.isPublished(getState(), sessionPlanId) || mode === Modes.PUBLISH || mode === Modes.EDIT_GROUP_HOMEWORK;
      }
    },
    'Add Personalised Practice': {
      route: { mode: Modes.CREATE_PERSONALISED_HW, personalisedHomeworkId: null },
      isPrimary: false,
      visibleWhen: function visibleWhen(_ref3) {
        var groupId = _ref3.params.groupId;
        return !_.actions.isAutoPublishHomework(getState(), groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.AssignHomework.ManageOwn);
      },
      disableWhen: function disableWhen(_ref4) {
        var _ref4$params = _ref4.params,
            mode = _ref4$params.mode,
            sessionPlanId = _ref4$params.sessionPlanId;
        return Session.isFutureSession(getState(), sessionPlanId) || _Personalised.accessors.isPublished(getState(), sessionPlanId) || Homework.isPublished(getState(), sessionPlanId) || mode === Modes.CREATE_PERSONALISED_HW || mode === Modes.EDIT_PERSONALISED_HW || mode === Modes.EDIT_GROUP_HOMEWORK;
      }
    },
    CLEAR: {
      route: { mode: Modes.CLEAR, personalisedHomeworkId: null },
      isPrimary: false,
      visibleWhen: function visibleWhen(_ref5) {
        var sessionPlanId = _ref5.params.sessionPlanId;
        return Homework.hasWronglyResult(getState(), sessionPlanId);
      }
    }
  };
};

exports.default = function (_ref6) {
  var _actionButtons;

  var getState = _ref6.getState;
  return {
    appBars: {
      sticky: {
        'session-nav': {
          component: _SessionNav2.default,
          order: 1
        },
        'view-nav': {
          component: _ViewNav2.default,
          order: 2
        }
      }
    },
    path: 'session/:sessionPlanId(/unit/:unitId)(/:mode)(/:personalisedHomeworkId)',
    component: _component2.default,
    canAccess: function canAccess(_ref7) {
      var params = _ref7.params;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.AssignHomework.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.AssignHomework);
    },
    actionButtons: (_actionButtons = {
      default: actionButtons(getState)
    }, _defineProperty(_actionButtons, Modes.CREATE_PERSONALISED_HW, actionButtons(getState)), _defineProperty(_actionButtons, Modes.EDIT_PERSONALISED_HW, actionButtons(getState)), _defineProperty(_actionButtons, Modes.DELETE_PERSONALISED_HW, actionButtons(getState)), _defineProperty(_actionButtons, Modes.PUBLISH, actionButtons(getState)), _defineProperty(_actionButtons, Modes.EDIT_GROUP_HOMEWORK, actionButtons(getState)), _defineProperty(_actionButtons, Modes.CLEAR, actionButtons(getState)), _actionButtons)
  };
};

function canSubmitGroupHomework(state, sessionId) {
  var homework = Homework.getHomeworkBySessionId(state, sessionId);
  var homeworkTemplate = Homework.getHomeworkTemplateBySessionId(state, sessionId);
  if (!homework) return false;
  if (_is_js2.default.undefined(homeworkTemplate) || homeworkTemplate.size === 0) return false;
  if (Homework.isPublished(state, sessionId)) return false;

  return true;
}

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

exports.mapStateToProps = mapStateToProps;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(15);

var _redux = __webpack_require__(10);

var _reactRouter = __webpack_require__(16);

var _omniCommonUi = __webpack_require__(0);

var _immutable = __webpack_require__(3);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _GroupMembers = __webpack_require__(14);

var _UnlockHomework = __webpack_require__(755);

var _accessors = __webpack_require__(1735);

var accessors = _interopRequireWildcard(_accessors);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _UnlockManualInput = __webpack_require__(1736);

var _UnlockManualInput2 = _interopRequireDefault(_UnlockManualInput);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HEADER_LATEST = 'latest';
var HEADER_MANUAL = 'manual';

var UnlockHomework = function (_UnsavedChangesTracki) {
  _inherits(UnlockHomework, _UnsavedChangesTracki);

  function UnlockHomework(props) {
    _classCallCheck(this, UnlockHomework);

    var _this = _possibleConstructorReturn(this, (UnlockHomework.__proto__ || Object.getPrototypeOf(UnlockHomework)).call(this, props));

    _this._renderCell = _this._renderCell.bind(_this);
    return _this;
  }

  _createClass(UnlockHomework, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        allowRouteLeave: false,
        isChanged: false,
        unlockHomeworks: undefined
      });
      this.props.fetchUnlockHomework(this.props.groupId);
      this._clearUnlockHomeworkFaiure(this.props.unlockHomeworkError && this.props.unlockHomeworkError.id);
      this._changeUnlockable(false);
      _get(UnlockHomework.prototype.__proto__ || Object.getPrototypeOf(UnlockHomework.prototype), 'componentWillMount', this).call(this);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.unlockHomeworks !== nextProps.unlockHomeworks || !this.state.unlockHomeworks) {
        this.setState({
          allowRouteLeave: false,
          isChanged: false,
          unlockHomeworks: nextProps.unlockHomeworks
        });
      }
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave(nextLocation) {
      var _this2 = this;

      if (nextLocation && nextLocation.pathname.endsWith('/unlock')) {
        this._onSaveClick().then(function () {
          return !_this2.props.unlockHomeworkError && _this2.props.fetchUnlockHomework(_this2.props.groupId);
        });
        return false;
      }
      return _get(UnlockHomework.prototype.__proto__ || Object.getPrototypeOf(UnlockHomework.prototype), 'routerWillLeave', this).call(this, nextLocation);
    }
  }, {
    key: '_isChangesPresent',
    value: function _isChangesPresent() {
      var _state = this.state,
          unlockHomeworks = _state.unlockHomeworks,
          isChanged = _state.isChanged;

      return this.props.mode && !!isChanged && accessors.isUnlockHomeworksUnlockable(unlockHomeworks);
    }
  }, {
    key: '_onSaveClick',
    value: function _onSaveClick() {
      var unlockHomeworks = this.state.unlockHomeworks;

      unlockHomeworks = unlockHomeworks.filter(function (unlockHomework) {
        return !!unlockHomework.manualLessonSequence;
      }).map(function (unlockHomework) {
        return {
          studentId: Number(unlockHomework.studentId, 10),
          manualLessonSequence: Number(unlockHomework.manualLessonSequence, 10)
        };
      }).toList();
      this._changeUnlockable(false);
      return this.props.updateUnlockHomeworks(this.props.groupId, unlockHomeworks);
    }
  }, {
    key: '_clearUnlockHomeworkFaiure',
    value: function _clearUnlockHomeworkFaiure(errorKey) {
      if (errorKey) {
        this.props.clearApiCallError(errorKey);
      }
    }
  }, {
    key: '_changeUnlockable',
    value: function _changeUnlockable(status) {
      if (status) {
        this._forcePushRoute(this.props.buildRoute({ mode: 'edit-unlock' }));
      } else {
        this._forcePushRoute(this.props.buildRoute({ mode: '' }));
      }
    }
  }, {
    key: '_onChange',
    value: function _onChange(studentId, ev) {
      var unlockHomeworks = this.state.unlockHomeworks;

      unlockHomeworks = unlockHomeworks.update(studentId, function (unlockHomework) {
        return unlockHomework.set('manualLessonSequence', ev && Number(ev, 10));
      });
      if (accessors.isUnlockHomeworksUnlockable(unlockHomeworks)) {
        this._changeUnlockable(true);
        this.setState({ isChanged: true });
      } else {
        this._changeUnlockable(false);
      }
      this.setState({ unlockHomeworks: unlockHomeworks });
    }
  }, {
    key: '_renderUnlockHomeworkErrorDialog',
    value: function _renderUnlockHomeworkErrorDialog() {
      var _this3 = this;

      var unlockHomeworkError = this.props.unlockHomeworkError;

      if (!unlockHomeworkError) {
        return;
      }
      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: !!unlockHomeworkError,
          primaryButtonContent: 'Ok',
          onPrimaryClick: function onPrimaryClick() {
            _this3._clearUnlockHomeworkFaiure(unlockHomeworkError.id);
            _this3._clearRequestedLocation();
            if (accessors.isUnlockHomeworksUnlockable(_this3.state.unlockHomeworks)) {
              _this3._changeUnlockable(true);
              _this3.setState({ isChanged: true });
            }
          } },
        _react2.default.createElement(
          'span',
          null,
          unlockHomeworkError.error.response.message
        )
      );
    }
  }, {
    key: '_renderUnsavedChangesWarningDialog',
    value: function _renderUnsavedChangesWarningDialog() {
      var _this4 = this;

      return _react2.default.createElement(_UnsavedChangesWarning2.default, { isOpen: !!this._isNavigationWithChangesRequested(),
        dialogText: 'Do you want to unlock homework?',
        primaryButtonLabel: 'Unlock',
        secondaryButtonContent: 'Discard',
        isSaving: this.props.isAnyApiCallSaving,
        onSaveClicked: function onSaveClicked() {
          _this4._onSaveClick().then(function () {
            return !_this4.props.unlockHomeworkError && _this4._forcePushRequestedLocation();
          });
        },
        onDiscardClicked: function onDiscardClicked() {
          _this4._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this4._clearRequestedLocation();
        } });
    }
  }, {
    key: '_renderTableHeader',
    value: function _renderTableHeader() {
      var unlockHomeworks = this.state.unlockHomeworks;

      return _react2.default.createElement(
        _CourseViewTable2.default.Header,
        null,
        _react2.default.createElement(
          _CourseViewTable2.default.Row,
          null,
          _react2.default.createElement(
            _CourseViewTable2.default.Cell,
            { key: HEADER_LATEST,
              columnId: { column: HEADER_LATEST, unlockHomeworks: unlockHomeworks } },
            'Latest Lesson Unlocked'
          ),
          _react2.default.createElement(
            _CourseViewTable2.default.Cell,
            { key: HEADER_MANUAL,
              columnId: { column: HEADER_MANUAL, unlockHomeworks: unlockHomeworks } },
            'Manual Lesson Override'
          )
        )
      );
    }
  }, {
    key: '_renderCell',
    value: function _renderCell(member, _ref) {
      var column = _ref.column,
          unlockHomeworks = _ref.unlockHomeworks;
      var canEdit = this.props.canEdit;

      var unlockHW = unlockHomeworks && unlockHomeworks.get('' + member.studentGeneralInfo.id);
      if (!unlockHW) {
        return;
      }

      switch (column) {
        case HEADER_LATEST:
          {
            var unitLesson = unlockHW.latestUnlockedSequence ? ' (S' + unlockHW.sessionNumber + ' U' + unlockHW.unitNumber + ' L' + unlockHW.lessonNumber + ')' : '';
            return (unlockHW.latestUnlockedSequence || '-') + '/' + (unlockHW.totalLessonAmount || '-') + unitLesson;
          }
        case HEADER_MANUAL:
          {
            var onChange = this._onChange.bind(this, unlockHW.studentId);
            return _react2.default.createElement(_UnlockManualInput2.default, { key: unlockHW.studentId,
              disabled: !canEdit,
              onChange: onChange,
              min: unlockHW.latestUnlockedSequence,
              max: unlockHW.totalLessonAmount,
              manualLessonSequence: unlockHW.manualLessonSequence });
          }
        default:
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var members = this.props.members;

      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { outerMargin: true },
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          _react2.default.createElement(
            _CourseViewTable2.default,
            { students: members },
            this._renderTableHeader(),
            _react2.default.createElement(
              _CourseViewTable2.default.Body,
              null,
              this._renderCell
            )
          )
        ),
        this._renderUnsavedChangesWarningDialog(),
        this._renderUnlockHomeworkErrorDialog()
      );
    }
  }]);

  return UnlockHomework;
}(_UnsavedChangesTrackingPageComponent2.default);

UnlockHomework.propTypes = {
  groupId: _propTypes2.default.string.isRequired,
  mode: _propTypes2.default.string,
  canEdit: _propTypes2.default.string,
  members: _propTypes2.default.object.isRequired,
  unlockHomeworks: _propTypes2.default.object,
  fetchUnlockHomework: _propTypes2.default.func.isRequired,
  updateUnlockHomeworks: _propTypes2.default.func.isRequired,
  clearApiCallError: _propTypes2.default.func.isRequired,
  replace: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  isAnyApiCallSaving: _propTypes2.default.bool,
  unlockHomeworkError: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.undefined])
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      mode = _ownProps$params.mode;

  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var unlockHomeworks = accessors.getUnlockHomeworksByGroup(state, groupId);
  var unlockHomeworkError = getUnlockHomworkErrorCall(state);
  var canEdit = accessors.canEditUnlockHomework(state, groupId);
  return {
    members: members,
    unlockHomeworks: unlockHomeworks,
    groupId: groupId,
    mode: mode,
    canEdit: canEdit,
    unlockHomeworkError: unlockHomeworkError,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, { pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, { clearApiCallError: function clearApiCallError(errorKey) {
      return dispatch(_omniCommonUi.ApiCall.clean(errorKey));
    } }, (0, _redux.bindActionCreators)(_GroupMembers.actions, dispatch), (0, _redux.bindActionCreators)(_UnlockHomework.actions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST', 'DELETE'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

function getUnlockHomworkErrorCall(state) {
  return _omniCommonUi.ApiCall.getAllErrors(state).filter(function (call) {
    return call.id.endsWith('unlock-homework') && call.id.startsWith('PUT');
  }).first();
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(UnlockHomework));

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = exports.UnlockHomework = undefined;

var _actions2 = __webpack_require__(756);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1733);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(322);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var UnlockHomework = exports.UnlockHomework = _model2.default;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_UNLOCK_HOMEWORKS_FAILURE = exports.UPDATE_UNLOCK_HOMEWORKS_SUCCESS = exports.UPDATE_UNLOCK_HOMEWORKS_REQUEST = exports.FETCH_UNLOCK_HOMEWORK_FAILURE = exports.FETCH_UNLOCK_HOMEWORK_SUCCESS = exports.FETCH_UNLOCK_HOMEWORK_REQUEST = undefined;
exports.fetchUnlockHomeworkIfNeeded = fetchUnlockHomeworkIfNeeded;
exports.fetchUnlockHomework = fetchUnlockHomework;
exports.updateUnlockHomeworks = updateUnlockHomeworks;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var buildUnlockHomeworkURL = function buildUnlockHomeworkURL(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/unlock-homework');
};

var FETCH_UNLOCK_HOMEWORK_REQUEST = exports.FETCH_UNLOCK_HOMEWORK_REQUEST = 'FETCH_UNLOCK_HOMEWORK_REQUEST';
var FETCH_UNLOCK_HOMEWORK_SUCCESS = exports.FETCH_UNLOCK_HOMEWORK_SUCCESS = 'FETCH_UNLOCK_HOMEWORK_SUCCESS';
var FETCH_UNLOCK_HOMEWORK_FAILURE = exports.FETCH_UNLOCK_HOMEWORK_FAILURE = 'FETCH_UNLOCK_HOMEWORK_FAILURE';
var UPDATE_UNLOCK_HOMEWORKS_REQUEST = exports.UPDATE_UNLOCK_HOMEWORKS_REQUEST = 'UPDATE_UNLOCK_HOMEWORKS_REQUEST';
var UPDATE_UNLOCK_HOMEWORKS_SUCCESS = exports.UPDATE_UNLOCK_HOMEWORKS_SUCCESS = 'UPDATE_UNLOCK_HOMEWORKS_SUCCESS';
var UPDATE_UNLOCK_HOMEWORKS_FAILURE = exports.UPDATE_UNLOCK_HOMEWORKS_FAILURE = 'UPDATE_UNLOCK_HOMEWORKS_FAILURE';

function fetchUnlockHomeworkIfNeeded(groupId) {
  var method = 'GET';
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: method, url: buildUnlockHomeworkURL(groupId) })) {
      return false;
    }

    return dispatch(fetchUnlockHomework(groupId));
  };
}

function fetchUnlockHomework(groupId) {
  return function (dispatch) {
    var url = buildUnlockHomeworkURL(groupId);
    var method = 'GET';

    return dispatch(fetchUnlockHomeworkRequest()).payload.then(function (response) {
      return dispatch(fetchUnlockHomeworkSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchUnlockHomeworkFailure(error));
    });

    function fetchUnlockHomeworkRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_UNLOCK_HOMEWORK_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method
      });
    }

    function fetchUnlockHomeworkSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_UNLOCK_HOMEWORK_SUCCESS,
        payload: response,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchUnlockHomeworkFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_UNLOCK_HOMEWORK_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

function updateUnlockHomeworks(groupId, unlockHomeworks) {
  return function (dispatch) {
    var url = buildUnlockHomeworkURL(groupId);
    var method = 'PUT';
    return dispatch(updateUnlockHomeworksRequest()).payload.then(function (response) {
      return dispatch(updateUnlockHomeworksSuccess(response));
    }).catch(function (error) {
      return dispatch(updateUnlockHomeworksFailure(error));
    });

    function updateUnlockHomeworksRequest() {
      var param = {
        method: method,
        body: JSON.stringify(unlockHomeworks)
      };
      return _omniCommonUi.ApiCall.createAction({
        type: UPDATE_UNLOCK_HOMEWORKS_REQUEST,
        payload: (0, _Api.fetch)(url, param),
        url: url,
        method: method
      });
    }

    function updateUnlockHomeworksSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: UPDATE_UNLOCK_HOMEWORKS_SUCCESS,
        payload: response,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function updateUnlockHomeworksFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: UPDATE_UNLOCK_HOMEWORKS_FAILURE,
        error: error,
        url: url,
        method: method,
        disableDefault: true
      });
    }
  };
}

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUnlockHomeworkEnabled = undefined;

var _omniCommonUi = __webpack_require__(0);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _component = __webpack_require__(754);

var _component2 = _interopRequireDefault(_component);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isUnlockHomeworkEnabled = exports.isUnlockHomeworkEnabled = function isUnlockHomeworkEnabled(state, groupId) {
  return _TabSwitcher2.default.isTabEnabled(state, groupId, _TabSwitcher.TabCodes.UnlockHomework);
};

var actionButtons = function actionButtons(getState) {
  return {
    Unlock: {
      isPrimary: true,
      route: './unlock',
      visibleWhen: function visibleWhen() {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.AssignHomework.View);
      },
      disableWhen: function disableWhen(_ref) {
        var params = _ref.params;
        return params.mode !== 'edit-unlock';
      }
    }
  };
};

exports.default = function (_ref2) {
  var getState = _ref2.getState;
  return {
    appBars: {
      sticky: {
        'view-nav': {
          component: _ViewNav2.default,
          props: {
            hideExpandable: true
          }
        }
      }
    },
    path: 'unlock-homework(/:mode)',
    canAccess: function canAccess(_ref3) {
      var groupId = _ref3.params.groupId;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.AssignHomework.View) && isUnlockHomeworkEnabled(getState(), groupId);
    },
    component: _component2.default,
    actionButtons: {
      default: actionButtons(),
      'edit-unlock': actionButtons()
    }
  };
};

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _omniCommonUi = __webpack_require__(0);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _SkillRecommendation = __webpack_require__(325);

var _routes = __webpack_require__(772);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IndividualDevelopmentPlan = function (_PureComponent) {
  _inherits(IndividualDevelopmentPlan, _PureComponent);

  function IndividualDevelopmentPlan() {
    _classCallCheck(this, IndividualDevelopmentPlan);

    return _possibleConstructorReturn(this, (IndividualDevelopmentPlan.__proto__ || Object.getPrototypeOf(IndividualDevelopmentPlan)).apply(this, arguments));
  }

  _createClass(IndividualDevelopmentPlan, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._fetchIndividualDevelopmentPlan();
      this._redirectToListView();
      this.props.fetchSkillRecommendationsIfNeeded(this.props.params.groupId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._fetchIndividualDevelopmentPlan(nextProps);
      this._redirectToListView(nextProps);
    }
  }, {
    key: '_redirectToListView',
    value: function _redirectToListView() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var groupId = props.groupId,
          firstGroupIdpId = props.firstGroupIdpId;

      if (!props.firstGroupIdpId) return;
      if (props.location.pathname.endsWith('progress-report')) {
        props.replaceRoute(this.props.buildRoute('/group/' + groupId + ('/progress-report/' + firstGroupIdpId)));
      }
    }
  }, {
    key: '_fetchIndividualDevelopmentPlan',
    value: function _fetchIndividualDevelopmentPlan() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.props.fetchGroupIndividualDevelopmentPlanListIfNeeded(props.params.groupId);
      if (props.groupIdpId && this.props.isGroupIdpFetched) {
        this.props.fetchIndividualDevelopmentPlanListIfNeeded(props.groupIdpId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);

  return IndividualDevelopmentPlan;
}(_react.PureComponent);

IndividualDevelopmentPlan.propTypes = {
  children: _propTypes2.default.node,
  params: _propTypes2.default.shape().isRequired,
  firstGroupIdpId: _propTypes2.default.string,
  groupIdpId: _propTypes2.default.string,
  isGroupIdpFetched: _propTypes2.default.bool.isRequired,
  groupId: _propTypes2.default.string.isRequired,
  fetchGroupIndividualDevelopmentPlanListIfNeeded: _propTypes2.default.func.isRequired,
  fetchIndividualDevelopmentPlanListIfNeeded: _propTypes2.default.func.isRequired,
  fetchSkillRecommendationsIfNeeded: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  replaceRoute: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  routes: _propTypes2.default.array.isRequired,
  location: _propTypes2.default.object.isRequired
};

function getFirstGroupIdpId(groupIdpList) {
  if (groupIdpList.size === 1) {
    return groupIdpList.toList().get(0).id;
  } else if (groupIdpList.size > 1) {
    var firstGroupIdpInfo = groupIdpList.find(function (groupIdpInfo) {
      return groupIdpInfo.name.toLowerCase() === _routes.MID_LEVEL_REPORT;
    });
    if (!firstGroupIdpInfo) {
      firstGroupIdpInfo = groupIdpList.find(function (groupIdpInfo) {
        return groupIdpInfo;
      });
    }
    return firstGroupIdpInfo && firstGroupIdpInfo.id.toString();
  }
}

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      groupIdpId = _ownProps$params.groupIdpId;

  var groupIdpList = _IndividualDevelopmentPlans.accessors.getGroupIdpList(state, groupId);
  var isGroupIdpFetched = !!(groupIdpId && _IndividualDevelopmentPlans.accessors.isGroupIdpFetched(state, groupIdpId));

  var firstGroupIdpId = getFirstGroupIdpId(groupIdpList);
  return {
    groupId: groupId,
    firstGroupIdpId: firstGroupIdpId,
    groupIdpId: groupIdpId,
    isGroupIdpFetched: isGroupIdpFetched
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, { replaceRoute: function replaceRoute(path) {
      return dispatch((0, _reactRouterRedux.replace)(path));
    } }, (0, _redux.bindActionCreators)(_IndividualDevelopmentPlans.actions, dispatch), (0, _redux.bindActionCreators)(_SkillRecommendation.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(IndividualDevelopmentPlan);

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IdpListRecord = _immutable2.default.Record({
  id: undefined,
  studentId: undefined,
  period: undefined,
  skillResults: undefined,
  status: undefined,
  name: undefined,
  shouldShowSuggestions: undefined
});

var IdpList = function (_IdpListRecord) {
  _inherits(IdpList, _IdpListRecord);

  function IdpList() {
    _classCallCheck(this, IdpList);

    return _possibleConstructorReturn(this, (IdpList.__proto__ || Object.getPrototypeOf(IdpList)).apply(this, arguments));
  }

  return IdpList;
}(IdpListRecord);

exports.default = IdpList;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1742);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GroupIdpListRecord = _immutable2.default.Record({
  id: undefined,
  name: undefined,
  groupId: undefined,
  idpList: undefined
});

var GroupIdpList = function (_GroupIdpListRecord) {
  _inherits(GroupIdpList, _GroupIdpListRecord);

  function GroupIdpList() {
    _classCallCheck(this, GroupIdpList);

    return _possibleConstructorReturn(this, (GroupIdpList.__proto__ || Object.getPrototypeOf(GroupIdpList)).apply(this, arguments));
  }

  return GroupIdpList;
}(GroupIdpListRecord);

exports.default = GroupIdpList;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IndividualDevelopmentPlanRecord = _immutable2.default.Record({
  id: undefined,
  studentId: undefined,
  period: undefined,
  learningResult: undefined,
  studentIDPFeedbackSuggestions: undefined,
  lastUpdatedTimeUtc: undefined,
  dosRejectedComment: undefined,
  check: undefined
});

var IndividualDevelopmentPlan = function (_IndividualDevelopmen) {
  _inherits(IndividualDevelopmentPlan, _IndividualDevelopmen);

  function IndividualDevelopmentPlan() {
    _classCallCheck(this, IndividualDevelopmentPlan);

    return _possibleConstructorReturn(this, (IndividualDevelopmentPlan.__proto__ || Object.getPrototypeOf(IndividualDevelopmentPlan)).apply(this, arguments));
  }

  return IndividualDevelopmentPlan;
}(IndividualDevelopmentPlanRecord);

exports.default = IndividualDevelopmentPlan;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LearningResultRecord = _immutable2.default.Record({
  skillResults: undefined,
  finishedPaperBasedHomework: undefined,
  totalPaperBasedHomework: undefined,
  finishedOnlineHomework: undefined,
  totalOnlineHomework: undefined,
  presentAttendence: undefined,
  totalAttendence: undefined
});

var LearningResult = function (_LearningResultRecord) {
  _inherits(LearningResult, _LearningResultRecord);

  function LearningResult() {
    _classCallCheck(this, LearningResult);

    return _possibleConstructorReturn(this, (LearningResult.__proto__ || Object.getPrototypeOf(LearningResult)).apply(this, arguments));
  }

  return LearningResult;
}(LearningResultRecord);

exports.default = LearningResult;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(765);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1749);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SuggestionsRecord = _immutable2.default.Record({
  teacherId: undefined,
  overallSuggestion: undefined,
  overallRecommendation: undefined,
  suggestedTime: undefined,
  participationId: undefined,
  skillSuggestions: undefined
});

var Suggestions = function (_SuggestionsRecord) {
  _inherits(Suggestions, _SuggestionsRecord);

  function Suggestions() {
    _classCallCheck(this, Suggestions);

    return _possibleConstructorReturn(this, (Suggestions.__proto__ || Object.getPrototypeOf(Suggestions)).apply(this, arguments));
  }

  return Suggestions;
}(SuggestionsRecord);

exports.default = Suggestions;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SkillSuggestionRecord = _immutable2.default.Record({
  skillId: undefined,
  name: undefined,
  score: undefined,
  layeredScore: undefined,
  layeredFullMark: undefined,
  suggestion: undefined,
  isManuallyAdded: undefined,
  selectedRecommendationList: undefined
});

var SkillSuggestion = function (_SkillSuggestionRecor) {
  _inherits(SkillSuggestion, _SkillSuggestionRecor);

  function SkillSuggestion() {
    _classCallCheck(this, SkillSuggestion);

    return _possibleConstructorReturn(this, (SkillSuggestion.__proto__ || Object.getPrototypeOf(SkillSuggestion)).apply(this, arguments));
  }

  return SkillSuggestion;
}(SkillSuggestionRecord);

exports.default = SkillSuggestion;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DosRejectedCommentRecord = _immutable2.default.Record({
  rejectedBy: undefined,
  rejectedComment: undefined,
  rejectedDate: undefined
});

var DosRejectedComment = function (_DosRejectedCommentRe) {
  _inherits(DosRejectedComment, _DosRejectedCommentRe);

  function DosRejectedComment() {
    _classCallCheck(this, DosRejectedComment);

    return _possibleConstructorReturn(this, (DosRejectedComment.__proto__ || Object.getPrototypeOf(DosRejectedComment)).apply(this, arguments));
  }

  return DosRejectedComment;
}(DosRejectedCommentRecord);

exports.default = DosRejectedComment;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IdpApprovalListRecord = _immutable2.default.Record({
  studentIDPId: undefined
});

var IdpApprovalList = function (_IdpApprovalListRecor) {
  _inherits(IdpApprovalList, _IdpApprovalListRecor);

  function IdpApprovalList() {
    _classCallCheck(this, IdpApprovalList);

    return _possibleConstructorReturn(this, (IdpApprovalList.__proto__ || Object.getPrototypeOf(IdpApprovalList)).apply(this, arguments));
  }

  return IdpApprovalList;
}(IdpApprovalListRecord);

exports.default = IdpApprovalList;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IdpParticipationRecord = _immutable2.default.Record({
  id: undefined,
  name: undefined
});

var IdpParticipation = function (_IdpParticipationReco) {
  _inherits(IdpParticipation, _IdpParticipationReco);

  function IdpParticipation() {
    _classCallCheck(this, IdpParticipation);

    return _possibleConstructorReturn(this, (IdpParticipation.__proto__ || Object.getPrototypeOf(IdpParticipation)).apply(this, arguments));
  }

  return IdpParticipation;
}(IdpParticipationRecord);

exports.default = IdpParticipation;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_SKILL_RECOMMENDATION_FAILURE = exports.FETCH_SKILL_RECOMMENDATION_SUCCESS = exports.FETCH_SKILL_RECOMMENDATION_REQUEST = undefined;
exports.fetchSkillRecommendationsIfNeeded = fetchSkillRecommendationsIfNeeded;
exports.fetchSkillRecommendations = fetchSkillRecommendations;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var buildRecommendationURL = function buildRecommendationURL(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/skill-recommendations');
};
var method = 'GET';

var FETCH_SKILL_RECOMMENDATION_REQUEST = exports.FETCH_SKILL_RECOMMENDATION_REQUEST = 'FETCH_SKILL_RECOMMENDATION_REQUEST';
var FETCH_SKILL_RECOMMENDATION_SUCCESS = exports.FETCH_SKILL_RECOMMENDATION_SUCCESS = 'FETCH_SKILL_RECOMMENDATION_SUCCESS';
var FETCH_SKILL_RECOMMENDATION_FAILURE = exports.FETCH_SKILL_RECOMMENDATION_FAILURE = 'FETCH_SKILL_RECOMMENDATION_FAILURE';

function fetchSkillRecommendationsIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: method, url: buildRecommendationURL(groupId) })) {
      return false;
    }

    return dispatch(fetchSkillRecommendations(groupId));
  };
}

function fetchSkillRecommendations(groupId) {
  return function (dispatch) {
    var url = buildRecommendationURL(groupId);

    return dispatch(fetchSkillRecommendationsRequest()).payload.then(function (response) {
      return dispatch(fetchSkillRecommendationsSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchSkillRecommendationsFailure(error));
    });

    function fetchSkillRecommendationsRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_SKILL_RECOMMENDATION_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method
      });
    }

    function fetchSkillRecommendationsSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_SKILL_RECOMMENDATION_SUCCESS,
        payload: response,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchSkillRecommendationsFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_SKILL_RECOMMENDATION_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RecommendationItemRecord = _immutable2.default.Record({
  id: undefined,
  categoryName: undefined,
  itemName: undefined
});

var RecommendationItem = function (_RecommendationItemRe) {
  _inherits(RecommendationItem, _RecommendationItemRe);

  function RecommendationItem() {
    _classCallCheck(this, RecommendationItem);

    return _possibleConstructorReturn(this, (RecommendationItem.__proto__ || Object.getPrototypeOf(RecommendationItem)).apply(this, arguments));
  }

  return RecommendationItem;
}(RecommendationItemRecord);

exports.default = RecommendationItem;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldEnableIdp = exports.isRUCentreChecker = undefined;

var _omniCommonUi = __webpack_require__(0);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _component = __webpack_require__(758);

var _component2 = _interopRequireDefault(_component);

var _IndividualDevelopmentPlanListView = __webpack_require__(1763);

var _IndividualDevelopmentPlanDetailView = __webpack_require__(775);

var _IndividualDevelopmentPlanApprovalView = __webpack_require__(1835);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _Centre = __webpack_require__(282);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enableIdpForAllBU = function enableIdpForAllBU() {
  return _omniCommonUi.Config.get('enableIndividualDevelopmentPlanForAllBU');
};

var _secondLevelTabs = function _secondLevelTabs(getState, _ref, push, buildRoute) {
  var groupId = _ref.groupId,
      groupIdpId = _ref.groupIdpId;

  var groupIdpList = _IndividualDevelopmentPlans.accessors.getGroupIdpList(getState(), groupId);
  if (groupIdpList.size <= 1) return [];
  groupIdpList = groupIdpList.toList();
  return groupIdpList.map(function (groupIdpInfo) {
    return {
      text: groupIdpInfo.name.toUpperCase(),
      onClick: function onClick() {
        return push(buildRoute('/group/' + groupId + '/progress-report/' + groupIdpInfo.id));
      },
      isActive: groupIdpId === groupIdpInfo.id.toString()
    };
  }).toArray();
};

var isRUCentreChecker = exports.isRUCentreChecker = function isRUCentreChecker(state, groupId) {
  var groupInfo = _.actions.getGroup(state, groupId);
  if (!groupInfo) return;
  var isRUCentre = _Centre.accessors.isRUCentre(state, groupInfo.centreId);
  if (_is_js2.default.undefined(isRUCentre)) return;
  return isRUCentre;
};

var shouldEnableIdp = exports.shouldEnableIdp = function shouldEnableIdp(state, groupId) {
  var isTabEnabled = _TabSwitcher2.default.isTabEnabled(state, groupId, _TabSwitcher.TabCodes.IDP);
  var isRUCentre = isRUCentreChecker(state, groupId);
  if (_is_js2.default.undefined(isRUCentre)) return true;
  return isTabEnabled && (isRUCentre || enableIdpForAllBU());
};

exports.default = function (_ref2) {
  var getState = _ref2.getState;
  return {
    appBars: {
      sticky: {
        'view-nav': {
          component: _ViewNav2.default,
          order: 2,
          props: {
            hideExpandable: true
          }
        }
      }
    },
    path: 'progress-report',
    component: _component2.default,
    secondLevelTabs: function secondLevelTabs(_ref3) {
      var push = _ref3.push,
          params = _ref3.params,
          buildRoute = _ref3.buildRoute;
      return _secondLevelTabs(getState, params, push, buildRoute);
    },
    breadcrumbLabels: function breadcrumbLabels(_ref4) {
      var params = _ref4.params,
          buildRoute = _ref4.buildRoute;
      return {
        label: _IndividualDevelopmentPlans.accessors.getReportName(getState(), params.groupIdpId, 'progress report'),
        href: buildRoute(buildRoute('/group/' + params.groupId + '/progress-report/' + params.groupIdpId))
      };
    },
    canAccess: function canAccess(_ref5) {
      var params = _ref5.params;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.View) && shouldEnableIdp(getState(), params.groupId);
    },
    childRoutes: [_IndividualDevelopmentPlanApprovalView.routes, _IndividualDevelopmentPlanListView.routes, _IndividualDevelopmentPlanDetailView.routes],
    tab: {
      label: function label(params) {
        return _.actions.isDisabledReportActions(getState(), params.groupId) ? 'Historical Progress Reports' : 'Progress Reports';
      },
      order: 10,
      isVisible: function isVisible(params) {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.View) && shouldEnableIdp(getState(), params.groupId);
      }
    }
  };
};

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1764);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouter = __webpack_require__(16);

var _reactRouterRedux = __webpack_require__(15);

var _omniCommonUi = __webpack_require__(0);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _IndividualDevelopmentPlanStatus = __webpack_require__(68);

var _IndividualDevelopmentPlanStatus2 = _interopRequireDefault(_IndividualDevelopmentPlanStatus);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _ExportAllHandler = __webpack_require__(1768);

var _ExportAllHandler2 = _interopRequireDefault(_ExportAllHandler);

var _ = __webpack_require__(13);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _GroupMembers = __webpack_require__(14);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _routes = __webpack_require__(774);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var COLUMN_PERIOD = "period";
var COLUMN_SKILL1 = "skill1";
var COLUMN_SKILL2 = "skill2";
var COLUMN_SKILL3 = "skill3";
var COLUMN_STATUS = "status";
var COLUMN_ID = "id";

var IndividualDevelopmentPlanListView = function (_UnsavedChangesTracki) {
  _inherits(IndividualDevelopmentPlanListView, _UnsavedChangesTracki);

  function IndividualDevelopmentPlanListView() {
    _classCallCheck(this, IndividualDevelopmentPlanListView);

    return _possibleConstructorReturn(this, (IndividualDevelopmentPlanListView.__proto__ || Object.getPrototypeOf(IndividualDevelopmentPlanListView)).apply(this, arguments));
  }

  _createClass(IndividualDevelopmentPlanListView, [{
    key: "routerWillLeave",
    value: function routerWillLeave(nextLocation) {
      if (nextLocation && nextLocation.pathname.endsWith(_routes.Modes.GENERATE_ALL)) {
        this.props.groupIdpId && this.props.generateIndividualDevelopmentList(this.props.groupIdpId);
        return false;
      }
    }
  }, {
    key: "_gaLinkClicked",
    value: function _gaLinkClicked() {
      _reactGa2.default.event({
        category: "Individual Development Plan",
        action: "Clicked link to Individual Development Plan detail"
      });
    }
  }, {
    key: "_getStatus",
    value: function _getStatus(studentIdp) {
      if (studentIdp.shouldShowSuggestions && _IndividualDevelopmentPlanStatus.IdpStatus.INCOMPLETE === studentIdp.status.toLowerCase() && !studentIdp[COLUMN_SKILL1] && !studentIdp[COLUMN_SKILL2] && !studentIdp[COLUMN_SKILL3]) {
        return "NA";
      }

      return studentIdp.status;
    }
  }, {
    key: "_renderCell",
    value: function _renderCell(member, column) {
      var _this2 = this;

      var idpList = this.props.individualDevelopmentPlanList;
      if (!idpList || !idpList.size) return "-";

      var studentIdp = idpList.find(function (idp) {
        return idp.studentId === member.studentGeneralInfo.id;
      });

      if (!studentIdp) return column !== COLUMN_ID && "-";
      switch (column) {
        case COLUMN_STATUS:
          return _react2.default.createElement(_IndividualDevelopmentPlanStatus2.default, {
            status: this._getStatus(studentIdp)
          });
        case COLUMN_ID:
          return _react2.default.createElement(
            _reactRouter.Link,
            {
              className: (0, _classnames2.default)(_style2.default.IndividualDevelopmentPlanListViewLink, (0, _omniCommonUi.testClass)("report-link-cell")),
              to: this.props.buildRoute("./student/" + studentIdp.studentId),
              draggable: false,
              onClick: function onClick() {
                return _this2._gaLinkClicked();
              }
            },
            "REPORT",
            " ",
            _react2.default.createElement(_omniCommonUi.Icon, {
              id: "arrow-right",
              className: _style2.default.IndividualDevelopmentPlanListViewLink_icon
            })
          );
        default:
          return studentIdp[column] || "-";
      }
    }
  }, {
    key: "_renderIdpList",
    value: function _renderIdpList() {
      var _this3 = this;

      return _react2.default.createElement(
        _CourseViewTable2.default,
        { students: this.props.members, onlyRowDivider: true },
        _react2.default.createElement(
          _CourseViewTable2.default.Header,
          null,
          _react2.default.createElement(
            _CourseViewTable2.default.Row,
            null,
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: COLUMN_PERIOD, small: true },
              "Period covered"
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: COLUMN_SKILL1, small: true },
              "Skill 1"
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: COLUMN_SKILL2, small: true },
              "Skill 2"
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: COLUMN_SKILL3, small: true },
              "Skill 3"
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: COLUMN_STATUS, small: true },
              "Status"
            ),
            this.props.individualDevelopmentPlanList && this.props.individualDevelopmentPlanList.size > 0 && _react2.default.createElement(_CourseViewTable2.default.Cell, { columnId: COLUMN_ID, small: true })
          )
        ),
        _react2.default.createElement(
          _CourseViewTable2.default.Body,
          null,
          function (member, column) {
            return _this3._renderCell(member, column);
          }
        )
      );
    }
  }, {
    key: "_renderExportDialog",
    value: function _renderExportDialog() {
      var _props = this.props,
          mode = _props.mode,
          buildRoute = _props.buildRoute,
          pushRoute = _props.pushRoute,
          languageCode = _props.languageCode,
          individualDevelopmentPlanList = _props.individualDevelopmentPlanList,
          groupIdpId = _props.groupIdpId,
          groupId = _props.groupId,
          members = _props.members,
          reportName = _props.reportName;

      var isInExportAllRoute = mode === _routes.Modes.EXPORT_ALL;
      var memberStudentIds = members.map(function (member) {
        return member.studentGeneralInfo.id;
      });
      var exportableIDPList = individualDevelopmentPlanList && individualDevelopmentPlanList.filter(function (idp) {
        return memberStudentIds.includes(idp.studentId);
      });
      return individualDevelopmentPlanList && individualDevelopmentPlanList.size > 0 && isInExportAllRoute && _react2.default.createElement(_ExportAllHandler2.default, {
        individualDevelopmentPlanList: exportableIDPList,
        groupIdpId: groupIdpId,
        languageCode: languageCode,
        pushRoute: pushRoute,
        buildRoute: buildRoute,
        groupId: groupId,
        reportName: reportName
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: _style2.default.IndividualDevelopmentPlanListView_content },
          this._renderIdpList(),
          this._renderExportDialog()
        )
      );
    }
  }]);

  return IndividualDevelopmentPlanListView;
}(_UnsavedChangesTrackingPageComponent2.default);

IndividualDevelopmentPlanListView.propTypes = {
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  members: _propTypes2.default.object.isRequired,
  groupIdpId: _propTypes2.default.string.isRequired,
  individualDevelopmentPlanList: _propTypes2.default.object.isRequired,
  mode: _propTypes2.default.string.isRequired,
  reportName: _propTypes2.default.string.isRequired
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      groupIdpId = _ownProps$params.groupIdpId,
      mode = _ownProps$params.mode;

  var _groupActions$getCent = _.actions.getCentre(state, groupId),
      timeZone = _groupActions$getCent.timeZone;

  var group = state.get("rootReducer").get("groups").get(groupId).data;
  var languageCode = group.get("languageCode");

  var groupIdpList = state.get("rootReducer").get("individualDevelopmentPlanList");
  var originIndividualDevelopmentPlanList = _IndividualDevelopmentPlans.accessors.getIdpList(groupIdpList, groupIdpId);

  var individualDevelopmentPlanList = _IndividualDevelopmentPlans.accessors.formatToRenderUI(originIndividualDevelopmentPlanList, timeZone);
  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);

  var reportName = _IndividualDevelopmentPlans.accessors.getReportName(state, groupIdpId);
  return {
    reportName: reportName,
    mode: mode,
    state: state,
    members: members,
    individualDevelopmentPlanList: individualDevelopmentPlanList,
    groupId: groupId,
    groupIdpId: groupIdpId,
    languageCode: languageCode
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, { pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_IndividualDevelopmentPlans.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(IndividualDevelopmentPlanListView);

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modes = undefined;

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _component = __webpack_require__(773);

var _component2 = _interopRequireDefault(_component);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _IndividualDevelopmentPlanStatus = __webpack_require__(68);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modes = exports.Modes = {
  GENERATE_ALL: 'generate-all',
  EXPORT_ALL: 'export-all'
};

var isIdpListExist = function isIdpListExist(getState, params) {
  var groupIdpList = _IndividualDevelopmentPlans.accessors.getGroupIdpList(getState(), params.groupId);
  var idpList = _IndividualDevelopmentPlans.accessors.getIdpList(groupIdpList, params.groupIdpId);
  return !!idpList && idpList.size > 0;
};

var isExportDisable = function isExportDisable(getState, params) {
  var groupIdpList = _IndividualDevelopmentPlans.accessors.getGroupIdpList(getState(), params.groupId);
  var idpList = _IndividualDevelopmentPlans.accessors.getIdpList(groupIdpList, params.groupIdpId);
  var completeList = idpList.filter(function (idp) {
    return idp.status.toLowerCase() === _IndividualDevelopmentPlanStatus.IdpStatus.COMPLETED.toLowerCase();
  });
  return !completeList || completeList && completeList.size < 1;
};

var actionButtons = function actionButtons(getState) {
  return {
    Generate: {
      route: './' + Modes.GENERATE_ALL,
      visibleWhen: function visibleWhen(_ref) {
        var params = _ref.params;
        return !_.actions.isDisabledReportActions(getState(), params.groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.Manage) && params.groupIdpId;
      },
      isPrimary: true
    },
    'Export All': {
      route: './' + Modes.EXPORT_ALL,
      visibleWhen: function visibleWhen(_ref2) {
        var params = _ref2.params;
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.View) && isIdpListExist(getState, params);
      },
      disableWhen: function disableWhen(_ref3) {
        var params = _ref3.params;
        return isExportDisable(getState, params);
      },
      isPrimary: true
    }
  };
};

exports.default = function (_ref4) {
  var getState = _ref4.getState;
  return {
    path: ':groupIdpId(/:mode)',
    component: _component2.default,
    actionButtons: {
      default: actionButtons(getState),
      'export-all': actionButtons(getState),
      'generate-all': actionButtons(getState)
    }
  };
};

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BottomButtons = exports.routes = undefined;

var _component = __webpack_require__(776);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(169);

var _routes3 = _interopRequireDefault(_routes2);

var _BottomButtons2 = __webpack_require__(781);

var _BottomButtons3 = _interopRequireDefault(_BottomButtons2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
var BottomButtons = exports.BottomButtons = _BottomButtons3.default;

exports.default = _component2.default;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _ = __webpack_require__(13);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _StudentInformation = __webpack_require__(1771);

var _StudentInformation2 = _interopRequireDefault(_StudentInformation);

var _FeedbackSuggestions = __webpack_require__(1776);

var _FeedbackSuggestions2 = _interopRequireDefault(_FeedbackSuggestions);

var _ReportCard = __webpack_require__(1801);

var _ReportCard2 = _interopRequireDefault(_ReportCard);

var _StudyPlan = __webpack_require__(1804);

var _StudyPlan2 = _interopRequireDefault(_StudyPlan);

var _OverallDevelopment = __webpack_require__(1816);

var _OverallDevelopment2 = _interopRequireDefault(_OverallDevelopment);

var _routes = __webpack_require__(169);

var _ExportDialog = __webpack_require__(1832);

var _ExportDialog2 = _interopRequireDefault(_ExportDialog);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _RejectNote = __webpack_require__(210);

var _RejectNote2 = _interopRequireDefault(_RejectNote);

var _IndividualDevelopmentPlanStatus = __webpack_require__(68);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IndividualDevelopmentPlanDetailView = function (_UnsavedChangesTracki) {
  _inherits(IndividualDevelopmentPlanDetailView, _UnsavedChangesTracki);

  function IndividualDevelopmentPlanDetailView(props) {
    _classCallCheck(this, IndividualDevelopmentPlanDetailView);

    var _this = _possibleConstructorReturn(this, (IndividualDevelopmentPlanDetailView.__proto__ || Object.getPrototypeOf(IndividualDevelopmentPlanDetailView)).call(this, props));

    _this.state = {
      isExpandStudentInfo: false,
      isExpandReportCard: false
    };

    _this._changeMode = _this._changeMode.bind(_this);
    return _this;
  }

  _createClass(IndividualDevelopmentPlanDetailView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._fetchIndividualDevelopmentPlanDetail();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._fetchIndividualDevelopmentPlanDetail(nextProps);
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave(nextLocation) {
      if (nextLocation && nextLocation.pathname.endsWith('/' + _routes.Modes.SUBMIT)) {
        this._onSubmit();
        return false;
      }

      return _get(IndividualDevelopmentPlanDetailView.prototype.__proto__ || Object.getPrototypeOf(IndividualDevelopmentPlanDetailView.prototype), 'routerWillLeave', this).call(this, nextLocation);
    }
  }, {
    key: '_onSubmit',
    value: function _onSubmit() {
      var _props = this.props,
          idpId = _props.idpId,
          groupIdpId = _props.groupIdpId;

      this.props.submitIndividualDevelopmentPlan(idpId, groupIdpId).then(this._changeMode());
    }
  }, {
    key: '_isChangesPresent',
    value: function _isChangesPresent() {
      if (IndividualDevelopmentPlanDetailView.isInEditCommentsMode(this.props)) {
        return this.feedbackSuggestionsComponent.wasCommentsEditMade();
      }
      if (IndividualDevelopmentPlanDetailView.isInEditStudyPlanMode(this.props)) {
        return this.studyPlanComponent.wasEditMade();
      }
      if (IndividualDevelopmentPlanDetailView.isInEditOverallDevelopmentMode(this.props)) {
        return this.overallDevelopmentComponent.wasEditMade();
      }
      return false;
    }
  }, {
    key: '_fetchIndividualDevelopmentPlanDetail',
    value: function _fetchIndividualDevelopmentPlanDetail() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      if (!props.idpId) return;
      props.fetchIdpLearningResultIfNeeded(props.idpId);
      props.fetchIdpFeedbackSuggestionsIfNeeded(props.idpId);
      props.fetchIdpParticipationIfNeeded();
    }
  }, {
    key: '_expandStudentInfo',
    value: function _expandStudentInfo() {
      this.setState({ isExpandStudentInfo: !this.state.isExpandStudentInfo });
    }
  }, {
    key: '_expandReportCard',
    value: function _expandReportCard() {
      this.setState({ isExpandReportCard: !this.state.isExpandReportCard });
    }
  }, {
    key: '_renderStudentInformation',
    value: function _renderStudentInformation() {
      var _this2 = this;

      if (!this.props.studentInfo || !this.props.timeZone) return null;
      return _react2.default.createElement(_StudentInformation2.default, { studentInfo: this.props.studentInfo,
        isExpanded: this.state.isExpandStudentInfo,
        onExpandButtonClick: function onExpandButtonClick() {
          return _this2._expandStudentInfo();
        },
        idpId: this.props.idpId,
        groupIdpId: this.props.groupIdpId,
        groupStartDate: this.props.groupStartDate,
        groupEndDate: this.props.groupEndDate,
        timeZone: this.props.timeZone,
        isInEditMode: IndividualDevelopmentPlanDetailView.isInEditMode(this.props),
        canEdit: this.props.canEdit });
    }
  }, {
    key: '_renderReportCard',
    value: function _renderReportCard() {
      var _this3 = this;

      if (!this.props.reportCardInfo) return null;
      var shouldShowAttendance = this.props.isFromOdin;
      return _react2.default.createElement(_ReportCard2.default, { reportCardInfo: this.props.reportCardInfo,
        isExpanded: this.state.isExpandReportCard,
        onExpandButtonClick: function onExpandButtonClick() {
          return _this3._expandReportCard();
        },
        shouldShowAttendance: shouldShowAttendance });
    }
  }, {
    key: '_renderSuggestions',
    value: function _renderSuggestions() {
      var _this4 = this;

      if (!this.props.suggestionsInfo) return null;
      return _react2.default.createElement(_FeedbackSuggestions2.default, { onComponentMounted: function onComponentMounted(_cmpt) {
          _this4.feedbackSuggestionsComponent = _cmpt;
        },
        suggestionsInfo: this.props.suggestionsInfo,
        participationInfo: this.props.idpParticipation,
        isSSV3Group: this.props.isSSV3Group,
        isSkillSuggestionManualOnly: this.props.isSkillSuggestionManualOnly,
        isInEditMode: IndividualDevelopmentPlanDetailView.isInEditCommentsMode(this.props),
        changeMode: this._changeMode,
        idpId: this.props.idpId,
        groupIdpId: this.props.groupIdpId,
        canEdit: this.props.canEdit,
        shouldShowSuggestions: this.props.shouldShowSuggestions,
        skillRecommendations: this.props.skillRecommendations });
    }
  }, {
    key: '_renderOverallDevelopment',
    value: function _renderOverallDevelopment() {
      var _this5 = this;

      if (!this.props.isSSV3Group || !this.props.studentInfo) return null;
      return _react2.default.createElement(_OverallDevelopment2.default, { onComponentMounted: function onComponentMounted(_cmpt) {
          _this5.overallDevelopmentComponent = _cmpt;
        },
        studentInfo: this.props.studentInfo,
        idpId: this.props.idpId,
        groupIdpId: this.props.groupIdpId,
        canEdit: this.props.canEdit,
        changeMode: this._changeMode,
        isInEditMode: IndividualDevelopmentPlanDetailView.isInEditOverallDevelopmentMode(this.props) });
    }
  }, {
    key: '_renderStudyPlan',
    value: function _renderStudyPlan() {
      var _this6 = this;

      if (!this.props.studentInfo) return null;
      return _react2.default.createElement(_StudyPlan2.default, { onComponentMounted: function onComponentMounted(_cmpt) {
          _this6.studyPlanComponent = _cmpt;
        },
        groupId: this.props.groupId,
        studentInfo: this.props.studentInfo,
        idpId: this.props.idpId,
        groupIdpId: this.props.groupIdpId,
        canEdit: this.props.canEdit,
        changeMode: this._changeMode,
        isInEditMode: IndividualDevelopmentPlanDetailView.isInEditStudyPlanMode(this.props) });
    }
  }, {
    key: '_changeMode',
    value: function _changeMode() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var buildRoute = this.props.buildRoute;

      this._forcePushRoute(buildRoute({ mode: mode }));
    }
  }, {
    key: '_onDiscardClick',
    value: function _onDiscardClick() {
      this.feedbackSuggestionsComponent.setWasCommentsEditMade(false);
      this.studyPlanComponent.setWasEditMade(false);
      this.overallDevelopmentComponent.setWasEditMade(false);
    }
  }, {
    key: '_shouldRenderStayLeaveWarning',
    value: function _shouldRenderStayLeaveWarning() {
      if (IndividualDevelopmentPlanDetailView.isInEditCommentsMode(this.props)) {
        return false;
      }
      if (IndividualDevelopmentPlanDetailView.isInEditStudyPlanMode(this.props)) {
        return this.studyPlanComponent && this.studyPlanComponent.shouldDisableSaveButton();
      }
      if (IndividualDevelopmentPlanDetailView.isInEditOverallDevelopmentMode(this.props)) {
        return this.overallDevelopmentComponent && this.overallDevelopmentComponent.shouldDisableSaveButton();
      }
      return false;
    }
  }, {
    key: '_onSaveClickedOnWarningDialog',
    value: function _onSaveClickedOnWarningDialog() {
      if (IndividualDevelopmentPlanDetailView.isInEditCommentsMode(this.props)) {
        this.feedbackSuggestionsComponent.onSaveClick();
      }
      if (IndividualDevelopmentPlanDetailView.isInEditStudyPlanMode(this.props)) {
        this.studyPlanComponent.onSaveClick();
      }
      if (IndividualDevelopmentPlanDetailView.isInEditOverallDevelopmentMode(this.props)) {
        this.overallDevelopmentComponent.onSaveClick();
      }
    }
  }, {
    key: '_renderUnsavedChangesWarningDialog',
    value: function _renderUnsavedChangesWarningDialog() {
      var _this7 = this;

      if (this._shouldRenderStayLeaveWarning()) {
        return _react2.default.createElement(_omniCommonUi.ConfirmDialog, { isOpen: !!this._isNavigationWithChangesRequested(),
          primaryButtonContent: 'Stay',
          secondaryButtonContent: 'Leave',
          content: 'Are you sure you want to leave this page and lose unsaved changes?',
          onPrimaryClick: function onPrimaryClick() {
            _this7._clearRequestedLocation();
          },
          onSecondaryClick: function onSecondaryClick() {
            _this7._onDiscardClick();
            _this7._forcePushRequestedLocation();
          },
          onRequestClose: function onRequestClose() {
            _this7._clearRequestedLocation();
          } });
      }
      return _react2.default.createElement(_UnsavedChangesWarning2.default, { isOpen: !!this._isNavigationWithChangesRequested(),
        isSaving: this.props.isAnyApiCallSaving,
        onSaveClicked: function onSaveClicked() {
          _this7._onSaveClickedOnWarningDialog();
        },
        onDiscardClicked: function onDiscardClicked() {
          _this7._onDiscardClick();
          _this7._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this7._clearRequestedLocation();
        },
        onSaved: function onSaved() {
          _this7._forcePushRequestedLocation();
        } });
    }
  }, {
    key: '_renderExportDialog',
    value: function _renderExportDialog() {
      var _props2 = this.props,
          mode = _props2.mode,
          buildRoute = _props2.buildRoute,
          pushRoute = _props2.pushRoute,
          languageCode = _props2.languageCode,
          idpId = _props2.idpId,
          reportName = _props2.reportName;

      var isInExportRoute = mode === _routes.Modes.EXPORT;
      return isInExportRoute && _react2.default.createElement(_ExportDialog2.default, { idpId: idpId,
        languageCode: languageCode,
        pushRoute: pushRoute,
        buildRoute: buildRoute,
        reportName: reportName });
    }
  }, {
    key: '_renderRjectNote',
    value: function _renderRjectNote() {
      var _props3 = this.props,
          _props3$idpStatus = _props3.idpStatus,
          idpStatus = _props3$idpStatus === undefined ? '' : _props3$idpStatus,
          dosRejectedComment = _props3.dosRejectedComment,
          timeZone = _props3.timeZone;

      return dosRejectedComment && idpStatus.toLowerCase() === _IndividualDevelopmentPlanStatus.IdpStatus.REJECTED.toLowerCase() && _react2.default.createElement(_RejectNote2.default, { note: dosRejectedComment.rejectedComment,
        rejectTime: dosRejectedComment.rejectedDate,
        timeZone: timeZone,
        teacherId: dosRejectedComment.rejectedBy });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { outerMargin: true },
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          this._renderRjectNote(),
          this._renderStudentInformation(),
          this._renderReportCard(),
          this._renderSuggestions(),
          this._renderOverallDevelopment(),
          this._renderStudyPlan(),
          this._renderUnsavedChangesWarningDialog(),
          this._renderExportDialog()
        )
      );
    }
  }]);

  return IndividualDevelopmentPlanDetailView;
}(_UnsavedChangesTrackingPageComponent2.default);

IndividualDevelopmentPlanDetailView.isInEditCommentsMode = function (props) {
  return props.params && props.params.mode === _routes.Modes.EDIT_COMMENTS;
};

IndividualDevelopmentPlanDetailView.isInEditStudyPlanMode = function (props) {
  return props.params && props.params.mode === _routes.Modes.EDIT_STUDY_PLAN;
};

IndividualDevelopmentPlanDetailView.isInEditOverallDevelopmentMode = function (props) {
  return props.params && props.params.mode === _routes.Modes.EDIT_OVERALL_DEVELOPMENT;
};

IndividualDevelopmentPlanDetailView.isInEditMode = function (props) {
  return IndividualDevelopmentPlanDetailView.isInEditCommentsMode(props) || IndividualDevelopmentPlanDetailView.isInEditStudyPlanMode(props) || IndividualDevelopmentPlanDetailView.isInEditOverallDevelopmentMode(props);
};

IndividualDevelopmentPlanDetailView.propTypes = {
  fetchIdpLearningResultIfNeeded: _propTypes2.default.func.isRequired,
  fetchIdpFeedbackSuggestionsIfNeeded: _propTypes2.default.func.isRequired,
  fetchIdpParticipationIfNeeded: _propTypes2.default.func.isRequired,
  submitIndividualDevelopmentPlan: _propTypes2.default.func.isRequired,
  idpParticipation: _propTypes2.default.shape(),
  studentInfo: _propTypes2.default.shape(),
  reportCardInfo: _propTypes2.default.shape(),
  suggestionsInfo: _propTypes2.default.shape(),
  skillRecommendations: _propTypes2.default.shape(),
  dosRejectedComment: _propTypes2.default.shape(),
  idpId: _propTypes2.default.string,
  groupIdpId: _propTypes2.default.string,
  groupId: _propTypes2.default.string,
  isFromOdin: _propTypes2.default.bool,
  canEdit: _propTypes2.default.bool,
  isSSV3Group: _propTypes2.default.bool,
  isSkillSuggestionManualOnly: _propTypes2.default.bool,
  shouldShowSuggestions: _propTypes2.default.bool,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func,
  isAnyApiCallSaving: _propTypes2.default.bool,
  groupStartDate: _propTypes2.default.shape(),
  groupEndDate: _propTypes2.default.shape(),
  timeZone: _propTypes2.default.string,
  mode: _propTypes2.default.string,
  languageCode: _propTypes2.default.string,
  reportName: _propTypes2.default.string
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      groupIdpId = _ownProps$params.groupIdpId,
      studentId = _ownProps$params.studentId,
      mode = _ownProps$params.mode;

  var _groupActions$getCent = _.actions.getCentre(state, groupId),
      timeZone = _groupActions$getCent.timeZone;

  var idpParticipation = state.get('rootReducer').get('idpParticipation');
  var groupIdpList = state.get('rootReducer').get('individualDevelopmentPlanList');
  var shouldShowSuggestions = _IndividualDevelopmentPlans.accessors.shouldShowSuggestions(groupIdpList, groupIdpId, studentId);
  var studentInfo = _IndividualDevelopmentPlans.accessors.getStudentInfo(state, ownProps);
  var reportCardInfo = _IndividualDevelopmentPlans.accessors.getReportCardInfo(state, ownProps);
  var idpId = _IndividualDevelopmentPlans.accessors.getIdpId(state, groupIdpId, studentId);
  var idpStatus = _IndividualDevelopmentPlans.accessors.getIdpStatus(state, idpId);
  var dosRejectedComment = _IndividualDevelopmentPlans.accessors.getDosRejectedComment(state, ownProps);
  var suggestionsInfo = _IndividualDevelopmentPlans.accessors.getSuggestionsInfo(state, ownProps);
  var group = state.get('rootReducer').get('groups').get(groupId).data;
  var isFromOdin = group.isFromOdin;
  var languageCode = group.get('languageCode');
  var skillRecommendations = state.get('rootReducer').get('skillRecommendation').get(groupId);
  var _group$period = group.period,
      groupStartDate = _group$period.start,
      groupEndDate = _group$period.end;


  var canEdit = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.IndividualDevelopmentPlan.Manage) && !_.actions.isDisabledReportActions(state, groupId) && idpStatus && !IndividualDevelopmentPlanDetailView.isInEditMode(ownProps) && (idpStatus.toLowerCase() === _IndividualDevelopmentPlanStatus.IdpStatus.INCOMPLETE.toLowerCase() || idpStatus.toLowerCase() === _IndividualDevelopmentPlanStatus.IdpStatus.READY.toLowerCase() || idpStatus.toLowerCase() === _IndividualDevelopmentPlanStatus.IdpStatus.REJECTED.toLowerCase());
  var reportName = _IndividualDevelopmentPlans.accessors.getReportName(state, groupIdpId);

  return {
    reportName: reportName,
    mode: mode,
    languageCode: languageCode,
    idpParticipation: idpParticipation,
    studentInfo: studentInfo,
    reportCardInfo: reportCardInfo,
    suggestionsInfo: suggestionsInfo,
    idpId: idpId,
    groupIdpId: groupIdpId,
    groupId: groupId,
    isFromOdin: isFromOdin,
    canEdit: canEdit,
    shouldShowSuggestions: shouldShowSuggestions,
    skillRecommendations: skillRecommendations,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state),
    groupStartDate: groupStartDate,
    groupEndDate: groupEndDate,
    timeZone: timeZone,
    idpStatus: idpStatus,
    dosRejectedComment: dosRejectedComment,
    isSSV3Group: !!_.actions.isSSV3Group(state, groupId),
    isSkillSuggestionManualOnly: !!_.actions.isFRV2CourseTypeGroup(state, groupId)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_IndividualDevelopmentPlans.actions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(IndividualDevelopmentPlanDetailView));

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1774);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReadOnlyField = function ReadOnlyField(props) {
  var classesBoard = (0, _classnames2.default)(_style2.default.ReadOnlyField_board, props.className);
  var classesH5 = (0, _classnames2.default)(_style2.default.ReadOnlyField_h5, (0, _omniCommonUi.testClass)('field-title'));
  var classesP = (0, _classnames2.default)(_style2.default.ReadOnlyField_p, (0, _omniCommonUi.testClass)('field-value'));

  return _react2.default.createElement(
    'div',
    { className: classesBoard },
    _react2.default.createElement(
      'h5',
      { className: classesH5 },
      props.boardTitle
    ),
    _react2.default.createElement(
      'p',
      { className: classesP },
      judgeValue(props.boardValue)
    )
  );

  function judgeValue(boardValue) {
    if (!_is_js2.default.not.undefined(boardValue) || !boardValue || boardValue === '') {
      return '–';
    }
    return boardValue;
  }
};

ReadOnlyField.propTypes = {
  boardTitle: _propTypes2.default.string.isRequired,
  boardValue: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string
};

exports.default = ReadOnlyField;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.stateify = exports.TokenState = exports.CharacterState = undefined;

var _class = __webpack_require__(214);

function createStateClass() {
	return function (tClass) {
		this.j = [];
		this.T = tClass || null;
	};
}

/**
	A simple state machine that can emit token classes

	The `j` property in this class refers to state jumps. It's a
	multidimensional array where for each element:

	* index [0] is a symbol or class of symbols to transition to.
	* index [1] is a State instance which matches

	The type of symbol will depend on the target implementation for this class.
	In Linkify, we have a two-stage scanner. Each stage uses this state machine
	but with a slighly different (polymorphic) implementation.

	The `T` property refers to the token class.

	TODO: Can the `on` and `next` methods be combined?

	@class BaseState
*/
var BaseState = createStateClass();
BaseState.prototype = {
	defaultTransition: false,

	/**
 	@method constructor
 	@param {Class} tClass Pass in the kind of token to emit if there are
 		no jumps after this state and the state is accepting.
 */

	/**
 	On the given symbol(s), this machine should go to the given state
 		@method on
 	@param {Array|Mixed} symbol
 	@param {BaseState} state Note that the type of this state should be the
 		same as the current instance (i.e., don't pass in a different
 		subclass)
 */
	on: function on(symbol, state) {
		if (symbol instanceof Array) {
			for (var i = 0; i < symbol.length; i++) {
				this.j.push([symbol[i], state]);
			}
			return this;
		}
		this.j.push([symbol, state]);
		return this;
	},


	/**
 	Given the next item, returns next state for that item
 	@method next
 	@param {Mixed} item Should be an instance of the symbols handled by
 		this particular machine.
 	@return {State} state Returns false if no jumps are available
 */
	next: function next(item) {
		for (var i = 0; i < this.j.length; i++) {
			var jump = this.j[i];
			var symbol = jump[0]; // Next item to check for
			var state = jump[1]; // State to jump to if items match

			// compare item with symbol
			if (this.test(item, symbol)) {
				return state;
			}
		}

		// Nowhere left to jump!
		return this.defaultTransition;
	},


	/**
 	Does this state accept?
 	`true` only of `this.T` exists
 		@method accepts
 	@return {Boolean}
 */
	accepts: function accepts() {
		return !!this.T;
	},


	/**
 	Determine whether a given item "symbolizes" the symbol, where symbol is
 	a class of items handled by this state machine.
 		This method should be overriden in extended classes.
 		@method test
 	@param {Mixed} item Does this item match the given symbol?
 	@param {Mixed} symbol
 	@return {Boolean}
 */
	test: function test(item, symbol) {
		return item === symbol;
	},


	/**
 	Emit the token for this State (just return it in this case)
 	If this emits a token, this instance is an accepting state
 	@method emit
 	@return {Class} T
 */
	emit: function emit() {
		return this.T;
	}
};

/**
	State machine for string-based input

	@class CharacterState
	@extends BaseState
*/
var CharacterState = (0, _class.inherits)(BaseState, createStateClass(), {
	/**
 	Does the given character match the given character or regular
 	expression?
 		@method test
 	@param {String} char
 	@param {String|RegExp} charOrRegExp
 	@return {Boolean}
 */
	test: function test(character, charOrRegExp) {
		return character === charOrRegExp || charOrRegExp instanceof RegExp && charOrRegExp.test(character);
	}
});

/**
	State machine for input in the form of TextTokens

	@class TokenState
	@extends BaseState
*/
var TokenState = (0, _class.inherits)(BaseState, createStateClass(), {

	/**
  * Similar to `on`, but returns the state the results in the transition from
  * the given item
  * @method jump
  * @param {Mixed} item
  * @param {Token} [token]
  * @return state
  */
	jump: function jump(token) {
		var tClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		var state = this.next(new token('')); // dummy temp token
		if (state === this.defaultTransition) {
			// Make a new state!
			state = new this.constructor(tClass);
			this.on(token, state);
		} else if (tClass) {
			state.T = tClass;
		}
		return state;
	},


	/**
 	Is the given token an instance of the given token class?
 		@method test
 	@param {TextToken} token
 	@param {Class} tokenClass
 	@return {Boolean}
 */
	test: function test(token, tokenClass) {
		return token instanceof tokenClass;
	}
});

/**
	Given a non-empty target string, generates states (if required) for each
	consecutive substring of characters in str starting from the beginning of
	the string. The final state will have a special value, as specified in
	options. All other "in between" substrings will have a default end state.

	This turns the state machine into a Trie-like data structure (rather than a
	intelligently-designed DFA).

	Note that I haven't really tried these with any strings other than
	DOMAIN.

	@param {String} str
	@param {CharacterState} start State to jump from the first character
	@param {Class} endToken Token class to emit when the given string has been
		matched and no more jumps exist.
	@param {Class} defaultToken "Filler token", or which token type to emit when
		we don't have a full match
	@return {Array} list of newly-created states
*/
function stateify(str, start, endToken, defaultToken) {
	var i = 0,
	    len = str.length,
	    state = start,
	    newStates = [],
	    nextState = void 0;

	// Find the next state without a jump to the next character
	while (i < len && (nextState = state.next(str[i]))) {
		state = nextState;
		i++;
	}

	if (i >= len) {
		return [];
	} // no new tokens were added

	while (i < len - 1) {
		nextState = new CharacterState(defaultToken);
		newStates.push(nextState);
		state.on(str[i], nextState);
		state = nextState;
		i++;
	}

	nextState = new CharacterState(endToken);
	newStates.push(nextState);
	state.on(str[len - 1], nextState);

	return newStates;
}

exports.CharacterState = CharacterState;
exports.TokenState = TokenState;
exports.stateify = stateify;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createTokenClass() {
	return function (value) {
		if (value) {
			this.v = value;
		}
	};
}

exports.createTokenClass = createTokenClass;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1794);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_PureComponent) {
  _inherits(Checkbox, _PureComponent);

  function Checkbox(props) {
    _classCallCheck(this, Checkbox);

    var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

    _this._handleCheck = _this._handleCheck.bind(_this);
    return _this;
  }

  _createClass(Checkbox, [{
    key: '_handleCheck',
    value: function _handleCheck(e) {
      this.props.onChange(e.target.checked);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          checked = _props.checked,
          disabled = _props.disabled,
          onChange = _props.onChange;

      return _react2.default.createElement(
        'div',
        { className: _style2.default.Checkbox },
        _react2.default.createElement('input', { type: 'checkbox',
          id: this.props.id,
          name: this.props.name,
          value: this.props.value || this.props.id,
          checked: _is_js2.default.existy(checked) ? !!checked : undefined,
          disabled: _is_js2.default.existy(disabled) ? !!disabled : undefined,
          className: _style2.default.Checkbox_input,
          onChange: onChange ? this._handleCheck : null }),
        _react2.default.createElement('label', { className: _style2.default.Checkbox_label, htmlFor: this.props.id })
      );
    }
  }]);

  return Checkbox;
}(_react.PureComponent);

Checkbox.propTypes = {
  id: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func
};

exports.default = Checkbox;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1796);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BottomButtons = function (_PureComponent) {
  _inherits(BottomButtons, _PureComponent);

  function BottomButtons() {
    _classCallCheck(this, BottomButtons);

    return _possibleConstructorReturn(this, (BottomButtons.__proto__ || Object.getPrototypeOf(BottomButtons)).apply(this, arguments));
  }

  _createClass(BottomButtons, [{
    key: '_renderButtons',
    value: function _renderButtons() {
      var _this2 = this;

      if (_is_js2.default.array(this.props.buttons)) {
        return this.props.buttons.map(function (button) {
          return _react2.default.createElement(
            _omniCommonUi.Button,
            { className: (0, _classnames2.default)(_style2.default.BottomButtons_button, (0, _omniCommonUi.testClass)(button.text)),
              type: button.primary && _omniCommonUi.Button.Type.primary,
              onClick: function onClick() {
                return button.onClick && button.onClick();
              },
              disabled: button.disabled,
              key: button.text },
            button.text
          );
        });
      }
      return [_react2.default.createElement(
        _omniCommonUi.Button,
        { className: (0, _classnames2.default)(_style2.default.BottomButtons_button, (0, _omniCommonUi.testClass)('button-' + this.props.primaryText)),
          type: _omniCommonUi.Button.Type.primary,
          onClick: function onClick() {
            return _this2.props.onPrimaryClick && _this2.props.onPrimaryClick();
          },
          disabled: this.props.isPrimaryDisabled,
          key: this.props.primaryText },
        this.props.primaryText
      ), _react2.default.createElement(
        _omniCommonUi.Button,
        { className: (0, _classnames2.default)(_style2.default.BottomButtons_button, (0, _omniCommonUi.testClass)('button-' + this.props.secondaryText)),
          type: _omniCommonUi.Button.Type.default,
          onClick: function onClick() {
            return _this2.props.onSecondaryClick && _this2.props.onSecondaryClick();
          },
          disabled: this.props.isSecondaryDisabled,
          key: this.props.secondaryText },
        this.props.secondaryText
      )];
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _omniCommonUi.Button.Container,
        { className: (0, _classnames2.default)(_style2.default.BottomButtons, this.props.className),
          align: 'right' },
        this._renderButtons()
      );
    }
  }]);

  return BottomButtons;
}(_react.PureComponent);

BottomButtons.propTypes = {
  buttons: _propTypes2.default.array,
  primaryText: _propTypes2.default.string,
  secondaryText: _propTypes2.default.string,
  onPrimaryClick: _propTypes2.default.func,
  onSecondaryClick: _propTypes2.default.func,
  isPrimaryDisabled: _propTypes2.default.bool,
  isSecondaryDisabled: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

exports.default = BottomButtons;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextInput2 = __webpack_require__(1809);

var _TextInput3 = _interopRequireDefault(_TextInput2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextInput = _TextInput3.default;

exports.default = TextInput;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PUBLISH_STUDY_PLAN_FAILURE = exports.PUBLISH_STUDY_PLAN_SUCCESS = exports.PUBLISH_STUDY_PLAN_REQUEST = exports.FETCH_STUDY_PLAN_FAILURE = exports.FETCH_STUDY_PLAN_SUCCESS = exports.FETCH_STUDY_PLAN_REQUEST = exports.FETCH_STUDY_PLAN_COURSES_FAILURE = exports.FETCH_STUDY_PLAN_COURSES_SUCCESS = exports.FETCH_STUDY_PLAN_COURSES_REQUEST = undefined;
exports.fetchStudyPlanCourseIfNeeded = fetchStudyPlanCourseIfNeeded;
exports.fetchStudyPlanIfNeeded = fetchStudyPlanIfNeeded;
exports.fetchStudyPlanCourse = fetchStudyPlanCourse;
exports.fetchStudentPlan = fetchStudentPlan;
exports.publishStudyPlan = publishStudyPlan;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var _actions = __webpack_require__(168);

var idpActions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var FETCH_STUDY_PLAN_COURSES_REQUEST = exports.FETCH_STUDY_PLAN_COURSES_REQUEST = 'FETCH_STUDY_PLAN_COURSES_REQUEST';
var FETCH_STUDY_PLAN_COURSES_SUCCESS = exports.FETCH_STUDY_PLAN_COURSES_SUCCESS = 'FETCH_STUDY_PLAN_COURSES_SUCCESS';
var FETCH_STUDY_PLAN_COURSES_FAILURE = exports.FETCH_STUDY_PLAN_COURSES_FAILURE = 'FETCH_STUDY_PLAN_COURSES_FAILURE';
var FETCH_STUDY_PLAN_REQUEST = exports.FETCH_STUDY_PLAN_REQUEST = 'FETCH_STUDY_PLAN_REQUEST';
var FETCH_STUDY_PLAN_SUCCESS = exports.FETCH_STUDY_PLAN_SUCCESS = 'FETCH_STUDY_PLAN_SUCCESS';
var FETCH_STUDY_PLAN_FAILURE = exports.FETCH_STUDY_PLAN_FAILURE = 'FETCH_STUDY_PLAN_FAILURE';
var PUBLISH_STUDY_PLAN_REQUEST = exports.PUBLISH_STUDY_PLAN_REQUEST = 'PUBLISH_STUDY_PLAN_REQUEST';
var PUBLISH_STUDY_PLAN_SUCCESS = exports.PUBLISH_STUDY_PLAN_SUCCESS = 'PUBLISH_STUDY_PLAN_SUCCESS';
var PUBLISH_STUDY_PLAN_FAILURE = exports.PUBLISH_STUDY_PLAN_FAILURE = 'PUBLISH_STUDY_PLAN_FAILURE';

var buildFetchStudyPlanCourseUrl = function buildFetchStudyPlanCourseUrl(idpId) {
  return (0, _Api.buildUrl)('/student-idps/' + idpId + '/study-plan-courses');
};
var buildPublishStudyPlanUrl = function buildPublishStudyPlanUrl(idpId) {
  return (0, _Api.buildUrl)('/student-idps/' + idpId + '/study-plan');
};
var buildFetchStudyPlanUrl = function buildFetchStudyPlanUrl(idpId) {
  return (0, _Api.buildUrl)('/student-idps/' + idpId + '/study-plan');
};

function fetchStudyPlanCourseIfNeeded(idpId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchStudyPlanCourseUrl(idpId) })) {
      return false;
    }

    return dispatch(fetchStudyPlanCourse(idpId));
  };
}

function fetchStudyPlanIfNeeded(idpId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchStudyPlanUrl(idpId) })) {
      return false;
    }

    return dispatch(fetchStudentPlan(idpId));
  };
}

function fetchStudyPlanCourse(idpId) {
  return function (dispatch) {
    var url = buildFetchStudyPlanCourseUrl(idpId);
    var method = 'GET';

    return dispatch(fetchStudyPlanCourseRequest()).payload.then(function (response) {
      return dispatch(fetchStudyPlanCourseSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchStudyPlanCourseFailure(error));
    });

    function fetchStudyPlanCourseRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDY_PLAN_COURSES_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        idpId: idpId
      });
    }

    function fetchStudyPlanCourseSuccess(courses) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDY_PLAN_COURSES_SUCCESS,
        payload: courses,
        url: url,
        method: method,
        idpId: idpId
      });
    }

    function fetchStudyPlanCourseFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDY_PLAN_COURSES_FAILURE,
        error: error,
        url: url,
        method: method,
        idpId: idpId
      });
    }
  };
}

function fetchStudentPlan(idpId) {
  return function (dispatch) {
    var url = buildFetchStudyPlanUrl(idpId);
    var method = 'GET';

    return dispatch(fetchStudentPlanRequest()).payload.then(function (response) {
      return dispatch(fetchStudentPlanSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchStudentPlanFailure(error));
    });

    function fetchStudentPlanRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDY_PLAN_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        idpId: idpId
      });
    }

    function fetchStudentPlanSuccess(studyPlan) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDY_PLAN_SUCCESS,
        payload: studyPlan,
        url: url,
        method: method,
        idpId: idpId
      });
    }

    function fetchStudentPlanFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_STUDY_PLAN_FAILURE,
        error: error,
        url: url,
        method: method,
        idpId: idpId
      });
    }
  };
}

function publishStudyPlan(idpId, studyPlan, groupIdpId) {
  return function (dispatch) {
    var url = buildPublishStudyPlanUrl(idpId);
    var method = 'POST';
    var request = (0, _Api.fetch)(url, {
      method: method, body: JSON.stringify(studyPlan)
    });

    return dispatch(publishStudyPlanRequest()).payload.then(function (response) {
      return dispatch(publishStudyPlanSuccess(response));
    }).then(function () {
      return dispatch(fetchStudentPlan(idpId));
    }).catch(function (error) {
      return dispatch(publishStudyPlanFailure(error));
    }).then(function () {
      return dispatch(idpActions.fetchIndividualDevelopmentPlanList(groupIdpId));
    });

    function publishStudyPlanRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: PUBLISH_STUDY_PLAN_REQUEST,
        payload: request,
        url: url,
        method: method,
        idpId: idpId
      });
    }

    function publishStudyPlanSuccess() {
      return _omniCommonUi.ApiCall.createAction({
        type: PUBLISH_STUDY_PLAN_SUCCESS,
        url: url,
        method: method,
        studyPlan: studyPlan
      });
    }

    function publishStudyPlanFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: PUBLISH_STUDY_PLAN_FAILURE,
        error: error,
        url: url,
        method: method,
        idpId: idpId
      });
    }
  };
}

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudyPlanRecord = _immutable2.default.Record({
  studentIDPId: undefined,
  studyPlanId: undefined,
  coreCourseId: undefined,
  nonCoreCourseId: undefined,
  otherOptions: undefined,
  sequence: undefined
});

var StudyPlan = function (_StudyPlanRecord) {
  _inherits(StudyPlan, _StudyPlanRecord);

  function StudyPlan() {
    _classCallCheck(this, StudyPlan);

    return _possibleConstructorReturn(this, (StudyPlan.__proto__ || Object.getPrototypeOf(StudyPlan)).apply(this, arguments));
  }

  return StudyPlan;
}(StudyPlanRecord);

exports.default = StudyPlan;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _style = __webpack_require__(1836);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouter = __webpack_require__(16);

var _reactRouterRedux = __webpack_require__(15);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _classnames3 = __webpack_require__(7);

var _classnames4 = _interopRequireDefault(_classnames3);

var _omniCommonUi = __webpack_require__(0);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _GroupMembers = __webpack_require__(14);

var _ = __webpack_require__(13);

var _2 = __webpack_require__(323);

var _StudentCardProfile = __webpack_require__(84);

var _StudentCardProfile2 = _interopRequireDefault(_StudentCardProfile);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _AddInternalNoteControl = __webpack_require__(67);

var _AddInternalNoteControl2 = _interopRequireDefault(_AddInternalNoteControl);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _NoContentMessage = __webpack_require__(66);

var _NoContentMessage2 = _interopRequireDefault(_NoContentMessage);

var _RejectNotePopup = __webpack_require__(206);

var _RejectNotePopup2 = _interopRequireDefault(_RejectNotePopup);

var _UserInfo = __webpack_require__(1838);

var _UserInfo2 = _interopRequireDefault(_UserInfo);

var _routes = __webpack_require__(786);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IndividualDevelopmentPlanApprovalView = function (_UnsavedChangesTracki) {
  _inherits(IndividualDevelopmentPlanApprovalView, _UnsavedChangesTracki);

  function IndividualDevelopmentPlanApprovalView(props) {
    _classCallCheck(this, IndividualDevelopmentPlanApprovalView);

    var _this = _possibleConstructorReturn(this, (IndividualDevelopmentPlanApprovalView.__proto__ || Object.getPrototypeOf(IndividualDevelopmentPlanApprovalView)).call(this, props));

    _this.state = { wasContentEditMade: false, isAnyMandatoryEmpty: false };

    _this._onDiscardClick = _this._onDiscardClick.bind(_this);
    _this._onOverallChanged = _this._onOverallChanged.bind(_this);
    _this._onSkillSuggestionChanged = _this._onSkillSuggestionChanged.bind(_this);
    _this._onDialogCancelled = _this._onDialogCancelled.bind(_this);
    _this._onRejectStudentIdpReport = _this._onRejectStudentIdpReport.bind(_this);
    return _this;
  }

  _createClass(IndividualDevelopmentPlanApprovalView, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      _get(IndividualDevelopmentPlanApprovalView.prototype.__proto__ || Object.getPrototypeOf(IndividualDevelopmentPlanApprovalView.prototype), 'componentWillMount', this).call(this);
      this._fetchIdpApprovalContents(this.props, true);
      this._initCommentsInEditMode();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._fetchIdpApprovalContents(nextProps);
      this._initCommentsInEditMode(nextProps);
    }
  }, {
    key: '_isChangesPresent',
    value: function _isChangesPresent() {
      return IndividualDevelopmentPlanApprovalView.isInEditMode(this.props) && this.state.wasContentEditMade;
    }
  }, {
    key: '_wasContentEditMade',
    value: function _wasContentEditMade() {
      return IndividualDevelopmentPlanApprovalView.isInEditMode(this.props) && this.state.wasContentEditMade;
    }
  }, {
    key: '_setWasContEditMade',
    value: function _setWasContEditMade(wasContentEditMade) {
      if (this.state.wasContentEditMade === wasContentEditMade) return;
      this.setState({ wasContentEditMade: wasContentEditMade });
    }
  }, {
    key: '_initCommentsInEditMode',
    value: function _initCommentsInEditMode() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      var isInEditMode = IndividualDevelopmentPlanApprovalView.isInEditMode;
      if (!props.idpApprovalContents || props.idpApprovalContents.size === 0 || !IndividualDevelopmentPlanApprovalView.isInEditMode(props) || !isInEditMode(this.props) && isInEditMode(props)) return;
      var idpApprovalContent = props.idpApprovalContents.find(function (content) {
        return content.idpId === props.idpId;
      });
      if (!idpApprovalContent) return;
      var overallSuggestion = idpApprovalContent.overallSuggestion,
          participationId = idpApprovalContent.participationId,
          skillSuggestions = idpApprovalContent.skillSuggestions,
          idpId = idpApprovalContent.idpId;

      if (this.state.wasContentEditMade) return;
      this._onEditComments(overallSuggestion, participationId, skillSuggestions, idpId);
    }
  }, {
    key: '_isContentInEditMode',
    value: function _isContentInEditMode(props, idpId) {
      var isPageInEditMode = IndividualDevelopmentPlanApprovalView.isInEditMode(props);
      return isPageInEditMode && idpId === props.idpId;
    }
  }, {
    key: '_onEditComments',
    value: function _onEditComments(overallSuggestion, participationId, skillSuggestions, idpId) {
      this.setState({
        overallSuggestion: overallSuggestion || '',
        participationId: participationId,
        skillSuggestions: this._getInitialSkillSuggestions(skillSuggestions)
      });
      if (_routes.Modes.EDIT !== this.props.mode || idpId !== this.props.idpId) {
        this._changeMode(_routes.Modes.EDIT, idpId);
      }
    }
  }, {
    key: '_getInitialSkillSuggestions',
    value: function _getInitialSkillSuggestions(skillSuggestions) {
      return skillSuggestions.toJS().map(function (skillSuggestion) {
        return {
          skillId: skillSuggestion.skillId,
          suggestion: skillSuggestion.suggestion || '',
          isManuallyAdded: !!skillSuggestion.isManuallyAdded,
          selectedRecommendationList: skillSuggestion.selectedRecommendationList
        };
      });
    }
  }, {
    key: '_onApproveClick',
    value: function _onApproveClick() {
      var _this2 = this;

      var idpId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.idpId;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props,
          groupIdpId = _ref.groupIdpId;

      this.props.approveStudentIdpReport(idpId, groupIdpId).then(function () {
        return _this2._changeMode();
      });
    }
  }, {
    key: '_onRejectStudentIdpReport',
    value: function _onRejectStudentIdpReport() {
      var rejectedComment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var _this3 = this;

      var idpId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.idpId;

      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props,
          groupIdpId = _ref2.groupIdpId;

      this.props.rejectStudentIdpReport(idpId, groupIdpId, rejectedComment).then(function () {
        return _this3._changeMode();
      });
    }
  }, {
    key: '_onRejectClick',
    value: function _onRejectClick(idpId) {
      this._changeMode(_routes.Modes.REJECT, idpId);
    }
  }, {
    key: '_changeMode',
    value: function _changeMode() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var idpId = arguments[1];
      var buildRoute = this.props.buildRoute;

      this._forcePushRoute(buildRoute({ mode: mode, idpId: idpId }));
    }
  }, {
    key: '_fetchIdpApprovalContents',
    value: function _fetchIdpApprovalContents() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var shouldForceFetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var groupIdpId = props.groupIdpId;

      shouldForceFetch ? this.props.fetchIdpApprovalList(groupIdpId) : this.props.fetchIdpApprovalListIfNeeded(groupIdpId);
    }
  }, {
    key: '_renderApprovalList',
    value: function _renderApprovalList() {
      var _this4 = this;

      if (!this.props.idpApprovalContents) return;
      return this.props.idpApprovalContents.map(function (idpApprovalContent) {
        if (!idpApprovalContent) return null;
        return _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          { key: idpApprovalContent.idpId },
          _react2.default.createElement(
            _omniCommonUi.PageCard,
            { className: (0, _omniCommonUi.testClass)('idp-approval') },
            _react2.default.createElement(
              _omniCommonUi.PageCard.Heading,
              { className: _style2.default.IndividualDevelopmentPlanApprovalView_pageHeading },
              _this4._renderStudentCard(idpApprovalContent)
            ),
            _react2.default.createElement(
              _omniCommonUi.PageCard.Heading,
              null,
              _this4._renderReportLink(idpApprovalContent)
            ),
            _react2.default.createElement(
              _omniCommonUi.PageCard.Content,
              { className: _style2.default.IndividualDevelopmentPlanApprovalView_pageContent },
              _this4._renderTeacherAndOverall(idpApprovalContent),
              _this4._renderSuggestions(idpApprovalContent),
              _this4._renderBottomButtons(idpApprovalContent)
            )
          )
        );
      });
    }
  }, {
    key: '_renderReportLink',
    value: function _renderReportLink(_ref3) {
      var studentId = _ref3.studentInfo.id;
      var _props = this.props,
          groupId = _props.groupId,
          groupIdpId = _props.groupIdpId;

      var link = '/group/' + groupId + '/progress-report/' + groupIdpId + '/student/' + studentId;
      return _react2.default.createElement(
        _reactRouter.Link,
        { className: (0, _classnames4.default)(_style2.default.IndividualDevelopmentPlanApprovalViewLink, (0, _omniCommonUi.testClass)('report-link')),
          to: this.props.buildRoute(link),
          draggable: false },
        'Progress Report ',
        _react2.default.createElement(_omniCommonUi.Icon, { id: 'arrow-right',
          className: _style2.default.IndividualDevelopmentPlanApprovalViewLink_icon })
      );
    }
  }, {
    key: '_renderStudentCard',
    value: function _renderStudentCard(_ref4) {
      var studentInfo = _ref4.studentInfo;

      return _react2.default.createElement(
        _omniCommonUi.StudentCard,
        { borderless: true, backgroundless: true },
        _react2.default.createElement(_StudentCardProfile2.default, { withoutBottomPadding: true,
          studentId: studentInfo.id })
      );
    }
  }, {
    key: '_renderTeacherAndOverall',
    value: function _renderTeacherAndOverall(_ref5) {
      var teacherId = _ref5.teacherId,
          overallSuggestion = _ref5.overallSuggestion,
          suggestedTime = _ref5.suggestedTime,
          idpId = _ref5.idpId;
      var timeZone = this.props.timeZone;

      if (!timeZone || !teacherId) return;
      var dateStr = _is_js2.default.existy(suggestedTime) && _is_js2.default.existy(timeZone) ? _omniCommonUi.moment.parseZone(suggestedTime).clone().tz(timeZone).format('YYYY-MM-DD') : '';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_UserInfo2.default, { id: teacherId.toString(),
          dateStr: dateStr,
          className: _style2.default.IndividualDevelopmentPlanApprovalView_userInfo }),
        this._renderOverall(overallSuggestion, idpId)
      );
    }
  }, {
    key: '_renderOverall',
    value: function _renderOverall(overallSuggestion, idpId) {
      var isContentInEditMode = this._isContentInEditMode(this.props, idpId);
      var overallTitleClasses = (0, _classnames4.default)(_style2.default._overallTitle, _defineProperty({}, _style2.default.__noGray, isContentInEditMode));
      var content = isContentInEditMode ? this.state.overallSuggestion : overallSuggestion;
      return _react2.default.createElement(
        'div',
        { className: _style2.default.IndividualDevelopmentPlanApprovalView_overall },
        _react2.default.createElement(
          'div',
          { className: overallTitleClasses },
          'Overall'
        ),
        this._renderContent(content, isContentInEditMode, 'overall')
      );
    }
  }, {
    key: '_renderSuggestions',
    value: function _renderSuggestions(_ref6) {
      var _this5 = this;

      var skillSuggestions = _ref6.skillSuggestions,
          idpId = _ref6.idpId,
          shouldShowSuggestions = _ref6.shouldShowSuggestions;

      if (!shouldShowSuggestions) return;
      return skillSuggestions.map(function (skillSuggestion, index) {
        var isContentInEditMode = _this5._isContentInEditMode(_this5.props, idpId);
        var skillTitle = '' + (skillSuggestion.name || '') + (' ' + _IndividualDevelopmentPlans.accessors.formatSkillScore(skillSuggestion.score, '') + ' ') + '- Suggestions';
        var skillTitleClasses = (0, _classnames4.default)(_style2.default._suggestionTitle, _defineProperty({}, _style2.default.__noGray, isContentInEditMode));
        var content = isContentInEditMode ? _this5.state.skillSuggestions && _this5.state.skillSuggestions[index].suggestion : skillSuggestion.suggestion;

        return _react2.default.createElement(
          'div',
          { key: skillSuggestion.name || index,
            className: _style2.default.IndividualDevelopmentPlanApprovalView_suggestionCard },
          _react2.default.createElement(
            'div',
            { className: skillTitleClasses },
            skillTitle
          ),
          _this5._renderContent(content, isContentInEditMode, index)
        );
      });
    }
  }, {
    key: '_onOverallChanged',
    value: function _onOverallChanged(text) {
      this._setWasContEditMade(true);
      this.setState({ overallSuggestion: text });
    }
  }, {
    key: '_onSkillSuggestionChanged',
    value: function _onSkillSuggestionChanged(text, index) {
      this._setWasContEditMade(true);
      var skillSuggestions = this.state.skillSuggestions.map(function (skillSuggestion, _index) {
        if (index !== _index) return skillSuggestion;
        return Object.assign({}, skillSuggestion, { suggestion: text });
      });
      this.setState({ skillSuggestions: skillSuggestions });
    }
  }, {
    key: '_renderContent',
    value: function _renderContent(content, isContentInEditMode, contentType) {
      var onContentChanged = void 0;
      if (contentType === 'overall') {
        onContentChanged = this._onOverallChanged;
      } else {
        onContentChanged = this._onSkillSuggestionChanged;
      }

      if (isContentInEditMode) {
        return _react2.default.createElement(_AddInternalNoteControl2.default, { text: content,
          maxCharacters: 1320,
          onChange: function onChange(text) {
            return onContentChanged(text, contentType);
          },
          noAutoScroll: true });
      }
      return _react2.default.createElement(
        'div',
        { className: _style2.default._content },
        content
      );
    }
  }, {
    key: '_onDiscardClick',
    value: function _onDiscardClick() {
      this._setWasContEditMade(false);
      this._changeMode('');
    }
  }, {
    key: '_onDialogCancelled',
    value: function _onDialogCancelled() {
      this._changeMode('');
    }
  }, {
    key: '_onSaveClick',
    value: function _onSaveClick(idpId) {
      var _this6 = this;

      var submittedSuggestions = {
        overallSuggestion: this.state.overallSuggestion || '',
        participationId: this.state.participationId,
        skillSuggestions: this.state.skillSuggestions
      };
      this.props.submitIdpFeedbackSuggestions(idpId, submittedSuggestions, this.props.groupIdpId).then(function () {
        _this6._fetchIdpApprovalContents(_this6.props, true);
        _this6._onDiscardClick();
      });
    }
  }, {
    key: '_markIfAnyMandatoryEmpty',
    value: function _markIfAnyMandatoryEmpty(isAnyMandatoryEmpty) {
      if (isAnyMandatoryEmpty === this.state.isAnyMandatoryEmpty) return;
      this.setState({ isAnyMandatoryEmpty: isAnyMandatoryEmpty });
    }
  }, {
    key: '_renderBottomButtons',
    value: function _renderBottomButtons(idpApprovalContent) {
      var _this7 = this;

      var overallSuggestion = idpApprovalContent.overallSuggestion,
          participationId = idpApprovalContent.participationId,
          skillSuggestions = idpApprovalContent.skillSuggestions,
          idpId = idpApprovalContent.idpId;

      if (this._isContentInEditMode(this.props, idpId)) {
        var hasOverallSuggestionEmpty = !this.state.overallSuggestion.trim();
        this._markIfAnyMandatoryEmpty(hasOverallSuggestionEmpty);
        return _react2.default.createElement(_2.BottomButtons, { primaryText: 'SAVE',
          secondaryText: 'DISCARD',
          isPrimaryDisabled: hasOverallSuggestionEmpty,
          onPrimaryClick: function onPrimaryClick() {
            return _this7._onSaveClick(idpId);
          },
          onSecondaryClick: this._onDiscardClick,
          className: _style2.default.IndividualDevelopmentPlanApprovalView_bottomButtons });
      }
      var isPageInEditMode = IndividualDevelopmentPlanApprovalView.isInEditMode(this.props);
      var saveButton = {
        text: 'APPROVE',
        onClick: function onClick() {
          return _this7._onApproveClick(idpId);
        },
        disabled: !!isPageInEditMode,
        primary: true
      };
      var rejectButton = {
        text: 'REJECT',
        onClick: function onClick() {
          return _this7._onRejectClick(idpId);
        },
        disabled: !!isPageInEditMode
      };
      var editButton = {
        text: 'EDIT',
        onClick: function onClick() {
          return _this7._onEditComments(overallSuggestion, participationId, skillSuggestions, idpId);
        },
        disabled: !!isPageInEditMode
      };
      return _react2.default.createElement(_2.BottomButtons, { buttons: [saveButton, rejectButton, editButton],
        className: _style2.default.IndividualDevelopmentPlanApprovalView_bottomButtons });
    }
  }, {
    key: '_renderDeleteConfirmDialog',
    value: function _renderDeleteConfirmDialog() {
      var isInRejectMode = IndividualDevelopmentPlanApprovalView.isInRejectMode(this.props);
      return isInRejectMode && _react2.default.createElement(_RejectNotePopup2.default, { isOpen: true,
        isLoading: this.props.isAnyApiCallSaving || this.props.isAnyApiCallLoading,
        onSave: this._onRejectStudentIdpReport,
        onCancel: this._onDialogCancelled });
    }
  }, {
    key: '_renderUnsavedChangesWarningDialog',
    value: function _renderUnsavedChangesWarningDialog() {
      var _this8 = this;

      if (IndividualDevelopmentPlanApprovalView.isInEditMode(this.props) && this.state.isAnyMandatoryEmpty) {
        return _react2.default.createElement(_omniCommonUi.ConfirmDialog, { isOpen: !!this._isNavigationWithChangesRequested(),
          primaryButtonContent: 'Stay',
          secondaryButtonContent: 'Leave',
          content: 'Are you sure you want to leave this page and lose unsaved changes?',
          onPrimaryClick: function onPrimaryClick() {
            _this8._clearRequestedLocation();
          },
          onSecondaryClick: function onSecondaryClick() {
            _this8._onDiscardClick();
            _this8._forcePushRequestedLocation();
          },
          onRequestClose: function onRequestClose() {
            _this8._clearRequestedLocation();
          } });
      }
      return _react2.default.createElement(_UnsavedChangesWarning2.default, { isOpen: !!this._isNavigationWithChangesRequested(),
        isSaving: this.props.isAnyApiCallSaving,
        onSaveClicked: function onSaveClicked() {
          _this8._onSaveClick(_this8.props.idpId);
        },
        onDiscardClicked: function onDiscardClicked() {
          _this8._onDiscardClick();
          _this8._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this8._clearRequestedLocation();
        },
        onSaved: function onSaved() {
          _this8._forcePushRequestedLocation();
        } });
    }
  }, {
    key: '_renderNoContentMessage',
    value: function _renderNoContentMessage() {
      var idpApprovalContents = this.props.idpApprovalContents;

      if ((!idpApprovalContents || idpApprovalContents.size === 0) && !this.props.isAnyApiCallLoading) {
        return _react2.default.createElement(_NoContentMessage2.default, { className: (0, _omniCommonUi.testClass)('empty'),
          text: 'There are no reports waiting for approval at this time.' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { outerMargin: true },
        this._renderApprovalList(),
        this._renderNoContentMessage(),
        this._renderUnsavedChangesWarningDialog(),
        this._renderDeleteConfirmDialog()
      );
    }
  }]);

  return IndividualDevelopmentPlanApprovalView;
}(_UnsavedChangesTrackingPageComponent2.default);

IndividualDevelopmentPlanApprovalView.isInEditMode = function (_ref7) {
  var params = _ref7.params;
  return params.mode === _routes.Modes.EDIT && params.idpId;
};

IndividualDevelopmentPlanApprovalView.isInRejectMode = function (_ref8) {
  var params = _ref8.params;
  return params.mode === _routes.Modes.REJECT && params.idpId;
};

IndividualDevelopmentPlanApprovalView.propTypes = {
  groupIdpId: _propTypes2.default.string.isRequired,
  groupId: _propTypes2.default.string.isRequired,
  timeZone: _propTypes2.default.string,
  idpApprovalList: _propTypes2.default.shape(),
  idpApprovalContents: _propTypes2.default.shape(),
  idpId: _propTypes2.default.string,
  fetchIdpApprovalList: _propTypes2.default.func.isRequired,
  fetchIdpApprovalListIfNeeded: _propTypes2.default.func.isRequired,
  fetchIdpFeedbackSuggestionsIfNeeded: _propTypes2.default.func.isRequired,
  submitIdpFeedbackSuggestions: _propTypes2.default.func.isRequired,
  approveStudentIdpReport: _propTypes2.default.func.isRequired,
  rejectStudentIdpReport: _propTypes2.default.func.isRequired,
  isAnyApiCallSaving: _propTypes2.default.bool,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired
};

function mapStatToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      groupIdpId = _ownProps$params.groupIdpId,
      idpId = _ownProps$params.idpId,
      mode = _ownProps$params.mode;

  var groupIdpList = _IndividualDevelopmentPlans.accessors.getGroupIdpList(state, groupId);
  var idpDetailList = state.get('rootReducer').get('individualDevelopmentPlan');
  var idpList = _IndividualDevelopmentPlans.accessors.getIdpList(groupIdpList, groupIdpId);
  var idpApprovalList = state.get('rootReducer').get('idpApprovalList').get(groupIdpId);
  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);

  var _groupActions$getCent = _.actions.getCentre(state, groupId),
      timeZone = _groupActions$getCent.timeZone;

  var idpApprovalContents = void 0;
  if (idpApprovalList && idpApprovalList.size > 0 && members.size > 0 && idpList) {
    idpApprovalContents = idpApprovalList.map(function (idpApproval) {
      return _IndividualDevelopmentPlans.accessors.getApprovalContent(idpList, idpDetailList, members, idpApproval.studentIDPId);
    }).filter(function (idpApprovalContent) {
      return _is_js2.default.not.undefined(idpApprovalContent);
    });
    idpApprovalContents = members.map(function (_ref9) {
      var id = _ref9.studentGeneralInfo.id;
      return idpApprovalContents.find(function (idpApprovalContent) {
        return idpApprovalContent.studentInfo.id === id;
      });
    });
    idpApprovalContents = idpApprovalContents.filter(function (content) {
      return _is_js2.default.not.undefined(content);
    });
  }
  return {
    groupId: groupId,
    groupIdpId: groupIdpId,
    idpId: idpId,
    mode: mode,
    idpApprovalList: idpApprovalList,
    idpApprovalContents: idpApprovalContents,
    timeZone: timeZone,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state),
    isAnyApiCallLoading: !!isAnyApiCallLoading(state)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_IndividualDevelopmentPlans.actions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

function isAnyApiCallLoading(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['GET'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

exports.default = (0, _omniCommonUi.connect)(mapStatToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(IndividualDevelopmentPlanApprovalView));

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modes = undefined;

var _component = __webpack_require__(785);

var _component2 = _interopRequireDefault(_component);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modes = exports.Modes = {
  APPROVE: 'approve',
  EDIT: 'edit',
  REJECT: 'reject'
};

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: ':groupIdpId/dos-approval(/:mode)(/:idpId)',
    component: _component2.default,
    canAccess: function canAccess() {
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.ApproveComment);
    },
    tabs: {
      hidden: true
    },
    sessionNav: {
      hidden: true
    },
    actionButtons: {
      hidden: true
    },
    breadcrumbLabels: 'DOS Approval'
  };
};

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LESSON_CATEGORY = exports.routes = undefined;

var _routes2 = __webpack_require__(216);

var _routes3 = _interopRequireDefault(_routes2);

var _component = __webpack_require__(802);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
var LESSON_CATEGORY = exports.LESSON_CATEGORY = _routes2.LESSON_CATEGORY;
exports.default = _component2.default;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _statusStyle;

exports.mapStateToProps = mapStateToProps;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _reactRouterRedux = __webpack_require__(15);

var _redux = __webpack_require__(10);

var _GroupMembers = __webpack_require__(14);

var _omniCommonUi = __webpack_require__(0);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _style = __webpack_require__(1843);

var _style2 = _interopRequireDefault(_style);

var _WritingAssignment = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var statusStyle = (_statusStyle = {}, _defineProperty(_statusStyle, _WritingAssignment.status.NEW, (0, _classnames2.default)(_style2.default.cell_status, _style2.default.cell_status_new)), _defineProperty(_statusStyle, _WritingAssignment.status.INPROGRESS, (0, _classnames2.default)(_style2.default.cell_status, _style2.default.cell_status_inprogress)), _defineProperty(_statusStyle, _WritingAssignment.status.COMPLETE, (0, _classnames2.default)(_style2.default.cell_status, _style2.default.cell_status_complete)), _statusStyle);

var DEFAULT_CELL = '-';
var movementLimit = 20;

var wasLeftMouseButtonPressed = function wasLeftMouseButtonPressed() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.event;

  var button = e.which || e.button;
  return button === 1;
};

var CoreAndCatchUp = function (_PureComponent) {
  _inherits(CoreAndCatchUp, _PureComponent);

  function CoreAndCatchUp(props) {
    _classCallCheck(this, CoreAndCatchUp);

    var _this = _possibleConstructorReturn(this, (CoreAndCatchUp.__proto__ || Object.getPrototypeOf(CoreAndCatchUp)).call(this, props));

    _this._renderCell = _this._renderCell.bind(_this);
    return _this;
  }

  _createClass(CoreAndCatchUp, [{
    key: '_onMouseDown',
    value: function _onMouseDown(e) {
      if (!wasLeftMouseButtonPressed(e.nativeEvent)) return;
      this._startMouseX = e.screenX;
    }
  }, {
    key: '_onClick',
    value: function _onClick(e) {
      var movement = Math.abs(this._startMouseX - e.screenX);
      if (this._startMouseX && movement > movementLimit) {
        // x-axis drag happened; block click
        e.preventDefault();
        return false;
      }
    }
  }, {
    key: '_renderCell',
    value: function _renderCell(member, lesson) {
      var _this2 = this;

      if (!member || !lesson || !lesson.studentActivities) return DEFAULT_CELL;
      var studentActivity = lesson.studentActivities.get(member.studentGeneralInfo.id);
      if (!studentActivity) return DEFAULT_CELL;
      return _react2.default.createElement(
        _reactRouter.Link,
        { className: _style2.default.cell,
          draggable: false,
          onMouseDown: function onMouseDown(e) {
            return _this2._onMouseDown(e);
          },
          onClick: function onClick(e) {
            return _this2._onClick(e);
          },
          to: this._getDetailUrl(studentActivity.studentId, lesson.unitNo, lesson.lessonNo) },
        _react2.default.createElement(
          'div',
          { className: _style2.default.cell_label },
          _WritingAssignment.accessors.formatActivityType(studentActivity.activityType)
        ),
        _react2.default.createElement(
          'div',
          { className: statusStyle[studentActivity.status] },
          studentActivity.statusDisplayName
        )
      );
    }
  }, {
    key: '_getDetailUrl',
    value: function _getDetailUrl(studentId, unitNo, lessonNo) {
      var groupId = this.props.groupId;

      var lessonSeq = this._getLessonSequence(unitNo, lessonNo);
      return '/group/' + groupId + '/writing-assignment' + ('/lesson/' + lessonSeq) + ('/student/' + studentId);
    }
  }, {
    key: '_getLessonSequence',
    value: function _getLessonSequence(unitNo, lessonNo) {
      var lessonInfo = this.props.coreAndCatchUplessons.find(function (lesson) {
        return lesson.unitNo === unitNo && lesson.lessonNo === lessonNo;
      });
      if (!lessonInfo) return '';
      return lessonInfo.seq;
    }
  }, {
    key: '_renderTableHeader',
    value: function _renderTableHeader() {
      var writingAssignmentListGroupByUnit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return _react2.default.createElement(
        _CourseViewTable2.default.Header,
        null,
        _react2.default.createElement(
          _CourseViewTable2.default.Row,
          null,
          writingAssignmentListGroupByUnit.map(function (val) {
            return _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { colSpan: val.size, small: true },
              _react2.default.createElement(
                'span',
                { className: _style2.default.header },
                'Unit ' + val.get(0).unitNo
              )
            );
          })
        ),
        _react2.default.createElement(
          _CourseViewTable2.default.Row,
          null,
          writingAssignmentListGroupByUnit.map(function (val) {
            return val.map(function (lesson) {
              return _react2.default.createElement(
                _CourseViewTable2.default.Cell,
                { columnId: lesson, small: true },
                _react2.default.createElement(
                  'span',
                  { className: _style2.default.header },
                  '' + _WritingAssignment.accessors.formatCategory(lesson.lessonCategory)
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'span',
                  { className: _style2.default.header },
                  'Lesson ' + lesson.lessonNo
                )
              );
            });
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          members = _props.members,
          writingAssignmentListGroupByUnit = _props.writingAssignmentListGroupByUnit;

      if (members && writingAssignmentListGroupByUnit) {
        return _react2.default.createElement(
          _CourseViewTable2.default,
          { students: members },
          this._renderTableHeader(writingAssignmentListGroupByUnit),
          _react2.default.createElement(
            _CourseViewTable2.default.Body,
            null,
            this._renderCell
          )
        );
      }
      return _react2.default.createElement('div', null);
    }
  }]);

  return CoreAndCatchUp;
}(_react.PureComponent);

CoreAndCatchUp.propTypes = {
  groupId: _propTypes2.default.string.isRequired,
  members: _propTypes2.default.array.isRequired,
  writingAssignmentListGroupByUnit: _propTypes2.default.object,
  coreAndCatchUplessons: _propTypes2.default.object
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var coreWritingAssignmentList = _WritingAssignment.accessors.getCoreWritingAssignment(state, groupId);
  var writingAssignmentListGroupByUnit = coreWritingAssignmentList && coreWritingAssignmentList.groupBy(function (x) {
    return x.unitNo;
  });
  var coreAndCatchUplessons = _WritingAssignment.accessors.getCoreWritingAssignmentLessons(state, groupId);
  return {
    members: members,
    groupId: groupId,
    writingAssignmentListGroupByUnit: writingAssignmentListGroupByUnit,
    coreAndCatchUplessons: coreAndCatchUplessons
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, { pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_GroupMembers.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(CoreAndCatchUp);

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = __webpack_require__(1847);

var _create2 = _interopRequireDefault(_create);

var _model = __webpack_require__(790);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActivityRecord = (0, _immutable.Record)({
  studentId: undefined,
  activityId: undefined,
  status: undefined, // NE, IP, CO
  statusDisplayName: undefined, // //New, In Progress, Complete
  activityType: undefined // Essay, ShortAnswer
});

var Activity = function (_ActivityRecord) {
  _inherits(Activity, _ActivityRecord);

  function Activity() {
    _classCallCheck(this, Activity);

    return _possibleConstructorReturn(this, (Activity.__proto__ || Object.getPrototypeOf(Activity)).apply(this, arguments));
  }

  return Activity;
}(ActivityRecord);

exports.default = Activity;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_SPIN_WRITING_ASSIGNMENT_FAILURE = exports.FETCH_SPIN_WRITING_ASSIGNMENT_SUCCESS = exports.FETCH_SPIN_WRITING_ASSIGNMENT_REQUEST = undefined;
exports.fetchSPINWrittingAssignmentIfNeed = fetchSPINWrittingAssignmentIfNeed;
exports.fetchSPINWrittingAssignment = fetchSPINWrittingAssignment;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_SPIN_WRITING_ASSIGNMENT_REQUEST = exports.FETCH_SPIN_WRITING_ASSIGNMENT_REQUEST = 'FETCH_SPIN_WRITING_ASSIGNMENT_REQUEST';
var FETCH_SPIN_WRITING_ASSIGNMENT_SUCCESS = exports.FETCH_SPIN_WRITING_ASSIGNMENT_SUCCESS = 'FETCH_SPIN_WRITING_ASSIGNMENT_SUCCESS';
var FETCH_SPIN_WRITING_ASSIGNMENT_FAILURE = exports.FETCH_SPIN_WRITING_ASSIGNMENT_FAILURE = 'FETCH_SPIN_WRITING_ASSIGNMENT_FAILURE';

var buildSPINWrittingAssignmentURL = function buildSPINWrittingAssignmentURL(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/spin-writing-assignments');
};

function fetchSPINWrittingAssignmentIfNeed(groupId) {
  var method = 'GET';
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: method, url: buildSPINWrittingAssignmentURL(groupId) })) {
      return false;
    }

    return dispatch(fetchSPINWrittingAssignment(groupId));
  };
}

function fetchSPINWrittingAssignment(groupId) {
  return function (dispatch) {
    var url = buildSPINWrittingAssignmentURL(groupId);
    var method = 'GET';

    return dispatch(fetchSPINWrittingAssignmentRequest()).payload.then(function (response) {
      return dispatch(fetchSPINWrittingAssignmentSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchSPINWrittingAssignmentFailure(error));
    });

    function fetchSPINWrittingAssignmentRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_SPIN_WRITING_ASSIGNMENT_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method
      });
    }

    function fetchSPINWrittingAssignmentSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_SPIN_WRITING_ASSIGNMENT_SUCCESS,
        payload: response,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchSPINWrittingAssignmentFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_SPIN_WRITING_ASSIGNMENT_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_CORE_WRITING_ASSIGNMENT_FAILURE = exports.FETCH_CORE_WRITING_ASSIGNMENT_SUCCESS = exports.FETCH_CORE_WRITING_ASSIGNMENT_REQUEST = undefined;
exports.fetchCoreWrittingAssignmentIfNeed = fetchCoreWrittingAssignmentIfNeed;
exports.fetchCoreWrittingAssignment = fetchCoreWrittingAssignment;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_CORE_WRITING_ASSIGNMENT_REQUEST = exports.FETCH_CORE_WRITING_ASSIGNMENT_REQUEST = 'FETCH_CORE_WRITING_ASSIGNMENT_REQUEST';
var FETCH_CORE_WRITING_ASSIGNMENT_SUCCESS = exports.FETCH_CORE_WRITING_ASSIGNMENT_SUCCESS = 'FETCH_CORE_WRITING_ASSIGNMENT_SUCCESS';
var FETCH_CORE_WRITING_ASSIGNMENT_FAILURE = exports.FETCH_CORE_WRITING_ASSIGNMENT_FAILURE = 'FETCH_CORE_WRITING_ASSIGNMENT_FAILURE';

var buildCoreWrittingAssignmentURL = function buildCoreWrittingAssignmentURL(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/core-writing-assignments');
};

function fetchCoreWrittingAssignmentIfNeed(groupId) {
  var method = 'GET';
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: method, url: buildCoreWrittingAssignmentURL(groupId) })) {
      return false;
    }

    return dispatch(fetchCoreWrittingAssignment(groupId));
  };
}

function fetchCoreWrittingAssignment(groupId) {
  return function (dispatch) {
    var url = buildCoreWrittingAssignmentURL(groupId);
    var method = 'GET';

    return dispatch(fetchCoreWrittingAssignmentRequest()).payload.then(function (response) {
      return dispatch(fetchCoreWrittingAssignmentSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchCoreWrittingAssignmentFailure(error));
    });

    function fetchCoreWrittingAssignmentRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_CORE_WRITING_ASSIGNMENT_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method
      });
    }

    function fetchCoreWrittingAssignmentSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_CORE_WRITING_ASSIGNMENT_SUCCESS,
        payload: response,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchCoreWrittingAssignmentFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_CORE_WRITING_ASSIGNMENT_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchEssay = exports.FETCH_ESSAY_FAILURE = exports.FETCH_ESSAY_SUCCESS = exports.FETCH_ESSAY_REQUEST = undefined;
exports.fetchEssayIfNeeded = fetchEssayIfNeeded;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var ACTION_OBJECT_NAME = 'ESSAY';
var FETCH_ESSAY_REQUEST = exports.FETCH_ESSAY_REQUEST = 'FETCH_' + ACTION_OBJECT_NAME + '_REQUEST';
var FETCH_ESSAY_SUCCESS = exports.FETCH_ESSAY_SUCCESS = 'FETCH_' + ACTION_OBJECT_NAME + '_SUCCESS';
var FETCH_ESSAY_FAILURE = exports.FETCH_ESSAY_FAILURE = 'FETCH_' + ACTION_OBJECT_NAME + '_FAILURE';

var DISABLE_DEFAULT_ACTION_EXTRAS = { disableDefault: true };
var buildEssayUrl = function buildEssayUrl(id, studentId) {
  return (0, _Api.buildUrl)('/writing-assignment-activities/' + id + '/essay?studentId=' + studentId);
};
var createFetchEssayActions = function createFetchEssayActions(id, studentId) {
  return (0, _omniCommonUi.createApiActionCreator)(ACTION_OBJECT_NAME, buildEssayUrl(id, studentId), 'GET', DISABLE_DEFAULT_ACTION_EXTRAS, { id: id, studentId: studentId }, DISABLE_DEFAULT_ACTION_EXTRAS);
};

var fetchEssay = exports.fetchEssay = function fetchEssay(id, studentId) {
  return createFetchEssayActions(id, studentId);
};

function fetchEssayIfNeeded(id, studentId) {
  var method = 'GET';
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: method, url: buildEssayUrl(id, studentId) })) {
      return false;
    }

    return dispatch(fetchEssay(id, studentId));
  };
}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EssayRecord = (0, _immutable.Record)({
  name: undefined,
  studentId: undefined,
  submitBy: undefined,
  submitDate: undefined,
  essay: undefined,
  comment: undefined,
  commentBy: undefined,
  commentDate: undefined,
  status: undefined,
  statusDisplayName: undefined
});

var Essay = function (_EssayRecord) {
  _inherits(Essay, _EssayRecord);

  function Essay() {
    _classCallCheck(this, Essay);

    return _possibleConstructorReturn(this, (Essay.__proto__ || Object.getPrototypeOf(Essay)).apply(this, arguments));
  }

  return Essay;
}(EssayRecord);

exports.default = Essay;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitShortAnswer = exports.fetchShortAnswer = exports.SUBMIT_SHORT_ANSWER_FAILURE = exports.SUBMIT_SHORT_ANSWER_SUCCESS = exports.SUBMIT_SHORT_ANSWER_REQUEST = exports.FETCH_SHORT_ANSWER_FAILURE = exports.FETCH_SHORT_ANSWER_SUCCESS = exports.FETCH_SHORT_ANSWER_REQUEST = undefined;
exports.fetchShortAnswerIfNeed = fetchShortAnswerIfNeed;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var ACTION_OBJECT_NAME = 'SHORT_ANSWER';
var FETCH_SHORT_ANSWER_REQUEST = exports.FETCH_SHORT_ANSWER_REQUEST = 'FETCH_' + ACTION_OBJECT_NAME + '_REQUEST';
var FETCH_SHORT_ANSWER_SUCCESS = exports.FETCH_SHORT_ANSWER_SUCCESS = 'FETCH_' + ACTION_OBJECT_NAME + '_SUCCESS';
var FETCH_SHORT_ANSWER_FAILURE = exports.FETCH_SHORT_ANSWER_FAILURE = 'FETCH_' + ACTION_OBJECT_NAME + '_FAILURE';
var SUBMIT_SHORT_ANSWER_REQUEST = exports.SUBMIT_SHORT_ANSWER_REQUEST = 'SUBMIT_' + ACTION_OBJECT_NAME + '_REQUEST';
var SUBMIT_SHORT_ANSWER_SUCCESS = exports.SUBMIT_SHORT_ANSWER_SUCCESS = 'SUBMIT_' + ACTION_OBJECT_NAME + '_SUCCESS';
var SUBMIT_SHORT_ANSWER_FAILURE = exports.SUBMIT_SHORT_ANSWER_FAILURE = 'SUBMIT_' + ACTION_OBJECT_NAME + '_FAILURE';

var DISABLE_DEFAULT_ACTION_EXTRAS = { disableDefault: true };

var buildShortAnswerURL = function buildShortAnswerURL(activityId, studentId) {
  return (0, _Api.buildUrl)('/writing-assignment-activities/' + activityId + '/short-answer?studentId=' + studentId);
};

var createfetchShortAnswerActions = function createfetchShortAnswerActions(activityId, studentId) {
  return (0, _omniCommonUi.createApiActionCreator)(ACTION_OBJECT_NAME, buildShortAnswerURL(activityId, studentId), 'GET', DISABLE_DEFAULT_ACTION_EXTRAS, { activityId: activityId, studentId: studentId }, DISABLE_DEFAULT_ACTION_EXTRAS);
};

var fetchShortAnswer = exports.fetchShortAnswer = function fetchShortAnswer(activityId, studentId) {
  return createfetchShortAnswerActions(activityId, studentId);
};

function fetchShortAnswerIfNeed(activityId, studentId) {
  var method = 'GET';
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: method, url: buildShortAnswerURL(activityId, studentId) })) {
      return false;
    }
    return dispatch(fetchShortAnswer(activityId, studentId));
  };
}

var submitShortAnswer = exports.submitShortAnswer = function submitShortAnswer(id, payload) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/writing-assignment-activities/' + id + '/short-answer-remarks');
    var method = 'PUT';
    return dispatch(submitShortAnswerRequest()).payload.then(function (response) {
      return dispatch(submitShortAnswerSuccess(response));
    }).catch(function (error) {
      return dispatch(submitShortAnswerFailure(error));
    });

    function submitShortAnswerRequest() {
      var request = (0, _Api.fetch)(url, {
        method: method,
        body: JSON.stringify(payload)
      });
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_SHORT_ANSWER_REQUEST,
        payload: request,
        url: url,
        method: method
      });
    }

    function submitShortAnswerSuccess() {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_SHORT_ANSWER_SUCCESS,
        url: url,
        method: method
      });
    }

    function submitShortAnswerFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_SHORT_ANSWER_FAILURE,
        url: url,
        method: method,
        error: error
      });
    }
  };
};

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShortAnswerRecord = (0, _immutable.Record)({
  name: undefined,
  studentId: undefined,
  submitBy: undefined,
  submitDate: undefined,
  status: undefined,
  statusDisplayName: undefined,
  comment: undefined,
  commentBy: undefined,
  commentDate: undefined,
  shortAnswers: undefined
});

var ShortAnswer = function (_ShortAnswerRecord) {
  _inherits(ShortAnswer, _ShortAnswerRecord);

  function ShortAnswer() {
    _classCallCheck(this, ShortAnswer);

    return _possibleConstructorReturn(this, (ShortAnswer.__proto__ || Object.getPrototypeOf(ShortAnswer)).apply(this, arguments));
  }

  return ShortAnswer;
}(ShortAnswerRecord);

exports.default = ShortAnswer;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemRecord = (0, _immutable.Record)({
  questionNo: undefined,
  question: undefined,
  studentAnswer: undefined,
  isCorrect: undefined
});

var Item = function (_ItemRecord) {
  _inherits(Item, _ItemRecord);

  function Item() {
    _classCallCheck(this, Item);

    return _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
  }

  return Item;
}(ItemRecord);

exports.default = Item;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Status = exports.Status = {
  NEW: 'NE',
  INPROGRESS: 'IP',
  COMPLETE: 'CO'
};

exports.default = Status;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _statusStyle;

exports.mapStateToProps = mapStateToProps;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _reactRouterRedux = __webpack_require__(15);

var _redux = __webpack_require__(10);

var _GroupMembers = __webpack_require__(14);

var _omniCommonUi = __webpack_require__(0);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _style = __webpack_require__(1865);

var _style2 = _interopRequireDefault(_style);

var _WritingAssignment = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var statusStyle = (_statusStyle = {}, _defineProperty(_statusStyle, _WritingAssignment.status.NEW, (0, _classnames2.default)(_style2.default.cell_status, _style2.default.cell_status_new)), _defineProperty(_statusStyle, _WritingAssignment.status.INPROGRESS, (0, _classnames2.default)(_style2.default.cell_status, _style2.default.cell_status_inprogress)), _defineProperty(_statusStyle, _WritingAssignment.status.COMPLETE, (0, _classnames2.default)(_style2.default.cell_status, _style2.default.cell_status_complete)), _statusStyle);

var DEFAULT_CELL = '-';
var movementLimit = 20;

var wasLeftMouseButtonPressed = function wasLeftMouseButtonPressed() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.event;

  var button = e.which || e.button;
  return button === 1;
};

var SpinListView = function (_PureComponent) {
  _inherits(SpinListView, _PureComponent);

  function SpinListView(props) {
    _classCallCheck(this, SpinListView);

    var _this = _possibleConstructorReturn(this, (SpinListView.__proto__ || Object.getPrototypeOf(SpinListView)).call(this, props));

    _this._renderCell = _this._renderCell.bind(_this);
    return _this;
  }

  _createClass(SpinListView, [{
    key: '_onMouseDown',
    value: function _onMouseDown(e) {
      if (!wasLeftMouseButtonPressed(e.nativeEvent)) return;
      this._startMouseX = e.screenX;
    }
  }, {
    key: '_onClick',
    value: function _onClick(e) {
      var movement = Math.abs(this._startMouseX - e.screenX);
      if (this._startMouseX && movement > movementLimit) {
        // x-axis drag happened; block click
        e.preventDefault();
        return false;
      }
    }
  }, {
    key: '_renderCell',
    value: function _renderCell(member, spinActivity) {
      var _this2 = this;

      if (!member || !spinActivity || !spinActivity.studentActivities) return DEFAULT_CELL;
      var studentActivity = spinActivity.studentActivities.get(member.studentGeneralInfo.id);
      if (!studentActivity) return DEFAULT_CELL;
      return _react2.default.createElement(
        _reactRouter.Link,
        { className: _style2.default.cell,
          onMouseDown: function onMouseDown(e) {
            return _this2._onMouseDown(e);
          },
          onClick: function onClick(e) {
            return _this2._onClick(e);
          },
          to: this._getDetailURL(studentActivity, studentActivity.activityId) },
        _react2.default.createElement(
          'div',
          { className: _style2.default.cell_label },
          _WritingAssignment.accessors.formatActivityType(studentActivity.activityType)
        ),
        _react2.default.createElement(
          'div',
          { className: statusStyle[studentActivity.status] },
          studentActivity.statusDisplayName
        )
      );
    }
  }, {
    key: '_getDetailURL',
    value: function _getDetailURL(studentActivity, activityId) {
      var _props = this.props,
          groupId = _props.groupId,
          buildRoute = _props.buildRoute;
      var studentId = studentActivity.studentId;

      var url = '/group/' + groupId + '/writing-assignment/activity/' + activityId + '/student/' + studentId;
      return buildRoute(url);
    }
  }, {
    key: '_renderTableHeader',
    value: function _renderTableHeader() {
      var spinWritingAssignmentList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return _react2.default.createElement(
        _CourseViewTable2.default.Header,
        null,
        _react2.default.createElement(
          _CourseViewTable2.default.Row,
          null,
          spinWritingAssignmentList.map(function (spinActivity) {
            return _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: spinActivity, small: true },
              spinActivity.examType
            );
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          members = _props2.members,
          spinWritingAssignmentList = _props2.spinWritingAssignmentList;

      if (!members) return null;
      return _react2.default.createElement(
        _CourseViewTable2.default,
        { students: members },
        this._renderTableHeader(spinWritingAssignmentList),
        _react2.default.createElement(
          _CourseViewTable2.default.Body,
          null,
          this._renderCell
        )
      );
    }
  }]);

  return SpinListView;
}(_react.PureComponent);

SpinListView.propTypes = {
  groupId: _propTypes2.default.string.isRequired,
  members: _propTypes2.default.array.isRequired,
  spinWritingAssignmentList: _propTypes2.default.object,
  buildRoute: _propTypes2.default.func
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var spinWritingAssignmentList = _WritingAssignment.accessors.getSPINWritingAssignment(state, groupId);
  return {
    members: members,
    groupId: groupId,
    spinWritingAssignmentList: spinWritingAssignmentList
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, { pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_GroupMembers.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(SpinListView);

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _style = __webpack_require__(1868);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _NoContentMessage = __webpack_require__(66);

var _NoContentMessage2 = _interopRequireDefault(_NoContentMessage);

var _ = __webpack_require__(13);

var _IndividualCard = __webpack_require__(1870);

var _IndividualCard2 = _interopRequireDefault(_IndividualCard);

var _ExportDialog = __webpack_require__(1873);

var _ExportDialog2 = _interopRequireDefault(_ExportDialog);

var _routes = __webpack_require__(801);

var _immutable = __webpack_require__(3);

var _WritingAssignment = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ESSAY = 'essay';
var SHORT_ANSWER = 'shortanswer';

var WritingAssignment = function (_UnsavedChangesTracki) {
  _inherits(WritingAssignment, _UnsavedChangesTracki);

  function WritingAssignment(props) {
    _classCallCheck(this, WritingAssignment);

    var _this = _possibleConstructorReturn(this, (WritingAssignment.__proto__ || Object.getPrototypeOf(WritingAssignment)).call(this, props));

    _this.state = {
      nextLocation: '',
      comment: '',
      shortAnswers: new _immutable.List()
    };
    _this._onEdit = _this._onEdit.bind(_this);
    _this._onDiscardComment = _this._onDiscardComment.bind(_this);
    _this._onSaveComment = _this._onSaveComment.bind(_this);
    _this._onUnSaveClose = _this._onUnSaveClose.bind(_this);
    _this._onDiscardUnsavedComment = _this._onDiscardUnsavedComment.bind(_this);
    _this._onCommentUpdate = _this._onCommentUpdate.bind(_this);
    _this._onShortAnswersUpdate = _this._onShortAnswersUpdate.bind(_this);
    _this._onSaveUnsavedComment = _this._onSaveUnsavedComment.bind(_this);
    return _this;
  }

  _createClass(WritingAssignment, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._fetchActivity(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this._fetchActivity(props);
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave(nextLocation) {
      var _this2 = this;

      var pathname = nextLocation.pathname;
      var _props = this.props,
          activityId = _props.activityId,
          publishWritingAssignmment = _props.publishWritingAssignmment,
          studentId = _props.studentId;

      if (WritingAssignment.isInEditMode(this.props) && this._isEssayChanged(pathname) && this.state.nextLocation.length === 0) {
        this.setState({
          nextLocation: pathname
        });
        return false;
      } else if (pathname.endsWith(_routes.PUBLISH)) {
        var payload = {
          studentId: studentId
        };
        publishWritingAssignmment(activityId, payload).then(function () {
          return _this2._refreshData(_this2.props);
        });
        return false;
      }
      return _get(WritingAssignment.prototype.__proto__ || Object.getPrototypeOf(WritingAssignment.prototype), 'routerWillLeave', this).call(this, nextLocation);
    }
  }, {
    key: '_refreshData',
    value: function _refreshData(props) {
      var activityId = props.activityId,
          studentId = props.studentId,
          groupId = props.groupId,
          activityType = props.activityType,
          fetchEssay = props.fetchEssay,
          fetchShortAnswer = props.fetchShortAnswer,
          fetchCoreWrittingAssignment = props.fetchCoreWrittingAssignment,
          fetchSPINWrittingAssignment = props.fetchSPINWrittingAssignment;

      var type = _is_js2.default.string(activityType) ? activityType.toLowerCase() : '';
      if (type === ESSAY) {
        return fetchEssay(activityId, studentId).then(function () {
          fetchCoreWrittingAssignment(groupId);
          fetchSPINWrittingAssignment(groupId);
        });
      }
      if (type === SHORT_ANSWER) {
        return fetchShortAnswer(activityId, studentId).then(function () {
          fetchCoreWrittingAssignment(groupId);
          fetchSPINWrittingAssignment(groupId);
        });
      }
    }
  }, {
    key: '_isEssayChanged',
    value: function _isEssayChanged(pathname) {
      return !(pathname === this.props.buildRoute({ mode: '' }) || pathname === this.props.buildRoute({ mode: _routes.EDIT }));
    }
  }, {
    key: '_fetchActivity',
    value: function _fetchActivity(props) {
      var activityId = props.activityId,
          activityType = props.activityType,
          studentId = props.studentId,
          writingAssignment = props.writingAssignment,
          fetchEssayIfNeeded = props.fetchEssayIfNeeded,
          fetchShortAnswerIfNeed = props.fetchShortAnswerIfNeed;

      var type = _is_js2.default.string(activityType) ? activityType.toLowerCase() : '';
      if (type === ESSAY) {
        fetchEssayIfNeeded(activityId, studentId);
      }
      if (type === SHORT_ANSWER) {
        fetchShortAnswerIfNeed(activityId, studentId);
      }
      if (_is_js2.default.existy(writingAssignment)) {
        this.setState({
          comment: _is_js2.default.existy(writingAssignment.comment) ? writingAssignment.comment : '',
          shortAnswers: writingAssignment.shortAnswers || new _immutable.List()
        });
      }
    }
  }, {
    key: '_onUnSaveClose',
    value: function _onUnSaveClose() {
      this.setState({ nextLocation: '' });
    }
  }, {
    key: '_onDiscardUnsavedComment',
    value: function _onDiscardUnsavedComment() {
      this.props.push(this.state.nextLocation);
      this.setState({ nextLocation: '' });
    }
  }, {
    key: '_onSaveUnsavedComment',
    value: function _onSaveUnsavedComment() {
      this._submitComment(this.props, this.state.nextLocation);
      this.setState({ nextLocation: '' });
    }
  }, {
    key: '_onCommentUpdate',
    value: function _onCommentUpdate(comment) {
      this.setState({ comment: comment });
    }
  }, {
    key: '_onShortAnswersUpdate',
    value: function _onShortAnswersUpdate(shortAnswers) {
      this.setState({ shortAnswers: shortAnswers });
    }
  }, {
    key: '_onEdit',
    value: function _onEdit() {
      this.props.push(this.props.buildRoute({ mode: _routes.EDIT }));
    }
  }, {
    key: '_onSaveComment',
    value: function _onSaveComment() {
      this._submitComment(this.props, this.props.buildRoute({ mode: '' }));
    }
  }, {
    key: '_submitComment',
    value: function _submitComment(props, nextLocation) {
      var _this3 = this;

      var activityId = props.activityId,
          studentId = props.studentId,
          submitWritingAssignmmentComment = props.submitWritingAssignmmentComment,
          submitShortAnswer = props.submitShortAnswer,
          push = props.push,
          activityType = props.activityType;

      if (_is_js2.default.string(activityType) && activityType.toLowerCase() === ESSAY) {
        var payload = {
          studentId: parseInt(studentId, 10),
          comment: this.state.comment && this.state.comment.trim()
        };
        submitWritingAssignmmentComment(activityId, payload).then(function () {
          return _this3._refreshData(props);
        });
      }

      if (_is_js2.default.string(activityType) && activityType.toLowerCase() === SHORT_ANSWER) {
        var shortAnswers = this.state.shortAnswers;

        var studentAnswerResult = shortAnswers.filter(function (shortAnswer) {
          return _is_js2.default.boolean(shortAnswer.isCorrect);
        }).map(function (shortAnswer) {
          return {
            questionNo: parseInt(shortAnswer.questionNo, 10),
            isCorrect: shortAnswer.isCorrect
          };
        }).toJS();
        var _payload = {
          studentId: parseInt(studentId, 10),
          // comment: this.state.comment && this.state.comment.trim(),
          studentAnswerResult: studentAnswerResult
        };
        submitShortAnswer(activityId, _payload).then(function () {
          return _this3._refreshData(props);
        });
      }
      push(nextLocation);
    }
  }, {
    key: '_onDiscardComment',
    value: function _onDiscardComment() {
      this.props.push(this.props.buildRoute({ mode: '' }));
    }
  }, {
    key: '_renderExportDialog',
    value: function _renderExportDialog() {
      var _props2 = this.props,
          activityId = _props2.activityId,
          groupId = _props2.groupId,
          studentId = _props2.studentId,
          mode = _props2.mode,
          buildRoute = _props2.buildRoute,
          push = _props2.push,
          languageCode = _props2.languageCode,
          exportName = _props2.exportName;

      var isInExportRoute = mode === _routes.EXPORT;
      return isInExportRoute && _react2.default.createElement(_ExportDialog2.default, { activityId: activityId,
        groupId: groupId,
        studentId: studentId,
        languageCode: languageCode,
        pushRoute: push,
        buildRoute: buildRoute,
        exportName: exportName });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          activityType = _props3.activityType,
          writingAssignment = _props3.writingAssignment,
          timeZone = _props3.timeZone,
          canEdit = _props3.canEdit;

      if (!_is_js2.default.existy(writingAssignment)) {
        return _react2.default.createElement(_NoContentMessage2.default, { text: 'No Writing Assignment is submitted.' });
      }
      return _react2.default.createElement(
        'div',
        { className: _style2.default.TextEditor_content },
        _react2.default.createElement(
          _omniCommonUi.Grid,
          null,
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            _react2.default.createElement(_IndividualCard2.default, { writing: writingAssignment,
              isEdit: WritingAssignment.isInEditMode(this.props),
              onEdit: this._onEdit,
              comment: this.state.comment,
              shortAnswers: this.state.shortAnswers,
              type: activityType,
              onCommentUpdate: this._onCommentUpdate,
              onShortAnswersUpdate: this._onShortAnswersUpdate,
              onDiscardComment: this._onDiscardComment,
              onSaveComment: this._onSaveComment,
              timeZone: timeZone,
              canEdit: canEdit })
          )
        ),
        _react2.default.createElement(_UnsavedChangesWarning2.default, { isOpen: this.state.nextLocation.length !== 0,
          onCloseClicked: this._onUnSaveClose,
          onSaveClicked: this._onSaveUnsavedComment,
          onDiscardClicked: this._onDiscardUnsavedComment }),
        this._renderExportDialog()
      );
    }
  }]);

  return WritingAssignment;
}(_UnsavedChangesTrackingPageComponent2.default);

WritingAssignment.isInEditMode = function (props) {
  return props.params && props.params.mode === _routes.EDIT;
};

WritingAssignment.propTypes = {
  activityId: _propTypes2.default.string,
  activityType: _propTypes2.default.string,
  mode: _propTypes2.default.string,
  writingAssignment: _propTypes2.default.object,
  studentId: _propTypes2.default.string,
  groupId: _propTypes2.default.string,
  languageCode: _propTypes2.default.string,
  exportName: _propTypes2.default.string,
  buildRoute: _propTypes2.default.func,
  push: _propTypes2.default.func,
  fetchEssayIfNeeded: _propTypes2.default.func,
  fetchEssay: _propTypes2.default.func,
  fetchShortAnswerIfNeed: _propTypes2.default.func,
  fetchShortAnswer: _propTypes2.default.func,
  submitWritingAssignmmentComment: _propTypes2.default.func,
  publishWritingAssignmment: _propTypes2.default.func
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      mode = _ownProps$params.mode,
      lessonSeq = _ownProps$params.lessonSeq,
      activityId = _ownProps$params.activityId,
      studentId = _ownProps$params.studentId,
      groupId = _ownProps$params.groupId;

  var _groupActions$getCent = _.actions.getCentre(state, groupId),
      timeZone = _groupActions$getCent.timeZone;

  var activity = _WritingAssignment.accessors.getStudentActivityByLessonCategory(state, groupId, { lessonSeq: lessonSeq, activityId: activityId }, studentId) || {};
  var writingAssignment = _WritingAssignment.accessors.getWritingAssignmentByActivityType(state, activity.activityType, activity.activityId, studentId);
  var group = state.get('rootReducer').get('groups').get(groupId).data;
  var languageCode = group.get('languageCode');
  var activityType = activity.activityType;
  var exportName = 'WritingAssignment - ' + activityType + '.pdf';
  return {
    activityId: activity.activityId,
    activityType: activityType,
    exportName: exportName,
    mode: mode,
    writingAssignment: writingAssignment,
    groupId: groupId,
    languageCode: languageCode,
    studentId: studentId,
    timeZone: timeZone,
    canEdit: _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.AssignHomework.ManageOwn)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, (0, _redux.bindActionCreators)(_WritingAssignment.activityActions, dispatch), (0, _redux.bindActionCreators)(_WritingAssignment.commentsActions, dispatch), (0, _redux.bindActionCreators)(_WritingAssignment.essayActions, dispatch), (0, _redux.bindActionCreators)(_WritingAssignment.shortAnswerActions, dispatch), (0, _redux.bindActionCreators)(_WritingAssignment.spinActions, dispatch), (0, _redux.bindActionCreators)(_WritingAssignment.coreActions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(WritingAssignment);

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spinWritingAssignment = exports.coreCatchUpWritingAssignment = exports.EXPORT = exports.PUBLISH = exports.EDIT = undefined;

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _component = __webpack_require__(800);

var _component2 = _interopRequireDefault(_component);

var _StudentSelect = __webpack_require__(1876);

var _StudentSelect2 = _interopRequireDefault(_StudentSelect);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _WritingAssignmentSessionNav = __webpack_require__(1879);

var _WritingAssignmentSessionNav2 = _interopRequireDefault(_WritingAssignmentSessionNav);

var _WritingAssignment = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EDIT = exports.EDIT = 'edit-comment';
var PUBLISH = exports.PUBLISH = 'publish';
var EXPORT = exports.EXPORT = 'export';

var getWritingAssignment = function getWritingAssignment(state, params) {
  var groupId = params.groupId,
      studentId = params.studentId;

  var activity = _WritingAssignment.accessors.getStudentActivityByLessonCategory(state, groupId, params, studentId) || {};
  return _WritingAssignment.accessors.getWritingAssignmentByActivityType(state, activity.activityType, activity.activityId, studentId);
};

var actionButtons = function actionButtons(getState) {
  return {
    Publish: {
      isPrimary: true,
      visibleWhen: function visibleWhen() {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.AssignHomework.Publish);
      },
      disableWhen: function disableWhen(props) {
        var writingAssignment = getWritingAssignment(getState(), props.params);
        var isShortAnswer = _WritingAssignment.accessors.isShortAnswer(props.activityType);
        return !_WritingAssignment.accessors.canPublish(writingAssignment, isShortAnswer) || _component2.default.isInEditMode(props);
      },
      route: './publish'
    },
    Export: {
      disableWhen: function disableWhen(_ref) {
        var params = _ref.params;

        var writingAssignment = getWritingAssignment(getState(), params);
        return !(writingAssignment && writingAssignment.status.toLowerCase() === _WritingAssignment.status.COMPLETE.toLowerCase());
      },
      route: './export'
    }
  };
};

var appBars = function appBars() {
  return {
    sticky: {
      'session-nav': {
        component: _WritingAssignmentSessionNav2.default,
        order: 1
      },
      'student-select': {
        component: _StudentSelect2.default,
        order: 2
      },
      'view-nav': {
        component: _ViewNav2.default,
        order: 3
      }
    }
  };
};

var buildPath = function buildPath(lessonCategory) {
  switch (lessonCategory) {
    case 'coreCatchUp':
      return 'lesson/:lessonSeq/student/:studentId(/:mode)';
    case 'spin':
      return 'activity/:activityId/student/:studentId(/:mode)';
    default:
      return '';
  }
};

var getBreadcrumb = function getBreadcrumb(props, getState) {
  var _props$params = props.params,
      groupId = _props$params.groupId,
      lessonSeq = _props$params.lessonSeq,
      studentId = _props$params.studentId;

  var activity = _WritingAssignment.accessors.getCoreActivityByLessonAndStudentId(getState(), groupId, lessonSeq, studentId);
  var _activity$activityTyp = activity.activityType,
      activityType = _activity$activityTyp === undefined ? '' : _activity$activityTyp;

  return {
    label: _WritingAssignment.accessors.formatActivityType(activityType),
    clickable: false
  };
};

var buildRoute = function buildRoute(lessonCategory) {
  return function (_ref2) {
    var _actionButtons;

    var getState = _ref2.getState;
    return {
      breadcrumbLabels: function breadcrumbLabels(props) {
        return getBreadcrumb(props, getState);
      },
      actionButtons: (_actionButtons = {
        default: actionButtons(getState)
      }, _defineProperty(_actionButtons, EDIT, actionButtons(getState)), _defineProperty(_actionButtons, EXPORT, actionButtons(getState)), _actionButtons),
      appBars: appBars(),
      path: buildPath(lessonCategory),
      canAccess: function canAccess(props) {
        if (!_component2.default.isInEditMode(props)) return true;
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.AssignHomework.ManageOwn);
      },
      component: _component2.default
    };
  };
};

var coreCatchUpWritingAssignment = exports.coreCatchUpWritingAssignment = buildRoute('coreCatchUp');
var spinWritingAssignment = exports.spinWritingAssignment = buildRoute('spin');

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WritingAssignment = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1880);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _WritingAssignment = __webpack_require__(86);

var _routes = __webpack_require__(216);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WritingAssignment = exports.WritingAssignment = function (_Component) {
  _inherits(WritingAssignment, _Component);

  function WritingAssignment() {
    _classCallCheck(this, WritingAssignment);

    return _possibleConstructorReturn(this, (WritingAssignment.__proto__ || Object.getPrototypeOf(WritingAssignment)).apply(this, arguments));
  }

  _createClass(WritingAssignment, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._fetchWrittingAssignmentIfNeed(this.props);
      if (this.props.pathname.endsWith(_routes.writingAssignmentRootPath)) {
        this._redirectTo();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.pathname.endsWith(_routes.writingAssignmentRootPath)) {
        this._redirectTo();
      }
    }
  }, {
    key: '_redirectTo',
    value: function _redirectTo() {
      var _props = this.props,
          groupId = _props.groupId,
          replacehRoute = _props.replacehRoute,
          buildRoute = _props.buildRoute;


      replacehRoute(buildRoute('/group/' + groupId + '/' + _routes.writingAssignmentRootPath + '/' + _routes.TABS[_routes.LESSON_CATEGORY.CORE_CATCH_UP]));
    }
  }, {
    key: '_fetchWrittingAssignmentIfNeed',
    value: function _fetchWrittingAssignmentIfNeed(props) {
      var groupId = props.groupId;

      props.fetchCoreWrittingAssignmentIfNeed(groupId);
      props.fetchSPINWrittingAssignmentIfNeed(groupId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          coreWritingAssignmentList = _props2.coreWritingAssignmentList,
          spinWritingAssignmentList = _props2.spinWritingAssignmentList;

      if (coreWritingAssignmentList && spinWritingAssignmentList) {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.WritingAssignment_container },
          this.props.children
        );
      }
      return null;
    }
  }]);

  return WritingAssignment;
}(_react.Component);

WritingAssignment.propTypes = {
  groupId: _propTypes2.default.string,
  pathname: _propTypes2.default.string,
  children: _propTypes2.default.node,
  replacehRoute: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  fetchWrittingAssignmentIfNeed: _propTypes2.default.func,
  coreWritingAssignmentList: _propTypes2.default.object,
  spinWritingAssignmentList: _propTypes2.default.object
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;
  var pathname = ownProps.location.pathname;

  var coreWritingAssignmentList = _WritingAssignment.accessors.getCoreWritingAssignment(state, groupId);
  var spinWritingAssignmentList = _WritingAssignment.accessors.getSPINWritingAssignment(state, groupId);

  return {
    groupId: groupId,
    pathname: pathname,
    coreWritingAssignmentList: coreWritingAssignmentList,
    spinWritingAssignmentList: spinWritingAssignmentList
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ replacehRoute: function replacehRoute(path) {
      return dispatch((0, _reactRouterRedux.replace)(path));
    } }, (0, _redux.bindActionCreators)(_WritingAssignment.coreActions, dispatch), (0, _redux.bindActionCreators)(_WritingAssignment.spinActions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(WritingAssignment);

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionReport = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouter = __webpack_require__(16);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _Exporter = __webpack_require__(50);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _accessors = __webpack_require__(36);

var Session = _interopRequireWildcard(_accessors);

var _accessors2 = __webpack_require__(195);

var GroupMembers = _interopRequireWildcard(_accessors2);

var _CoveredInClass = __webpack_require__(95);

var _Template = __webpack_require__(166);

var _Feedback = __webpack_require__(217);

var _routes = __webpack_require__(332);

var _Feedback2 = __webpack_require__(1889);

var _Feedback3 = _interopRequireDefault(_Feedback2);

var _GrammarPro = __webpack_require__(1895);

var _GrammarPro2 = _interopRequireDefault(_GrammarPro);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXPORTING_MESSAGE = 'Exporting reports, please wait';

var SessionReport = exports.SessionReport = function (_UnsavedChangesTracki) {
  _inherits(SessionReport, _UnsavedChangesTracki);

  function SessionReport() {
    _classCallCheck(this, SessionReport);

    var _this = _possibleConstructorReturn(this, (SessionReport.__proto__ || Object.getPrototypeOf(SessionReport)).call(this));

    _this.state = {
      isSaving: false,
      isExportInProgress: false,
      isExportErrorOccurred: false
    };
    return _this;
  }

  _createClass(SessionReport, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._redirectTo(this.props);
      this._setUpData(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._redirectTo(nextProps);
      this._setUpData(nextProps);
    }
  }, {
    key: '_setUpData',
    value: function _setUpData(props) {
      var sessionPlanId = this._getSessionPlanId(props);
      var studentId = this._getStudentId(props);
      props.fetchCoveredInClassIfNeeded(sessionPlanId);
      props.fetchCoveredInClassTemplateIfNeeded(sessionPlanId, true);
      props.fetchFeedbackIfNeeded(sessionPlanId, studentId);
    }
  }, {
    key: '_redirectTo',
    value: function _redirectTo(props) {
      var buildRoute = props.buildRoute,
          replace = props.replace,
          params = props.params,
          mode = props.mode;

      if (_is_js2.default.existy(mode) && mode === _routes.Modes.EXPORT) {
        this._beginExport(props);
        return replace(buildRoute({
          mode: ''
        }));
      }
      if (_is_js2.default.existy(params.sessionPlanId) && _is_js2.default.existy(params.unitId) && _is_js2.default.existy(params.studentId) && _is_js2.default.existy(params.category)) {
        this.setState({
          isSaving: false
        });
        return;
      }
      var sessionPlanId = this._getSessionPlanId(props);
      var unitId = params.unitId || props.unitId;
      var studentId = params.studentId || props.studentId;
      var category = params.category || _routes.CATEGORY_GRAMMAR_PRO;

      return replace(buildRoute({
        sessionPlanId: sessionPlanId,
        unitId: unitId,
        studentId: studentId,
        category: category
      }));
    }
  }, {
    key: '_getSessionPlanId',
    value: function _getSessionPlanId(props) {
      return props.params.sessionPlanId || props.sessionPlanId;
    }
  }, {
    key: '_getStudentId',
    value: function _getStudentId(props) {
      return props.params.studentId || props.studentId;
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave(nextLocation) {
      if (nextLocation.pathname.endsWith(_routes.Modes.SAVE)) {
        this.setState({
          isSaving: true
        });
        return false;
      }
      _get(SessionReport.prototype.__proto__ || Object.getPrototypeOf(SessionReport.prototype), 'routerWillLeave', this).call(this, nextLocation);
    }
  }, {
    key: '_beginExport',
    value: function _beginExport(props) {
      var _this2 = this;

      var sessionPlanId = this._getSessionPlanId(props);
      var studentId = this._getStudentId(props);
      var url = _omniCommonUi.Config.get('apiBase').concat('/sessions/' + sessionPlanId + '/students/' + studentId + '/feedback-printing');
      this.setState({
        isExportInProgress: true
      });
      _Exporter.exporter.get(url, 'SessionReport.pdf', false, 'application/pdf').then(function () {
        _this2.setState({
          isExportInProgress: false
        });
      }).catch(function () {
        _this2._handleExportError();
      });
    }
  }, {
    key: '_handleExportError',
    value: function _handleExportError() {
      this.setState({
        isExportInProgress: false
      });
      this._onBeginGeneralError();
    }
  }, {
    key: '_onBeginGeneralError',
    value: function _onBeginGeneralError() {
      this.setState({ isExportErrorOccurred: true });
    }
  }, {
    key: '_onEndExportWarningOrError',
    value: function _onEndExportWarningOrError() {
      this.setState({
        isExportErrorOccurred: false
      });
    }
  }, {
    key: '_renderExportGeneralErrorDialog',
    value: function _renderExportGeneralErrorDialog() {
      var _this3 = this;

      return _react2.default.createElement(_omniCommonUi.ErrorDialog, { isOpen: this.state.isExportErrorOccurred,
        onConfirmClick: function onConfirmClick() {
          _this3._onEndExportWarningOrError();
        } });
    }
  }, {
    key: '_renderExportingDialog',
    value: function _renderExportingDialog() {
      return _react2.default.createElement(_omniCommonUi.ConfirmDialog, { isOpen: this.state.isExportInProgress,
        isLoading: true,
        isButtonless: true,
        title: EXPORTING_MESSAGE });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          category = _props.category,
          mode = _props.mode,
          buildRoute = _props.buildRoute,
          index = _props.index,
          groupId = _props.groupId;

      var sessionPlanId = this._getSessionPlanId(this.props);
      var studentId = this._getStudentId(this.props);
      return _react2.default.createElement(
        'div',
        null,
        category === _routes.CATEGORY_GRAMMAR_PRO ? _react2.default.createElement(_GrammarPro2.default, { sessionPlanId: sessionPlanId,
          groupId: groupId,
          buildRouteWithContext: buildRoute,
          mode: this.state.isSaving ? _routes.Modes.SAVE : mode,
          index: index }) : _react2.default.createElement(_Feedback3.default, { mode: mode,
          groupId: groupId,
          studentId: studentId,
          sessionPlanId: sessionPlanId }),
        this._renderExportGeneralErrorDialog(),
        this._renderExportingDialog()
      );
    }
  }]);

  return SessionReport;
}(_UnsavedChangesTrackingPageComponent2.default);

SessionReport.propTypes = {
  buildRoute: _propTypes2.default.func,
  category: _propTypes2.default.string,
  groupId: _propTypes2.default.string,
  mode: _propTypes2.default.string,
  sessionPlanId: _propTypes2.default.string,
  unitId: _propTypes2.default.string,
  studentId: _propTypes2.default.string,
  index: _propTypes2.default.string
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      category = _ownProps$params.category,
      groupId = _ownProps$params.groupId,
      mode = _ownProps$params.mode,
      index = _ownProps$params.index;

  var defaultSession = Session.getDefaultSession(state, groupId);
  var sessionPlanId = defaultSession && defaultSession.id;
  var unitId = Session.getFirstUnitOfSession(state, sessionPlanId);
  var member = GroupMembers.getDefaultMember(state, groupId);
  return {
    category: category,
    groupId: groupId,
    mode: mode,
    index: index,
    sessionPlanId: sessionPlanId,
    unitId: unitId,
    studentId: member && member.studentGeneralInfo.id
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, (0, _redux.bindActionCreators)(_CoveredInClass.actions, dispatch), (0, _redux.bindActionCreators)(_Template.actions, dispatch), (0, _redux.bindActionCreators)(_Feedback.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(SessionReport));

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitFeedback = exports.SUBMIT_FEEDBACK_FAILURE = exports.SUBMIT_FEEDBACK_SUCCESS = exports.SUBMIT_FEEDBACK_REQUEST = exports.FETCH_FEEDBACK_FAILURE = exports.FETCH_FEEDBACK_SUCCESS = exports.FETCH_FEEDBACK_REQUEST = undefined;
exports.fetchFeedbackIfNeeded = fetchFeedbackIfNeeded;
exports.fetchFeedback = fetchFeedback;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_FEEDBACK_REQUEST = exports.FETCH_FEEDBACK_REQUEST = 'FETCH_FEEDBACK_REQUEST';
var FETCH_FEEDBACK_SUCCESS = exports.FETCH_FEEDBACK_SUCCESS = 'FETCH_FEEDBACK_SUCCESS';
var FETCH_FEEDBACK_FAILURE = exports.FETCH_FEEDBACK_FAILURE = 'FETCH_FEEDBACK_FAILURE';
var SUBMIT_FEEDBACK_REQUEST = exports.SUBMIT_FEEDBACK_REQUEST = 'SUBMIT_FEEDBACK_REQUEST';
var SUBMIT_FEEDBACK_SUCCESS = exports.SUBMIT_FEEDBACK_SUCCESS = 'SUBMIT_FEEDBACK_SUCCESS';
var SUBMIT_FEEDBACK_FAILURE = exports.SUBMIT_FEEDBACK_FAILURE = 'SUBMIT_FEEDBACK_FAILURE';

var buildFeedbackUrl = function buildFeedbackUrl(sessionId, studentId) {
  return (0, _Api.buildUrl)('/sessions/' + sessionId + '/students/' + studentId + '/feedback');
};

function fetchFeedbackIfNeeded(sessionId, studentId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildFeedbackUrl(sessionId, studentId) })) {
      return false;
    }
    return dispatch(fetchFeedback(sessionId, studentId));
  };
}

function fetchFeedback(sessionId, studentId) {
  return function (dispatch) {
    var url = buildFeedbackUrl(sessionId, studentId);
    var method = 'GET';

    var promise = dispatch(fetchFeedbackRequest()).payload.then(function (response) {
      return dispatch(fetchFeedbackSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchFeedbackFailure(error));
    });

    function fetchFeedbackRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_FEEDBACK_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        sessionId: sessionId,
        studentId: studentId,
        disableDefault: true
      });
    }

    function fetchFeedbackSuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_FEEDBACK_SUCCESS,
        payload: payload,
        url: url,
        method: method,
        sessionId: sessionId,
        studentId: studentId
      });
    }

    function fetchFeedbackFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_FEEDBACK_FAILURE,
        error: error,
        url: url,
        method: method,
        sessionId: sessionId,
        studentId: studentId,
        disableDefault: true
      });
    }

    return promise;
  };
}

var submitFeedback = exports.submitFeedback = function submitFeedback(sessionId, studentId, payload) {
  return function (dispatch) {
    var url = buildFeedbackUrl(sessionId, studentId);
    var method = 'PUT';
    return dispatch(submitFeedbackRequest()).payload.then(function (response) {
      return dispatch(submitFeedbackSuccess(response));
    }).catch(function (error) {
      return dispatch(submitFeedbackFailure(error));
    });

    function submitFeedbackRequest() {
      var request = (0, _Api.fetch)(url, {
        method: method,
        body: JSON.stringify(payload)
      });
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_FEEDBACK_REQUEST,
        payload: request,
        url: url,
        method: method
      });
    }

    function submitFeedbackSuccess() {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_FEEDBACK_SUCCESS,
        url: url,
        method: method
      });
    }

    function submitFeedbackFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_FEEDBACK_FAILURE,
        url: url,
        method: method,
        error: error
      });
    }
  };
};

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1901);

var _style2 = _interopRequireDefault(_style);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(15);

var _redux = __webpack_require__(10);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _GroupMembers = __webpack_require__(14);

var _ = __webpack_require__(13);

var _GrammaPro = __webpack_require__(806);

var _omniCommonUi = __webpack_require__(0);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_CELL = '';
var COLUMN_ID = 'id-ID';
var COLUMN_RU = 'ru-RU';
var COLUMN_CN = 'zh-CN';
var COLUMN_EN = 'en-US';

var COUNTRY_LANGUAGE_MAPPING = {
  CN: [COLUMN_CN, COLUMN_EN],
  ID: [COLUMN_ID, COLUMN_EN, COLUMN_CN],
  RU: [COLUMN_RU, COLUMN_EN]
};

var GarammaPro = function (_PureComponent) {
  _inherits(GarammaPro, _PureComponent);

  function GarammaPro(props) {
    _classCallCheck(this, GarammaPro);

    var _this = _possibleConstructorReturn(this, (GarammaPro.__proto__ || Object.getPrototypeOf(GarammaPro)).call(this, props));

    _this._renderCell = _this._renderCell.bind(_this);
    return _this;
  }

  _createClass(GarammaPro, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.fetchGrammaPro(this.props.groupId);
    }
  }, {
    key: '_renderReport',
    value: function _renderReport(reportUrl, date) {
      if (_is_js2.default.existy(reportUrl)) {
        return _react2.default.createElement(
          'a',
          { href: reportUrl, target: '_blank' },
          _react2.default.createElement(
            _omniCommonUi.Button,
            null,
            'REPORT ON ' + this._getDate(date)
          )
        );
      }
      return DEFAULT_CELL;
    }
  }, {
    key: '_getDate',
    value: function _getDate(date) {
      return _is_js2.default.existy(date) ? this._transformDate(date) : DEFAULT_CELL;
    }
  }, {
    key: '_renderDate',
    value: function _renderDate(date) {
      if (_is_js2.default.existy(date)) {
        return _react2.default.createElement(
          'span',
          { className: _style2.default.GrammarPro_report_date },
          this._transformDate(date)
        );
      }
      return _react2.default.createElement(
        'span',
        null,
        DEFAULT_CELL
      );
    }
  }, {
    key: '_renderPeriod',
    value: function _renderPeriod(start, end) {
      if (_is_js2.default.existy(start) && _is_js2.default.existy(end)) {
        return this._transformDate(start) + ' to ' + this._transformDate(end);
      }
      return DEFAULT_CELL;
    }
  }, {
    key: '_renderRportByLanguageCode',
    value: function _renderRportByLanguageCode(reports, languageCode) {
      var report = reports && reports.find(function (r) {
        return r.get('languageCode') === languageCode;
      });
      var reportUrl = report && report.get('reportUrl');
      var date = report && this._transformDate(report.get('reportGeneratedDate'));
      return report ? _react2.default.createElement(
        'div',
        { className: _style2.default.GrammarPro_report },
        this._renderReport(reportUrl, date)
      ) : DEFAULT_CELL;
    }
  }, {
    key: '_renderCell',
    value: function _renderCell(member, columnId) {
      var grammaPros = this.props.grammaPros;

      if (!member || !grammaPros) {
        return DEFAULT_CELL;
      }
      var grammaPro = grammaPros.get('' + member.studentGeneralInfo.id);
      if (!grammaPro) return DEFAULT_CELL;
      var reports = grammaPro.reports;
      var activationStart = grammaPro.activationStartDate;
      var activationEnd = grammaPro.activationEndDate;
      switch (columnId) {
        case COLUMN_CN:
          return this._renderRportByLanguageCode(reports, COLUMN_CN);
        case COLUMN_EN:
          return this._renderRportByLanguageCode(reports, COLUMN_EN);
        case COLUMN_ID:
          return this._renderRportByLanguageCode(reports, COLUMN_ID);
        case COLUMN_RU:
          return this._renderRportByLanguageCode(reports, COLUMN_RU);
        case 'activationPeriod':
          return this._renderPeriod(activationStart, activationEnd);
        default:
          return DEFAULT_CELL;
      }
    }
  }, {
    key: '_transformDate',
    value: function _transformDate(date) {
      if (!date) return '';
      return _omniCommonUi.moment.utc(date).clone().tz(this.props.timeZone).format('YYYY-MM-DD');
    }
  }, {
    key: '_renderTableHeader',
    value: function _renderTableHeader() {
      var languages = COUNTRY_LANGUAGE_MAPPING[this.props.countryCode];
      if (!_is_js2.default.existy(languages)) return null;
      return _react2.default.createElement(
        _CourseViewTable2.default.Header,
        null,
        _react2.default.createElement(
          _CourseViewTable2.default.Row,
          null,
          _react2.default.createElement(
            _CourseViewTable2.default.Cell,
            { columnId: 'activationPeriod', small: true },
            'Activation Period'
          ),
          languages.map(function (languageCode) {
            return _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: languageCode, small: true },
              _Languages2.default.getDisplayName(languageCode)
            );
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var members = this.props.members;

      if (!members) return null;
      return _react2.default.createElement(
        'div',
        { className: _style2.default.GrammarPro },
        _react2.default.createElement(
          'div',
          { className: _style2.default.GrammarPro_wrapper },
          _react2.default.createElement(
            _CourseViewTable2.default,
            { students: members },
            this._renderTableHeader(),
            _react2.default.createElement(
              _CourseViewTable2.default.Body,
              null,
              this._renderCell
            )
          )
        )
      );
    }
  }]);

  return GarammaPro;
}(_react.PureComponent);

GarammaPro.propTypes = {
  countryCode: _propTypes2.default.string.isRequired,
  groupId: _propTypes2.default.string.isRequired,
  members: _propTypes2.default.array.isRequired,
  grammaPros: _propTypes2.default.object,
  buildRoute: _propTypes2.default.func,
  timeZone: _propTypes2.default.string.isRequired,
  fetchGrammaPro: _propTypes2.default.func
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);

  var _groupActions$getCent = _.actions.getCentre(state, groupId),
      countryCode = _groupActions$getCent.countryCode,
      timeZone = _groupActions$getCent.timeZone;

  var grammaPros = state.get('rootReducer').get('grammaPro').get('' + groupId);
  return {
    countryCode: countryCode,
    timeZone: timeZone,
    members: members,
    groupId: groupId,
    grammaPros: grammaPros
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, { pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_GroupMembers.actions, dispatch), (0, _redux.bindActionCreators)(_GrammaPro.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(GarammaPro);

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(807);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1903);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchGrammaPro = exports.FETCH_GRAMMA_PRO_FAILURE = exports.FETCH_GRAMMA_PRO_SUCCESS = exports.FETCH_GRAMMA_PRO_REQUEST = undefined;
exports.fetchGrammaProIfNeed = fetchGrammaProIfNeed;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var ACTION_OBJECT_NAME = 'GRAMMA_PRO';

var FETCH_GRAMMA_PRO_REQUEST = exports.FETCH_GRAMMA_PRO_REQUEST = 'FETCH_' + ACTION_OBJECT_NAME + '_REQUEST';
var FETCH_GRAMMA_PRO_SUCCESS = exports.FETCH_GRAMMA_PRO_SUCCESS = 'FETCH_' + ACTION_OBJECT_NAME + '_SUCCESS';
var FETCH_GRAMMA_PRO_FAILURE = exports.FETCH_GRAMMA_PRO_FAILURE = 'FETCH_' + ACTION_OBJECT_NAME + '_FAILURE';

var DISABLE_DEFAULT_ACTION_EXTRAS = { disableDefault: true };

var buildGrammaProURL = function buildGrammaProURL(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/grammar-pro-reports');
};

var createfetchGrammaProActions = function createfetchGrammaProActions(groupId) {
  return (0, _omniCommonUi.createApiActionCreator)(ACTION_OBJECT_NAME, buildGrammaProURL(groupId), 'GET', DISABLE_DEFAULT_ACTION_EXTRAS, { groupId: groupId }, DISABLE_DEFAULT_ACTION_EXTRAS);
};

var fetchGrammaPro = exports.fetchGrammaPro = function fetchGrammaPro(groupId) {
  return createfetchGrammaProActions(groupId);
};

function fetchGrammaProIfNeed(activityId, studentId) {
  var method = 'GET';
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: method, url: fetchGrammaPro(activityId, studentId) })) {
      return false;
    }
    return dispatch(fetchGrammaPro(activityId, studentId));
  };
}

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GrammaProRecord = (0, _immutable.Record)({
  studentId: undefined,
  activationStartDate: undefined,
  activationEndDate: undefined,
  reportGeneratedDate: undefined,
  reportUrl: undefined,
  reports: undefined
});

var GrammaPro = function (_GrammaProRecord) {
  _inherits(GrammaPro, _GrammaProRecord);

  function GrammaPro() {
    _classCallCheck(this, GrammaPro);

    return _possibleConstructorReturn(this, (GrammaPro.__proto__ || Object.getPrototypeOf(GrammaPro)).apply(this, arguments));
  }

  return GrammaPro;
}(GrammaProRecord);

exports.default = GrammaPro;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MidtermAndFinalExam = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1907);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _ProgressTests = __webpack_require__(40);

var _ProgressReports = __webpack_require__(94);

var _ProgressTestsPlan = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MidtermAndFinalExam = exports.MidtermAndFinalExam = function (_Component) {
  _inherits(MidtermAndFinalExam, _Component);

  function MidtermAndFinalExam() {
    _classCallCheck(this, MidtermAndFinalExam);

    return _possibleConstructorReturn(this, (MidtermAndFinalExam.__proto__ || Object.getPrototypeOf(MidtermAndFinalExam)).apply(this, arguments));
  }

  _createClass(MidtermAndFinalExam, [{
    key: 'componentWillMount',

    // triggered on first load
    value: function componentWillMount() {
      this._loadIfNeed(this.props);
      this._fetchProgressTestModels(this.props);
      this._redirectToCourseView(this.props);
      this._checkIsMarkableInMarkMode(this.props);
      this._checkIsCanBeOverwriteInMarkMode(this.props);
    }

    // triggered on PT navigation

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._loadIfNeed(nextProps);
      this._fetchProgressTestModels(nextProps);
      this._redirectToCourseView(nextProps);
      this._checkIsMarkableInMarkMode(nextProps);
      this._checkIsCanBeOverwriteInMarkMode(nextProps);
    }
  }, {
    key: '_loadIfNeed',
    value: function _loadIfNeed(props) {
      var groupId = props.params.groupId;

      props.fetchProgressTestPlanIfNeeded(groupId);
    }
  }, {
    key: '_redirectToCourseView',
    value: function _redirectToCourseView(props) {
      var groupId = props.groupId,
          currentProgressTestIndex = props.currentProgressTestIndex,
          buildRoute = props.buildRoute,
          replace = props.replace;

      if (!(currentProgressTestIndex >= 0)) return;
      if (props.location.pathname.endsWith('exam')) {
        replace(buildRoute('/group/' + groupId + ('/exam/' + currentProgressTestIndex + '/course')));
      }
    }
  }, {
    key: '_fetchProgressTestModels',
    value: function _fetchProgressTestModels() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var progressTest = props.progressTest,
          progressReports = props.progressReports,
          currentProgressTestPlan = props.currentProgressTestPlan;

      if (!currentProgressTestPlan) return;
      var groupId = props.params.groupId;

      if (_omniCommonUi.ApiResponseHelper.shouldFetch(progressTest)) {
        props.fetchProgressTest(groupId, currentProgressTestPlan);
      }
      if (_omniCommonUi.ApiResponseHelper.shouldFetch(progressReports)) {
        props.fetchProgressReport(groupId);
      }
    }
  }, {
    key: '_checkIsMarkableInMarkMode',
    value: function _checkIsMarkableInMarkMode(props) {
      var markable = props.markable,
          params = props.params,
          buildRoute = props.buildRoute,
          replace = props.replace;


      if (_is_js2.default.boolean(markable) && !markable && params.mode === 'edit') {
        _omniCommonUi.log.warn('MidtermAndFinalExam: not a markable test; leaving edit mode');
        return replace(buildRoute({ mode: '' }));
      }
    }
  }, {
    key: '_checkIsCanBeOverwriteInMarkMode',
    value: function _checkIsCanBeOverwriteInMarkMode(props) {
      var progressTest = props.progressTest,
          params = props.params,
          buildRoute = props.buildRoute,
          replace = props.replace;
      var studentId = params.studentId;

      if (!_omniCommonUi.ApiResponseHelper.hasSucceeded(progressTest) || !studentId) return;

      var _progressTest$data$st = progressTest.data.studentProgressTestResults.get(studentId),
          canBeOverwrite = _progressTest$data$st.canBeOverwrite;

      if (_is_js2.default.boolean(canBeOverwrite) && !canBeOverwrite && params.mode === 'edit') {
        _omniCommonUi.log.warn('MidtermAndFinalExam: not an overwritable skill; leaving edit mode');
        return replace(buildRoute({ mode: '' }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          progressTestPlan = _props.progressTestPlan,
          progressTest = _props.progressTest;

      if (!progressTestPlan || !progressTest) return null;
      return _react2.default.createElement(
        'div',
        { className: _style2.default.MidtermAndFinalExam },
        _react2.default.createElement(
          'div',
          { className: _style2.default.MidtermAndFinalExam_content },
          this.props.children
        )
      );
    }
  }]);

  return MidtermAndFinalExam;
}(_react.Component);

MidtermAndFinalExam.getCurrentRouteSegment = function (props) {
  return props.routes[props.routes.length - 1];
};

MidtermAndFinalExam.propTypes = {
  children: _propTypes2.default.node,
  progressTest: _propTypes2.default.object,
  progressReports: _propTypes2.default.object,
  progressTestPlan: _propTypes2.default.object.isRequired,
  params: _propTypes2.default.object.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  routes: _propTypes2.default.array.isRequired,
  location: _propTypes2.default.object.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  replace: _propTypes2.default.func.isRequired,
  markable: _propTypes2.default.bool.isRequired
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      progressTestIndex = _ownProps$params.progressTestIndex;

  var group = state.get('rootReducer').get('groups').get(groupId);
  var progressTestPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId); // string groupId
  var midtermAndFinalExams = progressTestPlan && progressTestPlan.data && progressTestPlan.data.filter(function (ptp) {
    return ptp.isUnitQuiz === false;
  });
  if (!progressTestPlan || !midtermAndFinalExams) {
    return;
  }
  var defaultProgressTestIndex = (0, _ProgressTestsPlan.getDefaultProgressTestIndex)(state, groupId, false);
  var currentProgressTestIndex = progressTestIndex || defaultProgressTestIndex;
  var currentProgressTestPlan = midtermAndFinalExams.toList().sortBy(function (progressTest) {
    return progressTest.index;
  }).get(currentProgressTestIndex);
  var currentProgressTestId = currentProgressTestPlan.id;
  var progressTest = state.get('rootReducer').get('progressTests').get(currentProgressTestId);

  return {
    groupId: groupId,
    progressTestPlan: progressTestPlan,
    currentProgressTestPlan: currentProgressTestPlan,
    progressTest: progressTest,
    currentProgressTestIndex: currentProgressTestIndex,
    progressReports: group && group.data.progressReports,
    markable: (0, _ProgressTestsPlan.isMarkable)(state, groupId, currentProgressTestIndex, false)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_ProgressTests.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressReports.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTestsPlan.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(MidtermAndFinalExam);

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MidtermAndFinalExamHFv4 = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1911);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _ProgressTests = __webpack_require__(40);

var _ProgressTestsPlan = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MidtermAndFinalExamHFv4 = exports.MidtermAndFinalExamHFv4 = function (_Component) {
  _inherits(MidtermAndFinalExamHFv4, _Component);

  function MidtermAndFinalExamHFv4() {
    _classCallCheck(this, MidtermAndFinalExamHFv4);

    return _possibleConstructorReturn(this, (MidtermAndFinalExamHFv4.__proto__ || Object.getPrototypeOf(MidtermAndFinalExamHFv4)).apply(this, arguments));
  }

  _createClass(MidtermAndFinalExamHFv4, [{
    key: 'componentWillMount',

    // triggered on first load
    value: function componentWillMount() {
      this._loadIfNeed(this.props);
      this._fetchProgressTestModels(this.props);
      this._redirectToCourseView(this.props);
      this._checkIsMarkableInMarkMode(this.props);
      this._checkIsCanBeOverwriteInMarkMode(this.props);
    }

    // triggered on PT navigation

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._loadIfNeed(nextProps);
      this._fetchProgressTestModels(nextProps);
      this._redirectToCourseView(nextProps);
      this._checkIsMarkableInMarkMode(nextProps);
      this._checkIsCanBeOverwriteInMarkMode(nextProps);
    }
  }, {
    key: '_loadIfNeed',
    value: function _loadIfNeed(props) {
      var groupId = props.params.groupId;

      props.fetchProgressTestPlanIfNeeded(groupId);
    }
  }, {
    key: '_redirectToCourseView',
    value: function _redirectToCourseView(props) {
      var groupId = props.groupId,
          currentProgressTestIndex = props.currentProgressTestIndex,
          buildRoute = props.buildRoute,
          replace = props.replace;

      if (!(currentProgressTestIndex >= 0)) return;
      if (props.location.pathname.endsWith('exam-hfv4')) {
        replace(buildRoute('/group/' + groupId + ('/exam-hfv4/' + currentProgressTestIndex + '/course')));
      }
    }
  }, {
    key: '_fetchProgressTestModels',
    value: function _fetchProgressTestModels() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var progressTest = props.progressTest,
          currentProgressTestPlan = props.currentProgressTestPlan;

      if (!currentProgressTestPlan) return;
      var groupId = props.params.groupId;

      if (_omniCommonUi.ApiResponseHelper.shouldFetch(progressTest)) {
        props.fetchProgressTest(groupId, currentProgressTestPlan);
      }
    }
  }, {
    key: '_checkIsMarkableInMarkMode',
    value: function _checkIsMarkableInMarkMode(props) {
      var markable = props.markable,
          params = props.params,
          buildRoute = props.buildRoute,
          replace = props.replace;


      if (_is_js2.default.boolean(markable) && !markable && params.mode === 'edit') {
        _omniCommonUi.log.warn('MidtermAndFinalExamHFv4: not a markable test; leaving edit mode');
        return replace(buildRoute({ mode: '' }));
      }
    }
  }, {
    key: '_checkIsCanBeOverwriteInMarkMode',
    value: function _checkIsCanBeOverwriteInMarkMode(props) {
      var progressTest = props.progressTest,
          params = props.params,
          buildRoute = props.buildRoute,
          replace = props.replace;
      var studentId = params.studentId;

      if (!_omniCommonUi.ApiResponseHelper.hasSucceeded(progressTest) || !studentId) return;

      var _progressTest$data$st = progressTest.data.studentProgressTestResults.get(studentId),
          canBeOverwrite = _progressTest$data$st.canBeOverwrite;

      if (_is_js2.default.boolean(canBeOverwrite) && !canBeOverwrite && params.mode === 'edit') {
        _omniCommonUi.log.warn('MidtermAndFinalExamHFv4: not an overwritable skill; leaving edit mode');
        return replace(buildRoute({ mode: '' }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          progressTestPlan = _props.progressTestPlan,
          progressTest = _props.progressTest;

      if (!progressTestPlan || !progressTest) return null;
      return _react2.default.createElement(
        'div',
        { className: _style2.default.MidtermAndFinalExamHFv4 },
        _react2.default.createElement(
          'div',
          { className: _style2.default.MidtermAndFinalExamHFv4_content },
          this.props.children
        )
      );
    }
  }]);

  return MidtermAndFinalExamHFv4;
}(_react.Component);

MidtermAndFinalExamHFv4.getCurrentRouteSegment = function (props) {
  return props.routes[props.routes.length - 1];
};

MidtermAndFinalExamHFv4.propTypes = {
  children: _propTypes2.default.node,
  progressTest: _propTypes2.default.object,
  progressTestPlan: _propTypes2.default.object.isRequired,
  params: _propTypes2.default.object.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  routes: _propTypes2.default.array.isRequired,
  location: _propTypes2.default.object.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  replace: _propTypes2.default.func.isRequired,
  markable: _propTypes2.default.bool.isRequired
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      progressTestIndex = _ownProps$params.progressTestIndex;

  var progressTestPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId); // string groupId
  var midtermAndFinalExams = progressTestPlan && progressTestPlan.data && progressTestPlan.data.filter(function (ptp) {
    return ptp.isUnitQuiz === false;
  });
  if (!progressTestPlan || !midtermAndFinalExams) {
    return;
  }
  var defaultProgressTestIndex = (0, _ProgressTestsPlan.getDefaultProgressTestIndex)(state, groupId, false);
  var currentProgressTestIndex = progressTestIndex || defaultProgressTestIndex;
  var currentProgressTestPlan = midtermAndFinalExams.toList().sortBy(function (progressTest) {
    return progressTest.index;
  }).get(currentProgressTestIndex);
  if (!currentProgressTestPlan) {
    return;
  }
  var currentProgressTestId = currentProgressTestPlan.id;
  var progressTest = state.get('rootReducer').get('progressTests').get(currentProgressTestId);

  return {
    groupId: groupId,
    progressTestPlan: progressTestPlan,
    currentProgressTestPlan: currentProgressTestPlan,
    progressTest: progressTest,
    currentProgressTestIndex: currentProgressTestIndex,
    markable: (0, _ProgressTestsPlan.isMarkable)(state, groupId, currentProgressTestIndex, false)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_ProgressTests.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTestsPlan.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(MidtermAndFinalExamHFv4);

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressTestCourseView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1915);

var _style2 = _interopRequireDefault(_style);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _reactRouter = __webpack_require__(16);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _immutable = __webpack_require__(3);

var _ = __webpack_require__(13);

var _accessors = __webpack_require__(52);

var _omniCommonUi = __webpack_require__(0);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _SessionsAttendance = __webpack_require__(161);

var SessionsAttendance = _interopRequireWildcard(_SessionsAttendance);

var _ProgressTests = __webpack_require__(40);

var _GroupMembers = __webpack_require__(14);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _NewNotePopup = __webpack_require__(288);

var _NewNotePopup2 = _interopRequireDefault(_NewNotePopup);

var _QuickSummary = __webpack_require__(162);

var _QuickSummary2 = _interopRequireDefault(_QuickSummary);

var _Note = __webpack_require__(131);

var _rcTooltip = __webpack_require__(151);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _EditableScoreCell = __webpack_require__(1917);

var _EditableScoreCell2 = _interopRequireDefault(_EditableScoreCell);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MARKING = "edit";
var EMPTY_HYPHEN = "-";

var BENCHMARKING_DATA = [{
  range: "0-59%",
  category: "Needs Improvement",
  descriptor: "Your child is finding it difficult to understand and use the language and skills taught in this unit. They need extra support to practise key vocabulary and structures and to build confidence in using what they have learned."
}, {
  range: "60-79%",
  category: "Developing",
  descriptor: "Your child is making progress with the language and skills from this unit and is beginning to use them with some success. They are close to meeting expectations but may still need support or reminders to use new vocabulary and structures accurately and consistently."
}, {
  range: "80-89%",
  category: "On Track",
  descriptor: "Your child shows a good understanding of the language and skills taught in this unit and meets the expected learning goals. They can use the key vocabulary and structures independently in familiar activities, with only occasional mistakes."
}, {
  range: "90-100%",
  category: "Outstanding",
  descriptor: "Your child shows an excellent understanding of the language and skills taught in this unit and uses what they have learned confidently and accurately. They apply the unit’s vocabulary and structures effectively in a range of activities and may use them flexibly or make clear connections with other learning."
}];

var SHOW_REMAINING_MEMBERS_CARD = false;
var SHOW_EXAM_LOG_CARD = false;
var SHOW_ADD_STUDENT_NOTES_ICON = false;

function getExamType(name) {
  if (name === 'Midterm Exam') return 'midterm';
  if (name === 'Final Exam') return 'final';
  return null;
}

var ProgressTestCourseView = exports.ProgressTestCourseView = function (_UnsavedChangesTracki) {
  _inherits(ProgressTestCourseView, _UnsavedChangesTracki);

  function ProgressTestCourseView(props) {
    _classCallCheck(this, ProgressTestCourseView);

    var _this = _possibleConstructorReturn(this, (ProgressTestCourseView.__proto__ || Object.getPrototypeOf(ProgressTestCourseView)).call(this, props));

    _this._renderAddNoteDialog = _this._renderAddNoteDialog.bind(_this);
    _this._onAddNoteClicked = _this._onAddNoteClicked.bind(_this);
    _this._onCancelNoteClicked = _this._onCancelNoteClicked.bind(_this);
    _this._onSaveNoteClicked = _this._onSaveNoteClicked.bind(_this);

    _this.state = {
      allowRouteLeave: false,
      isRouterLeaveConfirmed: false,
      studentProgressTestResult: new _immutable.Map(),
      studentChanged: [],
      dialogOpen: false,
      retakePTConfirmDialog: false,
      isExpandRemainingMember: true,
      isExpandMembersInScoreInfo: false,
      benchmarkingTooltipVisible: false
    };

    _this._onIndividualScoreEditedCache = {};
    return _this;
  }

  _createClass(ProgressTestCourseView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._buildViewState(this.props);
      this._fetchProgressTestModels();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.params.mode !== this.props.params.mode) {
        window.getSelection().removeAllRanges();
      }
      if (this.props.location.pathname === nextProps.location.pathname && this.state.studentProgressTestResult.size && nextProps.progressTest === this.props.progressTest) {
        return;
      }

      this._fetchProgressTestModels(nextProps);
      this._buildViewState(nextProps);
    }
  }, {
    key: "routerWillLeave",
    value: function routerWillLeave(nextLocation) {
      var that = this;
      var _state = this.state,
          studentProgressTestResult = _state.studentProgressTestResult,
          studentChanged = _state.studentChanged;

      var returnToView = function returnToView() {
        return that._forcePushRoute(that.props.buildRoute({ mode: "" }));
      };
      if (nextLocation && nextLocation.pathname.endsWith("/save")) {
        returnToView();
        setTimeout(function () {
          if (studentChanged.length !== 0) {
            that._handleSave(studentProgressTestResult.filter(function (result) {
              return studentChanged.findIndex(function (studentId) {
                return studentId === result.studentId;
              }) !== -1;
            }));
          }
        }, 0);
      } else if (nextLocation && nextLocation.pathname.endsWith("/discard")) {
        returnToView();
      } else {
        this.lastStateBeforeRouteChange = this.state.studentProgressTestResult;
        return _get(ProgressTestCourseView.prototype.__proto__ || Object.getPrototypeOf(ProgressTestCourseView.prototype), "routerWillLeave", this).call(this, nextLocation);
      }
    }
  }, {
    key: "_onAddNoteClicked",
    value: function _onAddNoteClicked(student) {
      this.setState({ dialogOpen: student });
    }
  }, {
    key: "_onCancelNoteClicked",
    value: function _onCancelNoteClicked() {
      this.setState({ dialogOpen: false });
    }
  }, {
    key: "_onSaveNoteClicked",
    value: function _onSaveNoteClicked(note) {
      var studentId = this.state.dialogOpen.studentGeneralInfo.id;
      this.props.submitStudentNote(studentId, {
        groupId: this.props.groupId,
        category: _Note.actions.STUDENT_NOTE_CATEGORY_PROGRESS_TEST,
        content: note,
        entityId: this.props.progressTestId
      });
      this.setState({ dialogOpen: false });
    }
  }, {
    key: "_buildViewState",
    value: function _buildViewState(props) {
      var extraState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!_omniCommonUi.ApiResponseHelper.hasSucceeded(props.progressTest)) {
        return;
      }
      this.setState(Object.assign({
        studentProgressTestResult: props.progressTest.data.studentProgressTestResults,
        studentChanged: [],
        wasAnEditMade: false
      }, extraState));
    }
  }, {
    key: "_wasAnAddReallyMade",
    value: function _wasAnAddReallyMade() {
      var _this2 = this;

      var getOriginalScore = function getOriginalScore(studentId, skillId) {
        return _this2.props.progressTest.data.studentProgressTestResults.get(studentId).skillResults.get(skillId).currentResult;
      };
      return this.state.studentProgressTestResult.some(function (studentProgressTestResult, studentId) {
        return studentProgressTestResult.skillResults.some(function (skillResult, skillId) {
          return _is_js2.default.number(skillResult.currentResult) && _is_js2.default.not.number(getOriginalScore(studentId, skillId));
        });
      });
    }
  }, {
    key: "_isChangesPresent",
    value: function _isChangesPresent() {
      return ProgressTestCourseView.isInMarkingRoute(this.props) && (this.state.wasAnEditMade || this._wasAnAddReallyMade());
    }
  }, {
    key: "_handleSave",
    value: function _handleSave() {
      var studentProgressTestResults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.studentProgressTestResult;
      var _props = this.props,
          submitProgressTestResults = _props.submitProgressTestResults,
          currentProgressTestPlan = _props.currentProgressTestPlan,
          params = _props.params;

      var progressTest = _ProgressTests.ProgressTest.serialize(_ProgressTests.ProgressTest.create({
        studentProgressTestResults: studentProgressTestResults
      }));
      return submitProgressTestResults(params.groupId, currentProgressTestPlan.id, progressTest);
    }
  }, {
    key: "_onRubricButtonClicked",
    value: function _onRubricButtonClicked(studentId, skillId) {
      var _props2 = this.props,
          pushRoute = _props2.pushRoute,
          buildRoute = _props2.buildRoute,
          progressTest = _props2.progressTest,
          currentProgressTestIndex = _props2.currentProgressTestIndex,
          groupId = _props2.params.groupId;

      var progressTestSkills = progressTest.data.skills;
      var skillIndex = progressTestSkills.findIndex(function (pt) {
        return pt.skillId === skillId;
      });
      pushRoute(buildRoute("/group/" + groupId + ("/exam-hfv4/" + currentProgressTestIndex) + ("/student/" + studentId) + ("/skill/" + skillIndex)));
    }
  }, {
    key: "_onIndividualScoreEdited",
    value: function _onIndividualScoreEdited(studentId, skillId, fullMark, newScoreText) {
      var originalScore = this.props.progressTest.data.studentProgressTestResults.get(studentId).skillResults.get(skillId).currentResult;
      var newScoreInt = Number.parseFloat(newScoreText);
      var newScoreNum = _is_js2.default.number(newScoreInt) ? newScoreInt : null;
      var updatedStudentProgressTestResult = this.state.studentProgressTestResult.update(studentId, function (student) {
        return student.update("skillResults", function (skillResults) {
          return skillResults.update(skillId, function (skillResult) {
            return skillResult.set("currentResult", newScoreNum);
          });
        });
      });
      var newState = {
        studentProgressTestResult: updatedStudentProgressTestResult
      };
      if (this.state.studentChanged.findIndex(function (ele) {
        return ele === studentId;
      }) === -1) {
        var studentChanged = this.state.studentChanged;
        studentChanged.push(studentId);
        newState.studentChanged = studentChanged;
      }
      if (_is_js2.default.number(originalScore)) {
        newState.wasAnEditMade = true;
      }
      this.setState(newState);
    }
  }, {
    key: "_getTotalAsPercentageOrHyphen",
    value: function _getTotalAsPercentageOrHyphen() {
      var resultsDescriptor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _resultsDescriptor$to = resultsDescriptor.totalScore,
          totalScore = _resultsDescriptor$to === undefined ? {} : _resultsDescriptor$to;

      if (!_is_js2.default.object(totalScore) || totalScore.isEmpty || totalScore.isNotApplicable) {
        return EMPTY_HYPHEN;
      }
      return totalScore.percentage;
    }
  }, {
    key: "_renderTotalsAsPercentages",
    value: function _renderTotalsAsPercentages(results) {
      var currentTotalPercentage = this._getTotalAsPercentageOrHyphen(results);
      return _react2.default.createElement(
        "div",
        {
          className: (0, _classnames3.default)(_style2.default.ProgressTestCourseView_scoreCell, (0, _omniCommonUi.testClass)("average-score"))
        },
        _react2.default.createElement(
          "div",
          { className: _style2.default.ProgressTestCourseView_scoreCell_currentScore },
          _is_js2.default.number(currentTotalPercentage) ? currentTotalPercentage + "%" : currentTotalPercentage
        )
      );
    }
  }, {
    key: "_gaLinkToRetakePT",
    value: function _gaLinkToRetakePT() {
      _reactGa2.default.event({
        category: "Progress Tests",
        action: "Clicked button to retake PT"
      });
    }
  }, {
    key: "_renderScoresForSkill",
    value: function _renderScoresForSkill(result, progressTestSkill, studentId, canBeOverwrite) {
      var _this3 = this;

      var skillId = progressTestSkill.skillId;

      var isScoreEmpty = function isScoreEmpty(score) {
        return !_is_js2.default.number(score);
      };
      var renderScores = function renderScores(score, previousScore, fullMark) {
        var isEditableScore = ProgressTestCourseView.isInMarkingRoute(_this3.props) && !progressTestSkill.isRubric && canBeOverwrite;
        var editScoreCellClassName = progressTestSkill.isRubric ? "" : (0, _omniCommonUi.testClass)("non-rubric");
        if (!isEditableScore && isScoreEmpty(score)) {
          return _react2.default.createElement(
            "div",
            { className: _style2.default.ProgressTestCourseView_scoreCell },
            _react2.default.createElement(
              "div",
              {
                className: _style2.default.ProgressTestCourseView_scoreCell_currentScore
              },
              "-/" + fullMark
            )
          );
        }
        var onIndividualScoreEditedKey = studentId + "-" + skillId;
        var onIndividualScoreEdited = _this3._onIndividualScoreEditedCache[onIndividualScoreEditedKey] || (_this3._onIndividualScoreEditedCache[onIndividualScoreEditedKey] = _this3._onIndividualScoreEdited.bind(_this3, studentId, skillId, fullMark));
        return _react2.default.createElement(_EditableScoreCell2.default, {
          className: editScoreCellClassName,
          score: score,
          previousScore: previousScore,
          isEditableScore: isEditableScore,
          showAsPercentage: !ProgressTestCourseView.isInMarkingRoute(_this3.props),
          studentId: studentId,
          skillId: skillId,
          fullMark: fullMark,
          onChange: onIndividualScoreEdited
        });
      };
      var scoresReadout = renderScores(result.currentResult, result.previousResult, isScoreEmpty(result.fullMark) ? progressTestSkill.fullMark : result.fullMark);
      var rubricButtonClassNames = (0, _classnames3.default)(_style2.default.ProgressTestCourseView_scoreCell, _style2.default.__isRubric, (0, _omniCommonUi.testClass)("rubric-score"));
      if (progressTestSkill.isRubric) {
        return _react2.default.createElement(
          _omniCommonUi.Button,
          {
            className: rubricButtonClassNames,
            disabled: progressTestSkill.name === _accessors.shouldDisabledSkillName || !canBeOverwrite,
            onClick: function onClick() {
              return _this3._onRubricButtonClicked(studentId, result.skillId);
            },
            attrs: { tabIndex: "-1" }
          },
          scoresReadout,
          _react2.default.createElement(_omniCommonUi.Icon, {
            id: "arrow-right",
            className: _style2.default.ProgressTestCourseView_scoreCell_icon
          })
        );
      }
      return scoresReadout;
    }
  }, {
    key: "_renderScoresInfoForSkill",
    value: function _renderScoresInfoForSkill(skillResult) {
      if (!skillResult.isRubric && skillResult.currentResult) {
        var timeZone = this.props.timeZone;

        return _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "p",
            null,
            skillResult.markedBy ? "Marked by " + skillResult.markedBy : "Synced from PT App"
          ),
          _react2.default.createElement(
            "p",
            null,
            "On",
            " ",
            _omniCommonUi.moment.utc(skillResult.markedTime).clone().tz(timeZone).format("YYYY-MM-DD")
          )
        );
      }
      return _react2.default.createElement(
        "div",
        null,
        "-"
      );
    }
  }, {
    key: "_findProgressTestResultsForStudent",
    value: function _findProgressTestResultsForStudent(progressTestResults, studentId) {
      return progressTestResults.get(studentId);
    }
  }, {
    key: "_renderUnsavedChangesWarningDialog",
    value: function _renderUnsavedChangesWarningDialog() {
      var _this4 = this;

      var isSaving = false;
      return _react2.default.createElement(_UnsavedChangesWarning2.default, {
        isOpen: !!this._isNavigationWithChangesRequested(),
        isSaving: this.props.isAnyApiCallSaving || isSaving,
        onSaveClicked: function onSaveClicked() {
          isSaving = true;
          _this4._handleSave(_this4.lastStateBeforeRouteChange.filter(function (result) {
            return !!result.canBeOverwrite;
          })).then(function () {
            isSaving = false;
          });
          _this4._forcePushRequestedLocation();
        },
        onDiscardClicked: function onDiscardClicked() {
          _this4._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this4._clearRequestedLocation();
        }
      });
    }
  }, {
    key: "_fetchProgressTestModels",
    value: function _fetchProgressTestModels() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var progressTest = props.progressTest,
          currentProgressTestPlan = props.currentProgressTestPlan;

      if (!currentProgressTestPlan) return;
      var groupId = props.params.groupId;

      if (_omniCommonUi.ApiResponseHelper.shouldFetch(progressTest)) {
        props.fetchProgressTest(groupId, currentProgressTestPlan);
      }
    }
  }, {
    key: "_renderCell",
    value: function _renderCell(member, column, isShowScoreInfo) {
      var progressTestResults = this._findProgressTestResultsForStudent(this.state.studentProgressTestResult, member.studentGeneralInfo.id);

      var skill = this.props.progressTest.data.skills.find(function (skillIt) {
        return skillIt.name === column;
      });

      if (_is_js2.default.undefined(progressTestResults)) {
        return null;
      }

      if (_is_js2.default.not.undefined(skill)) {
        var testResult = progressTestResults.skillResults.get(skill.skillId);
        if (isShowScoreInfo) {
          return this._renderScoresInfoForSkill(testResult);
        }
        return this._renderScoresForSkill(testResult, skill, member.studentGeneralInfo.id, progressTestResults.canBeOverwrite);
      }

      switch (column) {
        case "total":
          return this._renderTotalsAsPercentages(progressTestResults);
        case "retake":
          return _react2.default.createElement(
            "div",
            { className: (0, _omniCommonUi.testClass)("report-link-cell") },
            this._renderRetakeLink(member)
          );
        case "assessment-results":
          return _react2.default.createElement(
            "div",
            { className: (0, _omniCommonUi.testClass)("report-link-cell") },
            this._renderAssessmentResultsLink(member)
          );
        default:
          throw new Error("Invalid column " + column);
      }
    }
  }, {
    key: "_hasOnlineSkillScore",
    value: function _hasOnlineSkillScore(results) {
      var onlineSkills = this.props.progressTest.data.skills.filter(function (skill) {
        return !skill.isRubric;
      });
      if (onlineSkills.length === 0) return false;
      return onlineSkills.some(function (skill) {
        var testResult = results.skillResults.get(skill.skillId);
        return testResult && _is_js2.default.number(testResult.currentResult);
      });
    }
  }, {
    key: "_renderRetakeLink",
    value: function _renderRetakeLink(member) {
      var _this5 = this;

      var results = this._findProgressTestResultsForStudent(this.state.studentProgressTestResult, member.studentGeneralInfo.id);

      var canRetake = _is_js2.default.not.undefined(results) && this._hasOnlineSkillScore(results);
      var className = (0, _classnames3.default)(_style2.default.ProgressReportLink, _defineProperty({}, _style2.default.ProgressReportLink_disabled, !canRetake));

      return _react2.default.createElement(
        _reactRouter.Link,
        {
          className: className,
          draggable: false,
          onClick: canRetake ? function () {
            return _this5._onRetakeLinkClicked(member);
          } : undefined,
          tabIndex: "-1"
        },
        "Retake Exam"
      );
    }
  }, {
    key: "_onRetakeLinkClicked",
    value: function _onRetakeLinkClicked(student) {
      this.setState({ retakePTConfirmDialog: student });
    }
  }, {
    key: "_onCancelRetakeClicked",
    value: function _onCancelRetakeClicked() {
      this.setState({ retakePTConfirmDialog: false });
    }
  }, {
    key: "_onOKRetakeClicked",
    value: function _onOKRetakeClicked() {
      this._gaLinkToRetakePT();
      var studentId = this.state.retakePTConfirmDialog.studentGeneralInfo.id;

      this.props.retakeProgressTest(this.props.groupId, { progressTestId: this.props.progressTestId, studentId: studentId });
      this.setState({ retakePTConfirmDialog: false });
    }
  }, {
    key: "_renderAssessmentResultsLink",
    value: function _renderAssessmentResultsLink(member) {
      var memberId = member.studentGeneralInfo.id;
      var studentAssessmentReportBaseUrl = this.props.studentAssessmentReportBaseUrl;

      var url = studentAssessmentReportBaseUrl + "&studentId=" + memberId;

      return _react2.default.createElement(
        "a",
        {
          className: _style2.default.ProgressReportLink,
          href: url,
          target: "_blank",
          rel: "noreferrer",
          draggable: false,
          tabIndex: "-1"
        },
        "Assessment Results",
        " ",
        _react2.default.createElement(_omniCommonUi.Icon, { id: "arrow-right", className: _style2.default.ProgressReportLink_icon })
      );
    }
  }, {
    key: "_renderRetakePTConfirmDialog",
    value: function _renderRetakePTConfirmDialog() {
      var _this6 = this;

      if (!this.state.retakePTConfirmDialog) {
        return null;
      }

      var student = this.state.retakePTConfirmDialog;

      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        {
          isOpen: true,
          primaryButtonContent: "Confirm",
          secondaryButtonContent: "Cancel",
          onPrimaryClick: function onPrimaryClick() {
            return _this6._onOKRetakeClicked(student);
          },
          onSecondaryClick: function onSecondaryClick() {
            return _this6._onCancelRetakeClicked();
          },
          onRequestClose: function onRequestClose() {
            return _this6._onCancelRetakeClicked();
          }
        },
        _react2.default.createElement(
          "span",
          null,
          " ",
          "This will clear the student this online progress test result! Are you sure? ",
          _react2.default.createElement("br", null),
          "(note the cleared result/new result will take a while to be synced to here. ",
          _react2.default.createElement("br", null),
          "Until then this view will still show the last result)"
        )
      );
    }
  }, {
    key: "_renderAddNoteDialog",
    value: function _renderAddNoteDialog(student) {
      if (this.state.dialogOpen !== student) {
        return null;
      }

      return _react2.default.createElement(_NewNotePopup2.default, {
        titleGroup: this.props.groupNumber,
        studentName: student.studentGeneralInfo.firstName + " " + student.studentGeneralInfo.lastName,
        extraInfo: _react2.default.createElement(_QuickSummary2.default, {
          type: _QuickSummary2.default.Type.progressTest,
          entityId: this.props.progressTestId
        }),
        onSave: this._onSaveNoteClicked,
        onCancel: this._onCancelNoteClicked
      });
    }
  }, {
    key: "_renderExpandButtonForRemainingTable",
    value: function _renderExpandButtonForRemainingTable() {
      var _this7 = this;

      var isExpandRemainingMember = this.state.isExpandRemainingMember;


      return _react2.default.createElement(_ExpansionButton2.default, {
        isExpand: isExpandRemainingMember,
        onExpansionButtonClick: function onExpansionButtonClick() {
          return _this7.setState({ isExpandRemainingMember: !isExpandRemainingMember });
        },
        className: _style2.default.ProgressTestCourseView_expand
      });
    }
  }, {
    key: "_renderExpandButtonForSocreInfoTable",
    value: function _renderExpandButtonForSocreInfoTable() {
      var _this8 = this;

      var isExpandMembersInScoreInfo = this.state.isExpandMembersInScoreInfo;


      return _react2.default.createElement(_ExpansionButton2.default, {
        isExpand: isExpandMembersInScoreInfo,
        onExpansionButtonClick: function onExpansionButtonClick() {
          return _this8.setState({
            isExpandMembersInScoreInfo: !isExpandMembersInScoreInfo
          });
        },
        className: _style2.default.ProgressTestCourseView_expand
      });
    }
  }, {
    key: "_renderPTTable",
    value: function _renderPTTable(members) {
      var _this9 = this;

      var _props3 = this.props,
          canRetakeExam = _props3.canRetakeExam,
          canViewStudentAssessmentReport = _props3.canViewStudentAssessmentReport;


      return _react2.default.createElement(
        _CourseViewTable2.default,
        {
          students: members,
          onlyRowDivider: true,
          onAddNoteClicked: SHOW_ADD_STUDENT_NOTES_ICON && this.props.canAddStudentNotes ? this._onAddNoteClicked : undefined,
          renderAddNoteDialog: this._renderAddNoteDialog
        },
        _react2.default.createElement(
          _CourseViewTable2.default.Header,
          null,
          _react2.default.createElement(
            _CourseViewTable2.default.Row,
            null,
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: "total", small: true },
              "Total"
            ),
            this.props.progressTest.data.skills.map(function (skill) {
              return skill.name !== _accessors.shouldDisabledSkillName && _react2.default.createElement(
                _CourseViewTable2.default.Cell,
                {
                  key: skill.name,
                  columnId: skill.name,
                  small: true
                },
                skill.name === 'Speaking 1' ? 'Speaking' : skill.name
              );
            }),
            canRetakeExam && _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: "retake", small: true },
              _react2.default.createElement("span", { className: (0, _omniCommonUi.testClass)("report-link-header") })
            ),
            canViewStudentAssessmentReport && _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: "assessment-results", small: true },
              _react2.default.createElement("span", { className: (0, _omniCommonUi.testClass)("report-link-header") })
            )
          )
        ),
        _react2.default.createElement(
          _CourseViewTable2.default.Body,
          null,
          function (member, column) {
            return _this9._renderCell(member, column, false);
          }
        )
      );
    }
  }, {
    key: "_renderPTScoreInfoTable",
    value: function _renderPTScoreInfoTable(members) {
      var _this10 = this;

      return _react2.default.createElement(
        _CourseViewTable2.default,
        {
          students: members,
          onlyRowDivider: true,
          onAddNoteClicked: SHOW_ADD_STUDENT_NOTES_ICON && this.props.canAddStudentNotes ? this._onAddNoteClicked : undefined,
          renderAddNoteDialog: this._renderAddNoteDialog
        },
        _react2.default.createElement(
          _CourseViewTable2.default.Header,
          null,
          _react2.default.createElement(
            _CourseViewTable2.default.Row,
            null,
            this.props.progressTest.data.skills.map(function (skill) {
              if (skill.isRubric) {
                return null;
              }
              return _react2.default.createElement(
                _CourseViewTable2.default.Cell,
                {
                  key: skill.name,
                  columnId: skill.name,
                  small: true
                },
                skill.name
              );
            })
          )
        ),
        _react2.default.createElement(
          _CourseViewTable2.default.Body,
          null,
          function (member, column) {
            return _this10._renderCell(member, column, true);
          }
        )
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this11 = this;

      if (!_immutable.List.isList(this.props.members) || !this.props.progressTest || !this.props.progressTest.data) {
        return null;
      }

      var remainingMembers = [];
      if (this.state.isExpandRemainingMember) {
        remainingMembers = this.props.remainingMembers;
      }

      var ptMembers = [];
      if (this.state.isExpandMembersInScoreInfo) {
        ptMembers = this.props.ptSessionMembers.concat(this.props.remainingMembers);
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(
            _omniCommonUi.PageCard.Heading,
            {
              text: "Assessment Session Members",
              className: _style2.default.ProgressTestCourseView_cardHeader,
              titleClassName: _style2.default.ProgressTestCourseView_cardHeader_title
            },
            _react2.default.createElement(
              _rcTooltip2.default,
              {
                placement: "right",
                trigger: ["hover"],
                destroyPopupOnHide: true,
                visible: this.state.benchmarkingTooltipVisible,
                onVisibleChange: function onVisibleChange(visible) {
                  return _this11.setState({ benchmarkingTooltipVisible: visible });
                },
                overlayClassName: _style2.default.BenchmarkingTooltip_overlay,
                overlay: _react2.default.createElement(
                  "div",
                  { className: _style2.default.BenchmarkingTooltip },
                  _react2.default.createElement(
                    "div",
                    { className: _style2.default.BenchmarkingTooltip_title },
                    "Benchmarking"
                  ),
                  BENCHMARKING_DATA.map(function (item, index) {
                    return _react2.default.createElement(
                      "div",
                      {
                        key: index,
                        className: _style2.default.BenchmarkingTooltip_row
                      },
                      _react2.default.createElement(
                        "div",
                        { className: _style2.default.BenchmarkingTooltip_range },
                        item.range
                      ),
                      _react2.default.createElement(
                        "div",
                        { className: _style2.default.BenchmarkingTooltip_content },
                        _react2.default.createElement(
                          "div",
                          {
                            className: _style2.default.BenchmarkingTooltip_category
                          },
                          item.category
                        ),
                        _react2.default.createElement(
                          "div",
                          {
                            className: _style2.default.BenchmarkingTooltip_descriptor
                          },
                          item.descriptor
                        )
                      )
                    );
                  }),
                  _react2.default.createElement(
                    "div",
                    { className: _style2.default.BenchmarkingTooltip_footer },
                    _react2.default.createElement(
                      "span",
                      {
                        className: _style2.default.BenchmarkingTooltip_gotIt,
                        onClick: function onClick() {
                          return _this11.setState({ benchmarkingTooltipVisible: false });
                        }
                      },
                      "Got it"
                    )
                  )
                )
              },
              _react2.default.createElement(
                "div",
                {
                  className: _style2.default.ProgressTestCourseView_cardHeader_tooltip
                },
                _react2.default.createElement(_omniCommonUi.Icon, { id: "info" })
              )
            )
          ),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.ProgressTestCourseView_content },
            this._renderPTTable(this.props.ptSessionMembers)
          )
        ),
        SHOW_REMAINING_MEMBERS_CARD && _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(_omniCommonUi.PageCard.Heading, {
            text: "Remaining Session Members",
            className: _style2.default.ProgressTestCourseView_cardHeader
          }),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.ProgressTestCourseView_content },
            this._renderPTTable(remainingMembers)
          ),
          this._renderExpandButtonForRemainingTable()
        ),
        SHOW_EXAM_LOG_CARD && _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(_omniCommonUi.PageCard.Heading, {
            text: "Exam Log",
            className: _style2.default.ProgressTestCourseView_cardHeader
          }),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.ProgressTestCourseView_content },
            this._renderPTScoreInfoTable(ptMembers)
          ),
          this._renderExpandButtonForSocreInfoTable()
        ),
        this._renderUnsavedChangesWarningDialog(),
        this._renderRetakePTConfirmDialog()
      );
    }
  }]);

  return ProgressTestCourseView;
}(_UnsavedChangesTrackingPageComponent2.default);

ProgressTestCourseView.isInMarkingRoute = function (props) {
  return props.params && props.params.mode === MARKING;
};

ProgressTestCourseView.propTypes = {
  timeZone: _propTypes2.default.string.isRequired,
  contentMap: _propTypes2.default.object.isRequired,
  progressTest: _propTypes2.default.object.isRequired,
  currentProgressTestIndex: _propTypes2.default.number.isRequired,
  members: _propTypes2.default.object.isRequired,
  ptSessionMembers: _propTypes2.default.object.isRequired,
  remainingMembers: _propTypes2.default.object.isRequired,
  params: _propTypes2.default.object.isRequired,
  currentProgressTestPlan: _propTypes2.default.object.isRequired,
  submitProgressTestResults: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func,
  pushRoute: _propTypes2.default.func,
  router: _propTypes2.default.any.isRequired,
  route: _propTypes2.default.any.isRequired,
  routes: _propTypes2.default.array.isRequired,
  pathName: _propTypes2.default.string,
  location: _propTypes2.default.object.isRequired,
  canRetakeExam: _propTypes2.default.bool,
  isAnyApiCallSaving: _propTypes2.default.bool,
  groupNumber: _propTypes2.default.string.isRequired,
  canAddStudentNotes: _propTypes2.default.bool,
  progressTestId: _propTypes2.default.string,
  canViewStudentAssessmentReport: _propTypes2.default.bool,
  studentAssessmentReportBaseUrl: _propTypes2.default.string,
  groupId: _propTypes2.default.string,
  progressTestResetted: _propTypes2.default.object.isRequired
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var _Group$getCentre = _.actions.getCentre(state, groupId),
      timeZone = _Group$getCentre.timeZone;

  var pathName = ownProps.location.pathname;
  var group = state.get("rootReducer").get("groups").get(ownProps.params.groupId).data;
  var currentProgressTestIndex = Number.parseInt(ownProps.params.progressTestIndex, 10);
  var currentProgressTestPlan = (0, _accessors.getProgressTestPlanFromIndex)(state, groupId, currentProgressTestIndex, false);
  var progressTest = getCurrentProgressTest(state, currentProgressTestPlan && currentProgressTestPlan.id);
  var ptSessionStudentIds = progressTest && progressTest.data && progressTest.data.studentProgressTestResults.filter(function (studentProgressTestResult) {
    return studentProgressTestResult.isPTSessionMember;
  }).map(function (studentProgressTestResult) {
    return studentProgressTestResult.studentId;
  });
  var remainingStudentIds = progressTest && progressTest.data && progressTest.data.studentProgressTestResults.filter(function (studentProgressTestResult) {
    return !studentProgressTestResult.isPTSessionMember;
  }).map(function (studentProgressTestResult) {
    return studentProgressTestResult.studentId;
  });
  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var ptSessionMembers = ptSessionStudentIds && members.filter(function (member) {
    return ptSessionStudentIds.includes(member.studentGeneralInfo.id);
  });
  var remainingMembers = remainingStudentIds && members.filter(function (member) {
    return remainingStudentIds.includes(member.studentGeneralInfo.id);
  });
  var canRetakeExam = _.actions.isHFV4CourseTypeGroup(state, groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.ProgressTest.ReTake);
  var canAddStudentNotes = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.AcademicInfo.AddStudentNotes);
  var progressTestId = currentProgressTestPlan && currentProgressTestPlan.id;
  var progressTestResetted = state.get("rootReducer").get("isProgressTestResetted");
  var assessmentBaseUrl = _omniCommonUi.Config.get('hf4OnlineHomeworkViewerUrl');
  var examType = currentProgressTestPlan && getExamType(currentProgressTestPlan.name);
  var canViewStudentAssessmentReport = !!assessmentBaseUrl && !!examType;
  var studentAssessmentReportBaseUrl = canViewStudentAssessmentReport ? assessmentBaseUrl + "/?type=" + examType + "&groupId=" + groupId : null;

  return {
    groupId: groupId,
    timeZone: timeZone,
    groupNumber: group.number,
    members: members,
    ptSessionMembers: ptSessionMembers,
    remainingMembers: remainingMembers,
    progressTest: progressTest,
    currentProgressTestIndex: currentProgressTestIndex,
    currentProgressTestPlan: currentProgressTestPlan,
    pathName: pathName,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state),
    canAddStudentNotes: canAddStudentNotes,
    canRetakeExam: canRetakeExam,
    progressTestId: progressTestId,
    canViewStudentAssessmentReport: canViewStudentAssessmentReport,
    studentAssessmentReportBaseUrl: studentAssessmentReportBaseUrl,
    progressTestResetted: progressTestResetted
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(SessionsAttendance.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTests.ProgressTest.actions, dispatch), (0, _redux.bindActionCreators)(_Note.actions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !!(state.get("apiCalls") || new _immutable.List()).filter(function (call, key) {
    return ["PUT", "POST"].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

function getCurrentProgressTest(state, progressTestId) {
  var progressTests = state.get("rootReducer").get("progressTests");
  if (!_immutable.Map.isMap(progressTests)) {
    return;
  }
  return progressTests.get(progressTestId);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(ProgressTestCourseView));

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1934);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _ProgressTests = __webpack_require__(40);

var _ProgressReports = __webpack_require__(94);

var _StudentReportSummaries = __webpack_require__(42);

var _ProgressTestsPlan = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressReport = function (_Component) {
  _inherits(ProgressReport, _Component);

  function ProgressReport(props) {
    _classCallCheck(this, ProgressReport);

    var _this = _possibleConstructorReturn(this, (ProgressReport.__proto__ || Object.getPrototypeOf(ProgressReport)).call(this, props));

    _this.state = {};
    return _this;
  }

  // triggered on first load


  _createClass(ProgressReport, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._fetchProgressTestAndReportModels();
      this._redirectToProgressReportList(this.props);
    }

    // triggered on PT navigation

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._fetchProgressTestAndReportModels(nextProps);
      this._redirectToProgressReportList(nextProps);
    }
  }, {
    key: '_redirectToProgressReportList',
    value: function _redirectToProgressReportList(props) {
      var groupId = props.groupId,
          defaultProgressReportId = props.defaultProgressReportId,
          buildRoute = props.buildRoute,
          replace = props.replace;

      if (!defaultProgressReportId) return;
      if (props.location.pathname.endsWith('unit-report-hfv4')) {
        replace(buildRoute('/group/' + groupId + ('/unit-report-hfv4/' + defaultProgressReportId)));
      }
    }
  }, {
    key: '_fetchProgressTestAndReportModels',
    value: function _fetchProgressTestAndReportModels() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var progressTest = props.progressTest,
          progressReports = props.progressReports,
          studentReportSummaries = props.studentReportSummaries,
          progressTestId = props.currentProgressTestId,
          progressReportId = props.currentProgressReportId;
      var groupId = props.params.groupId;

      props.fetchProgressTestPlanIfNeeded(groupId);
      if (!progressReportId) return;
      if (_omniCommonUi.ApiResponseHelper.shouldFetch(studentReportSummaries)) {
        props.fetchStudentReportSummaries(progressReportId);
      }
      if (_omniCommonUi.ApiResponseHelper.shouldFetch(progressReports)) {
        props.fetchProgressReport(groupId);
      } else if (_omniCommonUi.ApiResponseHelper.hasSucceeded(progressReports) && _omniCommonUi.ApiResponseHelper.shouldFetch(progressTest)) {
        props.fetchProgressTest(groupId, { id: progressTestId });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          progressTest = _props.progressTest,
          progressReport = _props.progressReport,
          progressReports = _props.progressReports,
          params = _props.params;


      if (!progressReport || !progressReports.data || !progressTest || !progressTest.data || !params.progressReportId) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: _style2.default.ProgressReport_content },
          this.props.children
        )
      );
    }
  }]);

  return ProgressReport;
}(_react.Component);

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var group = state.get('rootReducer').get('groups').get(groupId).data;
  var progressReports = group.get('progressReports');
  var defaultProgressReportId = (0, _ProgressTestsPlan.getDefaultProgressReportId)(state, groupId);
  if (!defaultProgressReportId) return;
  var currentProgressReportId = ownProps.params.progressReportId;
  if (!currentProgressReportId) {
    currentProgressReportId = (0, _ProgressTestsPlan.getDefaultProgressReportId)(state, groupId);
  }
  var studentReportSummaries = state.get('rootReducer').get('studentReportSummaries').get(currentProgressReportId);
  var progressTest = void 0;
  var progressReport = void 0;
  var currentProgressTestId = void 0;

  if (_omniCommonUi.ApiResponseHelper.hasSucceeded(progressReports)) {
    progressReport = progressReports.data.get(currentProgressReportId);
    currentProgressTestId = progressReport.progressTestId;
    progressTest = state.get('rootReducer').get('progressTests').get(currentProgressTestId);
  }

  return {
    groupId: groupId,
    groupName: group.name,
    currentProgressTestId: currentProgressTestId,
    defaultProgressReportId: defaultProgressReportId,
    currentProgressReportId: currentProgressReportId,
    progressReports: progressReports,
    progressReport: progressReport,
    progressTest: progressTest,
    studentReportSummaries: studentReportSummaries,
    params: ownProps.params
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_ProgressTests.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressReports.actions, dispatch), (0, _redux.bindActionCreators)(_StudentReportSummaries.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTestsPlan.actions, dispatch));
}

ProgressReport.getCurrentRouteSegment = function (props) {
  return props.routes[props.routes.length - 1];
};

ProgressReport.propTypes = {
  children: _propTypes2.default.node,
  progressReports: _propTypes2.default.object.isRequired,
  progressReport: _propTypes2.default.object,
  progressTest: _propTypes2.default.object,
  fetchProgressTest: _propTypes2.default.func.isRequired,
  fetchProgressReport: _propTypes2.default.func.isRequired,
  fetchStudentReportSummaries: _propTypes2.default.func.isRequired,
  params: _propTypes2.default.object.isRequired
};

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(ProgressReport);

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _StudentReportSummaries = __webpack_require__(42);

var _GroupMembers = __webpack_require__(14);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _NoContentMessage = __webpack_require__(66);

var _NoContentMessage2 = _interopRequireDefault(_NoContentMessage);

var _DosApprovalCard = __webpack_require__(1938);

var _DosApprovalCard2 = _interopRequireDefault(_DosApprovalCard);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FILTER_BY_REPORT_STATUS = 'SentToDoS';

var DosApprovalList = function (_UnsavedChangesTracki) {
  _inherits(DosApprovalList, _UnsavedChangesTracki);

  function DosApprovalList() {
    _classCallCheck(this, DosApprovalList);

    return _possibleConstructorReturn(this, (DosApprovalList.__proto__ || Object.getPrototypeOf(DosApprovalList)).apply(this, arguments));
  }

  _createClass(DosApprovalList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          fetchStudentReportSummaries = _props.fetchStudentReportSummaries,
          approvalList = _props.approvalList,
          params = _props.params;
      var progressReportId = params.progressReportId;

      if (_omniCommonUi.ApiResponseHelper.shouldFetch(approvalList)) {
        fetchStudentReportSummaries(progressReportId);
      }
      this.setState({
        cardsInEditingModeCount: 0,
        shouldTriggerSaveAllComments: false,
        isAnyCommentChanged: false
      });
      _get(DosApprovalList.prototype.__proto__ || Object.getPrototypeOf(DosApprovalList.prototype), 'componentWillMount', this).call(this);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setState({
        cardsInEditingModeCount: 0,
        shouldTriggerSaveAllComments: false,
        isAnyCommentChanged: false
      });
    }
  }, {
    key: '_isChangesPresent',
    value: function _isChangesPresent() {
      return this.state.cardsInEditingModeCount > 0 && this.state.isAnyCommentChanged;
    }
  }, {
    key: '_onCardEnterOrLeaveEditMode',
    value: function _onCardEnterOrLeaveEditMode(isLeaving) {
      var inc = isLeaving ? -1 : 1;
      this.setState(function (_ref) {
        var cardsInEditingModeCount = _ref.cardsInEditingModeCount;
        return {
          cardsInEditingModeCount: cardsInEditingModeCount + inc
        };
      });
    }
  }, {
    key: '_renderCards',
    value: function _renderCards() {
      var _this2 = this;

      var _props2 = this.props,
          approvalList = _props2.approvalList,
          approvalListForGroup = _props2.approvalListForGroup,
          params = _props2.params;
      var progressReportId = params.progressReportId;


      if (!_omniCommonUi.ApiResponseHelper.hasSucceeded(approvalList)) {
        return null;
      }

      if (approvalListForGroup.size === 0) {
        return _react2.default.createElement(_NoContentMessage2.default, { className: (0, _omniCommonUi.testClass)('empty'),
          text: 'There are no reports waiting for approval at this time.' });
      }

      return _react2.default.createElement(
        _omniCommonUi.Grid,
        null,
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          approvalListForGroup.map(function (studentReport) {
            return _react2.default.createElement(_DosApprovalCard2.default, { key: studentReport.id,
              groupId: params.groupId,
              progressReportId: progressReportId,
              studentId: studentReport.studentId,
              buildRoute: _this2.props.buildRoute,
              location: _this2.props.location,
              shouldTriggerSaveAllComments: _this2.state.shouldTriggerSaveAllComments,
              onEnterEditMode: function onEnterEditMode() {
                _this2._onCardEnterOrLeaveEditMode();
              },
              onLeaveEditMode: function onLeaveEditMode() {
                _this2._onCardEnterOrLeaveEditMode(true);
              },
              onCommentChanged: function onCommentChanged() {
                _this2.state.isAnyCommentChanged || _this2.setState({
                  isAnyCommentChanged: true
                });
              } });
          }).toArray()
        )
      );
    }
  }, {
    key: '_renderUnsavedChangesWarningDialog',
    value: function _renderUnsavedChangesWarningDialog() {
      var _this3 = this;

      return _react2.default.createElement(_UnsavedChangesWarning2.default, { isOpen: !!this._isNavigationWithChangesRequested(),
        isSaving: this.props.isAnyApiCallSaving,
        onDiscardClicked: function onDiscardClicked() {
          _this3._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this3._clearRequestedLocation();
        },
        onSaveClicked: function onSaveClicked() {
          _this3.setState({ shouldTriggerSaveAllComments: true });
        },
        onSaved: function onSaved() {
          _this3._forcePushRequestedLocation();
        } });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this._renderCards(),
        this._renderUnsavedChangesWarningDialog()
      );
    }
  }]);

  return DosApprovalList;
}(_UnsavedChangesTrackingPageComponent2.default);

DosApprovalList.propTypes = {
  fetchStudentReportSummaries: _propTypes2.default.func.isRequired,
  approvalList: _propTypes2.default.instanceOf(_omniCommonUi.ApiResponse),
  approvalListForGroup: _propTypes2.default.objectOf(_immutable.List),
  params: _propTypes2.default.shape({
    progressReportId: _propTypes2.default.string.isRequired,
    groupId: _propTypes2.default.string.isRequired
  }).isRequired,
  location: _propTypes2.default.object.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  isAnyApiCallSaving: _propTypes2.default.bool,
  route: _propTypes2.default.any.isRequired,
  router: _propTypes2.default.any.isRequired
};

function mapStateToProps(state, _ref2) {
  var params = _ref2.params;
  var progressReportId = params.progressReportId;


  var groupMemberIds = _GroupMembers.actions.getMembersByGroup(state, params.groupId).map(function (member) {
    return member.studentGeneralInfo.id;
  });

  var approvalList = state.get('rootReducer').get('studentReportSummaries').get(progressReportId);

  // we might have students who aren't in our group. filter them out.
  // we'll also take the reports with a status of "SentToDoS" here.
  var approvalListForGroup = null;
  if (_omniCommonUi.ApiResponseHelper.hasSucceeded(approvalList)) {
    approvalListForGroup = approvalList.update('data', function (data) {
      return data.filter(function (sr) {
        return sr.status === FILTER_BY_REPORT_STATUS && groupMemberIds.indexOf(sr.studentId) !== -1;
      });
    }).data;
  }

  return {
    approvalList: approvalList,
    approvalListForGroup: approvalListForGroup,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_StudentReportSummaries.actions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(DosApprovalList));

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentReportView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1943);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _InternalNoteView = __webpack_require__(207);

var _InternalNoteView2 = _interopRequireDefault(_InternalNoteView);

var _AddInternalNoteControl = __webpack_require__(67);

var _AddInternalNoteControl2 = _interopRequireDefault(_AddInternalNoteControl);

var _StudentReportComment = __webpack_require__(205);

var _StudentReportComment2 = _interopRequireDefault(_StudentReportComment);

var _OnlineHomework = __webpack_require__(208);

var _StudentReportSummaries = __webpack_require__(42);

var _accessors = __webpack_require__(164);

var _PaperBasedHomework = __webpack_require__(135);

var _accessors2 = __webpack_require__(41);

var _ = __webpack_require__(13);

var _GroupMembers = __webpack_require__(14);

var _ScoreBand = __webpack_require__(165);

var _hfv4ScoreBands = __webpack_require__(110);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _RejectNote = __webpack_require__(210);

var _RejectNote2 = _interopRequireDefault(_RejectNote);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _ReportStudentCard = __webpack_require__(1946);

var _ProgressTestCard = __webpack_require__(1949);

var _OverallDevelopmentCard = __webpack_require__(1955);

var _OverallDevelopmentCard2 = _interopRequireDefault(_OverallDevelopmentCard);

var _HomeworkCard = __webpack_require__(1958);

var _SkillScoreCard = __webpack_require__(1961);

var _UserCard = __webpack_require__(65);

var _UserCard2 = _interopRequireDefault(_UserCard);

var _ExportDialog = __webpack_require__(1964);

var _ExportDialog2 = _interopRequireDefault(_ExportDialog);

var _routes = __webpack_require__(818);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SHOW_PAPER_BASED_HOMEWORK = false;
var SHOW_TEACHER_COMMENT = false;

var StudentReportView = exports.StudentReportView = function (_UnsavedChangesTracki) {
  _inherits(StudentReportView, _UnsavedChangesTracki);

  function StudentReportView(props) {
    _classCallCheck(this, StudentReportView);

    var _this = _possibleConstructorReturn(this, (StudentReportView.__proto__ || Object.getPrototypeOf(StudentReportView)).call(this, props));

    _this.state = { wasCommentEditMade: false };
    return _this;
  }

  _createClass(StudentReportView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.fetchOnlineHomeworkIfNeeded(this.props.groupId);
      this.props.fetchGroupPaperBasedHomeworkIfNeeded(this.props.groupId);
      if (!_hfv4ScoreBands.USE_LOCAL_HFV4_SCORE_BANDS) {
        this.props.fetchScoreBandIfNeeded(this.props.language);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setState({ wasCommentEditMade: false });
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave(nextLocation) {
      var _props = this.props,
          progressReportId = _props.progressReportId,
          studentReportSummary = _props.studentReportSummary,
          studentId = _props.studentId,
          submitStudentReportSummaryTeacherPublish = _props.submitStudentReportSummaryTeacherPublish,
          groupId = _props.groupId;

      if (nextLocation && nextLocation.pathname.endsWith('/publish')) {
        var studentReportSummaryIds = new _immutable.List([studentReportSummary.id]);
        submitStudentReportSummaryTeacherPublish(progressReportId, groupId, studentReportSummaryIds, studentId);
        // we want the changes dialog to show for this new route, so we won't use _forcePushRoute
        this.props.pushRoute(this.props.buildRoute({ mode: '' }));
      } else {
        return _get(StudentReportView.prototype.__proto__ || Object.getPrototypeOf(StudentReportView.prototype), 'routerWillLeave', this).call(this, nextLocation);
      }
    }
  }, {
    key: '_isChangesPresent',
    value: function _isChangesPresent() {
      var studentReportComment = this.props.studentReportComment;

      if (StudentReportView.isInAddCommentMode(this.props)) {
        return this.state.comment && this.state.comment.length;
      } else if (StudentReportView.isInEditCommentMode(this.props)) {
        return !!this.state.wasCommentEditMade || studentReportComment !== this.state.comment;
      }
      return false;
    }
  }, {
    key: '_goToViewModeAfterSaveOrDiscard',
    value: function _goToViewModeAfterSaveOrDiscard() {
      this._forcePushRoute(this.props.buildRoute({ mode: '' }), {
        comment: undefined
      });
    }
  }, {
    key: '_onDiscardCommentClick',
    value: function _onDiscardCommentClick() {
      _reactGa2.default.event({
        category: 'Progress Reports',
        action: 'Clicked "Discard"'
      });

      this._goToViewModeAfterSaveOrDiscard();
    }
  }, {
    key: '_onSaveComment',
    value: function _onSaveComment(text) {
      _reactGa2.default.event({
        category: 'Progress Reports',
        action: 'Clicked "Save"'
      });

      this._goToViewModeAfterSaveOrDiscard();
      var _props2 = this.props,
          progressReportId = _props2.progressReportId,
          studentReportId = _props2.studentReportId,
          submitStudentReportComment = _props2.submitStudentReportComment,
          fetchStudentReportSummary = _props2.fetchStudentReportSummary,
          studentId = _props2.studentId;

      submitStudentReportComment(progressReportId, studentReportId, text, studentId).then(function () {
        return fetchStudentReportSummary(progressReportId, studentId);
      });
    }
  }, {
    key: '_onCommentChanged',
    value: function _onCommentChanged(text) {
      this.setState({
        comment: text,
        wasCommentEditMade: true
      });
    }
  }, {
    key: '_isCommentEmpty',
    value: function _isCommentEmpty() {
      return !this.state.comment || _is_js2.default.empty(this.state.comment.trim());
    }
  }, {
    key: '_onDeleteComment',
    value: function _onDeleteComment() {
      _reactGa2.default.event({
        category: 'Progress Reports',
        action: 'Clicked "Delete"'
      });

      this._openDeleteCommentConfirmation();
    }
  }, {
    key: '_onDeleteCommentCancelled',
    value: function _onDeleteCommentCancelled() {
      _reactGa2.default.event({
        category: 'Progress Reports',
        action: 'Clicked "Cancel"'
      });

      this._closeDeleteCommentConfirmation();
    }
  }, {
    key: '_onDeleteCommentConfirmed',
    value: function _onDeleteCommentConfirmed() {
      _reactGa2.default.event({
        category: 'Progress Reports',
        action: 'Clicked "Delete"'
      });

      this._closeDeleteCommentConfirmation();
      var _props3 = this.props,
          progressReportId = _props3.progressReportId,
          studentReportId = _props3.studentReportId,
          deleteStudentReportComment = _props3.deleteStudentReportComment,
          fetchStudentReportSummary = _props3.fetchStudentReportSummary,
          studentId = _props3.studentId;

      deleteStudentReportComment(progressReportId, studentReportId, studentId).then(function () {
        return fetchStudentReportSummary(progressReportId, studentId);
      });
    }
  }, {
    key: '_openDeleteCommentConfirmation',
    value: function _openDeleteCommentConfirmation() {
      this.setState({ showDeleteConfirm: true }, function () {
        _reactGa2.default.send({
          hitType: 'pageview',
          page: window.location.pathname,
          location: window.location.href,
          title: document.title,
          modal: 'delete-report-comment-confirmation'
        });
      });
    }
  }, {
    key: '_closeDeleteCommentConfirmation',
    value: function _closeDeleteCommentConfirmation() {
      this.setState({ showDeleteConfirm: false }, function () {
        _reactGa2.default.send({
          hitType: 'pageview',
          page: window.location.pathname,
          location: window.location.href,
          title: document.title
        });
      });
    }
  }, {
    key: '_onEditComment',
    value: function _onEditComment(comment) {
      _reactGa2.default.event({
        category: 'Progress Reports',
        action: 'Clicked "Edit"'
      });

      this.setState({ comment: comment });
      this.props.pushRoute(this.props.buildRoute({ mode: 'edit-comment' }));
    }
  }, {
    key: '_isCommentEditable',
    value: function _isCommentEditable(reportStatus) {
      return this.props.canAddComment && (!_is_js2.default.undefined(reportStatus) && reportStatus !== _StudentReportSummaries.StudentReportSummary.Status.SentToDoS && reportStatus !== _StudentReportSummaries.StudentReportSummary.Status.Completed && reportStatus !== _StudentReportSummaries.StudentReportSummary.Status.Published || this.props.canUpdatePublishedProgressReport);
    }
  }, {
    key: '_renderExportDialog',
    value: function _renderExportDialog() {
      var _props4 = this.props,
          buildRoute = _props4.buildRoute,
          pushRoute = _props4.pushRoute,
          languageCode = _props4.languageCode,
          progressReportId = _props4.progressReportId,
          studentReportSummary = _props4.studentReportSummary,
          studentId = _props4.studentId;

      var isInExportRoute = this.props.params.mode === _routes.Modes.EXPORT;
      return isInExportRoute && _react2.default.createElement(_ExportDialog2.default, {
        progressReportId: progressReportId,
        languageCode: languageCode,
        pushRoute: pushRoute,
        buildRoute: buildRoute,
        studentReportSummary: studentReportSummary,
        studentId: studentId
      });
    }
  }, {
    key: '_renderCommentsViewMode',
    value: function _renderCommentsViewMode(comment, reportStatus) {
      var _props5 = this.props,
          studentReportSummary = _props5.studentReportSummary,
          timeZone = _props5.timeZone;

      var commentViewMode = {
        note: comment,
        userId: studentReportSummary && studentReportSummary.commentedByUserId,
        date: studentReportSummary && studentReportSummary.commentedTimeUtc,
        timeZone: timeZone
      };
      return _react2.default.createElement(_InternalNoteView2.default, {
        note: commentViewMode,
        canOperate: this._isCommentEditable(reportStatus),
        hideActionButtons: true
      });
    }
  }, {
    key: '_renderCommentsEditor',
    value: function _renderCommentsEditor() {
      var _this2 = this;

      return _react2.default.createElement(_AddInternalNoteControl2.default, {
        text: this.state.comment,
        maxCharacters: 500,
        onChange: function onChange(text) {
          return _this2._onCommentChanged(text);
        },
        onDiscardClick: function onDiscardClick() {
          return _this2._onDiscardCommentClick();
        },
        onSaveClick: function onSaveClick(text) {
          return _this2._onSaveComment(text);
        }
      });
    }
  }, {
    key: '_renderActionIcons',
    value: function _renderActionIcons(reportStatus, studentReportComment) {
      var _this3 = this;

      if (!this._isCommentEditable(reportStatus) || StudentReportView.isInAddCommentMode(this.props) || StudentReportView.isInEditCommentMode(this.props)) {
        return null;
      }

      return [_react2.default.createElement(
        _omniCommonUi.Tooltip,
        {
          className: _style2.default.StudentReportView_card_icon,
          text: 'Edit',
          placement: 'top',
          trigger: ['hover']
        },
        _react2.default.createElement(_omniCommonUi.Icon, {
          id: 'edit',
          onClick: function onClick() {
            return _this3._onEditComment(studentReportComment);
          }
        })
      ), _react2.default.createElement(
        _omniCommonUi.Tooltip,
        {
          className: _style2.default.StudentReportView_card_icon,
          text: 'Delete',
          placement: 'top',
          trigger: ['hover']
        },
        _react2.default.createElement(_omniCommonUi.Icon, {
          id: 'trash',
          title: 'Delete',
          onClick: function onClick() {
            return _this3._onDeleteComment();
          }
        })
      )];
    }
  }, {
    key: '_renderStudentReportComment',
    value: function _renderStudentReportComment(comment, reportStatus) {
      if (StudentReportView.isInAddCommentMode(this.props) || StudentReportView.isInEditCommentMode(this.props)) {
        return this._renderCommentsEditor(comment);
      }
      return this._renderCommentsViewMode(comment, reportStatus);
    }
  }, {
    key: '_renderUnitSummary',
    value: function _renderUnitSummary() {
      var progressReportUnitSummary = this.props.progressReportUnitSummary;

      if (!progressReportUnitSummary) {
        return null;
      }

      return _react2.default.createElement(
        _omniCommonUi.Grid.Item,
        { xs: 12, sm: 12, md: 12, lg: 12 },
        _react2.default.createElement(
          _omniCommonUi.PageCard,
          { className: (0, _classnames2.default)(_style2.default.StudentReportView_card) },
          _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Unit Summary' }),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.StudentReportView_unitSummary_body },
            progressReportUnitSummary
          )
        )
      );
    }
  }, {
    key: '_renderTeacherCommentsGridItem',
    value: function _renderTeacherCommentsGridItem(studentReportComment, reportStatus) {
      if (!SHOW_TEACHER_COMMENT) {
        return null;
      }

      if (StudentReportView.isInAddCommentMode(this.props)) {
        return _react2.default.createElement(
          _omniCommonUi.Grid.Item,
          { xs: 12, sm: 12, md: 12, lg: 12 },
          _react2.default.createElement(
            _omniCommonUi.PageCard,
            { className: (0, _classnames2.default)(_style2.default.StudentReportView_card) },
            _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Teacher\'s Comment' }),
            _react2.default.createElement(
              _omniCommonUi.PageCard.Content,
              null,
              this._renderStudentReportComment()
            )
          )
        );
      }

      if (studentReportComment && studentReportComment.length > 0) {
        return _react2.default.createElement(
          _omniCommonUi.Grid.Item,
          { xs: 12, sm: 12, md: 12, lg: 12 },
          _react2.default.createElement(
            _omniCommonUi.PageCard,
            { className: (0, _classnames2.default)(_style2.default.StudentReportView_card) },
            _react2.default.createElement(
              _omniCommonUi.PageCard.Heading,
              { text: 'Teacher\'s Comment', stackMode: 'horizontal' },
              this._renderActionIcons(reportStatus, studentReportComment)
            ),
            _react2.default.createElement(
              _omniCommonUi.PageCard.Content,
              null,
              this._renderStudentReportComment(studentReportComment, reportStatus)
            )
          )
        );
      }

      return null;
    }
  }, {
    key: '_renderProgressTestCardGridItem',
    value: function _renderProgressTestCardGridItem(percentage, publishedDateStr, name, isSSCourseTypeGroup, isSSV3Group) {
      if (_is_js2.default.not.number(percentage) || isSSV3Group) {
        return null;
      }

      return _react2.default.createElement(
        _omniCommonUi.Grid.Item,
        { xs: 12, sm: 12, md: 12, lg: 12 },
        _react2.default.createElement(_ProgressTestCard.ProgressTestCard, {
          className: _style2.default.StudentReportView_card,
          percentage: percentage,
          publishedDateStr: publishedDateStr,
          name: name,
          isSSCourseTypeGroup: isSSCourseTypeGroup
        })
      );
    }
  }, {
    key: '_shouldShowPaperBasedInHomeworkCard',
    value: function _shouldShowPaperBasedInHomeworkCard() {
      return !!this.props.hasPaperBasedHomework;
    }
  }, {
    key: '_renderHomeworkCardGridItem',
    value: function _renderHomeworkCardGridItem() {

      if (!SHOW_PAPER_BASED_HOMEWORK) {
        return null;
      }

      var _props6 = this.props,
          onlineHomeworkResult = _props6.onlineHomeworkResult,
          paperBasedHomeworkResult = _props6.paperBasedHomeworkResult;

      if (_is_js2.default.undefined(this.props.onlineHomeworkResult)) {
        return null;
      }

      return _react2.default.createElement(
        _omniCommonUi.Grid.Item,
        { xs: 12, sm: 12, md: 6, lg: 6 },
        _react2.default.createElement(_HomeworkCard.HomeworkCard, {
          className: _style2.default.StudentReportView_card,
          averageScorePercentage: onlineHomeworkResult.averageScorePercentage,
          completedAssignments: onlineHomeworkResult.completedAssignments,
          totalAssignments: onlineHomeworkResult.totalAssignments,
          shouldShowPaperBased: this._shouldShowPaperBasedInHomeworkCard(),
          completedPaperBased: paperBasedHomeworkResult.completedAssignments,
          totalPaperBased: paperBasedHomeworkResult.totalAssignments
        })
      );
    }
  }, {
    key: '_renderOverallDevelopmentCard',
    value: function _renderOverallDevelopmentCard(studentProgressTestResult, progressTestSkills, isSSV3CourseTypeGroup) {
      if (!isSSV3CourseTypeGroup) {
        return null;
      }

      var rubricSkills = progressTestSkills.filter(function (s) {
        return s.isRubric;
      });
      var rubricSkillResults = studentProgressTestResult.skillResults.filter(function (sr) {
        return sr.isRubric;
      });
      return _react2.default.createElement(
        _omniCommonUi.Grid.Item,
        { xs: 12, sm: 12, md: 12, lg: 12 },
        _react2.default.createElement(_OverallDevelopmentCard2.default, {
          className: _style2.default.StudentReportView_card,
          skills: rubricSkills,
          skillResults: rubricSkillResults
        })
      );
    }
  }, {
    key: '_renderSkillScoreCardGridItems',
    value: function _renderSkillScoreCardGridItems(studentProgressTestResult, progressTestSkills, isSSCourseTypeGroup, isSSV3Group) {
      var getStudentResultForSkill = function getStudentResultForSkill(skillId) {
        return studentProgressTestResult.skillResults.find(function (sr) {
          return sr.skillId === skillId;
        });
      };

      var items = progressTestSkills.filter(function (skill) {
        var studentResultForSkill = getStudentResultForSkill(skill.skillId);
        if (isSSV3Group && studentResultForSkill.isRubric) {
          return false;
        }
        return _is_js2.default.number(studentResultForSkill.currentResult);
      }).map(function (skill) {
        var studentResultForSkill = getStudentResultForSkill(skill.skillId);
        var percentage = Math.round(studentResultForSkill.currentResult / studentResultForSkill.fullMark * 100);
        return _react2.default.createElement(
          _omniCommonUi.Grid.Item,
          { key: skill.skillId, xs: 12, sm: 12, md: 6, lg: 6 },
          _react2.default.createElement(_SkillScoreCard.SkillScoreCard, {
            skillName: skill.name,
            skillDescription: skill.expectation ? 'This score reflects how well student can ' + skill.expectation : skill.description,
            scorePercentage: percentage,
            isSSCourseTypeGroup: isSSCourseTypeGroup,
            studentResultForSkill: studentResultForSkill
          })
        );
      });
      return items;
    }
  }, {
    key: '_renderDeleteCommentDialog',
    value: function _renderDeleteCommentDialog() {
      var _this4 = this;

      return _react2.default.createElement(_omniCommonUi.ConfirmDialog, {
        isOpen: this.state.showDeleteConfirm,
        content: 'Are you sure you want to delete this comment?',
        primaryButtonContent: 'CANCEL',
        secondaryButtonContent: 'DELETE',
        onPrimaryClick: function onPrimaryClick() {
          return _this4._onDeleteCommentCancelled();
        },
        onSecondaryClick: function onSecondaryClick() {
          return _this4._onDeleteCommentConfirmed();
        }
      });
    }
  }, {
    key: '_renderUnsavedChangesWarningDialog',
    value: function _renderUnsavedChangesWarningDialog() {
      var _this5 = this;

      if (StudentReportView.isInEditCommentMode(this.props) && this._isCommentEmpty()) {
        return _react2.default.createElement(_omniCommonUi.ConfirmDialog, {
          isOpen: !!this._isNavigationWithChangesRequested(),
          primaryButtonContent: 'Stay',
          secondaryButtonContent: 'Leave',
          content: 'Are you sure you want to leave this page and lose unsaved changes?',
          onPrimaryClick: function onPrimaryClick() {
            _this5._clearRequestedLocation();
          },
          onSecondaryClick: function onSecondaryClick() {
            _this5._forcePushRequestedLocation();
          },
          onRequestClose: function onRequestClose() {
            _this5._clearRequestedLocation();
          }
        });
      }
      return _react2.default.createElement(_UnsavedChangesWarning2.default, {
        isOpen: !!this._isNavigationWithChangesRequested(),
        isSaving: this.props.isAnyApiCallSaving,
        onSaveClicked: function onSaveClicked() {
          var text = _this5.state.comment;

          _this5._onSaveComment(text);
        },
        onDiscardClicked: function onDiscardClicked() {
          _this5._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this5._clearRequestedLocation();
        },
        onSaved: function onSaved() {
          _this5._forcePushRequestedLocation();
        }
      });
    }
  }, {
    key: '_renderRjectNote',
    value: function _renderRjectNote() {
      var _props7 = this.props,
          _props7$studentReport = _props7.studentReportSummary,
          studentReportSummary = _props7$studentReport === undefined ? {} : _props7$studentReport,
          timeZone = _props7.timeZone;

      var reportStatus = studentReportSummary.status || '';
      var dosRejectedComment = studentReportSummary && studentReportSummary.dosRejectedComment;

      return dosRejectedComment && reportStatus.toLowerCase() === _StudentReportSummaries.StudentReportSummary.Status.Rejected.toLowerCase() && _react2.default.createElement(_RejectNote2.default, {
        note: dosRejectedComment.rejectedComment,
        rejectTime: dosRejectedComment.rejectedDate,
        timeZone: timeZone,
        teacherId: dosRejectedComment.rejectedBy
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props8 = this.props,
          group = _props8.group,
          member = _props8.member,
          progressTest = _props8.progressTest,
          progressTestUnitName = _props8.progressTestUnitName,
          studentProgressTestResult = _props8.studentProgressTestResult,
          studentReportComment = _props8.studentReportComment,
          studentReportSummary = _props8.studentReportSummary,
          isSSCourseTypeGroup = _props8.isSSCourseTypeGroup,
          isSSV3Group = _props8.isSSV3Group,
          timeZone = _props8.timeZone;
      var progressTestSkills = progressTest.data.skills;


      if (_is_js2.default.undefined(member)) {
        return null;
      }
      var studentGeneralInfo = member.studentGeneralInfo;

      var studentName = studentGeneralInfo.firstName + ' ' + studentGeneralInfo.lastName;
      var teachers = group.get('teachers');

      var reportStatus = void 0;
      var reportPublishedDateStr = null;
      if (!_is_js2.default.undefined(studentReportSummary)) {
        reportStatus = studentReportSummary.status;
        reportPublishedDateStr = studentReportSummary.publishedTimeUtc ? _omniCommonUi.moment.utc(studentReportSummary.publishedTimeUtc).clone().tz(timeZone).format('YYYY-MM-DD') : null;
      }

      return _react2.default.createElement(
        'div',
        null,
        this._renderExportDialog(),
        this._renderUnsavedChangesWarningDialog(),
        this._renderDeleteCommentDialog(),
        _react2.default.createElement(
          _omniCommonUi.Grid,
          null,
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12, sm: 12, md: 12, lg: 12 },
              this._renderRjectNote()
            ),
            this._renderUnitSummary(),
            _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12, sm: 12, md: 6, lg: 6 },
              _react2.default.createElement(_ReportStudentCard.ReportStudentCard, {
                studentName: studentName,
                studentGeneralInfo: studentGeneralInfo,
                member: member,
                reportStatus: _is_js2.default.undefined(reportStatus) ? '-' : reportStatus,
                submittedDate: reportPublishedDateStr
              })
            ),
            _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12, sm: 12, md: 6, lg: 6 },
              _react2.default.createElement(
                _omniCommonUi.PageCard,
                {
                  className: (0, _classnames2.default)(_style2.default.StudentReportView_card, _style2.default.StudentReportView_teachers_card)
                },
                _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Teachers' }),
                _react2.default.createElement(
                  _omniCommonUi.PageCard.Content,
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: _style2.default.StudentReportView_teachers_list },
                    teachers.map(function (teacher) {
                      return _react2.default.createElement(_UserCard2.default, {
                        id: '' + teacher.get('userId'),
                        key: 'user-' + teacher.get('userId'),
                        className: _style2.default.StudentReportView_teachers_item
                      });
                    })
                  )
                )
              )
            ),
            this._renderProgressTestCardGridItem(studentProgressTestResult.totalScore.percentage, reportPublishedDateStr, progressTestUnitName, isSSCourseTypeGroup, isSSV3Group),
            this._renderHomeworkCardGridItem(),
            this._renderTeacherCommentsGridItem(studentReportComment, reportStatus)
          ),
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            this._renderOverallDevelopmentCard(studentProgressTestResult, progressTestSkills, isSSV3Group),
            this._renderSkillScoreCardGridItems(studentProgressTestResult, progressTestSkills, isSSCourseTypeGroup, isSSV3Group)
          )
        )
      );
    }
  }]);

  return StudentReportView;
}(_UnsavedChangesTrackingPageComponent2.default);

StudentReportView.isInAddCommentMode = function (props) {
  return props.params && props.params.mode === 'add-comment';
};

StudentReportView.isInEditCommentMode = function (props) {
  return props.params && props.params.mode === 'edit-comment';
};

StudentReportView.propTypes = {
  group: _propTypes2.default.object,
  member: _propTypes2.default.object.isRequired,
  timeZone: _propTypes2.default.string.isRequired,
  hasPaperBasedHomework: _propTypes2.default.bool,
  progressReportId: _propTypes2.default.string,
  progressTestUnitName: _propTypes2.default.string,
  progressTest: _propTypes2.default.object,
  studentProgressTestResult: _propTypes2.default.object,
  studentReportSummary: _propTypes2.default.object,
  studentId: _propTypes2.default.string,
  studentReportId: _propTypes2.default.string,
  groupId: _propTypes2.default.string,
  studentReportComment: _propTypes2.default.object,
  progressReportUnitSummary: _propTypes2.default.string,
  pushRoute: _propTypes2.default.func,
  deleteStudentReportComment: _propTypes2.default.func,
  fetchStudentReportComment: _propTypes2.default.func,
  fetchStudentReportSummary: _propTypes2.default.func,
  fetchOnlineHomeworkIfNeeded: _propTypes2.default.func,
  fetchGroupPaperBasedHomeworkIfNeeded: _propTypes2.default.func,
  submitStudentReportComment: _propTypes2.default.func,
  submitStudentReportSummaryTeacherPublish: _propTypes2.default.func,
  onlineHomeworkResult: _propTypes2.default.object,
  paperBasedHomeworkResult: _propTypes2.default.object,
  buildRoute: _propTypes2.default.func.isRequired,
  router: _propTypes2.default.any.isRequired,
  routes: _propTypes2.default.array.isRequired,
  route: _propTypes2.default.any.isRequired,
  location: _propTypes2.default.any.isRequired,
  canAddComment: _propTypes2.default.bool,
  canUpdatePublishedProgressReport: _propTypes2.default.bool,
  isAnyApiCallSaving: _propTypes2.default.bool,
  isSSCourseTypeGroup: _propTypes2.default.bool,
  isSSV3Group: _propTypes2.default.bool,
  language: _propTypes2.default.string,
  languageCode: _propTypes2.default.string
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      studentId = _ownProps$params.studentId,
      progressReportId = _ownProps$params.progressReportId;

  var _Group$getCentre = _.actions.getCentre(state, groupId),
      timeZone = _Group$getCentre.timeZone;

  var hasPaperBasedHomework = _.actions.hasPaperBasedHomework(state, groupId);
  var canAddComment = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.ProgressReport.AddComment);
  var canUpdatePublishedProgressReport = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.ProgressReport.UpdatePublishedProgressReport);
  var group = state.get('rootReducer').get('groups').get(groupId).data;
  var member = _GroupMembers.actions.getMemberById(state, studentId);
  var studentReportSummaries = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data;
  var progressTestsPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId).data;
  var studentReportSummary = studentReportSummaries && studentReportSummaries.get('' + studentId);
  var studentReportComment = studentReportSummary && studentReportSummary.comments;
  var progressReportRecord = group.progressReports.data.get(progressReportId);
  var progressReportUnitSummary = (0, _accessors.getCombinedUnitSummariesText)(progressReportRecord);
  var progressTestId = progressReportRecord.progressTestId;

  var progressTest = state.get('rootReducer').get('progressTests').get(progressTestId);
  var studentProgressTestResult = void 0;
  if (_omniCommonUi.ApiResponseHelper.hasSucceeded(progressTest)) {
    studentProgressTestResult = progressTest.data.studentProgressTestResults.get(studentId);
  }

  var currentUnits = progressTestsPlan.find(function (plan) {
    return plan.progressReportId === progressReportId;
  }).unitIds;
  var units = (0, _accessors2.getUnitList)(state, groupId) || [];
  var progressTestUnit = units.filter(function (unit) {
    return currentUnits.includes(unit.id);
  }).toList().get(0);
  var onlineHomeworkResult = studentReportSummary && studentReportSummary.onlineHomeworkResult;
  var paperBasedHomeworkResult = studentReportSummary && studentReportSummary.paperBasedHomeworkResult;

  var language = state.get('rootReducer').get('language');
  var languageCode = group.languageCode;
  return {
    group: group,
    timeZone: timeZone,
    hasPaperBasedHomework: hasPaperBasedHomework,
    member: member,
    progressReportId: progressReportId,
    progressTestUnitName: progressTestUnit && progressTestUnit.name,
    progressTest: progressTest,
    studentProgressTestResult: studentProgressTestResult,
    studentReportSummary: studentReportSummary,
    studentReportId: studentReportSummary && studentReportSummary.id,
    studentId: studentId,
    groupId: groupId,
    studentReportComment: studentReportComment,
    progressReportUnitSummary: progressReportUnitSummary,
    canAddComment: canAddComment,
    canUpdatePublishedProgressReport: canUpdatePublishedProgressReport,
    onlineHomeworkResult: onlineHomeworkResult,
    paperBasedHomeworkResult: paperBasedHomeworkResult,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state),
    isSSCourseTypeGroup: !!_.actions.isSSCourseTypeGroup(state, groupId),
    isSSV3Group: !!_.actions.isSSV3Group(state, groupId),
    language: language,
    languageCode: languageCode
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_StudentReportSummaries.actions, dispatch), (0, _redux.bindActionCreators)(_StudentReportComment2.default, dispatch), (0, _redux.bindActionCreators)(_OnlineHomework.actions, dispatch), (0, _redux.bindActionCreators)(_ScoreBand.actions, dispatch), (0, _redux.bindActionCreators)(_PaperBasedHomework.actions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(StudentReportView));

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1945);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./hfv4BandColors.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./hfv4BandColors.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _ScoreBand = __webpack_require__(165);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hfv4ScoreBands = __webpack_require__(110);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScoreBand = function ScoreBand(props) {
  if (_is_js2.default.undefined(props.band)) {
    return null;
  }
  var band = props.textKey ? props.band[props.textKey] : props.band.interpretation;
  return _react2.default.createElement(
    'p',
    { className: props.className, style: props.style },
    band
  );
};

ScoreBand.propTypes = {
  className: _propTypes2.default.string,
  band: _propTypes2.default.object,
  textKey: _propTypes2.default.string,
  style: _propTypes2.default.object
};

function mapStateToProps(state, ownProps) {
  var score = ownProps.score;


  if (_hfv4ScoreBands.USE_LOCAL_HFV4_SCORE_BANDS) {
    var _band = _hfv4ScoreBands.HFV4_SCORE_BANDS.find(function (b) {
      return score >= b.scorePercentageFrom && score <= b.scorePercentageTo;
    });
    return { band: _band };
  }

  var scoreBand = state.get('rootReducer').get('scoreBand');
  var language = state.get('rootReducer').get('language');
  var band = _ScoreBand.accessors.getBandByScore(score, language, scoreBand);
  return { band: band };
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null)(ScoreBand);

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScoreStar = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _style = __webpack_require__(1953);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScoreStar = exports.ScoreStar = function ScoreStar(props) {
  var fullMark = props.fullMark,
      currentResult = props.currentResult;

  var level = getLevelByPercentage(percentage(currentResult, fullMark));
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_style2.default.ScoreStar, props.className) },
    renderStarsByLevel(level)
  );
};

function fraction() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var max = arguments[1];

  if (_is_js2.default.number(max)) {
    return value / max;
  }

  if (value > 100) {
    value = 100; // eslint-disable-line
  }

  return value / 100;
}

function clamp(fract) {
  return Math.min(1, Math.max(0, fract));
}

function percentage(value, max) {
  return Math.round(clamp(fraction(value, max)) * 100);
}

function getLevelByPercentage(percent) {
  if (percent >= 1 && percent < 30) return 1;else if (percent >= 30 && percent < 60) return 2;else if (percent >= 60 && percent < 70) return 3;else if (percent >= 70 && percent < 80) return 4;else if (percent >= 80 && percent <= 100) return 5;
  return 0;
}

function calcStarNumberByLevel(level) {
  if (level === 0) {
    return 0;
  }
  return level / 2 + 0.5;
}

function renderStarsByLevel(level) {
  var stars = [];
  var starNumber = calcStarNumberByLevel(level);
  var starFullNumber = parseInt(starNumber, 10);

  for (var i = 0; i < 3; i++) {
    if (i < starFullNumber) {
      stars.push(_react2.default.createElement(_omniCommonUi.Icon, { className: _style2.default.ScoreStar_starIcon, key: 'star-full' + i, id: 'star-full' }));
    } else if (i === starFullNumber && starNumber % 1 !== 0) {
      stars.push(_react2.default.createElement(_omniCommonUi.Icon, { className: _style2.default.ScoreStar_starIcon, key: 'star-half' + i, id: 'star-half' }));
    } else {
      stars.push(_react2.default.createElement(_omniCommonUi.Icon, { className: _style2.default.ScoreStar_starIcon, key: 'star-empty' + i, id: 'star-empty' }));
    }
  }
  return stars;
}

ScoreStar.propTypes = {
  className: _propTypes2.default.string,
  currentResult: _propTypes2.default.number,
  fullMark: _propTypes2.default.number
};

exports.default = ScoreStar;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modes = undefined;

var _component = __webpack_require__(814);

var _component2 = _interopRequireDefault(_component);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _StudentReportSummaries = __webpack_require__(42);

var _StudentSelect = __webpack_require__(1967);

var _StudentSelect2 = _interopRequireDefault(_StudentSelect);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SHOW_SUBMIT_FOR_APPROVAL = false;
var SHOW_ADD_COMMENTS = false;

var actionButtons = function actionButtons(getState) {
  return {
    Submit: {
      isPrimary: true,
      route: './publish',
      label: function label(_ref) {
        var _ref$params = _ref.params,
            progressReportId = _ref$params.progressReportId,
            studentId = _ref$params.studentId;

        try {
          // meh.
          return isCommentExist(getState(), progressReportId, studentId) ? 'Submit for Approval' : 'Submit';
        } catch (e) {
          return 'Submit';
        }
      },
      disableWhen: function disableWhen(_ref2) {
        var _ref2$params = _ref2.params,
            progressReportId = _ref2$params.progressReportId,
            studentId = _ref2$params.studentId,
            mode = _ref2$params.mode;
        return mode && mode.length || // disable when in `edit` or `add` modes
        !isPublishable(getState(), progressReportId, studentId);
      },
      visibleWhen: function visibleWhen(_ref3) {
        var _ref3$params = _ref3.params,
            groupId = _ref3$params.groupId,
            progressReportId = _ref3$params.progressReportId,
            studentId = _ref3$params.studentId;
        return SHOW_SUBMIT_FOR_APPROVAL && !_.actions.isDisabledReportActions(getState(), groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.Publish) && !isFuture(getState(), progressReportId, studentId);
      }
    },
    Export: {
      route: './export',
      visibleWhen: function visibleWhen(_ref4) {
        var _ref4$params = _ref4.params,
            groupId = _ref4$params.groupId,
            progressReportId = _ref4$params.progressReportId,
            studentId = _ref4$params.studentId;
        return !_.actions.isHFV4CourseTypeGroup(getState(), groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.Export) && !isFuture(getState(), progressReportId, studentId);
      },
      disableWhen: function disableWhen(_ref5) {
        var _ref5$params = _ref5.params,
            progressReportId = _ref5$params.progressReportId,
            studentId = _ref5$params.studentId,
            mode = _ref5$params.mode;
        return mode && mode.length || !isExportable(getState(), progressReportId, studentId);
      }
    },
    'Add Comment': {
      route: './add-comment',
      disableWhen: function disableWhen(_ref6) {
        var _ref6$params = _ref6.params,
            progressReportId = _ref6$params.progressReportId,
            studentId = _ref6$params.studentId,
            mode = _ref6$params.mode;
        return mode && mode.length || // disable when in `edit` or `add` modes
        !isPublishable(getState(), progressReportId, studentId);
      },
      visibleWhen: function visibleWhen(_ref7) {
        var _ref7$params = _ref7.params,
            groupId = _ref7$params.groupId,
            progressReportId = _ref7$params.progressReportId,
            studentId = _ref7$params.studentId;
        return SHOW_ADD_COMMENTS && !_.actions.isDisabledReportActions(getState(), groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.AddComment) && (!isFuture(getState(), progressReportId, studentId) && !isCommentExist(getState(), progressReportId, studentId) && !isCommentPublished(getState(), progressReportId, studentId) || _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.UpdatePublishedProgressReport));
      }
    }
  };
};

var Modes = exports.Modes = {
  EXPORT: 'export'
};

exports.default = function (_ref8) {
  var getState = _ref8.getState;
  return {
    path: 'student/:studentId(/:mode)',
    component: _component2.default,
    canAccess: function canAccess(_ref9) {
      var pathname = _ref9.location.pathname;

      var isEditMode = pathname.endsWith('/add-comment') || pathname.endsWith('/edit-comment');
      if (!isEditMode) {
        return true;
      }
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.AddComment);
    },
    breadcrumbLabels: 'Student Report',
    actionButtons: _defineProperty({
      default: actionButtons(getState),
      'add-comment': actionButtons(getState),
      'edit-comment': actionButtons(getState)
    }, Modes.EXPORT, actionButtons(getState)),
    appBars: {
      sticky: {
        'student-select': {
          component: _StudentSelect2.default,
          order: 2
        }
      }
    }
  };
};

function isFuture(state, progressReportId, studentId) {
  var studentReportSummary = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data.get('' + studentId);
  return _is_js2.default.undefined(studentReportSummary) || _is_js2.default.falsy(studentReportSummary.status);
}

function isPublishable(state, progressReportId, studentId) {
  var studentReportSummary = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data.get('' + studentId);
  return studentReportSummary && studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.Ready;
}
function isExportable(state, progressReportId, studentId) {
  var studentReportSummary = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data.get('' + studentId);
  return studentReportSummary && (studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.SentToDoS || studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.Completed || studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.Published || studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.Ready);
}
function isCommentPublished(state, progressReportId, studentId) {
  var studentReportSummary = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data.get('' + studentId);
  return studentReportSummary && (studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.SentToDoS || studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.Completed || studentReportSummary.status === _StudentReportSummaries.StudentReportSummary.Status.Published);
}

function isCommentExist(state, progressReportId, studentId) {
  var studentReportSummary = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data.get('' + studentId);
  if (studentReportSummary && studentReportSummary.comments) {
    return !_is_js2.default.falsy(studentReportSummary.comments) && studentReportSummary.comments.length > 0;
  }
  return false;
}

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateActionButtons = undefined;

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_SUBMIT_ALL = false;

var generateActionButtons = exports.generateActionButtons = function generateActionButtons(getState) {
  return {
    Submit: {
      isPrimary: true,
      route: './publish-all',
      label: function label(_ref) {
        var progressReportId = _ref.params.progressReportId;

        try {
          // meh.
          return isAnyCommentExist(getState(), progressReportId) ? 'Submit All for Approval' : 'Submit All-2';
        } catch (e) {
          return 'Submit All';
        }
      },
      visibleWhen: function visibleWhen(_ref2) {
        var _ref2$params = _ref2.params,
            groupId = _ref2$params.groupId,
            progressReportId = _ref2$params.progressReportId;
        return SHOW_SUBMIT_ALL && !_.actions.isDisabledReportActions(getState(), groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.Publish) && !isFuture(getState(), progressReportId);
      },
      disableWhen: function disableWhen(_ref3) {
        var progressReportId = _ref3.params.progressReportId;
        return !isAnyPublishable(getState(), progressReportId);
      }
    },
    'Export All': {
      route: './export-all',
      visibleWhen: function visibleWhen(_ref4) {
        var _ref4$params = _ref4.params,
            groupId = _ref4$params.groupId,
            progressReportId = _ref4$params.progressReportId;
        return !_.actions.isHFV4CourseTypeGroup(getState(), groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.Export) && !isFuture(getState(), progressReportId);
      },
      disableWhen: function disableWhen(_ref5) {
        var progressReportId = _ref5.params.progressReportId;
        return !isAnyExportable(getState(), progressReportId);
      }
    }
  };
};

function isFuture(state, progressReportId) {
  var studentReportSummaries = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data;
  return studentReportSummaries && studentReportSummaries.size === 0;
}

function isAnyExportable(state, progressReportId) {
  var studentReports = state.get('rootReducer').get('studentReportSummaries').get(progressReportId);
  if (!_immutable.Map.isMap(studentReports.data)) {
    return false;
  }
  return !!studentReports.data.some(function (report) {
    return report.status && report.status !== 'ScoresMissing';
  });
}

function isAnyPublishable(state, progressReportId) {
  var studentReports = state.get('rootReducer').get('studentReportSummaries').get(progressReportId);
  if (!_immutable.Map.isMap(studentReports.data)) {
    return false;
  }
  return !!studentReports.data.some(function (report) {
    return report.status === 'Ready';
  });
}

function isAnyCommentExist(state, progressReportId) {
  return state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data.some(function (studentReportSummary) {
    if (studentReportSummary && studentReportSummary.comments) {
      return !_is_js2.default.falsy(studentReportSummary.comments) && studentReportSummary.comments.length > 0;
    }
    return false;
  });
}

exports.default = {
  generateActionButtons: generateActionButtons
};

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _omniCommonUi = __webpack_require__(0);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _SkillRecommendation = __webpack_require__(325);

var _routes = __webpack_require__(821);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IndividualDevelopmentPlan = function (_PureComponent) {
  _inherits(IndividualDevelopmentPlan, _PureComponent);

  function IndividualDevelopmentPlan() {
    _classCallCheck(this, IndividualDevelopmentPlan);

    return _possibleConstructorReturn(this, (IndividualDevelopmentPlan.__proto__ || Object.getPrototypeOf(IndividualDevelopmentPlan)).apply(this, arguments));
  }

  _createClass(IndividualDevelopmentPlan, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._fetchIndividualDevelopmentPlan();
      this._redirectToListView();
      this.props.fetchSkillRecommendationsIfNeeded(this.props.params.groupId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._fetchIndividualDevelopmentPlan(nextProps);
      this._redirectToListView(nextProps);
    }
  }, {
    key: '_redirectToListView',
    value: function _redirectToListView() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var groupId = props.groupId,
          firstGroupIdpId = props.firstGroupIdpId;

      if (!props.firstGroupIdpId) return;
      if (props.location.pathname.endsWith('progress-report-hfv4')) {
        props.replaceRoute(this.props.buildRoute('/group/' + groupId + ('/progress-report-hfv4/' + firstGroupIdpId)));
      }
    }
  }, {
    key: '_fetchIndividualDevelopmentPlan',
    value: function _fetchIndividualDevelopmentPlan() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.props.fetchGroupIndividualDevelopmentPlanListIfNeeded(props.params.groupId);
      if (props.groupIdpId && this.props.isGroupIdpFetched) {
        this.props.fetchIndividualDevelopmentPlanListIfNeeded(props.groupIdpId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);

  return IndividualDevelopmentPlan;
}(_react.PureComponent);

IndividualDevelopmentPlan.propTypes = {
  children: _propTypes2.default.node,
  params: _propTypes2.default.shape().isRequired,
  firstGroupIdpId: _propTypes2.default.string,
  groupIdpId: _propTypes2.default.string,
  isGroupIdpFetched: _propTypes2.default.bool.isRequired,
  groupId: _propTypes2.default.string.isRequired,
  fetchGroupIndividualDevelopmentPlanListIfNeeded: _propTypes2.default.func.isRequired,
  fetchIndividualDevelopmentPlanListIfNeeded: _propTypes2.default.func.isRequired,
  fetchSkillRecommendationsIfNeeded: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  replaceRoute: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  routes: _propTypes2.default.array.isRequired,
  location: _propTypes2.default.object.isRequired
};

function getFirstGroupIdpId(groupIdpList) {
  if (groupIdpList.size === 1) {
    return groupIdpList.toList().get(0).id;
  } else if (groupIdpList.size > 1) {
    var firstGroupIdpInfo = groupIdpList.find(function (groupIdpInfo) {
      return groupIdpInfo.name.toLowerCase() === _routes.MID_LEVEL_REPORT;
    });
    if (!firstGroupIdpInfo) {
      firstGroupIdpInfo = groupIdpList.find(function (groupIdpInfo) {
        return groupIdpInfo;
      });
    }
    return firstGroupIdpInfo && firstGroupIdpInfo.id.toString();
  }
}

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      groupIdpId = _ownProps$params.groupIdpId;

  var groupIdpList = _IndividualDevelopmentPlans.accessors.getGroupIdpList(state, groupId);
  var isGroupIdpFetched = !!(groupIdpId && _IndividualDevelopmentPlans.accessors.isGroupIdpFetched(state, groupIdpId));

  var firstGroupIdpId = getFirstGroupIdpId(groupIdpList);
  return {
    groupId: groupId,
    firstGroupIdpId: firstGroupIdpId,
    groupIdpId: groupIdpId,
    isGroupIdpFetched: isGroupIdpFetched
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, { replaceRoute: function replaceRoute(path) {
      return dispatch((0, _reactRouterRedux.replace)(path));
    } }, (0, _redux.bindActionCreators)(_IndividualDevelopmentPlans.actions, dispatch), (0, _redux.bindActionCreators)(_SkillRecommendation.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(IndividualDevelopmentPlan);

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _ViewNav = __webpack_require__(822);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _component = __webpack_require__(820);

var _component2 = _interopRequireDefault(_component);

var _IndividualDevelopmentPlanListView = __webpack_require__(1980);

var _IndividualDevelopmentPlanDetailView = __webpack_require__(827);

var _IndividualDevelopmentPlanApprovalView = __webpack_require__(2042);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _secondLevelTabs = function _secondLevelTabs(getState, _ref, push, buildRoute) {
  var groupId = _ref.groupId,
      groupIdpId = _ref.groupIdpId;

  var groupIdpList = _IndividualDevelopmentPlans.accessors.getGroupIdpList(getState(), groupId);
  if (groupIdpList.size <= 1) return [];
  groupIdpList = groupIdpList.toList();
  return groupIdpList.map(function (groupIdpInfo) {
    return {
      text: groupIdpInfo.name.toUpperCase(),
      onClick: function onClick() {
        return push(buildRoute('/group/' + groupId + '/progress-report-hfv4/' + groupIdpInfo.id));
      },
      isActive: groupIdpId === groupIdpInfo.id.toString()
    };
  }).toArray();
};

exports.default = function (_ref2) {
  var getState = _ref2.getState;
  return {
    appBars: {
      sticky: {
        'view-nav': {
          component: _ViewNav2.default,
          order: 2,
          props: {
            hideExpandable: true
          }
        }
      }
    },
    path: 'progress-report-hfv4',
    component: _component2.default,
    secondLevelTabs: function secondLevelTabs(_ref3) {
      var push = _ref3.push,
          params = _ref3.params,
          buildRoute = _ref3.buildRoute;
      return _secondLevelTabs(getState, params, push, buildRoute);
    },
    breadcrumbLabels: function breadcrumbLabels(_ref4) {
      var params = _ref4.params,
          buildRoute = _ref4.buildRoute;
      return {
        label: _IndividualDevelopmentPlans.accessors.getReportName(getState(), params.groupIdpId, 'progress report'),
        href: buildRoute(buildRoute('/group/' + params.groupId + '/progress-report-hfv4/' + params.groupIdpId))
      };
    },
    canAccess: function canAccess(_ref5) {
      var params = _ref5.params;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.ProgressReportHFv4);
    },
    childRoutes: [_IndividualDevelopmentPlanApprovalView.routes, _IndividualDevelopmentPlanListView.routes, _IndividualDevelopmentPlanDetailView.routes],
    tab: {
      label: function label(params) {
        return _.actions.isDisabledReportActions(getState(), params.groupId) ? 'Historical Progress Reports' : 'Progress Reports';
      },
      order: 10,
      isVisible: function isVisible(params) {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.ProgressReportHFv4);
      }
    }
  };
};

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _LanguageSwitcher = __webpack_require__(692);

var _LanguageSwitcher2 = _interopRequireDefault(_LanguageSwitcher);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

var _exportFlags = __webpack_require__(823);

var _style = __webpack_require__(1978);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXPORT_LANGUAGES = [{
  code: _LanguageSwitcher.CHINESE_LANGUAGE,
  label: '中文'
}, {
  code: _Languages2.default.defaultLanguageCode,
  label: 'EN'
}];

var isDetailView = function isDetailView() {
  var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var current = routes[routes.length - 1];
  return !!(current && current.path && current.path.indexOf('student/:studentId') !== -1);
};

var getCurrentRouteSegment = function getCurrentRouteSegment(routes) {
  return routes && routes.length ? routes[routes.length - 1] : {};
};

var getExportButtonDescriptor = function getExportButtonDescriptor(props) {
  var currentRoute = getCurrentRouteSegment(props.routes);
  var currentModeName = props.params && props.params.mode && props.params.mode.length ? props.params.mode : 'default';
  var actionButtonsForMode = currentRoute.actionButtons && currentRoute.actionButtons[currentModeName];
  return actionButtonsForMode && actionButtonsForMode.Export;
};

var evaluateCondition = function evaluateCondition(condition, props, defaultValue) {
  if (!_is_js2.default.function(condition)) {
    return defaultValue;
  }
  try {
    if (condition.length < 2) {
      return condition(props);
    }
    return condition(props.state, props);
  } catch (err) {
    return defaultValue;
  }
};

var ProgressReportHFv4ViewNav = function (_Component) {
  _inherits(ProgressReportHFv4ViewNav, _Component);

  function ProgressReportHFv4ViewNav(props) {
    _classCallCheck(this, ProgressReportHFv4ViewNav);

    var _this = _possibleConstructorReturn(this, (ProgressReportHFv4ViewNav.__proto__ || Object.getPrototypeOf(ProgressReportHFv4ViewNav)).call(this, props));

    _this.state = {
      selectedLanguage: _Languages2.default.defaultLanguageCode
    };
    _this._onLanguageChange = _this._onLanguageChange.bind(_this);
    _this._onExportClick = _this._onExportClick.bind(_this);
    return _this;
  }

  _createClass(ProgressReportHFv4ViewNav, [{
    key: '_onLanguageChange',
    value: function _onLanguageChange(languageCode) {
      if (languageCode === _LanguageSwitcher.CHINESE_LANGUAGE) {
        return;
      }
      this.setState({ selectedLanguage: languageCode });
    }
  }, {
    key: '_onExportClick',
    value: function _onExportClick() {
      var _props = this.props,
          push = _props.push,
          buildRoute = _props.buildRoute;

      if (!_is_js2.default.function(push) || !_is_js2.default.function(buildRoute)) {
        return;
      }
      push(buildRoute('./export'));
    }
  }, {
    key: '_isExportVisible',
    value: function _isExportVisible() {
      var exportButton = getExportButtonDescriptor(this.props);
      if (!exportButton) {
        return false;
      }
      return evaluateCondition(exportButton.visibleWhen, this.props, true);
    }
  }, {
    key: '_isExportDisabled',
    value: function _isExportDisabled() {
      var exportButton = getExportButtonDescriptor(this.props);
      if (!exportButton) {
        return true;
      }
      return evaluateCondition(exportButton.disableWhen, this.props, false);
    }
  }, {
    key: '_renderExportLanguageCluster',
    value: function _renderExportLanguageCluster() {
      if (!_exportFlags.SHOW_EXPORT_LANGUAGE) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: _style2.default.DetailViewNav_rightCluster },
        _react2.default.createElement(_LanguageSwitcher2.default, {
          className: _style2.default.DetailViewNav_languageSwitcher,
          languages: EXPORT_LANGUAGES,
          selectedLanguage: this.state.selectedLanguage,
          onLanguageChange: this._onLanguageChange
        }),
        this._isExportVisible() && _react2.default.createElement(
          _omniCommonUi.Button,
          {
            autoWidth: true,
            type: _omniCommonUi.Button.Type.default,
            disabled: this._isExportDisabled(),
            className: (0, _classnames3.default)(_style2.default.DetailViewNav_exportButton, (0, _omniCommonUi.testClass)('hfv4-viewnav-button-export')),
            onClick: this._onExportClick
          },
          'Export'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (!isDetailView(this.props.routes)) {
        return _react2.default.createElement(_ViewNav2.default, this.props);
      }

      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames3.default)(_style2.default.DetailViewNav, _defineProperty({}, _style2.default.__withExportLanguage, _exportFlags.SHOW_EXPORT_LANGUAGE))
        },
        _react2.default.createElement(
          'div',
          { className: _style2.default.DetailViewNav_viewNav },
          _react2.default.createElement(_ViewNav2.default, this.props)
        ),
        this._renderExportLanguageCluster()
      );
    }
  }]);

  return ProgressReportHFv4ViewNav;
}(_react.Component);

ProgressReportHFv4ViewNav.propTypes = {
  routes: _propTypes2.default.array,
  params: _propTypes2.default.object,
  state: _propTypes2.default.object,
  push: _propTypes2.default.func,
  buildRoute: _propTypes2.default.func
};

exports.default = ProgressReportHFv4ViewNav;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SHOW_EXPORT = exports.SHOW_EXPORT = true;
var SHOW_EXPORT_LANGUAGE = exports.SHOW_EXPORT_LANGUAGE = false;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1981);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouter = __webpack_require__(16);

var _reactRouterRedux = __webpack_require__(15);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _rcTooltip = __webpack_require__(151);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _ProgressReportGenerationFailedDialog = __webpack_require__(1983);

var _ProgressReportGenerationFailedDialog2 = _interopRequireDefault(_ProgressReportGenerationFailedDialog);

var _generateErrors = __webpack_require__(825);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _IndividualDevelopmentPlanStatus = __webpack_require__(68);

var _IndividualDevelopmentPlanStatus2 = _interopRequireDefault(_IndividualDevelopmentPlanStatus);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _ExportAllHandler = __webpack_require__(1986);

var _ExportAllHandler2 = _interopRequireDefault(_ExportAllHandler);

var _ = __webpack_require__(13);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _skillScoreHFv = __webpack_require__(111);

var skillScoreHFv4 = _interopRequireWildcard(_skillScoreHFv);

var _GroupMembers = __webpack_require__(14);

var _ProgressTestsPlan = __webpack_require__(64);

var _ProgressTests = __webpack_require__(40);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _routes = __webpack_require__(826);

var _actions = __webpack_require__(1989);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _hfv4ScoreBands = __webpack_require__(110);

var _assessmentScores = __webpack_require__(335);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getScoreColorStyle(scoreStr) {
  if (!scoreStr || typeof scoreStr !== "string") return undefined;
  var match = scoreStr.match(/^(\d+)%$/);
  if (!match) return undefined;
  var band = (0, _hfv4ScoreBands.getHfv4BandForScore)(parseInt(match[1], 10));
  return band && band.color ? { color: band.color } : undefined;
}

var COLUMN_PERIOD = "period";
var COLUMN_STATUS = "status";
var COLUMN_ID = "id";

var BASE_SKILL_COLUMNS = ["Vocabulary", "Grammar", "Phonics", "Reading", "Listening", "Writing"];
var SPLIT_SPEAKING_COLUMNS = ["Speaking 1", "Speaking 2"];
var MERGED_SPEAKING_COLUMNS = [skillScoreHFv4.MERGED_SPEAKING_NAME];

function getSkillColumns(hasMergedSpeaking) {
  return BASE_SKILL_COLUMNS.concat(hasMergedSpeaking ? MERGED_SPEAKING_COLUMNS : SPLIT_SPEAKING_COLUMNS);
}

var GROUP_A_CODES = ["v4Bk0", "v4Bk1a", "v4Bk2a", "v4Bk3a", "v4Bk4a"];
var GROUP_B_CODES = ["v4Bk1b", "v4Bk2b", "v4Bk3b", "v4Bk4b"];

function getUnitRange(courseTypeLevelCode, reportName) {
  var isReport2 = reportName && /2/.test(reportName);
  if (GROUP_B_CODES.includes(courseTypeLevelCode)) {
    return isReport2 ? "7-12" : "7-10";
  }
  if (GROUP_A_CODES.includes(courseTypeLevelCode)) {
    return isReport2 ? "1-6" : "1-4";
  }
  return isReport2 ? "1-6" : "1-4";
}

var IndividualDevelopmentPlanListView = function (_UnsavedChangesTracki) {
  _inherits(IndividualDevelopmentPlanListView, _UnsavedChangesTracki);

  function IndividualDevelopmentPlanListView(props) {
    _classCallCheck(this, IndividualDevelopmentPlanListView);

    var _this = _possibleConstructorReturn(this, (IndividualDevelopmentPlanListView.__proto__ || Object.getPrototypeOf(IndividualDevelopmentPlanListView)).call(this, props));

    _this.state = Object.assign({}, _this.state, {
      showNoProgressTestResultsDialog: false
    });
    return _this;
  }

  _createClass(IndividualDevelopmentPlanListView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._fetchAssessmentDataIfNeeded(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this._fetchAssessmentDataIfNeeded(nextProps);
    }
  }, {
    key: "_fetchAssessmentDataIfNeeded",
    value: function _fetchAssessmentDataIfNeeded(props) {
      if (!props.isReport2) return;

      var groupId = props.params.groupId;

      props.fetchProgressTestPlanIfNeeded(groupId);

      if (props.assessmentPlan && _omniCommonUi.ApiResponseHelper.shouldFetch(props.assessmentProgressTest)) {
        props.fetchProgressTest(groupId, props.assessmentPlan);
      }
    }
  }, {
    key: "routerWillLeave",
    value: function routerWillLeave(nextLocation) {
      var _this2 = this;

      if (nextLocation && nextLocation.pathname.endsWith(_routes.Modes.GENERATE_ALL)) {
        var _props = this.props,
            groupIdpId = _props.groupIdpId,
            generateIndividualDevelopmentList = _props.generateIndividualDevelopmentList;

        if (groupIdpId) {
          generateIndividualDevelopmentList(groupIdpId).then(function (error) {
            if ((0, _generateErrors.isNoProgressTestResultsWithinIdpPeriodError)(error)) {
              _this2.setState({ showNoProgressTestResultsDialog: true });
            }
          });
        }
        return false;
      }
    }
  }, {
    key: "_renderNoProgressTestResultsDialog",
    value: function _renderNoProgressTestResultsDialog() {
      var _this3 = this;

      if (!this.state.showNoProgressTestResultsDialog) {
        return null;
      }

      return _react2.default.createElement(_ProgressReportGenerationFailedDialog2.default, {
        isOpen: true,
        onConfirmClick: function onConfirmClick() {
          _this3.setState({ showNoProgressTestResultsDialog: false });
        }
      });
    }
  }, {
    key: "_gaLinkClicked",
    value: function _gaLinkClicked() {
      _reactGa2.default.event({
        category: "Individual Development Plan",
        action: "Clicked link to Individual Development Plan detail"
      });
    }
  }, {
    key: "_getSkillColumns",
    value: function _getSkillColumns() {
      return getSkillColumns(this.props.hasMergedSpeaking);
    }
  }, {
    key: "_getStatus",
    value: function _getStatus(studentIdp) {
      if (studentIdp.shouldShowSuggestions && _IndividualDevelopmentPlanStatus.IdpStatus.INCOMPLETE === studentIdp.status.toLowerCase() && this._getSkillColumns().every(function (skill) {
        return !studentIdp[skill];
      })) {
        return "NA";
      }

      return studentIdp.status;
    }
  }, {
    key: "_renderSkillCell",
    value: function _renderSkillCell(suggestScore, assessmentScore) {
      var hasSuggestScore = suggestScore && suggestScore !== "–";
      var _props2 = this.props,
          isReport2 = _props2.isReport2,
          assessmentScoreMap = _props2.assessmentScoreMap;

      var showAssessment = isReport2 && assessmentScoreMap;

      if (!hasSuggestScore && !assessmentScore) return "-";

      var unitRange = getUnitRange(this.props.courseTypeLevelCode, this.props.reportName);

      if (showAssessment) {
        var triggerEl = null;
        var handlePopupAlign = function handlePopupAlign(popupDomNode) {
          var arrowEl = popupDomNode.querySelector('.rc-tooltip-arrow');
          if (!arrowEl || !triggerEl) return;
          var popupRect = popupDomNode.getBoundingClientRect();
          var triggerRect = triggerEl.getBoundingClientRect();
          var triggerCenterX = triggerRect.left + triggerRect.width / 2;
          var arrowLeft = triggerCenterX - popupRect.left;

          var minArrow = popupRect.width * 0.15;
          var maxArrow = popupRect.width * 0.85;
          if (arrowLeft > maxArrow) {
            var shift = arrowLeft - maxArrow;
            popupDomNode.style.left = (parseFloat(popupDomNode.style.left) || 0) + shift + "px";
            arrowLeft = maxArrow;
          } else if (arrowLeft < minArrow) {
            var _shift = minArrow - arrowLeft;
            popupDomNode.style.left = (parseFloat(popupDomNode.style.left) || 0) - _shift + "px";
            arrowLeft = minArrow;
          }
          arrowEl.style.left = arrowLeft + "px";
        };
        return _react2.default.createElement(
          _rcTooltip2.default,
          {
            placement: "bottom",
            trigger: ["hover"],
            destroyPopupOnHide: true,
            onPopupAlign: handlePopupAlign,
            overlay: _react2.default.createElement(
              "div",
              null,
              "Average Score of Unit ",
              unitRange,
              ": ",
              _react2.default.createElement(
                "b",
                null,
                suggestScore || '-'
              ),
              " | Assessment Score: ",
              _react2.default.createElement(
                "b",
                null,
                assessmentScore || '-'
              )
            ),
            overlayClassName: (0, _classnames2.default)(_style2.default.scoreTooltipBase, _style2.default.splitScore_tooltip)
          },
          _react2.default.createElement(
            "div",
            { ref: function ref(el) {
                triggerEl = el;
              } },
            _react2.default.createElement(
              "span",
              { className: _style2.default.splitScore },
              _react2.default.createElement(
                "span",
                { style: getScoreColorStyle(suggestScore) },
                hasSuggestScore ? suggestScore : '-'
              ),
              _react2.default.createElement(
                "span",
                { className: _style2.default.splitScore_divider },
                "|"
              ),
              _react2.default.createElement(
                "span",
                { className: _style2.default.splitScore_assessment, style: getScoreColorStyle(assessmentScore) },
                assessmentScore || '-'
              )
            )
          )
        );
      }

      if (!hasSuggestScore) return "-";

      return _react2.default.createElement(
        _rcTooltip2.default,
        {
          placement: "bottom",
          trigger: ["hover"],
          destroyPopupOnHide: true,
          overlay: _react2.default.createElement(
            "div",
            null,
            "Average Score of Unit ",
            unitRange,
            ": ",
            _react2.default.createElement(
              "b",
              null,
              suggestScore
            )
          ),
          overlayClassName: _style2.default.scoreTooltipBase
        },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "span",
            { style: getScoreColorStyle(suggestScore) },
            suggestScore
          )
        )
      );
    }
  }, {
    key: "_renderCell",
    value: function _renderCell(member, column) {
      var _this4 = this;

      var idpList = this.props.individualDevelopmentPlanList;
      if (!idpList || !idpList.size) return "-";

      var studentIdp = idpList.find(function (idp) {
        return idp.studentId === member.studentGeneralInfo.id;
      });

      if (!studentIdp) return column !== COLUMN_ID && "-";
      switch (column) {
        case COLUMN_STATUS:
          return _react2.default.createElement(_IndividualDevelopmentPlanStatus2.default, {
            status: this._getStatus(studentIdp)
          });
        case COLUMN_ID:
          return _react2.default.createElement(
            _reactRouter.Link,
            {
              className: (0, _classnames2.default)(_style2.default.IndividualDevelopmentPlanListViewLink, (0, _omniCommonUi.testClass)("report-link-cell")),
              to: this.props.buildRoute("./student/" + studentIdp.studentId),
              draggable: false,
              onClick: function onClick() {
                return _this4._gaLinkClicked();
              }
            },
            "REPORT",
            " ",
            _react2.default.createElement(_omniCommonUi.Icon, {
              id: "arrow-right",
              className: _style2.default.IndividualDevelopmentPlanListViewLink_icon
            })
          );
        default:
          if (this._getSkillColumns().includes(column)) {
            var assessmentScore = this.props.assessmentScoreMap && this.props.assessmentScoreMap["" + member.studentGeneralInfo.id] && this.props.assessmentScoreMap["" + member.studentGeneralInfo.id][column];
            return this._renderSkillCell(studentIdp[column], assessmentScore);
          }
          return studentIdp[column] || "-";
      }
    }
  }, {
    key: "_renderIdpList",
    value: function _renderIdpList() {
      var _this5 = this;

      return _react2.default.createElement(
        _CourseViewTable2.default,
        { students: this.props.members, onlyRowDivider: true },
        _react2.default.createElement(
          _CourseViewTable2.default.Header,
          null,
          _react2.default.createElement(
            _CourseViewTable2.default.Row,
            null,
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: COLUMN_PERIOD, small: true },
              "Period covered"
            ),
            this._getSkillColumns().map(function (skill) {
              return _react2.default.createElement(
                _CourseViewTable2.default.Cell,
                { key: skill, columnId: skill, small: true },
                skill
              );
            }),
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: COLUMN_STATUS, small: true },
              "Status"
            ),
            this.props.individualDevelopmentPlanList && this.props.individualDevelopmentPlanList.size > 0 && _react2.default.createElement(_CourseViewTable2.default.Cell, { columnId: COLUMN_ID, small: true })
          )
        ),
        _react2.default.createElement(
          _CourseViewTable2.default.Body,
          null,
          function (member, column) {
            return _this5._renderCell(member, column);
          }
        )
      );
    }
  }, {
    key: "_renderExportDialog",
    value: function _renderExportDialog() {
      var _props3 = this.props,
          mode = _props3.mode,
          buildRoute = _props3.buildRoute,
          pushRoute = _props3.pushRoute,
          languageCode = _props3.languageCode,
          individualDevelopmentPlanList = _props3.individualDevelopmentPlanList,
          groupIdpId = _props3.groupIdpId,
          groupId = _props3.groupId,
          members = _props3.members,
          reportName = _props3.reportName;

      var isInExportAllRoute = mode === _routes.Modes.EXPORT_ALL;
      var memberStudentIds = members.map(function (member) {
        return member.studentGeneralInfo.id;
      });
      var exportableIDPList = individualDevelopmentPlanList && individualDevelopmentPlanList.filter(function (idp) {
        return memberStudentIds.includes(idp.studentId);
      });
      return individualDevelopmentPlanList && individualDevelopmentPlanList.size > 0 && isInExportAllRoute && _react2.default.createElement(_ExportAllHandler2.default, {
        individualDevelopmentPlanList: exportableIDPList,
        groupIdpId: groupIdpId,
        languageCode: languageCode,
        pushRoute: pushRoute,
        buildRoute: buildRoute,
        groupId: groupId,
        reportName: reportName
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: _style2.default.IndividualDevelopmentPlanListView_content },
          this._renderIdpList(),
          this._renderExportDialog()
        ),
        this._renderNoProgressTestResultsDialog()
      );
    }
  }]);

  return IndividualDevelopmentPlanListView;
}(_UnsavedChangesTrackingPageComponent2.default);

IndividualDevelopmentPlanListView.propTypes = {
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  members: _propTypes2.default.object.isRequired,
  groupIdpId: _propTypes2.default.string.isRequired,
  individualDevelopmentPlanList: _propTypes2.default.object.isRequired,
  mode: _propTypes2.default.string.isRequired,
  reportName: _propTypes2.default.string.isRequired,
  courseTypeLevelCode: _propTypes2.default.string,
  isReport2: _propTypes2.default.bool,
  hasMergedSpeaking: _propTypes2.default.bool,
  assessmentScoreMap: _propTypes2.default.object,
  assessmentPlan: _propTypes2.default.object,
  assessmentProgressTest: _propTypes2.default.object,
  fetchProgressTestPlanIfNeeded: _propTypes2.default.func.isRequired,
  fetchProgressTest: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      groupIdpId = _ownProps$params.groupIdpId,
      mode = _ownProps$params.mode;

  var _groupActions$getCent = _.actions.getCentre(state, groupId),
      timeZone = _groupActions$getCent.timeZone;

  var group = state.get("rootReducer").get("groups").get(groupId).data;
  var languageCode = group.get("languageCode");

  var groupIdpList = state.get("rootReducer").get("individualDevelopmentPlanList");
  var originIndividualDevelopmentPlanList = _IndividualDevelopmentPlans.accessors.getIdpList(groupIdpList, groupIdpId);

  var hasMergedSpeaking = _IndividualDevelopmentPlans.accessors.isHfv4ProgressReportOneOrTwo(state, groupId, groupIdpId);
  var displayList = hasMergedSpeaking && originIndividualDevelopmentPlanList ? originIndividualDevelopmentPlanList.map(function (idpRow) {
    return idpRow.set("skillResults", skillScoreHFv4.mergeSpeakingSkillResults(idpRow.skillResults));
  }) : originIndividualDevelopmentPlanList;
  var individualDevelopmentPlanList = _IndividualDevelopmentPlans.accessors.formatToRenderUIBySkillNameHFv4(displayList, timeZone);
  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);

  var reportName = _IndividualDevelopmentPlans.accessors.getReportName(state, groupIdpId);
  var courseTypeLevelCode = group.get("courseTypeLevelCode");

  var isReport2 = !!(reportName && /2/.test(reportName));
  var assessmentScoreMap = null;
  var assessmentPlan = null;
  var assessmentProgressTest = null;

  if (isReport2) {
    assessmentPlan = (0, _assessmentScores.getAssessmentPlanFromState)(state, groupId);
    assessmentProgressTest = (0, _assessmentScores.getAssessmentProgressTestFromState)(state, assessmentPlan);

    if (_omniCommonUi.ApiResponseHelper.hasSucceeded(assessmentProgressTest)) {
      assessmentScoreMap = (0, _assessmentScores.buildAssessmentScoreMap)(originIndividualDevelopmentPlanList, assessmentProgressTest.data);
      // Assessment scores are keyed by skill name, so they need the same single
      // Speaking label the unit-quiz columns use.
      if (assessmentScoreMap && hasMergedSpeaking) {
        assessmentScoreMap = Object.keys(assessmentScoreMap).reduce(function (normalized, studentId) {
          return Object.assign(normalized, _defineProperty({}, studentId, (0, _assessmentScores.normalizeAssessmentSkillLabels)(assessmentScoreMap[studentId])));
        }, {});
      }
    }
  }

  return {
    reportName: reportName,
    mode: mode,
    state: state,
    members: members,
    individualDevelopmentPlanList: individualDevelopmentPlanList,
    groupId: groupId,
    groupIdpId: groupIdpId,
    languageCode: languageCode,
    courseTypeLevelCode: courseTypeLevelCode,
    isReport2: isReport2,
    assessmentScoreMap: assessmentScoreMap,
    assessmentPlan: assessmentPlan,
    assessmentProgressTest: assessmentProgressTest,
    hasMergedSpeaking: hasMergedSpeaking
  };
}

function mapDispatchToProps(dispatch) {
  var idpActions = (0, _redux.bindActionCreators)(_IndividualDevelopmentPlans.actions, dispatch);

  return Object.assign({}, { pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, idpActions, {
    generateIndividualDevelopmentList: function generateIndividualDevelopmentList(groupIdpId) {
      return dispatch((0, _actions.generateHfv4IndividualDevelopmentList)(groupIdpId));
    }
  }, (0, _redux.bindActionCreators)(_ProgressTestsPlan.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTests.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(IndividualDevelopmentPlanListView);

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNoProgressTestResultsWithinIdpPeriodError = isNoProgressTestResultsWithinIdpPeriodError;
var NO_PROGRESS_TEST_RESULTS_WITHIN_IDP_PERIOD_MESSAGE = exports.NO_PROGRESS_TEST_RESULTS_WITHIN_IDP_PERIOD_MESSAGE = 'No progress test results were found within the IDP period. Please verify whether the IDP period is correct.';

function isNoProgressTestResultsWithinIdpPeriodError(error) {
  if (!error || !error.response) {
    return false;
  }

  var response = error.response;

  var status = response.status || response.code;
  var message = response.message || '';

  return Number(status) === 500 && message === NO_PROGRESS_TEST_RESULTS_WITHIN_IDP_PERIOD_MESSAGE;
}

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modes = undefined;

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _component = __webpack_require__(824);

var _component2 = _interopRequireDefault(_component);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _IndividualDevelopmentPlanStatus = __webpack_require__(68);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modes = exports.Modes = {
  GENERATE_ALL: 'generate-all',
  EXPORT_ALL: 'export-all'
};

var SHOW_EXPORT_ALL = false;

var isIdpListExist = function isIdpListExist(getState, params) {
  var groupIdpList = _IndividualDevelopmentPlans.accessors.getGroupIdpList(getState(), params.groupId);
  var idpList = _IndividualDevelopmentPlans.accessors.getIdpList(groupIdpList, params.groupIdpId);
  return !!idpList && idpList.size > 0;
};

var isExportDisable = function isExportDisable(getState, params) {
  var groupIdpList = _IndividualDevelopmentPlans.accessors.getGroupIdpList(getState(), params.groupId);
  var idpList = _IndividualDevelopmentPlans.accessors.getIdpList(groupIdpList, params.groupIdpId);
  var completeList = idpList.filter(function (idp) {
    return idp.status.toLowerCase() === _IndividualDevelopmentPlanStatus.IdpStatus.COMPLETED.toLowerCase();
  });
  return !completeList || completeList && completeList.size < 1;
};

var actionButtons = function actionButtons(getState) {
  return {
    Generate: {
      route: './' + Modes.GENERATE_ALL,
      visibleWhen: function visibleWhen(_ref) {
        var params = _ref.params;
        return !_.actions.isDisabledReportActions(getState(), params.groupId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.Manage) && params.groupIdpId;
      },
      isPrimary: true
    },
    'Export All': {
      route: './' + Modes.EXPORT_ALL,
      visibleWhen: function visibleWhen(_ref2) {
        var params = _ref2.params;
        return SHOW_EXPORT_ALL && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.View) && isIdpListExist(getState, params);
      },
      disableWhen: function disableWhen(_ref3) {
        var params = _ref3.params;
        return isExportDisable(getState, params);
      },
      isPrimary: true
    }
  };
};

exports.default = function (_ref4) {
  var getState = _ref4.getState;
  return {
    path: ':groupIdpId(/:mode)',
    component: _component2.default,
    actionButtons: {
      default: actionButtons(getState),
      'export-all': actionButtons(getState),
      'generate-all': actionButtons(getState)
    }
  };
};

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BottomButtons = exports.routes = undefined;

var _component = __webpack_require__(828);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(170);

var _routes3 = _interopRequireDefault(_routes2);

var _BottomButtons2 = __webpack_require__(830);

var _BottomButtons3 = _interopRequireDefault(_BottomButtons2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
var BottomButtons = exports.BottomButtons = _BottomButtons3.default;

exports.default = _component2.default;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _ = __webpack_require__(13);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _skillScoreHFv = __webpack_require__(111);

var skillScoreHFv4 = _interopRequireWildcard(_skillScoreHFv);

var _StudentInformation = __webpack_require__(1990);

var _StudentInformation2 = _interopRequireDefault(_StudentInformation);

var _FeedbackSuggestions = __webpack_require__(1995);

var _FeedbackSuggestions2 = _interopRequireDefault(_FeedbackSuggestions);

var _ReportCard = __webpack_require__(2017);

var _ReportCard2 = _interopRequireDefault(_ReportCard);

var _AssessmentResultsCard = __webpack_require__(2020);

var _AssessmentResultsCard2 = _interopRequireDefault(_AssessmentResultsCard);

var _assessmentScores = __webpack_require__(335);

var _ProgressTestsPlan = __webpack_require__(64);

var _ProgressTests = __webpack_require__(40);

var _ProgressTestOverview = __webpack_require__(832);

var _StudyPlan = __webpack_require__(2025);

var _StudyPlan2 = _interopRequireDefault(_StudyPlan);

var _OverallDevelopment = __webpack_require__(2028);

var _OverallDevelopment2 = _interopRequireDefault(_OverallDevelopment);

var _routes = __webpack_require__(170);

var _ExportDialog = __webpack_require__(2031);

var _ExportDialog2 = _interopRequireDefault(_ExportDialog);

var _SubmitConfirmDialog = __webpack_require__(2034);

var _SubmitConfirmDialog2 = _interopRequireDefault(_SubmitConfirmDialog);

var _SubmitSuccessDialog = __webpack_require__(2037);

var _SubmitSuccessDialog2 = _interopRequireDefault(_SubmitSuccessDialog);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _RejectNote = __webpack_require__(210);

var _RejectNote2 = _interopRequireDefault(_RejectNote);

var _IndividualDevelopmentPlanStatus = __webpack_require__(68);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _style = __webpack_require__(2040);

var _style2 = _interopRequireDefault(_style);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IndividualDevelopmentPlanDetailView = function (_UnsavedChangesTracki) {
  _inherits(IndividualDevelopmentPlanDetailView, _UnsavedChangesTracki);

  function IndividualDevelopmentPlanDetailView(props) {
    _classCallCheck(this, IndividualDevelopmentPlanDetailView);

    var _this = _possibleConstructorReturn(this, (IndividualDevelopmentPlanDetailView.__proto__ || Object.getPrototypeOf(IndividualDevelopmentPlanDetailView)).call(this, props));

    _this.state = {
      isExpandStudentInfo: true,
      isExpandReportCard: true,
      isExpandAssessmentResultsCard: true,
      showSubmitConfirmDialog: false,
      showSubmitSuccessDialog: false
    };

    _this._changeMode = _this._changeMode.bind(_this);
    return _this;
  }

  _createClass(IndividualDevelopmentPlanDetailView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._fetchIndividualDevelopmentPlanDetail();
      this._fetchAssessmentDataIfNeeded(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._fetchIndividualDevelopmentPlanDetail(nextProps);
      this._fetchAssessmentDataIfNeeded(nextProps);
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave(nextLocation) {
      if (nextLocation && nextLocation.pathname.endsWith('/' + _routes.Modes.SUBMIT)) {
        if (this.props.isHfv4Group) {
          this.setState({ showSubmitConfirmDialog: true });
          return false;
        }
        this._onSubmit();
        return false;
      }

      return _get(IndividualDevelopmentPlanDetailView.prototype.__proto__ || Object.getPrototypeOf(IndividualDevelopmentPlanDetailView.prototype), 'routerWillLeave', this).call(this, nextLocation);
    }
  }, {
    key: '_onSubmitConfirmed',
    value: function _onSubmitConfirmed() {
      this.setState({ showSubmitConfirmDialog: false });
      this._onSubmit();
    }
  }, {
    key: '_onSubmitCancelled',
    value: function _onSubmitCancelled() {
      this.setState({ showSubmitConfirmDialog: false });
    }
  }, {
    key: '_onSubmit',
    value: function _onSubmit() {
      var _this2 = this;

      var _props = this.props,
          idpId = _props.idpId,
          groupIdpId = _props.groupIdpId,
          isHfv4Group = _props.isHfv4Group;

      this.props.submitIndividualDevelopmentPlan(idpId, groupIdpId).then(function (success) {
        if (!success) return;
        if (isHfv4Group) {
          _this2.setState({ showSubmitSuccessDialog: true });
        } else {
          _this2._changeMode();
        }
      });
    }
  }, {
    key: '_onSubmitSuccessClosed',
    value: function _onSubmitSuccessClosed() {
      this.setState({ showSubmitSuccessDialog: false });
      this._changeMode();
    }
  }, {
    key: '_isChangesPresent',
    value: function _isChangesPresent() {
      if (IndividualDevelopmentPlanDetailView.isInEditCommentsMode(this.props)) {
        return this.feedbackSuggestionsComponent.wasCommentsEditMade();
      }
      if (IndividualDevelopmentPlanDetailView.isInEditStudyPlanMode(this.props)) {
        return this.studyPlanComponent.wasEditMade();
      }
      if (IndividualDevelopmentPlanDetailView.isInEditOverallDevelopmentMode(this.props)) {
        return this.overallDevelopmentComponent.wasEditMade();
      }
      return false;
    }
  }, {
    key: '_fetchIndividualDevelopmentPlanDetail',
    value: function _fetchIndividualDevelopmentPlanDetail() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      if (!props.idpId) return;
      props.fetchIdpLearningResultIfNeeded(props.idpId);
      props.fetchIdpFeedbackSuggestionsIfNeeded(props.idpId);
      props.fetchIdpParticipationIfNeeded();
    }
  }, {
    key: '_fetchAssessmentDataIfNeeded',
    value: function _fetchAssessmentDataIfNeeded(props) {
      if (!props.isReport2 || !props.isHfv4Group) return;

      var groupId = props.groupId;

      props.fetchProgressTestPlanIfNeeded(groupId);
      props.fetchProgressTestOverviewIfNeeded(groupId);

      if (props.assessmentPlan && _omniCommonUi.ApiResponseHelper.shouldFetch(props.assessmentProgressTest)) {
        props.fetchProgressTest(groupId, props.assessmentPlan);
      }
    }
  }, {
    key: '_expandStudentInfo',
    value: function _expandStudentInfo() {
      this.setState({ isExpandStudentInfo: !this.state.isExpandStudentInfo });
    }
  }, {
    key: '_expandReportCard',
    value: function _expandReportCard() {
      this.setState({ isExpandReportCard: !this.state.isExpandReportCard });
    }
  }, {
    key: '_expandAssessmentResultsCard',
    value: function _expandAssessmentResultsCard() {
      this.setState({
        isExpandAssessmentResultsCard: !this.state.isExpandAssessmentResultsCard
      });
    }
  }, {
    key: '_renderStudentInformation',
    value: function _renderStudentInformation() {
      var _this3 = this;

      if (!this.props.studentInfo || !this.props.timeZone) return null;
      return _react2.default.createElement(_StudentInformation2.default, { studentInfo: this.props.studentInfo,
        isExpanded: this.state.isExpandStudentInfo,
        onExpandButtonClick: function onExpandButtonClick() {
          return _this3._expandStudentInfo();
        },
        idpId: this.props.idpId,
        groupIdpId: this.props.groupIdpId,
        groupStartDate: this.props.groupStartDate,
        groupEndDate: this.props.groupEndDate,
        periodFromMinDate: this.props.periodFromMinDate,
        timeZone: this.props.timeZone,
        isInEditMode: IndividualDevelopmentPlanDetailView.isInEditMode(this.props),
        canEdit: this.props.canEdit });
    }
  }, {
    key: '_renderReportCard',
    value: function _renderReportCard() {
      var _this4 = this;

      if (!this.props.reportCardInfo) return null;
      var shouldShowAttendance = this.props.isFromOdin;
      return _react2.default.createElement(_ReportCard2.default, { reportCardInfo: this.props.reportCardInfo,
        isExpanded: this.state.isExpandReportCard,
        onExpandButtonClick: function onExpandButtonClick() {
          return _this4._expandReportCard();
        },
        shouldShowAttendance: shouldShowAttendance,
        courseTypeLevelCode: this.props.courseTypeLevelCode,
        reportName: this.props.reportName });
    }
  }, {
    key: '_renderAssessmentResultsCard',
    value: function _renderAssessmentResultsCard() {
      var _this5 = this;

      var _props2 = this.props,
          isReport2 = _props2.isReport2,
          assessmentResultsInfo = _props2.assessmentResultsInfo;

      if (!isReport2 || !assessmentResultsInfo) return null;

      return _react2.default.createElement(_AssessmentResultsCard2.default, { assessmentResultsInfo: assessmentResultsInfo,
        isExpanded: this.state.isExpandAssessmentResultsCard,
        onExpandButtonClick: function onExpandButtonClick() {
          return _this5._expandAssessmentResultsCard();
        } });
    }
  }, {
    key: '_renderSuggestions',
    value: function _renderSuggestions() {
      var _this6 = this;

      if (!this.props.suggestionsInfo) return null;
      return _react2.default.createElement(_FeedbackSuggestions2.default, { onComponentMounted: function onComponentMounted(_cmpt) {
          _this6.feedbackSuggestionsComponent = _cmpt;
        },
        suggestionsInfo: this.props.suggestionsInfo,
        participationInfo: this.props.idpParticipation,
        isSSV3Group: this.props.isSSV3Group,
        isSkillSuggestionManualOnly: this.props.isSkillSuggestionManualOnly,
        isInEditMode: IndividualDevelopmentPlanDetailView.isInEditCommentsMode(this.props),
        changeMode: this._changeMode,
        idpId: this.props.idpId,
        groupIdpId: this.props.groupIdpId,
        canEdit: this.props.canEdit,
        shouldShowSuggestions: this.props.shouldShowSuggestions,
        skillRecommendations: this.props.skillRecommendations });
    }
  }, {
    key: '_renderOverallDevelopment',
    value: function _renderOverallDevelopment() {
      var _this7 = this;

      if (!this.props.isSSV3Group || !this.props.studentInfo) return null;
      return _react2.default.createElement(_OverallDevelopment2.default, { onComponentMounted: function onComponentMounted(_cmpt) {
          _this7.overallDevelopmentComponent = _cmpt;
        },
        studentInfo: this.props.studentInfo,
        idpId: this.props.idpId,
        groupIdpId: this.props.groupIdpId,
        canEdit: this.props.canEdit,
        changeMode: this._changeMode,
        isInEditMode: IndividualDevelopmentPlanDetailView.isInEditOverallDevelopmentMode(this.props) });
    }
  }, {
    key: '_renderStudyPlan',
    value: function _renderStudyPlan() {
      var _this8 = this;

      if (!this.props.studentInfo) return null;
      return _react2.default.createElement(_StudyPlan2.default, { onComponentMounted: function onComponentMounted(_cmpt) {
          _this8.studyPlanComponent = _cmpt;
        },
        groupId: this.props.groupId,
        studentInfo: this.props.studentInfo,
        idpId: this.props.idpId,
        groupIdpId: this.props.groupIdpId,
        canEdit: this.props.canEdit,
        changeMode: this._changeMode,
        isInEditMode: IndividualDevelopmentPlanDetailView.isInEditStudyPlanMode(this.props) });
    }
  }, {
    key: '_changeMode',
    value: function _changeMode() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var buildRoute = this.props.buildRoute;

      this._forcePushRoute(buildRoute({ mode: mode }));
    }
  }, {
    key: '_onDiscardClick',
    value: function _onDiscardClick() {
      this.feedbackSuggestionsComponent.setWasCommentsEditMade(false);
      this.studyPlanComponent.setWasEditMade(false);
      this.overallDevelopmentComponent.setWasEditMade(false);
    }
  }, {
    key: '_shouldRenderStayLeaveWarning',
    value: function _shouldRenderStayLeaveWarning() {
      if (IndividualDevelopmentPlanDetailView.isInEditCommentsMode(this.props)) {
        return false;
      }
      if (IndividualDevelopmentPlanDetailView.isInEditStudyPlanMode(this.props)) {
        return this.studyPlanComponent && this.studyPlanComponent.shouldDisableSaveButton();
      }
      if (IndividualDevelopmentPlanDetailView.isInEditOverallDevelopmentMode(this.props)) {
        return this.overallDevelopmentComponent && this.overallDevelopmentComponent.shouldDisableSaveButton();
      }
      return false;
    }
  }, {
    key: '_onSaveClickedOnWarningDialog',
    value: function _onSaveClickedOnWarningDialog() {
      if (IndividualDevelopmentPlanDetailView.isInEditCommentsMode(this.props)) {
        this.feedbackSuggestionsComponent.onSaveClick();
      }
      if (IndividualDevelopmentPlanDetailView.isInEditStudyPlanMode(this.props)) {
        this.studyPlanComponent.onSaveClick();
      }
      if (IndividualDevelopmentPlanDetailView.isInEditOverallDevelopmentMode(this.props)) {
        this.overallDevelopmentComponent.onSaveClick();
      }
    }
  }, {
    key: '_renderUnsavedChangesWarningDialog',
    value: function _renderUnsavedChangesWarningDialog() {
      var _this9 = this;

      if (this._shouldRenderStayLeaveWarning()) {
        return _react2.default.createElement(_omniCommonUi.ConfirmDialog, { isOpen: !!this._isNavigationWithChangesRequested(),
          primaryButtonContent: 'Stay',
          secondaryButtonContent: 'Leave',
          content: 'Are you sure you want to leave this page and lose unsaved changes?',
          onPrimaryClick: function onPrimaryClick() {
            _this9._clearRequestedLocation();
          },
          onSecondaryClick: function onSecondaryClick() {
            _this9._onDiscardClick();
            _this9._forcePushRequestedLocation();
          },
          onRequestClose: function onRequestClose() {
            _this9._clearRequestedLocation();
          } });
      }
      return _react2.default.createElement(_UnsavedChangesWarning2.default, { isOpen: !!this._isNavigationWithChangesRequested(),
        isSaving: this.props.isAnyApiCallSaving,
        onSaveClicked: function onSaveClicked() {
          _this9._onSaveClickedOnWarningDialog();
        },
        onDiscardClicked: function onDiscardClicked() {
          _this9._onDiscardClick();
          _this9._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this9._clearRequestedLocation();
        },
        onSaved: function onSaved() {
          _this9._forcePushRequestedLocation();
        } });
    }
  }, {
    key: '_renderExportDialog',
    value: function _renderExportDialog() {
      var _props3 = this.props,
          mode = _props3.mode,
          buildRoute = _props3.buildRoute,
          pushRoute = _props3.pushRoute,
          languageCode = _props3.languageCode,
          idpId = _props3.idpId,
          reportName = _props3.reportName,
          idpStatus = _props3.idpStatus,
          missingInformation = _props3.missingInformation,
          fetchIdpCheck = _props3.fetchIdpCheck;
      var studentId = this.props.params.studentId;

      var isInExportRoute = mode === _routes.Modes.EXPORT;
      return isInExportRoute && _react2.default.createElement(_ExportDialog2.default, { idpId: idpId,
        studentId: studentId,
        languageCode: languageCode,
        pushRoute: pushRoute,
        buildRoute: buildRoute,
        reportName: reportName,
        idpStatus: idpStatus,
        missingInformation: missingInformation,
        fetchIdpCheck: fetchIdpCheck });
    }
  }, {
    key: '_renderRjectNote',
    value: function _renderRjectNote() {
      var _props4 = this.props,
          _props4$idpStatus = _props4.idpStatus,
          idpStatus = _props4$idpStatus === undefined ? '' : _props4$idpStatus,
          dosRejectedComment = _props4.dosRejectedComment,
          timeZone = _props4.timeZone;

      return dosRejectedComment && idpStatus.toLowerCase() === _IndividualDevelopmentPlanStatus.IdpStatus.REJECTED.toLowerCase() && _react2.default.createElement(_RejectNote2.default, { note: dosRejectedComment.rejectedComment,
        rejectTime: dosRejectedComment.rejectedDate,
        timeZone: timeZone,
        teacherId: dosRejectedComment.rejectedBy });
    }
  }, {
    key: '_renderSubmitConfirmDialog',
    value: function _renderSubmitConfirmDialog() {
      var _this10 = this;

      if (!this.props.isHfv4Group) return null;

      return _react2.default.createElement(_SubmitConfirmDialog2.default, { isOpen: this.state.showSubmitConfirmDialog,
        groupName: this.props.groupName,
        onConfirmClick: function onConfirmClick() {
          return _this10._onSubmitConfirmed();
        },
        onCancelClick: function onCancelClick() {
          return _this10._onSubmitCancelled();
        } });
    }
  }, {
    key: '_renderSubmitSuccessDialog',
    value: function _renderSubmitSuccessDialog() {
      var _this11 = this;

      if (!this.props.isHfv4Group) return null;

      return _react2.default.createElement(_SubmitSuccessDialog2.default, { isOpen: this.state.showSubmitSuccessDialog,
        groupName: this.props.groupName,
        onCloseClick: function onCloseClick() {
          return _this11._onSubmitSuccessClosed();
        } });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { outerMargin: true },
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          this._renderRjectNote(),
          this._renderStudentInformation(),
          this._renderReportCard(),
          this._renderAssessmentResultsCard(),
          this._renderSuggestions(),
          this._renderOverallDevelopment(),
          this._renderStudyPlan(),
          this._renderUnsavedChangesWarningDialog(),
          this._renderExportDialog(),
          this._renderSubmitConfirmDialog(),
          this._renderSubmitSuccessDialog()
        )
      );
    }
  }]);

  return IndividualDevelopmentPlanDetailView;
}(_UnsavedChangesTrackingPageComponent2.default);

IndividualDevelopmentPlanDetailView.isInEditCommentsMode = function (props) {
  return props.params && props.params.mode === _routes.Modes.EDIT_COMMENTS;
};

IndividualDevelopmentPlanDetailView.isInEditStudyPlanMode = function (props) {
  return props.params && props.params.mode === _routes.Modes.EDIT_STUDY_PLAN;
};

IndividualDevelopmentPlanDetailView.isInEditOverallDevelopmentMode = function (props) {
  return props.params && props.params.mode === _routes.Modes.EDIT_OVERALL_DEVELOPMENT;
};

IndividualDevelopmentPlanDetailView.isInEditMode = function (props) {
  return IndividualDevelopmentPlanDetailView.isInEditCommentsMode(props) || IndividualDevelopmentPlanDetailView.isInEditStudyPlanMode(props) || IndividualDevelopmentPlanDetailView.isInEditOverallDevelopmentMode(props);
};

IndividualDevelopmentPlanDetailView.propTypes = {
  fetchIdpLearningResultIfNeeded: _propTypes2.default.func.isRequired,
  fetchIdpFeedbackSuggestionsIfNeeded: _propTypes2.default.func.isRequired,
  fetchIdpParticipationIfNeeded: _propTypes2.default.func.isRequired,
  submitIndividualDevelopmentPlan: _propTypes2.default.func.isRequired,
  idpParticipation: _propTypes2.default.shape(),
  studentInfo: _propTypes2.default.shape(),
  reportCardInfo: _propTypes2.default.shape(),
  suggestionsInfo: _propTypes2.default.shape(),
  skillRecommendations: _propTypes2.default.shape(),
  dosRejectedComment: _propTypes2.default.shape(),
  idpId: _propTypes2.default.string,
  groupIdpId: _propTypes2.default.string,
  groupId: _propTypes2.default.string,
  isFromOdin: _propTypes2.default.bool,
  canEdit: _propTypes2.default.bool,
  isSSV3Group: _propTypes2.default.bool,
  isSkillSuggestionManualOnly: _propTypes2.default.bool,
  shouldShowSuggestions: _propTypes2.default.bool,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func,
  isAnyApiCallSaving: _propTypes2.default.bool,
  groupStartDate: _propTypes2.default.shape(),
  groupEndDate: _propTypes2.default.shape(),
  periodFromMinDate: _propTypes2.default.object,
  timeZone: _propTypes2.default.string,
  mode: _propTypes2.default.string,
  languageCode: _propTypes2.default.string,
  reportName: _propTypes2.default.string,
  courseTypeLevelCode: _propTypes2.default.string,
  isReport2: _propTypes2.default.bool,
  assessmentResultsInfo: _propTypes2.default.shape(),
  assessmentPlan: _propTypes2.default.object,
  assessmentProgressTest: _propTypes2.default.object,
  fetchProgressTestPlanIfNeeded: _propTypes2.default.func.isRequired,
  fetchProgressTestOverviewIfNeeded: _propTypes2.default.func.isRequired,
  fetchProgressTest: _propTypes2.default.func.isRequired,
  isHfv4Group: _propTypes2.default.bool,
  groupName: _propTypes2.default.string,
  missingInformation: _propTypes2.default.arrayOf(_propTypes2.default.string),
  fetchIdpCheck: _propTypes2.default.func.isRequired
};

function withHfv4SkillScores(reportCardInfo, skillResults, shouldMergeSpeaking) {
  if (!reportCardInfo || !skillResults) return reportCardInfo;
  var displayedResults = shouldMergeSpeaking ? skillScoreHFv4.mergeSpeakingSkillResults(skillResults) : skillResults;
  var quizAverageScore = skillScoreHFv4.calculateQuizAverageScore(displayedResults);
  return Object.assign({}, reportCardInfo, {
    skillResults: displayedResults.map(function (skillResult) {
      return skillResult.set('score', skillScoreHFv4.formatSkillScore(skillResult));
    }),
    totalScore: typeof quizAverageScore === 'number' ? quizAverageScore + '%' : '–'
  });
}

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      groupIdpId = _ownProps$params.groupIdpId,
      studentId = _ownProps$params.studentId,
      mode = _ownProps$params.mode;

  var _groupActions$getCent = _.actions.getCentre(state, groupId),
      timeZone = _groupActions$getCent.timeZone;

  var idpParticipation = state.get('rootReducer').get('idpParticipation');
  var groupIdpList = state.get('rootReducer').get('individualDevelopmentPlanList');
  var shouldShowSuggestions = _IndividualDevelopmentPlans.accessors.shouldShowSuggestions(groupIdpList, groupIdpId, studentId);
  var studentInfo = _IndividualDevelopmentPlans.accessors.getStudentInfo(state, ownProps);
  var idpId = _IndividualDevelopmentPlans.accessors.getIdpId(state, groupIdpId, studentId);
  var idpDetail = state.get('rootReducer').get('individualDevelopmentPlan').get(idpId);
  var learningResult = idpDetail && idpDetail.get('learningResult');
  var reportCardInfo = withHfv4SkillScores(_IndividualDevelopmentPlans.accessors.getReportCardInfo(state, ownProps), learningResult && learningResult.skillResults, _IndividualDevelopmentPlans.accessors.isHfv4ProgressReportOneOrTwo(state, groupId, groupIdpId));
  var idpStatus = _IndividualDevelopmentPlans.accessors.getIdpStatus(state, idpId);
  var dosRejectedComment = _IndividualDevelopmentPlans.accessors.getDosRejectedComment(state, ownProps);
  var suggestionsInfo = _IndividualDevelopmentPlans.accessors.getSuggestionsInfo(state, ownProps);
  var group = state.get('rootReducer').get('groups').get(groupId).data;
  var isFromOdin = group.isFromOdin;
  var languageCode = group.get('languageCode');
  var skillRecommendations = state.get('rootReducer').get('skillRecommendation').get(groupId);
  var _group$period = group.period,
      groupStartDate = _group$period.start,
      groupEndDate = _group$period.end;


  var canEdit = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.IndividualDevelopmentPlan.Manage) && !_.actions.isDisabledReportActions(state, groupId) && idpStatus && !IndividualDevelopmentPlanDetailView.isInEditMode(ownProps) && (idpStatus.toLowerCase() === _IndividualDevelopmentPlanStatus.IdpStatus.INCOMPLETE.toLowerCase() || idpStatus.toLowerCase() === _IndividualDevelopmentPlanStatus.IdpStatus.READY.toLowerCase() || idpStatus.toLowerCase() === _IndividualDevelopmentPlanStatus.IdpStatus.REJECTED.toLowerCase());
  var reportName = _IndividualDevelopmentPlans.accessors.getReportName(state, groupIdpId);
  var courseTypeLevelCode = group.get('courseTypeLevelCode');
  var isReport2 = !!(reportName && /2/.test(reportName));

  var assessmentResultsInfo = null;
  var assessmentPlan = null;
  var assessmentProgressTest = null;
  var periodFromMinDate = null;

  var isHfv4Group = _.actions.isHFV4CourseTypeGroup(state, groupId);

  if (isReport2 && isHfv4Group) {
    assessmentPlan = (0, _assessmentScores.getAssessmentPlanFromState)(state, groupId);
    assessmentProgressTest = (0, _assessmentScores.getAssessmentProgressTestFromState)(state, assessmentPlan);
    assessmentResultsInfo = (0, _assessmentScores.getAssessmentResultsCardInfo)(state, {
      groupId: groupId,
      groupIdpId: groupIdpId,
      studentId: studentId
    });

    var minStartTime = (0, _ProgressTestOverview.getPeriodFromMinStartTime)(state, groupId);
    periodFromMinDate = minStartTime ? _omniCommonUi.moment.tz(minStartTime, timeZone) : null;
  }

  return {
    reportName: reportName,
    courseTypeLevelCode: courseTypeLevelCode,
    isReport2: isReport2,
    isHfv4Group: isHfv4Group,
    groupName: group.name,
    assessmentResultsInfo: assessmentResultsInfo,
    assessmentPlan: assessmentPlan,
    assessmentProgressTest: assessmentProgressTest,
    mode: mode,
    languageCode: languageCode,
    idpParticipation: idpParticipation,
    studentInfo: studentInfo,
    reportCardInfo: reportCardInfo,
    suggestionsInfo: suggestionsInfo,
    idpId: idpId,
    groupIdpId: groupIdpId,
    groupId: groupId,
    isFromOdin: isFromOdin,
    canEdit: canEdit,
    shouldShowSuggestions: shouldShowSuggestions,
    skillRecommendations: skillRecommendations,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state),
    groupStartDate: groupStartDate,
    groupEndDate: groupEndDate,
    periodFromMinDate: periodFromMinDate,
    timeZone: timeZone,
    idpStatus: idpStatus,
    missingInformation: _IndividualDevelopmentPlans.accessors.getMissingInformation(state, idpId),
    dosRejectedComment: dosRejectedComment,
    isSSV3Group: !!_.actions.isSSV3Group(state, groupId),
    isSkillSuggestionManualOnly: !!_.actions.isFRV2CourseTypeGroup(state, groupId)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_IndividualDevelopmentPlans.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTestsPlan.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTestOverview.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTests.actions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(IndividualDevelopmentPlanDetailView));

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1996);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2010);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BottomButtons = function (_PureComponent) {
  _inherits(BottomButtons, _PureComponent);

  function BottomButtons() {
    _classCallCheck(this, BottomButtons);

    return _possibleConstructorReturn(this, (BottomButtons.__proto__ || Object.getPrototypeOf(BottomButtons)).apply(this, arguments));
  }

  _createClass(BottomButtons, [{
    key: '_renderButtons',
    value: function _renderButtons() {
      var _this2 = this;

      if (_is_js2.default.array(this.props.buttons)) {
        return this.props.buttons.map(function (button) {
          return _react2.default.createElement(
            _omniCommonUi.Button,
            { className: (0, _classnames2.default)(_style2.default.BottomButtons_button, (0, _omniCommonUi.testClass)(button.text)),
              type: button.primary && _omniCommonUi.Button.Type.primary,
              onClick: function onClick() {
                return button.onClick && button.onClick();
              },
              disabled: button.disabled,
              key: button.text },
            button.text
          );
        });
      }
      return [_react2.default.createElement(
        _omniCommonUi.Button,
        { className: (0, _classnames2.default)(_style2.default.BottomButtons_button, (0, _omniCommonUi.testClass)('button-' + this.props.primaryText)),
          type: _omniCommonUi.Button.Type.primary,
          onClick: function onClick() {
            return _this2.props.onPrimaryClick && _this2.props.onPrimaryClick();
          },
          disabled: this.props.isPrimaryDisabled,
          key: this.props.primaryText },
        this.props.primaryText
      ), _react2.default.createElement(
        _omniCommonUi.Button,
        { className: (0, _classnames2.default)(_style2.default.BottomButtons_button, (0, _omniCommonUi.testClass)('button-' + this.props.secondaryText)),
          type: _omniCommonUi.Button.Type.default,
          onClick: function onClick() {
            return _this2.props.onSecondaryClick && _this2.props.onSecondaryClick();
          },
          disabled: this.props.isSecondaryDisabled,
          key: this.props.secondaryText },
        this.props.secondaryText
      )];
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _omniCommonUi.Button.Container,
        { className: (0, _classnames2.default)(_style2.default.BottomButtons, this.props.className),
          align: 'right' },
        this._renderButtons()
      );
    }
  }]);

  return BottomButtons;
}(_react.PureComponent);

BottomButtons.propTypes = {
  buttons: _propTypes2.default.array,
  primaryText: _propTypes2.default.string,
  secondaryText: _propTypes2.default.string,
  onPrimaryClick: _propTypes2.default.func,
  onSecondaryClick: _propTypes2.default.func,
  isPrimaryDisabled: _propTypes2.default.bool,
  isSecondaryDisabled: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

exports.default = BottomButtons;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUnitRange = getUnitRange;
exports.getAverageScoreHeading = getAverageScoreHeading;
var GROUP_A_CODES = ['v4Bk0', 'v4Bk1a', 'v4Bk2a', 'v4Bk3a', 'v4Bk4a'];
var GROUP_B_CODES = ['v4Bk1b', 'v4Bk2b', 'v4Bk3b', 'v4Bk4b'];

function getUnitRange(courseTypeLevelCode, reportName) {
  var isReport2 = reportName && /2/.test(reportName);
  if (GROUP_B_CODES.includes(courseTypeLevelCode)) {
    return isReport2 ? '7-12' : '7-10';
  }
  if (GROUP_A_CODES.includes(courseTypeLevelCode)) {
    return isReport2 ? '1-6' : '1-4';
  }
  return isReport2 ? '1-6' : '1-4';
}

function getAverageScoreHeading(courseTypeLevelCode, reportName) {
  var unitRange = getUnitRange(courseTypeLevelCode, reportName);
  return 'Average Score of Unit ' + unitRange;
}

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = exports.getPeriodFromMinStartTime = undefined;

var _accessors = __webpack_require__(2023);

Object.defineProperty(exports, 'getPeriodFromMinStartTime', {
  enumerable: true,
  get: function get() {
    return _accessors.getPeriodFromMinStartTime;
  }
});

var _actions2 = __webpack_require__(833);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(2024);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_PROGRESS_TEST_OVERVIEW_FAILURE = exports.FETCH_PROGRESS_TEST_OVERVIEW_SUCCESS = exports.FETCH_PROGRESS_TEST_OVERVIEW_REQUEST = undefined;
exports.fetchProgressTestOverviewIfNeeded = fetchProgressTestOverviewIfNeeded;
exports.fetchProgressTestOverview = fetchProgressTestOverview;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_PROGRESS_TEST_OVERVIEW_REQUEST = exports.FETCH_PROGRESS_TEST_OVERVIEW_REQUEST = 'FETCH_PROGRESS_TEST_OVERVIEW_REQUEST';
var FETCH_PROGRESS_TEST_OVERVIEW_SUCCESS = exports.FETCH_PROGRESS_TEST_OVERVIEW_SUCCESS = 'FETCH_PROGRESS_TEST_OVERVIEW_SUCCESS';
var FETCH_PROGRESS_TEST_OVERVIEW_FAILURE = exports.FETCH_PROGRESS_TEST_OVERVIEW_FAILURE = 'FETCH_PROGRESS_TEST_OVERVIEW_FAILURE';

var buildProgressTestOverviewUrl = function buildProgressTestOverviewUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/progress-test-overview');
};

function fetchProgressTestOverviewIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildProgressTestOverviewUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchProgressTestOverview(groupId));
  };
}

function fetchProgressTestOverview(groupId) {
  return function (dispatch) {
    var url = buildProgressTestOverviewUrl(groupId);
    var method = 'GET';

    return dispatch(fetchProgressTestOverviewRequest()).payload.then(function (response) {
      return dispatch(fetchProgressTestOverviewSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchProgressTestOverviewFailure(error));
    });

    function fetchProgressTestOverviewRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_OVERVIEW_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchProgressTestOverviewSuccess(overview) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_OVERVIEW_SUCCESS,
        payload: overview,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchProgressTestOverviewFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_PROGRESS_TEST_OVERVIEW_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _style = __webpack_require__(2043);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouter = __webpack_require__(16);

var _reactRouterRedux = __webpack_require__(15);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _classnames3 = __webpack_require__(7);

var _classnames4 = _interopRequireDefault(_classnames3);

var _omniCommonUi = __webpack_require__(0);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _skillScoreHFv = __webpack_require__(111);

var skillScoreHFv4 = _interopRequireWildcard(_skillScoreHFv);

var _GroupMembers = __webpack_require__(14);

var _ = __webpack_require__(13);

var _IndividualDevelopmentPlan = __webpack_require__(323);

var _StudentCardProfile = __webpack_require__(84);

var _StudentCardProfile2 = _interopRequireDefault(_StudentCardProfile);

var _UnsavedChangesTrackingPageComponent = __webpack_require__(31);

var _UnsavedChangesTrackingPageComponent2 = _interopRequireDefault(_UnsavedChangesTrackingPageComponent);

var _AddInternalNoteControl = __webpack_require__(67);

var _AddInternalNoteControl2 = _interopRequireDefault(_AddInternalNoteControl);

var _UnsavedChangesWarning = __webpack_require__(39);

var _UnsavedChangesWarning2 = _interopRequireDefault(_UnsavedChangesWarning);

var _NoContentMessage = __webpack_require__(66);

var _NoContentMessage2 = _interopRequireDefault(_NoContentMessage);

var _RejectNotePopup = __webpack_require__(206);

var _RejectNotePopup2 = _interopRequireDefault(_RejectNotePopup);

var _UserInfo = __webpack_require__(2045);

var _UserInfo2 = _interopRequireDefault(_UserInfo);

var _routes = __webpack_require__(835);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IndividualDevelopmentPlanApprovalView = function (_UnsavedChangesTracki) {
  _inherits(IndividualDevelopmentPlanApprovalView, _UnsavedChangesTracki);

  function IndividualDevelopmentPlanApprovalView(props) {
    _classCallCheck(this, IndividualDevelopmentPlanApprovalView);

    var _this = _possibleConstructorReturn(this, (IndividualDevelopmentPlanApprovalView.__proto__ || Object.getPrototypeOf(IndividualDevelopmentPlanApprovalView)).call(this, props));

    _this.state = { wasContentEditMade: false, isAnyMandatoryEmpty: false };

    _this._onDiscardClick = _this._onDiscardClick.bind(_this);
    _this._onOverallChanged = _this._onOverallChanged.bind(_this);
    _this._onSkillSuggestionChanged = _this._onSkillSuggestionChanged.bind(_this);
    _this._onDialogCancelled = _this._onDialogCancelled.bind(_this);
    _this._onRejectStudentIdpReport = _this._onRejectStudentIdpReport.bind(_this);
    return _this;
  }

  _createClass(IndividualDevelopmentPlanApprovalView, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      _get(IndividualDevelopmentPlanApprovalView.prototype.__proto__ || Object.getPrototypeOf(IndividualDevelopmentPlanApprovalView.prototype), 'componentWillMount', this).call(this);
      this._fetchIdpApprovalContents(this.props, true);
      this._initCommentsInEditMode();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._fetchIdpApprovalContents(nextProps);
      this._initCommentsInEditMode(nextProps);
    }
  }, {
    key: '_isChangesPresent',
    value: function _isChangesPresent() {
      return IndividualDevelopmentPlanApprovalView.isInEditMode(this.props) && this.state.wasContentEditMade;
    }
  }, {
    key: '_wasContentEditMade',
    value: function _wasContentEditMade() {
      return IndividualDevelopmentPlanApprovalView.isInEditMode(this.props) && this.state.wasContentEditMade;
    }
  }, {
    key: '_setWasContEditMade',
    value: function _setWasContEditMade(wasContentEditMade) {
      if (this.state.wasContentEditMade === wasContentEditMade) return;
      this.setState({ wasContentEditMade: wasContentEditMade });
    }
  }, {
    key: '_initCommentsInEditMode',
    value: function _initCommentsInEditMode() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      var isInEditMode = IndividualDevelopmentPlanApprovalView.isInEditMode;
      if (!props.idpApprovalContents || props.idpApprovalContents.size === 0 || !IndividualDevelopmentPlanApprovalView.isInEditMode(props) || !isInEditMode(this.props) && isInEditMode(props)) return;
      var idpApprovalContent = props.idpApprovalContents.find(function (content) {
        return content.idpId === props.idpId;
      });
      if (!idpApprovalContent) return;
      var overallSuggestion = idpApprovalContent.overallSuggestion,
          participationId = idpApprovalContent.participationId,
          skillSuggestions = idpApprovalContent.skillSuggestions,
          idpId = idpApprovalContent.idpId;

      if (this.state.wasContentEditMade) return;
      this._onEditComments(overallSuggestion, participationId, skillSuggestions, idpId);
    }
  }, {
    key: '_isContentInEditMode',
    value: function _isContentInEditMode(props, idpId) {
      var isPageInEditMode = IndividualDevelopmentPlanApprovalView.isInEditMode(props);
      return isPageInEditMode && idpId === props.idpId;
    }
  }, {
    key: '_onEditComments',
    value: function _onEditComments(overallSuggestion, participationId, skillSuggestions, idpId) {
      this.setState({
        overallSuggestion: overallSuggestion || '',
        participationId: participationId,
        skillSuggestions: this._getInitialSkillSuggestions(skillSuggestions)
      });
      if (_routes.Modes.EDIT !== this.props.mode || idpId !== this.props.idpId) {
        this._changeMode(_routes.Modes.EDIT, idpId);
      }
    }
  }, {
    key: '_getInitialSkillSuggestions',
    value: function _getInitialSkillSuggestions(skillSuggestions) {
      return skillSuggestions.toJS().map(function (skillSuggestion) {
        return {
          skillId: skillSuggestion.skillId,
          suggestion: skillSuggestion.suggestion || '',
          isManuallyAdded: !!skillSuggestion.isManuallyAdded,
          selectedRecommendationList: skillSuggestion.selectedRecommendationList
        };
      });
    }
  }, {
    key: '_onApproveClick',
    value: function _onApproveClick() {
      var _this2 = this;

      var idpId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.idpId;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props,
          groupIdpId = _ref.groupIdpId;

      this.props.approveStudentIdpReport(idpId, groupIdpId).then(function () {
        return _this2._changeMode();
      });
    }
  }, {
    key: '_onRejectStudentIdpReport',
    value: function _onRejectStudentIdpReport() {
      var rejectedComment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var _this3 = this;

      var idpId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.idpId;

      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props,
          groupIdpId = _ref2.groupIdpId;

      this.props.rejectStudentIdpReport(idpId, groupIdpId, rejectedComment).then(function () {
        return _this3._changeMode();
      });
    }
  }, {
    key: '_onRejectClick',
    value: function _onRejectClick(idpId) {
      this._changeMode(_routes.Modes.REJECT, idpId);
    }
  }, {
    key: '_changeMode',
    value: function _changeMode() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var idpId = arguments[1];
      var buildRoute = this.props.buildRoute;

      this._forcePushRoute(buildRoute({ mode: mode, idpId: idpId }));
    }
  }, {
    key: '_fetchIdpApprovalContents',
    value: function _fetchIdpApprovalContents() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var shouldForceFetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var groupIdpId = props.groupIdpId;

      shouldForceFetch ? this.props.fetchIdpApprovalList(groupIdpId) : this.props.fetchIdpApprovalListIfNeeded(groupIdpId);
    }
  }, {
    key: '_renderApprovalList',
    value: function _renderApprovalList() {
      var _this4 = this;

      if (!this.props.idpApprovalContents) return;
      return this.props.idpApprovalContents.map(function (idpApprovalContent) {
        if (!idpApprovalContent) return null;
        return _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          { key: idpApprovalContent.idpId },
          _react2.default.createElement(
            _omniCommonUi.PageCard,
            { className: (0, _omniCommonUi.testClass)('idp-approval') },
            _react2.default.createElement(
              _omniCommonUi.PageCard.Heading,
              { className: _style2.default.IndividualDevelopmentPlanApprovalView_pageHeading },
              _this4._renderStudentCard(idpApprovalContent)
            ),
            _react2.default.createElement(
              _omniCommonUi.PageCard.Heading,
              null,
              _this4._renderReportLink(idpApprovalContent)
            ),
            _react2.default.createElement(
              _omniCommonUi.PageCard.Content,
              { className: _style2.default.IndividualDevelopmentPlanApprovalView_pageContent },
              _this4._renderTeacherAndOverall(idpApprovalContent),
              _this4._renderSuggestions(idpApprovalContent),
              _this4._renderBottomButtons(idpApprovalContent)
            )
          )
        );
      });
    }
  }, {
    key: '_renderReportLink',
    value: function _renderReportLink(_ref3) {
      var studentId = _ref3.studentInfo.id;
      var _props = this.props,
          groupId = _props.groupId,
          groupIdpId = _props.groupIdpId;

      var link = '/group/' + groupId + '/progress-report/' + groupIdpId + '/student/' + studentId;
      return _react2.default.createElement(
        _reactRouter.Link,
        { className: (0, _classnames4.default)(_style2.default.IndividualDevelopmentPlanApprovalViewLink, (0, _omniCommonUi.testClass)('report-link')),
          to: this.props.buildRoute(link),
          draggable: false },
        'Progress Report ',
        _react2.default.createElement(_omniCommonUi.Icon, { id: 'arrow-right',
          className: _style2.default.IndividualDevelopmentPlanApprovalViewLink_icon })
      );
    }
  }, {
    key: '_renderStudentCard',
    value: function _renderStudentCard(_ref4) {
      var studentInfo = _ref4.studentInfo;

      return _react2.default.createElement(
        _omniCommonUi.StudentCard,
        { borderless: true, backgroundless: true },
        _react2.default.createElement(_StudentCardProfile2.default, { withoutBottomPadding: true,
          studentId: studentInfo.id })
      );
    }
  }, {
    key: '_renderTeacherAndOverall',
    value: function _renderTeacherAndOverall(_ref5) {
      var teacherId = _ref5.teacherId,
          overallSuggestion = _ref5.overallSuggestion,
          suggestedTime = _ref5.suggestedTime,
          idpId = _ref5.idpId;
      var timeZone = this.props.timeZone;

      if (!timeZone || !teacherId) return;
      var dateStr = _is_js2.default.existy(suggestedTime) && _is_js2.default.existy(timeZone) ? _omniCommonUi.moment.parseZone(suggestedTime).clone().tz(timeZone).format('YYYY-MM-DD') : '';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_UserInfo2.default, { id: teacherId.toString(),
          dateStr: dateStr,
          className: _style2.default.IndividualDevelopmentPlanApprovalView_userInfo }),
        this._renderOverall(overallSuggestion, idpId)
      );
    }
  }, {
    key: '_renderOverall',
    value: function _renderOverall(overallSuggestion, idpId) {
      var isContentInEditMode = this._isContentInEditMode(this.props, idpId);
      var overallTitleClasses = (0, _classnames4.default)(_style2.default._overallTitle, _defineProperty({}, _style2.default.__noGray, isContentInEditMode));
      var content = isContentInEditMode ? this.state.overallSuggestion : overallSuggestion;
      return _react2.default.createElement(
        'div',
        { className: _style2.default.IndividualDevelopmentPlanApprovalView_overall },
        _react2.default.createElement(
          'div',
          { className: overallTitleClasses },
          'Overall'
        ),
        this._renderContent(content, isContentInEditMode, 'overall')
      );
    }
  }, {
    key: '_renderSuggestions',
    value: function _renderSuggestions(_ref6) {
      var _this5 = this;

      var skillSuggestions = _ref6.skillSuggestions,
          idpId = _ref6.idpId,
          shouldShowSuggestions = _ref6.shouldShowSuggestions,
          isSimplifiedTeacherFeedback = _ref6.isSimplifiedTeacherFeedback;

      if (isSimplifiedTeacherFeedback) return;
      if (!shouldShowSuggestions) return;
      return skillSuggestions.map(function (skillSuggestion, index) {
        var isContentInEditMode = _this5._isContentInEditMode(_this5.props, idpId);
        var skillTitle = '' + (skillSuggestion.name || '') + (' ' + skillScoreHFv4.formatSkillScore(skillSuggestion, '') + ' ') + '- Suggestions';
        var skillTitleClasses = (0, _classnames4.default)(_style2.default._suggestionTitle, _defineProperty({}, _style2.default.__noGray, isContentInEditMode));
        var content = isContentInEditMode ? _this5.state.skillSuggestions && _this5.state.skillSuggestions[index].suggestion : skillSuggestion.suggestion;

        return _react2.default.createElement(
          'div',
          { key: skillSuggestion.name || index,
            className: _style2.default.IndividualDevelopmentPlanApprovalView_suggestionCard },
          _react2.default.createElement(
            'div',
            { className: skillTitleClasses },
            skillTitle
          ),
          _this5._renderContent(content, isContentInEditMode, index)
        );
      });
    }
  }, {
    key: '_onOverallChanged',
    value: function _onOverallChanged(text) {
      this._setWasContEditMade(true);
      this.setState({ overallSuggestion: text });
    }
  }, {
    key: '_onSkillSuggestionChanged',
    value: function _onSkillSuggestionChanged(text, index) {
      this._setWasContEditMade(true);
      var skillSuggestions = this.state.skillSuggestions.map(function (skillSuggestion, _index) {
        if (index !== _index) return skillSuggestion;
        return Object.assign({}, skillSuggestion, { suggestion: text });
      });
      this.setState({ skillSuggestions: skillSuggestions });
    }
  }, {
    key: '_renderContent',
    value: function _renderContent(content, isContentInEditMode, contentType) {
      var onContentChanged = contentType === 'overall' ? this._onOverallChanged : this._onSkillSuggestionChanged;

      if (isContentInEditMode) {
        return _react2.default.createElement(_AddInternalNoteControl2.default, { text: content,
          maxCharacters: 1320,
          onChange: function onChange(text) {
            return onContentChanged(text, contentType);
          },
          noAutoScroll: true });
      }
      return _react2.default.createElement(
        'div',
        { className: _style2.default._content },
        content
      );
    }
  }, {
    key: '_onDiscardClick',
    value: function _onDiscardClick() {
      this._setWasContEditMade(false);
      this._changeMode('');
    }
  }, {
    key: '_onDialogCancelled',
    value: function _onDialogCancelled() {
      this._changeMode('');
    }
  }, {
    key: '_onSaveClick',
    value: function _onSaveClick(idpId) {
      var _this6 = this;

      var idpRow = this.props.idpApprovalContents && this.props.idpApprovalContents.find(function (c) {
        return c && c.idpId === idpId;
      });
      var isSimplified = idpRow && idpRow.isSimplifiedTeacherFeedback;
      var submittedSuggestions = isSimplified ? {
        overallSuggestion: this.state.overallSuggestion || ''
      } : {
        overallSuggestion: this.state.overallSuggestion || '',
        participationId: this.state.participationId,
        skillSuggestions: this.state.skillSuggestions
      };
      this.props.submitIdpFeedbackSuggestions(idpId, submittedSuggestions, this.props.groupIdpId).then(function () {
        _this6._fetchIdpApprovalContents(_this6.props, true);
        _this6._onDiscardClick();
      });
    }
  }, {
    key: '_markIfAnyMandatoryEmpty',
    value: function _markIfAnyMandatoryEmpty(isAnyMandatoryEmpty) {
      if (isAnyMandatoryEmpty === this.state.isAnyMandatoryEmpty) return;
      this.setState({ isAnyMandatoryEmpty: isAnyMandatoryEmpty });
    }
  }, {
    key: '_renderBottomButtons',
    value: function _renderBottomButtons(idpApprovalContent) {
      var _this7 = this;

      var overallSuggestion = idpApprovalContent.overallSuggestion,
          participationId = idpApprovalContent.participationId,
          skillSuggestions = idpApprovalContent.skillSuggestions,
          idpId = idpApprovalContent.idpId;

      if (this._isContentInEditMode(this.props, idpId)) {
        var hasMandatoryEmpty = !this.state.overallSuggestion.trim();
        this._markIfAnyMandatoryEmpty(hasMandatoryEmpty);
        return _react2.default.createElement(_IndividualDevelopmentPlan.BottomButtons, { primaryText: 'SAVE',
          secondaryText: 'DISCARD',
          isPrimaryDisabled: hasMandatoryEmpty,
          onPrimaryClick: function onPrimaryClick() {
            return _this7._onSaveClick(idpId);
          },
          onSecondaryClick: this._onDiscardClick,
          className: _style2.default.IndividualDevelopmentPlanApprovalView_bottomButtons });
      }
      var isPageInEditMode = IndividualDevelopmentPlanApprovalView.isInEditMode(this.props);
      var saveButton = {
        text: 'APPROVE',
        onClick: function onClick() {
          return _this7._onApproveClick(idpId);
        },
        disabled: !!isPageInEditMode,
        primary: true
      };
      var rejectButton = {
        text: 'REJECT',
        onClick: function onClick() {
          return _this7._onRejectClick(idpId);
        },
        disabled: !!isPageInEditMode
      };
      var editButton = {
        text: 'EDIT',
        onClick: function onClick() {
          return _this7._onEditComments(overallSuggestion, participationId, skillSuggestions, idpId);
        },
        disabled: !!isPageInEditMode
      };
      return _react2.default.createElement(_IndividualDevelopmentPlan.BottomButtons, { buttons: [saveButton, rejectButton, editButton],
        className: _style2.default.IndividualDevelopmentPlanApprovalView_bottomButtons });
    }
  }, {
    key: '_renderDeleteConfirmDialog',
    value: function _renderDeleteConfirmDialog() {
      var isInRejectMode = IndividualDevelopmentPlanApprovalView.isInRejectMode(this.props);
      return isInRejectMode && _react2.default.createElement(_RejectNotePopup2.default, { isOpen: true,
        isLoading: this.props.isAnyApiCallSaving || this.props.isAnyApiCallLoading,
        onSave: this._onRejectStudentIdpReport,
        onCancel: this._onDialogCancelled });
    }
  }, {
    key: '_renderUnsavedChangesWarningDialog',
    value: function _renderUnsavedChangesWarningDialog() {
      var _this8 = this;

      if (IndividualDevelopmentPlanApprovalView.isInEditMode(this.props) && this.state.isAnyMandatoryEmpty) {
        return _react2.default.createElement(_omniCommonUi.ConfirmDialog, { isOpen: !!this._isNavigationWithChangesRequested(),
          primaryButtonContent: 'Stay',
          secondaryButtonContent: 'Leave',
          content: 'Are you sure you want to leave this page and lose unsaved changes?',
          onPrimaryClick: function onPrimaryClick() {
            _this8._clearRequestedLocation();
          },
          onSecondaryClick: function onSecondaryClick() {
            _this8._onDiscardClick();
            _this8._forcePushRequestedLocation();
          },
          onRequestClose: function onRequestClose() {
            _this8._clearRequestedLocation();
          } });
      }
      return _react2.default.createElement(_UnsavedChangesWarning2.default, { isOpen: !!this._isNavigationWithChangesRequested(),
        isSaving: this.props.isAnyApiCallSaving,
        onSaveClicked: function onSaveClicked() {
          _this8._onSaveClick(_this8.props.idpId);
        },
        onDiscardClicked: function onDiscardClicked() {
          _this8._onDiscardClick();
          _this8._forcePushRequestedLocation();
        },
        onCloseClicked: function onCloseClicked() {
          _this8._clearRequestedLocation();
        },
        onSaved: function onSaved() {
          _this8._forcePushRequestedLocation();
        } });
    }
  }, {
    key: '_renderNoContentMessage',
    value: function _renderNoContentMessage() {
      var idpApprovalContents = this.props.idpApprovalContents;

      if ((!idpApprovalContents || idpApprovalContents.size === 0) && !this.props.isAnyApiCallLoading) {
        return _react2.default.createElement(_NoContentMessage2.default, { className: (0, _omniCommonUi.testClass)('empty'),
          text: 'There are no reports waiting for approval at this time.' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { outerMargin: true },
        this._renderApprovalList(),
        this._renderNoContentMessage(),
        this._renderUnsavedChangesWarningDialog(),
        this._renderDeleteConfirmDialog()
      );
    }
  }]);

  return IndividualDevelopmentPlanApprovalView;
}(_UnsavedChangesTrackingPageComponent2.default);

IndividualDevelopmentPlanApprovalView.isInEditMode = function (_ref7) {
  var params = _ref7.params;
  return params.mode === _routes.Modes.EDIT && params.idpId;
};

IndividualDevelopmentPlanApprovalView.isInRejectMode = function (_ref8) {
  var params = _ref8.params;
  return params.mode === _routes.Modes.REJECT && params.idpId;
};

IndividualDevelopmentPlanApprovalView.propTypes = {
  groupIdpId: _propTypes2.default.string.isRequired,
  groupId: _propTypes2.default.string.isRequired,
  timeZone: _propTypes2.default.string,
  idpApprovalList: _propTypes2.default.shape(),
  idpApprovalContents: _propTypes2.default.shape(),
  idpId: _propTypes2.default.string,
  fetchIdpApprovalList: _propTypes2.default.func.isRequired,
  fetchIdpApprovalListIfNeeded: _propTypes2.default.func.isRequired,
  fetchIdpFeedbackSuggestionsIfNeeded: _propTypes2.default.func.isRequired,
  submitIdpFeedbackSuggestions: _propTypes2.default.func.isRequired,
  approveStudentIdpReport: _propTypes2.default.func.isRequired,
  rejectStudentIdpReport: _propTypes2.default.func.isRequired,
  isAnyApiCallSaving: _propTypes2.default.bool,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired
};

function mapStatToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      groupIdpId = _ownProps$params.groupIdpId,
      idpId = _ownProps$params.idpId,
      mode = _ownProps$params.mode;

  var groupIdpList = _IndividualDevelopmentPlans.accessors.getGroupIdpList(state, groupId);
  var idpDetailList = state.get('rootReducer').get('individualDevelopmentPlan');
  var idpList = _IndividualDevelopmentPlans.accessors.getIdpList(groupIdpList, groupIdpId);
  var idpApprovalList = state.get('rootReducer').get('idpApprovalList').get(groupIdpId);
  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);

  var _groupActions$getCent = _.actions.getCentre(state, groupId),
      timeZone = _groupActions$getCent.timeZone;

  var idpApprovalContents = void 0;
  if (idpApprovalList && idpApprovalList.size > 0 && members.size > 0 && idpList) {
    idpApprovalContents = idpApprovalList.map(function (idpApproval) {
      return _IndividualDevelopmentPlans.accessors.getApprovalContentHFv4(state, groupId, groupIdpId, idpList, idpDetailList, members, idpApproval.studentIDPId);
    }).filter(function (idpApprovalContent) {
      return _is_js2.default.not.undefined(idpApprovalContent);
    });
    idpApprovalContents = members.map(function (_ref9) {
      var id = _ref9.studentGeneralInfo.id;
      return idpApprovalContents.find(function (idpApprovalContent) {
        return idpApprovalContent.studentInfo.id === id;
      });
    });
    idpApprovalContents = idpApprovalContents.filter(function (content) {
      return _is_js2.default.not.undefined(content);
    });
  }
  return {
    groupId: groupId,
    groupIdpId: groupIdpId,
    idpId: idpId,
    mode: mode,
    idpApprovalList: idpApprovalList,
    idpApprovalContents: idpApprovalContents,
    timeZone: timeZone,
    isAnyApiCallSaving: !!isAnyApiCallSaving(state),
    isAnyApiCallLoading: !!isAnyApiCallLoading(state)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_IndividualDevelopmentPlans.actions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

function isAnyApiCallLoading(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['GET'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

exports.default = (0, _omniCommonUi.connect)(mapStatToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(IndividualDevelopmentPlanApprovalView));

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modes = undefined;

var _component = __webpack_require__(834);

var _component2 = _interopRequireDefault(_component);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modes = exports.Modes = {
  APPROVE: 'approve',
  EDIT: 'edit',
  REJECT: 'reject'
};

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: ':groupIdpId/dos-approval(/:mode)(/:idpId)',
    component: _component2.default,
    canAccess: function canAccess() {
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.IndividualDevelopmentPlan.ApproveComment);
    },
    tabs: {
      hidden: true
    },
    sessionNav: {
      hidden: true
    },
    actionButtons: {
      hidden: true
    },
    breadcrumbLabels: 'DOS Approval'
  };
};

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBMIT_KET_EXAM_RESULT_FAILURE = exports.SUBMIT_KET_EXAM_RESULT_SUCCESS = exports.SUBMIT_KET_EXAM_RESULT_REQUEST = exports.FETCH_KET_EXAM_FAILURE = exports.FETCH_KET_EXAM_SUCCESS = exports.FETCH_KET_EXAM_REQUEST = exports.FETCH_KET_EXAMS_PLAN_FAILURE = exports.FETCH_KET_EXAMS_PLAN_SUCCESS = exports.FETCH_KET_EXAMS_PLAN_REQUEST = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.fetchKetExamsPlanIfNeeded = fetchKetExamsPlanIfNeeded;
exports.fetchKetExamsPlan = fetchKetExamsPlan;
exports.fetchKetExam = fetchKetExam;
exports.submitKetExamResult = submitKetExamResult;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_KET_EXAMS_PLAN_REQUEST = exports.FETCH_KET_EXAMS_PLAN_REQUEST = 'FETCH_KET_EXAMS_PLAN_REQUEST';
var FETCH_KET_EXAMS_PLAN_SUCCESS = exports.FETCH_KET_EXAMS_PLAN_SUCCESS = 'FETCH_KET_EXAMS_PLAN_SUCCESS';
var FETCH_KET_EXAMS_PLAN_FAILURE = exports.FETCH_KET_EXAMS_PLAN_FAILURE = 'FETCH_KET_EXAMS_PLAN_FAILURE';
var FETCH_KET_EXAM_REQUEST = exports.FETCH_KET_EXAM_REQUEST = 'FETCH_KET_EXAM_REQUEST';
var FETCH_KET_EXAM_SUCCESS = exports.FETCH_KET_EXAM_SUCCESS = 'FETCH_KET_EXAM_SUCCESS';
var FETCH_KET_EXAM_FAILURE = exports.FETCH_KET_EXAM_FAILURE = 'FETCH_KET_EXAM_FAILURE';
var SUBMIT_KET_EXAM_RESULT_REQUEST = exports.SUBMIT_KET_EXAM_RESULT_REQUEST = 'SUBMIT_KET_EXAM_RESULT_REQUEST';
var SUBMIT_KET_EXAM_RESULT_SUCCESS = exports.SUBMIT_KET_EXAM_RESULT_SUCCESS = 'SUBMIT_KET_EXAM_RESULT_SUCCESS';
var SUBMIT_KET_EXAM_RESULT_FAILURE = exports.SUBMIT_KET_EXAM_RESULT_FAILURE = 'SUBMIT_KET_EXAM_RESULT_FAILURE';

var buildKetExamsPlanUrl = function buildKetExamsPlanUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/ket-exams');
};

function fetchKetExamsPlanIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildKetExamsPlanUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchKetExamsPlan(groupId));
  };
}

function fetchKetExamsPlan(groupId) {
  return function (dispatch) {
    var url = buildKetExamsPlanUrl(groupId);
    var method = 'GET';

    return dispatch(fetchKetExamsPlanRequest()).payload.then(function (response) {
      return dispatch(fetchKetExamsPlanSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchKetExamsPlanFailure(error));
    });

    function fetchKetExamsPlanRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_KET_EXAMS_PLAN_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchKetExamsPlanSuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_KET_EXAMS_PLAN_SUCCESS,
        payload: payload,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchKetExamsPlanFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_KET_EXAMS_PLAN_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId
      });
    }
  };
}

function fetchKetExam(groupId, ketExamId) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/ket-exams/' + ketExamId + '/content');
    var method = 'GET';

    return dispatch(fetchKetExamRequest()).payload.then(function (response) {
      return dispatch(fetchKetExamSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchKetExamFailure(error));
    });

    function fetchKetExamRequest() {
      var content = (0, _Api.fetch)(url);
      var results = (0, _Api.fetch)((0, _Api.buildUrl)('/ket-exams/' + ketExamId + '/results'));
      var payload = Promise.all([content, results]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            contentResp = _ref2[0],
            resultsResp = _ref2[1];

        return _extends({}, contentResp, resultsResp);
      });
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_KET_EXAM_REQUEST,
        payload: payload,
        url: url,
        method: method,
        groupId: groupId,
        ketExamId: ketExamId
      });
    }

    function fetchKetExamSuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_KET_EXAM_SUCCESS,
        payload: payload,
        url: url,
        method: method,
        groupId: groupId,
        ketExamId: ketExamId
      });
    }

    function fetchKetExamFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_KET_EXAM_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId,
        ketExamId: ketExamId
      });
    }
  };
}

function submitKetExamResult(groupId, ketExamId, studentId, skillMarks) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/ket-exams/' + ketExamId + '/students/' + studentId + '/results');
    var method = 'PUT';

    return dispatch(submitKetExamResultRequest()).payload.then(function (response) {
      return dispatch(submitKetExamResultSuccess(response));
    }).catch(function (error) {
      dispatch(submitKetExamResultFailure(error));
      throw error;
    }).then(function () {
      return dispatch(fetchKetExam(groupId, ketExamId));
    });

    function submitKetExamResultRequest() {
      var request = (0, _Api.fetch)(url, {
        method: method,
        body: JSON.stringify({ skillMarks: skillMarks })
      });
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_KET_EXAM_RESULT_REQUEST,
        payload: request,
        url: url,
        method: method,
        groupId: groupId,
        ketExamId: ketExamId,
        studentId: studentId
      });
    }

    function submitKetExamResultSuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_KET_EXAM_RESULT_SUCCESS,
        payload: payload,
        url: url,
        method: method,
        groupId: groupId,
        ketExamId: ketExamId,
        studentId: studentId
      });
    }

    function submitKetExamResultFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_KET_EXAM_RESULT_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId,
        ketExamId: ketExamId,
        studentId: studentId
      });
    }
  };
}

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2060);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _omniCommonUi = __webpack_require__(0);

var _GroupSummary = __webpack_require__(2070);

var _GroupSummary2 = _interopRequireDefault(_GroupSummary);

var _Interval = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GroupRecord = _immutable2.default.Record({
  id: undefined,
  name: undefined,
  number: undefined,
  centreId: undefined,
  closedTime: undefined,
  comments: undefined,
  status: undefined,
  teachers: undefined,
  courseTypeCode: undefined,
  groupSummary: undefined,
  period: undefined,
  languageCode: undefined,
  courseTypeLevelId: undefined,
  courseTypeLevelCode: undefined,
  members: _omniCommonUi.ApiResponseHelper.create(),
  sessions: _omniCommonUi.ApiResponseHelper.create(),
  sessionPlans: _omniCommonUi.ApiResponseHelper.create(),
  progressReports: _omniCommonUi.ApiResponseHelper.create(),
  autoPublishContent: undefined,
  enabledModuleCodes: undefined,
  isFromOdin: undefined,
  groupExternalUrl: undefined,
  onlineProductName: undefined,
  hasContentPath: undefined
});

var Group = function (_GroupRecord) {
  _inherits(Group, _GroupRecord);

  function Group() {
    _classCallCheck(this, Group);

    return _possibleConstructorReturn(this, (Group.__proto__ || Object.getPrototypeOf(Group)).apply(this, arguments));
  }

  return Group;
}(GroupRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'centreId':
    case 'courseTypeLevelId':
      return [key, '' + val]; // stringify
    case 'groupSummary':
      return [key, _GroupSummary2.default.create(val)];
    case 'period':
      return [key, _Interval.Interval.create({
        start: val.startDate,
        end: val.endDate
      })];
    case 'autoPublishContent':
    case 'enabledModuleCodes':
      return [key, new _immutable.List(val)];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};
Group.create = function (data) {
  return new Group(data).mapEntries(reviver);
};

exports.default = Group;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionSchedule = undefined;

var _model = __webpack_require__(2072);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(2073);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SessionSchedule = exports.SessionSchedule = _model2.default;

SessionSchedule.create = _create2.default;

exports.default = SessionSchedule;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserDashboard = function UserDashboard(_ref) {
  var children = _ref.children;
  return children;
};

UserDashboard.propTypes = {
  children: _propTypes2.default.node
};

exports.default = UserDashboard;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaskFilter = undefined;

var _component = __webpack_require__(2076);

var _component2 = _interopRequireDefault(_component);

var _TaskFilter2 = __webpack_require__(846);

var _TaskFilter3 = _interopRequireDefault(_TaskFilter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _component2.default;
var TaskFilter = exports.TaskFilter = _TaskFilter3.default;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2077);

var _style2 = _interopRequireDefault(_style);

var _reactRadialProgressSansAnimation = __webpack_require__(284);

var _reactRadialProgressSansAnimation2 = _interopRequireDefault(_reactRadialProgressSansAnimation);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskProgressCard = function (_Component) {
  _inherits(TaskProgressCard, _Component);

  function TaskProgressCard() {
    _classCallCheck(this, TaskProgressCard);

    return _possibleConstructorReturn(this, (TaskProgressCard.__proto__ || Object.getPrototypeOf(TaskProgressCard)).apply(this, arguments));
  }

  _createClass(TaskProgressCard, [{
    key: '_renderProgressBar',
    value: function _renderProgressBar(counts) {
      var statsusColor = {
        Completed: '#74d17f',
        Pending: '#f7932d',
        Overdue: '#de4c4c',
        Expired: '#4a4a4a'
      };

      var responsiveParameters = [{
        className: (0, _classnames2.default)(_style2.default.TaskProgressCard_radialContainer, _style2.default.__md),
        radius: 60,
        circleStrokeWidth: 3,
        edgeSize: 130,
        forcedTextY: 44,
        fontSize: ['24', '', ''],
        fontWeight: 'inherit',
        tspanX: '65',
        tspanDy: ['10', '28', '16'],
        showText: true
      }, {
        className: (0, _classnames2.default)(_style2.default.TaskProgressCard_radialContainer, _style2.default.__sm),
        radius: 40,
        circleStrokeWidth: 2,
        edgeSize: 90,
        forcedTextY: 34,
        fontSize: ['18', '11', '11'],
        fontWeight: 'inherit',
        tspanX: '45',
        tspanDy: ['3', '18', '14'],
        showText: true
      }, {
        className: (0, _classnames2.default)(_style2.default.TaskProgressCard_radialContainer, _style2.default.__xs),
        radius: 25,
        circleStrokeWidth: 2,
        edgeSize: 60,
        forcedTextY: 32,
        fontSize: ['14', '11', '11'],
        fontWeight: 500,
        tspanX: '30',
        tspanDy: ['3', '18', '14'],
        showText: false
      }];

      return responsiveParameters.map(function (parameter) {
        return _react2.default.createElement(
          'div',
          { className: parameter.className },
          counts.map(function (statisticCount) {
            return _react2.default.createElement(
              'div',
              { className: _style2.default.TaskProgressCard_svgContainer },
              _react2.default.createElement(_reactRadialProgressSansAnimation2.default, { radius: parameter.radius,
                circleStrokeWidth: parameter.circleStrokeWidth,
                edgeSize: parameter.edgeSize,
                forcedTextY: parameter.forcedTextY,
                unit: 'percent',
                formatText: function formatText() {
                  return _react2.default.createElement(
                    'tspan',
                    null,
                    _react2.default.createElement(
                      'tspan',
                      { x: parameter.tspanX,
                        dy: parameter.tspanDy[0],
                        fontSize: parameter.fontSize[0],
                        fontWeight: parameter.fontWeight },
                      statisticCount.count
                    ),
                    _react2.default.createElement(
                      'tspan',
                      { x: parameter.tspanX,
                        dy: parameter.tspanDy[1],
                        fontSize: parameter.fontSize[1] },
                      parameter.showText && statisticCount.status
                    ),
                    _react2.default.createElement(
                      'tspan',
                      { x: parameter.tspanX,
                        dy: parameter.tspanDy[2],
                        fontSize: parameter.fontSize[2] },
                      parameter.showText && 'Tasks'
                    )
                  );
                },
                circleStroke: '#cdcdcd',
                progressStroke: statsusColor[statisticCount.status],
                value: statisticCount.percentage })
            );
          })
        );
      });
    }
  }, {
    key: '_isTasksEmpty',
    value: function _isTasksEmpty(taskCounts) {
      var result = true;
      taskCounts.map(function (statisticCount) {
        if (statisticCount.count !== 0) {
          result = false;
        }
        return false;
      });
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var sinceTimeText = this._isTasksEmpty(this.props.tasksCounts) ? '' : 'since ' + this.props.sinceTime;
      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _classnames2.default)(_style2.default.TaskProgressCard, this.props.className) },
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          { className: (0, _classnames2.default)(this.props.cardTitleClass, _style2.default.TaskProgressCard_title),
            text: this.props.cardTitle,
            stackMode: 'horizontal' },
          _react2.default.createElement(
            'span',
            { className: _style2.default.TaskProgressCard_title_time },
            sinceTimeText
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.TaskProgressCard_pageCardContent },
          this._renderProgressBar(this.props.tasksCounts)
        )
      );
    }
  }]);

  return TaskProgressCard;
}(_react.Component);

TaskProgressCard.propTypes = {
  cardTitleClass: _propTypes2.default.object,
  cardTitle: _propTypes2.default.string,
  tasksCounts: _propTypes2.default.array,
  sinceTime: _propTypes2.default.string,
  showSinceTime: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

exports.default = TaskProgressCard;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.taskOwnersUrl = exports.CANCEL_TASK_FAILURE = exports.CANCEL_TASK_SUCCESS = exports.CANCEL_TASK_REQUEST = exports.FETCH_TASK_CENTRES_FAILURE = exports.FETCH_TASK_CENTRES_SUCCESS = exports.FETCH_TASK_CENTRES_REQUEST = exports.FETCH_TASK_TYPES_FAILURE = exports.FETCH_TASK_TYPES_SUCCESS = exports.FETCH_TASK_TYPES_REQUEST = exports.FETCH_DOS_TASKS_FAILURE = exports.FETCH_DOS_TASKS_SUCCESS = exports.FETCH_DOS_TASKS_REQUEST = exports.FETCH_TASK_OWNERS_FAILURE = exports.FETCH_TASK_OWNERS_SUCCESS = exports.FETCH_TASK_OWNERS_REQUEST = exports.FETCH_TASKS_FAILURE = exports.FETCH_TASKS_SUCCESS = exports.FETCH_TASKS_REQUEST = undefined;
exports.fetchTasks = fetchTasks;
exports.fetchDosTasks = fetchDosTasks;
exports.fetchTaskOwnersIfNeeded = fetchTaskOwnersIfNeeded;
exports.fetchTaskOwners = fetchTaskOwners;
exports.fetchTaskCentresIfNeeded = fetchTaskCentresIfNeeded;
exports.fetchTaskCentres = fetchTaskCentres;
exports.fetchTaskTypesIfNeeded = fetchTaskTypesIfNeeded;
exports.fetchTaskTypes = fetchTaskTypes;
exports.cancelTask = cancelTask;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_TASKS_REQUEST = exports.FETCH_TASKS_REQUEST = 'FETCH_TASKS_REQUEST';
var FETCH_TASKS_SUCCESS = exports.FETCH_TASKS_SUCCESS = 'FETCH_TASKS_SUCCESS';
var FETCH_TASKS_FAILURE = exports.FETCH_TASKS_FAILURE = 'FETCH_TASKS_FAILURE';
var FETCH_TASK_OWNERS_REQUEST = exports.FETCH_TASK_OWNERS_REQUEST = 'FETCH_TASK_OWNERS_REQUEST';
var FETCH_TASK_OWNERS_SUCCESS = exports.FETCH_TASK_OWNERS_SUCCESS = 'FETCH_TASK_OWNERS_SUCCESS';
var FETCH_TASK_OWNERS_FAILURE = exports.FETCH_TASK_OWNERS_FAILURE = 'FETCH_TASK_OWNERS_FAILURE';
var FETCH_DOS_TASKS_REQUEST = exports.FETCH_DOS_TASKS_REQUEST = 'FETCH_DOS_TASKS_REQUEST';
var FETCH_DOS_TASKS_SUCCESS = exports.FETCH_DOS_TASKS_SUCCESS = 'FETCH_DOS_TASKS_SUCCESS';
var FETCH_DOS_TASKS_FAILURE = exports.FETCH_DOS_TASKS_FAILURE = 'FETCH_DOS_TASKS_FAILURE';
var FETCH_TASK_TYPES_REQUEST = exports.FETCH_TASK_TYPES_REQUEST = 'FETCH_TASK_TYPES_REQUEST';
var FETCH_TASK_TYPES_SUCCESS = exports.FETCH_TASK_TYPES_SUCCESS = 'FETCH_TASK_TYPES_SUCCESS';
var FETCH_TASK_TYPES_FAILURE = exports.FETCH_TASK_TYPES_FAILURE = 'FETCH_TASK_TYPES_FAILURE';
var FETCH_TASK_CENTRES_REQUEST = exports.FETCH_TASK_CENTRES_REQUEST = 'FETCH_TASK_CENTRES_REQUEST';
var FETCH_TASK_CENTRES_SUCCESS = exports.FETCH_TASK_CENTRES_SUCCESS = 'FETCH_TASK_CENTRES_SUCCESS';
var FETCH_TASK_CENTRES_FAILURE = exports.FETCH_TASK_CENTRES_FAILURE = 'FETCH_TASK_CENTRES_FAILURE';
var CANCEL_TASK_REQUEST = exports.CANCEL_TASK_REQUEST = 'CANCEL_TASK_REQUEST';
var CANCEL_TASK_SUCCESS = exports.CANCEL_TASK_SUCCESS = 'CANCEL_TASK_SUCCESS';
var CANCEL_TASK_FAILURE = exports.CANCEL_TASK_FAILURE = 'CANCEL_TASK_FAILURE';

function fetchTasks(filterParams) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/tasks/my-tasks?' + ('pageSize=' + filterParams.pageSize + '&') + ('pageNumber=' + filterParams.pageNumber + '&') + ('sortBy=' + filterParams.sortBy + '&') + ('sortType=' + filterParams.sortType + '&') + ('isAllTasks=' + filterParams.taskFilter));
    var method = 'GET';

    return dispatch(fetchTasksRequest()).payload.then(function (response) {
      return dispatch(fetchTasksSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchTasksFailure(error));
    });

    function fetchTasksRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_TASKS_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method
      });
    }

    function fetchTasksSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_TASKS_SUCCESS,
        payload: response,
        url: url,
        method: method
      });
    }

    function fetchTasksFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_TASKS_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

function fetchDosTasks(filterParams) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/tasks/dos-tasks' + ('/centres/' + filterParams.taskCentre) + ('/task-owners/' + filterParams.taskOwner + '?') + ('pageSize=' + filterParams.pageSize + '&') + ('pageNumber=' + filterParams.pageNumber + '&') + ('sortBy=' + filterParams.sortBy + '&') + ('sortType=' + filterParams.sortType + '&') + ('isAllTasks=' + filterParams.taskFilter + '&') + ('taskTypeCode=' + filterParams.taskSubject));
    var method = 'GET';
    return dispatch(fetchDosTaskRequest()).payload.then(function (response) {
      return dispatch(fetchDosTaskSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchDosTaskFailure(error));
    });

    function fetchDosTaskRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_DOS_TASKS_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method
      });
    }

    function fetchDosTaskSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_DOS_TASKS_SUCCESS,
        payload: response,
        url: url,
        method: method
      });
    }

    function fetchDosTaskFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_DOS_TASKS_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

var taskOwnersUrl = exports.taskOwnersUrl = (0, _Api.buildUrl)('/tasks/dos-tasks/task-owners');

function fetchTaskOwnersIfNeeded() {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: taskOwnersUrl })) {
      return false;
    }

    return dispatch(fetchTaskOwners());
  };
}

function fetchTaskOwners() {
  return function (dispatch) {
    var url = taskOwnersUrl;
    var method = 'GET';

    return dispatch(fetchTaskOwnersRequest()).payload.then(function (response) {
      return dispatch(fetchTaskOwnersSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchTaskOwnersFailure(error));
    });

    function fetchTaskOwnersRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_TASK_OWNERS_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method
      });
    }

    function fetchTaskOwnersSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_TASK_OWNERS_SUCCESS,
        payload: response,
        url: url,
        method: method
      });
    }

    function fetchTaskOwnersFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_TASKS_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

var taskCentresUrl = (0, _Api.buildUrl)('/tasks/dos-tasks/centres');

function fetchTaskCentresIfNeeded() {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: taskCentresUrl })) {
      return false;
    }

    return dispatch(fetchTaskCentres());
  };
}

function fetchTaskCentres() {
  return function (dispatch) {
    var method = 'GET';
    var url = taskCentresUrl;

    return dispatch(fetchTaskCentresRequest()).payload.then(function (response) {
      return dispatch(fetchTaskCentresSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchTaskCentresFailure(error));
    });

    function fetchTaskCentresRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_TASK_CENTRES_REQUEST,
        payload: (0, _Api.fetch)(url),
        method: method,
        url: url
      });
    }

    function fetchTaskCentresSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_TASK_CENTRES_SUCCESS,
        payload: response,
        method: method,
        url: url
      });
    }

    function fetchTaskCentresFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_TASK_CENTRES_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

var taskTypesUrl = (0, _Api.buildUrl)('/tasks/types');

function fetchTaskTypesIfNeeded() {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: taskTypesUrl })) {
      return false;
    }

    return dispatch(fetchTaskTypes());
  };
}

function fetchTaskTypes() {
  return function (dispatch) {
    var method = 'GET';
    var url = taskTypesUrl;

    return dispatch(fetchTaskTypesRequest()).payload.then(function (response) {
      return dispatch(fetchTaskTypesSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchTaskTypesFailure(error));
    });

    function fetchTaskTypesRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_TASK_TYPES_REQUEST,
        payload: (0, _Api.fetch)(url),
        method: method,
        url: url
      });
    }

    function fetchTaskTypesSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_TASK_TYPES_SUCCESS,
        payload: response,
        method: method,
        url: url
      });
    }

    function fetchTaskTypesFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_TASK_TYPES_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

function cancelTask(taskId) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/tasks/' + taskId + '/cancel');
    var method = 'PUT';
    return dispatch(cancelTaskRequest()).payload.then(function (response) {
      return dispatch(cancelTaskSuccess(response));
    }).catch(function (error) {
      return dispatch(cancelTaskFailure(error));
    });

    function cancelTaskRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: CANCEL_TASK_REQUEST,
        payload: (0, _Api.fetch)(url, { method: method }),
        method: method,
        url: url
      });
    }

    function cancelTaskSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: CANCEL_TASK_SUCCESS,
        payload: response,
        method: method,
        url: url
      });
    }

    function cancelTaskFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: CANCEL_TASK_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_TASK_STATISTIC_FAILURE = exports.FETCH_TASK_STATISTIC_SUCCESS = exports.FETCH_TASK_STATISTIC_REQUEST = undefined;
exports.fetchTaskStatistics = fetchTaskStatistics;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_TASK_STATISTIC_REQUEST = exports.FETCH_TASK_STATISTIC_REQUEST = 'FETCH_TASK_STATISTIC_REQUEST';
var FETCH_TASK_STATISTIC_SUCCESS = exports.FETCH_TASK_STATISTIC_SUCCESS = 'FETCH_TASK_STATISTIC_SUCCESS';
var FETCH_TASK_STATISTIC_FAILURE = exports.FETCH_TASK_STATISTIC_FAILURE = 'FETCH_TASK_STATISTIC_FAILURE';

function fetchTaskStatistics(type, taskFilter) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/tasks/' + type + '/statistic?isAllTasks=' + taskFilter);
    var method = 'GET';
    return dispatch(fetchTaskStatisticRequest()).payload.then(function (response) {
      return dispatch(fetchTaskStatisticSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchTaskStatisticFailure(error));
    });

    function fetchTaskStatisticRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_TASK_STATISTIC_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method
      });
    }

    function fetchTaskStatisticSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_TASK_STATISTIC_SUCCESS,
        payload: response,
        url: url,
        method: method
      });
    }

    function fetchTaskStatisticFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_TASK_STATISTIC_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskStatisticRecord = (0, _immutable.Record)({
  taskStatusCode: undefined,
  taskCount: undefined
});

var TaskStatistic = function (_TaskStatisticRecord) {
  _inherits(TaskStatistic, _TaskStatisticRecord);

  function TaskStatistic() {
    _classCallCheck(this, TaskStatistic);

    return _possibleConstructorReturn(this, (TaskStatistic.__proto__ || Object.getPrototypeOf(TaskStatistic)).apply(this, arguments));
  }

  return TaskStatistic;
}(TaskStatisticRecord);

TaskStatistic.create = function (data) {
  return new TaskStatistic(data);
};

exports.default = TaskStatistic;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaskFilterOptions = undefined;

var _omniCommonUi = __webpack_require__(0);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _style = __webpack_require__(2087);

var _style2 = _interopRequireDefault(_style);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TaskFilterOptions = exports.TaskFilterOptions = [{
  label: 'Tasks in 24 hours',
  value: false
}, {
  label: 'All',
  value: true
}];

var TaskFilter = function TaskFilter(props) {
  return _react2.default.createElement(
    _omniCommonUi.Form,
    { className: _style2.default.Filter },
    _react2.default.createElement(
      'label',
      null,
      'Task Filter'
    ),
    _react2.default.createElement(_omniCommonUi.Form.Select, { className: _style2.default.Filter_select,
      searchable: false,
      clearable: false,
      name: 'taskFilter',
      options: TaskFilterOptions,
      value: props.value,
      setValue: function setValue(value) {
        return props.handleFilterChange(value);
      },
      fieldOptions: {
        labelTextClassName: _style2.default.Filters_label,
        neighborStackMode: 'horizontal',
        innerStackMode: 'vertical'
      } })
  );
};

TaskFilter.propTypes = {
  handleFilterChange: _propTypes2.default.func,
  value: _propTypes2.default.string
};

TaskFilter.options = TaskFilterOptions;

exports.default = TaskFilter;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeacherTasks = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2090);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _TaskProgressCard = __webpack_require__(842);

var _TaskProgressCard2 = _interopRequireDefault(_TaskProgressCard);

var _redux = __webpack_require__(10);

var _Tasks = __webpack_require__(339);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _TableView = __webpack_require__(59);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MyTasks = __webpack_require__(841);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FILTER_TYPE_TASK_OWNER = 'taskOwner';
var FILTER_TYPE_TASK_CENTRE = 'taskCentre';
var FILTER_TYPE_TASK_SUBJECT = 'taskSubject';

var convertNamesToLabelsAndIdsToValues = function convertNamesToLabelsAndIdsToValues(list) {
  return list.map(function (item) {
    return { label: item.name, value: item.id };
  });
};

var convertDescriptionsToLabelsAndCodesToValues = function convertDescriptionsToLabelsAndCodesToValues(list) {
  return list.map(function (item) {
    return { label: _Tasks.accessors.getTaskSubject(item.description), value: item.code };
  });
};

var TeacherTasks = exports.TeacherTasks = function (_PureComponent) {
  _inherits(TeacherTasks, _PureComponent);

  function TeacherTasks(props) {
    var _filterParams;

    _classCallCheck(this, TeacherTasks);

    var _this = _possibleConstructorReturn(this, (TeacherTasks.__proto__ || Object.getPrototypeOf(TeacherTasks)).call(this, props));

    _this.state = {
      filterParams: (_filterParams = {
        pageSize: 10,
        pageNumber: 1,
        sortBy: 'generatedTime',
        sortType: 'Descending'
      }, _defineProperty(_filterParams, FILTER_TYPE_TASK_OWNER, 0), _defineProperty(_filterParams, FILTER_TYPE_TASK_CENTRE, 0), _defineProperty(_filterParams, FILTER_TYPE_TASK_SUBJECT, 0), _filterParams),
      taskFilter: false,
      shouldPopupDialog: false
    };

    _this._renderTableRow = _this._renderTableRow.bind(_this);
    _this._handleOnFilterChange = _this._handleOnFilterChange.bind(_this);
    return _this;
  }

  _createClass(TeacherTasks, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._fetchTaskStatistics('teacher-tasks');
      this.props.fetchTaskCentresIfNeeded();
      this.props.fetchTaskOwnersIfNeeded();
      this.props.fetchTaskTypesIfNeeded();
      if (this.props.taskCentres.size > 0) {
        this._handleTableFilterChanged(FILTER_TYPE_TASK_CENTRE, this.props.taskCentres.get(0).id);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (this.props.taskCentres.size === 0 && props.taskCentres.size > 0) {
        var centreId = props.taskCentres.get(0).id;
        this._handleTableFilterChanged(FILTER_TYPE_TASK_CENTRE, centreId);
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.filterParams === this.state.filterParams) {
        return;
      }

      this._fetchDosTasks(nextState.filterParams);
    }
  }, {
    key: '_onCancelTaskButtonClick',
    value: function _onCancelTaskButtonClick(taskId) {
      this._toggleConfirmDialog(true, taskId);
    }
  }, {
    key: '_toggleConfirmDialog',
    value: function _toggleConfirmDialog(isDialogShow, taskId) {
      this.setState({ shouldPopupDialog: isDialogShow, currentTaskId: '' + taskId });
    }
  }, {
    key: '_onDiscardClicked',
    value: function _onDiscardClicked() {
      this._toggleConfirmDialog(false);
    }
  }, {
    key: '_onSaveButtonClicked',
    value: function _onSaveButtonClicked() {
      var _this2 = this;

      var currentTaskId = this.state.currentTaskId;
      if (currentTaskId) {
        this.props.cancelTask(currentTaskId).then(function () {
          return _this2._toggleConfirmDialog(false);
        }).then(function () {
          return _this2._fetchDosTasks(_this2.state.filterParams);
        });
      }
    }
  }, {
    key: '_renderConfirmDialog',
    value: function _renderConfirmDialog() {
      var _this3 = this;

      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: this.state.shouldPopupDialog,
          primaryButtonContent: 'Yes',
          secondaryButtonContent: 'No',
          onPrimaryClick: function onPrimaryClick() {
            return _this3._onSaveButtonClicked();
          },
          onSecondaryClick: function onSecondaryClick() {
            return _this3._onDiscardClicked();
          },
          onRequestClose: function onRequestClose() {
            return _this3._onDiscardClicked();
          } },
        _react2.default.createElement(
          'span',
          null,
          'This task will be deleted from task owner\'s task list.'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'span',
          null,
          'Are you sure you want to cancel this task.'
        )
      );
    }
  }, {
    key: '_renderStatisticCard',
    value: function _renderStatisticCard() {
      var taskCounts = this.props.taskStatisticResult.taskStatistics || [];
      var sinceTime = this.props.taskStatisticResult.statisticFromDateTime || '';
      return _react2.default.createElement(_TaskProgressCard2.default, { cardTitle: 'Staff Tasks Completion',
        className: (0, _omniCommonUi.testClass)('staff-tasks-completion'),
        tasksCounts: taskCounts,
        sinceTime: sinceTime });
    }
  }, {
    key: '_handleOnFilterChange',
    value: function _handleOnFilterChange(filterParams) {
      this.setState({ filterParams: filterParams });
    }
  }, {
    key: '_handleTableFilterChanged',
    value: function _handleTableFilterChanged(type, value) {
      var _filterParams2;

      var filterParams = (_filterParams2 = {
        pageSize: 10,
        pageNumber: 1,
        sortBy: 'generatedTime',
        sortType: 'Descending'
      }, _defineProperty(_filterParams2, FILTER_TYPE_TASK_OWNER, this.state.filterParams.taskOwner || 0), _defineProperty(_filterParams2, FILTER_TYPE_TASK_CENTRE, this.state.filterParams.taskCentre || 0), _defineProperty(_filterParams2, FILTER_TYPE_TASK_SUBJECT, this.state.filterParams.taskSubject || 0), _filterParams2);
      Object.assign(filterParams, _defineProperty({}, type, value || 0));

      this._handleOnFilterChange(filterParams);
    }
  }, {
    key: '_fetchTaskStatistics',
    value: function _fetchTaskStatistics() {
      var taskFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.taskFilter;

      this.props.fetchTaskStatistics('teacher-tasks', taskFilter);
    }
  }, {
    key: '_fetchDosTasks',
    value: function _fetchDosTasks() {
      var filterParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.filterParams;
      var taskFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.taskFilter;

      var filter = _extends({}, filterParams, { taskFilter: taskFilter });
      this.props.fetchDosTasks(filter);
    }
  }, {
    key: '_handleOnTaskFilterChange',
    value: function _handleOnTaskFilterChange(taskFilter) {
      this.setState({ taskFilter: taskFilter });
      this._fetchDosTasks(this.state.filterParams, taskFilter);
      this._fetchTaskStatistics(taskFilter);
    }
  }, {
    key: '_renderTableRow',
    value: function _renderTableRow(row) {
      var _this4 = this;

      var hasCancelTaskPrivilege = this.props.hasCancelTaskPrivilege;

      return _react2.default.createElement(
        _TableView.TableViewTr,
        null,
        _react2.default.createElement(_TableView.TextTd, { text: _Tasks.accessors.getTaskSubject(row.subject) }),
        _react2.default.createElement(_TableView.TextTd, { text: row.owner }),
        _react2.default.createElement(_TableView.StatusTd, { text: row.statusName }),
        _react2.default.createElement(_TableView.TextTd, { text: row.itemsAffected }),
        _react2.default.createElement(_TableView.TextTd, { text: row.details }),
        _react2.default.createElement(_TableView.TextTd, { text: row.dueDate }),
        hasCancelTaskPrivilege && _react2.default.createElement(_TableView.ButtonTd, { text: 'Cancel',
          onButtonClick: function onButtonClick() {
            return _this4._onCancelTaskButtonClick(row.id);
          } }),
        _react2.default.createElement(_TableView.DetailLinkTd, { url: row.redirectUrl })
      );
    }
  }, {
    key: '_renderTaskOwnerFilter',
    value: function _renderTaskOwnerFilter() {
      var _this5 = this;

      var taskOwnersResult = this.props.taskOwnersResult;

      if (!taskOwnersResult.data) return;
      return _react2.default.createElement(_omniCommonUi.Form.Select, { clearable: true,
        searchable: true,
        name: 'owner',
        label: 'Select Owner',
        options: convertNamesToLabelsAndIdsToValues(taskOwnersResult.data),
        value: this.state.filterParams[FILTER_TYPE_TASK_OWNER],
        setValue: function setValue(value) {
          _this5._handleTableFilterChanged(FILTER_TYPE_TASK_OWNER, value);
        },
        fieldOptions: {
          className: _style2.default.TeacherTasks_filters_field,
          labelTextClassName: _style2.default.TeacherTasks_filters_field_label,
          neighborStackMode: 'horizontal',
          innerStackMode: 'vertical'
        } });
    }
  }, {
    key: '_renderTaskCentreFilter',
    value: function _renderTaskCentreFilter() {
      var _this6 = this;

      var taskCentres = this.props.taskCentres;

      return _react2.default.createElement(_omniCommonUi.Form.Select, { clearable: false,
        searchable: true,
        name: 'centre',
        label: 'Select Centre',
        options: convertNamesToLabelsAndIdsToValues(taskCentres.toJS()),
        value: this.state.filterParams[FILTER_TYPE_TASK_CENTRE],
        setValue: function setValue(value) {
          _this6._handleTableFilterChanged(FILTER_TYPE_TASK_CENTRE, value);
        },
        fieldOptions: {
          className: _style2.default.TeacherTasks_filters_field,
          labelTextClassName: _style2.default.TeacherTasks_filters_field_label,
          neighborStackMode: 'horizontal',
          innerStackMode: 'vertical'
        } });
    }
  }, {
    key: '_renderTaskTypesFilter',
    value: function _renderTaskTypesFilter() {
      var _this7 = this;

      var taskTypes = this.props.taskTypes;

      var options = taskTypes.filter(function (type) {
        return type.code !== 'MA';
      });
      return _react2.default.createElement(_omniCommonUi.Form.Select, { clearable: true,
        searchable: true,
        name: 'subject',
        label: 'Select Subject',
        options: convertDescriptionsToLabelsAndCodesToValues(options.toJS()),
        value: this.state.filterParams[FILTER_TYPE_TASK_SUBJECT],
        setValue: function setValue(value) {
          _this7._handleTableFilterChanged(FILTER_TYPE_TASK_SUBJECT, value);
        },
        fieldOptions: {
          className: _style2.default.TeacherTasks_filters_field,
          labelTextClassName: _style2.default.TeacherTasks_filters_field_label,
          neighborStackMode: 'horizontal',
          innerStackMode: 'vertical'
        } });
    }
  }, {
    key: '_renderTaskFilters',
    value: function _renderTaskFilters() {
      return _react2.default.createElement(
        _omniCommonUi.Form,
        { className: _style2.default.TeacherTasks_filters },
        this._renderTaskCentreFilter(),
        this._renderTaskOwnerFilter(),
        this._renderTaskTypesFilter()
      );
    }
  }, {
    key: '_renderTaskTable',
    value: function _renderTaskTable() {
      var _props = this.props,
          dosTaskFilterResult = _props.dosTaskFilterResult,
          hasCancelTaskPrivilege = _props.hasCancelTaskPrivilege;

      if (!_omniCommonUi.ApiResponseHelper.hasSucceeded(dosTaskFilterResult)) {
        return null;
      }

      var data = dosTaskFilterResult.data;
      var headers = [{ key: 'subject', text: 'Subject', sortable: true }, { key: 'firstName', text: 'Owner', sortable: true }, { key: 'statusName', text: 'Status', sortable: true }, { key: 'itemsAffected', text: 'Items Affected', sortable: true }, { key: 'description', text: 'Details', sortable: true }, { key: 'dueDateTimeUtc', text: 'Due Date', sortable: true }, { key: 'link', text: '', sortable: false }];
      hasCancelTaskPrivilege && headers.splice(-1, 0, { key: 'CancelButton', text: '', sortable: false });
      return _react2.default.createElement(
        _omniCommonUi.Grid.Item,
        null,
        _react2.default.createElement(_TableView.TableView, { tableTitle: 'Staff Tasks',
          className: (0, _omniCommonUi.testClass)('staff-tasks'),
          noResultsString: 'No results yet.',
          totalRecords: data.totalRecords,
          source: data.tasks,
          headers: headers,
          pageable: true,
          query: this.state.filterParams,
          renderTableRow: this._renderTableRow,
          onFilterChange: this._handleOnFilterChange,
          customerPageControlRightPart: this._renderTaskFilters() })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { outerMargin: true },
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          _react2.default.createElement(
            _omniCommonUi.Grid.Item,
            null,
            _react2.default.createElement(_MyTasks.TaskFilter, { value: this.state.taskFilter,
              handleFilterChange: function handleFilterChange(val) {
                return _this8._handleOnTaskFilterChange(val);
              } })
          ),
          _react2.default.createElement(
            _omniCommonUi.Grid.Item,
            null,
            this._renderStatisticCard()
          ),
          this._renderTaskTable()
        ),
        this._renderConfirmDialog()
      );
    }
  }]);

  return TeacherTasks;
}(_react.PureComponent);

TeacherTasks.propTypes = {
  dosTaskFilterResult: _propTypes2.default.object,
  taskOwnersResult: _propTypes2.default.object,
  fetchDosTasks: _propTypes2.default.func.isRequired,
  fetchTaskOwnersIfNeeded: _propTypes2.default.func.isRequired,
  taskStatisticResult: _propTypes2.default.object,
  fetchTaskStatistics: _propTypes2.default.func.isRequired,
  fetchTaskCentresIfNeeded: _propTypes2.default.func.isRequired,
  fetchTaskTypesIfNeeded: _propTypes2.default.func.isRequired,
  taskCentres: _propTypes2.default.object.isRequired,
  taskTypes: _propTypes2.default.object.isRequired,
  isLoadingTaskCentres: _propTypes2.default.bool.isRequired,
  hasCancelTaskPrivilege: _propTypes2.default.bool.isRequired,
  cancelTask: _propTypes2.default.func.isRequired
};

function mapStateToProps(state) {
  var dosTaskFilterResult = state.get('rootReducer').get('dosTaskFilterResult');
  var taskOwnersResult = state.get('rootReducer').get('taskOwnersResult');
  var taskCentres = state.get('rootReducer').get('taskCentres');
  var taskTypes = state.get('rootReducer').get('taskTypes');
  var taskStatisticResult = state.get('rootReducer').get('taskStatisticResult');
  var isLoadingTaskCentres = _isLoadingTaskCentres(state);
  return {
    dosTaskFilterResult: dosTaskFilterResult,
    taskOwnersResult: taskOwnersResult,
    taskCentres: taskCentres,
    taskTypes: taskTypes,
    taskStatisticResult: taskStatisticResult,
    isLoadingTaskCentres: isLoadingTaskCentres,
    hasCancelTaskPrivilege: _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.GroupTask.CancelGroupTask)
  };
}

function _isLoadingTaskCentres(state) {
  var callState = _omniCommonUi.ApiCall.find(state, { method: 'GET', url: _Tasks.actions.taskOwnersUrl });
  return _omniCommonUi.ApiCall.State.isValue(callState) && _omniCommonUi.ApiCall.State.isLoading(callState);
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, (0, _redux.bindActionCreators)(_Tasks.actions, dispatch), (0, _redux.bindActionCreators)(_Tasks.taskStatisticActions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(TeacherTasks);

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AcademicInfo = function (_PureComponent) {
  _inherits(AcademicInfo, _PureComponent);

  function AcademicInfo() {
    _classCallCheck(this, AcademicInfo);

    return _possibleConstructorReturn(this, (AcademicInfo.__proto__ || Object.getPrototypeOf(AcademicInfo)).apply(this, arguments));
  }

  _createClass(AcademicInfo, [{
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AcademicInfo;
}(_react.PureComponent);

exports.default = AcademicInfo;


AcademicInfo.propTypes = {
  children: _propTypes2.default.node.isRequired
};

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2095);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(10);

var _reactRouter = __webpack_require__(16);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _RadialScoreDisplay = __webpack_require__(283);

var _RadialScoreDisplay2 = _interopRequireDefault(_RadialScoreDisplay);

var _NoContentMessage = __webpack_require__(66);

var _NoContentMessage2 = _interopRequireDefault(_NoContentMessage);

var _AcademicInfo = __webpack_require__(341);

var _Summary = __webpack_require__(855);

var _OverviewBadge = __webpack_require__(2108);

var _OverviewBadge2 = _interopRequireDefault(_OverviewBadge);

var _routes = __webpack_require__(340);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AcademicInfoGroups = function (_PureComponent) {
  _inherits(AcademicInfoGroups, _PureComponent);

  function AcademicInfoGroups() {
    _classCallCheck(this, AcademicInfoGroups);

    return _possibleConstructorReturn(this, (AcademicInfoGroups.__proto__ || Object.getPrototypeOf(AcademicInfoGroups)).apply(this, arguments));
  }

  _createClass(AcademicInfoGroups, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.fetchAcademicInfoGroupListIfNeeded(this._isAllGroups());
      this._fetchAcademicSummariesIfNeeded(this.props.academicInfoGroups);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      props.fetchAcademicInfoGroupListIfNeeded(this._isAllGroups(props));
      this._fetchAcademicSummariesIfNeeded(props.academicInfoGroups);
    }
  }, {
    key: '_fetchAcademicSummariesIfNeeded',
    value: function _fetchAcademicSummariesIfNeeded(groups) {
      var _this2 = this;

      if (_immutable.List.isList(groups)) {
        groups.forEach(function (_ref) {
          var groupId = _ref.id;

          _this2.props.fetchAcademicInfoSummaryIfNeeded(groupId);
        });
      }
    }
  }, {
    key: '_isAllGroups',
    value: function _isAllGroups() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      return props.location.pathname.indexOf(_routes.ALL_GROUPS) > 0;
    }
  }, {
    key: '_renderOverviewBadge',
    value: function _renderOverviewBadge(academicInfoSummaryForGroup) {
      if (_is_js2.default.undefined(academicInfoSummaryForGroup)) {
        return null;
      }
      var studentNumberWithLowerPTScore = academicInfoSummaryForGroup.studentNumberWithLowerPTScore,
          studentNumberWithLowerSkillScore = academicInfoSummaryForGroup.studentNumberWithLowerSkillScore;

      return _react2.default.createElement(_OverviewBadge2.default, { className: _style2.default.AcademicInfoGroups_cardContent_badge,
        studentNumberWithLowerPTScore: studentNumberWithLowerPTScore,
        studentNumberWithLowerSkillScore: studentNumberWithLowerSkillScore });
    }
  }, {
    key: '_renderAcademicInfoDetail',
    value: function _renderAcademicInfoDetail(summary) {
      if (!_is_js2.default.existy(summary) || !_is_js2.default.existy(summary.progressTestAverageScore)) {
        var noDataClass = (0, _classnames2.default)(_style2.default.AcademicInfoGroups_cardContent_info, _style2.default.__empty);
        var noDataText = 'We\'re waiting for data!';
        return _react2.default.createElement(
          'div',
          { className: noDataClass },
          noDataText
        );
      }
      return _react2.default.createElement(
        _omniCommonUi.PageCard.Content,
        { className: _style2.default.AcademicInfoGroups_cardContent },
        this._renderOverviewBadge(summary),
        _react2.default.createElement(
          'div',
          { className: _style2.default.AcademicInfoGroups_cardContent_info },
          summary && _react2.default.createElement(_RadialScoreDisplay2.default, { radius: 25,
            circleStrokeWidth: 2,
            edgeSize: 70,
            forcedTextY: 40,
            unit: 'percent',
            displayText: true,
            circleStroke: 'transparent',
            formatText: function formatText(value) {
              return value + '%';
            },
            value: summary.progressTestAverageScore }),
          'Unit Quizs',
          _react2.default.createElement('br', null),
          'Average Score'
        )
      );
    }
  }, {
    key: '_renderAcademicInfoGroup',
    value: function _renderAcademicInfoGroup() {
      var _this3 = this;

      var _props = this.props,
          academicInfoGroups = _props.academicInfoGroups,
          academicInfoSummaries = _props.academicInfoSummaries,
          buildRoute = _props.buildRoute;

      if (academicInfoGroups.size === 0) return;
      return academicInfoGroups.map(function (academicInfoGroup) {
        var academicInfoSummaryForGroup = academicInfoSummaries.get('' + academicInfoGroup.id);
        return _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          { key: academicInfoGroup.id },
          _react2.default.createElement(
            _omniCommonUi.PageCard,
            null,
            _react2.default.createElement(
              _omniCommonUi.PageCard.Heading,
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: buildRoute('/group/' + academicInfoGroup.id),
                  draggable: false },
                academicInfoGroup.groupName + ' | ' + academicInfoGroup.groupCode
              )
            ),
            _react2.default.createElement(
              _omniCommonUi.PageCard.Content,
              { className: _style2.default.AcademicInfoGroups_cardContent },
              _this3._renderAcademicInfoDetail(academicInfoSummaryForGroup)
            )
          )
        );
      });
    }
  }, {
    key: '_renderNoCotentMessage',
    value: function _renderNoCotentMessage() {
      if (this.props.academicInfoGroups.size > 0) return;
      return _react2.default.createElement(_NoContentMessage2.default, { text: 'There are no groups on your schedule.' });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { outerMargin: true },
        this._renderAcademicInfoGroup(),
        this._renderNoCotentMessage()
      );
    }
  }]);

  return AcademicInfoGroups;
}(_react.PureComponent);

AcademicInfoGroups.propTypes = {
  fetchAcademicInfoGroupListIfNeeded: _propTypes2.default.func.isRequired,
  fetchAcademicInfoSummaryIfNeeded: _propTypes2.default.func.isRequired,
  academicInfoGroups: _propTypes2.default.shape().isRequired,
  academicInfoSummaries: _propTypes2.default.shape({
    get: _propTypes2.default.func
  }).isRequired,
  location: _propTypes2.default.shape().isRequired,
  buildRoute: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var academicInfoGroups = state.get('rootReducer').get('academicInfoGroups').toList();
  if (ownProps.location.pathname.indexOf(_routes.ALL_GROUPS) < 0) {
    academicInfoGroups = academicInfoGroups.filter(function (academicInfoGroup) {
      return academicInfoGroup.isTodayGroup;
    });
  }
  var academicInfoSummaries = state.get('rootReducer').get('academicInfoSummary');
  return {
    academicInfoGroups: academicInfoGroups,
    academicInfoSummaries: academicInfoSummaries
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign((0, _redux.bindActionCreators)(_AcademicInfo.actions, dispatch), (0, _redux.bindActionCreators)(_Summary.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(AcademicInfoGroups);

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_FAILURE = exports.FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_SUCCESS = exports.FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_REQUEST = exports.FETCH_ACADEMIC_INFO_GROUP_LIST_FAILURE = exports.FETCH_ACADEMIC_INFO_GROUP_LIST_SUCCESS = exports.FETCH_ACADEMIC_INFO_GROUP_LIST_REQUEST = undefined;
exports.fetchAcademicInfoGroupListIfNeeded = fetchAcademicInfoGroupListIfNeeded;
exports.fetchAcademicInfoGroupList = fetchAcademicInfoGroupList;
exports.fetchAcademicInfoConcernsStudentSkills = fetchAcademicInfoConcernsStudentSkills;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_ACADEMIC_INFO_GROUP_LIST_REQUEST = exports.FETCH_ACADEMIC_INFO_GROUP_LIST_REQUEST = 'FETCH_ACADEMIC_INFO_GROUP_LIST_REQUEST';
var FETCH_ACADEMIC_INFO_GROUP_LIST_SUCCESS = exports.FETCH_ACADEMIC_INFO_GROUP_LIST_SUCCESS = 'FETCH_ACADEMIC_INFO_GROUP_LIST_SUCCESS';
var FETCH_ACADEMIC_INFO_GROUP_LIST_FAILURE = exports.FETCH_ACADEMIC_INFO_GROUP_LIST_FAILURE = 'FETCH_ACADEMIC_INFO_GROUP_LIST_FAILURE';
var FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_REQUEST = exports.FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_REQUEST = 'FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_REQUEST';
var FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_SUCCESS = exports.FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_SUCCESS = 'FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_SUCCESS';
var FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_FAILURE = exports.FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_FAILURE = 'FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_FAILURE';

var buildAcademicInfoSummaryUrl = function buildAcademicInfoSummaryUrl(isAllGroups) {
  return (0, _Api.buildUrl)('/users/academic-info/my-groups?isAllGroups=' + isAllGroups);
};

function fetchAcademicInfoGroupListIfNeeded(isAllGroups) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildAcademicInfoSummaryUrl(isAllGroups) })) {
      return false;
    }

    return dispatch(fetchAcademicInfoGroupList(isAllGroups));
  };
}

function fetchAcademicInfoGroupList(isAllGroups) {
  return function (dispatch) {
    var method = 'GET';
    var url = buildAcademicInfoSummaryUrl(isAllGroups);

    return dispatch(fetchAcademicInfoGroupListRequest()).payload.then(function (response) {
      return dispatch(fetchAcademicInfoGroupListSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchAcademicInfoGroupListFailure(error));
    });

    function fetchAcademicInfoGroupListRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_GROUP_LIST_REQUEST,
        payload: (0, _Api.fetch)(url),
        method: method,
        url: url
      });
    }

    function fetchAcademicInfoGroupListSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_GROUP_LIST_SUCCESS,
        payload: response,
        isAllGroups: isAllGroups,
        method: method,
        url: url
      });
    }

    function fetchAcademicInfoGroupListFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_GROUP_LIST_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

function fetchAcademicInfoConcernsStudentSkills(scoresFrom, scoresTo) {
  return function (dispatch) {
    var method = 'GET';
    var url = (0, _Api.buildUrl)('/users/academic-info/concerns/student-skills?' + ('scoresFrom=' + scoresFrom + '&') + ('scoresTo=' + scoresTo));

    return dispatch(fetchAcademicInfoConcernsStudentSkillsRequest()).payload.then(function (response) {
      return dispatch(fetchAcademicInfoConcernsStudentSkillsSuccess(response));
    }).catch(function (error) {
      return dispatch(fetchAcademicInfoConcernsStudentSkillsFailure(error));
    });

    function fetchAcademicInfoConcernsStudentSkillsRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_REQUEST,
        payload: (0, _Api.fetch)(url),
        method: method,
        url: url
      });
    }

    function fetchAcademicInfoConcernsStudentSkillsSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_SUCCESS,
        payload: response,
        method: method,
        url: url
      });
    }

    function fetchAcademicInfoConcernsStudentSkillsFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_FAILURE,
        method: method,
        url: url,
        error: error
      });
    }
  };
}

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AcademicInfoGroupRecord = _immutable2.default.Record({
  id: undefined,
  groupName: undefined,
  groupCode: undefined,
  isTodayGroup: undefined
});

var AcademicInfoGroup = function (_AcademicInfoGroupRec) {
  _inherits(AcademicInfoGroup, _AcademicInfoGroupRec);

  function AcademicInfoGroup() {
    _classCallCheck(this, AcademicInfoGroup);

    return _possibleConstructorReturn(this, (AcademicInfoGroup.__proto__ || Object.getPrototypeOf(AcademicInfoGroup)).apply(this, arguments));
  }

  return AcademicInfoGroup;
}(AcademicInfoGroupRecord);

exports.default = AcademicInfoGroup;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConcernsSutdentSkillRecord = _immutable2.default.Record({
  groupId: undefined,
  groupCode: undefined,
  recentUnit: undefined,
  studentGeneralInfo: undefined,
  skillScores: undefined
});

var ConcernsSutdentSkill = function (_ConcernsSutdentSkill) {
  _inherits(ConcernsSutdentSkill, _ConcernsSutdentSkill);

  function ConcernsSutdentSkill() {
    _classCallCheck(this, ConcernsSutdentSkill);

    return _possibleConstructorReturn(this, (ConcernsSutdentSkill.__proto__ || Object.getPrototypeOf(ConcernsSutdentSkill)).apply(this, arguments));
  }

  return ConcernsSutdentSkill;
}(ConcernsSutdentSkillRecord);

exports.default = ConcernsSutdentSkill;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentGeneralInfoRecord = _immutable2.default.Record({
  id: undefined,
  firstName: undefined,
  lastName: undefined,
  localName: undefined,
  studentNumber: undefined,
  avatarUrl: undefined,
  gender: undefined
});

var StudentGeneralInfo = function (_StudentGeneralInfoRe) {
  _inherits(StudentGeneralInfo, _StudentGeneralInfoRe);

  function StudentGeneralInfo() {
    _classCallCheck(this, StudentGeneralInfo);

    return _possibleConstructorReturn(this, (StudentGeneralInfo.__proto__ || Object.getPrototypeOf(StudentGeneralInfo)).apply(this, arguments));
  }

  return StudentGeneralInfo;
}(StudentGeneralInfoRecord);

exports.default = StudentGeneralInfo;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SkillScoreRecord = _immutable2.default.Record({
  skillId: undefined,
  name: undefined,
  score: undefined
});

var SkillScore = function (_SkillScoreRecord) {
  _inherits(SkillScore, _SkillScoreRecord);

  function SkillScore() {
    _classCallCheck(this, SkillScore);

    return _possibleConstructorReturn(this, (SkillScore.__proto__ || Object.getPrototypeOf(SkillScore)).apply(this, arguments));
  }

  return SkillScore;
}(SkillScoreRecord);

exports.default = SkillScore;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.academicInfoConcernsStudentSkills = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(856);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(2106);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var academicInfoConcernsStudentSkills = exports.academicInfoConcernsStudentSkills = _reducer2.academicInfoConcernsStudentSkills;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_ACADEMIC_INFO_SUMMARY_FAILURE = exports.FETCH_ACADEMIC_INFO_SUMMARY_SUCCESS = exports.FETCH_ACADEMIC_INFO_SUMMARY_REQUEST = undefined;
exports.getApiCallState = getApiCallState;
exports.fetchAcademicInfoSummaryIfNeeded = fetchAcademicInfoSummaryIfNeeded;
exports.fetchAcademicInfoSummary = fetchAcademicInfoSummary;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var FETCH_ACADEMIC_INFO_SUMMARY_REQUEST = exports.FETCH_ACADEMIC_INFO_SUMMARY_REQUEST = 'FETCH_ACADEMIC_INFO_SUMMARY_REQUEST';
var FETCH_ACADEMIC_INFO_SUMMARY_SUCCESS = exports.FETCH_ACADEMIC_INFO_SUMMARY_SUCCESS = 'FETCH_ACADEMIC_INFO_SUMMARY_SUCCESS';
var FETCH_ACADEMIC_INFO_SUMMARY_FAILURE = exports.FETCH_ACADEMIC_INFO_SUMMARY_FAILURE = 'FETCH_ACADEMIC_INFO_SUMMARY_FAILURE';

var buildAcademicInfoSummaryUrl = function buildAcademicInfoSummaryUrl(groupId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/academic-info/summary');
};

function getApiCallState(state, groupId) {
  return _omniCommonUi.ApiCall.find(state, { method: 'GET', url: buildAcademicInfoSummaryUrl(groupId) });
}

function fetchAcademicInfoSummaryIfNeeded(groupId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!_omniCommonUi.ApiCall.shouldPerform(state, { method: 'GET', url: buildAcademicInfoSummaryUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchAcademicInfoSummary(groupId));
  };
}

function fetchAcademicInfoSummary(groupId) {
  return function (dispatch) {
    var url = buildAcademicInfoSummaryUrl(groupId);
    var method = 'GET';

    return dispatch(fetchAcademicInfoSummaryRequest()).payload.then(function (response) {
      return dispatch(fetchAcademicInfoSummarySuccess(response));
    }).catch(function (error) {
      return dispatch(fetchAcademicInfoSummaryFailure(error));
    });

    function fetchAcademicInfoSummaryRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_SUMMARY_REQUEST,
        payload: (0, _Api.fetch)(url),
        url: url,
        method: method,
        groupId: groupId,
        disableDefault: true
      });
    }

    function fetchAcademicInfoSummarySuccess(summary) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_SUMMARY_SUCCESS,
        payload: summary,
        url: url,
        method: method,
        groupId: groupId
      });
    }

    function fetchAcademicInfoSummaryFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_SUMMARY_FAILURE,
        error: error,
        url: url,
        method: method,
        groupId: groupId,
        disableDefault: true
      });
    }
  };
}

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BadgeType = Object.freeze({ WARNING: 0, INFO: 1 });
exports.default = BadgeType;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2116);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _redux = __webpack_require__(10);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _AcademicInfo = __webpack_require__(341);

var _TableView = __webpack_require__(59);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ASCENDING = 'Ascending';
var DESCENDING = 'Descending';
var skillScoresHeaders = [{ key: 'listening', text: 'Listening' }, { key: 'grammar', text: 'Grammar' }, { key: 'reading', text: 'Reading' }, { key: 'vocabulary', text: 'Vocabulary' }, { key: 'writing', text: 'Writing' }, { key: 'speaking', text: 'Speaking' }, { key: 'phonics', text: 'Phonics' }];
var NUMBER_OF_DEFAULT_STUDENTS = 3;

var Concerns = function (_PureComponent) {
  _inherits(Concerns, _PureComponent);

  function Concerns(props) {
    _classCallCheck(this, Concerns);

    var _this = _possibleConstructorReturn(this, (Concerns.__proto__ || Object.getPrototypeOf(Concerns)).call(this, props));

    _this.state = {
      queryParams: {},
      scoreFrom: 0,
      scoreTo: 69,
      isExpand: false
    };
    _this._renderTableRow = _this._renderTableRow.bind(_this);
    _this._onFilterChange = _this._onFilterChange.bind(_this);
    _this._onScoreFromChange = _this._onScoreFromChange.bind(_this);
    _this._onScoreToChange = _this._onScoreToChange.bind(_this);
    _this._onFilterApply = _this._onFilterApply.bind(_this);
    _this._sortStudents = _this._sortStudents.bind(_this);
    return _this;
  }

  _createClass(Concerns, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._fetchStudentSkills();
    }
  }, {
    key: '_fetchStudentSkills',
    value: function _fetchStudentSkills() {
      var _state = this.state,
          scoreFrom = _state.scoreFrom,
          scoreTo = _state.scoreTo;

      if (_is_js2.default.not.number(scoreFrom) || _is_js2.default.not.number(scoreTo)) return;
      if (scoreFrom > scoreTo) return;
      this.props.fetchAcademicInfoConcernsStudentSkills(scoreFrom, scoreTo);
    }
  }, {
    key: '_onScoreFromChange',
    value: function _onScoreFromChange(value) {
      this.setState({ scoreFrom: value });
    }
  }, {
    key: '_onScoreToChange',
    value: function _onScoreToChange(value) {
      this.setState({ scoreTo: value });
    }
  }, {
    key: '_onFilterApply',
    value: function _onFilterApply() {
      this._fetchStudentSkills();
    }
  }, {
    key: '_renderScoresFilter',
    value: function _renderScoresFilter(headersCount) {
      var _state2 = this.state,
          scoreFrom = _state2.scoreFrom,
          scoreTo = _state2.scoreTo;

      return _react2.default.createElement(
        _TableView.TableViewTr,
        null,
        _react2.default.createElement(
          _TableView.NormalTd,
          { colSpan: headersCount, className: _style2.default.Concerns_filters },
          _react2.default.createElement(
            'span',
            null,
            'Scores(%) from'
          ),
          _react2.default.createElement(_omniCommonUi.NumberInput, { className: _style2.default.Concerns_filters_input,
            value: scoreFrom,
            min: '0',
            max: '100',
            onChange: this._onScoreFromChange }),
          _react2.default.createElement(
            'span',
            null,
            'to'
          ),
          _react2.default.createElement(_omniCommonUi.NumberInput, { className: _style2.default.Concerns_filters_input,
            value: scoreTo,
            min: '0',
            max: '100',
            onChange: this._onScoreToChange }),
          _react2.default.createElement(
            _omniCommonUi.Button,
            { type: _omniCommonUi.Button.Type.primary,
              onClick: this._onFilterApply,
              className: _style2.default.Concerns_filters_button },
            _react2.default.createElement(_omniCommonUi.Icon, { id: 'cycle' })
          )
        )
      );
    }
  }, {
    key: '_onSort',
    value: function _onSort(sortKey) {
      var sortType = ASCENDING;
      if (sortKey === this.state.sortKey) {
        sortType = this.state.sortType === ASCENDING ? DESCENDING : ASCENDING;
      }
      this.setState({ sortKey: sortKey, sortType: sortType });
    }
  }, {
    key: '_renderTableHeaderRow',
    value: function _renderTableHeaderRow() {
      var _this2 = this;

      var _state3 = this.state,
          sortKey = _state3.sortKey,
          sortType = _state3.sortType;

      var headers = [{ key: 'name', text: 'Name' }, { key: 'groupCode', text: 'Group Code' }].concat(skillScoresHeaders, [{ key: 'recentUnit', text: 'Latest Unit' }]);
      var columnHeaders = _react2.default.createElement(
        _TableView.TableViewTr,
        null,
        headers.map(function (header) {
          return _react2.default.createElement(
            _TableView.HeaderTd,
            { sortable: true,
              sortType: sortKey === header.key ? sortType : '',
              onSort: function onSort() {
                return _this2._onSort(header.key);
              },
              key: header.key },
            header.text
          );
        })
      );
      var headersCount = _react2.default.Children.count(columnHeaders.props.children);

      return [this._renderScoresFilter(headersCount), columnHeaders];
    }
  }, {
    key: '_renderSkillScores',
    value: function _renderSkillScores(row) {
      return skillScoresHeaders.map(function (skillScoresHeader) {
        var filteredSkillScore = row.skillScores.find(function (skillScore) {
          return skillScore.name.toLowerCase().trim() === skillScoresHeader.key.toLowerCase();
        });
        if (!filteredSkillScore || _is_js2.default.not.existy(filteredSkillScore.score)) {
          return _react2.default.createElement(_TableView.ProgressCardTd, { percent: null });
        }
        var key = filteredSkillScore.skillId + '-' + row.groupId + '-' + row.studentGeneralInfo;
        return _react2.default.createElement(_TableView.ProgressCardTd, { key: key, percent: filteredSkillScore.score });
      });
    }
  }, {
    key: '_renderTableRow',
    value: function _renderTableRow(row) {
      var _row$studentGeneralIn = row.studentGeneralInfo,
          firstName = _row$studentGeneralIn.firstName,
          lastName = _row$studentGeneralIn.lastName,
          localName = _row$studentGeneralIn.localName,
          avatarUrl = _row$studentGeneralIn.avatarUrl,
          gender = _row$studentGeneralIn.gender;

      var groupLink = this.props.buildRoute('/group/' + row.groupId);
      return _react2.default.createElement(
        _TableView.TableViewTr,
        null,
        _react2.default.createElement(_TableView.MemberCardTd, { name: firstName + ' ' + lastName,
          surname: localName,
          avatarUrl: avatarUrl,
          gender: gender }),
        _react2.default.createElement(
          _TableView.NormalTd,
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: groupLink },
            row.groupCode
          )
        ),
        this._renderSkillScores(row),
        _react2.default.createElement(_TableView.TextTd, { text: row.recentUnit })
      );
    }
  }, {
    key: '_onFilterChange',
    value: function _onFilterChange(queryParams) {
      this.setState({ queryParams: queryParams });
    }
  }, {
    key: '_renderExpansionButton',
    value: function _renderExpansionButton() {
      var _this3 = this;

      var concernsStudentSkills = this.props.concernsStudentSkills;

      if (concernsStudentSkills.size <= NUMBER_OF_DEFAULT_STUDENTS) return;
      var isExpand = this.state.isExpand;

      return _react2.default.createElement(_ExpansionButton2.default, { className: _style2.default.Concerns_expansionButton,
        isExpand: isExpand,
        onExpansionButtonClick: function onExpansionButtonClick() {
          return _this3.setState({ isExpand: !isExpand });
        } });
    }
  }, {
    key: '_sortStudents',
    value: function _sortStudents(currentObject, nextObject) {
      var _this4 = this;

      var current = currentObject.get(this.state.sortKey);
      var next = nextObject.get(this.state.sortKey);
      if (this.state.sortKey === 'name') {
        current = (currentObject.studentGeneralInfo.firstName + ' ' + currentObject.studentGeneralInfo.lastName).toLowerCase();
        next = (nextObject.studentGeneralInfo.firstName + ' ' + nextObject.studentGeneralInfo.lastName).toLowerCase();
      } else if (skillScoresHeaders.map(function (skillScoresHeader) {
        return skillScoresHeader.key.toLowerCase();
      }).indexOf(this.state.sortKey.toLowerCase()) >= 0) {
        var currentScoreDescriptor = currentObject.skillScores.find(function (skillScore) {
          return '' + skillScore.get('name').toLowerCase() === _this4.state.sortKey.toLowerCase();
        });
        var nextScoreDescriptor = nextObject.skillScores.find(function (skillScore) {
          return '' + skillScore.get('name').toLowerCase() === _this4.state.sortKey.toLowerCase();
        });
        current = currentScoreDescriptor && currentScoreDescriptor.get('score');
        next = nextScoreDescriptor && nextScoreDescriptor.get('score');
        current = _is_js2.default.number(current) ? current : null;
        next = _is_js2.default.number(next) ? next : null;
      }
      // Make sure none score student sorted bottom.
      if (this.state.sortType === 'Ascending') {
        current = current === null ? 101 : current;
        next = next === null ? 101 : next;
      } else if (this.state.sortType === 'Descending') {
        current = current === null ? -101 : current;
        next = next === null ? -101 : next;
      }
      if (current > next) {
        return this.state.sortType === 'Ascending' ? 1 : -1;
      } else if (current < next) {
        return this.state.sortType === 'Ascending' ? -1 : 1;
      }
      return 0;
    }
  }, {
    key: '_collapseRowsIfNeeded',
    value: function _collapseRowsIfNeeded(rows) {
      if (this.state.isExpand) return rows;
      return rows.slice(0, NUMBER_OF_DEFAULT_STUDENTS);
    }
  }, {
    key: '_renderStudentSkills',
    value: function _renderStudentSkills() {
      var concernsStudentSkills = this.props.concernsStudentSkills;

      var numberOfStudents = concernsStudentSkills.size;
      if (numberOfStudents > 0 && _is_js2.default.not.undefined(this.state.sortKey)) {
        concernsStudentSkills = concernsStudentSkills.sort(this._sortStudents);
      }
      concernsStudentSkills = this._collapseRowsIfNeeded(concernsStudentSkills);
      concernsStudentSkills = concernsStudentSkills.toJS();
      return _react2.default.createElement(_TableView.TableView, { source: concernsStudentSkills,
        tableTitle: 'Students with low skill scores (' + numberOfStudents + ')',
        renderTableRow: this._renderTableRow,
        noResultsString: 'There are no scores within this range.',
        query: this.state.queryParams,
        onFilterChange: this._onFilterChange,
        customerFooter: this._renderExpansionButton(),
        customerHeader: this._renderTableHeaderRow() });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { outerMargin: true },
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          this._renderStudentSkills()
        )
      );
    }
  }]);

  return Concerns;
}(_react.PureComponent);

Concerns.propTypes = {
  fetchAcademicInfoConcernsStudentSkills: _propTypes2.default.func.isRequired,
  concernsStudentSkills: _propTypes2.default.shape(),
  buildRoute: _propTypes2.default.func.isRequired
};

function mapStateToProps(state) {
  var concernsStudentSkills = state.get('rootReducer').get('academicInfoConcernsStudentSkills');
  return { concernsStudentSkills: concernsStudentSkills };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_AcademicInfo.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(Concerns);

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = exports.accessors = exports.routes = exports.Student = undefined;

var _component = __webpack_require__(860);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(2121);

var _routes3 = _interopRequireDefault(_routes2);

var _accessors2 = __webpack_require__(197);

var _accessors3 = _interopRequireDefault(_accessors2);

var _actions2 = __webpack_require__(198);

var _actions3 = _interopRequireDefault(_actions2);

var _reducer2 = __webpack_require__(2125);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Student = exports.Student = _component2.default;
var routes = exports.routes = _routes3.default;
var accessors = exports.accessors = _accessors3.default;
var actions = exports.actions = _actions3.default;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Student = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2119);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _component = __webpack_require__(623);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Student = exports.Student = function (_PureComponent) {
  _inherits(Student, _PureComponent);

  function Student() {
    _classCallCheck(this, Student);

    return _possibleConstructorReturn(this, (Student.__proto__ || Object.getPrototypeOf(Student)).apply(this, arguments));
  }

  _createClass(Student, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _style2.default.Student },
        _react2.default.createElement(_component2.default, { studentId: this.props.params.studentId })
      );
    }
  }]);

  return Student;
}(_react.PureComponent);

Student.propTypes = {
  params: _propTypes2.default.object
};

exports.default = Student;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2132);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessors = exports.actions = exports.reducer = undefined;

var _omniCommonUi = __webpack_require__(0);

var _actions2 = __webpack_require__(863);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(2141);

var _reducer3 = _interopRequireDefault(_reducer2);

var _accessors2 = __webpack_require__(864);

var _accessors = _interopRequireWildcard(_accessors2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var reducer = exports.reducer = _reducer3.default;
var actions = exports.actions = _actions;
var accessors = exports.accessors = _accessors;

exports.default = _omniCommonUi.Notification;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchNotifications = exports.SUBMIT_MARK_NOTIFICATIONS_READ_SUCCESS = exports.FETCH_NOTIFICATIONS_FAILURE = exports.FETCH_NOTIFICATIONS_SUCCESS = exports.FETCH_NOTIFICATIONS_REQUEST = undefined;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var ACTION_OBJECT_NAME = 'NOTIFICATIONS';

var FETCH_NOTIFICATIONS_REQUEST = exports.FETCH_NOTIFICATIONS_REQUEST = 'FETCH_' + ACTION_OBJECT_NAME + '_REQUEST';
var FETCH_NOTIFICATIONS_SUCCESS = exports.FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_' + ACTION_OBJECT_NAME + '_SUCCESS';
var FETCH_NOTIFICATIONS_FAILURE = exports.FETCH_NOTIFICATIONS_FAILURE = 'FETCH_' + ACTION_OBJECT_NAME + '_FAILURE';
var SUBMIT_MARK_NOTIFICATIONS_READ_SUCCESS = exports.SUBMIT_MARK_NOTIFICATIONS_READ_SUCCESS = 'SUBMIT_MARK_NOTIFICATIONS_READ_SUCCESS';

var createNotificationsActionCreators = (0, _omniCommonUi.createApiActionCreator)(ACTION_OBJECT_NAME, (0, _Api.buildUrl)('/users/my-notifications'));

var fetchNotifications = exports.fetchNotifications = createNotificationsActionCreators;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUnitReport = isUnitReport;
exports.isProgressReport = isProgressReport;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isUnitReport(category) {
  if (_is_js2.default.string(category)) {
    return category.toLowerCase() === 'UnitReport'.toLowerCase();
  }
  return false;
}

function isProgressReport(category) {
  if (_is_js2.default.string(category)) {
    return category.toLowerCase() === 'ProgressReport'.toLowerCase();
  }
  return false;
}

/***/ }),
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _omniCommonUi = __webpack_require__(0);

var _routes = __webpack_require__(1214);

var _routes2 = _interopRequireDefault(_routes);

var _rootReducer = __webpack_require__(2138);

var _rootReducer2 = _interopRequireDefault(_rootReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _omniCommonUi.setupApp)({ routes: _routes2.default, reducer: _rootReducer2.default });

/***/ }),
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebar;

var _App = __webpack_require__(1215);

var _App2 = _interopRequireDefault(_App);

var _Group = __webpack_require__(13);

var _UserDashboard = __webpack_require__(2074);

var _Student = __webpack_require__(859);

var _omniCommonUi = __webpack_require__(0);

var _main = __webpack_require__(2127);

var _main2 = _interopRequireDefault(_main);

var _TabNav = __webpack_require__(2129);

var _TabNav2 = _interopRequireDefault(_TabNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var odinLink = _omniCommonUi.Config.get('odinLink');
var schedulingLink = _omniCommonUi.Config.get('schedulingLink');

exports.default = {
  path: '/',
  component: _App2.default,
  appBars: {
    preSticky: {
      'tab-nav': {
        component: _TabNav2.default,
        order: 1
      }
    }
  },
  sidebarColor: _main2.default.colorSideNav,
  sidebar: (_sidebar = {}, _defineProperty(_sidebar, odinLink, {
    order: 0,
    text: 'ODIN+'
  }), _defineProperty(_sidebar, schedulingLink, {
    order: 1,
    text: 'Scheduling'
  }), _sidebar),
  childRoutes: [_UserDashboard.routes, _Group.routes, _Student.routes]
};

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1216);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _AppBars = __webpack_require__(1219);

var _AppBars2 = _interopRequireDefault(_AppBars);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = function App(props) {
  return _react2.default.createElement(
    'div',
    { className: _style2.default.App_container },
    _react2.default.createElement(_AppBars2.default, props),
    props.children
  );
};

App.propTypes = {
  children: _propTypes2.default.node
};

exports.default = App;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1217);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"App": "n_ZjjaV048Ohzqg77UafK",
	"App_container": "_3dLjwBkTP6cuCo2IxEkIFt"
};

/***/ }),
/* 1218 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppBars = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _immutable = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(15);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var APP_BARS_SKELETON = new _immutable.Map({
  preSticky: new _immutable.Map(),
  sticky: new _immutable.Map(),
  postSticky: new _immutable.Map()
});

// This is important to avoid new instances being mounted all the time.
var JustDiv = function JustDiv(props) {
  return _react2.default.createElement('div', props);
};

var EMPTY_ITEM_PROPS = new _immutable.Map();

var AppBars = exports.AppBars = function (_PureComponent) {
  _inherits(AppBars, _PureComponent);

  function AppBars(props) {
    _classCallCheck(this, AppBars);

    var _this = _possibleConstructorReturn(this, (AppBars.__proto__ || Object.getPrototypeOf(AppBars)).call(this, props));

    _this._parseRoutes(props);
    return _this;
  }

  _createClass(AppBars, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.props.routes !== newProps.routes) {
        this._parseRoutes(newProps);
      }
    }
  }, {
    key: '_parseRoutes',
    value: function _parseRoutes(newProps) {
      var routes = newProps.routes;

      var appBarsConfigArray = routes.filter(function (routeItem) {
        return _is_js2.default.object(routeItem.appBars);
      }).map(function (routeItem) {
        return routeItem.appBars;
      }).map(function (routeItem) {
        return _is_js2.default.function(routeItem) ? routeItem(newProps) : routeItem;
      });
      this._appBars = appBarsConfigArray.reduce(function (appBars, appBarsConfigItem) {
        return appBars.update('preSticky', function (previous) {
          return previous.merge(appBarsConfigItem.preSticky);
        }).update('sticky', function (previous) {
          return previous.merge(appBarsConfigItem.sticky);
        }).update('postSticky', function (previous) {
          return previous.merge(appBarsConfigItem.postSticky);
        });
      }, APP_BARS_SKELETON);
    }
  }, {
    key: '_renderType',
    value: function _renderType(type) {
      var _this2 = this;

      if (this._appBars.get(type).isEmpty()) {
        return null;
      }

      var Component = type === 'sticky' ? _omniCommonUi.Sticky : JustDiv;
      return _react2.default.createElement(
        Component,
        { className: (0, _omniCommonUi.testClass)('app-bars-' + type) },
        this._appBars.get(type).sortBy(function (item) {
          return item.get('order');
        }).map(function (item, key) {
          var Item = item.get('component');
          var itemProps = item.get('props') || EMPTY_ITEM_PROPS;
          (0, _invariant2.default)(_immutable.Map.isMap(itemProps), 'AppBars\'s items can only receive props as a JS object');
          // eslint-disable-next-line react/no-array-index-key
          return _react2.default.createElement(Item, _extends({ key: key }, _this2.props, itemProps.toJS()));
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: (0, _omniCommonUi.testClass)('app-bars') },
        this._renderType('preSticky'),
        this._renderType('sticky'),
        this._renderType('postSticky')
      );
    }
  }]);

  return AppBars;
}(_react.PureComponent);

AppBars.propTypes = {
  routes: _propTypes2.default.arrayOf(_propTypes2.default.shape())
};

function mapDispatchToProps(dispatch) {
  return { push: function push(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } };
}

exports.default = (0, _omniCommonUi.connect)(null, mapDispatchToProps)(AppBars);

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHomeworkGrammaProEnabled = exports.isWritingAssignmentEnabled = exports.isIDPEnabled = undefined;

var _component = __webpack_require__(1221);

var _component2 = _interopRequireDefault(_component);

var _Dashboard = __webpack_require__(1243);

var _Dashboard2 = _interopRequireDefault(_Dashboard);

var _Attendance = __webpack_require__(1312);

var _ProgressTest = __webpack_require__(1417);

var _ProgressReport = __webpack_require__(1457);

var _CoveredInClass = __webpack_require__(1537);

var _CoveredInClassRAv = __webpack_require__(1567);

var _CoveredInClassHFv = __webpack_require__(1576);

var _DigitalPracticeRAv = __webpack_require__(1598);

var _UnitResources = __webpack_require__(1604);

var _UnitReview = __webpack_require__(1615);

var _Homework = __webpack_require__(1623);

var _AssignHomework = __webpack_require__(1695);

var _IndividualDevelopmentPlan = __webpack_require__(323);

var _WritingAssignment = __webpack_require__(787);

var _SessionReport = __webpack_require__(1882);

var _GrammaPro = __webpack_require__(1899);

var _MidtermAndFinalExam = __webpack_require__(1906);

var _MidtermAndFinalExamHFv = __webpack_require__(1910);

var _UnitReportHFv = __webpack_require__(1933);

var _ProgressReportHFv = __webpack_require__(1977);

var _KetExam = __webpack_require__(2048);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _omniCommonUi = __webpack_require__(0);

var _GroupInfoBar = __webpack_require__(2062);

var _GroupInfoBar2 = _interopRequireDefault(_GroupInfoBar);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isIDPEnabled = exports.isIDPEnabled = function isIDPEnabled() {
  return _omniCommonUi.Config.get('enableIndividualDevelopmentPlan');
};
var isWritingAssignmentEnabled = exports.isWritingAssignmentEnabled = function isWritingAssignmentEnabled() {
  return _omniCommonUi.Config.get('enableWritingAssignment');
};
var isHomeworkGrammaProEnabled = exports.isHomeworkGrammaProEnabled = function isHomeworkGrammaProEnabled() {
  return _omniCommonUi.Config.get('enableHomeworkGrammaPro');
};

var getErrorMessage = function getErrorMessage(props) {
  if (props.config && _is_js2.default.function(props.config.icon) && props.config.icon() === 'lock') {
    return 'You have no permission to access this page.';
  }

  var NO_CONTENT_ERROR_CODE = 100001;
  var NO_SYNCED_GROUP_ERROR_CODE = 100002;
  var commonErrorMessage = 'Omni could not load this page.';
  if (!props.erroredApi || !props.erroredApi.error) return commonErrorMessage;

  var errorResponse = props.erroredApi.error.response;
  if (!errorResponse || !errorResponse.code) return commonErrorMessage;
  switch (errorResponse.code) {
    case NO_CONTENT_ERROR_CODE:
      return 'No content for this group.';
    case NO_SYNCED_GROUP_ERROR_CODE:
      return 'Please refresh browser to get latest information after several seconds.';
    default:
      return commonErrorMessage;
  }
};

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: 'group/:groupId',
    component: _component2.default,
    appBars: {
      preSticky: {
        'group-info': {
          component: _GroupInfoBar2.default,
          order: 0
        }
      }
    },
    indexRoute: {
      component: _Dashboard2.default
    },
    errorPage: {
      buttonText: function buttonText() {
        return 'Back to Dashboard';
      },
      buttonLink: function buttonLink(_ref2) {
        var groupId = _ref2.params.groupId,
            buildRoute = _ref2.buildRoute;
        return buildRoute('/group/' + groupId);
      },
      message: getErrorMessage
    },
    canAccess: function canAccess() {
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.GroupDashboard.ViewGroupDashboard);
    },
    tab: {
      label: 'Group',
      order: 0
    },
    breadcrumbLabels: function breadcrumbLabels(_ref3) {
      var groupId = _ref3.params.groupId;

      try {
        return {
          label: getState().get('rootReducer').get('groups').get(groupId).data.number || '',
          backLinkHref: '/'
        };
      } catch (e) {
        return 'Group';
      }
    },
    childRoutes: [_Attendance.routes, _ProgressTest.routes, _ProgressReport.routes, _UnitReportHFv.routes, _CoveredInClass.routes, _UnitReview.routes, _Homework.routes, _AssignHomework.routes, isIDPEnabled() && _IndividualDevelopmentPlan.routes, isWritingAssignmentEnabled() && _WritingAssignment.routes, _SessionReport.routes, isHomeworkGrammaProEnabled() && _GrammaPro.routes, _MidtermAndFinalExam.routes, _MidtermAndFinalExamHFv.routes, _CoveredInClassRAv.routes, _CoveredInClassHFv.routes, _DigitalPracticeRAv.routes, _UnitResources.routes, _ProgressReportHFv.routes, _KetExam.ketMockExamRoutes, _KetExam.ketScoreRoutes]
  };
};

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1222);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _actions = __webpack_require__(158);

var actions = _interopRequireWildcard(_actions);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _GroupMembers = __webpack_require__(14);

var _SessionPlans = __webpack_require__(44);

var _Units = __webpack_require__(281);

var _ApiError = __webpack_require__(596);

var _Users = __webpack_require__(82);

var _Centre = __webpack_require__(282);

var _ProgressTestsPlan = __webpack_require__(64);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Group = exports.Group = function (_Component) {
  _inherits(Group, _Component);

  function Group() {
    _classCallCheck(this, Group);

    return _possibleConstructorReturn(this, (Group.__proto__ || Object.getPrototypeOf(Group)).apply(this, arguments));
  }

  _createClass(Group, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._loadIfNeeded(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this._loadIfNeeded(props);
    }
  }, {
    key: '_loadIfNeeded',
    value: function _loadIfNeeded(props) {
      var group = props.group;
      var groupId = props.params.groupId;


      props.fetchGroupIfNeeded(groupId);
      if (!group || !group.data) {
        return;
      }

      props.fetchCentreIfNeeded(group.data.centreId);

      if (props.canSeeGroupMemberInfo) {
        props.fetchGroupMembersIfNeeded(groupId);
      }

      props.fetchSessionPlansIfNeeded(groupId);

      props.fetchUnitIfNeeded(groupId);

      props.fetchProgressTestPlanIfNeeded(groupId);
    }
  }, {
    key: '_isAnyLoading',
    value: function _isAnyLoading() {
      var _props = this.props,
          group = _props.group,
          canSeeGroupBasicInfo = _props.canSeeGroupBasicInfo;

      var groupReady = group && group.data;
      var sessionPlansReady = groupReady && group.data.sessionPlans && group.data.sessionPlans.data;
      var summaryReady = groupReady && group.data.groupSummary;

      if (canSeeGroupBasicInfo && !summaryReady) {
        return true;
      }

      return !(groupReady && sessionPlansReady);
    }
  }, {
    key: '_renderErrorDialog',
    value: function _renderErrorDialog(err) {
      var _this2 = this;

      return _react2.default.createElement(_omniCommonUi.ErrorDialog, { isOpen: !_is_js2.default.undefined(err),
        onConfirmClick: function onConfirmClick() {
          return _this2._clearErrorMessage();
        },
        onRequestClose: function onRequestClose() {} });
    }
  }, {
    key: '_clearErrorMessage',
    value: function _clearErrorMessage() {
      this.props.removeApiError(this.props.pathName);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      if (this._isAnyLoading()) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: _style2.default.Group },
        _react2.default.createElement(
          'div',
          null,
          children
        ),
        this._renderErrorDialog(this.props.apiError)
      );
    }
  }]);

  return Group;
}(_react.Component);

Group.propTypes = {
  group: _propTypes2.default.object,
  params: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.node,
  removeApiError: _propTypes2.default.func.isRequired,
  fetchGroupIfNeeded: _propTypes2.default.func.isRequired,
  fetchGroupMembersIfNeeded: _propTypes2.default.func.isRequired,
  fetchUnitIfNeeded: _propTypes2.default.func.isRequired,
  fetchSessionPlansIfNeeded: _propTypes2.default.func.isRequired,
  fetchProgressTestPlanIfNeeded: _propTypes2.default.func.isRequired,
  loginUserId: _propTypes2.default.string,
  pathName: _propTypes2.default.string,
  apiError: _propTypes2.default.object,
  privileges: _propTypes2.default.object,
  canSeeGroupMemberInfo: _propTypes2.default.bool.isRequired,
  canSeeGroupBasicInfo: _propTypes2.default.bool.isRequired
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;
  var pathName = ownProps.location.pathname;
  var group = state.get('rootReducer').get('groups').get(groupId);
  var apiError = state.get('rootReducer').get('apiError').get(pathName);
  var privileges = state.get('privileges');
  var loginUserId = state.get('singleSignOn').get('user') && state.get('singleSignOn').get('user').get('profile').sub;
  var canSeeGroupMemberInfo = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.GroupDashboard.ViewGroupMemberInfo);
  var canSeeGroupBasicInfo = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.GroupDashboard.ViewGroupBasicInfo);
  return {
    group: group,
    pathName: pathName,
    apiError: apiError,
    privileges: privileges,
    loginUserId: loginUserId,
    canSeeGroupMemberInfo: canSeeGroupMemberInfo,
    canSeeGroupBasicInfo: canSeeGroupBasicInfo
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, (0, _redux.bindActionCreators)(actions, dispatch), (0, _redux.bindActionCreators)(_ApiError.actions, dispatch), (0, _redux.bindActionCreators)(_GroupMembers.actions, dispatch), (0, _redux.bindActionCreators)(_SessionPlans.actions, dispatch), (0, _redux.bindActionCreators)(_Units.actions, dispatch), (0, _redux.bindActionCreators)(_Users.actions, dispatch), (0, _redux.bindActionCreators)(_Centre.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTestsPlan.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(Group);

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1223);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._9uDKzalrxSrnF-EuqB-t1{font-size:1.25em;font-weight:700;margin:1em 0}", ""]);

// exports
exports.locals = {
	"Group_title": "_9uDKzalrxSrnF-EuqB-t1"
};

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  MarkAttendance: 'MA',
  ProgressTest: 'PT',
  ProgressReport: 'PR',
  MarkHomework: 'MH',
  AssignHomework: 'AH',
  GroupDashboard: 'GD',
  CoveredInClass: 'CIC',
  CoveredInClassRAv2: 'CIC_RAv2',
  CoveredInClassAndHomeworkHFv4: 'CIC_HFv4',
  DigitalPracticeRAv2: 'MH_RAv2',
  UnitResources: 'URES',
  IDP: 'IDP',
  UnitReview: 'URW',
  UnlockHomework: 'AH-UN',
  Assignments: 'AH-AS',
  SmallStarsApp: 'MH-SA',
  UnitQuiz: 'MH-UQ',
  Reader: 'MH-RD',
  Vocabulary: 'MH-VY',
  PracticePlay: 'MH-PP',
  PaperBased: 'MH-PB',
  TrailblazersApp: 'MH-ETA',
  Mentor: 'MH-ME',
  Online: 'MH-OL',
  OnlineUsage: 'MH-OU',
  GrammaPro: 'GP',
  WritingAssignment: 'WA',
  SessionReport: 'SR',
  MidtermAndFinalExam: 'MFE',
  AssessmentHFv4: 'MFE_HFv4',
  UnitReportHFv4: 'UR_HFv4',
  ProgressReportHFv4: 'PR_HFv4',
  KETMockExam: 'KET_MOCK',
  KETScore: 'KET_SCORE'
};

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultMembersSortComparator = defaultMembersSortComparator;
function defaultMembersSortComparator() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a$studentGeneralInfo = a.studentGeneralInfo,
      studentAGeneralInfo = _a$studentGeneralInfo === undefined ? {} : _a$studentGeneralInfo;
  var _b$studentGeneralInfo = b.studentGeneralInfo,
      studentBGeneralInfo = _b$studentGeneralInfo === undefined ? {} : _b$studentGeneralInfo;


  var aFirstName = (studentAGeneralInfo.firstName || '').toLocaleLowerCase();
  var aLastName = (studentAGeneralInfo.lastName || '').toLocaleLowerCase();
  var bFirstName = (studentBGeneralInfo.firstName || '').toLocaleLowerCase();
  var bLastName = (studentBGeneralInfo.lastName || '').toLocaleLowerCase();

  if (a.isInProduction === b.isInProduction) {
    if (aFirstName === bFirstName) {
      return aLastName.localeCompare(bLastName);
    }
    return aFirstName.localeCompare(bFirstName);
  }

  if (a.isInProduction) {
    return -1;
  }

  return 1;
}

exports.default = defaultMembersSortComparator;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = groupMembers;

var _actions = __webpack_require__(194);

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(278);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function groupMembers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_GROUP_MEMBERS_SUCCESS:
      return onSuccess(state, action);
    default:
      return state;
  }
}

function onSuccess(state, action) {
  var newState = state;
  action.payload.forEach(function (member) {
    var memberModel = _model2.default.create(Object.assign({}, member, { groupId: action.groupId }));
    newState = newState.set(memberModel.studentGeneralInfo.id, memberModel);
  });
  return newState;
}

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Interval = function (_Immutable$Record) {
  _inherits(Interval, _Immutable$Record);

  function Interval() {
    _classCallCheck(this, Interval);

    return _possibleConstructorReturn(this, (Interval.__proto__ || Object.getPrototypeOf(Interval)).apply(this, arguments));
  }

  return Interval;
}(_immutable2.default.Record({
  start: undefined,
  end: undefined
}));

exports.default = Interval;

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = undefined;

var _ = __webpack_require__(81);

var _2 = _interopRequireDefault(_);

var _omniCommonUi = __webpack_require__(0);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var create = exports.create = function create(data) {
  var parsedData = {
    start: data.start || data.startDate,
    end: data.end || data.endDate
  };

  return new _2.default(parsedData).update('start', function (start) {
    return updateValue(start);
  }).update('end', function (end) {
    return updateValue(end);
  });
};

exports.default = create;


function updateValue(value) {
  if (_is_js2.default.undefined(value)) {
    return undefined;
  }
  // the backend returns UTC timestamps
  return _omniCommonUi.moment.utc(value);
}

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentGeneralInfoRecord = (0, _immutable.Record)({
  id: undefined,
  firstName: undefined,
  lastName: undefined,
  studentNumber: undefined,
  avatarUrl: undefined,
  gender: undefined,
  localName: undefined
});

var StudentGeneralInfo = function (_StudentGeneralInfoRe) {
  _inherits(StudentGeneralInfo, _StudentGeneralInfoRe);

  function StudentGeneralInfo() {
    _classCallCheck(this, StudentGeneralInfo);

    return _possibleConstructorReturn(this, (StudentGeneralInfo.__proto__ || Object.getPrototypeOf(StudentGeneralInfo)).apply(this, arguments));
  }

  return StudentGeneralInfo;
}(StudentGeneralInfoRecord);

exports.default = StudentGeneralInfo;

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _omniCommonUi = __webpack_require__(0);

var _ = __webpack_require__(107);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'id':
      return [key, '' + val];
    case 'gender':
      return [key, _omniCommonUi.Gender.parse(val)];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

var create = exports.create = function create(data) {
  return new _2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _StudentGeneralInfo = __webpack_require__(107);

var _StudentGeneralInfo2 = _interopRequireDefault(_StudentGeneralInfo);

var _Interval = __webpack_require__(81);

var _Interval2 = _interopRequireDefault(_Interval);

var _model = __webpack_require__(592);

var _ = __webpack_require__(278);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      item = _ref2[1];

  if (!item) return [key, item];
  switch (key) {
    case 'studentGeneralInfo':
      return [key, _StudentGeneralInfo2.default.create(item)];
    case 'period':
      return [key, _Interval2.default.create({
        start: item.start,
        end: item.end
      })];
    case 'ach':
      return [key, new _model.ACH(item)];
    default:
      return [key, _immutable2.default.fromJS(item)];
  }
};

var create = exports.create = function create(data) {
  return new _2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SessionPlanRecord = (0, _immutable.Record)({
  attendanceId: undefined,
  id: undefined,
  index: undefined,
  lessonNumber: undefined,
  cancelReason: undefined,
  period: undefined,
  academicHour: undefined,
  teacher: undefined,
  sessionType: undefined,
  isCancelled: undefined,
  sessionId: null,
  unitId: undefined,
  unitIds: undefined,
  unitOrderingSequence: undefined,
  groupId: undefined, // set by us (keep it)
  sessionMembers: undefined
});

var SessionPlan = function (_SessionPlanRecord) {
  _inherits(SessionPlan, _SessionPlanRecord);

  function SessionPlan() {
    _classCallCheck(this, SessionPlan);

    return _possibleConstructorReturn(this, (SessionPlan.__proto__ || Object.getPrototypeOf(SessionPlan)).apply(this, arguments));
  }

  _createClass(SessionPlan, [{
    key: 'isFuture',
    value: function isFuture() {
      return this.period.start.isAfter((0, _omniCommonUi.moment)());
    }
  }]);

  return SessionPlan;
}(SessionPlanRecord);

exports.default = SessionPlan;

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _Interval = __webpack_require__(81);

var _Interval2 = _interopRequireDefault(_Interval);

var _ = __webpack_require__(280);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (key === 'sessionMembers' && !val) return [key, new _immutable.List()];
  if (!val) return [key, val];
  switch (key) {
    case 'attendanceId':
    case 'id':
    case 'groupId':
    case 'unitId':
      return [key, '' + val]; // stringify
    case 'unitIds':
      return [key, updateUnitIds(val)];
    case 'period':
      return [key, updatePeriod(val)];
    case 'sessionMembers':
      return [key, new _immutable.List(val.map(function (v) {
        return '' + v;
      }))];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

var create = exports.create = function create(data) {
  return new _2.default(data).mapEntries(reviver);
};

exports.default = create;


function updateUnitIds(unitIds) {
  return Array.isArray(unitIds) ? unitIds.map(function (id) {
    return '' + id;
  }) : unitIds;
}

function updatePeriod(period) {
  if (_is_js2.default.undefined(period)) {
    return undefined;
  }

  return _Interval2.default.create(period);
}

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sessions;

var _actions = __webpack_require__(594);

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(595);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sessions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_UNITS_SUCCESS:
      return onSuccess(state, action);
    default:
      return state;
  }
}

function onSuccess(state, action) {
  var units = action.payload.reduce(function (unitResults, unit) {
    return unitResults.set('' + unit.id, _model2.default.create(unit));
  }, new _immutable.Map());
  return state.set(action.groupId, units);
}

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitRecord = (0, _immutable.Record)({
  id: undefined,
  name: undefined,
  orderingSequence: undefined
});

var Unit = function (_UnitRecord) {
  _inherits(Unit, _UnitRecord);

  function Unit() {
    _classCallCheck(this, Unit);

    return _possibleConstructorReturn(this, (Unit.__proto__ || Object.getPrototypeOf(Unit)).apply(this, arguments));
  }

  return Unit;
}(UnitRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'id':
      return [key, '' + val]; // stringify
    default:
      return [key, val];
  }
};

Unit.create = function (data) {
  return new Unit(data).mapEntries(reviver);
};

exports.default = Unit;

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = apiError;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(597);

function apiError() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.ADD_ERROR:
      return state.set(action.pathName, action.payload);
    case _actions.REMOVE_ERROR:
      return state.delete(action.pathName);
    default:
      return state;
  }
}

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoginUserId = getLoginUserId;
exports.getCurrentUserId = getCurrentUserId;
exports.getCurrentUserName = getCurrentUserName;
exports.getUserByUserId = getUserByUserId;
exports.isLoadingUser = isLoadingUser;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildUserUrl = function buildUserUrl(userId) {
  return (0, _Api.buildUrl)('/users/' + userId);
};

function getLoginUserId(state) {
  return state.get('singleSignOn').get('user') && state.get('singleSignOn').get('user').get('profile').sub;
}

function getLoginUserName(state) {
  return state.get('singleSignOn').get('user') && state.get('singleSignOn').get('user').get('profile').name;
}

function getCurrentUserId(state) {
  return state.get('singleSignOn').get('user') && state.get('singleSignOn').get('user').get('profile').impersonated_user_id || getLoginUserId(state);
}

function getCurrentUserName(state) {
  return state.get('singleSignOn').get('user') && state.get('singleSignOn').get('user').get('profile').impersonated_user_name || getLoginUserName(state);
}

function getUserByUserId(state, userId, notFoundFn) {
  var user = state.get('rootReducer').get('user').get('' + userId);
  if (_is_js2.default.undefined(user)) {
    _is_js2.default.function(notFoundFn) && notFoundFn(userId);
    return undefined;
  }
  return user;
}

function isLoadingUser(state, userId) {
  var callState = _omniCommonUi.ApiCall.find(state, { method: 'GET', url: buildUserUrl(userId) });
  return _omniCommonUi.ApiCall.State.isValue(callState) && _omniCommonUi.ApiCall.State.isLoading(callState);
}

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = users;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(598);

var _model = __webpack_require__(599);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function users() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_USER_SUCCESS:
      {
        var user = new _model2.default(action.payload);
        return state.set('' + user.id, user);
      }
    default:
      return state;
  }
}

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = centreReducer;

var _actions = __webpack_require__(600);

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(601);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function centreReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_CENTRE_SUCCESS:
      {
        var centre = Object.assign({}, action.payload, { id: action.centreId });
        return state.set(action.centreId, new _model2.default(centre));
      }
    default:
      return state;
  }
}

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRUCentre = undefined;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/prefer-default-export
var isRUCentre = exports.isRUCentre = function isRUCentre(state, centreId) {
  var centres = state.get('rootReducer').get('centres');
  var centre = centres && centres.get(centreId);
  if (!centre || _is_js2.default.not.string(centre.countryCode)) return;
  return centre.countryCode.toLowerCase() === 'ru';
};

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sessions;

var _actions = __webpack_require__(602);

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(603);

var _model2 = _interopRequireDefault(_model);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sessions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_PROGRESS_TESTS_PLAN_SUCCESS:
      return onSuccess(state, action);
    default:
      return state;
  }
}

function onSuccess(state, action) {
  var plan = new _immutable.Map({});
  var unitQuizPlanIndex = 0;
  var midtermFinalExamPlanIndex = 0;
  action.payload.forEach(function (planItem) {
    var tempPlan = {
      progressReportId: planItem.unitReportId
    };

    if (planItem.isUnitQuiz) {
      tempPlan.index = unitQuizPlanIndex;
      ++unitQuizPlanIndex;
    } else {
      tempPlan.index = midtermFinalExamPlanIndex;
      ++midtermFinalExamPlanIndex;
    }

    var planItemModel = _model2.default.create(Object.assign(planItem, tempPlan));
    plan = plan.set(planItemModel.id, planItemModel);
  });
  return state.set(action.groupId, _omniCommonUi.ApiResponseHelper.create({ data: plan }));
}

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressTestsPlanRecord = (0, _immutable.Record)({
  id: undefined,
  index: undefined,
  progressReportId: undefined,
  name: undefined,
  unitIds: undefined,
  isCurrentProgressTest: undefined,
  isUnitQuiz: undefined,
  startTime: undefined
});

var ProgressTestsPlan = function (_ProgressTestsPlanRec) {
  _inherits(ProgressTestsPlan, _ProgressTestsPlanRec);

  function ProgressTestsPlan() {
    _classCallCheck(this, ProgressTestsPlan);

    return _possibleConstructorReturn(this, (ProgressTestsPlan.__proto__ || Object.getPrototypeOf(ProgressTestsPlan)).apply(this, arguments));
  }

  return ProgressTestsPlan;
}(ProgressTestsPlanRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'id':
    case 'progressReportId':
      return [key, '' + val]; // stringify
    case 'unitIds':
      return [key, val.map(function (v) {
        return '' + v;
      })];
    default:
      return [key, val];
  }
};

ProgressTestsPlan.create = function (data) {
  return new ProgressTestsPlan(data).mapEntries(reviver);
};

exports.default = ProgressTestsPlan;

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dashboard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _redux = __webpack_require__(10);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _accessors = __webpack_require__(36);

var _ProgressTestsPlan = __webpack_require__(64);

var _CourseProgress = __webpack_require__(604);

var _ = __webpack_require__(13);

var _GroupPerformance = __webpack_require__(607);

var _GroupDetail = __webpack_require__(1248);

var _GroupDetail2 = _interopRequireDefault(_GroupDetail);

var _CourseProgress2 = __webpack_require__(1256);

var _CourseProgress3 = _interopRequireDefault(_CourseProgress2);

var _PerformanceCard = __webpack_require__(1262);

var _PerformanceCard2 = _interopRequireDefault(_PerformanceCard);

var _PerformanceCardRAv = __webpack_require__(1307);

var _PerformanceCardRAv2 = _interopRequireDefault(_PerformanceCardRAv);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dashboard = exports.Dashboard = function (_Component) {
  _inherits(Dashboard, _Component);

  function Dashboard(props) {
    _classCallCheck(this, Dashboard);

    var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));

    _this.state = { isExpandGroupDetail: false };
    return _this;
  }

  _createClass(Dashboard, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var courseProgress = this.props.courseProgress;
      var groupId = this.props.params.groupId;

      var isKETGroup = _.actions.isKETCourseTypeGroup(this.props.state, groupId);
      if (!isKETGroup && _omniCommonUi.PrivilegeChecker.hasPrivilege(this.props.state, _Privileges2.default.GroupDashboard.ViewGroupMemberInfo)) {
        this.props.fetchGroupPerformance(groupId);
      }

      this._calculateDefaultSessionId(this.props);

      if (!isKETGroup && _omniCommonUi.ApiResponseHelper.shouldFetch(courseProgress) && _omniCommonUi.PrivilegeChecker.hasPrivilege(this.props.state, _Privileges2.default.GroupDashboard.ViewGroupBasicInfo)) {
        this.props.fetchCourseProgress(groupId);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this._calculateDefaultSessionId(props);
    }
  }, {
    key: '_calculateDefaultSessionId',
    value: function _calculateDefaultSessionId(props) {
      var sessionPlans = props.sessionPlans;

      if (_is_js2.default.existy(props.params.sessionPlanId) || !_immutable.List.isList(sessionPlans.data)) {
        return;
      }

      var defaultSession = (0, _accessors.calculateDefaultSession)(sessionPlans.data, props.now);
      var defaultSessionId = _is_js2.default.object(defaultSession) ? defaultSession.id : undefined;

      this.setState({ defaultSessionId: defaultSessionId });
    }
  }, {
    key: '_expandGroupDetail',
    value: function _expandGroupDetail() {
      var isExpandGroupDetail = this.state.isExpandGroupDetail;

      this.setState({ isExpandGroupDetail: !isExpandGroupDetail });
    }
  }, {
    key: '_renderGroupDetail',
    value: function _renderGroupDetail() {
      var _this2 = this;

      if (!_omniCommonUi.PrivilegeChecker.hasPrivilege(this.props.state, _Privileges2.default.GroupDashboard.ViewGroupBasicInfo)) {
        return false;
      }

      var _props = this.props,
          groupSummary = _props.groupSummary,
          timeZone = _props.timeZone;


      if (_is_js2.default.undefined(groupSummary) || _is_js2.default.null(groupSummary)) {
        return false;
      }

      var isExpandGroupDetail = this.state.isExpandGroupDetail;

      return _react2.default.createElement(_GroupDetail2.default, { groupSummary: groupSummary,
        isExpanded: isExpandGroupDetail,
        onExpandBottonClick: function onExpandBottonClick() {
          return _this2._expandGroupDetail();
        },
        timeZone: timeZone });
    }
  }, {
    key: '_renderProgressBar',
    value: function _renderProgressBar() {
      if (!_omniCommonUi.PrivilegeChecker.hasPrivilege(this.props.state, _Privileges2.default.GroupDashboard.ViewGroupBasicInfo)) {
        return false;
      }

      var courseProgress = this.props.courseProgress;


      if (!courseProgress || !courseProgress.sessions) {
        return null;
      }

      var highLightEvents = this._getHighLightEvents(courseProgress.sessions);
      var currentEvent = this._getCurrentEvent(courseProgress.sessions);
      var totalSessionNumber = courseProgress.sessions ? courseProgress.sessions.length : 0;
      var groupStartDate = courseProgress.groupStartDate;
      var groupEndDate = courseProgress.groupEndDate;
      var startEvent = this._getStartOrEndGroupEvent(groupStartDate);
      var endEvent = this._getStartOrEndGroupEvent(groupEndDate, false);
      var GROUP_PROGRESS_UN_START = 0;
      var GROUP_PROGRESS_END = 2;

      if (courseProgress.groupProgress === GROUP_PROGRESS_UN_START) {
        currentEvent.percentage = 0;
      } else if (courseProgress.groupProgress === GROUP_PROGRESS_END) {
        currentEvent.percentage = 100;
      }

      return _react2.default.createElement(_CourseProgress3.default, { startEvent: startEvent,
        endEvent: endEvent,
        currentEvent: currentEvent,
        highLightEvents: highLightEvents,
        totalSessionNumber: totalSessionNumber,
        startWeekNumber: this.props.courseProgress.startWeekCode,
        endWeekNumber: this.props.courseProgress.endWeekCode });
    }
  }, {
    key: '_getVisibleColumnsInAveragesOverview',
    value: function _getVisibleColumnsInAveragesOverview() {
      var columns = new _immutable.List(['averageTotalScore', 'averageOnlineHomeworkCompletion', 'averageOnlineHomeworkAccuracy', 'averageOnlineHomeworkBestAccuracy', 'averagePaperBasedHomeworkCompletion', 'ach']);

      var groupId = this.props.groupId;

      var state = _omniCommonUi.Store.get().getState();

      if (!_.actions.shouldShowAch(state, groupId)) {
        columns = columns.filterNot(function (col) {
          return col === 'ach';
        });
      }

      if (!_.actions.hasPaperBasedHomework(state, groupId)) {
        columns = columns.filterNot(function (col) {
          return col === 'averagePaperBasedHomeworkCompletion';
        });
      }

      if (_.actions.isSSCourseTypeGroup(state, groupId) && !_TabSwitcher2.default.isTabEnabled(state, groupId, _TabSwitcher.TabCodes.SmallStarsApp)) {
        columns = columns.filterNot(function (col) {
          return col === 'averageOnlineHomeworkCompletion';
        });
      }

      if (!_.actions.isHFV4CourseTypeGroup(state, groupId)) {
        columns = columns.filterNot(function (col) {
          return col === 'averageOnlineHomeworkAccuracy';
        });
        columns = columns.filterNot(function (col) {
          return col === 'averageOnlineHomeworkBestAccuracy';
        });
      }

      if (_.actions.isHFV4CourseTypeGroup(state, groupId)) {
        columns = columns.filterNot(function (col) {
          return col === 'averageTotalScore';
        });
      }

      return columns;
    }
  }, {
    key: '_getColumnLabelsInAveragesOverview',
    value: function _getColumnLabelsInAveragesOverview() {
      var groupId = this.props.groupId;

      var state = _omniCommonUi.Store.get().getState();

      return _.actions.isHFV4CourseTypeGroup(state, groupId) ? {
        averageOnlineHomeworkCompletion: 'Avg. Completion',
        averageOnlineHomeworkAccuracy: 'Avg. Accuracy (First)',
        averageOnlineHomeworkBestAccuracy: 'Avg. Accuracy (Best)'
      } : {};
    }
  }, {
    key: '_disableSwitchTableInPerformanceCard',
    value: function _disableSwitchTableInPerformanceCard() {
      var groupId = this.props.groupId;

      var state = _omniCommonUi.Store.get().getState();

      return _.actions.isHFV4CourseTypeGroup(state, groupId);
    }
  }, {
    key: '_renderPerformanceCard',
    value: function _renderPerformanceCard() {
      var _props2 = this.props,
          groupPerformance = _props2.groupPerformance,
          isLoadingGroupPerformance = _props2.isLoadingGroupPerformance,
          groupId = _props2.groupId;


      var state = _omniCommonUi.Store.get().getState();
      if (_.actions.isRAv2CourseTypeGroup(state, groupId)) {
        return _react2.default.createElement(_PerformanceCardRAv2.default, { params: this.props.params });
      }

      if (isLoadingGroupPerformance === true) {
        return _react2.default.createElement(
          'div',
          { className: (0, _omniCommonUi.testClass)('groudPerformance-loading-view') },
          'Loading\u2026'
        );
      }

      if (!groupPerformance || groupPerformance.currentUnitNumber === -1 || groupPerformance.currentUnitNumber === 0) {
        return null;
      }

      return _react2.default.createElement(_PerformanceCard2.default, { location: this.props.location,
        groupPerformance: groupPerformance,
        groupId: groupId,
        sessionId: this.state.defaultSessionId,
        disableSwitchTable: this._disableSwitchTableInPerformanceCard(),
        visibleOptionalColumnsInAveragesOverview: this._getVisibleColumnsInAveragesOverview(),
        columnLabelsInAveragesOverview: this._getColumnLabelsInAveragesOverview() });
    }
  }, {
    key: '_getStartSession',
    value: function _getStartSession(sessions) {
      return this._getStartOrEndSession(sessions);
    }
  }, {
    key: '_getLastSession',
    value: function _getLastSession(sessions) {
      return this._getStartOrEndSession(sessions, false);
    }
  }, {
    key: '_getStartOrEndSession',
    value: function _getStartOrEndSession(sessions) {
      var isStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (sessions.length > 0) {
        var index = isStart ? 0 : sessions.length - 1;
        var sessionDate = sessions[index].actualPeriod.startDate ? sessions[index].actualPeriod.startDate : sessions[index].plannedPeriod.startDate;
        var session = {
          date: this._formatDate(sessionDate, 'YYYY-MM-DD'),
          percentage: isStart ? 0 : 100
        };
        return session;
      }
      return { date: '', percentage: isStart ? 0 : 100 };
    }
  }, {
    key: '_getStartOrEndGroupEvent',
    value: function _getStartOrEndGroupEvent(date) {
      var isStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      return {
        date: this._formatDate(date, 'YYYY-MM-DD'),
        percentage: isStart ? 0 : 100
      };
    }
  }, {
    key: '_getHighLightEvents',
    value: function _getHighLightEvents(sessions) {
      var _this3 = this;

      var highLightEvents = [];
      sessions.map(function (session) {
        if (session.isHighLight) {
          var event = _this3._transFormSessionToEvent(session, sessions);
          highLightEvents.push(event);
        }
        return false;
      });

      return highLightEvents;
    }
  }, {
    key: '_transFormSessionToEvent',
    value: function _transFormSessionToEvent(session, sessions) {
      var date = session.actualPeriod.endDate ? session.actualPeriod.endDate : session.plannedPeriod.startDate;
      var currentIndex = sessions.indexOf(session);
      var content = session.sessionTypeCode === 'PTC' ? 'PTC' : session.sessionType;
      var type = session.hasProgressTest ? 'progressTest' : 'events';
      var percentage = (currentIndex + 2) / (sessions.length + 2) * 100;

      if (session.hasProgressTest) {
        content = session.progressTestName;
      }

      return {
        date: this._formatDate(date, 'YYYY-MM-DD'),
        content: content,
        percentage: percentage,
        type: type,
        currentIndex: currentIndex
      };
    }
  }, {
    key: '_getCurrentEvent',
    value: function _getCurrentEvent(sessions) {
      var _this4 = this;

      var currentEvent = { date: '', content: '', percentage: 0, currentIndex: 0 };
      sessions.map(function (session) {
        if (session.isMostRecent) {
          currentEvent = _this4._transFormSessionToEvent(session, sessions);
          currentEvent.content = 'Session ' + (currentEvent.currentIndex + 1) + '/' + sessions.length;
        }
        return false;
      });
      return currentEvent;
    }
  }, {
    key: '_formatDate',
    value: function _formatDate(dataString, customFormat) {
      // TODO: Suppresses a random race condition problem that could have been caused
      //       by any one of several calling components. Try to fix this in a better way.
      var _moment = _omniCommonUi.moment.utc(dataString).clone().tz(this.props.timeZone);
      if (!_moment) {
        _moment = _omniCommonUi.moment.utc(dataString);
      }
      return _moment.format(customFormat);
    }
  }, {
    key: 'render',
    value: function render() {
      var groupId = this.props.groupId;

      var state = _omniCommonUi.Store.get().getState();
      if (_.actions.isKETCourseTypeGroup(state, groupId)) {
        return _react2.default.createElement(
          _omniCommonUi.Grid,
          { outerMargin: true },
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              null,
              this._renderGroupDetail()
            )
          )
        );
      }

      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { outerMargin: true },
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          _react2.default.createElement(
            _omniCommonUi.Grid.Item,
            null,
            this._renderGroupDetail()
          ),
          _react2.default.createElement(
            _omniCommonUi.Grid.Item,
            null,
            this._renderProgressBar()
          ),
          _react2.default.createElement(
            _omniCommonUi.Grid.Item,
            null,
            this._renderPerformanceCard()
          )
        )
      );
    }
  }]);

  return Dashboard;
}(_react.Component);

Dashboard.propTypes = {
  state: _propTypes2.default.object.isRequired,
  group: _propTypes2.default.object.isRequired,
  groupId: _propTypes2.default.string.isRequired,
  location: _propTypes2.default.object.isRequired,
  params: _propTypes2.default.shape({
    mode: _propTypes2.default.string,
    groupId: _propTypes2.default.string,
    sessionPlanId: _propTypes2.default.string
  }),
  buildRoute: _propTypes2.default.func.isRequired,
  sessionPlans: _propTypes2.default.object.isRequired,
  groupSummary: _propTypes2.default.object.isRequired,
  courseProgress: _propTypes2.default.object.isRequired,
  fetchCourseProgress: _propTypes2.default.func.isRequired,
  fetchProgressTestsPlan: _propTypes2.default.func.isRequired,
  now: _propTypes2.default.object.isRequired,
  timeZone: _propTypes2.default.string,
  groupPerformance: _propTypes2.default.object,
  isLoadingGroupPerformance: _propTypes2.default.bool,
  fetchGroupPerformance: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var _Group$getCentre = _.actions.getCentre(state, groupId),
      timeZone = _Group$getCentre.timeZone;

  var sessionPlans = getSessionPlans(state, groupId);
  var groupSummary = getGroupSummary(state, groupId);
  var group = state.get('rootReducer').get('groups').get(groupId);
  var courseProgress = getCourseProgress(state);
  var groupPerformance = _GroupPerformance.actions.getGroupPerformanceByGroupId(state, groupId);
  var isLoadingGroupPerformance = _GroupPerformance.actions.isLoadingGroupPerformance(state, groupId);
  return {
    state: state,
    group: group,
    groupId: groupId,
    timeZone: timeZone,
    sessionPlans: sessionPlans,
    groupSummary: groupSummary,
    courseProgress: courseProgress,
    groupPerformance: groupPerformance,
    isLoadingGroupPerformance: isLoadingGroupPerformance
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign((0, _redux.bindActionCreators)(_CourseProgress.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTestsPlan.actions, dispatch), (0, _redux.bindActionCreators)(_GroupPerformance.actions, dispatch));
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  var now = (0, _omniCommonUi.moment)();
  return Object.assign({ now: now }, ownProps, stateProps, dispatchProps);
}

function getSessionPlans(state, groupId) {
  var sessionPlans = state.get('rootReducer').get('groups').get(groupId).data.sessionPlans;

  if (_omniCommonUi.ApiResponseHelper.shouldFetch(sessionPlans) || !_omniCommonUi.ApiResponseHelper.hasSucceeded(sessionPlans)) {
    return sessionPlans;
  }

  sessionPlans = sessionPlans.update('data', function (data) {
    return data.map(function (sessionPlanId) {
      return state.get('rootReducer').get('sessionPlans').get(sessionPlanId);
    });
  });
  sessionPlans = sessionPlans.update('data', function (data) {
    return new _immutable.List(data);
  });
  return sessionPlans;
}

function getGroupSummary(state, groupId) {
  var groupSummary = state.get('rootReducer').get('groups').get(groupId).data.groupSummary;

  return groupSummary;
}

function getCourseProgress(state) {
  var courseProgressSessions = state.get('rootReducer').get('courseProgress');
  return courseProgressSessions;
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps, mergeProps)(Dashboard);

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = courseProgress;

var _actions = __webpack_require__(605);

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(606);

var _model2 = _interopRequireDefault(_model);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function courseProgress() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_COURSE_PROGRESS_REQUEST:
      return _omniCommonUi.ApiResponseHelper.create({ loading: true });
    case _actions.FETCH_COURSE_PROGRESS_SUCCESS:
      return _model2.default.create(action.payload);
    case _actions.FETCH_COURSE_PROGRESS_FAILURE:
      return _omniCommonUi.ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = groupPerformance;

var _actions = __webpack_require__(608);

var _model = __webpack_require__(609);

var _model2 = _interopRequireDefault(_model);

var _immutable = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function groupPerformance() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_GROUPPERFORMANCE_REQUEST:
      return state.set(action.groupId, undefined);
    case _actions.FETCH_GROUPPERFORMANCE_SUCCESS:
      return state.set(action.groupId, _model2.default.create(action.payload));
    default:
      return state;
  }
}

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rewards = undefined;

var _model = __webpack_require__(612);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Rewards = exports.Rewards = _model2.default;

exports.default = Rewards;

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _StudentGeneralInfo = __webpack_require__(107);

var _StudentGeneralInfo2 = _interopRequireDefault(_StudentGeneralInfo);

var _ = __webpack_require__(610);

var _2 = _interopRequireDefault(_);

var _model = __webpack_require__(611);

var _model2 = __webpack_require__(612);

var _model3 = _interopRequireDefault(_model2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      item = _ref2[1];

  if (!item) return [key, item];
  switch (key) {
    case 'studentGeneralInfo':
      return [key, _StudentGeneralInfo2.default.create(item)];
    case 'ach':
      return [key, new _model.ACH(item)];
    case 'rewards':
      return [key, _model3.default.create(item)];
    default:
      return [key, _immutable2.default.fromJS(item)];
  }
};

var create = exports.create = function create(data) {
  return new _2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1249);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _ReadOnlyField = __webpack_require__(1253);

var _ReadOnlyField2 = _interopRequireDefault(_ReadOnlyField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PROGRESS_ADVISOR = 'Progress Advisor ';
var TEACHERS_FIRST = 'Teacher 1';
var TEACHERS_SECOND = 'Teacher 2';
var TEACHERASSISTANT = 'Teaching Assistant ';

var GroupDetail = function (_Component) {
  _inherits(GroupDetail, _Component);

  function GroupDetail(props) {
    _classCallCheck(this, GroupDetail);

    var _this = _possibleConstructorReturn(this, (GroupDetail.__proto__ || Object.getPrototypeOf(GroupDetail)).call(this, props));

    _this._bigQueryListener = _this._bigQueryListener.bind(_this);
    _this._hugeQueryListener = _this._hugeQueryListener.bind(_this);
    _this._bigQuery = (0, _omniCommonUi.mediaQuery)('(min-width: ' + _style2.default.bigViewportWidth + ')');
    _this._hugeQuery = (0, _omniCommonUi.mediaQuery)('(min-width: ' + _style2.default.hugeViewportWidth + ')');
    _this.state = {
      isInBigViewport: !!_this._bigQuery.matches,
      isInHugeViewport: !!_this._hugeQuery.matches
    };
    return _this;
  }

  _createClass(GroupDetail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._bigQuery.addListener(this._bigQueryListener);
      this._hugeQuery.addListener(this._hugeQueryListener);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._bigQuery.removeListener(this._bigQueryListener);
      this._hugeQuery.removeListener(this._hugeQueryListener);
    }
  }, {
    key: '_bigQueryListener',
    value: function _bigQueryListener(mql) {
      this.setState({ isInBigViewport: !!mql.matches });
    }
  }, {
    key: '_hugeQueryListener',
    value: function _hugeQueryListener(mql) {
      this.setState({ isInHugeViewport: !!mql.matches });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isExpanded = _props.isExpanded,
          groupSummary = _props.groupSummary,
          onExpandBottonClick = _props.onExpandBottonClick,
          timeZone = _props.timeZone;

      var groupSummaryDisplayItems = [];
      prepareGroupSummaryDisplayItems.call(this);

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _classnames2.default)(_style2.default.GroupDetail_container, (0, _omniCommonUi.testClass)('group-detail-view')) },
        _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Group Details' }),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.GroupDetail_content },
          _react2.default.createElement(
            _omniCommonUi.Grid,
            { className: _style2.default.GroupDetail_content_grid },
            _react2.default.createElement(
              _omniCommonUi.Grid.Group,
              null,
              renderGridItems()
            )
          )
        ),
        renderExpansionButton()
      );

      function renderGridItems() {
        return groupSummaryDisplayItems.map(function (source) {
          return _react2.default.createElement(
            _omniCommonUi.Grid.Item,
            { xs: 12,
              sm: 6,
              md: 4,
              lg: 3,
              className: _style2.default.GroupDetail_item },
            _react2.default.createElement(_ReadOnlyField2.default, { boardTitle: source.title,
              boardValue: source.value,
              className: source.className })
          );
        });
      }

      function prepareGroupSummaryDisplayItems() {
        groupSummaryDisplayItems.push({
          title: PROGRESS_ADVISOR,
          value: groupSummary.pa,
          className: (0, _omniCommonUi.testClass)('progress-advisor')
        });
        groupSummaryDisplayItems.push({
          title: TEACHERS_FIRST,
          value: groupSummary.mainTeacherName,
          className: (0, _omniCommonUi.testClass)('teacher-1')
        });
        if (isExpanded || this.state.isInBigViewport || this.state.isInHugeViewport) {
          groupSummaryDisplayItems.push({
            title: TEACHERS_SECOND,
            value: groupSummary.coTeacherName,
            className: (0, _omniCommonUi.testClass)('teacher-2')
          });
        }
        if (isExpanded || this.state.isInHugeViewport) {
          groupSummaryDisplayItems.push({
            title: TEACHERASSISTANT,
            value: groupSummary.teacherAssistant,
            className: (0, _omniCommonUi.testClass)('assistant')
          });
        }
        if (isExpanded) {
          groupSummary.sessionSchedules.map(function (session, index) {
            var sessionNumber = index + 1;
            groupSummaryDisplayItems.push({
              title: 'Session ' + sessionNumber,
              value: getClassDate(session.period),
              className: (0, _omniCommonUi.testClass)('session-' + sessionNumber)
            });
            return false;
          });
        }
      }

      function getClassDate(period) {
        if (_is_js2.default.undefined(period.start) || _is_js2.default.undefined(period.end)) return '';
        return period.start.clone().tz(timeZone).format('ddd, HH:mm') + '-' + period.end.clone().tz(timeZone).format('HH:mm');
      }

      function renderExpansionButton() {
        return _react2.default.createElement(_ExpansionButton2.default, { isExpand: isExpanded,
          onExpansionButtonClick: function onExpansionButtonClick() {
            return onExpandBottonClick();
          },
          className: (0, _omniCommonUi.testClass)('expand-group-details') });
      }
    }
  }]);

  return GroupDetail;
}(_react.Component);

GroupDetail.propTypes = {
  groupSummary: _propTypes2.default.object.isRequired,
  timeZone: _propTypes2.default.string.isRequired,
  isExpanded: _propTypes2.default.bool.isRequired,
  onExpandBottonClick: _propTypes2.default.func.isRequired
};

exports.default = GroupDetail;

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1250);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._7K0FCM9S4ktlJe_USBPkI{padding-bottom:0;padding-top:0}._1UnwbAW8Tg2dDoTB9uEcs{margin:0}._1j_tRb5kUeh2Jg2DPpvPsE{margin:0;padding-top:.5em}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"bigViewportWidth": "800px",
	"hugeViewportWidth": "980px",
	"GroupDetail_container": "_2o4czAjfqt4lyIPZGdP6Mj",
	"GroupDetail_content": "_7K0FCM9S4ktlJe_USBPkI",
	"GroupDetail_content_grid": "_1UnwbAW8Tg2dDoTB9uEcs",
	"GroupDetail_item": "_1j_tRb5kUeh2Jg2DPpvPsE"
};

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1252);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2kExyNROhE7y2MpuGem1t4{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f3f5f7;border-top:.07143rem solid #ccc;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;font-size:.85714rem;font-weight:600;height:2.14286rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}._2rJOaz2F5N4v70GTjgcEpj{margin-left:.57143rem;-webkit-transition:-webkit-transform .3s ease-in-out;transition:-webkit-transform .3s ease-in-out;-o-transition:-o-transform .3s ease-in-out;-moz-transition:transform .3s ease-in-out,-moz-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out,-moz-transform .3s ease-in-out,-o-transform .3s ease-in-out}._2kExyNROhE7y2MpuGem1t4._2ncEHLKlm855R4OI3NdI0_ ._2rJOaz2F5N4v70GTjgcEpj{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg)}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ExpansionButton": "_2kExyNROhE7y2MpuGem1t4",
	"ExpansionButton_arrow": "_2rJOaz2F5N4v70GTjgcEpj",
	"__expanded": "_2ncEHLKlm855R4OI3NdI0_"
};

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1254);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReadOnlyField = function ReadOnlyField(props) {
  var classesBoard = (0, _classnames2.default)(_style2.default.ReadOnlyField_board, props.className);
  var classesH5 = (0, _classnames2.default)(_style2.default.ReadOnlyField_h5, (0, _omniCommonUi.testClass)('field-title'));
  var classesP = (0, _classnames2.default)(_style2.default.ReadOnlyField_p, (0, _omniCommonUi.testClass)('field-value'));

  return _react2.default.createElement(
    'div',
    { className: classesBoard },
    _react2.default.createElement(
      'h5',
      { className: classesH5 },
      props.boardTitle
    ),
    _react2.default.createElement(
      'p',
      { className: classesP },
      judgeValue(props.boardValue)
    )
  );

  function judgeValue(boardValue) {
    if (!_is_js2.default.not.undefined(boardValue) || !boardValue || boardValue === '') {
      return '–';
    }
    return boardValue;
  }
};

ReadOnlyField.propTypes = {
  boardTitle: _propTypes2.default.string.isRequired,
  boardValue: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string
};

exports.default = ReadOnlyField;

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1255);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1FGCIDN0s2EoDeNJbbAkg0{float:left;line-height:1.8;padding-right:1rem;width:100%}._1FGCIDN0s2EoDeNJbbAkg0:after{background:#ccc;content:\"\";display:block;height:.07143rem;left:0;position:absolute;width:100%}._2EJTRPJb3fu3Lg2R-ANOr5{color:#b4b4b4;font-size:.95em;font-weight:400;margin:0}.f0FZssV8hEi-X_va9a9Z7{border-bottom:.07143rem solid transparent;font-size:1rem;margin:0;padding-bottom:.57143rem;white-space:pre-line}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ReadOnlyField_board": "_1FGCIDN0s2EoDeNJbbAkg0",
	"ReadOnlyField_h5": "_2EJTRPJb3fu3Lg2R-ANOr5",
	"ReadOnlyField_p": "f0FZssV8hEi-X_va9a9Z7"
};

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1257);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _CourseProgressBar = __webpack_require__(1259);

var _CourseProgressBar2 = _interopRequireDefault(_CourseProgressBar);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CourseProgress = function (_Component) {
  _inherits(CourseProgress, _Component);

  function CourseProgress() {
    _classCallCheck(this, CourseProgress);

    return _possibleConstructorReturn(this, (CourseProgress.__proto__ || Object.getPrototypeOf(CourseProgress)).apply(this, arguments));
  }

  _createClass(CourseProgress, [{
    key: '_getStartEvent',
    value: function _getStartEvent() {
      return this.props.startEvent;
    }
  }, {
    key: '_getCurrentEvent',
    value: function _getCurrentEvent() {
      return this.props.currentEvent;
    }
  }, {
    key: '_getEndEvent',
    value: function _getEndEvent() {
      return this.props.endEvent;
    }
  }, {
    key: '_getHightLightEvent',
    value: function _getHightLightEvent() {
      return this.props.highLightEvents;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _omniCommonUi.testClass)('course-progress-view') },
        _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Course Progress' }),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          null,
          _react2.default.createElement(
            _CourseProgressBar2.default,
            { className: _style2.default.CourseProgress_bar,
              currentEvent: this._getCurrentEvent(),
              startEvent: this._getStartEvent(),
              endEvent: this._getEndEvent(),
              highLightEvents: this._getHightLightEvent() },
            _react2.default.createElement(
              'div',
              { className: _style2.default.CourseProgress_bottom },
              _react2.default.createElement(
                'time',
                { className: _style2.default.CourseProgress_startTime,
                  dateTime: this.props.startEvent.date },
                this.props.startEvent.date,
                ' ',
                _react2.default.createElement('br', null),
                '(week ',
                this.props.startWeekNumber,
                ')'
              ),
              _react2.default.createElement(
                'time',
                { className: _style2.default.CourseProgress_endTime,
                  dateTime: this.props.endEvent.date },
                this.props.endEvent.date,
                ' ',
                _react2.default.createElement('br', null),
                '(week ',
                this.props.endWeekNumber,
                ')'
              )
            )
          )
        )
      );
    }
  }]);

  return CourseProgress;
}(_react.Component);

CourseProgress.propTypes = {
  currentEvent: _propTypes2.default.object.isRequired,
  startEvent: _propTypes2.default.object.isRequired,
  endEvent: _propTypes2.default.object.isRequired,
  highLightEvents: _propTypes2.default.array,
  totalSessionNumber: _propTypes2.default.number,
  startWeekNumber: _propTypes2.default.string,
  endWeekNumber: _propTypes2.default.string
};

exports.default = CourseProgress;

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1258);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2Cm1iSrC8CDEMuSmczpDh3{font-size:.76429rem;letter-spacing:.07143rem;padding:1.42857rem 2.14286rem 0;padding-bottom:2.14286rem;width:100%}@media (max-width:480px){._2Cm1iSrC8CDEMuSmczpDh3{padding:1.42857rem;padding-bottom:2.14286rem}}._2XL20Jw4Hc21cWXab1eQhz{margin-bottom:2.14286rem}._3nYlcbgTc9ht7Gtk_9Lx9v{margin-top:-.71429rem}@media (max-width:480px){._3nYlcbgTc9ht7Gtk_9Lx9v{margin-bottom:-1.07143rem;margin-top:-1.42857rem}}.iN2msMB6oT5OvYUjfz1EN{font-size:.76429rem;height:3.21429rem;letter-spacing:.07143rem;overflow:hidden;width:100%}._2_NEYxO0Zocj53lOPTgobo,._2JvLOfcqSizAOsDiei7Oiv{background-color:#fbfbfb;bottom:0;cursor:default;font-size:115%;font-weight:600;line-height:1.3;position:absolute}._2JvLOfcqSizAOsDiei7Oiv{left:0}@media (max-width:480px){._2JvLOfcqSizAOsDiei7Oiv{left:.78571rem}}._2_NEYxO0Zocj53lOPTgobo{right:0;text-align:right}@media (max-width:480px){._2_NEYxO0Zocj53lOPTgobo{right:.78571rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"CourseProgress": "_2Cm1iSrC8CDEMuSmczpDh3",
	"CourseProgress_count": "_2XL20Jw4Hc21cWXab1eQhz",
	"CourseProgress_bar": "_3nYlcbgTc9ht7Gtk_9Lx9v",
	"CourseProgress_bottom": "iN2msMB6oT5OvYUjfz1EN",
	"CourseProgress_startTime": "_2JvLOfcqSizAOsDiei7Oiv",
	"CourseProgress_endTime": "_2_NEYxO0Zocj53lOPTgobo"
};

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1260);

var _style2 = _interopRequireDefault(_style);

var _classnames6 = __webpack_require__(7);

var _classnames7 = _interopRequireDefault(_classnames6);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactIscroll = __webpack_require__(574);

var _reactIscroll2 = _interopRequireDefault(_reactIscroll);

var _iscroll = __webpack_require__(575);

var _iscroll2 = _interopRequireDefault(_iscroll);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CourseProgressBar = function (_Component) {
  _inherits(CourseProgressBar, _Component);

  function CourseProgressBar(props) {
    _classCallCheck(this, CourseProgressBar);

    var _this = _possibleConstructorReturn(this, (CourseProgressBar.__proto__ || Object.getPrototypeOf(CourseProgressBar)).call(this, props));

    _this.state = {
      isAtScrollMinX: true,
      isAtScrollMaxX: false
    };
    _this._onScrollStart = _this._onScrollStart.bind(_this);
    _this._onScrollEnd = _this._onScrollEnd.bind(_this);
    return _this;
  }

  _createClass(CourseProgressBar, [{
    key: '_renderEventDot',
    value: function _renderEventDot(eventDate, eventPercentage) {
      var eventContent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var eventType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var index = arguments[4];

      var percentage = eventPercentage;
      var style = this._calculateProgress() <= 0 || this._calculateProgress() < percentage ? { left: 'calc(' + percentage + '% - 10px)' } : { left: 'calc(' + percentage + '% - 10px)', backgroundColor: '#0087e6' };
      var whiteDotStyle = this._calculateProgress() <= 0 || this._calculateProgress() < percentage ? { backgroundColor: '#a4a4a4' } : { backgroundColor: 'white' };
      var toolTipClassName = (0, _classnames7.default)(_defineProperty({}, _style2.default.CourseProgressBar_eventDots_tooltip, percentage <= 90 && percentage >= 10), _defineProperty({}, _style2.default.CourseProgressBar_eventDots_rightTooltip, percentage > 90), _defineProperty({}, _style2.default.CourseProgressBar_eventDots_leftTooltip, percentage < 10));

      return _react2.default.createElement(
        'div',
        { className: _style2.default.CourseProgressBar_eventDots,
          style: style,
          key: eventDate + '-' + (index || eventType) },
        eventType === 'progressTest' ? _react2.default.createElement('div', { className: _style2.default.CourseProgressBar_eventDots_whiteDots, style: whiteDotStyle }) : '',
        eventContent !== '' ? _react2.default.createElement(
          'span',
          { className: toolTipClassName },
          eventContent,
          _react2.default.createElement('br', null),
          eventDate
        ) : ''
      );
    }
  }, {
    key: '_renderHighLightEventDots',
    value: function _renderHighLightEventDots() {
      var _this2 = this;

      var hightLightEvents = this.props.highLightEvents || [];
      return hightLightEvents.map(function (event, index) {
        return _this2._renderEventDot(event.date, event.percentage, event.content, event.type, index);
      });
    }
  }, {
    key: '_renderStartEventDot',
    value: function _renderStartEventDot() {
      return this._renderEventDot(this.props.startEvent.date, this.props.startEvent.percentage, this.props.startEvent.content, 'startEvent');
    }
  }, {
    key: '_renderEndEventDot',
    value: function _renderEndEventDot() {
      return this._renderEventDot(this.props.endEvent.date, this.props.endEvent.percentage, this.props.endEvent.content, 'endEvent');
    }
  }, {
    key: '_getProgressBarStyle',
    value: function _getProgressBarStyle() {
      var progressWidth = this._calculateProgress() + '%';
      return { width: progressWidth };
    }
  }, {
    key: '_calculateProgress',
    value: function _calculateProgress() {
      return this.props.currentEvent.percentage;
    }
  }, {
    key: '_renderCurrentTooltip',
    value: function _renderCurrentTooltip() {
      var lastCurrentStyle = {};
      if (this.props.currentEvent.percentage > 90) {
        lastCurrentStyle = { left: '-77px' };
      }

      if (this.props.currentEvent.percentage < 10) {
        lastCurrentStyle = { left: '-20px' };
      }

      return this._calculateProgress() > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { className: _style2.default.CourseProgressBar_currentSessionLine_tooltip,
            style: lastCurrentStyle },
          this.props.currentEvent.content,
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'time',
            { dateTime: this.props.currentEvent.date },
            this.props.currentEvent.date
          )
        )
      ) : '';
    }
  }, {
    key: '_onScrollStart',
    value: function _onScrollStart() {
      this.setState({
        isAtScrollMinX: false,
        isAtScrollMaxX: false
      });
    }
  }, {
    key: '_onScrollEnd',
    value: function _onScrollEnd(_iScroll) {
      var newState = {
        isAtScrollMinX: false,
        isAtScrollMaxX: false
      };
      if (_iScroll.x === 0) {
        newState.isAtScrollMinX = true;
      } else if (_iScroll.x === _iScroll.maxScrollX) {
        newState.isAtScrollMaxX = true;
      }
      if (newState.isAtScrollMinX !== this.state.isAtScrollMinX || newState.isAtScrollMaxX !== this.state.isAtScrollMaxX) {
        this.setState(newState);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var courseProgressBarNode = void 0;
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames7.default)(_style2.default.CourseProgressBar_container, this.props.className) },
        _react2.default.createElement(
          _reactIscroll2.default,
          { className: _style2.default.CourseProgressBar,
            iScroll: _iscroll2.default,
            options: {
              bounce: false,
              scrollX: true,
              scrollY: false,
              scrollbars: true,
              interactiveScrollbars: true,
              eventPassthrough: true,
              keyBindings: true
            },
            ref: function ref(node) {
              courseProgressBarNode = node;
            },
            onScrollStart: this._onScrollStart,
            onScrollEnd: this._onScrollEnd },
          _react2.default.createElement(
            'div',
            { className: _style2.default.CourseProgressBar_inner,
              onMouseDown: function onMouseDown() {
                var wrapper = courseProgressBarNode.getIScroll().wrapper;
                wrapper.classList.add(_style2.default.__moving);
              },
              onMouseUp: function onMouseUp() {
                var wrapper = courseProgressBarNode.getIScroll().wrapper;
                wrapper.classList.remove(_style2.default.__moving);
              } },
            _react2.default.createElement(
              'div',
              { className: _style2.default.CourseProgressBar_basicBar },
              _react2.default.createElement(
                'div',
                { className: _style2.default.CourseProgressBar_progressBar,
                  style: this._getProgressBarStyle() },
                _react2.default.createElement(
                  'div',
                  { className: _style2.default.CourseProgressBar_currentSessionLine },
                  this._renderCurrentTooltip()
                )
              ),
              this._renderStartEventDot(),
              this._renderHighLightEventDots(),
              this._renderEndEventDot()
            ),
            this.props.children
          )
        ),
        _react2.default.createElement('div', { className: (0, _classnames7.default)(_style2.default.CourseProgressBar_leftNav, _defineProperty({}, _style2.default.__visible, !this.state.isAtScrollMinX)),
          onClick: function onClick(ev) {
            ev.preventDefault();
            courseProgressBarNode.withIScroll(function (_iScroll) {
              // gte because x pos is negative for some reason
              if (_iScroll.x >= 0) return;
              _iScroll.scrollBy(50, 0, 300, _iscroll2.default.utils.ease.circular);
            });
          } }),
        _react2.default.createElement('div', { className: (0, _classnames7.default)(_style2.default.CourseProgressBar_rightNav, _defineProperty({}, _style2.default.__visible, !this.state.isAtScrollMaxX)),
          onClick: function onClick(ev) {
            ev.preventDefault();
            courseProgressBarNode.withIScroll(function (_iScroll) {
              if (_iScroll.x <= _iScroll.maxScrollX) return;
              _iScroll.scrollBy(-50, 0, 300, _iscroll2.default.utils.ease.circular);
            });
          } })
      );
    }
  }]);

  return CourseProgressBar;
}(_react.Component);

CourseProgressBar.propTypes = {
  className: _propTypes2.default.string,
  currentEvent: _propTypes2.default.object.isRequired,
  startEvent: _propTypes2.default.object.isRequired,
  endEvent: _propTypes2.default.object.isRequired,
  highLightEvents: _propTypes2.default.array,
  children: _propTypes2.default.node
};

exports.default = CourseProgressBar;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1261);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@-webkit-keyframes _2t4Vsdc99d-r4vovftWY6v{0%{opacity:0}to{opacity:1}}@-moz-keyframes _2t4Vsdc99d-r4vovftWY6v{0%{opacity:0}to{opacity:1}}@-o-keyframes _2t4Vsdc99d-r4vovftWY6v{0%{opacity:0}to{opacity:1}}@keyframes _2t4Vsdc99d-r4vovftWY6v{0%{opacity:0}to{opacity:1}}._6jqUGZADsIp87Z4yzqF7a .iScrollHorizontalScrollbar{z-index:200!important}._6jqUGZADsIp87Z4yzqF7a .iScrollIndicator{background-color:#ccc!important;cursor:all-scroll}._6jqUGZADsIp87Z4yzqF7a{letter-spacing:.07143rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media (min-width:481px){._6jqUGZADsIp87Z4yzqF7a{overflow:visible!important}}@media (max-width:480px){._6jqUGZADsIp87Z4yzqF7a{cursor:move;cursor:-webkit-grab;cursor:-moz-grab;cursor:grab;height:10.35714rem;position:absolute!important;width:100%}._6jqUGZADsIp87Z4yzqF7a._3iEEqcqDaR75MOK8R6w0ZX{cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}}._3WDaCPIet48LXqgoydnILc{height:100%;overflow:visible;position:relative;width:100%}@media (max-width:480px){._3WDaCPIet48LXqgoydnILc{height:9.28571rem}}._1e589zfQQT3MxlOBIeY7FM{height:7.14286rem;min-width:24.28571rem;padding-top:3.57143rem;position:relative}@media (max-width:480px){._1e589zfQQT3MxlOBIeY7FM{height:8.21429rem;width:-webkit-calc(100% + 2.85714rem);width:-moz-calc(100% + 2.85714rem);width:calc(100% + 2.85714rem)}}.R9ggbkcg201LGOeppVv_G{background:#d8d8d8;height:.42857rem;margin:0 .71429rem;min-width:22.85714rem;position:relative;width:-webkit-calc(100% - 1.28571rem);width:-moz-calc(100% - 1.28571rem);width:calc(100% - 1.28571rem)}@media (max-width:480px){.R9ggbkcg201LGOeppVv_G{border-right:1.42857rem solid #fbfbfb;left:1.42857rem;margin:0;margin-top:.71429rem}}._2qPywyxr3-O_4Q9QXYZKaZ{background:#0087e6;height:.42857rem;width:0}.Sim8X3tj2rbWwagCf9i2F{background-color:#0087e6;bottom:.78571rem;float:right;height:1.21429rem;position:relative;width:.07143rem}._3uGp3s8xBwarPDehfsDB5t{bottom:.92857rem;cursor:default;display:block;font-size:.85714rem;left:-3.57143rem;padding:.42857rem .57143rem;position:absolute;text-align:center;white-space:nowrap}._2RwtheKX_UIyIlfdh5lQbz{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:#d8d8d8;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:1.28571rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute;top:-.42857rem;width:1.28571rem}._2RwtheKX_UIyIlfdh5lQbz,._3wAtkjLaxPoeNttKUxYxW0{-webkit-border-radius:7.14286rem;-moz-border-radius:7.14286rem;border-radius:7.14286rem}._3wAtkjLaxPoeNttKUxYxW0{background:#fff;height:.57143rem;width:.57143rem}._3a0j4E-2cTj7-XHs7tGo-b,._3TtgzOEYNhh3XSFhc7IlmN,._39s6Y6JPFbxCs0dWtT90HQ{-webkit-border-radius:.21429rem;-moz-border-radius:.21429rem;border-radius:.21429rem;-webkit-box-shadow:0 .14286rem .35714rem rgba(0,0,0,.26667);-moz-box-shadow:0 .14286rem .35714rem rgba(0,0,0,.26667);box-shadow:0 .14286rem .35714rem rgba(0,0,0,.26667);cursor:default;display:none;text-align:center;white-space:nowrap;word-wrap:word-break;z-index:100}._2RwtheKX_UIyIlfdh5lQbz:hover ._3a0j4E-2cTj7-XHs7tGo-b,._2RwtheKX_UIyIlfdh5lQbz:hover ._3TtgzOEYNhh3XSFhc7IlmN,._2RwtheKX_UIyIlfdh5lQbz:hover ._39s6Y6JPFbxCs0dWtT90HQ{-webkit-animation:_2t4Vsdc99d-r4vovftWY6v .3s;-moz-animation:_2t4Vsdc99d-r4vovftWY6v .3s;-o-animation:_2t4Vsdc99d-r4vovftWY6v .3s;animation:_2t4Vsdc99d-r4vovftWY6v .3s;background-color:#4a4a4a;color:#fff;display:block;font-size:.85714rem;font-weight:600;padding:.42857rem .57143rem;position:absolute;top:145%}._2RwtheKX_UIyIlfdh5lQbz:hover ._3a0j4E-2cTj7-XHs7tGo-b:after,._2RwtheKX_UIyIlfdh5lQbz:hover ._3TtgzOEYNhh3XSFhc7IlmN:after,._2RwtheKX_UIyIlfdh5lQbz:hover ._39s6Y6JPFbxCs0dWtT90HQ:after{border-left:.57143rem solid transparent;border-right:.57143rem solid transparent;border-top:.57143rem solid #4a4a4a;content:\" \";display:block;height:.57143rem;position:absolute;right:.92857rem;top:-15%;-webkit-transform:scaleY(-1);-moz-transform:scaleY(-1);-ms-transform:scaleY(-1);-o-transform:scaleY(-1);transform:scaleY(-1);width:1.14286rem}._2RwtheKX_UIyIlfdh5lQbz:hover ._3a0j4E-2cTj7-XHs7tGo-b{left:-2.64286rem}._2RwtheKX_UIyIlfdh5lQbz:hover ._3a0j4E-2cTj7-XHs7tGo-b:after{left:2.71429rem}._2RwtheKX_UIyIlfdh5lQbz:hover ._3TtgzOEYNhh3XSFhc7IlmN{left:-.35714rem}._2RwtheKX_UIyIlfdh5lQbz:hover ._3TtgzOEYNhh3XSFhc7IlmN:after{left:3%}._2RwtheKX_UIyIlfdh5lQbz:hover ._39s6Y6JPFbxCs0dWtT90HQ{right:-20%}._2RwtheKX_UIyIlfdh5lQbz:hover ._39s6Y6JPFbxCs0dWtT90HQ:after{right:3%}._3BwvB1GstmAmkDwvyjHEnx,.Blnbn8SsFJ7anUOEMnGYX{display:none;opacity:0;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;will-change:opacity,pointer-events}._3BwvB1GstmAmkDwvyjHEnx.kfBzo1hC6ZjMdP32lf-_0,.Blnbn8SsFJ7anUOEMnGYX.kfBzo1hC6ZjMdP32lf-_0{opacity:1;pointer-events:auto}@media (max-width:480px){._3BwvB1GstmAmkDwvyjHEnx,.Blnbn8SsFJ7anUOEMnGYX{cursor:pointer;display:inline-block;height:90%;position:absolute;top:0;width:2.14286rem}}.Blnbn8SsFJ7anUOEMnGYX{background:-webkit-gradient(linear,right top,left top,from(hsla(0,0%,98%,0)),to(#fbfbfb));background:-webkit-linear-gradient(right,hsla(0,0%,98%,0),#fbfbfb);background:-moz-linear-gradient(right,hsla(0,0%,98%,0),#fbfbfb);background:-o-linear-gradient(right,hsla(0,0%,98%,0),#fbfbfb);background:linear-gradient(-90deg,hsla(0,0%,98%,0),#fbfbfb)}._3BwvB1GstmAmkDwvyjHEnx{background:-webkit-gradient(linear,left top,right top,from(hsla(0,0%,98%,0)),to(#fbfbfb));background:-webkit-linear-gradient(left,hsla(0,0%,98%,0),#fbfbfb);background:-moz-linear-gradient(left,hsla(0,0%,98%,0),#fbfbfb);background:-o-linear-gradient(left,hsla(0,0%,98%,0),#fbfbfb);background:linear-gradient(90deg,hsla(0,0%,98%,0),#fbfbfb)}@media (max-width:480px){._3BwvB1GstmAmkDwvyjHEnx{right:0}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"CourseProgressBar": "_6jqUGZADsIp87Z4yzqF7a",
	"__moving": "_3iEEqcqDaR75MOK8R6w0ZX",
	"CourseProgressBar_container": "_3WDaCPIet48LXqgoydnILc",
	"CourseProgressBar_inner": "_1e589zfQQT3MxlOBIeY7FM",
	"CourseProgressBar_basicBar": "R9ggbkcg201LGOeppVv_G",
	"CourseProgressBar_progressBar": "_2qPywyxr3-O_4Q9QXYZKaZ",
	"CourseProgressBar_currentSessionLine": "Sim8X3tj2rbWwagCf9i2F",
	"CourseProgressBar_currentSessionLine_tooltip": "_3uGp3s8xBwarPDehfsDB5t",
	"CourseProgressBar_eventDots": "_2RwtheKX_UIyIlfdh5lQbz",
	"CourseProgressBar_eventDots_whiteDots": "_3wAtkjLaxPoeNttKUxYxW0",
	"CourseProgressBar_eventDots_tooltip": "_3a0j4E-2cTj7-XHs7tGo-b",
	"CourseProgressBar_eventDots_leftTooltip": "_3TtgzOEYNhh3XSFhc7IlmN",
	"CourseProgressBar_eventDots_rightTooltip": "_39s6Y6JPFbxCs0dWtT90HQ",
	"CourseProgressBar_tooltip_opacity": "_2t4Vsdc99d-r4vovftWY6v",
	"CourseProgressBar_leftNav": "Blnbn8SsFJ7anUOEMnGYX",
	"CourseProgressBar_rightNav": "_3BwvB1GstmAmkDwvyjHEnx",
	"__visible": "kfBzo1hC6ZjMdP32lf-_0"
};

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1263);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TableView = __webpack_require__(59);

var _SwitchButton = __webpack_require__(1300);

var _SwitchButton2 = _interopRequireDefault(_SwitchButton);

var _ = __webpack_require__(13);

var _AveragesOverviewTable = __webpack_require__(1303);

var _AveragesOverviewTable2 = _interopRequireDefault(_AveragesOverviewTable);

var _SkillsAveragesTable = __webpack_require__(1305);

var _SkillsAveragesTable2 = _interopRequireDefault(_SkillsAveragesTable);

var _RewardsTable = __webpack_require__(1306);

var _RewardsTable2 = _interopRequireDefault(_RewardsTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TABLES = {
  'Averages Overview': _AveragesOverviewTable2.default,
  'Skills Averages': _SkillsAveragesTable2.default
};

var PerformanceCard = function (_Component) {
  _inherits(PerformanceCard, _Component);

  function PerformanceCard(props) {
    _classCallCheck(this, PerformanceCard);

    var _this = _possibleConstructorReturn(this, (PerformanceCard.__proto__ || Object.getPrototypeOf(PerformanceCard)).call(this, props));

    _this.state = {
      activeTable: 'Averages Overview'
    };
    return _this;
  }

  _createClass(PerformanceCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          groupId = _props.groupId,
          groupPerformance = _props.groupPerformance,
          disableSwitchTable = _props.disableSwitchTable;

      if (!_is_js2.default.existy(groupPerformance) || !_is_js2.default.existy(groupPerformance.studentsPerformance)) {
        return null;
      }

      var state = _omniCommonUi.Store.get().getState();

      if (_.actions.isHFCourseTypeGroup(state, groupId) && _.actions.hasContentPath(state, groupId)) {
        Object.assign(TABLES, { Rewards: _RewardsTable2.default });
      }

      var isAnyStudentHasRewards = groupPerformance.studentsPerformance.some(function (studentPerformance) {
        return _is_js2.default.existy(studentPerformance.rewards);
      });
      var isAnyStudentHasTotalScore = groupPerformance.studentsPerformance.some(function (studentPerformance) {
        return _is_js2.default.number(studentPerformance.averageTotalScore) && studentPerformance.averageTotalScore > 0;
      });
      var isAnyStudentHasHomeworkCompletion = groupPerformance.studentsPerformance.some(function (studentPerformance) {
        return _is_js2.default.number(studentPerformance.averageOnlineHomeworkCompletion) && studentPerformance.averageOnlineHomeworkCompletion > 0;
      });
      var isAnyStudentHasPaperBasedHomeworkCompletion = groupPerformance.studentsPerformance.some(function (studentPerformance) {
        return _is_js2.default.number(studentPerformance.averagePaperBasedHomeworkCompletion) && studentPerformance.averagePaperBasedHomeworkCompletion > 0;
      });
      var isPerformanceCardShown = isAnyStudentHasHomeworkCompletion || isAnyStudentHasTotalScore || isAnyStudentHasPaperBasedHomeworkCompletion;
      if (!isPerformanceCardShown) {
        return null;
      }
      var options = Object.keys(TABLES).map(function (name, idx) {
        if (name === 'Rewards') {
          return { label: name, value: name, disabled: idx > 0 && !isAnyStudentHasRewards };
        }

        return { label: name, value: name, disabled: idx > 0 && !isAnyStudentHasTotalScore };
      });
      // eek. why does TableView have a PageCard in it?
      var OriginalCmpt = TABLES[this.state.activeTable];
      var that = this;
      var EnhancedCmpt = function (_OriginalCmpt) {
        _inherits(EnhancedCmpt, _OriginalCmpt);

        function EnhancedCmpt() {
          _classCallCheck(this, EnhancedCmpt);

          return _possibleConstructorReturn(this, (EnhancedCmpt.__proto__ || Object.getPrototypeOf(EnhancedCmpt)).apply(this, arguments));
        }

        _createClass(EnhancedCmpt, [{
          key: '_renderTableHeaderRow',
          value: function _renderTableHeaderRow(arg) {
            // override
            var secondRow = _get(EnhancedCmpt.prototype.__proto__ || Object.getPrototypeOf(EnhancedCmpt.prototype), '_renderTableHeaderRow', this).call(this, arg);
            (0, _invariant2.default)(secondRow && secondRow.props && secondRow.props.children, 'it should have an existing heading row with children');
            var headingsCount = _react2.default.Children.count(secondRow.props.children);
            var firstRow = _react2.default.createElement(
              _TableView.TableViewTr,
              { key: 'PerformanceCard-hrow1' },
              _react2.default.createElement(
                'td',
                { colSpan: headingsCount },
                _react2.default.createElement(
                  'div',
                  { className: _style2.default.PerformanceCard_firstHeaderRow },
                  _react2.default.createElement(
                    _omniCommonUi.Form,
                    { className: _style2.default.PerformanceCard_form },
                    _react2.default.createElement(_omniCommonUi.Form.Select, { className: _style2.default.PerformanceCard_select,
                      name: 'table',
                      options: options,
                      value: that.state.activeTable,
                      setValue: function setValue(val) {
                        that.setState({ activeTable: val });
                      },
                      clearable: false,
                      searchable: false })
                  ),
                  that.state.activeTable === 'Rewards' && _react2.default.createElement(_SwitchButton2.default, { text: 'Percent',
                    isSelected: this.state.isShowPercent,
                    onSwitchButtonClicked: this._onSwitchButtonClicked })
                )
              )
            );
            return disableSwitchTable ? [secondRow] : [firstRow, secondRow];
          }
        }]);

        return EnhancedCmpt;
      }(OriginalCmpt);
      EnhancedCmpt.displayName = this.state.activeTable;
      return _react2.default.createElement(
        'div',
        { className: (0, _omniCommonUi.testClass)('performance-card') },
        _react2.default.createElement(EnhancedCmpt, this.props)
      );
    }
  }]);

  return PerformanceCard;
}(_react.Component);

PerformanceCard.propTypes = {
  groupId: _propTypes2.default.string.isRequired,
  location: _propTypes2.default.object.isRequired,
  groupPerformance: _propTypes2.default.object.isRequired,
  disableSwitchTable: _propTypes2.default.bool,
  sessionId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

exports.default = PerformanceCard;

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1264);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._6wPajO5vpBiA8raPPbSXb{max-width:20rem;padding:.5rem 0}._1NPe_KxxFtCApCvGsAG1eo{width:17.14286rem}._1NPe_KxxFtCApCvGsAG1eo .Select-control{border:.07143rem solid #ccc;-webkit-border-radius:.35714rem;-moz-border-radius:.35714rem;border-radius:.35714rem}._1NPe_KxxFtCApCvGsAG1eo .Select-menu-outer>*{text-indent:.35714rem}._1NPe_KxxFtCApCvGsAG1eo .Select-value{font-size:1em;padding-left:1.14286rem!important}._2UJWGyCqXFF4WnvxefMwPt{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"PerformanceCard_form": "_6wPajO5vpBiA8raPPbSXb",
	"PerformanceCard_select": "_1NPe_KxxFtCApCvGsAG1eo",
	"PerformanceCard_firstHeaderRow": "_2UJWGyCqXFF4WnvxefMwPt"
};

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1266);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _ = __webpack_require__(59);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(401);

var _lodash2 = _interopRequireDefault(_lodash);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _PageSelector = __webpack_require__(1268);

var _PageSelector2 = _interopRequireDefault(_PageSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_PAGE_SIZE = 10;

var TableView = function (_Component) {
  _inherits(TableView, _Component);

  function TableView(props) {
    _classCallCheck(this, TableView);

    var _this = _possibleConstructorReturn(this, (TableView.__proto__ || Object.getPrototypeOf(TableView)).call(this, props));

    _this.state = { pageSize: _this._calculateDefaultPageSize(props) };
    _this._onNumberOfItemsPerPageChanged = _this._onNumberOfItemsPerPageChanged.bind(_this);
    _this._onNumberOfItemsPerPageChanged = (0, _lodash2.default)(_this._onNumberOfItemsPerPageChanged);
    return _this;
  }

  _createClass(TableView, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.query.pageSize !== this.props.query.pageSize) {
        return this.setState({ pageSize: newProps.query.pageSize });
      }

      if (newProps.totalRecords !== this.props.totalRecords) {
        return this.setState({
          pageSize: this._calculateCurrentPageSize(newProps)
        });
      }
    }
  }, {
    key: '_calculateDefaultPageSize',
    value: function _calculateDefaultPageSize(props) {
      var totalRecords = parseInt(props.totalRecords, 10);
      return totalRecords < DEFAULT_PAGE_SIZE ? totalRecords : DEFAULT_PAGE_SIZE;
    }
  }, {
    key: '_calculateCurrentPageSize',
    value: function _calculateCurrentPageSize(props) {
      var pageSize = props.query.pageSize;
      var totalRecords = parseInt(props.totalRecords, 10);
      if (pageSize) {
        return pageSize < totalRecords ? pageSize : totalRecords;
      }
    }
  }, {
    key: '_renderHeaders',
    value: function _renderHeaders() {
      var _this2 = this;

      var _props = this.props,
          headers = _props.headers,
          query = _props.query,
          customerHeader = _props.customerHeader;

      if (customerHeader) {
        return customerHeader;
      }

      if (!headers) {
        return null;
      }

      return _react2.default.createElement(
        _.TableViewTr,
        null,
        headers.map(function (header) {
          return _react2.default.createElement(
            _.HeaderTd,
            {
              sortable: header.sortable,
              sortType: query.sortBy === header.key ? query.sortType : '',
              onSort: function onSort(sortType) {
                _this2._filterChange({
                  sortBy: header.key,
                  sortType: sortType,
                  pageNumber: 1
                });
              }
            },
            header.text
          );
        })
      );
    }
  }, {
    key: '_filterChange',
    value: function _filterChange(query) {
      if (!(this.state.pageSize > 0)) return;
      var onFilterChange = this.props.onFilterChange;

      if (onFilterChange) {
        onFilterChange(Object.assign({}, this.props.query, query));
      }
    }
  }, {
    key: '_onNumberOfItemsPerPageChanged',
    value: function _onNumberOfItemsPerPageChanged(value) {
      this.setState({ pageSize: value });
      if (_is_js2.default.not.number(value)) {
        return;
      }

      this._filterChange({ pageSize: value, pageNumber: 1 });
    }
  }, {
    key: '_renderPagination',
    value: function _renderPagination() {
      var _this3 = this;

      var _props2 = this.props,
          totalRecords = _props2.totalRecords,
          query = _props2.query;

      if (!this.props.pageable || totalRecords <= 0) {
        return null;
      }

      var pageNumber = parseInt(query.pageNumber, 10);
      var pageSize = parseInt(query.pageSize, 10) || 10;
      var totalPages = Math.ceil(totalRecords / pageSize);
      if (pageNumber > totalPages) {
        this._filterChange({ pageNumber: totalPages });
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: _style2.default.TableView_pagination },
        _react2.default.createElement(_PageSelector2.default, {
          current: pageNumber,
          last: totalPages,
          onChange: function onChange(page) {
            return _this3._onPageChange(page);
          }
        })
      );
    }
  }, {
    key: '_onPageChange',
    value: function _onPageChange(value) {
      this._filterChange({ pageNumber: value });
    }
  }, {
    key: '_renderInputItemsPerPage',
    value: function _renderInputItemsPerPage() {
      var totalRecords = parseInt(this.props.totalRecords, 10);
      return _react2.default.createElement(
        'div',
        { className: _style2.default.TableView_numberSetting_numberInputItem },
        _react2.default.createElement(_omniCommonUi.NumberInput, {
          value: this.state.pageSize,
          className: _style2.default.TableView_numberInput,
          min: '1',
          max: totalRecords,
          onChange: this._onNumberOfItemsPerPageChanged
        }),
        _react2.default.createElement(
          'span',
          { className: _style2.default.TableView_numberSetting_space },
          'Items per page (of ',
          totalRecords,
          ')'
        )
      );
    }
  }, {
    key: '_renderPageSizeControl',
    value: function _renderPageSizeControl() {
      var _props3 = this.props,
          totalRecords = _props3.totalRecords,
          pageable = _props3.pageable,
          customerPageControlRightPart = _props3.customerPageControlRightPart;

      if ((!pageable || totalRecords <= 0) && !customerPageControlRightPart) return null;
      return _react2.default.createElement(
        'div',
        { className: _style2.default.TableView_numberSetting },
        this._renderInputItemsPerPage(),
        customerPageControlRightPart
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          tableTitle = _props4.tableTitle,
          source = _props4.source,
          renderTableRow = _props4.renderTableRow,
          noResultsString = _props4.noResultsString,
          customerFooter = _props4.customerFooter,
          className = _props4.className;


      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _classnames2.default)(_style2.default.TableView, className) },
        tableTitle && _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: tableTitle }),
        this._renderPageSizeControl(),
        _react2.default.createElement(
          _omniCommonUi.HorizontalScroll,
          null,
          _react2.default.createElement(
            'table',
            { className: _style2.default.TableView_table },
            _react2.default.createElement(
              'thead',
              null,
              this._renderHeaders()
            ),
            _react2.default.createElement(
              'tbody',
              null,
              source.map(function (row) {
                return renderTableRow(row);
              })
            )
          )
        ),
        this._renderPagination(),
        (!source || source.length === 0) && noResultsString && _react2.default.createElement(
          'div',
          { className: _style2.default.TableView_noResults },
          noResultsString
        ),
        customerFooter
      );
    }
  }]);

  return TableView;
}(_react.Component);

TableView.propTypes = {
  tableTitle: _propTypes2.default.string,
  headers: _propTypes2.default.array,
  source: _propTypes2.default.array,
  renderTableRow: _propTypes2.default.func,
  pageable: _propTypes2.default.bool,
  noResultsString: _propTypes2.default.string,
  query: _propTypes2.default.object,
  onFilterChange: _propTypes2.default.func,
  customerHeader: _propTypes2.default.object,
  customerFooter: _propTypes2.default.node,
  totalRecords: _propTypes2.default.number,
  className: _propTypes2.default.string,
  customerPageControlRightPart: _propTypes2.default.node
};

exports.default = TableView;

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1267);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3LJgO3R_tGEl9lm6DjJcRl{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1JPgNwxRpF9mNEkKv4tafy{border-collapse:collapse;letter-spacing:.03571rem;width:100%}._1JPgNwxRpF9mNEkKv4tafy td:first-child{padding-left:1.42857rem!important}._1JPgNwxRpF9mNEkKv4tafy td:last-child{padding-right:1.42857rem!important}@media only screen and (min-width:640px){._1JPgNwxRpF9mNEkKv4tafy td:first-child{padding-left:2.14286rem!important}._1JPgNwxRpF9mNEkKv4tafy td:last-child{padding-right:2.14286rem!important}}._2SHUgpmGWxFksDHL3JdlYw{border-top:.07143rem solid #ccc;color:#b4b4b4;font-size:1rem;min-height:3.21429rem;padding:1rem 1.42857rem}@media only screen and (min-width:640px){._2SHUgpmGWxFksDHL3JdlYw{padding:1rem 2.14286rem}}._1A18bmrc8TY6PzIE8ieBhR{border-bottom:.07143rem solid #ccc;font-size:1rem;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:3.57143rem;padding:0 1.42857rem}._1A18bmrc8TY6PzIE8ieBhR,._2Iutnnr6j5jp7wdZxrmVV8{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._2Iutnnr6j5jp7wdZxrmVV8{-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;line-height:3.57143rem}._2NxFdzDj2jxciVdeAGlLyT{margin-left:.35714rem;white-space:nowrap}._1A18bmrc8TY6PzIE8ieBhR:focus{outline:0}@media only screen and (min-width:640px){._1A18bmrc8TY6PzIE8ieBhR{padding:0 2.14286rem}}._2bXqAGj0fu66waXkkfjlAh{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:3.57143rem;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;min-height:3.57143rem;padding:0 1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"TableView": "_3LJgO3R_tGEl9lm6DjJcRl",
	"TableView_table": "_1JPgNwxRpF9mNEkKv4tafy",
	"TableView_noResults": "_2SHUgpmGWxFksDHL3JdlYw",
	"TableView_numberSetting": "_1A18bmrc8TY6PzIE8ieBhR",
	"TableView_numberSetting_numberInputItem": "_2Iutnnr6j5jp7wdZxrmVV8",
	"TableView_numberSetting_space": "_2NxFdzDj2jxciVdeAGlLyT",
	"TableView_pagination": "_2bXqAGj0fu66waXkkfjlAh"
};

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.testClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1269);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RENDER_ALL_BUTTONS_LIMIT = 4;

var testClass = exports.testClass = function testClass(klass) {
  return (0, _omniCommonUi.testClass)('page-selector-' + klass);
};

var PageSelector = function (_PureComponent) {
  _inherits(PageSelector, _PureComponent);

  function PageSelector(props) {
    _classCallCheck(this, PageSelector);

    var _this = _possibleConstructorReturn(this, (PageSelector.__proto__ || Object.getPrototypeOf(PageSelector)).call(this, props));

    _this._onPreviousClicked = _this._onPreviousClicked.bind(_this);
    _this._onNextClicked = _this._onNextClicked.bind(_this);
    _this._onButtonClicked = _this._onButtonClicked.bind(_this);
    return _this;
  }

  _createClass(PageSelector, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._validateLast(this.props.last);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      this._validateLast(nextProps.last);
    }
  }, {
    key: '_validateLast',
    value: function _validateLast(last) {
      (0, _invariant2.default)(last >= 1, 'PageSelector needs to render at least one page');
    }
  }, {
    key: '_onPreviousClicked',
    value: function _onPreviousClicked() {
      if (this._isCurrentFirst()) return;
      this.props.onChange(this.props.current - 1);
    }
  }, {
    key: '_onNextClicked',
    value: function _onNextClicked() {
      if (this._isCurrentLast()) return;
      this.props.onChange(this.props.current + 1);
    }
  }, {
    key: '_onButtonClicked',
    value: function _onButtonClicked(event) {
      this.props.onChange(event.currentTarget.dataset.pageNumber);
    }
  }, {
    key: '_isCurrentFirst',
    value: function _isCurrentFirst() {
      return this.props.current <= 1;
    }
  }, {
    key: '_isCurrentLast',
    value: function _isCurrentLast() {
      return this.props.current === this.props.last;
    }
  }, {
    key: '_renderButtons',
    value: function _renderButtons() {
      if (this.props.last <= RENDER_ALL_BUTTONS_LIMIT) {
        return this._renderAllButtons();
      }

      return this._renderSomeButtons();
    }
  }, {
    key: '_renderAllButtons',
    value: function _renderAllButtons() {
      var _this2 = this;

      return new Array(this.props.last).fill(null).map(function (item, index) {
        return _this2._renderButton(index + 1);
      });
    }
  }, {
    key: '_renderSomeButtons',
    value: function _renderSomeButtons() {
      var _props = this.props,
          last = _props.last,
          current = _props.current;

      return [this._renderButton(1), current !== 2 && this._renderSeparator(), current > 1 && current < last && this._renderButton(current), current > 1 && current < last - 1 && this._renderSeparator(), this._renderButton(this.props.last)];
    }
  }, {
    key: '_renderButton',
    value: function _renderButton(pageNumber) {
      var isCurrent = pageNumber === this.props.current;
      var classes = (0, _classnames3.default)(_style2.default.PageSelector_button, testClass('button'), testClass(pageNumber), _defineProperty({}, _style2.default.__active, isCurrent));
      return _react2.default.createElement(
        'button',
        {
          className: classes,
          key: pageNumber,
          onClick: isCurrent ? undefined : this._onButtonClicked,
          'data-page-number': pageNumber
        },
        pageNumber
      );
    }
  }, {
    key: '_renderSeparator',
    value: function _renderSeparator() {
      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames3.default)(_style2.default.PageSelector_separator, testClass('separator'))
        },
        '\u2026'
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _style2.default.PageSelector },
        _react2.default.createElement(
          'a',
          {
            className: (0, _classnames3.default)(_style2.default.PageSelector_arrow, testClass('previous')),
            onClick: this._onPreviousClicked,
            disabled: this._isCurrentFirst()
          },
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'chevron-small-left' })
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.PageSelector_buttons },
          this._renderButtons()
        ),
        _react2.default.createElement(
          'a',
          {
            className: (0, _classnames3.default)(_style2.default.PageSelector_arrow, testClass('next')),
            onClick: this._onNextClicked,
            disabled: this._isCurrentLast()
          },
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'chevron-small-right' })
        )
      );
    }
  }]);

  return PageSelector;
}(_react.PureComponent);

PageSelector.propTypes = {
  last: _propTypes2.default.number.isRequired,
  current: _propTypes2.default.number.isRequired,
  onChange: _propTypes2.default.func.isRequired
};

exports.default = PageSelector;

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1270);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3kufEGxASpkFszMolOZHUv{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._3kufEGxASpkFszMolOZHUv,._12oCjtybPAYSAn3C9orPpe{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row}._12oCjtybPAYSAn3C9orPpe{margin-left:.71429rem;margin-right:.71429rem}.yt1uNKlj5WspCpsNu7UGr{background-color:transparent;border:.07143rem solid #4a4a4a;-webkit-border-radius:.35714rem;-moz-border-radius:.35714rem;border-radius:.35714rem;cursor:pointer;height:2.14286rem;min-width:2.14286rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:.85714rem;font-weight:600;letter-spacing:.07143rem;text-transform:uppercase}.yt1uNKlj5WspCpsNu7UGr._3AnGjDTXRn-hO9tXD9Jx6j{background-color:#4a4a4a;color:#fff;cursor:default}._2oOeCGQ897bYCeMB9-k_hz:not(:last-child),.yt1uNKlj5WspCpsNu7UGr:not(:last-child){margin-right:.71429rem}._2oOeCGQ897bYCeMB9-k_hz{-webkit-box-align:end;-webkit-align-items:flex-end;-moz-box-align:end;-ms-flex-align:end;align-items:flex-end;cursor:default;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding-bottom:.35714rem}._1iVBpFH0KVKczxVwtg1nau{cursor:pointer;font-size:1rem}._1iVBpFH0KVKczxVwtg1nau[disabled]{color:#a4a4a4;cursor:default}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"PageSelector": "_3kufEGxASpkFszMolOZHUv",
	"PageSelector_buttons": "_12oCjtybPAYSAn3C9orPpe",
	"PageSelector_button": "yt1uNKlj5WspCpsNu7UGr",
	"__active": "_3AnGjDTXRn-hO9tXD9Jx6j",
	"PageSelector_separator": "_2oOeCGQ897bYCeMB9-k_hz",
	"PageSelector_arrow": "_1iVBpFH0KVKczxVwtg1nau"
};

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1272);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableViewTr = function TableViewTr(props) {
  return _react2.default.createElement(
    'tr',
    { className: _style2.default.TableViewTr },
    props.children
  );
};

TableViewTr.propTypes = {
  children: _propTypes2.default.node
};

exports.default = TableViewTr;

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1273);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1GjZIixQNmLIxMOQOOxXpu{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._3O9lBXqhxiGSXAFlpFdjt0{border-collapse:collapse;letter-spacing:.03571rem;width:100%}._3O9lBXqhxiGSXAFlpFdjt0 td:first-child{padding-left:1.42857rem!important}._3O9lBXqhxiGSXAFlpFdjt0 td:last-child{padding-right:1.42857rem!important}@media only screen and (min-width:640px){._3O9lBXqhxiGSXAFlpFdjt0 td:first-child{padding-left:2.14286rem!important}._3O9lBXqhxiGSXAFlpFdjt0 td:last-child{padding-right:2.14286rem!important}}._1hMlJcrvInWFUFbejb9R_T{border-top:.07143rem solid #ccc;color:#b4b4b4;font-size:1rem;min-height:3.21429rem;padding:1rem 1.42857rem}@media only screen and (min-width:640px){._1hMlJcrvInWFUFbejb9R_T{padding:1rem 2.14286rem}}.L5pi5jZGAVJwlzAmkm2SH{border-bottom:.07143rem solid #ccc;font-size:1rem;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:3.57143rem;padding:0 1.42857rem}._2RvHlx0DpBKTRtDSR3Hucb,.L5pi5jZGAVJwlzAmkm2SH{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._2RvHlx0DpBKTRtDSR3Hucb{-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;line-height:3.57143rem}._21B1ObDGo7x1rDfs5CZI-h{margin-left:.35714rem;white-space:nowrap}.L5pi5jZGAVJwlzAmkm2SH:focus{outline:0}@media only screen and (min-width:640px){.L5pi5jZGAVJwlzAmkm2SH{padding:0 2.14286rem}}._2jLRHqHyapws9d05pso7Z-{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:3.57143rem;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;min-height:3.57143rem;padding:0 1.42857rem}._3XlzveaaVBValdIfauCg_3{border-bottom:.07143rem solid #ccc;height:3.21429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"TableView": "_1GjZIixQNmLIxMOQOOxXpu",
	"TableView_table": "_3O9lBXqhxiGSXAFlpFdjt0",
	"TableView_noResults": "_1hMlJcrvInWFUFbejb9R_T",
	"TableView_numberSetting": "L5pi5jZGAVJwlzAmkm2SH",
	"TableView_numberSetting_numberInputItem": "_2RvHlx0DpBKTRtDSR3Hucb",
	"TableView_numberSetting_space": "_21B1ObDGo7x1rDfs5CZI-h",
	"TableView_pagination": "_2jLRHqHyapws9d05pso7Z-",
	"TableViewTr": "_3XlzveaaVBValdIfauCg_3"
};

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1275);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3XI5pzA82_-QsaT-r45NDs{padding-left:1.42857rem}", ""]);

// exports
exports.locals = {
	"NormalTd": "_3XI5pzA82_-QsaT-r45NDs"
};

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1277);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MemberCardTd = function MemberCardTd(props) {
  return _react2.default.createElement(
    'td',
    null,
    _react2.default.createElement(
      'div',
      { className: _style2.default.MemberCardTd_content },
      _react2.default.createElement(
        _omniCommonUi.StudentCard,
        { borderless: true,
          className: _style2.default.MemberCardTd_studentCard },
        _react2.default.createElement(_omniCommonUi.StudentCard.Profile, { name: props.name,
          localName: props.surname,
          gender: props.gender,
          avatarUrl: props.avatarUrl })
      )
    )
  );
};

MemberCardTd.propTypes = {
  name: _propTypes2.default.string,
  surname: _propTypes2.default.string,
  gender: _propTypes2.default.string,
  avatarUrl: _propTypes2.default.string
};

exports.default = MemberCardTd;

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1278);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".cCgtFdTJxNzMYWxMPWzRt{margin-left:-5.71429rem}.cCgtFdTJxNzMYWxMPWzRt>div,.cCgtFdTJxNzMYWxMPWzRt>div>div,.cCgtFdTJxNzMYWxMPWzRt>div>div>div{width:21.42857rem}._2Pjg7RhesWiI9GYb6SHVft{min-width:5.71429rem;overflow:hidden}@media only screen and (min-width:640px){.cCgtFdTJxNzMYWxMPWzRt{margin-left:-1.07143rem;min-width:14.28571rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MemberCardTd_studentCard": "cCgtFdTJxNzMYWxMPWzRt",
	"MemberCardTd_content": "_2Pjg7RhesWiI9GYb6SHVft"
};

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1280);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _RadialScoreDisplay = __webpack_require__(283);

var _RadialScoreDisplay2 = _interopRequireDefault(_RadialScoreDisplay);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressCardTd = function ProgressCardTd(props) {
  return _react2.default.createElement(
    'td',
    { className: (0, _classnames2.default)(_style2.default.ProgressCardTd, props.className) },
    _react2.default.createElement(_RadialScoreDisplay2.default, { radius: 25,
      circleStrokeWidth: 2,
      edgeSize: 70,
      forcedTextY: 40,
      unit: 'percent',
      displayText: true,
      formatText: function formatText(value) {
        if (props.percent === null) {
          return '-';
        }
        return value + '%';
      },
      circleStroke: 'transparent',
      value: props.percent })
  );
};

ProgressCardTd.propTypes = {
  percent: _propTypes2.default.number,
  className: _propTypes2.default.string
};

exports.default = ProgressCardTd;

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1281);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1yQtNWIT7HSPYALI9wOioP{padding-left:.71429rem}", ""]);

// exports
exports.locals = {
	"ProgressCardTd": "_1yQtNWIT7HSPYALI9wOioP"
};

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1283);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"colorUnknown": "#0087e6",
	"colorOutstanding": "#74d17f",
	"colorStrong": "#74d17f",
	"colorOnTrack": "#f7932d",
	"colorNeedsImprovement": "#de4c4c",
	"colorExperiencingDifficulty": "#de4c4c"
};

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1285);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _NormalTd = __webpack_require__(160);

var _NormalTd2 = _interopRequireDefault(_NormalTd);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusTd = function StatusTd(props) {
  var className = void 0;
  switch (props.text) {
    case 'ACTIVE':
      className = _style2.default.__green;
      break;
    case 'MAINTENANCE':
    case 'PENDING':
      className = _style2.default.__orange;
      break;
    case 'DEACTIVATED':
    case 'OVERDUE':
      className = _style2.default.__red;
      break;
    default:
      className = '';
  }
  return _react2.default.createElement(
    _NormalTd2.default,
    null,
    _react2.default.createElement(
      'span',
      { className: (0, _classnames2.default)(_style2.default.StatusField_status, className) },
      props.text
    )
  );
};

StatusTd.propTypes = {
  text: _propTypes2.default.string
};

exports.default = StatusTd;

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1286);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._11Ve7Zz5792LKh3VYCESAx{color:#fff;font-size:.85714rem;font-weight:600;letter-spacing:.03571rem;padding:.21429rem .35714rem}._11Ve7Zz5792LKh3VYCESAx._39Xs-QXGIwa3F-ewuFN_BR{background:#74d17f}._11Ve7Zz5792LKh3VYCESAx._3UWIszekWz5zwso9BXgcLG{background:#f7932d}._11Ve7Zz5792LKh3VYCESAx._3PBl-luwVROEihb97G6IzM{background:#de4c4c}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StatusField_status": "_11Ve7Zz5792LKh3VYCESAx",
	"__green": "_39Xs-QXGIwa3F-ewuFN_BR",
	"__orange": "_3UWIszekWz5zwso9BXgcLG",
	"__red": "_3PBl-luwVROEihb97G6IzM"
};

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1288);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBarTd = function ProgressBarTd(props) {
  return _react2.default.createElement(
    'td',
    { className: (0, _classnames2.default)(_style2.default.ProgressBarTd, props.className) },
    _react2.default.createElement(_omniCommonUi.ProgressBar, { className: _style2.default.ProgressBarTd_ProgressBar,
      value: props.percent,
      max: 100,
      larger: true,
      rounded: true }),
    !props.isHideText && _react2.default.createElement(
      'div',
      { className: _style2.default.ProgressBarTd_Percent },
      props.progressValue ? props.progressValue : (props.percent ? props.percent : 0) + '%'
    )
  );
};

ProgressBarTd.propTypes = {
  percent: _propTypes2.default.number,
  className: _propTypes2.default.string,
  progressValue: _propTypes2.default.string,
  isHideText: _propTypes2.default.bool
};

exports.default = ProgressBarTd;

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1289);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3N6yxDAvPVrHF_h0zKlFuu{padding-left:1.42857rem}._3drqPduQ_eLlh_x4NWD4me{display:inline-block;width:2.5rem}@media only screen and (min-width:640px){._3drqPduQ_eLlh_x4NWD4me{width:7.85714rem}}._2I0IQM8sYonq9sRLef51x3{display:inline-block;margin-left:.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ProgressBarTd": "_3N6yxDAvPVrHF_h0zKlFuu",
	"ProgressBarTd_ProgressBar": "_3drqPduQ_eLlh_x4NWD4me",
	"ProgressBarTd_Percent": "_2I0IQM8sYonq9sRLef51x3"
};

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1291);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ASCENDING = 'Ascending';
var DESCENDING = 'Descending';

var HeaderTd = function HeaderTd(props) {
  var _classnames;

  var sortClassName = (0, _classnames3.default)(_style2.default.HeaderTd_sort, (_classnames = {}, _defineProperty(_classnames, _style2.default.__ascending, props.sortType === ASCENDING), _defineProperty(_classnames, _style2.default.__descending, props.sortType === DESCENDING), _classnames));
  var nextSortType = props.sortType === ASCENDING ? DESCENDING : ASCENDING;
  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
  return _react2.default.createElement(
    'td',
    { className: (0, _classnames3.default)(props.className, _style2.default.HeaderTd, props.sortable ? _style2.default.HeaderTd_sortable : ''),
      onClick: function onClick() {
        return props.sortable && props.onSort(nextSortType);
      } },
    _react2.default.createElement(
      'div',
      { className: _style2.default.HeaderTd_content },
      _react2.default.createElement(
        'p',
        { className: _style2.default.HeaderTd_p },
        props.children
      ),
      (props.sortType === ASCENDING || props.sortType === DESCENDING) && _react2.default.createElement(_omniCommonUi.Icon, { id: 'sorting', className: sortClassName })
    )
  );
};

HeaderTd.propTypes = {
  sortable: _propTypes2.default.bool,
  sortType: _propTypes2.default.string,
  onSort: _propTypes2.default.func,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

exports.default = HeaderTd;

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1292);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1Xn5gR793jCKw7WGedcgm8{cursor:default;height:3.21429rem;padding-left:1.42857rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:600;letter-spacing:.03571rem;line-height:1.28571}._1hcieoxc0u5EfgcUYuEUDS{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;float:left;white-space:nowrap}._1xL3aeLOYF_33fCRbRGZF5{-webkit-box-flex:0;-webkit-flex:0 1 auto;-moz-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;line-height:1.5;margin:0}._3ZGKa85vhwTMzTAoM_HKDM{cursor:pointer}._1gojXC5dNkeQRRMf8Tjs-8{-webkit-box-flex:0;-webkit-flex:0 0 auto;-moz-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;font-size:.85714rem;margin-left:.42857rem;-webkit-transition:-webkit-transform .3s ease-in-out;transition:-webkit-transform .3s ease-in-out;-o-transition:-o-transform .3s ease-in-out;-moz-transition:transform .3s ease-in-out,-moz-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out,-moz-transform .3s ease-in-out,-o-transform .3s ease-in-out}._1gojXC5dNkeQRRMf8Tjs-8._30Qgw92BZkzBKGnybgm-qM{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg)}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"HeaderTd": "_1Xn5gR793jCKw7WGedcgm8",
	"HeaderTd_content": "_1hcieoxc0u5EfgcUYuEUDS",
	"HeaderTd_p": "_1xL3aeLOYF_33fCRbRGZF5",
	"HeaderTd_sortable": "_3ZGKa85vhwTMzTAoM_HKDM",
	"HeaderTd_sort": "_1gojXC5dNkeQRRMf8Tjs-8",
	"__ascending": "_30Qgw92BZkzBKGnybgm-qM"
};

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1294);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _NormalTd = __webpack_require__(160);

var _NormalTd2 = _interopRequireDefault(_NormalTd);

var _reactRouter = __webpack_require__(16);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DetailLinkTd = function DetailLinkTd(props) {
  return _react2.default.createElement(
    _NormalTd2.default,
    null,
    _react2.default.createElement(
      'div',
      { className: _style2.default.DetailLinkTd_content },
      _react2.default.createElement(
        _reactRouter.Link,
        { to: props.url,
          draggable: false },
        _react2.default.createElement(_omniCommonUi.Icon, { id: 'arrow-right', className: _style2.default.DetailLinkTd_arrowRight })
      )
    )
  );
};

DetailLinkTd.propTypes = {
  url: _propTypes2.default.string.isRequired
};

exports.default = DetailLinkTd;

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1295);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._226kRjufP3DcR2P1QhuqV-{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._2zYX7-ScH9odHE8LAOuawi{cursor:pointer}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"DetailLinkTd_content": "_226kRjufP3DcR2P1QhuqV-",
	"DetailLinkTd_arrowRight": "_2zYX7-ScH9odHE8LAOuawi"
};

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _NormalTd = __webpack_require__(160);

var _NormalTd2 = _interopRequireDefault(_NormalTd);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextTd = function TextTd(props) {
  return _react2.default.createElement(
    _NormalTd2.default,
    null,
    _react2.default.createElement(
      'p',
      null,
      judgeValue(props.text)
    )
  );

  function judgeValue(text) {
    if (_is_js2.default.undefined(text) || text === '') {
      return '-';
    }
    return text;
  }
};

TextTd.propTypes = {
  text: _propTypes2.default.string
};

exports.default = TextTd;

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1298);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _NormalTd = __webpack_require__(160);

var _NormalTd2 = _interopRequireDefault(_NormalTd);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonTd = function ButtonTd(props) {
  return _react2.default.createElement(
    _NormalTd2.default,
    null,
    _react2.default.createElement(
      'div',
      { className: _style2.default.ButtonTd_content },
      _react2.default.createElement(
        _omniCommonUi.Button,
        { onClick: function onClick() {
            return props.onButtonClick();
          } },
        props.text
      )
    )
  );
};

ButtonTd.propTypes = {
  text: _propTypes2.default.string,
  onButtonClick: _propTypes2.default.func
};

exports.default = ButtonTd;

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1299);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1mxwcdBvORuvgDzOvc3wPK{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ButtonTd_content": "_1mxwcdBvORuvgDzOvc3wPK"
};

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1301);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames4 = __webpack_require__(7);

var _classnames5 = _interopRequireDefault(_classnames4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SwitchButton = function (_PureComponent) {
  _inherits(SwitchButton, _PureComponent);

  function SwitchButton() {
    _classCallCheck(this, SwitchButton);

    return _possibleConstructorReturn(this, (SwitchButton.__proto__ || Object.getPrototypeOf(SwitchButton)).apply(this, arguments));
  }

  _createClass(SwitchButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          isSelected = _props.isSelected,
          onSwitchButtonClicked = _props.onSwitchButtonClicked;


      var switchButtonClassName = (0, _classnames5.default)(_style2.default.SwitchButton, _defineProperty({}, _style2.default._selected, isSelected));
      var textClassName = (0, _classnames5.default)(_style2.default.SwitchButton_content_text, _defineProperty({}, _style2.default._selected, isSelected));
      var circleClassName = (0, _classnames5.default)(_style2.default.SwitchButton_content_circle, _defineProperty({}, _style2.default._selected, isSelected));

      return _react2.default.createElement(
        'div',
        { className: switchButtonClassName, onClick: onSwitchButtonClicked },
        _react2.default.createElement(
          'div',
          { className: _style2.default.SwitchButton_content },
          _react2.default.createElement(
            'span',
            { className: textClassName },
            text
          ),
          _react2.default.createElement('div', { className: circleClassName })
        )
      );
    }
  }]);

  return SwitchButton;
}(_react.PureComponent);

SwitchButton.propTypes = {
  text: _propTypes2.default.string,
  isSelected: _propTypes2.default.bool.isRequired,
  onSwitchButtonClicked: _propTypes2.default.func.isRequired
};

exports.default = SwitchButton;

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1302);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3CPjlJLjo8eR-WXfB_IrNh{background:#f4f5f7;-webkit-border-radius:1.07143rem;-moz-border-radius:1.07143rem;border-radius:1.07143rem;cursor:pointer;height:2.14286rem;padding:0 .35714rem;position:relative;width:9.28571rem}._3CPjlJLjo8eR-WXfB_IrNh._3G2WK5QqeOIHmpilc3iJcZ{background:#135805}.Qlf_nj0pxDtrccFcFYHGs{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;position:relative;width:100%}._2GJ2fQXrvWDrPjWLU_XOxx{background:#fff;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;height:1.42857rem;position:absolute;width:1.42857rem}._2GJ2fQXrvWDrPjWLU_XOxx._3G2WK5QqeOIHmpilc3iJcZ{right:0}._2Ee_kt9q60d7LvHDJbSTnl{color:#a4a4a4;margin:0 auto}._2Ee_kt9q60d7LvHDJbSTnl._3G2WK5QqeOIHmpilc3iJcZ{color:#fff}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SwitchButton": "_3CPjlJLjo8eR-WXfB_IrNh",
	"_selected": "_3G2WK5QqeOIHmpilc3iJcZ",
	"SwitchButton_content": "Qlf_nj0pxDtrccFcFYHGs",
	"SwitchButton_content_circle": "_2GJ2fQXrvWDrPjWLU_XOxx",
	"SwitchButton_content_text": "_2Ee_kt9q60d7LvHDJbSTnl"
};

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _style = __webpack_require__(285);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _TableView = __webpack_require__(59);

var _ProductionStatus = __webpack_require__(73);

var _Api = __webpack_require__(11);

var _ = __webpack_require__(13);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ALL_COLUMNS = new _immutable.List([{
  key: 'name',
  text: 'Name',
  sortable: true,
  required: true,
  renderCell: function renderCell(row) {
    return _react2.default.createElement(_TableView.MemberCardTd, { name: row.studentGeneralInfo.firstName + ' ' + row.studentGeneralInfo.lastName,
      surname: row.studentGeneralInfo.localName,
      avatarUrl: row.studentGeneralInfo.avatarUrl,
      gender: row.studentGeneralInfo.gender });
  },
  cellClass: ''
}, {
  key: 'status',
  text: 'Status',
  sortable: false,
  required: true,
  renderCell: function renderCell(row) {
    var isInProduction = row.isInProduction;

    var status = Object.assign({ isInProduction: isInProduction }, (0, _ProductionStatus.parseProductionStatus)(row.status));
    return _react2.default.createElement(
      _TableView.NormalTd,
      null,
      _react2.default.createElement(_omniCommonUi.ProductionStatus, { status: row.status, highlighted: status.isInProduction })
    );
  },
  cellClass: ''
}, {
  key: 'averageTotalScore',
  text: _react2.default.createElement(
    'span',
    null,
    'Average ',
    _react2.default.createElement('wbr', null),
    'Total Score'
  ),
  sortable: true,
  required: false,
  renderCell: function renderCell(row) {
    return _react2.default.createElement(_TableView.ProgressCardTd, { percent: row.averageTotalScore });
  },
  cellClass: ''
}, {
  key: 'averageOnlineHomeworkCompletion',
  text: _react2.default.createElement(
    'span',
    null,
    'Ave. Online ',
    _react2.default.createElement('wbr', null),
    'Practice Completion'
  ),
  sortable: true,
  required: false,
  renderCell: function renderCell(row) {
    return _react2.default.createElement(_TableView.ProgressBarTd, { className: _style2.default.PerformanceCard_mobileLastColomn,
      percent: row.averageOnlineHomeworkCompletion });
  },
  cellClass: _style2.default.PerformanceCard_mobileLastColomn
}, {
  key: 'averageOnlineHomeworkAccuracy',
  text: _react2.default.createElement(
    'span',
    null,
    'Ave. Online ',
    _react2.default.createElement('wbr', null),
    'Practice Accuray'
  ),
  sortable: true,
  required: false,
  renderCell: function renderCell(row) {
    return _react2.default.createElement(_TableView.ProgressBarTd, { className: _style2.default.PerformanceCard_mobileLastColomn,
      percent: row.averageOnlineHomeworkAccuracy });
  },
  cellClass: _style2.default.PerformanceCard_mobileLastColomn
}, {
  key: 'averageOnlineHomeworkBestAccuracy',
  text: _react2.default.createElement(
    'span',
    null,
    'Ave. Online ',
    _react2.default.createElement('wbr', null),
    'Practice Accuray'
  ),
  sortable: true,
  required: false,
  renderCell: function renderCell(row) {
    return _react2.default.createElement(_TableView.ProgressBarTd, { className: _style2.default.PerformanceCard_mobileLastColomn,
      percent: row.averageOnlineHomeworkBestAccuracy });
  },
  cellClass: _style2.default.PerformanceCard_mobileLastColomn
}, {
  key: 'averagePaperBasedHomeworkCompletion',
  text: _react2.default.createElement(
    'span',
    null,
    'Ave. Paper-based ',
    _react2.default.createElement('wbr', null),
    'Practice Completion'
  ),
  sortable: true,
  required: false,
  renderCell: function renderCell(row) {
    return _react2.default.createElement(_TableView.ProgressBarTd, { className: _style2.default.PerformanceCard_mobileLastColomn,
      percent: row.averagePaperBasedHomeworkCompletion });
  },
  cellClass: _style2.default.PerformanceCard_mobileLastColomn
}, {
  key: 'ach',
  text: '% Present ACH',
  sortable: true,
  required: false,
  renderCell: function renderCell(row) {
    var ACHPersent = row.ach.produced === 0 ? '0%' : parseInt(row.ach.present * 100 / row.ach.produced, 10) + '%';
    return _react2.default.createElement(
      _TableView.NormalTd,
      { className: _style2.default.PerformanceCard_presentColomn },
      ACHPersent + ' (' + row.ach.present + '/' + row.ach.produced + ')'
    );
  },
  cellClass: _style2.default.PerformanceCard_presentColomn
}]);

var REQUIRED_COLUMNS = ALL_COLUMNS.filter(function (col) {
  return col.required;
}).map(function (col) {
  return col.key;
}).toArray();

var OPTIONAL_COLUMNS = ALL_COLUMNS.filter(function (col) {
  return !col.required;
}).map(function (col) {
  return col.key;
}).toArray();

var DEFAULT_OPTIONAL_COLUMNS = ['averageTotalScore', 'averageOnlineHomeworkCompletion', 'averageOnlineHomeworkAccuracy', 'averageOnlineHomeworkBestAccuracy', 'averagePaperBasedHomeworkCompletion', 'ach'];

// HFv4 has its own viewer that takes plain query params.
var buildParentPageUrl = function buildParentPageUrl(groupId, sessionId, studentId) {
  var params = new URLSearchParams({
    groupId: groupId || '',
    sessionId: sessionId || '',
    studentId: studentId || ''
  });
  return (_omniCommonUi.Config.get('parentPageViewer') || '') + '?' + params.toString();
};

// Other course types go to the parent app, which needs a token exchanged at click time
// so it does not expire while the table is open.
var openParentPage = function openParentPage(studentId) {
  (0, _Api.fetch)((0, _Api.buildUrl)('/students/' + studentId + '/study-report-token')).then(function (response) {
    var redirectUrl = '' + (_omniCommonUi.Config.get('parentPageAuthUrl') || '') + ('?idTokenV2=' + response.idToken + '&accessTokenV2=' + response.accessToken + '&origin=learning');
    window.open(redirectUrl, '_blank', 'noreferrer');
  }).catch(function () {
    // do nothing.
  });
};

var buildParentPageColumn = function buildParentPageColumn(isHFV4Group) {
  return {
    key: 'parentPage',
    text: 'Parent Page',
    sortable: false,
    required: false,
    renderCell: function renderCell(row) {
      var tableProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var studentId = row.studentGeneralInfo.id;
      var linkProps = isHFV4Group ? {
        href: buildParentPageUrl(tableProps.groupId, tableProps.sessionId, studentId),
        target: '_blank',
        rel: 'noopener noreferrer'
      } : { onClick: function onClick() {
          return openParentPage(studentId);
        } };

      return _react2.default.createElement(
        _TableView.NormalTd,
        null,
        _react2.default.createElement(
          'a',
          _extends({ className: _style2.default.PerformanceCard_parentPageLink }, linkProps),
          'View Parent Page',
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'arrow-right', className: _style2.default.PerformanceCard_parentPageArrow })
        )
      );
    },
    cellClass: ''
  };
};

var AveragesOverviewTable = function (_Component) {
  _inherits(AveragesOverviewTable, _Component);

  function AveragesOverviewTable(props) {
    _classCallCheck(this, AveragesOverviewTable);

    var _this = _possibleConstructorReturn(this, (AveragesOverviewTable.__proto__ || Object.getPrototypeOf(AveragesOverviewTable)).call(this, props));

    _this.state = {
      isExpand: false,
      sortKey: 'averageTotalScore',
      sortType: 'Ascending',
      filterParams: {}
    };
    _this._handleOnFilterChange = _this._handleOnFilterChange.bind(_this);
    return _this;
  }

  _createClass(AveragesOverviewTable, [{
    key: '_handleOnFilterChange',
    value: function _handleOnFilterChange(filterParams) {
      this.setState({ filterParams: filterParams });
    }
  }, {
    key: 'getVisibleColumns',
    value: function getVisibleColumns() {
      var _props = this.props,
          groupId = _props.groupId,
          _props$visibleOptiona = _props.visibleOptionalColumnsInAveragesOverview,
          visibleOptionalColumnsInAveragesOverview = _props$visibleOptiona === undefined ? DEFAULT_OPTIONAL_COLUMNS : _props$visibleOptiona;


      var validOptionalColumns = visibleOptionalColumnsInAveragesOverview.filter(function (colKey) {
        return OPTIONAL_COLUMNS.includes(colKey);
      });

      var finalVisibleColumnKeys = [].concat(_toConsumableArray(REQUIRED_COLUMNS), _toConsumableArray(validOptionalColumns));

      var visibleColumns = ALL_COLUMNS.filter(function (column) {
        return finalVisibleColumnKeys.includes(column.key);
      }).sort(function (a, b) {
        var indexA = finalVisibleColumnKeys.indexOf(a.key);
        var indexB = finalVisibleColumnKeys.indexOf(b.key);
        return indexA - indexB;
      });

      var isHFV4Group = _.actions.isHFV4CourseTypeGroup(_omniCommonUi.Store.get().getState(), groupId);
      return visibleColumns.push(buildParentPageColumn(isHFV4Group));
    }
  }, {
    key: '_renderTableRow',
    value: function _renderTableRow(row) {
      var _this2 = this;

      var visibleColumns = this.getVisibleColumns();
      return _react2.default.createElement(
        _TableView.TableViewTr,
        { key: row.studentGeneralInfo.id + '-performance' },
        visibleColumns.map(function (column) {
          return column.renderCell(row, _this2.props);
        })
      );
    }
  }, {
    key: '_renderExpansionButton',
    value: function _renderExpansionButton() {
      var _this3 = this;

      var groupPerformance = this.props.groupPerformance;

      if (groupPerformance.studentsPerformance.size <= 4) {
        return null;
      }
      return _react2.default.createElement(_ExpansionButton2.default, { isExpand: this.state.isExpand,
        className: _style2.default.PerformanceCard_expansion,
        onExpansionButtonClick: function onExpansionButtonClick() {
          return _this3.setState({ isExpand: !_this3.state.isExpand });
        } });
    }
  }, {
    key: '_renderTableHeaderRow',
    value: function _renderTableHeaderRow() {
      var _this4 = this;

      var _state = this.state,
          sortKey = _state.sortKey,
          sortType = _state.sortType;
      var _props$columnLabelsIn = this.props.columnLabelsInAveragesOverview,
          columnLabelsInAveragesOverview = _props$columnLabelsIn === undefined ? {} : _props$columnLabelsIn;

      var visibleColumns = this.getVisibleColumns();

      return _react2.default.createElement(
        _TableView.TableViewTr,
        { key: 'PerformanceCard-hrow2' },
        visibleColumns.map(function (header) {
          return _react2.default.createElement(
            _TableView.HeaderTd,
            { sortable: header.sortable,
              className: header.cellClass,
              sortType: sortKey === header.key ? sortType : '',
              onSort: function onSort() {
                return _this4._sort(header.key);
              },
              key: header.key },
            columnLabelsInAveragesOverview[header.key] || header.text
          );
        })
      );
    }
  }, {
    key: '_sort',
    value: function _sort(sortKey) {
      var sortType = 'Ascending';
      if (sortKey === this.state.sortKey) {
        sortType = this.state.sortType === 'Ascending' ? 'Descending' : 'Ascending';
      }
      this.setState({ sortKey: sortKey, sortType: sortType });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var groupPerformance = this.props.groupPerformance;
      var startUnitNumber = groupPerformance.startUnitNumber,
          endUnitNumber = groupPerformance.endUnitNumber;

      var tableTitle = startUnitNumber === endUnitNumber ? 'Performance (Unit ' + startUnitNumber + ')' : 'Performance (Units ' + startUnitNumber + '-' + endUnitNumber + ')';
      var viewCount = groupPerformance.studentsPerformance.size >= 4 ? 4 : groupPerformance.studentsPerformance.size;

      var sortedStudentsPerformance = groupPerformance.studentsPerformance.sort(function (currentObject, nextObject) {
        var _state2 = _this5.state,
            sortKey = _state2.sortKey,
            sortType = _state2.sortType;

        var current = currentObject.get(sortKey);
        var next = nextObject.get(sortKey);

        switch (sortKey) {
          case 'name':
            current = (currentObject.studentGeneralInfo.firstName + ' ' + currentObject.studentGeneralInfo.lastName).toLowerCase();
            next = (nextObject.studentGeneralInfo.firstName + ' ' + nextObject.studentGeneralInfo.lastName).toLowerCase();
            break;
          case 'ach':
            current = current.present / (current.produced + 1);
            next = next.present / (next.produced + 1);
            break;
          default:
            break;
        }

        if (sortType === 'Ascending') {
          current = current === null ? 101 : current;
          next = next === null ? 101 : next;
        } else if (sortType === 'Descending') {
          current = current === null ? -101 : current;
          next = next === null ? -101 : next;
        }

        if (currentObject.status === 'Swapped') return 1;
        if (nextObject.status === 'Swapped') return -1;

        if (current > next) return sortType === 'Ascending' ? 1 : -1;
        if (current < next) return sortType === 'Ascending' ? -1 : 1;
        return 0;
      });

      var source = this.state.isExpand ? sortedStudentsPerformance : sortedStudentsPerformance.slice(0, viewCount);

      return _react2.default.createElement(_TableView.TableView, { source: source,
        tableTitle: tableTitle,
        renderTableRow: function renderTableRow(row) {
          return _this5._renderTableRow(row);
        },
        noResultsString: 'No Results.',
        query: this.state.filterParams,
        onFilterChange: this._handleOnFilterChange,
        customerFooter: this._renderExpansionButton(),
        customerHeader: this._renderTableHeaderRow() });
    }
  }]);

  return AveragesOverviewTable;
}(_react.Component);

AveragesOverviewTable.propTypes = {
  groupPerformance: _propTypes2.default.object.isRequired,
  groupId: _propTypes2.default.string,
  sessionId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  visibleOptionalColumnsInAveragesOverview: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(OPTIONAL_COLUMNS)),
  columnLabelsInAveragesOverview: _propTypes2.default.shape({
    name: _propTypes2.default.node,
    status: _propTypes2.default.node,
    averageTotalScore: _propTypes2.default.node,
    averageOnlineHomeworkCompletion: _propTypes2.default.node,
    averagePaperBasedHomeworkCompletion: _propTypes2.default.node,
    ach: _propTypes2.default.node
  })
};

AveragesOverviewTable.defaultProps = {
  visibleOptionalColumns: DEFAULT_OPTIONAL_COLUMNS,
  columnLabels: {}
};

exports.default = AveragesOverviewTable;

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2OK-fv8DsiaxpgdYhOorur{display:none}@media only screen and (min-width:768px){._2OK-fv8DsiaxpgdYhOorur{display:table-cell}}._1d5TOX2tjT9gO7CBUntvLH{padding-right:1.42857rem}@media only screen and (min-width:768px){._1d5TOX2tjT9gO7CBUntvLH{padding-right:0}}._255pJtwFohXsf9Calr91vn{border-top:.07143rem solid #f3f5f7}._2vkpdETQ5SGEVjb5DcR08F{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;gap:.28571rem}._36B57GYvCOeAWuy8Ys0VvS{height:1.28571rem;width:1.28571rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"PerformanceCard_presentColomn": "_2OK-fv8DsiaxpgdYhOorur",
	"PerformanceCard_mobileLastColomn": "_1d5TOX2tjT9gO7CBUntvLH",
	"PerformanceCard_expansion": "_255pJtwFohXsf9Calr91vn",
	"PerformanceCard_parentPageLink": "_2vkpdETQ5SGEVjb5DcR08F",
	"PerformanceCard_parentPageArrow": "_36B57GYvCOeAWuy8Ys0VvS"
};

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(285);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _TableView = __webpack_require__(59);

var _ProductionStatus = __webpack_require__(73);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SkillsAveragesTable = function (_Component) {
  _inherits(SkillsAveragesTable, _Component);

  // eslint-disable-line
  function SkillsAveragesTable(props) {
    _classCallCheck(this, SkillsAveragesTable);

    var _this = _possibleConstructorReturn(this, (SkillsAveragesTable.__proto__ || Object.getPrototypeOf(SkillsAveragesTable)).call(this, props));

    _this.state = {
      isExpand: false,
      sortKey: 'averageTotalScore',
      sortType: 'Ascending',
      filterParams: {} // required for the TableView
    };
    _this._handleOnFilterChange = _this._handleOnFilterChange.bind(_this);
    return _this;
  }

  _createClass(SkillsAveragesTable, [{
    key: '_handleOnFilterChange',
    value: function _handleOnFilterChange(filterParams) {
      this.setState({ filterParams: filterParams });
    }
  }, {
    key: '_renderTableHeaderRow',
    value: function _renderTableHeaderRow() {
      var _this2 = this;

      var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.OrderedMap();
      // overridden/used in PerformanceCard!
      var _state = this.state,
          sortKey = _state.sortKey,
          sortType = _state.sortType;

      var headerDescriptors = [{
        key: 'name', label: 'Name', sortable: true
      }, {
        key: 'status', label: 'Status', sortable: false
      }].concat(headers.map(function (skillName, skillId) {
        return {
          key: '' + skillId, label: skillName, sortable: true
        };
      }).toArray());
      return _react2.default.createElement(
        _TableView.TableViewTr,
        { key: 'PerformanceCard-hrow2' },
        headerDescriptors.map(function (header) {
          return _react2.default.createElement(
            _TableView.HeaderTd,
            { sortable: header.sortable,
              sortType: sortKey === header.key ? sortType : '',
              onSort: function onSort() {
                return _this2._sort(header.key);
              },
              key: header.label },
            header.label
          );
        })
      );
    }
  }, {
    key: '_renderTableRow',
    value: function _renderTableRow(row) {
      var isInProduction = row.isInProduction;

      var status = Object.assign({ isInProduction: isInProduction }, (0, _ProductionStatus.parseProductionStatus)(row.status));
      return _react2.default.createElement(
        _TableView.TableViewTr,
        { key: row.studentGeneralInfo.id + '-performance' },
        _react2.default.createElement(_TableView.MemberCardTd, { name: row.studentGeneralInfo.firstName + ' ' + row.studentGeneralInfo.lastName,
          surname: row.studentGeneralInfo.localName,
          avatarUrl: row.studentGeneralInfo.avatarUrl,
          gender: row.studentGeneralInfo.gender }),
        _react2.default.createElement(
          _TableView.NormalTd,
          null,
          _react2.default.createElement(_omniCommonUi.ProductionStatus, { status: row.status,
            highlighted: status.isInProduction })
        ),
        this.skillMap.map(function (skillName, skillId) {
          // todo: use a Map for these
          var scoreDescriptor = row.averageSkillScores.find(function (averageSkillScore) {
            return averageSkillScore.get('skillId') === skillId;
          });
          if (!scoreDescriptor) return _react2.default.createElement(
            _TableView.NormalTd,
            null,
            '-'
          );
          var key = scoreDescriptor.get('skillId') + '-' + row.studentGeneralInfo.id;
          return _react2.default.createElement(_TableView.ProgressCardTd, { key: key, percent: scoreDescriptor.get('score') });
        })
      );
    }
  }, {
    key: '_renderExpansionButton',
    value: function _renderExpansionButton() {
      var _this3 = this;

      var groupPerformance = this.props.groupPerformance;

      if (groupPerformance.studentsPerformance.size <= 4) {
        return null;
      }
      return _react2.default.createElement(_ExpansionButton2.default, { className: _style2.default.PerformanceCard_expansion,
        isExpand: this.state.isExpand,
        onExpansionButtonClick: function onExpansionButtonClick() {
          return _this3.setState({ isExpand: !_this3.state.isExpand });
        } });
    }
  }, {
    key: '_sort',
    value: function _sort(sortKey) {
      var sortType = 'Ascending';
      if (sortKey === this.state.sortKey) {
        sortType = this.state.sortType === 'Ascending' ? 'Descending' : 'Ascending';
      }
      this.setState({ sortKey: sortKey, sortType: sortType });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var groupPerformance = this.props.groupPerformance;
      var startUnitNumber = groupPerformance.startUnitNumber,
          endUnitNumber = groupPerformance.endUnitNumber;

      var tableTitle = startUnitNumber === endUnitNumber ? 'Performance (Unit ' + startUnitNumber + ')' : 'Performance (Units ' + startUnitNumber + '-' + endUnitNumber + ')';
      var viewCount = groupPerformance.studentsPerformance.size >= 4 ? 4 : groupPerformance.studentsPerformance.size;
      var sortedstudentsPerformance = groupPerformance.studentsPerformance.sort(function (currentObject, nextObject) {
        var current = currentObject.get(_this4.state.sortKey);
        var next = nextObject.get(_this4.state.sortKey);
        if (_this4.state.sortKey === 'name') {
          current = (currentObject.studentGeneralInfo.firstName + ' ' + currentObject.studentGeneralInfo.lastName).toLowerCase();
          next = (nextObject.studentGeneralInfo.firstName + ' ' + nextObject.studentGeneralInfo.lastName).toLowerCase();
        } else if (_this4.state.sortKey === 'averageTotalScore') {
          // bleh
        } else {
          var currentScoreDescriptor = currentObject.averageSkillScores.find(function (averageSkillScore) {
            return (// eslint-disable-line
              '' + averageSkillScore.get('skillId') === _this4.state.sortKey
            );
          });
          var nextScoreDescriptor = nextObject.averageSkillScores.find(function (averageSkillScore) {
            return '' + averageSkillScore.get('skillId') === _this4.state.sortKey;
          });
          current = currentScoreDescriptor && currentScoreDescriptor.get('score');
          next = nextScoreDescriptor && nextScoreDescriptor.get('score');
          current = _is_js2.default.number(current) ? current : null;
          next = _is_js2.default.number(next) ? next : null;
        }
        // Make sure none score student sorted bottom.
        if (_this4.state.sortType === 'Ascending') {
          current = current === null ? 101 : current;
          next = next === null ? 101 : next;
        } else if (_this4.state.sortType === 'Descending') {
          current = current === null ? -101 : current;
          next = next === null ? -101 : next;
        }
        // Make sure Swapped student sorted bottom.
        if (currentObject.status === 'Swapped') {
          return 1;
        } else if (nextObject.status === 'Swapped') {
          return -1;
        }
        if (current > next) {
          return _this4.state.sortType === 'Ascending' ? 1 : -1;
        } else if (current < next) {
          return _this4.state.sortType === 'Ascending' ? -1 : 1;
        }
        return 0;
      });
      var skillMap = new _immutable.OrderedMap();
      groupPerformance.studentsPerformance.forEach(function (studentsPerformance) {
        var averageSkillScores = studentsPerformance.averageSkillScores;

        if (!averageSkillScores) return;
        averageSkillScores.forEach(function (averageSkillScore) {
          skillMap = skillMap.set(averageSkillScore.get('skillId'), averageSkillScore.get('name'));
        });
      });
      this.skillMap = skillMap; // bleh
      var source = this.state.isExpand ? sortedstudentsPerformance : sortedstudentsPerformance.slice(0, viewCount);
      return _react2.default.createElement(_TableView.TableView, { tableTitle: tableTitle,
        customerHeader: this._renderTableHeaderRow(skillMap),
        renderTableRow: function renderTableRow(row) {
          return _this4._renderTableRow(row);
        },
        customerFooter: this._renderExpansionButton(),
        noResultsString: 'No Results.',
        query: this.state.filterParams,
        onFilterChange: this._handleOnFilterChange,
        source: source });
    }
  }]);

  return SkillsAveragesTable;
}(_react.Component);

SkillsAveragesTable.propTypes = {
  groupPerformance: _propTypes2.default.object.isRequired
};

exports.default = SkillsAveragesTable;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(285);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _TableView = __webpack_require__(59);

var _ProductionStatus = __webpack_require__(73);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SORT_KEYS = {
  status: 'status',
  class: 'class',
  practice: 'practice',
  unitQuiz: 'unitQuiz',
  reader: 'reader',
  vocabulary: 'vocabulary'
};

var RewardsTable = function (_Component) {
  _inherits(RewardsTable, _Component);

  function RewardsTable(props) {
    _classCallCheck(this, RewardsTable);

    var _this = _possibleConstructorReturn(this, (RewardsTable.__proto__ || Object.getPrototypeOf(RewardsTable)).call(this, props));

    _this.state = {
      isExpand: false,
      sortKey: SORT_KEYS.class,
      sortType: 'Ascending',
      filterParams: {},
      isShowPercent: false
    };
    _this._handleOnFilterChange = _this._handleOnFilterChange.bind(_this);
    _this._onSwitchButtonClicked = _this._onSwitchButtonClicked.bind(_this);
    return _this;
  }

  _createClass(RewardsTable, [{
    key: '_handleOnFilterChange',
    value: function _handleOnFilterChange(filterParams) {
      this.setState({ filterParams: filterParams });
    }
  }, {
    key: '_onSwitchButtonClicked',
    value: function _onSwitchButtonClicked() {
      this.setState({ isShowPercent: !this.state.isShowPercent });
    }
  }, {
    key: '_renderTableRow',
    value: function _renderTableRow(row) {
      var isInProduction = row.isInProduction;

      var status = Object.assign({ isInProduction: isInProduction }, (0, _ProductionStatus.parseProductionStatus)(row.status));
      var isShowPercent = this.state.isShowPercent;

      if (_is_js2.default.existy(row.rewards)) {
        return _react2.default.createElement(
          _TableView.TableViewTr,
          { key: row.studentGeneralInfo.id + '-performance' },
          _react2.default.createElement(_TableView.MemberCardTd, { name: row.studentGeneralInfo.firstName + ' ' + row.studentGeneralInfo.lastName,
            surname: row.studentGeneralInfo.localName,
            avatarUrl: row.studentGeneralInfo.avatarUrl,
            gender: row.studentGeneralInfo.gender }),
          _react2.default.createElement(
            _TableView.NormalTd,
            null,
            _react2.default.createElement(_omniCommonUi.ProductionStatus, { status: row.status, highlighted: status.isInProduction })
          ),
          _react2.default.createElement(_TableView.ProgressBarTd, { className: _style2.default.PerformanceCard_mobileLastColomn,
            percent: Math.round(row.rewards.classesCompletedPercent),
            progressValue: isShowPercent ? null : row.rewards.completedClasses + '/' + row.rewards.totalClasses }),
          _react2.default.createElement(_TableView.ProgressBarTd, { className: _style2.default.PerformanceCard_mobileLastColomn,
            percent: Math.round(row.rewards.homeworksCompletedPercent),
            progressValue: isShowPercent ? null : row.rewards.completedHomeworks + '/' + row.rewards.totalHomeworks }),
          _react2.default.createElement(_TableView.ProgressBarTd, { className: _style2.default.PerformanceCard_mobileLastColomn,
            percent: Math.round(row.rewards.unitQuizCompletedPercent),
            progressValue: isShowPercent ? null : row.rewards.completedUnitQuiz + '/' + row.rewards.totalUnitQuiz }),
          _react2.default.createElement(_TableView.ProgressBarTd, { className: _style2.default.PerformanceCard_mobileLastColomn,
            percent: Math.round(row.rewards.readersCompletedPercent),
            progressValue: isShowPercent ? null : row.rewards.completedReaders + '/' + row.rewards.totalReaders }),
          _react2.default.createElement(_TableView.ProgressBarTd, { className: _style2.default.PerformanceCard_mobileLastColomn,
            percent: Math.round(row.rewards.wordsCompletedPercent),
            progressValue: isShowPercent ? null : row.rewards.completedWords + '/' + row.rewards.totalWords })
        );
      }

      return _react2.default.createElement(
        _TableView.TableViewTr,
        { key: row.studentGeneralInfo.id + '-performance' },
        _react2.default.createElement(_TableView.MemberCardTd, { name: row.studentGeneralInfo.firstName + ' ' + row.studentGeneralInfo.lastName,
          surname: row.studentGeneralInfo.localName,
          avatarUrl: row.studentGeneralInfo.avatarUrl,
          gender: row.studentGeneralInfo.gender }),
        _react2.default.createElement(
          _TableView.NormalTd,
          null,
          _react2.default.createElement(_omniCommonUi.ProductionStatus, { status: row.status, highlighted: status.isInProduction })
        ),
        _react2.default.createElement(
          _TableView.NormalTd,
          { className: _style2.default.PerformanceCard_mobileLastColomn },
          '-'
        ),
        _react2.default.createElement(
          _TableView.NormalTd,
          { className: _style2.default.PerformanceCard_mobileLastColomn },
          '-'
        ),
        _react2.default.createElement(
          _TableView.NormalTd,
          { className: _style2.default.PerformanceCard_mobileLastColomn },
          '-'
        ),
        _react2.default.createElement(
          _TableView.NormalTd,
          { className: _style2.default.PerformanceCard_mobileLastColomn },
          '-'
        ),
        _react2.default.createElement(
          _TableView.NormalTd,
          { className: _style2.default.PerformanceCard_mobileLastColomn },
          '-'
        )
      );
    }
  }, {
    key: '_renderExpansionButton',
    value: function _renderExpansionButton() {
      var _this2 = this;

      var groupPerformance = this.props.groupPerformance;

      if (groupPerformance.studentsPerformance.size <= 4) {
        return null;
      }
      return _react2.default.createElement(_ExpansionButton2.default, { isExpand: this.state.isExpand,
        className: _style2.default.PerformanceCard_expansion,
        onExpansionButtonClick: function onExpansionButtonClick() {
          return _this2.setState({ isExpand: !_this2.state.isExpand });
        } });
    }
  }, {
    key: '_renderTableHeaderRow',
    value: function _renderTableHeaderRow() {
      var _this3 = this;

      // overridden/used in PerformanceCard!
      var _state = this.state,
          sortKey = _state.sortKey,
          sortType = _state.sortType;

      var headers = new _immutable.List([{ key: 'name', text: 'Name', sortable: true }, { key: SORT_KEYS.status, text: 'Status', sortable: false }, { key: SORT_KEYS.class, text: 'Class', sortable: true }, { key: SORT_KEYS.practice, text: 'Practice', sortable: true }, { key: SORT_KEYS.unitQuiz, text: 'Unit Quiz', sortable: true }, { key: SORT_KEYS.reader, text: 'Reader', sortable: true }, { key: SORT_KEYS.vocabulary, text: 'Vocabulary', sortable: true }]);

      return _react2.default.createElement(
        _TableView.TableViewTr,
        { key: 'PerformanceCard-hrow2' },
        headers.map(function (header) {
          return _react2.default.createElement(
            _TableView.HeaderTd,
            { sortable: header.sortable,
              sortType: sortKey === header.key ? sortType : '',
              onSort: function onSort() {
                return _this3._sort(header.key);
              },
              key: header.key },
            header.text
          );
        })
      );
    }
  }, {
    key: '_sort',
    value: function _sort(sortKey) {
      var sortType = 'Ascending';
      if (sortKey === this.state.sortKey) {
        sortType = this.state.sortType === 'Ascending' ? 'Descending' : 'Ascending';
      }
      this.setState({ sortKey: sortKey, sortType: sortType });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var groupPerformance = this.props.groupPerformance;
      var startUnitNumber = groupPerformance.startUnitNumber,
          endUnitNumber = groupPerformance.endUnitNumber;

      var tableTitle = startUnitNumber === endUnitNumber ? 'Performance (Unit ' + startUnitNumber + ')' : 'Performance (Units ' + startUnitNumber + '-' + endUnitNumber + ')';
      var viewCount = groupPerformance.studentsPerformance.size >= 4 ? 4 : groupPerformance.studentsPerformance.size;
      var sortedstudentsPerformance = groupPerformance.studentsPerformance.sort(function (currentObject, nextObject) {
        var current = currentObject.get(_this4.state.sortKey);
        var next = nextObject.get(_this4.state.sortKey);
        if (_this4.state.sortKey === 'name') {
          current = (currentObject.studentGeneralInfo.firstName + ' ' + currentObject.studentGeneralInfo.lastName).toLowerCase();
          next = (nextObject.studentGeneralInfo.firstName + ' ' + nextObject.studentGeneralInfo.lastName).toLowerCase();
        } else {
          switch (_this4.state.sortKey) {
            case SORT_KEYS.class:
              current = currentObject.rewards && currentObject.rewards.classesCompletedPercent;
              next = nextObject.rewards && nextObject.rewards.classesCompletedPercent;
              break;
            case SORT_KEYS.practice:
              current = currentObject.rewards && currentObject.rewards.homeworksCompletedPercent;
              next = nextObject.rewards && nextObject.rewards.homeworksCompletedPercent;
              break;
            case SORT_KEYS.unitQuiz:
              current = currentObject.rewards && currentObject.rewards.unitQuizCompletedPercent;
              next = nextObject.rewards && nextObject.rewards.unitQuizCompletedPercent;
              break;
            case SORT_KEYS.reader:
              current = currentObject.rewards && currentObject.rewards.readersCompletedPercent;
              next = nextObject.rewards && nextObject.rewards.readersCompletedPercent;
              break;
            case SORT_KEYS.vocabulary:
              current = currentObject.rewards && currentObject.rewards.wordsCompletedPercent;
              next = nextObject.rewards && nextObject.rewards.wordsCompletedPercent;
              break;
            default:
              break;
          }
        }

        // Make sure none score student sorted bottom.
        if (_this4.state.sortType === 'Ascending') {
          current = current === null ? 101 : current;
          next = next === null ? 101 : next;
        } else if (_this4.state.sortType === 'Descending') {
          current = current === null ? -101 : current;
          next = next === null ? -101 : next;
        }
        // Make sure Swapped student sorted bottom.
        if (currentObject.status === 'Swapped') {
          return 1;
        } else if (nextObject.status === 'Swapped') {
          return -1;
        }
        if (current > next) {
          return _this4.state.sortType === 'Ascending' ? 1 : -1;
        } else if (current < next) {
          return _this4.state.sortType === 'Ascending' ? -1 : 1;
        }
        return 0;
      });
      var source = this.state.isExpand ? sortedstudentsPerformance : sortedstudentsPerformance.slice(0, viewCount);
      return _react2.default.createElement(_TableView.TableView, { source: source,
        tableTitle: tableTitle,
        renderTableRow: function renderTableRow(row) {
          return _this4._renderTableRow(row);
        },
        noResultsString: 'No Results.',
        query: this.state.filterParams,
        onFilterChange: this._handleOnFilterChange,
        customerFooter: this._renderExpansionButton(),
        customerHeader: this._renderTableHeaderRow() });
    }
  }]);

  return RewardsTable;
}(_react.Component);

RewardsTable.propTypes = {
  groupPerformance: _propTypes2.default.object.isRequired
};

exports.default = RewardsTable;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1308);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _redux = __webpack_require__(10);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _TableView = __webpack_require__(59);

var _GroupMembers = __webpack_require__(14);

var _RAv2HomeworkResultSummary = __webpack_require__(613);

var _ProductionStatus = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INITIAL_VIEW_COUNT = 2;

function getStudentSummary(homeworkSummary, studentId) {
  if (!homeworkSummary || !_immutable.Map.isMap(homeworkSummary)) {
    return {};
  }
  return homeworkSummary.get('' + studentId) || {};
}

var COLUMNS = [{
  key: 'name',
  text: 'Name',
  sortable: true,
  renderCell: function renderCell(member) {
    return _react2.default.createElement(_TableView.MemberCardTd, {
      key: 'name',
      name: member.studentGeneralInfo.firstName + ' ' + member.studentGeneralInfo.lastName,
      surname: member.studentGeneralInfo.localName,
      avatarUrl: member.studentGeneralInfo.avatarUrl,
      gender: member.studentGeneralInfo.gender });
  }
}, {
  key: 'status',
  text: 'Status',
  sortable: false,
  renderCell: function renderCell(member) {
    var isInProduction = member.isInProduction;

    var status = Object.assign({ isInProduction: isInProduction }, (0, _ProductionStatus.parseProductionStatus)(member.status));
    return _react2.default.createElement(
      _TableView.NormalTd,
      { key: 'status' },
      _react2.default.createElement(_omniCommonUi.ProductionStatus, { status: status.fullName, highlighted: status.isInProduction })
    );
  }
}, {
  key: 'avgCompletion',
  text: 'Avg. Completion',
  sortable: true,
  renderCell: function renderCell(member, homeworkSummary) {
    var summary = getStudentSummary(homeworkSummary, member.studentGeneralInfo.id);
    return _react2.default.createElement(
      _TableView.NormalTd,
      { key: 'avgCompletion' },
      (summary.avgCompletion || 0) + '%'
    );
  }
}, {
  key: 'avgAccuracy',
  text: 'Avg. Accuracy',
  sortable: true,
  renderCell: function renderCell(member, homeworkSummary) {
    var summary = getStudentSummary(homeworkSummary, member.studentGeneralInfo.id);
    return _react2.default.createElement(
      _TableView.NormalTd,
      { key: 'avgAccuracy' },
      (summary.avgAccuracy || 0) + '%'
    );
  }
}, {
  key: 'totalRecorded',
  text: 'Total Recorded',
  sortable: true,
  renderCell: function renderCell(member, homeworkSummary) {
    var summary = getStudentSummary(homeworkSummary, member.studentGeneralInfo.id);
    return _react2.default.createElement(
      _TableView.NormalTd,
      { key: 'totalRecorded' },
      summary.totalRecorded || 0
    );
  }
}, {
  key: 'totalStoryRead',
  text: 'Total Story Read',
  sortable: true,
  renderCell: function renderCell(member, homeworkSummary) {
    var summary = getStudentSummary(homeworkSummary, member.studentGeneralInfo.id);
    return _react2.default.createElement(
      _TableView.NormalTd,
      { key: 'totalStoryRead' },
      summary.totalStoryRead || 0
    );
  }
}];

var PerformanceCardRAv2 = function (_Component) {
  _inherits(PerformanceCardRAv2, _Component);

  function PerformanceCardRAv2(props) {
    _classCallCheck(this, PerformanceCardRAv2);

    var _this = _possibleConstructorReturn(this, (PerformanceCardRAv2.__proto__ || Object.getPrototypeOf(PerformanceCardRAv2)).call(this, props));

    _this.state = {
      isExpand: false,
      sortKey: 'name',
      sortType: 'Ascending'
    };
    return _this;
  }

  _createClass(PerformanceCardRAv2, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var groupId = this.props.groupId;

      if (groupId) {
        this.props.fetchRAv2HomeworkResultSummaryIfNeeded(groupId);
      }
    }
  }, {
    key: '_sort',
    value: function _sort(sortKey) {
      var sortType = 'Ascending';
      if (sortKey === this.state.sortKey) {
        sortType = this.state.sortType === 'Ascending' ? 'Descending' : 'Ascending';
      }
      this.setState({ sortKey: sortKey, sortType: sortType });
    }
  }, {
    key: '_getSortedMembers',
    value: function _getSortedMembers() {
      var _this2 = this;

      var members = this.props.members;

      if (!members || members.size === 0) return new _immutable.List();

      return members.sort(function (a, b) {
        var _state = _this2.state,
            sortKey = _state.sortKey,
            sortType = _state.sortType;

        var current = void 0;
        var next = void 0;

        switch (sortKey) {
          case 'name':
            current = (a.studentGeneralInfo.firstName + ' ' + a.studentGeneralInfo.lastName).toLowerCase();
            next = (b.studentGeneralInfo.firstName + ' ' + b.studentGeneralInfo.lastName).toLowerCase();
            break;
          default:
            {
              var homeworkSummary = _this2.props.homeworkSummary;

              var summaryA = getStudentSummary(homeworkSummary, a.studentGeneralInfo.id);
              var summaryB = getStudentSummary(homeworkSummary, b.studentGeneralInfo.id);
              current = summaryA[sortKey] || 0;
              next = summaryB[sortKey] || 0;
              break;
            }
        }

        if (current > next) return sortType === 'Ascending' ? 1 : -1;
        if (current < next) return sortType === 'Ascending' ? -1 : 1;
        return 0;
      });
    }
  }, {
    key: '_renderTableHeaderRow',
    value: function _renderTableHeaderRow() {
      var _this3 = this;

      var _state2 = this.state,
          sortKey = _state2.sortKey,
          sortType = _state2.sortType;

      return _react2.default.createElement(
        _TableView.TableViewTr,
        { key: 'PerformanceCardRAv2-header' },
        COLUMNS.map(function (col) {
          return _react2.default.createElement(
            _TableView.HeaderTd,
            {
              sortable: col.sortable,
              sortType: sortKey === col.key ? sortType : '',
              onSort: function onSort() {
                return _this3._sort(col.key);
              },
              key: col.key },
            col.text
          );
        })
      );
    }
  }, {
    key: '_renderTableRow',
    value: function _renderTableRow(member) {
      var homeworkSummary = this.props.homeworkSummary;

      return _react2.default.createElement(
        _TableView.TableViewTr,
        { key: member.studentGeneralInfo.id + '-rav2' },
        COLUMNS.map(function (col) {
          return col.renderCell(member, homeworkSummary);
        })
      );
    }
  }, {
    key: '_renderExpansionButton',
    value: function _renderExpansionButton(totalSize) {
      var _this4 = this;

      if (totalSize <= INITIAL_VIEW_COUNT) return null;
      return _react2.default.createElement(_ExpansionButton2.default, {
        isExpand: this.state.isExpand,
        onExpansionButtonClick: function onExpansionButtonClick() {
          return _this4.setState({ isExpand: !_this4.state.isExpand });
        } });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var sorted = this._getSortedMembers();
      var source = this.state.isExpand ? sorted : sorted.slice(0, INITIAL_VIEW_COUNT);

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _omniCommonUi.testClass)('performance-card-rav2') },
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          {
            text: 'Performance',
            className: _style2.default.PerformanceCardRAv2_heading },
          _react2.default.createElement(
            'div',
            { className: _style2.default.PerformanceCardRAv2_infoIcon },
            _react2.default.createElement(
              'svg',
              { width: '18', height: '18', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
              _react2.default.createElement('path', { d: 'M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z', fill: 'black' })
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default.PerformanceCardRAv2_tooltip },
              _react2.default.createElement(
                'h3',
                { className: _style2.default.PerformanceCardRAv2_tooltip_title },
                'Performance Legends'
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.PerformanceCardRAv2_tooltip_item },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Completion'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Completion rate records include completing Step2 activities'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.PerformanceCardRAv2_tooltip_item },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Accuracy'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Accuracy rate is calculated based on the ratio of correct answers to total answers in the step 2 activities'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.PerformanceCardRAv2_tooltip_item },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Story Read'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Reading completion is marked as achieved when the student listen to and read the entire story once'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.PerformanceCardRAv2_tooltip_item },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Recorded'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Recordings are displayed based on how many times a student records the story, with each attempt contributing to the total count'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.PerformanceCardRAv2_content },
          _react2.default.createElement(_TableView.TableView, {
            source: source.toArray(),
            renderTableRow: function renderTableRow(row) {
              return _this5._renderTableRow(row);
            },
            noResultsString: 'No Results.',
            query: {},
            customerHeader: this._renderTableHeaderRow(),
            customerFooter: this._renderExpansionButton(sorted.size) })
        )
      );
    }
  }]);

  return PerformanceCardRAv2;
}(_react.Component);

PerformanceCardRAv2.propTypes = {
  members: _propTypes2.default.object,
  homeworkSummary: _propTypes2.default.object,
  groupId: _propTypes2.default.string,
  fetchRAv2HomeworkResultSummaryIfNeeded: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var homeworkSummary = _RAv2HomeworkResultSummary.accessors.getRAv2HomeworkResultSummaryByGroup(state, groupId);
  return { members: members, homeworkSummary: homeworkSummary, groupId: groupId };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    fetchRAv2HomeworkResultSummaryIfNeeded: _RAv2HomeworkResultSummary.actions.fetchRAv2HomeworkResultSummaryIfNeeded
  }, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(PerformanceCardRAv2);

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1309);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1U5EIV8ZgcG5XVhcZ7KpfL{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._1U5EIV8ZgcG5XVhcZ7KpfL h1{-webkit-box-flex:0;-webkit-flex:0 0 auto;-moz-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;margin-right:.28571rem}._1_DdO5oYkZxAyHFfWprYC4{padding:0}._2qwpXtL9NeaUh4z0X6q0Ct{position:relative;cursor:pointer;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}._2qwpXtL9NeaUh4z0X6q0Ct:hover ._1PFcvJADeWSDAAvgR8z0tI{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._1PFcvJADeWSDAAvgR8z0tI{display:none;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:start;-webkit-align-items:flex-start;-moz-box-align:start;-ms-flex-align:start;align-items:flex-start;padding:1.14286rem;gap:1.71429rem;position:absolute;width:39.28571rem;top:-webkit-calc(100% + .57143rem);top:-moz-calc(100% + .57143rem);top:calc(100% + .57143rem);left:0;background:#fff;-webkit-box-shadow:0 .07143rem .14286rem rgba(0,0,0,.08),0 .14286rem .57143rem .07143rem rgba(0,0,0,.16);-moz-box-shadow:0 .07143rem .14286rem rgba(0,0,0,.08),0 .14286rem .57143rem .07143rem rgba(0,0,0,.16);box-shadow:0 .07143rem .14286rem rgba(0,0,0,.08),0 .14286rem .57143rem .07143rem rgba(0,0,0,.16);-webkit-border-radius:.28571rem;-moz-border-radius:.28571rem;border-radius:.28571rem;z-index:10}._3I3CoGBXAcRnv_rW8twFK1{font-size:1.14286rem;font-weight:700;margin:0;color:#333}._32RpkxHH0RT0G-_74kIR-e strong{display:block;font-size:1rem;font-weight:700;color:#333;margin-bottom:.28571rem}._32RpkxHH0RT0G-_74kIR-e p{font-size:1rem;font-weight:400;color:#333;margin:0;line-height:1.5}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"PerformanceCardRAv2_heading": "_1U5EIV8ZgcG5XVhcZ7KpfL",
	"PerformanceCardRAv2_content": "_1_DdO5oYkZxAyHFfWprYC4",
	"PerformanceCardRAv2_infoIcon": "_2qwpXtL9NeaUh4z0X6q0Ct",
	"PerformanceCardRAv2_tooltip": "_1PFcvJADeWSDAAvgR8z0tI",
	"PerformanceCardRAv2_tooltip_title": "_3I3CoGBXAcRnv_rW8twFK1",
	"PerformanceCardRAv2_tooltip_item": "_32RpkxHH0RT0G-_74kIR-e"
};

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRAv2HomeworkResultSummaryByGroup = getRAv2HomeworkResultSummaryByGroup;
exports.getRAv2HomeworkResultSummaryByStudent = getRAv2HomeworkResultSummaryByStudent;
exports.getStudentAvgCompletion = getStudentAvgCompletion;
exports.getStudentAvgAccuracy = getStudentAvgAccuracy;
exports.getStudentTotalRecorded = getStudentTotalRecorded;
exports.getStudentTotalStoryRead = getStudentTotalStoryRead;
exports.isLoadingRAv2HomeworkResultSummary = isLoadingRAv2HomeworkResultSummary;

var _immutable = __webpack_require__(3);

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var _model = __webpack_require__(286);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var method = 'GET';
var buildRAv2HomeworkResultSummaryUrl = function buildRAv2HomeworkResultSummaryUrl(groupId) {
  return (0, _Api.buildUrl)('/ra-v2-groups/' + groupId + '/homework-result-summary');
};

function getRAv2HomeworkResultSummaryByGroup(state, groupId) {
  var summariesByGroup = state.get('rootReducer').get('rav2HomeworkResultSummary');

  if (!summariesByGroup || !_immutable.Map.isMap(summariesByGroup)) {
    return new _immutable.Map({});
  }

  return summariesByGroup.get(groupId) || new _immutable.Map({});
}

function getRAv2HomeworkResultSummaryByStudent(state, groupId, studentId) {
  if (!studentId) {
    return _model2.default.create();
  }

  var groupSummary = getRAv2HomeworkResultSummaryByGroup(state, groupId);
  return groupSummary.get('' + studentId) || _model2.default.create({ studentId: studentId });
}

function getStudentAvgCompletion(state, groupId, studentId) {
  return getRAv2HomeworkResultSummaryByStudent(state, groupId, studentId).avgCompletion || 0;
}

function getStudentAvgAccuracy(state, groupId, studentId) {
  return getRAv2HomeworkResultSummaryByStudent(state, groupId, studentId).avgAccuracy || 0;
}

function getStudentTotalRecorded(state, groupId, studentId) {
  return getRAv2HomeworkResultSummaryByStudent(state, groupId, studentId).totalRecorded || 0;
}

function getStudentTotalStoryRead(state, groupId, studentId) {
  return getRAv2HomeworkResultSummaryByStudent(state, groupId, studentId).totalStoryRead || 0;
}

function isLoadingRAv2HomeworkResultSummary(state, groupId) {
  var callState = _omniCommonUi.ApiCall.find(state, {
    method: method,
    url: buildRAv2HomeworkResultSummaryUrl(groupId)
  });

  return _omniCommonUi.ApiCall.State.isValue(callState) && _omniCommonUi.ApiCall.State.isLoading(callState);
}

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rav2HomeworkResultSummary;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(614);

var _model = __webpack_require__(286);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function rav2HomeworkResultSummary() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_SUCCESS:
      return state.set(action.groupId, toGroupSummaryMap(action.payload));
    default:
      return state;
  }
}

function toGroupSummaryMap(payload) {
  var list = normalizePayload(payload);
  var summaryByStudentId = new _immutable.Map({});

  list.forEach(function (item) {
    if (!item) {
      return;
    }

    var normalized = normalizeApiItem(item);
    if (!normalized || !normalized.studentId) {
      return;
    }

    summaryByStudentId = summaryByStudentId.set('' + normalized.studentId, _model2.default.create(normalized));
  });

  return summaryByStudentId;
}

function normalizeApiItem(item) {
  var studentId = item.studentGeneralInfo && item.studentGeneralInfo.id || item.studentId;
  if (!studentId) {
    return null;
  }

  return {
    studentId: studentId,
    avgCompletion: Math.round((item.averageCompletion || 0) * 100),
    avgAccuracy: Math.round((item.averageAccuracy || 0) * 100),
    totalRecorded: item.totalRecorded || 0,
    totalStoryRead: item.totalStoryRead || 0
  };
}

function normalizePayload(payload) {
  if (!payload) {
    return [];
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload.data)) {
    return payload.data;
  }

  if (Array.isArray(payload.items)) {
    return payload.items;
  }

  return [];
}

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _routes2 = __webpack_require__(615);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default; /* eslint import/prefer-default-export: "off" */

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _routes2 = __webpack_require__(1314);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default; /* eslint import/prefer-default-export: "off" */

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(1315);

var _component2 = _interopRequireDefault(_component);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: 'history',
    component: _component2.default,
    breadcrumbLabels: {
      label: 'History',
      clickable: false
    },
    canAccess: function canAccess() {
      var state = getState();
      if (_omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.MarkAttendance.ViewDayView) || _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.MarkAttendance.ViewCourseView)) {
        return true;
      }
      return false;
    }
  };
};

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttendanceHistory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _redux = __webpack_require__(10);

var _AttendanceHistory = __webpack_require__(616);

var _ = __webpack_require__(13);

var _TableView = __webpack_require__(59);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _style = __webpack_require__(1319);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TABLE_FILTER_DEFAULT = {
  pageSize: 10,
  pageNumber: 1
};

var AttendanceHistory = exports.AttendanceHistory = function (_Component) {
  _inherits(AttendanceHistory, _Component);

  function AttendanceHistory(props) {
    _classCallCheck(this, AttendanceHistory);

    var _this = _possibleConstructorReturn(this, (AttendanceHistory.__proto__ || Object.getPrototypeOf(AttendanceHistory)).call(this, props));

    _this.state = { tableFilter: {} };
    _this._onTableFilterChange = _this._onTableFilterChange.bind(_this);
    return _this;
  }

  _createClass(AttendanceHistory, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props$location$query = this.props.location.query,
          pageSize = _props$location$query.pageSize,
          pageNumber = _props$location$query.pageNumber;

      var hasQuery = !(_is_js2.default.undefined(pageSize) || _is_js2.default.undefined(pageNumber));
      var tableFilter = hasQuery ? this.props.location.query : this.state.tableFilter;
      this._onTableFilterChange(tableFilter);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.tableFilter === this.state.tableFilter) {
        return;
      }

      this._fetchHistory(nextProps, nextState.tableFilter);
    }
  }, {
    key: '_fetchHistory',
    value: function _fetchHistory(props, tableFilter) {
      this.props.fetchAttendanceHistory(_extends({}, tableFilter, { groupId: props.groupId }));
      this.props.router.replace(Object.assign({}, this.props.location, { query: tableFilter }));
    }
  }, {
    key: '_onTableFilterChange',
    value: function _onTableFilterChange(tableFilter) {
      if (!(tableFilter.pageNumber && tableFilter.pageSize)) {
        this.setState({ tableFilter: TABLE_FILTER_DEFAULT });
      } else {
        this.setState({ tableFilter: tableFilter });
      }
    }
  }, {
    key: '_renderTableRow',
    value: function _renderTableRow(row) {
      return _react2.default.createElement(
        _TableView.TableViewTr,
        null,
        _react2.default.createElement(_TableView.TextTd, { text: row.action }),
        _react2.default.createElement(_TableView.TextTd, { text: row.studentName }),
        _react2.default.createElement(
          _TableView.NormalTd,
          null,
          row.sessionDuration
        ),
        _react2.default.createElement(_TableView.TextTd, { text: row.previousStatus }),
        _react2.default.createElement(_TableView.TextTd, { text: row.currentStatus }),
        _react2.default.createElement(_TableView.TextTd, { text: row.editedByName }),
        _react2.default.createElement(
          _TableView.NormalTd,
          null,
          row.actionTime
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var attendanceHistory = this.props.attendanceHistory;

      if (!attendanceHistory) {
        return null;
      }

      var dateTimeHeader = _react2.default.createElement(
        'div',
        { className: _style2.default.AttendanceHistory_table_dateTimeHeader },
        _react2.default.createElement(
          'span',
          null,
          'Date & Time'
        ),
        _react2.default.createElement(_omniCommonUi.Icon, { id: 'sorting' })
      );
      var headers = [{ key: 'action', text: 'Action', sortable: false }, { key: 'studentName', text: 'Student', sortable: false }, { key: 'sessionDuration', text: 'Session', sortable: false }, { key: 'previousStatus', text: 'Before', sortable: false }, { key: 'currentStatus', text: 'After', sortable: false }, { key: 'editedByName', text: 'Edit By', sortable: false }, { key: 'actionTime', text: dateTimeHeader, sortable: false }];

      return _react2.default.createElement(
        'div',
        { className: _style2.default.AttendanceHistory },
        _react2.default.createElement(_TableView.TableView, { source: attendanceHistory.studentAttendanceHistories,
          headers: headers,
          pageable: true,
          tableTitle: 'Change Logs',
          renderTableRow: function renderTableRow(row) {
            return _this2._renderTableRow(row);
          },
          noResultsString: 'No results yet.',
          query: this.state.tableFilter,
          totalRecords: attendanceHistory.totalRecords,
          onFilterChange: this._onTableFilterChange })
      );
    }
  }]);

  return AttendanceHistory;
}(_react.Component);

AttendanceHistory.propTypes = {
  attendanceHistory: _propTypes2.default.object,
  fetchAttendanceHistory: _propTypes2.default.func,
  groupId: _propTypes2.default.number,
  location: _propTypes2.default.object,
  replace: _propTypes2.default.func,
  router: _propTypes2.default.object,
  timeZone: _propTypes2.default.string
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;
  var attendanceHistory = getHistory(state, ownProps);
  return { attendanceHistory: attendanceHistory, groupId: groupId };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, (0, _redux.bindActionCreators)(_AttendanceHistory.actions, dispatch));
}

function getHistory(state, ownProps) {
  var _groupActions$getCent = _.actions.getCentre(state, ownProps.params.groupId),
      timeZone = _groupActions$getCent.timeZone;

  var attendanceHistory = state.get('rootReducer').get('attendanceHistory');
  if (!timeZone || !_omniCommonUi.ApiResponseHelper.hasSucceeded(attendanceHistory)) {
    return undefined;
  }

  attendanceHistory = attendanceHistory.data;
  return attendanceHistory.update('studentAttendanceHistories', function (attendanceHistories) {
    return _AttendanceHistory.accessors.updateDateByTimeZone(attendanceHistories, timeZone);
  });
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(AttendanceHistory);

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = attendanceHistory;

var _actions = __webpack_require__(617);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _model = __webpack_require__(618);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function attendanceHistory() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_ATTENDANCE_HISTORY_SUCCESS:
      return _omniCommonUi.ApiResponseHelper.create(_model2.default.create(action.payload));
    case _actions.FETCH_ATTENDANCE_HISTORY_FAILURE:
      return _omniCommonUi.ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(619);

var _omniCommonUi = __webpack_require__(0);

var _Interval = __webpack_require__(81);

var getStatusDisplayName = function getStatusDisplayName(statusName) {
  if (!statusName) return '-';
  switch (statusName) {
    case 'UnMarked':
      return 'Not Marked';
    case 'NotApplicable':
      return 'Not Applicable';
    default:
      return statusName;
  }
};

var getActionDisplayName = function getActionDisplayName(actionName) {
  if (!actionName) return '-';
  switch (actionName) {
    case 'U':
    case 'D':
      return 'Edit';
    case 'I':
      return 'New';
    default:
      return actionName;
  }
};

var reviverHistoryItems = function reviverHistoryItems(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      item = _ref2[1];

  if (!item) return [key, item];
  switch (key) {
    case 'action':
      return [key, getActionDisplayName(item)];
    case 'previousStatus':
    case 'currentStatus':
      return [key, getStatusDisplayName(item)];
    case 'actionTime':
      return [key, _omniCommonUi.moment.utc(item)];
    case 'sessionDuration':
      return [key, _Interval.Interval.create({
        start: item.startDate,
        end: item.endDate
      })];
    default:
      return [key, item];
  }
};

var createHistoryItems = function createHistoryItems(data) {
  var attendanceHistoryItems = [];
  if (data) {
    data.forEach(function (historyObject) {
      var newHistoryObject = JSON.parse(JSON.stringify(historyObject));
      newHistoryObject.studentName = newHistoryObject.studentFirstName + ' ' + newHistoryObject.studentLastName;
      newHistoryObject.editedByName = newHistoryObject.editedByFirstName + ' ' + newHistoryObject.editedByLastName;
      attendanceHistoryItems.push(new _model.AttendanceHistoryItems(newHistoryObject).mapEntries(reviverHistoryItems));
    });
  }

  return attendanceHistoryItems;
};

var reviver = function reviver(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      item = _ref4[1];

  if (!item) return [key, item];
  switch (key) {
    case 'studentAttendanceHistories':
      return [key, createHistoryItems(item)];
    default:
      return [key, item];
  }
};

var create = function create(data) {
  return new _model.AttendanceHistoryTable(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDateByTimeZone = updateDateByTimeZone;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateDateByTimeZone(attendanceHistories, timeZone) {
  return attendanceHistories.map(function (historyItem) {
    var actionDate = formatDate(historyItem.actionTime, 'YYYY-MM-DD');
    var actionTime = formatDate(historyItem.actionTime, 'HH:mm:ss');
    var updatedActionTime = _react2.default.createElement(
      'span',
      null,
      actionDate,
      _react2.default.createElement('br', null),
      actionTime
    );
    var sessionDay = formatDate(historyItem.sessionDuration.start, 'YYYY-MM-DD');
    var sessionStartTime = formatDate(historyItem.sessionDuration.start, 'HH:mm');
    var sessionEndTime = formatDate(historyItem.sessionDuration.end, 'HH:mm');
    var updatedSessionDurationTime = _react2.default.createElement(
      'span',
      null,
      sessionDay,
      _react2.default.createElement('br', null),
      sessionStartTime + ' - ' + sessionEndTime
    );
    return historyItem.set('actionTime', updatedActionTime).set('sessionDuration', updatedSessionDurationTime);
  });

  function formatDate(momentDate, customFormat) {
    return momentDate.clone().tz(timeZone).format(customFormat);
  }
}

exports.default = updateDateByTimeZone;

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1320);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3Uyj6--kdBeT_tB3LV786g{padding:1.42857rem}@media only screen and (min-width:640px){._3Uyj6--kdBeT_tB3LV786g{padding:1.42857rem 2.14286rem}}.LTe65KZPaZPwtNMSSF_OE{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;width:-webkit-calc(100% + 1.78571rem);width:-moz-calc(100% + 1.78571rem);width:calc(100% + 1.78571rem)}.LTe65KZPaZPwtNMSSF_OE span{max-width:-webkit-calc(100% - 1.78571rem);max-width:-moz-calc(100% - 1.78571rem);max-width:calc(100% - 1.78571rem)}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"AttendanceHistory": "_3Uyj6--kdBeT_tB3LV786g",
	"AttendanceHistory_table_dateTimeHeader": "LTe65KZPaZPwtNMSSF_OE"
};

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _routes2 = __webpack_require__(1322);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default; /* eslint import/prefer-default-export: "off" */

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _MarkAttendanceDayView = __webpack_require__(1323);

var _MarkAttendanceCourseView = __webpack_require__(1389);

var _component = __webpack_require__(1407);

var _component2 = _interopRequireDefault(_component);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    appBars: {
      sticky: {
        'view-nav': {
          component: _ViewNav2.default,
          order: 2
        }
      }
    },
    path: 'session/:sessionPlanId(/unit/:unitId)',
    component: _component2.default,
    showSessionCourseSwitch: function showSessionCourseSwitch() {
      var state = getState();
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.MarkAttendance.ViewDayView) && _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.MarkAttendance.ViewCourseView);
    },
    canAccess: function canAccess(_ref2) {
      var replace = _ref2.replace,
          buildRoute = _ref2.buildRoute,
          routes = _ref2.routes;

      var state = getState();
      if (routes[routes.length - 1].path === 'attendance/:sessionPlanId') {
        if (_omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.MarkAttendance.ViewDayView)) {
          replace(buildRoute('day'));
          return true;
        }

        if (_omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.MarkAttendance.ViewCourseView)) {
          replace(buildRoute('course'));
          return true;
        }
      }

      return true;
    },
    indexRoute: {
      onEnter: function onEnter(_ref3, replace) {
        var routes = _ref3.routes,
            location = _ref3.location;

        var viewMode = getState().get('rootReducer').get('uiState').get('viewMode');
        var isInCourseView = viewMode === 'course' || !_omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.MarkAttendance.ViewDayView);
        var courseViewMode = isInCourseView && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.MarkAttendance.ViewCourseView);
        replace(withoutTrailingSlash(location.pathname) + '/' + (courseViewMode ? 'course' : 'day'));
      }
    },
    breadcrumbLabels: function breadcrumbLabels(props) {
      var currentSessionNumber = getCurrentSessionNumber(getState(), props);
      var segments = [];
      if (_is_js2.default.number(currentSessionNumber)) {
        segments.push('Session ' + currentSessionNumber);
      }
      if (props.params.mode === 'edit') {
        segments.push('Edit');
      }
      return segments;
    },
    childRoutes: [_MarkAttendanceDayView.routes, _MarkAttendanceCourseView.routes]
  };
};

function getCurrentSessionNumber(state, _ref4) {
  var _ref4$params = _ref4.params,
      groupId = _ref4$params.groupId,
      sessionPlanId = _ref4$params.sessionPlanId;

  var group = state.get('rootReducer').get('groups').get(groupId);
  group = group && group.data;
  return group && group.sessionPlans.data && group.sessionPlans.data.indexOf(sessionPlanId) + 1;
}

function withoutTrailingSlash(path) {
  var out = path;
  if (path.substr(path.length - 1) === '/') {
    out = path.substr(0, path.length - 1);
  }
  return out;
}

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(620);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1386);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sessionsAttendance;

var _actions = __webpack_require__(621);

var _omniCommonUi = __webpack_require__(0);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _status = __webpack_require__(83);

var _model = __webpack_require__(287);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setAttendanceStatusesInSession = function setAttendanceStatusesInSession(session) {
  if (_is_js2.default.not.array(session)) {
    return session;
  }

  return new _immutable.List(session.map(function (student) {
    var parsedSession = Object.assign({}, student, {
      attendanceStatus: (0, _status.convertBackendAttendanceStatusToAttendanceStatus)(student.attendanceStatus)
    });
    return _model2.default.create(parsedSession);
  }));
};

var groupAttendanceSuccessState = function groupAttendanceSuccessState(attendances, state) {
  var result = state;
  Object.keys(attendances).forEach(function (key) {
    var data = _omniCommonUi.ApiResponseHelper.create(setAttendanceStatusesInSession(attendances[key]));
    result = result.set('' + key, data);
  });
  return result;
};

function sessionsAttendance() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_SESSION_ATTENDANCE_REQUEST:
      return state.set('' + action.id, _omniCommonUi.ApiResponseHelper.create({ loading: true }));
    case _actions.FETCH_SESSION_ATTENDANCE_SUCCESS:
      {
        var data = _omniCommonUi.ApiResponseHelper.create(setAttendanceStatusesInSession(action.payload));
        return state.set('' + action.id, data);
      }
    case _actions.FETCH_GROUP_ATTENDANCE_SUCCESS:
      {
        return groupAttendanceSuccessState(action.payload, state);
      }
    case _actions.FETCH_SESSION_ATTENDANCE_FAILURE:
      return state.set('' + action.id, _omniCommonUi.ApiResponseHelper.create(action.error));
    default:
      return state;
  }
}

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _StudentGeneralInfo = __webpack_require__(107);

var _StudentGeneralInfo2 = _interopRequireDefault(_StudentGeneralInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SessionAttendanceRecord = (0, _immutable.Record)({
  id: undefined,
  studentGeneralInfo: new _StudentGeneralInfo2.default(),
  attendanceStatus: undefined
});

var SessionAttendance = function (_SessionAttendanceRec) {
  _inherits(SessionAttendance, _SessionAttendanceRec);

  function SessionAttendance() {
    _classCallCheck(this, SessionAttendance);

    return _possibleConstructorReturn(this, (SessionAttendance.__proto__ || Object.getPrototypeOf(SessionAttendance)).apply(this, arguments));
  }

  return SessionAttendance;
}(SessionAttendanceRecord);

exports.default = SessionAttendance;

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _StudentGeneralInfo = __webpack_require__(107);

var _StudentGeneralInfo2 = _interopRequireDefault(_StudentGeneralInfo);

var _ = __webpack_require__(287);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      seq = _ref2[1];

  if (!seq) return [key, seq];
  switch (key) {
    case 'studentGeneralInfo':
      return [key, _StudentGeneralInfo2.default.create(seq)];
    default:
      return [key, _immutable2.default.fromJS(seq)];
  }
};

var create = exports.create = function create(data) {
  return new _2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttendanceStatus = exports.Status = exports.Student = undefined;

var _student = __webpack_require__(1328);

var _student2 = _interopRequireDefault(_student);

var _status = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Student = exports.Student = _student2.default;
var Status = exports.Status = _status.AttendanceStatus;
var AttendanceStatus = exports.AttendanceStatus = _status.AttendanceStatus;

Student.Status = Status;

exports.default = Student;

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Student = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1329);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _status = __webpack_require__(83);

var _omniCommonUi = __webpack_require__(0);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _component = __webpack_require__(1331);

var _component2 = _interopRequireDefault(_component);

var _ProductionStatus = __webpack_require__(73);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StudentCardProfile = __webpack_require__(84);

var _StudentCardProfile2 = _interopRequireDefault(_StudentCardProfile);

var _NewNotePopup = __webpack_require__(288);

var _NewNotePopup2 = _interopRequireDefault(_NewNotePopup);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _Note = __webpack_require__(131);

var _redux = __webpack_require__(10);

var _QuickSummary = __webpack_require__(162);

var _QuickSummary2 = _interopRequireDefault(_QuickSummary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Student = exports.Student = function (_PureComponent) {
  _inherits(Student, _PureComponent);

  function Student(props) {
    _classCallCheck(this, Student);

    var _this = _possibleConstructorReturn(this, (Student.__proto__ || Object.getPrototypeOf(Student)).call(this, props));

    _this.state = { dialogOpen: false };
    _this._onSaveNoteClicked = _this._onSaveNoteClicked.bind(_this);
    _this._onOpenDialogClicked = _this._onOpenDialogClicked.bind(_this);
    _this._onCancelDialogClicked = _this._onCancelDialogClicked.bind(_this);
    return _this;
  }

  _createClass(Student, [{
    key: '_onSaveNoteClicked',
    value: function _onSaveNoteClicked(note) {
      this.props.submitStudentNote(this.props.studentId, {
        groupId: this.props.groupId,
        category: _Note.actions.STUDENT_NOTE_CATEGORY_ATTENDANCE,
        content: note,
        entityId: this.props.sessionId
      });
      this.setState({ dialogOpen: false });
    }
  }, {
    key: '_onOpenDialogClicked',
    value: function _onOpenDialogClicked() {
      this.setState({ dialogOpen: true });
    }
  }, {
    key: '_onCancelDialogClicked',
    value: function _onCancelDialogClicked() {
      this.setState({ dialogOpen: false });
    }
  }, {
    key: '_renderStatus',
    value: function _renderStatus() {
      var className = (0, _classnames2.default)(_style2.default.Student_attendanceStatusText, (0, _omniCommonUi.testClass)('student-attendance-status'));
      if (this.props.marking) {
        return _react2.default.createElement(_component2.default, { status: this.props.status,
          onMarkPresent: this.props.onMarkPresent,
          onMarkAbsent: this.props.onMarkAbsent,
          onMarkLate: this.props.onMarkLate });
      }
      return _react2.default.createElement(
        'p',
        { className: className },
        this.props.status
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var status = this.props.status || _status.DefaultAttendanceStatus;
      (0, _status.validateAttendanceStatus)(status);

      var productionStatus = (0, _ProductionStatus.parseProductionStatus)(this.props.productionStatus);
      return _react2.default.createElement(
        _omniCommonUi.StudentCard,
        { withSeparatorLine: !this.props.marking,
          statusAccentColor: this.props.marking ? undefined : _status.AttendanceStatusColorMappings[status],
          className: (0, _omniCommonUi.testClass)('attendance-studentCard') },
        _react2.default.createElement(
          'div',
          { className: _style2.default.Student_wrapper },
          this.state.dialogOpen && _react2.default.createElement(_NewNotePopup2.default, { titleGroup: this.props.groupNumber,
            studentName: this.props.name + ' ' + this.props.surname,
            extraInfo: _react2.default.createElement(_QuickSummary2.default, { type: _QuickSummary2.default.Type.attendance,
              entityId: this.props.sessionId }),
            onSave: this._onSaveNoteClicked,
            onCancel: this._onCancelDialogClicked,
            category: 'Behaviour & Participation' }),
          _react2.default.createElement(
            'div',
            { className: _style2.default.Student_student },
            _react2.default.createElement(_StudentCardProfile2.default, { studentId: this.props.studentId,
              status: productionStatus.fullName,
              statusHighlighted: this.props.isInProduction })
          ),
          this.props.canAddStudentNotes && _react2.default.createElement(
            'div',
            { className: _style2.default.Student_icon, onClick: this._onOpenDialogClicked },
            _react2.default.createElement(_omniCommonUi.Icon, { id: 'new-message' })
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.StudentCard.Content,
          null,
          this._renderStatus()
        )
      );
    }
  }]);

  return Student;
}(_react.PureComponent);

Student.propTypes = {
  status: _propTypes2.default.string,
  name: _propTypes2.default.string,
  surname: _propTypes2.default.string,
  localname: _propTypes2.default.string,
  avatarUrl: _propTypes2.default.string,
  gender: _propTypes2.default.string,
  marking: _propTypes2.default.bool,
  onMarkPresent: _propTypes2.default.func,
  onMarkAbsent: _propTypes2.default.func,
  onMarkLate: _propTypes2.default.func,
  productionStatus: _propTypes2.default.string,
  isInProduction: _propTypes2.default.bool,
  studentId: _propTypes2.default.string,
  groupNumber: _propTypes2.default.string,
  sessionInfo: _propTypes2.default.string,
  canAddStudentNotes: _propTypes2.default.bool,
  submitStudentNote: _propTypes2.default.func.isRequired,
  groupId: _propTypes2.default.string.isRequired,
  sessionId: _propTypes2.default.string.isRequired
};

function mapStateToProps(state) {
  var canAddStudentNotes = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.AcademicInfo.AddStudentNotes);

  return {
    canAddStudentNotes: canAddStudentNotes
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_Note.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(Student);

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1330);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3Hlnx8TD51H6DWq36iAn-r{-webkit-box-align:stretch;-webkit-align-items:stretch;-moz-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3YjEa25tdSaU9C0YyNS-k_{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;width:0}._1_kGx9e0b4_V3lTC22NqVD{-webkit-align-self:flex-start;-ms-flex-item-align:start;align-self:flex-start;cursor:pointer;font-size:1.28571rem;margin-right:1.07143rem;margin-top:1.14286rem}._1_kGx9e0b4_V3lTC22NqVD:hover{color:#0087e6}._2eNth-YolSW24K63CUM-3j{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-size:.92857rem;height:2.5rem;letter-spacing:.07143rem;margin:0;margin-bottom:-.07143rem;padding-left:1.07143rem;position:relative;text-transform:uppercase;top:-.14286rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Student_wrapper": "_3Hlnx8TD51H6DWq36iAn-r",
	"Student_student": "_3YjEa25tdSaU9C0YyNS-k_",
	"Student_icon": "_1_kGx9e0b4_V3lTC22NqVD",
	"Student_attendanceStatusText": "_2eNth-YolSW24K63CUM-3j"
};

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1332);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _status = __webpack_require__(83);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MarkAttendanceButtons = function MarkAttendanceButtons(props) {
  var markPresentClassName = (0, _classnames3.default)(_style2.default.MarkAttendanceButtons_button, (0, _omniCommonUi.testClass)('mark-present-btn'));
  var markAbsentClassName = (0, _classnames3.default)(_style2.default.MarkAttendanceButtons_button, (0, _omniCommonUi.testClass)('mark-absent-btn'));
  var markLateClassName = (0, _classnames3.default)(_style2.default.MarkAttendanceButtons_button, (0, _omniCommonUi.testClass)('mark-late-btn'));
  return _react2.default.createElement(
    'div',
    { className: _style2.default.MarkAttendanceButtons },
    _react2.default.createElement(
      _omniCommonUi.Tooltip,
      { text: 'Present', className: _style2.default.MarkAttendanceButtons_buttonContainer },
      _react2.default.createElement(
        _omniCommonUi.Button,
        { className: markPresentClassName,
          onClick: function onClick() {
            return props.onMarkPresent();
          },
          autoWidth: true,
          active: props.status === _status.AttendanceStatus.present },
        _react2.default.createElement(_omniCommonUi.Icon, { id: 'tick' })
      )
    ),
    _react2.default.createElement(
      _omniCommonUi.Tooltip,
      { text: 'Absent', className: _style2.default.MarkAttendanceButtons_buttonContainer },
      _react2.default.createElement(
        _omniCommonUi.Button,
        { className: markAbsentClassName,
          onClick: function onClick() {
            return props.onMarkAbsent();
          },
          autoWidth: true,
          active: props.status === _status.AttendanceStatus.absent },
        _react2.default.createElement(_omniCommonUi.Icon, { id: 'cross' })
      )
    ),
    _react2.default.createElement(
      _omniCommonUi.Tooltip,
      { text: 'Late', className: _style2.default.MarkAttendanceButtons_buttonContainer },
      _react2.default.createElement(
        _omniCommonUi.Button,
        { className: markLateClassName,
          onClick: function onClick() {
            return props.onMarkLate();
          },
          autoWidth: true,
          active: props.status === _status.AttendanceStatus.late },
        _react2.default.createElement(_omniCommonUi.Icon, { id: 'clock' })
      )
    ),
    renderNotApplicable()
  );

  function renderNotApplicable() {
    if (props.canSeeNotApplicable !== true) {
      return null;
    }

    return _react2.default.createElement(
      _omniCommonUi.Tooltip,
      { text: 'Not Applicable', className: _style2.default.MarkAttendanceButtons_buttonContainer },
      _react2.default.createElement(_omniCommonUi.Button, { className: (0, _classnames3.default)(_style2.default.MarkAttendanceButtons_button, _style2.default.__na, _defineProperty({}, _style2.default.__highlighted, props.status === _status.AttendanceStatus.notApplicable)),
        onClick: function onClick() {
          return props.onMarkNA();
        },
        autoWidth: true })
    );
  }
};

MarkAttendanceButtons.propTypes = {
  status: _propTypes2.default.oneOf(Object.values(_status.AttendanceStatus)),
  onMarkPresent: _propTypes2.default.func.isRequired,
  onMarkAbsent: _propTypes2.default.func.isRequired,
  onMarkLate: _propTypes2.default.func.isRequired,
  onMarkNA: _propTypes2.default.func,
  canSeeNotApplicable: _propTypes2.default.bool
};

exports.default = MarkAttendanceButtons;

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1333);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1BTUYLoJ4aktjlWVzGqMir{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._3xxOkr3YR8UKvTZZrjlKTS{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1}._3xxOkr3YR8UKvTZZrjlKTS:not(:last-child) ._7CI6N2H2PTG8IKuVwK-3R{border-right:none}._7CI6N2H2PTG8IKuVwK-3R{-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;min-width:0;width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MarkAttendanceButtons": "_1BTUYLoJ4aktjlWVzGqMir",
	"MarkAttendanceButtons_buttonContainer": "_3xxOkr3YR8UKvTZZrjlKTS",
	"MarkAttendanceButtons_button": "_7CI6N2H2PTG8IKuVwK-3R"
};

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1335);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1FgNhbiRqovsd1Kt2GzMyY{padding-top:.5rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"__placeholder": "_1FgNhbiRqovsd1Kt2GzMyY"
};

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1337);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".QblNIEGFob6-5hz9_Ixvg._3TWITpx-myhca0ut6404ZU{-webkit-animation-play-state:running;-moz-animation-play-state:running;-o-animation-play-state:running;animation-play-state:running}._3gata3qLfgCJJKZy4miL_{-webkit-animation-duration:1s;-moz-animation-duration:1s;-o-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:forwards;-moz-animation-fill-mode:forwards;-o-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-iteration-count:infinite;-moz-animation-iteration-count:infinite;-o-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:_3qtKaOg816Fs06YoHV1Img;-moz-animation-name:_3qtKaOg816Fs06YoHV1Img;-o-animation-name:_3qtKaOg816Fs06YoHV1Img;animation-name:_3qtKaOg816Fs06YoHV1Img;-webkit-animation-timing-function:linear;-moz-animation-timing-function:linear;-o-animation-timing-function:linear;animation-timing-function:linear;background:-webkit-gradient(linear,left top,right top,color-stop(30%,#ebebed),color-stop(50%,#e1e1e5),color-stop(70%,#ebebed));background:-webkit-linear-gradient(left,#ebebed 30%,#e1e1e5 50%,#ebebed 70%);background:-moz-linear-gradient(left,#ebebed 30%,#e1e1e5 50%,#ebebed 70%);background:-o-linear-gradient(left,#ebebed 30%,#e1e1e5 50%,#ebebed 70%);background:linear-gradient(90deg,#ebebed 30%,#e1e1e5 50%,#ebebed 70%);background-color:#dedede;-webkit-background-size:400% 7.14286rem;-moz-background-size:400% 7.14286rem;background-size:400% 7.14286rem;width:50%}._3gata3qLfgCJJKZy4miL_:nth-child(odd){width:70%}@-webkit-keyframes _3qtKaOg816Fs06YoHV1Img{0%{background-position:115% 0}to{background-position:-115% 0}}@-moz-keyframes _3qtKaOg816Fs06YoHV1Img{0%{background-position:115% 0}to{background-position:-115% 0}}@-o-keyframes _3qtKaOg816Fs06YoHV1Img{0%{background-position:115% 0}to{background-position:-115% 0}}@keyframes _3qtKaOg816Fs06YoHV1Img{0%{background-position:115% 0}to{background-position:-115% 0}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"UserCardPlaceholder": "QblNIEGFob6-5hz9_Ixvg",
	"__loading": "_3TWITpx-myhca0ut6404ZU",
	"UserCardPlaceholder_placeholderText": "_3gata3qLfgCJJKZy4miL_",
	"shimmer": "_3qtKaOg816Fs06YoHV1Img"
};

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1339);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3scQxTKx3CtAitf_guloil{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:3.57143rem;padding-left:1.42857rem;padding-right:1.42857rem}@media only screen and (min-width:640px){._3scQxTKx3CtAitf_guloil{padding-left:2.14286rem;padding-right:2.14286rem}}._1AClkAelDaWANGBHo7yvbY{display:inline;margin:0;font-size:1.14286rem;letter-spacing:.07143rem;line-height:1.25}._1AClkAelDaWANGBHo7yvbY,._25K1p7h1lFKEgtycyNV_{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-weight:400}._25K1p7h1lFKEgtycyNV_{font-size:1rem;letter-spacing:.03571rem;line-height:1.28571}._1rO4Kj0MtMF0vIuhQLNfpb{padding:1.42857rem}@media only screen and (min-width:640px){._1rO4Kj0MtMF0vIuhQLNfpb{padding:1.42857rem 2.14286rem}}._3Aw1i2XKdmJSq6rDhgsgsb,.yhadtb6FHr2l-MAnIxRMc{margin-bottom:1.42857rem}.yhadtb6FHr2l-MAnIxRMc{font-weight:700}.BRfm_55dMTvX11eDG6zNF{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-top:1.42857rem}.BRfm_55dMTvX11eDG6zNF>*{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1}@media only screen and (min-width:640px){.BRfm_55dMTvX11eDG6zNF>*{-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"NewNotePopup_titleBar": "_3scQxTKx3CtAitf_guloil",
	"NewNotePopup_title": "_1AClkAelDaWANGBHo7yvbY",
	"NewNotePopup_title_group": "_25K1p7h1lFKEgtycyNV_",
	"NewNotePopup_content": "_1rO4Kj0MtMF0vIuhQLNfpb",
	"NewNotePopup_info": "_3Aw1i2XKdmJSq6rDhgsgsb",
	"NewNotePopup_category": "yhadtb6FHr2l-MAnIxRMc",
	"NewNotePopup_buttons": "BRfm_55dMTvX11eDG6zNF"
};

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1341);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1st2xmrxmbQy0ayutBugLU{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:1.42857rem;width:100%}._3rildP10KCwacoYaGHGI3d{width:100%}._12dsW6e2TMTEwvwtOUBBKX{padding:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Note": "_1st2xmrxmbQy0ayutBugLU",
	"Note_wrapper": "_3rildP10KCwacoYaGHGI3d",
	"Note_card": "_12dsW6e2TMTEwvwtOUBBKX"
};

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpansionGridItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1343);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = __webpack_require__(7);

var _classnames4 = _interopRequireDefault(_classnames3);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExpansionGridItem = exports.ExpansionGridItem = function (_PureComponent) {
  _inherits(ExpansionGridItem, _PureComponent);

  function ExpansionGridItem(props) {
    _classCallCheck(this, ExpansionGridItem);

    var _this = _possibleConstructorReturn(this, (ExpansionGridItem.__proto__ || Object.getPrototypeOf(ExpansionGridItem)).call(this, props));

    _this.state = { expanded: false };
    return _this;
  }

  _createClass(ExpansionGridItem, [{
    key: '_onHeaderClick',
    value: function _onHeaderClick() {
      this.setState({ expanded: !this.state.expanded });
    }
  }, {
    key: '_renderContent',
    value: function _renderContent() {
      if (!this.state.expanded) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: _style2.default.ExpansionGridItem_Content },
        this.props.children
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var headerClassName = (0, _classnames4.default)(_style2.default.ExpansionGridItem_header, (0, _omniCommonUi.testClass)('expansion-item-header'), _defineProperty({}, _style2.default.__expanded, this.state.expanded));
      var iconClassName = (0, _classnames4.default)(_style2.default.ExpansionGridItem_header_icon, _defineProperty({}, _style2.default.__expanded, this.state.expanded));
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames4.default)(this.props.className, _style2.default.ExpansionGridItem) },
        _react2.default.createElement(
          'div',
          { className: headerClassName, onClick: function onClick() {
              return _this2._onHeaderClick();
            } },
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'chevron-small-right',
            className: iconClassName }),
          _react2.default.createElement(
            'span',
            { className: _style2.default.ExpansionGridItem_header_title },
            this.props.title
          ),
          _react2.default.createElement(
            'span',
            { className: _style2.default.ExpansionGridItem_header_summary },
            this.props.summary
          )
        ),
        this._renderContent()
      );
    }
  }]);

  return ExpansionGridItem;
}(_react.PureComponent);

ExpansionGridItem.propTypes = {
  className: _propTypes2.default.string,
  title: _propTypes2.default.string,
  summary: _propTypes2.default.string,
  children: _propTypes2.default.node
};

exports.default = ExpansionGridItem;

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1344);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".ANQI9ksecwIeSI8zxCVoi{border-bottom:.07143rem solid #ccc}.QQsxC3ktgoU9HBULR5CNM{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:1.78571rem}.QQsxC3ktgoU9HBULR5CNM._1MyG94e6RV5lFzLmR5c88p{border-bottom:.07143rem solid #ccc}._29CaDFMWKz6Sd7FpXWrzz_{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:1.125em;font-weight:600;margin-right:1.42857rem}._3Xh4nLMWUsw2IX5nc-Zm8I{margin-right:1.42857rem}._3Xh4nLMWUsw2IX5nc-Zm8I,._3Xh4nLMWUsw2IX5nc-Zm8I._1MyG94e6RV5lFzLmR5c88p{-webkit-transition-duration:.5s;-moz-transition-duration:.5s;-o-transition-duration:.5s;transition-duration:.5s}._3Xh4nLMWUsw2IX5nc-Zm8I._1MyG94e6RV5lFzLmR5c88p{-webkit-transform:rotate(90deg);-moz-transform:rotate(90deg);-ms-transform:rotate(90deg);-o-transform:rotate(90deg);transform:rotate(90deg)}._2q3mGkm5Adsd87Yh-qRrg8{color:#a4a4a4}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ExpansionGridItem": "ANQI9ksecwIeSI8zxCVoi",
	"ExpansionGridItem_header": "QQsxC3ktgoU9HBULR5CNM",
	"__expanded": "_1MyG94e6RV5lFzLmR5c88p",
	"ExpansionGridItem_header_title": "_29CaDFMWKz6Sd7FpXWrzz_",
	"ExpansionGridItem_header_icon": "_3Xh4nLMWUsw2IX5nc-Zm8I",
	"ExpansionGridItem_header_summary": "_2q3mGkm5Adsd87Yh-qRrg8"
};

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1346);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = __webpack_require__(16);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _UserCard = __webpack_require__(65);

var _UserCard2 = _interopRequireDefault(_UserCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IndividualNote = function (_PureComponent) {
  _inherits(IndividualNote, _PureComponent);

  function IndividualNote() {
    _classCallCheck(this, IndividualNote);

    return _possibleConstructorReturn(this, (IndividualNote.__proto__ || Object.getPrototypeOf(IndividualNote)).apply(this, arguments));
  }

  _createClass(IndividualNote, [{
    key: '_renderNoteDate',
    value: function _renderNoteDate() {
      return _react2.default.createElement(
        'span',
        { className: _style2.default.IndividualNote_footer_date },
        _omniCommonUi.moment.utc(this.props.note.notedDateTimeUtc).local().format('YYYY-MM-DD')
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _style2.default.IndividualNote },
        _react2.default.createElement(
          'div',
          { className: _style2.default.IndividualNote_header },
          _react2.default.createElement(
            'span',
            { className: (0, _omniCommonUi.testClass)('individual-note-title') },
            this.props.note.category
          ),
          _react2.default.createElement(
            'span',
            null,
            this.props.note.noteName
          ),
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: this.props.buildRoute('/group/' + this.props.note.groupId) },
              this.props.note.groupCode
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_style2.default.IndividualNote_content, (0, _omniCommonUi.testClass)('individual-note-content')) },
          this.props.note.content
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.IndividualNote_footer },
          _react2.default.createElement(
            'span',
            null,
            'Created by:'
          ),
          _react2.default.createElement(_UserCard2.default, { id: '' + this.props.note.notedByUserId,
            className: _style2.default.IndividualNote_footer_user,
            avatarClassName: _style2.default.IndividualNote_footer_user_avatar }),
          this._renderNoteDate()
        )
      );
    }
  }]);

  return IndividualNote;
}(_react.PureComponent);

IndividualNote.propTypes = {
  note: _propTypes2.default.object,
  buildRoute: _propTypes2.default.func
};

exports.default = (0, _omniCommonUi.connect)()(IndividualNote);

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1347);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2-Xtf52pXegQOau5mlx56Q{border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-left:2.85714rem;padding:1.42857rem}._2-Xtf52pXegQOau5mlx56Q:last-child{border-bottom-width:0}._2a5Y4VVZWErmCq5Mbhl7t2,.e1fwkKE2KqYxgSgPGiTuO,.lSHncaFXgYtjnBMK9V86A{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;width:100%}._2a5Y4VVZWErmCq5Mbhl7t2 span{border-right:.07143rem solid #ccc;font-weight:600;padding:0 .71429rem}._2a5Y4VVZWErmCq5Mbhl7t2 span:last-child{border-right-width:0}._2a5Y4VVZWErmCq5Mbhl7t2 span:first-child{padding-left:0}.e1fwkKE2KqYxgSgPGiTuO{padding:1.42857rem 0}.lSHncaFXgYtjnBMK9V86A{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;font-size:.85714rem;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}._19sNWtqLxfVmRoxKvdjIr1{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;padding:0 .71429rem}._1fyT2y_KfKCe5EYoJnTWOG{height:2.14286rem;width:2.14286rem}._2DZgbWr3AOInl05WGKz5MJ{color:#a4a4a4}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"IndividualNote": "_2-Xtf52pXegQOau5mlx56Q",
	"IndividualNote_header": "_2a5Y4VVZWErmCq5Mbhl7t2",
	"IndividualNote_content": "e1fwkKE2KqYxgSgPGiTuO",
	"IndividualNote_footer": "lSHncaFXgYtjnBMK9V86A",
	"IndividualNote_footer_user": "_19sNWtqLxfVmRoxKvdjIr1",
	"IndividualNote_footer_user_avatar": "_1fyT2y_KfKCe5EYoJnTWOG",
	"IndividualNote_footer_date": "_2DZgbWr3AOInl05WGKz5MJ"
};

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1349);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3g8vfTCSpWKmUcxSWO3yOF{height:3.57143rem;width:3.57143rem}.fePwUNv7cNBZD_-62VWLK{color:#a4a4a4}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"UserCard_picture": "_3g8vfTCSpWKmUcxSWO3yOF",
	"UserCard_date": "fePwUNv7cNBZD_-62VWLK"
};

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNotes = exports.getAttendanceNoteByStudentIdAndSessionId = undefined;

var _immutable = __webpack_require__(3);

var CATEGORY_ATTENDACE = 'Behavior & Participation';

var getAttendanceNoteByStudentIdAndSessionId = exports.getAttendanceNoteByStudentIdAndSessionId = function getAttendanceNoteByStudentIdAndSessionId(state, studentId, sessionId) {
  var notes = state.get('rootReducer').get('studentNotes');
  return _immutable.Map.isMap(notes) && notes.findLast(function (note) {
    return eql(note.get('studentId'), studentId) && note.get('category') === CATEGORY_ATTENDACE && eql(note.get('entityId'), sessionId);
  });
};

function eql(source, target) {
  return '' + source === '' + target;
}

var getNotes = exports.getNotes = function getNotes(state) {
  return state.get('rootReducer').get('studentNotes');
};

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = notes;

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _model = __webpack_require__(1352);

var _model2 = _interopRequireDefault(_model);

var _actions = __webpack_require__(199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function notes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  var newState = state;
  var noteModel = void 0;
  switch (action.type) {
    case _actions.FETCH_SINGLE_STUDENT_NOTE_SUCCESS:
      noteModel = _model2.default.create(action.payload);
      newState = newState.set(noteModel.id, noteModel);
      return newState;
    case _actions.FETCH_STUDENT_NOTES_SUCCESS:
      {
        if (_is_js2.default.array(action.payload)) {
          action.payload.forEach(function (note) {
            noteModel = _model2.default.create(note);
            newState = newState.set(noteModel.id, noteModel);
          });
        }
        return newState;
      }
    default:
      return state;
  }
}

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _omniCommonUi = __webpack_require__(0);

var _category = __webpack_require__(1353);

var _category2 = _interopRequireDefault(_category);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'id':
    case 'studentId':
      return [key, '' + val];
    case 'category':
      return [key, getCategory(val)];
    case 'notedDateTimeUtc':
      return [key, _omniCommonUi.moment.utc(val)];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

function getCategory(categoryCode) {
  return _category2.default[categoryCode.toLowerCase()];
}

var NoteRecord = (0, _immutable.Record)({
  id: undefined,
  entityId: undefined,
  noteName: undefined,
  notedByUserId: undefined,
  notedDateTimeUtc: undefined,
  groupId: undefined,
  groupCode: undefined,
  fullCourseTypeLevelCode: undefined,
  category: undefined,
  content: undefined,
  studentId: undefined
});

var Note = function (_NoteRecord) {
  _inherits(Note, _NoteRecord);

  function Note() {
    _classCallCheck(this, Note);

    return _possibleConstructorReturn(this, (Note.__proto__ || Object.getPrototypeOf(Note)).apply(this, arguments));
  }

  _createClass(Note, null, [{
    key: 'create',
    value: function create(data) {
      return new Note(data).mapEntries(reviver);
    }
  }]);

  return Note;
}(NoteRecord);

exports.default = Note;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var category = {
  attendance: 'Behavior & Participation',
  progresstest: 'Test Results',
  unitreport: 'unitReport',
  progressreport: 'progressReport'
};

exports.default = category;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1355);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1xNzYy0NvHIS1RIGX4VKeW{white-space:nowrap}._1ExaYwQ4909WjdZaDfTc1T{display:inline-block;max-width:7.85714rem;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;vertical-align:bottom}", ""]);

// exports
exports.locals = {
	"QuickSummary": "_1xNzYy0NvHIS1RIGX4VKeW",
	"QuickSummary_unit": "_1ExaYwQ4909WjdZaDfTc1T"
};

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = studentReportSummaryReducer;

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _actions = __webpack_require__(200);

var _model = __webpack_require__(289);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function studentReportSummaryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_STUDENT_REPORT_SUMMARIES_REQUEST:
      return state.set(action.progressReportId, _omniCommonUi.ApiResponseHelper.create({ loading: true }));
    case _actions.FETCH_STUDENT_REPORT_SUMMARY_SUCCESS:
      return addStudentSummaryToMap(state, action);
    case _actions.FETCH_STUDENT_REPORT_SUMMARIES_SUCCESS:
      return addStudentSummariesToMap(state, action);
    case _actions.FETCH_STUDENT_REPORT_SUMMARIES_FAILURE:
      return state.set(action.progressReportId, _omniCommonUi.ApiResponseHelper.create(action.error));
    default:
      return state;
  }
}

function addStudentSummariesToMap(state, _ref) {
  var payload = _ref.payload,
      progressReportId = _ref.progressReportId;

  var newState = state;
  var studentSummaries = new _immutable.Map();
  payload.forEach(function (studentReportSummary) {
    var studentReportSummaryModel = _model2.default.create(studentReportSummary);
    studentSummaries = studentSummaries.set('' + studentReportSummaryModel.studentId, studentReportSummaryModel);
  });
  newState = newState.set(progressReportId, _omniCommonUi.ApiResponseHelper.create(studentSummaries));
  return newState;
}

function addStudentSummaryToMap(state, _ref2) {
  var payload = _ref2.payload,
      progressReportId = _ref2.progressReportId,
      studentId = _ref2.studentId;

  var newState = state;
  var studentReportSummaryModel = _model2.default.create(payload);
  if (newState.get(progressReportId) && newState.get(progressReportId).data) {
    newState = newState.get(progressReportId).data.set(studentId, studentReportSummaryModel);
  } else {
    var studentSummaries = new _immutable.Map();
    studentSummaries = studentSummaries.set('' + studentReportSummaryModel.studentId, studentReportSummaryModel);
    newState = newState.set(progressReportId, _omniCommonUi.ApiResponseHelper.create(studentSummaries));
  }

  return newState;
}

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(625);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1358);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaperBasedHomeworkResult = _model2.default;

PaperBasedHomeworkResult.create = _create2.default;
exports.default = PaperBasedHomeworkResult;

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(625);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, 0];
  return [key, val];
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(626);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1360);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OnlineHomeworkResult = _model2.default;

OnlineHomeworkResult.create = _create2.default;

exports.default = OnlineHomeworkResult;

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(626);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, 0];
  return [key, val];
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(627);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1362);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(627);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var create = function create(data) {
  return new _model2.default(data);
};

exports.default = create;

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = progressTests;
exports.createProgressTest = createProgressTest;

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _actions = __webpack_require__(624);

var _model = __webpack_require__(628);

var _model2 = _interopRequireDefault(_model);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toMap = function toMap(arr, key) {
  return new _immutable.Map(arr.reduce(function (obj, item) {
    // eslint-disable-next-line no-param-reassign
    obj[item[key]] = item; // stringifies keys!
    return obj;
  }, {}));
};

function progressTests() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var payload = action.payload,
      groupId = action.groupId,
      progressReportId = action.progressReportId,
      progressTestName = action.name;

  switch (action.type) {
    case _actions.FETCH_PROGRESS_TEST_REQUEST:
    case _actions.SUBMIT_PROGRESS_TEST_RESULTS_REQUEST:
    case _actions.RETAKE_PROGRESS_TEST_REQUEST:
      return state.set(action.progressTestId, _omniCommonUi.ApiResponseHelper.create({
        loading: true
      }));
    case _actions.FETCH_PROGRESS_TEST_SUCCESS:
      return state.set(action.progressTestId, _omniCommonUi.ApiResponseHelper.create(createProgressTest(payload, groupId, progressReportId, progressTestName)));
    case _actions.RETAKE_PROGRESS_TEST_SUCCESS:
      return addReTakeStateToMap(state, action);
    case _actions.FETCH_PROGRESS_TEST_FAILURE:
      return state.set(action.progressTestId, _omniCommonUi.ApiResponseHelper.create(action.error));
    default:
      return state;
  }
}

function createProgressTest(payload, groupId, progressReportId, progressTestName) {
  var studentProgressTestResults = payload.studentProgressTestResults || [];
  return _model2.default.create(Object.assign({}, payload, {
    groupId: groupId,
    progressReportId: progressReportId,
    name: progressTestName,
    skills: payload.skills || [],
    studentProgressTestResults: studentProgressTestResults.map(function (result) {
      var res = result; // grr - eslint

      res.skillResults = createStudentProgressTestSkillResults(result, payload.skills);
      res.totalScore = createStudentProgressTestTotalScore(result, payload.skills);
      res.previousTotalScore = createStudentProgressTestTotalScore(result, payload.skills, 'previousResult');

      return res;
    })
  }));
}

function createStudentProgressTestSkillResults(result, skills) {
  return result.skillResults.map(function (skillResult) {
    var progressTestSkill = skills.find(function (skill) {
      return skill.skillId === skillResult.skillId;
    });
    if (_is_js2.default.undefined(progressTestSkill)) {
      throw new Error('skill ' + skillResult.skillId + ' could not be found in the content map');
    }
    if (progressTestSkill.isRubric) {
      var skillAbilitiesMap = toMap(progressTestSkill.abilities, 'abilityId');
      var rubricScoreAndFullMark = findScoreAndFullMarkForRubricResult(skillResult, progressTestSkill, skillAbilitiesMap);
      var previousRubricScoreAndFullMark = findScoreAndFullMarkForRubricResult(skillResult, progressTestSkill, skillAbilitiesMap, 'previousResultAbilityId');
      // eslint-disable-next-line no-param-reassign
      skillResult = Object.assign({}, skillResult, {
        currentResult: rubricScoreAndFullMark.score,
        previousResult: previousRubricScoreAndFullMark.score,
        fullMark: rubricScoreAndFullMark.fullMark
      });
    }
    if (_is_js2.default.number(skillResult.fullMark)) {
      progressTestSkill.fullMark = skillResult.fullMark;
    }
    return skillResult;
  });
}

// it could be argued that the backend should be doing this stuff
function findScoreAndFullMarkForRubricResult(rubricResult, progressTestSkill, skillAbilitiesMap) {
  var abilityIdKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'currentResultAbilityId';

  var fallbackAbilityIdKey = 'currentResultAbilityId';
  // fullMark is the highest ability score * number of subSkills in the rubric skill
  // eslint-disable-next-line no-confusing-arrow
  var fullMark = progressTestSkill.abilities.reduce(function (max, ability) {
    return ability.point > max ? ability.point : max;
  }, 0) * progressTestSkill.subSkills.length;
  // score is the sum of the points of abilities in a student's sub skill result set
  // (I know...)
  var isAnyNull = false;
  var score = rubricResult.subSkillResults.reduce(function (totalSubSkillScore) {
    var subSkillResult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var isResultAvailable = subSkillResult && _is_js2.default.not.null(subSkillResult[abilityIdKey]);
    var scoredPointsForSubSkill = isResultAvailable ? (skillAbilitiesMap.get('' + subSkillResult[abilityIdKey]) || {}).point : (skillAbilitiesMap.get('' + subSkillResult[fallbackAbilityIdKey]) || {}).point || 0;
    isAnyNull = isAnyNull || _is_js2.default.null(subSkillResult[abilityIdKey]);
    return totalSubSkillScore + scoredPointsForSubSkill;
  }, 0);
  return { score: isAnyNull ? null : score, fullMark: fullMark };
}

function createStudentProgressTestTotalScore(result, progressTestSkills) {
  var scoreKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'currentResult';

  var fallbackScoreKey = 'currentResult';
  var skillResults = toMap(result.skillResults, 'skillId');
  var skillScorePercentages = new _immutable.Map();
  var output = new _immutable.Map({ skillScorePercentages: skillScorePercentages });
  var totalScore = 0;
  var SkillCount = 0;
  var isAnyNA = false;
  progressTestSkills.forEach(function (skill) {
    var skillResult = skillResults.get(skill.skillId.toString());
    var isResultAvailable = _is_js2.default.object(skillResult) && _is_js2.default.number(skillResult[scoreKey]);
    var isFallbackResultAvailable = _is_js2.default.object(skillResult) && _is_js2.default.number(skillResult[fallbackScoreKey]);
    if (!skillResult.isAbandoned) {
      if (isResultAvailable || isFallbackResultAvailable) {
        var score = isResultAvailable ? skillResult[scoreKey] : skillResult[fallbackScoreKey];
        var baseNum = score * 100;
        var percentage = Math.min(100, baseNum / skill.fullMark);
        var percentageRounded = Math.round(percentage);
        skillScorePercentages = skillScorePercentages.set('' + skill.skillId, percentageRounded);
        output = output.set('skillScorePercentages', skillScorePercentages);
        totalScore += percentage;
        SkillCount += 1;
      } else {
        isAnyNA = true;
      }
    }
  });
  if (isAnyNA) {
    return output.set('isNotApplicable', true);
  }
  if (totalScore === 0) {
    // no divide by zero!
    return output.set('percentage', 0);
  }
  var perc = Math.round(totalScore / SkillCount);
  return Number.isNaN(perc) ? output.set('isEmpty', true) : output.set('percentage', perc);
}

function addReTakeStateToMap(state, _ref) {
  var progressTestId = _ref.progressTestId,
      studentId = _ref.studentId;

  var newState = state;
  newState = newState.set('progressTestResetted', { progressTestId: progressTestId, studentId: studentId });
  return newState;
}

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1365);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _Abilities = __webpack_require__(1366);

var _Abilities2 = _interopRequireDefault(_Abilities);

var _SubSkills = __webpack_require__(1368);

var _SubSkills2 = _interopRequireDefault(_SubSkills);

var _TargetLanguageCategories = __webpack_require__(1372);

var _TargetLanguageCategories2 = _interopRequireDefault(_TargetLanguageCategories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SkillRecord = (0, _immutable.Record)({
  skillId: undefined,
  name: undefined,
  fullMark: undefined,
  description: undefined,
  expectation: undefined,
  isRubric: undefined,
  abilities: new _immutable.List(),
  subSkills: new _immutable.List(),
  targetLanguageCategories: new _immutable.List()
});

var Skill = function (_SkillRecord) {
  _inherits(Skill, _SkillRecord);

  function Skill() {
    _classCallCheck(this, Skill);

    return _possibleConstructorReturn(this, (Skill.__proto__ || Object.getPrototypeOf(Skill)).apply(this, arguments));
  }

  return Skill;
}(SkillRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'skillId':
      return [key, '' + val];
    case 'abilities':
      return [key, new _immutable.List(val.map(_Abilities2.default.create))];
    case 'subSkills':
      return [key, new _immutable.List(val.map(_SubSkills2.default.create))];
    case 'targetLanguageCategories':
      return [key, new _immutable.List(val.map(_TargetLanguageCategories2.default.create))];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

Skill.create = function (data) {
  return new Skill(data).mapEntries(reviver);
};

exports.default = Skill;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1367);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AbilityRecord = (0, _immutable.Record)({
  abilityId: undefined,
  name: undefined,
  point: undefined
});

var Ability = function (_AbilityRecord) {
  _inherits(Ability, _AbilityRecord);

  function Ability() {
    _classCallCheck(this, Ability);

    return _possibleConstructorReturn(this, (Ability.__proto__ || Object.getPrototypeOf(Ability)).apply(this, arguments));
  }

  return Ability;
}(AbilityRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'abilityId':
      return [key, '' + val];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

Ability.create = function (data) {
  return new Ability(data).mapEntries(reviver);
};

exports.default = Ability;

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1369);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _AbilityDescriptions = __webpack_require__(1370);

var _AbilityDescriptions2 = _interopRequireDefault(_AbilityDescriptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubSkillRecord = (0, _immutable.Record)({
  subSkillId: undefined,
  name: undefined,
  abilityDescriptions: new _immutable.List()
});

var SubSkill = function (_SubSkillRecord) {
  _inherits(SubSkill, _SubSkillRecord);

  function SubSkill() {
    _classCallCheck(this, SubSkill);

    return _possibleConstructorReturn(this, (SubSkill.__proto__ || Object.getPrototypeOf(SubSkill)).apply(this, arguments));
  }

  return SubSkill;
}(SubSkillRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'subSkillId':
      return [key, '' + val];
    case 'abilityDescriptions':
      return [key, new _immutable.List(val.map(_AbilityDescriptions2.default.create))];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

SubSkill.create = function (data) {
  return new SubSkill(data).mapEntries(reviver);
};

exports.default = SubSkill;

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1371);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AbilityDescriptionRecord = (0, _immutable.Record)({
  abilityId: undefined,
  note: undefined
});

var AbilityDescription = function (_AbilityDescriptionRe) {
  _inherits(AbilityDescription, _AbilityDescriptionRe);

  function AbilityDescription() {
    _classCallCheck(this, AbilityDescription);

    return _possibleConstructorReturn(this, (AbilityDescription.__proto__ || Object.getPrototypeOf(AbilityDescription)).apply(this, arguments));
  }

  return AbilityDescription;
}(AbilityDescriptionRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'abilityId':
      return [key, '' + val];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

AbilityDescription.create = function (data) {
  return new AbilityDescription(data).mapEntries(reviver);
};

exports.default = AbilityDescription;

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1373);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TargetLanguageCategoryRecord = (0, _immutable.Record)({
  title: undefined,
  items: new _immutable.List()
});

var TargetLanguageCategory = function (_TargetLanguageCatego) {
  _inherits(TargetLanguageCategory, _TargetLanguageCatego);

  function TargetLanguageCategory() {
    _classCallCheck(this, TargetLanguageCategory);

    return _possibleConstructorReturn(this, (TargetLanguageCategory.__proto__ || Object.getPrototypeOf(TargetLanguageCategory)).apply(this, arguments));
  }

  return TargetLanguageCategory;
}(TargetLanguageCategoryRecord);

TargetLanguageCategory.create = function (data) {
  return new TargetLanguageCategory(data);
};

exports.default = TargetLanguageCategory;

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1375);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitRecord = (0, _immutable.Record)({
  id: undefined,
  name: undefined,
  sessionPlanIds: new _immutable.List()
});

var Unit = function (_UnitRecord) {
  _inherits(Unit, _UnitRecord);

  function Unit() {
    _classCallCheck(this, Unit);

    return _possibleConstructorReturn(this, (Unit.__proto__ || Object.getPrototypeOf(Unit)).apply(this, arguments));
  }

  return Unit;
}(UnitRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      seq = _ref2[1];

  if (!seq) return [key, seq];
  return [key, _immutable2.default.fromJS(seq)];
};

Unit.create = function (data) {
  return new Unit(data).mapEntries(reviver);
};

exports.default = Unit;

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1377);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _SkillResults = __webpack_require__(1378);

var _SkillResults2 = _interopRequireDefault(_SkillResults);

var _TotalScore = __webpack_require__(1382);

var _TotalScore2 = _interopRequireDefault(_TotalScore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentProgressTestResultsRecord = (0, _immutable.Record)({
  studentId: undefined,
  canBeOverwrite: undefined,
  isPTSessionMember: undefined,
  skillResults: new _immutable.OrderedMap(), // key: skillId
  totalScore: _TotalScore2.default.create(),
  previousTotalScore: _TotalScore2.default.create()
});

var StudentProgressTestResults = function (_StudentProgressTestR) {
  _inherits(StudentProgressTestResults, _StudentProgressTestR);

  function StudentProgressTestResults() {
    _classCallCheck(this, StudentProgressTestResults);

    return _possibleConstructorReturn(this, (StudentProgressTestResults.__proto__ || Object.getPrototypeOf(StudentProgressTestResults)).apply(this, arguments));
  }

  return StudentProgressTestResults;
}(StudentProgressTestResultsRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'studentId':
      return [key, '' + val];
    case 'canBeOverwrite':
      return [key, Boolean(val)];
    case 'isPTSessionMember':
      return [key, Boolean(val)];
    case 'totalScore':
    case 'previousTotalScore':
      return [key, _TotalScore2.default.create(val)];
    case 'skillResults':
      // if we've constructed this using an existing OrderedMap, keep it
      if (_immutable.OrderedMap.isOrderedMap(val)) return [key, val];
      return [key, new _immutable.OrderedMap(val.map(function (item) {
        var skillResult = _SkillResults2.default.create(item);
        return [skillResult.skillId, skillResult];
      }))];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

StudentProgressTestResults.create = function (data) {
  return new StudentProgressTestResults(data).mapEntries(reviver);
};

StudentProgressTestResults.serialize = function (studentProgressTestResults) {
  return studentProgressTestResults.map(function (studentProgressTestResult) {
    var serializedModel = studentProgressTestResult.toObject();
    serializedModel.skillResults = studentProgressTestResult.skillResults.toList();
    return serializedModel;
  }).toList();
};

StudentProgressTestResults.isSerialized = function (studentProgressTestResults) {
  return studentProgressTestResults.every(function (studentProgressTestResult) {
    return _immutable.List.isList(studentProgressTestResult.skillResults);
  });
};

exports.default = StudentProgressTestResults;

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1379);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _SubSkillResults = __webpack_require__(1380);

var _SubSkillResults2 = _interopRequireDefault(_SubSkillResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SkillResultRecord = (0, _immutable.Record)({
  previousResult: undefined,
  isRubric: undefined,
  isAbandoned: undefined,
  skillId: undefined,
  currentResult: undefined,
  fullMark: undefined, // leave this here for rubric fullMark calculation
  subSkillResults: new _immutable.List(),
  suggestions: new _immutable.List(),
  markedBy: undefined,
  markedTime: undefined
});

var SkillResult = function (_SkillResultRecord) {
  _inherits(SkillResult, _SkillResultRecord);

  function SkillResult() {
    _classCallCheck(this, SkillResult);

    return _possibleConstructorReturn(this, (SkillResult.__proto__ || Object.getPrototypeOf(SkillResult)).apply(this, arguments));
  }

  return SkillResult;
}(SkillResultRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'skillId':
      return [key, '' + val];
    case 'subSkillResults':
      return [key, new _immutable.List(val.map(_SubSkillResults2.default.create))];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

SkillResult.create = function (data) {
  return new SkillResult(data).mapEntries(reviver);
};

exports.default = SkillResult;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1381);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubSkillResultRecord = (0, _immutable.Record)({
  subSkillId: undefined,
  currentResultAbilityId: undefined,
  previousResultAbilityId: undefined
});

var SubSkillResult = function (_SubSkillResultRecord) {
  _inherits(SubSkillResult, _SubSkillResultRecord);

  function SubSkillResult() {
    _classCallCheck(this, SubSkillResult);

    return _possibleConstructorReturn(this, (SubSkillResult.__proto__ || Object.getPrototypeOf(SubSkillResult)).apply(this, arguments));
  }

  return SubSkillResult;
}(SubSkillResultRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'subSkillId':
    case 'currentResultAbilityId':
    case 'previousResultAbilityId':
      return [key, '' + val];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

SubSkillResult.create = function (data) {
  return new SubSkillResult(data).mapEntries(reviver);
};

exports.default = SubSkillResult;

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1383);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TotalScoreRecord = (0, _immutable.Record)({
  isEmpty: undefined,
  isNotApplicable: undefined,
  percentage: undefined,
  skillScorePercentages: new Map()
});

var TotalScore = function (_TotalScoreRecord) {
  _inherits(TotalScore, _TotalScoreRecord);

  function TotalScore() {
    _classCallCheck(this, TotalScore);

    return _possibleConstructorReturn(this, (TotalScore.__proto__ || Object.getPrototypeOf(TotalScore)).apply(this, arguments));
  }

  return TotalScore;
}(TotalScoreRecord);

TotalScore.create = function (data) {
  return new TotalScore(data);
};

exports.default = TotalScore;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProgressTestTab = getProgressTestTab;
exports.getPTNameWithGroup = getPTNameWithGroup;
exports.getPTName = getPTName;

var _Group = __webpack_require__(13);

function getProgressTestTab(state, groupId) {
  if (_Group.actions.isSSV3Group(state, groupId)) {
    return 'Progress';
  }

  return _Group.actions.isCNGroup(state, groupId) ? 'Unit Review' : 'Unit Quiz';
}

function getPTNameWithGroup(state, name, groupId) {
  var isSSV3Group = _Group.actions.isSSV3Group(state, groupId);

  return getPTName(name, isSSV3Group);
}

function getPTName(name, isSSV3Group) {
  var ssv3PtUnits = ['4', '7', '10'];
  var ptNumber = name.replace('Unit Quiz', '').trim();
  if (isSSV3Group) {
    if (ssv3PtUnits.some(function (u) {
      return name.endsWith(u);
    })) {
      return 'Progress Test ' + (ssv3PtUnits.indexOf(ptNumber) + 1);
    }
    return 'Unit ' + ptNumber + ' Progress';
  }

  return 'Unit Review ' + ptNumber;
}

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uiState;

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _actions = __webpack_require__(629);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function uiState() {
  var _ref;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map((_ref = {}, _defineProperty(_ref, _actions.SHOW_NAVIGATION_BAR, getShowNavigationBarFromLocalStorage()), _defineProperty(_ref, _actions.VIEW_MODE, undefined), _defineProperty(_ref, _actions.CIC_DISPLAY_LANGUAGE, null), _ref));
  var action = arguments[1];

  switch (action.type) {
    case _actions.TOGGLE_NAVIGATION:
      saveShowNavigationBarToLocalStorage(!state.get(_actions.SHOW_NAVIGATION_BAR));
      return state.set(_actions.SHOW_NAVIGATION_BAR, !state.get(_actions.SHOW_NAVIGATION_BAR));
    case _actions.TOGGLE_VIEW_MODE:
      return state.set(_actions.VIEW_MODE, action.viewMode);
    case _actions.SET_CIC_DISPLAY_LANGUAGE:
      return state.set(_actions.CIC_DISPLAY_LANGUAGE, action.languageCode);
    default:
      return state;
  }
}

function getShowNavigationBarFromLocalStorage() {
  return !_is_js2.default.existy(localStorage.getItem(_actions.SHOW_NAVIGATION_BAR)) ? true : JSON.parse(localStorage.getItem(_actions.SHOW_NAVIGATION_BAR));
}

function saveShowNavigationBarToLocalStorage(showNavigationBar) {
  localStorage.setItem(_actions.SHOW_NAVIGATION_BAR, showNavigationBar);
}

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(620);

var _component2 = _interopRequireDefault(_component);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _accessors = __webpack_require__(36);

var _SessionNav = __webpack_require__(132);

var _SessionNav2 = _interopRequireDefault(_SessionNav);

var _actions = __webpack_require__(158);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    appBars: function appBars(_ref2) {
      var params = _ref2.params;
      return {
        sticky: {
          'session-nav': {
            component: _SessionNav2.default,
            props: {
              shouldShowTime: (0, _actions.isGrammarProGroup)(getState(), params.groupId)
            },
            order: 1
          }
        }
      };
    },
    path: 'day(/:mode)',
    view: 'day',
    component: _component2.default,
    sessionNavConfig: {
      setModeOnNavigate: ''
    },
    canAccess: function canAccess(props) {
      var state = getState();
      if (!_omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.MarkAttendance.ViewDayView)) {
        return false;
      }

      if (!_component2.default.isInMarkingRoute(props)) {
        return true;
      }

      return _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.MarkAttendance.MarkDayView);
    },
    actionButtons: {
      default: {
        Mark: {
          isPrimary: true,
          route: './edit',
          visibleWhen: function visibleWhen(_ref3) {
            var params = _ref3.params;
            return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.MarkAttendance.MarkDayView) && (0, _accessors.isMarkable)(getState(), params.groupId, params.sessionPlanId);
          }
        }

      },
      edit: {
        Publish: {
          isPrimary: true,
          route: '../save'
        },
        Discard: {
          route: '../discard'
        }
      }
    },
    history: function history(props) {
      var params = props.params,
          buildRoute = props.buildRoute;

      var attendanceHistoryPath = '/group/:groupId/attendance/history';
      var link = buildRoute(attendanceHistoryPath, params);
      return { link: link };
    }
  };
};

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseSessionNav2 = __webpack_require__(108);

var _BaseSessionNav3 = _interopRequireDefault(_BaseSessionNav2);

var _QuickSummary = __webpack_require__(162);

var _QuickSummary2 = _interopRequireDefault(_QuickSummary);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DATE_FORMAT = 'YYYY-MM-DD';
var TIME_FORMAT = 'HH:mm';

var ClassroomSessionNav = function (_BaseSessionNav) {
  _inherits(ClassroomSessionNav, _BaseSessionNav);

  function ClassroomSessionNav() {
    _classCallCheck(this, ClassroomSessionNav);

    return _possibleConstructorReturn(this, (ClassroomSessionNav.__proto__ || Object.getPrototypeOf(ClassroomSessionNav)).apply(this, arguments));
  }

  _createClass(ClassroomSessionNav, [{
    key: '_hasNext',
    value: function _hasNext() {
      return this.props.currentSessionNumber !== this.props.sessionCount;
    }
  }, {
    key: '_hasPrevious',
    value: function _hasPrevious() {
      return this.props.currentSessionNumber > 1;
    }
  }, {
    key: '_hasNextUnit',
    value: function _hasNextUnit() {
      return _is_js2.default.existy(this.props.nextUnitText);
    }
  }, {
    key: '_hasPreviousUnit',
    value: function _hasPreviousUnit() {
      return _is_js2.default.existy(this.props.previousUnitText);
    }
  }, {
    key: '_getTimeFormat',
    value: function _getTimeFormat(moment) {
      return moment.format(TIME_FORMAT);
    }
  }, {
    key: '_getHeadingText',
    value: function _getHeadingText() {
      var _props = this.props,
          currentSessionStartDate = _props.currentSessionStartDate,
          currentSessionEndDate = _props.currentSessionEndDate,
          shouldShowTime = _props.shouldShowTime;

      var date = currentSessionStartDate.format(DATE_FORMAT);
      var time = this._getTimeFormat(currentSessionStartDate) + '-' + this._getTimeFormat(currentSessionEndDate);
      var dateTime = _is_js2.default.boolean(shouldShowTime) && shouldShowTime ? date + ' ' + time : date;
      return _react2.default.createElement(
        'time',
        { dateTime: dateTime },
        dateTime
      );
    }
  }, {
    key: '_getNextUnitText',
    value: function _getNextUnitText() {
      return this.props.nextUnitText;
    }
  }, {
    key: '_getPreviousUnitText',
    value: function _getPreviousUnitText() {
      return this.props.previousUnitText;
    }
  }, {
    key: '_getCurrentUnitInfo',
    value: function _getCurrentUnitInfo() {
      if (this.props.currentUnit) {
        return ', ' + this.props.currentUnit.name;
      }
    }
  }, {
    key: '_getAdditionalChildren',
    value: function _getAdditionalChildren() {
      return _react2.default.createElement(
        'h2',
        null,
        _react2.default.createElement(_QuickSummary2.default, { type: _QuickSummary2.default.Type.attendance,
          currentUnit: this.props.currentUnit,
          entityId: this.props.currentSessionId,
          sessionCount: this.props.sessionCount })
      );
    }
  }]);

  return ClassroomSessionNav;
}(_BaseSessionNav3.default);

ClassroomSessionNav.propTypes = Object.assign({
  currentSessionStartDate: _propTypes2.default.object.isRequired,
  currentSessionEndDate: _propTypes2.default.object.isRequired,
  currentUnit: _propTypes2.default.object.isRequired,
  currentSessionId: _propTypes2.default.string,
  currentGroupName: _propTypes2.default.string,
  nextUnitText: _propTypes2.default.string,
  previousUnitText: _propTypes2.default.string,
  shouldShowTime: _propTypes2.default.bool
}, _BaseSessionNav3.default.propTypes);

exports.default = (0, _omniCommonUi.connect)(null, null)(ClassroomSessionNav);

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1frkquIj1WUbom9mF_le1U{padding:1.42857rem;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}@media only screen and (min-width:640px){._1frkquIj1WUbom9mF_le1U{padding:1.42857rem 2.14286rem}}.KMicxlxFpatUSxlfSgEN2{cursor:not-allowed}._77eQ1AnPWSSAhEPkNulgZ{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;-webkit-flex-basis:33.3%;-ms-flex-preferred-size:33.3%;flex-basis:33.3%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:auto;overflow:hidden;padding-left:0;padding-right:0}@media only screen and (min-width:640px){._77eQ1AnPWSSAhEPkNulgZ{max-width:21.42857rem}}._2hVPab6qVnUzTfFyhriGKW{display:none}@media only screen and (min-width:640px){._2hVPab6qVnUzTfFyhriGKW{content:\"\";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;-webkit-flex-basis:33.3%;-ms-flex-preferred-size:33.3%;flex-basis:33.3%}}.KotzWNLMBX9owXKpkvteq{display:none}@media only screen and (min-width:640px){.KotzWNLMBX9owXKpkvteq{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;-webkit-flex-basis:33.3%;-ms-flex-preferred-size:33.3%;flex-basis:33.3%;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:0 .71429rem;pointer-events:none}._3H16egmbiWABPL-2g_Vks-{height:100%;min-width:5rem;width:5rem}._2HC0WMOAcxECQurquJr9ks{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;width:1.42857rem}._3H16egmbiWABPL-2g_Vks-+._3H16egmbiWABPL-2g_Vks-{margin-left:0!important}.KotzWNLMBX9owXKpkvteq button._3H16egmbiWABPL-2g_Vks-{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;pointer-events:auto}.KotzWNLMBX9owXKpkvteq button._3H16egmbiWABPL-2g_Vks-._3fTnxecXPKGfHQinTy_O99{-webkit-border-bottom-right-radius:0;-moz-border-radius-bottomright:0;border-bottom-right-radius:0;border-right-width:0;-webkit-border-top-right-radius:0;-moz-border-radius-topright:0;border-top-right-radius:0}.KotzWNLMBX9owXKpkvteq button._3H16egmbiWABPL-2g_Vks-._3fTnxecXPKGfHQinTy_O99[disabled]{-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.KotzWNLMBX9owXKpkvteq button._3H16egmbiWABPL-2g_Vks-._3fTnxecXPKGfHQinTy_O99.mgv4XS-Oe5trhin6IQDlH{border-right-width:.07143rem}.KotzWNLMBX9owXKpkvteq button._3H16egmbiWABPL-2g_Vks-._1a8CyhHWBm4pIEy1qBp2xR{-webkit-border-bottom-left-radius:0;-moz-border-radius-bottomleft:0;border-bottom-left-radius:0;-webkit-border-top-left-radius:0;-moz-border-radius-topleft:0;border-top-left-radius:0}.KotzWNLMBX9owXKpkvteq button._3H16egmbiWABPL-2g_Vks-._1a8CyhHWBm4pIEy1qBp2xR[disabled]{border-left-width:0;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}}._3VWoZIjhUyRo3vvW4K0Q9b{background-color:#f3f5f7;border-bottom:.07143rem solid #ccc;overflow:hidden;width:100%}._3VWoZIjhUyRo3vvW4K0Q9b.session-nav-enter{height:0}._3VWoZIjhUyRo3vvW4K0Q9b.session-nav-enter ._1frkquIj1WUbom9mF_le1U{margin-top:-6.42857rem}._3VWoZIjhUyRo3vvW4K0Q9b.session-nav-enter.session-nav-enter-active{height:6.42857rem;-webkit-transition:height .3s ease-in;-o-transition:height .3s ease-in;-moz-transition:height .3s ease-in;transition:height .3s ease-in}._3VWoZIjhUyRo3vvW4K0Q9b.session-nav-enter.session-nav-enter-active ._1frkquIj1WUbom9mF_le1U{margin-top:0;-webkit-transition:margin .3s ease-in;-o-transition:margin .3s ease-in;-moz-transition:margin .3s ease-in;transition:margin .3s ease-in}._3VWoZIjhUyRo3vvW4K0Q9b.session-nav-leave{height:6.42857rem}._3VWoZIjhUyRo3vvW4K0Q9b.session-nav-leave ._1frkquIj1WUbom9mF_le1U{margin-top:0}._3VWoZIjhUyRo3vvW4K0Q9b.session-nav-leave.session-nav-leave-active{height:0;-webkit-transition:height .3s ease-in;-o-transition:height .3s ease-in;-moz-transition:height .3s ease-in;transition:height .3s ease-in}._3VWoZIjhUyRo3vvW4K0Q9b.session-nav-leave.session-nav-leave-active ._1frkquIj1WUbom9mF_le1U{margin-top:-6.42857rem;-webkit-transition:margin .3s ease-in;-o-transition:margin .3s ease-in;-moz-transition:margin .3s ease-in;transition:margin .3s ease-in}.qSD2dvwaoYSFovjl0R9rl{margin-left:2.14286rem}._2c687mCHeGEd9TpQROgb0M,.Kzte0EjcCTLl4blnz3wlK{cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-size:1.42857rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._2c687mCHeGEd9TpQROgb0M._3bTpc8J7O9_mqXqtXP2hBB,.Kzte0EjcCTLl4blnz3wlK._3bTpc8J7O9_mqXqtXP2hBB{color:#a4a4a4;pointer-events:none}._2c687mCHeGEd9TpQROgb0M{margin-right:.71429rem}.Kzte0EjcCTLl4blnz3wlK{margin-left:.71429rem}._1-bs1UyDOLT66pepB2wlny{-webkit-box-flex:1;-webkit-flex:1 0 0%;-moz-box-flex:1;-ms-flex:1 0 0%;flex:1 0 0%;overflow:hidden;text-align:center;white-space:nowrap}._1N70vJGZL_FiVkN4d0hGVt{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;letter-spacing:.07143rem;line-height:1.42857rem;margin-bottom:.35714rem;margin-top:.35714rem;overflow:hidden}._1N70vJGZL_FiVkN4d0hGVt h2,._1N70vJGZL_FiVkN4d0hGVt h3,._1N70vJGZL_FiVkN4d0hGVt h4,.swo2-8CpkeM1Zw0NgWRVr{max-width:100%;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis}.swo2-8CpkeM1Zw0NgWRVr{font-family:Helvetica Neue Condensed,Helvetica Neue,Tahoma,sans-serif;font-size:1rem;font-stretch:condensed;font-weight:700;margin-bottom:0;margin-top:0;text-transform:uppercase}._1N70vJGZL_FiVkN4d0hGVt h2,._1N70vJGZL_FiVkN4d0hGVt h3,._1N70vJGZL_FiVkN4d0hGVt h4{font-size:inherit;font-weight:400;margin:0}.-zgNStPD9Gl1rfGbi1ckT:before{content:\" \"}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"BaseSessionNav": "_1frkquIj1WUbom9mF_le1U",
	"BaseSessionNav_disabled": "KMicxlxFpatUSxlfSgEN2",
	"BaseSessionNav_navigator": "_77eQ1AnPWSSAhEPkNulgZ",
	"BaseSessionNav_current": "_2hVPab6qVnUzTfFyhriGKW",
	"BaseSessionNav_units": "KotzWNLMBX9owXKpkvteq",
	"BaseSessionNav_units_btn": "_3H16egmbiWABPL-2g_Vks-",
	"BaseSessionNav_units_btn_text": "_2HC0WMOAcxECQurquJr9ks",
	"__previous": "_3fTnxecXPKGfHQinTy_O99",
	"__isLast": "mgv4XS-Oe5trhin6IQDlH",
	"__next": "_1a8CyhHWBm4pIEy1qBp2xR",
	"BaseSessionNav_navWrapper": "_3VWoZIjhUyRo3vvW4K0Q9b",
	"BaseSessionNav_emptyBtn": "qSD2dvwaoYSFovjl0R9rl",
	"BaseSessionNav_previous": "_2c687mCHeGEd9TpQROgb0M",
	"BaseSessionNav_next": "Kzte0EjcCTLl4blnz3wlK",
	"__disabled": "_3bTpc8J7O9_mqXqtXP2hBB",
	"BaseSessionNav_content": "_1-bs1UyDOLT66pepB2wlny",
	"BaseSessionNav_content_line": "_1N70vJGZL_FiVkN4d0hGVt",
	"BaseSessionNav_content_line_heading": "swo2-8CpkeM1Zw0NgWRVr",
	"BaseSessionNav_content_line_session": "-zgNStPD9Gl1rfGbi1ckT",
	"__populated": "_3uj9FvJEtkiK2AAZoSCfwE"
};

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(631);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1406);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1391);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1u7NJSARgUb4HaqNNGlx09{padding:1.42857rem}@media only screen and (min-width:640px){._1u7NJSARgUb4HaqNNGlx09{padding:2.14286rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MarkAttendanceCourseView": "_1u7NJSARgUb4HaqNNGlx09"
};

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1393);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _status = __webpack_require__(83);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DASH = '-';

var AttendanceCell = function (_PureComponent) {
  _inherits(AttendanceCell, _PureComponent);

  function AttendanceCell() {
    _classCallCheck(this, AttendanceCell);

    return _possibleConstructorReturn(this, (AttendanceCell.__proto__ || Object.getPrototypeOf(AttendanceCell)).apply(this, arguments));
  }

  _createClass(AttendanceCell, [{
    key: '_getDisplayConfig',
    value: function _getDisplayConfig() {
      var attendanceStatus = this.props.attendanceStatus;

      var presentClassName = (0, _classnames2.default)(_style2.default.__present, (0, _omniCommonUi.testClass)('present'));
      var absentClassName = (0, _classnames2.default)(_style2.default.__absent, (0, _omniCommonUi.testClass)('absent'));
      var lateClassName = (0, _classnames2.default)(_style2.default.__late, (0, _omniCommonUi.testClass)('late'));
      switch (attendanceStatus) {
        case _status.AttendanceStatus.present:
          return { img: 'success', text: (0, _status.getDisplayName)(_status.AttendanceStatus.present), class: presentClassName };
        case _status.AttendanceStatus.absent:
          return { img: 'cross-circle', text: (0, _status.getDisplayName)(_status.AttendanceStatus.absent), class: absentClassName };
        case _status.AttendanceStatus.late:
          return { img: 'clock', text: (0, _status.getDisplayName)(_status.AttendanceStatus.late), class: lateClassName };
        case _status.AttendanceStatus.unmarked:
          return { img: 'circle', text: (0, _status.getDisplayName)(_status.AttendanceStatus.unmarked) };
        case _status.AttendanceStatus.notapplicable:
          return { text: (0, _status.getDisplayName)(_status.AttendanceStatus.notapplicable) };
        default:
          throw new Error('Invalid attendance status: ' + attendanceStatus);
      }
    }
  }, {
    key: '_renderStatusTooltip',
    value: function _renderStatusTooltip() {
      var _props = this.props,
          isFutureSession = _props.isFutureSession,
          attendanceStatus = _props.attendanceStatus;

      if (isFutureSession === true) {
        return DASH;
      }

      if (_is_js2.default.not.string(attendanceStatus)) {
        return DASH; // In case the API returns something strange.
      }

      var displayConf = this._getDisplayConfig();
      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        { text: displayConf.text },
        this._renderStatusView(displayConf)
      );
    }
  }, {
    key: '_renderStatusView',
    value: function _renderStatusView(displayConf) {
      var attendanceStatus = this.props.attendanceStatus;

      if (attendanceStatus === _status.AttendanceStatus.notapplicable) {
        return 'n/a';
      }

      return _react2.default.createElement(_omniCommonUi.Icon, { id: displayConf.img,
        className: (0, _classnames2.default)(_style2.default.AttendanceCell_img, displayConf.class) });
    }
  }, {
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)(_style2.default.AttendanceCell, (0, _omniCommonUi.testClass)('attendance-cell'));
      return _react2.default.createElement(
        'div',
        { className: className },
        this._renderStatusTooltip()
      );
    }
  }]);

  return AttendanceCell;
}(_react.PureComponent);

AttendanceCell.propTypes = {
  isFutureSession: _propTypes2.default.bool,
  attendanceStatus: _propTypes2.default.oneOf(Object.keys(_status.AttendanceStatus))
};

exports.default = AttendanceCell;

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1394);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._21LMsO4-d7TPkYjzmWHj43{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:1.42857rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;width:1.42857rem}.rpQg_ruDr5YTG54z4s5Y3{display:block;font-size:1.42857rem}.rpQg_ruDr5YTG54z4s5Y3._3jKU4p4hAXM87sSsOphcOK{color:#74d17f}.rpQg_ruDr5YTG54z4s5Y3._2LZmNyvHOglXsevVssGwBL{color:#f7932d}.rpQg_ruDr5YTG54z4s5Y3._2o5-6YRbRXTGdOhvIAAP3l{color:#de4c4c}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"AttendanceCell": "_21LMsO4-d7TPkYjzmWHj43",
	"AttendanceCell_img": "rpQg_ruDr5YTG54z4s5Y3",
	"__present": "_3jKU4p4hAXM87sSsOphcOK",
	"__late": "_2LZmNyvHOglXsevVssGwBL",
	"__absent": "_2o5-6YRbRXTGdOhvIAAP3l"
};

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1396);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _TableWithExpandablePanel = __webpack_require__(201);

var _TableWithExpandablePanel2 = _interopRequireDefault(_TableWithExpandablePanel);

var _ProductionStatus = __webpack_require__(73);

var _omniCommonUi = __webpack_require__(0);

var _classnames3 = __webpack_require__(7);

var _classnames4 = _interopRequireDefault(_classnames3);

var _Body = __webpack_require__(637);

var _Body2 = _interopRequireDefault(_Body);

var _OptionsCell = __webpack_require__(1403);

var _OptionsCell2 = _interopRequireDefault(_OptionsCell);

var _immutable = __webpack_require__(3);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NOT_APPLICABLE = '-';

var CourseViewTable = function (_Component) {
  _inherits(CourseViewTable, _Component);

  function CourseViewTable(props) {
    _classCallCheck(this, CourseViewTable);

    var _this = _possibleConstructorReturn(this, (CourseViewTable.__proto__ || Object.getPrototypeOf(CourseViewTable)).call(this, props));

    _this.state = { expanded: (0, _omniCommonUi.mediaQuery)('(min-width: 1024px)').matches };
    _this._setUpData(props);
    return _this;
  }

  _createClass(CourseViewTable, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(props) {
      this._setUpData(props);
    }
  }, {
    key: '_onAddNoteClicked',
    value: function _onAddNoteClicked(student, e) {
      this.props.onAddNoteClicked(student);
      e.preventDefault();
      e.stopPropagation();
    }
  }, {
    key: '_setUpData',
    value: function _setUpData(props) {
      var header = _react2.default.Children.toArray(props.children).find(function (child) {
        return child.type === _TableWithExpandablePanel2.default.Header;
      });
      var lastHeaderRow = new _immutable.List(_react2.default.Children.toArray(header.props.children)).last();
      this._isPanelHeaderSmall = new _immutable.List(_react2.default.Children.toArray(lastHeaderRow.props.children)).every(function (cell) {
        return cell.props.small;
      });
    }
  }, {
    key: '_onExpandedChange',
    value: function _onExpandedChange(expanded) {
      this.setState({ expanded: expanded });
    }
  }, {
    key: '_getStudentAcademicLink',
    value: function _getStudentAcademicLink(studentId) {
      return this.props.buildRoute('/student/' + studentId);
    }
  }, {
    key: '_renderUnassignedReader',
    value: function _renderUnassignedReader(student) {
      var extraInfo = this.props.extraInfo;

      var readingItemClassName = (0, _classnames4.default)(_style2.default.studentNameWithStatusAndReading_reading_item, _defineProperty({}, _style2.default.__collapsed, !this.state.expanded));
      var descriptionClassName = (0, _classnames4.default)(readingItemClassName, _style2.default.studentNameWithStatusAndReading_reading_description);
      var unassignedReader = extraInfo && extraInfo.find(function (item) {
        return item.studentId === student.studentGeneralInfo.id;
      });

      var currentLevel = unassignedReader ? unassignedReader.currentLevel : NOT_APPLICABLE;
      var completedInCurrentLevel = unassignedReader ? unassignedReader.completedInCurrentLevel : NOT_APPLICABLE;
      var totalInCurrentLevel = unassignedReader ? unassignedReader.totalInCurrentLevel : NOT_APPLICABLE;
      var totalReader = unassignedReader ? unassignedReader.completedInTotal : NOT_APPLICABLE;
      var tooltip = unassignedReader ? 'Unassigned reading tells you the student’s current level,' + ' the number of books they have read out of the total number in that level' + ' and the total number of books read from the unassigned reading library.' + ('  This student is in level ' + currentLevel + ', having read ' + completedInCurrentLevel + ' book') + (' out of the ' + totalInCurrentLevel + ' books in level ' + currentLevel + ',') + (' and ' + totalReader + ' books total from the Reading Library.') : 'Unassigned reading tells you the student’s current level,' + ' the number of books they have read out of the total number in that level' + ' and the total number of books read from the unassigned reading library.' + '  This student has not gone to the Reading Library yet so does not have' + ' a level and has not read any books yet.';

      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        { text: tooltip,
          placement: 'right',
          overlayClassName: _style2.default.studentNameWithStatusAndReading_reading_tooltip },
        _react2.default.createElement(
          'div',
          { className: _style2.default.studentNameWithStatusAndReading_reading },
          _react2.default.createElement(
            'div',
            { className: descriptionClassName },
            'UNASSIGNED'
          ),
          _react2.default.createElement(
            'div',
            { className: readingItemClassName },
            'Current level: ' + currentLevel
          ),
          _react2.default.createElement(
            'div',
            { className: readingItemClassName },
            'Completed in current level: ' + completedInCurrentLevel + '/' + totalInCurrentLevel
          ),
          _react2.default.createElement(
            'div',
            { className: readingItemClassName },
            'Total read: ' + totalReader
          )
        )
      );
    }
  }, {
    key: '_renderStudentNameWithStatusAndReader',
    value: function _renderStudentNameWithStatusAndReader(student) {
      var colSpan = this.state.expanded ? 2 : 1;
      var isInProduction = student.isInProduction;

      var status = Object.assign({ isInProduction: isInProduction }, (0, _ProductionStatus.parseProductionStatus)(student.status));
      return _react2.default.createElement(
        _TableWithExpandablePanel2.default.Cell,
        { colSpan: colSpan },
        _react2.default.createElement(
          'div',
          { className: _style2.default.studentNameWithStatusAndReading },
          _react2.default.createElement(
            'div',
            { className: _style2.default.studentNameWithStatusAndReading_nameAndStatus },
            this._renderStudentNameContent(student),
            this.state.expanded && _react2.default.createElement(_omniCommonUi.ProductionStatus, { status: status.fullName,
              initial: undefined,
              highlighted: status.isInProduction }),
            !this.state.expanded && _react2.default.createElement(
              'div',
              { className: _style2.default.studentNameWithStatusAndReading_status },
              _react2.default.createElement(_omniCommonUi.ProductionStatus, { status: status.fullName,
                initial: status.initial,
                highlighted: status.isInProduction })
            )
          ),
          this._renderUnassignedReader(student)
        )
      );
    }
  }, {
    key: '_renderStudentNameWithStatus',
    value: function _renderStudentNameWithStatus(student) {
      return _react2.default.createElement(
        'div',
        { className: _style2.default.StudentCellWithStatus },
        this._renderStudentNameContent(student),
        this._renderProductionStatus(student)
      );
    }
  }, {
    key: '_renderStudentName',
    value: function _renderStudentName(student) {
      if (this.props.showSkill) {
        var rowSpan = 0;
        var studentSkills = this.props.students.filter(function (s) {
          return s.studentGeneralInfo.id === student.studentGeneralInfo.id;
        }).map(function (s) {
          return s.skill;
        });

        if (studentSkills.indexOf(student.skill) === 0) {
          rowSpan = studentSkills.length;
        } else {
          return null;
        }

        return _react2.default.createElement(
          _TableWithExpandablePanel2.default.Cell,
          { rowSpan: rowSpan },
          this._renderStudentNameContent(student)
        );
      }

      return this._renderStudentNameContent(student);
    }
  }, {
    key: '_renderStudentNameContent',
    value: function _renderStudentNameContent(student) {
      var _this2 = this;

      var classes = (0, _classnames4.default)(_style2.default.StudentCell, (0, _omniCommonUi.testClass)('student-cell'), _defineProperty({}, _style2.default.__collapsed, !this.state.expanded));
      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
          'div',
          { className: _style2.default.StudentCell_inner },
          _react2.default.createElement(
            'div',
            { className: _style2.default.StudentCell_nameWrapper },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: this._getStudentAcademicLink(student.studentGeneralInfo.id) },
              student.studentGeneralInfo.firstName + ' ' + student.studentGeneralInfo.lastName
            ),
            _react2.default.createElement(
              'div',
              null,
              student.studentGeneralInfo.localName
            )
          ),
          this.props.onAddNoteClicked && _react2.default.createElement(
            'div',
            { className: _style2.default.StudentCell_icon,
              onClick: function onClick(e) {
                return _this2._onAddNoteClicked(student, e);
              } },
            _react2.default.createElement(_omniCommonUi.Icon, { id: 'new-message' })
          ),
          this.props.renderAddNoteDialog && this.props.renderAddNoteDialog(student)
        )
      );
    }
  }, {
    key: '_renderAch',
    value: function _renderAch(student) {
      return _react2.default.createElement(
        'div',
        null,
        student.ach.produced > 0 && parseInt(student.ach.present * 100 / student.ach.produced, 10) + '%',
        _react2.default.createElement('br', null),
        '(' + student.ach.present + '/' + student.ach.produced + ')'
      );
    }
  }, {
    key: '_renderProductionStatus',
    value: function _renderProductionStatus(student) {
      var isInProduction = student.isInProduction;

      var status = Object.assign({ isInProduction: isInProduction }, (0, _ProductionStatus.parseProductionStatus)(student.status));
      return _react2.default.createElement(_omniCommonUi.ProductionStatus, { status: status.fullName,
        initial: this.state.expanded ? undefined : status.initial,
        highlighted: status.isInProduction });
    }
  }, {
    key: '_renderSkills',
    value: function _renderSkills(student) {
      return _react2.default.createElement(
        'div',
        null,
        student.skill
      );
    }
  }, {
    key: '_shouldRenderAch',
    value: function _shouldRenderAch() {
      return this.props.showAch && this.state.expanded;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          students = _props.students,
          children = _props.children,
          highlightedColumns = _props.highlightedColumns,
          stripeRows = _props.stripeRows,
          extraInfo = _props.extraInfo;


      var bodyComponent = children.find(function (child) {
        return child.type === _Body2.default;
      });
      var _bodyComponent$props = bodyComponent.props,
          buildCell = _bodyComponent$props.children,
          cellOptions = _bodyComponent$props.cellOptions,
          firstOptionHeader = _bodyComponent$props.firstOptionHeader,
          secondOptionHeader = _bodyComponent$props.secondOptionHeader;

      var header = children.find(function (child) {
        return child.type === _TableWithExpandablePanel2.default.Header;
      });
      var showExtraInfo = _is_js2.default.not.undefined(extraInfo) && _is_js2.default.existy(extraInfo);

      return _react2.default.createElement(
        _TableWithExpandablePanel2.default,
        { rows: students,
          highlightedColumns: highlightedColumns,
          stripeRows: stripeRows,
          isFullHeightToPanel: showExtraInfo,
          onExpandedChange: function onExpandedChange(expanded) {
            return _this3._onExpandedChange(expanded);
          },
          onlyRowDivider: this.props.onlyRowDivider },
        header,
        _react2.default.createElement(
          _TableWithExpandablePanel2.default.Body,
          null,
          function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _react2.default.createElement(_OptionsCell2.default, { args: args,
              cellOptions: cellOptions,
              buildCell: buildCell,
              firstOptionHeader: firstOptionHeader,
              secondOptionHeader: secondOptionHeader });
          }
        ),
        _react2.default.createElement(
          _TableWithExpandablePanel2.default.Panel,
          null,
          _react2.default.createElement(
            _TableWithExpandablePanel2.default.Header,
            null,
            _react2.default.createElement(
              _TableWithExpandablePanel2.default.Row,
              null,
              _react2.default.createElement(
                _TableWithExpandablePanel2.default.Cell,
                { columnId: 'student-name', small: this._isPanelHeaderSmall },
                'Student Name'
              ),
              this._shouldRenderAch() && _react2.default.createElement(
                _TableWithExpandablePanel2.default.Cell,
                { columnId: 'ach', small: this._isPanelHeaderSmall },
                '% Present',
                _react2.default.createElement('br', null),
                '(ACH)'
              ),
              this.state.expanded && !this.props.showSkill && _react2.default.createElement(
                _TableWithExpandablePanel2.default.Cell,
                { columnId: 'production-status',
                  small: this._isPanelHeaderSmall },
                'Status'
              ),
              this.state.expanded && this.props.showSkill && _react2.default.createElement(
                _TableWithExpandablePanel2.default.Cell,
                { columnId: 'skill',
                  small: this._isPanelHeaderSmall },
                'Skill'
              )
            )
          ),
          _react2.default.createElement(
            _TableWithExpandablePanel2.default.Body,
            null,
            function (student, columnId) {
              switch (columnId) {
                case 'student-name':
                  if (showExtraInfo) {
                    return _this3._renderStudentNameWithStatusAndReader(student);
                  }

                  return _this3.props.showSkill || _this3.state.expanded ? _this3._renderStudentName(student) : _this3._renderStudentNameWithStatus(student);
                case 'ach':
                  return _this3._renderAch(student);
                case 'production-status':
                  if (showExtraInfo) {
                    return null;
                  }

                  return _this3._renderProductionStatus(student);
                case 'skill':
                  return _this3._renderSkills(student);
                default:
                  throw new Error('Invalid column ' + columnId);
              }
            }
          )
        )
      );
    }
  }]);

  return CourseViewTable;
}(_react.Component);

CourseViewTable.propTypes = {
  students: _propTypes2.default.arrayOf(_propTypes2.default.any),
  children: _propTypes2.default.node,
  stripeRows: _propTypes2.default.arrayOf(_propTypes2.default.number),
  highlightedColumns: _propTypes2.default.arrayOf(_propTypes2.default.number),
  showAch: _propTypes2.default.bool,
  showSkill: _propTypes2.default.bool,
  onlyRowDivider: _propTypes2.default.bool,
  buildRoute: _propTypes2.default.func,
  onSaveNote: _propTypes2.default.func,
  onAddNoteClicked: _propTypes2.default.func,
  renderAddNoteDialog: _propTypes2.default.func,
  extraInfo: _propTypes2.default.object // Show in first two columns. (e.g. unassigned reader info)
};

exports.default = (0, _omniCommonUi.connect)()(CourseViewTable);

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1397);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2GHLIlRRjRQaD41iwXcJRf{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;position:relative}._321aqO905a3-mfvMW7UW-A{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;left:0;position:absolute;top:0;white-space:nowrap;width:100%}._1tTcBWSbPd8a86V-CIJVkn{-webkit-box-flex:1;-webkit-flex:1 1 auto;-moz-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;margin-right:1.42857rem;overflow:hidden;text-align:left}._1tTcBWSbPd8a86V-CIJVkn *{overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis}._1tTcBWSbPd8a86V-CIJVkn :last-child{color:#a4a4a4}._2Jokw49BydTP1Z-WgIPvDj{cursor:pointer;font-size:1.42857rem}._2Jokw49BydTP1Z-WgIPvDj:hover{color:#0087e6}._2GHLIlRRjRQaD41iwXcJRf._7fVNXAEm5thP0N81XVbTN{padding:0 1.42857rem}._2GHLIlRRjRQaD41iwXcJRf._7fVNXAEm5thP0N81XVbTN ._1tTcBWSbPd8a86V-CIJVkn{-webkit-flex-basis:0%;-ms-flex-preferred-size:0%;flex-basis:0%}._2GHLIlRRjRQaD41iwXcJRf._7fVNXAEm5thP0N81XVbTN ._2Jokw49BydTP1Z-WgIPvDj{margin-right:.71429rem}._2GHLIlRRjRQaD41iwXcJRf:not(._7fVNXAEm5thP0N81XVbTN) ._321aqO905a3-mfvMW7UW-A{position:relative}._2GHLIlRRjRQaD41iwXcJRf:not(._7fVNXAEm5thP0N81XVbTN) ._2Jokw49BydTP1Z-WgIPvDj{margin-right:-1.42857rem}._2dCsLk_lc--zbSP8gTKFZF{-webkit-box-align:stretch;-webkit-align-items:stretch;-moz-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._17bmC_tLG8GOgd9o58sM2w{height:12.78571rem;padding:1.42857rem 0}.oAKQta6PcQTtT6KvUl-Zp{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._1GsJF_TBPGU79gswYf8S2-{margin-top:1.78571rem}.mPYMLdwfFSy-6bX1itQgy>*>.rc-tooltip-arrow{display:none}._1GsJF_TBPGU79gswYf8S2-:hover{border:.07143rem solid #ff0}._1NL86bDwZ9kwBP59nKU4Sc{margin:.21429rem 0;white-space:nowrap}._1BewfoVfZSHScZeCBErm-x{font-weight:700}._2cnOqV4LagYKlPyGQw-Opg{-webkit-box-flex:1.5;-webkit-flex:1.5;-moz-box-flex:1.5;-ms-flex:1.5;flex:1.5}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentCell": "_2GHLIlRRjRQaD41iwXcJRf",
	"StudentCell_inner": "_321aqO905a3-mfvMW7UW-A",
	"StudentCell_nameWrapper": "_1tTcBWSbPd8a86V-CIJVkn",
	"StudentCell_icon": "_2Jokw49BydTP1Z-WgIPvDj",
	"__collapsed": "_7fVNXAEm5thP0N81XVbTN",
	"StudentCellWithStatus": "_2dCsLk_lc--zbSP8gTKFZF",
	"studentNameWithStatusAndReading": "_17bmC_tLG8GOgd9o58sM2w",
	"studentNameWithStatusAndReading_nameAndStatus": "oAKQta6PcQTtT6KvUl-Zp",
	"studentNameWithStatusAndReading_reading": "_1GsJF_TBPGU79gswYf8S2-",
	"studentNameWithStatusAndReading_reading_tooltip": "mPYMLdwfFSy-6bX1itQgy",
	"studentNameWithStatusAndReading_reading_item": "_1NL86bDwZ9kwBP59nKU4Sc",
	"studentNameWithStatusAndReading_reading_description": "_1BewfoVfZSHScZeCBErm-x",
	"studentNameWithStatusAndReading_status": "_2cnOqV4LagYKlPyGQw-Opg"
};

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1399);

var _style2 = _interopRequireDefault(_style);

var _style3 = __webpack_require__(163);

var _style4 = _interopRequireDefault(_style3);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _Panel = __webpack_require__(632);

var _Panel2 = _interopRequireDefault(_Panel);

var _omniCommonUi = __webpack_require__(0);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _SimpleTable = __webpack_require__(133);

var _SimpleTable2 = _interopRequireDefault(_SimpleTable);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableWithExpandablePanel = function (_PureComponent) {
  _inherits(TableWithExpandablePanel, _PureComponent);

  function TableWithExpandablePanel(props) {
    _classCallCheck(this, TableWithExpandablePanel);

    var _this = _possibleConstructorReturn(this, (TableWithExpandablePanel.__proto__ || Object.getPrototypeOf(TableWithExpandablePanel)).call(this, props));

    _this._onScrollReady = _this._onScrollReady.bind(_this);
    _this._toggleExpand = _this._toggleExpand.bind(_this);
    _this._onAnimationEnded = _this._onAnimationEnded.bind(_this);
    _this.state = { expanded: (0, _omniCommonUi.mediaQuery)('(min-width: 1024px)').matches };
    _this._setUpData(props);
    return _this;
  }

  _createClass(TableWithExpandablePanel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._animatePanel();
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(props) {
      this._setUpData(props);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._animatePanel();

      var panelTrs = this._panel.querySelectorAll('tbody tr');
      var tableTrs = this._table.querySelectorAll('tbody tr');
      for (var index = 0; index < panelTrs.length; index++) {
        panelTrs[index].style.height = tableTrs[index].offsetHeight + 'px';
      }
    }
  }, {
    key: '_setUpData',
    value: function _setUpData(props) {
      var children = _react2.default.Children.toArray(props.children);
      var panel = children.find(function (child) {
        return child.type === _Panel2.default;
      });
      var panelChildren = panel.props.children;
      this._panelClassName = panel.props.className;
      this._mainTableHeader = children.find(function (child) {
        return child.type === _SimpleTable2.default.Header;
      });
      this._mainTableBody = children.find(function (child) {
        return child.type === _SimpleTable2.default.Body;
      });
      this._panelTableHeader = panelChildren.find(function (child) {
        return child.type === _SimpleTable2.default.Header;
      });
      this._panelTableBody = panelChildren.find(function (child) {
        return child.type === _SimpleTable2.default.Body;
      });
      this._setUpPanelWidth();
    }
  }, {
    key: '_setUpPanelWidth',
    value: function _setUpPanelWidth() {
      if (this._expandedPanelSize) return;
      if (this._panel) {
        var ths = this._panel.querySelectorAll('.test-table-row th');
        var cells = this._panel.querySelectorAll('.test-table-cell');
        // ensure that we calculate the right width
        if (ths && cells && cells.length > ths.length) {
          this._expandedPanelSize = this._panel.querySelector('table').offsetWidth;
        }
      }
    }
  }, {
    key: '_onScrollReady',
    value: function _onScrollReady(scroll) {
      this._scroll = scroll;
      var smallScreenQuery = (0, _omniCommonUi.mediaQuery)('(max-width: 639px)');
      var activeDiv = this._table.querySelector('.' + _style4.default.__highlighted);
      var animLeftOffset = 50;
      var animLeftOffsetLg = 100;
      var animDurationMs = 300;
      if (activeDiv && activeDiv.offsetLeft > 0) {
        if (smallScreenQuery.matches) {
          // mobile?
          // snap to left for mobile
          scroll.scrollToElement(activeDiv, 0, -animLeftOffset);
          scroll.scrollBy(-animLeftOffset, 0, animDurationMs); // flush with "panel"
        } else {
          // centre the element on-screen
          scroll.scrollToElement(activeDiv, 0, true, true); // centre
          scroll.scrollBy(animLeftOffsetLg, 0, 0); // back
          scroll.scrollBy(-animLeftOffsetLg, 0, animDurationMs); // forth
        }
      }
    }
  }, {
    key: '_toggleExpand',
    value: function _toggleExpand() {
      var _this2 = this;

      var afterStateChange = _is_js2.default.function(this.props.onExpandedChange) && function () {
        return _this2.props.onExpandedChange(_this2.state.expanded);
      };
      this.setState(function (state) {
        return { expanded: !state.expanded };
      }, afterStateChange);
    }
  }, {
    key: '_animatePanel',
    value: function _animatePanel() {
      this._panel.addEventListener('transitionend', this._onAnimationEnded, { once: true });
      if (this.state.expanded) {
        this._panel.style.width = this._expandedPanelSize + 'px';
        this._panel.style.flexBasis = this._expandedPanelSize + 'px';
      } else {
        this._panel.style.width = '';
        this._panel.style.flexBasis = '';
      }
    }
  }, {
    key: '_onAnimationEnded',
    value: function _onAnimationEnded() {
      this._scroll && this._scroll.refresh();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var panelClasses = (0, _classnames3.default)(_style2.default.TableWithExpandablePanel_panel, (0, _omniCommonUi.testClass)('panel'), _defineProperty({}, _style2.default.__expanded, this.state.expanded), this._panelClassName);

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _classnames3.default)(_style2.default.TableWithExpandablePanel, (0, _omniCommonUi.testClass)('table-with-expandable-panel')) },
        _react2.default.createElement(
          'div',
          { className: panelClasses, onClick: this._toggleExpand, ref: function ref(c) {
              _this3._panel = c;
            } },
          _react2.default.createElement(
            'div',
            { className: _style2.default.TableWithExpandablePanel_panel_wrap },
            _react2.default.createElement(_omniCommonUi.Icon, { id: 'chevron-small-right',
              className: _style2.default.TableWithExpandablePanel_panel_icon }),
            _react2.default.createElement(
              _SimpleTable2.default,
              { stripeRows: this.props.stripeRows,
                rows: this.props.rows,
                onlyRowDivider: true,
                textAlign: 'left' },
              _react2.default.createElement(
                _SimpleTable2.default.Header,
                null,
                this._panelTableHeader.props.children
              ),
              _react2.default.createElement(
                _SimpleTable2.default.Body,
                null,
                this._panelTableBody.props.children
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames3.default)(_style2.default.TableWithExpandablePanel_tableContainer, (0, _omniCommonUi.testClass)('body')), ref: function ref(c) {
              _this3._table = c;
            } },
          _react2.default.createElement(
            _omniCommonUi.HorizontalScroll,
            { onScrollReady: this._onScrollReady },
            _react2.default.createElement(
              _SimpleTable2.default,
              { highlightedColumns: this.props.highlightedColumns,
                stripeRows: this.props.stripeRows,
                tableRef: function tableRef(c) {
                  _this3._table = c;
                },
                rows: this.props.rows,
                isFullHeightToPanel: this.props.isFullHeightToPanel,
                onlyRowDivider: this.props.onlyRowDivider },
              _react2.default.createElement(
                _SimpleTable2.default.Header,
                null,
                this._mainTableHeader.props.children
              ),
              _react2.default.createElement(
                _SimpleTable2.default.Body,
                null,
                this._mainTableBody.props.children
              )
            )
          )
        )
      );
    }
  }]);

  return TableWithExpandablePanel;
}(_react.PureComponent);

TableWithExpandablePanel.propTypes = {
  rows: _propTypes2.default.arrayOf(_propTypes2.default.any),
  children: _propTypes2.default.node,
  stripeRows: _propTypes2.default.arrayOf(_propTypes2.default.number),
  highlightedColumns: _propTypes2.default.arrayOf(_propTypes2.default.number),
  onExpandedChange: _propTypes2.default.func,
  onlyRowDivider: _propTypes2.default.bool,
  isFullHeightToPanel: _propTypes2.default.bool
};

exports.default = TableWithExpandablePanel;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1400);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".ObHCPUJ_ecA_5YZ-QzrRw{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1n0jOuo4GDn0GduwDHjAXK{border:0;-webkit-box-shadow:0 0 .21429rem .07143rem rgba(0,0,0,.15);-moz-box-shadow:0 0 .21429rem .07143rem rgba(0,0,0,.15);box-shadow:0 0 .21429rem .07143rem rgba(0,0,0,.15);background-color:#fbfbfb;-ms-flex-align:stretch;border-right:.35714rem solid #0087e6;cursor:pointer;-webkit-box-flex:0;-webkit-flex:0 0 12.14286rem;-moz-box-flex:0;-ms-flex:0 0 12.14286rem;flex:0 0 12.14286rem;-webkit-box-orient:horizontal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row;position:relative;-webkit-transition:all .3s ease-in-out;-o-transition:all .3s ease-in-out;-moz-transition:all .3s ease-in-out;transition:all .3s ease-in-out;width:12.14286rem;z-index:200}._1n0jOuo4GDn0GduwDHjAXK,._1ni9wU8JZNrxlVkaMctrUX{-webkit-box-align:stretch;-webkit-align-items:stretch;-moz-box-align:stretch;align-items:stretch;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-moz-box-direction:normal}._1ni9wU8JZNrxlVkaMctrUX{-ms-flex-align:stretch;-webkit-box-orient:vertical;-webkit-flex-direction:column;-moz-box-orient:vertical;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;overflow:hidden;width:100%}._1813B68fwGLkKTFTL3GQH3{background-color:#0087e6;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;color:#fff;font-size:.85714rem;height:1.42857rem;position:absolute;right:-0.89286rem;right:calc(0% - .89286rem);top:-webkit-calc(50% - .71429rem);top:-moz-calc(50% - .71429rem);top:calc(50% - .71429rem);-webkit-transition:-webkit-transform .3s ease-in-out;transition:-webkit-transform .3s ease-in-out;-o-transition:-o-transform .3s ease-in-out;-moz-transition:transform .3s ease-in-out,-moz-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out,-moz-transform .3s ease-in-out,-o-transform .3s ease-in-out;width:1.42857rem}._1n0jOuo4GDn0GduwDHjAXK._1ELpZQet06Q9J--iUN-rzK{width:auto}._1n0jOuo4GDn0GduwDHjAXK._1ELpZQet06Q9J--iUN-rzK ._1813B68fwGLkKTFTL3GQH3{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg)}._3-Nziq6-Ow6R4_jf7_E37y{-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-flex-shrink:1;-ms-flex-negative:1;flex-shrink:1;-webkit-transition:all .3s ease-in-out;-o-transition:all .3s ease-in-out;-moz-transition:all .3s ease-in-out;transition:all .3s ease-in-out;width:0;z-index:100}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"TableWithExpandablePanel": "ObHCPUJ_ecA_5YZ-QzrRw",
	"TableWithExpandablePanel_panel": "_1n0jOuo4GDn0GduwDHjAXK",
	"TableWithExpandablePanel_panel_wrap": "_1ni9wU8JZNrxlVkaMctrUX",
	"TableWithExpandablePanel_panel_icon": "_1813B68fwGLkKTFTL3GQH3",
	"__expanded": "_1ELpZQet06Q9J--iUN-rzK",
	"TableWithExpandablePanel_tableContainer": "_3-Nziq6-Ow6R4_jf7_E37y"
};

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1n-rY_3fiklGNwSq5vkdpR{border-collapse:collapse;width:100%;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:400;letter-spacing:.03571rem;line-height:1.28571}._3VHtjVK29HqiZ1pjkIPUCI.Fu-tWTDExu4uyGeWRqQtK{background-color:#e8ebef}._2eVs-3cjxZSzJngTqRjbv1{border:.07143rem solid #ccc;height:3.92857rem;padding:0 1.42857rem}._2eVs-3cjxZSzJngTqRjbv1._P8o7kaZQ7_Qz2SCVqnpi{height:3.21429rem}._2eVs-3cjxZSzJngTqRjbv1._2iRK-hYPN3wT_uP3dJcDqE{position:relative}._2eVs-3cjxZSzJngTqRjbv1._3u4NOVmkWYEM9yB9SZdhdM{border-left:none;border-right:none}._1n-rY_3fiklGNwSq5vkdpR._1ejKbdjLQlfqiQS3Dz_Opg{text-align:left}._1n-rY_3fiklGNwSq5vkdpR._1KpOb87xZBrfhx0a0G4xAJ{text-align:center}._1n-rY_3fiklGNwSq5vkdpR._3OvlihDzYkkS02QkI0Lq3m,._1n-rY_3fiklGNwSq5vkdpR._3OvlihDzYkkS02QkI0Lq3m ._2Y3jIv9-aF8rjKyY4FjyAI,._1n-rY_3fiklGNwSq5vkdpR._3OvlihDzYkkS02QkI0Lq3m .cwSyXRYvfxhZWv78_VoXN{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1n-rY_3fiklGNwSq5vkdpR._3OvlihDzYkkS02QkI0Lq3m ._2Y3jIv9-aF8rjKyY4FjyAI:not(:last-child),._1n-rY_3fiklGNwSq5vkdpR._3OvlihDzYkkS02QkI0Lq3m .cwSyXRYvfxhZWv78_VoXN:not(:last-child){border-bottom:.07143rem solid #ccc}._1n-rY_3fiklGNwSq5vkdpR._3OvlihDzYkkS02QkI0Lq3m ._2Y3jIv9-aF8rjKyY4FjyAI ._3VHtjVK29HqiZ1pjkIPUCI,._1n-rY_3fiklGNwSq5vkdpR._3OvlihDzYkkS02QkI0Lq3m .cwSyXRYvfxhZWv78_VoXN ._3VHtjVK29HqiZ1pjkIPUCI{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row}._1n-rY_3fiklGNwSq5vkdpR._3OvlihDzYkkS02QkI0Lq3m ._2Y3jIv9-aF8rjKyY4FjyAI ._3VHtjVK29HqiZ1pjkIPUCI:not(:last-child),._1n-rY_3fiklGNwSq5vkdpR._3OvlihDzYkkS02QkI0Lq3m .cwSyXRYvfxhZWv78_VoXN ._3VHtjVK29HqiZ1pjkIPUCI:not(:last-child){border-bottom:.07143rem solid #ccc}._1n-rY_3fiklGNwSq5vkdpR._3OvlihDzYkkS02QkI0Lq3m ._2Y3jIv9-aF8rjKyY4FjyAI ._3VHtjVK29HqiZ1pjkIPUCI ._2eVs-3cjxZSzJngTqRjbv1,._1n-rY_3fiklGNwSq5vkdpR._3OvlihDzYkkS02QkI0Lq3m .cwSyXRYvfxhZWv78_VoXN ._3VHtjVK29HqiZ1pjkIPUCI ._2eVs-3cjxZSzJngTqRjbv1{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;border:none;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex:1 1 0%;-moz-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;height:auto;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;min-height:3.21429rem}._1n-rY_3fiklGNwSq5vkdpR._3OvlihDzYkkS02QkI0Lq3m ._2Y3jIv9-aF8rjKyY4FjyAI ._3VHtjVK29HqiZ1pjkIPUCI ._2eVs-3cjxZSzJngTqRjbv1:not(:last-child):not(._3u4NOVmkWYEM9yB9SZdhdM),._1n-rY_3fiklGNwSq5vkdpR._3OvlihDzYkkS02QkI0Lq3m .cwSyXRYvfxhZWv78_VoXN ._3VHtjVK29HqiZ1pjkIPUCI ._2eVs-3cjxZSzJngTqRjbv1:not(:last-child):not(._3u4NOVmkWYEM9yB9SZdhdM){border-right:.07143rem solid #ccc}._1n-rY_3fiklGNwSq5vkdpR.NKHu41-Shpcqpm_gLGztd{height:100%}th._2eVs-3cjxZSzJngTqRjbv1{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:600;letter-spacing:.03571rem;line-height:1.28571}td._2eVs-3cjxZSzJngTqRjbv1.BmVtGrRGhSnDOGWvbybrg{background-color:#e8ebef}th._2eVs-3cjxZSzJngTqRjbv1.BmVtGrRGhSnDOGWvbybrg{background-color:#0087e6;color:#fff}th._2eVs-3cjxZSzJngTqRjbv1.BmVtGrRGhSnDOGWvbybrg :-webkit-any-link{color:inherit}th._2eVs-3cjxZSzJngTqRjbv1.BmVtGrRGhSnDOGWvbybrg :-moz-any-link{color:inherit}th._2eVs-3cjxZSzJngTqRjbv1.BmVtGrRGhSnDOGWvbybrg :any-link{color:inherit}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SimpleTable": "_1n-rY_3fiklGNwSq5vkdpR",
	"SimpleTable_row": "_3VHtjVK29HqiZ1pjkIPUCI",
	"__stripe": "Fu-tWTDExu4uyGeWRqQtK",
	"SimpleTable_cell": "_2eVs-3cjxZSzJngTqRjbv1",
	"__small": "_P8o7kaZQ7_Qz2SCVqnpi",
	"__relative": "_2iRK-hYPN3wT_uP3dJcDqE",
	"__onlyRowDivider": "_3u4NOVmkWYEM9yB9SZdhdM",
	"__alignLeft": "_1ejKbdjLQlfqiQS3Dz_Opg",
	"__alignCenter": "_1KpOb87xZBrfhx0a0G4xAJ",
	"__flex": "_3OvlihDzYkkS02QkI0Lq3m",
	"SimpleTable_header": "_2Y3jIv9-aF8rjKyY4FjyAI",
	"SimpleTable_body": "cwSyXRYvfxhZWv78_VoXN",
	"__heightFillParent": "NKHu41-Shpcqpm_gLGztd",
	"__highlighted": "BmVtGrRGhSnDOGWvbybrg"
};

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(163);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _Header = __webpack_require__(633);

var _Header2 = _interopRequireDefault(_Header);

var _Body = __webpack_require__(634);

var _Body2 = _interopRequireDefault(_Body);

var _Row = __webpack_require__(635);

var _Row2 = _interopRequireDefault(_Row);

var _Cell = __webpack_require__(636);

var _Cell2 = _interopRequireDefault(_Cell);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleTable = function (_PureComponent) {
  _inherits(SimpleTable, _PureComponent);

  function SimpleTable(props) {
    _classCallCheck(this, SimpleTable);

    var _this = _possibleConstructorReturn(this, (SimpleTable.__proto__ || Object.getPrototypeOf(SimpleTable)).call(this, props));

    _this._setUpData(props);
    return _this;
  }

  _createClass(SimpleTable, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(props) {
      this._setUpData(props);
    }
  }, {
    key: '_setUpData',
    value: function _setUpData(props) {
      var children = _react2.default.Children.toArray(props.children);
      this._header = children.find(function (child) {
        return child.type === _Header2.default;
      });
      this._buildCell = children.find(function (child) {
        return child.type === _Body2.default;
      }).props.children;
      this._columnIds = getColumnIds(this._header);
    }
  }, {
    key: '_isColumnHighlighted',
    value: function _isColumnHighlighted(columnIndex) {
      var colSpan = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      if (_is_js2.default.not.array(this.props.highlightedColumns)) {
        return false;
      }

      var calculatedIndex = columnIndex * colSpan;
      return this.props.highlightedColumns.indexOf(calculatedIndex) >= 0;
    }
  }, {
    key: '_isRowStriped',
    value: function _isRowStriped(rowIndex) {
      if (_is_js2.default.not.array(this.props.stripeRows)) {
        return false;
      }

      return this.props.stripeRows.indexOf(rowIndex) >= 0;
    }
  }, {
    key: '_wrapCellContentIfNeeded',
    value: function _wrapCellContentIfNeeded(cellContent, columnIndex) {
      if (cellContent.type === _Cell2.default) {
        return _react2.default.createElement(
          _Cell2.default,
          _extends({}, cellContent.props, {
            highlighted: this._isColumnHighlighted(columnIndex),
            onlyRowDivider: this.props.onlyRowDivider,
            key: columnIndex }),
          cellContent.props.children
        );
      }

      return _react2.default.createElement(
        _Cell2.default,
        { highlighted: this._isColumnHighlighted(columnIndex),
          onlyRowDivider: this.props.onlyRowDivider,
          key: columnIndex },
        cellContent
      );
    }
  }, {
    key: '_renderHeader',
    value: function _renderHeader() {
      var _this2 = this;

      return _react2.default.createElement(
        _Header2.default,
        null,
        _react2.default.Children.map(this._header.props.children, function (row) {
          return _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.Children.map(row.props.children, function (cell, columnIndex) {
              if (!cell) return null;
              return _react2.default.createElement(
                _Cell2.default,
                _extends({}, cell.props, {
                  highlighted: _this2._isColumnHighlighted(columnIndex, cell.props.colSpan),
                  onlyRowDivider: _this2.props.onlyRowDivider }),
                cell.props.children
              );
            })
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this3 = this;

      var classes = (0, _classnames3.default)(_style2.default.SimpleTable, (0, _omniCommonUi.testClass)('simple-table'), (_classnames = {}, _defineProperty(_classnames, _style2.default.__flex, this.props.flex), _defineProperty(_classnames, _style2.default.__alignLeft, this.props.textAlign === 'left'), _defineProperty(_classnames, _style2.default.__alignCenter, this.props.textAlign !== 'left'), _defineProperty(_classnames, _style2.default.__heightFillParent, this.props.isFullHeightToPanel), _classnames));
      return _react2.default.createElement(
        'table',
        { className: classes, ref: this.props.tableRef },
        this._renderHeader(),
        _react2.default.createElement(
          'tbody',
          { className: _style2.default.SimpleTable_body },
          this.props.rows.map(function (row, rowIndex) {
            return _react2.default.createElement(
              _Row2.default,
              { stripe: _this3._isRowStriped(rowIndex),
                className: (0, _omniCommonUi.testClass)('table-row-' + (rowIndex + 1))
                // eslint-disable-next-line react/no-array-index-key
                , key: rowIndex },
              _this3._columnIds.map(function (columnId, columnIndex) {
                var cell = _this3._buildCell(row, columnId);
                if (cell === null) {
                  return null;
                }

                if (_is_js2.default.array(cell)) {
                  return cell.map(function (cellIt) {
                    return _this3._wrapCellContentIfNeeded(cellIt, columnIndex, rowIndex);
                  });
                }

                return _this3._wrapCellContentIfNeeded(cell, columnIndex, rowIndex);
              })
            );
          })
        )
      );
    }
  }]);

  return SimpleTable;
}(_react.PureComponent);

SimpleTable.propTypes = {
  rows: _propTypes2.default.oneOfType([_propTypes2.default.shape(), _propTypes2.default.arrayOf(_propTypes2.default.any)]),
  children: _propTypes2.default.node,
  stripeRows: _propTypes2.default.arrayOf(_propTypes2.default.number),
  highlightedColumns: _propTypes2.default.arrayOf(_propTypes2.default.number),
  tableRef: _propTypes2.default.func,
  onlyRowDivider: _propTypes2.default.bool,
  flex: _propTypes2.default.bool,
  textAlign: _propTypes2.default.oneOf(['left', 'center']),
  isFullHeightToPanel: _propTypes2.default.bool
};

exports.default = SimpleTable;


function getColumnIds(header) {
  return recursive(header);
  function recursive(header) {
    var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    // eslint-disable-line no-shadow
    _react2.default.Children.toArray(header.props.children).forEach(function (child) {
      if (child.type === _Row2.default) {
        return recursive(child, columns);
      }

      if (child.type !== _Cell2.default || _is_js2.default.undefined(child.props.columnId)) {
        return;
      }

      columns.push(child.props.columnId);
    });

    return columns;
  }
}

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1404);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _immutable = __webpack_require__(3);

var _classnames3 = __webpack_require__(7);

var _classnames4 = _interopRequireDefault(_classnames3);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptionsCell = function (_PureComponent) {
  _inherits(OptionsCell, _PureComponent);

  function OptionsCell(props) {
    _classCallCheck(this, OptionsCell);

    var _this = _possibleConstructorReturn(this, (OptionsCell.__proto__ || Object.getPrototypeOf(OptionsCell)).call(this, props));

    _this.state = { isDropdownOpen: false };
    _this._prepareOptionsToRender(props);
    return _this;
  }

  _createClass(OptionsCell, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      this._prepareOptionsToRender(nextProps);
    }
  }, {
    key: '_toggleDropdown',
    value: function _toggleDropdown(evt) {
      if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
      }
      this.setState(function (state) {
        return { isDropdownOpen: !state.isDropdownOpen };
      });
    }
  }, {
    key: '_prepareOptionsToRender',
    value: function _prepareOptionsToRender(props) {
      var cellOptions = props.cellOptions,
          args = props.args;

      this._options = _is_js2.default.function(cellOptions) && new _immutable.Map(cellOptions.apply(undefined, _toConsumableArray(args)));
      this._canOpen = this._options.size > 0;
      // just for Tutorial Book of HF 3.0
      this._isInVarietyMode = this._options && this._options.size > 4;
    }
  }, {
    key: '_renderDropdown',
    value: function _renderDropdown() {
      var _this2 = this;

      var className = (0, _classnames4.default)(_style2.default.OptionsCell_dropdown, _defineProperty({}, _style2.default.OptionsCell_dropdown_varietyMode, this._isInVarietyMode));
      return _react2.default.createElement(
        _omniCommonUi.DropdownBox,
        { className: className,
          open: this.state.isDropdownOpen === true && this._canOpen,
          smartPosition: true },
        '.',
        this._isInVarietyMode && _react2.default.createElement(
          _omniCommonUi.DropdownBox.Item,
          { className: _style2.default.OptionsCell_dropdown_optionFirstHeader },
          this.props.firstOptionHeader
        ),
        this._isInVarietyMode && _react2.default.createElement(
          _omniCommonUi.DropdownBox.Item,
          { className: _style2.default.OptionsCell_dropdown_optionSecondHeader },
          this.props.secondOptionHeader
        ),
        this._options && this._options.map &&
        // eslint-disable-next-line react/no-array-index-key
        this._options.map(function (config, key) {
          return _react2.default.createElement(
            _omniCommonUi.DropdownBox.Item,
            { key: key,
              className: _this2._isInVarietyMode && _style2.default.OptionsCell_dropdown_item,
              onClick: function onClick(evt) {
                config.onClick(evt);
                // close the dropdown. this is the expected UX in most situations (I think)
                _this2._toggleDropdown();
              } },
            config.label
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames2,
          _this3 = this;

      var _props = this.props,
          args = _props.args,
          buildCell = _props.buildCell;

      var classes = (0, _classnames4.default)(_style2.default.OptionsCell, (_classnames2 = {}, _defineProperty(_classnames2, _style2.default.__canOpen, this._canOpen), _defineProperty(_classnames2, _style2.default.__isOpen, this.state.isDropdownOpen === true), _classnames2));

      return _react2.default.createElement(
        _omniCommonUi.DropdownBox.Container,
        { className: classes,
          onClickOutside: function onClickOutside() {
            return _this3.setState({ isDropdownOpen: false });
          } },
        _react2.default.createElement(
          'div',
          { className: _style2.default.OptionsCell_wrap,
            onClick: this._canOpen && function (e) {
              return _this3._toggleDropdown(e);
            } },
          buildCell.apply(undefined, _toConsumableArray(args))
        ),
        this._renderDropdown()
      );
    }
  }]);

  return OptionsCell;
}(_react.PureComponent);

OptionsCell.propTypes = {
  firstOptionHeader: _propTypes2.default.string,
  secondOptionHeader: _propTypes2.default.string,
  cellOptions: _propTypes2.default.func,
  buildCell: _propTypes2.default.func,
  args: _propTypes2.default.oneOfType([_propTypes2.default.shape(), _propTypes2.default.array])
};

exports.default = OptionsCell;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1405);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1GSE1nCIR3knZJzwLrsGbQ{height:100%;margin:0 -1.42857rem;position:relative;width:-webkit-calc(100% + 2.78571rem);width:-moz-calc(100% + 2.78571rem);width:calc(100% + 2.78571rem)}._1GSE1nCIR3knZJzwLrsGbQ.tP7rAygS8-sZnrW3YZ691:after{border-bottom:.35714rem solid #4a4a4a;border-left:.35714rem solid transparent;border-right:.35714rem solid #4a4a4a;border-top:.35714rem solid transparent;bottom:0;content:\"\";pointer-events:none;position:absolute;right:0}._1GSE1nCIR3knZJzwLrsGbQ.tP7rAygS8-sZnrW3YZ691.bUPKbIPmkOuAaNieU90eY:after{border-bottom-color:#0087e6;border-right-color:#0087e6}._1GSE1nCIR3knZJzwLrsGbQ.tP7rAygS8-sZnrW3YZ691 ._2G0Yv2oM7eYrwdsAg8lQqB{cursor:pointer}._2G0Yv2oM7eYrwdsAg8lQqB{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0 1.42857rem;width:100%}._3rSMmSt4AK1KHQb4VN2T_T{position:absolute;z-index:100}._1d1yjRka91VZGUfg2jAcsH{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-flow:wrap row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-flow:wrap row;flex-flow:row wrap;width:25rem}.FzqaF7VlHwctttafNGNmU{text-align:center;width:50%}.FzqaF7VlHwctttafNGNmU,.FzqaF7VlHwctttafNGNmU:hover{background:blue;color:#fff;font-size:1.07143rem}.q6hGQocqtFjfnSVm-UILg{text-align:center;width:50%}.q6hGQocqtFjfnSVm-UILg,.q6hGQocqtFjfnSVm-UILg:hover{background:hotpink;color:#fff;font-size:1.07143rem}._1Ud5xlH-cflvpooXshfA0l{width:50%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"OptionsCell": "_1GSE1nCIR3knZJzwLrsGbQ",
	"__canOpen": "tP7rAygS8-sZnrW3YZ691",
	"__isOpen": "bUPKbIPmkOuAaNieU90eY",
	"OptionsCell_wrap": "_2G0Yv2oM7eYrwdsAg8lQqB",
	"OptionsCell_dropdown": "_3rSMmSt4AK1KHQb4VN2T_T",
	"OptionsCell_dropdown_varietyMode": "_1d1yjRka91VZGUfg2jAcsH",
	"OptionsCell_dropdown_optionFirstHeader": "FzqaF7VlHwctttafNGNmU",
	"OptionsCell_dropdown_optionSecondHeader": "q6hGQocqtFjfnSVm-UILg",
	"OptionsCell_dropdown_item": "_1Ud5xlH-cflvpooXshfA0l"
};

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(631);

var _component2 = _interopRequireDefault(_component);

var _accessors = __webpack_require__(36);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: 'course(/:mode)',
    view: 'course',
    component: _component2.default,
    sessionNav: {
      noUnitSessionNavigation: true
    },
    canAccess: function canAccess(props) {
      var state = getState();
      if (!_omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.MarkAttendance.ViewCourseView)) {
        return false;
      }

      if (!_component2.default.isInMarkingRoute(props)) {
        return true;
      }

      return _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.MarkAttendance.MarkCourseView);
    },
    actionButtons: {
      default: {
        Mark: {
          isPrimary: true,
          route: './edit',
          visibleWhen: function visibleWhen(_ref2) {
            var _ref2$params = _ref2.params,
                groupId = _ref2$params.groupId,
                sessionPlanId = _ref2$params.sessionPlanId;
            return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.MarkAttendance.MarkCourseView) && (0, _accessors.isMarkable)(getState(), groupId, sessionPlanId);
          }
        },
        Export: {
          isPrimary: false,
          route: './export',
          visibleWhen: function visibleWhen() {
            return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.MarkAttendance.ViewCourseView);
          }
        }
      },
      edit: {
        Exit: {
          route: {
            mode: ''
          }
        }
      }
    },
    history: function history(props) {
      var params = props.params,
          buildRoute = props.buildRoute;

      var attendanceHistoryPath = '/group/:groupId/attendance/history';
      var link = buildRoute(attendanceHistoryPath, params);
      return { link: link };
    }
  };
};

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkAttendance = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _SessionPlans = __webpack_require__(44);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _accessors = __webpack_require__(36);

var Session = _interopRequireWildcard(_accessors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarkAttendance = exports.MarkAttendance = function (_PureComponent) {
  _inherits(MarkAttendance, _PureComponent);

  function MarkAttendance() {
    _classCallCheck(this, MarkAttendance);

    return _possibleConstructorReturn(this, (MarkAttendance.__proto__ || Object.getPrototypeOf(MarkAttendance)).apply(this, arguments));
  }

  _createClass(MarkAttendance, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._checkIsMarkableInMarkMode(this.props);
      this.props.fetchSessionPlansIfNeeded(this.props.params.groupId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._checkIsMarkableInMarkMode(nextProps);
    }
  }, {
    key: '_checkIsMarkableInMarkMode',
    value: function _checkIsMarkableInMarkMode(props) {
      var markable = props.markable,
          mode = props.mode,
          buildRoute = props.buildRoute,
          replace = props.replace;


      if (_is_js2.default.boolean(markable) && !markable && mode === 'edit') {
        _omniCommonUi.log.warn('Session: not a markable session; leaving edit mode');
        return replace(buildRoute({ mode: '' }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!_is_js2.default.existy(this.props.sessions)) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);

  return MarkAttendance;
}(_react.PureComponent);

MarkAttendance.getCurrentRouteSegment = function (_ref) {
  var routes = _ref.routes;
  return routes ? routes[routes.length - 1] : {};
};

MarkAttendance.propTypes = {
  children: _propTypes2.default.node,
  markable: _propTypes2.default.bool,
  fetchSessionPlansIfNeeded: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  replace: _propTypes2.default.func.isRequired,
  params: _propTypes2.default.shape({
    groupId: _propTypes2.default.string.isRequired
  }).isRequired,
  sessions: _propTypes2.default.object,
  mode: _propTypes2.default.string
};

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      sessionPlanId = _ownProps$params.sessionPlanId;

  var sessions = Session.getSessions(state, groupId);
  if (_immutable.Map.isMap(sessions) && sessions.size !== 0) {
    return {
      markable: Session.isMarkable(state, groupId, sessionPlanId),
      sessions: sessions,
      mode: ownProps.mode
    };
  }
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_SessionPlans.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(MarkAttendance);

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1409);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3I_gsgxABJyfss9wz8dAaN{width:100%}._3wXgNpmdBAaJ3X5GhV1XRs{background-position:50%;background-repeat:no-repeat;-webkit-background-size:contain;-moz-background-size:contain;background-size:contain;content:\"\";cursor:pointer;display:block;font-size:.85714rem;-webkit-transition:-webkit-transform .3s ease-in-out;transition:-webkit-transform .3s ease-in-out;-o-transition:-o-transform .3s ease-in-out;-moz-transition:transform .3s ease-in-out,-moz-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out,-moz-transform .3s ease-in-out,-o-transform .3s ease-in-out}._3wXgNpmdBAaJ3X5GhV1XRs._3UcdlQA-Be-ZSthX9vCd_B{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg)}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ViewNav": "_3I_gsgxABJyfss9wz8dAaN",
	"ViewNav_expandIcon": "_3wXgNpmdBAaJ3X5GhV1XRs",
	"__reverse": "_3UcdlQA-Be-ZSthX9vCd_B"
};

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1411);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _ViewNavButton = __webpack_require__(290);

var _ViewNavButton2 = _interopRequireDefault(_ViewNavButton);

var _ViewNavExtra = __webpack_require__(291);

var _ViewNavExtra2 = _interopRequireDefault(_ViewNavExtra);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewNavBig = function ViewNavBig(_ref) {
  var children = _ref.children;

  var childrenArr = _react2.default.Children.toArray(children);
  var className = _style2.default.ViewNavBig;
  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'div',
      { className: (0, _omniCommonUi.testClass)('viewnav-action-buttons') },
      childrenArr.filter(function (child) {
        return child.type === _ViewNavButton2.default;
      })
    ),
    childrenArr.find(function (child) {
      return child.type === _ViewNavExtra2.default;
    })
  );
};

ViewNavBig.propTypes = {
  children: _propTypes2.default.arrayOf(function (arr) {
    return arr.every(function (val) {
      if (_is_js2.default.array(val) && val.every(function (comp) {
        return comp.type === 'ViewNavButton';
      })) return true;
      if (val.type === 'ViewNavButton' || val.type === 'ViewNavExtra') return true;
      return new Error('\'children\' invalid. got ' + val);
    });
  })
};

exports.default = ViewNavBig;

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1412);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".Ar_sLIJIhNIXkmcclIZI7{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:#f3f5f7;border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:3.92857rem;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;overflow:hidden;padding:0;padding-left:1.42857rem;padding-right:1.42857rem}@media only screen and (min-width:640px){.Ar_sLIJIhNIXkmcclIZI7{padding-left:2.14286rem;padding-right:2.14286rem}}.Ar_sLIJIhNIXkmcclIZI7 button{overflow:hidden;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ViewNavBig": "Ar_sLIJIhNIXkmcclIZI7"
};

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1414);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ViewNavButton = __webpack_require__(290);

var _ViewNavButton2 = _interopRequireDefault(_ViewNavButton);

var _ViewNavExtra = __webpack_require__(291);

var _ViewNavExtra2 = _interopRequireDefault(_ViewNavExtra);

var _omniCommonUi = __webpack_require__(0);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewNavSmall = function (_Component) {
  _inherits(ViewNavSmall, _Component);

  function ViewNavSmall(props) {
    _classCallCheck(this, ViewNavSmall);

    var _this = _possibleConstructorReturn(this, (ViewNavSmall.__proto__ || Object.getPrototypeOf(ViewNavSmall)).call(this, props));

    _this.state = { open: false };
    _this._setUp(props);
    return _this;
  }

  _createClass(ViewNavSmall, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(props) {
      this._setUp(props);
    }
  }, {
    key: '_setUp',
    value: function _setUp(props) {
      var childrenArr = _react2.default.Children.toArray(props.children);
      this._buttons = childrenArr.filter(function (child) {
        return child.type === _ViewNavButton2.default;
      });
      this._extra = childrenArr.find(function (child) {
        return child.type === _ViewNavExtra2.default;
      });
    }
  }, {
    key: '_toggleDropdown',
    value: function _toggleDropdown(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.setState({ open: !this.state.open });
    }
  }, {
    key: '_renderDropdown',
    value: function _renderDropdown() {
      var _this2 = this;

      if (this._buttons.length <= 0) {
        return _react2.default.createElement('div', null); // Needed to keep the proper alignment.
      }

      return _react2.default.createElement(
        _omniCommonUi.DropdownBox.Container,
        { className: _style2.default.ViewNavSmall_container,
          onClickOutside: function onClickOutside() {
            return _this2.setState({ open: false });
          } },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_style2.default.ViewNavSmall_expand, (0, _omniCommonUi.testClass)('viewnav-expand-action-buttons')),
            onClick: function onClick(e) {
              return _this2._toggleDropdown(e);
            } },
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'dots' })
        ),
        _react2.default.createElement(
          _omniCommonUi.DropdownBox,
          { className: (0, _classnames2.default)(_style2.default.ViewNavSmall_dropdown, (0, _omniCommonUi.testClass)('viewnav-action-buttons')),
            open: this.state.open },
          this._buttons.map(function (_ref) {
            var props = _ref.props;
            return _react2.default.createElement(
              _omniCommonUi.DropdownBox.Item,
              { className: _style2.default.ViewNavSmall_item },
              _react2.default.createElement(
                _omniCommonUi.Button,
                _extends({}, props, {
                  className: (0, _classnames2.default)(_style2.default.ViewNavSmall_item_button, props.className) }),
                props.title
              )
            );
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _style2.default.ViewNavSmall },
        this._renderDropdown(),
        this._extra
      );
    }
  }]);

  return ViewNavSmall;
}(_react.Component);

ViewNavSmall.propTypes = {
  children: _propTypes2.default.arrayOf(_ViewNavButton2.default)
};

exports.default = ViewNavSmall;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1415);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".cwZsMM60rMwJJOd_tDmA{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:#f3f5f7;border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:2.85714rem;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0;z-index:500;padding-left:1.42857rem;padding-right:1.42857rem}@media only screen and (min-width:640px){.cwZsMM60rMwJJOd_tDmA{padding-left:2.14286rem;padding-right:2.14286rem}}.dmdA9OVMajBOoFz0Jj4PR{height:100%;position:relative}._3ixS5mm-ZmBY-4AgWmahd-,.dmdA9OVMajBOoFz0Jj4PR{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._3ixS5mm-ZmBY-4AgWmahd-{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-color:#0087e6;color:#fff;cursor:pointer;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-left:-1.42857rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:2.85714rem}.LNrKRo2lDcAhWEiL9ZFN4{background-color:#f3f5f7;left:-1.42857rem;position:absolute;top:2.85714rem;z-index:500}._3KcWQ6sZH7EuNvlJ9u7eAi{padding:0}._3L_ZKn40bscylvF9Gsk1SL{background:transparent!important;border:none!important;-webkit-border-radius:0!important;-moz-border-radius:0!important;border-radius:0!important;-webkit-box-shadow:100%!important;-moz-box-shadow:100%!important;box-shadow:100%!important;color:inherit!important;display:block;height:100%!important;min-height:2.5rem!important;min-width:0!important;width:100%!important;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:.85714rem;font-weight:600;letter-spacing:.07143rem;text-transform:uppercase}._3KcWQ6sZH7EuNvlJ9u7eAi>._3L_ZKn40bscylvF9Gsk1SL{padding:0 1.42857rem!important}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ViewNavSmall": "cwZsMM60rMwJJOd_tDmA",
	"ViewNavSmall_container": "dmdA9OVMajBOoFz0Jj4PR",
	"ViewNavSmall_expand": "_3ixS5mm-ZmBY-4AgWmahd-",
	"ViewNavSmall_dropdown": "LNrKRo2lDcAhWEiL9ZFN4",
	"ViewNavSmall_item": "_3KcWQ6sZH7EuNvlJ9u7eAi",
	"ViewNavSmall_item_button": "_3L_ZKn40bscylvF9Gsk1SL"
};

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _routes = __webpack_require__(615);

var _accessors = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Attendance = function (_PureComponent) {
  _inherits(Attendance, _PureComponent);

  function Attendance() {
    _classCallCheck(this, Attendance);

    return _possibleConstructorReturn(this, (Attendance.__proto__ || Object.getPrototypeOf(Attendance)).apply(this, arguments));
  }

  _createClass(Attendance, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._doRedirectionIfNeeded(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this._doRedirectionIfNeeded(newProps);
    }
  }, {
    key: '_doRedirectionIfNeeded',
    value: function _doRedirectionIfNeeded(_ref) {
      var defaultSessionId = _ref.defaultSessionId,
          defaultUnitId = _ref.defaultUnitId,
          routes = _ref.routes,
          replace = _ref.replace,
          buildRoute = _ref.buildRoute;

      if (!defaultSessionId || routes[routes.length - 1].path !== _routes.path) {
        return;
      }
      var url = _is_js2.default.existy(defaultUnitId) ? 'session/' + defaultSessionId + '/unit/' + defaultUnitId : 'session/' + defaultSessionId + '/unit/0';
      replace(buildRoute(url));
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return Attendance;
}(_react.PureComponent);

Attendance.propTypes = {
  children: _propTypes2.default.node,
  defaultSessionId: _propTypes2.default.string
};

function mapStateToProps(state, ownProps) {
  var defaultSessionId = (0, _accessors.getDefaultSession)(state, ownProps.params.groupId).id;
  var defaultUnitId = (0, _accessors.getFirstUnitOfSession)(state, defaultSessionId);
  return { defaultSessionId: defaultSessionId, defaultUnitId: defaultUnitId };
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps)(Attendance);

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(638);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1420);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1419);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._33CfMKaWyyBZwfW9uMEUr3{padding:1.42857rem}@media only screen and (min-width:640px){._33CfMKaWyyBZwfW9uMEUr3{padding:2.14286rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ProgressTest_content": "_33CfMKaWyyBZwfW9uMEUr3"
};

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _component = __webpack_require__(638);

var _component2 = _interopRequireDefault(_component);

var _ = __webpack_require__(13);

var _ProgressTestDayView = __webpack_require__(293);

var _ProgressTestCourseView = __webpack_require__(641);

var _ProgressTestRubricView = __webpack_require__(644);

var _component3 = __webpack_require__(300);

var _component4 = _interopRequireDefault(_component3);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _ProgressTestSessionNav = __webpack_require__(651);

var _ProgressTestSessionNav2 = _interopRequireDefault(_ProgressTestSessionNav);

var _ProgressTests = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// HFv4 Unit Review shares the progress-test URL, but must not sort inside the
// shared ProgressTestRubricView (also mounted by non-HFv4 exam).
var progressTestRubricViewForGroup = function progressTestRubricViewForGroup(_ref) {
  var getState = _ref.getState;

  var route = (0, _ProgressTestRubricView.routes)({ getState: getState });
  var ProgressTestRubricViewSwitch = function ProgressTestRubricViewSwitch(props) {
    var View = _.actions.isHFV4CourseTypeGroup(getState(), props.params.groupId) ? _component4.default : route.component;
    return _react2.default.createElement(View, props);
  };
  ProgressTestRubricViewSwitch.propTypes = {
    params: _propTypes2.default.object.isRequired
  };
  return Object.assign({}, route, {
    component: ProgressTestRubricViewSwitch
  });
};

exports.default = function (_ref2) {
  var getState = _ref2.getState;
  return {
    appBars: {
      sticky: {
        ptNav: {
          component: _ProgressTestSessionNav2.default,
          props: {
            isUnitQuiz: true
          },
          order: 1
        },
        'view-nav': {
          component: _ViewNav2.default,
          props: {
            showExpandable: true
          },
          order: 3
        }
      }
    },
    path: 'progress-test',
    component: _component2.default,
    canAccess: function canAccess(_ref3) {
      var params = _ref3.params;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressTest.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.ProgressTest);
    },
    tab: {
      label: function label(params) {
        return _ProgressTests.accessors.getProgressTestTab(getState(), params.groupId);
      },
      order: 6,
      isVisible: function isVisible(params) {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressTest.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.ProgressTest);
      }
    },
    breadcrumbLabels: function breadcrumbLabels(props) {
      var _props$params = props.params,
          groupId = _props$params.groupId,
          progressTestIndex = _props$params.progressTestIndex,
          buildRoute = props.buildRoute;

      var currentProps = (0, _component.mapStateToProps)(getState(), props);
      if (!currentProps || !currentProps.currentProgressTestPlan) return;
      var labelName = _ProgressTests.accessors.getPTNameWithGroup(getState(), currentProps.currentProgressTestPlan.name, groupId);
      return {
        label: labelName,
        href: buildRoute('/group/' + groupId + '/progress-test/' + progressTestIndex + '/course')
      };
    },
    childRoutes: [_ProgressTestDayView.routes, _ProgressTestCourseView.routes, progressTestRubricViewForGroup]
  };
};

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'day',
  view: 'day',
  component: function component() {
    return _react2.default.createElement(
      'div',
      null,
      'Not Implemented'
    );
  }
};

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1423);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3veqxQSFJAkDitK_zqTT5g{border-bottom:0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:.71429rem 1.42857rem}._2fgFitsowvQGehi76QBIXy{display:contents}._29ysvzZrJVdtKxMJOg7fih{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-left:.35714rem}._3pAC2UhJZSX2uD0MsmRC-8{overflow:hidden;padding:0}._1CL_rQQF0Dx0DJNkp9ugHC{border-top:0}._3H7swAtHNrVeHLJOI21G-t{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;border:.07143rem solid transparent;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:1.14286rem}._36yKFygVER4wfSuC03KPZ3{margin-left:.35714rem}._3H7swAtHNrVeHLJOI21G-t._3p-UsbBj1H-_Z916Oq4ry9{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;height:2.5rem;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-width:6.42857rem;text-transform:lowercase;width:6.42857rem;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:400;letter-spacing:.03571rem;line-height:1.28571}._3H7swAtHNrVeHLJOI21G-t._3p-UsbBj1H-_Z916Oq4ry9 ._3Fw9h8627MS7xUadknaCWW,._3H7swAtHNrVeHLJOI21G-t._3p-UsbBj1H-_Z916Oq4ry9 ._37ukqpIKWlQKwu5d1uX2KV{text-align:right}._1dbF7VmH9W_cE649F5XxRj{display:inline-block}._3h0hsRFhvXdgcBW4wEDS_S:hover{color:#0087e6}._1Y9Z5pC-8ZkCGLjtyhqJiE{max-width:14.28571rem}.A9RqE0wDrhMf05AVU89sR{cursor:pointer}.A9RqE0wDrhMf05AVU89sR._2mxlDU8DAXa0Z2S_VHKlK5{color:#a4a4a4;pointer-events:none}._39aTkUR07G6fOPZrGEm6Gn{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:600;letter-spacing:.03571rem;line-height:1.28571;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;color:inherit;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;font-size:.85714rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;outline:0;text-decoration:none;text-transform:uppercase}._35p0tuoBWkJdJ_FnhUeBwv{margin-left:.71429rem}._8f0lmITzohWMcKjyv942O{color:#a4a4a4;pointer-events:none}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ProgressTestCourseView_cardHeader": "_3veqxQSFJAkDitK_zqTT5g",
	"ProgressTestCourseView_cardHeader_title": "_2fgFitsowvQGehi76QBIXy",
	"ProgressTestCourseView_cardHeader_tooltip": "_29ysvzZrJVdtKxMJOg7fih",
	"ProgressTestCourseView_content": "_3pAC2UhJZSX2uD0MsmRC-8",
	"ProgressTestCourseView_expand": "_1CL_rQQF0Dx0DJNkp9ugHC",
	"ProgressTestCourseView_scoreCell": "_3H7swAtHNrVeHLJOI21G-t",
	"ProgressTestCourseView_scoreCell_icon": "_36yKFygVER4wfSuC03KPZ3",
	"__isRubric": "_3p-UsbBj1H-_Z916Oq4ry9",
	"EditableScoreCell_currentScore": "_3Fw9h8627MS7xUadknaCWW",
	"EditableScoreCell_previousScore": "_37ukqpIKWlQKwu5d1uX2KV",
	"ProgressTestCourseView_tooltip": "_1dbF7VmH9W_cE649F5XxRj",
	"ProgressTestCourseView_tooltip_icon": "_3h0hsRFhvXdgcBW4wEDS_S",
	"ProgressTestCourseView_tooltip_inner": "_1Y9Z5pC-8ZkCGLjtyhqJiE",
	"GeneralLink": "A9RqE0wDrhMf05AVU89sR",
	"__disabled": "_2mxlDU8DAXa0Z2S_VHKlK5",
	"ProgressReportLink": "_39aTkUR07G6fOPZrGEm6Gn",
	"ProgressReportLink_icon": "_35p0tuoBWkJdJ_FnhUeBwv",
	"ProgressReportLink_disabled": "_8f0lmITzohWMcKjyv942O"
};

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = progressTestViewLinkReducer;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(294);

function progressTestViewLinkReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_PROGRESS_TEST_VIEW_LINK_SUCCESS:
      return addViewLinkToMap(state, action);
    default:
      return state;
  }
}

function addViewLinkToMap(state, _ref) {
  var payload = _ref.payload,
      progressTestId = _ref.progressTestId;

  var newState = state;
  newState = newState.set('' + progressTestId, payload);
  return newState;
}

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1426);

var _style2 = _interopRequireDefault(_style);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BASE_NUM_REGEX = /^[0-9]$/;
var DECIMAL_NUM_REGEX = /^[0-9.]$/;

var EditableScoreCell = function (_PureComponent) {
  _inherits(EditableScoreCell, _PureComponent);

  function EditableScoreCell() {
    _classCallCheck(this, EditableScoreCell);

    var _this = _possibleConstructorReturn(this, (EditableScoreCell.__proto__ || Object.getPrototypeOf(EditableScoreCell)).call(this));

    _this._onMouseDown = _this._onMouseDown.bind(_this);
    _this._onTouchOrClick = _this._onTouchOrClick.bind(_this);
    _this._onFocus = _this._onFocus.bind(_this);
    _this._onKeyDown = _this._onKeyDown.bind(_this);
    _this._selectTheWholeText = _this._selectTheWholeText.bind(_this);
    return _this;
  }

  _createClass(EditableScoreCell, [{
    key: '_onMouseDown',
    value: function _onMouseDown(ev) {
      if (!this.props.isEditableScore) return;
      ev.preventDefault();
    }
  }, {
    key: '_onTouchOrClick',
    value: function _onTouchOrClick(ev) {
      ev.preventDefault();
      if (!this.props.isEditableScore) return;
      var htmlEl = this.contentEditableComp.htmlEl;

      htmlEl && htmlEl.focus();
    }
  }, {
    key: '_onFocus',
    value: function _onFocus() {
      this._selectTheWholeText();
    }

    // _onKeyDown: input and score range validation

  }, {
    key: '_onKeyDown',
    value: function _onKeyDown(ev) {
      var _props = this.props,
          score = _props.score,
          fullMark = _props.fullMark,
          allowDecimal = _props.allowDecimal;

      (0, _invariant2.default)(_is_js2.default.number(fullMark), 'fullMark must be numeric');
      (0, _invariant2.default)(_is_js2.default.string(ev.key), 'ev.key must be a string');
      if (ev.key.startsWith('Arrow')) {
        // arrow keys mess up this code. disabled!
        ev.preventDefault();
        ev.stopPropagation(); // don't scroll the table
        return;
      }
      // backspace, tab, etc allowed
      if (ev.ctrlKey || ev.metaKey || ev.key.length !== 1) return true;

      var keyRegex = allowDecimal ? DECIMAL_NUM_REGEX : BASE_NUM_REGEX;
      if (!keyRegex.test(ev.key)) {
        ev.preventDefault();
        return;
      }

      var currentValue = '';
      if (this.contentEditableComp && this.contentEditableComp.htmlEl) {
        currentValue = this.contentEditableComp.htmlEl.textContent || '';
      } else {
        currentValue = _is_js2.default.number(score) || _is_js2.default.string(score) ? score.toString() : '';
      }

      var selection = window.getSelection().toString();
      var newScore = void 0; // user has the whole score selected
      if (selection) {
        newScore = currentValue.replace(selection, ev.key);
      } else {
        newScore = '' + currentValue + ev.key;
      }

      var _newScore$split = newScore.split('.'),
          _newScore$split2 = _slicedToArray(_newScore$split, 2),
          integerPart = _newScore$split2[0],
          _newScore$split2$ = _newScore$split2[1],
          decimalPart = _newScore$split2$ === undefined ? '' : _newScore$split2$;

      if (allowDecimal) {
        if (ev.key === '.' && newScore.split('.').length - 1 > 1) {
          ev.preventDefault();
          return;
        }

        if (integerPart === '' && ev.key === '.') {
          return;
        }

        if (decimalPart.length > 2) {
          ev.preventDefault();
          return;
        }
      }

      if (integerPart.length > 2 || integerPart.startsWith('0') && integerPart.length > 1) {
        ev.preventDefault();
        return;
      }

      var numericValue = Number.parseFloat(newScore);
      console.log(numericValue);
      if (!isNaN(numericValue) && numericValue > fullMark) {
        ev.preventDefault();
      }
    }
  }, {
    key: '_selectTheWholeText',
    value: function _selectTheWholeText() {
      (0, _omniCommonUi.selectElementContents)(this.contentEditableComp.htmlEl);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          className = _props2.className,
          score = _props2.score,
          previousScore = _props2.previousScore,
          isEditableScore = _props2.isEditableScore,
          fullMark = _props2.fullMark,
          onChange = _props2.onChange;


      var isPreviousScoreShown = !isEditableScore && _is_js2.default.number(previousScore) && previousScore !== score;
      var previousScorePart = isPreviousScoreShown ? _react2.default.createElement(
        'div',
        { className: _style2.default.EditableScoreCell_previousScore },
        _react2.default.createElement(
          'span',
          { className: (0, _omniCommonUi.testClass)('previous-score') },
          previousScore
        ),
        '/',
        fullMark
      ) : null;
      var scoreStyle = {};
      if (score / fullMark < 0.6 && !isEditableScore) {
        scoreStyle = _style2.default.EditableScoreCell_low;
      } else {
        scoreStyle = _style2.default.EditableScoreCell;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames3.default)(scoreStyle, className, _defineProperty({}, _style2.default.__editable, isEditableScore)),
          ref: function ref(_ref2) {
            _this2.outerNode = _ref2;
          },
          onMouseDown: this._onMouseDown,
          onClick: this._onTouchOrClick,
          onTouchStart: this._onTouchOrClick },
        _react2.default.createElement(
          'div',
          { className: _style2.default.EditableScoreCell_currentScore },
          _react2.default.createElement(_omniCommonUi.ContentEditable, { className: (0, _classnames3.default)(_style2.default.EditableScoreCell_currentScore_editor, (0, _omniCommonUi.testClass)('score-editor')),
            ref: function ref(_ref) {
              _this2.contentEditableComp = _ref;
            },
            html: _is_js2.default.number(score) ? score.toString() : '',
            disabled: !isEditableScore,
            onFocus: this._onFocus,
            onChange: onChange,
            onKeyDown: this._onKeyDown,
            onMouseDown: this._onMouseDown,
            onClick: this._selectTheWholeText,
            onTouchStart: this._selectTheWholeText }),
          _react2.default.createElement(
            'span',
            { className: _style2.default.EditableScoreCell_currentScoreFullMark },
            '/',
            fullMark
          )
        ),
        previousScorePart
      );
    }
  }]);

  return EditableScoreCell;
}(_react.PureComponent);

EditableScoreCell.propTypes = {
  className: _propTypes2.default.string,
  score: _propTypes2.default.number,
  previousScore: _propTypes2.default.number,
  fullMark: _propTypes2.default.number.isRequired,
  isEditableScore: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  allowDecimal: _propTypes2.default.bool
};

EditableScoreCell.defaultProps = {
  className: '',
  score: 0,
  previousScore: null,
  isEditableScore: false,
  onChange: function onChange() {},
  allowDecimal: false
};

exports.default = EditableScoreCell;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1427);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1l36i-uUNIGrvEPLUQJ9k5{border:.07143rem solid transparent;-webkit-border-radius:.35714rem;-moz-border-radius:.35714rem;border-radius:.35714rem;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-transition:background .3s ease-in-out;-o-transition:background .3s ease-in-out;-moz-transition:background .3s ease-in-out;transition:background .3s ease-in-out;width:6.42857rem;@nest &.__editable &_currentScore_editor{cursor:text}@nest &:not(.__editable) &_currentScore_editor{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}}.VOd0NFCw4PHotj_k0Gi27{background-color:#fbcb22}._1l36i-uUNIGrvEPLUQJ9k5 [contentEditable=true]{cursor:text;min-width:.71429rem}._1l36i-uUNIGrvEPLUQJ9k5._35yAEFr7xMZuzlKrKTYsF3{background-color:#fff;border-color:#ccc;cursor:text;min-height:2.5rem;padding:.35714rem 1.07143rem}.HwEzlnrKVBq467J7JQAeO{display:inline;-webkit-user-select:auto;-moz-user-select:auto;-ms-user-select:auto;user-select:auto}._3w5fjVhq76qV_DaVwyEMOQ,._iqH1OdEgSgvZRc_4yDTC{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._3w5fjVhq76qV_DaVwyEMOQ{color:#a4a4a4;font-size:75%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"EditableScoreCell": "_1l36i-uUNIGrvEPLUQJ9k5",
	"EditableScoreCell_low": "VOd0NFCw4PHotj_k0Gi27",
	"__editable": "_35yAEFr7xMZuzlKrKTYsF3",
	"EditableScoreCell_currentScore_editor": "HwEzlnrKVBq467J7JQAeO",
	"EditableScoreCell_previousScore": "_3w5fjVhq76qV_DaVwyEMOQ",
	"EditableScoreCell_currentScoreFullMark": "_iqH1OdEgSgvZRc_4yDTC"
};

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omniCommonUi = __webpack_require__(0);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _actions = __webpack_require__(294);

var _accessors = __webpack_require__(52);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _component = __webpack_require__(642);

var _component2 = _interopRequireDefault(_component);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PT_VIEWER_NAME = 'Assessment Viewer';

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: ':progressTestIndex/course(/:mode)',
    view: 'course',
    component: _component2.default,
    sessionNavConfig: {
      setModeOnNavigate: ''
    },
    canAccess: function canAccess(props) {
      if (!_component2.default.isInMarkingRoute(props)) {
        return true;
      }
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressTest.Edit);
    },
    breadcrumbLabels: function breadcrumbLabels(_ref2) {
      var params = _ref2.params;

      if (params.mode === 'edit') return 'Edit';
      return [];
    },
    actionButtons: {
      default: _defineProperty({
        Mark: {
          route: './edit',
          visibleWhen: function visibleWhen(_ref3) {
            var location = _ref3.location,
                params = _ref3.params;

            if (_.actions.isHFV4CourseTypeGroup(getState(), params.groupId)) {
              return false;
            }
            var isUnitQuiz = (0, _accessors.checkIsUnitQuiz)(location.pathname);
            return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressTest.Edit) && (0, _accessors.isMarkable)(getState(), params.groupId, Number.parseInt(params.progressTestIndex, 10), isUnitQuiz);
          },
          isPrimary: true
        }
      }, PT_VIEWER_NAME, {
        label: function label(_ref4) {
          var pathname = _ref4.location.pathname,
              _ref4$params = _ref4.params,
              groupId = _ref4$params.groupId,
              progressTestIndex = _ref4$params.progressTestIndex;

          var call = getProgressTestViewLinkApiCall(getState(), groupId, progressTestIndex, pathname);
          if (!_is_js2.default.existy(call)) {
            return '';
          }
          return _omniCommonUi.ApiCall.State.hasFailed(call) ? PT_VIEWER_NAME + ' is not available now' : PT_VIEWER_NAME;
        },
        newTab: true,
        linkHref: function linkHref(_ref5) {
          var pathname = _ref5.location.pathname,
              _ref5$params = _ref5.params,
              groupId = _ref5$params.groupId,
              progressTestIndex = _ref5$params.progressTestIndex;

          var progressTestLink = getProgressTestViewLinkResultViaIndex(getState(), groupId, progressTestIndex, pathname);
          return progressTestLink && progressTestLink.url;
        },
        visibleWhen: function visibleWhen(_ref6) {
          var pathname = _ref6.location.pathname,
              _ref6$params = _ref6.params,
              groupId = _ref6$params.groupId,
              progressTestIndex = _ref6$params.progressTestIndex;

          var state = getState();

          if (_.actions.isSSCourseTypeGroup(state, groupId) || _.actions.isNotTBv3Group(state, groupId)) {
            return false;
          }

          var progressTestLink = getProgressTestViewLinkResultViaIndex(state, groupId, progressTestIndex, pathname);
          if (progressTestLink && (progressTestLink.isHaveOnlineCourseKey === false || progressTestLink.isEnabledPTViewer === false)) {
            return false;
          }
          var call = getProgressTestViewLinkApiCall(state, groupId, progressTestIndex, pathname);
          return _is_js2.default.existy(call) && !_omniCommonUi.ApiCall.State.shouldPerform(call) && !_omniCommonUi.ApiCall.State.isLoading(call);
        },
        disableWhen: function disableWhen(_ref7) {
          var pathname = _ref7.location.pathname,
              _ref7$params = _ref7.params,
              groupId = _ref7$params.groupId,
              progressTestIndex = _ref7$params.progressTestIndex;

          var state = getState();
          var progressTestLink = getProgressTestViewLinkResultViaIndex(state, groupId, progressTestIndex, pathname);
          var call = getProgressTestViewLinkApiCall(state, groupId, progressTestIndex, pathname);
          try {
            return _omniCommonUi.ApiCall.State.hasFailed(call) || progressTestLink.url.length === 0;
          } catch (e) {
            return true;
          }
        }
      }),
      edit: {
        Save: {
          isPrimary: true,
          route: '../save'
        },
        Discard: {
          route: '../discard'
        }
      }
    }
  };
};

function getProgressTestViewLinkResultViaId(state, progressTestId) {
  return state.get('rootReducer').get('progressTestViewLink') && state.get('rootReducer').get('progressTestViewLink').get('' + progressTestId);
}

function getProgressTestViewLinkResultViaIndex(state, groupId, progressTestIndex, pathname) {
  var isUnitQuiz = (0, _accessors.checkIsUnitQuiz)(pathname);
  var progressTestId = (0, _accessors.getProgressTestPlanFromIndex)(state, groupId, progressTestIndex, isUnitQuiz) && (0, _accessors.getProgressTestPlanFromIndex)(state, groupId, progressTestIndex, isUnitQuiz).id;
  if (!_is_js2.default.existy(progressTestId)) {
    return undefined;
  }
  return getProgressTestViewLinkResultViaId(state, progressTestId);
}

function getProgressTestViewLinkApiCall(state, groupId, progressTestIndex, pathname) {
  var isUnitQuiz = (0, _accessors.checkIsUnitQuiz)(pathname);
  var progressTestId = (0, _accessors.getProgressTestPlanFromIndex)(state, groupId, progressTestIndex, isUnitQuiz) && (0, _accessors.getProgressTestPlanFromIndex)(state, groupId, progressTestIndex, isUnitQuiz).id;
  if (_is_js2.default.existy(progressTestId)) {
    var call = _omniCommonUi.ApiCall.find(state, {
      method: 'GET',
      url: (0, _actions.buildProgressTestViewLinkUrl)(progressTestId)
    });
    return call;
  }
}

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1430);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._14ArCMdvqHMro5whcw2kd9{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._1edgZNiMzo_zrrxJN8r9dq{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.-QMtxGtFieuyySAbJytXb{background-color:#fbfbfb;border:0;-webkit-box-shadow:0 0 .21429rem .07143rem rgba(0,0,0,.15);-moz-box-shadow:0 0 .21429rem .07143rem rgba(0,0,0,.15);box-shadow:0 0 .21429rem .07143rem rgba(0,0,0,.15);-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;margin-bottom:1.42857rem;min-height:5em;padding:.35714rem;position:relative;z-index:200}._2L8gGHkaEwLbN1bWVKsHn6{width:10rem}._10utIiu-yH1s5iWOYDRbd7{padding:0;text-align:center}._1huYJmMw7MvnSA8Jx6ipPc{margin-top:-1.42857rem!important}._11rbr4IWl8MVPk-OpOgS-8{display:block;padding-left:1rem}._11rbr4IWl8MVPk-OpOgS-8 h3,._11rbr4IWl8MVPk-OpOgS-8 h4{color:#a4a4a4}._11rbr4IWl8MVPk-OpOgS-8 h3{font-weight:600;letter-spacing:.07143rem}._3J7BKImB0fqHRmcemxdwBD{border-collapse:collapse;position:relative;width:100%}._3J7BKImB0fqHRmcemxdwBD>caption{background-color:#fbfbfb;border:0;-webkit-box-shadow:0 0 .21429rem .07143rem rgba(0,0,0,.15);-moz-box-shadow:0 0 .21429rem .07143rem rgba(0,0,0,.15);box-shadow:0 0 .21429rem .07143rem rgba(0,0,0,.15);border-bottom:none;caption-side:top;font-weight:700;height:3.57143rem;padding:1.28571rem;text-align:left}.tGAA-mcDe4h0Kl0_I4TWh{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;line-height:1rem;text-align:left}.tGAA-mcDe4h0Kl0_I4TWh>.mrEG91xGsvMxPkV_BSHB7{line-height:1.2rem;padding-top:.3rem}._3hdpivn7sDJ3xmfRr_L0hE{border-bottom:none!important}._38xeGLd-Bf2pH3ihiOD_uf{display:none;line-height:1.3rem;min-height:4.28571rem;white-space:pre-line}._38xeGLd-Bf2pH3ihiOD_uf._1T2JK7o9fBzUqSKQ0oVmGu{display:block}._1jq54FI8xnPy5p6yWt9vVN{display:table}._2cJrawPZYm1ju-Sbh5_gNK{display:table-cell;width:1.42857rem}._1FkFMuUDAQROs8rRwk-RAP:hover{color:#0087e6}._1XwQXeibL9dmt4zHGZNWPz{max-width:14.28571rem}._2qK8_40DEtw7CCZx8cfyq1{height:5.71429rem}.nDp8knV4VL7tRH9TGAGxN{min-width:2.85714rem}._3o5h_Hv_WbDY2u5XRmE7iq{display:table-cell;line-height:1.3rem}._3CWGzC_MtsoOOGytobFVjv{height:4.28571rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%}.lkafYhnVeNOMBW2-ve-Ny{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;min-height:100%}._3o5h_Hv_WbDY2u5XRmE7iq p{-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;-webkit-flex-basis:100%;-ms-flex-preferred-size:100%;flex-basis:100%;margin:0;white-space:pre-line;width:100%}._11ij8L1SYmHYQUqUcaJbWC{text-align:center}._1CpYUJa2zh6CZlrzX_N6tp{vertical-align:top}._2aiFN8oVnBXXKznLrHMvbZ{border-bottom:.07143rem solid #dfdfdf;border-top:.07143rem solid #dfdfdf}._2aiFN8oVnBXXKznLrHMvbZ._3AyeQlRcBbP_3Qvqx5qut7 ._3p3uvotYRsJYtnpiwMkBzr,._2aiFN8oVnBXXKznLrHMvbZ._3AyeQlRcBbP_3Qvqx5qut7 .mrEG91xGsvMxPkV_BSHB7{height:2.14286rem;min-height:2.14286rem}._1QO7U5CZ_Rdm_LzTZJZHy7,._1RWPVqHtM2WheneqezEGif{margin:0;padding:.35714rem 1.42857rem .35714rem 0}._1QO7U5CZ_Rdm_LzTZJZHy7:last-child,._1RWPVqHtM2WheneqezEGif:last-child{padding-right:1.42857rem}@media only screen and (min-width:640px){._1QO7U5CZ_Rdm_LzTZJZHy7:last-child,._1RWPVqHtM2WheneqezEGif:last-child{padding-right:2.14286rem}}._1QO7U5CZ_Rdm_LzTZJZHy7:first-child,._1RWPVqHtM2WheneqezEGif:first-child{padding-left:1.42857rem}@media only screen and (min-width:640px){._1QO7U5CZ_Rdm_LzTZJZHy7:first-child,._1RWPVqHtM2WheneqezEGif:first-child{padding-left:2.14286rem}}._3p3uvotYRsJYtnpiwMkBzr,.mrEG91xGsvMxPkV_BSHB7{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;min-height:3.57143rem}._3V1_QaQU_CHKoZGfxmK0L2,.rC_7dnuEjLDH1zAhwn9lA{display:block;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis}._1QO7U5CZ_Rdm_LzTZJZHy7.TW_8Xo180FsjFSQJlPug9,._1RWPVqHtM2WheneqezEGif.TW_8Xo180FsjFSQJlPug9{position:relative}._1QO7U5CZ_Rdm_LzTZJZHy7.TW_8Xo180FsjFSQJlPug9:before,._1RWPVqHtM2WheneqezEGif.TW_8Xo180FsjFSQJlPug9:before{bottom:0;-webkit-box-shadow:inset .5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);-moz-box-shadow:inset .5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);box-shadow:inset .5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);content:\"\";display:block;left:0;position:absolute;right:0;top:0}._1QO7U5CZ_Rdm_LzTZJZHy7._2X-di6EUaDkW5WerzRz5c0,._1RWPVqHtM2WheneqezEGif._2X-di6EUaDkW5WerzRz5c0{position:relative}._1QO7U5CZ_Rdm_LzTZJZHy7._2X-di6EUaDkW5WerzRz5c0:before,._1RWPVqHtM2WheneqezEGif._2X-di6EUaDkW5WerzRz5c0:before{bottom:0;-webkit-box-shadow:inset -.5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);-moz-box-shadow:inset -.5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);box-shadow:inset -.5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);content:\"\";display:block;left:0;position:absolute;right:0;top:0}._1QO7U5CZ_Rdm_LzTZJZHy7.TW_8Xo180FsjFSQJlPug9._1QO7U5CZ_Rdm_LzTZJZHy7._2X-di6EUaDkW5WerzRz5c0:before,._1RWPVqHtM2WheneqezEGif.TW_8Xo180FsjFSQJlPug9._1RWPVqHtM2WheneqezEGif._2X-di6EUaDkW5WerzRz5c0:before{-webkit-box-shadow:inset .5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196),inset -.5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);-moz-box-shadow:inset .5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196),inset -.5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);box-shadow:inset .5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196),inset -.5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196)}._1QO7U5CZ_Rdm_LzTZJZHy7._3-DaoLFg7bzdthI94zDA7k,._1RWPVqHtM2WheneqezEGif._3-DaoLFg7bzdthI94zDA7k{text-align:left;vertical-align:top}._1QO7U5CZ_Rdm_LzTZJZHy7._3-DaoLFg7bzdthI94zDA7k>.mrEG91xGsvMxPkV_BSHB7,._1RWPVqHtM2WheneqezEGif._3-DaoLFg7bzdthI94zDA7k>.mrEG91xGsvMxPkV_BSHB7{-webkit-box-align:initial;-webkit-align-items:initial;-moz-box-align:initial;-ms-flex-align:initial;align-items:initial;display:table-caption;-webkit-box-pack:initial;-webkit-justify-content:initial;-moz-box-pack:initial;-ms-flex-pack:initial;justify-content:initial}._1QO7U5CZ_Rdm_LzTZJZHy7.hCBx9S9bHsZkYKNAKruAh,._1RWPVqHtM2WheneqezEGif.hCBx9S9bHsZkYKNAKruAh{width:5.71429rem}._1QO7U5CZ_Rdm_LzTZJZHy7.hCBx9S9bHsZkYKNAKruAh._2AgoSVJ456BqAALpFGaSqd,._1RWPVqHtM2WheneqezEGif.hCBx9S9bHsZkYKNAKruAh._2AgoSVJ456BqAALpFGaSqd{display:none}._1QO7U5CZ_Rdm_LzTZJZHy7.hCBx9S9bHsZkYKNAKruAh>.mrEG91xGsvMxPkV_BSHB7,._1RWPVqHtM2WheneqezEGif.hCBx9S9bHsZkYKNAKruAh>.mrEG91xGsvMxPkV_BSHB7{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-top:0}._1QO7U5CZ_Rdm_LzTZJZHy7{width:15%}.mrEG91xGsvMxPkV_BSHB7{height:3.57143rem}._3p3uvotYRsJYtnpiwMkBzr{-webkit-box-align:baseline;-webkit-align-items:baseline;-moz-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}._39TcnEr2ktC6-r3IUd5dzX{-webkit-flex-basis:auto;-ms-flex-preferred-size:auto;flex-basis:auto;margin-top:.28571rem;text-align:left;width:100%}._1YJPhW8WRxZQ3H7_w3qua4{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-flex-direction:column;-moz-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}._1YJPhW8WRxZQ3H7_w3qua4,._24Gy8G8MepgpN33Q-XMLTU{-webkit-box-direction:normal;-moz-box-direction:normal}._24Gy8G8MepgpN33Q-XMLTU{-webkit-box-orient:horizontal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row}._2xEojGqo6BgdIcKwZV7bru{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:50%}._2xEojGqo6BgdIcKwZV7bru+._2xEojGqo6BgdIcKwZV7bru{margin-left:1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ProgressTestRubricView_selectionTable_header": "_14ArCMdvqHMro5whcw2kd9",
	"ProgressTestRubricView_selectionTable_header_inner": "_1edgZNiMzo_zrrxJN8r9dq",
	"ProgressTestRubricView_section": "-QMtxGtFieuyySAbJytXb",
	"ProgressTestRubricView_studentHorizontalSelect_options": "_2L8gGHkaEwLbN1bWVKsHn6",
	"ProgressTestRubricView_studentHorizontalSelect_options_score": "_10utIiu-yH1s5iWOYDRbd7",
	"ProgressTestRubricView_studentDropdown_options": "_1huYJmMw7MvnSA8Jx6ipPc",
	"ProgressTestRubricView_targetCopy": "_11rbr4IWl8MVPk-OpOgS-8",
	"ProgressTestRubricView_table": "_3J7BKImB0fqHRmcemxdwBD",
	"ProgressTestRubricView_table_subskill_name": "tGAA-mcDe4h0Kl0_I4TWh",
	"Th_wrap": "mrEG91xGsvMxPkV_BSHB7",
	"ProgressTestRubricView_table_row": "_3hdpivn7sDJ3xmfRr_L0hE",
	"ProgressTestRubricView_table_row_instructionText": "_38xeGLd-Bf2pH3ihiOD_uf",
	"__visible": "_1T2JK7o9fBzUqSKQ0oVmGu",
	"ProgressTestRubricView_tableForOneSubSkill": "_1jq54FI8xnPy5p6yWt9vVN",
	"ProgressTestRubricView_tableForOneSubSkill_tooltip": "_2cJrawPZYm1ju-Sbh5_gNK",
	"ProgressTestRubricView_tableForOneSubSkill_tooltip_icon": "_1FkFMuUDAQROs8rRwk-RAP",
	"ProgressTestRubricView_tableForOneSubSkill_tooltip_inner": "_1XwQXeibL9dmt4zHGZNWPz",
	"ProgressTestRubricView_tableForOneSubSkill_row": "_2qK8_40DEtw7CCZx8cfyq1",
	"ProgressTestRubricView_tableForOneSubSkill_pointColumn_button": "nDp8knV4VL7tRH9TGAGxN",
	"ProgressTestRubricView_tableForOneSubSkill_instructionText": "_3o5h_Hv_WbDY2u5XRmE7iq",
	"ProgressTestRubricView_tableForOneSubSkill_instructionText_viewport": "_3CWGzC_MtsoOOGytobFVjv",
	"ProgressTestRubricView_tableForOneSubSkill_instructionText_inner": "lkafYhnVeNOMBW2-ve-Ny",
	"ProgressTestRubricView_tableForAllSubSkills": "_11ij8L1SYmHYQUqUcaJbWC",
	"ProgressTestRubricView_tableForAllSubSkills_pointCell": "_1CpYUJa2zh6CZlrzX_N6tp",
	"Tr": "_2aiFN8oVnBXXKznLrHMvbZ",
	"__firstRow": "_3AyeQlRcBbP_3Qvqx5qut7",
	"Td_wrap": "_3p3uvotYRsJYtnpiwMkBzr",
	"Th": "_1QO7U5CZ_Rdm_LzTZJZHy7",
	"Td": "_1RWPVqHtM2WheneqezEGif",
	"Th_content": "_3V1_QaQU_CHKoZGfxmK0L2",
	"Td_content": "rC_7dnuEjLDH1zAhwn9lA",
	"__shadowLeft": "TW_8Xo180FsjFSQJlPug9",
	"__shadowRight": "_2X-di6EUaDkW5WerzRz5c0",
	"__left": "_3-DaoLFg7bzdthI94zDA7k",
	"__leftAlignedAbilityName": "hCBx9S9bHsZkYKNAKruAh",
	"__hidden": "_2AgoSVJ456BqAALpFGaSqd",
	"RubricPointButton_container": "_39TcnEr2ktC6-r3IUd5dzX",
	"Masonry": "_1YJPhW8WRxZQ3H7_w3qua4",
	"Masonry_multi": "_24Gy8G8MepgpN33Q-XMLTU",
	"Masonry_flow": "_2xEojGqo6BgdIcKwZV7bru"
};

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1432);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!./alertify.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!./alertify.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".alertify .ajs-dimmer{margin:0;background-color:#252525;opacity:.5}.alertify .ajs-dimmer,.alertify .ajs-modal{position:fixed;z-index:1981;top:0;right:0;bottom:0;left:0;padding:0}.alertify .ajs-modal{overflow-y:auto}.alertify .ajs-dialog{position:relative;margin:5% auto;min-height:110px;max-width:500px;padding:24px 24px 0;outline:0;background-color:#fff}.alertify .ajs-dialog.ajs-capture:before{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;display:block;z-index:1}.alertify .ajs-reset{position:absolute!important;display:inline!important;width:0!important;height:0!important;opacity:0!important}.alertify .ajs-commands{position:absolute;right:4px;margin:-14px 24px 0 0;z-index:2}.alertify .ajs-commands button{display:none;width:10px;height:10px;margin-left:10px;padding:10px;border:0;background-color:transparent;background-repeat:no-repeat;background-position:50%;cursor:pointer}.alertify .ajs-commands button.ajs-close{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNy8xMy8xNOrZqugAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzbovLKMAAAAh0lEQVQYlY2QsQ0EIQwEB9cBAR1CJUaI/gigDnwR6NBL/7/xWLNrZ2b8EwGotVpr7eOitWa1VjugiNB7R1UPrKrWe0dEAHBbXUqxMQbeewDmnHjvyTm7C3zDwAUd9c63YQdUVdu6EAJzzquz7HXvTiklt+H9DQFYaxFjvDqllFyMkbXWvfpXHjJrWFgdBq/hAAAAAElFTkSuQmCC)}.alertify .ajs-commands button.ajs-maximize{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNy8xMy8xNOrZqugAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzbovLKMAAAAOUlEQVQYlWP8//8/AzGAhYGBgaG4uBiv6t7eXkYmooxjYGAgWiELsvHYFMCcRX2rSXcjoSBiJDbAAeD+EGu+8BZcAAAAAElFTkSuQmCC)}.alertify .ajs-header{margin:-24px;margin-bottom:0;padding:16px 24px;background-color:#fff}.alertify .ajs-body{min-height:56px}.alertify .ajs-body .ajs-content{padding:16px 24px 16px 16px}.alertify .ajs-footer{padding:4px;margin-left:-24px;margin-right:-24px;min-height:43px;background-color:#fff}.alertify .ajs-footer .ajs-buttons.ajs-primary{text-align:right}.alertify .ajs-footer .ajs-buttons.ajs-primary .ajs-button{margin:4px}.alertify .ajs-footer .ajs-buttons.ajs-auxiliary{float:left;clear:none;text-align:left}.alertify .ajs-footer .ajs-buttons.ajs-auxiliary .ajs-button{margin:4px}.alertify .ajs-footer .ajs-buttons .ajs-button{min-width:88px;min-height:35px}.alertify .ajs-handle{position:absolute;display:none;width:10px;height:10px;right:0;bottom:0;z-index:1;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNy8xMS8xNEDQYmMAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzbovLKMAAAAQ0lEQVQYlaXNMQoAIAxD0dT7H657l0KX3iJuUlBUNOsPPCGJm7VDp6ryeMxMuDsAQH7owW3pyn3RS26iKxERMLN3ugOaAkaL3sWVigAAAABJRU5ErkJggg==);-webkit-transform:scaleX(1);transform:scaleX(1);cursor:se-resize}.alertify.ajs-no-overflow .ajs-body .ajs-content{overflow:hidden!important}.alertify.ajs-no-padding.ajs-maximized .ajs-body .ajs-content{left:0;right:0;padding:0}.alertify.ajs-no-padding:not(.ajs-maximized) .ajs-body{margin-left:-24px;margin-right:-24px}.alertify.ajs-no-padding:not(.ajs-maximized) .ajs-body .ajs-content{padding:0}.alertify.ajs-no-padding.ajs-resizable .ajs-body .ajs-content{left:0;right:0}.alertify.ajs-closable .ajs-commands button.ajs-close,.alertify.ajs-maximizable .ajs-commands button.ajs-maximize,.alertify.ajs-maximizable .ajs-commands button.ajs-restore{display:inline-block}.alertify.ajs-maximized .ajs-dialog{width:100%!important;height:100%!important;max-width:none!important;margin:0 auto!important;top:0!important;left:0!important}.alertify.ajs-maximized.ajs-modeless .ajs-modal{position:fixed!important;min-height:100%!important;max-height:none!important;margin:0!important}.alertify.ajs-maximized .ajs-commands button.ajs-maximize{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNy8xMy8xNOrZqugAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzbovLKMAAAASklEQVQYlZWQ0QkAMQhDtXRincOZX78KVtrDCwgqJNEoIB3MPLj7lRUROlpyVXGzby6zWuY+kz6tj5sBMTMAyVV3/595RbOh3cAXsww1raeiOcoAAAAASUVORK5CYII=)}.alertify.ajs-maximized .ajs-dialog,.alertify.ajs-resizable .ajs-dialog{padding:0}.alertify.ajs-maximized .ajs-commands,.alertify.ajs-resizable .ajs-commands{margin:14px 24px 0 0}.alertify.ajs-maximized .ajs-header,.alertify.ajs-resizable .ajs-header{position:absolute;top:0;left:0;right:0;margin:0;padding:16px 24px}.alertify.ajs-maximized .ajs-body,.alertify.ajs-resizable .ajs-body{min-height:224px;display:inline-block}.alertify.ajs-maximized .ajs-body .ajs-content,.alertify.ajs-resizable .ajs-body .ajs-content{position:absolute;top:50px;right:24px;bottom:50px;left:24px;overflow:auto}.alertify.ajs-maximized .ajs-footer,.alertify.ajs-resizable .ajs-footer{position:absolute;left:0;right:0;bottom:0;margin:0}.alertify.ajs-resizable:not(.ajs-maximized) .ajs-dialog{min-width:548px}.alertify.ajs-resizable:not(.ajs-maximized) .ajs-handle{display:block}.alertify.ajs-movable:not(.ajs-maximized) .ajs-header{cursor:move}.alertify.ajs-modeless .ajs-dimmer,.alertify.ajs-modeless .ajs-reset{display:none}.alertify.ajs-modeless .ajs-modal{overflow:visible;max-width:none;max-height:0}.alertify.ajs-modeless.ajs-pinnable .ajs-commands button.ajs-pin{display:inline-block;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNy8xMy8xNOrZqugAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzbovLKMAAAAQklEQVQYlcWPMQ4AIAwCqU9u38GbcbHRWN1MvKQDhQFMEpKImGJA0gCgnYw0V0rwxseg5erT4oSkQVI5d9f+e9+xA0NbLpWfitPXAAAAAElFTkSuQmCC)}.alertify.ajs-modeless.ajs-unpinned .ajs-modal{position:absolute}.alertify.ajs-modeless.ajs-unpinned .ajs-commands button.ajs-pin{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNy8xMy8xNOrZqugAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzbovLKMAAAAO0lEQVQYlWP8//8/AzGAiShV6AqLi4txGs+CLoBLMYbC3t5eRmyaWfBZhwwYkX2NTxPRvibKjRhW4wMAhxkYGbLu3pEAAAAASUVORK5CYII=)}.alertify.ajs-modeless:not(.ajs-unpinned) .ajs-body{max-height:500px;overflow:auto}.alertify.ajs-basic .ajs-header{opacity:0}.alertify.ajs-basic .ajs-footer{visibility:hidden}.alertify.ajs-frameless .ajs-header{position:absolute;top:0;left:0;right:0;min-height:60px;margin:0;padding:0;opacity:0;z-index:1}.alertify.ajs-frameless .ajs-footer{display:none}.alertify.ajs-frameless .ajs-body .ajs-content{position:absolute;top:0;right:0;bottom:0;left:0}.alertify.ajs-frameless:not(.ajs-resizable) .ajs-dialog{padding-top:0}.alertify.ajs-frameless:not(.ajs-resizable) .ajs-dialog .ajs-commands{margin-top:0}.ajs-no-overflow{overflow:hidden!important;outline:none}.ajs-no-overflow.ajs-fixed{position:fixed;top:0;right:0;bottom:0;left:0;overflow-y:scroll!important}.ajs-no-selection,.ajs-no-selection *{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media screen and (max-width:568px){.alertify .ajs-dialog{min-width:150px}.alertify:not(.ajs-maximized) .ajs-modal{padding:0 5%}.alertify:not(.ajs-maximized).ajs-resizable .ajs-dialog{min-width:0;min-width:auto}}@-moz-document url-prefix(){.alertify button:focus{outline:1px dotted #3593d2}}.alertify .ajs-dimmer,.alertify .ajs-modal{-webkit-transform:translateZ(0);transform:translateZ(0);transition-property:opacity,visibility;transition-timing-function:linear;transition-duration:.25s}.alertify.ajs-hidden .ajs-dimmer,.alertify.ajs-hidden .ajs-modal{visibility:hidden;opacity:0}.alertify.ajs-in:not(.ajs-hidden) .ajs-dialog{-webkit-animation-duration:.5s;animation-duration:.5s}.alertify.ajs-out.ajs-hidden .ajs-dialog{-webkit-animation-duration:.25s;animation-duration:.25s}.alertify .ajs-dialog.ajs-shake{-webkit-animation-name:ajs-shake;animation-name:ajs-shake;-webkit-animation-duration:.1s;animation-duration:.1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}@-webkit-keyframes ajs-shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}@keyframes ajs-shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}.alertify.ajs-slide.ajs-in:not(.ajs-hidden) .ajs-dialog{-webkit-animation-name:ajs-slideIn;animation-name:ajs-slideIn;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1.275);animation-timing-function:cubic-bezier(.175,.885,.32,1.275)}.alertify.ajs-slide.ajs-out.ajs-hidden .ajs-dialog{-webkit-animation-name:ajs-slideOut;animation-name:ajs-slideOut;-webkit-animation-timing-function:cubic-bezier(.6,-.28,.735,.045);animation-timing-function:cubic-bezier(.6,-.28,.735,.045)}.alertify.ajs-zoom.ajs-in:not(.ajs-hidden) .ajs-dialog{-webkit-animation-name:ajs-zoomIn;animation-name:ajs-zoomIn}.alertify.ajs-zoom.ajs-out.ajs-hidden .ajs-dialog{-webkit-animation-name:ajs-zoomOut;animation-name:ajs-zoomOut}.alertify.ajs-fade.ajs-in:not(.ajs-hidden) .ajs-dialog{-webkit-animation-name:ajs-fadeIn;animation-name:ajs-fadeIn}.alertify.ajs-fade.ajs-out.ajs-hidden .ajs-dialog{-webkit-animation-name:ajs-fadeOut;animation-name:ajs-fadeOut}.alertify.ajs-pulse.ajs-in:not(.ajs-hidden) .ajs-dialog{-webkit-animation-name:ajs-pulseIn;animation-name:ajs-pulseIn}.alertify.ajs-pulse.ajs-out.ajs-hidden .ajs-dialog{-webkit-animation-name:ajs-pulseOut;animation-name:ajs-pulseOut}.alertify.ajs-flipx.ajs-in:not(.ajs-hidden) .ajs-dialog{-webkit-animation-name:ajs-flipInX;animation-name:ajs-flipInX}.alertify.ajs-flipx.ajs-out.ajs-hidden .ajs-dialog{-webkit-animation-name:ajs-flipOutX;animation-name:ajs-flipOutX}.alertify.ajs-flipy.ajs-in:not(.ajs-hidden) .ajs-dialog{-webkit-animation-name:ajs-flipInY;animation-name:ajs-flipInY}.alertify.ajs-flipy.ajs-out.ajs-hidden .ajs-dialog{-webkit-animation-name:ajs-flipOutY;animation-name:ajs-flipOutY}@-webkit-keyframes ajs-pulseIn{0%,20%,40%,60%,80%,to{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{opacity:1;-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes ajs-pulseIn{0%,20%,40%,60%,80%,to{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{opacity:1;-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}@-webkit-keyframes ajs-pulseOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}to{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}}@keyframes ajs-pulseOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}to{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}}@-webkit-keyframes ajs-zoomIn{0%{opacity:0;-webkit-transform:scale3d(.25,.25,.25);transform:scale3d(.25,.25,.25)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes ajs-zoomIn{0%{opacity:0;-webkit-transform:scale3d(.25,.25,.25);transform:scale3d(.25,.25,.25)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}@-webkit-keyframes ajs-zoomOut{0%{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}to{opacity:0;-webkit-transform:scale3d(.25,.25,.25);transform:scale3d(.25,.25,.25)}}@keyframes ajs-zoomOut{0%{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}to{opacity:0;-webkit-transform:scale3d(.25,.25,.25);transform:scale3d(.25,.25,.25)}}@-webkit-keyframes ajs-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes ajs-fadeIn{0%{opacity:0}to{opacity:1}}@-webkit-keyframes ajs-fadeOut{0%{opacity:1}to{opacity:0}}@keyframes ajs-fadeOut{0%{opacity:1}to{opacity:0}}@-webkit-keyframes ajs-flipInX{0%{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);transition-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);transition-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotateX(10deg);transform:perspective(400px) rotateX(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateX(-5deg);transform:perspective(400px) rotateX(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes ajs-flipInX{0%{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);transition-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);transition-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotateX(10deg);transform:perspective(400px) rotateX(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateX(-5deg);transform:perspective(400px) rotateX(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@-webkit-keyframes ajs-flipOutX{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);opacity:1}to{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}}@keyframes ajs-flipOutX{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);opacity:1}to{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}}@-webkit-keyframes ajs-flipInY{0%{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);transition-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotateY(-20deg);transform:perspective(400px) rotateY(-20deg);transition-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotateY(10deg);transform:perspective(400px) rotateY(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateY(-5deg);transform:perspective(400px) rotateY(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes ajs-flipInY{0%{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);transition-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotateY(-20deg);transform:perspective(400px) rotateY(-20deg);transition-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotateY(10deg);transform:perspective(400px) rotateY(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateY(-5deg);transform:perspective(400px) rotateY(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@-webkit-keyframes ajs-flipOutY{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateY(-15deg);transform:perspective(400px) rotateY(-15deg);opacity:1}to{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}}@keyframes ajs-flipOutY{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateY(-15deg);transform:perspective(400px) rotateY(-15deg);opacity:1}to{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}}@-webkit-keyframes ajs-slideIn{0%{margin-top:-100%}to{margin-top:5%}}@keyframes ajs-slideIn{0%{margin-top:-100%}to{margin-top:5%}}@-webkit-keyframes ajs-slideOut{0%{margin-top:5%}to{margin-top:-100%}}@keyframes ajs-slideOut{0%{margin-top:5%}to{margin-top:-100%}}.alertify-notifier{position:fixed;width:0;overflow:visible;z-index:1982}.alertify-notifier,.alertify-notifier .ajs-message{-webkit-transform:translateZ(0);transform:translateZ(0)}.alertify-notifier .ajs-message{position:relative;width:260px;max-height:0;padding:0;opacity:0;margin:0;transition-duration:.25s;transition-timing-function:linear}.alertify-notifier .ajs-message.ajs-visible{transition-duration:.5s;transition-timing-function:cubic-bezier(.175,.885,.32,1.275);opacity:1;max-height:100%;padding:15px;margin-top:10px}.alertify-notifier .ajs-message.ajs-success{background:rgba(91,189,114,.95)}.alertify-notifier .ajs-message.ajs-error{background:rgba(217,92,92,.95)}.alertify-notifier .ajs-message.ajs-warning{background:hsla(54,86%,92%,.95)}.alertify-notifier .ajs-message .ajs-close{position:absolute;top:0;right:0;width:16px;height:16px;cursor:pointer;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAABGdBTUEAALGPC/xhBQAAAFBJREFUGBl1j0EKADEIA+ve/P9f9bh1hEihNBfjVCO1v7RKVqJK4h8gM5cAPR42AkQEpSXPwMTyoi13n5N9YqJehm3Fnr7nL1D0ZEbD5OubGyC7a9gx+9eNAAAAAElFTkSuQmCC);background-repeat:no-repeat;background-position:50%;background-color:rgba(0,0,0,.5);border-top-right-radius:2px}.alertify-notifier.ajs-top{top:10px}.alertify-notifier.ajs-bottom{bottom:10px}.alertify-notifier.ajs-right{right:10px}.alertify-notifier.ajs-right .ajs-message{right:-320px}.alertify-notifier.ajs-right .ajs-message.ajs-visible{right:290px}.alertify-notifier.ajs-left{left:10px}.alertify-notifier.ajs-left .ajs-message{left:-300px}.alertify-notifier.ajs-left .ajs-message.ajs-visible{left:0}", ""]);

// exports


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1434);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1MtR0UcXRR5qrQ17oJ7Uvf{float:left;margin-bottom:1.42857rem;margin-right:2.14286rem;padding-right:1rem;width:100%}._1aqRpPMJuwzqMFQhdXlJOO{color:#b4b4b4;font-size:.85714rem;font-weight:400;line-height:1.8;margin:0}.K_1FCmKb_j_w80vIXx-L3{border-bottom:.07143rem solid #ccc;font-size:1rem;margin:.4em 0;white-space:pre-line}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Detailsboard_board": "_1MtR0UcXRR5qrQ17oJ7Uvf",
	"Detailsboard_h5": "_1aqRpPMJuwzqMFQhdXlJOO",
	"Detailsboard_p": "K_1FCmKb_j_w80vIXx-L3"
};

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1436);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2Z4EU1u2RRUueuR9a2UrrU{max-height:80vh;max-width:64.28571rem;overflow:hidden;overflow-y:scroll}", ""]);

// exports
exports.locals = {
	"InfoDialog": "_2Z4EU1u2RRUueuR9a2UrrU"
};

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _SimpleTable = __webpack_require__(133);

var _SimpleTable2 = _interopRequireDefault(_SimpleTable);

var _immutable = __webpack_require__(3);

var _style = __webpack_require__(1438);

var _style2 = _interopRequireDefault(_style);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCollapse = __webpack_require__(647);

var _accessors = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var abilitiesSortMapper = function abilitiesSortMapper(ability) {
  return ability.point;
};

var RubricSkillTable = function (_PureComponent) {
  _inherits(RubricSkillTable, _PureComponent);

  function RubricSkillTable() {
    _classCallCheck(this, RubricSkillTable);

    return _possibleConstructorReturn(this, (RubricSkillTable.__proto__ || Object.getPrototypeOf(RubricSkillTable)).apply(this, arguments));
  }

  _createClass(RubricSkillTable, [{
    key: '_isAbilityCurrentlySelected',
    value: function _isAbilityCurrentlySelected(subSkillId, abilityId) {
      return this.props.subSkillsToAbilityIds.get(subSkillId) === abilityId;
    }
  }, {
    key: '_isInstructionTextsExpanded',
    value: function _isInstructionTextsExpanded(skillId, subSkillId) {
      return !!this.props.showInstructionsFor.getIn([skillId, subSkillId]);
    }
  }, {
    key: '_getButtonTypeForAbility',
    value: function _getButtonTypeForAbility(ability, maxAbilityPoint) {
      if (ability.point === 0) {
        return _omniCommonUi.Button.Type.black;
      }

      var relativeAbility = ability.point / maxAbilityPoint;
      if (relativeAbility >= 0.8) {
        return _omniCommonUi.Button.Type.correct;
      }

      if (relativeAbility >= 0.7) {
        return _omniCommonUi.Button.Type.needsAttention;
      }

      return _omniCommonUi.Button.Type.wrong;
    }
  }, {
    key: '_isAbilityCheckAll',
    value: function _isAbilityCheckAll(abilityId) {
      var checkAll = true;
      this.props.subSkillsToAbilityIds.forEach(function (resultAbilityId) {
        if (abilityId !== resultAbilityId) {
          checkAll = false;
        }
      });
      return checkAll;
    }
  }, {
    key: '_renderHeader',
    value: function _renderHeader() {
      var _props = this.props,
          rubricSkill = _props.rubricSkill,
          onTargetLanguageButtonClick = _props.onTargetLanguageButtonClick,
          subSkillsToAbilityIds = _props.subSkillsToAbilityIds;

      var headingClass = _style2.default.BigTable_heading;

      var maxAbilityPoint = rubricSkill.abilities.max(function (a, b) {
        return a.point - b.point;
      }).point;
      var maxPoint = rubricSkill.subSkills.size * maxAbilityPoint;

      var getScoreByAbiltyId = function getScoreByAbiltyId(abilityId) {
        var ability = rubricSkill.abilities.find(function (ab) {
          return ab.abilityId === abilityId;
        });
        return ability && ability.point || 0;
      };
      var currentPoint = subSkillsToAbilityIds.map(function (v) {
        return getScoreByAbiltyId(v);
      }).reduce(function (pre, current) {
        return pre + current;
      });

      var targetLanguageBtnClassName = _style2.default.BigTable_targetLanguageBtn;
      return _react2.default.createElement(
        _omniCommonUi.PageCard.Heading,
        { className: headingClass,
          text: rubricSkill.name + ' Rubric ' + (currentPoint || '-') + '/' + maxPoint },
        rubricSkill && rubricSkill.targetLanguageCategories && rubricSkill.targetLanguageCategories.size > 0 && _react2.default.createElement(
          _omniCommonUi.Button,
          { type: _omniCommonUi.Button.Type.default,
            onClick: function onClick() {
              return onTargetLanguageButtonClick(rubricSkill.skillId);
            },
            className: targetLanguageBtnClassName },
          _react2.default.createElement(
            'span',
            null,
            'TARGET LANGUAGE'
          )
        )
      );
    }
  }, {
    key: '_renderCheckAll',
    value: function _renderCheckAll(rubricSkill, hasSkillDesciption) {
      var _this2 = this;

      return _react2.default.createElement(
        _SimpleTable2.default.Row,
        null,
        _react2.default.createElement(_SimpleTable2.default.Cell, { className: _style2.default.BigTable_subSkillCell }),
        rubricSkill.abilities.sortBy(abilitiesSortMapper).map(function (ability) {
          var skillId = rubricSkill.skillId;

          return _react2.default.createElement(
            _SimpleTable2.default.Cell,
            { className: _style2.default.BigTable_abilityCell },
            _react2.default.createElement(
              'label',
              { key: skillId + '-' + ability.abilityId,
                htmlFor: skillId + '-' + ability.abilityId },
              _react2.default.createElement(_omniCommonUi.Checkbox, { id: skillId + '-' + ability.abilityId,
                onChange: function onChange(checked) {
                  return _this2.props.onCheckAllAbility(skillId, checked, ability.abilityId);
                },
                disabled: !_this2.props.isUnitQuiz && rubricSkill.name === _accessors.shouldDisabledSkillName,
                name: skillId + '-' + ability.abilityId,
                checked: _this2._isAbilityCheckAll(ability.abilityId) }),
              _react2.default.createElement(
                'span',
                { className: _style2.default.BigTable_subSkillCell_span },
                'grade all '
              )
            )
          );
        }),
        hasSkillDesciption && _react2.default.createElement(_SimpleTable2.default.Cell, { className: _style2.default.BigTable_toggleCell })
      );
    }
  }, {
    key: '_renderScores',
    value: function _renderScores(subSkill, ability, maxAbilityPoint, hasSkillDesciption) {
      var _props2 = this.props,
          rubricSkill = _props2.rubricSkill,
          isMarking = _props2.isMarking,
          onScoreClick = _props2.onScoreClick,
          isUnitQuiz = _props2.isUnitQuiz;

      var abilityDescription = subSkill.abilityDescriptions.find(function (ad) {
        return ability.abilityId === ad.abilityId;
      }) || {};
      return _react2.default.createElement(
        'div',
        { key: ability.abilityId, className: _style2.default.BigTable_scoreCell_wrap },
        _react2.default.createElement(
          _omniCommonUi.Button,
          { disabled: !isUnitQuiz && rubricSkill.name === _accessors.shouldDisabledSkillName || !isMarking,
            className: _style2.default.BigTable_scoreCell_wrap_button,
            active: this._isAbilityCurrentlySelected(subSkill.subSkillId, ability.abilityId),
            onClick: function onClick() {
              return onScoreClick(subSkill.subSkillId, ability.abilityId, rubricSkill.skillId);
            },
            type: this._getButtonTypeForAbility(ability, maxAbilityPoint),
            block: true },
          ability.point
        ),
        hasSkillDesciption && _react2.default.createElement(
          _reactCollapse.Collapse,
          { isOpened: this._isInstructionTextsExpanded(rubricSkill.skillId, subSkill.subSkillId) },
          _react2.default.createElement(
            'p',
            { className: _style2.default.BigTable_scoreCell_wrap_instructions },
            abilityDescription.note || ''
          )
        )
      );
    }
  }, {
    key: '_renderTableHeader',
    value: function _renderTableHeader(isMarking, rubricSkill, hasSkillDesciption) {
      var tHeadRow = _react2.default.createElement(
        _SimpleTable2.default.Row,
        null,
        _react2.default.createElement(_SimpleTable2.default.Cell, { columnId: { columnId: 'subskills' },
          className: _style2.default.BigTable_subSkillCell }),
        rubricSkill.abilities.sortBy(abilitiesSortMapper).map(function (ability) {
          return _react2.default.createElement(
            _SimpleTable2.default.Cell,
            { key: ability.abilityId,
              columnId: { columnId: 'ability', ability: ability },
              className: _style2.default.BigTable_abilityCell },
            ability.name
          );
        }),
        hasSkillDesciption && _react2.default.createElement(_SimpleTable2.default.Cell, { columnId: { columnId: 'expand' },
          className: _style2.default.BigTable_toggleCell })
      );
      if (isMarking) {
        return _react2.default.createElement(
          _SimpleTable2.default.Header,
          null,
          tHeadRow,
          this._renderCheckAll(rubricSkill, hasSkillDesciption)
        );
      }
      return _react2.default.createElement(
        _SimpleTable2.default.Header,
        null,
        tHeadRow
      );
    }
  }, {
    key: '_renderTable',
    value: function _renderTable() {
      var _this3 = this;

      var _props3 = this.props,
          isMarking = _props3.isMarking,
          rubricSkill = _props3.rubricSkill,
          onIntructionToggleClick = _props3.onIntructionToggleClick;

      var maxAbilityPoint = rubricSkill.abilities.max(function (a, b) {
        return a.point - b.point;
      }).point;
      var hasSkillDesciption = rubricSkill.subSkills.some(function (subkill) {
        return subkill.abilityDescriptions && subkill.abilityDescriptions.some(function (abilityDescription) {
          return abilityDescription.note;
        });
      });

      return _react2.default.createElement(
        _SimpleTable2.default,
        { rows: rubricSkill.subSkills, onlyRowDivider: true, className: _style2.default.BigTable, flex: true },
        this._renderTableHeader(isMarking, rubricSkill, hasSkillDesciption),
        _react2.default.createElement(
          _SimpleTable2.default.Body,
          null,
          function (subSkill, _ref) {
            var columnId = _ref.columnId,
                ability = _ref.ability;

            if (columnId === 'subskills') {
              return _react2.default.createElement(
                _SimpleTable2.default.Cell,
                { className: _style2.default.BigTable_subSkillCell,
                  key: subSkill.subSkillId + '-instructionText' },
                _react2.default.createElement(
                  'div',
                  { className: _style2.default.BigTable_subSkillCell_wrap },
                  subSkill.name
                )
              );
            }
            if (columnId === 'ability') {
              return _react2.default.createElement(
                _SimpleTable2.default.Cell,
                { className: _style2.default.BigTable_abilityCell },
                _this3._renderScores(subSkill, ability, maxAbilityPoint, hasSkillDesciption)
              );
            }

            if (columnId === 'expand' && hasSkillDesciption) {
              var iconClasses = (0, _classnames3.default)(_style2.default.BigTable_toggleCell_icon, _defineProperty({}, _style2.default.__expanded, _this3._isInstructionTextsExpanded(rubricSkill.skillId, subSkill.subSkillId)));
              return _react2.default.createElement(
                _SimpleTable2.default.Cell,
                { className: _style2.default.BigTable_toggleCell },
                _react2.default.createElement(
                  'div',
                  { className: _style2.default.BigTable_toggleCell_wrap,
                    onClick: function onClick() {
                      return onIntructionToggleClick(rubricSkill.skillId, subSkill.subSkillId);
                    } },
                  _react2.default.createElement(
                    'button',
                    { className: _style2.default.BigTable_toggleCell_button },
                    'Scoring Criteria'
                  ),
                  _react2.default.createElement(_omniCommonUi.Icon, { id: 'chevron-small-down', className: iconClasses })
                )
              );
            }
            return null;
          }
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: _style2.default.PageCard },
        this._renderHeader(),
        this._renderTable()
      );
    }
  }]);

  return RubricSkillTable;
}(_react.PureComponent);

RubricSkillTable.propTypes = {
  isMarking: _propTypes2.default.isMarking,
  rubricSkill: _propTypes2.default.object,
  subSkillsToAbilityIds: _propTypes2.default.instanceOf(_immutable.Map),
  showInstructionsFor: _propTypes2.default.instanceOf(_immutable.Map),
  onIndividualAbilityButtonClicked: _propTypes2.default.func,
  onTargetLanguageButtonClick: _propTypes2.default.func,
  onScoreClick: _propTypes2.default.func,
  onCheckAllAbility: _propTypes2.default.func,
  onIntructionToggleClick: _propTypes2.default.func,
  isUnitQuiz: _propTypes2.default.bool.isRequired
};

exports.default = RubricSkillTable;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1439);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2kLHt-r0lhmv7L7ucKHdDX{position:relative;text-align:left!important}._20MTTQd2ihXlwJQYrbRHBB{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.B12Bty8lUry2oCpDE1v-9{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._1H3owfkPUr55XtOndKKuWw,._3t4POLX4CJuvZss9z3frh9,.zBGrK598_xyKiG4CE6Zbc{-webkit-box-pack:start!important;-webkit-justify-content:flex-start!important;-moz-box-pack:start!important;-ms-flex-pack:start!important;justify-content:flex-start!important;padding:1.07143rem .71429rem;text-align:left}._1H3owfkPUr55XtOndKKuWw:first-child,._3t4POLX4CJuvZss9z3frh9:first-child,.zBGrK598_xyKiG4CE6Zbc:first-child{padding-left:2.14286rem}._1H3owfkPUr55XtOndKKuWw:last-child,._3t4POLX4CJuvZss9z3frh9:last-child,.zBGrK598_xyKiG4CE6Zbc:last-child{padding-right:2.14286rem}._3t4POLX4CJuvZss9z3frh9{-webkit-box-align:start!important;-webkit-align-items:flex-start!important;-moz-box-align:start!important;-ms-flex-align:start!important;align-items:flex-start!important;-webkit-box-flex:0!important;-webkit-flex:0 0 12.14286rem!important;-moz-box-flex:0!important;-ms-flex:0 0 12.14286rem!important;flex:0 0 12.14286rem!important;vertical-align:top}._1Qw9D5kD5pJ03znT7WAv6k{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;min-height:2.5rem;word-break:break-word}._-1ABl6IZnapEm5Zbd2iHO{white-space:nowrap}.zBGrK598_xyKiG4CE6Zbc{vertical-align:top}._2M9Bv2Gsz4UhzVM6dx6EBX{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;width:100%}._2KDx7588d4GrgtncswyVoH{line-height:1.3rem;margin:0;min-height:4.28571rem;padding:1.07143rem 0 0;text-align:left;white-space:pre-line;word-break:break-word}._2KDx7588d4GrgtncswyVoH.instructions-enter{height:0;opacity:0}._2KDx7588d4GrgtncswyVoH.instructions-enter.instructions-enter-active{opacity:1;-webkit-transition:height .3s ease-in-out,opacity .3s ease-in-out;-o-transition:height .3s ease-in-out,opacity .3s ease-in-out;-moz-transition:height .3s ease-in-out,opacity .3s ease-in-out;transition:height .3s ease-in-out,opacity .3s ease-in-out}._2KDx7588d4GrgtncswyVoH.instructions-leave{opacity:1}._2KDx7588d4GrgtncswyVoH.instructions-leave.instructions-leave-active{height:0;opacity:0;-webkit-transition:height .3s ease-in-out,opacity .3s ease-in-out;-o-transition:height .3s ease-in-out,opacity .3s ease-in-out;-moz-transition:height .3s ease-in-out,opacity .3s ease-in-out;transition:height .3s ease-in-out,opacity .3s ease-in-out}._2rh-5kmh0JblFHnNJYUVji{min-width:100%}._1ZKGUOpVW1QQzoCzTbF3uU{-webkit-box-align:start!important;-webkit-align-items:flex-start!important;-moz-box-align:start!important;-ms-flex-align:start!important;align-items:flex-start!important;-webkit-box-flex:0!important;-webkit-flex:0 0 10rem!important;-moz-box-flex:0!important;-ms-flex:0 0 10rem!important;flex:0 0 10rem!important;padding:1.07143rem .71429rem;padding-right:2.14286rem}._2T_GDObkXNeB88RytnU7B9{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;min-height:2.5rem;padding:0;width:100%}._1yWITvo2XZlVXzsY-xTxBZ{background-color:transparent;border:none;cursor:pointer;text-transform:uppercase}._1yWITvo2XZlVXzsY-xTxBZ:focus{outline:none}._259p8vdZAO269-X88f5_9u{margin-left:.35714rem;-webkit-transition:-webkit-transform .3s ease-in-out;transition:-webkit-transform .3s ease-in-out;-o-transition:-o-transform .3s ease-in-out;-moz-transition:transform .3s ease-in-out,-moz-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out,-moz-transform .3s ease-in-out,-o-transform .3s ease-in-out}._259p8vdZAO269-X88f5_9u._2CNgP9wVfVBFOd9WOCmUGV{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg)}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"BigTable": "_2kLHt-r0lhmv7L7ucKHdDX",
	"BigTable_heading": "_20MTTQd2ihXlwJQYrbRHBB",
	"BigTable_targetLanguageBtn": "B12Bty8lUry2oCpDE1v-9",
	"BigTable_subSkillCell": "_3t4POLX4CJuvZss9z3frh9",
	"BigTable_scoreCell": "zBGrK598_xyKiG4CE6Zbc",
	"BigTable_abilityCell": "_1H3owfkPUr55XtOndKKuWw",
	"BigTable_subSkillCell_wrap": "_1Qw9D5kD5pJ03znT7WAv6k",
	"BigTable_subSkillCell_span": "_-1ABl6IZnapEm5Zbd2iHO",
	"BigTable_scoreCell_wrap": "_2M9Bv2Gsz4UhzVM6dx6EBX",
	"BigTable_scoreCell_wrap_instructions": "_2KDx7588d4GrgtncswyVoH",
	"BigTable_scoreCell_wrap_button": "_2rh-5kmh0JblFHnNJYUVji",
	"BigTable_toggleCell": "_1ZKGUOpVW1QQzoCzTbF3uU",
	"BigTable_toggleCell_wrap": "_2T_GDObkXNeB88RytnU7B9",
	"BigTable_toggleCell_button": "_1yWITvo2XZlVXzsY-xTxBZ",
	"BigTable_toggleCell_icon": "_259p8vdZAO269-X88f5_9u",
	"__expanded": "_2CNgP9wVfVBFOd9WOCmUGV"
};

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(1441);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(1442);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(1443);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(1445);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(649);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(203);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(1446);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(296);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(203);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(297);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(204);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(298);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(299);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(296);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(203);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(297);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(204);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(298);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(299);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(296);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(203);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(297);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(1444);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(204);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(298);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(299);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(649);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnmountClosed = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Collapse = __webpack_require__(648);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnmountClosed = exports.UnmountClosed = function (_React$PureComponent) {
  _inherits(UnmountClosed, _React$PureComponent);

  function UnmountClosed(props) {
    _classCallCheck(this, UnmountClosed);

    var _this = _possibleConstructorReturn(this, (UnmountClosed.__proto__ || Object.getPrototypeOf(UnmountClosed)).call(this, props));

    _this.componentWillReceiveProps = function (_ref) {
      var isOpened = _ref.isOpened;

      if (!_this.props.isOpened && isOpened) {
        _this.setState({
          forceInitialAnimation: true,
          shouldUnmount: false
        });
      }
    };

    _this.onRest = function () {
      var _this$props = _this.props,
          isOpened = _this$props.isOpened,
          onRest = _this$props.onRest;


      if (!isOpened) {
        _this.setState({ shouldUnmount: true });
      }
      if (onRest) {
        onRest.apply(undefined, arguments);
      }
    };

    _this.state = {
      shouldUnmount: !_this.props.isOpened,
      forceInitialAnimation: !_this.props.isOpened
    };
    return _this;
  }

  _createClass(UnmountClosed, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpened = _props.isOpened,
          _onRest = _props.onRest,
          props = _objectWithoutProperties(_props, ['isOpened', 'onRest']);

      var _state = this.state,
          forceInitialAnimation = _state.forceInitialAnimation,
          shouldUnmount = _state.shouldUnmount;


      return shouldUnmount ? null : _react2.default.createElement(_Collapse.Collapse, _extends({
        forceInitialAnimation: forceInitialAnimation,
        isOpened: isOpened,
        onRest: this.onRest
      }, props));
    }
  }]);

  return UnmountClosed;
}(_react2.default.PureComponent);

UnmountClosed.propTypes = {
  isOpened: _propTypes2.default.bool.isRequired,
  onRest: _propTypes2.default.func
};

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _omniCommonUi = __webpack_require__(0);

var _component = __webpack_require__(645);

var _component2 = _interopRequireDefault(_component);

var _StudentHorizontalSelect = __webpack_require__(650);

var _StudentHorizontalSelect2 = _interopRequireDefault(_StudentHorizontalSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    appBars: {
      sticky: {
        'student-select': {
          component: _StudentHorizontalSelect2.default,
          order: 2
        }
      }
    },
    path: ':progressTestIndex/student/:studentId/skill/:skillIndex(/:mode)',
    view: 'student',
    component: _component2.default,
    sessionNav: {
      noUnitSessionNavigation: true
    },
    canAccess: function canAccess(props) {
      if (!_component2.default.isInMarkingRoute(props)) {
        return true;
      }

      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressTest.Edit);
    },
    breadcrumbLabels: function breadcrumbLabels(props) {
      var mappedProps = (0, _component.mapStateToProps)(getState(), props);
      var currentSkill = mappedProps.currentSkill;
      var params = props.params;

      var segments = [currentSkill && currentSkill.name];
      if (params.mode === 'edit') segments.push('Edit');
      return segments;
    },
    actionButtons: {
      default: {
        Mark: {
          isPrimary: true,
          route: './edit',
          visibleWhen: function visibleWhen(_ref2) {
            var isMarkable = _ref2.isMarkable,
                params = _ref2.params;

            var state = getState();
            var groupId = params.groupId,
                studentId = params.studentId,
                progressTestIndex = params.progressTestIndex;

            var hasPrivilege = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.ProgressTest.Edit);
            var contentMap = state.get('rootReducer').get('contentMaps').get(groupId).data;
            var currentProgressTestId = contentMap.progressTests.get(progressTestIndex).progressTestId;
            var currentProgressTest = state.get('rootReducer').get('progressTests').get(currentProgressTestId);
            if (currentProgressTest) {
              currentProgressTest = currentProgressTest.data;
            } else {
              // the progress test is unset; show the disabled button
              return true;
            }
            if (_is_js2.default.not.undefined(currentProgressTest)) {
              var currentStudentResult = currentProgressTest.studentProgressTestResults.get(studentId);
              return hasPrivilege && currentStudentResult.canBeOverwrite && isMarkable;
            }
            return hasPrivilege && isMarkable;
          },
          disableWhen: function disableWhen(_ref3) {
            var _ref3$params = _ref3.params,
                groupId = _ref3$params.groupId,
                progressTestIndex = _ref3$params.progressTestIndex;

            var state = getState();
            var contentMap = state.get('rootReducer').get('contentMaps').get(groupId).data;
            var currentProgressTestId = contentMap.progressTests.get(progressTestIndex).progressTestId;
            var currentProgressTest = state.get('rootReducer').get('progressTests').get(currentProgressTestId);
            if (!currentProgressTest) {
              return true;
            }
            return false;
          }
        }
      },
      edit: {
        Save: {
          isPrimary: true,
          route: '../save'
        },
        Discard: {
          route: '../discard'
        }
      }
    }
  };
};

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1450);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3UUra69ZKPmwt1PZzoY85k{background:#f3f5f7;border-bottom:.07143rem solid #ccc;padding:0}.N60pGYS7oFWQ832jDooPc{height:10.71429rem;width:10.71429rem}.aaBaOK5rretB1MnYZGTC6{color:#4a4a4a;font-size:125%;font-weight:600;letter-spacing:.07143rem;margin-bottom:.14286rem;padding:0;text-align:center}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentHorizontalSelect": "_3UUra69ZKPmwt1PZzoY85k",
	"StudentHorizontalSelect_options": "N60pGYS7oFWQ832jDooPc",
	"StudentHorizontalSelect_options_score": "aaBaOK5rretB1MnYZGTC6"
};

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1452);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3Ck-kNcC0cRcGp8NjiXAnC{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.kwm4knL-8eazUIBLGPgVB{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._185-RSTKgpFMG2NDgeXk5j{background-color:#fbfbfb;border:0;-webkit-box-shadow:0 0 .21429rem .07143rem rgba(0,0,0,.15);-moz-box-shadow:0 0 .21429rem .07143rem rgba(0,0,0,.15);box-shadow:0 0 .21429rem .07143rem rgba(0,0,0,.15);-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;margin-bottom:1.42857rem;min-height:5em;padding:.35714rem;position:relative;z-index:200}.gRjHucgrJyyVp8uqWnJo3{width:10rem}._1kNAl-qDjeuSxyeBMgoqkh{padding:0;text-align:center}._2XDc1vcD9mOdCZGtD9ZLGv{margin-top:-1.42857rem!important}.S2jn6Ebng_6gZQy9xKwq{display:block;padding-left:1rem}.S2jn6Ebng_6gZQy9xKwq h3,.S2jn6Ebng_6gZQy9xKwq h4{color:#a4a4a4}.S2jn6Ebng_6gZQy9xKwq h3{font-weight:600;letter-spacing:.07143rem}.XlCrSDHpJUz1ACwRHCtyt{border-collapse:collapse;position:relative;width:100%}.XlCrSDHpJUz1ACwRHCtyt>caption{background-color:#fbfbfb;border:0;-webkit-box-shadow:0 0 .21429rem .07143rem rgba(0,0,0,.15);-moz-box-shadow:0 0 .21429rem .07143rem rgba(0,0,0,.15);box-shadow:0 0 .21429rem .07143rem rgba(0,0,0,.15);border-bottom:none;caption-side:top;font-weight:700;height:3.57143rem;padding:1.28571rem;text-align:left}._3Jow3lOsGWfvobzeP-K21w{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;line-height:1rem;text-align:left}._3Jow3lOsGWfvobzeP-K21w>.Mn6sUlIJyz82gHPd-91pX{line-height:1.2rem;padding-top:.3rem}._3lK0sy994wRY3-70BOlUZc{border-bottom:none!important}._3gflawVKrBAZ7vaaYs2tZh{display:none;line-height:1.3rem;min-height:4.28571rem;white-space:pre-line}._3gflawVKrBAZ7vaaYs2tZh.jF1492MiLr7AX76ug-TwW{display:block}.cAHVLvQRw2wBLx5gad0S6{display:table}._2F2YtDL_QPtSqoOmsVF17s{display:table-cell;width:1.42857rem}._3d98sxIVhZx-X8VRhQgE6_:hover{color:#0087e6}._3oqKcZoJhZiDgP018yxxC6{max-width:14.28571rem}._3AMt7qQyUU5tZ6rNLpd_4Z{height:5.71429rem}._1Xf7CR2OTuxptEicZLmHaA{min-width:2.85714rem}._2bS8csbOHGyeoG21GCZm1S{display:table-cell;line-height:1.3rem}._1ajRgEfsx3owYdvlxsOW2r{height:4.28571rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%}._2uZ2qx1XW39qdKBvekIgrs{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;min-height:100%}._2bS8csbOHGyeoG21GCZm1S p{-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;-webkit-flex-basis:100%;-ms-flex-preferred-size:100%;flex-basis:100%;margin:0;white-space:pre-line;width:100%}._2lSJuNqUIsSuRs_3Ybke_n{text-align:center}._2P3m1ofpSSPl5JwV2csbiW{vertical-align:top}._2RzhWlED9Gf5ZgWSXcN8HG{border-bottom:.07143rem solid #dfdfdf;border-top:.07143rem solid #dfdfdf}._2RzhWlED9Gf5ZgWSXcN8HG._3oVSWy2pOxj3tGiksZWVqc ._1RelH3Vs3vFFhgzRXnPoU3,._2RzhWlED9Gf5ZgWSXcN8HG._3oVSWy2pOxj3tGiksZWVqc .Mn6sUlIJyz82gHPd-91pX{height:2.14286rem;min-height:2.14286rem}._2XtQK6SSR7ap4sePx9pEpB,._3MVotuGvEmLkbbmayGx-6A{margin:0;padding:.35714rem 1.42857rem .35714rem 0}._2XtQK6SSR7ap4sePx9pEpB:last-child,._3MVotuGvEmLkbbmayGx-6A:last-child{padding-right:1.42857rem}@media only screen and (min-width:640px){._2XtQK6SSR7ap4sePx9pEpB:last-child,._3MVotuGvEmLkbbmayGx-6A:last-child{padding-right:2.14286rem}}._2XtQK6SSR7ap4sePx9pEpB:first-child,._3MVotuGvEmLkbbmayGx-6A:first-child{padding-left:1.42857rem}@media only screen and (min-width:640px){._2XtQK6SSR7ap4sePx9pEpB:first-child,._3MVotuGvEmLkbbmayGx-6A:first-child{padding-left:2.14286rem}}._1RelH3Vs3vFFhgzRXnPoU3,.Mn6sUlIJyz82gHPd-91pX{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;min-height:3.57143rem}._11ZRndc9wklJOtS30e1jCr,._60fvyoYZ7A6ynFTZCzYEf{display:block;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis}._2XtQK6SSR7ap4sePx9pEpB._3baCLm0zCDqDvCIZYaVHvw,._3MVotuGvEmLkbbmayGx-6A._3baCLm0zCDqDvCIZYaVHvw{position:relative}._2XtQK6SSR7ap4sePx9pEpB._3baCLm0zCDqDvCIZYaVHvw:before,._3MVotuGvEmLkbbmayGx-6A._3baCLm0zCDqDvCIZYaVHvw:before{bottom:0;-webkit-box-shadow:inset .5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);-moz-box-shadow:inset .5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);box-shadow:inset .5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);content:\"\";display:block;left:0;position:absolute;right:0;top:0}._2XtQK6SSR7ap4sePx9pEpB._5QEcgoEK_TxAkCGypeZAi,._3MVotuGvEmLkbbmayGx-6A._5QEcgoEK_TxAkCGypeZAi{position:relative}._2XtQK6SSR7ap4sePx9pEpB._5QEcgoEK_TxAkCGypeZAi:before,._3MVotuGvEmLkbbmayGx-6A._5QEcgoEK_TxAkCGypeZAi:before{bottom:0;-webkit-box-shadow:inset -.5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);-moz-box-shadow:inset -.5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);box-shadow:inset -.5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);content:\"\";display:block;left:0;position:absolute;right:0;top:0}._2XtQK6SSR7ap4sePx9pEpB._3baCLm0zCDqDvCIZYaVHvw._2XtQK6SSR7ap4sePx9pEpB._5QEcgoEK_TxAkCGypeZAi:before,._3MVotuGvEmLkbbmayGx-6A._3baCLm0zCDqDvCIZYaVHvw._3MVotuGvEmLkbbmayGx-6A._5QEcgoEK_TxAkCGypeZAi:before{-webkit-box-shadow:inset .5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196),inset -.5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);-moz-box-shadow:inset .5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196),inset -.5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196);box-shadow:inset .5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196),inset -.5rem 0 .42857rem -.42857rem rgba(0,0,0,.30196)}._2XtQK6SSR7ap4sePx9pEpB._1hUr3ryFdpSoPPE4D0gWOB,._3MVotuGvEmLkbbmayGx-6A._1hUr3ryFdpSoPPE4D0gWOB{text-align:left;vertical-align:top}._2XtQK6SSR7ap4sePx9pEpB._1hUr3ryFdpSoPPE4D0gWOB>.Mn6sUlIJyz82gHPd-91pX,._3MVotuGvEmLkbbmayGx-6A._1hUr3ryFdpSoPPE4D0gWOB>.Mn6sUlIJyz82gHPd-91pX{-webkit-box-align:initial;-webkit-align-items:initial;-moz-box-align:initial;-ms-flex-align:initial;align-items:initial;display:table-caption;-webkit-box-pack:initial;-webkit-justify-content:initial;-moz-box-pack:initial;-ms-flex-pack:initial;justify-content:initial}._2XtQK6SSR7ap4sePx9pEpB._2uKIlJIp2j5VfXC-DRIKd5,._3MVotuGvEmLkbbmayGx-6A._2uKIlJIp2j5VfXC-DRIKd5{width:5.71429rem}._2XtQK6SSR7ap4sePx9pEpB._2uKIlJIp2j5VfXC-DRIKd5._2J93wa8K9Hn7Jm1sA3Hvum,._3MVotuGvEmLkbbmayGx-6A._2uKIlJIp2j5VfXC-DRIKd5._2J93wa8K9Hn7Jm1sA3Hvum{display:none}._2XtQK6SSR7ap4sePx9pEpB._2uKIlJIp2j5VfXC-DRIKd5>.Mn6sUlIJyz82gHPd-91pX,._3MVotuGvEmLkbbmayGx-6A._2uKIlJIp2j5VfXC-DRIKd5>.Mn6sUlIJyz82gHPd-91pX{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-top:0}._2XtQK6SSR7ap4sePx9pEpB{width:15%}.Mn6sUlIJyz82gHPd-91pX{height:3.57143rem}._1RelH3Vs3vFFhgzRXnPoU3{-webkit-box-align:baseline;-webkit-align-items:baseline;-moz-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}._3hUrCMuX4Y0dDwQjbFbMix{-webkit-flex-basis:auto;-ms-flex-preferred-size:auto;flex-basis:auto;margin-top:.28571rem;text-align:left;width:100%}.fBzKxhZp5EtJOT1RIfmpp{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-flex-direction:column;-moz-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}.fBzKxhZp5EtJOT1RIfmpp,.PC9xW28Y2aHXKglT3T1Kj{-webkit-box-direction:normal;-moz-box-direction:normal}.PC9xW28Y2aHXKglT3T1Kj{-webkit-box-orient:horizontal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row}.nGj_MHmEXSB3I7_SqmQqY{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:50%}.nGj_MHmEXSB3I7_SqmQqY+.nGj_MHmEXSB3I7_SqmQqY{margin-left:1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ProgressTestRubricView_selectionTable_header": "_3Ck-kNcC0cRcGp8NjiXAnC",
	"ProgressTestRubricView_selectionTable_header_inner": "kwm4knL-8eazUIBLGPgVB",
	"ProgressTestRubricView_section": "_185-RSTKgpFMG2NDgeXk5j",
	"ProgressTestRubricView_studentHorizontalSelect_options": "gRjHucgrJyyVp8uqWnJo3",
	"ProgressTestRubricView_studentHorizontalSelect_options_score": "_1kNAl-qDjeuSxyeBMgoqkh",
	"ProgressTestRubricView_studentDropdown_options": "_2XDc1vcD9mOdCZGtD9ZLGv",
	"ProgressTestRubricView_targetCopy": "S2jn6Ebng_6gZQy9xKwq",
	"ProgressTestRubricView_table": "XlCrSDHpJUz1ACwRHCtyt",
	"ProgressTestRubricView_table_subskill_name": "_3Jow3lOsGWfvobzeP-K21w",
	"Th_wrap": "Mn6sUlIJyz82gHPd-91pX",
	"ProgressTestRubricView_table_row": "_3lK0sy994wRY3-70BOlUZc",
	"ProgressTestRubricView_table_row_instructionText": "_3gflawVKrBAZ7vaaYs2tZh",
	"__visible": "jF1492MiLr7AX76ug-TwW",
	"ProgressTestRubricView_tableForOneSubSkill": "cAHVLvQRw2wBLx5gad0S6",
	"ProgressTestRubricView_tableForOneSubSkill_tooltip": "_2F2YtDL_QPtSqoOmsVF17s",
	"ProgressTestRubricView_tableForOneSubSkill_tooltip_icon": "_3d98sxIVhZx-X8VRhQgE6_",
	"ProgressTestRubricView_tableForOneSubSkill_tooltip_inner": "_3oqKcZoJhZiDgP018yxxC6",
	"ProgressTestRubricView_tableForOneSubSkill_row": "_3AMt7qQyUU5tZ6rNLpd_4Z",
	"ProgressTestRubricView_tableForOneSubSkill_pointColumn_button": "_1Xf7CR2OTuxptEicZLmHaA",
	"ProgressTestRubricView_tableForOneSubSkill_instructionText": "_2bS8csbOHGyeoG21GCZm1S",
	"ProgressTestRubricView_tableForOneSubSkill_instructionText_viewport": "_1ajRgEfsx3owYdvlxsOW2r",
	"ProgressTestRubricView_tableForOneSubSkill_instructionText_inner": "_2uZ2qx1XW39qdKBvekIgrs",
	"ProgressTestRubricView_tableForAllSubSkills": "_2lSJuNqUIsSuRs_3Ybke_n",
	"ProgressTestRubricView_tableForAllSubSkills_pointCell": "_2P3m1ofpSSPl5JwV2csbiW",
	"Tr": "_2RzhWlED9Gf5ZgWSXcN8HG",
	"__firstRow": "_3oVSWy2pOxj3tGiksZWVqc",
	"Td_wrap": "_1RelH3Vs3vFFhgzRXnPoU3",
	"Th": "_2XtQK6SSR7ap4sePx9pEpB",
	"Td": "_3MVotuGvEmLkbbmayGx-6A",
	"Th_content": "_11ZRndc9wklJOtS30e1jCr",
	"Td_content": "_60fvyoYZ7A6ynFTZCzYEf",
	"__shadowLeft": "_3baCLm0zCDqDvCIZYaVHvw",
	"__shadowRight": "_5QEcgoEK_TxAkCGypeZAi",
	"__left": "_1hUr3ryFdpSoPPE4D0gWOB",
	"__leftAlignedAbilityName": "_2uKIlJIp2j5VfXC-DRIKd5",
	"__hidden": "_2J93wa8K9Hn7Jm1sA3Hvum",
	"RubricPointButton_container": "_3hUrCMuX4Y0dDwQjbFbMix",
	"Masonry": "fBzKxhZp5EtJOT1RIfmpp",
	"Masonry_multi": "PC9xW28Y2aHXKglT3T1Kj",
	"Masonry_flow": "nGj_MHmEXSB3I7_SqmQqY"
};

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSpeaking1Or2Skill = isSpeaking1Or2Skill;
exports.sortSubSkills = sortSubSkills;
exports.orderSpeakingSubSkillsIfNeeded = orderSpeakingSubSkillsIfNeeded;
// HFv4 Unit Review / Assessment Speaking 1–2 rubric row order.
// Display-only: do not import from shared accessors or the ProgressTests reducer.
// Import as a namespace (`import * as speakingSubSkillOrderHFv4`).

var SPEAKING_1 = 'Speaking 1';
var SPEAKING_2 = 'Speaking 2';

var BUCKET_VOCABULARY = 0;
var BUCKET_GRAMMAR_STRUCTURES = 1;
var BUCKET_CONFIDENCE_FLUENCY = 2;
var BUCKET_PRONUNCIATION = 3;
var BUCKET_OTHER = 4;
var STABLE_INDEX_SPAN = 10000;

function isSpeaking1Or2Skill(skill) {
  var name = skill && skill.name;
  return name === SPEAKING_1 || name === SPEAKING_2;
}

function bucketForSubSkillName(name) {
  var normalized = ('' + (name || '')).trim().toLowerCase();
  if (normalized === 'vocabulary') {
    return BUCKET_VOCABULARY;
  }
  if (normalized.includes('grammar') || normalized.includes('structures')) {
    return BUCKET_GRAMMAR_STRUCTURES;
  }
  if (normalized === 'confidence and fluency') {
    return BUCKET_CONFIDENCE_FLUENCY;
  }
  if (normalized === 'pronunciation') {
    return BUCKET_PRONUNCIATION;
  }
  return BUCKET_OTHER;
}

function sortSubSkills(subSkills) {
  if (!subSkills || !subSkills.size) {
    return subSkills;
  }
  return subSkills.sortBy(function (subSkill, index) {
    return bucketForSubSkillName(subSkill.name) * STABLE_INDEX_SPAN + index;
  });
}

function orderSpeakingSubSkillsIfNeeded(skill) {
  if (!skill || !isSpeaking1Or2Skill(skill) || !skill.subSkills) {
    return skill;
  }
  return skill.set('subSkills', sortSubSkills(skill.subSkills));
}

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _SimpleTable = __webpack_require__(133);

var _SimpleTable2 = _interopRequireDefault(_SimpleTable);

var _immutable = __webpack_require__(3);

var _style = __webpack_require__(1455);

var _style2 = _interopRequireDefault(_style);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCollapse = __webpack_require__(647);

var _accessors = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var abilitiesSortMapper = function abilitiesSortMapper(ability) {
  return ability.point;
};

var RubricSkillTable = function (_PureComponent) {
  _inherits(RubricSkillTable, _PureComponent);

  function RubricSkillTable() {
    _classCallCheck(this, RubricSkillTable);

    return _possibleConstructorReturn(this, (RubricSkillTable.__proto__ || Object.getPrototypeOf(RubricSkillTable)).apply(this, arguments));
  }

  _createClass(RubricSkillTable, [{
    key: '_isAbilityCurrentlySelected',
    value: function _isAbilityCurrentlySelected(subSkillId, abilityId) {
      return this.props.subSkillsToAbilityIds.get(subSkillId) === abilityId;
    }
  }, {
    key: '_isInstructionTextsExpanded',
    value: function _isInstructionTextsExpanded(skillId, subSkillId) {
      return !!this.props.showInstructionsFor.getIn([skillId, subSkillId]);
    }
  }, {
    key: '_getButtonTypeForAbility',
    value: function _getButtonTypeForAbility(ability, maxAbilityPoint) {
      if (ability.point === 0) {
        return _omniCommonUi.Button.Type.black;
      }

      var relativeAbility = ability.point / maxAbilityPoint;
      if (relativeAbility >= 0.8) {
        return _omniCommonUi.Button.Type.correct;
      }

      if (relativeAbility >= 0.7) {
        return _omniCommonUi.Button.Type.needsAttention;
      }

      return _omniCommonUi.Button.Type.wrong;
    }
  }, {
    key: '_isAbilityCheckAll',
    value: function _isAbilityCheckAll(abilityId) {
      var checkAll = true;
      this.props.subSkillsToAbilityIds.forEach(function (resultAbilityId) {
        if (abilityId !== resultAbilityId) {
          checkAll = false;
        }
      });
      return checkAll;
    }
  }, {
    key: '_renderHeader',
    value: function _renderHeader() {
      var _props = this.props,
          rubricSkill = _props.rubricSkill,
          onTargetLanguageButtonClick = _props.onTargetLanguageButtonClick,
          subSkillsToAbilityIds = _props.subSkillsToAbilityIds;

      var headingClass = _style2.default.BigTable_heading;

      var maxAbilityPoint = rubricSkill.abilities.max(function (a, b) {
        return a.point - b.point;
      }).point;
      var maxPoint = rubricSkill.subSkills.size * maxAbilityPoint;

      var getScoreByAbiltyId = function getScoreByAbiltyId(abilityId) {
        var ability = rubricSkill.abilities.find(function (ab) {
          return ab.abilityId === abilityId;
        });
        return ability && ability.point || 0;
      };
      var currentPoint = subSkillsToAbilityIds.map(function (v) {
        return getScoreByAbiltyId(v);
      }).reduce(function (pre, current) {
        return pre + current;
      });

      var targetLanguageBtnClassName = _style2.default.BigTable_targetLanguageBtn;
      return _react2.default.createElement(
        _omniCommonUi.PageCard.Heading,
        { className: headingClass,
          text: rubricSkill.name + ' Rubric ' + (currentPoint || '-') + '/' + maxPoint },
        rubricSkill && rubricSkill.targetLanguageCategories && rubricSkill.targetLanguageCategories.size > 0 && _react2.default.createElement(
          _omniCommonUi.Button,
          { type: _omniCommonUi.Button.Type.default,
            onClick: function onClick() {
              return onTargetLanguageButtonClick(rubricSkill.skillId);
            },
            className: targetLanguageBtnClassName },
          _react2.default.createElement(
            'span',
            null,
            'TARGET LANGUAGE'
          )
        )
      );
    }
  }, {
    key: '_renderCheckAll',
    value: function _renderCheckAll(rubricSkill, hasSkillDesciption) {
      var _this2 = this;

      return _react2.default.createElement(
        _SimpleTable2.default.Row,
        null,
        _react2.default.createElement(_SimpleTable2.default.Cell, { className: _style2.default.BigTable_subSkillCell }),
        rubricSkill.abilities.sortBy(abilitiesSortMapper).map(function (ability) {
          var skillId = rubricSkill.skillId;

          return _react2.default.createElement(
            _SimpleTable2.default.Cell,
            { className: _style2.default.BigTable_abilityCell },
            _react2.default.createElement(
              'label',
              { key: skillId + '-' + ability.abilityId,
                htmlFor: skillId + '-' + ability.abilityId },
              _react2.default.createElement(_omniCommonUi.Checkbox, { id: skillId + '-' + ability.abilityId,
                onChange: function onChange(checked) {
                  return _this2.props.onCheckAllAbility(skillId, checked, ability.abilityId);
                },
                disabled: !_this2.props.isUnitQuiz && rubricSkill.name === _accessors.shouldDisabledSkillName,
                name: skillId + '-' + ability.abilityId,
                checked: _this2._isAbilityCheckAll(ability.abilityId) }),
              _react2.default.createElement(
                'span',
                { className: _style2.default.BigTable_subSkillCell_span },
                'grade all '
              )
            )
          );
        }),
        hasSkillDesciption && _react2.default.createElement(_SimpleTable2.default.Cell, { className: _style2.default.BigTable_toggleCell })
      );
    }
  }, {
    key: '_renderScores',
    value: function _renderScores(subSkill, ability, maxAbilityPoint, hasSkillDesciption) {
      var _props2 = this.props,
          rubricSkill = _props2.rubricSkill,
          isMarking = _props2.isMarking,
          onScoreClick = _props2.onScoreClick,
          isUnitQuiz = _props2.isUnitQuiz;

      var abilityDescription = subSkill.abilityDescriptions.find(function (ad) {
        return ability.abilityId === ad.abilityId;
      }) || {};
      return _react2.default.createElement(
        'div',
        { key: ability.abilityId, className: _style2.default.BigTable_scoreCell_wrap },
        _react2.default.createElement(
          _omniCommonUi.Button,
          { disabled: !isUnitQuiz && rubricSkill.name === _accessors.shouldDisabledSkillName || !isMarking,
            className: _style2.default.BigTable_scoreCell_wrap_button,
            active: this._isAbilityCurrentlySelected(subSkill.subSkillId, ability.abilityId),
            onClick: function onClick() {
              return onScoreClick(subSkill.subSkillId, ability.abilityId, rubricSkill.skillId);
            },
            type: this._getButtonTypeForAbility(ability, maxAbilityPoint),
            block: true },
          ability.point
        ),
        hasSkillDesciption && _react2.default.createElement(
          _reactCollapse.Collapse,
          { isOpened: this._isInstructionTextsExpanded(rubricSkill.skillId, subSkill.subSkillId) },
          _react2.default.createElement(
            'p',
            { className: _style2.default.BigTable_scoreCell_wrap_instructions },
            abilityDescription.note || ''
          )
        )
      );
    }
  }, {
    key: '_renderTableHeader',
    value: function _renderTableHeader(isMarking, rubricSkill, hasSkillDesciption) {
      var tHeadRow = _react2.default.createElement(
        _SimpleTable2.default.Row,
        null,
        _react2.default.createElement(_SimpleTable2.default.Cell, { columnId: { columnId: 'subskills' },
          className: _style2.default.BigTable_subSkillCell }),
        rubricSkill.abilities.sortBy(abilitiesSortMapper).map(function (ability) {
          return _react2.default.createElement(
            _SimpleTable2.default.Cell,
            { key: ability.abilityId,
              columnId: { columnId: 'ability', ability: ability },
              className: _style2.default.BigTable_abilityCell },
            ability.name
          );
        }),
        hasSkillDesciption && _react2.default.createElement(_SimpleTable2.default.Cell, { columnId: { columnId: 'expand' },
          className: _style2.default.BigTable_toggleCell })
      );
      if (isMarking) {
        return _react2.default.createElement(
          _SimpleTable2.default.Header,
          null,
          tHeadRow,
          this._renderCheckAll(rubricSkill, hasSkillDesciption)
        );
      }
      return _react2.default.createElement(
        _SimpleTable2.default.Header,
        null,
        tHeadRow
      );
    }
  }, {
    key: '_renderTable',
    value: function _renderTable() {
      var _this3 = this;

      var _props3 = this.props,
          isMarking = _props3.isMarking,
          rubricSkill = _props3.rubricSkill,
          onIntructionToggleClick = _props3.onIntructionToggleClick;

      var maxAbilityPoint = rubricSkill.abilities.max(function (a, b) {
        return a.point - b.point;
      }).point;
      var hasSkillDesciption = rubricSkill.subSkills.some(function (subkill) {
        return subkill.abilityDescriptions && subkill.abilityDescriptions.some(function (abilityDescription) {
          return abilityDescription.note;
        });
      });

      return _react2.default.createElement(
        _SimpleTable2.default,
        { rows: rubricSkill.subSkills, onlyRowDivider: true, className: _style2.default.BigTable, flex: true },
        this._renderTableHeader(isMarking, rubricSkill, hasSkillDesciption),
        _react2.default.createElement(
          _SimpleTable2.default.Body,
          null,
          function (subSkill, _ref) {
            var columnId = _ref.columnId,
                ability = _ref.ability;

            if (columnId === 'subskills') {
              return _react2.default.createElement(
                _SimpleTable2.default.Cell,
                { className: _style2.default.BigTable_subSkillCell,
                  key: subSkill.subSkillId + '-instructionText' },
                _react2.default.createElement(
                  'div',
                  { className: _style2.default.BigTable_subSkillCell_wrap },
                  subSkill.name
                )
              );
            }
            if (columnId === 'ability') {
              return _react2.default.createElement(
                _SimpleTable2.default.Cell,
                { className: _style2.default.BigTable_abilityCell },
                _this3._renderScores(subSkill, ability, maxAbilityPoint, hasSkillDesciption)
              );
            }

            if (columnId === 'expand' && hasSkillDesciption) {
              var iconClasses = (0, _classnames3.default)(_style2.default.BigTable_toggleCell_icon, _defineProperty({}, _style2.default.__expanded, _this3._isInstructionTextsExpanded(rubricSkill.skillId, subSkill.subSkillId)));
              return _react2.default.createElement(
                _SimpleTable2.default.Cell,
                { className: _style2.default.BigTable_toggleCell },
                _react2.default.createElement(
                  'div',
                  { className: _style2.default.BigTable_toggleCell_wrap,
                    onClick: function onClick() {
                      return onIntructionToggleClick(rubricSkill.skillId, subSkill.subSkillId);
                    } },
                  _react2.default.createElement(
                    'button',
                    { className: _style2.default.BigTable_toggleCell_button },
                    'Scoring Criteria'
                  ),
                  _react2.default.createElement(_omniCommonUi.Icon, { id: 'chevron-small-down', className: iconClasses })
                )
              );
            }
            return null;
          }
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: _style2.default.PageCard },
        this._renderHeader(),
        this._renderTable()
      );
    }
  }]);

  return RubricSkillTable;
}(_react.PureComponent);

RubricSkillTable.propTypes = {
  isMarking: _propTypes2.default.isMarking,
  rubricSkill: _propTypes2.default.object,
  subSkillsToAbilityIds: _propTypes2.default.instanceOf(_immutable.Map),
  showInstructionsFor: _propTypes2.default.instanceOf(_immutable.Map),
  onIndividualAbilityButtonClicked: _propTypes2.default.func,
  onTargetLanguageButtonClick: _propTypes2.default.func,
  onScoreClick: _propTypes2.default.func,
  onCheckAllAbility: _propTypes2.default.func,
  onIntructionToggleClick: _propTypes2.default.func,
  isUnitQuiz: _propTypes2.default.bool.isRequired
};

exports.default = RubricSkillTable;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1456);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3JFGPhvBtuPa6GlIJ5Y8kh{position:relative;text-align:left!important}._1BetZQaadqEPAd0Y86LZjE{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._2-voECslQQ1Ve57EI7ISTG{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._1VnXf4uvG_EevoTp4Elegv,._3_tdvJqZZd5D5lWzDeKTPC,._3vKxgxtq00ScEiEoAdlUVW{-webkit-box-pack:start!important;-webkit-justify-content:flex-start!important;-moz-box-pack:start!important;-ms-flex-pack:start!important;justify-content:flex-start!important;padding:1.07143rem .71429rem;text-align:left}._1VnXf4uvG_EevoTp4Elegv:first-child,._3_tdvJqZZd5D5lWzDeKTPC:first-child,._3vKxgxtq00ScEiEoAdlUVW:first-child{padding-left:2.14286rem}._1VnXf4uvG_EevoTp4Elegv:last-child,._3_tdvJqZZd5D5lWzDeKTPC:last-child,._3vKxgxtq00ScEiEoAdlUVW:last-child{padding-right:2.14286rem}._3_tdvJqZZd5D5lWzDeKTPC{-webkit-box-align:start!important;-webkit-align-items:flex-start!important;-moz-box-align:start!important;-ms-flex-align:start!important;align-items:flex-start!important;-webkit-box-flex:0!important;-webkit-flex:0 0 12.14286rem!important;-moz-box-flex:0!important;-ms-flex:0 0 12.14286rem!important;flex:0 0 12.14286rem!important;vertical-align:top}.PZJ_SEiXer54QlbhwNCFS{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;min-height:2.5rem;word-break:break-word}._2LYJCZg0jVhZq0SJZWS1LH{white-space:nowrap}._3vKxgxtq00ScEiEoAdlUVW{vertical-align:top}._29C5k29Jquiv1AXv6BwI1d{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;width:100%}._1w2QzJ_GFZJZ3ahxml2j3J{line-height:1.3rem;margin:0;min-height:4.28571rem;padding:1.07143rem 0 0;text-align:left;white-space:pre-line;word-break:break-word}._1w2QzJ_GFZJZ3ahxml2j3J.instructions-enter{height:0;opacity:0}._1w2QzJ_GFZJZ3ahxml2j3J.instructions-enter.instructions-enter-active{opacity:1;-webkit-transition:height .3s ease-in-out,opacity .3s ease-in-out;-o-transition:height .3s ease-in-out,opacity .3s ease-in-out;-moz-transition:height .3s ease-in-out,opacity .3s ease-in-out;transition:height .3s ease-in-out,opacity .3s ease-in-out}._1w2QzJ_GFZJZ3ahxml2j3J.instructions-leave{opacity:1}._1w2QzJ_GFZJZ3ahxml2j3J.instructions-leave.instructions-leave-active{height:0;opacity:0;-webkit-transition:height .3s ease-in-out,opacity .3s ease-in-out;-o-transition:height .3s ease-in-out,opacity .3s ease-in-out;-moz-transition:height .3s ease-in-out,opacity .3s ease-in-out;transition:height .3s ease-in-out,opacity .3s ease-in-out}._3J3QwKYH1ID7QbEFZ7mrCg{min-width:100%}.rns7sqP-IsS5xePhQNPzP{-webkit-box-align:start!important;-webkit-align-items:flex-start!important;-moz-box-align:start!important;-ms-flex-align:start!important;align-items:flex-start!important;-webkit-box-flex:0!important;-webkit-flex:0 0 10rem!important;-moz-box-flex:0!important;-ms-flex:0 0 10rem!important;flex:0 0 10rem!important;padding:1.07143rem .71429rem;padding-right:2.14286rem}.aHWMWOZUr42xgLRyFOgtJ{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;min-height:2.5rem;padding:0;width:100%}._3DlTeREnnmnFYkm96gmaBZ{background-color:transparent;border:none;cursor:pointer;text-transform:uppercase}._3DlTeREnnmnFYkm96gmaBZ:focus{outline:none}._8G28ynsZCBS0Eh_hskWH6{margin-left:.35714rem;-webkit-transition:-webkit-transform .3s ease-in-out;transition:-webkit-transform .3s ease-in-out;-o-transition:-o-transform .3s ease-in-out;-moz-transition:transform .3s ease-in-out,-moz-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out,-moz-transform .3s ease-in-out,-o-transform .3s ease-in-out}._8G28ynsZCBS0Eh_hskWH6._1EP7W2_60cVlmM1yjvqy8P{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg)}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"BigTable": "_3JFGPhvBtuPa6GlIJ5Y8kh",
	"BigTable_heading": "_1BetZQaadqEPAd0Y86LZjE",
	"BigTable_targetLanguageBtn": "_2-voECslQQ1Ve57EI7ISTG",
	"BigTable_subSkillCell": "_3_tdvJqZZd5D5lWzDeKTPC",
	"BigTable_scoreCell": "_3vKxgxtq00ScEiEoAdlUVW",
	"BigTable_abilityCell": "_1VnXf4uvG_EevoTp4Elegv",
	"BigTable_subSkillCell_wrap": "PZJ_SEiXer54QlbhwNCFS",
	"BigTable_subSkillCell_span": "_2LYJCZg0jVhZq0SJZWS1LH",
	"BigTable_scoreCell_wrap": "_29C5k29Jquiv1AXv6BwI1d",
	"BigTable_scoreCell_wrap_instructions": "_1w2QzJ_GFZJZ3ahxml2j3J",
	"BigTable_scoreCell_wrap_button": "_3J3QwKYH1ID7QbEFZ7mrCg",
	"BigTable_toggleCell": "rns7sqP-IsS5xePhQNPzP",
	"BigTable_toggleCell_wrap": "aHWMWOZUr42xgLRyFOgtJ",
	"BigTable_toggleCell_button": "_3DlTeREnnmnFYkm96gmaBZ",
	"BigTable_toggleCell_icon": "_8G28ynsZCBS0Eh_hskWH6",
	"__expanded": "_1EP7W2_60cVlmM1yjvqy8P"
};

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(652);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1460);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1459);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1LGqbSJ0w4IeuOGvkhkDVx{padding:1.42857rem}@media only screen and (min-width:640px){._1LGqbSJ0w4IeuOGvkhkDVx{padding:2.14286rem}}._2EH4cFehKv2SKTImIJ_lF8{background:#f3f5f7;padding:1em;padding-left:1.42857rem;padding-right:1.42857rem}@media only screen and (min-width:640px){._2EH4cFehKv2SKTImIJ_lF8{padding-left:2.14286rem;padding-right:2.14286rem}}._2AcFdpQlMCjjOwuMSvRSGu{width:100%}@media only screen and (min-width:480px){._2AcFdpQlMCjjOwuMSvRSGu{width:20%;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}}._1YA28zWcDrNZsdfnlBgPIN{margin-top:1em}._1YA28zWcDrNZsdfnlBgPIN a:hover ._1PF3Xsv5qMtkV_6eFJ5e-C{-webkit-filter:invert(100%);filter:invert(100%)}.NKP7_VCCWISmAXiraNCW5{font-size:1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ProgressReport_content": "_1LGqbSJ0w4IeuOGvkhkDVx",
	"ProgressReport_studentDropdown": "_2EH4cFehKv2SKTImIJ_lF8",
	"ProgressReport_studentDropdown_selectedItem": "_2AcFdpQlMCjjOwuMSvRSGu",
	"ProgressReport_studentDropdown_options": "_1YA28zWcDrNZsdfnlBgPIN",
	"ProgressReport_studentDropdown_options_aside_checkmark": "_1PF3Xsv5qMtkV_6eFJ5e-C",
	"ProgressReport_studentDropdown_options_checkmark": "NKP7_VCCWISmAXiraNCW5"
};

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omniCommonUi = __webpack_require__(0);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _DosApprovalList = __webpack_require__(1461);

var _StudentReportView = __webpack_require__(1486);

var _routes = __webpack_require__(669);

var _accessors = __webpack_require__(164);

var _component = __webpack_require__(652);

var _component2 = _interopRequireDefault(_component);

var _ProgressReportListView = __webpack_require__(1530);

var _ProgressReportListView2 = _interopRequireDefault(_ProgressReportListView);

var _ProgressReportSessionNav = __webpack_require__(670);

var _ProgressReportSessionNav2 = _interopRequireDefault(_ProgressReportSessionNav);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    appBars: {
      sticky: {
        navigation: {
          component: _ProgressReportSessionNav2.default,
          order: 1
        },
        'view-nav': {
          component: _ViewNav2.default,
          order: 3
        }
      }
    },
    path: 'unit-report(/:progressReportId)',
    component: _component2.default,
    indexRoute: {
      component: _ProgressReportListView2.default,
      actionButtons: {
        default: (0, _routes.generateActionButtons)(getState),
        'export-all': (0, _routes.generateActionButtons)(getState)
      }
    },
    canAccess: function canAccess(_ref2) {
      var params = _ref2.params;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.ProgressReport);
    },
    breadcrumbLabels: function breadcrumbLabels(_ref3) {
      var buildRoute = _ref3.buildRoute,
          params = _ref3.params;
      var progressReportId = params.progressReportId,
          groupId = params.groupId;

      var progressReport = (0, _accessors.getProgressReportById)(getState(), progressReportId);
      if (!_is_js2.default.existy(progressReport)) {
        return [];
      }
      return {
        label: progressReport.name,
        href: buildRoute('/group/' + groupId + '/unit-report/' + progressReportId)
      };
    },
    tab: {
      label: function label(params) {
        return _.actions.isDisabledReportActions(getState(), params.groupId) ? 'Historical Unit Reports' : 'Unit Reports';
      },
      order: 8,
      isVisible: function isVisible(params) {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.ProgressReport);
      }
    },
    childRoutes: [_DosApprovalList.routes, _StudentReportView.routes, {
      path: ':mode',
      component: _ProgressReportListView2.default,
      actionButtons: {
        default: (0, _routes.generateActionButtons)(getState),
        'export-all': (0, _routes.generateActionButtons)(getState)
      }
    }]
  };
};

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(653);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1485);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
exports.default = _component2.default;

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1463);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3FvMZg7uMpcZIftMNq0elH{color:#a4a4a4;font-size:1.14286rem;margin-bottom:1.42857rem;padding-top:5rem;text-align:center}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"NoContentMessage": "_3FvMZg7uMpcZIftMNq0elH"
};

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1465);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _ = __webpack_require__(13);

var _StudentReportSummaries = __webpack_require__(42);

var _ApproveByDos = __webpack_require__(301);

var _RejectByDos = __webpack_require__(655);

var _RejectByDos2 = _interopRequireDefault(_RejectByDos);

var _ProgressTests = __webpack_require__(40);

var _StudentReportComment = __webpack_require__(205);

var _StudentReportComment2 = _interopRequireDefault(_StudentReportComment);

var _GroupMembers = __webpack_require__(14);

var _ArrowLink = __webpack_require__(656);

var _ArrowLink2 = _interopRequireDefault(_ArrowLink);

var _ProgressReportStatus = __webpack_require__(134);

var _ProgressReportStatus2 = _interopRequireDefault(_ProgressReportStatus);

var _AddInternalNoteControl = __webpack_require__(67);

var _AddInternalNoteControl2 = _interopRequireDefault(_AddInternalNoteControl);

var _UserCard = __webpack_require__(65);

var _UserCard2 = _interopRequireDefault(_UserCard);

var _StudentCardProfile = __webpack_require__(84);

var _StudentCardProfile2 = _interopRequireDefault(_StudentCardProfile);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _RejectNotePopup = __webpack_require__(206);

var _RejectNotePopup2 = _interopRequireDefault(_RejectNotePopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DosApprovalCard = function (_Component) {
  _inherits(DosApprovalCard, _Component);

  function DosApprovalCard(props) {
    _classCallCheck(this, DosApprovalCard);

    var _this = _possibleConstructorReturn(this, (DosApprovalCard.__proto__ || Object.getPrototypeOf(DosApprovalCard)).call(this, props));

    _this.state = {
      comments: null,
      isEditingComment: false,
      // the publish button is disabled while publishing
      isPublishButtonDisabled: false,
      // when publish succeeds we don't fetch again - we simply update this.
      isReportStatusPublished: false,
      isSaveAllTriggered: false, // mutex for the save all part
      isReportDetailsExpandedOnMobile: false,
      shouldShowRejectDialog: false
    };
    _this._hideShowRejectDialog = _this._hideShowRejectDialog.bind(_this);
    _this._onExpansionButtonClicked = _this._onExpansionButtonClicked.bind(_this);
    return _this;
  }

  _createClass(DosApprovalCard, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        comments: this.props.studentReport && this.props.studentReport.comments
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var studentReport = _ref.studentReport,
          shouldTriggerSaveAllComments = _ref.shouldTriggerSaveAllComments;
      var _props = this.props,
          progressReportId = _props.progressReportId,
          studentId = _props.studentId,
          submitStudentReportComment = _props.submitStudentReportComment;
      var studentReportId = studentReport.id;

      var comments = this.state.comments;
      if (this.props.studentReport !== studentReport) {
        this.setState({ comments: comments = studentReport && studentReport.comments });
      }
      if (shouldTriggerSaveAllComments && this.state.isEditingComment && !this.state.isSaveAllTriggered) {
        this.setState({ isSaveAllTriggered: true });
        submitStudentReportComment(progressReportId, studentReportId, comments, studentId);
      }
      if (!shouldTriggerSaveAllComments) {
        this.setState({ isSaveAllTriggered: false });
      }
    }
  }, {
    key: '_onExpansionButtonClicked',
    value: function _onExpansionButtonClicked() {
      var isReportDetailsExpandedOnMobile = this.state.isReportDetailsExpandedOnMobile;

      this.setState({
        isReportDetailsExpandedOnMobile: !isReportDetailsExpandedOnMobile
      });
    }
  }, {
    key: '_onEditButtonClicked',
    value: function _onEditButtonClicked() {
      this.setState({ isEditingComment: true });
      _is_js2.default.function(this.props.onEnterEditMode) && this.props.onEnterEditMode();
    }
  }, {
    key: '_onRejectButtonClicked',
    value: function _onRejectButtonClicked() {
      this.setState({ shouldShowRejectDialog: true });
    }
  }, {
    key: '_rejectStudentReport',
    value: function _rejectStudentReport(note) {
      var _this2 = this;

      var _props2 = this.props,
          progressReportId = _props2.progressReportId,
          studentReport = _props2.studentReport,
          studentId = _props2.studentId,
          rejectStudentReport = _props2.rejectStudentReport;

      var studentReportId = studentReport.id;
      rejectStudentReport(note, progressReportId, studentReportId).then(function () {
        return _this2.props.fetchStudentReportSummary(progressReportId, studentId);
      });
    }
  }, {
    key: '_onCommentChanged',
    value: function _onCommentChanged(text) {
      this.setState({ comments: text });
      _is_js2.default.function(this.props.onCommentChanged) && this.props.onCommentChanged(text);
    }
  }, {
    key: '_onDiscardCommentClick',
    value: function _onDiscardCommentClick() {
      var studentReport = this.props.studentReport;

      this.setState({
        isEditingComment: false,
        comments: studentReport && studentReport.comments
      });
      _is_js2.default.function(this.props.onLeaveEditMode) && this.props.onLeaveEditMode();
    }
  }, {
    key: '_onSaveCommentClicked',
    value: function _onSaveCommentClicked(commentText) {
      var _this3 = this;

      var _props3 = this.props,
          progressReportId = _props3.progressReportId,
          studentReport = _props3.studentReport,
          studentId = _props3.studentId,
          submitStudentReportComment = _props3.submitStudentReportComment;
      var studentReportId = studentReport.id;

      submitStudentReportComment(progressReportId, studentReportId, commentText, studentId).then(function () {
        return _this3.props.fetchStudentReportSummary(progressReportId, studentId);
      });
      this.setState({
        isEditingComment: false
      });
      this.props.onLeaveEditMode && this.props.onLeaveEditMode();
    }
  }, {
    key: '_onPublishClicked',
    value: function _onPublishClicked() {
      var _this4 = this;

      var _props4 = this.props,
          progressReportId = _props4.progressReportId,
          studentReport = _props4.studentReport,
          studentId = _props4.studentId,
          approveStudentReport = _props4.approveStudentReport;

      var studentReportId = studentReport.id;
      if (_is_js2.default.not.string(progressReportId) || _is_js2.default.not.string(studentReportId)) {
        return;
      }
      this.setState({ isPublishButtonDisabled: true });
      approveStudentReport(progressReportId, studentReportId).then(function (result) {
        if (Error.isError(result.payload)) {
          _this4.setState({ isPublishButtonDisabled: false });
        } else {
          _this4.setState({ isReportStatusPublished: true });
          _this4.props.fetchStudentReportSummary(progressReportId, studentId);
        }
      }).then(function () {
        var _props5 = _this4.props,
            progressTestPlan = _props5.progressTestPlan,
            groupId = _props5.groupId;

        if (!_is_js2.default.existy(progressTestPlan)) {
          return;
        }
        _this4.props.fetchProgressTest(groupId, progressTestPlan);
      });
    }
  }, {
    key: '_renderComments',
    value: function _renderComments() {
      if (_is_js2.default.not.string(this.state.comments) || _is_js2.default.empty(this.state.comments)) {
        return _react2.default.createElement(
          'div',
          null,
          'This Progress Report does not include comments.'
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          { className: _style2.default.DosApprovalCard_comments_body },
          this.state.comments
        )
      );
    }
  }, {
    key: '_renderCommentsEditor',
    value: function _renderCommentsEditor() {
      var _this5 = this;

      return _react2.default.createElement(_AddInternalNoteControl2.default, { text: this.state.comments,
        maxCharacters: 500,
        onChange: function onChange(text) {
          return _this5._onCommentChanged(text);
        },
        onDiscardClick: function onDiscardClick() {
          return _this5._onDiscardCommentClick();
        },
        onSaveClick: function onSaveClick(text) {
          return _this5._onSaveCommentClicked(text);
        } });
    }
  }, {
    key: '_renderButtons',
    value: function _renderButtons() {
      return _react2.default.createElement(
        _omniCommonUi.Button.Container,
        { className: _style2.default.DosApprovalCard_buttons },
        [this._renderPublishButton(), this._renderRejectButton(), this._renderEditButton()]
      );
    }
  }, {
    key: '_renderEditButton',
    value: function _renderEditButton() {
      var _this6 = this;

      var isReportStatusPublished = this.state.isReportStatusPublished;

      return _react2.default.createElement(
        _omniCommonUi.Button,
        { key: 'edit-button',
          type: _omniCommonUi.Button.Type.default,
          onClick: function onClick() {
            return _this6._onEditButtonClicked();
          },
          disabled: isReportStatusPublished },
        'Edit'
      );
    }
  }, {
    key: '_renderRejectButton',
    value: function _renderRejectButton() {
      var _this7 = this;

      return _react2.default.createElement(
        _omniCommonUi.Button,
        { key: 'reject-button',
          type: _omniCommonUi.Button.Type.default,
          onClick: function onClick() {
            return _this7._onRejectButtonClicked();
          } },
        'Reject'
      );
    }
  }, {
    key: '_renderPublishButton',
    value: function _renderPublishButton() {
      var _this8 = this;

      var _state = this.state,
          isReportStatusPublished = _state.isReportStatusPublished,
          isPublishButtonDisabled = _state.isPublishButtonDisabled;

      var buttonLabel = isReportStatusPublished ? 'Completed' : 'Approve';
      return _react2.default.createElement(
        _omniCommonUi.Button,
        { key: 'publish-button',
          onClick: function onClick() {
            return _this8._onPublishClicked();
          },
          type: _omniCommonUi.Button.Type.primary,
          disabled: isPublishButtonDisabled },
        buttonLabel
      );
    }
  }, {
    key: '_renderRejectDialog',
    value: function _renderRejectDialog() {
      var _this9 = this;

      return this.state.shouldShowRejectDialog && _react2.default.createElement(_RejectNotePopup2.default, { isOpen: true,
        isLoading: this.props.isAnyApiCall,
        onSave: function onSave(note) {
          return _this9._rejectStudentReport(note);
        },
        onCancel: this._hideShowRejectDialog });
    }
  }, {
    key: '_hideShowRejectDialog',
    value: function _hideShowRejectDialog() {
      this.setState({ shouldShowRejectDialog: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          student = _props6.student,
          studentReport = _props6.studentReport,
          progressTest = _props6.progressTest,
          studentProgressTestResult = _props6.studentProgressTestResult,
          timeZone = _props6.timeZone,
          buildRoute = _props6.buildRoute;
      var _state2 = this.state,
          isEditingComment = _state2.isEditingComment,
          isReportStatusPublished = _state2.isReportStatusPublished;


      if (_is_js2.default.undefined(studentReport)) {
        return null;
      }

      var progressTestSkills = progressTest.data.skills;
      var totalScore = studentProgressTestResult.totalScore;
      var percentage = totalScore.percentage,
          skillScorePercentages = totalScore.skillScorePercentages;
      var _studentProgressTestR = studentProgressTestResult.previousTotalScore,
          previousPercentage = _studentProgressTestR.percentage,
          previousSkillScorePercentages = _studentProgressTestR.skillScorePercentages;

      // mimics the backend response string. do not alter

      var localReportStatus = isReportStatusPublished ? _StudentReportSummaries.StudentReportSummary.Status.Completed : studentReport.status;
      var reportLink = './group/' + this.props.groupId + ('/unit-report/' + this.props.progressReportId) + ('/student/' + student.studentGeneralInfo.id);

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: _style2.default.DosApprovalCard },
        _react2.default.createElement(
          _omniCommonUi.Grid,
          null,
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12,
                sm: 4,
                className: (0, _classnames3.default)(_style2.default.DosApprovalCard_leftColumn, _defineProperty({}, _style2.default.__expandedOnMobile, this.state.isReportDetailsExpandedOnMobile)) },
              _react2.default.createElement(
                _omniCommonUi.StudentCard,
                { className: _style2.default.DosApprovalCard_student,
                  borderless: true,
                  backgroundless: true,
                  withSeparatorLine: true },
                _react2.default.createElement(_StudentCardProfile2.default, { studentId: student.studentGeneralInfo.id,
                  status: student.status,
                  statusHighlighted: student.isInProduction }),
                _react2.default.createElement(_omniCommonUi.StudentCard.Content, null)
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.DosApprovalCard_status },
                _react2.default.createElement(
                  'strong',
                  { className: _style2.default.DosApprovalCard_status_label },
                  'Report',
                  _react2.default.createElement('br', null),
                  'Status'
                ),
                _react2.default.createElement(_ProgressReportStatus2.default, { status: localReportStatus })
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.DosApprovalCard_scores },
                _react2.default.createElement(
                  'ul',
                  { className: _style2.default.DosApprovalCard_scores_breakdown },
                  _react2.default.createElement(
                    'li',
                    { className: _style2.default.DosApprovalCard_scores_total },
                    'Total Score:\xA0',
                    _react2.default.createElement(
                      'span',
                      { className: _style2.default.DosApprovalCard_scores_percentage },
                      totalScore.isNotApplicable ? 'n/a' : percentage + '%'
                    ),
                    _is_js2.default.number(previousPercentage) && previousPercentage !== percentage ? _react2.default.createElement(
                      'span',
                      { className: (0, _classnames3.default)(_style2.default.DosApprovalCard_scores_percentage, _style2.default.DosApprovalCard_scores_previous) },
                      previousPercentage,
                      '%'
                    ) : null
                  ),
                  progressTestSkills.map(function (skill) {
                    return _react2.default.createElement(
                      'li',
                      { key: skill.skillId },
                      function () {
                        var currentSkillScorePerc = skillScorePercentages.get(skill.skillId);
                        var previousSkillScorePerc = previousSkillScorePercentages.get(skill.skillId);
                        var currentSkillScorePercText = _is_js2.default.number(currentSkillScorePerc) ? currentSkillScorePerc + '%' : '';
                        var output = [_react2.default.createElement(
                          'span',
                          { key: student.studentGeneralInfo.id + '-' + skill.skillId + '-perc',
                            className: _style2.default.DosApprovalCard_scores_percentage },
                          skill.name,
                          ': ',
                          currentSkillScorePercText
                        )];
                        if (_is_js2.default.number(previousSkillScorePerc) && previousSkillScorePerc !== currentSkillScorePerc) {
                          output.push(_react2.default.createElement(
                            'span',
                            { key: student.studentGeneralInfo.id + '-' + skill.skillId + '-prevPerc',
                              className: (0, _classnames3.default)(_style2.default.DosApprovalCard_scores_percentage, _style2.default.DosApprovalCard_scores_previous) },
                            previousSkillScorePerc,
                            '%'
                          ));
                        }
                        return output;
                      }()
                    );
                  })
                ),
                _react2.default.createElement(
                  _ArrowLink2.default,
                  { className: _style2.default.DosApprovalCard_reportLink,
                    to: buildRoute(reportLink) },
                  'Report'
                )
              ),
              _react2.default.createElement(_ExpansionButton2.default, { className: _style2.default.DosApprovalCard_expander,
                isExpand: this.state.isReportDetailsExpandedOnMobile,
                onExpansionButtonClick: this._onExpansionButtonClicked })
            ),
            _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12,
                sm: 8,
                className: _style2.default.DosApprovalCard_rightColumn },
              ' ',
              _react2.default.createElement(
                'div',
                { className: _style2.default.DosApprovalCard_comment },
                _react2.default.createElement(_UserCard2.default, { id: studentReport.commentedByUserId,
                  className: _style2.default.DosApprovalCard_teacher,
                  getLines: function getLines(_ref2) {
                    var user = _ref2.user;
                    return [_react2.default.createElement(
                      'div',
                      { className: _style2.default.DosApprovalCard_teacher_line,
                        key: 'UserCard#item0' },
                      user.firstName,
                      ' ',
                      user.lastName
                    ), _react2.default.createElement(
                      'div',
                      { className: _style2.default.DosApprovalCard_teacher_line,
                        key: 'UserCard#item1' },
                      'Teacher'
                    ), _react2.default.createElement(
                      'div',
                      { className: _style2.default.DosApprovalCard_teacher_line,
                        key: 'UserCard#item2' },
                      _omniCommonUi.moment.utc(studentReport.commentedTimeUtc).clone().tz(timeZone).format('YYYY.MM.DD')
                    )];
                  } }),
                isEditingComment ? this._renderCommentsEditor() : this._renderComments()
              ),
              !isEditingComment && !isReportStatusPublished ? this._renderButtons() : null
            )
          )
        ),
        this._renderRejectDialog()
      );
    }
  }]);

  return DosApprovalCard;
}(_react.Component);

DosApprovalCard.propTypes = {
  fetchStudentReportSummary: _propTypes2.default.func.isRequired,
  groupId: _propTypes2.default.string.isRequired,
  timeZone: _propTypes2.default.string.isRequired,
  approveStudentReport: _propTypes2.default.func.isRequired,
  rejectStudentReport: _propTypes2.default.func.isRequired,
  progressReportId: _propTypes2.default.string.isRequired,
  studentId: _propTypes2.default.string.isRequired,
  studentReport: _propTypes2.default.object,
  progressTest: _propTypes2.default.instanceOf(_omniCommonUi.ApiResponse),
  studentProgressTestResult: _propTypes2.default.object,
  submitStudentReportComment: _propTypes2.default.func,
  student: _propTypes2.default.instanceOf(_GroupMembers.GroupMember),
  approval: _propTypes2.default.instanceOf(_omniCommonUi.ApiResponse),
  location: _propTypes2.default.object.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  shouldTriggerSaveAllComments: _propTypes2.default.bool,
  onEnterEditMode: _propTypes2.default.func.isRequired,
  onLeaveEditMode: _propTypes2.default.func.isRequired,
  onCommentChanged: _propTypes2.default.func,
  progressTestPlan: _propTypes2.default.object,
  isAnyApiCall: _propTypes2.default.boolean,
  fetchProgressTest: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var progressReportId = ownProps.progressReportId,
      studentId = ownProps.studentId,
      groupId = ownProps.groupId;

  var _Group$getCentre = _.actions.getCentre(state, groupId),
      timeZone = _Group$getCentre.timeZone;

  var key = progressReportId + '-' + studentId;
  var studentReport = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data.get('' + studentId);

  var approval = state.get('rootReducer').get('approveByDos').get(key);

  var progressReport = state.get('rootReducer').get('groups').get(groupId).data.get('progressReports').data.get(progressReportId);

  var student = _GroupMembers.actions.getMemberById(state, studentId);
  var progressTest = null;
  var studentProgressTestResult = null;
  var progressTestPlan = null;

  if (progressReport) {
    var reportProgressTestId = progressReport.progressTestId;

    progressTest = state.get('rootReducer').get('progressTests').get(reportProgressTestId);

    studentProgressTestResult = progressTest.data.studentProgressTestResults.get(studentId);

    progressTestPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId).data.find(function (plan) {
      return plan.progressReportId === progressReportId;
    });
  }
  return {
    timeZone: timeZone,
    progressReportId: progressReportId,
    progressTest: progressTest,
    studentReport: studentReport,
    studentProgressTestResult: studentProgressTestResult,
    student: student,
    approval: approval,
    progressTestPlan: progressTestPlan,
    groupId: groupId,
    isAnyApiCall: !!isAnyApiCall(state)
  };
}
function isAnyApiCall(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST', 'GET'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, (0, _redux.bindActionCreators)(_StudentReportSummaries.actions, dispatch), (0, _redux.bindActionCreators)(_RejectByDos2.default, dispatch), (0, _redux.bindActionCreators)(_ApproveByDos.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTests.actions, dispatch), (0, _redux.bindActionCreators)(_StudentReportComment2.default, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(DosApprovalCard);

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1466);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2aAlN8dQmRBUIswWYwhQ-r{padding:0;padding-bottom:1.42857rem}@media only screen and (min-width:480px){._2aAlN8dQmRBUIswWYwhQ-r{background:-webkit-gradient(linear,left top,right top,color-stop(35%,#e8ebef),color-stop(35%,#fbfbfb));background:-webkit-linear-gradient(left,#e8ebef 35%,#fbfbfb 0);background:-moz-linear-gradient(left,#e8ebef 35%,#fbfbfb 35%);background:-o-linear-gradient(left,#e8ebef 35%,#fbfbfb 35%);background:linear-gradient(90deg,#e8ebef 35%,#fbfbfb 0)}}@media only screen and (min-width:640px){._2aAlN8dQmRBUIswWYwhQ-r{padding:.57143rem 1.07143rem}}.VB19jf7an-_lGfdGpR1-0 ._2N3UwmpZHEDKC3cIVuT0bF,.VB19jf7an-_lGfdGpR1-0 .Fke9rHT-7e4UURliG3tY7{display:none}.VB19jf7an-_lGfdGpR1-0._1j3jgp7kFAjfvKPHRLNykw ._2N3UwmpZHEDKC3cIVuT0bF,.VB19jf7an-_lGfdGpR1-0._1j3jgp7kFAjfvKPHRLNykw .Fke9rHT-7e4UURliG3tY7{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}@media only screen and (min-width:480px){.VB19jf7an-_lGfdGpR1-0 ._2N3UwmpZHEDKC3cIVuT0bF,.VB19jf7an-_lGfdGpR1-0 .Fke9rHT-7e4UURliG3tY7{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.VB19jf7an-_lGfdGpR1-0 .K5-54ziKNFpAxwXmBi8uB{display:none}}._2oRrg5G18kkKTD6hN75ypo{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._2N3UwmpZHEDKC3cIVuT0bF,.Fke9rHT-7e4UURliG3tY7,.K5-54ziKNFpAxwXmBi8uB,.uClZ7qeRRkFB29beogP9L{background:#e8ebef}.uClZ7qeRRkFB29beogP9L{padding-top:.35714rem}@media only screen and (min-width:480px){.uClZ7qeRRkFB29beogP9L{background:transparent;padding-top:0}}._2N3UwmpZHEDKC3cIVuT0bF{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-flow:row wrap;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;padding:1.42857rem;padding-bottom:0;padding-top:.71429rem}._2N3UwmpZHEDKC3cIVuT0bF strong{font-weight:600}._2o07ClK6cKrPK4OJWmWb_{margin-right:1.42857rem}.Fke9rHT-7e4UURliG3tY7,.lRclSN72_tyCiXK9I0feV{line-height:1.5}.Fke9rHT-7e4UURliG3tY7{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-left:1.42857rem}@media only screen and (min-width:640px){.Fke9rHT-7e4UURliG3tY7{border-bottom:none;padding-bottom:0}}._3t0PYJjb5jA-MAGF5tlLt{-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;list-style-type:none;margin:0;padding:1.07143rem 0;padding-bottom:.71429rem;white-space:nowrap}._13DWJM3fhU3ezxbDf2a3l-{color:#a4a4a4;font-weight:400}._13DWJM3fhU3ezxbDf2a3l-:before{content:\" \"}.K5-54ziKNFpAxwXmBi8uB{border-bottom:.07143rem solid #ccc;-webkit-box-shadow:0 .07143rem .07143rem 0 #e3e3e3;-moz-box-shadow:0 .07143rem .07143rem 0 #e3e3e3;box-shadow:0 .07143rem .07143rem 0 #e3e3e3;position:relative;text-align:center;top:-.07143rem}._2Q1cLnCu-MM2c8E_xEdD15{display:none;font-weight:600;-webkit-box-pack:start!important;-webkit-justify-content:flex-start!important;-moz-box-pack:start!important;-ms-flex-pack:start!important;justify-content:flex-start!important;line-height:200%!important;margin-bottom:1.07143rem;text-transform:uppercase}@media only screen and (min-width:480px){._2Q1cLnCu-MM2c8E_xEdD15{display:block;line-height:150%!important}}._2HaZq78LJTAMXBvIMYrWiz{-webkit-box-flex:0;-webkit-flex:0 0 auto;-moz-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;margin-bottom:1.42857rem}._1Go3SNAG94_tVIvX2PbQmr{margin-bottom:0!important}._1Go3SNAG94_tVIvX2PbQmr:not(:first-child){color:#a4a4a4;font-size:90%}.lRclSN72_tyCiXK9I0feV{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex:1 0 auto;-moz-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:0 1.42857rem}@media only screen and (min-width:480px){.lRclSN72_tyCiXK9I0feV{padding-top:1rem}}@media only screen and (min-width:640px){.lRclSN72_tyCiXK9I0feV{padding-bottom:1.07143rem;padding-left:2.14286rem}}.lRclSN72_tyCiXK9I0feV p:first-child{margin-top:0}._22ZV4pVI4dWHHFpBltOSdm{-webkit-align-self:flex-end;-ms-flex-item-align:end;align-self:flex-end;-webkit-box-flex:0;-webkit-flex:0 0 auto;-moz-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding:.57143rem 1.42857rem}@media only screen and (min-width:480px){._22ZV4pVI4dWHHFpBltOSdm{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-bottom:1.07143rem;padding-top:.42857rem;white-space:nowrap}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"DosApprovalCard": "_2aAlN8dQmRBUIswWYwhQ-r",
	"DosApprovalCard_leftColumn": "VB19jf7an-_lGfdGpR1-0",
	"DosApprovalCard_status": "_2N3UwmpZHEDKC3cIVuT0bF",
	"DosApprovalCard_scores": "Fke9rHT-7e4UURliG3tY7",
	"__expandedOnMobile": "_1j3jgp7kFAjfvKPHRLNykw",
	"DosApprovalCard_expander": "K5-54ziKNFpAxwXmBi8uB",
	"DosApprovalCard_rightColumn": "_2oRrg5G18kkKTD6hN75ypo",
	"DosApprovalCard_student": "uClZ7qeRRkFB29beogP9L",
	"DosApprovalCard_status_label": "_2o07ClK6cKrPK4OJWmWb_",
	"DosApprovalCard_comment": "lRclSN72_tyCiXK9I0feV",
	"DosApprovalCard_scores_breakdown": "_3t0PYJjb5jA-MAGF5tlLt",
	"DosApprovalCard_scores_total": "_1as9vZovUvyXSeMQY_8F38",
	"DosApprovalCard_scores_percentage": "w9p9FEGsj0LMDgdNcq9f8",
	"DosApprovalCard_scores_previous": "_13DWJM3fhU3ezxbDf2a3l-",
	"DosApprovalCard_reportLink": "_2Q1cLnCu-MM2c8E_xEdD15",
	"DosApprovalCard_teacher": "_2HaZq78LJTAMXBvIMYrWiz",
	"DosApprovalCard_teacher_line": "_1Go3SNAG94_tVIvX2PbQmr",
	"DosApprovalCard_comment_body": "pAJOniPM35N47_Yjo3tnw",
	"DosApprovalCard_buttons": "_22ZV4pVI4dWHHFpBltOSdm"
};

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = approveByDos;

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _actions = __webpack_require__(654);

function approveByDos() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  var key = action.progressReportId + '-' + action.studentReportId;
  switch (action.type) {
    case _actions.APPROVE_STUDENT_REPORT_REQUEST:
      return state.set(key, _omniCommonUi.ApiResponseHelper.create({ loading: true }));
    case _actions.APPROVE_STUDENT_REPORT_SUCCESS:
      return state.set(key, _omniCommonUi.ApiResponseHelper.create({ data: true }));
    case _actions.APPROVE_STUDENT_REPORT_FAILURE:
      return state.set(key, _omniCommonUi.ApiResponseHelper.create(action.error));
    default:
      return state;
  }
}

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REJECT_STUDENT_REPORT_FAILURE = exports.REJECT_STUDENT_REPORT_SUCCESS = exports.REJECT_STUDENT_REPORT_REQUEST = undefined;
exports.rejectStudentReport = rejectStudentReport;

var _Api = __webpack_require__(11);

var _actions = __webpack_require__(200);

var _omniCommonUi = __webpack_require__(0);

var REJECT_STUDENT_REPORT_REQUEST = exports.REJECT_STUDENT_REPORT_REQUEST = 'REJECT_STUDENT_REPORT_REQUEST';
var REJECT_STUDENT_REPORT_SUCCESS = exports.REJECT_STUDENT_REPORT_SUCCESS = 'REJECT_STUDENT_REPORT_SUCCESS';
var REJECT_STUDENT_REPORT_FAILURE = exports.REJECT_STUDENT_REPORT_FAILURE = 'REJECT_STUDENT_REPORT_FAILURE';

function rejectStudentReport(note, progressReportId, studentReportId) {
  return function (dispatch, getState) {
    var userId = getState().get('singleSignOn').get('user').get('profile').sub;
    var url = (0, _Api.buildUrl)('/unit-reports/' + progressReportId + '/dos-rejects');
    var method = 'PUT';

    return dispatch(rejectStudentReportRequest()).payload.then(function (response) {
      return dispatch(rejectStudentReportSuccess(response));
    }
    // So that the report summary information gets updated
    ).then(function () {
      return dispatch((0, _actions.fetchStudentReportSummaryIfNeeded)(progressReportId, studentReportId));
    }).catch(function (error) {
      return dispatch(rejectStudentReportFailure(error));
    });

    function rejectStudentReportRequest() {
      var payload = (0, _Api.fetch)(url, {
        method: method,
        body: JSON.stringify({
          studentReportId: Number.parseInt(studentReportId, 10),
          rejectedBy: Number.parseInt(userId, 10),
          rejectedComment: note
        })
      });

      return _omniCommonUi.ApiCall.createAction({
        type: REJECT_STUDENT_REPORT_REQUEST,
        payload: payload,
        url: url,
        method: method
      });
    }

    function rejectStudentReportSuccess(payload) {
      return _omniCommonUi.ApiCall.createAction({
        type: REJECT_STUDENT_REPORT_SUCCESS,
        payload: payload,
        url: url,
        method: method
      });
    }

    function rejectStudentReportFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: REJECT_STUDENT_REPORT_FAILURE,
        error: error,
        url: url,
        method: method
      });
    }
  };
}

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_STUDENT_REPORT_COMMENT_FAILURE = exports.DELETE_STUDENT_REPORT_COMMENT_SUCCESS = exports.DELETE_STUDENT_REPORT_COMMENT_REQUEST = exports.SUBMIT_STUDENT_REPORT_COMMENT_FAILURE = exports.SUBMIT_STUDENT_REPORT_COMMENT_SUCCESS = exports.SUBMIT_STUDENT_REPORT_COMMENT_REQUEST = undefined;
exports.submitStudentReportComment = submitStudentReportComment;
exports.deleteStudentReportComment = deleteStudentReportComment;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var SUBMIT_STUDENT_REPORT_COMMENT_REQUEST = exports.SUBMIT_STUDENT_REPORT_COMMENT_REQUEST = 'SUBMIT_STUDENT_REPORT_COMMENT_REQUEST';
var SUBMIT_STUDENT_REPORT_COMMENT_SUCCESS = exports.SUBMIT_STUDENT_REPORT_COMMENT_SUCCESS = 'SUBMIT_STUDENT_REPORT_COMMENT_SUCCESS';
var SUBMIT_STUDENT_REPORT_COMMENT_FAILURE = exports.SUBMIT_STUDENT_REPORT_COMMENT_FAILURE = 'SUBMIT_STUDENT_REPORT_COMMENT_FAILURE';
var DELETE_STUDENT_REPORT_COMMENT_REQUEST = exports.DELETE_STUDENT_REPORT_COMMENT_REQUEST = 'DELETE_STUDENT_REPORT_COMMENT_REQUEST';
var DELETE_STUDENT_REPORT_COMMENT_SUCCESS = exports.DELETE_STUDENT_REPORT_COMMENT_SUCCESS = 'DELETE_STUDENT_REPORT_COMMENT_SUCCESS';
var DELETE_STUDENT_REPORT_COMMENT_FAILURE = exports.DELETE_STUDENT_REPORT_COMMENT_FAILURE = 'DELETE_STUDENT_REPORT_COMMENT_FAILURE';

function submitStudentReportComment(progressReportId, studentReportId, commentText, studentId) {
  return function (dispatch, getState) {
    var url = (0, _Api.buildUrl)('/unit-reports/' + progressReportId + '/' + ('student-reports/' + studentReportId + '/comments'));
    var method = 'PUT';
    var userId = getState().get('singleSignOn').get('user').get('profile').sub;
    return dispatch(submitStudentReportCommentRequest()).payload.then(function (response) {
      return dispatch(submitStudentReportCommentSuccess(response, commentText, progressReportId, studentId));
    }).catch(function (error) {
      return dispatch(submitStudentReportCommentFailure(error));
    });

    function submitStudentReportCommentRequest() {
      var request = (0, _Api.fetch)(url, {
        method: method,
        body: JSON.stringify({
          commentedByUserId: userId, // todo: set something realistic
          comments: commentText
        })
      });
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_STUDENT_REPORT_COMMENT_REQUEST,
        payload: request,
        url: url,
        method: method,
        progressReportId: progressReportId,
        studentReportId: studentReportId,
        comments: commentText
      });
    }

    function submitStudentReportCommentSuccess(response, comments) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_STUDENT_REPORT_COMMENT_SUCCESS,
        url: url,
        method: method,
        payload: response,
        comments: comments,
        progressReportId: progressReportId,
        studentId: studentId,
        userId: userId
      });
    }

    function submitStudentReportCommentFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_STUDENT_REPORT_COMMENT_FAILURE,
        url: url,
        method: method,
        error: error
      });
    }
  };
}

function deleteStudentReportComment(progressReportId, studentReportId, studentId) {
  return function (dispatch, getState) {
    var url = (0, _Api.buildUrl)('/unit-reports/' + progressReportId + '/' + ('student-reports/' + studentReportId + '/comments'));
    var method = 'DELETE';

    return dispatch(deleteStudentReportCommentRequest()).payload.then(function (response) {
      return dispatch(deleteStudentReportCommentSuccess(response, progressReportId, studentId));
    }).catch(function (error) {
      return dispatch(deleteStudentReportCommentFailure(error));
    });

    function deleteStudentReportCommentRequest() {
      var userId = getState().get('singleSignOn').get('user').get('profile').sub;
      var request = (0, _Api.fetch)(url, {
        method: method,
        body: JSON.stringify({ deletedByUserId: userId })
      });
      return _omniCommonUi.ApiCall.createAction({
        type: DELETE_STUDENT_REPORT_COMMENT_REQUEST,
        payload: request,
        url: url,
        method: method,
        progressReportId: progressReportId,
        studentReportId: studentReportId
      });
    }

    function deleteStudentReportCommentSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: DELETE_STUDENT_REPORT_COMMENT_SUCCESS,
        url: url,
        method: method,
        payload: response,
        progressReportId: progressReportId,
        studentId: studentId
      });
    }

    function deleteStudentReportCommentFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: DELETE_STUDENT_REPORT_COMMENT_FAILURE,
        url: url,
        method: method,
        error: error
      });
    }
  };
}

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1471);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._31llzd_ZO15pHEZONwa96f{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;font-size:.92857rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:100%;text-decoration:none;text-transform:uppercase;white-space:nowrap}._7I8_NvFUfuJ53Q8curfnO{margin-left:.71429rem}", ""]);

// exports
exports.locals = {
	"ArrowLink": "_31llzd_ZO15pHEZONwa96f",
	"ArrowLink_arrow": "_7I8_NvFUfuJ53Q8curfnO"
};

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1473);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1n-CQAO6QDG4FHG1wzpHKw{cursor:default;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._2VXg11ffz5NDwr4t0yFBhE{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-color:#a4a4a4;color:#fff;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-webkit-flex:0 1 auto;-moz-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;font-size:.71429rem;font-weight:400;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;letter-spacing:.07143rem;padding:.35714rem;text-transform:uppercase;white-space:nowrap}._2VXg11ffz5NDwr4t0yFBhE._1oug9-aFO4cxYEMlo4-kzx{background-color:#74d17f}._2VXg11ffz5NDwr4t0yFBhE._20LUn8GqmB99ek12NVIbF_{background-color:#f7932d}._2VXg11ffz5NDwr4t0yFBhE._2_YT8nt7gwg_cOpMWuZn_j{background-color:#a4a4a4}._2VXg11ffz5NDwr4t0yFBhE._2o4cxwOJIu4tvZRpq0Qxmg{background-color:#de4c4c}._2VXg11ffz5NDwr4t0yFBhE.CdqLJ6f3W0KuibTJ172vi{background-color:#92205f}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ProgressReportStatus": "_1n-CQAO6QDG4FHG1wzpHKw",
	"ProgressReportStatus_inner": "_2VXg11ffz5NDwr4t0yFBhE",
	"__ready": "_1oug9-aFO4cxYEMlo4-kzx",
	"__sent": "_20LUn8GqmB99ek12NVIbF_",
	"__published": "_2_YT8nt7gwg_cOpMWuZn_j",
	"__missing": "_2o4cxwOJIu4tvZRpq0Qxmg",
	"__rejected": "CdqLJ6f3W0KuibTJ172vi"
};

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1475);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._10_LvFSD0ykuksZMP0Id-N{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex:1 1 auto;-moz-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative}._2RsfaIqd2oPyTSy9Qud44b,.vDgVfyf0eLYAK2NWzlLpr{font-size:.85714rem;line-height:1rem}.vDgVfyf0eLYAK2NWzlLpr{color:#a4a4a4;font-size:.85714rem;letter-spacing:.05714rem}._24nCqbGVFoxZFiPdvvDLCh{-webkit-box-flex:1;-webkit-flex:1 0 auto;-moz-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto}._24nCqbGVFoxZFiPdvvDLCh+:not(._2RsfaIqd2oPyTSy9Qud44b){margin-top:.71429rem}._3-vV8lLZXP5pcIl7b0AKv2{border-color:#de4c4c}._2RsfaIqd2oPyTSy9Qud44b{-webkit-align-self:flex-end;-ms-flex-item-align:end;align-self:flex-end;line-height:2;margin-bottom:.35714rem}._2Vyo2tmNLxVVh-OEzp_pVb{-webkit-box-flex:0;-webkit-flex:0 0 auto;-moz-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin:1.42857rem 0 0;margin-top:auto}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"AddInternalNoteControl": "_10_LvFSD0ykuksZMP0Id-N",
	"AddInternalNoteControl_description": "vDgVfyf0eLYAK2NWzlLpr",
	"AddInternalNoteControl_charactersUsed": "_2RsfaIqd2oPyTSy9Qud44b",
	"AddInternalNoteControl_textarea": "_24nCqbGVFoxZFiPdvvDLCh",
	"AddInternalNoteControl_textarea_missing": "_3-vV8lLZXP5pcIl7b0AKv2",
	"AddInternalNoteControl_buttonWrapper": "_2Vyo2tmNLxVVh-OEzp_pVb"
};

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

var scroll = __webpack_require__(1477);

function calculateScrollOffset(elem, additionalOffset, alignment) {
  var body = document.body,
      html = document.documentElement;

  var elemRect = elem.getBoundingClientRect();
  var clientHeight = html.clientHeight;
  var documentHeight = Math.max( body.scrollHeight, body.offsetHeight, 
                                 html.clientHeight, html.scrollHeight, html.offsetHeight );

  additionalOffset = additionalOffset || 0;

  var scrollPosition;
  if (alignment === 'bottom') {
    scrollPosition = elemRect.bottom - clientHeight;
  } else if (alignment === 'middle') {
    scrollPosition = elemRect.bottom - clientHeight / 2 - elemRect.height / 2;
  } else { // top and default
    scrollPosition = elemRect.top;
  }

  var maxScrollPosition = documentHeight - clientHeight;
  return Math.min(scrollPosition + additionalOffset + window.pageYOffset,
                  maxScrollPosition);
}

module.exports = function (elem, options) {
  options = options || {};
  if (typeof elem === 'string') elem = document.querySelector(elem);
  if (elem) return scroll(0, calculateScrollOffset(elem, options.offset, options.align), options);
};


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Tween = __webpack_require__(1478);
var raf = __webpack_require__(1482);

/**
 * Expose `scrollTo`.
 */

module.exports = scrollTo;

/**
 * Scroll to `(x, y)`.
 *
 * @param {Number} x
 * @param {Number} y
 * @api public
 */

function scrollTo(x, y, options) {
  options = options || {};

  // start position
  var start = scroll();

  // setup tween
  var tween = Tween(start)
    .ease(options.ease || 'out-circ')
    .to({ top: y, left: x })
    .duration(options.duration || 1000);

  // scroll
  tween.update(function(o){
    window.scrollTo(o.left | 0, o.top | 0);
  });

  // handle end
  tween.on('end', function(){
    animate = function(){};
  });

  // animate
  function animate() {
    raf(animate);
    tween.update();
  }

  animate();
  
  return tween;
}

/**
 * Return scroll position.
 *
 * @return {Object}
 * @api private
 */

function scroll() {
  var y = window.pageYOffset || document.documentElement.scrollTop;
  var x = window.pageXOffset || document.documentElement.scrollLeft;
  return { top: y, left: x };
}


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var Emitter = __webpack_require__(1479);
var clone = __webpack_require__(1480);
var type = __webpack_require__(302);
var ease = __webpack_require__(1481);

/**
 * Expose `Tween`.
 */

module.exports = Tween;

/**
 * Initialize a new `Tween` with `obj`.
 *
 * @param {Object|Array} obj
 * @api public
 */

function Tween(obj) {
  if (!(this instanceof Tween)) return new Tween(obj);
  this._from = obj;
  this.ease('linear');
  this.duration(500);
}

/**
 * Mixin emitter.
 */

Emitter(Tween.prototype);

/**
 * Reset the tween.
 *
 * @api public
 */

Tween.prototype.reset = function(){
  this.isArray = 'array' === type(this._from);
  this._curr = clone(this._from);
  this._done = false;
  this._start = Date.now();
  return this;
};

/**
 * Tween to `obj` and reset internal state.
 *
 *    tween.to({ x: 50, y: 100 })
 *
 * @param {Object|Array} obj
 * @return {Tween} self
 * @api public
 */

Tween.prototype.to = function(obj){
  this.reset();
  this._to = obj;
  return this;
};

/**
 * Set duration to `ms` [500].
 *
 * @param {Number} ms
 * @return {Tween} self
 * @api public
 */

Tween.prototype.duration = function(ms){
  this._duration = ms;
  return this;
};

/**
 * Set easing function to `fn`.
 *
 *    tween.ease('in-out-sine')
 *
 * @param {String|Function} fn
 * @return {Tween}
 * @api public
 */

Tween.prototype.ease = function(fn){
  fn = 'function' == typeof fn ? fn : ease[fn];
  if (!fn) throw new TypeError('invalid easing function');
  this._ease = fn;
  return this;
};

/**
 * Stop the tween and immediately emit "stop" and "end".
 *
 * @return {Tween}
 * @api public
 */

Tween.prototype.stop = function(){
  this.stopped = true;
  this._done = true;
  this.emit('stop');
  this.emit('end');
  return this;
};

/**
 * Perform a step.
 *
 * @return {Tween} self
 * @api private
 */

Tween.prototype.step = function(){
  if (this._done) return;

  // duration
  var duration = this._duration;
  var now = Date.now();
  var delta = now - this._start;
  var done = delta >= duration;

  // complete
  if (done) {
    this._from = this._to;
    this._update(this._to);
    this._done = true;
    this.emit('end');
    return this;
  }

  // tween
  var from = this._from;
  var to = this._to;
  var curr = this._curr;
  var fn = this._ease;
  var p = (now - this._start) / duration;
  var n = fn(p);

  // array
  if (this.isArray) {
    for (var i = 0; i < from.length; ++i) {
      curr[i] = from[i] + (to[i] - from[i]) * n;
    }

    this._update(curr);
    return this;
  }

  // objech
  for (var k in from) {
    curr[k] = from[k] + (to[k] - from[k]) * n;
  }

  this._update(curr);
  return this;
};

/**
 * Set update function to `fn` or
 * when no argument is given this performs
 * a "step".
 *
 * @param {Function} fn
 * @return {Tween} self
 * @api public
 */

Tween.prototype.update = function(fn){
  if (0 == arguments.length) return this.step();
  this._update = fn;
  return this;
};

/***/ }),
/* 1479 */
/***/ (function(module, exports) {


/**
 * Expose `Emitter`.
 */

module.exports = Emitter;

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var type;
try {
  type = __webpack_require__(302);
} catch (_) {
  type = __webpack_require__(302);
}

/**
 * Module exports.
 */

module.exports = clone;

/**
 * Clones objects.
 *
 * @param {Mixed} any object
 * @api public
 */

function clone(obj){
  switch (type(obj)) {
    case 'object':
      var copy = {};
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          copy[key] = clone(obj[key]);
        }
      }
      return copy;

    case 'array':
      var copy = new Array(obj.length);
      for (var i = 0, l = obj.length; i < l; i++) {
        copy[i] = clone(obj[i]);
      }
      return copy;

    case 'regexp':
      // from millermedeiros/amd-utils - MIT
      var flags = '';
      flags += obj.multiline ? 'm' : '';
      flags += obj.global ? 'g' : '';
      flags += obj.ignoreCase ? 'i' : '';
      return new RegExp(obj.source, flags);

    case 'date':
      return new Date(obj.getTime());

    default: // string, number, boolean, …
      return obj;
  }
}


/***/ }),
/* 1481 */
/***/ (function(module, exports) {


// easing functions from "Tween.js"

exports.linear = function(n){
  return n;
};

exports.inQuad = function(n){
  return n * n;
};

exports.outQuad = function(n){
  return n * (2 - n);
};

exports.inOutQuad = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n;
  return - 0.5 * (--n * (n - 2) - 1);
};

exports.inCube = function(n){
  return n * n * n;
};

exports.outCube = function(n){
  return --n * n * n + 1;
};

exports.inOutCube = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n * n;
  return 0.5 * ((n -= 2 ) * n * n + 2);
};

exports.inQuart = function(n){
  return n * n * n * n;
};

exports.outQuart = function(n){
  return 1 - (--n * n * n * n);
};

exports.inOutQuart = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n * n * n;
  return -0.5 * ((n -= 2) * n * n * n - 2);
};

exports.inQuint = function(n){
  return n * n * n * n * n;
}

exports.outQuint = function(n){
  return --n * n * n * n * n + 1;
}

exports.inOutQuint = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n * n * n * n;
  return 0.5 * ((n -= 2) * n * n * n * n + 2);
};

exports.inSine = function(n){
  return 1 - Math.cos(n * Math.PI / 2 );
};

exports.outSine = function(n){
  return Math.sin(n * Math.PI / 2);
};

exports.inOutSine = function(n){
  return .5 * (1 - Math.cos(Math.PI * n));
};

exports.inExpo = function(n){
  return 0 == n ? 0 : Math.pow(1024, n - 1);
};

exports.outExpo = function(n){
  return 1 == n ? n : 1 - Math.pow(2, -10 * n);
};

exports.inOutExpo = function(n){
  if (0 == n) return 0;
  if (1 == n) return 1;
  if ((n *= 2) < 1) return .5 * Math.pow(1024, n - 1);
  return .5 * (-Math.pow(2, -10 * (n - 1)) + 2);
};

exports.inCirc = function(n){
  return 1 - Math.sqrt(1 - n * n);
};

exports.outCirc = function(n){
  return Math.sqrt(1 - (--n * n));
};

exports.inOutCirc = function(n){
  n *= 2
  if (n < 1) return -0.5 * (Math.sqrt(1 - n * n) - 1);
  return 0.5 * (Math.sqrt(1 - (n -= 2) * n) + 1);
};

exports.inBack = function(n){
  var s = 1.70158;
  return n * n * (( s + 1 ) * n - s);
};

exports.outBack = function(n){
  var s = 1.70158;
  return --n * n * ((s + 1) * n + s) + 1;
};

exports.inOutBack = function(n){
  var s = 1.70158 * 1.525;
  if ( ( n *= 2 ) < 1 ) return 0.5 * ( n * n * ( ( s + 1 ) * n - s ) );
  return 0.5 * ( ( n -= 2 ) * n * ( ( s + 1 ) * n + s ) + 2 );
};

exports.inBounce = function(n){
  return 1 - exports.outBounce(1 - n);
};

exports.outBounce = function(n){
  if ( n < ( 1 / 2.75 ) ) {
    return 7.5625 * n * n;
  } else if ( n < ( 2 / 2.75 ) ) {
    return 7.5625 * ( n -= ( 1.5 / 2.75 ) ) * n + 0.75;
  } else if ( n < ( 2.5 / 2.75 ) ) {
    return 7.5625 * ( n -= ( 2.25 / 2.75 ) ) * n + 0.9375;
  } else {
    return 7.5625 * ( n -= ( 2.625 / 2.75 ) ) * n + 0.984375;
  }
};

exports.inOutBounce = function(n){
  if (n < .5) return exports.inBounce(n * 2) * .5;
  return exports.outBounce(n * 2 - 1) * .5 + .5;
};

// aliases

exports['in-quad'] = exports.inQuad;
exports['out-quad'] = exports.outQuad;
exports['in-out-quad'] = exports.inOutQuad;
exports['in-cube'] = exports.inCube;
exports['out-cube'] = exports.outCube;
exports['in-out-cube'] = exports.inOutCube;
exports['in-quart'] = exports.inQuart;
exports['out-quart'] = exports.outQuart;
exports['in-out-quart'] = exports.inOutQuart;
exports['in-quint'] = exports.inQuint;
exports['out-quint'] = exports.outQuint;
exports['in-out-quint'] = exports.inOutQuint;
exports['in-sine'] = exports.inSine;
exports['out-sine'] = exports.outSine;
exports['in-out-sine'] = exports.inOutSine;
exports['in-expo'] = exports.inExpo;
exports['out-expo'] = exports.outExpo;
exports['in-out-expo'] = exports.inOutExpo;
exports['in-circ'] = exports.inCirc;
exports['out-circ'] = exports.outCirc;
exports['in-out-circ'] = exports.inOutCirc;
exports['in-back'] = exports.inBack;
exports['out-back'] = exports.outBack;
exports['in-out-back'] = exports.inOutBack;
exports['in-bounce'] = exports.inBounce;
exports['out-bounce'] = exports.outBounce;
exports['in-out-bounce'] = exports.inOutBounce;


/***/ }),
/* 1482 */
/***/ (function(module, exports) {

/**
 * Expose `requestAnimationFrame()`.
 */

exports = module.exports = window.requestAnimationFrame
  || window.webkitRequestAnimationFrame
  || window.mozRequestAnimationFrame
  || fallback;

/**
 * Fallback implementation.
 */

var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime();
  var ms = Math.max(0, 16 - (curr - prev));
  var req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

/**
 * Cancel.
 */

var cancel = window.cancelAnimationFrame
  || window.webkitCancelAnimationFrame
  || window.mozCancelAnimationFrame
  || window.clearTimeout;

exports.cancel = function(id){
  cancel.call(window, id);
};


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1484);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".ZkPRT4ejlLCSEPE0yx2KK{border-bottom:.07143rem solid #ccc;padding:.71429rem 1.42857rem}.tZdXLGu6B5GqKPycn_lTo{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:1.125em;font-weight:600;margin-right:1.42857rem}._13i9CSXbnkF9AsqOic_P3l{font-style:italic;padding:.71429rem 1.42857rem 1.42857rem}.AkwN0RrqSBQOqDHxEVj5A{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:.71429rem 0 2.14286rem}._3r1IPix_8OkRBwFJVCEqK1{margin-right:.35714rem}.Rm7AtlyGawjkGbwXDQGTF{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"RejectNotePopup_title": "ZkPRT4ejlLCSEPE0yx2KK",
	"RejectNotePopup_title_text": "tZdXLGu6B5GqKPycn_lTo",
	"RejectNotePopup_content": "_13i9CSXbnkF9AsqOic_P3l",
	"RejectNotePopup_content_info": "AkwN0RrqSBQOqDHxEVj5A",
	"RejectNotePopup_content_info_icon": "_3r1IPix_8OkRBwFJVCEqK1",
	"RejectNotePopup_buttons": "Rm7AtlyGawjkGbwXDQGTF"
};

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(653);

var _component2 = _interopRequireDefault(_component);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: 'dos-approval',
    component: _component2.default,
    canAccess: function canAccess() {
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.ApproveComment);
    },
    tabs: {
      hidden: true
    },
    sessionNav: {
      hidden: true
    },
    actionButtons: {
      hidden: true
    },
    breadcrumbLabels: 'DOS Approval'
  };
};

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(658);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(668);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
exports.default = _component2.default;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1488);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2Arg5Tci6AFIGC5caJ7iwj{white-space:pre-wrap}._1P6CQtNPGGwiTWkdkFkqUb:not(:first-child){margin-left:1.42857rem}._2EVsUlvIPvBS43S7ks7uqb,._2p6IU6CBnwhFCIr-0D2iBL{height:100%}._1ZnTNttp1tBvYWCHtgVLc9{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-top:.57143rem}._1ZjkPqJdGuDKbPWLzE9flp{-webkit-box-flex:1;-webkit-flex:1 1 100%;-moz-box-flex:1;-ms-flex:1 1 100%;flex:1 1 100%;max-width:100%}@media only screen and (min-width:640px){._1ZjkPqJdGuDKbPWLzE9flp{-webkit-flex-basis:0;-ms-flex-preferred-size:0;flex-basis:0}}._1ZjkPqJdGuDKbPWLzE9flp:not(:last-child){margin-bottom:1.42857rem}@media only screen and (min-width:640px){._1ZjkPqJdGuDKbPWLzE9flp:not(:last-child){margin-bottom:0;margin-right:2.14286rem}}._1fvIzPQ4DHE9kQCmgXt9ez{margin-left:1.07143rem;padding:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentReportView_unitSummary_body": "_2Arg5Tci6AFIGC5caJ7iwj",
	"StudentReportView_card_icon": "_1P6CQtNPGGwiTWkdkFkqUb",
	"StudentReportView_student_card": "_2p6IU6CBnwhFCIr-0D2iBL",
	"StudentReportView_teachers_card": "_2EVsUlvIPvBS43S7ks7uqb",
	"StudentReportView_teachers_list": "_1ZnTNttp1tBvYWCHtgVLc9",
	"StudentReportView_teachers_item": "_1ZjkPqJdGuDKbPWLzE9flp",
	"StudentReportView_teachers_profile": "_1fvIzPQ4DHE9kQCmgXt9ez"
};

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1490);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "@-webkit-keyframes _2STe4gRlx-rLGQNRbbFTVg{0%{opacity:0}to{opacity:1}}@-moz-keyframes _2STe4gRlx-rLGQNRbbFTVg{0%{opacity:0}to{opacity:1}}@-o-keyframes _2STe4gRlx-rLGQNRbbFTVg{0%{opacity:0}to{opacity:1}}@keyframes _2STe4gRlx-rLGQNRbbFTVg{0%{opacity:0}to{opacity:1}}._3-6oOHeYE1njP_ALC7qI3r{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;-moz-box-orient:horizontal;-moz-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}._1eMLdgU4knzSTO1J9DWJGs{-webkit-flex-basis:100%;-ms-flex-preferred-size:100%;flex-basis:100%}._1QWNqinqqPnBx_4lOmgBxG{-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;margin-top:1.25em}._2yYttsiY74v7DoLcZDpGdk{font-size:1rem;line-height:1.5rem;margin:0;margin-top:.42857rem}._3H6JhBcZu1hrCv3K9qnHeG{border-bottom:.07143rem solid #ccc;margin-bottom:1.42857rem;margin-top:1.42857rem;-webkit-transition-duration:0ms;-moz-transition-duration:0ms;-o-transition-duration:0ms;transition-duration:0ms}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"InternalNoteView_header": "_3-6oOHeYE1njP_ALC7qI3r",
	"InternalNoteView_header_info": "_1eMLdgU4knzSTO1J9DWJGs",
	"InternalNoteView_header_actions": "_1QWNqinqqPnBx_4lOmgBxG",
	"InternalNoteView_note": "_2yYttsiY74v7DoLcZDpGdk",
	"InternalNoteView_noteWithBottomLine": "_3H6JhBcZu1hrCv3K9qnHeG",
	"InternalNoteView_tooltip_opacity": "_2STe4gRlx-rLGQNRbbFTVg"
};

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1492);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._21TL7WUaQJ0vdCim457MkR{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row}._1GWOHCgV-4HEA4I8EN74YI:not(:first-child){margin-left:1.42857rem}._1GWOHCgV-4HEA4I8EN74YI a{cursor:pointer}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"CardActionIcons": "_21TL7WUaQJ0vdCim457MkR",
	"CardActionIcons_item": "_1GWOHCgV-4HEA4I8EN74YI"
};

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = onlineHomeworkReducer;

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _actions = __webpack_require__(659);

var _model = __webpack_require__(303);

var _model2 = _interopRequireDefault(_model);

var _StudentOnlineHomework = __webpack_require__(1494);

var _StudentOnlineHomework2 = _interopRequireDefault(_StudentOnlineHomework);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function onlineHomeworkReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_ONLINE_HOMEWORK_REQUEST:
      return state.set(action.groupId, _omniCommonUi.ApiResponseHelper.create({ loading: true }));
    case _actions.FETCH_ONLINE_HOMEWORK_SUCCESS:
      return state.set(action.groupId, _omniCommonUi.ApiResponseHelper.create(setOnlineHomework(state, action.payload)));
    case _actions.FETCH_ONLINE_HOMEWORK_FAILURE:
      return state.set(action.groupId, _omniCommonUi.ApiResponseHelper.create(action.error));
    default:
      return state;
  }
}

function setOnlineHomework(state, payload) {
  return new _immutable.List(payload.map(function (homeworkBySession) {
    var studentOnlineHomeworkResults = new _immutable.List(homeworkBySession.studentOnlineHomeworkResults.map(function (homeworkByStudent) {
      return _StudentOnlineHomework2.default.create(homeworkByStudent).set('sessionId', '' + homeworkBySession.sessionId);
    }));
    return _model2.default.create(homeworkBySession).set('studentOnlineHomeworkResults', studentOnlineHomeworkResults);
  }));
}

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(660);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1495);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(660);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'sessionId':
    case 'studentId':
      return [key, '' + val];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(303);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'lessonNumber':
      return [key, Number.parseInt(val, 10)];
    case 'sessionId':
    case 'unitId':
      return [key, '' + val];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = paperBasedHomework;

var _actions = __webpack_require__(661);

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(662);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function paperBasedHomework() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_PAPERBASE_HOMEWORK_SUCCESS:
      return state.set('' + action.id, onSuccess(action.payload));
    case _actions.FETCH_GROUP_PAPERBASE_HOMEWORK_SUCCESS:
      return onSuccess(action.payload).groupBy(function (paperBased) {
        return paperBased.sessionId;
      });
    default:
      return state;
  }
}

function onSuccess(paperBasedHomeworks) {
  return new _immutable.List(paperBasedHomeworks.map(function (paperBased) {
    return _model2.default.create(paperBased);
  }));
}

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _StudentPaperBasedHomework = __webpack_require__(1499);

var _StudentPaperBasedHomework2 = _interopRequireDefault(_StudentPaperBasedHomework);

var _model = __webpack_require__(662);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'sessionId':
    case 'unitId':
      return [key, '' + val];
    case 'lessonNumber':
      return [key, Number.parseInt(val, 10)];
    case 'studentPaperBasedHomeworks':
      return [key, new _immutable.List(val.map(function (data) {
        return _StudentPaperBasedHomework2.default.create(data);
      }))];
    case 'studentTutorialHomeworks':
      return [key, new _immutable.List(val.map(function (data) {
        return _StudentPaperBasedHomework2.default.create(data);
      }))];
    default:
      return [key, val];
  }
};
var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentPaperBasedHomework = undefined;

var _model = __webpack_require__(663);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1500);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudentPaperBasedHomework = exports.StudentPaperBasedHomework = _model2.default;

StudentPaperBasedHomework.create = _create2.default;

exports.default = StudentPaperBasedHomework;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _model = __webpack_require__(663);

var _model2 = _interopRequireDefault(_model);

var _status = __webpack_require__(109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'id':
    case 'studentId':
      return [key, '' + val]; // stringify
    case 'homeworkStatus':
      return [key, (0, _status.covertBackendPaperBasedHomeworkStatusToHomeworkStatus)(val)];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

var create = exports.create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBandByScore = getBandByScore;
exports.getScoreBand = getScoreBand;
function getBandByScore(score, language, scoreBand) {
  var band = void 0;
  if (scoreBand && scoreBand.size && scoreBand.size !== 0) {
    scoreBand.forEach(function (level) {
      if (score >= level.get('scorePercentageFrom') && score < level.get('scorePercentageTo') && level.get('language') === language) {
        band = level;
      } else if (score === 100 && score === level.get('scorePercentageTo') && level.get('language') === language) {
        band = level;
      }
    });
  }
  return band;
}

function getScoreBand(state, id) {
  return state.get('rootReducer').get('scoreBand').get(id);
}

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scoreBandReducer;

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _actions = __webpack_require__(664);

var _model = __webpack_require__(665);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scoreBandReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_SCORE_BAND_SUCCESS:
      return addScoreBandToMap(state, action);
    case _actions.FETCH_SCORE_BAND_FAILURE:
      return state.set(action.score + '-' + action.languageCode, _omniCommonUi.ApiResponseHelper.create(action.error));
    default:
      return state;
  }
}

function addScoreBandToMap(state, _ref) {
  var payload = _ref.payload;

  var newState = state;
  if (payload && payload.length && payload.length !== 0) {
    payload.forEach(function (scoreBand) {
      var model = new _model2.default(scoreBand);
      newState = newState.set(model.id, model);
    });
  }
  return newState;
}

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1504);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._9_FB0vP9b0ZvBYDOmwd4H{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-style:italic;padding:.71429rem 0 1.42857rem}._36XmYVqGE58sjdlGEnF3bl{margin-right:.35714rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"RejectNote_content_info": "_9_FB0vP9b0ZvBYDOmwd4H",
	"RejectNote_content_info_icon": "_36XmYVqGE58sjdlGEnF3bl"
};

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportStudentCard = undefined;

var _style = __webpack_require__(1506);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _ProductionStatus = __webpack_require__(73);

var _ProgressReportStatus = __webpack_require__(134);

var _ProgressReportStatus2 = _interopRequireDefault(_ProgressReportStatus);

var _StudentCardProfile = __webpack_require__(84);

var _StudentCardProfile2 = _interopRequireDefault(_StudentCardProfile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportStudentCard = exports.ReportStudentCard = function ReportStudentCard(props) {
  var studentGeneralInfo = props.studentGeneralInfo,
      member = props.member,
      reportStatus = props.reportStatus,
      submittedDate = props.submittedDate;

  var status = (0, _ProductionStatus.parseProductionStatus)(member.status);
  var pageCardClassName = (0, _classnames2.default)(_style2.default.ReportStudentCard, (0, _omniCommonUi.testClass)('report-student-card'));
  return _react2.default.createElement(
    _omniCommonUi.PageCard,
    { className: pageCardClassName },
    _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Student' }),
    _react2.default.createElement(
      _omniCommonUi.PageCard.Content,
      { className: _style2.default.ReportStudentCard_content },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_style2.default.ReportStudentCard_content_items, _style2.default.ReportStudentCard_studentInfo) },
        _react2.default.createElement(
          _omniCommonUi.StudentCard,
          { borderless: true, backgroundless: true },
          _react2.default.createElement(_StudentCardProfile2.default, { useLowerLevelPersonComponent: true,
            className: _style2.default.ReportStudentCard_profile,
            withoutBottomPadding: true,
            studentId: studentGeneralInfo.id,
            status: status.fullName,
            statusHighlighted: member.isInProduction })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_style2.default.ReportStudentCard_items, _style2.default.ReportStudentCard_reportStatus) },
        _react2.default.createElement(
          'h2',
          { className: _style2.default.ReportStudentCard_reportStatus_title },
          'Report Status'
        ),
        _react2.default.createElement(_ProgressReportStatus2.default, { status: reportStatus,
          className: _style2.default.ReportStudentCard_reportStatus_status })
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_style2.default.ReportStudentCard_items, _style2.default.ReportStudentCard_reportStatus) },
        _react2.default.createElement(
          'h2',
          { className: _style2.default.ReportStudentCard_reportStatus_title },
          'Submitted Date'
        ),
        _react2.default.createElement(
          'p',
          { className: _style2.default.ReportStudentCard_reportStatus_status },
          submittedDate
        )
      )
    )
  );
};

ReportStudentCard.propTypes = {
  studentName: _propTypes2.default.string,
  studentGeneralInfo: _propTypes2.default.object,
  member: _propTypes2.default.object,
  reportStatus: _propTypes2.default.string,
  submittedDate: _propTypes2.default.string
};

exports.default = ReportStudentCard;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1507);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3s1374RkzmSSzt_hH_BgSY{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}._17mQ2BBEJjkFxT38SHMq3f{-webkit-flex-basis:100%;-ms-flex-preferred-size:100%;flex-basis:100%}@media only screen and (min-width:480px){._17mQ2BBEJjkFxT38SHMq3f{-webkit-flex-basis:50%;-ms-flex-preferred-size:50%;flex-basis:50%}}._37Lv0xiAVrpsAOo_myMrd_{padding:.57143rem 1.07143rem}._23rODRztetR0byTH3Hzsdx{font-size:1.07143rem;font-weight:600;margin:0}._1l5y5lf-oSehdy_u-SAVzp{margin-top:.71429rem}@media only screen and (min-width:480px){._1l5y5lf-oSehdy_u-SAVzp{margin-top:1.57143rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ReportStudentCard_profile": "_18Xjd5GQcnXb--7QL_Qb4v",
	"ReportStudentCard_content": "_3s1374RkzmSSzt_hH_BgSY",
	"ReportStudentCard_content_items": "_17mQ2BBEJjkFxT38SHMq3f",
	"ReportStudentCard_reportStatus": "_37Lv0xiAVrpsAOo_myMrd_",
	"ReportStudentCard_reportStatus_title": "_23rODRztetR0byTH3Hzsdx",
	"ReportStudentCard_reportStatus_status": "_1l5y5lf-oSehdy_u-SAVzp"
};

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressTestCard = undefined;

var _style = __webpack_require__(1509);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _RadialScoreDisplay = __webpack_require__(283);

var _RadialScoreDisplay2 = _interopRequireDefault(_RadialScoreDisplay);

var _ScoreBand = __webpack_require__(666);

var _ScoreBand2 = _interopRequireDefault(_ScoreBand);

var _ScoreStar = __webpack_require__(667);

var _ScoreStar2 = _interopRequireDefault(_ScoreStar);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressTestCard = exports.ProgressTestCard = function ProgressTestCard(props) {
  var publishedDateStr = props.publishedDateStr,
      name = props.name,
      percentage = props.percentage,
      isSSCourseTypeGroup = props.isSSCourseTypeGroup,
      className = props.className;

  return _react2.default.createElement(
    _omniCommonUi.PageCard,
    { className: (0, _classnames2.default)(className, _style2.default.ProgressTestCard) },
    _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Progress' }),
    _react2.default.createElement(
      _omniCommonUi.PageCard.Content,
      null,
      _react2.default.createElement(
        'div',
        { className: _style2.default.ProgressTestCard_wrapper },
        _react2.default.createElement(
          'div',
          { className: _style2.default.ProgressTestCard_wrapper_narrative },
          _react2.default.createElement(
            'h2',
            { className: _style2.default.ProgressTestCard_wrapper_narrative_subTitle },
            name,
            _react2.default.createElement('br', null),
            'Total score:\xA0',
            _react2.default.createElement(
              'span',
              { className: _style2.default.ProgressTestCard_wrapper_scoreText },
              percentage,
              '%'
            )
          ),
          _react2.default.createElement(_ScoreBand2.default, { score: percentage }),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'time',
              { dateTime: publishedDateStr },
              publishedDateStr
            )
          )
        ),
        isSSCourseTypeGroup ? _react2.default.createElement(_ScoreStar2.default, { currentResult: percentage,
          fullMark: 100 }) : _react2.default.createElement(_RadialScoreDisplay2.default, { className: _style2.default.ProgressTestCard_wrapper_radialScore,
          radius: 40,
          circleStrokeWidth: 2,
          edgeSize: 120,
          forcedTextY: 66,
          unit: 'percent',
          displayText: true,
          formatText: function formatText(value) {
            return value + '%';
          },
          circleStroke: 'transparent',
          progressStroke: '#74d17f',
          value: percentage })
      )
    )
  );
};

ProgressTestCard.propTypes = {
  className: _propTypes2.default.object,
  publishedDateStr: _propTypes2.default.string,
  name: _propTypes2.default.string,
  percentage: _propTypes2.default.number,
  isSSCourseTypeGroup: _propTypes2.default.bool.isRequired
};

exports.default = ProgressTestCard;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1510);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3EAmsecFZQg8vV8SD0fh6B{height:100%}._3UPSJytv7IOCq6ePE8m8lF{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.p_uExkHiuipDYl340-jzY{-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1}.kQb2_RHoWGwkXlBRzg3f2{font-size:1.14286rem;font-weight:600;line-height:1.71429rem}.kQb2_RHoWGwkXlBRzg3f2:first-child{margin-top:0}.kQb2_RHoWGwkXlBRzg3f2:only-child{margin-bottom:0;margin-top:0}.p_uExkHiuipDYl340-jzY p:last-child{margin-bottom:0}@media only screen and (min-width:640px){.pzV-oaW4qDQd3OXtk3JKA{display:none}}._2ReNy0VELNbbDg63uCxyqA{display:none;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;font-size:1.28571rem}@media only screen and (min-width:640px){._2ReNy0VELNbbDg63uCxyqA{display:block}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ProgressTestCard": "_3EAmsecFZQg8vV8SD0fh6B",
	"ProgressTestCard_wrapper": "_3UPSJytv7IOCq6ePE8m8lF",
	"ProgressTestCard_wrapper_narrative": "p_uExkHiuipDYl340-jzY",
	"ProgressTestCard_wrapper_narrative_subTitle": "kQb2_RHoWGwkXlBRzg3f2",
	"ProgressTestCard_wrapper_scoreText": "pzV-oaW4qDQd3OXtk3JKA",
	"ProgressTestCard_wrapper_radialScore": "_2ReNy0VELNbbDg63uCxyqA"
};

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1512);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._26NLp5rFi4Dm1Ge8e8CeOY{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex}._21oX3Fa2g_RO6g_doIYpio{color:#f5a623}._21oX3Fa2g_RO6g_doIYpio+._21oX3Fa2g_RO6g_doIYpio{margin-left:.35714rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ScoreStar": "_26NLp5rFi4Dm1Ge8e8CeOY",
	"ScoreStar_starIcon": "_21oX3Fa2g_RO6g_doIYpio"
};

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _SimpleTable = __webpack_require__(133);

var _SimpleTable2 = _interopRequireDefault(_SimpleTable);

var _style = __webpack_require__(1514);

var _style2 = _interopRequireDefault(_style);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverallDevelopmentCard = function (_PureComponent) {
  _inherits(OverallDevelopmentCard, _PureComponent);

  function OverallDevelopmentCard() {
    _classCallCheck(this, OverallDevelopmentCard);

    return _possibleConstructorReturn(this, (OverallDevelopmentCard.__proto__ || Object.getPrototypeOf(OverallDevelopmentCard)).apply(this, arguments));
  }

  _createClass(OverallDevelopmentCard, [{
    key: '_renderHeader',
    value: function _renderHeader(abilities) {
      return _react2.default.createElement(
        _SimpleTable2.default.Header,
        null,
        _react2.default.createElement(
          _SimpleTable2.default.Row,
          null,
          _react2.default.createElement(_SimpleTable2.default.Cell, { columnId: { columnId: 'skill' }, key: 0 }),
          abilities.sort(function (a, b) {
            return b.point - a.point;
          }).map(function (ability) {
            return _react2.default.createElement(
              _SimpleTable2.default.Cell,
              { key: ability.abilityId,
                columnId: { columnId: 'ability', ability: ability } },
              ability.name
            );
          })
        )
      );
    }
  }, {
    key: '_renderBody',
    value: function _renderBody(skillMap, subSkillMap) {
      return _react2.default.createElement(
        _SimpleTable2.default.Body,
        null,
        function (_ref, _ref2) {
          var skillResult = _ref.skillResult;
          var columnId = _ref2.columnId,
              ability = _ref2.ability;

          if (columnId === 'skill') {
            return _react2.default.createElement(
              _SimpleTable2.default.Cell,
              null,
              skillMap.get(skillResult.skillId)
            );
          }

          var items = skillResult.subSkillResults.filter(function (ssr) {
            return ssr.currentResultAbilityId === ability.abilityId;
          }).map(function (ssr) {
            return { uid: ssr.subSkillId, value: subSkillMap.get(ssr.subSkillId) };
          });

          if (items.length === 0) {
            return _react2.default.createElement(_SimpleTable2.default.Cell, null);
          } else if (items.length === 1) {
            return _react2.default.createElement(
              _SimpleTable2.default.Cell,
              null,
              items[0].value
            );
          }

          return _react2.default.createElement(
            _SimpleTable2.default.Cell,
            null,
            _react2.default.createElement(
              'ul',
              null,
              items.map(function (item) {
                return _react2.default.createElement(
                  'li',
                  { key: item.uid, style: { textAlign: 'left' } },
                  item.value
                );
              })
            )
          );
        }
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          skills = _props.skills,
          skillResults = _props.skillResults;


      var skillMap = new Map();
      var subSkillMap = new Map();
      var abilities = skills.get(0).abilities;
      skills.forEach(function (skill) {
        if (!skillMap.has(skill.skillId)) {
          skillMap.set(skill.skillId, skill.name);
        }

        skill.subSkills.forEach(function (subSkill) {
          if (!subSkillMap.has(subSkill.subSkillId)) {
            subSkillMap.set(subSkill.subSkillId, subSkill.name);
          }
        });
      });

      var rows = skillResults.toList().map(function (skillResult) {
        return { skillResult: skillResult };
      });

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _classnames2.default)(className, _style2.default.OverallDevelopmentCard) },
        _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Overall Development' }),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          null,
          _react2.default.createElement(
            _SimpleTable2.default,
            { rows: rows },
            this._renderHeader(abilities),
            this._renderBody(skillMap, subSkillMap)
          )
        )
      );
    }
  }]);

  return OverallDevelopmentCard;
}(_react.PureComponent);

OverallDevelopmentCard.propTypes = {
  className: _propTypes2.default.string,
  skills: _propTypes2.default.object,
  skillResults: _propTypes2.default.object
};

exports.default = OverallDevelopmentCard;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1515);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3bUEz9xa51PZBPuOUxj3oH{height:100%}._3bUEz9xa51PZBPuOUxj3oH p{margin-bottom:0;margin-top:0}._3bUEz9xa51PZBPuOUxj3oH span{font-weight:700}.JpMM8HcUVXJE5AV03zmYY:first-child{margin-top:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"OverallDevelopmentCard": "_3bUEz9xa51PZBPuOUxj3oH",
	"OverallDevelopmentCard_subtitle": "JpMM8HcUVXJE5AV03zmYY"
};

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomeworkCard = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _style = __webpack_require__(1517);

var _style2 = _interopRequireDefault(_style);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var HomeworkCard = exports.HomeworkCard = function HomeworkCard(props) {
  var className = props.className;
  var averageScorePercentage = props.averageScorePercentage,
      completedAssignments = props.completedAssignments,
      totalAssignments = props.totalAssignments,
      completedPaperBased = props.completedPaperBased,
      totalPaperBased = props.totalPaperBased,
      shouldShowPaperBased = props.shouldShowPaperBased;

  return _react2.default.createElement(
    _omniCommonUi.PageCard,
    { className: (0, _classnames2.default)(className, _style2.default.HomeworkCard) },
    _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Homework' }),
    _react2.default.createElement(
      _omniCommonUi.PageCard.Content,
      null,
      _react2.default.createElement(
        'div',
        { className: _style2.default.HomeworkCard_wrapper },
        _react2.default.createElement(
          'p',
          { className: _style2.default.HomeworkCard_subtitle },
          'Assignments completed'
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.HomeworkCard_dots_wrapper },
          _react2.default.createElement(
            'span',
            { className: _style2.default.HomeworkCard_dots_caption },
            completedAssignments + '/' + totalAssignments
          ),
          totalAssignments <= 10 && _react2.default.createElement(
            'div',
            { className: _style2.default.HomeworkCard_dots },
            [].concat(_toConsumableArray(Array(completedAssignments).keys())).map(function (index) {
              return _react2.default.createElement('span', { key: index,
                className: (0, _classnames2.default)(_style2.default.HomeworkCard_dot, _style2.default.HomeworkCard_dot_filled) });
            }),
            [].concat(_toConsumableArray(Array(totalAssignments - completedAssignments).keys())).map(function (index) {
              return _react2.default.createElement('span', { className: _style2.default.HomeworkCard_dot, key: index });
            })
          )
        ),
        _react2.default.createElement(
          'p',
          { className: _style2.default.HomeworkCard_subtitle },
          'Average score for completed assignments'
        ),
        _react2.default.createElement(
          'span',
          { className: _style2.default.HomeworkCard_avgScorePerc },
          averageScorePercentage || 0,
          '%'
        ),
        shouldShowPaperBased && [_react2.default.createElement(
          'p',
          { className: _style2.default.HomeworkCard_subtitle },
          'Paper-based practice completed'
        ), _react2.default.createElement(
          'div',
          { className: _style2.default.HomeworkCard_dots_wrapper },
          _react2.default.createElement(
            'span',
            { className: _style2.default.HomeworkCard_dots_caption },
            completedPaperBased + '/' + totalPaperBased
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.HomeworkCard_dots },
            [].concat(_toConsumableArray(Array(completedPaperBased).keys())).map(function (index) {
              return _react2.default.createElement('span', { key: index,
                className: (0, _classnames2.default)(_style2.default.HomeworkCard_dot, _style2.default.HomeworkCard_dot_filled) });
            }),
            [].concat(_toConsumableArray(Array(totalPaperBased - completedPaperBased).keys())).map(function (index) {
              return _react2.default.createElement('span', { key: index, className: _style2.default.HomeworkCard_dot });
            })
          )
        )]
      )
    )
  );
};

HomeworkCard.propTypes = {
  averageScorePercentage: _propTypes2.default.number,
  completedAssignments: _propTypes2.default.number,
  totalAssignments: _propTypes2.default.number,
  className: _propTypes2.default.string,
  shouldShowPaperBased: _propTypes2.default.bool.isRequired,
  completedPaperBased: _propTypes2.default.number,
  totalPaperBased: _propTypes2.default.number
};

exports.default = HomeworkCard;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1518);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".t4LftBhvDMoJnB2AFmLt8{height:100%}.t4LftBhvDMoJnB2AFmLt8 p{margin-bottom:0;margin-top:0}.t4LftBhvDMoJnB2AFmLt8 span{font-weight:700}._38zSZ9UZHVj26MAhIQzPQg:first-child{margin-top:0}._3zzv8UCqb0MR0qfHaI4eEq+._38zSZ9UZHVj26MAhIQzPQg,.yI8-WJfHJL2QzwYVVWSgu+._38zSZ9UZHVj26MAhIQzPQg{margin-top:1.42857rem}._3zzv8UCqb0MR0qfHaI4eEq{margin-bottom:0}.oMApYg_sFkBN_BRryZSOv{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-left:.71429rem;margin-top:.21429rem;width:14.64286rem}.oMApYg_sFkBN_BRryZSOv,.yI8-WJfHJL2QzwYVVWSgu{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._3A7C5K3ww6I_N0DCoJv1I1{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin-right:.71429rem}._3A7C5K3ww6I_N0DCoJv1I1,._3A7C5K3ww6I_N0DCoJv1I1:before{-webkit-box-flex:0;-moz-box-flex:0;height:.71429rem;width:.71429rem}._3A7C5K3ww6I_N0DCoJv1I1:before{background-color:#ccc;border-color:#ccc;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;content:\"\";-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto}._1ju5cDkH9SgEkSSLiACLOr:before{background-color:#0087e6;border-color:#0087e6}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"HomeworkCard": "t4LftBhvDMoJnB2AFmLt8",
	"HomeworkCard_subtitle": "_38zSZ9UZHVj26MAhIQzPQg",
	"HomeworkCard_dots_wrapper": "yI8-WJfHJL2QzwYVVWSgu",
	"HomeworkCard_avgScorePerc": "_3zzv8UCqb0MR0qfHaI4eEq",
	"HomeworkCard_dots": "oMApYg_sFkBN_BRryZSOv",
	"HomeworkCard_dot": "_3A7C5K3ww6I_N0DCoJv1I1",
	"HomeworkCard_dot_filled": "_1ju5cDkH9SgEkSSLiACLOr"
};

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkillScoreCard = undefined;

var _style = __webpack_require__(1520);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _ScoreStar = __webpack_require__(667);

var _ScoreStar2 = _interopRequireDefault(_ScoreStar);

var _ScoreBand = __webpack_require__(666);

var _ScoreBand2 = _interopRequireDefault(_ScoreBand);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SkillScoreCard = exports.SkillScoreCard = function SkillScoreCard(_ref) {
  var skillName = _ref.skillName,
      skillDescription = _ref.skillDescription,
      scorePercentage = _ref.scorePercentage,
      studentResultForSkill = _ref.studentResultForSkill,
      isSSCourseTypeGroup = _ref.isSSCourseTypeGroup;

  var suggestionsElem = null;
  if (studentResultForSkill.suggestions && studentResultForSkill.suggestions.size > 0) {
    suggestionsElem = _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'h4',
        null,
        'Suggestions'
      ),
      _react2.default.createElement(
        'ul',
        null,
        studentResultForSkill.suggestions.map(function (suggestion) {
          return _react2.default.createElement(
            'li',
            null,
            suggestion
          );
        })
      )
    );
  }
  return _react2.default.createElement(
    _omniCommonUi.PageCard,
    { className: _style2.default.SkillScoreCard },
    _react2.default.createElement(
      _omniCommonUi.PageCard.Content,
      null,
      _react2.default.createElement(
        'h4',
        { className: _style2.default.SkillScoreCard_heading },
        _react2.default.createElement(
          'span',
          { className: (0, _omniCommonUi.testClass)('pt-skill') },
          skillName
        ),
        '\xA0',
        !isSSCourseTypeGroup && studentResultForSkill.currentResult + '/' + studentResultForSkill.fullMark
      ),
      _react2.default.createElement(
        'div',
        { className: _style2.default.SkillScoreCard_progressWrapper },
        isSSCourseTypeGroup ? _react2.default.createElement(_ScoreStar2.default, { currentResult: studentResultForSkill.currentResult,
          fullMark: studentResultForSkill.fullMark }) : _react2.default.createElement(_omniCommonUi.ProgressBar, { className: _style2.default.SkillScoreCard_progressBar,
          value: studentResultForSkill.currentResult,
          max: studentResultForSkill.fullMark,
          larger: true,
          rounded: true })
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ScoreBand2.default, { className: _style2.default.SkillScoreCard_scoreBand,
          score: scorePercentage,
          textKey: 'name' }),
        _react2.default.createElement(
          'p',
          { className: _style2.default.SkillScoreCard_description },
          skillDescription
        )
      ),
      suggestionsElem
    )
  );
};

SkillScoreCard.propTypes = {
  skillName: _propTypes2.default.string.isRequired,
  skillDescription: _propTypes2.default.string.isRequired,
  scorePercentage: _propTypes2.default.number.isRequired,
  studentResultForSkill: _propTypes2.default.object.isRequired,
  isSSCourseTypeGroup: _propTypes2.default.bool.isRequired
};

exports.default = SkillScoreCard;

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1521);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2ba4fb08S-exan0LWLJEOP{height:100%}._3RxGsnFI0Tm6ujjtU4Woym{font-weight:700;margin-top:0}._2P25nuTTvxS9ypIPyKI4VA{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin:1.28571rem 0}._3Dk_FZ00vCFmRiQ2k9jPOL{-webkit-flex-basis:65%;-ms-flex-preferred-size:65%;flex-basis:65%}@media only screen and (min-width:800px){._3Dk_FZ00vCFmRiQ2k9jPOL{-webkit-flex-basis:40%;-ms-flex-preferred-size:40%;flex-basis:40%}}@media only screen and (min-width:800px){._2YNpvhAd4czFQZrr0WnKr_{margin-right:.71429rem}}._3emVLuWnX70OFJgTxvoyQE{font-weight:700}._2nl3zYfjIlSKEwfta5_n21{margin-bottom:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SkillScoreCard": "_2ba4fb08S-exan0LWLJEOP",
	"SkillScoreCard_heading": "_3RxGsnFI0Tm6ujjtU4Woym",
	"SkillScoreCard_progressWrapper": "_2P25nuTTvxS9ypIPyKI4VA",
	"SkillScoreCard_progressBar": "_3Dk_FZ00vCFmRiQ2k9jPOL",
	"SkillScoreCard_mistakesLink": "_2YNpvhAd4czFQZrr0WnKr_",
	"SkillScoreCard_scoreBand": "_3emVLuWnX70OFJgTxvoyQE",
	"SkillScoreCard_description": "_2nl3zYfjIlSKEwfta5_n21"
};

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1523);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Api = __webpack_require__(11);

var _Exporter = __webpack_require__(50);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

var _omniCommonUi = __webpack_require__(0);

var _LanguageRadio = __webpack_require__(74);

var _LanguageRadio2 = _interopRequireDefault(_LanguageRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXPORT_FILENAME = 'Unit Reports.pdf';
var EXPORT_MIME_TYPE = 'application/pdf';

var ExportDialog = function (_Component) {
  _inherits(ExportDialog, _Component);

  function ExportDialog() {
    _classCallCheck(this, ExportDialog);

    var _this = _possibleConstructorReturn(this, (ExportDialog.__proto__ || Object.getPrototypeOf(ExportDialog)).call(this));

    _this.state = {
      isExportRequested: false
    };

    _this._onLanguageChanged = _this._onLanguageChanged.bind(_this);
    return _this;
  }

  _createClass(ExportDialog, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ choosedLanguageCode: this.props.languageCode });
    }
  }, {
    key: '_close',
    value: function _close() {
      var _props = this.props,
          buildRoute = _props.buildRoute,
          pushRoute = _props.pushRoute;

      function redirect(param) {
        pushRoute(buildRoute(param));
      }
      redirect({ mode: '' });
    }
  }, {
    key: '_performExport',
    value: function _performExport() {
      var _this2 = this;

      var _props2 = this.props,
          progressReportId = _props2.progressReportId,
          studentId = _props2.studentId;

      if (_is_js2.default.falsy(progressReportId)) {
        _omniCommonUi.log.error('ExportAllHandler is not exporting - progressReportId is not set!');
        return;
      }

      var url = (0, _Api.buildUrl)('/unit-reports/' + progressReportId + '/students/' + studentId + '/printable-student-reports-pdf?' + ('languageCode=' + (this.state.choosedLanguageCode || _Languages2.default.defaultLanguageCode)));

      _Exporter.exporter.get(url, EXPORT_FILENAME, false, EXPORT_MIME_TYPE).then(function () {
        _this2._close();
      }).catch(function () {
        _this2.setState({ isExportErrorOccurred: true });
      });

      this.setState({ isExportRequested: true });
    }
  }, {
    key: '_onLanguageChanged',
    value: function _onLanguageChanged(languageCode) {
      this.setState({ choosedLanguageCode: languageCode });
    }
  }, {
    key: '_isChecked',
    value: function _isChecked(languageCode) {
      return languageCode === this.state.choosedLanguageCode;
    }
  }, {
    key: '_isDefaultLanguage',
    value: function _isDefaultLanguage() {
      if (!this.props.languageCode) return true;
      return _Languages2.default.defaultLanguageCode === this.props.languageCode;
    }
  }, {
    key: '_renderLanguageRadio',
    value: function _renderLanguageRadio() {
      return _react2.default.createElement(_LanguageRadio2.default, { name: 'language-picker',
        languageCode: this.props.languageCode,
        onChecked: this._onLanguageChanged,
        choosedLanguageCode: this.state.choosedLanguageCode });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (this.state.isExportErrorOccurred) {
        return _react2.default.createElement(_omniCommonUi.ErrorDialog, { isOpen: true,
          onConfirmClick: function onConfirmClick() {
            _this3._close();
          } });
      }

      if (!this._isDefaultLanguage()) {
        return _react2.default.createElement(
          _omniCommonUi.ConfirmDialog,
          { isOpen: true,
            isLoading: this.state.isExportRequested,
            title: 'Choose Language:',
            primaryButtonContent: 'Export',
            secondaryButtonContent: 'Cancel',
            onPrimaryClick: function onPrimaryClick() {
              return _this3._performExport();
            },
            onSecondaryClick: function onSecondaryClick() {
              return _this3._close();
            },
            onRequestClose: function onRequestClose() {
              return _this3._close();
            } },
          _react2.default.createElement(
            'div',
            { className: _style2.default.ExportAllHandler_feedback_content },
            _react2.default.createElement(
              'div',
              { className: _style2.default.ExportAllHandler_feedback_languageRadio },
              this._renderLanguageRadio()
            )
          )
        );
      }
      // the export starts automatically!
      !this.state.isExportRequested && this._performExport();
      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: true,
          isLoading: true,
          isButtonless: true,
          title: 'Exporting reports, please wait' },
        _react2.default.createElement('div', { className: _style2.default.ExportAllHandler_feedback_exportingImmediately })
      );
    }
  }]);

  return ExportDialog;
}(_react.Component);

ExportDialog.propTypes = {
  studentReportSummary: _propTypes2.default.shape({
    filter: _propTypes2.default.func.isRequired
  }).isRequired,
  progressReportId: _propTypes2.default.string.isRequired,
  languageCode: _propTypes2.default.string.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  studentId: _propTypes2.default.func.isRequired
};

exports.default = ExportDialog;

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1524);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3HkKeRtxq_VU80y-de6eCj{min-height:4.57143rem}._3ArmliX5rU1n7VsaFCoc6X{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3ArmliX5rU1n7VsaFCoc6X>p+p{margin-top:0}.PAyzrujocQ8o7hQCjKVE_{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:initial}.PAyzrujocQ8o7hQCjKVE_>*{margin-top:1.07143rem}._2M_FwR973DHoQ3xboMA5gD{border-top:.07143rem solid #ccc;display:block;margin:.35714rem 0;width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ExportAllHandler_feedback_exportingImmediately": "_3HkKeRtxq_VU80y-de6eCj",
	"ExportAllHandler_feedback_content": "_3ArmliX5rU1n7VsaFCoc6X",
	"ExportAllHandler_feedback_languageRadio": "PAyzrujocQ8o7hQCjKVE_",
	"ExportAllHandler_feedback_divider": "_2M_FwR973DHoQ3xboMA5gD"
};

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1526);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3znHXjVFnc0qDe4Ofm1G03{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:initial}._3znHXjVFnc0qDe4Ofm1G03>:not(:first-of-type){margin-top:1.07143rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"LanguageRadio": "_3znHXjVFnc0qDe4Ofm1G03"
};

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1528);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _GroupMembers = __webpack_require__(14);

var _UiState = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentSelect = function (_PureComponent) {
  _inherits(StudentSelect, _PureComponent);

  function StudentSelect(props) {
    _classCallCheck(this, StudentSelect);

    var _this = _possibleConstructorReturn(this, (StudentSelect.__proto__ || Object.getPrototypeOf(StudentSelect)).call(this, props));

    _this._getLinkHrefForValue = function (studentId) {
      return _this.props.buildRoute({ studentId: studentId, mode: '' });
    };
    return _this;
  }

  _createClass(StudentSelect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._buildStudentSelectOptions();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._buildStudentSelectOptions(nextProps);
    }
  }, {
    key: '_buildStudentSelectOptions',
    value: function _buildStudentSelectOptions() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      // cache the result
      if (_is_js2.default.existy(this._studentSelectOptions) && _is_js2.default.existy(this._membersInCurrentProgressReport) && this._membersInCurrentProgressReport === props.membersInCurrentProgressReport) {
        return;
      }
      var membersInCurrentProgressReport = props.membersInCurrentProgressReport;

      if (membersInCurrentProgressReport && membersInCurrentProgressReport.size > 0) {
        // cache this - do not recreate each time
        this._membersInCurrentProgressReport = membersInCurrentProgressReport;
        this._studentSelectOptions = membersInCurrentProgressReport.map(function (option) {
          var studentGeneralInfo = option.studentGeneralInfo;

          var optionHtml = _react2.default.createElement(
            _omniCommonUi.StudentCard,
            { vertical: true,
              borderless: true,
              backgroundless: true },
            _react2.default.createElement(_omniCommonUi.StudentCard.Profile, { name: studentGeneralInfo.firstName,
              surname: studentGeneralInfo.lastName,
              localName: studentGeneralInfo.localName,
              avatarUrl: studentGeneralInfo.avatarUrl,
              gender: studentGeneralInfo.gender })
          );
          return {
            html: optionHtml,
            value: studentGeneralInfo.id
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentMember = _props.currentMember,
          membersInCurrentProgressReport = _props.membersInCurrentProgressReport,
          isHide = _props.isHide;

      if (currentMember && membersInCurrentProgressReport.size && membersInCurrentProgressReport.size > 0) {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.StudentSelect },
          _react2.default.createElement(_omniCommonUi.HorizontalSelect, { options: this._studentSelectOptions,
            value: currentMember && currentMember.studentGeneralInfo.id,
            getLinkHrefForValue: this._getLinkHrefForValue,
            isHide: isHide })
        );
      }
      return null;
    }
  }]);

  return StudentSelect;
}(_react.PureComponent);

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      studentId = _ownProps$params.studentId,
      groupId = _ownProps$params.groupId,
      progressReportId = _ownProps$params.progressReportId;

  var studentReportSummaries = state.get('rootReducer').get('studentReportSummaries').get(progressReportId);
  if (studentReportSummaries && studentReportSummaries.data) {
    var studentReportSummariesStudentIds = studentReportSummaries.data.toList().map(function (srs) {
      return srs.studentId;
    });
    var membersInCurrentProgressReport = _GroupMembers.actions.getMembersByGroup(state, groupId).filter(function (_ref) {
      var id = _ref.studentGeneralInfo.id;
      return studentReportSummariesStudentIds.indexOf('' + id) !== -1;
    });
    return {
      currentMember: _GroupMembers.actions.getMemberById(state, studentId),
      membersInCurrentProgressReport: membersInCurrentProgressReport,
      isHide: !_UiState.actions.getShowNavigationBar(state)
    };
  }
}

StudentSelect.propTypes = {
  currentMember: _propTypes2.default.object,
  membersInCurrentProgressReport: _propTypes2.default.object,
  buildRoute: _propTypes2.default.func,
  isHide: _propTypes2.default.bool
};

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null)(StudentSelect);

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1529);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2ILFgvuezGfIPwRG_qGSnL{background:#f3f5f7;border-bottom:.07143rem solid #ccc;padding:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentSelect": "_2ILFgvuezGfIPwRG_qGSnL"
};

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(1531);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(669);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
exports.default = _component2.default;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressReportListView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1532);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _reactRouter = __webpack_require__(16);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _omniCommonUi = __webpack_require__(0);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _ProgressReports = __webpack_require__(94);

var _StudentReportSummaries = __webpack_require__(42);

var _GroupMembers = __webpack_require__(14);

var _ProgressReportStatus = __webpack_require__(134);

var _ProgressReportStatus2 = _interopRequireDefault(_ProgressReportStatus);

var _ExportAllHandler = __webpack_require__(1534);

var _ExportAllHandler2 = _interopRequireDefault(_ExportAllHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MARKING = "edit";
var EXPORT_ALL = "export-all";
var EMPTY_HYPHEN = "–";

var COLUMN_SCORE = "total-score";
var COLUMN_COMMENTS = "comments";
var COLUMN_STATUS = "report-status";
var COLUMN_REPORT = "unit-report";

var ProgressReportListView = exports.ProgressReportListView = function (_Component) {
  _inherits(ProgressReportListView, _Component);

  function ProgressReportListView(props) {
    _classCallCheck(this, ProgressReportListView);

    var _this = _possibleConstructorReturn(this, (ProgressReportListView.__proto__ || Object.getPrototypeOf(ProgressReportListView)).call(this, props));

    _this.state = {
      isExpandRemainingMember: true
    };
    return _this;
  }

  _createClass(ProgressReportListView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
    }
  }, {
    key: "routerWillLeave",
    value: function routerWillLeave(nextLocation) {
      var _props = this.props,
          studentReportSummaries = _props.studentReportSummaries,
          currentProgressReportId = _props.currentProgressReportId,
          submitStudentReportSummaryTeacherPublish = _props.submitStudentReportSummaryTeacherPublish,
          buildRoute = _props.buildRoute,
          pushRoute = _props.pushRoute,
          groupId = _props.groupId;

      if (!nextLocation) return;
      if (nextLocation.pathname.endsWith("/publish-all")) {
        var studentReportSummaryIds = studentReportSummaries.toList().filter(function (srs) {
          return srs.status === _StudentReportSummaries.StudentReportSummary.Status.Ready;
        }).map(function (srs) {
          return srs.id;
        });
        submitStudentReportSummaryTeacherPublish(currentProgressReportId, groupId, studentReportSummaryIds);
        pushRoute(buildRoute({ mode: "" }));
      }
    }
  }, {
    key: "_findProgressTestResultsForStudent",
    value: function _findProgressTestResultsForStudent(progressTestResults, studentId) {
      return progressTestResults.find(function (result) {
        return result.studentId === studentId;
      });
    }
  }, {
    key: "_getTotalAsPercentageOrHyphen",
    value: function _getTotalAsPercentageOrHyphen(_ref) {
      var _ref$totalScore = _ref.totalScore,
          totalScore = _ref$totalScore === undefined ? {} : _ref$totalScore;

      if (!_is_js2.default.object(totalScore) || totalScore.isEmpty || totalScore.isNotApplicable) {
        return EMPTY_HYPHEN;
      }
      return (totalScore.percentage || 0) + "%";
    }
  }, {
    key: "_gaLinkClicked",
    value: function _gaLinkClicked() {
      _reactGa2.default.event({
        category: "Progress Reports",
        action: "Clicked link to individual report"
      });
    }
  }, {
    key: "_renderCell",
    value: function _renderCell(member, column) {
      var _this2 = this;

      var _props2 = this.props,
          studentReportSummaries = _props2.studentReportSummaries,
          progressTest = _props2.progressTest;
      var studentId = member.studentGeneralInfo.id;

      var progressTestResults = progressTest.data.studentProgressTestResults;

      var reportSummaryForStudent = studentReportSummaries.find(function (report) {
        return report.studentId === studentId;
      });

      if (!reportSummaryForStudent && column !== COLUMN_REPORT) {
        if (column === COLUMN_STATUS) {
          return _react2.default.createElement(
            "div",
            { className: _style2.default.ProgressReportListView_status },
            EMPTY_HYPHEN
          );
        }
        return EMPTY_HYPHEN;
      }

      var studentProgressTestResults = this._findProgressTestResultsForStudent(progressTestResults, member.studentGeneralInfo.id);
      var progressReportLinkClassName = (0, _classnames2.default)(_style2.default.ProgressReportLink, (0, _omniCommonUi.testClass)("report-link-cell"));

      switch (column) {
        case COLUMN_SCORE:
          return this._getTotalAsPercentageOrHyphen(studentProgressTestResults);
        case COLUMN_COMMENTS:
          return this._renderComments(reportSummaryForStudent.comments);
        case COLUMN_STATUS:
          return _react2.default.createElement(
            "div",
            { className: _style2.default.ProgressReportListView_status },
            _react2.default.createElement(_ProgressReportStatus2.default, {
              className: _style2.default.ProgressReportListView_status_content,
              status: reportSummaryForStudent.status
            })
          );
        case COLUMN_REPORT:
          return _react2.default.createElement(
            _reactRouter.Link,
            {
              className: progressReportLinkClassName,
              to: this.props.buildRoute("./student/" + studentId),
              draggable: false,
              onClick: function onClick() {
                return _this2._gaLinkClicked();
              }
            },
            "Report",
            " ",
            _react2.default.createElement(_omniCommonUi.Icon, { id: "arrow-right", className: _style2.default.ProgressReportLink_icon })
          );
        default:
          throw new Error("Invalid column: " + column);
      }
    }
  }, {
    key: "_renderComments",
    value: function _renderComments(comments) {
      if (!comments) {
        return _react2.default.createElement(
          "span",
          {
            className: (0, _classnames2.default)(_style2.default.ProgressReportListView_comment, _style2.default.__empty)
          },
          EMPTY_HYPHEN
        );
      }

      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        {
          className: _style2.default.ProgressReportListView_comment,
          text: comments
        },
        _react2.default.createElement(
          "span",
          { className: _style2.default.ProgressReportListView_comment_inner },
          comments
        )
      );
    }
  }, {
    key: "_renderExpandButton",
    value: function _renderExpandButton() {
      var _this3 = this;

      var isExpandRemainingMember = this.state.isExpandRemainingMember;


      return _react2.default.createElement(_ExpansionButton2.default, {
        isExpand: isExpandRemainingMember,
        onExpansionButtonClick: function onExpansionButtonClick() {
          return _this3.setState({ isExpandRemainingMember: !isExpandRemainingMember });
        },
        className: _style2.default.ProgressReportListView_expand
      });
    }
  }, {
    key: "_renderURTable",
    value: function _renderURTable(members) {
      var _this4 = this;

      var tip = "";

      if (this.props.courseType.indexOf("SSv3") !== -1) {
        tip = _react2.default.createElement(
          _omniCommonUi.Tooltip,
          {
            text: "Total Score calculated from Can-do Statements",
            placement: "right",
            trigger: ["hover"],
            className: _style2.default.ProgressReportListView_cardHeader_tooltip
          },
          _react2.default.createElement(_omniCommonUi.Icon, { id: "question" })
        );
      }

      return _react2.default.createElement(
        _CourseViewTable2.default,
        { students: members },
        _react2.default.createElement(
          _CourseViewTable2.default.Header,
          null,
          _react2.default.createElement(
            _CourseViewTable2.default.Row,
            null,
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: COLUMN_SCORE },
              "Total Score",
              tip
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: COLUMN_COMMENTS },
              "Comments"
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: COLUMN_STATUS },
              "Report Status"
            ),
            _react2.default.createElement(_CourseViewTable2.default.Cell, { columnId: COLUMN_REPORT })
          )
        ),
        _react2.default.createElement(
          _CourseViewTable2.default.Body,
          null,
          function (member, column) {
            return _this4._renderCell(member, column);
          }
        )
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          members = _props3.members,
          studentReportSummaries = _props3.studentReportSummaries,
          currentProgressReportId = _props3.currentProgressReportId,
          languageCode = _props3.languageCode,
          pushRoute = _props3.pushRoute,
          buildRoute = _props3.buildRoute;


      if (!_immutable.List.isList(members) || !studentReportSummaries) {
        return null;
      }

      var isInExportAllRoute = ProgressReportListView.isInExportAllRoute(this.props);

      // disregard reports that are for students not in the list of group members
      var memberStudentIds = members.map(function (member) {
        return member.studentGeneralInfo.id;
      });
      var exportableStudentReportSummaries = studentReportSummaries.filter(function (report) {
        return memberStudentIds.indexOf(report.studentId) !== -1;
      });

      var remainingMembers = [];
      if (this.state.isExpandRemainingMember) {
        remainingMembers = this.props.remainingMembers;
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(
            _omniCommonUi.PageCard.Heading,
            {
              text: "PT Session Members",
              className: _style2.default.ProgressReportListView_cardHeader,
              titleClassName: _style2.default.ProgressReportListView_cardHeader_title
            },
            _react2.default.createElement(
              _omniCommonUi.Tooltip,
              {
                text: "PT Session: Last session of every unit",
                placement: "right",
                trigger: ["hover"],
                className: _style2.default.ProgressReportListView_cardHeader_tooltip
              },
              _react2.default.createElement(_omniCommonUi.Icon, { id: "question" })
            )
          ),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.ProgressReportListView_content },
            this._renderURTable(this.props.ptSessionMembers)
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(_omniCommonUi.PageCard.Heading, {
            text: "Remaining Session Members",
            className: _style2.default.ProgressReportListView_cardHeader
          }),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.ProgressReportListView_content },
            this._renderURTable(remainingMembers)
          ),
          this._renderExpandButton()
        ),
        isInExportAllRoute ? _react2.default.createElement(_ExportAllHandler2.default, {
          studentReportSummaries: exportableStudentReportSummaries,
          progressReportId: currentProgressReportId,
          bestCaseReportCount: members.size,
          languageCode: languageCode,
          pushRoute: pushRoute,
          buildRoute: buildRoute
        }) : null
      );
    }
  }]);

  return ProgressReportListView;
}(_react.Component);

ProgressReportListView.isInMarkingRoute = function (props) {
  return props.params && props.params.mode === MARKING;
};

ProgressReportListView.isInExportAllRoute = function (props) {
  return props.params && props.params.mode === EXPORT_ALL;
};

ProgressReportListView.propTypes = {
  members: _propTypes2.default.object.isRequired,
  ptSessionMembers: _propTypes2.default.object.isRequired,
  remainingMembers: _propTypes2.default.object.isRequired,
  currentProgressReportId: _propTypes2.default.string.isRequired,
  progressReports: _propTypes2.default.object.isRequired,
  progressReport: _propTypes2.default.object,
  progressTest: _propTypes2.default.object,
  studentReportSummaries: _propTypes2.default.object,
  languageCode: _propTypes2.default.string,
  courseType: _propTypes2.default.string,
  fetchProgressReport: _propTypes2.default.func.isRequired,
  submitStudentReportSummaryTeacherPublish: _propTypes2.default.func.isRequired,
  params: _propTypes2.default.object.isRequired,
  buildRoute: _propTypes2.default.func,
  pushRoute: _propTypes2.default.func,
  router: _propTypes2.default.any.isRequired,
  routes: _propTypes2.default.array.isRequired,
  route: _propTypes2.default.any.isRequired,
  groupId: _propTypes2.default.string
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var group = state.get("rootReducer").get("groups").get(groupId).data;
  var progressReports = group.get("progressReports");
  var languageCode = group.get("languageCode");
  var courseTypeLevelCode = group.get("courseTypeLevelCode");
  var courseTypeCode = group.get("courseTypeCode");
  var courseType = courseTypeCode + courseTypeLevelCode;
  var currentProgressReportId = ownProps.params.progressReportId;
  if (!currentProgressReportId) return;
  var studentReportSummaries = state.get("rootReducer").get("studentReportSummaries").get(currentProgressReportId).data;
  var ptSessionStudentIds = studentReportSummaries && studentReportSummaries.filter(function (studentReportSummary) {
    return studentReportSummary.isPTSessionMember;
  }).map(function (studentReportSummary) {
    return studentReportSummary.studentId;
  });
  var remainingStudentIds = studentReportSummaries && studentReportSummaries.filter(function (studentReportSummary) {
    return !studentReportSummary.isPTSessionMember;
  }).map(function (studentReportSummary) {
    return studentReportSummary.studentId;
  });
  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var ptSessionMembers = ptSessionStudentIds && members.filter(function (member) {
    return ptSessionStudentIds.includes(member.studentGeneralInfo.id);
  });
  var remainingMembers = remainingStudentIds && members.filter(function (member) {
    return remainingStudentIds.includes(member.studentGeneralInfo.id);
  });
  var progressReport = progressReports.data.get(currentProgressReportId);
  var currentProgressTestId = progressReport.progressTestId;
  var progressTest = state.get("rootReducer").get("progressTests").get(currentProgressTestId);

  return {
    members: members,
    ptSessionMembers: ptSessionMembers,
    remainingMembers: remainingMembers,
    currentProgressReportId: currentProgressReportId,
    progressReports: progressReports,
    progressReport: progressReport,
    progressTest: progressTest,
    studentReportSummaries: studentReportSummaries,
    groupId: groupId,
    languageCode: languageCode,
    courseType: courseType
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_ProgressReports.actions, dispatch), (0, _redux.bindActionCreators)(_StudentReportSummaries.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(ProgressReportListView));

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1533);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2afaJvm-QGi8CDSa3XgQ-{border-bottom:0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:.71429rem 1.42857rem}._2B364eWog1zsf4Lh2LdbR8{display:contents}._2TDBt4UZWW3t4kFblGDpP_{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-left:.35714rem}._1JAJrj9Yg9n4fKUPf3Lbnm{overflow:hidden;padding:0}.C-nY64bSS-bhGvjCnYycp{border-top:0}._3b7sZ_LxyweRdL4dDQ0m4W{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;max-width:100%;min-width:35vw;position:relative;vertical-align:text-bottom!important;width:100%}._2a-uM7TOmhD-JZqr4salnC{cursor:help;left:0;max-width:100%;min-width:0;overflow:hidden;position:absolute;text-align:left;-o-text-overflow:ellipsis;text-overflow:ellipsis;top:-webkit-calc(50% - .64286rem);top:-moz-calc(50% - .64286rem);top:calc(50% - .64286rem);white-space:nowrap}._3b7sZ_LxyweRdL4dDQ0m4W.v5r6BxMyj1izlwB6a_KhO{-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}._3IbAQfohH_VpwdI3qZGC-Q{color:inherit;font-size:120%;text-decoration:none}.QK0dS4PlMahUBymj3JFLh{-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:left;width:100%}._2uP-6mUXdojEf3ONrBgks9{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._3L_4KLMNP0FJ5StvMdQD1V{text-align:left}.IpR-fx35usmvMXaoTAAZk{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:600;letter-spacing:.03571rem;line-height:1.28571;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;color:inherit;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;font-size:.85714rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;outline:0;text-decoration:none;text-transform:uppercase}._18ZavE7htyF67b5kzt-jxf{margin-left:.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ProgressReportListView_cardHeader": "_2afaJvm-QGi8CDSa3XgQ-",
	"ProgressReportListView_cardHeader_title": "_2B364eWog1zsf4Lh2LdbR8",
	"ProgressReportListView_cardHeader_tooltip": "_2TDBt4UZWW3t4kFblGDpP_",
	"ProgressReportListView_content": "_1JAJrj9Yg9n4fKUPf3Lbnm",
	"ProgressReportListView_expand": "C-nY64bSS-bhGvjCnYycp",
	"ProgressReportListView_comment": "_3b7sZ_LxyweRdL4dDQ0m4W",
	"ProgressReportListView_comment_inner": "_2a-uM7TOmhD-JZqr4salnC",
	"__empty": "v5r6BxMyj1izlwB6a_KhO",
	"ProgressReportListView_reportLink": "_3IbAQfohH_VpwdI3qZGC-Q",
	"ProgressReportListView_status": "QK0dS4PlMahUBymj3JFLh",
	"ProgressReportListView_status_content": "_2uP-6mUXdojEf3ONrBgks9",
	"ProgressReportListView_status_header": "_3L_4KLMNP0FJ5StvMdQD1V",
	"ProgressReportLink": "IpR-fx35usmvMXaoTAAZk",
	"ProgressReportLink_icon": "_18ZavE7htyF67b5kzt-jxf"
};

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1535);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Api = __webpack_require__(11);

var _Exporter = __webpack_require__(50);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

var _omniCommonUi = __webpack_require__(0);

var _StudentReportSummaries = __webpack_require__(42);

var _LanguageRadio = __webpack_require__(74);

var _LanguageRadio2 = _interopRequireDefault(_LanguageRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXPORT_FILENAME = 'Unit Reports.pdf';
var EXPORT_MIME_TYPE = 'application/pdf';

var ExportAllHandler = function (_Component) {
  _inherits(ExportAllHandler, _Component);

  function ExportAllHandler() {
    _classCallCheck(this, ExportAllHandler);

    var _this = _possibleConstructorReturn(this, (ExportAllHandler.__proto__ || Object.getPrototypeOf(ExportAllHandler)).call(this));

    _this.state = {
      isExportRequested: false
    };

    _this._onLanguageChanged = _this._onLanguageChanged.bind(_this);
    return _this;
  }

  _createClass(ExportAllHandler, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ choosedLanguageCode: this.props.languageCode });
    }
  }, {
    key: '_close',
    value: function _close() {
      var _props = this.props,
          buildRoute = _props.buildRoute,
          pushRoute = _props.pushRoute;

      function redirect(param) {
        pushRoute(buildRoute(param));
      }
      redirect({ mode: '' });
    }
  }, {
    key: '_performExport',
    value: function _performExport() {
      var _this2 = this;

      var progressReportId = this.props.progressReportId;


      if (_is_js2.default.falsy(progressReportId)) {
        _omniCommonUi.log.error('ExportAllHandler is not exporting - progressReportId is not set!');
        return;
      }

      var url = (0, _Api.buildUrl)('/unit-reports/' + progressReportId + '/printable-student-reports-pdf?' + ('languageCode=' + (this.state.choosedLanguageCode || _Languages2.default.defaultLanguageCode)));

      _Exporter.exporter.get(url, EXPORT_FILENAME, false, EXPORT_MIME_TYPE).then(function () {
        _this2._close();
      }).catch(function () {
        _this2.setState({ isExportErrorOccurred: true });
      });

      this.setState({ isExportRequested: true });
    }
  }, {
    key: '_onLanguageChanged',
    value: function _onLanguageChanged(languageCode) {
      this.setState({ choosedLanguageCode: languageCode });
    }
  }, {
    key: '_isDefaultLanguage',
    value: function _isDefaultLanguage() {
      if (!this.props.languageCode) return true;
      return _Languages2.default.defaultLanguageCode === this.props.languageCode;
    }
  }, {
    key: '_renderLanguageRadio',
    value: function _renderLanguageRadio() {
      return _react2.default.createElement(_LanguageRadio2.default, { name: 'language-picker',
        languageCode: this.props.languageCode,
        onChecked: this._onLanguageChanged,
        choosedLanguageCode: this.state.choosedLanguageCode });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          studentReportSummaries = _props2.studentReportSummaries,
          bestCaseReportCount = _props2.bestCaseReportCount;


      if (this.state.isExportErrorOccurred) {
        return _react2.default.createElement(_omniCommonUi.ErrorDialog, { isOpen: true,
          onConfirmClick: function onConfirmClick() {
            _this3._close();
          } });
      }

      var readyCount = countByStatus(_StudentReportSummaries.StudentReportSummary.Status.Ready);
      var completedCount = countByStatus(_StudentReportSummaries.StudentReportSummary.Status.Completed) + countByStatus(_StudentReportSummaries.StudentReportSummary.Status.Published);
      var missingCount = countByStatus(_StudentReportSummaries.StudentReportSummary.Status.ScoresMissing);
      var awaitingApprovalCount = countByStatus(_StudentReportSummaries.StudentReportSummary.Status.SentToDoS);

      var bestCaseCount = _is_js2.default.number(bestCaseReportCount) ? bestCaseReportCount : studentReportSummaries.size;
      var notAvailableCount = bestCaseCount - (readyCount + completedCount + missingCount + awaitingApprovalCount);
      var willExportCount = readyCount + completedCount + awaitingApprovalCount;
      var willExportWithoutJustificationCount = readyCount + completedCount;

      // no reports are exportable :( (we shouldn't end up here though)
      if (willExportCount <= 0) {
        return _react2.default.createElement(
          _omniCommonUi.ConfirmDialog,
          { isOpen: true,
            title: 'No reports are available',
            primaryButtonContent: 'Close',
            onPrimaryClick: function onPrimaryClick() {
              return _this3._close();
            },
            onRequestClose: function onRequestClose() {
              return _this3._close();
            } },
          _react2.default.createElement(
            'p',
            { className: _style2.default.ExportAllHandler_feedback_noneToExport },
            'There are no reports available to export.'
          )
        );
      }

      // all reports are exportable; no need to display stats.
      if (willExportWithoutJustificationCount === bestCaseCount) {
        if (!this._isDefaultLanguage()) {
          return _react2.default.createElement(
            _omniCommonUi.ConfirmDialog,
            { isOpen: true,
              isLoading: this.state.isExportRequested,
              title: 'Choose Language:',
              primaryButtonContent: 'Export',
              secondaryButtonContent: 'Cancel',
              onPrimaryClick: function onPrimaryClick() {
                return _this3._performExport();
              },
              onSecondaryClick: function onSecondaryClick() {
                return _this3._close();
              },
              onRequestClose: function onRequestClose() {
                return _this3._close();
              } },
            _react2.default.createElement(
              'div',
              { className: _style2.default.ExportAllHandler_feedback_content },
              _react2.default.createElement(
                'div',
                { className: _style2.default.ExportAllHandler_feedback_languageRadio },
                this._renderLanguageRadio()
              )
            )
          );
        }
        // the export starts automatically!
        !this.state.isExportRequested && this._performExport();
        return _react2.default.createElement(
          _omniCommonUi.ConfirmDialog,
          { isOpen: true,
            isLoading: true,
            isButtonless: true,
            title: 'Exporting reports, please wait' },
          _react2.default.createElement('div', { className: _style2.default.ExportAllHandler_feedback_exportingImmediately })
        );
      }

      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: true,
          isLoading: this.state.isExportRequested,
          title: 'Exporting ' + willExportCount + ' of ' + bestCaseCount + ' reports',
          primaryButtonContent: 'Export',
          secondaryButtonContent: 'Cancel',
          onPrimaryClick: function onPrimaryClick() {
            return _this3._performExport();
          },
          onSecondaryClick: function onSecondaryClick() {
            return _this3._close();
          },
          onRequestClose: function onRequestClose() {
            return _this3._close();
          } },
        _react2.default.createElement(
          'div',
          { className: _style2.default.ExportAllHandler_feedback_content },
          notAvailableCount > 0 ? _react2.default.createElement(
            'p',
            { className: _style2.default.ExportAllHandler_feedback_someNotAvailable,
              'data-not-available-count': notAvailableCount },
            notAvailableCount,
            notAvailableCount > 1 ? ' reports are ' : ' report is ',
            'not available'
          ) : null,
          missingCount > 0 ? _react2.default.createElement(
            'p',
            { className: _style2.default.ExportAllHandler_feedback_someMissingScores,
              'data-missing-scores-count': missingCount },
            missingCount,
            missingCount > 1 ? ' reports are ' : ' report is ',
            'missing scores and cannot be exported'
          ) : null,
          awaitingApprovalCount > 0 ? _react2.default.createElement(
            'p',
            { className: _style2.default.ExportAllHandler_feedback_someAwaitingApproval,
              'data-awaiting-approval-count': awaitingApprovalCount },
            awaitingApprovalCount,
            awaitingApprovalCount > 1 ? ' reports are ' : ' report is ',
            'awaiting approval and will be exported without teacher\u2019s comments'
          ) : null,
          !this._isDefaultLanguage() && _react2.default.createElement('div', { className: _style2.default.ExportAllHandler_feedback_divider }),
          !this._isDefaultLanguage() && _react2.default.createElement(
            'div',
            { className: _style2.default.ExportAllHandler_feedback_languageRadio },
            _react2.default.createElement(
              'span',
              null,
              'Choose Language:'
            ),
            this._renderLanguageRadio()
          )
        )
      );

      function countByStatus(status) {
        return studentReportSummaries.filter(function (report) {
          return _is_js2.default.string(report.status) && report.status === status;
        }).size;
      }
    }
  }]);

  return ExportAllHandler;
}(_react.Component);

ExportAllHandler.propTypes = {
  studentReportSummaries: _propTypes2.default.shape({
    filter: _propTypes2.default.func.isRequired
  }).isRequired,
  progressReportId: _propTypes2.default.string.isRequired,
  bestCaseReportCount: _propTypes2.default.number,
  languageCode: _propTypes2.default.string.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired
};

exports.default = ExportAllHandler;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1536);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3-lWb_SZ4ptkPVgTx5zKB8{min-height:4.57143rem}.UMNGJDSf8vPcB3ZZseAYa{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.UMNGJDSf8vPcB3ZZseAYa>p+p{margin-top:0}._2g0AnH9wye3EMhMkMYoe3h{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:initial}._2g0AnH9wye3EMhMkMYoe3h>*{margin-top:1.07143rem}.SXdK_lEZXcK4qnK60pVdD{border-top:.07143rem solid #ccc;display:block;margin:.35714rem 0;width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ExportAllHandler_feedback_exportingImmediately": "_3-lWb_SZ4ptkPVgTx5zKB8",
	"ExportAllHandler_feedback_content": "UMNGJDSf8vPcB3ZZseAYa",
	"ExportAllHandler_feedback_languageRadio": "_2g0AnH9wye3EMhMkMYoe3h",
	"ExportAllHandler_feedback_divider": "SXdK_lEZXcK4qnK60pVdD",
	"ExportAllHandler_feedback_noneToExport": "_1x0J5vjKj4ciz8yGljL8Qw",
	"ExportAllHandler_feedback_someNotAvailable": "gDTR4AKdKFc03eljALLbu",
	"ExportAllHandler_feedback_someMissingScores": "_2OjX-ourrVo4tRJJ73pgks",
	"ExportAllHandler_feedback_someAwaitingApproval": "_2cmXxCx2zM-CvS_dqcQtdz"
};

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(671);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(308);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._34QACpUL7wriGEqQJvhxOr{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:left}.fr3iMKUvyNh8LI8E4H3yZ{margin-top:1.42857rem;white-space:nowrap;width:50%}._1pBWlAPQaOtDD9weOyIPDR{border-top:.07143rem solid #ccc;display:block;margin:1.42857rem 0;width:100%}._3hwj7fn0GOJYSlzYoO6kDE{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3hwj7fn0GOJYSlzYoO6kDE,.Z-JT9QBszGfJ5On-O7sJx{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.Z-JT9QBszGfJ5On-O7sJx{background:#f3f5f7;border-bottom:.07143rem solid #ccc;height:3.92857rem;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;min-width:23rem;overflow:hidden;padding:0 1.42857rem;position:-webkit-sticky;position:sticky;top:0;z-index:500;padding-left:1.42857rem;padding-right:1.42857rem}@media only screen and (min-width:640px){.Z-JT9QBszGfJ5On-O7sJx{padding-left:2.14286rem;padding-right:2.14286rem}}.Z-JT9QBszGfJ5On-O7sJx button{min-width:0;overflow:hidden;white-space:nowrap}.IV8xiynDCWtl9sP2qSyjc{color:#a4a4a4;font-size:1.14286rem;margin-bottom:1.42857rem;padding-top:5rem;text-align:center}._1PSc3R7KgZTwEzsYU1gRKc{padding:1.42857rem;padding-left:1.42857rem;padding-right:1.42857rem}@media only screen and (min-width:640px){._1PSc3R7KgZTwEzsYU1gRKc{padding-left:2.14286rem;padding-right:2.14286rem}}._2IOhduYUe8rilY74O_houy{font-size:1.14286rem;font-weight:700;margin-bottom:1.42857rem}._3BQvfnVW-Z2mOn766K5GiO{display:block;margin-bottom:.71429rem}._3BQvfnVW-Z2mOn766K5GiO:last-child{margin-bottom:0}.-uzyD2FXTrJ8zHtORhuKy{font-weight:700}._1TsfClILUAXYyVXCwrDFbA{margin:.28571rem 0 .85714rem}._3BCEKobn7Adf7HwNANHCvW{font-weight:600;margin-bottom:.42857rem;font-size:.92857rem}._2h2TJgFRw3d-BcTisxrlmc{margin:.21429rem 0;font-size:.92857rem;padding-left:0}._25OBDSKPh6o71MnqBDo3BP{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._3uXsSnw5IbaX-FP8V2QZL8{cursor:pointer;-webkit-box-flex:1;-webkit-flex:auto;-moz-box-flex:1;-ms-flex:auto;flex:auto;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap}._3uXsSnw5IbaX-FP8V2QZL8>*{display:inline-block;line-height:100%;vertical-align:middle}._3sGB6cPtdUnPmAjs-FEyLD{-webkit-border-radius:.28571rem;-moz-border-radius:.28571rem;border-radius:.28571rem;-webkit-box-shadow:0 .07143rem .14286rem rgba(0,0,0,.08),0 .28571rem .57143rem rgba(0,0,0,.16);-moz-box-shadow:0 .07143rem .14286rem rgba(0,0,0,.08),0 .28571rem .57143rem rgba(0,0,0,.16);box-shadow:0 .07143rem .14286rem rgba(0,0,0,.08),0 .28571rem .57143rem rgba(0,0,0,.16);overflow:visible}._3k5VFgs_LQDyk3lG092-FB{background:#f3f5f7;border-bottom:.07143rem solid #c9c9c9;font-size:1.14286rem;padding:1.14286rem}.idlHvypjTiNvICexMo9Zs{width:100%}._1MEuWqNOcyr1W6czLkI8MQ{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border-bottom:.07143rem solid #c9c9c9;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;min-height:4rem;padding:0 1.14286rem}._248bZQd4fIsmc1esjZDBgv{height:4rem;color:#747474;font-weight:700}._248bZQd4fIsmc1esjZDBgv ._1wNwsfOKfAuyDcSed9PPie,._248bZQd4fIsmc1esjZDBgv .RLpjHu6GX_jAOxG_VhmGT{height:unset;padding-left:1.14286rem}.PU8Ur_xT-TA1TAs7XGy2P{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:1.14286rem;width:21.42857rem}._1wNwsfOKfAuyDcSed9PPie{width:7.14286rem;height:7.14286rem;margin-right:1.71429rem}.RLpjHu6GX_jAOxG_VhmGT{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:.57143rem}._3jP4LL80gFf1C2ZNgVjq3I{-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;height:4.28571rem;overflow:hidden;width:4.28571rem}._3jP4LL80gFf1C2ZNgVjq3I>div{height:100%;width:100%}._1fWUV9EA1Dik0VJZ9IuW42:after,.ZpL4myToLXfUZJUZFHNHX:after{content:attr(data-tooltip);position:absolute;bottom:0;left:50%;-webkit-transform:translateX(-50%) translateY(100%);-moz-transform:translateX(-50%) translateY(100%);-ms-transform:translateX(-50%) translateY(100%);-o-transform:translateX(-50%) translateY(100%);transform:translateX(-50%) translateY(100%);background:#000;-webkit-border-radius:.28571rem;-moz-border-radius:.28571rem;border-radius:.28571rem;color:#fff;font-size:1rem;line-height:1.42857rem;padding:.57143rem .85714rem;white-space:nowrap;opacity:0;pointer-events:none;z-index:10;-webkit-box-shadow:0 .07143rem .14286rem 0 rgba(0,0,0,.08),0 .28571rem .57143rem .14286rem rgba(0,0,0,.16);-moz-box-shadow:0 .07143rem .14286rem 0 rgba(0,0,0,.08),0 .28571rem .57143rem .14286rem rgba(0,0,0,.16);box-shadow:0 .07143rem .14286rem 0 rgba(0,0,0,.08),0 .28571rem .57143rem .14286rem rgba(0,0,0,.16)}._1fWUV9EA1Dik0VJZ9IuW42:before,.ZpL4myToLXfUZJUZFHNHX:before{content:\"\";position:absolute;bottom:0;left:50%;-webkit-transform:translateX(-50%) translateY(50%) rotate(45deg);-moz-transform:translateX(-50%) translateY(50%) rotate(45deg);-ms-transform:translateX(-50%) translateY(50%) rotate(45deg);-o-transform:translateX(-50%) translateY(50%) rotate(45deg);transform:translateX(-50%) translateY(50%) rotate(45deg);width:.85714rem;height:.85714rem;background:#000;opacity:0;pointer-events:none;z-index:9}._1fWUV9EA1Dik0VJZ9IuW42:hover:after,._1fWUV9EA1Dik0VJZ9IuW42:hover:before,.ZpL4myToLXfUZJUZFHNHX:hover:after,.ZpL4myToLXfUZJUZFHNHX:hover:before{opacity:1}._1fWUV9EA1Dik0VJZ9IuW42{position:relative;width:7.14286rem;height:7.14286rem;padding:.57143rem}._1Lf6GGS4KQHRx_cECiRanC{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:#dad8cc;-webkit-border-radius:1.14286rem;-moz-border-radius:1.14286rem;border-radius:1.14286rem;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:.28571rem;height:6rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:.57143rem 0;width:6rem}._2RQtK3wXJgOi_RFYehvfNJ{height:3.28571rem;-o-object-fit:contain;object-fit:contain;width:3.28571rem}._3KfKCL4RK4NJ3H6F2meakV{white-space:nowrap;font-size:.85714rem;line-height:1.21429rem;font-weight:700}.ZpL4myToLXfUZJUZFHNHX{position:relative;height:7.14286rem;width:7.14286rem}.ZpL4myToLXfUZJUZFHNHX img{height:100%;width:100%}._3PzmbVBLp9QFfIiZz7zX9m{position:absolute;width:1.71429rem;height:1.71429rem;right:.28571rem;top:.32143rem;background:#ea6a25;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;color:#fff;font-size:.85714rem;font-weight:700}._3PzmbVBLp9QFfIiZz7zX9m,._11uiKDTWPH7cwtCFwOBLxO{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}._11uiKDTWPH7cwtCFwOBLxO{background:#f3f5f7;border-top:.07143rem solid #c9c9c9;color:#242424;cursor:pointer;font-size:1.14286rem;gap:.28571rem;line-height:1.4;padding:1.14286rem}._11uiKDTWPH7cwtCFwOBLxO:hover{background:#eaecef}._1EG9oFlf4s_loznmRMbvme{color:#8c8c8c;font-size:1rem;padding:2.28571rem 1.14286rem;text-align:center}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"CoveredInClass_exportOptions": "_34QACpUL7wriGEqQJvhxOr",
	"CoveredInClass_exportOption": "fr3iMKUvyNh8LI8E4H3yZ",
	"CoveredInClass_exportOptionsDivider": "_1pBWlAPQaOtDD9weOyIPDR",
	"CoveredInClass_languagePicker": "_3hwj7fn0GOJYSlzYoO6kDE",
	"CoveredInClass_viewNav": "Z-JT9QBszGfJ5On-O7sJx",
	"CoveredInClass_noContent_message": "IV8xiynDCWtl9sP2qSyjc",
	"CoveredInClass_homeworkSection": "_1PSc3R7KgZTwEzsYU1gRKc",
	"CoveredInClass_homeworkSectionTitle": "_2IOhduYUe8rilY74O_houy",
	"CoveredInClass_homeworkItem": "_3BQvfnVW-Z2mOn766K5GiO",
	"CoveredInClass_homeworkItemLabel": "-uzyD2FXTrJ8zHtORhuKy",
	"CoveredInClass_studentTasks": "_1TsfClILUAXYyVXCwrDFbA",
	"CoveredInClass_lessonTasksHeader": "_3BCEKobn7Adf7HwNANHCvW",
	"CoveredInClass_taskItem": "_2h2TJgFRw3d-BcTisxrlmc",
	"CoveredInClass_header": "_25OBDSKPh6o71MnqBDo3BP",
	"CoveredInClass_header_checkAll": "_3uXsSnw5IbaX-FP8V2QZL8",
	"CoveredInClass_performanceCard": "_3sGB6cPtdUnPmAjs-FEyLD",
	"CoveredInClass_performanceHeader": "_3k5VFgs_LQDyk3lG092-FB",
	"CoveredInClass_performanceTable": "idlHvypjTiNvICexMo9Zs",
	"CoveredInClass_performanceRow": "_1MEuWqNOcyr1W6czLkI8MQ",
	"CoveredInClass_performanceRowHead": "_248bZQd4fIsmc1esjZDBgv",
	"CoveredInClass_performanceColStickers": "_1wNwsfOKfAuyDcSed9PPie",
	"CoveredInClass_performanceColBadges": "RLpjHu6GX_jAOxG_VhmGT",
	"CoveredInClass_performanceColName": "PU8Ur_xT-TA1TAs7XGy2P",
	"CoveredInClass_performanceAvatar": "_3jP4LL80gFf1C2ZNgVjq3I",
	"CoveredInClass_performanceSticker": "_1fWUV9EA1Dik0VJZ9IuW42",
	"CoveredInClass_performanceBadge": "ZpL4myToLXfUZJUZFHNHX",
	"CoveredInClass_performanceStickerContent": "_1Lf6GGS4KQHRx_cECiRanC",
	"CoveredInClass_performanceStickerIcon": "_2RQtK3wXJgOi_RFYehvfNJ",
	"CoveredInClass_performanceStickerCount": "_3KfKCL4RK4NJ3H6F2meakV",
	"CoveredInClass_performanceBadgeCount": "_3PzmbVBLp9QFfIiZz7zX9m",
	"CoveredInClass_performanceShowMore": "_11uiKDTWPH7cwtCFwOBLxO",
	"CoveredInClass_performanceEmpty": "_1EG9oFlf4s_loznmRMbvme"
};

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1540);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2ydvqWnH8RYLQP_3kB0G0k{margin-top:2.14286rem}.pvOPBwLkkJK7GKjrHXp1u{padding:1.42857rem 1.14286rem 1.28571rem 2.14286rem}._2vmYOnArE7jB3ehBKXz-Em{margin-top:2.14286rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"PageActivitiesPart": "_2ydvqWnH8RYLQP_3kB0G0k",
	"PageActivitiesPart_container": "pvOPBwLkkJK7GKjrHXp1u",
	"PageActivitiesPart_container_view": "_2vmYOnArE7jB3ehBKXz-Em"
};

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1542);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Detailsboard = __webpack_require__(202);

var _Detailsboard2 = _interopRequireDefault(_Detailsboard);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageActivitesSeletor = function PageActivitesSeletor(props) {
  var title = props.title,
      isEditMode = props.isEditMode,
      activities = props.activities,
      onActivityChecked = props.onActivityChecked;


  if (isEditMode) {
    return _react2.default.createElement(
      "div",
      { className: _style2.default.PageActivitiesSelector },
      _react2.default.createElement(
        "p",
        { className: _style2.default.PageActivitiesSelector_title },
        title
      ),
      _react2.default.createElement(
        "div",
        { className: _style2.default.PageActivitesSeletor_activities },
        renderEditableActivities()
      )
    );
  }

  return _react2.default.createElement(_Detailsboard2.default, { boardTitle: title, boardValue: activitiesString() });

  function activitiesString() {
    var result = [_react2.default.createElement(
      "span",
      null,
      "Activities: "
    )];
    activities.map(function (activity) {
      // eslint-disable-line
      var spanStyle = activity.isChecked ? {} : { color: "#a4a4a4" };
      result.push(_react2.default.createElement(
        "span",
        { style: spanStyle },
        activity.cicActivityItemCode
      ));
      result.push(_react2.default.createElement(
        "span",
        null,
        ", "
      ));
    });
    result.pop();
    return result;
  }

  function renderEditableActivities() {
    return activities.map(function (activity, index) {
      var activityItemStyle = activity.isChecked ? _style2.default.PageActivitiesSelector_activities_activityChecked : _style2.default.PageActivitiesSelector_activities_activityUnchecked;
      return _react2.default.createElement(
        "div",
        {
          className: (0, _classnames2.default)(activityItemStyle),
          onClick: function onClick() {
            return activityChecked(index);
          }
        },
        _react2.default.createElement(
          "span",
          null,
          activity.cicActivityItemCode
        )
      );
    });
  }

  function activityChecked(index) {
    _reactGa2.default.event({
      category: "Covered in Class",
      action: "Clicked activity",
      label: "Clicked activity " + index
    });

    var newActivities = activities;
    var activity = newActivities.get(index);
    var newActivity = activity.set("isChecked", !activity.isChecked);
    onActivityChecked(props.index, newActivities.set(index, newActivity));
  }
};

PageActivitesSeletor.propTypes = {
  index: _propTypes2.default.int,
  isEditMode: _propTypes2.default.bool,
  title: _propTypes2.default.string.isRequired,
  activities: _propTypes2.default.object.isRequired,
  onActivityChecked: _propTypes2.default.func
};

exports.default = PageActivitesSeletor;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1543);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3RsoU7aC_jvTI__ZMziYI4{display:inline-block;margin-right:2.85714rem}._38FEs6v6TP6n6u7uvrgcdx{color:#4a4a4a;display:block;font-size:1rem;font-weight:600;letter-spacing:.07143rem;line-height:1.7;margin:0}._1biCzf5S0nwclpcKXOAi_{margin-top:.71429rem}._1q1pDpx4EmOnW0MK79ajDp,._3OFvyulSukUGMubPPA3DV3{cursor:pointer;display:inline-block;height:2.85714rem;line-height:2.85714rem;margin-right:.71429rem;margin-top:.71429rem;padding:0 1.07143rem;text-align:center;-webkit-transition-duration:.3s;-moz-transition-duration:.3s;-o-transition-duration:.3s;transition-duration:.3s}._3OFvyulSukUGMubPPA3DV3{background:#0087e6;border:.07143rem solid #0087e6;color:#fff}._1q1pDpx4EmOnW0MK79ajDp{background:#fff;border:.07143rem solid #0087e6;color:#0087e6}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"PageActivitiesSelector": "_3RsoU7aC_jvTI__ZMziYI4",
	"PageActivitiesSelector_title": "_38FEs6v6TP6n6u7uvrgcdx",
	"PageActivitiesSelector_activities": "_1biCzf5S0nwclpcKXOAi_",
	"PageActivitiesSelector_activities_activityChecked": "_3OFvyulSukUGMubPPA3DV3",
	"PageActivitiesSelector_activities_activityUnchecked": "_1q1pDpx4EmOnW0MK79ajDp"
};

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1545);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3dBMEkXKp6DK9A_k0WK3FN,.UwAzExYqpZfwP_Y3L7_xq{height:100%}", ""]);

// exports
exports.locals = {
	"CoveredInClassCategoryView_categoryCardContainer": "UwAzExYqpZfwP_Y3L7_xq",
	"CoveredInClassCategoryView_categoryCardContainer_lastodd": "_3dBMEkXKp6DK9A_k0WK3FN"
};

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1547);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3XIh2hqznbbt9j_eGcqhLA{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;height:100%}._1BYf3gaxzkEkQhG2sYBaZZ,.W3sNCwmvtmZRHzsGX7t2d{height:100%}._2YbD7VznB433He_XDFawa-{display:block;margin-bottom:.71429rem}._2YbD7VznB433He_XDFawa-:last-of-type{margin-bottom:0}._1nOWM-VO3sCQFqCs_KyPgZ{cursor:pointer;display:block;margin-bottom:.71429rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap}._1nOWM-VO3sCQFqCs_KyPgZ:last-of-type{margin-bottom:0}._1nOWM-VO3sCQFqCs_KyPgZ>*{display:inline-block;line-height:1.4;vertical-align:middle}._3EdXhT4JVm8DzxvNPBBhAv{font-size:1rem;letter-spacing:.07143rem;white-space:pre-line}._1s9tQUFT7kt7BlCb4k_KLV{color:#a4a4a4}._1dav8PxU4VeZ2L82XthDlg{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1dav8PxU4VeZ2L82XthDlg,._20uSorOmJR-BhcvUFF21qO{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._20uSorOmJR-BhcvUFF21qO{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;font-size:1rem;margin-bottom:.71429rem}._12u4qm8tMtiBLbmnRU8TVa{border:.07143rem solid #273947;line-height:1.4;margin-right:.71429rem;padding:.35714rem;text-transform:uppercase}._1f1WVH_R7U8vhFeDmJRYAh{margin-left:1.85714rem}._2YbD7VznB433He_XDFawa-+._1dav8PxU4VeZ2L82XthDlg{margin-top:1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"CICCategoryCard": "_3XIh2hqznbbt9j_eGcqhLA",
	"CICCategoryCard_container": "W3sNCwmvtmZRHzsGX7t2d",
	"CICCategoryCard_card": "_1BYf3gaxzkEkQhG2sYBaZZ",
	"CICCategoryCard_categoryItem": "_2YbD7VznB433He_XDFawa-",
	"CICCategoryCard_categoryItem_edit": "_1nOWM-VO3sCQFqCs_KyPgZ",
	"CICCategoryCard_categoryItem_content": "_3EdXhT4JVm8DzxvNPBBhAv",
	"CICCategoryCard_categoryItem_content_uncheck": "_1s9tQUFT7kt7BlCb4k_KLV",
	"CICCategoryCard_freeText": "_1dav8PxU4VeZ2L82XthDlg",
	"CICCategoryCard_freeText_header": "_20uSorOmJR-BhcvUFF21qO",
	"CICCategoryCard_freeText_header_title": "_12u4qm8tMtiBLbmnRU8TVa",
	"CICCategoryCard_freeText_header_edit": "_1f1WVH_R7U8vhFeDmJRYAh"
};

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

/*! @license DOMPurify 2.3.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.3.0/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.DOMPurify = factory());
}(this, function () { 'use strict';

  function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return new (Function.prototype.bind.apply(Func, [null].concat(_toConsumableArray(args))))();
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);

  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);

  var regExpTest = unapply(RegExp.prototype.test);

  var typeErrorCreate = unconstruct(TypeError);

  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }

  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }

  /* Add properties to a lookup table */
  function addToSet(set, array) {
    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;
    while (l--) {
      var element = array[l];
      if (typeof element === 'string') {
        var lcElement = stringToLowerCase(element);
        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }

  /* Shallow clone an object */
  function clone(object) {
    var newObject = create(null);

    var property = void 0;
    for (property in object) {
      if (apply(hasOwnProperty, object, [property])) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }

  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */
  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);
      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);

  // SVG
  var svg = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);

  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);

  // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.
  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'feimage', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);

  var mathMl = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);

  // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.
  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);

  var text = freeze(['#text']);

  var html$1 = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);

  var svg$1 = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);

  var mathMl$1 = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);

  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  // eslint-disable-next-line unicorn/better-regex
  var MUSTACHE_EXPR = seal(/\{\{[\s\S]*|[\s\S]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
  var ERB_EXPR = seal(/<%[\s\S]*|[\s\S]*%>/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

  function _toConsumableArray$1(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };

  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */
  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if ((typeof trustedTypes === 'undefined' ? 'undefined' : _typeof(trustedTypes)) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    }

    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';
    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html$$1) {
          return html$$1;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };

    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */
    DOMPurify.version = '2.3.0';

    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */
    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;

      return DOMPurify;
    }

    var originalDocument = window.document;

    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === undefined ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        Text = window.Text,
        Comment = window.Comment,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;


    var ElementPrototype = Element.prototype;

    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode');

    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');
      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
    var emptyHTML = trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML('') : '';

    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;


    var documentMode = {};
    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};

    /**
     * Expose whether this browser supports running the full DOMPurify.
     */
    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;

    var MUSTACHE_EXPR$$1 = MUSTACHE_EXPR,
        ERB_EXPR$$1 = ERB_EXPR,
        DATA_ATTR$$1 = DATA_ATTR,
        ARIA_ATTR$$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$$1 = IS_ALLOWED_URI;

    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(html), _toConsumableArray$1(svg), _toConsumableArray$1(svgFilters), _toConsumableArray$1(mathMl), _toConsumableArray$1(text)));

    /* Allowed attribute names */
    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray$1(html$1), _toConsumableArray$1(svg$1), _toConsumableArray$1(mathMl$1), _toConsumableArray$1(xml)));

    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
    var FORBID_TAGS = null;

    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
    var FORBID_ATTR = null;

    /* Decide if ARIA attributes are okay */
    var ALLOW_ARIA_ATTR = true;

    /* Decide if custom data attributes are okay */
    var ALLOW_DATA_ATTR = true;

    /* Decide if unknown protocols are okay */
    var ALLOW_UNKNOWN_PROTOCOLS = false;

    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */
    var SAFE_FOR_TEMPLATES = false;

    /* Decide if document with <html>... should be returned */
    var WHOLE_DOCUMENT = false;

    /* Track whether config is already set on this instance of DOMPurify. */
    var SET_CONFIG = false;

    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */
    var FORCE_BODY = false;

    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */
    var RETURN_DOM = false;

    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */
    var RETURN_DOM_FRAGMENT = false;

    /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
     * `Node` is imported into the current `Document`. If this flag is not enabled the
     * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
     * DOMPurify.
     *
     * This defaults to `true` starting DOMPurify 2.2.0. Note that setting it to `false`
     * might cause XSS from attacks hidden in closed shadowroots in case the browser
     * supports Declarative Shadow: DOM https://web.dev/declarative-shadow-dom/
     */
    var RETURN_DOM_IMPORT = true;

    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */
    var RETURN_TRUSTED_TYPE = false;

    /* Output should be free from DOM clobbering attacks? */
    var SANITIZE_DOM = true;

    /* Keep element content when removing element? */
    var KEEP_CONTENT = true;

    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */
    var IN_PLACE = false;

    /* Allow usage of profiles like html, svg and mathMl */
    var USE_PROFILES = {};

    /* Tags to ignore content of when KEEP_CONTENT is true */
    var FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);

    /* Tags that are safe for data: URIs */
    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);

    /* Attributes safe for values like "javascript:" */
    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'summary', 'title', 'value', 'style', 'xmlns']);

    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */
    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;

    /* Keep a reference to config to pass to hooks */
    var CONFIG = null;

    /* Ideally, do not touch anything below this line */
    /* ______________________________________________ */

    var formElement = document.createElement('form');

    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity
    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }

      /* Shield configuration object from tampering */
      if (!cfg || (typeof cfg === 'undefined' ? 'undefined' : _typeof(cfg)) !== 'object') {
        cfg = {};
      }

      /* Shield configuration object from prototype pollution */
      cfg = clone(cfg);

      /* Set configuration parameters */
      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR) : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS) : DEFAULT_DATA_URI_TAGS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
      RETURN_DOM = cfg.RETURN_DOM || false; // Default false
      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
      RETURN_DOM_IMPORT = cfg.RETURN_DOM_IMPORT !== false; // Default true
      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
      FORCE_BODY = cfg.FORCE_BODY || false; // Default false
      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
      IN_PLACE = cfg.IN_PLACE || false; // Default false
      IS_ALLOWED_URI$$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }

      /* Parse profile info */
      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(text)));
        ALLOWED_ATTR = [];
        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html);
          addToSet(ALLOWED_ATTR, html$1);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg);
          addToSet(ALLOWED_ATTR, svg$1);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg$1);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl);
          addToSet(ALLOWED_ATTR, mathMl$1);
          addToSet(ALLOWED_ATTR, xml);
        }
      }

      /* Merge configuration parameters */
      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
      }

      /* Add #text in case KEEP_CONTENT is set to true */
      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }

      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }

      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      }

      // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.
      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);

    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']);

    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */
    var ALL_SVG_TAGS = addToSet({}, svg);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);

    var ALL_MATHML_TAGS = addToSet({}, mathMl);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);

    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */
    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element);

      // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.
      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: HTML_NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        }

        // The only way to switch from MathML to SVG is via
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.
        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        }

        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        }

        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        }

        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erronously deleted from
        // HTML namespace.
        var commonSvgAndHTMLElements = addToSet({}, ['title', 'style', 'font', 'a', 'script']);

        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (commonSvgAndHTMLElements[tagName] || !ALL_SVG_TAGS[tagName]);
      }

      // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG or MathML). Return false just in case.
      return false;
    };

    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */
    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, { element: node });
      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };

    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */
    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name);

      // We void attribute values for unremovable "is"" attributes
      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };

    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */
    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc = void 0;
      var leadingWhitespace = void 0;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */
      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, 'text/html');
        } catch (_) {}
      }

      /* Use createHTMLDocument in case DOMParser is not available */
      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);
        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? '' : dirtyPayload;
        } catch (_) {
          // Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }

      /* Work on whole document or just its body */
      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };

    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */
    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };

    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */
    var _isClobbered = function _isClobbered(elm) {
      if (elm instanceof Text || elm instanceof Comment) {
        return false;
      }

      if (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function') {
        return true;
      }

      return false;
    };

    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */
    var _isNode = function _isNode(object) {
      return (typeof Node === 'undefined' ? 'undefined' : _typeof(Node)) === 'object' ? object instanceof Node : object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };

    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */
    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };

    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */
    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content = void 0;

      /* Execute a hook if present */
      _executeHook('beforeSanitizeElements', currentNode, null);

      /* Check if element is clobbered or can clobber */
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Check if tagname contains Unicode */
      if (stringMatch(currentNode.nodeName, /[\u0080-\uFFFF]/)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Now let's check the element's type and name */
      var tagName = stringToLowerCase(currentNode.nodeName);

      /* Execute a hook if present */
      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });

      /* Detect mXSS attempts abusing namespace confusion */
      if (!_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove element if anything forbids its presence */
      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Keep content except for bad-listed elements */
        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);
        return true;
      }

      /* Check whether element has a valid namespace */
      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Sanitize element content to be template-safe */
      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$$1, ' ');
        content = stringReplace(content, ERB_EXPR$$1, ' ');
        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, { element: currentNode.cloneNode() });
          currentNode.textContent = content;
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };

    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity
    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }

      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */
      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        return false;

        /* Check value is safe. First, is attr inert? If so, is safe */
      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if (!value) ; else {
        return false;
      }

      return true;
    };

    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */
    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr = void 0;
      var value = void 0;
      var lcName = void 0;
      var l = void 0;
      /* Execute a hook if present */
      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;

      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;

      /* Go backwards over all attributes; safely remove bad ones */
      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;

        value = stringTrim(attr.value);
        lcName = stringToLowerCase(name);

        /* Execute a hook if present */
        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */
        if (hookEvent.forceKeepAttr) {
          continue;
        }

        /* Remove attribute */
        _removeAttribute(name, currentNode);

        /* Did the hooks approve of the attribute? */
        if (!hookEvent.keepAttr) {
          continue;
        }

        /* Work around a security issue in jQuery 3.0 */
        if (regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Sanitize attribute content to be template-safe */
        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$$1, ' ');
          value = stringReplace(value, ERB_EXPR$$1, ' ');
        }

        /* Is `value` valid for this attribute? */
        var lcTag = currentNode.nodeName.toLowerCase();
        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }

        /* Handle invalid data-* attribute set by try-catching it */
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeAttributes', currentNode, null);
    };

    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */
    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode = void 0;
      var shadowIterator = _createIterator(fragment);

      /* Execute a hook if present */
      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);

        /* Sanitize tags and elements */
        if (_sanitizeElements(shadowNode)) {
          continue;
        }

        /* Deep shadow DOM detected */
        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(shadowNode);
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };

    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function (dirty, cfg) {
      var body = void 0;
      var importedNode = void 0;
      var currentNode = void 0;
      var oldNode = void 0;
      var returnNode = void 0;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */
      IS_EMPTY_INPUT = !dirty;
      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }

      /* Stringify, in case dirty is an object */
      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        // eslint-disable-next-line no-negated-condition
        if (typeof dirty.toString !== 'function') {
          throw typeErrorCreate('toString is not a function');
        } else {
          dirty = dirty.toString();
          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        }
      }

      /* Check we can run. Otherwise fall back or ignore */
      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }

      /* Assign config vars */
      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }

      /* Clean up removed elements */
      DOMPurify.removed = [];

      /* Check if dirty is correctly typed for IN_PLACE */
      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) ; else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);
        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
        // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }

        /* Initialize the document to work on */
        body = _initDocument(dirty);

        /* Check we have a DOM node from the data */
        if (!body) {
          return RETURN_DOM ? null : emptyHTML;
        }
      }

      /* Remove first element node (ours) if FORCE_BODY is set */
      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }

      /* Get node iterator */
      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);

      /* Now start iterating over the created document */
      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }

        /* Sanitize tags and elements */
        if (_sanitizeElements(currentNode)) {
          continue;
        }

        /* Shadow DOM detected, sanitize it */
        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;

      /* If we sanitized `dirty` in-place, return it. */
      if (IN_PLACE) {
        return dirty;
      }

      /* Return sanitized string or DOM */
      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (RETURN_DOM_IMPORT) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;

      /* Sanitize final string template-safe */
      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };

    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */
    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);
      SET_CONFIG = true;
    };

    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */
    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };

    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */
    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = stringToLowerCase(tag);
      var lcName = stringToLowerCase(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };

    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */
    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };

    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     */
    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        arrayPop(hooks[entryPoint]);
      }
    };

    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */
    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };

    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */
    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = coveredInClassContent;

var _actions = __webpack_require__(676);

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(305);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function coveredInClassContent() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_COVERED_IN_CLASS_CONTENT_SUCCESS:
      {
        if (!action.payload) {
          // no CIC content for session. this will show the "No content" message in the component.
          return state.set(action.sessionId, null);
        }
        return state.set(action.sessionId, onSuccess(state, action));
      }
    case _actions.CHANGE_COVERED_IN_CLASS_OBJECT:
      return state.set(action.sessionId, action.payload);
    case _actions.RESET_COVERED_IN_CLASS_OBJECT:
      return resetCICBySessionId(state, action.sessionId);
    default:
      return state;
  }
}

function onSuccess(state, action) {
  return action.payload.reduce(function (map, coveredInClass) {
    return map.set(coveredInClass.unitId + '-' + coveredInClass.lessonNumber, _model2.default.create(coveredInClass));
  }, new _immutable.Map());
}

function resetCICBySessionId(state, sessionId) {
  return state.set(sessionId, state.get(sessionId).map(function (cic) {
    return cic.set('cicActivities', new _immutable.List()).set('cicCategories', new _immutable.List());
  }));
}

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1551);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _CategoryItem = __webpack_require__(1552);

var _CategoryItem2 = _interopRequireDefault(_CategoryItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryRecord = (0, _immutable.Record)({
  lessonNumber: undefined,
  cicCategoryId: undefined,
  cicCategoryName: undefined,
  orderingSequence: undefined,
  cicCategoryItems: new _immutable.List()
});

var Category = function (_CategoryRecord) {
  _inherits(Category, _CategoryRecord);

  function Category() {
    _classCallCheck(this, Category);

    return _possibleConstructorReturn(this, (Category.__proto__ || Object.getPrototypeOf(Category)).apply(this, arguments));
  }

  return Category;
}(CategoryRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'cicCategoryItems':
      return [key, new _immutable.List(val.map(_CategoryItem2.default.create))];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

Category.create = function (data) {
  return new Category(data).mapEntries(reviver);
};

exports.default = Category;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1553);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryItemReacord = (0, _immutable.Record)({
  cicCategoryItemId: undefined,
  cicCategoryItemName: undefined,
  orderingSequence: undefined,
  isChecked: true
});

var CategoryItem = function (_CategoryItemReacord) {
  _inherits(CategoryItem, _CategoryItemReacord);

  function CategoryItem() {
    _classCallCheck(this, CategoryItem);

    return _possibleConstructorReturn(this, (CategoryItem.__proto__ || Object.getPrototypeOf(CategoryItem)).apply(this, arguments));
  }

  return CategoryItem;
}(CategoryItemReacord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  switch (key) {
    case 'cicCategoryItemName':
      return [key, '' + val];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

CategoryItem.create = function (data) {
  return new CategoryItem(data).mapEntries(reviver);
};

exports.default = CategoryItem;

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1555);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _ActivityItem = __webpack_require__(1556);

var _ActivityItem2 = _interopRequireDefault(_ActivityItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActivityRecord = (0, _immutable.Record)({
  lessonNumber: undefined,
  cicActivityId: undefined,
  cicActivityName: undefined,
  orderingSequence: undefined,
  cicActivityItems: new _immutable.List()
});

var Activity = function (_ActivityRecord) {
  _inherits(Activity, _ActivityRecord);

  function Activity() {
    _classCallCheck(this, Activity);

    return _possibleConstructorReturn(this, (Activity.__proto__ || Object.getPrototypeOf(Activity)).apply(this, arguments));
  }

  return Activity;
}(ActivityRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'cicActivityName':
      return [key, '' + val];
    case 'cicActivityItems':
      return [key, new _immutable.List(val.map(_ActivityItem2.default.create))];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

Activity.create = function (data) {
  return new Activity(data).mapEntries(reviver);
};

exports.default = Activity;

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1557);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActivityItemRecord = (0, _immutable.Record)({
  cicActivityItemId: undefined,
  cicActivityItemCode: undefined,
  orderingSequence: undefined,
  isChecked: true
});

var ActivityItem = function (_ActivityItemRecord) {
  _inherits(ActivityItem, _ActivityItemRecord);

  function ActivityItem() {
    _classCallCheck(this, ActivityItem);

    return _possibleConstructorReturn(this, (ActivityItem.__proto__ || Object.getPrototypeOf(ActivityItem)).apply(this, arguments));
  }

  return ActivityItem;
}(ActivityItemRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  switch (key) {
    case 'cicActivityItemCode':
      return [key, '' + val];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

ActivityItem.create = function (data) {
  return new ActivityItem(data).mapEntries(reviver);
};

exports.default = ActivityItem;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CICTemplate;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(677);

var _model = __webpack_require__(305);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CICTemplate() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_COVERED_IN_CLASS_TEMPLATE_SUCCESS:
      return state.set(action.sessionId, onSuccess(state, action));
    default:
      return state;
  }
}

function onSuccess(state, action) {
  var isDefaultUnchecked = action.isDefaultUnchecked,
      payload = action.payload;

  return payload.reduce(function (map, coveredInClass) {
    var cicCategories = coveredInClass.cicCategories && coveredInClass.cicCategories.map(function (category) {
      return Object.assign(category, {
        cicCategoryItems: category.cicCategoryItems.map(function (item) {
          return Object.assign(item, { isChecked: !isDefaultUnchecked });
        })
      });
    });
    var template = Object.assign(coveredInClass, { cicCategories: cicCategories });
    return map.set(coveredInClass.unitId + '-' + coveredInClass.lessonNumber, _model2.default.create(template));
  }, new _immutable.Map());
}

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CICCategories;

var _actions = __webpack_require__(678);

var _model = __webpack_require__(1560);

var _model2 = _interopRequireDefault(_model);

var _immutable = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CICCategories() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_CIC_CATEGORIES_SUCCESS:
      return state.set(action.groupId, onSuccess(action));
    default:
      return state;
  }
}

function onSuccess(_ref) {
  var payload = _ref.payload;

  return payload.map(function (category) {
    return new _model2.default(category);
  });
}

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryRecord = (0, _immutable.Record)({
  cicCategoryId: undefined,
  cicCategoryName: undefined
});

var Category = function (_CategoryRecord) {
  _inherits(Category, _CategoryRecord);

  function Category() {
    _classCallCheck(this, Category);

    return _possibleConstructorReturn(this, (Category.__proto__ || Object.getPrototypeOf(Category)).apply(this, arguments));
  }

  return Category;
}(CategoryRecord);

exports.default = Category;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1562);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1LaiUlY70kqrnnF7k2nz1x{border-bottom:.07143rem solid #ccc;margin:1.42857rem 0 .71429rem 1.07143rem;-webkit-transition-duration:0ms;-moz-transition-duration:0ms;-o-transition-duration:0ms;transition-duration:0ms}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"InternalNotesPart_addNote": "_3MFvtIE3aB_gfvSU7GrG3e",
	"InternalNotesPart_line": "_1LaiUlY70kqrnnF7k2nz1x"
};

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = internalNotes;

var _actions = __webpack_require__(680);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

function internalNotes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_INTERNAL_NOTES_REQUEST:
      return state.set(action.sessionPlanId, _omniCommonUi.ApiResponseHelper.create({ loading: true }));
    case _actions.FETCH_INTERNAL_NOTES_SUCCESS:
      {
        var data = _omniCommonUi.ApiResponseHelper.create(action.payload);
        return state.set(action.sessionPlanId, data);
      }
    case _actions.FETCH_INTERNAL_NOTES_FAILURE:
      return state.set(action.sessionPlanId, _omniCommonUi.ApiResponseHelper.create(action.error));
    case _actions.EDIT_INTERNAL_NOTE_SUCCESS:
      {
        var newInternalNotes = state.get(action.sessionPlanId);
        newInternalNotes.update('data', function (data) {
          if (action.index >= 0) {
            data.splice(action.index, 1);
          }
          data.splice(0, 0, action.internalNote);
        });
        return state.set(action.sessionPlanId, newInternalNotes);
      }
    case _actions.DELETE_INTERNAL_NOTE:
      {
        var _newInternalNotes = state.get(action.sessionPlanId);
        _newInternalNotes.update('data', function (data) {
          data.splice(action.index, 1);
        });
        return state.set(action.sessionPlanId, _newInternalNotes);
      }
    default:
      return state;
  }
}

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InternalNoteRecord = (0, _immutable.Record)({
  noteId: undefined,
  note: undefined,
  userId: undefined,
  userName: undefined
});

var InternalNote = function (_InternalNoteRecord) {
  _inherits(InternalNote, _InternalNoteRecord);

  function InternalNote() {
    _classCallCheck(this, InternalNote);

    return _possibleConstructorReturn(this, (InternalNote.__proto__ || Object.getPrototypeOf(InternalNote)).apply(this, arguments));
  }

  return InternalNote;
}(InternalNoteRecord);

InternalNoteRecord.create = function (data) {
  return new InternalNoteRecord(data);
};

exports.default = InternalNote;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1566);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".YrdLOnp5hhbrOp4X7E5Th{border-bottom:.07143rem solid #ccc;padding:.71429rem 1.42857rem}.jHVtKtrNJBIM7c5rLtPmu{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:1.125em;font-weight:600;margin-right:1.42857rem}._19DZtAEpV0skPveiDLkEau{padding:.71429rem 0}._39aliJKj2W3GKGzr9rxsfH{padding:.71429rem 1.42857rem 1.42857rem}.HVlEvw9iQmcbCPstEE5aB{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-style:normal;padding:.71429rem 0 2.14286rem}.j-OPMf1MN2ESsCwGqvJr3{margin-right:.35714rem}._1mjijXv5zphQf6k96IEkhQ{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"AddFreeTextDialog_title": "YrdLOnp5hhbrOp4X7E5Th",
	"AddFreeTextDialog_title_text": "jHVtKtrNJBIM7c5rLtPmu",
	"AddFreeTextDialog_subTitle": "_19DZtAEpV0skPveiDLkEau",
	"AddFreeTextDialog_content": "_39aliJKj2W3GKGzr9rxsfH",
	"AddFreeTextDialog_content_info": "HVlEvw9iQmcbCPstEE5aB",
	"AddFreeTextDialog_content_info_icon": "j-OPMf1MN2ESsCwGqvJr3",
	"AddFreeTextDialog_buttons": "_1mjijXv5zphQf6k96IEkhQ"
};

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(682);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1572);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1569);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._36tnovB_RJZt9YCHnVWu2t{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;margin-bottom:1.14286rem}._1N80wVqAHNvvhcdMkcHTjJ{margin-bottom:1.14286rem}._3p-x49UiBBF_IrC7w7DhAn{font-size:1rem;line-height:1.6;letter-spacing:.07143rem;white-space:pre-line}._1ne4U_la5EyCHe8v07FRlv{padding:2.85714rem;text-align:center;color:#a4a4a4;font-size:1rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"header": "_36tnovB_RJZt9YCHnVWu2t",
	"section": "_1N80wVqAHNvvhcdMkcHTjJ",
	"sectionContent": "_3p-x49UiBBF_IrC7w7DhAn",
	"empty": "_1ne4U_la5EyCHe8v07FRlv"
};

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRAv2Cic = getRAv2Cic;
function getRAv2Cic(state, sessionId) {
  return state.get('rootReducer').get('rav2Cic').get(sessionId);
}

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rav2Cic;

var _actions = __webpack_require__(683);

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(684);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function rav2Cic() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_RAV2_CIC_SUCCESS:
      {
        if (!action.payload) {
          return state.set(action.sessionId, null);
        }
        return state.set(action.sessionId, _model2.default.create(action.payload));
      }
    default:
      return state;
  }
}

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _component = __webpack_require__(682);

var _component2 = _interopRequireDefault(_component);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _omniCommonUi = __webpack_require__(0);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _CoveredInClassRAv2SessionNav = __webpack_require__(1573);

var _CoveredInClassRAv2SessionNav2 = _interopRequireDefault(_CoveredInClassRAv2SessionNav);

var _accessors = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    appBars: {
      sticky: {
        'session-nav': {
          component: _CoveredInClassRAv2SessionNav2.default,
          order: 1
        }
      }
    },
    path: 'session/:sessionPlanId(/unit/:unitId)/covered-in-class-ra-v2',
    component: _component2.default,
    canAccess: function canAccess(_ref2) {
      var params = _ref2.params;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.ViewCoveredInClass) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.CoveredInClassRAv2);
    },
    tab: {
      label: 'Covered in Class',
      order: 5,
      isVisible: function isVisible(params) {
        if (!_omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.CoveredInClass.ViewCoveredInClass)) {
          return false;
        }
        if (!_TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.CoveredInClassRAv2)) {
          return false;
        }
        // Only show tab if group has session data
        var defaultSession = (0, _accessors.getDefaultSession)(getState(), params.groupId);
        return !!defaultSession;
      },
      params: function params(currentParams) {
        var defaultSession = (0, _accessors.getDefaultSession)(getState(), currentParams.groupId);
        var sessionPlanId = defaultSession && defaultSession.id;
        return _extends({}, currentParams, {
          sessionPlanId: sessionPlanId,
          unitId: (0, _accessors.getFirstUnitOfSession)(getState(), sessionPlanId)
        });
      }
    },
    breadcrumbLabels: function breadcrumbLabels() {
      return [{
        label: 'Covered in Class',
        clickable: false
      }];
    }
  };
};

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

exports.mapStateToProps = mapStateToProps;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseSessionNav2 = __webpack_require__(108);

var _BaseSessionNav3 = _interopRequireDefault(_BaseSessionNav2);

var _style = __webpack_require__(630);

var _style2 = _interopRequireDefault(_style);

var _style3 = __webpack_require__(1574);

var _style4 = _interopRequireDefault(_style3);

var _omniCommonUi = __webpack_require__(0);

var _SessionPlans = __webpack_require__(44);

var _Group = __webpack_require__(13);

var _UiState = __webpack_require__(30);

var _accessors = __webpack_require__(41);

var _RAv2Cic = __webpack_require__(309);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DATE_FORMAT = 'YYYY-MM-DD';

var CoveredInClassRAv2SessionNav = function (_BaseSessionNav) {
  _inherits(CoveredInClassRAv2SessionNav, _BaseSessionNav);

  function CoveredInClassRAv2SessionNav() {
    _classCallCheck(this, CoveredInClassRAv2SessionNav);

    return _possibleConstructorReturn(this, (CoveredInClassRAv2SessionNav.__proto__ || Object.getPrototypeOf(CoveredInClassRAv2SessionNav)).apply(this, arguments));
  }

  _createClass(CoveredInClassRAv2SessionNav, [{
    key: '_hasNext',
    value: function _hasNext() {
      return this.props.currentSessionIndex < this.props.sessionCount - 1;
    }
  }, {
    key: '_hasPrevious',
    value: function _hasPrevious() {
      return this.props.currentSessionIndex > 0;
    }
  }, {
    key: '_hasNextUnit',
    value: function _hasNextUnit() {
      return _is_js2.default.existy(this.props.nextUnitText);
    }
  }, {
    key: '_hasPreviousUnit',
    value: function _hasPreviousUnit() {
      return _is_js2.default.existy(this.props.previousUnitText);
    }
  }, {
    key: '_getNextUnitText',
    value: function _getNextUnitText() {
      return this.props.nextUnitText;
    }
  }, {
    key: '_getPreviousUnitText',
    value: function _getPreviousUnitText() {
      return this.props.previousUnitText;
    }
  }, {
    key: '_getHeadingText',
    value: function _getHeadingText() {
      var _props = this.props,
          currentSession = _props.currentSession,
          levelNumber = _props.levelNumber,
          sessionCount = _props.sessionCount,
          currentUnit = _props.currentUnit;

      if (!currentSession) return '';
      var sessionText = _is_js2.default.existy(levelNumber) ? 'Level ' + levelNumber : currentSession.index + '/' + sessionCount;
      var unitText = currentUnit ? ', Story ' + currentUnit.orderingSequence : '';
      return '' + sessionText + unitText;
    }
  }, {
    key: '_getAdditionalChildren',
    value: function _getAdditionalChildren() {
      var currentSessionStartDate = this.props.currentSessionStartDate;

      if (!currentSessionStartDate) return _react2.default.createElement('div', null);
      var date = currentSessionStartDate.format(DATE_FORMAT);
      var displayDate = currentSessionStartDate.format('ddd, D MMM YYYY');
      return _react2.default.createElement(
        'h2',
        null,
        _react2.default.createElement(
          'time',
          { dateTime: date },
          displayDate
        )
      );
    }
  }, {
    key: '_renderPreviousUnit',
    value: function _renderPreviousUnit() {
      return null;
    }
  }, {
    key: '_renderNextUnit',
    value: function _renderNextUnit() {
      return null;
    }
  }, {
    key: '_renderCurrent',
    value: function _renderCurrent() {
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames3.default)(_style2.default.BaseSessionNav_current, _defineProperty({}, _style2.default.__populated, !!this.props.showCurrentNav)) },
        _is_js2.default.existy(this.props.currentLinkHref) ? _react2.default.createElement(
          _omniCommonUi.Button,
          { linkTo: this.props.currentLinkHref },
          'Current'
        ) : null
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.currentSession || !this.props.timeZone) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: _style4.default.CoveredInClassRAv2SessionNav },
        _get(CoveredInClassRAv2SessionNav.prototype.__proto__ || Object.getPrototypeOf(CoveredInClassRAv2SessionNav.prototype), 'render', this).call(this)
      );
    }
  }]);

  return CoveredInClassRAv2SessionNav;
}(_BaseSessionNav3.default);

CoveredInClassRAv2SessionNav.propTypes = Object.assign({
  currentSession: _propTypes2.default.object,
  currentSessionIndex: _propTypes2.default.number,
  currentSessionStartDate: _propTypes2.default.object,
  currentUnit: _propTypes2.default.object,
  levelNumber: _propTypes2.default.number,
  sessionCount: _propTypes2.default.number,
  nextUnitText: _propTypes2.default.string,
  previousUnitText: _propTypes2.default.string,
  timeZone: _propTypes2.default.string
}, _BaseSessionNav3.default.propTypes);

function getSessionLinkHref(sessionPlan, buildRoute) {
  var sessionPlanId = sessionPlan && sessionPlan.id;
  var unitId = sessionPlanId && Array.isArray(sessionPlan.unitIds) && sessionPlan.unitIds[0];

  var params = _is_js2.default.existy(unitId) ? { unitId: unitId, sessionPlanId: sessionPlanId, mode: '' } : { unitId: 0, sessionPlanId: sessionPlanId, mode: '' };
  return sessionPlanId && buildRoute(params);
}

function getPreviousOrNextSession(sessionList, currentSessionIndex, previous) {
  return sessionList.get(previous ? currentSessionIndex - 1 : currentSessionIndex + 1);
}

function getUnitLinkHref(session, unitId, buildRoute) {
  return unitId && session && buildRoute({
    unitId: unitId,
    sessionPlanId: session.id,
    mode: ''
  });
}

function isSessionContainsUnit(session, unitId) {
  if (_is_js2.default.existy(unitId)) {
    session.unitIds.includes(unitId);
  }
  return false;
}

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      currentSessionId = _ownProps$params.sessionPlanId;

  if (!_is_js2.default.existy(groupId) || !_is_js2.default.existy(currentSessionId)) {
    return;
  }
  var buildRoute = ownProps.buildRoute;

  var group = state.get('rootReducer').get('groups').get(groupId) && state.get('rootReducer').get('groups').get(groupId).data;
  var sessions = _SessionPlans.actions.getSessions(state, groupId);
  var units = (0, _accessors.getUnitList)(state, groupId);
  if (_is_js2.default.existy(group) && _is_js2.default.existy(sessions) && sessions.size !== 0 && _is_js2.default.existy(units)) {
    var _Group$getCentre = _Group.actions.getCentre(state, groupId),
        timeZone = _Group$getCentre.timeZone;

    var sessionList = _SessionPlans.actions.getOrderSessions(state, groupId);
    var currentUnitId = _is_js2.default.existy(ownProps.params.unitId) ? ownProps.params.unitId : _SessionPlans.actions.getFirstUnitOfSession(state, currentSessionId);
    var defaultSession = _SessionPlans.actions.getDefaultSession(state, groupId);
    var currentSession = sessions.get(currentSessionId);
    var currentSessionIndex = currentSession.index - 1;
    var previousSession = getPreviousOrNextSession(sessionList, currentSessionIndex, true);
    var nextSession = getPreviousOrNextSession(sessionList, currentSessionIndex, false);
    var nextUnitId = currentUnitId > 0 ? (0, _accessors.getNextUnit)(state, currentUnitId, groupId) && (0, _accessors.getNextUnit)(state, currentUnitId, groupId).id : _SessionPlans.actions.getNextUnitIdBySessionId(state, groupId, currentSessionId);
    var previousUnitId = currentUnitId > 0 ? (0, _accessors.getPreviousUnit)(state, currentUnitId, groupId) && (0, _accessors.getPreviousUnit)(state, currentUnitId, groupId).id : _SessionPlans.actions.getPreviousUnitIdBySessionId(state, groupId, currentSessionId);
    var nextUnitHref = isSessionContainsUnit(currentSession, nextUnitId) ? getUnitLinkHref(currentSession, nextUnitId, buildRoute) : getUnitLinkHref(_SessionPlans.actions.getFirstSessionOfUnit(state, groupId, nextUnitId), nextUnitId, buildRoute);
    var previousUnitHref = isSessionContainsUnit(currentSession, previousUnitId) ? getUnitLinkHref(currentSession, previousUnitId, buildRoute) : getUnitLinkHref(_SessionPlans.actions.getFirstSessionOfUnit(state, groupId, previousUnitId), previousUnitId, buildRoute);
    var nextUnit = units.get(nextUnitId);
    var previousUnit = units.get(previousUnitId);
    var nextUnitText = nextUnit && 'U ' + nextUnit.orderingSequence;
    var previousUnitText = previousUnit && 'U ' + previousUnit.orderingSequence;
    var shouldShowUnitNav = !!(units && units.size !== 0);
    var currentUnit = units.get(currentUnitId);
    var rav2Cic = _RAv2Cic.accessors.getRAv2Cic(state, currentSessionId);
    var levelNumber = rav2Cic ? rav2Cic.levelNumber : null;
    return {
      timeZone: timeZone,
      currentLinkHref: getSessionLinkHref(defaultSession, buildRoute),
      currentSession: currentSession,
      currentSessionIndex: currentSessionIndex,
      currentSessionStartDate: currentSession.period.start.clone().tz(timeZone),
      currentUnit: currentUnit,
      levelNumber: levelNumber,
      nextSessionLinkHref: getSessionLinkHref(nextSession, buildRoute),
      nextUnitLinkHref: nextUnitHref,
      nextUnitText: nextUnitText,
      previousSessionLinkHref: getSessionLinkHref(previousSession, buildRoute),
      previousUnitLinkHref: previousUnitHref,
      previousUnitText: previousUnitText,
      showUnitNav: shouldShowUnitNav,
      showCurrentNav: true,
      sessionCount: sessions.size,
      isHide: !_UiState.actions.getShowNavigationBar(state)
    };
  }
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null)(CoveredInClassRAv2SessionNav);

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1575);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".eqhbVtv8mMu9VhpL5_nIz h1{text-transform:none}", ""]);

// exports
exports.locals = {
	"CoveredInClassRAv2SessionNav": "eqhbVtv8mMu9VhpL5_nIz"
};

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(685);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(691);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHF4Homework = getHF4Homework;
function getHF4Homework(state, sessionId) {
  return state.getIn(['rootReducer', 'hf4Homework', sessionId]);
}

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hf4Homework;

var _actions = __webpack_require__(687);

var _immutable = __webpack_require__(3);

function hf4Homework() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_HF4_HOMEWORK_SUCCESS:
      {
        if (!action.payload) return state.set(action.sessionId, null);
        return state.set(action.sessionId, action.payload);
      }
    default:
      return state;
  }
}

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = studentTasksReducer;

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _actions = __webpack_require__(688);

var _model = __webpack_require__(311);

var _model2 = _interopRequireDefault(_model);

var _StudentTaskResult = __webpack_require__(1580);

var _StudentTaskResult2 = _interopRequireDefault(_StudentTaskResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = new _immutable.Map({
  taskResults: new _immutable.Map({}),
  taskList: new _immutable.Map({})
});

function studentTasksReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_STUDENT_TASK_RESULTS_REQUEST:
      return state.setIn(['taskResults', action.groupId], _omniCommonUi.ApiResponseHelper.create({ loading: true }));
    case _actions.FETCH_STUDENT_TASK_RESULTS_SUCCESS:
      return state.setIn(['taskResults', action.groupId], _omniCommonUi.ApiResponseHelper.create(setStudentTasks(state, action.payload)));
    case _actions.FETCH_STUDENT_TASK_RESULTS_FAILURE:
      return state.setIn(['taskResults', action.groupId], _omniCommonUi.ApiResponseHelper.create(action.error));
    case _actions.FETCH_STUDENT_TASK_LIST_REQUEST:
      return state.setIn(['taskList', action.sessionId], _omniCommonUi.ApiResponseHelper.create({ loading: true }));
    case _actions.FETCH_STUDENT_TASK_LIST_SUCCESS:
      return state.setIn(['taskList', action.sessionId], _omniCommonUi.ApiResponseHelper.create({ data: action.payload.data || action.payload }));
    case _actions.FETCH_STUDENT_TASK_LIST_FAILURE:
      return state.setIn(['taskList', action.sessionId], _omniCommonUi.ApiResponseHelper.create(action.error));
    default:
      return state;
  }
}

function setStudentTasks(state, payload) {
  return new _immutable.List(payload.map(function (tasksBySession) {
    var studentTaskResults = new _immutable.List(tasksBySession.studentTaskResults.map(function (taskByStudent) {
      return _StudentTaskResult2.default.create(taskByStudent).set('sessionId', '' + tasksBySession.sessionId);
    }));
    return _model2.default.create(tasksBySession).set('studentTaskResults', studentTaskResults);
  }));
}

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(689);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1581);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(689);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'sessionId':
    case 'studentId':
      return [key, '' + val];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(311);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'lessonNumber':
      return [key, Number.parseInt(val, 10)];
    case 'sessionId':
    case 'unitId':
      return [key, '' + val];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStudentTaskResults = getStudentTaskResults;
exports.getStudentTaskList = getStudentTaskList;
function getStudentTaskResults(state, groupId) {
  return state.getIn(['rootReducer', 'studentTasks', 'taskResults', groupId]);
}

function getStudentTaskList(state, sessionId) {
  return state.getIn(['rootReducer', 'studentTasks', 'taskList', sessionId]);
}

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGroupLessonAwards = getGroupLessonAwards;
function getGroupLessonAwards(state, sessionId) {
  return state.getIn(['rootReducer', 'groupLessonAwards', '' + sessionId]);
}

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = groupLessonAwards;

var _actions = __webpack_require__(312);

var _immutable = __webpack_require__(3);

function groupLessonAwards() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_GROUP_LESSON_AWARDS_SUCCESS:
      {
        var key = '' + action.sessionId;
        if (!action.payload) return state.set(key, null);
        return state.set(key, action.payload);
      }
    default:
      return state;
  }
}

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewNavCIC = exports.fnToValue = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1587);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _ViewNavBig = __webpack_require__(1589);

var _ViewNavBig2 = _interopRequireDefault(_ViewNavBig);

var _ViewNavSmall = __webpack_require__(1592);

var _ViewNavSmall2 = _interopRequireDefault(_ViewNavSmall);

var _ViewNavButton = __webpack_require__(313);

var _ViewNavButton2 = _interopRequireDefault(_ViewNavButton);

var _ViewNavExtra = __webpack_require__(314);

var _ViewNavExtra2 = _interopRequireDefault(_ViewNavExtra);

var _omniCommonUi = __webpack_require__(0);

var _immutable = __webpack_require__(3);

var _UiState = __webpack_require__(30);

var _classnames3 = __webpack_require__(7);

var _classnames4 = _interopRequireDefault(_classnames3);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LanguageSwitcher = __webpack_require__(692);

var _LanguageSwitcher2 = _interopRequireDefault(_LanguageSwitcher);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EDIT_MODE_MATCH_REGEXP = new RegExp("^edit$", "i");
var HIDE_EXTRA_ICON = true;

var fnToValue = exports.fnToValue = function fnToValue(any, props) {
  if (_is_js2.default.function(any)) {
    return any(props);
  }
  return any;
};

var ViewNavCIC = exports.ViewNavCIC = function (_Component) {
  _inherits(ViewNavCIC, _Component);

  function ViewNavCIC(props) {
    _classCallCheck(this, ViewNavCIC);

    var _this = _possibleConstructorReturn(this, (ViewNavCIC.__proto__ || Object.getPrototypeOf(ViewNavCIC)).call(this, props));

    _this._queryListener = _this._queryListener.bind(_this);
    _this._query = (0, _omniCommonUi.mediaQuery)("(min-width: 639px)");
    _this._setButtonsToDisplay(_this.props);
    _this.state = { big: _this._query.matches };
    return _this;
  }

  _createClass(ViewNavCIC, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._query.addListener(this._queryListener);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      this._setButtonsToDisplay(props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._query.removeListener(this._queryListener);
    }
  }, {
    key: "_queryListener",
    value: function _queryListener(mql) {
      this.setState({ big: mql.matches });
    }
  }, {
    key: "_setButtonsToDisplay",
    value: function _setButtonsToDisplay(props) {
      var currentRoute = ViewNavCIC.getCurrentRouteSegment(props);
      var currentModeName = props.params && props.params.mode && props.params.mode.length ? props.params.mode : "default";

      if (EDIT_MODE_MATCH_REGEXP.test(currentModeName)) {
        this._buttons = new _immutable.Map();
        return;
      }

      var actionButtonsMap = {};
      var actionButtonsForMode = void 0;
      if (currentRoute.actionButtons && currentRoute.actionButtons[currentModeName]) {
        actionButtonsForMode = currentRoute.actionButtons[currentModeName];
        Object.assign(actionButtonsMap, actionButtonsForMode);
      }

      var buttonsToDisplay = Object.keys(actionButtonsMap).filter(function (buttonLabel) {
        var buttonDescriptor = actionButtonsMap[buttonLabel];
        try {
          if (_is_js2.default.function(buttonDescriptor.visibleWhen)) {
            if (buttonDescriptor.visibleWhen.length < 2) {
              return buttonDescriptor.visibleWhen(props);
            } else if (!buttonDescriptor.visibleWhen(props.state, props)) {
              return false;
            }
          }
        } catch (err) {
          _omniCommonUi.log.warn("Error in `visibleWhen` in route `" + currentRoute.path + "`", err);
        }
        return true;
      });

      this._buttons = new _immutable.Map(actionButtonsMap).filter(function (v, key) {
        return buttonsToDisplay.indexOf(key) >= 0;
      });
    }
  }, {
    key: "_getIsDisabled",
    value: function _getIsDisabled(buttonDescriptor) {
      var props = this.props;
      try {
        if (_is_js2.default.function(buttonDescriptor.disableWhen)) {
          if (buttonDescriptor.disableWhen.length < 2) {
            return buttonDescriptor.disableWhen(props);
          } else if (buttonDescriptor.disableWhen(props.state, props)) {
            return true;
          }
        }
      } catch (err) {
        var currentRoute = ViewNavCIC.getCurrentRouteSegment(this.props);
        _omniCommonUi.log.warn("Error in `disableWhen` in route `" + currentRoute.path + "`", err);
      }
      return false;
    }
  }, {
    key: "_getOnClickHandler",
    value: function _getOnClickHandler(buttonDescriptor, buttonLabel) {
      var _this2 = this;

      if (buttonDescriptor.onClick) {
        return function () {
          registerClick();
          return buttonDescriptor.onClick.call(_this2, _this2.props.state, _this2.props);
        };
      }

      return buttonDescriptor.route && function () {
        registerClick();
        return _this2._redirect(fnToValue(buttonDescriptor.route, _this2.props));
      };

      function registerClick() {
        _reactGa2.default.event({
          category: "Navigation",
          action: "Clicked action button",
          label: "Clicked " + buttonLabel + " in the top toolbar"
        });
      }
    }
  }, {
    key: "_redirect",
    value: function _redirect(param) {
      var _props = this.props,
          pushRoute = _props.pushRoute,
          buildRoute = _props.buildRoute;

      pushRoute(buildRoute(param));
    }
  }, {
    key: "_hasButtons",
    value: function _hasButtons() {
      return this._buttons.size > 0;
    }
  }, {
    key: "_hasExtra",
    value: function _hasExtra() {
      var _ref = ViewNavCIC.getCurrentRouteSegment(this.props) || {},
          settings = _ref.sessionNav;

      if (this.props.showExpandable) {
        return true;
      }
      return this.props.hideExpandable !== true && (!settings || settings.noUnitSessionNavigation !== true);
    }
  }, {
    key: "_hasLanguageSwitcher",
    value: function _hasLanguageSwitcher() {
      return this.props.groupLanguageCode && this.props.groupLanguageCode !== _Languages2.default.defaultLanguageCode;
    }
  }, {
    key: "_getLanguageOptions",
    value: function _getLanguageOptions() {
      var englishOption = { code: _Languages2.default.defaultLanguageCode, label: 'EN' };
      if (this.props.isIDGroup) {
        return [englishOption];
      }
      return [{ code: _LanguageSwitcher.CHINESE_LANGUAGE, label: '中文' }, englishOption];
    }
  }, {
    key: "_renderLanguageSwitcher",
    value: function _renderLanguageSwitcher() {
      if (!this._hasLanguageSwitcher()) {
        return null;
      }

      return _react2.default.createElement(_LanguageSwitcher2.default, { className: _style2.default.ViewNav_languageSwitcher,
        languages: this._getLanguageOptions(),
        selectedLanguage: this.props.cicDisplayLanguage,
        onLanguageChange: this.props.setCICDisplayLanguage });
    }
  }, {
    key: "_renderExpandIcon",
    value: function _renderExpandIcon() {
      var _props2 = this.props,
          showNavigationBar = _props2.showNavigationBar,
          toggleNavigation = _props2.toggleNavigation;


      if (!this._hasExtra() || HIDE_EXTRA_ICON) {
        return null;
      }

      var iconClass = (0, _classnames4.default)(_style2.default.ViewNav_expandIcon, _defineProperty({}, _style2.default.__reverse, showNavigationBar), _defineProperty({}, _style2.default.__sticky, this.state.stickToTop));

      return _react2.default.createElement(
        _ViewNavExtra2.default,
        null,
        _react2.default.createElement(_omniCommonUi.Icon, {
          id: "chevron-fat-down",
          className: iconClass,
          onClick: toggleNavigation
        })
      );
    }
  }, {
    key: "_renderButtons",
    value: function _renderButtons() {
      var _this3 = this;

      return this._buttons.map(function (buttonDescriptor, buttonLabel) {
        var title = _is_js2.default.function(buttonDescriptor.label) ? buttonDescriptor.label(_this3.props) : buttonLabel;
        var className = (0, _omniCommonUi.testClass)("viewnav-button-" + title.replace(/\s+/g, "-").toLowerCase());
        return _react2.default.createElement(_ViewNavButton2.default, {
          key: buttonLabel,
          title: title,
          className: className,
          isPrimary: buttonDescriptor.isPrimary,
          disabled: _this3._getIsDisabled(buttonDescriptor),
          onClick: _this3._getOnClickHandler(buttonDescriptor, buttonLabel),
          newTab: buttonDescriptor.newTab,
          linkHref: fnToValue(buttonDescriptor.linkHref, _this3.props)
        });
      }).toArray();
    }
  }, {
    key: "render",
    value: function render() {
      var currentRoute = ViewNavCIC.getCurrentRouteSegment(this.props);
      if (currentRoute && currentRoute.actionButtons && currentRoute.actionButtons.hidden === true) {
        return null;
      }
      if (!this._hasButtons() && !this._hasExtra() && !this._hasLanguageSwitcher()) {
        return null;
      }
      var ViewNavImpl = this.state.big ? _ViewNavBig2.default : _ViewNavSmall2.default;
      return _react2.default.createElement(
        ViewNavImpl,
        null,
        this._renderLanguageSwitcher(),
        this._renderButtons(),
        this._renderExpandIcon()
      );
    }
  }]);

  return ViewNavCIC;
}(_react.Component);

ViewNavCIC.getCurrentRouteSegment = function (_ref2) {
  var routes = _ref2.routes;
  return routes ? routes[routes.length - 1] : {};
};

ViewNavCIC.propTypes = {
  isMarkable: _propTypes2.default.bool,
  state: _propTypes2.default.object,
  routes: _propTypes2.default.array.isRequired,
  location: _propTypes2.default.object.isRequired,
  params: _propTypes2.default.object.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  groupLanguageCode: _propTypes2.default.string,
  isIDGroup: _propTypes2.default.bool,
  cicDisplayLanguage: _propTypes2.default.string,
  setCICDisplayLanguage: _propTypes2.default.func.isRequired,
  toggleNavigation: _propTypes2.default.func.isRequired,
  showNavigationBar: _propTypes2.default.bool.isRequired,
  hideExpandable: _propTypes2.default.bool,
  showExpandable: _propTypes2.default.bool
};

function mapStateToProps(state, ownProps) {
  var showNavigationBar = _UiState.actions.getShowNavigationBar(state);
  var groupLanguageCode = getGroupLanguageCode(state, ownProps);
  var groupId = ownProps.params && ownProps.params.groupId;
  var isIDGroup = !!(groupId && _.actions.isIDGroup(state, groupId));
  var cicDisplayLanguage = isIDGroup ? _Languages2.default.defaultLanguageCode : _UiState.actions.getCICDisplayLanguage(state) || _Languages2.default.defaultLanguageCode;
  return {
    showNavigationBar: showNavigationBar,
    cicDisplayLanguage: cicDisplayLanguage,
    groupLanguageCode: groupLanguageCode,
    isIDGroup: isIDGroup
  };
}

function getGroupLanguageCode(state, ownProps) {
  var groupId = ownProps.params && ownProps.params.groupId;
  var group = groupId && state.get('rootReducer').get('groups').get(groupId) && state.get('rootReducer').get('groups').get(groupId).data;

  return group && group.get && group.get('languageCode');
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_UiState.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(ViewNavCIC);

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1588);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3H4QqghfHCGVrEnVYVTCGD{width:100%}.jIzgtajQH37Z7_8XBzHA1{background-position:50%;background-repeat:no-repeat;-webkit-background-size:contain;-moz-background-size:contain;background-size:contain;content:\"\";cursor:pointer;display:block;font-size:.85714rem;-webkit-transition:-webkit-transform .3s ease-in-out;transition:-webkit-transform .3s ease-in-out;-o-transition:-o-transform .3s ease-in-out;-moz-transition:transform .3s ease-in-out,-moz-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out,-moz-transform .3s ease-in-out,-o-transform .3s ease-in-out}.jIzgtajQH37Z7_8XBzHA1.ycfOJIxtxToYoQ4hc0st9{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg)}._2yPdOG32DXzo-GxbyBQ_J9{margin-right:1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ViewNav": "_3H4QqghfHCGVrEnVYVTCGD",
	"ViewNav_expandIcon": "jIzgtajQH37Z7_8XBzHA1",
	"__reverse": "ycfOJIxtxToYoQ4hc0st9",
	"ViewNav_languageSwitcher": "_2yPdOG32DXzo-GxbyBQ_J9"
};

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1590);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _ViewNavButton = __webpack_require__(313);

var _ViewNavButton2 = _interopRequireDefault(_ViewNavButton);

var _ViewNavExtra = __webpack_require__(314);

var _ViewNavExtra2 = _interopRequireDefault(_ViewNavExtra);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewNavBig = function ViewNavBig(_ref) {
  var children = _ref.children;

  var childrenArr = _react2.default.Children.toArray(children);
  var className = _style2.default.ViewNavBig;
  var extraContent = childrenArr.filter(function (child) {
    return child.type !== _ViewNavButton2.default && child.type !== _ViewNavExtra2.default;
  });
  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_style2.default.ViewNavBig_actions, (0, _omniCommonUi.testClass)('viewnav-action-buttons')) },
      extraContent,
      childrenArr.filter(function (child) {
        return child.type === _ViewNavButton2.default;
      })
    ),
    childrenArr.find(function (child) {
      return child.type === _ViewNavExtra2.default;
    })
  );
};

ViewNavBig.propTypes = {
  children: _propTypes2.default.node
};

exports.default = ViewNavBig;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1591);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3gcsAnY9clqZRJ_qk9Ud9h{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:#f3f5f7;border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:3.92857rem;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;overflow:hidden;padding:0;padding-left:1.42857rem;padding-right:1.42857rem}@media only screen and (min-width:640px){._3gcsAnY9clqZRJ_qk9Ud9h{padding-left:2.14286rem;padding-right:2.14286rem}}._3gcsAnY9clqZRJ_qk9Ud9h button{overflow:hidden;white-space:nowrap}.O0hckfW1R25XjUGRjvL7A{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ViewNavBig": "_3gcsAnY9clqZRJ_qk9Ud9h",
	"ViewNavBig_actions": "O0hckfW1R25XjUGRjvL7A"
};

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1593);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ViewNavButton = __webpack_require__(313);

var _ViewNavButton2 = _interopRequireDefault(_ViewNavButton);

var _ViewNavExtra = __webpack_require__(314);

var _ViewNavExtra2 = _interopRequireDefault(_ViewNavExtra);

var _omniCommonUi = __webpack_require__(0);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewNavSmall = function (_Component) {
  _inherits(ViewNavSmall, _Component);

  function ViewNavSmall(props) {
    _classCallCheck(this, ViewNavSmall);

    var _this = _possibleConstructorReturn(this, (ViewNavSmall.__proto__ || Object.getPrototypeOf(ViewNavSmall)).call(this, props));

    _this.state = { open: false };
    _this._setUp(props);
    return _this;
  }

  _createClass(ViewNavSmall, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(props) {
      this._setUp(props);
    }
  }, {
    key: '_setUp',
    value: function _setUp(props) {
      var childrenArr = _react2.default.Children.toArray(props.children);
      this._buttons = childrenArr.filter(function (child) {
        return child.type === _ViewNavButton2.default;
      });
      this._extra = childrenArr.find(function (child) {
        return child.type === _ViewNavExtra2.default;
      });
      this._content = childrenArr.filter(function (child) {
        return child.type !== _ViewNavButton2.default && child.type !== _ViewNavExtra2.default;
      });
    }
  }, {
    key: '_toggleDropdown',
    value: function _toggleDropdown(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.setState({ open: !this.state.open });
    }
  }, {
    key: '_handleExpandKeyDown',
    value: function _handleExpandKeyDown(evt) {
      if (evt.key === 'Enter' || evt.key === ' ') {
        this._toggleDropdown(evt);
      }
    }
  }, {
    key: '_renderDropdown',
    value: function _renderDropdown() {
      var _this2 = this;

      if (this._buttons.length <= 0) {
        return _react2.default.createElement('div', null);
      }

      return _react2.default.createElement(
        _omniCommonUi.DropdownBox.Container,
        { className: _style2.default.ViewNavSmall_container,
          onClickOutside: function onClickOutside() {
            return _this2.setState({ open: false });
          } },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_style2.default.ViewNavSmall_expand, (0, _omniCommonUi.testClass)('viewnav-expand-action-buttons')),
            onClick: function onClick(e) {
              return _this2._toggleDropdown(e);
            },
            onKeyDown: function onKeyDown(e) {
              return _this2._handleExpandKeyDown(e);
            },
            role: 'button',
            tabIndex: '0' },
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'dots' })
        ),
        _react2.default.createElement(
          _omniCommonUi.DropdownBox,
          { className: (0, _classnames2.default)(_style2.default.ViewNavSmall_dropdown, (0, _omniCommonUi.testClass)('viewnav-action-buttons')),
            open: this.state.open },
          this._buttons.map(function (_ref) {
            var props = _ref.props;
            return _react2.default.createElement(
              _omniCommonUi.DropdownBox.Item,
              { className: _style2.default.ViewNavSmall_item },
              _react2.default.createElement(
                _omniCommonUi.Button,
                _extends({}, props, {
                  className: (0, _classnames2.default)(_style2.default.ViewNavSmall_item_button, props.className) }),
                props.title
              )
            );
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _style2.default.ViewNavSmall },
        _react2.default.createElement(
          'div',
          { className: _style2.default.ViewNavSmall_leftContent },
          this._content,
          this._renderDropdown()
        ),
        this._extra
      );
    }
  }]);

  return ViewNavSmall;
}(_react.Component);

ViewNavSmall.propTypes = {
  children: _propTypes2.default.node
};

exports.default = ViewNavSmall;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1594);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1nsJAeoHv-EHPiNvNjWeHD{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:#f3f5f7;border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:2.85714rem;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0;z-index:500;padding-left:1.42857rem;padding-right:1.42857rem}@media only screen and (min-width:640px){._1nsJAeoHv-EHPiNvNjWeHD{padding-left:2.14286rem;padding-right:2.14286rem}}.HRvr4ETZ0Kq4cBKjX37aQ{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;position:relative}._2kGUnfIZd9xGRQVIklnSXb,._3kC62L9C24Be-7duMvbg1E{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._3kC62L9C24Be-7duMvbg1E{background-color:#0087e6;color:#fff;cursor:pointer;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-left:-1.42857rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:2.85714rem}._23jTc9VU222qxVVsHRfXI{background-color:#f3f5f7;left:-1.42857rem;position:absolute;top:2.85714rem;z-index:500}._3PjqP5o4_Y593VRTckwT9w{padding:0}.UI-9kKfYRH27ZjYi4cIzi{background:transparent!important;border:none!important;-webkit-border-radius:0!important;-moz-border-radius:0!important;border-radius:0!important;-webkit-box-shadow:100%!important;-moz-box-shadow:100%!important;box-shadow:100%!important;color:inherit!important;display:block;height:100%!important;min-height:2.5rem!important;min-width:0!important;width:100%!important;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:.85714rem;font-weight:600;letter-spacing:.07143rem;text-transform:uppercase}._3PjqP5o4_Y593VRTckwT9w>.UI-9kKfYRH27ZjYi4cIzi{padding:0 1.42857rem!important}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ViewNavSmall": "_1nsJAeoHv-EHPiNvNjWeHD",
	"ViewNavSmall_container": "HRvr4ETZ0Kq4cBKjX37aQ",
	"ViewNavSmall_leftContent": "_2kGUnfIZd9xGRQVIklnSXb",
	"ViewNavSmall_expand": "_3kC62L9C24Be-7duMvbg1E",
	"ViewNavSmall_dropdown": "_23jTc9VU222qxVVsHRfXI",
	"ViewNavSmall_item": "_3PjqP5o4_Y593VRTckwT9w",
	"ViewNavSmall_item_button": "UI-9kKfYRH27ZjYi4cIzi"
};

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1596);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2NhxCDAabrLFg1bP1Fmzms{-webkit-box-align:stretch;-webkit-align-items:stretch;-moz-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;border:.07143rem solid #0087e6;-webkit-border-radius:.35714rem;-moz-border-radius:.35714rem;border-radius:.35714rem;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:2.5rem;overflow:hidden}._32dRsdSVTWmuyVy7wK6MlH{background:#f3f5f7;border:0;color:#0087e6;cursor:pointer;font-size:1rem;min-width:3.5rem;padding:0 .71429rem}._32dRsdSVTWmuyVy7wK6MlH:focus{outline:none}._32dRsdSVTWmuyVy7wK6MlH._1lkh-y5c_J_1DE83RzcuvO{background:#0087e6;color:#fff}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"LanguageSwitcher": "_2NhxCDAabrLFg1bP1Fmzms",
	"LanguageSwitcher_option": "_32dRsdSVTWmuyVy7wK6MlH",
	"_selected": "_1lkh-y5c_J_1DE83RzcuvO"
};

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var Badges = [{ uuid: '27122013-aadf-4ed3-a9c8-3757e3f22bc4', type: 'badge', name_zh: '进步更惊人', name_en: 'Most Improved Student', icon_cn: 'https://storyblok-cdn.yingfu.cn/f/290/200x200/1528b387f0/most-improved-student.png', icon_en: 'https://storyblok-cdn.yingfu.cn/f/293/200x200/2cc908b588/most-improved-student.png' }, { uuid: 'c641836e-bce3-43c1-94a4-6349c9d48795', type: 'badge', name_zh: '互动更热烈', name_en: 'Best in Class Participation', icon_cn: 'https://storyblok-cdn.yingfu.cn/f/290/200x200/ca92e3570d/best-in-class-participation.png', icon_en: 'https://storyblok-cdn.yingfu.cn/f/293/200x200/4a3c10aa15/best-in-class-participation.png' }, { uuid: '1af12043-afa1-4436-b74e-3e4dfe2952c0', type: 'badge', name_zh: '出勤更稳定', name_en: 'Best in Attendance', icon_cn: 'https://storyblok-cdn.yingfu.cn/f/290/200x200/668c996512/best-in-attendance.png', icon_en: 'https://storyblok-cdn.yingfu.cn/f/293/200x200/2c05e2e448/best-in-attendance.png' }, { uuid: '3f58386c-e099-40c0-852b-18554469b536', type: 'badge', name_zh: '练习更用心', name_en: 'Best Practice Completion', icon_cn: 'https://storyblok-cdn.yingfu.cn/f/290/200x200/3fa75dfa34/best-practice-completion.png', icon_en: 'https://storyblok-cdn.yingfu.cn/f/293/200x200/e6fc2a7fd9/best-practice-completion.png' }, { uuid: '5efa5f85-682c-4c60-af90-1ea00965ce8d', type: 'badge', name_zh: '参与更积极', name_en: 'Best Event Participation', icon_cn: 'https://storyblok-cdn.yingfu.cn/f/290/200x200/ebcdad57fd/best-event-participation.png', icon_en: 'https://storyblok-cdn.yingfu.cn/f/293/200x200/469045f3d5/best-event-participation.png' }, { uuid: 'c6982292-7b80-4d59-9747-3c0403e0e66a', type: 'badge', name_zh: '创意更独特', name_en: 'Most Creative Student', icon_cn: 'https://storyblok-cdn.yingfu.cn/f/290/200x200/e04ba4fd37/most-creative-student.png', icon_en: 'https://storyblok-cdn.yingfu.cn/f/293/200x200/38902e2f12/most-creative-student.png' }, { uuid: '5201ea90-a079-4cbb-8eba-23c66fb408a5', type: 'badge', name_zh: '自信更饱满', name_en: 'Most Confident Student', icon_cn: 'https://storyblok-cdn.yingfu.cn/f/290/200x200/1ae08783d7/most-confident-student.png', icon_en: 'https://storyblok-cdn.yingfu.cn/f/293/200x200/c35db419d7/most-confident-student.png' }, { uuid: '55a5a3cf-b47e-4961-93cd-e44529ae3065', type: 'badge', name_zh: '团队更默契', name_en: 'Best Team Spirit', icon_cn: 'https://storyblok-cdn.yingfu.cn/f/290/200x200/dc4bc72261/best-team-spirit.png', icon_en: 'https://storyblok-cdn.yingfu.cn/f/293/200x200/7471d243a0/best-team-spirit.png' }];

var Points = [{ uuid: '4c60ffa2-4b0a-4031-951c-f561629dd6e8', type: 'point', name: 'pts_avatar_clarence', icon: 'https://storyblok-cdn.yingfu.cn/f/293/96x96/9c56b804af/pts_avatar_clarence.png' }, { uuid: '71aa294c-edf7-42c6-b62b-fd6c45bd682d', type: 'point', name: 'pts_avatar_clora', icon: 'https://storyblok-cdn.yingfu.cn/f/293/96x96/c1878542c3/pts_avatar_clora.png' }, { uuid: '3486ed5a-acf0-413b-b9fe-67474c5ce397', type: 'point', name: 'pts_avatar_cooper', icon: 'https://storyblok-cdn.yingfu.cn/f/293/96x96/d8af88b39a/pts_avatar_cooper.png' }, { uuid: '31e92ce5-706b-41d1-b7e8-faa564d29197', type: 'point', name: 'pts_avatar_elise', icon: 'https://storyblok-cdn.yingfu.cn/f/293/96x96/8412651648/pts_avatar_elise.png' }, { uuid: 'bed52cec-fe95-41d5-b4b6-3b88ff944079', type: 'point', name: 'pts_avatar_fleet', icon: 'https://storyblok-cdn.yingfu.cn/f/293/96x96/4702608f21/pts_avatar_fleet.png' }, { uuid: '19f84d61-04cf-47bd-9ca3-e6904e69609b', type: 'point', name: 'pts_avatar_jones', icon: 'https://storyblok-cdn.yingfu.cn/f/293/96x96/1b96c1d201/pts_avatar_jones.png' }, { uuid: '9c6e94bb-417a-4209-89ed-1b4f1f2cdc5f', type: 'point', name: 'pts_avatar_king', icon: 'https://storyblok-cdn.yingfu.cn/f/293/96x96/b4babf0980/pts_avatar_king.png' }, { uuid: '60203ac7-0454-4d2e-9594-d1e34e706f96', type: 'point', name: 'pts_avatar_mo', icon: 'https://storyblok-cdn.yingfu.cn/f/293/96x96/eba28bcec8/pts_avatar_mo.png' }, { uuid: 'b79193ec-27d4-47c7-b6bd-a353f49f1587', type: 'point', name: 'pts_avatar_no-body', icon: 'https://storyblok-cdn.yingfu.cn/f/293/96x96/98db6aa872/pts_avatar_no-body.png' }, { uuid: 'f3c0229a-d088-4250-b640-500dec550179', type: 'point', name: 'pts_avatar_tom', icon: 'https://storyblok-cdn.yingfu.cn/f/293/96x96/4fcbc6231d/pts_avatar_tom.png' }, { uuid: '8e52d5f6-3f16-4330-ae5a-2a0c6fbd3152', type: 'point', name: 'pts_thumbup_original', icon: 'https://storyblok-cdn.yingfu.cn/f/293/96x96/a9a419cc36/pts_thumbup_original.png' }, { uuid: '2a3fcbe1-2819-4a51-9787-cd79f55fd350', type: 'point', name: 'pts_strawberry_original', icon: 'https://storyblok-cdn.yingfu.cn/f/293/96x96/5f77a48379/pts_strawberry_original.png' }, { uuid: '5ef34e2d-faa4-44d3-bcd2-ac53a98a3cf8', type: 'point', name: 'pts_icecream_original', icon: 'https://storyblok-cdn.yingfu.cn/f/293/96x96/07beba22c9/pts_icecream_original.png' }, { uuid: '55780bd6-86fd-4707-93e1-c390dae07a34', type: 'point', name: 'pts_teddybear_original', icon: 'https://storyblok-cdn.yingfu.cn/f/293/96x96/52812b3ae4/pts_teddybear_original.png' }, { uuid: '7b5fd635-6a7b-4fa6-a8f0-e1828353b9b8', type: 'point', name: 'pts_pineapple_original', icon: 'https://storyblok-cdn.yingfu.cn/f/293/96x96/3260009b01/pts_pineapple_original.png' }];

var findBadgeByUUID = exports.findBadgeByUUID = function findBadgeByUUID(uuid) {
  return Badges.find(function (badge) {
    return badge.uuid === uuid;
  });
};

var findPointByUUID = exports.findPointByUUID = function findPointByUUID(uuid) {
  return Points.find(function (point) {
    return point.uuid === uuid;
  });
};

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(693);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1603);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1600);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._26tpvKI93fub-FSZi7np2U{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._26tpvKI93fub-FSZi7np2U h1{-webkit-box-flex:0;-webkit-flex:0 0 auto;-moz-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;margin-right:.28571rem}.CN056-UealNtiAw5Lp52t{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;margin-left:auto}._2LCvAgtN2OmAyKrfLsYffC{margin-left:.85714rem;padding:.42857rem 1.14286rem;border:.07143rem solid #ccc;-webkit-border-radius:.28571rem;-moz-border-radius:.28571rem;border-radius:.28571rem;background:#fff;cursor:pointer;font-size:1rem;color:#333}._2LCvAgtN2OmAyKrfLsYffC:hover{background:#f5f5f5}._1iWTlYq83gt1gZgIDoACTQ{position:relative;cursor:pointer;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}._1iWTlYq83gt1gZgIDoACTQ:hover ._2mKqQtjPanOfdPRpnYfrpu{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._2mKqQtjPanOfdPRpnYfrpu{display:none;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:start;-webkit-align-items:flex-start;-moz-box-align:start;-ms-flex-align:start;align-items:flex-start;padding:1.14286rem;gap:1.71429rem;position:absolute;width:39.28571rem;top:-webkit-calc(100% + .57143rem);top:-moz-calc(100% + .57143rem);top:calc(100% + .57143rem);left:0;background:#fff;-webkit-box-shadow:0 .07143rem .14286rem rgba(0,0,0,.08),0 .14286rem .57143rem .07143rem rgba(0,0,0,.16);-moz-box-shadow:0 .07143rem .14286rem rgba(0,0,0,.08),0 .14286rem .57143rem .07143rem rgba(0,0,0,.16);box-shadow:0 .07143rem .14286rem rgba(0,0,0,.08),0 .14286rem .57143rem .07143rem rgba(0,0,0,.16);-webkit-border-radius:.28571rem;-moz-border-radius:.28571rem;border-radius:.28571rem;z-index:10}._3h5ox4Eemhk8fHhFewX-7i{font-size:1.14286rem;font-weight:700;margin:0;color:#333}._1KqcelpMjG8a4o3MkHkAvl strong{display:block;font-size:1rem;font-weight:700;color:#333;margin-bottom:.28571rem}._1KqcelpMjG8a4o3MkHkAvl p{font-size:1rem;font-weight:400;color:#333;margin:0;line-height:1.5}.GtmauLY2yyMvNp8o3veaZ{padding:0}.hgkbM4L3I6_LNgxoLn4Sr{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;width:100%}.EHQMggdqn0FRnaEIT5fQh{-webkit-box-flex:0;-webkit-flex:0 0 auto;-moz-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;border-right:.35714rem solid #0087e6;z-index:2;background:#fff}._3udOR3juIjPsfNq299K3lI{-webkit-box-flex:1;-webkit-flex:1 1 0%;-moz-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;overflow-x:auto}._3DKBn4gdY7Gkp-RjxH5QlI{border-collapse:separate;border-spacing:0;font-size:1rem}._3DKBn4gdY7Gkp-RjxH5QlI td,._3DKBn4gdY7Gkp-RjxH5QlI th{padding:.28571rem .85714rem;text-align:center;border-bottom:.07143rem solid #e8e8e8;border-right:.07143rem solid #e8e8e8;white-space:nowrap;height:3.92857rem;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}._3DKBn4gdY7Gkp-RjxH5QlI td:last-child,._3DKBn4gdY7Gkp-RjxH5QlI th:last-child{border-right:none}._3DKBn4gdY7Gkp-RjxH5QlI th{font-weight:600;color:#666;background:#fafafa}._3DKBn4gdY7Gkp-RjxH5QlI td{color:#333}._3DKBn4gdY7Gkp-RjxH5QlI th._20ALPSSzp0Qgc5M3oZeqLb{background-color:#0087e6;color:#fff}._3DKBn4gdY7Gkp-RjxH5QlI th._20ALPSSzp0Qgc5M3oZeqLb ._17CzWVWFKaXjkGU1RmFMRG{color:hsla(0,0%,100%,.8)}._3DKBn4gdY7Gkp-RjxH5QlI th.FrEE0iILu1Pgc35Cg8KR-{background-color:#0087e6;color:#fff}._3DKBn4gdY7Gkp-RjxH5QlI td._3sAnqM4OgFZ_YH-z4FuOX0{background-color:#e8ebef;border-color:#d0d0d0}._1BIc2DWMQtn9j6W8SxbmVQ{width:14.28571rem;min-width:14.28571rem;text-align:left}.jZ0Et5LnSmWaoDiUvhcVa{width:7.14286rem;min-width:7.14286rem}._3ZUwyTziEWOs3-Nk-wdYQ2{text-align:center;font-weight:600;color:#333;border-bottom:.07143rem solid #e8e8e8}._3ZUwyTziEWOs3-Nk-wdYQ2,.ZMjCZ2u4OViUDD52X4yGR{border-left:.07143rem solid #e8e8e8}._17CzWVWFKaXjkGU1RmFMRG{display:block;font-size:.85714rem;font-weight:400;color:#999;margin-top:.14286rem}._2IZ181HPwy0WNVrsfpFIj5{font-size:1rem;font-weight:600;color:#333;height:3.21429rem}._3crBBZN_twzxbWSsXr0SaL{color:#4caf50;font-size:1.14286rem}._3jDYsletS8ofPIVyGDNXW2{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;max-height:3.92857rem;overflow:hidden}._3jDYsletS8ofPIVyGDNXW2 :hover{-webkit-transform:none!important;-moz-transform:none!important;-ms-transform:none!important;-o-transform:none!important;transform:none!important}.qahyXeDXrRbLeA5S4hZ-T{text-align:center;padding:2.85714rem;color:#999;font-size:1rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"DigitalPracticeRAv2_heading": "_26tpvKI93fub-FSZi7np2U",
	"DigitalPracticeRAv2_headingActions": "CN056-UealNtiAw5Lp52t",
	"DigitalPracticeRAv2_exportBtn": "_2LCvAgtN2OmAyKrfLsYffC",
	"DigitalPracticeRAv2_infoIcon": "_1iWTlYq83gt1gZgIDoACTQ",
	"DigitalPracticeRAv2_tooltip": "_2mKqQtjPanOfdPRpnYfrpu",
	"DigitalPracticeRAv2_tooltip_title": "_3h5ox4Eemhk8fHhFewX-7i",
	"DigitalPracticeRAv2_tooltip_item": "_1KqcelpMjG8a4o3MkHkAvl",
	"DigitalPracticeRAv2_content": "GtmauLY2yyMvNp8o3veaZ",
	"DigitalPracticeRAv2_tableLayout": "hgkbM4L3I6_LNgxoLn4Sr",
	"DigitalPracticeRAv2_panel": "EHQMggdqn0FRnaEIT5fQh",
	"DigitalPracticeRAv2_tableContainer": "_3udOR3juIjPsfNq299K3lI",
	"DigitalPracticeRAv2_table": "_3DKBn4gdY7Gkp-RjxH5QlI",
	"DigitalPracticeRAv2_unitHeaderActive": "_20ALPSSzp0Qgc5M3oZeqLb",
	"DigitalPracticeRAv2_unitHeaderDate": "_17CzWVWFKaXjkGU1RmFMRG",
	"DigitalPracticeRAv2_subHeaderActive": "FrEE0iILu1Pgc35Cg8KR-",
	"DigitalPracticeRAv2_cellActive": "_3sAnqM4OgFZ_YH-z4FuOX0",
	"DigitalPracticeRAv2_studentCol": "_1BIc2DWMQtn9j6W8SxbmVQ",
	"DigitalPracticeRAv2_statusCol": "jZ0Et5LnSmWaoDiUvhcVa",
	"DigitalPracticeRAv2_unitHeader": "_3ZUwyTziEWOs3-Nk-wdYQ2",
	"DigitalPracticeRAv2_unitFirstCol": "ZMjCZ2u4OViUDD52X4yGR",
	"DigitalPracticeRAv2_subHeader": "_2IZ181HPwy0WNVrsfpFIj5",
	"DigitalPracticeRAv2_checkmark": "_3crBBZN_twzxbWSsXr0SaL",
	"DigitalPracticeRAv2_studentCard": "_3jDYsletS8ofPIVyGDNXW2",
	"DigitalPracticeRAv2_empty": "qahyXeDXrRbLeA5S4hZ-T"
};

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRAv2HomeworkResultDetailByGroup = getRAv2HomeworkResultDetailByGroup;
exports.isLoadingRAv2HomeworkResultDetail = isLoadingRAv2HomeworkResultDetail;
exports.getUnitCount = getUnitCount;

var _immutable = __webpack_require__(3);

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var method = 'GET';
var buildRAv2HomeworkResultDetailUrl = function buildRAv2HomeworkResultDetailUrl(groupId) {
  return (0, _Api.buildUrl)('/ra-v2-groups/' + groupId + '/homework-result-detail');
};

function getRAv2HomeworkResultDetailByGroup(state, groupId) {
  var detailSlice = state.get('rootReducer').get('rav2HomeworkResultDetail');

  if (!detailSlice) {
    return new _immutable.List();
  }

  return detailSlice.get(groupId) || new _immutable.List();
}

function isLoadingRAv2HomeworkResultDetail(state, groupId) {
  var callState = _omniCommonUi.ApiCall.find(state, {
    method: method,
    url: buildRAv2HomeworkResultDetailUrl(groupId)
  });

  return _omniCommonUi.ApiCall.State.isValue(callState) && _omniCommonUi.ApiCall.State.isLoading(callState);
}

function getUnitCount(state, groupId) {
  var details = getRAv2HomeworkResultDetailByGroup(state, groupId);
  if (!details || details.size === 0) {
    return 0;
  }

  var maxUnits = 0;
  details.forEach(function (student) {
    var unitCount = student.unitResults ? student.unitResults.size : 0;
    if (unitCount > maxUnits) {
      maxUnits = unitCount;
    }
  });

  return maxUnits;
}

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rav2HomeworkResultDetail;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(695);

var _model = __webpack_require__(696);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function rav2HomeworkResultDetail() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_RAV2_HOMEWORK_RESULT_DETAIL_SUCCESS:
      return state.set(action.groupId, toGroupDetailList(action.payload));
    default:
      return state;
  }
}

function toGroupDetailList(payload) {
  var list = normalizePayload(payload);

  return new _immutable.List(list.filter(function (item) {
    return item && item.studentGeneralInfo && item.studentGeneralInfo.id;
  }).map(function (item) {
    return _model2.default.create({
      studentId: item.studentGeneralInfo.id,
      studentGeneralInfo: item.studentGeneralInfo,
      unitResults: item.unitResults || [],
      status: item.status,
      isInProduction: item.isInProduction
    });
  }));
}

function normalizePayload(payload) {
  if (!payload) {
    return [];
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload.data)) {
    return payload.data;
  }

  if (Array.isArray(payload.items)) {
    return payload.items;
  }

  return [];
}

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(693);

var _component2 = _interopRequireDefault(_component);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _omniCommonUi = __webpack_require__(0);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: 'digital-practice-ra-v2',
    component: _component2.default,
    canAccess: function canAccess(_ref2) {
      var params = _ref2.params;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.Homework.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.DigitalPracticeRAv2);
    },
    tab: {
      label: 'Digital Practice',
      order: 3,
      isVisible: function isVisible(params) {
        if (!_omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.Homework.View)) {
          return false;
        }
        if (!_TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.DigitalPracticeRAv2)) {
          return false;
        }
        return true;
      }
    },
    breadcrumbLabels: function breadcrumbLabels() {
      return [{
        label: 'Digital Practice',
        clickable: false
      }];
    }
  };
};

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(698);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1613);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1606);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".u8qqiI-Pz5YIstNV2MeEW{padding:1.42857rem}._1waRrOPxb84j7GEVlYLKGe{overflow:hidden;padding:0}._1waRrOPxb84j7GEVlYLKGe [class*=TableWithExpandablePanel_tableContainer___] [class*=SimpleTable_row___] [class*=SimpleTable_cell___]{min-width:10rem}._1waRrOPxb84j7GEVlYLKGe [class*=TableWithExpandablePanel_tableContainer___] thead [class*=SimpleTable_cell___]{white-space:nowrap}._1waRrOPxb84j7GEVlYLKGe [class*=TableWithExpandablePanel_tableContainer___] [class*=SimpleTable_cell___]:not(:last-child){-webkit-box-shadow:inset -.07143rem 0 0 #e7e7e7;-moz-box-shadow:inset -.07143rem 0 0 #e7e7e7;box-shadow:inset -.07143rem 0 0 #e7e7e7}._14UcekHb-9CtrAOMxlx_eV{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;gap:.57143rem;margin-bottom:1.42857rem}._1TJRcxmR94g2B5WyZDuzH1{padding:.42857rem 1.14286rem;border:.07143rem solid #d9d9d9;-webkit-border-radius:.28571rem;-moz-border-radius:.28571rem;border-radius:.28571rem;background:#fff;cursor:pointer;font-size:1rem;color:#333;white-space:nowrap}._1TJRcxmR94g2B5WyZDuzH1:hover{background:#f5f5f5}._1t6rmoQT2ke6kDAg6fXeII{border-color:#0a75ba;background:#0a75ba;color:#fff}._1t6rmoQT2ke6kDAg6fXeII:hover{background:#0a75ba}._22xSdZMLIX_iNg_kNVTT6A{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex}._1CF1_fyU4dU8yqMBUQvXBB{max-width:25.71429rem}._3z7VrOmE647HQQeTt4j00L{display:block;width:100%}._3cf5ODnzsMsqaZh0yxDfJE{color:#bbb}._1B_23jfHshvETTHy3cAKPq{display:inline-block;vertical-align:middle;width:1.28571rem;height:1.28571rem}._1Q0Nm3ry2kWMusMKQLu-GI{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;gap:.57143rem}._1Q0Nm3ry2kWMusMKQLu-GI,._2FP3isRTJBQjXdBR3pvxmt{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}._2FP3isRTJBQjXdBR3pvxmt{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%;position:relative}._2FP3isRTJBQjXdBR3pvxmt ._1B_23jfHshvETTHy3cAKPq{position:absolute;right:0}._2FP3isRTJBQjXdBR3pvxmt ._1Q0Nm3ry2kWMusMKQLu-GI{position:absolute;right:0;top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);-o-transform:translateY(-50%);transform:translateY(-50%)}._2FP3isRTJBQjXdBR3pvxmt ._1Q0Nm3ry2kWMusMKQLu-GI ._1B_23jfHshvETTHy3cAKPq{position:static}._10O7lAmIp9RlkZtH-xZAfK{color:#333}.tnsqdJqxw79zHQm0LyzI0{color:#bbb}._5Qx1VF0TS87rwthm1-pDK{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;gap:.28571rem}._1XoAthKQQbJeKBxIlI1Q_p,._5Qx1VF0TS87rwthm1-pDK{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}._1XoAthKQQbJeKBxIlI1Q_p{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;width:100%}._1XoAthKQQbJeKBxIlI1Q_p ._1B_23jfHshvETTHy3cAKPq{position:absolute;right:0}._1XoAthKQQbJeKBxIlI1Q_p ._1Q0Nm3ry2kWMusMKQLu-GI{position:absolute;right:0;top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);-o-transform:translateY(-50%);transform:translateY(-50%)}._1XoAthKQQbJeKBxIlI1Q_p ._1Q0Nm3ry2kWMusMKQLu-GI ._1B_23jfHshvETTHy3cAKPq{position:static}._3aJVt_3oJYG2Vyj_zFlao-{color:#333;font-weight:600}._1R39tcYCVr9D0rIsOFvUHo{padding:2.85714rem;text-align:center;color:#999}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"UnitResources": "u8qqiI-Pz5YIstNV2MeEW",
	"UnitResources_content": "_1waRrOPxb84j7GEVlYLKGe",
	"UnitResources_filters": "_14UcekHb-9CtrAOMxlx_eV",
	"UnitResources_filterBtn": "_1TJRcxmR94g2B5WyZDuzH1",
	"UnitResources_filterBtnActive": "_1t6rmoQT2ke6kDAg6fXeII",
	"UnitResources_filterTooltip": "_22xSdZMLIX_iNg_kNVTT6A",
	"UnitResources_filterTooltip_inner": "_1CF1_fyU4dU8yqMBUQvXBB",
	"UnitResources_challengeTooltip": "_3z7VrOmE647HQQeTt4j00L",
	"UnitResources_dash": "_3cf5ODnzsMsqaZh0yxDfJE",
	"UnitResources_icon": "_1B_23jfHshvETTHy3cAKPq",
	"UnitResources_lateCell": "_1Q0Nm3ry2kWMusMKQLu-GI",
	"UnitResources_progressCell": "_2FP3isRTJBQjXdBR3pvxmt",
	"UnitResources_progress": "_10O7lAmIp9RlkZtH-xZAfK",
	"UnitResources_progressTotal": "tnsqdJqxw79zHQm0LyzI0",
	"UnitResources_challengeCell": "_5Qx1VF0TS87rwthm1-pDK",
	"UnitResources_challengeCellWithExtra": "_1XoAthKQQbJeKBxIlI1Q_p",
	"UnitResources_extra": "_3aJVt_3oJYG2Vyj_zFlao-",
	"UnitResources_empty": "_1R39tcYCVr9D0rIsOFvUHo"
};

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUnitResources = getUnitResources;
exports.isLoadingUnitResources = isLoadingUnitResources;

var _immutable = __webpack_require__(3);

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var _model = __webpack_require__(315);

var method = 'GET';
var buildUnitResourcesUrl = function buildUnitResourcesUrl(groupId, unitId) {
  return (0, _Api.buildUrl)('/groups/' + groupId + '/units/' + unitId + '/resources');
};

function getUnitResources(state, groupId, unitId) {
  var slice = state.get('rootReducer').get('unitResources');
  if (!slice) {
    return new _immutable.List();
  }
  return slice.get((0, _model.buildUnitResourcesKey)(groupId, unitId)) || new _immutable.List();
}

function isLoadingUnitResources(state, groupId, unitId) {
  var callState = _omniCommonUi.ApiCall.find(state, {
    method: method,
    url: buildUnitResourcesUrl(groupId, unitId)
  });

  return _omniCommonUi.ApiCall.State.isValue(callState) && _omniCommonUi.ApiCall.State.isLoading(callState);
}

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = unitResources;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(700);

var _model = __webpack_require__(315);

function unitResources() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_UNIT_RESOURCES_SUCCESS:
      return state.set((0, _model.buildUnitResourcesKey)(action.groupId, action.unitId), (0, _model.toStudentUnitResourcesList)(action.payload));
    default:
      return state;
  }
}

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMEM0LjQ3IDAgMCA0LjQ3IDAgMTBzNC40NyAxMCAxMCAxMCAxMC00LjQ3IDEwLTEwUzE1LjUzIDAgMTAgMHptMCAxOGMtNC40MiAwLTgtMy41OC04LThzMy41OC04IDgtOCA4IDMuNTggOCA4LTMuNTggOC04IDh6IiBmaWxsPSIjQzlDOUM5Ii8+PC9zdmc+"

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS41OSAxMC41OEwxLjQyIDYuNDEgMCA3LjgybDUuNTkgNS41OSAxMi0xMkwxNi4xOCAwIDUuNTkgMTAuNTh6IiBmaWxsPSIjMEE3NUJBIi8+PC9zdmc+"

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS41OSAxMC41OEwxLjQyIDYuNDEgMCA3LjgybDUuNTkgNS41OSAxMi0xMkwxNi4xOCAwIDUuNTkgMTAuNTh6IiBmaWxsPSIjRjJCNTI2Ii8+PC9zdmc+"

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS4wMzUgMTcuNjI3bC0uNTU2LjgzMi41NTYtLjgzMnpNMS42OSAxMy41NTNsLjkyNC0uMzgzLS45MjQuMzgzem0tLjUxNy01LjI0NWwtLjk4LS4xOTYuOTguMTk2ek0zLjY2IDMuNjU5bC43MDcuNzA3LS43MDctLjcwN3ptOS44OTQtMS45NjhsLjM4My0uOTI0LS4zODMuOTI0em0tMy40NzQgOC4zODhsLjcwNy43MDcuMjkzLS4yOTN2LS40MTRoLTF6bTUuOTkzIDguOTY1YTEgMSAwIDAgMC0yIDBoMnptLTIgLjAzMWExIDEgMCAxIDAgMiAwaC0yem0tMy45OTMuMDgydi0xYTguMDc5IDguMDc5IDAgMCAxLTQuNDg5LTEuMzYxbC0uNTU1LjgzMS0uNTU2LjgzMmExMC4wNzggMTAuMDc4IDAgMCAwIDUuNiAxLjY5OHYtMXptLTUuMDQ0LTEuNTNsLjU1NS0uODMxYTguMDc5IDguMDc5IDAgMCAxLTIuOTc1LTMuNjI2bC0uOTI0LjM4My0uOTI0LjM4M2ExMC4wNzggMTAuMDc4IDAgMCAwIDMuNzEyIDQuNTIzbC41NTYtLjgzMnpNMS42OSAxMy41NTNsLjkyNC0uMzgzYTguMDc5IDguMDc5IDAgMCAxLS40Ni00LjY2N2wtLjk4LS4xOTUtLjk4MS0uMTk2YTEwLjA3OSAxMC4wNzkgMCAwIDAgLjU3MyA1LjgyNGwuOTI0LS4zODN6bS0uNTE3LTUuMjQ1bC45ODEuMTk1YTguMDc5IDguMDc5IDAgMCAxIDIuMjExLTQuMTM3TDMuNjYgMy42NmwtLjcwNy0uNzA3YTEwLjA3OSAxMC4wNzkgMCAwIDAtMi43NTggNS4xNmwuOTguMTk2ek0zLjY2IDMuNjU5bC43MDcuNzA3YTguMDc5IDguMDc5IDAgMCAxIDQuMTM3LTIuMjFsLS4xOTUtLjk4Mi0uMTk2LS45OGExMC4wNzkgMTAuMDc5IDAgMCAwLTUuMTYgMi43NThsLjcwNy43MDd6bTQuNjQ5LTIuNDg1bC4xOTUuOTgxYTguMDc5IDguMDc5IDAgMCAxIDQuNjY3LjQ2bC4zODMtLjkyNC4zODMtLjkyNEExMC4wNzkgMTAuMDc5IDAgMCAwIDguMTEyLjE5NGwuMTk2Ljk4em01LjI0NS41MTdsLS4zODMuOTI0YTguMDc5IDguMDc5IDAgMCAxIDMuNjI2IDIuOTc1bC44MzEtLjU1NS44MzItLjU1NkExMC4wNzggMTAuMDc4IDAgMCAwIDEzLjkzNi43NjdsLS4zODMuOTI0em00LjA3NCAzLjM0NGwtLjgzMS41NTVhOC4wNzkgOC4wNzkgMCAwIDEgMS4zNjEgNC40ODloMmMwLTEuOTk0LS41OS0zLjk0Mi0xLjY5OC01LjZsLS44MzIuNTU2ek0xMC4wOCAzLjcyNGgtMXY2LjM1NWgyVjMuNzI0aC0xem0wIDYuMzU1bC0uNzA3LS43MDctNC4wODYgNC4wODUuNzA3LjcwNy43MDcuNzA3IDQuMDg2LTQuMDg1LS43MDctLjcwN3ptNC45OTMuOTc0aC0xdjUuOTc2aDJ2LTUuOTc2aC0xem0wIDcuOTloLTF2LjAzMmgydi0uMDMxaC0xeiIgZmlsbD0iI0YyQjUyNiIvPjwvc3ZnPg=="

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _component = __webpack_require__(698);

var _component2 = _interopRequireDefault(_component);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _UnitResourcesNav = __webpack_require__(1614);

var _UnitResourcesNav2 = _interopRequireDefault(_UnitResourcesNav);

var _accessors = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFirstUnitId(getState, groupId) {
  var unitList = (0, _accessors.getUnitList)(getState(), groupId);
  var firstUnit = unitList && unitList.toList().first();
  return firstUnit && firstUnit.id;
}

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    appBars: {
      sticky: {
        navigation: {
          component: _UnitResourcesNav2.default,
          order: 1
        }
      }
    },
    path: 'unit-resources(/:unitId)',
    component: _component2.default,
    canAccess: function canAccess(_ref2) {
      var params = _ref2.params;
      return _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.UnitResources);
    },
    tab: {
      label: 'Resources',
      order: 11,
      isVisible: function isVisible(params) {
        return _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.UnitResources);
      },
      params: function params(currentParams) {
        return _extends({}, currentParams, {
          unitId: getFirstUnitId(getState, currentParams.groupId)
        });
      }
    },
    breadcrumbLabels: function breadcrumbLabels() {
      return [{
        label: 'Resources',
        clickable: false
      }];
    }
  };
};

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

exports.mapStateToProps = mapStateToProps;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _BaseSessionNav2 = __webpack_require__(108);

var _BaseSessionNav3 = _interopRequireDefault(_BaseSessionNav2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _accessors = __webpack_require__(41);

var _UiState = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitResourcesNav = function (_BaseSessionNav) {
  _inherits(UnitResourcesNav, _BaseSessionNav);

  function UnitResourcesNav() {
    _classCallCheck(this, UnitResourcesNav);

    return _possibleConstructorReturn(this, (UnitResourcesNav.__proto__ || Object.getPrototypeOf(UnitResourcesNav)).apply(this, arguments));
  }

  _createClass(UnitResourcesNav, [{
    key: '_hasNext',
    value: function _hasNext() {
      return _is_js2.default.existy(this.props.nextSessionLinkHref);
    }
  }, {
    key: '_hasPrevious',
    value: function _hasPrevious() {
      return _is_js2.default.existy(this.props.previousSessionLinkHref);
    }
  }, {
    key: '_getHeadingText',
    value: function _getHeadingText() {
      return this.props.currentGroupName;
    }
  }, {
    key: '_getAdditionalChildren',
    value: function _getAdditionalChildren() {
      return _react2.default.createElement(
        'h2',
        null,
        this.props.currentUnitName
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (_is_js2.default.existy(this.props.currentGroupName) && _is_js2.default.existy(this.props.currentUnitName)) {
        return _get(UnitResourcesNav.prototype.__proto__ || Object.getPrototypeOf(UnitResourcesNav.prototype), 'render', this).call(this);
      }
      return null;
    }
  }]);

  return UnitResourcesNav;
}(_BaseSessionNav3.default);

UnitResourcesNav.propTypes = Object.assign({
  currentGroupName: _propTypes2.default.string,
  currentUnitName: _propTypes2.default.string
}, _BaseSessionNav3.default.propTypes);

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      unitId = _ownProps$params.unitId;

  if (!_is_js2.default.existy(unitId)) return;
  var buildRoute = ownProps.buildRoute;

  var group = state.get('rootReducer').get('groups').get(groupId) && state.get('rootReducer').get('groups').get(groupId).data;
  var unitList = (0, _accessors.getUnitList)(state, groupId);
  if (!_is_js2.default.existy(group) || !_is_js2.default.existy(unitList)) return;

  var currentUnit = unitList.get('' + unitId);
  if (!_is_js2.default.existy(currentUnit)) return;

  var previousUnit = (0, _accessors.getPreviousUnit)(state, '' + unitId, groupId);
  var nextUnit = (0, _accessors.getNextUnit)(state, '' + unitId, groupId);

  return {
    currentGroupName: group.name,
    currentUnitName: currentUnit.name,
    previousSessionLinkHref: previousUnit && buildRoute({ unitId: previousUnit.id }),
    nextSessionLinkHref: nextUnit && buildRoute({ unitId: nextUnit.id }),
    isHide: !_UiState.actions.getShowNavigationBar(state)
  };
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null)(UnitResourcesNav);

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _routes2 = __webpack_require__(1616);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = routes;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(316);

var _component2 = _interopRequireDefault(_component);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _omniCommonUi = __webpack_require__(0);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: 'unit-review',
    component: _component2.default,
    canAccess: function canAccess(_ref2) {
      var params = _ref2.params;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.Homework.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.UnitReview);
    },
    tab: {
      label: 'Unit Review',
      order: 5,
      isVisible: function isVisible(params) {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.Homework.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.UnitReview);
      }
    },
    breadcrumbLabels: function breadcrumbLabels() {
      return [{
        label: 'Unit Review',
        clickable: false
      }];
    }
  };
};

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(703);

var _model2 = _interopRequireDefault(_model);

var _UnitQuizResult = __webpack_require__(1618);

var _UnitQuizResult2 = _interopRequireDefault(_UnitQuizResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'studentId':
      return [key, '' + val];
    case 'unitQuizResults':
      return [key, new _immutable.List(val.map(function (result) {
        return _UnitQuizResult2.default.create(result);
      }))];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(704);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1619);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(704);

var _model2 = _interopRequireDefault(_model);

var _UnitQuizSkillResult = __webpack_require__(1620);

var _UnitQuizSkillResult2 = _interopRequireDefault(_UnitQuizSkillResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'unitId':
      return [key, '' + val];
    case 'skillResults':
      return [key, new _immutable.List(val.map(function (skillResult) {
        return _UnitQuizSkillResult2.default.create(skillResult);
      }))];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(705);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1621);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(705);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  return [key, val];
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = unitQuizResultsReducer;

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(702);

var _model2 = _interopRequireDefault(_model);

var _actions = __webpack_require__(706);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function unitQuizResultsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_UNIT_QUIZ_RESULTS_SUCCESS:
      return addUnitQuizResultsToMap(state, action);
    default:
      return state;
  }
}

function addUnitQuizResultsToMap(state, _ref) {
  var payload = _ref.payload,
      groupId = _ref.groupId;

  var newState = state;
  newState = newState.set(groupId, new _immutable.List(payload.map(function (result) {
    return _model2.default.create(result);
  })));
  return newState;
}

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(707);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(709);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2832vTEWp3oC_ZCTUemch{padding:1.42857rem}@media only screen and (min-width:640px){._2832vTEWp3oC_ZCTUemch{padding:2.14286rem}}._1qkwhI1326cL6Kri6eh4Q6{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Homework_wrapper": "_2832vTEWp3oC_ZCTUemch",
	"Homework_innerTable_sessionHeading": "_1qkwhI1326cL6Kri6eh4Q6"
};

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(710);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1628);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mentor;

var _actions = __webpack_require__(712);

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(713);

var _model2 = _interopRequireDefault(_model);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mentor() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_MENTOR_REQUEST:
      return _omniCommonUi.ApiResponseHelper.create({ loading: true });
    case _actions.FETCH_MENTOR_SUCCESS:
      return onSuccess(state, action);
    case _actions.FETCH_MENTOR_FAILURE:
      return _omniCommonUi.ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}

function onSuccess(state, action) {
  var newState = new _immutable.Map();
  action.payload.forEach(function (unit) {
    unit.studentMentorResults.forEach(function (mentorResult) {
      var mentorModel = _model2.default.create(Object.assign(mentorResult, { unitId: unit.unitId, groupId: action.groupId }));
      newState = newState.set(action.groupId + '-' + unit.unitId + '-' + mentorResult.studentId, mentorModel);
    });
  });
  return _omniCommonUi.ApiResponseHelper.create({ data: newState });
}

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MentorRecord = (0, _immutable.Record)({
  groupId: undefined,
  studentId: undefined,
  unitId: undefined,
  wordsMastered: undefined,
  wordsStudying: undefined,
  wordsAssigned: undefined
});

var Mentor = function (_MentorRecord) {
  _inherits(Mentor, _MentorRecord);

  function Mentor() {
    _classCallCheck(this, Mentor);

    return _possibleConstructorReturn(this, (Mentor.__proto__ || Object.getPrototypeOf(Mentor)).apply(this, arguments));
  }

  return Mentor;
}(MentorRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'groupId':
    case 'studentId':
    case 'unitId':
      return [key, '' + val]; // stringify
    default:
      return [key, val];
  }
};

Mentor.create = function (data) {
  return new Mentor(data).mapEntries(reviver);
};

exports.default = Mentor;

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(710);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'mentor',
  component: _component2.default
};

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(714);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1640);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1631);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3yVhEfGl5YtEA0Nc8PCJ5u{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:600;letter-spacing:.03571rem;line-height:1.28571;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;color:inherit;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;font-size:.85714rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;outline:0;text-decoration:none;text-transform:uppercase}._8cG9dDExba2IpFC2x8u1B{margin-left:.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"LessonHomeworkViewerLink": "_3yVhEfGl5YtEA0Nc8PCJ5u",
	"LessonHomeworkViewerLink_icon": "_8cG9dDExba2IpFC2x8u1B"
};

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = totalPoints;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(716);

var _model = __webpack_require__(717);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function totalPoints() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_STUDENT_TOTAL_POINTS_SUCCESS:
      return state.set(action.groupId, new _immutable.List(action.payload.map(function (item) {
        return _model2.default.create(item);
      })));
    default:
      return state;
  }
}

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(717);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'studentId':
    case 'totalPoint':
      return [key, '' + val];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = onlineHomeworkHFUsageReducer;

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(1635);

var _model2 = _interopRequireDefault(_model);

var _actions = __webpack_require__(719);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function onlineHomeworkHFUsageReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_ONLINE_HOMEWORK_HF_USAGE_SUCCESS:
      return state.set('' + action.groupId, onSuccess(action.payload));
    default:
      return state;
  }
}

function onSuccess() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return payload.reduce(function (map, student) {
    return map.set('' + student.studentId, _model2.default.create(student));
  }, new _immutable.Map());
}

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(720);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1636);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HFUsage = _model2.default;
HFUsage.create = _create2.default;

exports.default = HFUsage;

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(720);

var _model2 = _interopRequireDefault(_model);

var _onlineUsage = __webpack_require__(1637);

var _onlineUsage2 = _interopRequireDefault(_onlineUsage);

var _immutable = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  switch (key) {
    case 'studentId':
    case 'gainedDiamonds':
    case 'totalDiamonds':
      return [key, '' + val];
    case 'onlineUsages':
      {
        if (val && val.map) {
          return [key, val.map(function (item) {
            return _onlineUsage2.default.create(item);
          })];
        }
        return [key, new _immutable.List()];
      }
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(721);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1638);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsageItem = _model2.default;
UsageItem.create = _create2.default;

exports.default = UsageItem;

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(721);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  switch (key) {
    case 'allCoreActivities':
    case 'completedCoreActivities':
      return [key, '' + val];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Games = exports.EXTRA_COLUMNS = undefined;
exports.renderHFUsageHeader = renderHFUsageHeader;
exports.renderHFUsageSubHeader = renderHFUsageSubHeader;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(3);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var EXTRA_COLUMNS = exports.EXTRA_COLUMNS = {
  GAME_COMPLETED: 'game-completed',
  GAME_COMPLETED_DATE: 'game-completed-date',
  DIAMONDS: 'diamonds',
  ACTIVITIES_COMPLETED: 'ACTIVITIES_COMPLETED',
  LAST_ACTIVITIES_DATE: 'LAST_ACTIVITIES_DATE'
};

var Games = exports.Games = new _immutable.List([{
  index: 1
}, {
  index: 2
}, {
  index: 3
}]);

function renderHFUsageHeader() {
  var cellItems = [_react2.default.createElement(
    _CourseViewTable2.default.Cell,
    { rowSpan: 2, colSpan: 2, small: true },
    'Activities'
  ), _react2.default.createElement(
    _CourseViewTable2.default.Cell,
    { rowSpan: 3, colSpan: 1 },
    'Diamonds'
  )];
  cellItems.push(Games.map(function (game) {
    return _react2.default.createElement(
      _CourseViewTable2.default.Cell,
      { rowSpan: 2, colSpan: 2 },
      'Game' + game.index
    );
  }));
  return cellItems;
}

function renderHFUsageSubHeader() {
  var cellItems = [_react2.default.createElement(
    _CourseViewTable2.default.Cell,
    { colSpan: 1,
      columnId: {
        column: EXTRA_COLUMNS.ACTIVITIES_COMPLETED,
        usageIndex: 0
      } },
    'Activities Completed'
  ), _react2.default.createElement(
    _CourseViewTable2.default.Cell,
    { colSpan: 1,
      columnId: {
        column: EXTRA_COLUMNS.LAST_ACTIVITIES_DATE,
        usageIndex: 0
      } },
    'Last Activity Date'
  ), _react2.default.createElement(_CourseViewTable2.default.Cell, { style: { display: 'none' },
    columnId: { column: EXTRA_COLUMNS.DIAMONDS } })];
  cellItems.push(Games.reduce(function (list, game) {
    return [].concat(_toConsumableArray(list), [_react2.default.createElement(
      _CourseViewTable2.default.Cell,
      { columnId: {
          usageIndex: game.index,
          column: EXTRA_COLUMNS.GAME_COMPLETED
        } },
      'Level Completed'
    ), _react2.default.createElement(
      _CourseViewTable2.default.Cell,
      { columnId: {
          usageIndex: game.index,
          column: EXTRA_COLUMNS.GAME_COMPLETED_DATE
        } },
      'Completed on'
    )]);
  }, []));
  return cellItems;
}

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _accessors = __webpack_require__(36);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _component = __webpack_require__(714);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: '(small-stars-app)(online)(trailblazers-app)',
    component: _component2.default,
    actionButtons: {
      default: {
        'View Content': {
          route: function route(_ref2) {
            var params = _ref2.params;
            var groupId = params.groupId;

            var sessionId = (0, _accessors.getDefaultSession)(getState(), groupId).id;
            var unitId = (0, _accessors.getFirstUnitOfSession)(getState(), sessionId);
            return '/group/' + groupId + '/assign-homework/session/' + sessionId + '/unit/' + unitId;
          },
          visibleWhen: function visibleWhen(_ref3) {
            var groupId = _ref3.params.groupId;
            return _TabSwitcher2.default.isTabEnabled(getState(), groupId, _TabSwitcher.TabCodes.AssignHomework);
          }
        }
      }
    }
  };
};

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(722);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1645);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _component2.default;
var routes = exports.routes = _routes3.default;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = practicePlay;

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(1643);

var _model2 = _interopRequireDefault(_model);

var _actions = __webpack_require__(724);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function practicePlay() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_PRACTICE_PLAY_SUCCESS:
      return state.set(action.groupId, new _immutable.List(action.payload.map(function (item) {
        return _model2.default.create(item);
      })));
    default:
      return state;
  }
}

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(725);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1644);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(725);

var _model2 = _interopRequireDefault(_model);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'studentId':
      return [key, '' + val];
    case 'lastActivitiesCompletedDate':
      return [key, _omniCommonUi.moment.utc(val)];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(722);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return {
    path: 'practice-play',
    component: _component2.default
  };
};

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(726);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1653);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1648);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2acf79DzX8mWN2OjVq5LZk{color:#0087e6;-webkit-text-decoration-line:none;-moz-text-decoration-line:none;text-decoration-line:none;white-space:nowrap}.MZXp5gdcDzikofnjM1JYo{text-align:left}._24EqeH6lIdbIP4iURyRSdr{padding-bottom:.71429rem}._1appiifmPAK3hyXxocPWPA{margin-left:.71429rem}._9Sa-38J86djX7OuuXcqR7{margin:0;padding-left:0;padding-top:.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"OnlineUsage_spinLink": "_2acf79DzX8mWN2OjVq5LZk",
	"OnlineUsage_popup": "MZXp5gdcDzikofnjM1JYo",
	"OnlineUsage_popup_name": "_24EqeH6lIdbIP4iURyRSdr",
	"OnlineUsage_popup_name_label": "_1appiifmPAK3hyXxocPWPA",
	"OnlineUsage_popup_ul": "_9Sa-38J86djX7OuuXcqR7"
};

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = onlineUsagesReducer;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(728);

var _model = __webpack_require__(317);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function onlineUsagesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_ONLINE_USAGE_SUCCESS:
      return state.set(action.groupId, getOnlineUsage(state, action));
    default:
      return state;
  }
}

function getOnlineUsage(state, action) {
  var OnlineUsages = new _immutable.Map({});
  action.payload.forEach(function (onlineUsages) {
    OnlineUsages = OnlineUsages.set('' + onlineUsages.studentId, _model2.default.create(onlineUsages));
  });
  return OnlineUsages;
}

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _UnitOnlineUsage = __webpack_require__(1651);

var _UnitOnlineUsage2 = _interopRequireDefault(_UnitOnlineUsage);

var _model = __webpack_require__(317);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'studentId':
      return [key, '' + val]; // stringify
    case 'unitOnlineUsages':
      return [key, new _immutable.Map(val.map(function (data) {
        var unitOnlineUsage = _UnitOnlineUsage2.default.create(data);
        return [unitOnlineUsage.unitNo, unitOnlineUsage];
      }))];
    case 'selectedCourse':
      return [key, new _immutable.List(val)];
    default:
      return [key, val];
  }
};
var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(729);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1652);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnitOnlineUsage = _model2.default;

UnitOnlineUsage.create = _create2.default;

exports.default = UnitOnlineUsage;

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(729);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'unitNo':
      return [key, '' + val]; // stringify
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(726);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'online-usage(/:mode/:studentId)',
  component: _component2.default
};

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(316);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1655);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(316);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return {
    path: 'unit-quiz',
    component: _component2.default
  };
};

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(730);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1664);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1658);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1xqLZErvEz3WnNz0iDRzN8{height:12.78571rem;width:2.5rem}._290rdsNUtByDJfCb2z7Lt6>*>.rc-tooltip-arrow{display:none}._1xqLZErvEz3WnNz0iDRzN8:hover{border:.07143rem solid #ff0}@media only screen and (min-width:640px){._1xqLZErvEz3WnNz0iDRzN8{width:7.85714rem}}._1ehcc3_PqUT2XTq_19d0AP{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}._3gbZ7oKvQirH_TOpl32lTf{white-space:nowrap}._228PgE2y77AjE9UIO335to{color:#74d17f;height:100%}._228PgE2y77AjE9UIO335to svg{height:1.42857rem;width:1.42857rem}._3L9cgPBLWncwER_6juzzCI{padding:0;width:2.5rem}@media only screen and (min-width:640px){._3L9cgPBLWncwER_6juzzCI{width:7.85714rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Reader_cell": "_1xqLZErvEz3WnNz0iDRzN8",
	"Reader_cell_tooltip": "_290rdsNUtByDJfCb2z7Lt6",
	"Reader_cell_border": "_1ehcc3_PqUT2XTq_19d0AP",
	"Reader_sessionNumberAndDate": "_3gbZ7oKvQirH_TOpl32lTf",
	"Reader_successIcon": "_228PgE2y77AjE9UIO335to",
	"Reader_progressBarTd": "_3L9cgPBLWncwER_6juzzCI"
};

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1660);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignedReader = _model2.default;

exports.default = AssignedReader;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReaderResultRecord = (0, _immutable.Record)({
  studentId: undefined,
  completion: undefined
});

var ReaderResult = function (_ReaderResultRecord) {
  _inherits(ReaderResult, _ReaderResultRecord);

  function ReaderResult() {
    _classCallCheck(this, ReaderResult);

    return _possibleConstructorReturn(this, (ReaderResult.__proto__ || Object.getPrototypeOf(ReaderResult)).apply(this, arguments));
  }

  return ReaderResult;
}(ReaderResultRecord);

var ReaderResultReviver = function ReaderResultReviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      item = _ref2[1];

  if (!item) return [key, item];
  switch (key) {
    case 'completion':
      return [key, Number.parseInt(item, 10)];
    case 'studentId':
      return [key, '' + item];
    default:
      [key, item];
  }
};

ReaderResult.create = function (data) {
  return new ReaderResult(data).mapEntries(ReaderResultReviver);
};

var AssignedReaderRecord = (0, _immutable.Record)({
  sessionId: undefined,
  unitId: undefined,
  lessonNumber: undefined,
  unitOrderingSequence: undefined,
  studentAssignedReaderResults: new _immutable.List()
});

var AssignedReader = function (_AssignedReaderRecord) {
  _inherits(AssignedReader, _AssignedReaderRecord);

  function AssignedReader() {
    _classCallCheck(this, AssignedReader);

    return _possibleConstructorReturn(this, (AssignedReader.__proto__ || Object.getPrototypeOf(AssignedReader)).apply(this, arguments));
  }

  return AssignedReader;
}(AssignedReaderRecord);

var reviver = function reviver(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      item = _ref4[1];

  if (!item) return [key, item];
  switch (key) {
    case 'lessonNumber':
      return [key, Number.parseInt(item, 10)];
    case 'sessionId':
    case 'unitId':
      return [key, '' + item];
    case 'studentAssignedReaderResults':
      return [key, new _immutable.List(item.map(function (readerResult) {
        return ReaderResult.create(readerResult);
      }))];
    default:
      [key, item];
  }
};

AssignedReader.create = function (data) {
  return new AssignedReader(data).mapEntries(reviver);
};

exports.default = AssignedReader;

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1662);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnassignedReader = _model2.default;

exports.default = UnassignedReader;

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnassignedReaderRecord = (0, _immutable.Record)({
  studentId: undefined,
  currentLevel: undefined,
  completedInCurrentLevel: undefined,
  totalInCurrentLevel: undefined,
  completedInTotal: undefined
});

var UnassignedReader = function (_UnassignedReaderReco) {
  _inherits(UnassignedReader, _UnassignedReaderReco);

  function UnassignedReader() {
    _classCallCheck(this, UnassignedReader);

    return _possibleConstructorReturn(this, (UnassignedReader.__proto__ || Object.getPrototypeOf(UnassignedReader)).apply(this, arguments));
  }

  return UnassignedReader;
}(UnassignedReaderRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      item = _ref2[1];

  if (!item) return [key, item];
  switch (key) {
    case 'currentLevel':
    case 'completedInTotal':
    case 'completedInCurrentLevel':
    case 'totalInCurrentLevel':
      return [key, Number.parseInt(item, 10)];
    case 'studentId':
      return [key, '' + item];
    default:
      [key, item];
  }
};

UnassignedReader.create = function (data) {
  return new UnassignedReader(data).mapEntries(reviver);
};

exports.default = UnassignedReader;

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = readerReducer;

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _actions = __webpack_require__(733);

var _model = __webpack_require__(732);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function readerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_READER_RESULTS_REQUEST:
      return _omniCommonUi.ApiResponseHelper.create({ loading: true });
    case _actions.FETCH_READER_RESULTS_SUCCESS:
      return _omniCommonUi.ApiResponseHelper.create(_model2.default.create(action.payload));
    case _actions.FETCH_READER_RESULTS_FAILURE:
      return _omniCommonUi.ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(730);

var _component2 = _interopRequireDefault(_component);

var _accessors = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: 'reading',
    component: _component2.default,
    actionButtons: {
      default: {
        'View Content': {
          route: function route(_ref2) {
            var params = _ref2.params;
            var groupId = params.groupId;

            var sessionId = (0, _accessors.getDefaultSession)(getState(), groupId).id;
            var unitId = (0, _accessors.getFirstUnitOfSession)(getState(), sessionId);
            return '/group/' + groupId + '/assign-homework/session/' + sessionId + '/unit/' + unitId;
          }
        }
      }
    }
  };
};

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(734);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1671);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1667);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".BEcnDXYGep62uVIOW71XK{border-bottom:0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:.71429rem 1.42857rem}._2lVqeZi0xUOHifKA3fOTqy{display:contents}._38_xi1yMXFBPH2zGDevXmw{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-left:.35714rem}._1XT6QI21F91vWGzswE11cG{overflow:hidden;padding:0}._3io09NQcaQ8g1uXjg9H4f5:hover{border:.07143rem solid #ff0}._1fbmAJfthP0CjsuHOWU7l9{margin-bottom:.57143rem}._2rF7vfZGt8LidniZAnZi5x{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._20CpSPMXMg_jz1hMl8GM-q>*>.rc-tooltip-arrow{display:none}.bxcZ0xnQACWJ4cmQHBq-7{margin-bottom:.57143rem}.bxcZ0xnQACWJ4cmQHBq-7:hover{background-color:#ff0}._3oKcDoHSoPsU71HOXO_4hr{color:#74d17f}._3oKcDoHSoPsU71HOXO_4hr svg{height:1.21429rem;width:1.21429rem}._2J3FBN630z3zMo572hCeDC{padding:0}._2J3FBN630z3zMo572hCeDC:hover{border:.07143rem solid #ff0}@media only screen and (min-width:640px){._2rF7vfZGt8LidniZAnZi5x{width:7.85714rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Vocabulary_cardHeader": "BEcnDXYGep62uVIOW71XK",
	"Vocabulary_cardHeader_title": "_2lVqeZi0xUOHifKA3fOTqy",
	"Vocabulary_cardHeader_tooltip": "_38_xi1yMXFBPH2zGDevXmw",
	"Vocabulary_content": "_1XT6QI21F91vWGzswE11cG",
	"Vocabulary_pureCell": "_3io09NQcaQ8g1uXjg9H4f5",
	"Vocabulary_pureCell_pureText": "_1fbmAJfthP0CjsuHOWU7l9",
	"Vocabulary_cell": "_2rF7vfZGt8LidniZAnZi5x",
	"Vocabulary_cell_tooltip": "_20CpSPMXMg_jz1hMl8GM-q",
	"Vocabulary_cell_text": "bxcZ0xnQACWJ4cmQHBq-7",
	"Vocabulary_cell_successIcon": "_3oKcDoHSoPsU71HOXO_4hr",
	"Vocabulary_cell_progressBarTd": "_2J3FBN630z3zMo572hCeDC"
};

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VocabularyResult = undefined;

var _model = __webpack_require__(1669);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VocabularyResult = exports.VocabularyResult = _model2.default;

exports.default = VocabularyResult;

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VocabularyResultRecord = (0, _immutable.Record)({
  studentId: undefined,
  totalWords: undefined,
  completedWords: undefined,
  completedRatio: undefined
});

var VocabularyResult = function (_VocabularyResultReco) {
  _inherits(VocabularyResult, _VocabularyResultReco);

  function VocabularyResult() {
    _classCallCheck(this, VocabularyResult);

    return _possibleConstructorReturn(this, (VocabularyResult.__proto__ || Object.getPrototypeOf(VocabularyResult)).apply(this, arguments));
  }

  return VocabularyResult;
}(VocabularyResultRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      item = _ref2[1];

  if (!item) return [key, item];
  switch (key) {
    case 'studentId':
      return [key, '' + item];
    case 'totalWords':
    case 'completedWords':
      return [key, Number.parseInt(item, 10)];
    default:
      return [key, item];
  }
};

VocabularyResult.create = function (data) {
  return new VocabularyResult(data).mapEntries(reviver);
};

exports.default = VocabularyResult;

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = vocabularyReducer;

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _actions = __webpack_require__(737);

var _model = __webpack_require__(736);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function vocabularyReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_VOCABULARY_RESULTS_REQUEST:
      return _omniCommonUi.ApiResponseHelper.create({ loading: true });
    case _actions.FETCH_VOCABULARY_RESULTS_SUCCESS:
      return _omniCommonUi.ApiResponseHelper.create(action.payload.map(function (vocabulary) {
        return _model2.default.create(vocabulary);
      }));
    case _actions.FETCH_VOCABULARY_RESULTS_FAILURE:
      return _omniCommonUi.ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(734);

var _component2 = _interopRequireDefault(_component);

var _accessors = __webpack_require__(36);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: 'vocabulary',
    component: _component2.default,
    actionButtons: {
      default: {
        'View Content': {
          route: function route(_ref2) {
            var params = _ref2.params;
            var groupId = params.groupId;

            var sessionId = (0, _accessors.getDefaultSession)(getState(), groupId).id;
            var unitId = (0, _accessors.getFirstUnitOfSession)(getState(), sessionId);
            return '/group/' + groupId + '/assign-homework/session/' + sessionId + '/unit/' + unitId;
          },
          visibleWhen: function visibleWhen(_ref3) {
            var groupId = _ref3.params.groupId;
            return _TabSwitcher2.default.isTabEnabled(getState(), groupId, _TabSwitcher.TabCodes.AssignHomework);
          }
        }
      }
    }
  };
};

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routes2 = __webpack_require__(1673);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = _routes3.default;

exports.default = routes;

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MarkHomeworkDayView = __webpack_require__(1674);

var _MarkHomeworkCourseView = __webpack_require__(1688);

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: 'session/:sessionPlanId(/unit/:unitId)/paper-based',
    component: _MarkHomeworkDayView.MarkHomeworkDayView,
    indexRoute: {
      onEnter: function onEnter(nextState, replace) {
        var viewMode = getState().get('rootReducer').get('uiState').get('viewMode');
        var isInCourseView = viewMode === 'course';
        return replace(withoutTrailingSlash(nextState.location.pathname) + '/' + (isInCourseView ? 'course' : 'day'));
      }
    },
    showSessionCourseSwitch: true,
    childRoutes: [_MarkHomeworkDayView.routes, _MarkHomeworkCourseView.routes]
  };
};

function withoutTrailingSlash(path) {
  var out = path;
  if (path.substr(path.length - 1) === '/') {
    out = path.substr(0, path.length - 1);
  }
  return out;
}

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(738);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1687);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
exports.default = _component2.default;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1676);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".K7NG8_HeUdqs6d0q_Dal5{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MarkHomeworkDayView_lessonHomework": "K7NG8_HeUdqs6d0q_Dal5"
};

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Student = undefined;

var _student = __webpack_require__(1678);

var _student2 = _interopRequireDefault(_student);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Student = exports.Student = _student2.default;

exports.default = Student;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1679);

var _style2 = _interopRequireDefault(_style);

var _component = __webpack_require__(1681);

var _component2 = _interopRequireDefault(_component);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _status = __webpack_require__(109);

var _omniCommonUi = __webpack_require__(0);

var _ProductionStatus = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Student = function Student(props) {
  var firstStatus = props.firstStatus || _status.DefaultPaperbasedHomeworkStatus;
  var secondStatus = props.secondStatus || _status.DefaultPaperbasedHomeworkStatus;
  var productionStatus = (0, _ProductionStatus.parseProductionStatus)(props.productionStatus);
  var isInProduction = props.isInProduction;

  (0, _status.validateHomeworkStatus)(firstStatus.toLowerCase());
  (0, _status.validateHomeworkStatus)(secondStatus.toLowerCase());

  var renderHomeworkStatus = function renderHomeworkStatus(homeworkStatus) {
    switch (homeworkStatus) {
      case 'PartialComplete':
        return 'Partial Complete';
      case 'NotApplicable':
        return 'Not Applicable';
      default:
        return homeworkStatus;
    }
  };

  var renderMarkButtonOrStatus = function renderMarkButtonOrStatus(title, level, status, className) {
    if (props.markable) {
      return _react2.default.createElement(_component2.default, { status: status,
        title: title,
        eventSender: level,
        className: className,
        canSeeNotApplicable: !isInProduction,
        onMarkComplete: props.onMarkComplete,
        onMarkIncomplete: props.onMarkIncomplete,
        onMarkPartialComplete: props.onMarkPartialComplete,
        onMarkNA: props.onMarkNA });
    }
    return _react2.default.createElement(
      'p',
      { className: (0, _classnames2.default)(_style2.default.Student_homeworkStatusText, className) },
      renderHomeworkStatus(status)
    );
  };

  return _react2.default.createElement(
    _omniCommonUi.StudentCard,
    { withSeparatorLine: !props.markable,
      statusAccentColor: props.markable ? undefined : _status.PaperbasedHomeworkStatusColorMappins[status] },
    _react2.default.createElement(_omniCommonUi.StudentCard.Profile, { name: props.name,
      surname: props.surname,
      localName: props.localname,
      gender: props.gender,
      avatarUrl: props.avatarUrl,
      status: productionStatus.fullName,
      statusHighlighted: isInProduction }),
    _react2.default.createElement(
      _omniCommonUi.StudentCard.Content,
      null,
      renderMarkButtonOrStatus(props.secondStatus ? 'Practice' : null, 'first', props.firstStatus),
      props.secondStatus ? renderMarkButtonOrStatus('Tutorial', 'second', props.secondStatus, _style2.default.Student_hotPinkColor) : null
    )
  );
};

Student.propTypes = {
  firstStatus: _propTypes2.default.string,
  secondStatus: _propTypes2.default.string,
  name: _propTypes2.default.string,
  surname: _propTypes2.default.string,
  localname: _propTypes2.default.string,
  avatarUrl: _propTypes2.default.string,
  gender: _propTypes2.default.string,
  markable: _propTypes2.default.bool,
  onMarkComplete: _propTypes2.default.func,
  onMarkIncomplete: _propTypes2.default.func,
  onMarkPartialComplete: _propTypes2.default.func,
  onMarkNA: _propTypes2.default.func,
  productionStatus: _propTypes2.default.string,
  isInProduction: _propTypes2.default.bool
};

exports.default = Student;

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1680);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3o83nwrwZcDMo2F6VIxRq7{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-size:.92857rem;height:2.5rem;margin:0;margin-bottom:-.07143rem;padding-left:1.07143rem;position:relative;text-transform:uppercase;top:-.14286rem}._2g6GlY_IEq5umh_FXqhIC5{color:hotpink}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Student_homeworkStatusText": "_3o83nwrwZcDMo2F6VIxRq7",
	"Student_hotPinkColor": "_2g6GlY_IEq5umh_FXqhIC5"
};

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1682);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _status = __webpack_require__(109);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MarkButtons = function MarkButtons(props) {
  return _react2.default.createElement(
    'div',
    { className: _style2.default.MarkButtons },
    props.title ? _react2.default.createElement(
      _omniCommonUi.Button,
      { className: (0, _classnames2.default)(_style2.default.MarkButtons_button, props.className),
        autoWidth: true,
        disabled: true },
      props.title
    ) : null,
    _react2.default.createElement(
      _omniCommonUi.Tooltip,
      { text: 'Complete', className: _style2.default.MarkButtons_buttonContainer },
      _react2.default.createElement(
        _omniCommonUi.Button,
        { className: _style2.default.MarkButtons_button,
          onClick: function onClick() {
            return props.onMarkComplete(props.eventSender);
          },
          active: props.status === _status.PaperbasedHomeworkStatus.complete,
          autoWidth: true },
        _react2.default.createElement(_omniCommonUi.Icon, { id: 'tick' })
      )
    ),
    _react2.default.createElement(
      _omniCommonUi.Tooltip,
      { text: 'Partial Complete', className: _style2.default.MarkButtons_buttonContainer },
      _react2.default.createElement(
        _omniCommonUi.Button,
        { className: _style2.default.MarkButtons_button,
          onClick: function onClick() {
            return props.onMarkPartialComplete(props.eventSender);
          },
          active: props.status === _status.PaperbasedHomeworkStatus.partialcomplete,
          autoWidth: true },
        _react2.default.createElement(_omniCommonUi.Icon, { id: 'tick', className: _style2.default.MarkButtons_PartialIcon })
      )
    ),
    _react2.default.createElement(
      _omniCommonUi.Tooltip,
      { text: 'Incomplete', className: _style2.default.MarkButtons_buttonContainer },
      _react2.default.createElement(
        _omniCommonUi.Button,
        { className: _style2.default.MarkButtons_button,
          onClick: function onClick() {
            return props.onMarkIncomplete(props.eventSender);
          },
          active: props.status === _status.PaperbasedHomeworkStatus.incomplete,
          autoWidth: true },
        _react2.default.createElement(_omniCommonUi.Icon, { id: 'cross' })
      )
    ),
    _react2.default.createElement(
      _omniCommonUi.Tooltip,
      { text: 'Not Applicable', className: _style2.default.MarkButtons_buttonContainer },
      _react2.default.createElement(
        _omniCommonUi.Button,
        { className: _style2.default.MarkButtons_button,
          onClick: function onClick() {
            return props.onMarkNA(props.eventSender);
          },
          active: props.status === _status.PaperbasedHomeworkStatus.notapplicable,
          autoWidth: true },
        'N/A'
      )
    )
  );
};

MarkButtons.propTypes = {
  title: _propTypes2.default.string,
  status: _propTypes2.default.oneOf(Object.values(_status.PaperbasedHomeworkStatus)),
  eventSender: _propTypes2.default.string.isRequired,
  onMarkComplete: _propTypes2.default.func.isRequired,
  onMarkIncomplete: _propTypes2.default.func.isRequired,
  onMarkPartialComplete: _propTypes2.default.func.isRequired,
  onMarkNA: _propTypes2.default.func,
  canSeeNotApplicable: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

exports.default = MarkButtons;

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1683);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2-djj1zqzhEwa8F1t3f8-5{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._3Mm3VuXUuHJ7QD8pjh0LZ4{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1}._3Mm3VuXUuHJ7QD8pjh0LZ4:not(:last-child) ._2hbU2_7D2CrkbTGBYK5lYx{border-right:none}._2hbU2_7D2CrkbTGBYK5lYx{-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;min-width:0;width:100%}._1HnvyI4fsZNcgrnND15ulz>svg{fill:transparent;height:1.2em;stroke:currentColor;stroke-dasharray:2;stroke-width:1;width:1.2em}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MarkButtons": "_2-djj1zqzhEwa8F1t3f8-5",
	"MarkButtons_buttonContainer": "_3Mm3VuXUuHJ7QD8pjh0LZ4",
	"MarkButtons_button": "_2hbU2_7D2CrkbTGBYK5lYx",
	"MarkButtons_PartialIcon": "_1HnvyI4fsZNcgrnND15ulz"
};

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1685);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _Api = __webpack_require__(11);

var _Detailsboard = __webpack_require__(202);

var _Detailsboard2 = _interopRequireDefault(_Detailsboard);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HomeworkContentPopup = function (_Component) {
  _inherits(HomeworkContentPopup, _Component);

  function HomeworkContentPopup(props) {
    _classCallCheck(this, HomeworkContentPopup);

    var _this = _possibleConstructorReturn(this, (HomeworkContentPopup.__proto__ || Object.getPrototypeOf(HomeworkContentPopup)).call(this, props));

    _this.state = {
      homeworkContentItems: [],
      isErrored: false,
      isLoading: true
    };
    return _this;
  }

  _createClass(HomeworkContentPopup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var url = this.props.url;

      (0, _Api.fetch)((0, _Api.buildUrl)(url)).then(function (response) {
        _this2.setState({
          homeworkContentItems: response,
          isLoading: false
        });
      }).catch(function () {
        _this2.setState({
          isErrored: true,
          isLoading: false
        });
      });
      _reactGa2.default.send({
        hitType: 'pageview',
        page: window.location.pathname,
        location: window.location.href,
        title: document.title,
        modal: 'homework-content/' + url
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          homeworkContentItems = _state.homeworkContentItems,
          isErrored = _state.isErrored,
          isLoading = _state.isLoading;
      var _props = this.props,
          onOkButtonClicked = _props.onOkButtonClicked,
          title = _props.title;

      var buttonWrapper = _react2.default.createElement(
        _omniCommonUi.Button.Container,
        { align: 'center' },
        _react2.default.createElement(
          _omniCommonUi.Button,
          { type: _omniCommonUi.Button.Type.primary, onClick: function onClick() {
              return onOkButtonClicked();
            } },
          'OK'
        )
      );
      var popupContent = _react2.default.createElement('p', {
        className: (0, _classnames2.default)((0, _omniCommonUi.testClass)('loading'), _style2.default.HomeworkContentPopup_loading)
      });
      if (isErrored) {
        return _react2.default.createElement(_omniCommonUi.ErrorDialog, { isOpen: true, onConfirmClick: onOkButtonClicked });
      } else if (!isLoading) {
        popupContent = _react2.default.createElement(
          'div',
          { className: _style2.default.HomeworkContentPopup },
          _react2.default.createElement(
            'h2',
            { className: _style2.default.HomeworkContentPopup_title },
            title
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.HomeworkContentPopup_content },
            homeworkContentItems.map(function (homeworkContentItem) {
              var name = homeworkContentItem.name,
                  description = homeworkContentItem.description;

              return _react2.default.createElement(_Detailsboard2.default, {
                key: name,
                boardTitle: name,
                boardValue: description
              });
            })
          ),
          buttonWrapper
        );
      }
      return _react2.default.createElement(
        _omniCommonUi.Dialog,
        { isOpen: true, isLoading: isLoading },
        popupContent
      );
    }
  }]);

  return HomeworkContentPopup;
}(_react.Component);

HomeworkContentPopup.propTypes = {
  title: _propTypes2.default.string,
  url: _propTypes2.default.string,
  onOkButtonClicked: _propTypes2.default.func
};

exports.default = HomeworkContentPopup;

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1686);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2Th4MBIOamX4bUUrtgzprL{max-width:28.57143rem;overflow:hidden;padding:2.28571rem 1.78571rem}._2S2y4BA9j5AtC-Gz6QzG4j{min-height:4.57143rem;min-width:4.57143rem}.p3kudkjwk4dPMsVyIVSG1{color:#a4a4a4;font-weight:700;margin:0;text-align:center}._3I-irnWdrn9LZ35SGRf8PT{padding:2.85714rem 0}._3YU63DUSJOFs3rA-0dwr0G{font-size:.85714rem;height:2.85714rem!important;margin-left:.71429rem;margin-right:.71429rem;width:10.71429rem!important}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"HomeworkContentPopup": "_2Th4MBIOamX4bUUrtgzprL",
	"HomeworkContentPopup_loading": "_2S2y4BA9j5AtC-Gz6QzG4j",
	"HomeworkContentPopup_title": "p3kudkjwk4dPMsVyIVSG1",
	"HomeworkContentPopup_content": "_3I-irnWdrn9LZ35SGRf8PT",
	"HomeworkContentPopup_button": "_3YU63DUSJOFs3rA-0dwr0G"
};

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(738);

var _component2 = _interopRequireDefault(_component);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _accessors = __webpack_require__(209);

var _SessionNav = __webpack_require__(132);

var _SessionNav2 = _interopRequireDefault(_SessionNav);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _accessors2 = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    appBars: {
      sticky: {
        'session-nav': {
          component: _SessionNav2.default,
          order: 1
        },
        'view-nav': {
          component: _ViewNav2.default,
          order: 2,
          props: {
            hideExpandable: false
          }
        }
      }
    },
    path: 'day(/:mode)',
    view: 'day',
    component: _component2.default,
    sessionNavConfig: {
      setModeOnNavigate: ''
    },
    actionButtons: {
      default: {
        Mark: {
          isPrimary: true,
          route: './edit',
          canAccess: function canAccess() {
            return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.Homework.Mark);
          },
          visibleWhen: function visibleWhen(_ref2) {
            var _ref2$params = _ref2.params,
                sessionPlanId = _ref2$params.sessionPlanId,
                groupId = _ref2$params.groupId;
            return (0, _accessors.isMarkable)(getState(), groupId, sessionPlanId) && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.Homework.Mark);
          }
        },
        'View content': {
          route: function route(_ref3) {
            var params = _ref3.params;
            var sessionPlanId = params.sessionPlanId,
                groupId = params.groupId;

            var unitId = (0, _accessors2.getFirstUnitOfSession)(getState(), sessionPlanId);
            return '/group/' + groupId + '/assign-homework/session/' + sessionPlanId + '/unit/' + unitId;
          },
          canAccess: function canAccess() {
            return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.Homework.ViewAssignments);
          },
          visibleWhen: function visibleWhen() {
            return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.Homework.ViewAssignments);
          }
        }
      },
      edit: {
        Save: {
          isPrimary: true,
          route: '../save'
        },
        Discard: {
          route: '../discard'
        }

      }
    }
  };
};

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(739);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1694);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
exports.default = _component2.default;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1690);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _status = __webpack_require__(109);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaperFolding = function PaperFolding(_ref) {
  var paperBasedStatus = _ref.paperBasedStatus;

  return _react2.default.createElement(
    'div',
    { className: _style2.default.PaperBasedBall },
    renderStatus()
  );

  function renderStatus() {
    if (paperBasedStatus === _status.PaperbasedHomeworkStatus.notapplicable) {
      return 'n/a';
    }

    if (_is_js2.default.not.string(paperBasedStatus)) {
      return '–';
    }

    var imgConf = getImgConf();
    return _react2.default.createElement(_omniCommonUi.Icon, { id: imgConf.src,
      className: (0, _classnames2.default)(_style2.default.PaperBasedBall_img, imgConf.class),
      title: imgConf.alt });
  }

  function getImgConf() {
    switch (paperBasedStatus) {
      case _status.PaperbasedHomeworkStatus.complete:
        return { src: 'success', alt: _status.PaperbasedHomeworkStatus.complete, class: _style2.default.__complete };
      case _status.PaperbasedHomeworkStatus.incomplete:
        return { src: 'cross-circle', alt: _status.PaperbasedHomeworkStatus.incomplete, class: _style2.default.__incomplete };
      case _status.PaperbasedHomeworkStatus.unmarked:
        return { src: 'circle', alt: _status.PaperbasedHomeworkStatus.unmarked, class: _style2.default.__unmarked };
      case _status.PaperbasedHomeworkStatus.partialcomplete:
        return { src: 'success', alt: 'Partial Complete', class: _style2.default.__partialComplete };
      default:
        throw new Error('Invalid paper based homework status: ' + paperBasedStatus);
    }
  }
};

PaperFolding.propTypes = {
  paperBasedStatus: _propTypes2.default.oneOf(Object.keys(_status.PaperbasedHomeworkStatus))
};

exports.default = PaperFolding;

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1691);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3NPjBvbR7_ZzzIlMcrow-A{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:1.42857rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;width:1.42857rem}._1BxDI3qc-6XrqZnQwqtZp_{display:block;font-size:1.42857rem}._1BxDI3qc-6XrqZnQwqtZp_.-VJy4ZEGaPq5hWa7YH7Wz{color:#74d17f}._1BxDI3qc-6XrqZnQwqtZp_._3mG4YVE5gM0G5ZZtNGzS-{color:#de4c4c}._1BxDI3qc-6XrqZnQwqtZp_._3_PSg819NJ8uOEUbZgfAfg{color:#f7932d}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"PaperBasedBall": "_3NPjBvbR7_ZzzIlMcrow-A",
	"PaperBasedBall_img": "_1BxDI3qc-6XrqZnQwqtZp_",
	"__complete": "-VJy4ZEGaPq5hWa7YH7Wz",
	"__incomplete": "_3mG4YVE5gM0G5ZZtNGzS-",
	"__partialComplete": "_3_PSg819NJ8uOEUbZgfAfg"
};

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1693);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2KzlC9CNfxIGqJQwJFLS-G{white-space:nowrap}._2rxXWVq3YnwnfuY0Z5sTu7{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around;width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MarkHomeworkCourseView_header": "_2KzlC9CNfxIGqJQwJFLS-G",
	"MarkHomeworkCourseView_content": "_2rxXWVq3YnwnfuY0Z5sTu7"
};

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(739);

var _component2 = _interopRequireDefault(_component);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _omniCommonUi = __webpack_require__(0);

var _accessors = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: 'course(/:mode)',
    view: 'course',
    component: _component2.default,
    sessionNavConfig: {
      setModeOnNavigate: ''
    },
    actionButtons: {
      default: {
        Mark: {
          isPrimary: true,
          route: './edit',
          visibleWhen: function visibleWhen() {
            return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.Homework.Mark);
          }
        },
        'View Content': {
          route: function route(_ref2) {
            var params = _ref2.params;
            var groupId = params.groupId;

            var sessionId = (0, _accessors.getDefaultSession)(getState(), groupId).id;
            var unitId = (0, _accessors.getFirstUnitOfSession)(getState(), sessionId);
            return '/group/' + groupId + '/assign-homework/session/' + sessionId + '/unit/' + unitId;
          }
        }
      },
      edit: {
        Exit: {
          route: {
            mode: ''
          }
        }
      }
    }
  };
};

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(740);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1696);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _omniCommonUi = __webpack_require__(0);

var _Assignments = __webpack_require__(1697);

var _UnlockHomework = __webpack_require__(1732);

var _component = __webpack_require__(740);

var _component2 = _interopRequireDefault(_component);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _accessors = __webpack_require__(36);

var Session = _interopRequireWildcard(_accessors);

var _routes = __webpack_require__(757);

var _ = __webpack_require__(13);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSecondLevelTabs = function getSecondLevelTabs(getState, _ref) {
  var pathname = _ref.location.pathname,
      buildRoute = _ref.buildRoute,
      push = _ref.push,
      params = _ref.params;

  var defaultSession = Session.getDefaultSession(getState(), params.groupId);
  var sessionPlanId = defaultSession && defaultSession.id;
  var assignmentsparams = _extends({}, params, {
    sessionPlanId: sessionPlanId,
    unitId: Session.getFirstUnitOfSession(getState(), sessionPlanId)
  });
  if ((0, _routes.isUnlockHomeworkEnabled)(getState(), params.groupId) && !_.actions.hasContentPath(getState(), params.groupId)) {
    return [{
      text: 'Assignments',
      onClick: function onClick() {
        return push(buildRoute('/group/:groupId/assign-homework/session/:sessionPlanId(/unit/:unitId)', assignmentsparams));
      },
      isActive: pathname.includes('assign-homework/session')
    }, {
      text: 'Unlock Practice',
      onClick: function onClick() {
        return push(buildRoute('/group/:groupId/assign-homework/unlock-homework', params));
      },
      isActive: pathname.includes('unlock-homework')
    }];
  }
};

exports.default = function (_ref2) {
  var getState = _ref2.getState;
  return {
    path: 'assign-homework',
    component: _component2.default,
    canAccess: function canAccess(_ref3) {
      var params = _ref3.params;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.AssignHomework.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.AssignHomework);
    },
    breadcrumbLabels: function breadcrumbLabels() {
      return {
        label: 'At Home Review',
        clickable: false
      };
    },
    tab: {
      label: 'At Home Review',
      order: 4,
      isVisible: function isVisible(params) {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.AssignHomework.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.AssignHomework);
      }
    },
    secondLevelTabs: function secondLevelTabs(props) {
      return getSecondLevelTabs(getState, props);
    },
    childRoutes: [_Assignments.routes, _UnlockHomework.routes]
  };
};

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(741);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(753);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1699);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._37HUC3nMDsaXznMdYBIXXC{border-bottom:.07143rem solid #ccc;float:left;padding:1.07143rem 1.42857rem;width:100%}@media only screen and (min-width:640px){._37HUC3nMDsaXznMdYBIXXC{padding:1.07143rem 2.14286rem}}._2mc41Ew9a3ovszZaWvuyr_{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}._2mc41Ew9a3ovszZaWvuyr_,.EX0Lqh1rC4Pt2aW7jbSkF{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.EX0Lqh1rC4Pt2aW7jbSkF{border:.07143rem solid #4a4a4a;height:1.57143rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:7.14286rem;padding-left:.71429rem;padding-right:.71429rem;text-align:center;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:.85714rem;font-weight:600;letter-spacing:.07143rem;text-transform:uppercase;letter-spacing:normal}._79u8QkbVoTgZAMdAGiwOQ{color:#b4b4b4;display:inline;font-size:1rem;font-weight:400;margin:0}.EX0Lqh1rC4Pt2aW7jbSkF+._79u8QkbVoTgZAMdAGiwOQ{margin-left:.71429rem}._2gp-FQH4ZDrhFtVJtGSiHo{font-size:1rem;margin:.4em 0;margin-bottom:0;white-space:pre-line}._2gp-FQH4ZDrhFtVJtGSiHo:only-child{margin-top:0}._3AgfFdw9ZIibauWV-0CXIk{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:0}._3AgfFdw9ZIibauWV-0CXIk h4{padding:1.07143rem 1.42857rem;border-bottom:.07143rem solid #ccc;display:block;font-size:1.14286rem;font-weight:600;letter-spacing:.05rem;margin:0;width:100%}@media only screen and (min-width:640px){._3AgfFdw9ZIibauWV-0CXIk h4{padding-left:2.14286rem;padding-right:2.14286rem}}._34jCNqZO22sQklGUg-8zgH{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-size:1.28571rem;font-weight:400;letter-spacing:normal;margin:0;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}.cOHPFr99k9Zc-EiLKeKNq{-webkit-box-flex:1;-webkit-flex:auto;-moz-box-flex:1;-ms-flex:auto;flex:auto}._3VSb5FDBSMcZ4pndZigDq2{color:#a4a4a4;font-size:1.14286rem;padding-top:5rem;text-align:center}._3VSb5FDBSMcZ4pndZigDq2>div:not(:last-child){margin-bottom:1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ContentItem_board": "_37HUC3nMDsaXznMdYBIXXC",
	"ContentItem_title": "_2mc41Ew9a3ovszZaWvuyr_",
	"ContentItem_label": "EX0Lqh1rC4Pt2aW7jbSkF",
	"ContentItem_h5": "_79u8QkbVoTgZAMdAGiwOQ",
	"ContentItem_p": "_2gp-FQH4ZDrhFtVJtGSiHo",
	"AssignHomework_online_content": "_3AgfFdw9ZIibauWV-0CXIk",
	"AssignHomework_header": "_34jCNqZO22sQklGUg-8zgH",
	"AssignHomework_header_duedate": "cOHPFr99k9Zc-EiLKeKNq",
	"AssignHomework_noContent": "_3VSb5FDBSMcZ4pndZigDq2"
};

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1701);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _CardActionIcons = __webpack_require__(85);

var _CardActionIcons2 = _interopRequireDefault(_CardActionIcons);

var _ContentItem = __webpack_require__(318);

var _ContentItem2 = _interopRequireDefault(_ContentItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GroupHomeworkCard = function (_Component) {
  _inherits(GroupHomeworkCard, _Component);

  function GroupHomeworkCard(props) {
    _classCallCheck(this, GroupHomeworkCard);

    var _this = _possibleConstructorReturn(this, (GroupHomeworkCard.__proto__ || Object.getPrototypeOf(GroupHomeworkCard)).call(this));

    _this.state = {
      disabledSaveButton: true
    };
    _this._setGroupHomeworkItems(props);
    _this._editIconClick = _this._editIconClick.bind(_this);
    _this._onSaveClick = _this._onSaveClick.bind(_this);
    _this._onDiscardClick = _this._onDiscardClick.bind(_this);
    return _this;
  }

  _createClass(GroupHomeworkCard, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.homeworkTemplate !== this.props.homeworkTemplate || props.homeworkContent !== this.props.homeworkContent && !props.editMode) {
        this._setGroupHomeworkItems(props);
      }
    }
  }, {
    key: '_editIconClick',
    value: function _editIconClick() {
      this.props.onEditClick();
      this.setState({
        disabledSaveButton: true
      });
      this._setGroupHomeworkItems(this.props);
    }
  }, {
    key: '_onDiscardClick',
    value: function _onDiscardClick() {
      this.props.onDiscardClick();
      this._setGroupHomeworkItems(this.props);
    }
  }, {
    key: '_setGroupHomeworkItems',
    value: function _setGroupHomeworkItems(props) {
      var homeworkContent = props.homeworkContent,
          isNewStatus = props.isNewStatus;

      var homeworkTemplate = props.homeworkTemplate;
      if (!homeworkTemplate) {
        return;
      }
      if (isNewStatus) {
        homeworkTemplate = this._setHomeworkContentAssigned(homeworkTemplate, true);
      }
      this.setState({ editedGroupHomeworkItems: homeworkTemplate.mergeDeep(this._setHomeworkContentAssigned(homeworkContent, false)) });
    }
  }, {
    key: '_setHomeworkContentAssigned',
    value: function _setHomeworkContentAssigned(homeworkContent, isFromTemplate) {
      return homeworkContent && homeworkContent.map(function (homwork) {
        return homwork.update('contentItems', function (contentItems) {
          return contentItems.map(function (contentItem) {
            if (!isFromTemplate || !contentItem.isDeleted) {
              return contentItem.set('isAssigned', true);
            }

            return contentItem;
          });
        });
      });
    }
  }, {
    key: '_onSaveClick',
    value: function _onSaveClick() {
      var toSaveHomeworkItems = this.state.editedGroupHomeworkItems.map(function (homwork) {
        return homwork.update('contentItems', function (contentItems) {
          return contentItems.filter(function (item) {
            return !!item.isAssigned;
          });
        });
      });
      this.props.onSaveClick(toSaveHomeworkItems);
    }
  }, {
    key: '_handleCheckBoxChecked',
    value: function _handleCheckBoxChecked(item, unitId, lessonNumber, checkBoxStatus) {
      this.setState({ disabledSaveButton: false });
      var editedGroupHomeworkItems = this.state.editedGroupHomeworkItems;

      var newItem = item;
      newItem = item.set('isAssigned', checkBoxStatus);
      var newEditedGroupHomeworkItems = editedGroupHomeworkItems.update(unitId + '-' + lessonNumber, function (lesson) {
        return lesson.set('contentItems', lesson.contentItems.set(newItem.homeworkContentId, newItem));
      });
      this.setState({
        editedGroupHomeworkItems: newEditedGroupHomeworkItems
      });
      this.props.onNowSaveable(newEditedGroupHomeworkItems);
    }
  }, {
    key: '_renderViewModeContentItem',
    value: function _renderViewModeContentItem(item, unitId, lessonNumber) {
      return _react2.default.createElement(_ContentItem2.default, { key: unitId + '-' + lessonNumber + '-' + item.name,
        className: _style2.default.GroupHomeworkCard_item,
        homeworkType: item.homeworkType,
        boardTitle: item.name,
        boardValue: item.description });
    }
  }, {
    key: '_renderEditModeContentItem',
    value: function _renderEditModeContentItem(item, unitId, lessonNumber) {
      var checkBoxCheckedHandler = this._handleCheckBoxChecked.bind(this, item, unitId, lessonNumber);
      var uniqueId = unitId + '-' + lessonNumber + '-' + item.homeworkContentId;
      return _react2.default.createElement(_ContentItem2.default, { key: uniqueId,
        className: _style2.default.GroupHomeworkCard_item,
        homeworkType: item.homeworkType,
        boardTitle: item.name,
        boardValue: _react2.default.createElement(
          'label',
          { htmlFor: uniqueId },
          _react2.default.createElement(_omniCommonUi.Checkbox, { id: uniqueId,
            checked: item.isAssigned,
            onChange: checkBoxCheckedHandler }),
          _react2.default.createElement(
            'span',
            { className: _style2.default.GroupHomeworkCard_item_content },
            item.description
          )
        ) });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          canEdit = _props.canEdit,
          editMode = _props.editMode,
          homeworkContent = _props.homeworkContent,
          homeworkTemplate = _props.homeworkTemplate,
          isNewStatus = _props.isNewStatus;
      var _state = this.state,
          editedGroupHomeworkItems = _state.editedGroupHomeworkItems,
          disabledSaveButton = _state.disabledSaveButton;

      var validTemplate = !homeworkTemplate ? homeworkTemplate : homeworkTemplate.map(function (homwork) {
        return homwork.update('contentItems', function (contentItems) {
          return contentItems.filter(function (contentItem) {
            return !contentItem.isDeleted;
          });
        });
      });
      var viewHomework = isNewStatus ? validTemplate : homeworkContent;
      var groupHomework = editMode ? editedGroupHomeworkItems : viewHomework;
      if (!groupHomework) return null;
      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        null,
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          { text: 'Group Practice', stackMode: 'horizontal' },
          _react2.default.createElement(_CardActionIcons2.default, { onEditClick: this._editIconClick,
            hideEditIcon: !canEdit || editMode,
            hideDeleteIcon: true })
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.GroupHomeworkCard },
          groupHomework.map(function (_ref) {
            var lessonNumber = _ref.lessonNumber,
                unitOrderingSequence = _ref.unitOrderingSequence,
                unitId = _ref.unitId,
                contentItems = _ref.contentItems;
            return [_react2.default.createElement(
              'h4',
              { key: unitOrderingSequence + '-' + lessonNumber },
              'Unit ',
              unitOrderingSequence,
              ', Lesson ',
              lessonNumber
            )].concat(contentItems.map(function (item) {
              return (// eslint-disable-line no-confusing-arrow
                editMode ? _this2._renderEditModeContentItem(item, unitId, lessonNumber) : _this2._renderViewModeContentItem(item, unitId, lessonNumber)
              );
            }));
          }),
          editMode ? _react2.default.createElement(
            'div',
            { className: _style2.default.GroupHomeworkCard_buttons },
            _react2.default.createElement(
              _omniCommonUi.Button.Container,
              { align: 'right' },
              _react2.default.createElement(
                _omniCommonUi.Button,
                { type: _omniCommonUi.Button.Type.primary,
                  onClick: this._onSaveClick,
                  disabled: disabledSaveButton },
                'Save'
              ),
              _react2.default.createElement(
                _omniCommonUi.Button,
                { type: _omniCommonUi.Button.Type.default,
                  onClick: this._onDiscardClick },
                'Discard'
              )
            )
          ) : null
        )
      );
    }
  }]);

  return GroupHomeworkCard;
}(_react.Component);

GroupHomeworkCard.propTypes = {
  homeworkContent: _propTypes2.default.shape({
    map: _propTypes2.default.func,
    update: _propTypes2.default.func
  }),
  homeworkTemplate: _propTypes2.default.shape({
    map: _propTypes2.default.func,
    update: _propTypes2.default.func
  }).isRequired,
  isNewStatus: _propTypes2.default.bool,
  editMode: _propTypes2.default.bool,
  canEdit: _propTypes2.default.bool,
  onEditClick: _propTypes2.default.func.isRequired,
  onSaveClick: _propTypes2.default.func.isRequired,
  onDiscardClick: _propTypes2.default.func.isRequired,
  onNowSaveable: _propTypes2.default.func.isRequired
};

exports.default = GroupHomeworkCard;

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1702);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3eh2PvHlJRAn_I9w4TSA-t{border-bottom:.07143rem solid #ccc;float:left;padding:1.07143rem 1.42857rem;width:100%}@media only screen and (min-width:640px){._3eh2PvHlJRAn_I9w4TSA-t{padding:1.07143rem 2.14286rem}}._xQJG_OogqUJLfrh-ZKly{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}._7uS0xynkk6wAxYaOgtkQ7,._xQJG_OogqUJLfrh-ZKly{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._7uS0xynkk6wAxYaOgtkQ7{border:.07143rem solid #4a4a4a;height:1.57143rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:7.14286rem;padding-left:.71429rem;padding-right:.71429rem;text-align:center;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:.85714rem;font-weight:600;letter-spacing:.07143rem;text-transform:uppercase;letter-spacing:normal}._3XQFPVHvpfVcE3aQgPXDNx{color:#b4b4b4;display:inline;font-size:1rem;font-weight:400;margin:0}._7uS0xynkk6wAxYaOgtkQ7+._3XQFPVHvpfVcE3aQgPXDNx{margin-left:.71429rem}._3m4gr_eq3a3wPtQ7N_Cg4i{font-size:1rem;margin:.4em 0;margin-bottom:0;white-space:pre-line}._3m4gr_eq3a3wPtQ7N_Cg4i:only-child{margin-top:0}.kqKSRrW0AFVvYGdV1eACD{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:0}.kqKSRrW0AFVvYGdV1eACD h4{padding:1.07143rem 1.42857rem;border-bottom:.07143rem solid #ccc;display:block;font-size:1.14286rem;font-weight:600;letter-spacing:.05rem;margin:0;width:100%}@media only screen and (min-width:640px){.kqKSRrW0AFVvYGdV1eACD h4{padding-left:2.14286rem;padding-right:2.14286rem}}._3gKnGdYf2D5hK0pCgy-Qba{border:.07143rem solid;border-color:#4a4a4a;display:inline-block;min-width:7.14286rem;padding-left:.71429rem;padding-right:.71429rem;text-align:center;text-transform:uppercase}._1ZpnowbAvEaMMpCPq5RrXU{color:#b4b4b4;display:inline;font-weight:400;margin:0;margin-bottom:.71429rem}._3gKnGdYf2D5hK0pCgy-Qba+._1ZpnowbAvEaMMpCPq5RrXU{margin-left:.71429rem}._1a9PwzUos86cIG0x7EQ5WI{cursor:pointer;font-size:1rem;letter-spacing:.07143rem;white-space:pre-line}._3V9mL9QwGrNLZXYEyQm_9q{padding:1.07143rem 1.42857rem;width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ContentItem_board": "_3eh2PvHlJRAn_I9w4TSA-t",
	"ContentItem_title": "_xQJG_OogqUJLfrh-ZKly",
	"ContentItem_label": "_7uS0xynkk6wAxYaOgtkQ7",
	"ContentItem_h5": "_3XQFPVHvpfVcE3aQgPXDNx",
	"ContentItem_p": "_3m4gr_eq3a3wPtQ7N_Cg4i",
	"GroupHomeworkCard": "kqKSRrW0AFVvYGdV1eACD",
	"GroupHomeworkCard_item_label": "_3gKnGdYf2D5hK0pCgy-Qba",
	"GroupHomeworkCard_item_h5": "_1ZpnowbAvEaMMpCPq5RrXU",
	"GroupHomeworkCard_item_content": "_1a9PwzUos86cIG0x7EQ5WI",
	"GroupHomeworkCard_buttons": "_3V9mL9QwGrNLZXYEyQm_9q"
};

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1704);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".jGXnVFNwMbyvEHPzg23hL{border-bottom:.07143rem solid #ccc;float:left;padding:1.07143rem 1.42857rem;width:100%}@media only screen and (min-width:640px){.jGXnVFNwMbyvEHPzg23hL{padding:1.07143rem 2.14286rem}}.W8kF1CTmg4Jvpn-K7drJC{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}._1iiILP17t2f1U0ILwblrlt,.W8kF1CTmg4Jvpn-K7drJC{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._1iiILP17t2f1U0ILwblrlt{border:.07143rem solid #4a4a4a;height:1.57143rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:7.14286rem;padding-left:.71429rem;padding-right:.71429rem;text-align:center;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:.85714rem;font-weight:600;letter-spacing:.07143rem;text-transform:uppercase;letter-spacing:normal}._1I5hZ6LKpqRRsUT30YHpms{color:#b4b4b4;display:inline;font-size:1rem;font-weight:400;margin:0}._1iiILP17t2f1U0ILwblrlt+._1I5hZ6LKpqRRsUT30YHpms{margin-left:.71429rem}._1q9MkoqCZYYErUlklXYtZ1{font-size:1rem;margin:.4em 0;margin-bottom:0;white-space:pre-line}._1q9MkoqCZYYErUlklXYtZ1:only-child{margin-top:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ContentItem_board": "jGXnVFNwMbyvEHPzg23hL",
	"ContentItem_title": "W8kF1CTmg4Jvpn-K7drJC",
	"ContentItem_label": "_1iiILP17t2f1U0ILwblrlt",
	"ContentItem_h5": "_1I5hZ6LKpqRRsUT30YHpms",
	"ContentItem_p": "_1q9MkoqCZYYErUlklXYtZ1"
};

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteWarning = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSG = 'Are you sure you want to delete this?';

var DeleteWarning = exports.DeleteWarning = function (_Component) {
  _inherits(DeleteWarning, _Component);

  function DeleteWarning() {
    _classCallCheck(this, DeleteWarning);

    return _possibleConstructorReturn(this, (DeleteWarning.__proto__ || Object.getPrototypeOf(DeleteWarning)).apply(this, arguments));
  }

  _createClass(DeleteWarning, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          isOpen = _props.isOpen,
          isDeleting = _props.isDeleting,
          onDeleted = _props.onDeleted;

      if (isOpen && isDeleting && !nextProps.isDeleting) {
        onDeleted && onDeleted();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: _is_js2.default.function(props.isOpen) ? props.isOpen() : !!props.isOpen,
          isLoading: _is_js2.default.function(props.isDeleting) ? props.isDeleting() : !!props.isDeleting,
          primaryButtonContent: 'Cancel',
          secondaryButtonContent: 'Delete',
          onPrimaryClick: function onPrimaryClick() {
            return props.onDiscardClicked && props.onDiscardClicked();
          },
          onSecondaryClick: function onSecondaryClick() {
            return props.onDeleteClicked && props.onDeleteClicked();
          },
          onRequestClose: function onRequestClose() {
            return props.onCloseClicked && props.onCloseClicked();
          } },
        _react2.default.createElement(
          'span',
          null,
          _is_js2.default.undefined(props.warningMessage) ? MSG : props.warningMessage
        )
      );
    }
  }]);

  return DeleteWarning;
}(_react.Component);

DeleteWarning.propTypes = {
  isOpen: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  isDeleting: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  onDiscardClicked: _propTypes2.default.func,
  onCloseClicked: _propTypes2.default.func,
  onDeleteClicked: _propTypes2.default.func,
  onDeleted: _propTypes2.default.func,
  warningMessage: _propTypes2.default.string
};

exports.default = DeleteWarning;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(319);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'lessonNumber':
      return [key, Number.parseInt(val, 10)];
    case 'unitId':
      return [key, '' + val];
    case 'contentItems':
      return [key, val.reduce(function (map, item) {
        return map.set('' + item.name, new _model2.default.Item(item));
      }, new _immutable.OrderedMap())];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = onlineHomeworkContentReducer;

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(319);

var _model2 = _interopRequireDefault(_model);

var _actions = __webpack_require__(743);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function onlineHomeworkContentReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_ONLINE_HOMEWORK_CONTENT_SUCCESS:
      return addOnlineHomeworkContentToMap(state, action);
    default:
      return state;
  }
}

function addOnlineHomeworkContentToMap(state, _ref) {
  var payload = _ref.payload,
      sessionId = _ref.sessionId;

  var newState = state;
  newState = newState.set('' + sessionId, new _immutable.List(payload.map(function (activity) {
    return _model2.default.create(activity);
  })));
  return newState;
}

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = homeworkReducer;

var _immutable = __webpack_require__(3);

var _ = __webpack_require__(137);

var _actions = __webpack_require__(745);

var _actions2 = __webpack_require__(321);

function homeworkReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_HOMEWORK_SUCCESS:
      return addHomeworkToMap(state, action);
    case _actions.PUBLISH_HOMEWORK_SUCCESS:
      return updateHomeworkStatus(state, action.sessionId, _.Homework.Status.PUBLISHED);
    case _actions2.ASSIGN_HOMEWORK_SUCCESS:
      return updateHomeworkStatus(state, action.sessionId, _.Homework.Status.UPDATED);
    case _actions.CLEAR_HOMEWORK_SUCCESS:
      return updateHomeworkStatus(state, action.sessionId, _.Homework.Status.NEW);
    default:
      return state;
  }
}

function updateHomeworkStatus(state, sessionId, status) {
  return state.update('' + sessionId, function (homework) {
    return homework.set('homeworkResultStatus', status);
  });
}

function addHomeworkToMap(state, _ref) {
  var payload = _ref.payload;
  var homeworkResultStatus = payload.homeworkResultStatus,
      sessionId = payload.sessionId;

  return state.set('' + sessionId, new _.Homework({ homeworkResultStatus: homeworkResultStatus, sessionId: sessionId }));
}

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(167);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'lessonNumber':
      return [key, Number.parseInt(val, 10)];
    case 'unitId':
      return [key, '' + val];
    case 'contentItems':
      return [key, val.reduce(function (map, item) {
        return map.set('' + item.homeworkContentId, _model2.default.Item.create(item));
      }, new _immutable.OrderedMap())];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HomeworkRecord = (0, _immutable.Record)({
  sessionId: undefined,
  homeworkResultStatus: undefined
});

var Homework = function (_HomeworkRecord) {
  _inherits(Homework, _HomeworkRecord);

  function Homework() {
    _classCallCheck(this, Homework);

    return _possibleConstructorReturn(this, (Homework.__proto__ || Object.getPrototypeOf(Homework)).apply(this, arguments));
  }

  return Homework;
}(HomeworkRecord);

exports.default = Homework;

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummary = getSummary;
exports.isExisty = isExisty;
exports.isPublished = isPublished;
exports.getPersonalisedHomeworkViewModel = getPersonalisedHomeworkViewModel;

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _Users = __webpack_require__(82);

var _Homework = __webpack_require__(137);

var _Group = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PUBLISHED = _Homework.Homework.Status.PUBLISHED.toLowerCase();

function checkApplicableTeacherPrivileges(state, createdByUserId) {
  var loginUserId = _Users.accessors.getLoginUserId(state);
  var addPrivilege = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.AssignHomework.ManageOwn);
  return addPrivilege && loginUserId === createdByUserId;
}

function checkApplicablePAPrivileges(state) {
  return _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.AssignHomework.EditAny);
}

function checkIsPersonalisedHomeworkNotPublished(state, phId) {
  var publishedHomework = state.get('rootReducer').get('personalisedHomework').get(phId);
  return publishedHomework.status.toLowerCase() !== PUBLISHED;
}

function getSummary(state, sessionId) {
  var phSummary = state.get('rootReducer').get('personalisedHomework').reduce(function (summary, ph) {
    return {
      size: ph.sessionId === sessionId ? summary.size + 1 : summary.size,
      publishedSize: ph.sessionId === sessionId && ph.status.toLowerCase() === PUBLISHED ? summary.publishedSize + 1 : summary.publishedSize
    };
  }, { size: 0, publishedSize: 0 });
  return phSummary;
}

function isExisty(state, sessionId) {
  var summary = getSummary(state, sessionId);
  return summary.size > 0;
}

function isPublished(state, sessionId) {
  var summary = getSummary(state, sessionId);
  return summary.size !== 0 && summary.size === summary.publishedSize;
}

function getPersonalisedHomeworkViewModel(state, groupId, phId, isInEditGroupHomeworkdMode) {
  var personalisedHomework = state.get('rootReducer').get('personalisedHomework').get(phId);
  var canEditOrDelete = !_Group.actions.isAutoPublishHomework(state, groupId) && checkIsPersonalisedHomeworkNotPublished(state, phId) && (checkApplicableTeacherPrivileges(state, personalisedHomework.createdByUserId) || checkApplicablePAPrivileges(state)) && !isInEditGroupHomeworkdMode;
  var personalisedHomeworkJs = personalisedHomework.toJS();
  return Object.assign(personalisedHomeworkJs, {
    canEdit: canEditOrDelete,
    canDelete: canEditOrDelete,
    // TODO: revisit this quick hack to make this work again
    studentIds: new _immutable.Set(personalisedHomeworkJs.studentIds)
  });
}

exports.default = getPersonalisedHomeworkViewModel;

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = personalisedHomeworkReducer;

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _model = __webpack_require__(320);

var _model2 = _interopRequireDefault(_model);

var _Homework = __webpack_require__(137);

var _actions = __webpack_require__(744);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function personalisedHomeworkReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  var model = action.model;
  switch (action.type) {
    case _actions.FETCH_PERSONALISED_HOMEWORK_SUCCESS:
      return addPersonalisedHomeworkToMap(state, Object.assign({}, action.payload, { status: action.status }));
    case _actions.SUBMIT_PERSONALISED_HOMEWORK_SUCCESS:
      if (_is_js2.default.not.existy(action.model.id)) {
        model = action.model.set('id', action.payload);
      }
      return addPersonalisedHomeworkToMap(state, model);
    case _actions.DELETE_PERSONALISED_HOMEWORK_SUCCESS:
      return deletePersonalisedHomeworkFromMap(state, action.personalisedHomeworkId);
    case _actions.PUBLISH_PERSONALISED_HOMEWORK_SUCCESS:
      return publishPersonalisedHomework(state, action.phId);
    default:
      return state;
  }
}

function addPersonalisedHomeworkToMap(state, data) {
  var ph = _model2.default.create(data);
  return state.set(ph.id, ph);
}

function deletePersonalisedHomeworkFromMap(state, phId) {
  return state.delete(phId);
}

function publishPersonalisedHomework(state, phId) {
  var ph = state.get(phId).set('status', _Homework.status.PUBLISHED);
  return state.set(phId, ph);
}

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1714);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _Personalised = __webpack_require__(136);

var _Types = __webpack_require__(212);

var _Types2 = _interopRequireDefault(_Types);

var _ScrollPageToHereNow = __webpack_require__(657);

var _ScrollPageToHereNow2 = _interopRequireDefault(_ScrollPageToHereNow);

var _HomeworkContentItemForm = __webpack_require__(1718);

var _HomeworkContentItemForm2 = _interopRequireDefault(_HomeworkContentItemForm);

var _StudentPicker = __webpack_require__(1724);

var _StudentPicker2 = _interopRequireDefault(_StudentPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_CONTENT_ENTRIES_PER_HOMEWORK = 10;

var PersonalisedHomeworkFormCard = function (_Component) {
  _inherits(PersonalisedHomeworkFormCard, _Component);

  function PersonalisedHomeworkFormCard() {
    _classCallCheck(this, PersonalisedHomeworkFormCard);

    var _this = _possibleConstructorReturn(this, (PersonalisedHomeworkFormCard.__proto__ || Object.getPrototypeOf(PersonalisedHomeworkFormCard)).call(this));

    _this.state = {
      // this model is set when there are local (unsaved) changes
      // otherwise the model in props is used instead
      model: undefined
    };
    _this._onModelChanged = _this._onModelChanged.bind(_this);
    _this._getConsumedContentTypes = _this._getConsumedContentTypes.bind(_this);
    _this._onAddNewHomeworkContentClicked = _this._onAddNewHomeworkContentClicked.bind(_this);
    _this._onStudentCheckedOrUnchecked = _this._onStudentCheckedOrUnchecked.bind(_this);
    return _this;
  }

  _createClass(PersonalisedHomeworkFormCard, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var newModel = _ref.model,
          onNotSaveable = _ref.onNotSaveable;

      if (this._getCurrentModel().id !== newModel.id) {
        // wipe the local model
        this.setState({ model: undefined }, function () {
          // signal that the form is no longer saveable to permit unsaved changes nav.
          onNotSaveable && onNotSaveable();
        });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      var _props = this.props,
          onNowSaveable = _props.onNowSaveable,
          onNotSaveable = _props.onNotSaveable;

      var isSaveable = this._isFormSaveableWithState(nextState);
      var isSaveablePrev = this._isFormSaveableWithState(this.state);
      if (isSaveable && !isSaveablePrev) {
        onNowSaveable && onNowSaveable();
      } else if (!isSaveable && isSaveablePrev) {
        onNotSaveable && onNotSaveable();
      }
    }
  }, {
    key: 'forceSubmit',
    value: function forceSubmit(extraParam) {
      // heh. called by the unsaved changes warning dialog when "save" is pushed.
      var onSubmit = this.props.onSubmit;

      if (!onSubmit) return;
      onSubmit(this._getCurrentModel(), extraParam);
    }
  }, {
    key: '_getCurrentModel',
    value: function _getCurrentModel() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;

      return state.model || this.props.model;
    }
  }, {
    key: '_getConsumedContentTypes',
    value: function _getConsumedContentTypes() {
      return this._getCurrentModel().contents.map(function (item) {
        return item.homeworkTypeId;
      });
    }
  }, {
    key: '_isFormSaveableWithState',
    value: function _isFormSaveableWithState() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;

      // use local form state (set when there are changes)
      var isValid = _Personalised.PersonalisedHomework.validate(state.model);
      if (!isValid) {
        _omniCommonUi.log.info('PersonalisedHomework form model is not valid. model:', state.model);
      }
      return isValid;
    }
  }, {
    key: '_isAddHomeworkContentAllowed',
    value: function _isAddHomeworkContentAllowed() {
      var homeworkContentTypes = this.props.homeworkContentTypes;

      var currentCount = this._getCurrentModel().contents.size;
      return currentCount < MAX_CONTENT_ENTRIES_PER_HOMEWORK && this._getConsumedContentTypes().size < homeworkContentTypes.size;
    }
  }, {
    key: '_onAddNewHomeworkContentClicked',
    value: function _onAddNewHomeworkContentClicked() {
      var newModel = this._getCurrentModel().update('contents', function (contents) {
        return contents.push(new _Personalised.PersonalisedHomework.Item());
      });
      this.setState({ model: newModel });
    }
  }, {
    key: '_onStudentCheckedOrUnchecked',
    value: function _onStudentCheckedOrUnchecked(studentId, isChecked) {
      var checkedStudentIds = this._getCurrentModel().studentIds;
      var newSet = isChecked ? checkedStudentIds.add(studentId) : checkedStudentIds.delete(studentId);
      var newModel = this._getCurrentModel().set('studentIds', newSet);
      this.setState({ model: newModel });
    }
  }, {
    key: '_onAllStudentsCheckedOrUnchecked',
    value: function _onAllStudentsCheckedOrUnchecked(isChecked) {
      var students = this.props.students;

      var newSet = void 0;
      if (isChecked) {
        newSet = new _immutable.Set(students.map(function (student) {
          return student.studentGeneralInfo.id;
        }));
      } else {
        newSet = new _immutable.Set();
      }
      var newModel = this._getCurrentModel().set('studentIds', newSet);
      this.setState({ model: newModel });
    }
  }, {
    key: '_onModelChanged',
    value: function _onModelChanged(model) {
      this.setState({ model: model });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          students = _props2.students,
          _onSubmit = _props2.onSubmit,
          onDiscard = _props2.onDiscard,
          overrideHeadingText = _props2.overrideHeadingText,
          courseTypeLevelId = _props2.courseTypeLevelId,
          homeworkContentTypes = _props2.homeworkContentTypes;

      var model = this._getCurrentModel(); // DO NOT use props.model in render() !!
      var headingText = model.id ? 'Personalised Practice ' + model.id : 'Personalised Practice';
      if (_is_js2.default.string(overrideHeadingText)) {
        headingText = overrideHeadingText;
      }
      var labelClassName = (0, _classnames2.default)((0, _omniCommonUi.testClass)('personalised-homework-form-checkbox-all'), _style2.default.PersonalisedHomeworkFormCard_allStudentsCheckbox);
      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        null,
        _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: headingText }),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.PersonalisedHomeworkFormCard },
          _react2.default.createElement(_ScrollPageToHereNow2.default, { offset: -250 }),
          _react2.default.createElement(
            _omniCommonUi.Form,
            { className: _style2.default.PersonalisedHomeworkFormCard_form,
              onSubmit: function onSubmit() {
                if (!_onSubmit) return;
                _onSubmit(_this2._getCurrentModel());
              } },
            this._getCurrentModel().contents.map(function (item, idx, items) {
              return _react2.default.createElement(_HomeworkContentItemForm2.default, { key: item.homeworkTypeId,
                courseTypeLevelId: courseTypeLevelId,
                homeworkContentTypes: homeworkContentTypes,
                contentItem: item,
                contentItemIndex: idx,
                contentItemCount: items.size,
                model: _this2._getCurrentModel(),
                onModelChange: _this2._onModelChanged });
            }),
            this._isAddHomeworkContentAllowed() ? _react2.default.createElement(
              'p',
              { className: _style2.default.PersonalisedHomeworkFormCard_addLink },
              _react2.default.createElement(
                'a',
                { onClick: this._onAddNewHomeworkContentClicked,
                  role: 'button',
                  tabIndex: 0,
                  style: { cursor: 'pointer' } },
                _react2.default.createElement(_omniCommonUi.Icon, { id: 'new-message' }),
                ' Add Practice'
              )
            ) : null,
            _react2.default.createElement(
              'h4',
              null,
              'Assigned to'
            ),
            students.size ? _react2.default.createElement(
              'label',
              { className: labelClassName,
                htmlFor: 'PersonalisedHomeworkFormCard-checkbox-all' },
              _react2.default.createElement(_omniCommonUi.Checkbox, { id: 'PersonalisedHomeworkFormCard-checkbox-all',
                value: 'all',
                checked: students.size === model.studentIds.size,
                onChange: function onChange(isChecked) {
                  _this2._onAllStudentsCheckedOrUnchecked(isChecked);
                } }),
              _react2.default.createElement(
                'span',
                { className: _style2.default.PersonalisedHomeworkFormCard_allStudentsCheckbox_labelText },
                'All Students'
              )
            ) : _react2.default.createElement(
              'p',
              null,
              'There are no students available for assignment.'
            ),
            _react2.default.createElement(_StudentPicker2.default, { students: students,
              selectedStudentIds: model.studentIds,
              onStudentCheckedOrUnchecked: this._onStudentCheckedOrUnchecked }),
            _react2.default.createElement(
              _omniCommonUi.Button.Container,
              { className: _style2.default.PersonalisedHomeworkFormCard_buttons,
                align: 'right' },
              _react2.default.createElement(
                _omniCommonUi.Button,
                { type: _omniCommonUi.Button.Type.primary,
                  attrs: { type: 'submit' },
                  className: (0, _omniCommonUi.testClass)('personalised-homework-form-save'),
                  disabled: !this._isFormSaveableWithState() },
                'Save'
              ),
              _react2.default.createElement(
                _omniCommonUi.Button,
                { type: _omniCommonUi.Button.Type.default,
                  className: (0, _omniCommonUi.testClass)('personalised-homework-form-discard'),
                  onClick: onDiscard ? function (ev) {
                    ev.preventDefault();
                    onDiscard();
                  } : null },
                'Discard'
              )
            )
          )
        )
      );
    }
  }]);

  return PersonalisedHomeworkFormCard;
}(_react.Component);

PersonalisedHomeworkFormCard.propTypes = {
  model: _propTypes2.default.instanceOf(_Personalised.PersonalisedHomework).isRequired,
  overrideHeadingText: _propTypes2.default.string,
  students: _propTypes2.default.object.isRequired,
  courseTypeLevelId: _propTypes2.default.string,
  homeworkContentTypes: _propTypes2.default.instanceOf(_immutable.Map).isRequired,

  // form lifecycle callbacks
  onSubmit: _propTypes2.default.func,
  onDiscard: _propTypes2.default.func,

  // these two are for toggling save via the unsaved changes warning dialog
  onNowSaveable: _propTypes2.default.func,
  onNotSaveable: _propTypes2.default.func
};

function mapStateToProps(state, _ref2) {
  var courseTypeLevelId = _ref2.courseTypeLevelId;

  return {
    homeworkContentTypes: _Types2.default.accessors.getTypesByCourseTypeLevelId(state, courseTypeLevelId)
  };
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null, null, { withRef: true })( // allow getWrappedInstance
PersonalisedHomeworkFormCard);

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1715);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._56mnShMQlrn-nXmgVEyUt{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._56mnShMQlrn-nXmgVEyUt h4{font-weight:600;margin-bottom:.85714rem;margin-top:1.42857rem}._56mnShMQlrn-nXmgVEyUt h4:first-child{margin-top:0}._2S-JDp5sCAVbBXyEKoEkT-{position:relative}.C9img7EFSr0vdVvFAhYmz{margin-top:.35714rem}.C9img7EFSr0vdVvFAhYmz a{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:9.28571rem}._26TX-tvtpNZGqJv3QVZmu4{cursor:pointer;line-height:2;margin-left:.71429rem}._1f1BIfFzXSxOuB5FUcBeSL{padding-left:.35714rem}._3U77L2DXjCyYaF8ThDnSr9{margin-top:1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"PersonalisedHomeworkFormCard": "_56mnShMQlrn-nXmgVEyUt",
	"PersonalisedHomeworkFormCard_form": "_2S-JDp5sCAVbBXyEKoEkT-",
	"PersonalisedHomeworkFormCard_addLink": "C9img7EFSr0vdVvFAhYmz",
	"PersonalisedHomeworkFormCard_allStudentsCheckbox": "_26TX-tvtpNZGqJv3QVZmu4",
	"PersonalisedHomeworkFormCard_allStudentsCheckbox_labelText": "_1f1BIfFzXSxOuB5FUcBeSL",
	"PersonalisedHomeworkFormCard_buttons": "_3U77L2DXjCyYaF8ThDnSr9"
};

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTypesByCourseTypeLevelId = getTypesByCourseTypeLevelId;
exports.getTypeByHomeworkTypeCode = getTypeByHomeworkTypeCode;
function getTypesByCourseTypeLevelId(state, courseTypeLevelI) {
  return getHomeworkTypesState(state) && getHomeworkTypesState(state).filter(function (type) {
    return type.courseTypeLevelId === courseTypeLevelI;
  });
}

function getTypeByHomeworkTypeCode(state, code) {
  return getHomeworkTypesState(state) && getHomeworkTypesState(state).get(code);
}

function getHomeworkTypesState(state) {
  return state.get('rootReducer').get('homeworkTypes');
}

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = homeworkTypesReducer;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(748);

var _model = __webpack_require__(749);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function homeworkTypesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_HOMEWORK_CONTENT_TYPES_SUCCESS:
      return addTypesToMap(state, action);
    default:
      return state;
  }
}

function addTypesToMap(state, _ref) {
  var payload = _ref.payload,
      courseTypeLevelId = _ref.courseTypeLevelId;

  var newState = state;
  if (payload && payload.length > 0) {
    payload.forEach(function (type) {
      var model = _model2.default.create(Object.assign({}, type, { courseTypeLevelId: courseTypeLevelId }));
      newState = newState.set(model.id, model);
    });
  }
  return newState;
}

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1719);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _Personalised = __webpack_require__(136);

var _HomeworkTypeSelect = __webpack_require__(1721);

var _HomeworkTypeSelect2 = _interopRequireDefault(_HomeworkTypeSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HomeworkContentItemForm = function (_PureComponent) {
  _inherits(HomeworkContentItemForm, _PureComponent);

  function HomeworkContentItemForm() {
    _classCallCheck(this, HomeworkContentItemForm);

    var _this = _possibleConstructorReturn(this, (HomeworkContentItemForm.__proto__ || Object.getPrototypeOf(HomeworkContentItemForm)).call(this));

    _this.state = {
      isConfirmDeleteDialogOpen: false
    };
    _this._getConsumedContentTypes = _this._getConsumedContentTypes.bind(_this);
    _this._onHomeworkTypeSelected = _this._onHomeworkTypeSelected.bind(_this);
    _this._onTextareaValueChanged = _this._onTextareaValueChanged.bind(_this);
    _this._onDeleteHomeworkContentClicked = _this._onDeleteHomeworkContentClicked.bind(_this);
    _this._onCloseDeleteDialog = _this._onCloseDeleteDialog.bind(_this);
    _this._onConfirmDeleteHomeworkContentClicked = _this._onConfirmDeleteHomeworkContentClicked.bind(_this);
    return _this;
  }

  _createClass(HomeworkContentItemForm, [{
    key: '_getCurrentModel',
    value: function _getCurrentModel() {
      return this.props.model;
    }
  }, {
    key: '_getConsumedContentTypes',
    value: function _getConsumedContentTypes() {
      return this._getCurrentModel().contents.map(function (item) {
        return item.homeworkTypeId;
      });
    }
  }, {
    key: '_onHomeworkTypeSelected',
    value: function _onHomeworkTypeSelected(index, id) {
      var homeworkContentTypes = this.props.homeworkContentTypes;

      var _homeworkContentTypes = homeworkContentTypes.get(id),
          defaultContent = _homeworkContentTypes.defaultContent;

      var shouldSetContent = _is_js2.default.string(defaultContent);
      var newModel = this._getCurrentModel().update('contents', function (contents) {
        return contents.update(index, function (item) {
          var _item = shouldSetContent ? item.set('content', defaultContent) : item;
          return _item.set('homeworkTypeId', id);
        });
      });
      this.props.onModelChange(newModel);
    }
  }, {
    key: '_onTextareaValueChanged',
    value: function _onTextareaValueChanged(ev) {
      var index = this.props.contentItemIndex;

      var commentText = ev.target.value;
      var newModel = this._getCurrentModel().update('contents', function (contents) {
        return contents.update(index, function (item) {
          return item.set('content', commentText);
        });
      });
      this.props.onModelChange(newModel);
    }
  }, {
    key: '_onDeleteHomeworkContentClicked',
    value: function _onDeleteHomeworkContentClicked() {
      this.setState({ isConfirmDeleteDialogOpen: true });
    }
  }, {
    key: '_onCloseDeleteDialog',
    value: function _onCloseDeleteDialog() {
      this.setState({ isConfirmDeleteDialogOpen: false });
    }
  }, {
    key: '_onConfirmDeleteHomeworkContentClicked',
    value: function _onConfirmDeleteHomeworkContentClicked() {
      var index = this.props.contentItemIndex;

      var newModel = this._getCurrentModel().update('contents', function (contents) {
        return contents.delete(index);
      });
      this.props.onModelChange(newModel);
      this._onCloseDeleteDialog();
    }
  }, {
    key: '_renderCharacterLimitReadout',
    value: function _renderCharacterLimitReadout(index, maxCharacters) {
      var text = this._getCurrentModel().contents.get(index).content;
      var textLength = 0;
      if (_is_js2.default.string(text)) {
        textLength = text.length;
      }
      return _react2.default.createElement(
        'aside',
        { className: _style2.default.HomeworkContentItemForm_charactersUsed },
        textLength,
        '/',
        maxCharacters,
        ' characters'
      );
    }
  }, {
    key: '_renderConfirmDeleteDialog',
    value: function _renderConfirmDeleteDialog() {
      return _react2.default.createElement(_omniCommonUi.ConfirmDialog, { isOpen: this.state.isConfirmDeleteDialogOpen,
        primaryButtonContent: 'Delete',
        secondaryButtonContent: 'Cancel',
        content: 'Are you sure you want to delete this content item?',
        onPrimaryClick: this._onConfirmDeleteHomeworkContentClicked,
        onSecondaryClick: this._onCloseDeleteDialog,
        onRequestClose: this._onCloseDeleteDialog });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          courseTypeLevelId = _props.courseTypeLevelId,
          item = _props.contentItem,
          index = _props.contentItemIndex,
          count = _props.contentItemCount;

      return _react2.default.createElement(
        'div',
        { className: _style2.default.HomeworkContentItemForm },
        _react2.default.createElement(
          'h4',
          null,
          'Type'
        ),
        _react2.default.createElement(_HomeworkTypeSelect2.default, { courseTypeLevelId: courseTypeLevelId,
          value: item.homeworkTypeId,
          getConsumedTypes: this._getConsumedContentTypes,
          onSelect: function onSelect(typeId) {
            _this2._onHomeworkTypeSelected(index, typeId);
          } }),
        _react2.default.createElement(
          'h4',
          null,
          'Content'
        ),
        _react2.default.createElement(_omniCommonUi.TextArea, { className: (0, _classnames2.default)(_style2.default.HomeworkContentItemForm_textarea, (0, _omniCommonUi.testClass)('personalised-homework-form-content')),
          name: 'content',
          value: item.content,
          maxLength: 500,
          onChange: this._onTextareaValueChanged }),
        this._renderCharacterLimitReadout(index, 500),
        count > 1 ? _react2.default.createElement(
          'div',
          { className: _style2.default.HomeworkContentItemForm_deleteButton },
          _react2.default.createElement(
            _omniCommonUi.Tooltip,
            { text: 'Delete',
              placement: 'top',
              trigger: ['hover'] },
            _react2.default.createElement(
              'a',
              { onClick: this._onDeleteHomeworkContentClicked,
                role: 'button',
                tabIndex: 0 },
              _react2.default.createElement(_omniCommonUi.Icon, { id: 'trash' })
            )
          )
        ) : null,
        this._renderConfirmDeleteDialog()
      );
    }
  }]);

  return HomeworkContentItemForm;
}(_react.PureComponent);

HomeworkContentItemForm.propTypes = {
  courseTypeLevelId: _propTypes2.default.string.isRequired,
  homeworkContentTypes: _propTypes2.default.instanceOf(_immutable.Map).isRequired,
  contentItem: _propTypes2.default.instanceOf(_immutable.Map).isRequired,
  contentItemIndex: _propTypes2.default.number.isRequired,
  contentItemCount: _propTypes2.default.number.isRequired,
  model: _propTypes2.default.instanceOf(_Personalised.PersonalisedHomework).isRequired,
  onModelChange: _propTypes2.default.func.isRequired
};

exports.default = HomeworkContentItemForm;

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1720);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1Lq1JPcLwrgUUndhwsOnCD+._1Lq1JPcLwrgUUndhwsOnCD{margin-top:1.78571rem}._15EbDZW_e7WIv6QKU_948N{-webkit-user-select:auto;-moz-user-select:auto;-ms-user-select:auto;user-select:auto}._2nfQ4DTwaIIk6nIRxtT2uP{float:right;font-size:1.14286rem;left:-.71429rem;position:relative;top:-2.14286rem}._2nfQ4DTwaIIk6nIRxtT2uP a{cursor:pointer}._3XK8Cs737lM6GaQYE9KKId{font-size:.85714rem;line-height:1rem;position:absolute;right:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);

// exports
exports.locals = {
	"HomeworkContentItemForm": "_1Lq1JPcLwrgUUndhwsOnCD",
	"HomeworkContentItemForm_textarea": "_15EbDZW_e7WIv6QKU_948N",
	"HomeworkContentItemForm_deleteButton": "_2nfQ4DTwaIIk6nIRxtT2uP",
	"HomeworkContentItemForm_charactersUsed": "_3XK8Cs737lM6GaQYE9KKId"
};

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1722);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(10);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _Types = __webpack_require__(212);

var _Types2 = _interopRequireDefault(_Types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HomeworkTypeSelect = function (_PureComponent) {
  _inherits(HomeworkTypeSelect, _PureComponent);

  function HomeworkTypeSelect(props) {
    _classCallCheck(this, HomeworkTypeSelect);

    var _this = _possibleConstructorReturn(this, (HomeworkTypeSelect.__proto__ || Object.getPrototypeOf(HomeworkTypeSelect)).call(this, props));

    _this._onSelect = _this._onSelect.bind(_this);
    return _this;
  }

  _createClass(HomeworkTypeSelect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ val: this.props.value });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.fetchTypesIfNeeded(this.props.courseTypeLevelId);
    }
  }, {
    key: '_onSelect',
    value: function _onSelect(val) {
      this.setState({
        val: val
      });
      this.props.onSelect(val);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          homeworkContentTypes = _props.homeworkContentTypes,
          getConsumedTypes = _props.getConsumedTypes,
          value = _props.value;

      if (!homeworkContentTypes.isEmpty()) {
        var consumedTypes = getConsumedTypes();
        var options = homeworkContentTypes.toArray().filter(function (_ref) {
          var id = _ref.id;
          return id === value || !consumedTypes.contains(id);
        }).map(function (type) {
          return {
            label: type.name,
            value: type.id
          };
        });
        return _react2.default.createElement(_omniCommonUi.Form.Select, { options: options,
          className: _style2.default.HomeworkTypeSelect,
          name: 'homeworkType',
          value: this.state.val,
          setValue: this._onSelect,
          clearable: false,
          searchable: false });
      }
      return null;
    }
  }]);

  return HomeworkTypeSelect;
}(_react.PureComponent);

HomeworkTypeSelect.propTypes = {
  courseTypeLevelId: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string,
  homeworkContentTypes: _propTypes2.default.instanceOf(_immutable.Map).isRequired,
  onSelect: _propTypes2.default.func,
  getConsumedTypes: _propTypes2.default.func,
  fetchTypesIfNeeded: _propTypes2.default.func.isRequired
};

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_Types2.default.actions, dispatch);
}

function mapStateToProps(state, _ref2) {
  var courseTypeLevelId = _ref2.courseTypeLevelId;

  return {
    homeworkContentTypes: _Types2.default.accessors.getTypesByCourseTypeLevelId(state, courseTypeLevelId)
  };
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(HomeworkTypeSelect);

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1723);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._32F0NxawFB4A8FYArLPw2h{margin-bottom:1.42857rem;width:100%}._32F0NxawFB4A8FYArLPw2h+h4{margin-top:-.35714rem}@media only screen and (min-width:480px){._32F0NxawFB4A8FYArLPw2h{width:17.85714rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"HomeworkTypeSelect": "_32F0NxawFB4A8FYArLPw2h"
};

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentPicker = undefined;

var _style = __webpack_require__(1725);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _recompose = __webpack_require__(100);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__(3);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StudentPicker = exports.StudentPicker = function StudentPicker(_ref) {
  var students = _ref.students,
      selectedStudentIds = _ref.selectedStudentIds,
      onStudentCheckedOrUnchecked = _ref.onStudentCheckedOrUnchecked;
  return _react2.default.createElement(
    'div',
    { className: _style2.default.StudentPicker },
    _react2.default.createElement(
      _omniCommonUi.Grid,
      { className: _style2.default.StudentPicker_grid },
      _react2.default.createElement(
        _omniCommonUi.Grid.Group,
        null,
        students.map(function (member) {
          var studentId = member.studentGeneralInfo.id;
          var checkboxId = 'StudentPicker#checkbox-' + studentId;
          return _react2.default.createElement(
            _omniCommonUi.Grid.Item,
            { key: studentId,
              className: _style2.default.StudentPicker_item,
              xs: 12,
              sm: 6,
              lg: 4 },
            _react2.default.createElement(
              'label',
              { className: (0, _classnames3.default)(_style2.default.StudentPicker_student, _defineProperty({}, _style2.default.__selected, selectedStudentIds.has(studentId))),
                htmlFor: checkboxId },
              _react2.default.createElement(_omniCommonUi.Checkbox, { name: 'studentIds[]',
                id: checkboxId,
                value: studentId,
                checked: selectedStudentIds.has(studentId),
                onChange: function onChange(isChecked) {
                  onStudentCheckedOrUnchecked && onStudentCheckedOrUnchecked(studentId, isChecked);
                } }),
              _react2.default.createElement(
                _omniCommonUi.StudentCard,
                { borderless: true, backgroundless: true },
                _react2.default.createElement(_omniCommonUi.StudentCard.Profile, { className: _style2.default.StudentPicker_student_profile,
                  name: member.studentGeneralInfo.firstName,
                  surname: member.studentGeneralInfo.lastName,
                  localName: member.studentGeneralInfo.localName,
                  avatarUrl: member.studentGeneralInfo.avatarUrl,
                  gender: member.studentGeneralInfo.gender })
              )
            )
          );
        })
      )
    )
  );
};

StudentPicker.propTypes = {
  students: _propTypes2.default.shape({
    map: _propTypes2.default.func.isRequired
  }).isRequired,
  selectedStudentIds: _propTypes2.default.instanceOf(_immutable.Set).isRequired,
  onStudentCheckedOrUnchecked: _propTypes2.default.func
};

StudentPicker.defaultProps = {
  selectedStudentIds: new _immutable.Set()
};

exports.default = (0, _recompose.pure)(StudentPicker);

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1726);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1pQRUsgMwHuNQYZtxgkHxK{margin-bottom:-var(--studentSeparator)}._1pQRUsgMwHuNQYZtxgkHxK:after{background:#fbfbfb;content:\"\";display:block;height:var(--studentSeparator);margin-top:-var(--studentSeparator);position:relative;width:100%;z-index:1}._177sUIMdGywbZUh-fn3odr{margin-bottom:0}._2Z7BNV5By4igRFYqanByAw{margin:0}._3hZgcCGpjEo_rkxc21PJh3{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:var(--studentSeparator) solid #dedede;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:0 .71429rem;white-space:nowrap}._3hZgcCGpjEo_rkxc21PJh3 [data-prop=name]{font-weight:400;text-decoration:underline}._3mLUlHLHcQqnAsfNNYwO-6{margin-left:-.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentPicker": "_1pQRUsgMwHuNQYZtxgkHxK",
	"StudentPicker_grid": "_177sUIMdGywbZUh-fn3odr",
	"StudentPicker_item": "_2Z7BNV5By4igRFYqanByAw",
	"StudentPicker_student": "_3hZgcCGpjEo_rkxc21PJh3",
	"__selected": "_3K3YUY3vDGbiM-MHuoy7rl",
	"StudentPicker_student_profile": "_3mLUlHLHcQqnAsfNNYwO-6"
};

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalisedHomeworkViewCard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1728);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(10);

var _immutable = __webpack_require__(3);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _CardActionIcons = __webpack_require__(85);

var _CardActionIcons2 = _interopRequireDefault(_CardActionIcons);

var _StudentCardProfile = __webpack_require__(84);

var _StudentCardProfile2 = _interopRequireDefault(_StudentCardProfile);

var _Types = __webpack_require__(212);

var _Types2 = _interopRequireDefault(_Types);

var _ContentItem = __webpack_require__(318);

var _ContentItem2 = _interopRequireDefault(_ContentItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PersonalisedHomeworkViewCard = exports.PersonalisedHomeworkViewCard = function (_Component) {
  _inherits(PersonalisedHomeworkViewCard, _Component);

  function PersonalisedHomeworkViewCard() {
    _classCallCheck(this, PersonalisedHomeworkViewCard);

    return _possibleConstructorReturn(this, (PersonalisedHomeworkViewCard.__proto__ || Object.getPrototypeOf(PersonalisedHomeworkViewCard)).apply(this, arguments));
  }

  _createClass(PersonalisedHomeworkViewCard, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          fetchTypesIfNeeded = _props.fetchTypesIfNeeded,
          courseTypeLevelId = _props.courseTypeLevelId;

      fetchTypesIfNeeded(courseTypeLevelId);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      var fetchTypesIfNeeded = nextProps.fetchTypesIfNeeded,
          courseTypeLevelId = nextProps.courseTypeLevelId;

      fetchTypesIfNeeded(courseTypeLevelId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          students = _props2.students,
          homeworkContentTypes = _props2.homeworkContentTypes,
          personalisedHomework = _props2.personalisedHomework,
          index = _props2.index,
          contentClassName = _props2.contentClassName,
          editPersonalisedHomeworkLinkHref = _props2.editPersonalisedHomeworkLinkHref,
          deletePersonalisedHomeworkLinkHref = _props2.deletePersonalisedHomeworkLinkHref;


      var renderContent = function renderContent() {
        return personalisedHomework.contents.map(function (item) {
          var contentType = void 0;
          var contentTypeName = _immutable.Map.isMap(homeworkContentTypes) && ( // eslint-disable-line no-cond-assign
          contentType = homeworkContentTypes.get(item.homeworkTypeId)) && contentType.name ? contentType.name : '';
          return _react2.default.createElement(_ContentItem2.default, { key: personalisedHomework.id + item.homeworkTypeId,
            homeworkType: contentTypeName,
            boardValue: item.content });
        });
      };

      var renderStudents = function renderStudents() {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.PersonalisedHomeworkViewCard_students },
          _react2.default.createElement(
            'h5',
            { className: _style2.default.PersonalisedHomeworkViewCard_heading },
            'Assigned to'
          ),
          _react2.default.createElement(
            _omniCommonUi.Grid,
            null,
            _react2.default.createElement(
              _omniCommonUi.Grid.Group,
              null,
              students.map(function (member) {
                var studentId = member.studentGeneralInfo.id;
                return _react2.default.createElement(
                  _omniCommonUi.Grid.Item,
                  { key: studentId,
                    className: _style2.default.PersonalisedHomeworkViewCard_studentCell,
                    xs: 12,
                    sm: 6,
                    lg: 4 },
                  _react2.default.createElement(
                    _omniCommonUi.StudentCard,
                    { borderless: true, backgroundless: true },
                    _react2.default.createElement(_StudentCardProfile2.default, { className: _style2.default.PersonalisedHomeworkViewCard_studentProfile,
                      studentId: member.studentGeneralInfo.id })
                  )
                );
              })
            )
          )
        );
      };

      var renderActionIcons = function renderActionIcons() {
        return _react2.default.createElement(_CardActionIcons2.default, { editHref: editPersonalisedHomeworkLinkHref,
          deleteHref: deletePersonalisedHomeworkLinkHref,
          hideEditIcon: !personalisedHomework.canEdit,
          hideDeleteIcon: !personalisedHomework.canDelete });
      };

      var heading = 'Personalised Homework ' + (index + 1);
      var className = (0, _classnames2.default)(this.props.className, (0, _omniCommonUi.testClass)('personalised-homework-' + (index + 1)), (0, _omniCommonUi.testClass)('personalised-homework'));

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: className },
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          { text: heading, stackMode: 'horizontal' },
          renderActionIcons()
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: contentClassName },
          renderContent(),
          renderStudents()
        )
      );
    }
  }]);

  return PersonalisedHomeworkViewCard;
}(_react.Component);

PersonalisedHomeworkViewCard.propTypes = {
  className: _propTypes2.default.string,
  contentClassName: _propTypes2.default.string,
  index: _propTypes2.default.number,
  students: _propTypes2.default.object,
  courseTypeLevelId: _propTypes2.default.string,
  personalisedHomework: _propTypes2.default.object,
  editPersonalisedHomeworkLinkHref: _propTypes2.default.string,
  deletePersonalisedHomeworkLinkHref: _propTypes2.default.string,
  homeworkContentTypes: _propTypes2.default.instanceOf(_immutable.Map),
  fetchTypesIfNeeded: _propTypes2.default.func.isRequired
};

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_Types2.default.actions, dispatch);
}

function mapStateToProps(state, _ref) {
  var courseTypeLevelId = _ref.courseTypeLevelId;

  return {
    homeworkContentTypes: _Types2.default.accessors.getTypesByCourseTypeLevelId(state, courseTypeLevelId)
  };
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(PersonalisedHomeworkViewCard);

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1729);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3y6aO1nL87uEMKCc60sF2i{color:#a4a4a4;font-size:1rem;font-weight:400;margin:0}._2sk-UJRDvCXFSjFyydl5Rh{padding:1.42857rem;padding-bottom:0!important;width:100%}@media only screen and (min-width:640px){._2sk-UJRDvCXFSjFyydl5Rh{padding:1.42857rem 2.14286rem}}._3ECVJIv5vkLLcVtWtdt6CA:not(:last-child){margin-bottom:0!important}._3aRUqy0hdJgWxu7EJpio5e{margin-left:-1.07143rem}._3aRUqy0hdJgWxu7EJpio5e [data-prop=name]{font-weight:400;text-decoration:underline}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"PersonalisedHomeworkViewCard_heading": "_3y6aO1nL87uEMKCc60sF2i",
	"PersonalisedHomeworkViewCard_students": "_2sk-UJRDvCXFSjFyydl5Rh",
	"PersonalisedHomeworkViewCard_studentCell": "_3ECVJIv5vkLLcVtWtdt6CA",
	"PersonalisedHomeworkViewCard_studentProfile": "_3aRUqy0hdJgWxu7EJpio5e"
};

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HomeworkTemplateReducer;

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(167);

var _model2 = _interopRequireDefault(_model);

var _actions = __webpack_require__(751);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HomeworkTemplateReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_HOMEWORK_TEMPLATE_SUCCESS:
      return addHomeworkTemplateToMap(state, action);
    default:
      return state;
  }
}

function addHomeworkTemplateToMap(state, _ref) {
  var payload = _ref.payload,
      sessionId = _ref.sessionId;

  var newState = state;
  newState = newState.set('' + sessionId, new _immutable.OrderedMap(payload.reduce(function (pairs, activity) {
    var template = _model2.default.create(activity);
    var mapKey = template.unitId + '-' + template.lessonNumber;
    pairs.push([mapKey, template]);
    return pairs;
  }, [])));
  return newState;
}

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = HomeworkContentReducer;

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(167);

var _model2 = _interopRequireDefault(_model);

var _actions = __webpack_require__(321);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HomeworkContentReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_HOMEWORK_CONTENT_SUCCESS:
      return addHomeworkContentToMap(state, action);
    case _actions.ASSIGN_HOMEWORK_SUCCESS:
      return addHomeworkContentToMap(state, _extends({}, action, {
        payload: action.editedGroupHomeworkItems
      }));
    default:
      return state;
  }
}

function addHomeworkContentToMap(state, _ref) {
  var payload = _ref.payload,
      sessionId = _ref.sessionId;

  var newState = state;
  newState = newState.set('' + sessionId, new _immutable.OrderedMap(payload.reduce(function (pairs, activity) {
    var contentItem = _model2.default.create(activity);
    var mapKey = contentItem.unitId + '-' + contentItem.lessonNumber;
    pairs.push([mapKey, contentItem]);
    return pairs;
  }, [])));
  return newState;
}

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(754);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(757);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = unlockHomework;

var _actions = __webpack_require__(756);

var _model = __webpack_require__(322);

var _model2 = _interopRequireDefault(_model);

var _immutable = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function unlockHomework() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({ unlockable: false });
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_UNLOCK_HOMEWORK_SUCCESS:
      return state.set(action.groupId, onSuccess(action.payload));
    default:
      return state;
  }
}

function onSuccess(response) {
  return response.reduce(function (map, unlock) {
    return map.set('' + unlock.studentId, _model2.default.crete(unlock));
  }, new _immutable.Map());
}

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(322);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  switch (key) {
    case 'studentId':
      return [key, '' + val];
    case 'latestUnlockedSequence':
    case 'totalLessonAmount':
      return [key, Number.parseInt(val, 10)];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUnlockHomeworksUnlockable = isUnlockHomeworksUnlockable;
exports.getUnlockHomeworksByGroup = getUnlockHomeworksByGroup;
exports.canEditUnlockHomework = canEditUnlockHomework;

var _Group = __webpack_require__(13);

function isUnlockHomeworksUnlockable(unlockHomeworks) {
  return unlockHomeworks.some(function (unlockHomework) {
    return unlockHomework.manualLessonSequence && unlockHomework.manualLessonSequence <= unlockHomework.totalLessonAmount && unlockHomework.manualLessonSequence > unlockHomework.latestUnlockedSequence;
  });
}

function getUnlockHomeworksByGroup(state, groupId) {
  return state.get('rootReducer').get('unlockHomework').get('' + groupId);
}

function canEditUnlockHomework(state, groupId) {
  return !_Group.actions.hasContentPath(state, groupId);
}

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _style = __webpack_require__(1737);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEY_MATCH_REGEX = /^[0-9]$/;

var UnlockManualInput = function (_PureComponent) {
  _inherits(UnlockManualInput, _PureComponent);

  function UnlockManualInput() {
    _classCallCheck(this, UnlockManualInput);

    var _this = _possibleConstructorReturn(this, (UnlockManualInput.__proto__ || Object.getPrototypeOf(UnlockManualInput)).call(this));

    _this._onMouseDown = _this._onMouseDown.bind(_this);
    _this._onTouchOrClick = _this._onTouchOrClick.bind(_this);
    _this._onFocus = _this._onFocus.bind(_this);
    _this._onKeyDown = _this._onKeyDown.bind(_this);
    _this._onBlur = _this._onBlur.bind(_this);
    _this._selectTheWholeText = _this._selectTheWholeText.bind(_this);
    return _this;
  }

  _createClass(UnlockManualInput, [{
    key: '_onMouseDown',
    value: function _onMouseDown(ev) {
      ev.preventDefault();
    }
  }, {
    key: '_onTouchOrClick',
    value: function _onTouchOrClick(ev) {
      ev.preventDefault();
      var htmlEl = this.contentEditableComp.htmlEl;

      htmlEl && htmlEl.focus();
    }
  }, {
    key: '_onFocus',
    value: function _onFocus() {
      this._selectTheWholeText();
    }
  }, {
    key: '_onBlur',
    value: function _onBlur() {
      var _props = this.props,
          manualLessonSequence = _props.manualLessonSequence,
          max = _props.max,
          min = _props.min;

      if (_is_js2.default.number(manualLessonSequence) && manualLessonSequence > min && manualLessonSequence <= max) return;
      this.props.onChange('');
    }
  }, {
    key: '_onKeyDown',
    value: function _onKeyDown(ev) {
      var _props2 = this.props,
          manualLessonSequence = _props2.manualLessonSequence,
          max = _props2.max;


      if (ev.key === 'Backspace') return true;
      if (!ev.key.match(KEY_MATCH_REGEX)) {
        ev.preventDefault();
        return;
      }

      var selection = window.getSelection().toString();
      var newManualUnlockLessonSequence = manualLessonSequence;
      if ((_is_js2.default.string(newManualUnlockLessonSequence) || _is_js2.default.number(newManualUnlockLessonSequence)) && selection !== newManualUnlockLessonSequence.toString()) {
        newManualUnlockLessonSequence = '' + manualLessonSequence + ev.key;
      } else {
        newManualUnlockLessonSequence = ev.key;
      }

      if (newManualUnlockLessonSequence.startsWith('0')) {
        ev.preventDefault();
        return;
      }
      newManualUnlockLessonSequence = Number.parseInt(newManualUnlockLessonSequence, 10);
      if (newManualUnlockLessonSequence > max || newManualUnlockLessonSequence === 0 || !ev.key.match(KEY_MATCH_REGEX)) {
        ev.preventDefault();
      }
    }
  }, {
    key: '_selectTheWholeText',
    value: function _selectTheWholeText() {
      (0, _omniCommonUi.selectElementContents)(this.contentEditableComp.htmlEl);
    }
  }, {
    key: '_isDisable',
    value: function _isDisable() {
      var _props3 = this.props,
          min = _props3.min,
          max = _props3.max,
          disabled = _props3.disabled;


      if (disabled) {
        return true;
      }
      if (!_is_js2.default.number(max)) {
        return true;
      }
      if (_is_js2.default.number(min) && max - min < 1) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props4 = this.props,
          manualLessonSequence = _props4.manualLessonSequence,
          onChange = _props4.onChange;

      var unlockManualInputStyles = (0, _classnames3.default)(_style2.default.UnlockManualInput, _defineProperty({}, _style2.default.__disable, this._isDisable()));
      return _react2.default.createElement(
        'div',
        { className: unlockManualInputStyles,
          ref: function ref(_ref2) {
            _this2.outerNode = _ref2;
          },
          onMouseDown: this._onMouseDown,
          onClick: this._onTouchOrClick,
          onTouchStart: this._onTouchOrClick },
        _react2.default.createElement(_omniCommonUi.ContentEditable, { className: _style2.default.UnlockManualInput_manualUnlockLessonSequence,
          ref: function ref(_ref) {
            _this2.contentEditableComp = _ref;
          },
          html: _is_js2.default.number(manualLessonSequence) ? manualLessonSequence.toString() : '',
          disabled: this._isDisable(),
          onFocus: this._onFocus,
          onChange: onChange,
          onKeyDown: this._onKeyDown,
          onMouseDown: this._onMouseDown,
          onBlur: this._onBlur,
          onClick: this._selectTheWholeText,
          onTouchStart: this._selectTheWholeText })
      );
    }
  }]);

  return UnlockManualInput;
}(_react.PureComponent);

UnlockManualInput.propTypes = {
  disabled: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  min: _propTypes2.default.number,
  max: _propTypes2.default.number.isRequired,
  manualLessonSequence: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};

exports.default = UnlockManualInput;

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1738);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1426_a0Wl8BbqteCVW2MPp{background-color:#fff;border:.07143rem solid transparent;border-color:#ccc;-webkit-border-radius:.35714rem;-moz-border-radius:.35714rem;border-radius:.35714rem;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:60%;min-height:2.5rem;width:7.14286rem}._1426_a0Wl8BbqteCVW2MPp._1fpvIz5IuOi265HuIulAVD{cursor:not-allowed}._1426_a0Wl8BbqteCVW2MPp._1f6EDORoOOK3BLB7xKZ6GB{cursor:text;height:100%;padding:.35714rem 1.07143rem;width:100%}._1426_a0Wl8BbqteCVW2MPp [contentEditable=true]{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;cursor:text;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:-webkit-calc(1.14286rem + var(--fontSize));height:-moz-calc(1.14286rem + var(--fontSize));height:calc(1.14286rem + var(--fontSize));-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:.71429rem;width:100%}._1426_a0Wl8BbqteCVW2MPp [contentEditable=false]{background-color:#a4a4a4}._1426_a0Wl8BbqteCVW2MPp [contentEditable=true]:empty{padding-top:.57143rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"UnlockManualInput": "_1426_a0Wl8BbqteCVW2MPp",
	"__disable": "_1fpvIz5IuOi265HuIulAVD",
	"_manualUnlockLessonSequence": "_1f6EDORoOOK3BLB7xKZ6GB"
};

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.individualDevelopmentPlanList = individualDevelopmentPlanList;
exports.individualDevelopmentPlan = individualDevelopmentPlan;
exports.idpApprovalList = idpApprovalList;
exports.idpParticipation = idpParticipation;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(168);

var _IdpList = __webpack_require__(1740);

var _IdpList2 = _interopRequireDefault(_IdpList);

var _GroupIdpList = __webpack_require__(1743);

var _GroupIdpList2 = _interopRequireDefault(_GroupIdpList);

var _Idp = __webpack_require__(1745);

var _Idp2 = _interopRequireDefault(_Idp);

var _Suggestions = __webpack_require__(764);

var _Suggestions2 = _interopRequireDefault(_Suggestions);

var _IdpApprovalList = __webpack_require__(1754);

var _IdpApprovalList2 = _interopRequireDefault(_IdpApprovalList);

var _IdpParticipation = __webpack_require__(1756);

var _IdpParticipation2 = _interopRequireDefault(_IdpParticipation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function individualDevelopmentPlanList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS:
      return onGroupIdpListSuccess(state, action);
    case _actions.FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS:
      return state.update(action.groupIdpId, function (groupIdp) {
        return onIdpListSuccess(groupIdp, action);
      });
    default:
      return state;
  }
}

function onGroupIdpListSuccess(state, action) {
  var result = state;
  action.payload.forEach(function (groupIdp) {
    result = result.set(groupIdp.id, _GroupIdpList2.default.create(groupIdp).set('groupId', action.groupId));
  });
  return result;
}

function onIdpListSuccess(groupIdp, action) {
  if (!groupIdp) return;
  return groupIdp.set('idpList', createIdpList(action.payload));
}

function createIdpList(idpList) {
  var result = new _immutable.List();
  idpList.forEach(function (idpItem) {
    result = result.push(_IdpList2.default.create(idpItem));
  });
  return result;
}

function individualDevelopmentPlan() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_IDP_LEARNING_RESULT_SUCCESS:
      return state.update(action.idpId, function (originIdp) {
        return onIdpLearningResultSuccess(originIdp, action);
      });
    case _actions.FETCH_IDP_CHECK_SUCCESS:
      return state.update(action.idpId, function (originIdp) {
        return onIdpCheckSuccess(originIdp, action);
      });
    case _actions.FETCH_IDP_FEEDBACK_SUGGESTIONS_SUCCESS:
      return state.update(action.idpId, function (originIdp) {
        return onIdpFeedbackSuggestionsSuccess(originIdp, action);
      });
    default:
      return state;
  }
}

function onIdpLearningResultSuccess() {
  var originIdp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Idp2.default();
  var action = arguments[1];

  var learningResult = _Idp2.default.create(action.payload);
  learningResult = {
    id: learningResult.id,
    studentId: learningResult.studentId,
    period: learningResult.period,
    learningResult: learningResult.learningResult,
    dosRejectedComment: learningResult.dosRejectedComment,
    lastUpdatedTimeUtc: learningResult.lastUpdatedTimeUtc
  };
  return originIdp.merge(learningResult);
}

function onIdpCheckSuccess() {
  var originIdp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Idp2.default();
  var action = arguments[1];

  return originIdp.set('check', action.payload);
}

function onIdpFeedbackSuggestionsSuccess() {
  var originIdp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Idp2.default();
  var action = arguments[1];

  var suggestions = { studentIDPFeedbackSuggestions: _Suggestions2.default.create(action.payload) };
  return originIdp.merge(suggestions);
}

function idpApprovalList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_IDP_APPROVAL_LIST_SUCCESS:
      return state.set(action.groupIdpId, new _immutable.List(action.payload.map(function (idpApproval) {
        return _IdpApprovalList2.default.create(idpApproval);
      })));
    default:
      return state;
  }
}

function idpParticipation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_IDP_PARTICIPATION_SUCCESS:
      return action.payload.reduce(function (participationMap, item) {
        return participationMap.set('' + item.id, _IdpParticipation2.default.create(item));
      }, (0, _immutable.Map)());
    default:
      return state;
  }
}

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(759);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1741);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _Interval = __webpack_require__(81);

var _model = __webpack_require__(759);

var _model2 = _interopRequireDefault(_model);

var _SkillResult = __webpack_require__(760);

var _SkillResult2 = _interopRequireDefault(_SkillResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'skillResults':
      return [key, new _immutable.List(val.map(function (skill) {
        return new _SkillResult2.default(skill);
      }))];
    case 'period':
      return [key, _Interval.Interval.create({
        start: val.startDate,
        end: val.endDate
      })];
    default:
      return [key, (0, _immutable.fromJS)(val)];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SkillResultRecord = _immutable2.default.Record({
  skillId: undefined,
  name: undefined,
  score: undefined,
  layeredScore: undefined,
  layeredFullMark: undefined
});

var SkillResult = function (_SkillResultRecord) {
  _inherits(SkillResult, _SkillResultRecord);

  function SkillResult() {
    _classCallCheck(this, SkillResult);

    return _possibleConstructorReturn(this, (SkillResult.__proto__ || Object.getPrototypeOf(SkillResult)).apply(this, arguments));
  }

  return SkillResult;
}(SkillResultRecord);

exports.default = SkillResult;

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(761);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1744);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(761);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var create = function create(data) {
  return new _model2.default(data).set('idpList', new _immutable.List());
};

exports.default = create;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(762);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1746);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(762);

var _model2 = _interopRequireDefault(_model);

var _LearningResult = __webpack_require__(1747);

var _LearningResult2 = _interopRequireDefault(_LearningResult);

var _Suggestions = __webpack_require__(764);

var _Suggestions2 = _interopRequireDefault(_Suggestions);

var _DosRejectedComment = __webpack_require__(1752);

var _DosRejectedComment2 = _interopRequireDefault(_DosRejectedComment);

var _Interval = __webpack_require__(81);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'period':
      return [key, _Interval.Interval.create({
        start: val.startDate,
        end: val.endDate
      })];
    case 'learningResult':
      return [key, _LearningResult2.default.create(val)];
    case 'studentIDPFeedbackSuggestions':
      return [key, _Suggestions2.default.create(val)];
    case 'dosRejectedComment':
      return [key, _DosRejectedComment2.default.create(val)];
    case 'lastUpdatedTimeUtc':
      return [key, _omniCommonUi.moment.utc(val)];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(763);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1748);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(763);

var _model2 = _interopRequireDefault(_model);

var _SkillResult = __webpack_require__(760);

var _SkillResult2 = _interopRequireDefault(_SkillResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'skillResults':
      return [key, new _immutable.List(val.map(function (skillResult) {
        return new _SkillResult2.default(skillResult);
      }))];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(765);

var _model2 = _interopRequireDefault(_model);

var _SkillSuggestion = __webpack_require__(1750);

var _SkillSuggestion2 = _interopRequireDefault(_SkillSuggestion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'skillSuggestions':
      return [key, new _immutable.List(val.map(function (skillSuggestion) {
        return _SkillSuggestion2.default.create(skillSuggestion);
      }))];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(766);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1751);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;
exports.default = _model2.default;

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(766);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'selectedRecommendationList':
      return [key, new _immutable.List(val.map(function (id) {
        return '' + id;
      }))];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(767);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1753);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(767);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(768);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1755);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(768);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'studentIDPId':
      return [key, '' + val]; // stringify
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(769);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1757);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(769);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'id':
      return [key, '' + val]; // stringify
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatToRenderUI = formatToRenderUI;
exports.formatToRenderUIBySkillNameHFv4 = formatToRenderUIBySkillNameHFv4;
exports.getGroupIdpList = getGroupIdpList;
exports.getIdpList = getIdpList;
exports.getIdpId = getIdpId;
exports.getIdpStatus = getIdpStatus;
exports.getMissingInformation = getMissingInformation;
exports.getDosRejectedComment = getDosRejectedComment;
exports.getStudentInfo = getStudentInfo;
exports.getReportCardInfo = getReportCardInfo;
exports.calculateQuizAverageScore = calculateQuizAverageScore;
exports.formatSkillScore = formatSkillScore;
exports.getSuggestionsInfo = getSuggestionsInfo;
exports.shouldShowSuggestions = shouldShowSuggestions;
exports.getApprovalContent = getApprovalContent;
exports.getReportName = getReportName;
exports.isHfv4ProgressReportOneOrTwo = isHfv4ProgressReportOneOrTwo;
exports.getApprovalContentHFv4 = getApprovalContentHFv4;
exports.isGroupIdpFetched = isGroupIdpFetched;
exports.getEmptyActions = getEmptyActions;
exports.isSuggestionsInfoComplete = isSuggestionsInfoComplete;

var _Group = __webpack_require__(13);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function formatToRenderUI(idpList, timeZone) {
  if (!idpList || !idpList.size || !timeZone) return idpList;

  return idpList.map(function (idpRow) {
    return Object.assign({}, idpRow.update('period', function (period) {
      return getPeriodText(period, timeZone, 'list');
    }).toJS(), formatSkillResults(idpRow.skillResults));
  });

  function formatSkillResults(results) {
    var sortedResult = results.sort(resortByScore);
    var skillResults = {};
    sortedResult.forEach(function (result, index) {
      Object.assign(skillResults, _defineProperty({}, 'skill' + (index + 1), result.name + ' ' + formatSkillScore(result.score)));
    });
    return skillResults;
  }
}

function formatToRenderUIBySkillNameHFv4(idpList, timeZone) {
  if (!idpList || !idpList.size || !timeZone) return idpList;

  return idpList.map(function (idpRow) {
    return Object.assign({}, idpRow.update('period', function (period) {
      return getPeriodText(period, timeZone, 'list');
    }).toJS(), formatSkillResultsByName(idpRow.skillResults));
  });

  function formatSkillResultsByName(results) {
    var skillResults = {};
    results.forEach(function (result) {
      skillResults[result.name] = formatSkillScore(result.score);
    });
    return skillResults;
  }
}

function getGroupIdpList(state, groupId) {
  var groupIdpList = state.get('rootReducer').get('individualDevelopmentPlanList');
  if (!groupId) return groupIdpList;
  return groupIdpList.filter(function (groupIdpInfo) {
    return groupIdpInfo.groupId === groupId;
  });
}

function getIdpList(groupIdpList, groupIdpId) {
  if (!groupIdpList || groupIdpList.size === 0) return;
  var _groupIdp = groupIdpList.find(function (groupIdp) {
    return groupIdp.id.toString() === groupIdpId;
  });
  if (!_groupIdp) return;
  return _groupIdp.idpList;
}

function getIdpId(state, groupIdpId, studentId) {
  var groupIdpList = state.get('rootReducer').get('individualDevelopmentPlanList');
  var idpList = getIdpList(groupIdpList, groupIdpId);

  if (!idpList || !idpList.size > 0 || !studentId) return;
  var _idp = idpList.find(function (idp) {
    return idp.studentId === studentId;
  });
  return _idp && _idp.id && _idp.id.toString();
}

function getIdpStatus(state, idpId) {
  var groupIdpList = state.get('rootReducer').get('individualDevelopmentPlanList');
  if (!groupIdpList || groupIdpList.size === 0) return;
  var idpList = new _immutable.List();
  groupIdpList.forEach(function (groupIdp) {
    idpList = idpList.concat(groupIdp.idpList);
  });
  if (idpList.size === 0) return;
  return idpList.find(function (idp) {
    return idp.id.toString() === idpId.toString();
  }).status;
}

function getMissingInformation(state, idpId) {
  if (!idpId) return [];
  var idp = state.get('rootReducer').get('individualDevelopmentPlan').get(idpId);
  if (!idp || !idp.check || idp.check.isPassed) return [];
  return idp.check.missingItems || [];
}

function getDosRejectedComment(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupIdpId = _ownProps$params.groupIdpId,
      studentId = _ownProps$params.studentId;

  var idpId = getIdpId(state, groupIdpId, studentId);
  var individualDevelopmentPlan = state.get('rootReducer').get('individualDevelopmentPlan').get(idpId);
  return individualDevelopmentPlan && individualDevelopmentPlan.dosRejectedComment;
}

function getStudentInfo(state, ownProps) {
  var _ownProps$params2 = ownProps.params,
      groupId = _ownProps$params2.groupId,
      groupIdpId = _ownProps$params2.groupIdpId,
      studentId = _ownProps$params2.studentId;

  var idpId = getIdpId(state, groupIdpId, studentId);
  var individualDevelopmentPlan = state.get('rootReducer').get('individualDevelopmentPlan').get(idpId);
  if (!individualDevelopmentPlan || !individualDevelopmentPlan.period) return;

  var _groupActions$getCent = _Group.actions.getCentre(state, groupId),
      timeZone = _groupActions$getCent.timeZone,
      centre = _groupActions$getCent.name;

  var period = individualDevelopmentPlan.period;
  var _state$get$get$get$da = state.get('rootReducer').get('groups').get(groupId).data,
      groupSummary = _state$get$get$get$da.groupSummary,
      number = _state$get$get$get$da.number;

  var groupMembers = state.get('rootReducer').get('groupMembers');
  var status = getIdpStatus(state, idpId);

  if (!timeZone || !studentId || !groupMembers || !period) return;
  var forPeriod = getPeriodText(period, timeZone, 'detail');

  var _groupMembers$get$get = groupMembers.get(studentId).get('studentGeneralInfo'),
      firstName = _groupMembers$get$get.firstName,
      lastName = _groupMembers$get$get.lastName,
      localName = _groupMembers$get$get.localName;

  var name = getStudentName(firstName, lastName, localName);
  var teacherOne = groupSummary.mainTeacherName,
      teacherTwo = groupSummary.coTeacherName,
      progressAdvisor = groupSummary.pa;

  var course = number && number.substring(0, number.indexOf('-'));

  return {
    forPeriod: forPeriod,
    name: name,
    course: course,
    teacherOne: teacherOne,
    teacherTwo: teacherTwo,
    progressAdvisor: progressAdvisor,
    centre: centre,
    status: status,
    period: period
  };
}

function getStudentName(firstName, lastName, localName) {
  return firstName + ' ' + lastName + ' ' + localName;
}

function getPeriodText(period, timeZone, type) {
  switch (type) {
    case 'list':
      return formatDate(period.start, timeZone, 'YYYY.MM.DD') + '-' + formatDate(period.end, timeZone, 'YYYY.MM.DD');
    case 'detail':
      return 'from ' + formatDate(period.start, timeZone, 'YYYY-MM-DD') + ' to ' + ('' + formatDate(period.end, timeZone, 'YYYY-MM-DD'));
    default:
      return null;
  }
}

function formatDate(momentDate, timeZone, customFormat) {
  if (!momentDate) return;
  return momentDate.clone().tz(timeZone).format(customFormat);
}

function getReportCardInfo(state, ownProps) {
  var _ownProps$params3 = ownProps.params,
      groupId = _ownProps$params3.groupId,
      groupIdpId = _ownProps$params3.groupIdpId,
      studentId = _ownProps$params3.studentId;

  var hasPaperBasedHomework = _Group.actions.hasPaperBasedHomework(state, groupId);

  var _groupActions$getCent2 = _Group.actions.getCentre(state, groupId),
      timeZone = _groupActions$getCent2.timeZone;

  var idpId = getIdpId(state, groupIdpId, studentId);
  var individualDevelopmentPlan = state.get('rootReducer').get('individualDevelopmentPlan').get(idpId);
  if (!individualDevelopmentPlan) return;
  var learningResult = individualDevelopmentPlan.get('learningResult');
  if (!learningResult) return;

  var skillResults = learningResult.skillResults;


  var reportCard = {};
  reportCard.skillResults = skillResults.map(function (skillResult) {
    return skillResult.update('score', formatSkillScore);
  });
  reportCard.lastUpdatedTimeUtc = formatDate(individualDevelopmentPlan.lastUpdatedTimeUtc, timeZone, 'YYYY-MM-DD');
  var finishedPaperBasedHomework = learningResult.finishedPaperBasedHomework,
      totalPaperBasedHomework = learningResult.totalPaperBasedHomework,
      finishedOnlineHomework = learningResult.finishedOnlineHomework,
      totalOnlineHomework = learningResult.totalOnlineHomework,
      presentAttendence = learningResult.presentAttendence,
      totalAttendence = learningResult.totalAttendence;

  if (hasPaperBasedHomework) {
    if (_is_js2.default.number(totalPaperBasedHomework) && _is_js2.default.number(finishedPaperBasedHomework)) {
      reportCard.homeworkCompletion = finishedPaperBasedHomework + '/' + totalPaperBasedHomework + ' Assignments';
    } else {
      reportCard.homeworkCompletion = '–';
    }
  }

  if (_is_js2.default.number(finishedOnlineHomework) && _is_js2.default.number(totalOnlineHomework)) {
    reportCard.online = finishedOnlineHomework + '/' + totalOnlineHomework + ' Assignments';
  } else {
    reportCard.online = '–';
  }

  if (_is_js2.default.number(presentAttendence) && _is_js2.default.number(totalAttendence)) {
    reportCard.attendance = presentAttendence + '/' + totalAttendence + ' Attended';
  } else {
    reportCard.attendance = '–';
  }

  var quizAverageScore = calculateQuizAverageScore(skillResults);
  reportCard.totalScore = _is_js2.default.number(quizAverageScore) ? quizAverageScore + '%' : '–';

  return reportCard;
}

function calculateQuizAverageScore(skillResults) {
  if (!skillResults || skillResults.size <= 0) return null;

  var totalScore = 0;
  var scoreCount = 0;
  skillResults.forEach(function (skillResult) {
    if (_is_js2.default.number(skillResult.score)) {
      totalScore += Math.min(100, skillResult.score * 100);
      scoreCount += 1;
    }
  });

  if (scoreCount === 0) return null;
  return Math.round(totalScore / scoreCount);
}

function formatSkillScore(score) {
  var defaultText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '–';

  if (_is_js2.default.not.number(score)) return defaultText;
  return Math.round(score * 100) + '%';
}

function getSuggestionsInfo(state, ownProps) {
  var _ownProps$params4 = ownProps.params,
      groupId = _ownProps$params4.groupId,
      groupIdpId = _ownProps$params4.groupIdpId,
      studentId = _ownProps$params4.studentId;

  var _groupActions$getCent3 = _Group.actions.getCentre(state, groupId),
      timeZone = _groupActions$getCent3.timeZone;

  var idpId = getIdpId(state, groupIdpId, studentId);
  var individualDevelopmentPlan = state.get('rootReducer').get('individualDevelopmentPlan').get(idpId);
  if (!individualDevelopmentPlan) return;

  var suggestionsInfo = individualDevelopmentPlan.studentIDPFeedbackSuggestions;
  var learningResult = individualDevelopmentPlan.get('learningResult');
  if (!suggestionsInfo || !learningResult) return;
  var skillResults = learningResult.skillResults;

  skillResults = skillResults.sort(resortByScore);
  var teacherId = suggestionsInfo.teacherId,
      overallSuggestion = suggestionsInfo.overallSuggestion,
      suggestedTime = suggestionsInfo.suggestedTime,
      participationId = suggestionsInfo.participationId,
      skillSuggestions = suggestionsInfo.skillSuggestions;


  var mergedSkillSuggestions = new _immutable.List();
  if (skillResults.size > 0) {
    mergedSkillSuggestions = skillSuggestions.map(function (skillSuggestion) {
      var mappedSkillResult = skillResults.find(function (skillResult) {
        return skillResult.skillId === skillSuggestion.skillId;
      });
      return skillSuggestion.set('name', mappedSkillResult && mappedSkillResult.name).set('score', mappedSkillResult && mappedSkillResult.score);
    });
    mergedSkillSuggestions = mergedSkillSuggestions.sort(resortByScore);
  }

  var isSimplifiedTeacherFeedback = isHfv4ProgressReportOneOrTwo(state, groupId, groupIdpId);

  return {
    teacherId: teacherId,
    overallSuggestion: overallSuggestion,
    suggestedTime: suggestedTime,
    participationId: participationId,
    skillSuggestions: mergedSkillSuggestions,
    skillResults: skillResults,
    timeZone: timeZone,
    isSimplifiedTeacherFeedback: isSimplifiedTeacherFeedback
  };
}

function shouldShowSuggestions(groupIdpList, groupIdpId, studentId) {
  if (!groupIdpId || !groupIdpList || groupIdpList.size === 0) return;
  var idpList = groupIdpList.get(parseInt(groupIdpId, 10)).idpList;
  if (idpList.size === 0) return;
  var idpSummary = idpList.find(function (_idp) {
    return _idp.studentId === studentId;
  });
  if (!idpSummary) return;
  return idpSummary.shouldShowSuggestions;
}

function mergeIdpApprovalRow(idpList, idpDetailList, members, idpId) {
  if (idpList.size === 0) return;
  var idpSummary = idpList.find(function (idp) {
    return idp.id.toString() === idpId;
  });
  var idpDetail = idpDetailList.get(idpId);
  if (!idpSummary || !idpDetail) return;

  var feedbackSuggestion = idpDetail.studentIDPFeedbackSuggestions;
  var studentId = idpSummary.studentId,
      skillResults = idpSummary.skillResults;
  var teacherId = feedbackSuggestion.teacherId,
      overallSuggestion = feedbackSuggestion.overallSuggestion,
      suggestedTime = feedbackSuggestion.suggestedTime,
      participationId = feedbackSuggestion.participationId;
  var skillSuggestions = feedbackSuggestion.skillSuggestions;

  var _members$find = members.find(function (member) {
    return member.studentGeneralInfo.id === studentId;
  }),
      studentInfo = _members$find.studentGeneralInfo;

  skillSuggestions = skillSuggestions.map(function (skillSuggestion) {
    var skillResult = skillResults.find(function (result) {
      return result.skillId === skillSuggestion.skillId;
    });
    return skillSuggestion.merge(skillResult);
  });
  skillSuggestions = skillSuggestions.sort(resortByScore);
  return {
    idpId: idpId,
    studentInfo: studentInfo,
    teacherId: teacherId,
    overallSuggestion: overallSuggestion,
    suggestedTime: suggestedTime,
    participationId: participationId,
    skillSuggestions: skillSuggestions,
    shouldShowSuggestions: idpSummary.shouldShowSuggestions
  };
}

function getApprovalContent(idpList, idpDetailList, members, idpId) {
  var row = mergeIdpApprovalRow(idpList, idpDetailList, members, idpId);
  if (!row) return;
  return {
    idpId: row.idpId,
    studentInfo: row.studentInfo,
    teacherId: row.teacherId,
    overallSuggestion: row.overallSuggestion,
    suggestedTime: row.suggestedTime,
    participationId: row.participationId,
    skillSuggestions: row.skillSuggestions,
    shouldShowSuggestions: row.shouldShowSuggestions
  };
}

function resortByScore(a, b) {
  return a.score - b.score;
}

function getReportName(state, groupIdpId) {
  var defaultName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var groupIdpList = getGroupIdpList(state);
  if (!groupIdpList) return defaultName;
  var groupIdpInfo = groupIdpList.get(parseInt(groupIdpId, 10));
  if (!groupIdpInfo) return defaultName;
  return groupIdpInfo.name;
}

var HFV4_SIMPLIFIED_TEACHER_FEEDBACK_NAMES = ['progress report 1', 'progress report 2'];

function isHfv4ProgressReportOneOrTwo(state, groupId, groupIdpId) {
  if (!groupId || !groupIdpId || !_Group.actions.isHFV4CourseTypeGroup(state, groupId)) {
    return false;
  }
  var normalized = (getReportName(state, groupIdpId) || '').trim().toLowerCase();
  return HFV4_SIMPLIFIED_TEACHER_FEEDBACK_NAMES.includes(normalized);
}

function getApprovalContentHFv4(state, groupId, groupIdpId, idpList, idpDetailList, members, idpId) {
  var row = mergeIdpApprovalRow(idpList, idpDetailList, members, idpId);
  if (!row) return;
  return Object.assign({}, row, {
    isSimplifiedTeacherFeedback: isHfv4ProgressReportOneOrTwo(state, groupId, groupIdpId)
  });
}

function isGroupIdpFetched(state, groupIdpId) {
  var groupIdpList = state.get('rootReducer').get('individualDevelopmentPlanList');
  return _is_js2.default.not.undefined(groupIdpList.get(parseInt(groupIdpId, 10)));
}

function isEmpty(value) {
  return _is_js2.default.falsy(value) || _is_js2.default.existy(value) && _is_js2.default.empty(value);
}

function getEmptyActions(suggestionsInfo, shouldShowSuggestion, isSkillSuggestionManualOnly) {
  var overallSuggestion = suggestionsInfo.overallSuggestion,
      participationId = suggestionsInfo.participationId,
      skillSuggestions = suggestionsInfo.skillSuggestions,
      isSimplifiedTeacherFeedback = suggestionsInfo.isSimplifiedTeacherFeedback;

  var result = 0;

  if (isSimplifiedTeacherFeedback) {
    return isEmpty(overallSuggestion) ? 1 : 0;
  }

  if (isEmpty(overallSuggestion)) {
    result += 1;
  }

  if (isEmpty(participationId)) {
    result += 1;
  }

  if (shouldShowSuggestion && skillSuggestions && skillSuggestions.size > 0) {
    result += skillSuggestions.reduce(function (emptyNumber, skillSuggestion) {
      var selectedRecommendationList = skillSuggestion.selectedRecommendationList,
          suggestion = skillSuggestion.suggestion;

      if (isSkillSuggestionManualOnly) {
        if (isEmpty(suggestion)) {
          return emptyNumber + 1;
        }
      } else if (selectedRecommendationList.size <= 0) {
        return emptyNumber + 1;
      }

      return emptyNumber;
    }, 0);
  }
  return result;
}

function isSuggestionsInfoComplete(state, ownProps) {
  var _ownProps$params5 = ownProps.params,
      groupId = _ownProps$params5.groupId,
      groupIdpId = _ownProps$params5.groupIdpId,
      studentId = _ownProps$params5.studentId;

  var groupIdpList = state.get('rootReducer').get('individualDevelopmentPlanList');
  var shouldShowSuggestion = shouldShowSuggestions(groupIdpList, groupIdpId, studentId);
  var isSkillSuggestionManualOnly = !!_Group.actions.isFRV2CourseTypeGroup(state, groupId);
  var suggestionsInfo = getSuggestionsInfo(state, ownProps);

  if (suggestionsInfo && suggestionsInfo.isSimplifiedTeacherFeedback) {
    var _emptyActions = getEmptyActions(suggestionsInfo, shouldShowSuggestion, isSkillSuggestionManualOnly);
    return _emptyActions === 0;
  }

  if (shouldShowSuggestion) {
    var skillSuggestions = suggestionsInfo && suggestionsInfo.skillSuggestions;
    if (!skillSuggestions || skillSuggestions.size <= 0) {
      return false;
    }
  }
  var emptyActions = getEmptyActions(suggestionsInfo, shouldShowSuggestion, isSkillSuggestionManualOnly);
  return emptyActions === 0;
}

exports.default = formatToRenderUI;

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _RecommendationItem = __webpack_require__(1760);

var _RecommendationItem2 = _interopRequireDefault(_RecommendationItem);

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(326);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'skillRecommendationItems':
      return [key, new _immutable.List(val.map(function (recommendationItem) {
        return _RecommendationItem2.default.create(recommendationItem);
      }))];
    case 'skillId':
      return [key, '' + val];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(771);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1761);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _model = __webpack_require__(771);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  switch (key) {
    case 'id':
      return [key, '' + val];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = skillRecommendations;

var _actions = __webpack_require__(770);

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(326);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function skillRecommendations() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_SKILL_RECOMMENDATION_SUCCESS:
      return state.set('' + action.groupId, onSuccess(action.payload));
    default:
      return state;
  }
}

function onSuccess(payload) {
  return payload.reduce(function (result, skillRecommendation) {
    return result.set('' + skillRecommendation.skillId, _model2.default.create(skillRecommendation));
  }, new _immutable.Map());
}

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(773);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(774);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1765);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._34pBzhECDEOZfgy9CKS-yh{padding:1.42857rem}@media only screen and (min-width:640px){._34pBzhECDEOZfgy9CKS-yh{padding:2.14286rem}}.aY9qmh-VQ7Lpas-3PNjd0{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:600;letter-spacing:.03571rem;line-height:1.28571;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;color:inherit;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;font-size:.85714rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;outline:0;text-decoration:none;text-transform:uppercase}._19aPsoyAyKD9b6-k1aJON4{margin-left:.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"IndividualDevelopmentPlanListView_content": "_34pBzhECDEOZfgy9CKS-yh",
	"IndividualDevelopmentPlanListViewLink": "aY9qmh-VQ7Lpas-3PNjd0",
	"IndividualDevelopmentPlanListViewLink_icon": "_19aPsoyAyKD9b6-k1aJON4"
};

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1767);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._15DbEJbn28DpeUUMfn2r_E{cursor:default;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._2ztt0neYo_j9Pfa71zpNou{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-color:#a4a4a4;color:#fff;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-webkit-flex:0;-moz-box-flex:0;-ms-flex:0;flex:0;font-size:.71429rem;font-weight:400;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;letter-spacing:.07143rem;padding:.35714rem;text-transform:uppercase;white-space:nowrap}._2ztt0neYo_j9Pfa71zpNou._3nUYR2AvNo_d9cXts5GyTb{background-color:#74d17f}._2ztt0neYo_j9Pfa71zpNou._1WTgIptoyzmFSx-KW4nOu3{background-color:#f7932d}._2ztt0neYo_j9Pfa71zpNou._1PEORBHEfjhBon0n7oJ1r6{background-color:#a4a4a4}._2ztt0neYo_j9Pfa71zpNou._3mjGyitOoNXoYN1SoiKduu{background-color:#de4c4c}._2ztt0neYo_j9Pfa71zpNou._3Z3cBlAnWJYcenrLu16Rzy{background-color:#92205f}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"IndividualDevelopmentPlanStatus": "_15DbEJbn28DpeUUMfn2r_E",
	"IndividualDevelopmentPlanStatus_inner": "_2ztt0neYo_j9Pfa71zpNou",
	"__ready": "_3nUYR2AvNo_d9cXts5GyTb",
	"__sent": "_1WTgIptoyzmFSx-KW4nOu3",
	"__published": "_1PEORBHEfjhBon0n7oJ1r6",
	"__missing": "_3mjGyitOoNXoYN1SoiKduu",
	"__rejected": "_3Z3cBlAnWJYcenrLu16Rzy"
};

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1769);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Api = __webpack_require__(11);

var _Exporter = __webpack_require__(50);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

var _omniCommonUi = __webpack_require__(0);

var _IndividualDevelopmentPlanStatus = __webpack_require__(68);

var _LanguageRadio = __webpack_require__(74);

var _LanguageRadio2 = _interopRequireDefault(_LanguageRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXPORT_FILENAME = 'Progress Reports.pdf';
var EXPORT_MIME_TYPE = 'application/pdf';

var ExportAllHandler = function (_Component) {
  _inherits(ExportAllHandler, _Component);

  function ExportAllHandler() {
    _classCallCheck(this, ExportAllHandler);

    var _this = _possibleConstructorReturn(this, (ExportAllHandler.__proto__ || Object.getPrototypeOf(ExportAllHandler)).call(this));

    _this.state = {
      isExportRequested: false
    };

    _this._onLanguageChanged = _this._onLanguageChanged.bind(_this);
    return _this;
  }

  _createClass(ExportAllHandler, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ choosedLanguageCode: this.props.languageCode });
    }
  }, {
    key: '_close',
    value: function _close() {
      var _props = this.props,
          buildRoute = _props.buildRoute,
          pushRoute = _props.pushRoute,
          groupId = _props.groupId,
          groupIdpId = _props.groupIdpId;

      pushRoute(buildRoute('/group/' + groupId + '/progress-report/' + groupIdpId));
    }
  }, {
    key: '_performExport',
    value: function _performExport() {
      var _this2 = this;

      var groupIdpId = this.props.groupIdpId;


      if (_is_js2.default.falsy(groupIdpId)) {
        _omniCommonUi.log.error('ExportAllHandler is not exporting - groupIdpId is not set!');
        return;
      }

      var url = (0, _Api.buildUrl)('/group-compulsory-idps/' + groupIdpId + '/printings?' + ('languageCode=' + (this.state.choosedLanguageCode || _Languages2.default.defaultLanguageCode)));

      _Exporter.exporter.get(url, EXPORT_FILENAME, false, EXPORT_MIME_TYPE).then(function () {
        _this2._close();
      }).catch(function () {
        _this2.setState({ isExportErrorOccurred: true });
      });

      this.setState({ isExportRequested: true });
    }
  }, {
    key: '_onLanguageChanged',
    value: function _onLanguageChanged(languageCode) {
      this.setState({ choosedLanguageCode: languageCode });
    }
  }, {
    key: '_isDefaultLanguage',
    value: function _isDefaultLanguage() {
      if (!this.props.languageCode) return true;
      return _Languages2.default.defaultLanguageCode === this.props.languageCode;
    }
  }, {
    key: '_renderLanguageRadio',
    value: function _renderLanguageRadio() {
      return _react2.default.createElement(_LanguageRadio2.default, { name: 'language-picker',
        languageCode: this.props.languageCode,
        onChecked: this._onLanguageChanged,
        choosedLanguageCode: this.state.choosedLanguageCode });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var individualDevelopmentPlanList = this.props.individualDevelopmentPlanList;


      if (this.state.isExportErrorOccurred) {
        return _react2.default.createElement(_omniCommonUi.ErrorDialog, { isOpen: true,
          onConfirmClick: function onConfirmClick() {
            _this3._close();
          } });
      }

      var exportCount = countByStatus(_IndividualDevelopmentPlanStatus.IdpStatus.COMPLETED);
      var bestCaseCount = individualDevelopmentPlanList.size;
      var notAvailableCount = bestCaseCount - exportCount;

      // no reports are exportable :( (we shouldn't end up here though)
      if (exportCount <= 0) {
        return _react2.default.createElement(
          _omniCommonUi.ConfirmDialog,
          { isOpen: true,
            title: 'No reports are available',
            primaryButtonContent: 'Close',
            onPrimaryClick: function onPrimaryClick() {
              return _this3._close();
            },
            onRequestClose: function onRequestClose() {
              return _this3._close();
            } },
          _react2.default.createElement(
            'p',
            { className: _style2.default.ExportAllHandler_feedback_noneToExport },
            'There are no reports available to export.'
          )
        );
      }

      // all reports are exportable; no need to display stats.
      if (exportCount === bestCaseCount) {
        if (!this._isDefaultLanguage()) {
          return _react2.default.createElement(
            _omniCommonUi.ConfirmDialog,
            { isOpen: true,
              isLoading: this.state.isExportRequested,
              title: 'Choose Language:',
              primaryButtonContent: 'Export',
              secondaryButtonContent: 'Cancel',
              onPrimaryClick: function onPrimaryClick() {
                return _this3._performExport();
              },
              onSecondaryClick: function onSecondaryClick() {
                return _this3._close();
              },
              onRequestClose: function onRequestClose() {
                return _this3._close();
              } },
            _react2.default.createElement(
              'div',
              { className: _style2.default.ExportAllHandler_feedback_content },
              _react2.default.createElement(
                'div',
                { className: _style2.default.ExportAllHandler_feedback_languageRadio },
                this._renderLanguageRadio()
              )
            )
          );
        }
        // the export starts automatically!
        !this.state.isExportRequested && this._performExport();
        return _react2.default.createElement(
          _omniCommonUi.ConfirmDialog,
          { isOpen: true,
            isLoading: true,
            isButtonless: true,
            title: 'Exporting reports, please wait' },
          _react2.default.createElement('div', { className: _style2.default.ExportAllHandler_feedback_exportingImmediately })
        );
      }

      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: true,
          isLoading: this.state.isExportRequested,
          title: 'Exporting ' + exportCount + ' of ' + bestCaseCount + ' reports',
          primaryButtonContent: 'Export',
          secondaryButtonContent: 'Cancel',
          onPrimaryClick: function onPrimaryClick() {
            return _this3._performExport();
          },
          onSecondaryClick: function onSecondaryClick() {
            return _this3._close();
          },
          onRequestClose: function onRequestClose() {
            return _this3._close();
          } },
        _react2.default.createElement(
          'div',
          { className: _style2.default.ExportAllHandler_feedback_content },
          notAvailableCount > 0 ? _react2.default.createElement(
            'p',
            { className: _style2.default.ExportAllHandler_feedback_someNotAvailable,
              'data-not-available-count': notAvailableCount },
            notAvailableCount,
            notAvailableCount > 1 ? ' reports are ' : ' report is ',
            'not approved and cannot be exported'
          ) : null,
          !this._isDefaultLanguage() && _react2.default.createElement('div', { className: _style2.default.ExportAllHandler_feedback_divider }),
          !this._isDefaultLanguage() && _react2.default.createElement(
            'div',
            { className: _style2.default.ExportAllHandler_feedback_languageRadio },
            _react2.default.createElement(
              'span',
              null,
              'Choose Language:'
            ),
            this._renderLanguageRadio()
          )
        )
      );

      function countByStatus(status) {
        return individualDevelopmentPlanList.filter(function (report) {
          return _is_js2.default.string(report.status) && report.status.toLowerCase() === status;
        }).size;
      }
    }
  }]);

  return ExportAllHandler;
}(_react.Component);

ExportAllHandler.propTypes = {
  individualDevelopmentPlanList: _propTypes2.default.shape({
    filter: _propTypes2.default.func.isRequired
  }).isRequired,
  groupIdpId: _propTypes2.default.string.isRequired,
  groupId: _propTypes2.default.string.isRequired,
  languageCode: _propTypes2.default.string.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  reportName: _propTypes2.default.string.isRequired
};

exports.default = ExportAllHandler;

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1770);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".ZGHetedDX1ZaSPNG6DRwX{min-height:4.57143rem}._1BkJYlJTz8TbD3xiAQxql9{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1BkJYlJTz8TbD3xiAQxql9>p+p{margin-top:0}._3KTf0fHcVEc1CPZpyWH1Th{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:initial}._3KTf0fHcVEc1CPZpyWH1Th>*{margin-top:1.07143rem}.Qmx-UnIdaINBoaOBpZfTC{border-top:.07143rem solid #ccc;display:block;margin:.35714rem 0;width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ExportAllHandler_feedback_exportingImmediately": "ZGHetedDX1ZaSPNG6DRwX",
	"ExportAllHandler_feedback_content": "_1BkJYlJTz8TbD3xiAQxql9",
	"ExportAllHandler_feedback_languageRadio": "_3KTf0fHcVEc1CPZpyWH1Th",
	"ExportAllHandler_feedback_divider": "Qmx-UnIdaINBoaOBpZfTC"
};

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1772);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _ReadOnlyField = __webpack_require__(777);

var _ReadOnlyField2 = _interopRequireDefault(_ReadOnlyField);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _redux = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FOR_PERIOD = 'For Period';
var NAME = 'Name';
var TEACHER_ONE = 'Teacher 1';
var COURSE = 'Course';
var TEACHER_TWO = 'Teacher 2';
var CENTRE = 'Centre';
var PROGRESS_ADVISOR = 'Progress Advisor';
var START_OF_DAY = 'START_OF_DAY';
var END_OF_DAY = 'END_OF_DAY';
var PERIOD_FROM = 'periodFrom';
var PERIOD_TO = 'periodTo';

var StudentInformation = function (_Component) {
  _inherits(StudentInformation, _Component);

  function StudentInformation(props) {
    _classCallCheck(this, StudentInformation);

    var _this = _possibleConstructorReturn(this, (StudentInformation.__proto__ || Object.getPrototypeOf(StudentInformation)).call(this, props));

    var _this$props$studentIn = _this.props.studentInfo.period,
        start = _this$props$studentIn.start,
        end = _this$props$studentIn.end;

    _this.state = {
      periodFrom: _this._getLocalDateFromMoment(start, START_OF_DAY),
      periodTo: _this._getLocalDateFromMoment(end, END_OF_DAY),
      wasDateChangeMade: false,
      shouldShowConfirmDialog: false
    };
    _this.studentInfoDisplayItems = [];

    _this._onPeriodUpdated = _this._onPeriodUpdated.bind(_this);
    _this._onUpdateClicked = _this._onUpdateClicked.bind(_this);
    return _this;
  }

  _createClass(StudentInformation, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.studentInfo && (props.studentInfo.period.start !== this.props.studentInfo.period.start || props.studentInfo.period.end !== this.props.studentInfo.period.end)) {
        var _props$studentInfo$pe = props.studentInfo.period,
            start = _props$studentInfo$pe.start,
            end = _props$studentInfo$pe.end;

        this.setState({
          periodFrom: this._getLocalDateFromMoment(start, START_OF_DAY),
          periodTo: this._getLocalDateFromMoment(end, END_OF_DAY),
          wasDateChangeMade: false
        });
      }
    }
  }, {
    key: '_getLocalDateFromMoment',
    value: function _getLocalDateFromMoment(date, type) {
      (0, _invariant2.default)(_omniCommonUi.moment.isMoment(date), '<StudentInformation /> can only receive the period as moment object');
      switch (type) {
        case START_OF_DAY:
          return date.clone().tz(this.props.timeZone).startOf('day').toDate();
        case END_OF_DAY:
          return date.clone().tz(this.props.timeZone).endOf('day').toDate();
        default:
          return date.clone().tz(this.props.timeZone).toDate();
      }
    }
  }, {
    key: '_getUtcDateString',
    value: function _getUtcDateString(date) {
      return _omniCommonUi.moment.utc(date).format('YYYY-MM-DDTHH:mm:ss');
    }
  }, {
    key: '_getDisplayDate',
    value: function _getDisplayDate(date) {
      var momentDate = _omniCommonUi.moment.utc(date).clone().tz(this.props.timeZone);
      var year = momentDate.year();
      var month = momentDate.month();
      var day = momentDate.date();
      return new Date(year, month, day);
    }
  }, {
    key: '_renderGridItems',
    value: function _renderGridItems() {
      var _this2 = this;

      return this.studentInfoDisplayItems.map(function (source, index) {
        if (index === 0 && _this2.props.canEdit) return _this2._renderPeriodPickers();
        var size = {};
        size = index === 0 ? { xs: 12, sm: 12, md: 12 } : { xs: 12, sm: 6, md: 6 };
        return _react2.default.createElement(
          _omniCommonUi.Grid.Item,
          { xs: size.xs,
            sm: size.sm,
            md: size.md,
            className: _style2.default.StudentInformation_item,
            key: source.title },
          _react2.default.createElement(_ReadOnlyField2.default, { boardTitle: source.title,
            boardValue: source.value,
            className: source.className })
        );
      });
    }
  }, {
    key: '_renderConfirmDialog',
    value: function _renderConfirmDialog() {
      var _this3 = this;

      var returnToView = function returnToView() {
        return _this3.setState({ shouldShowConfirmDialog: false });
      };
      var discardUpdate = function discardUpdate() {
        var _props$studentInfo$pe2 = _this3.props.studentInfo.period,
            start = _props$studentInfo$pe2.start,
            end = _props$studentInfo$pe2.end;

        _this3.setState({
          periodFrom: _this3._getLocalDateFromMoment(start, START_OF_DAY),
          periodTo: _this3._getLocalDateFromMoment(end, END_OF_DAY),
          wasDateChangeMade: false
        });
        returnToView();
      };
      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: this.state.shouldShowConfirmDialog,
          primaryButtonContent: 'Update',
          secondaryButtonContent: 'Discard',
          onPrimaryClick: function onPrimaryClick() {
            return _this3._onPeriodUpdated();
          },
          onSecondaryClick: discardUpdate,
          onRequestClose: returnToView },
        _react2.default.createElement(
          'span',
          null,
          'This will update the scores and clear all previous edits.'
        )
      );
    }
  }, {
    key: '_shouldDisableUpdateButton',
    value: function _shouldDisableUpdateButton() {
      return this.props.isInEditMode || !this.state.wasDateChangeMade;
    }
  }, {
    key: '_renderPeriodPickers',
    value: function _renderPeriodPickers() {
      var _this4 = this;

      var _props = this.props,
          groupStartDate = _props.groupStartDate,
          groupEndDate = _props.groupEndDate;
      var _state = this.state,
          periodFrom = _state.periodFrom,
          periodTo = _state.periodTo;

      if (groupStartDate && groupEndDate) {
        var disabledStartDate = this._getLocalDateFromMoment(groupStartDate);
        var disabledEndDate = this._getLocalDateFromMoment(groupEndDate);
        var currentDay = (0, _omniCommonUi.moment)().clone().tz(this.props.timeZone).toDate();
        if (disabledEndDate.getTime() > currentDay.getTime()) disabledEndDate = currentDay;
        return _react2.default.createElement(
          _omniCommonUi.Grid.Item,
          { key: 'calenderPickers',
            xs: 12,
            sm: 12,
            md: 12,
            className: _style2.default.StudentInformation_item },
          _react2.default.createElement(
            'div',
            { className: _style2.default.StudentInformation_periodWrapper },
            _react2.default.createElement(
              'div',
              { className: _style2.default.StudentInformation_periodWrapper_itemContainer },
              _react2.default.createElement(
                'div',
                { className: _style2.default.StudentInformation_periodWrapper_item },
                _react2.default.createElement(
                  'span',
                  { className: _style2.default.StudentInformation_periodWrapper_item_label },
                  'For Period From'
                ),
                _react2.default.createElement(_omniCommonUi.CalendarPicker, { day: this._getDisplayDate(periodFrom),
                  onDateChanged: function onDateChanged(day) {
                    return _this4._onDateChanged(PERIOD_FROM, day);
                  },
                  disabledDayBefore: disabledStartDate,
                  disabledDayAfter: periodTo,
                  isValid: true })
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.StudentInformation_periodWrapper_item },
                _react2.default.createElement(
                  'span',
                  { className: _style2.default.StudentInformation_periodWrapper_item_label },
                  'To'
                ),
                _react2.default.createElement(_omniCommonUi.CalendarPicker, { day: this._getDisplayDate(periodTo),
                  onDateChanged: function onDateChanged(day) {
                    return _this4._onDateChanged(PERIOD_TO, day);
                  },
                  disabledDayBefore: periodFrom,
                  disabledDayAfter: disabledEndDate,
                  isValid: true })
              ),
              _react2.default.createElement(
                _omniCommonUi.Button,
                { type: _omniCommonUi.Button.Type.primary,
                  onClick: this._onUpdateClicked,
                  className: _style2.default.StudentInformation_button,
                  disabled: this._shouldDisableUpdateButton() },
                'UPDATE'
              )
            )
          )
        );
      }
    }
  }, {
    key: '_onUpdateClicked',
    value: function _onUpdateClicked() {
      this.setState({ shouldShowConfirmDialog: true });
    }
  }, {
    key: '_closeConfirmDialog',
    value: function _closeConfirmDialog() {
      this.setState({ shouldShowConfirmDialog: false });
    }
  }, {
    key: '_onPeriodUpdated',
    value: function _onPeriodUpdated() {
      var period = {
        fromTime: this._getUtcDateString(this.state.periodFrom),
        toTime: this._getUtcDateString(this.state.periodTo)
      };
      this.props.submitIdpPeriod(this.props.idpId, period, this.props.groupIdpId);
      this.setState({ wasDateChangeMade: false });
      this._closeConfirmDialog();
    }
  }, {
    key: '_onDateChanged',
    value: function _onDateChanged(changedType, date) {
      var _setState;

      var startOrEndOfDay = void 0;
      if (changedType === PERIOD_FROM) startOrEndOfDay = START_OF_DAY;
      if (changedType === PERIOD_TO) startOrEndOfDay = END_OF_DAY;
      var periodDate = this._getLocalDateFromMoment(_omniCommonUi.moment.utc(date), startOrEndOfDay);
      this.setState((_setState = {}, _defineProperty(_setState, changedType, periodDate), _defineProperty(_setState, 'wasDateChangeMade', true), _setState));
    }
  }, {
    key: '_prepareStudentInfoDisplayItems',
    value: function _prepareStudentInfoDisplayItems() {
      this.studentInfoDisplayItems = [];
      var _props2 = this.props,
          isExpanded = _props2.isExpanded,
          studentInfo = _props2.studentInfo;

      this.studentInfoDisplayItems.push({
        title: FOR_PERIOD,
        value: studentInfo.forPeriod,
        period: studentInfo.period
      });
      if (isExpanded) {
        this.studentInfoDisplayItems.push({
          title: NAME,
          value: studentInfo.name
        });
        this.studentInfoDisplayItems.push({
          title: TEACHER_ONE,
          value: studentInfo.teacherOne
        });
        this.studentInfoDisplayItems.push({
          title: COURSE,
          value: studentInfo.course
        });
        this.studentInfoDisplayItems.push({
          title: TEACHER_TWO,
          value: studentInfo.teacherTwo
        });
        this.studentInfoDisplayItems.push({
          title: CENTRE,
          value: studentInfo.centre
        });
        this.studentInfoDisplayItems.push({
          title: PROGRESS_ADVISOR,
          value: studentInfo.progressAdvisor
        });
      }
    }
  }, {
    key: '_renderExpansionButton',
    value: function _renderExpansionButton() {
      var _props3 = this.props,
          isExpanded = _props3.isExpanded,
          onExpandButtonClick = _props3.onExpandButtonClick;

      return _react2.default.createElement(_ExpansionButton2.default, { isExpand: isExpanded,
        onExpansionButtonClick: function onExpansionButtonClick() {
          return onExpandButtonClick();
        } });
    }
  }, {
    key: 'render',
    value: function render() {
      this._prepareStudentInfoDisplayItems.call(this);

      return _react2.default.createElement(
        'div',
        { className: (0, _omniCommonUi.testClass)('student-information') },
        _react2.default.createElement(
          _omniCommonUi.PageCard,
          { className: _style2.default.StudentInformation_container },
          _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Student information' }),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.StudentInformation_content },
            _react2.default.createElement(
              _omniCommonUi.Grid,
              { className: _style2.default.StudentInformation_grid },
              _react2.default.createElement(
                _omniCommonUi.Grid.Group,
                null,
                this._renderGridItems()
              )
            )
          ),
          this._renderExpansionButton()
        ),
        this._renderConfirmDialog()
      );
    }
  }]);

  return StudentInformation;
}(_react.Component);

StudentInformation.propTypes = {
  studentInfo: _propTypes2.default.object.isRequired,
  timeZone: _propTypes2.default.string.isRequired,
  isExpanded: _propTypes2.default.bool.isRequired,
  onExpandButtonClick: _propTypes2.default.func.isRequired,
  submitIdpPeriod: _propTypes2.default.func.isRequired,
  idpId: _propTypes2.default.string.isRequired,
  groupIdpId: _propTypes2.default.string.isRequired,
  groupStartDate: _propTypes2.default.object.isRequired,
  groupEndDate: _propTypes2.default.object.isRequired,
  isInEditMode: _propTypes2.default.bool.isRequired,
  canEdit: _propTypes2.default.bool
};

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_IndividualDevelopmentPlans.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(null, mapDispatchToProps)(StudentInformation);

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1773);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".s8cGOgez5NAijEf-7nX95{margin:0}._3czhlfuA5O9W_xv98mXnbR{margin:0;padding-top:.5em}._10DCplpjjKaeIZuo5vWXYm{margin-top:1.21429rem}._3ty2hKZFcM7UpCUlzOCc-U{float:left}._3ty2hKZFcM7UpCUlzOCc-U:after{background-color:#ccc;content:\"\";display:block;height:.07143rem;left:0;position:absolute;width:100%}._3YRcazykoICNCDBS_LSnUC{float:left}._2F9-AASnS-PrWiLp4HWjW0{padding-bottom:.35714rem}.GMVwZPzamBPSZZGssfTZ8{overflow:hidden;padding-bottom:.71429rem}.GMVwZPzamBPSZZGssfTZ8>:not(:last-child){margin-right:1.42857rem}._3ozNY7hlLkkjXKDebIxT-R{padding-bottom:0;padding-top:.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentInformation_container": "_1GF7wVIapw1OIcpaWw_ZRC",
	"StudentInformation_grid": "s8cGOgez5NAijEf-7nX95",
	"StudentInformation_item": "_3czhlfuA5O9W_xv98mXnbR",
	"StudentInformation_button": "_10DCplpjjKaeIZuo5vWXYm",
	"StudentInformation_periodWrapper": "_3ty2hKZFcM7UpCUlzOCc-U",
	"StudentInformation_periodWrapper_item": "_3YRcazykoICNCDBS_LSnUC",
	"StudentInformation_periodWrapper_item_label": "_2F9-AASnS-PrWiLp4HWjW0",
	"StudentInformation_periodWrapper_itemContainer": "GMVwZPzamBPSZZGssfTZ8",
	"StudentInformation_content": "_3ozNY7hlLkkjXKDebIxT-R"
};

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1775);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3WE8MsLxwNqIcFoTYVtQSI{float:left;line-height:1.8;padding-right:1rem;width:100%}._3WE8MsLxwNqIcFoTYVtQSI:after{background:#ccc;content:\"\";display:block;height:.07143rem;left:0;position:absolute;width:100%}._1AxewpG5ZPEaZIqseJCAcK{color:#b4b4b4;font-size:.95em;font-weight:400;margin:0}._3z3afrpOgB_d0Nvsg27KGG{border-bottom:.07143rem solid transparent;font-size:1rem;margin:0;padding-bottom:.57143rem;white-space:pre-line}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ReadOnlyField_board": "_3WE8MsLxwNqIcFoTYVtQSI",
	"ReadOnlyField_h5": "_1AxewpG5ZPEaZIqseJCAcK",
	"ReadOnlyField_p": "_3z3afrpOgB_d0Nvsg27KGG"
};

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1777);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _omniCommonUi = __webpack_require__(0);

var _SkillSuggestionCard = __webpack_require__(1779);

var _SkillSuggestionCard2 = _interopRequireDefault(_SkillSuggestionCard);

var _AddInternalNoteControl = __webpack_require__(67);

var _AddInternalNoteControl2 = _interopRequireDefault(_AddInternalNoteControl);

var _UserCard = __webpack_require__(65);

var _UserCard2 = _interopRequireDefault(_UserCard);

var _InfoDialog = __webpack_require__(295);

var _InfoDialog2 = _interopRequireDefault(_InfoDialog);

var _BottomButtons = __webpack_require__(781);

var _BottomButtons2 = _interopRequireDefault(_BottomButtons);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _routes = __webpack_require__(169);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NUMBER_OF_TOTAL_SKILL_SUGGESTIONS = 3;

var FeedbackSuggestions = function (_Component) {
  _inherits(FeedbackSuggestions, _Component);

  function FeedbackSuggestions(props) {
    _classCallCheck(this, FeedbackSuggestions);

    var _this = _possibleConstructorReturn(this, (FeedbackSuggestions.__proto__ || Object.getPrototypeOf(FeedbackSuggestions)).call(this, props));

    _this.state = {
      wasCommentsEditMade: false,
      commentsPopup: {
        isOpen: false
      }
    };

    _this._onDiscardClick = _this._onDiscardClick.bind(_this);
    _this.onSaveClick = _this.onSaveClick.bind(_this);
    _this._onParticipationChanged = _this._onParticipationChanged.bind(_this);
    return _this;
  }

  _createClass(FeedbackSuggestions, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.isInEditMode) {
        var _props$suggestionsInf = this.props.suggestionsInfo,
            overallSuggestion = _props$suggestionsInf.overallSuggestion,
            participationId = _props$suggestionsInf.participationId,
            skillSuggestions = _props$suggestionsInf.skillSuggestions;

        this._onEditComments(overallSuggestion, participationId, skillSuggestions);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_is_js2.default.function(this.props.onComponentMounted)) {
        return;
      }
      this.props.onComponentMounted(this);
    }
  }, {
    key: "wasCommentsEditMade",
    value: function wasCommentsEditMade() {
      return this.props.isInEditMode && this.state.wasCommentsEditMade;
    }
  }, {
    key: "setWasCommentsEditMade",
    value: function setWasCommentsEditMade(wasCommentsEditMade) {
      if (this.state.wasCommentsEditMade === wasCommentsEditMade) return;
      this.setState({ wasCommentsEditMade: wasCommentsEditMade });
    }
  }, {
    key: "_renderUserAndOverall",
    value: function _renderUserAndOverall() {
      var _props$suggestionsInf2 = this.props.suggestionsInfo,
          teacherId = _props$suggestionsInf2.teacherId,
          suggestedTime = _props$suggestionsInf2.suggestedTime,
          timeZone = _props$suggestionsInf2.timeZone;


      var wrapperClass = this.props.shouldShowSuggestions ? (0, _classnames3.default)(_style2.default.FeedbackSuggestions_overallWrapper, _style2.default._overallBorderBottom) : _style2.default.FeedbackSuggestions_overallWrapper;
      var dateStr = _is_js2.default.existy(suggestedTime) && _is_js2.default.existy(timeZone) ? _omniCommonUi.moment.parseZone(suggestedTime).clone().tz(timeZone).format("YYYY-MM-DD") : "";
      return _react2.default.createElement(
        "div",
        { className: wrapperClass },
        _is_js2.default.number(teacherId) && teacherId !== 0 && _react2.default.createElement(_UserCard2.default, {
          id: teacherId.toString(),
          dateStr: dateStr,
          className: _style2.default.FeedbackSuggestions_userCard
        }),
        _react2.default.createElement(
          "div",
          { className: _style2.default.FeedbackSuggestions_overall },
          _react2.default.createElement(
            "div",
            { className: _style2.default.FeedbackSuggestions_overall_heading },
            "Overall"
          ),
          this._renderOverallContent(),
          this._renderParticipation()
        )
      );
    }
  }, {
    key: "_renderParticipation",
    value: function _renderParticipation() {
      if (this.props.participationInfo.size === 0) return;
      var labelClasses = (0, _classnames3.default)(_style2.default.FeedbackSuggestions_subTitle, _defineProperty({}, _style2.default.__grey, !this.props.isInEditMode));
      return _react2.default.createElement(
        "div",
        { className: _style2.default.FeedbackSuggestions_overall_participation },
        _react2.default.createElement(
          "div",
          { className: labelClasses },
          "Participation"
        ),
        this._renderParticipationContent()
      );
    }
  }, {
    key: "_renderParticipationContent",
    value: function _renderParticipationContent() {
      if (this.props.isInEditMode) {
        var selectedParticipationId = this.state.participationId;
        var isMissing = this._isAnyEmpty(selectedParticipationId);
        var options = this.props.participationInfo.toList().toJS().map(function (option) {
          return {
            label: option.name,
            value: parseInt(option.id, 10)
          };
        });
        options.splice(0, 0, {
          label: " ",
          value: 0,
          className: _style2.default.FeedbackSuggestions_select_option
        });
        return _react2.default.createElement(
          _omniCommonUi.Grid,
          null,
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12, sm: 6, md: 6 },
              _react2.default.createElement(
                _omniCommonUi.Form,
                null,
                _react2.default.createElement(_omniCommonUi.Form.Select, {
                  name: "idp-participation",
                  className: isMissing && _style2.default.missing,
                  options: options,
                  value: selectedParticipationId,
                  setValue: this._onParticipationChanged,
                  clearable: false,
                  searchable: false
                })
              )
            )
          )
        );
      }

      var participationId = this.props.suggestionsInfo.participationId || 0;
      var participation = this.props.participationInfo.get(participationId.toString());
      var participationName = participation && participation.name || "–";
      return _react2.default.createElement(
        "div",
        null,
        participationName
      );
    }
  }, {
    key: "_renderOverallContent",
    value: function _renderOverallContent() {
      var _this2 = this;

      if (!this.props.isInEditMode) {
        return _react2.default.createElement(
          "p",
          { className: _style2.default.FeedbackSuggestions_overall_content },
          this.props.suggestionsInfo.overallSuggestion || "–"
        );
      }
      var overallSuggestion = this.state.overallSuggestion;

      return _react2.default.createElement(_AddInternalNoteControl2.default, {
        text: overallSuggestion,
        isMissing: this._isAnyEmpty(overallSuggestion && overallSuggestion.trim()),
        maxCharacters: 1320,
        onChange: function onChange(text) {
          return _this2._onOverallSuggestionChanged(text);
        }
      });
    }
  }, {
    key: "_onOverallSuggestionChanged",
    value: function _onOverallSuggestionChanged(overallSuggestion) {
      this.setWasCommentsEditMade(true);
      this.setState({ overallSuggestion: overallSuggestion });
    }
  }, {
    key: "_onSkillSuggestionChanged",
    value: function _onSkillSuggestionChanged(text, skillIndex) {
      this.setWasCommentsEditMade(true);
      var skillSuggestions = this.state.skillSuggestions.map(function (skillSuggestion, index) {
        if (skillIndex === index) {
          return Object.assign({}, skillSuggestion, { suggestion: text });
        }
        return skillSuggestion;
      });
      this.setState({ skillSuggestions: skillSuggestions });
    }
  }, {
    key: "_onSkillRecommendationChanged",
    value: function _onSkillRecommendationChanged(skillIndex, recommendations) {
      var skillSuggestions = this.state.skillSuggestions.map(function (skillSuggestion, index) {
        if (skillIndex === index) {
          return Object.assign({}, skillSuggestion, {
            selectedRecommendationList: recommendations
          });
        }
        return skillSuggestion;
      });
      this.setState({ skillSuggestions: skillSuggestions });
    }
  }, {
    key: "_onSkillChanged",
    value: function _onSkillChanged(skillIndex, skillId) {
      var skillSuggestions = this.state.skillSuggestions;
      var suggestion = skillSuggestions[skillIndex];
      if (!_is_js2.default.undefined(suggestion) && suggestion.skillId === skillId) {
        return;
      }

      var newSkillSuggestion = void 0;
      if (_is_js2.default.not.empty(skillId) && skillId !== 0) {
        newSkillSuggestion = {
          skillId: skillId,
          suggestion: "",
          isManuallyAdded: true,
          selectedRecommendationList: []
        };
      } else {
        newSkillSuggestion = {
          skillId: 0,
          suggestion: "",
          isManuallyAdded: true,
          selectedRecommendationList: []
        };
      }
      skillSuggestions[skillIndex] = newSkillSuggestion;
      this.setState({ skillSuggestions: skillSuggestions });
      this.setWasCommentsEditMade(true);
    }
  }, {
    key: "_onParticipationChanged",
    value: function _onParticipationChanged(participationId) {
      this.setWasCommentsEditMade(true);
      this.setState({ participationId: participationId });
    }
  }, {
    key: "_renderSkillSuggestions",
    value: function _renderSkillSuggestions() {
      var _this3 = this;

      var _props = this.props,
          shouldShowSuggestions = _props.shouldShowSuggestions,
          _props$suggestionsInf3 = _props.suggestionsInfo,
          skillSuggestions = _props$suggestionsInf3.skillSuggestions,
          skillResults = _props$suggestionsInf3.skillResults,
          isInEditMode = _props.isInEditMode;

      if (!shouldShowSuggestions) return;
      var skillOptions = skillResults.toJS();
      var choosenSuggestions = isInEditMode ? new _immutable.List(this.state.skillSuggestions) : skillSuggestions;
      var suggestionCards = choosenSuggestions.map(function (skillSuggestion, index) {
        return _this3._renderSkillSuggestionCard(skillSuggestion, index, skillOptions, choosenSuggestions.filter(function (_, idx) {
          return idx !== index;
        }).map(function (ss) {
          return ss.skillId;
        }).toJS(), skillSuggestion.selectedRecommendationList.size === 0);
      });
      var numberOfManual = NUMBER_OF_TOTAL_SKILL_SUGGESTIONS - suggestionCards.size;
      if (numberOfManual >= 1 && isInEditMode) {
        for (var index = suggestionCards.size; index < NUMBER_OF_TOTAL_SKILL_SUGGESTIONS; index++) {
          suggestionCards = suggestionCards.concat(this._renderSkillSuggestionCard(undefined, index, skillOptions, choosenSuggestions.map(function (ss) {
            return ss.skillId;
          }).toJS()));
        }
      }
      return suggestionCards;
    }
  }, {
    key: "_renderSkillSuggestionCard",
    value: function _renderSkillSuggestionCard(skillSuggestion, index, skillOptions) {
      var _this4 = this;

      var hiddenOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var isMissing = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var _props2 = this.props,
          isInEditMode = _props2.isInEditMode,
          isSSV3Group = _props2.isSSV3Group,
          isSkillSuggestionManualOnly = _props2.isSkillSuggestionManualOnly,
          skillRecommendations = _props2.skillRecommendations;

      var wrapperClass = isInEditMode ? _style2.default.FeedbackSuggestions_skillSuggestionWrapper : (0, _classnames3.default)(_style2.default.FeedbackSuggestions_skillSuggestionWrapper, _style2.default._borderTop);
      var skillSuggestionText = skillSuggestion && isInEditMode && this.state.skillSuggestions[index].suggestion;
      var isManuallyAdded = !skillSuggestion || !!skillSuggestion.isManuallyAdded;
      return _react2.default.createElement(
        "div",
        { key: index, className: wrapperClass },
        _react2.default.createElement(_SkillSuggestionCard2.default, {
          skillSuggestion: skillSuggestion,
          isInEditMode: isInEditMode,
          isSSV3Group: isSSV3Group,
          skillRecommendations: skillRecommendations,
          isMissing: isMissing,
          canEditSkillRecommandation: !isSkillSuggestionManualOnly,
          skillOptions: skillOptions,
          onSkillChanged: function onSkillChanged(skillId) {
            return _this4._onSkillChanged(index, skillId);
          },
          onRecommendationChanged: function onRecommendationChanged(recommendations) {
            return _this4._onSkillRecommendationChanged(index, recommendations);
          },
          isManuallyAdded: isManuallyAdded,
          hiddenOptions: hiddenOptions,
          index: index
        }),
        isInEditMode && _react2.default.createElement(
          "div",
          null,
          isSkillSuggestionManualOnly ? _react2.default.createElement(
            "div",
            { className: _style2.default.FeedbackSuggestions_subTitle },
            "Suggestions"
          ) : _react2.default.createElement(
            "div",
            { className: _style2.default.FeedbackSuggestions_subTitle },
            "Suggestions (optional)"
          ),
          _react2.default.createElement(_AddInternalNoteControl2.default, {
            text: skillSuggestionText,
            maxCharacters: 1320,
            isMissing: isSkillSuggestionManualOnly && skillSuggestion && skillSuggestion.skillId && this._isAnyEmpty(skillSuggestionText && skillSuggestionText.trim()),
            onChange: function onChange(text) {
              return _this4._onSkillSuggestionChanged(text, index);
            },
            textAreaProps: {
              disabled: _is_js2.default.not.existy(skillSuggestion) || skillSuggestion.skillId === 0,
              placeholder: "Type your own action plan here."
            },
            noAutoScroll: true
          })
        )
      );
    }
  }, {
    key: "_onEditComments",
    value: function _onEditComments(overallSuggestion, participationId) {
      var skillSuggestions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      _reactGa2.default.event({
        category: "IDP",
        action: 'Clicked "Edit" feedback and suggestions'
      });
      this.setState({
        overallSuggestion: overallSuggestion || "",
        participationId: participationId || 0,
        skillSuggestions: this._getInitialSkillSuggestions(skillSuggestions)
      });
      this.props.changeMode(_routes.Modes.EDIT_COMMENTS);
    }
  }, {
    key: "_renderTipIcons",
    value: function _renderTipIcons() {
      var _this5 = this;

      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        {
          text: "Tips for giving overall feedback",
          placement: "right",
          trigger: ["hover"],
          className: _style2.default.FeedbackSuggestions_actionButton
        },
        _react2.default.createElement(_omniCommonUi.Icon, {
          id: "question",
          className: _style2.default.ProgressTestCourseView_tooltip_icon,
          onClick: function onClick() {
            return _this5.setState({
              commentsPopup: {
                isOpen: true,
                isOpenedbyEdit: false
              }
            });
          }
        })
      );
    }
  }, {
    key: "_renderActionIcons",
    value: function _renderActionIcons() {
      var _this6 = this;

      if (!this.props.canEdit) {
        return null;
      }
      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        {
          text: "Edit",
          placement: "left",
          trigger: ["hover"],
          className: _style2.default.FeedbackSuggestions_actionButton
        },
        _react2.default.createElement(_omniCommonUi.Icon, {
          id: "edit",
          className: (0, _omniCommonUi.testClass)("edit"),
          onClick: function onClick() {
            return _this6.setState({
              commentsPopup: {
                isOpen: true,
                isOpenedbyEdit: true
              }
            });
          }
        })
      );
    }
  }, {
    key: "_onCommentsOKClick",
    value: function _onCommentsOKClick(isOpenedbyEdit) {
      var _props$suggestionsInf4 = this.props.suggestionsInfo,
          overallSuggestion = _props$suggestionsInf4.overallSuggestion,
          participationId = _props$suggestionsInf4.participationId,
          skillSuggestions = _props$suggestionsInf4.skillSuggestions;

      console.log(isOpenedbyEdit);
      if (isOpenedbyEdit) {
        console.log(isOpenedbyEdit);
        this._onEditComments(overallSuggestion, participationId, skillSuggestions);
      }
      this.setState({
        commentsPopup: {
          isOpen: false
        }
      });
    }
  }, {
    key: "_renderCommentsPopup",
    value: function _renderCommentsPopup() {
      var _this7 = this;

      var commentsPopup = this.state.commentsPopup;

      console.log(commentsPopup);
      return _react2.default.createElement(
        _InfoDialog2.default,
        {
          isOpen: commentsPopup.isOpen,
          onOKClick: function onOKClick() {
            return _this7._onCommentsOKClick(commentsPopup.isOpenedbyEdit);
          }
        },
        _react2.default.createElement(
          "h3",
          null,
          "Tips for giving overall feedback"
        ),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "i",
            null,
            "These are some guiding principles to provide feedback and suggestions to parents. Please, cover at least 3 of the highlighted points concisely.",
            " "
          ),
          _react2.default.createElement("br", null),
          _react2.default.createElement("br", null),
          "*Give an example of a favourite activity or an area that the student showed a strong performance in during this period",
          _react2.default.createElement("br", null),
          _react2.default.createElement("br", null),
          "*In what area does s/he struggle? (Give a specific example)",
          _react2.default.createElement("br", null),
          _react2.default.createElement("br", null),
          "*Provide any comments with specific anecdotes about their behaviour and participation in class",
          _react2.default.createElement("br", null),
          _react2.default.createElement("br", null),
          "*What have you done, or will you do in class to help to improve the weak area?",
          _react2.default.createElement("br", null),
          _react2.default.createElement("br", null),
          "*Is there anything from the previous report or from challenges voiced earlier that has been improved and how?",
          _react2.default.createElement("br", null),
          _react2.default.createElement("br", null)
        )
      );
    }
  }, {
    key: "_getInitialSkillSuggestions",
    value: function _getInitialSkillSuggestions(skillSuggestions) {
      return skillSuggestions.toJS().map(function (skillSuggestion) {
        return {
          skillId: skillSuggestion.skillId,
          suggestion: skillSuggestion.suggestion || "",
          isManuallyAdded: !!skillSuggestion.isManuallyAdded,
          selectedRecommendationList: skillSuggestion.selectedRecommendationList
        };
      });
    }
  }, {
    key: "_onDiscardClick",
    value: function _onDiscardClick() {
      this.setWasCommentsEditMade(false);
      this.props.changeMode("");
    }
  }, {
    key: "onSaveClick",
    value: function onSaveClick() {
      var skillSuggestions = void 0;
      if (this.props.shouldShowSuggestions) {
        skillSuggestions = this.state.skillSuggestions.filter(function (skillSuggestion) {
          return _is_js2.default.not.empty(skillSuggestion) && skillSuggestion.skillId !== 0;
        });
      }
      var submittedSuggestions = {
        overallSuggestion: this.state.overallSuggestion || "",
        participationId: this.state.participationId,
        skillSuggestions: skillSuggestions
      };
      this.props.submitIdpFeedbackSuggestions(this.props.idpId, submittedSuggestions, this.props.groupIdpId);
      this._onDiscardClick();
    }
  }, {
    key: "_renderSaveAndDiscardButtons",
    value: function _renderSaveAndDiscardButtons() {
      if (!this.props.isInEditMode) return;
      return _react2.default.createElement(_BottomButtons2.default, {
        onSecondaryClick: this._onDiscardClick,
        onPrimaryClick: this.onSaveClick,
        primaryText: "SAVE",
        secondaryText: "DISCARD",
        isPrimaryDisabled: false
      });
    }
  }, {
    key: "_isAnyEmpty",
    value: function _isAnyEmpty() {
      for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
        fields[_key] = arguments[_key];
      }

      return fields.reduce(function (previous, field) {
        return previous || _is_js2.default.falsy(field) || _is_js2.default.existy(field) && _is_js2.default.empty(field);
      }, false);
    }
  }, {
    key: "_getEmptyHint",
    value: function _getEmptyHint(emptyActions) {
      var hint = "";
      if (emptyActions === 1) {
        hint = emptyActions + " action is missing. Please edit the hightlighted field.";
      } else if (emptyActions > 1) {
        hint = emptyActions + " actions are missing. Please edit the hightlighted fields.";
      }
      return hint;
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          suggestionsInfo = _props3.suggestionsInfo,
          shouldShowSuggestions = _props3.shouldShowSuggestions,
          isSkillSuggestionManualOnly = _props3.isSkillSuggestionManualOnly,
          canEdit = _props3.canEdit;

      var emptyActions = _IndividualDevelopmentPlans.accessors.getEmptyActions(suggestionsInfo, shouldShowSuggestions, isSkillSuggestionManualOnly);
      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        null,
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          {
            text: "Teacher's feedback and suggestions",
            stackMode: "horizontal"
          },
          emptyActions && canEdit ? _react2.default.createElement(
            "div",
            { className: _style2.default.FeedbackSuggestions_header },
            this._getEmptyHint(emptyActions)
          ) : null,
          this._renderActionIcons(this.props.suggestionsInfo),
          this._renderTipIcons()
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.FeedbackSuggestions_content },
          this._renderUserAndOverall(),
          this._renderSkillSuggestions(),
          this._renderSaveAndDiscardButtons(),
          this._renderCommentsPopup()
        )
      );
    }
  }]);

  return FeedbackSuggestions;
}(_react.Component);

FeedbackSuggestions.propTypes = {
  suggestionsInfo: _propTypes2.default.shape().isRequired,
  participationInfo: _propTypes2.default.shape().isRequired,
  isSSV3Group: _propTypes2.default.bool,
  isSkillSuggestionManualOnly: _propTypes2.default.bool,
  isInEditMode: _propTypes2.default.bool.isRequired,
  changeMode: _propTypes2.default.func.isRequired,
  submitIdpFeedbackSuggestions: _propTypes2.default.func.isRequired,
  idpId: _propTypes2.default.string.isRequired,
  groupIdpId: _propTypes2.default.string.isRequired,
  onComponentMounted: _propTypes2.default.func,
  canEdit: _propTypes2.default.bool.isRequired,
  shouldShowSuggestions: _propTypes2.default.bool.isRequired,
  skillRecommendations: _propTypes2.default.shape()
};

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_IndividualDevelopmentPlans.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(null, mapDispatchToProps)(FeedbackSuggestions);

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1778);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1dEvqdSzkYAZflt3v-LeqZ{padding:0}._3J1C1PsVuWP0orVT3GTUpO{color:#de4c4c;font-style:Italic}._3J1C1PsVuWP0orVT3GTUpO+._1xeqLtKc6nU-kaJO434TPU{margin-left:1.14286rem}._3GfS8NVeghHW2KnSCXqtLl{padding:1.42857rem}@media only screen and (min-width:640px){._3GfS8NVeghHW2KnSCXqtLl{padding:1.42857rem 2.14286rem}}._3GfS8NVeghHW2KnSCXqtLl.gFZyU-gR8kwD1GfLAuiqO{border-bottom:.07143rem solid #ccc}._2uPtD3S-6XeoqdE8vILDEf{padding:1.42857rem}@media only screen and (min-width:640px){._2uPtD3S-6XeoqdE8vILDEf{padding:1.42857rem 2.14286rem}}._2uPtD3S-6XeoqdE8vILDEf._1D87oz6euu6jzOr1LA5Zcd+._2uPtD3S-6XeoqdE8vILDEf._1D87oz6euu6jzOr1LA5Zcd{border-top:.07143rem solid #ccc}._1Ep-q38WUDmWj3zvDjORxx{padding-bottom:1.07143rem}._3GmtOLUThCBIUorP0foNfh{padding-bottom:.35714rem}._3GmtOLUThCBIUorP0foNfh._3CN-ytKkSfLRltXkojbY3K{color:#a4a4a4}._1w7LuJAfULtuf8V3K7Zd86{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1.14286rem;font-weight:600;letter-spacing:.07143rem;line-height:1.125;padding-bottom:.71429rem}.q5a-lLPL4tyCeLZAqn6OA{border-bottom:.07143rem solid transparent;font-size:1rem;margin:0;white-space:pre-line}.q5a-lLPL4tyCeLZAqn6OA+._6oO6BvhoaCq00AUTEE4Ej{margin-top:.71429rem}._2b8GC4YjCJBRoaGY3TVQxR{min-height:2.5rem}._1E364DnwZwKho7pmOmr1A>div{border-color:#de4c4c}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"FeedbackSuggestions_container": "_2Mkt50m7fiJyJYCeFpSA5e",
	"FeedbackSuggestions_content": "_1dEvqdSzkYAZflt3v-LeqZ",
	"FeedbackSuggestions_header": "_3J1C1PsVuWP0orVT3GTUpO",
	"FeedbackSuggestions_actionButton": "_1xeqLtKc6nU-kaJO434TPU",
	"FeedbackSuggestions_overallWrapper": "_3GfS8NVeghHW2KnSCXqtLl",
	"_overallBorderBottom": "gFZyU-gR8kwD1GfLAuiqO",
	"FeedbackSuggestions_skillSuggestionWrapper": "_2uPtD3S-6XeoqdE8vILDEf",
	"_borderTop": "_1D87oz6euu6jzOr1LA5Zcd",
	"FeedbackSuggestions_userCard": "_1Ep-q38WUDmWj3zvDjORxx",
	"FeedbackSuggestions_subTitle": "_3GmtOLUThCBIUorP0foNfh",
	"__grey": "_3CN-ytKkSfLRltXkojbY3K",
	"FeedbackSuggestions_overall_heading": "_1w7LuJAfULtuf8V3K7Zd86",
	"FeedbackSuggestions_overall_content": "q5a-lLPL4tyCeLZAqn6OA",
	"FeedbackSuggestions_overall_participation": "_6oO6BvhoaCq00AUTEE4Ej",
	"FeedbackSuggestions_select_option": "_2b8GC4YjCJBRoaGY3TVQxR",
	"missing": "_1E364DnwZwKho7pmOmr1A"
};

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1780);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SkillRecommendation = __webpack_require__(1782);

var _SkillRecommendation2 = _interopRequireDefault(_SkillRecommendation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SkillSuggestionCard = function (_PureComponent) {
  _inherits(SkillSuggestionCard, _PureComponent);

  function SkillSuggestionCard() {
    _classCallCheck(this, SkillSuggestionCard);

    return _possibleConstructorReturn(this, (SkillSuggestionCard.__proto__ || Object.getPrototypeOf(SkillSuggestionCard)).apply(this, arguments));
  }

  _createClass(SkillSuggestionCard, [{
    key: '_judgeValue',
    value: function _judgeValue(boardValue) {
      if (!_is_js2.default.not.undefined(boardValue) || !boardValue || boardValue === '') {
        return '–';
      }
      return boardValue;
    }
  }, {
    key: '_getSkillDescription',
    value: function _getSkillDescription(skillSuggestion, skillOptions) {
      if (!skillSuggestion) return '';
      var selectedOption = skillOptions.find(function (skillOption) {
        return skillOption.skillId === skillSuggestion.skillId;
      });
      return this._formatOptionLabel(selectedOption.name, selectedOption.score);
    }
  }, {
    key: '_formatOptionLabel',
    value: function _formatOptionLabel(name, score) {
      return name + ' ' + _IndividualDevelopmentPlans.accessors.formatSkillScore(score);
    }
  }, {
    key: '_convertToSelectOptions',
    value: function _convertToSelectOptions(skillOptions) {
      var _this2 = this;

      var options = skillOptions.filter(function (skillOption) {
        return _is_js2.default.not.inArray(skillOption.skillId, _this2.props.hiddenOptions);
      }).map(function (skillOption) {
        var optionValue = _this2._formatOptionLabel(skillOption.name, skillOption.score);
        return { label: optionValue, value: skillOption.skillId };
      });
      options.splice(0, 0, {
        label: ' ',
        value: 0,
        className: _style2.default.SkillSuggestionCard_select_option
      });
      return options;
    }
  }, {
    key: '_renderSkillResult',
    value: function _renderSkillResult() {
      var _props = this.props,
          skillSuggestion = _props.skillSuggestion,
          skillOptions = _props.skillOptions,
          onSkillChanged = _props.onSkillChanged,
          index = _props.index;

      var classesH5 = (0, _classnames2.default)(_style2.default.SkillSuggestionCard_h5, (0, _omniCommonUi.testClass)('field-title'));
      if (this.props.isInEditMode && this.props.isManuallyAdded && _is_js2.default.not.empty(skillOptions)) {
        var options = this._convertToSelectOptions(skillOptions);
        var selectedValue = skillSuggestion && skillSuggestion.skillId || 0;
        return _react2.default.createElement(
          _omniCommonUi.Form,
          { className: _style2.default.SkillSuggestionCard_skillResult },
          _react2.default.createElement(
            'div',
            { className: _style2.default.SkillSuggestionCard_skillResult_indexLabel },
            'Skill ' + (index + 1) + ' (optional)'
          ),
          _react2.default.createElement(_omniCommonUi.Form.Select, { name: 'suggestion-skill',
            options: options,
            value: selectedValue,
            setValue: onSkillChanged,
            clearable: false,
            searchable: false })
        );
      }
      return _react2.default.createElement(
        'h5',
        { className: classesH5 },
        this._getSkillDescription(skillSuggestion, skillOptions)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var classesBoard = (0, _classnames2.default)(_style2.default.SkillSuggestionCard_board);
      var _props2 = this.props,
          skillSuggestion = _props2.skillSuggestion,
          isMissing = _props2.isMissing,
          canEditSkillRecommandation = _props2.canEditSkillRecommandation;

      return _react2.default.createElement(
        'div',
        { className: classesBoard },
        _react2.default.createElement(
          _omniCommonUi.Grid,
          null,
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12, sm: 6, md: 6, className: _style2.default.SkillSuggestionCard_item },
              this._renderSkillResult()
            )
          )
        ),
        skillSuggestion && _react2.default.createElement(_SkillRecommendation2.default, { skillRecommendations: this.props.skillRecommendations,
          skillId: skillSuggestion.skillId,
          isSSV3Group: this.props.isSSV3Group,
          isInEditMode: this.props.isInEditMode,
          selectedRecommendationItemIds: skillSuggestion.selectedRecommendationList,
          suggestion: this._judgeValue(skillSuggestion.suggestion),
          onRecommendationChanged: this.props.onRecommendationChanged,
          isMissing: isMissing,
          showEditButton: canEditSkillRecommandation })
      );
    }
  }]);

  return SkillSuggestionCard;
}(_react.PureComponent);

exports.default = SkillSuggestionCard;


SkillSuggestionCard.propTypes = {
  skillSuggestion: _propTypes2.default.shape(),
  isSSV3Group: _propTypes2.default.bool,
  isInEditMode: _propTypes2.default.bool.isRequired,
  className: _propTypes2.default.string,
  skillOptions: _propTypes2.default.array,
  onSkillChanged: _propTypes2.default.func,
  onRecommendationChanged: _propTypes2.default.func,
  isManuallyAdded: _propTypes2.default.bool.isRequired,
  isMissing: _propTypes2.default.bool,
  canEditSkillRecommandation: _propTypes2.default.bool,
  index: _propTypes2.default.number.isRequired,
  hiddenOptions: _propTypes2.default.array,
  skillRecommendations: _propTypes2.default.shape()
};

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1781);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2VlZYYKI6NcV_Z2SYFb3VS{width:100%}._2t16LNmDgPXb-ZG1cJ8X18{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1.14286rem;font-weight:600;letter-spacing:.07143rem;line-height:1.125;margin:0;padding-bottom:.71429rem}._1KeysdMgXZHBBRVkSCynLz{min-height:2.5rem}@media only screen and (min-width:480px){._3YSxMriUFnFIUYRBmKTZ7S{padding-right:1.42857rem}}@media only screen and (min-width:640px){._3YSxMriUFnFIUYRBmKTZ7S{padding-right:2.14286rem}}._33FqebRZsvULpmLdhHqabI{padding-bottom:.71429rem}.snAPyXOo3qoziYpC6RqPZ{padding-bottom:1.07143rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SkillSuggestionCard_board": "_2VlZYYKI6NcV_Z2SYFb3VS",
	"SkillSuggestionCard_h5": "_2t16LNmDgPXb-ZG1cJ8X18",
	"SkillSuggestionCard_select_option": "_1KeysdMgXZHBBRVkSCynLz",
	"SkillSuggestionCard_item": "_3YSxMriUFnFIUYRBmKTZ7S",
	"SkillSuggestionCard_skillResult": "_33FqebRZsvULpmLdhHqabI",
	"SkillSuggestionCard_skillResult_indexLabel": "snAPyXOo3qoziYpC6RqPZ"
};

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1783);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _react3 = __webpack_require__(213);

var _react4 = _interopRequireDefault(_react3);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SkillRecommendationExpandPanel = __webpack_require__(1791);

var _SkillRecommendationExpandPanel2 = _interopRequireDefault(_SkillRecommendationExpandPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SkillRecommendation = function (_PureComponent) {
  _inherits(SkillRecommendation, _PureComponent);

  function SkillRecommendation() {
    _classCallCheck(this, SkillRecommendation);

    var _this = _possibleConstructorReturn(this, (SkillRecommendation.__proto__ || Object.getPrototypeOf(SkillRecommendation)).call(this));

    _this.state = {
      isDialogOpen: false,
      selectedRecommendationItemIds: []
    };
    _this._checkRecommendationItem = _this._checkRecommendationItem.bind(_this);
    return _this;
  }

  _createClass(SkillRecommendation, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ selectedRecommendationItemIds: this.props.selectedRecommendationItemIds });
    }
  }, {
    key: '_checkRecommendationItem',
    value: function _checkRecommendationItem(id) {
      var selectedRecommendationItemIds = this.state.selectedRecommendationItemIds;

      if (selectedRecommendationItemIds.includes(id)) {
        selectedRecommendationItemIds = selectedRecommendationItemIds.filter(function (selectedId) {
          return selectedId !== id;
        });
      } else {
        selectedRecommendationItemIds = [].concat(_toConsumableArray(selectedRecommendationItemIds), [id]);
      }
      this.setState({ selectedRecommendationItemIds: selectedRecommendationItemIds });
    }
  }, {
    key: '_onOkClick',
    value: function _onOkClick() {
      this.props.onRecommendationChanged(this.state.selectedRecommendationItemIds);
      this.setState({ isDialogOpen: false });
    }
  }, {
    key: '_onCancelClick',
    value: function _onCancelClick() {
      this.setState({
        isDialogOpen: false,
        selectedRecommendationItemIds: this.props.selectedRecommendationItemIds
      });
    }
  }, {
    key: '_onClickEditActionPlan',
    value: function _onClickEditActionPlan() {
      this.setState({
        isDialogOpen: true,
        selectedRecommendationItemIds: this.props.selectedRecommendationItemIds
      });
    }
  }, {
    key: '_renderPopup',
    value: function _renderPopup(recommendationItems) {
      var _this2 = this;

      var recommendationItemsGroupByCategoryName = recommendationItems.groupBy(function (recommendationItem) {
        return recommendationItem.categoryName;
      });
      var selectedRecommendationItemIds = this.state.selectedRecommendationItemIds;

      return _react2.default.createElement(
        _omniCommonUi.Dialog,
        { isOpen: this.state.isDialogOpen,
          className: _style2.default.SkillRecommendation_popup,
          paddingless: true },
        _react2.default.createElement(
          'div',
          { className: _style2.default.SkillRecommendation_popup_content },
          recommendationItemsGroupByCategoryName.map(function (categoryItems) {
            return _react2.default.createElement(_SkillRecommendationExpandPanel2.default, { categoryName: categoryItems.first().categoryName,
              isSSV3Group: _this2.props.isSSV3Group,
              recommendationItems: categoryItems,
              selectedRecommendationItemIds: selectedRecommendationItemIds,
              checkRecommendationItem: _this2._checkRecommendationItem });
          })
        ),
        _react2.default.createElement(
          _omniCommonUi.Button.Container,
          { className: _style2.default.SkillRecommendation_popup_buttons },
          _react2.default.createElement(
            _omniCommonUi.Button,
            { onClick: function onClick() {
                return _this2._onCancelClick();
              } },
            'Cancel'
          ),
          _react2.default.createElement(
            _omniCommonUi.Button,
            { type: _omniCommonUi.Button.Type.primary,
              onClick: function onClick() {
                return _this2._onOkClick();
              } },
            'Ok'
          )
        )
      );
    }
  }, {
    key: '_renderSelectedRecommendationItems',
    value: function _renderSelectedRecommendationItems(recommendationItems, selectedRecommendationItemIds) {
      var selectedrecommendationItems = recommendationItems.filter(function (recommendationItem) {
        return selectedRecommendationItemIds.includes(recommendationItem.id);
      });
      return _react2.default.createElement(
        'div',
        { className: _style2.default.SkillRecommendation_container },
        !this.props.isInEditMode && _react2.default.createElement(
          'div',
          { className: _style2.default.SkillRecommendation_subHeading },
          'Suggestions'
        ),
        selectedrecommendationItems.map(function (selectedrecommendationItem) {
          return _react2.default.createElement(
            'div',
            { key: selectedrecommendationItem.id, className: _style2.default.SkillRecommendation_item },
            _react2.default.createElement(
              _react4.default,
              null,
              selectedrecommendationItem.itemName
            )
          );
        }),
        !this.props.isInEditMode && _react2.default.createElement(
          'div',
          { className: _style2.default.SkillRecommendation_item },
          this.props.suggestion
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          selectedRecommendationItemIds = _props.selectedRecommendationItemIds,
          skillRecommendations = _props.skillRecommendations,
          skillId = _props.skillId,
          isInEditMode = _props.isInEditMode,
          isMissing = _props.isMissing,
          showEditButton = _props.showEditButton;


      if (!skillRecommendations.keySeq().includes('' + skillId)) return null;

      var recommendationItems = skillRecommendations.get('' + skillId).skillRecommendationItems;
      return _react2.default.createElement(
        'div',
        null,
        this._renderSelectedRecommendationItems(recommendationItems, selectedRecommendationItemIds),
        isInEditMode && showEditButton && _react2.default.createElement(
          _omniCommonUi.Button,
          { className: _style2.default.SkillRecommendation_editButton,
            type: isMissing ? _omniCommonUi.Button.Type.wrong : _omniCommonUi.Button.Type.default,
            onClick: function onClick() {
              return _this3._onClickEditActionPlan();
            } },
          'Edit action plan'
        ),
        this._renderPopup(recommendationItems)
      );
    }
  }]);

  return SkillRecommendation;
}(_react.PureComponent);

exports.default = SkillRecommendation;


SkillRecommendation.propTypes = {
  skillRecommendations: _propTypes2.default.shape(),
  skillId: _propTypes2.default.number,
  suggestion: _propTypes2.default.string,
  isSSV3Group: _propTypes2.default.bool,
  isInEditMode: _propTypes2.default.bool.isRequired,
  selectedRecommendationItemIds: _propTypes2.default.oneOfType([_propTypes2.default.shape(), _propTypes2.default.array]),
  onRecommendationChanged: _propTypes2.default.func,
  isMissing: _propTypes2.default.bool,
  showEditButton: _propTypes2.default.bool
};

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1784);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".Z-8uCtX_c5hbcGQyOGuq5{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;width:35.71429rem}.TNWFWEMVugKIO_jaau8XN{height:28.57143rem;overflow-y:auto}._1py7fiTl7GLow510U4Cu8v{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-bottom:1.42857rem;padding-right:1.42857rem;padding-top:1.42857rem}._1DL1BPg62HpMXpPpHmdju4{border-bottom:.07143rem solid transparent;font-size:1rem;line-height:1.5;margin:0}._3NfnS2avixMqd4n3w61nKa{color:#a4a4a4;font-size:.92857rem;line-height:1.38462}._178pTBmcdHGfPsHUUEf3Vr+._178pTBmcdHGfPsHUUEf3Vr{margin-top:1.42857rem}._178pTBmcdHGfPsHUUEf3Vr:first-of-type{margin-top:1.07143rem}._1Vxs-3yJicPrteqYJmYDq-{margin-bottom:1.42857rem;margin-top:1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SkillRecommendation_popup": "Z-8uCtX_c5hbcGQyOGuq5",
	"SkillRecommendation_popup_content": "TNWFWEMVugKIO_jaau8XN",
	"SkillRecommendation_popup_buttons": "_1py7fiTl7GLow510U4Cu8v",
	"SkillRecommendation_container": "_1DL1BPg62HpMXpPpHmdju4",
	"SkillRecommendation_subHeading": "_3NfnS2avixMqd4n3w61nKa",
	"SkillRecommendation_item": "_178pTBmcdHGfPsHUUEf3Vr",
	"SkillRecommendation_editButton": "_1Vxs-3yJicPrteqYJmYDq-"
};

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _linkify = __webpack_require__(1786);

var linkify = _interopRequireWildcard(_linkify);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var options = linkify.options;
var Options = options.Options;

// Given a string, converts to an array of valid React components
// (which may include strings)

function stringToElements(str, opts) {

	var tokens = linkify.tokenize(str);
	var elements = [];
	var linkId = 0;

	for (var i = 0; i < tokens.length; i++) {
		var token = tokens[i];

		if (token.type === 'nl' && opts.nl2br) {
			elements.push(_react2.default.createElement('br', { key: 'linkified-' + ++linkId }));
			continue;
		} else if (!token.isLink || !opts.check(token)) {
			// Regular text
			elements.push(token.toString());
			continue;
		}

		var _opts$resolve = opts.resolve(token),
		    href = _opts$resolve.href,
		    formatted = _opts$resolve.formatted,
		    formattedHref = _opts$resolve.formattedHref,
		    tagName = _opts$resolve.tagName,
		    className = _opts$resolve.className,
		    target = _opts$resolve.target,
		    attributes = _opts$resolve.attributes,
		    events = _opts$resolve.events;

		var props = {
			key: 'linkified-' + ++linkId,
			href: formattedHref
		};

		if (className) {
			props.className = className;
		}

		if (target) {
			props.target = target;
		}

		// Build up additional attributes
		// Support for events via attributes hash
		if (attributes) {
			for (var attr in attributes) {
				props[attr] = attributes[attr];
			}
		}

		elements.push(_react2.default.createElement(tagName, props, formatted));
	}

	return elements;
}

// Recursively linkify the contents of the given React Element instance
function linkifyReactElement(element, opts) {
	var elementId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

	if (_react2.default.Children.count(element.props.children) === 0) {
		// No need to clone if the element had no children
		return element;
	}

	var children = [];

	_react2.default.Children.forEach(element.props.children, function (child) {
		if (typeof child === 'string') {
			children.push.apply(children, stringToElements(child, opts));
		} else if (_react2.default.isValidElement(child)) {
			if (typeof child.type === 'string' && options.contains(opts.ignoreTags, child.type.toUpperCase())) {
				// Don't linkify this element
				children.push(child);
			} else {
				children.push(linkifyReactElement(child, opts, ++elementId));
			}
		} else {
			// Unknown element type, just push
			children.push(child);
		}
	});

	// Set a default unique key, copy over remaining props
	var newProps = { key: 'linkified-element-' + elementId };
	for (var prop in element.props) {
		newProps[prop] = element.props[prop];
	}

	return _react2.default.cloneElement(element, newProps, children);
}

var Linkify = function (_React$Component) {
	_inherits(Linkify, _React$Component);

	function Linkify() {
		_classCallCheck(this, Linkify);

		return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	}

	Linkify.prototype.render = function render() {
		// Copy over all non-linkify-specific props
		var newProps = { key: 'linkified-element-0' };
		for (var prop in this.props) {
			if (prop !== 'options' && prop !== 'tagName') {
				newProps[prop] = this.props[prop];
			}
		}

		var opts = new Options(this.props.options);
		var tagName = this.props.tagName || 'span';
		var element = _react2.default.createElement(tagName, newProps);

		return linkifyReactElement(element, opts, 0);
	};

	return Linkify;
}(_react2.default.Component);

exports.default = Linkify;

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.tokenize = exports.test = exports.scanner = exports.parser = exports.options = exports.inherits = exports.find = undefined;

var _class = __webpack_require__(214);

var _options = __webpack_require__(1787);

var options = _interopRequireWildcard(_options);

var _scanner = __webpack_require__(1788);

var scanner = _interopRequireWildcard(_scanner);

var _parser = __webpack_require__(1789);

var parser = _interopRequireWildcard(_parser);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

if (!Array.isArray) {
	Array.isArray = function (arg) {
		return Object.prototype.toString.call(arg) === '[object Array]';
	};
}

/**
	Converts a string into tokens that represent linkable and non-linkable bits
	@method tokenize
	@param {String} str
	@return {Array} tokens
*/
var tokenize = function tokenize(str) {
	return parser.run(scanner.run(str));
};

/**
	Returns a list of linkable items in the given string.
*/
var find = function find(str) {
	var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var tokens = tokenize(str);
	var filtered = [];

	for (var i = 0; i < tokens.length; i++) {
		var token = tokens[i];
		if (token.isLink && (!type || token.type === type)) {
			filtered.push(token.toObject());
		}
	}

	return filtered;
};

/**
	Is the given string valid linkable text of some sort
	Note that this does not trim the text for you.

	Optionally pass in a second `type` param, which is the type of link to test
	for.

	For example,

		test(str, 'email');

	Will return `true` if str is a valid email.
*/
var test = function test(str) {
	var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var tokens = tokenize(str);
	return tokens.length === 1 && tokens[0].isLink && (!type || tokens[0].type === type);
};

// Scanner and parser provide states and tokens for the lexicographic stage
// (will be used to add additional link types)
exports.find = find;
exports.inherits = _class.inherits;
exports.options = options;
exports.parser = parser;
exports.scanner = scanner;
exports.test = test;
exports.tokenize = tokenize;

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var defaults = {
	defaultProtocol: 'http',
	events: null,
	format: noop,
	formatHref: noop,
	nl2br: false,
	tagName: 'a',
	target: typeToTarget,
	validate: true,
	ignoreTags: [],
	attributes: null,
	className: 'linkified' };

exports.defaults = defaults;
exports.Options = Options;
exports.contains = contains;


function Options(opts) {
	opts = opts || {};

	this.defaultProtocol = opts.defaultProtocol || defaults.defaultProtocol;
	this.events = opts.events || defaults.events;
	this.format = opts.format || defaults.format;
	this.formatHref = opts.formatHref || defaults.formatHref;
	this.nl2br = opts.nl2br || defaults.nl2br;
	this.tagName = opts.tagName || defaults.tagName;
	this.target = opts.target || defaults.target;
	this.validate = opts.validate || defaults.validate;
	this.ignoreTags = [];

	// linkAttributes and linkClass is deprecated
	this.attributes = opts.attributes || opts.linkAttributes || defaults.attributes;
	this.className = opts.className || opts.linkClass || defaults.className;

	// Make all tags names upper case

	var ignoredTags = opts.ignoreTags || defaults.ignoreTags;
	for (var i = 0; i < ignoredTags.length; i++) {
		this.ignoreTags.push(ignoredTags[i].toUpperCase());
	}
}

Options.prototype = {
	/**
  * Given the token, return all options for how it should be displayed
  */
	resolve: function resolve(token) {
		var href = token.toHref(this.defaultProtocol);
		return {
			formatted: this.get('format', token.toString(), token),
			formattedHref: this.get('formatHref', href, token),
			tagName: this.get('tagName', href, token),
			className: this.get('className', href, token),
			target: this.get('target', href, token),
			events: this.getObject('events', href, token),
			attributes: this.getObject('attributes', href, token)
		};
	},


	/**
  * Returns true or false based on whether a token should be displayed as a
  * link based on the user options. By default,
  */
	check: function check(token) {
		return this.get('validate', token.toString(), token);
	},


	// Private methods

	/**
  * Resolve an option's value based on the value of the option and the given
  * params.
  * @param [String] key Name of option to use
  * @param operator will be passed to the target option if it's method
  * @param [MultiToken] token The token from linkify.tokenize
  */
	get: function get(key, operator, token) {
		var option = this[key];

		if (!option) {
			return option;
		}

		switch (typeof option === 'undefined' ? 'undefined' : _typeof(option)) {
			case 'function':
				return option(operator, token.type);
			case 'object':
				var optionValue = option[token.type] || defaults[key];
				return typeof optionValue === 'function' ? optionValue(operator, token.type) : optionValue;
		}

		return option;
	},
	getObject: function getObject(key, operator, token) {
		var option = this[key];
		return typeof option === 'function' ? option(operator, token.type) : option;
	}
};

/**
 * Quick indexOf replacement for checking the ignoreTags option
 */
function contains(arr, value) {
	for (var i = 0; i < arr.length; i++) {
		if (arr[i] === value) {
			return true;
		}
	}
	return false;
}

function noop(val) {
	return val;
}

function typeToTarget(href, type) {
	return type === 'url' ? '_blank' : null;
}

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.start = exports.run = exports.TOKENS = exports.State = undefined;

var _state = __webpack_require__(778);

var _text = __webpack_require__(327);

var TOKENS = _interopRequireWildcard(_text);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var tlds = 'aaa|aarp|abb|abbott|abogado|ac|academy|accenture|accountant|accountants|aco|active|actor|ad|adac|ads|adult|ae|aeg|aero|af|afl|ag|agency|ai|aig|airforce|airtel|al|alibaba|alipay|allfinanz|alsace|am|amica|amsterdam|an|analytics|android|ao|apartments|app|apple|aq|aquarelle|ar|aramco|archi|army|arpa|arte|as|asia|associates|at|attorney|au|auction|audi|audio|author|auto|autos|avianca|aw|ax|axa|az|azure|ba|baidu|band|bank|bar|barcelona|barclaycard|barclays|bargains|bauhaus|bayern|bb|bbc|bbva|bcg|bcn|bd|be|beats|beer|bentley|berlin|best|bet|bf|bg|bh|bharti|bi|bible|bid|bike|bing|bingo|bio|biz|bj|black|blackfriday|bloomberg|blue|bm|bms|bmw|bn|bnl|bnpparibas|bo|boats|boehringer|bom|bond|boo|book|boots|bosch|bostik|bot|boutique|br|bradesco|bridgestone|broadway|broker|brother|brussels|bs|bt|budapest|bugatti|build|builders|business|buy|buzz|bv|bw|by|bz|bzh|ca|cab|cafe|cal|call|camera|camp|cancerresearch|canon|capetown|capital|car|caravan|cards|care|career|careers|cars|cartier|casa|cash|casino|cat|catering|cba|cbn|cc|cd|ceb|center|ceo|cern|cf|cfa|cfd|cg|ch|chanel|channel|chase|chat|cheap|chloe|christmas|chrome|church|ci|cipriani|circle|cisco|citic|city|cityeats|ck|cl|claims|cleaning|click|clinic|clinique|clothing|cloud|club|clubmed|cm|cn|co|coach|codes|coffee|college|cologne|com|commbank|community|company|compare|computer|comsec|condos|construction|consulting|contact|contractors|cooking|cool|coop|corsica|country|coupon|coupons|courses|cr|credit|creditcard|creditunion|cricket|crown|crs|cruises|csc|cu|cuisinella|cv|cw|cx|cy|cymru|cyou|cz|dabur|dad|dance|date|dating|datsun|day|dclk|de|dealer|deals|degree|delivery|dell|deloitte|delta|democrat|dental|dentist|desi|design|dev|diamonds|diet|digital|direct|directory|discount|dj|dk|dm|dnp|do|docs|dog|doha|domains|download|drive|dubai|durban|dvag|dz|earth|eat|ec|edeka|edu|education|ee|eg|email|emerck|energy|engineer|engineering|enterprises|epson|equipment|er|erni|es|esq|estate|et|eu|eurovision|eus|events|everbank|exchange|expert|exposed|express|fage|fail|fairwinds|faith|family|fan|fans|farm|fashion|fast|feedback|ferrero|fi|film|final|finance|financial|firestone|firmdale|fish|fishing|fit|fitness|fj|fk|flickr|flights|florist|flowers|flsmidth|fly|fm|fo|foo|football|ford|forex|forsale|forum|foundation|fox|fr|fresenius|frl|frogans|frontier|fund|furniture|futbol|fyi|ga|gal|gallery|gallup|game|garden|gb|gbiz|gd|gdn|ge|gea|gent|genting|gf|gg|ggee|gh|gi|gift|gifts|gives|giving|gl|glass|gle|global|globo|gm|gmail|gmbh|gmo|gmx|gn|gold|goldpoint|golf|goo|goog|google|gop|got|gov|gp|gq|gr|grainger|graphics|gratis|green|gripe|group|gs|gt|gu|gucci|guge|guide|guitars|guru|gw|gy|hamburg|hangout|haus|hdfcbank|health|healthcare|help|helsinki|here|hermes|hiphop|hitachi|hiv|hk|hm|hn|hockey|holdings|holiday|homedepot|homes|honda|horse|host|hosting|hoteles|hotmail|house|how|hr|hsbc|ht|hu|hyundai|ibm|icbc|ice|icu|id|ie|ifm|iinet|il|im|immo|immobilien|in|industries|infiniti|info|ing|ink|institute|insurance|insure|int|international|investments|io|ipiranga|iq|ir|irish|is|iselect|ist|istanbul|it|itau|iwc|jaguar|java|jcb|je|jetzt|jewelry|jlc|jll|jm|jmp|jo|jobs|joburg|jot|joy|jp|jpmorgan|jprs|juegos|kaufen|kddi|ke|kerryhotels|kerrylogistics|kerryproperties|kfh|kg|kh|ki|kia|kim|kinder|kitchen|kiwi|km|kn|koeln|komatsu|kp|kpn|kr|krd|kred|kuokgroup|kw|ky|kyoto|kz|la|lacaixa|lamborghini|lamer|lancaster|land|landrover|lanxess|lasalle|lat|latrobe|law|lawyer|lb|lc|lds|lease|leclerc|legal|lexus|lgbt|li|liaison|lidl|life|lifeinsurance|lifestyle|lighting|like|limited|limo|lincoln|linde|link|live|living|lixil|lk|loan|loans|local|locus|lol|london|lotte|lotto|love|lr|ls|lt|ltd|ltda|lu|lupin|luxe|luxury|lv|ly|ma|madrid|maif|maison|makeup|man|management|mango|market|marketing|markets|marriott|mba|mc|md|me|med|media|meet|melbourne|meme|memorial|men|menu|meo|mg|mh|miami|microsoft|mil|mini|mk|ml|mm|mma|mn|mo|mobi|mobily|moda|moe|moi|mom|monash|money|montblanc|mormon|mortgage|moscow|motorcycles|mov|movie|movistar|mp|mq|mr|ms|mt|mtn|mtpc|mtr|mu|museum|mutuelle|mv|mw|mx|my|mz|na|nadex|nagoya|name|natura|navy|nc|ne|nec|net|netbank|network|neustar|new|news|nexus|nf|ng|ngo|nhk|ni|nico|nikon|ninja|nissan|nl|no|nokia|norton|nowruz|np|nr|nra|nrw|ntt|nu|nyc|nz|obi|office|okinawa|om|omega|one|ong|onl|online|ooo|oracle|orange|org|organic|origins|osaka|otsuka|ovh|pa|page|pamperedchef|panerai|paris|pars|partners|parts|party|passagens|pe|pet|pf|pg|ph|pharmacy|philips|photo|photography|photos|physio|piaget|pics|pictet|pictures|pid|pin|ping|pink|pizza|pk|pl|place|play|playstation|plumbing|plus|pm|pn|pohl|poker|porn|post|pr|praxi|press|pro|prod|productions|prof|promo|properties|property|protection|ps|pt|pub|pw|pwc|py|qa|qpon|quebec|quest|racing|re|read|realtor|realty|recipes|red|redstone|redumbrella|rehab|reise|reisen|reit|ren|rent|rentals|repair|report|republican|rest|restaurant|review|reviews|rexroth|rich|ricoh|rio|rip|ro|rocher|rocks|rodeo|room|rs|rsvp|ru|ruhr|run|rw|rwe|ryukyu|sa|saarland|safe|safety|sakura|sale|salon|samsung|sandvik|sandvikcoromant|sanofi|sap|sapo|sarl|sas|saxo|sb|sbs|sc|sca|scb|schaeffler|schmidt|scholarships|school|schule|schwarz|science|scor|scot|sd|se|seat|security|seek|select|sener|services|seven|sew|sex|sexy|sfr|sg|sh|sharp|shell|shia|shiksha|shoes|show|shriram|si|singles|site|sj|sk|ski|skin|sky|skype|sl|sm|smile|sn|sncf|so|soccer|social|softbank|software|sohu|solar|solutions|song|sony|soy|space|spiegel|spot|spreadbetting|sr|srl|st|stada|star|starhub|statefarm|statoil|stc|stcgroup|stockholm|storage|store|studio|study|style|su|sucks|supplies|supply|support|surf|surgery|suzuki|sv|swatch|swiss|sx|sy|sydney|symantec|systems|sz|tab|taipei|taobao|tatamotors|tatar|tattoo|tax|taxi|tc|tci|td|team|tech|technology|tel|telecity|telefonica|temasek|tennis|tf|tg|th|thd|theater|theatre|tickets|tienda|tiffany|tips|tires|tirol|tj|tk|tl|tm|tmall|tn|to|today|tokyo|tools|top|toray|toshiba|total|tours|town|toyota|toys|tp|tr|trade|trading|training|travel|travelers|travelersinsurance|trust|trv|tt|tube|tui|tunes|tushu|tv|tvs|tw|tz|ua|ubs|ug|uk|unicom|university|uno|uol|us|uy|uz|va|vacations|vana|vc|ve|vegas|ventures|verisign|versicherung|vet|vg|vi|viajes|video|viking|villas|vin|vip|virgin|vision|vista|vistaprint|viva|vlaanderen|vn|vodka|volkswagen|vote|voting|voto|voyage|vu|vuelos|wales|walter|wang|wanggou|watch|watches|weather|weatherchannel|webcam|weber|website|wed|wedding|weir|wf|whoswho|wien|wiki|williamhill|win|windows|wine|wme|wolterskluwer|work|works|world|ws|wtc|wtf|xbox|xerox|xin|xperia|xxx|xyz|yachts|yahoo|yamaxun|yandex|ye|yodobashi|yoga|yokohama|youtube|yt|za|zara|zero|zip|zm|zone|zuerich|zw'.split('|'); // macro, see gulpfile.js

/**
	The scanner provides an interface that takes a string of text as input, and
	outputs an array of tokens instances that can be used for easy URL parsing.

	@module linkify
	@submodule scanner
	@main scanner
*/

var NUMBERS = '0123456789'.split('');
var ALPHANUM = '0123456789abcdefghijklmnopqrstuvwxyz'.split('');
var WHITESPACE = [' ', '\f', '\r', '\t', '\v', '\xA0', '\u1680', '\u180E']; // excluding line breaks

var domainStates = []; // states that jump to DOMAIN on /[a-z0-9]/
var makeState = function makeState(tokenClass) {
	return new _state.CharacterState(tokenClass);
};

// Frequently used states
var S_START = makeState();
var S_NUM = makeState(_text.NUM);
var S_DOMAIN = makeState(_text.DOMAIN);
var S_DOMAIN_HYPHEN = makeState(); // domain followed by 1 or more hyphen characters
var S_WS = makeState(_text.WS);

// States for special URL symbols
S_START.on('@', makeState(_text.AT)).on('.', makeState(_text.DOT)).on('+', makeState(_text.PLUS)).on('#', makeState(_text.POUND)).on('?', makeState(_text.QUERY)).on('/', makeState(_text.SLASH)).on('_', makeState(_text.UNDERSCORE)).on(':', makeState(_text.COLON)).on('{', makeState(_text.OPENBRACE)).on('[', makeState(_text.OPENBRACKET)).on('<', makeState(_text.OPENANGLEBRACKET)).on('(', makeState(_text.OPENPAREN)).on('}', makeState(_text.CLOSEBRACE)).on(']', makeState(_text.CLOSEBRACKET)).on('>', makeState(_text.CLOSEANGLEBRACKET)).on(')', makeState(_text.CLOSEPAREN)).on('&', makeState(_text.AMPERSAND)).on([',', ';', '!', '"', '\''], makeState(_text.PUNCTUATION));

// Whitespace jumps
// Tokens of only non-newline whitespace are arbitrarily long
S_START.on('\n', makeState(_text.NL)).on(WHITESPACE, S_WS);

// If any whitespace except newline, more whitespace!
S_WS.on(WHITESPACE, S_WS);

// Generates states for top-level domains
// Note that this is most accurate when tlds are in alphabetical order
for (var i = 0; i < tlds.length; i++) {
	var newStates = (0, _state.stateify)(tlds[i], S_START, _text.TLD, _text.DOMAIN);
	domainStates.push.apply(domainStates, newStates);
}

// Collect the states generated by different protocls
var partialProtocolFileStates = (0, _state.stateify)('file', S_START, _text.DOMAIN, _text.DOMAIN);
var partialProtocolFtpStates = (0, _state.stateify)('ftp', S_START, _text.DOMAIN, _text.DOMAIN);
var partialProtocolHttpStates = (0, _state.stateify)('http', S_START, _text.DOMAIN, _text.DOMAIN);
var partialProtocolMailtoStates = (0, _state.stateify)('mailto', S_START, _text.DOMAIN, _text.DOMAIN);

// Add the states to the array of DOMAINeric states
domainStates.push.apply(domainStates, partialProtocolFileStates);
domainStates.push.apply(domainStates, partialProtocolFtpStates);
domainStates.push.apply(domainStates, partialProtocolHttpStates);

// Protocol states
var S_PROTOCOL_FILE = partialProtocolFileStates.pop();
var S_PROTOCOL_FTP = partialProtocolFtpStates.pop();
var S_PROTOCOL_HTTP = partialProtocolHttpStates.pop();
var S_MAILTO = partialProtocolMailtoStates.pop();
var S_PROTOCOL_SECURE = makeState(_text.DOMAIN);
var S_FULL_PROTOCOL = makeState(_text.PROTOCOL); // Full protocol ends with COLON
var S_FULL_MAILTO = makeState(_text.MAILTO); // Mailto ends with COLON

// Secure protocols (end with 's')
S_PROTOCOL_FTP.on('s', S_PROTOCOL_SECURE).on(':', S_FULL_PROTOCOL);

S_PROTOCOL_HTTP.on('s', S_PROTOCOL_SECURE).on(':', S_FULL_PROTOCOL);

domainStates.push(S_PROTOCOL_SECURE);

// Become protocol tokens after a COLON
S_PROTOCOL_FILE.on(':', S_FULL_PROTOCOL);
S_PROTOCOL_SECURE.on(':', S_FULL_PROTOCOL);
S_MAILTO.on(':', S_FULL_MAILTO);

// Localhost
var partialLocalhostStates = (0, _state.stateify)('localhost', S_START, _text.LOCALHOST, _text.DOMAIN);
domainStates.push.apply(domainStates, partialLocalhostStates);

// Everything else
// DOMAINs make more DOMAINs
// Number and character transitions
S_START.on(NUMBERS, S_NUM);
S_NUM.on('-', S_DOMAIN_HYPHEN).on(NUMBERS, S_NUM).on(ALPHANUM, S_DOMAIN); // number becomes DOMAIN

S_DOMAIN.on('-', S_DOMAIN_HYPHEN).on(ALPHANUM, S_DOMAIN);

// All the generated states should have a jump to DOMAIN
for (var _i = 0; _i < domainStates.length; _i++) {
	domainStates[_i].on('-', S_DOMAIN_HYPHEN).on(ALPHANUM, S_DOMAIN);
}

S_DOMAIN_HYPHEN.on('-', S_DOMAIN_HYPHEN).on(NUMBERS, S_DOMAIN).on(ALPHANUM, S_DOMAIN);

// Set default transition
S_START.defaultTransition = makeState(_text.SYM);

/**
	Given a string, returns an array of TOKEN instances representing the
	composition of that string.

	@method run
	@param {String} str Input string to scan
	@return {Array} Array of TOKEN instances
*/
var run = function run(str) {

	// The state machine only looks at lowercase strings.
	// This selective `toLowerCase` is used because lowercasing the entire
	// string causes the length and character position to vary in some in some
	// non-English strings. This happens only on V8-based runtimes.
	var lowerStr = str.replace(/[A-Z]/g, function (c) {
		return c.toLowerCase();
	});
	var len = str.length;
	var tokens = []; // return value

	var cursor = 0;

	// Tokenize the string
	while (cursor < len) {
		var state = S_START;
		var secondState = null;
		var nextState = null;
		var tokenLength = 0;
		var latestAccepting = null;
		var sinceAccepts = -1;

		while (cursor < len && (nextState = state.next(lowerStr[cursor]))) {
			secondState = null;
			state = nextState;

			// Keep track of the latest accepting state
			if (state.accepts()) {
				sinceAccepts = 0;
				latestAccepting = state;
			} else if (sinceAccepts >= 0) {
				sinceAccepts++;
			}

			tokenLength++;
			cursor++;
		}

		if (sinceAccepts < 0) {
			continue;
		} // Should never happen

		// Roll back to the latest accepting state
		cursor -= sinceAccepts;
		tokenLength -= sinceAccepts;

		// Get the class for the new token
		var TOKEN = latestAccepting.emit(); // Current token class

		// No more jumps, just make a new token
		tokens.push(new TOKEN(str.substr(cursor - tokenLength, tokenLength)));
	}

	return tokens;
};

var start = S_START;
exports.State = _state.CharacterState;
exports.TOKENS = TOKENS;
exports.run = run;
exports.start = start;

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.start = exports.run = exports.TOKENS = exports.State = undefined;

var _state = __webpack_require__(778);

var _text = __webpack_require__(327);

var TEXT_TOKENS = _interopRequireWildcard(_text);

var _multi = __webpack_require__(1790);

var MULTI_TOKENS = _interopRequireWildcard(_multi);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var makeState = function makeState(tokenClass) {
	return new _state.TokenState(tokenClass);
};

// The universal starting state.
/**
	Not exactly parser, more like the second-stage scanner (although we can
	theoretically hotswap the code here with a real parser in the future... but
	for a little URL-finding utility abstract syntax trees may be a little
	overkill).

	URL format: http://en.wikipedia.org/wiki/URI_scheme
	Email format: http://en.wikipedia.org/wiki/Email_address (links to RFC in
	reference)

	@module linkify
	@submodule parser
	@main parser
*/

var S_START = makeState();

// Intermediate states for URLs. Note that domains that begin with a protocol
// are treated slighly differently from those that don't.
var S_PROTOCOL = makeState(); // e.g., 'http:'
var S_MAILTO = makeState(); // 'mailto:'
var S_PROTOCOL_SLASH = makeState(); // e.g., '/', 'http:/''
var S_PROTOCOL_SLASH_SLASH = makeState(); // e.g., '//', 'http://'
var S_DOMAIN = makeState(); // parsed string ends with a potential domain name (A)
var S_DOMAIN_DOT = makeState(); // (A) domain followed by DOT
var S_TLD = makeState(_multi.URL); // (A) Simplest possible URL with no query string
var S_TLD_COLON = makeState(); // (A) URL followed by colon (potential port number here)
var S_TLD_PORT = makeState(_multi.URL); // TLD followed by a port number
var S_URL = makeState(_multi.URL); // Long URL with optional port and maybe query string
var S_URL_NON_ACCEPTING = makeState(); // URL followed by some symbols (will not be part of the final URL)
var S_URL_OPENBRACE = makeState(); // URL followed by {
var S_URL_OPENBRACKET = makeState(); // URL followed by [
var S_URL_OPENANGLEBRACKET = makeState(); // URL followed by <
var S_URL_OPENPAREN = makeState(); // URL followed by (
var S_URL_OPENBRACE_Q = makeState(_multi.URL); // URL followed by { and some symbols that the URL can end it
var S_URL_OPENBRACKET_Q = makeState(_multi.URL); // URL followed by [ and some symbols that the URL can end it
var S_URL_OPENANGLEBRACKET_Q = makeState(_multi.URL); // URL followed by < and some symbols that the URL can end it
var S_URL_OPENPAREN_Q = makeState(_multi.URL); // URL followed by ( and some symbols that the URL can end it
var S_URL_OPENBRACE_SYMS = makeState(); // S_URL_OPENBRACE_Q followed by some symbols it cannot end it
var S_URL_OPENBRACKET_SYMS = makeState(); // S_URL_OPENBRACKET_Q followed by some symbols it cannot end it
var S_URL_OPENANGLEBRACKET_SYMS = makeState(); // S_URL_OPENANGLEBRACKET_Q followed by some symbols it cannot end it
var S_URL_OPENPAREN_SYMS = makeState(); // S_URL_OPENPAREN_Q followed by some symbols it cannot end it
var S_EMAIL_DOMAIN = makeState(); // parsed string starts with local email info + @ with a potential domain name (C)
var S_EMAIL_DOMAIN_DOT = makeState(); // (C) domain followed by DOT
var S_EMAIL = makeState(_multi.EMAIL); // (C) Possible email address (could have more tlds)
var S_EMAIL_COLON = makeState(); // (C) URL followed by colon (potential port number here)
var S_EMAIL_PORT = makeState(_multi.EMAIL); // (C) Email address with a port
var S_MAILTO_EMAIL = makeState(_multi.MAILTOEMAIL); // Email that begins with the mailto prefix (D)
var S_MAILTO_EMAIL_NON_ACCEPTING = makeState(); // (D) Followed by some non-query string chars
var S_LOCALPART = makeState(); // Local part of the email address
var S_LOCALPART_AT = makeState(); // Local part of the email address plus @
var S_LOCALPART_DOT = makeState(); // Local part of the email address plus '.' (localpart cannot end in .)
var S_NL = makeState(_multi.NL); // single new line

// Make path from start to protocol (with '//')
S_START.on(_text.NL, S_NL).on(_text.PROTOCOL, S_PROTOCOL).on(_text.MAILTO, S_MAILTO).on(_text.SLASH, S_PROTOCOL_SLASH);

S_PROTOCOL.on(_text.SLASH, S_PROTOCOL_SLASH);
S_PROTOCOL_SLASH.on(_text.SLASH, S_PROTOCOL_SLASH_SLASH);

// The very first potential domain name
S_START.on(_text.TLD, S_DOMAIN).on(_text.DOMAIN, S_DOMAIN).on(_text.LOCALHOST, S_TLD).on(_text.NUM, S_DOMAIN);

// Force URL for protocol followed by anything sane
S_PROTOCOL_SLASH_SLASH.on(_text.TLD, S_URL).on(_text.DOMAIN, S_URL).on(_text.NUM, S_URL).on(_text.LOCALHOST, S_URL);

// Account for dots and hyphens
// hyphens are usually parts of domain names
S_DOMAIN.on(_text.DOT, S_DOMAIN_DOT);
S_EMAIL_DOMAIN.on(_text.DOT, S_EMAIL_DOMAIN_DOT);

// Hyphen can jump back to a domain name

// After the first domain and a dot, we can find either a URL or another domain
S_DOMAIN_DOT.on(_text.TLD, S_TLD).on(_text.DOMAIN, S_DOMAIN).on(_text.NUM, S_DOMAIN).on(_text.LOCALHOST, S_DOMAIN);

S_EMAIL_DOMAIN_DOT.on(_text.TLD, S_EMAIL).on(_text.DOMAIN, S_EMAIL_DOMAIN).on(_text.NUM, S_EMAIL_DOMAIN).on(_text.LOCALHOST, S_EMAIL_DOMAIN);

// S_TLD accepts! But the URL could be longer, try to find a match greedily
// The `run` function should be able to "rollback" to the accepting state
S_TLD.on(_text.DOT, S_DOMAIN_DOT);
S_EMAIL.on(_text.DOT, S_EMAIL_DOMAIN_DOT);

// Become real URLs after `SLASH` or `COLON NUM SLASH`
// Here PSS and non-PSS converge
S_TLD.on(_text.COLON, S_TLD_COLON).on(_text.SLASH, S_URL);
S_TLD_COLON.on(_text.NUM, S_TLD_PORT);
S_TLD_PORT.on(_text.SLASH, S_URL);
S_EMAIL.on(_text.COLON, S_EMAIL_COLON);
S_EMAIL_COLON.on(_text.NUM, S_EMAIL_PORT);

// Types of characters the URL can definitely end in
var qsAccepting = [_text.DOMAIN, _text.AT, _text.LOCALHOST, _text.NUM, _text.PLUS, _text.POUND, _text.PROTOCOL, _text.SLASH, _text.TLD, _text.UNDERSCORE, _text.SYM, _text.AMPERSAND];

// Types of tokens that can follow a URL and be part of the query string
// but cannot be the very last characters
// Characters that cannot appear in the URL at all should be excluded
var qsNonAccepting = [_text.COLON, _text.DOT, _text.QUERY, _text.PUNCTUATION, _text.CLOSEBRACE, _text.CLOSEBRACKET, _text.CLOSEANGLEBRACKET, _text.CLOSEPAREN, _text.OPENBRACE, _text.OPENBRACKET, _text.OPENANGLEBRACKET, _text.OPENPAREN];

// These states are responsible primarily for determining whether or not to
// include the final round bracket.

// URL, followed by an opening bracket
S_URL.on(_text.OPENBRACE, S_URL_OPENBRACE).on(_text.OPENBRACKET, S_URL_OPENBRACKET).on(_text.OPENANGLEBRACKET, S_URL_OPENANGLEBRACKET).on(_text.OPENPAREN, S_URL_OPENPAREN);

// URL with extra symbols at the end, followed by an opening bracket
S_URL_NON_ACCEPTING.on(_text.OPENBRACE, S_URL_OPENBRACE).on(_text.OPENBRACKET, S_URL_OPENBRACKET).on(_text.OPENANGLEBRACKET, S_URL_OPENANGLEBRACKET).on(_text.OPENPAREN, S_URL_OPENPAREN);

// Closing bracket component. This character WILL be included in the URL
S_URL_OPENBRACE.on(_text.CLOSEBRACE, S_URL);
S_URL_OPENBRACKET.on(_text.CLOSEBRACKET, S_URL);
S_URL_OPENANGLEBRACKET.on(_text.CLOSEANGLEBRACKET, S_URL);
S_URL_OPENPAREN.on(_text.CLOSEPAREN, S_URL);
S_URL_OPENBRACE_Q.on(_text.CLOSEBRACE, S_URL);
S_URL_OPENBRACKET_Q.on(_text.CLOSEBRACKET, S_URL);
S_URL_OPENANGLEBRACKET_Q.on(_text.CLOSEANGLEBRACKET, S_URL);
S_URL_OPENPAREN_Q.on(_text.CLOSEPAREN, S_URL);
S_URL_OPENBRACE_SYMS.on(_text.CLOSEBRACE, S_URL);
S_URL_OPENBRACKET_SYMS.on(_text.CLOSEBRACKET, S_URL);
S_URL_OPENANGLEBRACKET_SYMS.on(_text.CLOSEANGLEBRACKET, S_URL);
S_URL_OPENPAREN_SYMS.on(_text.CLOSEPAREN, S_URL);

// URL that beings with an opening bracket, followed by a symbols.
// Note that the final state can still be `S_URL_OPENBRACE_Q` (if the URL only
// has a single opening bracket for some reason).
S_URL_OPENBRACE.on(qsAccepting, S_URL_OPENBRACE_Q);
S_URL_OPENBRACKET.on(qsAccepting, S_URL_OPENBRACKET_Q);
S_URL_OPENANGLEBRACKET.on(qsAccepting, S_URL_OPENANGLEBRACKET_Q);
S_URL_OPENPAREN.on(qsAccepting, S_URL_OPENPAREN_Q);
S_URL_OPENBRACE.on(qsNonAccepting, S_URL_OPENBRACE_SYMS);
S_URL_OPENBRACKET.on(qsNonAccepting, S_URL_OPENBRACKET_SYMS);
S_URL_OPENANGLEBRACKET.on(qsNonAccepting, S_URL_OPENANGLEBRACKET_SYMS);
S_URL_OPENPAREN.on(qsNonAccepting, S_URL_OPENPAREN_SYMS);

// URL that begins with an opening bracket, followed by some symbols
S_URL_OPENBRACE_Q.on(qsAccepting, S_URL_OPENBRACE_Q);
S_URL_OPENBRACKET_Q.on(qsAccepting, S_URL_OPENBRACKET_Q);
S_URL_OPENANGLEBRACKET_Q.on(qsAccepting, S_URL_OPENANGLEBRACKET_Q);
S_URL_OPENPAREN_Q.on(qsAccepting, S_URL_OPENPAREN_Q);
S_URL_OPENBRACE_Q.on(qsNonAccepting, S_URL_OPENBRACE_Q);
S_URL_OPENBRACKET_Q.on(qsNonAccepting, S_URL_OPENBRACKET_Q);
S_URL_OPENANGLEBRACKET_Q.on(qsNonAccepting, S_URL_OPENANGLEBRACKET_Q);
S_URL_OPENPAREN_Q.on(qsNonAccepting, S_URL_OPENPAREN_Q);

S_URL_OPENBRACE_SYMS.on(qsAccepting, S_URL_OPENBRACE_Q);
S_URL_OPENBRACKET_SYMS.on(qsAccepting, S_URL_OPENBRACKET_Q);
S_URL_OPENANGLEBRACKET_SYMS.on(qsAccepting, S_URL_OPENANGLEBRACKET_Q);
S_URL_OPENPAREN_SYMS.on(qsAccepting, S_URL_OPENPAREN_Q);
S_URL_OPENBRACE_SYMS.on(qsNonAccepting, S_URL_OPENBRACE_SYMS);
S_URL_OPENBRACKET_SYMS.on(qsNonAccepting, S_URL_OPENBRACKET_SYMS);
S_URL_OPENANGLEBRACKET_SYMS.on(qsNonAccepting, S_URL_OPENANGLEBRACKET_SYMS);
S_URL_OPENPAREN_SYMS.on(qsNonAccepting, S_URL_OPENPAREN_SYMS);

// Account for the query string
S_URL.on(qsAccepting, S_URL);
S_URL_NON_ACCEPTING.on(qsAccepting, S_URL);

S_URL.on(qsNonAccepting, S_URL_NON_ACCEPTING);
S_URL_NON_ACCEPTING.on(qsNonAccepting, S_URL_NON_ACCEPTING);

// Email address-specific state definitions
// Note: We are not allowing '/' in email addresses since this would interfere
// with real URLs

// For addresses with the mailto prefix
// 'mailto:' followed by anything sane is a valid email
S_MAILTO.on(_text.TLD, S_MAILTO_EMAIL).on(_text.DOMAIN, S_MAILTO_EMAIL).on(_text.NUM, S_MAILTO_EMAIL).on(_text.LOCALHOST, S_MAILTO_EMAIL);

// Greedily get more potential valid email values
S_MAILTO_EMAIL.on(qsAccepting, S_MAILTO_EMAIL).on(qsNonAccepting, S_MAILTO_EMAIL_NON_ACCEPTING);
S_MAILTO_EMAIL_NON_ACCEPTING.on(qsAccepting, S_MAILTO_EMAIL).on(qsNonAccepting, S_MAILTO_EMAIL_NON_ACCEPTING);

// For addresses without the mailto prefix
// Tokens allowed in the localpart of the email
var localpartAccepting = [_text.DOMAIN, _text.NUM, _text.PLUS, _text.POUND, _text.QUERY, _text.UNDERSCORE, _text.SYM, _text.AMPERSAND, _text.TLD];

// Some of the tokens in `localpartAccepting` are already accounted for here and
// will not be overwritten (don't worry)
S_DOMAIN.on(localpartAccepting, S_LOCALPART).on(_text.AT, S_LOCALPART_AT);
S_TLD.on(localpartAccepting, S_LOCALPART).on(_text.AT, S_LOCALPART_AT);
S_DOMAIN_DOT.on(localpartAccepting, S_LOCALPART);

// Okay we're on a localpart. Now what?
// TODO: IP addresses and what if the email starts with numbers?
S_LOCALPART.on(localpartAccepting, S_LOCALPART).on(_text.AT, S_LOCALPART_AT) // close to an email address now
.on(_text.DOT, S_LOCALPART_DOT);
S_LOCALPART_DOT.on(localpartAccepting, S_LOCALPART);
S_LOCALPART_AT.on(_text.TLD, S_EMAIL_DOMAIN).on(_text.DOMAIN, S_EMAIL_DOMAIN).on(_text.LOCALHOST, S_EMAIL);
// States following `@` defined above

var run = function run(tokens) {
	var len = tokens.length;
	var cursor = 0;
	var multis = [];
	var textTokens = [];

	while (cursor < len) {
		var state = S_START;
		var secondState = null;
		var nextState = null;
		var multiLength = 0;
		var latestAccepting = null;
		var sinceAccepts = -1;

		while (cursor < len && !(secondState = state.next(tokens[cursor]))) {
			// Starting tokens with nowhere to jump to.
			// Consider these to be just plain text
			textTokens.push(tokens[cursor++]);
		}

		while (cursor < len && (nextState = secondState || state.next(tokens[cursor]))) {

			// Get the next state
			secondState = null;
			state = nextState;

			// Keep track of the latest accepting state
			if (state.accepts()) {
				sinceAccepts = 0;
				latestAccepting = state;
			} else if (sinceAccepts >= 0) {
				sinceAccepts++;
			}

			cursor++;
			multiLength++;
		}

		if (sinceAccepts < 0) {

			// No accepting state was found, part of a regular text token
			// Add all the tokens we looked at to the text tokens array
			for (var i = cursor - multiLength; i < cursor; i++) {
				textTokens.push(tokens[i]);
			}
		} else {

			// Accepting state!

			// First close off the textTokens (if available)
			if (textTokens.length > 0) {
				multis.push(new _multi.TEXT(textTokens));
				textTokens = [];
			}

			// Roll back to the latest accepting state
			cursor -= sinceAccepts;
			multiLength -= sinceAccepts;

			// Create a new multitoken
			var MULTI = latestAccepting.emit();
			multis.push(new MULTI(tokens.slice(cursor - multiLength, cursor)));
		}
	}

	// Finally close off the textTokens (if available)
	if (textTokens.length > 0) {
		multis.push(new _multi.TEXT(textTokens));
	}

	return multis;
};

exports.State = _state.TokenState;
exports.TOKENS = MULTI_TOKENS;
exports.run = run;
exports.start = S_START;

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.URL = exports.TEXT = exports.NL = exports.EMAIL = exports.MAILTOEMAIL = exports.Base = undefined;

var _createTokenClass = __webpack_require__(779);

var _class = __webpack_require__(214);

var _text = __webpack_require__(327);

/******************************************************************************
	Multi-Tokens
	Tokens composed of arrays of TextTokens
******************************************************************************/

// Is the given token a valid domain token?
// Should nums be included here?
function isDomainToken(token) {
	return token instanceof _text.DOMAIN || token instanceof _text.TLD;
}

/**
	Abstract class used for manufacturing tokens of text tokens. That is rather
	than the value for a token being a small string of text, it's value an array
	of text tokens.

	Used for grouping together URLs, emails, hashtags, and other potential
	creations.

	@class MultiToken
	@abstract
*/
var MultiToken = (0, _createTokenClass.createTokenClass)();

MultiToken.prototype = {
	/**
 	String representing the type for this token
 	@property type
 	@default 'TOKEN'
 */
	type: 'token',

	/**
 	Is this multitoken a link?
 	@property isLink
 	@default false
 */
	isLink: false,

	/**
 	Return the string this token represents.
 	@method toString
 	@return {String}
 */
	toString: function toString() {
		var result = [];
		for (var i = 0; i < this.v.length; i++) {
			result.push(this.v[i].toString());
		}
		return result.join('');
	},


	/**
 	What should the value for this token be in the `href` HTML attribute?
 	Returns the `.toString` value by default.
 		@method toHref
 	@return {String}
 */
	toHref: function toHref() {
		return this.toString();
	},


	/**
 	Returns a hash of relevant values for this token, which includes keys
 	* type - Kind of token ('url', 'email', etc.)
 	* value - Original text
 	* href - The value that should be added to the anchor tag's href
 		attribute
 		@method toObject
 	@param {String} [protocol] `'http'` by default
 	@return {Object}
 */
	toObject: function toObject() {
		var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'http';

		return {
			type: this.type,
			value: this.toString(),
			href: this.toHref(protocol)
		};
	}
};

/**
	Represents an arbitrarily mailto email address with the prefix included
	@class MAILTO
	@extends MultiToken
*/
var MAILTOEMAIL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), {
	type: 'email',
	isLink: true
});

/**
	Represents a list of tokens making up a valid email address
	@class EMAIL
	@extends MultiToken
*/
var EMAIL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), {
	type: 'email',
	isLink: true,
	toHref: function toHref() {
		var tokens = this.v;
		return 'mailto:' + this.toString();
	}
});

/**
	Represents some plain text
	@class TEXT
	@extends MultiToken
*/
var TEXT = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), { type: 'text' });

/**
	Multi-linebreak token - represents a line break
	@class NL
	@extends MultiToken
*/
var NL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), { type: 'nl' });

/**
	Represents a list of tokens making up a valid URL
	@class URL
	@extends MultiToken
*/
var URL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), {
	type: 'url',
	isLink: true,

	/**
 	Lowercases relevant parts of the domain and adds the protocol if
 	required. Note that this will not escape unsafe HTML characters in the
 	URL.
 		@method href
 	@param {String} protocol
 	@return {String}
 */
	toHref: function toHref() {
		var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'http';

		var hasProtocol = false;
		var hasSlashSlash = false;
		var tokens = this.v;
		var result = [];
		var i = 0;

		// Make the first part of the domain lowercase
		// Lowercase protocol
		while (tokens[i] instanceof _text.PROTOCOL) {
			hasProtocol = true;
			result.push(tokens[i].toString().toLowerCase());
			i++;
		}

		// Skip slash-slash
		while (tokens[i] instanceof _text.SLASH) {
			hasSlashSlash = true;
			result.push(tokens[i].toString());
			i++;
		}

		// Lowercase all other characters in the domain
		while (isDomainToken(tokens[i])) {
			result.push(tokens[i].toString().toLowerCase());
			i++;
		}

		// Leave all other characters as they were written
		for (; i < tokens.length; i++) {
			result.push(tokens[i].toString());
		}

		result = result.join('');

		if (!(hasProtocol || hasSlashSlash)) {
			result = protocol + '://' + result;
		}

		return result;
	},
	hasProtocol: function hasProtocol() {
		return this.v[0] instanceof _text.PROTOCOL;
	}
});

exports.Base = MultiToken;
exports.MAILTOEMAIL = MAILTOEMAIL;
exports.EMAIL = EMAIL;
exports.NL = NL;
exports.TEXT = TEXT;
exports.URL = URL;

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1792);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _react3 = __webpack_require__(213);

var _react4 = _interopRequireDefault(_react3);

var _omniCommonUi = __webpack_require__(0);

var _Checkbox = __webpack_require__(780);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SkillRecommendationExpandPanel = function (_PureComponent) {
  _inherits(SkillRecommendationExpandPanel, _PureComponent);

  function SkillRecommendationExpandPanel(props) {
    _classCallCheck(this, SkillRecommendationExpandPanel);

    var _this = _possibleConstructorReturn(this, (SkillRecommendationExpandPanel.__proto__ || Object.getPrototypeOf(SkillRecommendationExpandPanel)).call(this, props));

    _this.state = { isExpand: false };
    _this._changeExpandState = _this._changeExpandState.bind(_this);
    return _this;
  }

  _createClass(SkillRecommendationExpandPanel, [{
    key: '_changeExpandState',
    value: function _changeExpandState() {
      this.setState({ isExpand: !this.state.isExpand });
    }
  }, {
    key: '_isChecked',
    value: function _isChecked(recommendationItemId) {
      var selectedRecommendationItemIds = this.props.selectedRecommendationItemIds;

      return selectedRecommendationItemIds.includes(recommendationItemId);
    }
  }, {
    key: '_isDisabled',
    value: function _isDisabled(recommendationItemId) {
      var _props = this.props,
          isSSV3Group = _props.isSSV3Group,
          selectedRecommendationItemIds = _props.selectedRecommendationItemIds;

      return isSSV3Group && selectedRecommendationItemIds.length >= 3 && !selectedRecommendationItemIds.includes(recommendationItemId);
    }
  }, {
    key: '_checkRecommendationItem',
    value: function _checkRecommendationItem(id) {
      this.props.checkRecommendationItem(id);
    }
  }, {
    key: '_renderRecommendationItem',
    value: function _renderRecommendationItem(recommendationItem) {
      var isDisabled = this._isDisabled(recommendationItem.id);
      var checkRecommendationItem = this._checkRecommendationItem.bind(this, recommendationItem.id);
      return _react2.default.createElement(
        'label',
        { htmlFor: recommendationItem.id,
          className: _style2.default.SkillRecommendationExpandPanel_item,
          key: recommendationItem.id },
        _react2.default.createElement(_Checkbox2.default, { id: recommendationItem.id,
          checked: this._isChecked(recommendationItem.id),
          onChange: checkRecommendationItem,
          disabled: isDisabled }),
        _react2.default.createElement(
          _react4.default,
          { disabled: isDisabled },
          recommendationItem.itemName
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          categoryName = _props2.categoryName,
          recommendationItems = _props2.recommendationItems;
      var isExpand = this.state.isExpand;

      var iconClassName = (0, _classnames3.default)(_style2.default.SkillRecommendationExpandPanel_header_arrow, _defineProperty({}, _style2.default.__expanded, isExpand));
      return _react2.default.createElement(
        'div',
        { className: _style2.default.SkillRecommendationExpandPanel_wrapper },
        _react2.default.createElement(
          'div',
          { className: _style2.default.SkillRecommendationExpandPanel_header // eslint-disable-line
            , onClick: this._changeExpandState },
          _react2.default.createElement(
            'label',
            { className: _style2.default.SkillRecommendationExpandPanel_category },
            categoryName
          ),
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'chevron-small-down', className: iconClassName })
        ),
        isExpand && recommendationItems.map(function (recommendationItem) {
          return _this2._renderRecommendationItem(recommendationItem);
        })
      );
    }
  }]);

  return SkillRecommendationExpandPanel;
}(_react.PureComponent);

exports.default = SkillRecommendationExpandPanel;

SkillRecommendationExpandPanel.propTypes = {
  isSSV3Group: _propTypes2.default.bool,
  categoryName: _propTypes2.default.string,
  recommendationItems: _propTypes2.default.shape(),
  checkRecommendationItem: _propTypes2.default.func,
  selectedRecommendationItemIds: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape()])
};

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1793);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".HpiUKcNIAXPIAh3YsB_Ve{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f3f5f7;border-bottom:.07143rem solid #ccc;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:2.85714rem;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding-left:1.42857rem;padding-right:1.42857rem}._17nyjC-YVZdsZS4gZyJLtT{-webkit-transform:rotate(-90deg);-moz-transform:rotate(-90deg);-ms-transform:rotate(-90deg);-o-transform:rotate(-90deg);transform:rotate(-90deg)}._17nyjC-YVZdsZS4gZyJLtT,._17nyjC-YVZdsZS4gZyJLtT._1UqwCx4lK_caacgRMp10yH{-webkit-transition-duration:.5s;-moz-transition-duration:.5s;-o-transition-duration:.5s;transition-duration:.5s}._17nyjC-YVZdsZS4gZyJLtT._1UqwCx4lK_caacgRMp10yH{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}._2pMZiyjlST-ep4I_1-nkmR{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:600;letter-spacing:.03571rem;line-height:1.28571}.T76m2PpVIX1CUcbWdHpdz{border-bottom:.07143rem solid #ccc;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:.71429rem 1.07143rem}.T76m2PpVIX1CUcbWdHpdz span[disabled]{opacity:.4}._1JKCOkJnRV0wc1L4NjS89Z:last-of-type .T76m2PpVIX1CUcbWdHpdz:last-of-type{border-bottom:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SkillRecommendationExpandPanel_header": "HpiUKcNIAXPIAh3YsB_Ve",
	"SkillRecommendationExpandPanel_header_arrow": "_17nyjC-YVZdsZS4gZyJLtT",
	"__expanded": "_1UqwCx4lK_caacgRMp10yH",
	"SkillRecommendationExpandPanel_category": "_2pMZiyjlST-ep4I_1-nkmR",
	"SkillRecommendationExpandPanel_item": "T76m2PpVIX1CUcbWdHpdz",
	"SkillRecommendationExpandPanel_wrapper": "_1JKCOkJnRV0wc1L4NjS89Z"
};

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1795);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".xKcipIoBes2C4Cv7tujrc{display:inline-block;margin-right:.71429rem}._1GCVQsroNf0Y6rAcU-Indb{-webkit-box-align:stretch;-webkit-align-items:stretch;-moz-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;border:.07143rem solid #4a4a4a;-webkit-border-radius:.14286rem;-moz-border-radius:.14286rem;border-radius:.14286rem;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:1.14286rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;width:1.14286rem}._1GCVQsroNf0Y6rAcU-Indb:after{background-color:#0087e6;border:.14286rem solid #fff;-webkit-border-radius:.21429rem;-moz-border-radius:.21429rem;border-radius:.21429rem;content:\"\";display:block;filter:alpha(opacity=0);-webkit-box-flex:1;-webkit-flex:1 0 0;-moz-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0;opacity:0;-webkit-transition:opacity .3s ease-in-out,background-color .3s ease-in-out;-o-transition:opacity .3s ease-in-out,background-color .3s ease-in-out;-moz-transition:opacity .3s ease-in-out,background-color .3s ease-in-out;transition:opacity .3s ease-in-out,background-color .3s ease-in-out}._1GCVQsroNf0Y6rAcU-Indb:hover:after{background-color:#026cb6}._1RN61oLJIvsCXfU9_ty4S_{float:left;margin-left:-714.21429rem;visibility:hidden}._1RN61oLJIvsCXfU9_ty4S_:checked+._1GCVQsroNf0Y6rAcU-Indb:after{filter:alpha(opacity=100);opacity:1}._1RN61oLJIvsCXfU9_ty4S_:disabled+._1GCVQsroNf0Y6rAcU-Indb{opacity:.4}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Checkbox": "xKcipIoBes2C4Cv7tujrc",
	"Checkbox_label": "_1GCVQsroNf0Y6rAcU-Indb",
	"Checkbox_input": "_1RN61oLJIvsCXfU9_ty4S_"
};

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1797);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2QM7Fx6GDcSk9mkS5K0lpe{padding:2.14286rem 2.14286rem 1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"BottomButtons": "_2QM7Fx6GDcSk9mkS5K0lpe"
};

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1799);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _GroupMembers = __webpack_require__(14);

var _immutable = __webpack_require__(3);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _UiState = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentSelect = function (_PureComponent) {
  _inherits(StudentSelect, _PureComponent);

  function StudentSelect() {
    _classCallCheck(this, StudentSelect);

    var _this = _possibleConstructorReturn(this, (StudentSelect.__proto__ || Object.getPrototypeOf(StudentSelect)).call(this));

    _this._getLinkHrefForValue = function (studentId) {
      return _this.props.buildRoute({ studentId: studentId, mode: '' });
    };
    return _this;
  }

  _createClass(StudentSelect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._buildStudentSelectOptions(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.membersInCurrentIdp !== nextProps.membersInCurrentIdp) {
        this._buildStudentSelectOptions(nextProps);
      }
    }
  }, {
    key: '_buildStudentSelectOptions',
    value: function _buildStudentSelectOptions(props) {
      // set and cache horizontalselect options (it's pure!)
      var membersInCurrentIdp = props.membersInCurrentIdp;

      if (membersInCurrentIdp.size > 0) {
        // cache this - do not recreate each time
        this._studentSelectOptions = membersInCurrentIdp.map(function (option) {
          var studentGeneralInfo = option.studentGeneralInfo;

          var optionHtml = _react2.default.createElement(
            _omniCommonUi.StudentCard,
            { className: (0, _omniCommonUi.testClass)('student-card'), vertical: true, borderless: true, backgroundless: true },
            _react2.default.createElement(_omniCommonUi.StudentCard.Profile, { name: studentGeneralInfo.firstName,
              surname: studentGeneralInfo.lastName,
              localName: studentGeneralInfo.localName,
              avatarUrl: studentGeneralInfo.avatarUrl,
              gender: studentGeneralInfo.gender })
          );
          return {
            html: optionHtml,
            value: studentGeneralInfo.id
          };
        }).toArray();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          membersInCurrentIdp = _props.membersInCurrentIdp,
          currentMember = _props.currentMember,
          shouldHide = _props.shouldHide;

      if (currentMember && membersInCurrentIdp.size && membersInCurrentIdp.size > 0) {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.IndividualDevelopmentPlan_studentHorizontalSelect },
          _react2.default.createElement(_omniCommonUi.HorizontalSelect, { options: this._studentSelectOptions,
            value: currentMember && currentMember.studentGeneralInfo.id,
            isHide: shouldHide,
            getLinkHrefForValue: this._getLinkHrefForValue })
        );
      }
      return null;
    }
  }]);

  return StudentSelect;
}(_react.PureComponent);

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      groupIdpId = _ownProps$params.groupIdpId,
      studentId = _ownProps$params.studentId;

  var groupIdpList = _IndividualDevelopmentPlans.accessors.getGroupIdpList(state, groupId);
  var idpList = _IndividualDevelopmentPlans.accessors.getIdpList(groupIdpList, groupIdpId);

  var idpStudentIds = new _immutable.List();
  if (idpList && idpList.size > 0) {
    idpStudentIds = idpList.map(function (idp) {
      return idp.studentId;
    });
  }
  var membersInCurrentIdp = _GroupMembers.actions.getMembersByGroup(state, groupId).filter(function (_ref) {
    var id = _ref.studentGeneralInfo.id;
    return idpStudentIds.indexOf('' + id) !== -1;
  });
  var currentMember = _GroupMembers.actions.getMemberById(state, studentId);
  return {
    membersInCurrentIdp: membersInCurrentIdp,
    currentMember: currentMember,
    shouldHide: !_UiState.actions.getShowNavigationBar(state)
  };
}

StudentSelect.propTypes = {
  currentMember: _propTypes2.default.object,
  membersInCurrentIdp: _propTypes2.default.object.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  shouldHide: _propTypes2.default.bool.isRequired
};

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null)(StudentSelect);

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1800);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1NO6M3Xg7TRZ8_B24t-VYA{background:#f3f5f7;border-bottom:.07143rem solid #ccc;padding:0}._2Eqvr1m0f1ymjnY3Z2f_IX{height:100%;width:9.28571rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"IndividualDevelopmentPlan_studentHorizontalSelect": "_1NO6M3Xg7TRZ8_B24t-VYA",
	"IndividualDevelopmentPlan_studentHorizontalSelect_option": "_2Eqvr1m0f1ymjnY3Z2f_IX"
};

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1802);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _ReadOnlyField = __webpack_require__(777);

var _ReadOnlyField2 = _interopRequireDefault(_ReadOnlyField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BOOKWORK = 'Bookwork';
var ONLINE = 'Online';
var ATTENDANCE = 'Attendance';

var ReportCard = function (_Component) {
  _inherits(ReportCard, _Component);

  function ReportCard() {
    _classCallCheck(this, ReportCard);

    return _possibleConstructorReturn(this, (ReportCard.__proto__ || Object.getPrototypeOf(ReportCard)).apply(this, arguments));
  }

  _createClass(ReportCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isExpanded = _props.isExpanded,
          reportCardInfo = _props.reportCardInfo,
          onExpandButtonClick = _props.onExpandButtonClick;

      var reportCardInfoDisplayItems = [];
      prepareReportCardInfoDisplayItems.call(this);

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _classnames2.default)(_style2.default.ReportCard_container, (0, _omniCommonUi.testClass)('report-card')) },
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          { className: _style2.default.ReportCard_heading },
          _react2.default.createElement(
            'span',
            null,
            'Report card'
          ),
          reportCardInfo.lastUpdatedTimeUtc && _react2.default.createElement(
            'span',
            null,
            'Last updated ',
            '' + reportCardInfo.lastUpdatedTimeUtc
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.ReportCard_content },
          _react2.default.createElement(
            _omniCommonUi.Grid,
            { className: _style2.default.ReportCard_grid },
            _react2.default.createElement(
              _omniCommonUi.Grid.Group,
              null,
              renderGridItems()
            )
          )
        ),
        renderExpansionButton()
      );

      function renderGridItems() {
        return reportCardInfoDisplayItems.map(function (source) {
          var size = { xs: 12, sm: 6, md: 6 };
          return _react2.default.createElement(
            _omniCommonUi.Grid.Item,
            { key: source.title,
              xs: size.xs,
              sm: size.sm,
              md: size.md,
              className: _style2.default.ReportCard_item },
            _react2.default.createElement(_ReadOnlyField2.default, { boardTitle: source.title,
              boardValue: source.value,
              className: source.className })
          );
        });
      }

      function prepareReportCardInfoDisplayItems() {
        reportCardInfo.skillResults.forEach(function (_ref) {
          var name = _ref.name,
              score = _ref.score;

          reportCardInfoDisplayItems.push({
            title: name,
            value: score
          });
        });

        if (reportCardInfo.homeworkCompletion) {
          reportCardInfoDisplayItems.push({
            title: BOOKWORK,
            value: reportCardInfo.homeworkCompletion
          });
        }
        reportCardInfoDisplayItems.push({
          title: ONLINE,
          value: reportCardInfo.online
        });
        this.props.shouldShowAttendance && reportCardInfoDisplayItems.push({
          title: ATTENDANCE,
          value: reportCardInfo.attendance
        });

        reportCardInfoDisplayItems = resortByDisplayingOrder(reportCardInfoDisplayItems);
        reportCardInfoDisplayItems = hideReportCardItemsIfNeeded(reportCardInfoDisplayItems);
      }

      function resortByDisplayingOrder(items) {
        if (!items || !items.length > 0) return;

        var numberOfRows = Math.ceil(items.length / 2);
        var sortedItems = items.map(function (_item, index) {
          var item = _item;
          if (index < numberOfRows) {
            item.displayOrder = 1 + 2 * index;
            return item;
          }
          item.displayOrder = 2 + 2 * (index - numberOfRows);
          return item;
        });
        return sortedItems.sort(function (a, b) {
          return a.displayOrder - b.displayOrder;
        });
      }

      function hideReportCardItemsIfNeeded(items) {
        if (isExpanded || !items || !items.length > 0) return items;
        return items.slice(0, 2);
      }

      function renderExpansionButton() {
        return _react2.default.createElement(_ExpansionButton2.default, { isExpand: isExpanded,
          onExpansionButtonClick: function onExpansionButtonClick() {
            return onExpandButtonClick();
          } });
      }
    }
  }]);

  return ReportCard;
}(_react.Component);

ReportCard.propTypes = {
  reportCardInfo: _propTypes2.default.object.isRequired,
  isExpanded: _propTypes2.default.bool.isRequired,
  onExpandButtonClick: _propTypes2.default.func.isRequired,
  shouldShowAttendance: _propTypes2.default.bool.isRequired
};

exports.default = ReportCard;

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1803);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2-HJOOdeb1cWn7gK9MDJUv{margin:0}._29buBOZove1jP4MRwLe1r9{margin:0;padding-top:.5em}.GFKOkxCnJ2XkPyv5bHBCJ{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._2opEQdvvyd9vnoPnZFApfK{padding-bottom:0;padding-top:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ReportCard_container": "o9eDZJ9Qqs9YSwxOh1RnY",
	"ReportCard_grid": "_2-HJOOdeb1cWn7gK9MDJUv",
	"ReportCard_item": "_29buBOZove1jP4MRwLe1r9",
	"ReportCard_heading": "GFKOkxCnJ2XkPyv5bHBCJ",
	"ReportCard_content": "_2opEQdvvyd9vnoPnZFApfK"
};

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1805);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(10);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _CardActionIcons = __webpack_require__(85);

var _CardActionIcons2 = _interopRequireDefault(_CardActionIcons);

var _CardActionButtons = __webpack_require__(215);

var _CardActionButtons2 = _interopRequireDefault(_CardActionButtons);

var _TextInput = __webpack_require__(782);

var _TextInput2 = _interopRequireDefault(_TextInput);

var _StudyPlan = __webpack_require__(328);

var _routes = __webpack_require__(169);

var _Month = __webpack_require__(211);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudyPlan = function (_PureComponent) {
  _inherits(StudyPlan, _PureComponent);

  function StudyPlan(props) {
    _classCallCheck(this, StudyPlan);

    var _this = _possibleConstructorReturn(this, (StudyPlan.__proto__ || Object.getPrototypeOf(StudyPlan)).call(this, props));

    _this._onEditClick = _this._onEditClick.bind(_this);
    _this.onSaveClick = _this.onSaveClick.bind(_this);
    _this._onDiscardClick = _this._onDiscardClick.bind(_this);
    _this._onRadioClick = _this._onRadioClick.bind(_this);
    _this.shouldDisableSaveButton = _this.shouldDisableSaveButton.bind(_this);
    _this.setWasEditMade = _this.setWasEditMade.bind(_this);
    _this.wasEditMade = _this.wasEditMade.bind(_this);
    _this.state = { wasEditMade: false };
    return _this;
  }

  _createClass(StudyPlan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          fetchStudyPlanCourseIfNeeded = _props.fetchStudyPlanCourseIfNeeded,
          fetchStudyPlanIfNeeded = _props.fetchStudyPlanIfNeeded,
          idpId = _props.idpId;

      fetchStudyPlanCourseIfNeeded(idpId);
      fetchStudyPlanIfNeeded(idpId);
      this.props.onComponentMounted(this);
      this._onStudyPlanResultUpdate(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._onStudyPlanResultUpdate(nextProps);
    }
  }, {
    key: '_getMonth',
    value: function _getMonth(end) {
      return end.date() <= 15 ? end.month() : end.month() + 1;
    }
  }, {
    key: '_getStudyPlanItem',
    value: function _getStudyPlanItem(studyPlan, index, itemName) {
      if (_immutable.List.isList(studyPlan) && _is_js2.default.existy(studyPlan.get(index))) {
        return studyPlan.get(index)[itemName];
      }
    }
  }, {
    key: '_getStudyPlan',
    value: function _getStudyPlan(studyPlan, period, month) {
      var _this2 = this;

      return new _immutable.List([].concat(_toConsumableArray(Array(period).keys())).map(function (index) {
        return {
          sequence: index,
          coreCourseId: _this2._getStudyPlanItem(studyPlan, index, 'coreCourseId'),
          nonCoreCourseId: _this2._getStudyPlanItem(studyPlan, index, 'nonCoreCourseId'),
          otherOptions: _this2._getStudyPlanItem(studyPlan, index, 'otherOptions'),
          month: _this2._getMonth(month) + index
        };
      }));
    }
  }, {
    key: '_onStudyPlanResultUpdate',
    value: function _onStudyPlanResultUpdate(props) {
      if (this.wasEditMade()) return;
      var studyPlan = props.studyPlan && props.studyPlan.get('result');
      var period = _immutable.List.isList(studyPlan) && studyPlan.size > 0 ? studyPlan.size : 6;
      var end = props.studentInfo.period.end;
      this.setState({
        period: period,
        isStudyPlanInited: false,
        studyPlan: this._getStudyPlan(studyPlan, period, end)
      });
    }
  }, {
    key: '_onEditClick',
    value: function _onEditClick() {
      this.props.changeMode(_routes.Modes.EDIT_STUDY_PLAN);
    }
  }, {
    key: 'onSaveClick',
    value: function onSaveClick() {
      var _this3 = this;

      var _props2 = this.props,
          idpId = _props2.idpId,
          groupIdpId = _props2.groupIdpId,
          publishStudyPlan = _props2.publishStudyPlan;

      var studyPlan = this.state.studyPlan.toArray().map(function (plan) {
        return {
          coreCourseId: plan.coreCourseId,
          nonCoreCourseId: plan.nonCoreCourseId,
          otherOptions: _is_js2.default.undefined(plan.otherOptions) ? undefined : plan.otherOptions.trim() || undefined,
          sequence: plan.sequence
        };
      });
      publishStudyPlan(idpId, studyPlan, groupIdpId).then(function () {
        return _this3._onDiscardClick();
      });
    }
  }, {
    key: '_onDiscardClick',
    value: function _onDiscardClick() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.setWasEditMade(false);
      props.changeMode('');
      this._onStudyPlanResultUpdate(props);
    }
  }, {
    key: '_onRadioClick',
    value: function _onRadioClick() {
      var period = this.state.period === 6 ? 12 : 6;
      var end = this.props.studentInfo.period.end;
      this.setState({
        period: period,
        isStudyPlanInited: false,
        studyPlan: this._getStudyPlan(this.state.studyPlan, period, end)
      });
    }
  }, {
    key: '_onContentChange',
    value: function _onContentChange(sequence, val, itemName) {
      var studyPlan = this.state.studyPlan;

      var index = studyPlan.findIndex(function (plan) {
        return plan.sequence === sequence;
      });
      var result = studyPlan.update(index, function (plan) {
        return Object.assign({}, plan, _defineProperty({}, itemName, val || undefined));
      });
      this.setState({
        studyPlan: result
      });
      this.setWasEditMade(true);
    }
  }, {
    key: '_isEditing',
    value: function _isEditing() {
      return this.props.isInEditMode;
    }
  }, {
    key: '_renderButtons',
    value: function _renderButtons() {
      if (!this._isEditing()) {
        return null;
      }
      return _react2.default.createElement(_CardActionButtons2.default, { className: _style2.default.StudyPlan_buttons,
        isPrimaryDisabled: this.shouldDisableSaveButton(),
        onPrimaryClick: this.onSaveClick,
        onSecondaryClick: this._onDiscardClick });
    }
  }, {
    key: 'shouldDisableSaveButton',
    value: function shouldDisableSaveButton() {
      var studyPlan = this.state.studyPlan;

      return !(_immutable.List.isList(studyPlan) && studyPlan.filter(function (plan) {
        return _is_js2.default.existy(plan.coreCourseId);
      }).size > 0);
    }
  }, {
    key: 'setWasEditMade',
    value: function setWasEditMade(wasEditMade) {
      if (_is_js2.default.not.boolean(wasEditMade)) return;
      this.setState({ wasEditMade: wasEditMade });
    }
  }, {
    key: 'wasEditMade',
    value: function wasEditMade() {
      return this.props.isInEditMode && this.state.wasEditMade;
    }
  }, {
    key: '_renderContent',
    value: function _renderContent() {
      return _react2.default.createElement(
        'div',
        null,
        this._renderTable()
      );
    }
  }, {
    key: '_renderRadio',
    value: function _renderRadio() {
      if (!this._isEditing()) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: _style2.default.StudyPlan_radio },
        _react2.default.createElement(
          'div',
          { className: _style2.default.StudyPlan_radio_item },
          _react2.default.createElement(_omniCommonUi.SolidRadio, { name: 'period',
            id: '6',
            value: '6',
            isChecked: this.state.period === 6,
            onChange: this._onRadioClick }),
          '6 months'
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.StudyPlan_radio_item },
          _react2.default.createElement(_omniCommonUi.SolidRadio, { name: 'period',
            id: '12',
            value: '12',
            isChecked: this.state.period === 12,
            onChange: this._onRadioClick }),
          '12 months'
        )
      );
    }
  }, {
    key: '_renderRow',
    value: function _renderRow(row) {
      return _react2.default.createElement(
        'li',
        { key: row.month },
        _react2.default.createElement(
          'ul',
          { className: _style2.default.StudyPlan_table_row },
          _react2.default.createElement(
            'li',
            null,
            (0, _Month.getMonthName)(row.month)
          ),
          _react2.default.createElement(
            'li',
            null,
            this._renderCourse(row, 'coreCourses')
          ),
          _react2.default.createElement(
            'li',
            null,
            this._renderCourse(row, 'nonCoreCourses')
          ),
          _react2.default.createElement(
            'li',
            null,
            this._renderOtherOptions(row)
          )
        )
      );
    }
  }, {
    key: '_renderCourse',
    value: function _renderCourse(row, itemName) {
      var _this4 = this;

      var idName = itemName === 'coreCourses' ? 'coreCourseId' : 'nonCoreCourseId';
      if (!_immutable.Map.isMap(this.props.studyPlan) || !_immutable.List.isList(this.props.studyPlan.get(itemName))) {
        return null;
      }
      var courses = this.props.studyPlan.get(itemName);
      var courseId = row[idName];
      if (!this._isEditing()) {
        if (_is_js2.default.number(courseId) && courseId > 0) {
          var currentCourse = courses.find(function (course) {
            return course.id === courseId;
          });
          var label = currentCourse && currentCourse.name;
          return _react2.default.createElement(
            'span',
            null,
            label || '-'
          );
        }
        return _react2.default.createElement(
          'span',
          null,
          '-'
        );
      }
      var options = courses.toArray().filter(function (course) {
        return !!course.isActive;
      }).sort(function (c1, c2) {
        return c1.displayOrder - c2.displayOrder;
      }).map(function (course) {
        return {
          label: course.name,
          value: course.id
        };
      });
      options.splice(0, 0, {
        label: ' ',
        value: null,
        className: _style2.default.StudyPlan_select_option
      });
      return _react2.default.createElement(_omniCommonUi.Form.Select, { options: options,
        className: _style2.default.StudyPlan_table_row_select,
        value: courseId,
        name: 'coreCourse',
        setValue: function setValue(val) {
          return _this4._onContentChange(row.sequence, val, idName);
        },
        clearable: false,
        searchable: false });
    }
  }, {
    key: '_renderOtherOptions',
    value: function _renderOtherOptions(row) {
      var _this5 = this;

      if (this._isEditing()) {
        return _react2.default.createElement(_TextInput2.default, { className: _style2.default.StudyPlan_table_row_input,
          value: row.otherOptions,
          maxLength: 100,
          onChange: function onChange(e) {
            return _this5._onContentChange(row.sequence, e.target.value, 'otherOptions');
          } });
      }

      return _react2.default.createElement(
        'span',
        null,
        row.otherOptions || '-'
      );
    }
  }, {
    key: '_renderTable',
    value: function _renderTable() {
      var _this6 = this;

      return _react2.default.createElement(
        'ul',
        { className: _style2.default.StudyPlan_table },
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'ul',
            { className: (0, _classnames2.default)(_style2.default.StudyPlan_table_header, _style2.default.StudyPlan_table_row) },
            _react2.default.createElement('li', null),
            _react2.default.createElement(
              'li',
              null,
              'Core Course'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Non-Core Course (optional)'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Other Options'
            )
          )
        ),
        this.state.studyPlan.map(function (row) {
          return _this6._renderRow(row);
        })
      );
    }
  }, {
    key: '_GenerateByDefault',
    value: function _GenerateByDefault() {
      if (this._isEditing() && !this.wasEditMade() && !this.state.isStudyPlanInited && _is_js2.default.existy(this.props.studyPlan) && _is_js2.default.existy(this.props.studyPlan.get('coreCourses')) && _is_js2.default.existy(this.props.studyPlan.get('result')) && this.props.studyPlan.get('result').size === 0 && this.state.studyPlan.size > 0) {
        var idpPeriod = this.props.studentInfo.period;
        var group = this.props.group;
        var groupPeriod = group.period;
        var courseType = group.groupSummary.courseTypeName;
        var courses = this.props.studyPlan.get('coreCourses');
        var currentCoreCourses = courses.filter(function (course) {
          return course.name.startsWith(courseType);
        }).sortBy(function (course) {
          return course.displayOrder;
        }).delete(0);
        var groupDays = groupPeriod.end.diff(groupPeriod.start, 'days');
        var remainingDays = groupPeriod.end.diff(idpPeriod.end, 'days');
        remainingDays = remainingDays < 0 ? 0 : remainingDays;
        var groupDuration = Math.ceil(groupDays / 30.0);
        var remainingDuration = Math.ceil(remainingDays / 30.0);
        var initedStudyPlan = new _immutable.List();
        this.state.studyPlan.map(function (sp) {
          var coreCourseId = sp.coreCourseId;
          if (remainingDuration > 0 && sp.sequence < remainingDuration) {
            coreCourseId = courses.first().id;
          } else {
            var index = (sp.sequence - remainingDuration) / groupDuration;
            if (index < currentCoreCourses.size) {
              coreCourseId = currentCoreCourses.get(index).id;
            }
          }
          initedStudyPlan = initedStudyPlan.push({
            sequence: sp.sequence,
            coreCourseId: coreCourseId,
            nonCoreCourseId: sp.nonCoreCourseId,
            otherOptions: sp.otherOptions,
            month: sp.month
          });
          return 0;
        });
        this.setState({
          isStudyPlanInited: true,
          studyPlan: initedStudyPlan
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state || !_is_js2.default.existy(this.state.studyPlan)) {
        return null;
      }

      this._GenerateByDefault();

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _omniCommonUi.testClass)('study-plan') },
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          { text: 'Study plan', stackMode: 'horizontal' },
          _react2.default.createElement(_CardActionIcons2.default, { hideEditIcon: !this.props.canEdit,
            onEditClick: this._onEditClick,
            hideDeleteIcon: true })
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.StudyPlan },
          _react2.default.createElement(
            _omniCommonUi.Form,
            null,
            this._renderRadio(),
            this._renderContent(),
            this._renderButtons()
          )
        )
      );
    }
  }]);

  return StudyPlan;
}(_react.PureComponent);

StudyPlan.propTypes = {
  studentInfo: _propTypes2.default.object,
  idpId: _propTypes2.default.string,
  groupIdpId: _propTypes2.default.string,
  fetchStudyPlanIfNeeded: _propTypes2.default.func,
  fetchStudyPlanCourseIfNeeded: _propTypes2.default.func,
  publishStudyPlan: _propTypes2.default.func,
  group: _propTypes2.default.object,
  studyPlan: _propTypes2.default.object,
  changeMode: _propTypes2.default.func.isRequired,
  canEdit: _propTypes2.default.bool,
  isInEditMode: _propTypes2.default.bool,
  onComponentMounted: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.groupId,
      idpId = ownProps.idpId;

  var group = state.get('rootReducer').get('groups').get(groupId).data;
  var studyPlan = state.get('rootReducer').get('studyPlan').get(idpId);
  return {
    group: group,
    studyPlan: studyPlan
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_StudyPlan.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(StudyPlan);

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1806);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3BD4fCxoBlGb_o_dYiDsnI{padding:1.42857rem 0}._1eK_pN6JRHDFwhQ5BUsBjK{padding:0 2.14286rem}.AKbfVU8T4wHf_h3cSbtiI{margin-bottom:.71429rem}._3-hjxuS4QEEKDziXYpc0Kx{list-style:none;padding-left:0}._1_TS11IOA9_RwLkyT2OgZB{font-weight:700}._1yXkO4qdGolbNzBdpJgD6B{border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around;list-style:none;padding:.71429rem 2.14286rem}._1yXkO4qdGolbNzBdpJgD6B li{-webkit-flex-basis:40%;-ms-flex-preferred-size:40%;flex-basis:40%}._1yXkO4qdGolbNzBdpJgD6B li:first-child{font-weight:700}._1yXkO4qdGolbNzBdpJgD6B li:first-child,._1yXkO4qdGolbNzBdpJgD6B li:last-child{-webkit-flex-basis:30%;-ms-flex-preferred-size:30%;flex-basis:30%}._334_9Fr9-ZeImegOjC_14o{width:50%}._1nyX7sv5_QVEk34wjArJy{width:65%}.GENPxmtPfAqp2rbxav429{min-height:2.5rem}._1K-56TjVIwnpkNyqNDNKTM{padding:0 2.14286rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudyPlan": "_3BD4fCxoBlGb_o_dYiDsnI",
	"StudyPlan_radio": "_1eK_pN6JRHDFwhQ5BUsBjK",
	"StudyPlan_radio_item": "AKbfVU8T4wHf_h3cSbtiI",
	"StudyPlan_table": "_3-hjxuS4QEEKDziXYpc0Kx",
	"StudyPlan_table_header": "_1_TS11IOA9_RwLkyT2OgZB",
	"StudyPlan_table_row": "_1yXkO4qdGolbNzBdpJgD6B",
	"StudyPlan_table_row_select": "_334_9Fr9-ZeImegOjC_14o",
	"StudyPlan_table_row_input": "_1nyX7sv5_QVEk34wjArJy",
	"StudyPlan_select_option": "GENPxmtPfAqp2rbxav429",
	"StudyPlan_buttons": "_1K-56TjVIwnpkNyqNDNKTM"
};

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1808);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".UkRXuOVS2IHX59QcchsaS{padding:2.14286rem 2.14286rem 1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"CardActionButtons": "UkRXuOVS2IHX59QcchsaS"
};

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1810);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextInput = function (_PureComponent) {
  _inherits(TextInput, _PureComponent);

  function TextInput(props) {
    _classCallCheck(this, TextInput);

    var _this2 = _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, props));

    _this2.handleChange = _this2.handleChange.bind(_this2);
    return _this2;
  }

  _createClass(TextInput, [{
    key: 'handleChange',
    value: function handleChange(e) {
      if (this.props.acceptedChars) {
        if (this.props.acceptedChars.type === 'number' && e.target.value.match(/\D/g)) {
          return;
        }
        if (this.props.acceptedChars.length > 0 && this.props.acceptedChars.length < e.target.value.length) {
          return;
        }
      }
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var suffix = this.props.suffix;

      var _this = this;
      var classes = (0, _classnames2.default)(_style2.default.TextInput, this.props.className);
      var inputClasses = !suffix ? (0, _classnames2.default)(_style2.default.TextInput_input, this.props.inputClassName) : (0, _classnames2.default)(_style2.default.TextInput_input, this.props.inputClassName, _style2.default.TextInput_suffixInput);
      return _react2.default.createElement(
        'div',
        { className: classes, style: this.props.myStyle },
        this.props.labelName && _react2.default.createElement(
          'span',
          { className: _style2.default.TextInput_name },
          this.props.labelName
        ),
        renderInputText()
      );

      function renderInputText() {
        if (suffix) {
          return _react2.default.createElement(
            'div',
            { className: _style2.default.TextInput_suffixWrapper },
            _react2.default.createElement('input', { type: 'text',
              style: _this.props.inputStyle,
              className: inputClasses,
              name: _this.props.name,
              disabled: _this.props.disabled,
              required: _this.props.required,
              value: _this.props.value,
              maxLength: _this.props.maxLength,
              placeholder: _this.props.placeholder,
              onBlur: _this.handleChange,
              onChange: _this.handleChange }),
            _react2.default.createElement(
              'span',
              { className: _style2.default.TextInput_suffixWrapper_suffix },
              suffix
            )
          );
        }

        return _react2.default.createElement('input', { type: 'text',
          style: _this.props.inputStyle,
          className: inputClasses,
          name: _this.props.name,
          disabled: _this.props.disabled,
          required: _this.props.required,
          value: _this.props.value,
          maxLength: _this.props.maxLength,
          placeholder: _this.props.placeholder,
          onBlur: _this.handleChange,
          onChange: _this.handleChange });
      }
    }
  }]);

  return TextInput;
}(_react.PureComponent);

TextInput.propTypes = {
  myStyle: _propTypes2.default.object,
  inputStyle: _propTypes2.default.object,
  value: _propTypes2.default.string,
  maxLength: _propTypes2.default.number,
  placeholder: _propTypes2.default.string,
  labelName: _propTypes2.default.string,
  name: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  required: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  suffix: _propTypes2.default.string,
  className: _propTypes2.default.string,
  inputClassName: _propTypes2.default.string,
  acceptedChars: _propTypes2.default.object
};

exports.default = TextInput;

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1811);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".PMLmqzzic4Z2BlKqcflGk{display:inline-block;letter-spacing:.07143rem}._2wti_x6sOLL6hr9DmllRtV{display:block;font-size:1rem;font-weight:600;letter-spacing:.07143rem;line-height:1.7;margin-bottom:.71429rem;text-transform:capitalize}.-rJJJr6q012QPtLivI9ir{display:inline-block;width:100%}._2D9FnMW9_8zDupsJAYLRyz{margin-left:-5.71429rem}._2pfPRE0k3nkIRQ1iQCDyaj{padding-right:5.71429rem;text-align:right}._3aCfxGir-le94Y15AbJihi{border:.07143rem solid #d3d3d3;-webkit-border-radius:.35714rem;-moz-border-radius:.35714rem;border-radius:.35714rem;display:inline-block;height:2.57143rem;letter-spacing:.07143rem;padding:0 1.07143rem;width:100%}._3aCfxGir-le94Y15AbJihi:focus{outline:unset}._3aCfxGir-le94Y15AbJihi::-webkit-input-placeholder{color:#a4a4a4;opacity:1;-webkit-transition:none;-o-transition:none;-moz-transition:none;transition:none}._3aCfxGir-le94Y15AbJihi:-moz-placeholder,._3aCfxGir-le94Y15AbJihi::-moz-placeholder{color:#a4a4a4;opacity:1;-webkit-transition:none;-o-transition:none;-moz-transition:none;transition:none}._3aCfxGir-le94Y15AbJihi:-ms-input-placeholder{color:#a4a4a4;opacity:1;-webkit-transition:none;-o-transition:none;-moz-transition:none;transition:none}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"TextInput": "PMLmqzzic4Z2BlKqcflGk",
	"TextInput_name": "_2wti_x6sOLL6hr9DmllRtV",
	"TextInput_suffixWrapper": "-rJJJr6q012QPtLivI9ir",
	"TextInput_suffixWrapper_suffix": "_2D9FnMW9_8zDupsJAYLRyz",
	"TextInput_suffixInput": "_2pfPRE0k3nkIRQ1iQCDyaj",
	"TextInput_input": "_3aCfxGir-le94Y15AbJihi"
};

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StudyPlanReducer;

var _model = __webpack_require__(1813);

var _model2 = _interopRequireDefault(_model);

var _result = __webpack_require__(1814);

var _result2 = _interopRequireDefault(_result);

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(783);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StudyPlanReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_STUDY_PLAN_COURSES_SUCCESS:
      return onFetchCourseSuccess(state, action);
    case _actions.FETCH_STUDY_PLAN_SUCCESS:
      return onFetchStudyPlanSuccess(state, action);
    default:
      return state;
  }
}

function onFetchCourseSuccess(state, action) {
  var idpId = action.idpId,
      payload = action.payload;

  if (payload) {
    var studyPlan = state.get(idpId) || new _immutable.Map();
    var coreCourses = new _immutable.List(payload.coreCourses.map(function (raw) {
      return new _model2.default(raw);
    }));
    var nonCoreCourses = new _immutable.List(payload.nonCoreCourses.map(function (raw) {
      return new _model2.default(raw);
    }));
    studyPlan = studyPlan.set('coreCourses', coreCourses);
    studyPlan = studyPlan.set('nonCoreCourses', nonCoreCourses);
    return state.set(action.idpId, studyPlan);
  }
  return state;
}

function onFetchStudyPlanSuccess(state, action) {
  var idpId = action.idpId,
      payload = action.payload;

  if (Array.isArray(payload)) {
    var studyPlan = state.get(idpId) || new _immutable.Map();
    var result = new _immutable.List(payload.map(function (raw) {
      return _result2.default.create(raw);
    }));
    studyPlan = studyPlan.set('result', result);
    return state.set(idpId, studyPlan);
  }
  return state;
}

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CourseRecord = _immutable2.default.Record({
  id: undefined,
  name: undefined,
  isActive: undefined,
  displayOrder: undefined
});

var Course = function (_CourseRecord) {
  _inherits(Course, _CourseRecord);

  function Course() {
    _classCallCheck(this, Course);

    return _possibleConstructorReturn(this, (Course.__proto__ || Object.getPrototypeOf(Course)).apply(this, arguments));
  }

  return Course;
}(CourseRecord);

exports.default = Course;

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(784);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1815);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(784);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  switch (key) {
    case 'coreCourseId':
      {
        if (val === 0) return [key, undefined];
        return [key, val];
      }
    case 'otherOptions':
    case 'nonCoreCourseId':
      {
        if (val === null) return [key, undefined];
        return [key, val];
      }

    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1817);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(10);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _CardActionIcons = __webpack_require__(85);

var _CardActionIcons2 = _interopRequireDefault(_CardActionIcons);

var _CardActionButtons = __webpack_require__(215);

var _CardActionButtons2 = _interopRequireDefault(_CardActionButtons);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _TableWithExpandablePanel = __webpack_require__(201);

var _TableWithExpandablePanel2 = _interopRequireDefault(_TableWithExpandablePanel);

var _OverallDevelopment = __webpack_require__(329);

var _routes = __webpack_require__(169);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var strengthsInfo = {
  type: 'ST',
  name: 'Strengths',
  maxMarkNumber: 3,
  tooltip: 'This section highlights areas in which your child has consistently performed well.'
};
var improvementsMadeInfo = {
  type: 'IM',
  name: 'Improvement made',
  maxMarkNumber: 3,
  tooltip: 'This section highlights areas in which your child has made noticeable improvement.'
};
var needAttentionInfo = {
  type: 'NA',
  name: 'Need attention',
  maxMarkNumber: 2,
  tooltip: 'This section highlights ares which would benefit from continued attention.'
};
var categoryInfo = {
  ST: strengthsInfo,
  IM: improvementsMadeInfo,
  NA: needAttentionInfo
};

var OverallDevelopment = function (_PureComponent) {
  _inherits(OverallDevelopment, _PureComponent);

  function OverallDevelopment(props) {
    var _isExpandRemainingMem;

    _classCallCheck(this, OverallDevelopment);

    var _this = _possibleConstructorReturn(this, (OverallDevelopment.__proto__ || Object.getPrototypeOf(OverallDevelopment)).call(this, props));

    _this._onEditClick = _this._onEditClick.bind(_this);
    _this.onSaveClick = _this.onSaveClick.bind(_this);
    _this._onDiscardClick = _this._onDiscardClick.bind(_this);
    _this.shouldDisableSaveButton = _this.shouldDisableSaveButton.bind(_this);
    _this.setWasEditMade = _this.setWasEditMade.bind(_this);
    _this.wasEditMade = _this.wasEditMade.bind(_this);
    _this.onItemClick = _this.onItemClick.bind(_this);
    _this.closeMenu = _this.closeMenu.bind(_this);
    _this.state = {
      wasEditMade: false,
      showMenu: undefined,
      isExpandRemainingMember: (_isExpandRemainingMem = {}, _defineProperty(_isExpandRemainingMem, strengthsInfo.type, false), _defineProperty(_isExpandRemainingMem, improvementsMadeInfo.type, false), _defineProperty(_isExpandRemainingMem, needAttentionInfo.type, false), _isExpandRemainingMem)
    };
    return _this;
  }

  _createClass(OverallDevelopment, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          fetchOverallDevelopmentResultIfNeeded = _props.fetchOverallDevelopmentResultIfNeeded,
          fetchOverallDevelopmentTemplateIfNeeded = _props.fetchOverallDevelopmentTemplateIfNeeded,
          idpId = _props.idpId;

      fetchOverallDevelopmentResultIfNeeded(idpId);
      fetchOverallDevelopmentTemplateIfNeeded(idpId);
      this.props.onComponentMounted(this);
      this._onOverallDevelopmentResultUpdate(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._onOverallDevelopmentResultUpdate(nextProps);
    }
  }, {
    key: '_onEditClick',
    value: function _onEditClick() {
      this.props.changeMode(_routes.Modes.EDIT_OVERALL_DEVELOPMENT);
    }
  }, {
    key: '_isEditing',
    value: function _isEditing() {
      return this.props.isInEditMode;
    }
  }, {
    key: 'setWasEditMade',
    value: function setWasEditMade(wasEditMade) {
      if (_is_js2.default.not.boolean(wasEditMade)) return;
      this.setState({ wasEditMade: wasEditMade });
    }
  }, {
    key: 'wasEditMade',
    value: function wasEditMade() {
      return this.props.isInEditMode && this.state.wasEditMade;
    }
  }, {
    key: 'shouldDisableSaveButton',
    value: function shouldDisableSaveButton() {
      var overallDevelopment = this.state.overallDevelopment;

      var template = this.props.overallDevelopment && this.props.overallDevelopment.get('template');
      return !_immutable.List.isList(overallDevelopment) || overallDevelopment.size === 0 || !_is_js2.default.existy(template) || this._isNeededToChoose(strengthsInfo.type, template.strengths) || this._isNeededToChoose(needAttentionInfo.type, template.needAttentions) || this._isNeededToChoose(improvementsMadeInfo.type, template.improvementsModes);
    }
  }, {
    key: '_onOverallDevelopmentResultUpdate',
    value: function _onOverallDevelopmentResultUpdate(props) {
      if (this.wasEditMade()) return;
      var overallDevelopmentResult = props.overallDevelopment && props.overallDevelopment.get('result');
      var items = _is_js2.default.not.existy(overallDevelopmentResult) ? new _immutable.List() : new _immutable.List(overallDevelopmentResult.items.toArray());
      this.setState({
        overallDevelopment: items
      });
    }
  }, {
    key: 'onSaveClick',
    value: function onSaveClick() {
      var _this2 = this;

      var overallDevelopment = this.state.overallDevelopment;
      var _props2 = this.props,
          idpId = _props2.idpId,
          groupIdpId = _props2.groupIdpId,
          saveOverallDevelopment = _props2.saveOverallDevelopment;

      var template = this.props.overallDevelopment.get('template');
      var validResults = overallDevelopment.filter(function (result) {
        return template.strengths.some(function (st) {
          return st.items.some(function (tp) {
            return result.typeCode === strengthsInfo.type && result.unitId === tp.unitId && result.subSkillId === tp.id;
          });
        }) || template.improvementsModes.some(function (st) {
          return st.items.some(function (tp) {
            return result.typeCode === improvementsMadeInfo.type && result.unitId === tp.unitId && result.subSkillId === tp.id;
          });
        }) || template.needAttentions.some(function (st) {
          return st.items.some(function (tp) {
            return result.typeCode === needAttentionInfo.type && result.unitId === tp.unitId && result.subSkillId === tp.id;
          });
        });
      });

      saveOverallDevelopment(idpId, validResults, groupIdpId).then(function () {
        return _this2._onDiscardClick();
      });
    }
  }, {
    key: '_onDiscardClick',
    value: function _onDiscardClick() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.setWasEditMade(false);
      props.changeMode('');
      this._onOverallDevelopmentResultUpdate(props);
    }
  }, {
    key: '_getMenuItemDescription',
    value: function _getMenuItemDescription(ability) {
      if (_is_js2.default.not.existy(ability)) return '';
      if (ability.point === '3') return 'The student can consistently ...';
      if (ability.point === '2') return 'The student can sometimes ...';

      return '';
    }
  }, {
    key: '_getButtonTypeForAbility',
    value: function _getButtonTypeForAbility(originalAbility, currentAbility) {
      var ability = currentAbility === undefined ? originalAbility : currentAbility;
      if (ability.point === '1') return _omniCommonUi.Button.Type.wrong;
      if (ability.point === '3') return _omniCommonUi.Button.Type.correct;
      if (ability.point === '2') return _omniCommonUi.Button.Type.needsAttention;

      return _omniCommonUi.Button.Type.black;
    }
  }, {
    key: '_isItemCurrentlySelected',
    value: function _isItemCurrentlySelected(type, item) {
      var overallDevelopment = this.state.overallDevelopment;

      return overallDevelopment.some(function (development) {
        return type === development.typeCode && development.unitId === item.unitId && development.subSkillId === item.id;
      });
    }
  }, {
    key: 'onItemClick',
    value: function onItemClick(event, skillId, item, type) {
      var _this3 = this;

      event.preventDefault();
      var result = void 0;
      if (_is_js2.default.existy(this.state.showMenu)) result = this.closeMenu();
      var overallDevelopment = this.state.overallDevelopment;

      var index = overallDevelopment.findIndex(function (development) {
        return type === development.typeCode && development.unitId === item.unitId && development.subSkillId === item.id;
      });
      var isShowMenu = index < 0 && type === improvementsMadeInfo.type;
      if (_is_js2.default.not.existy(result)) result = overallDevelopment;
      if (index >= 0) {
        result = result.remove(index);
      } else {
        result = result.push({
          typeCode: type,
          unitId: item.unitId,
          skillId: skillId,
          subSkillId: item.id,
          originalAbilityId: item.abilityId,
          improvedAbilityId: undefined
        });
      }
      this.setState({
        overallDevelopment: result,
        showMenu: isShowMenu ? { unitId: item.unitId, itemId: item.id } : undefined
      }, function () {
        isShowMenu ? document.addEventListener('click', _this3.closeMenu) : undefined;
      });
      this.setWasEditMade(true);
    }
  }, {
    key: 'closeMenu',
    value: function closeMenu() {
      var _this4 = this;

      var _state = this.state,
          overallDevelopment = _state.overallDevelopment,
          showMenu = _state.showMenu;

      var results = overallDevelopment;
      var index = results.findIndex(function (result) {
        return result.typeCode === 'IM' && result.subSkillId === showMenu.itemId && result.unitId === showMenu.unitId;
      });
      var currentResult = results.get(index);
      if (_is_js2.default.existy(currentResult) && _is_js2.default.not.existy(currentResult.ImprovedAbilityId)) {
        results = results.remove(index);
      }

      this.setState({
        showMenu: undefined,
        overallDevelopment: results
      }, function () {
        document.removeEventListener('click', _this4.closeMenu);
      });

      return results;
    }
  }, {
    key: '_onItemMarked',
    value: function _onItemMarked(skillId, item, ability, type) {
      var _this5 = this;

      var overallDevelopment = this.state.overallDevelopment;

      var index = overallDevelopment.findIndex(function (development) {
        return type === development.typeCode && development.unitId === item.unitId && development.subSkillId === item.id;
      });
      var result = overallDevelopment;
      if (index >= 0) {
        result = result.remove(index);
      }

      result = result.push({
        typeCode: type,
        unitId: item.unitId,
        skillId: skillId,
        subSkillId: item.id,
        originalAbilityId: item.abilityId,
        improvedAbilityId: ability.id
      });

      this.setState({
        overallDevelopment: result,
        showMenu: undefined
      }, function () {
        document.removeEventListener('click', _this5.closeMenu);
      });
    }
  }, {
    key: '_isEditItemDisabled',
    value: function _isEditItemDisabled(type, item) {
      var overallDevelopment = this.state.overallDevelopment;

      var maxMarkNumber = categoryInfo[type].maxMarkNumber;
      var selectedResults = type === improvementsMadeInfo.type ? overallDevelopment.filter(function (result) {
        return type === result.typeCode && _is_js2.default.existy(result.improvedAbilityId);
      }) : overallDevelopment.filter(function (result) {
        return type === result.typeCode;
      });
      var isSelectedInCurrentArea = selectedResults.some(function (result) {
        return result.unitId === item.unitId && result.subSkillId === item.id;
      });
      var isSelectedInOtherArea = overallDevelopment.some(function (od) {
        return od.typeCode !== type && od.unitId === item.unitId && od.subSkillId === item.id;
      });

      return isSelectedInOtherArea || !isSelectedInCurrentArea && selectedResults.size >= maxMarkNumber;
    }
  }, {
    key: '_renderCell',
    value: function _renderCell(type, skillTemplate, column, results) {
      var _this6 = this;

      var items = skillTemplate.items.filter(function (item) {
        return item.unitId === column;
      });
      return _react2.default.createElement(
        'div',
        { className: _style2.default.OverallDevelopment_editCard_cell },
        items.size === 0 ? null : items.map(function (item) {
          var originalAbility = skillTemplate.abilities.filter(function (ability) {
            return ability.id === item.abilityId;
          }).first();
          var itemResult = results.filter(function (result) {
            return result.unitId === item.unitId && result.subSkillId === item.id;
          }).first();
          var currentAbility = itemResult && skillTemplate.abilities.filter(function (ability) {
            return itemResult.improvedAbilityId === ability.id;
          }).first();

          return _react2.default.createElement(
            'div',
            { className: _style2.default.OverallDevelopment_editCard_cell_item },
            _react2.default.createElement(
              _omniCommonUi.Button,
              { type: _this6._getButtonTypeForAbility(originalAbility, currentAbility),
                className: _this6._isItemCurrentlySelected(type, item) && _style2.default.__buttonActived,
                block: true,
                disabled: _this6._isEditItemDisabled(type, item),
                onClickActiveClassRemoveDelay: 0,
                active: _this6._isItemCurrentlySelected(type, item),
                onClick: function onClick(event) {
                  return _this6.onItemClick(event, skillTemplate.id, item, type);
                } },
              _react2.default.createElement(
                'span',
                null,
                item.name
              )
            ),
            type === 'IM' && _is_js2.default.existy(_this6.state.showMenu) && _this6.state.showMenu.itemId === item.id && _this6.state.showMenu.unitId === item.unitId && _react2.default.createElement(
              'div',
              { className: _style2.default.OverallDevelopment_editCard_cell_menu },
              skillTemplate.abilities.filter(function (ability) {
                return ability.point > originalAbility.point;
              }).map(function (ability) {
                return _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    _omniCommonUi.Button,
                    { type: _this6._getButtonTypeForAbility(ability),
                      block: true,
                      onClick: function onClick() {
                        return _this6._onItemMarked(skillTemplate.id, item, ability, type);
                      } },
                    _react2.default.createElement(
                      'span',
                      null,
                      _this6._getMenuItemDescription(ability)
                    ),
                    _react2.default.createElement(_omniCommonUi.Icon, { id: _this6._getIconIdByAbility(ability),
                      className: _this6._getIconClassNameByAbility(ability) })
                  )
                );
              })
            )
          );
        })
      );
    }
  }, {
    key: '_renderExpandButton',
    value: function _renderExpandButton(type) {
      var _this7 = this;

      var isExpandRemainingMember = this.state.isExpandRemainingMember;


      return _react2.default.createElement(_ExpansionButton2.default, { isExpand: isExpandRemainingMember[type],
        onExpansionButtonClick: function onExpansionButtonClick() {
          var copy = _extends({}, isExpandRemainingMember);
          copy[type] = !copy[type];
          _this7.setState({ isExpandRemainingMember: copy });
        },
        className: _style2.default.OverallDevelopment_editCard_expand });
    }
  }, {
    key: '_renderTable',
    value: function _renderTable(type, skillTemplates, results, units) {
      var _this8 = this;

      return _react2.default.createElement(
        _TableWithExpandablePanel2.default,
        { rows: skillTemplates,
          onlyRowDivider: false },
        _react2.default.createElement(
          _TableWithExpandablePanel2.default.Panel,
          null,
          _react2.default.createElement(
            _TableWithExpandablePanel2.default.Header,
            null,
            _react2.default.createElement(_TableWithExpandablePanel2.default.Cell, { columnId: 'skill-name' })
          ),
          _react2.default.createElement(
            _TableWithExpandablePanel2.default.Body,
            null,
            function (skillTemplate, columnId) {
              switch (columnId) {
                case 'skill-name':
                  return _react2.default.createElement(
                    'span',
                    null,
                    skillTemplate.name
                  );
                default:
                  throw new Error('Invalid column ' + columnId);
              }
            }
          )
        ),
        _react2.default.createElement(
          _TableWithExpandablePanel2.default.Header,
          null,
          _react2.default.createElement(
            _TableWithExpandablePanel2.default.Row,
            null,
            units.sortBy(function (unit) {
              return unit.name;
            }).reverse().map(function (unit) {
              return _react2.default.createElement(
                _TableWithExpandablePanel2.default.Cell,
                { key: unit.id, columnId: unit.id, small: true },
                _react2.default.createElement(
                  'div',
                  { className: _style2.default.OverallDevelopment_table_header },
                  unit.name
                )
              );
            })
          )
        ),
        _react2.default.createElement(
          _TableWithExpandablePanel2.default.Body,
          null,
          function (skillTemplate, column) {
            return _this8._renderCell(type, skillTemplate, column, results);
          }
        )
      );
    }
  }, {
    key: '_getIconIdByAbility',
    value: function _getIconIdByAbility(ability) {
      if (_is_js2.default.not.existy(ability)) return '';
      if (ability.point === '3') return 'happy';else if (ability.point === '2') return 'smile';

      return 'unhappy';
    }
  }, {
    key: '_getIconClassNameByAbility',
    value: function _getIconClassNameByAbility(ability) {
      if (_is_js2.default.not.existy(ability)) return undefined;
      if (ability.point === '3') return _style2.default.OverallDevelopment_happyIcon;
      if (ability.point === '2') return _style2.default.OverallDevelopment_smileIcon;
      if (ability.point === '1') return _style2.default.OverallDevelopment_unhappyIcon;

      return undefined;
    }
  }, {
    key: '_getIconIdByType',
    value: function _getIconIdByType(type) {
      if (type === strengthsInfo.type) return 'happy';
      if (type === needAttentionInfo.type) return 'unhappy';

      return '';
    }
  }, {
    key: '_getIconClassNameByType',
    value: function _getIconClassNameByType(type) {
      if (type === strengthsInfo.type) return _style2.default.OverallDevelopment_happyIcon;
      if (type === needAttentionInfo.type) return _style2.default.OverallDevelopment_unhappyIcon;

      return undefined;
    }
  }, {
    key: '_renderViewSkillItem',
    value: function _renderViewSkillItem(type, item, result, abilities) {
      var originalAbility = abilities.filter(function (a) {
        return a.id === result.originalAbilityId;
      }).first();
      var improvedAbility = abilities.filter(function (a) {
        return a.id === result.improvedAbilityId;
      }).first();
      return _react2.default.createElement(
        'div',
        { className: _style2.default.OverallDevelopment_viewCard_item },
        _react2.default.createElement(
          _omniCommonUi.Button,
          { type: _omniCommonUi.Button.Type.black,
            block: false,
            disabled: true,
            onClickActiveClassRemoveDelay: 0 },
          _react2.default.createElement(
            'span',
            null,
            item.name
          )
        ),
        type === improvementsMadeInfo.type && _is_js2.default.existy(result) && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_omniCommonUi.Icon, { id: this._getIconIdByAbility(originalAbility),
            className: this._getIconClassNameByAbility(originalAbility) }),
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'chevron-small-right' }),
          _react2.default.createElement(_omniCommonUi.Icon, { id: this._getIconIdByAbility(improvedAbility),
            className: this._getIconClassNameByAbility(improvedAbility) })
        )
      );
    }
  }, {
    key: '_renderViewContent',
    value: function _renderViewContent(type, skillTemplates, results) {
      var _this9 = this;

      var categoryResults = results.filter(function (result) {
        return result.typeCode === type;
      });
      if (!(_immutable.List.isList(skillTemplates) && skillTemplates.size > 0 && categoryResults.size > 0)) return null;

      return _react2.default.createElement(
        'div',
        { className: _style2.default.OverallDevelopment_viewCard },
        _react2.default.createElement(
          'h1',
          null,
          categoryInfo[type].name
        ),
        _react2.default.createElement(_omniCommonUi.Icon, { id: this._getIconIdByType(type), className: this._getIconClassNameByType(type) }),
        skillTemplates.map(function (skillTemplate) {
          var items = skillTemplate.items.filter(function (i) {
            return categoryResults.some(function (r) {
              return r.unitId === i.unitId && r.subSkillId === i.id;
            });
          });
          if (items.size === 0) return null;
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h2',
              null,
              skillTemplate.name
            ),
            _react2.default.createElement(
              'div',
              null,
              items.map(function (item) {
                var result = categoryResults.filter(function (cr) {
                  return cr.unitId === item.unitId && cr.subSkillId === item.id;
                }).first();
                return _this9._renderViewSkillItem(type, item, result, skillTemplate.abilities);
              })
            )
          );
        })
      );
    }
  }, {
    key: '_isNeededToChoose',
    value: function _isNeededToChoose(type, skillTemplates) {
      if (skillTemplates.size === 0) return false;

      var overallDevelopment = this.state.overallDevelopment;

      var categoryResults = overallDevelopment.filter(function (r) {
        return r.typeCode === type;
      });

      var hasCanMarkedItems = skillTemplates.some(function (template) {
        return template.items.filter(function (item) {
          return !overallDevelopment.some(function (od) {
            return od.typeCode !== type && od.unitId === item.unitId && od.subSkillId === item.id;
          });
        }).size > 0;
      });

      if (hasCanMarkedItems) {
        return categoryResults.size === 0 || improvementsMadeInfo.type === type && !categoryResults.some(function (r) {
          return _is_js2.default.existy(r.improvedAbilityId);
        });
      }

      return false;
    }
  }, {
    key: '_renderEditContent',
    value: function _renderEditContent(type, skillTemplates, results, units) {
      var categoryResults = results.filter(function (result) {
        return result.typeCode === type;
      });
      if (!(_immutable.List.isList(skillTemplates) && skillTemplates.size > 0)) return null;
      var defaultDisplayNumber = 1;
      var displayedTemplates = skillTemplates.filter(function (_, index) {
        return index < defaultDisplayNumber;
      });
      if (this.state.isExpandRemainingMember[type]) {
        displayedTemplates = skillTemplates;
      }

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: _style2.default.OverallDevelopment_editCard },
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          { text: categoryInfo[type].name + ' ' + categoryResults.size + '/' + categoryInfo[type].maxMarkNumber,
            className: _style2.default.OverallDevelopment_editCard_header,
            titleClassName: _style2.default.OverallDevelopment_editCard_title },
          _react2.default.createElement(
            _omniCommonUi.Tooltip,
            { text: categoryInfo[type].tooltip,
              placement: 'right',
              trigger: ['hover'],
              className: _style2.default.OverallDevelopment_editCard_tooltip },
            _react2.default.createElement(_omniCommonUi.Icon, { id: 'question' })
          ),
          this._isNeededToChoose(type, skillTemplates) && _react2.default.createElement(
            'span',
            null,
            'Choose at least one item.'
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.OverallDevelopment_editCard_content },
          this._renderTable(type, displayedTemplates, categoryResults, units)
        ),
        this._renderExpandButton(type)
      );
    }
  }, {
    key: '_renderContent',
    value: function _renderContent() {
      var template = this.props.overallDevelopment && this.props.overallDevelopment.get('template');
      var overallDevelopment = this.state.overallDevelopment;

      if (_is_js2.default.not.existy(template) || _is_js2.default.not.existy(overallDevelopment)) return null;
      var units = template.units;
      if (!this._isEditing()) {
        return _react2.default.createElement(
          'div',
          null,
          this._renderViewContent(strengthsInfo.type, template.strengths, overallDevelopment),
          overallDevelopment.size > 0 && template.strengths.size > 0 && template.improvementsModes.size > 0 && _react2.default.createElement('div', { className: _style2.default.OverallDevelopment_separatorLine }),
          this._renderViewContent(improvementsMadeInfo.type, template.improvementsModes, overallDevelopment),
          overallDevelopment.size > 0 && template.needAttentions.size > 0 && template.improvementsModes.size > 0 && _react2.default.createElement('div', { className: _style2.default.OverallDevelopment_separatorLine }),
          this._renderViewContent(needAttentionInfo.type, template.needAttentions, overallDevelopment)
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        this._renderEditContent(strengthsInfo.type, template.strengths, overallDevelopment, units),
        this._renderEditContent(improvementsMadeInfo.type, template.improvementsModes, overallDevelopment, units),
        this._renderEditContent(needAttentionInfo.type, template.needAttentions, overallDevelopment, units)
      );
    }
  }, {
    key: '_renderButtons',
    value: function _renderButtons() {
      if (!this._isEditing()) {
        return null;
      }
      return _react2.default.createElement(_CardActionButtons2.default, { className: _style2.default.OverallDevelopment_buttons,
        isPrimaryDisabled: this.shouldDisableSaveButton(),
        onPrimaryClick: this.onSaveClick,
        onSecondaryClick: this._onDiscardClick });
    }
  }, {
    key: '_renderEmptyHint',
    value: function _renderEmptyHint() {
      if (this.props.isInEditMode) return null;

      var overallDevelopment = this.state.overallDevelopment;

      var template = this.props.overallDevelopment && this.props.overallDevelopment.get('template');
      if (!_immutable.List.isList(overallDevelopment) || !_is_js2.default.existy(template)) {
        return null;
      }

      var emptyActionsNumber = 0;
      if (this._isNeededToChoose(strengthsInfo.type, template.strengths)) {
        emptyActionsNumber += 1;
      }
      if (this._isNeededToChoose(needAttentionInfo.type, template.needAttentions)) {
        emptyActionsNumber += 1;
      }
      if (this._isNeededToChoose(improvementsMadeInfo.type, template.improvementsModes)) {
        emptyActionsNumber += 1;
      }

      if (emptyActionsNumber === 0) return null;

      var hint = '';
      if (emptyActionsNumber === 1) {
        hint = emptyActionsNumber + ' action is missing.';
      } else if (emptyActionsNumber > 1) {
        hint = emptyActionsNumber + ' actions are missing.';
      }

      return _react2.default.createElement(
        'div',
        { className: _style2.default.OverallDevelopment_HeaderHint },
        hint
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state || !_is_js2.default.existy(this.state.overallDevelopment)) {
        return null;
      }
      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _omniCommonUi.testClass)('overall-development') },
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          { text: 'Overall development', stackMode: 'horizontal' },
          this._renderEmptyHint(),
          _react2.default.createElement(_CardActionIcons2.default, { hideEditIcon: !this.props.canEdit,
            onEditClick: this._onEditClick,
            hideDeleteIcon: true })
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.OverallDevelopment },
          this._renderContent(),
          this._renderButtons()
        )
      );
    }
  }]);

  return OverallDevelopment;
}(_react.PureComponent);

OverallDevelopment.propTypes = {
  studentInfo: _propTypes2.default.object,
  idpId: _propTypes2.default.string,
  groupIdpId: _propTypes2.default.string,
  saveOverallDevelopment: _propTypes2.default.func,
  fetchOverallDevelopmentResultIfNeeded: _propTypes2.default.func,
  fetchOverallDevelopmentTemplateIfNeeded: _propTypes2.default.func,
  overallDevelopment: _propTypes2.default.object,
  changeMode: _propTypes2.default.func.isRequired,
  canEdit: _propTypes2.default.bool,
  isInEditMode: _propTypes2.default.bool,
  onComponentMounted: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var idpId = ownProps.idpId;

  var overallDevelopment = state.get('rootReducer').get('overallDevelopment').get(idpId);
  return {
    overallDevelopment: overallDevelopment
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_OverallDevelopment.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(OverallDevelopment);

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1818);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2VR-TdzEN1U_CltCwfv_OQ{padding:1.42857rem 0}._2VR-TdzEN1U_CltCwfv_OQ .iScrollIndicator{background-color:rgba(0,0,0,.2)!important;opacity:1}._2IVfEy5w5xKDcw2SsGDuhU{color:#de4c4c;font-style:Italic;margin-right:1.14286rem}._2xpoxOc9mb5yxKLMfBAJ7M{-webkit-box-shadow:0;-moz-box-shadow:0;box-shadow:0}._3_FRwe6ZUdFkH2XUjOzmlV{border-bottom:0}._3_FRwe6ZUdFkH2XUjOzmlV span{color:#de4c4c;font-style:Italic;position:absolute;right:2.14286rem;top:.92857rem}.RHpos7-cl4VwV9KaERT2x{display:inline-block;-webkit-box-flex:initial;-webkit-flex:initial;-moz-box-flex:initial;-ms-flex:initial;flex:initial;vertical-align:middle}._1z6kh4GUqCJawNCJA-MNQQ{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-left:.35714rem;vertical-align:middle}._2jwWBEfjLsqZKPlfqLXvhV{padding:0}._28EQpQIjek3kLdX7cZFkOv{border-top:0;margin-bottom:1rem}._3ufyo9qNh79LQhkLhRPN0m{left:50%;max-width:35.71429rem;min-width:21.42857rem;padding-bottom:.71429rem;position:relative}._3ZTV4LlZ5zxrPXOfSOWjF0{padding-top:.71429rem;position:relative;right:50%}._3ZTV4LlZ5zxrPXOfSOWjF0 button{font-weight:400;text-align:left}._3ZTV4LlZ5zxrPXOfSOWjF0 button:hover:not([disabled]):not(._2M_fBj_F5JeD0HPtXICK2n){opacity:.8}._3ZTV4LlZ5zxrPXOfSOWjF0 span{text-transform:none;white-space:normal}._2piNQBN_ql9CX_hQ2_iB-j{background:#e5e5e5;bottom:2.5rem;position:absolute;width:100%;z-index:999}._2piNQBN_ql9CX_hQ2_iB-j button{font-weight:400;margin-bottom:.35714rem;text-align:left;text-transform:none}._2piNQBN_ql9CX_hQ2_iB-j button span{vertical-align:middle}._2piNQBN_ql9CX_hQ2_iB-j button i{float:right}._34TNxwFHRPWAmsgCDqppTQ{padding:0 2.14286rem}._34TNxwFHRPWAmsgCDqppTQ h1{display:inline-block;font-size:1.14286rem;font-weight:700;margin-right:.35714rem}._34TNxwFHRPWAmsgCDqppTQ h2{font-size:1.14286rem;font-weight:700;margin-bottom:0}._2vJwEH0ichNaeBFQ2X_Su5{display:inline-block;margin:.71429rem 1.42857rem 0 0}._2vJwEH0ichNaeBFQ2X_Su5 button{font-weight:400;text-align:left;vertical-align:middle;width:21.42857rem}._2vJwEH0ichNaeBFQ2X_Su5 button[disabled]{opacity:1}._2vJwEH0ichNaeBFQ2X_Su5 button span{text-transform:none;white-space:normal}._2vJwEH0ichNaeBFQ2X_Su5 div{display:inline-block;margin-left:.71429rem}._2vJwEH0ichNaeBFQ2X_Su5 i{display:inline-block;vertical-align:middle}._2t2OpdcOOWXwEXBC5Tepj-{color:#50f173}._6bdUQHnBmJN_mqvxZOSN_{color:#fc0}.GbmojpMUT6-J6sWX4_WXp{color:#e2476f}._2t2OpdcOOWXwEXBC5Tepj-,._6bdUQHnBmJN_mqvxZOSN_,.GbmojpMUT6-J6sWX4_WXp{display:inline-block;vertical-align:middle}._2t2OpdcOOWXwEXBC5Tepj- svg,._6bdUQHnBmJN_mqvxZOSN_ svg,.GbmojpMUT6-J6sWX4_WXp svg{height:1.42857rem;width:1.42857rem}._1ubWsvINUL9CP91tCVAoqv{border-bottom:.07143rem solid #ccc;margin:2.14286rem 0 .71429rem}.mYyGEvMEGAWDDQxoUfpEu{padding:0 2.14286rem}.iOrdVOJ-Cs-l64Xfv37pJ{height:5.71429rem;line-height:5.71429rem}._2M_fBj_F5JeD0HPtXICK2n{color:#fff}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"OverallDevelopment": "_2VR-TdzEN1U_CltCwfv_OQ",
	"OverallDevelopment_HeaderHint": "_2IVfEy5w5xKDcw2SsGDuhU",
	"OverallDevelopment_editCard": "_2xpoxOc9mb5yxKLMfBAJ7M",
	"OverallDevelopment_editCard_header": "_3_FRwe6ZUdFkH2XUjOzmlV",
	"OverallDevelopment_editCard_title": "RHpos7-cl4VwV9KaERT2x",
	"OverallDevelopment_editCard_tooltip": "_1z6kh4GUqCJawNCJA-MNQQ",
	"OverallDevelopment_editCard_content": "_2jwWBEfjLsqZKPlfqLXvhV",
	"OverallDevelopment_editCard_expand": "_28EQpQIjek3kLdX7cZFkOv",
	"OverallDevelopment_editCard_cell": "_3ufyo9qNh79LQhkLhRPN0m",
	"OverallDevelopment_editCard_cell_item": "_3ZTV4LlZ5zxrPXOfSOWjF0",
	"__buttonActived": "_2M_fBj_F5JeD0HPtXICK2n",
	"OverallDevelopment_editCard_cell_menu": "_2piNQBN_ql9CX_hQ2_iB-j",
	"OverallDevelopment_viewCard": "_34TNxwFHRPWAmsgCDqppTQ",
	"OverallDevelopment_viewCard_item": "_2vJwEH0ichNaeBFQ2X_Su5",
	"OverallDevelopment_happyIcon": "_2t2OpdcOOWXwEXBC5Tepj-",
	"OverallDevelopment_smileIcon": "_6bdUQHnBmJN_mqvxZOSN_",
	"OverallDevelopment_unhappyIcon": "GbmojpMUT6-J6sWX4_WXp",
	"OverallDevelopment_separatorLine": "_1ubWsvINUL9CP91tCVAoqv",
	"OverallDevelopment_buttons": "mYyGEvMEGAWDDQxoUfpEu",
	"OverallDevelopment_table_header": "iOrdVOJ-Cs-l64Xfv37pJ"
};

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OverallDevelopmentReducer;

var _template = __webpack_require__(1820);

var _template2 = _interopRequireDefault(_template);

var _result = __webpack_require__(1828);

var _result2 = _interopRequireDefault(_result);

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(324);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OverallDevelopmentReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_OVERALL_DEVELOPMENT_RESULT_SUCCESS:
      return onFetchOverallDevelopmentResultSuccess(state, action);
    case _actions.FETCH_OVERALL_DEVELOPMENT_TEMPLATE_SUCCESS:
      return onFetchOverallDevelopmentTemplateSuccess(state, action);
    default:
      return state;
  }
}

function onFetchOverallDevelopmentTemplateSuccess(state, action) {
  var idpId = action.idpId,
      payload = action.payload;

  if (payload) {
    var overallDevelopment = state.get(idpId) || new _immutable.Map();
    var template = _template2.default.create(payload);
    overallDevelopment = overallDevelopment.set('template', template);
    return state.set(idpId, overallDevelopment);
  }
  return state;
}

function onFetchOverallDevelopmentResultSuccess(state, action) {
  var idpId = action.idpId,
      payload = action.payload;

  if (payload) {
    var overallDevelopment = state.get(idpId) || new _immutable.Map();
    var result = _result2.default.create(payload);
    overallDevelopment = overallDevelopment.set('result', result);
    return state.set(idpId, overallDevelopment);
  }
  return state;
}

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1821);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _skills = __webpack_require__(1822);

var _skills2 = _interopRequireDefault(_skills);

var _Units = __webpack_require__(281);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverallDevelopmentTemplateRecord = (0, _immutable.Record)({
  studentIDPId: undefined,
  studentId: undefined,
  units: new _immutable.List(),
  strengths: new _immutable.List(),
  improvementsModes: new _immutable.List(),
  needAttentions: new _immutable.List()
});

var OverallDevelopmentTemplate = function (_OverallDevelopmentTe) {
  _inherits(OverallDevelopmentTemplate, _OverallDevelopmentTe);

  function OverallDevelopmentTemplate() {
    _classCallCheck(this, OverallDevelopmentTemplate);

    return _possibleConstructorReturn(this, (OverallDevelopmentTemplate.__proto__ || Object.getPrototypeOf(OverallDevelopmentTemplate)).apply(this, arguments));
  }

  return OverallDevelopmentTemplate;
}(OverallDevelopmentTemplateRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'studentIDPId':
      return [key, '' + val];
    case 'studentId':
      return [key, '' + val];
    case 'units':
      return [key, new _immutable.List(val.map(_Units.Unit.create))];
    case 'strengths':
      return [key, new _immutable.List(val.map(_skills2.default.create))];
    case 'improvementsModes':
      return [key, new _immutable.List(val.map(_skills2.default.create))];
    case 'needAttentions':
      return [key, new _immutable.List(val.map(_skills2.default.create))];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

OverallDevelopmentTemplate.create = function (data) {
  return new OverallDevelopmentTemplate(data).mapEntries(reviver);
};

exports.default = OverallDevelopmentTemplate;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1823);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _abilities = __webpack_require__(1824);

var _abilities2 = _interopRequireDefault(_abilities);

var _items = __webpack_require__(1826);

var _items2 = _interopRequireDefault(_items);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverallDevelopmentSkillRecord = (0, _immutable.Record)({
  id: undefined,
  name: undefined,
  items: new _immutable.List(),
  abilities: new _immutable.List()
});

var OverallDevelopmentSkill = function (_OverallDevelopmentSk) {
  _inherits(OverallDevelopmentSkill, _OverallDevelopmentSk);

  function OverallDevelopmentSkill() {
    _classCallCheck(this, OverallDevelopmentSkill);

    return _possibleConstructorReturn(this, (OverallDevelopmentSkill.__proto__ || Object.getPrototypeOf(OverallDevelopmentSkill)).apply(this, arguments));
  }

  return OverallDevelopmentSkill;
}(OverallDevelopmentSkillRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'id':
      return [key, '' + val];
    case 'items':
      return [key, new _immutable.List(val.map(_items2.default.create))];
    case 'abilities':
      return [key, new _immutable.List(val.map(_abilities2.default.create))];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

OverallDevelopmentSkill.create = function (data) {
  return new OverallDevelopmentSkill(data).mapEntries(reviver);
};

exports.default = OverallDevelopmentSkill;

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1825);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SkillAbilityRecord = (0, _immutable.Record)({
  id: undefined,
  name: undefined,
  point: undefined
});

var SkillAbility = function (_SkillAbilityRecord) {
  _inherits(SkillAbility, _SkillAbilityRecord);

  function SkillAbility() {
    _classCallCheck(this, SkillAbility);

    return _possibleConstructorReturn(this, (SkillAbility.__proto__ || Object.getPrototypeOf(SkillAbility)).apply(this, arguments));
  }

  return SkillAbility;
}(SkillAbilityRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'id':
      return [key, '' + val];
    case 'point':
      return [key, '' + val];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

SkillAbility.create = function (data) {
  return new SkillAbility(data).mapEntries(reviver);
};

exports.default = SkillAbility;

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1827);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverallDevelopmentItemRecord = (0, _immutable.Record)({
  id: undefined,
  name: undefined,
  unitId: undefined,
  abilityId: undefined
});

var OverallDevelopmentItem = function (_OverallDevelopmentIt) {
  _inherits(OverallDevelopmentItem, _OverallDevelopmentIt);

  function OverallDevelopmentItem() {
    _classCallCheck(this, OverallDevelopmentItem);

    return _possibleConstructorReturn(this, (OverallDevelopmentItem.__proto__ || Object.getPrototypeOf(OverallDevelopmentItem)).apply(this, arguments));
  }

  return OverallDevelopmentItem;
}(OverallDevelopmentItemRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'id':
      return [key, '' + val];
    case 'unitId':
      return [key, '' + val];
    case 'abilityId':
      return [key, '' + val];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

OverallDevelopmentItem.create = function (data) {
  return new OverallDevelopmentItem(data).mapEntries(reviver);
};

exports.default = OverallDevelopmentItem;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1829);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _items = __webpack_require__(1830);

var _items2 = _interopRequireDefault(_items);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverallDevelopmentResultRecord = (0, _immutable.Record)({
  studentIDPId: undefined,
  studentId: undefined,
  items: new _immutable.List()
});

var OverallDevelopmentResult = function (_OverallDevelopmentRe) {
  _inherits(OverallDevelopmentResult, _OverallDevelopmentRe);

  function OverallDevelopmentResult() {
    _classCallCheck(this, OverallDevelopmentResult);

    return _possibleConstructorReturn(this, (OverallDevelopmentResult.__proto__ || Object.getPrototypeOf(OverallDevelopmentResult)).apply(this, arguments));
  }

  return OverallDevelopmentResult;
}(OverallDevelopmentResultRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'studentIDPId':
      return [key, '' + val];
    case 'studentId':
      return [key, '' + val];
    case 'items':
      return [key, new _immutable.List(val.map(_items2.default.create))];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

OverallDevelopmentResult.create = function (data) {
  return new OverallDevelopmentResult(data).mapEntries(reviver);
};

exports.default = OverallDevelopmentResult;

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(1831);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverallDevelopmentResultItemRecord = (0, _immutable.Record)({
  typeCode: undefined,
  unitId: undefined,
  skillId: undefined,
  subSkillId: undefined,
  originalAbilityId: undefined,
  improvedAbilityId: undefined
});

var OverallDevelopmentResultItem = function (_OverallDevelopmentRe) {
  _inherits(OverallDevelopmentResultItem, _OverallDevelopmentRe);

  function OverallDevelopmentResultItem() {
    _classCallCheck(this, OverallDevelopmentResultItem);

    return _possibleConstructorReturn(this, (OverallDevelopmentResultItem.__proto__ || Object.getPrototypeOf(OverallDevelopmentResultItem)).apply(this, arguments));
  }

  return OverallDevelopmentResultItem;
}(OverallDevelopmentResultItemRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'unitId':
      return [key, '' + val];
    case 'skillId':
      return [key, '' + val];
    case 'subSkillId':
      return [key, '' + val];
    case 'originalAbilityId':
      return [key, '' + val];
    case 'improvedAbilityId':
      return [key, '' + val];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

OverallDevelopmentResultItem.create = function (data) {
  return new OverallDevelopmentResultItem(data).mapEntries(reviver);
};

exports.default = OverallDevelopmentResultItem;

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1833);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Api = __webpack_require__(11);

var _Exporter = __webpack_require__(50);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

var _omniCommonUi = __webpack_require__(0);

var _LanguageRadio = __webpack_require__(74);

var _LanguageRadio2 = _interopRequireDefault(_LanguageRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXPORT_FILENAME = 'Progress Report.pdf';
var EXPORT_MIME_TYPE = 'application/pdf';

var ExportDialog = function (_Component) {
  _inherits(ExportDialog, _Component);

  function ExportDialog() {
    _classCallCheck(this, ExportDialog);

    var _this = _possibleConstructorReturn(this, (ExportDialog.__proto__ || Object.getPrototypeOf(ExportDialog)).call(this));

    _this.state = {
      isExportRequested: false
    };

    _this._onLanguageChanged = _this._onLanguageChanged.bind(_this);
    return _this;
  }

  _createClass(ExportDialog, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ choosedLanguageCode: this.props.languageCode });
    }
  }, {
    key: '_close',
    value: function _close() {
      var _props = this.props,
          buildRoute = _props.buildRoute,
          pushRoute = _props.pushRoute;

      function redirect(param) {
        pushRoute(buildRoute(param));
      }
      redirect({ mode: '' });
    }
  }, {
    key: '_performExport',
    value: function _performExport() {
      var _this2 = this;

      var idpId = this.props.idpId;


      if (_is_js2.default.falsy(idpId)) {
        _omniCommonUi.log.error('ExportAllHandler is not exporting - idpId is not set!');
        return;
      }

      var url = (0, _Api.buildUrl)('/student-idps/' + idpId + '/printing?' + ('languageCode=' + (this.state.choosedLanguageCode || _Languages2.default.defaultLanguageCode)));

      _Exporter.exporter.get(url, EXPORT_FILENAME, false, EXPORT_MIME_TYPE).then(function () {
        _this2._close();
      }).catch(function () {
        _this2.setState({ isExportErrorOccurred: true });
      });

      this.setState({ isExportRequested: true });
    }
  }, {
    key: '_onLanguageChanged',
    value: function _onLanguageChanged(languageCode) {
      this.setState({ choosedLanguageCode: languageCode });
    }
  }, {
    key: '_isChecked',
    value: function _isChecked(languageCode) {
      return languageCode === this.state.choosedLanguageCode;
    }
  }, {
    key: '_isDefaultLanguage',
    value: function _isDefaultLanguage() {
      if (!this.props.languageCode) return true;
      return _Languages2.default.defaultLanguageCode === this.props.languageCode;
    }
  }, {
    key: '_renderLanguageRadio',
    value: function _renderLanguageRadio() {
      return _react2.default.createElement(_LanguageRadio2.default, { name: 'language-picker',
        languageCode: this.props.languageCode,
        onChecked: this._onLanguageChanged,
        choosedLanguageCode: this.state.choosedLanguageCode });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (this.state.isExportErrorOccurred) {
        return _react2.default.createElement(_omniCommonUi.ErrorDialog, { isOpen: true,
          onConfirmClick: function onConfirmClick() {
            _this3._close();
          } });
      }

      if (!this._isDefaultLanguage()) {
        return _react2.default.createElement(
          _omniCommonUi.ConfirmDialog,
          { isOpen: true,
            isLoading: this.state.isExportRequested,
            title: 'Choose Language:',
            primaryButtonContent: 'Export',
            secondaryButtonContent: 'Cancel',
            onPrimaryClick: function onPrimaryClick() {
              return _this3._performExport();
            },
            onSecondaryClick: function onSecondaryClick() {
              return _this3._close();
            },
            onRequestClose: function onRequestClose() {
              return _this3._close();
            } },
          _react2.default.createElement(
            'div',
            { className: _style2.default.ExportAllHandler_feedback_content },
            _react2.default.createElement(
              'div',
              { className: _style2.default.ExportAllHandler_feedback_languageRadio },
              this._renderLanguageRadio()
            )
          )
        );
      }
      // the export starts automatically!
      !this.state.isExportRequested && this._performExport();
      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: true,
          isLoading: true,
          isButtonless: true,
          title: 'Exporting reports, please wait' },
        _react2.default.createElement('div', { className: _style2.default.ExportAllHandler_feedback_exportingImmediately })
      );
    }
  }]);

  return ExportDialog;
}(_react.Component);

ExportDialog.propTypes = {
  idpId: _propTypes2.default.string.isRequired,
  languageCode: _propTypes2.default.string.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  reportName: _propTypes2.default.string.isRequired
};

exports.default = ExportDialog;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1834);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".V5bDeZbjFWh3CWmYxIc7p{min-height:4.57143rem}.d2RS5lyrAjoIX_IqpFgso{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.d2RS5lyrAjoIX_IqpFgso>p+p{margin-top:0}._2Gk-VrcMHhlcJuRkhXVg5x{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:initial}._2Gk-VrcMHhlcJuRkhXVg5x>*{margin-top:1.07143rem}._221EY5RAfH0VrGRIwW75gR{border-top:.07143rem solid #ccc;display:block;margin:.35714rem 0;width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ExportAllHandler_feedback_exportingImmediately": "V5bDeZbjFWh3CWmYxIc7p",
	"ExportAllHandler_feedback_content": "d2RS5lyrAjoIX_IqpFgso",
	"ExportAllHandler_feedback_languageRadio": "_2Gk-VrcMHhlcJuRkhXVg5x",
	"ExportAllHandler_feedback_divider": "_221EY5RAfH0VrGRIwW75gR"
};

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(785);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(786);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _component2.default;
var routes = exports.routes = _routes3.default;

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1837);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2CPbPOKq18i1s3YWtAVBOr{padding-left:.35714rem}@media only screen and (min-width:640px){._2CPbPOKq18i1s3YWtAVBOr{padding-left:1.07143rem}}._2VdQ-mJVfsL53kYEmZlPik{padding-left:0;padding-right:0}.JNoKHBzQKTiuWj6IGPeqm{padding:0 1.42857rem}@media only screen and (min-width:640px){.JNoKHBzQKTiuWj6IGPeqm{padding:0 2.14286rem}}.VRcK6bCNdhF7PrO0XwyKf{margin-top:1.42857rem;padding:0 1.42857rem;padding-bottom:1.42857rem}@media only screen and (min-width:640px){.VRcK6bCNdhF7PrO0XwyKf{padding:0 2.14286rem;padding-bottom:1.42857rem}}.VRcK6bCNdhF7PrO0XwyKf ._1JZQBJiq0shyYTQEqWm55U{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:.92857rem;font-weight:400;letter-spacing:.03571rem;line-height:1.15385;color:#a4a4a4;margin-bottom:.71429rem}.VRcK6bCNdhF7PrO0XwyKf ._1JZQBJiq0shyYTQEqWm55U._3EvoDISGayJJ1M79U9pJJr{color:#4a4a4a}._199b2joiZ1jtjnxdIP77Kb{border-top:.07143rem solid #ccc;padding:1.42857rem}@media only screen and (min-width:640px){._199b2joiZ1jtjnxdIP77Kb{padding:1.42857rem 2.14286rem}}._199b2joiZ1jtjnxdIP77Kb ._2umlabijgoCJWq-pOmaKKC{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:.92857rem;font-weight:400;letter-spacing:.03571rem;line-height:1.15385;color:#a4a4a4;margin-bottom:.71429rem}._199b2joiZ1jtjnxdIP77Kb ._2umlabijgoCJWq-pOmaKKC._3EvoDISGayJJ1M79U9pJJr{color:#4a4a4a}._3Zh3KTRpjY_44idlNrDz8n{padding:.71429rem 1.42857rem 0}@media only screen and (min-width:640px){._3Zh3KTRpjY_44idlNrDz8n{padding:.71429rem 2.14286rem 0}}._3YxbUHNJpeYkTAEek5NNtV{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:600;letter-spacing:.03571rem;line-height:1.28571;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;color:inherit;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;line-height:1.71429;outline:0;text-decoration:none;text-transform:uppercase}._29pAfAJxU_BQi0gWQ0vckI{margin-left:.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"IndividualDevelopmentPlanApprovalView_pageHeading": "_2CPbPOKq18i1s3YWtAVBOr",
	"IndividualDevelopmentPlanApprovalView_pageContent": "_2VdQ-mJVfsL53kYEmZlPik",
	"IndividualDevelopmentPlanApprovalView_userInfo": "JNoKHBzQKTiuWj6IGPeqm",
	"IndividualDevelopmentPlanApprovalView_overall": "VRcK6bCNdhF7PrO0XwyKf",
	"_overallTitle": "_1JZQBJiq0shyYTQEqWm55U",
	"__noGray": "_3EvoDISGayJJ1M79U9pJJr",
	"IndividualDevelopmentPlanApprovalView_suggestionCard": "_199b2joiZ1jtjnxdIP77Kb",
	"_suggestionTitle": "_2umlabijgoCJWq-pOmaKKC",
	"IndividualDevelopmentPlanApprovalView_bottomButtons": "_3Zh3KTRpjY_44idlNrDz8n",
	"IndividualDevelopmentPlanApprovalViewLink": "_3YxbUHNJpeYkTAEek5NNtV",
	"IndividualDevelopmentPlanApprovalViewLink_icon": "_29pAfAJxU_BQi0gWQ0vckI"
};

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserInfo = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1839);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _omniCommonUi = __webpack_require__(0);

var _Users = __webpack_require__(82);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserInfo = exports.UserInfo = function (_Component) {
  _inherits(UserInfo, _Component);

  function UserInfo() {
    _classCallCheck(this, UserInfo);

    return _possibleConstructorReturn(this, (UserInfo.__proto__ || Object.getPrototypeOf(UserInfo)).apply(this, arguments));
  }

  _createClass(UserInfo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setUp(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this._setUp(props);
    }
  }, {
    key: '_setUp',
    value: function _setUp(props) {
      if (_is_js2.default.not.empty(props.id)) {
        props.fetchUserIfNeeded(props.id);
      }
    }
  }, {
    key: '_renderDate',
    value: function _renderDate(dateStr) {
      if (_is_js2.default.existy(dateStr)) {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.UserInfo_date },
          dateStr
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          dateStr = _props.dateStr;

      if (!user) return null;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(this.props.className) },
        _react2.default.createElement(
          'div',
          { className: _style2.default.UserInfo_name },
          user.firstName + ' ' + user.lastName + '\'s Comment'
        ),
        this._renderDate(dateStr)
      );
    }
  }]);

  return UserInfo;
}(_react.Component);

UserInfo.propTypes = {
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  fetchUserIfNeeded: _propTypes2.default.func,
  isLoading: _propTypes2.default.bool,
  user: _propTypes2.default.shape(),
  dateStr: _propTypes2.default.string
};

function mapStateToProps(state, ownProps) {
  return {
    user: _Users.accessors.getUserByUserId(state, ownProps.id)
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_Users.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(UserInfo);

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1840);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".ja2mtYiPENZSgpHY_ePff{font-size:.92857rem;line-height:1.15385;color:#a4a4a4;line-height:1.53846}._1P8rggMK3YwhiLNbFs08_n,.ja2mtYiPENZSgpHY_ePff{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-weight:400;letter-spacing:.03571rem}._1P8rggMK3YwhiLNbFs08_n{font-size:1rem;line-height:1.07143;line-height:1.42857}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"UserInfo_date": "ja2mtYiPENZSgpHY_ePff",
	"UserInfo_name": "_1P8rggMK3YwhiLNbFs08_n"
};

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CoreAndCatchUpListView = exports.routes = undefined;

var _routes2 = __webpack_require__(1842);

var _routes3 = _interopRequireDefault(_routes2);

var _component = __webpack_require__(788);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
var CoreAndCatchUpListView = exports.CoreAndCatchUpListView = _component2.default;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(788);

var _component2 = _interopRequireDefault(_component);

var _routes = __webpack_require__(216);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return {
    path: '' + _routes.TABS[_routes.LESSON_CATEGORY.CORE_CATCH_UP],
    component: _component2.default
  };
};

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1844);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1SdDy9Tiayw73YJa4T3mYw{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-decoration:none;width:100%}._2M7CHM4QR9rY5DAwEYVlHr{color:#4a4a4a;margin-bottom:.35714rem;white-space:nowrap}.FqhvakYPpT3rWBnKNTbhx{color:#fff;font-size:.85714rem;letter-spacing:.07143rem;padding:0 .35714rem;text-decoration:none;text-transform:uppercase;white-space:nowrap}.FqhvakYPpT3rWBnKNTbhx:hover{color:#fff}._3PtJdEOtFnO3G-I8vUBcp9{background-color:#74d17f}._3Wa1wAOhSHRAhhs2YjkUFm{background-color:#f7932d}._3O-3QpEHHIPnyJ5UCKLV-4{background-color:#a4a4a4}._1htshbEre9h1QngpXxEzEf{white-space:nowrap}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"cell": "_1SdDy9Tiayw73YJa4T3mYw",
	"cell_label": "_2M7CHM4QR9rY5DAwEYVlHr",
	"cell_status": "FqhvakYPpT3rWBnKNTbhx",
	"cell_status_new": "_3PtJdEOtFnO3G-I8vUBcp9",
	"cell_status_inprogress": "_3Wa1wAOhSHRAhhs2YjkUFm",
	"cell_status_complete": "_3O-3QpEHHIPnyJ5UCKLV-4",
	"header": "_1htshbEre9h1QngpXxEzEf"
};

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _model = __webpack_require__(330);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1846);

var _create2 = _interopRequireDefault(_create);

var _actions2 = __webpack_require__(791);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1848);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(330);

var _model2 = _interopRequireDefault(_model);

var _Activity = __webpack_require__(789);

var _Activity2 = _interopRequireDefault(_Activity);

var _immutable = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  switch (key) {
    case 'studentActivities':
      return [key, val.reduce(function (map, item) {
        return map.set('' + item.studentId, _Activity2.default.create(item));
      }, (0, _immutable.Map)())];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(790);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  switch (key) {
    case 'studentId':
    case 'activityId':
      return [key, '' + val];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SpinReducer;

var _actions = __webpack_require__(791);

var _model = __webpack_require__(330);

var _model2 = _interopRequireDefault(_model);

var _immutable = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SpinReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_SPIN_WRITING_ASSIGNMENT_SUCCESS:
      return state.set('' + action.groupId, onSuccess(action.payload));
    default:
      return state;
  }
}

function onSuccess(response) {
  return response.reduce(function (list, item) {
    return list.push(_model2.default.create(item));
  }, new _immutable.List());
}

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _model = __webpack_require__(331);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1850);

var _create2 = _interopRequireDefault(_create);

var _actions2 = __webpack_require__(792);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1851);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;
var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(331);

var _model2 = _interopRequireDefault(_model);

var _Activity = __webpack_require__(789);

var _Activity2 = _interopRequireDefault(_Activity);

var _immutable = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  switch (key) {
    case 'unitNo':
    case 'lessonNo':
      return [key, '' + val];
    case 'studentActivities':
      return [key, val.reduce(function (map, item) {
        return map.set('' + item.studentId, _Activity2.default.create(item));
      }, (0, _immutable.Map)())];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CoreAndCatchUpReducer;

var _actions = __webpack_require__(792);

var _model = __webpack_require__(331);

var _model2 = _interopRequireDefault(_model);

var _immutable = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CoreAndCatchUpReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_CORE_WRITING_ASSIGNMENT_SUCCESS:
      return state.set('' + action.groupId, onFetchCoreAndCatchUpSuccess(action.payload));
    default:
      return state;
  }
}

function onFetchCoreAndCatchUpSuccess(response) {
  return response.reduce(function (list, item) {
    return list.push(_model2.default.create(item));
  }, new _immutable.List());
}

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Essay = exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(793);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1853);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(794);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;
var Essay = exports.Essay = _model2.default;

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WritingAssignmentActivityReducer;

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(794);

var _model2 = _interopRequireDefault(_model);

var _actions = __webpack_require__(793);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WritingAssignmentActivityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_ESSAY_SUCCESS:
      return onFetchEssaySuccess(state, action);
    default:
      return state;
  }
}

function onFetchEssaySuccess(state, action) {
  var id = action.id,
      studentId = action.studentId,
      payload = action.payload;

  return state.set(id + '-' + studentId, new _model2.default(payload));
}

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _actions2 = __webpack_require__(795);

var _actions = _interopRequireWildcard(_actions2);

var _reducer2 = __webpack_require__(1855);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = exports.actions = _actions;
var reducer = exports.reducer = _reducer3.default;

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WritingAssignmentActivityReducer;

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(1856);

var _model2 = _interopRequireDefault(_model);

var _actions = __webpack_require__(795);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WritingAssignmentActivityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_SHORT_ANSWER_SUCCESS:
      return onFetchSuccess(state, action);
    default:
      return state;
  }
}

function onFetchSuccess(state, action) {
  var activityId = action.activityId,
      studentId = action.studentId,
      payload = action.payload;

  return state.set(activityId + '-' + studentId, _model2.default.create(payload));
}

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(796);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1857);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(796);

var _model2 = _interopRequireDefault(_model);

var _Item = __webpack_require__(1858);

var _Item2 = _interopRequireDefault(_Item);

var _immutable = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  switch (key) {
    case 'shortAnswers':
      {
        if (Array.isArray(val)) {
          return [key, val.reduce(function (list, item) {
            return list.push(_Item2.default.create(item));
          }, new _immutable.List())];
        }
        return [key, []];
      }
    case 'comment':
      {
        if (val) {
          return [key, val];
        }
        return [key, ''];
      }
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(797);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1859);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(797);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  switch (key) {
    case 'questionNo':
      return [key, '' + val];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishWritingAssignmment = exports.PUBLISH_WRITING_ASSIGNMENT_FAILURE = exports.PUBLISH_WRITING_ASSIGNMENT_SUCCESS = exports.PUBLISH_WRITING_ASSIGNMENT_REQUEST = undefined;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var ACTION_OBJECT_NAME = 'WRITING_ASSIGNMENT';
var PUBLISH_WRITING_ASSIGNMENT_REQUEST = exports.PUBLISH_WRITING_ASSIGNMENT_REQUEST = 'PUBLISH_' + ACTION_OBJECT_NAME + '_REQUEST';
var PUBLISH_WRITING_ASSIGNMENT_SUCCESS = exports.PUBLISH_WRITING_ASSIGNMENT_SUCCESS = 'PUBLISH_' + ACTION_OBJECT_NAME + '_SUCCESS';
var PUBLISH_WRITING_ASSIGNMENT_FAILURE = exports.PUBLISH_WRITING_ASSIGNMENT_FAILURE = 'PUBLISH_' + ACTION_OBJECT_NAME + '_FAILURE';

var publishWritingAssignmment = exports.publishWritingAssignmment = function publishWritingAssignmment(id, payload) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/writing-assignment-activities/' + id + '/publish');
    var method = 'POST';
    return dispatch(publishWritingAssignmmentRequest()).payload.then(function (response) {
      return dispatch(publishWritingAssignmmentSuccess(response));
    }).catch(function (error) {
      return dispatch(publishWritingAssignmmentFailure(error));
    });

    function publishWritingAssignmmentRequest() {
      var request = (0, _Api.fetch)(url, {
        method: method,
        body: JSON.stringify(payload)
      });
      return _omniCommonUi.ApiCall.createAction({
        type: PUBLISH_WRITING_ASSIGNMENT_REQUEST,
        payload: request,
        url: url,
        method: method
      });
    }

    function publishWritingAssignmmentSuccess() {
      return _omniCommonUi.ApiCall.createAction({
        type: PUBLISH_WRITING_ASSIGNMENT_SUCCESS,
        url: url,
        method: method
      });
    }

    function publishWritingAssignmmentFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: PUBLISH_WRITING_ASSIGNMENT_FAILURE,
        url: url,
        method: method,
        error: error
      });
    }
  };
};

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitWritingAssignmmentComment = exports.SUBMIT_WRITING_ASSIGNMENT_COMMENT_FAILURE = exports.SUBMIT_WRITING_ASSIGNMENT_COMMENT_SUCCESS = exports.SUBMIT_WRITING_ASSIGNMENT_COMMENT_REQUEST = undefined;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var ACTION_OBJECT_NAME = 'WRITING_ASSIGNMENT_COMMENT';
var SUBMIT_WRITING_ASSIGNMENT_COMMENT_REQUEST = exports.SUBMIT_WRITING_ASSIGNMENT_COMMENT_REQUEST = 'SUBMIT_' + ACTION_OBJECT_NAME + '_REQUEST';
var SUBMIT_WRITING_ASSIGNMENT_COMMENT_SUCCESS = exports.SUBMIT_WRITING_ASSIGNMENT_COMMENT_SUCCESS = 'SUBMIT_' + ACTION_OBJECT_NAME + '_SUCCESS';
var SUBMIT_WRITING_ASSIGNMENT_COMMENT_FAILURE = exports.SUBMIT_WRITING_ASSIGNMENT_COMMENT_FAILURE = 'SUBMIT_' + ACTION_OBJECT_NAME + '_FAILURE';

var submitWritingAssignmmentComment = exports.submitWritingAssignmmentComment = function submitWritingAssignmmentComment(id, payload) {
  return function (dispatch) {
    var url = (0, _Api.buildUrl)('/writing-assignment-activities/' + id + '/essay-remarks');
    var method = 'PUT';
    return dispatch(submitWritingAssignmmentCommentRequest()).payload.then(function (response) {
      return dispatch(submitWritingAssignmmentCommentSuccess(response));
    }).catch(function (error) {
      return dispatch(submitWritingAssignmmentCommentFailure(error));
    });

    function submitWritingAssignmmentCommentRequest() {
      var request = (0, _Api.fetch)(url, {
        method: method,
        body: JSON.stringify(payload)
      });
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_WRITING_ASSIGNMENT_COMMENT_REQUEST,
        payload: request,
        url: url,
        method: method
      });
    }

    function submitWritingAssignmmentCommentSuccess() {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_WRITING_ASSIGNMENT_COMMENT_SUCCESS,
        url: url,
        method: method
      });
    }

    function submitWritingAssignmmentCommentFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: SUBMIT_WRITING_ASSIGNMENT_COMMENT_FAILURE,
        url: url,
        method: method,
        error: error
      });
    }
  };
};

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCategory = formatCategory;
exports.formatActivityType = formatActivityType;
exports.getCoreWritingAssignment = getCoreWritingAssignment;
exports.getSPINWritingAssignment = getSPINWritingAssignment;
exports.getCoreWritingAssignmentLessons = getCoreWritingAssignmentLessons;
exports.getCoreActivityByLessonAndStudentId = getCoreActivityByLessonAndStudentId;
exports.getSpinActivityByActivityIdAndStudentId = getSpinActivityByActivityIdAndStudentId;
exports.getStudentActivityByLessonCategory = getStudentActivityByLessonCategory;
exports.getLessonCategory = getLessonCategory;
exports.getWritingAssignmentByActivityType = getWritingAssignmentByActivityType;
exports.isShortAnswer = isShortAnswer;
exports.isEssay = isEssay;
exports.canPublish = canPublish;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _WritingAssignment = __webpack_require__(787);

var _status = __webpack_require__(798);

var _status2 = _interopRequireDefault(_status);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHORT_ANSWER = 'shortAnswer';
var ESSAY = 'essay';

function formatCategory(category) {
  if (('' + category).toLowerCase() === 'catchup') {
    return 'Catch up';
  }
  return category;
}

function formatActivityType(activityType) {
  if (isShortAnswer(activityType)) {
    return 'Short Answer';
  }
  return activityType;
}

function getCoreWritingAssignment(state, groupId) {
  var coreWritingAssignment = state.get('rootReducer').get('coreWritingAssignment');
  var coreWritingAssignmentList = coreWritingAssignment && coreWritingAssignment.get('' + groupId);
  return coreWritingAssignmentList;
}

function getSPINWritingAssignment(state, groupId) {
  var spinWritingAssignment = state.get('rootReducer').get('spinWritingAssignment');
  var spinWritingAssignmentList = spinWritingAssignment && spinWritingAssignment.get('' + groupId);
  return spinWritingAssignmentList;
}

function getCoreWritingAssignmentLessons(state, groupId) {
  var overview = getCoreWritingAssignment(state, groupId);
  if (_is_js2.default.existy(overview)) {
    return overview.map(function (val, key) {
      return {
        lessonNo: val.lessonNo,
        unitNo: val.unitNo,
        seq: key
      };
    });
  }
}

function getCoreActivityByLessonAndStudentId(state, groupId, lessonSeq, studentId) {
  var overview = getCoreWritingAssignment(state, groupId);
  if (_is_js2.default.existy(overview)) {
    var activity = overview.get(lessonSeq).get('studentActivities').find(function (val) {
      return val.studentId === studentId;
    });
    return activity;
  }
}

function getSpinActivityByActivityIdAndStudentId(state, groupId, activityId, studentId) {
  var overview = getSPINWritingAssignment(state, groupId);
  if (_is_js2.default.existy(overview)) {
    var allStudentActivities = overview.reduce(function (result, exam) {
      return result.concat(exam.studentActivities.toList());
    }, new _immutable.List());
    var activity = allStudentActivities.find(function (val) {
      return val.studentId === studentId && val.activityId === activityId;
    });
    return activity;
  }
}

function getStudentActivityByLessonCategory(state, groupId, _ref, studentId) {
  var lessonSeq = _ref.lessonSeq,
      activityId = _ref.activityId;

  var lessonCategory = getLessonCategory({ lessonSeq: lessonSeq, activityId: activityId });
  switch (lessonCategory) {
    case _WritingAssignment.LESSON_CATEGORY.CORE_CATCH_UP:
      return getCoreActivityByLessonAndStudentId(state, groupId, lessonSeq, studentId);
    case _WritingAssignment.LESSON_CATEGORY.SPIN:
      return getSpinActivityByActivityIdAndStudentId(state, groupId, activityId, studentId);
    default:
      break;
  }
}

function getLessonCategory(_ref2) {
  var lessonSeq = _ref2.lessonSeq,
      activityId = _ref2.activityId;

  if (_is_js2.default.not.undefined(lessonSeq) && _is_js2.default.undefined(activityId)) return _WritingAssignment.LESSON_CATEGORY.CORE_CATCH_UP;
  if (_is_js2.default.undefined(lessonSeq) && _is_js2.default.not.undefined(activityId)) return _WritingAssignment.LESSON_CATEGORY.SPIN;
}

function getWritingAssignmentByActivityType(state, activityType, activityId, studentId) {
  var type = getActivityType(activityType);
  if (type.length > 0) {
    return state.get('rootReducer').get(type) && state.get('rootReducer').get(type).get(activityId + '-' + studentId);
  }
}

function isShortAnswer(activityType) {
  return _is_js2.default.string(activityType) && activityType.toLowerCase() === SHORT_ANSWER.toLowerCase();
}

function isEssay(activityType) {
  return _is_js2.default.string(activityType) && activityType.toLowerCase() === ESSAY.toLowerCase();
}

function getActivityType(activityType) {
  if (_is_js2.default.string(activityType)) {
    return [ESSAY, SHORT_ANSWER].reduce(function (accumulator, currentValue) {
      var current = currentValue.toLowerCase() === activityType.toLowerCase() ? currentValue : '';
      return accumulator + current;
    }, '');
  }
  return '';
}

function isShortAnswersChecked(shortAnswers) {
  if (!shortAnswers) return true;
  return shortAnswers.every(function (_ref3) {
    var isCorrect = _ref3.isCorrect;
    return _is_js2.default.boolean(isCorrect);
  });
}

function hasComment(comment, isShortAnswerFromParam) {
  return isShortAnswerFromParam || _is_js2.default.string(comment);
}

function canPublish(writingAssignment, isShortAnswerFromParam) {
  if (!writingAssignment) return false;
  var comment = writingAssignment.comment,
      status = writingAssignment.status,
      shortAnswers = writingAssignment.shortAnswers;

  if (hasComment(comment, isShortAnswerFromParam) && status === _status2.default.INPROGRESS && isShortAnswersChecked(shortAnswers)) {
    return true;
  }
  return false;
}

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _routes2 = __webpack_require__(1864);

var _routes3 = _interopRequireDefault(_routes2);

var _component = __webpack_require__(799);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
exports.default = _component2.default;

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(799);

var _component2 = _interopRequireDefault(_component);

var _routes = __webpack_require__(216);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return {
    path: '' + _routes.TABS[_routes.LESSON_CATEGORY.SPIN],
    component: _component2.default
  };
};

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1866);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2tkMhffbFx1KhmJpJXm0Mw{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-decoration:none;width:100%}._3n_maJhkVFUbMRUnOnMh53{color:#4a4a4a;margin-bottom:.35714rem;white-space:nowrap}._2Y9u3fQIbGAGVrxIBTtVu_{color:#fff;font-size:.85714rem;letter-spacing:.07143rem;padding:0 .35714rem;text-decoration:none;text-transform:uppercase;white-space:nowrap}._2Y9u3fQIbGAGVrxIBTtVu_:hover{color:#fff}._2vHTKHJKKFtA58cmmdFyjM{background-color:#74d17f}.Iwe1ANbXkRvPx0uNhPdcM{background-color:#f7932d}._22N-1if6DBPXNyfxeffAEV{background-color:#a4a4a4}._21HDSvPWnB_r3WCOuI-r8G{white-space:nowrap}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"cell": "_2tkMhffbFx1KhmJpJXm0Mw",
	"cell_label": "_3n_maJhkVFUbMRUnOnMh53",
	"cell_status": "_2Y9u3fQIbGAGVrxIBTtVu_",
	"cell_status_new": "_2vHTKHJKKFtA58cmmdFyjM",
	"cell_status_inprogress": "Iwe1ANbXkRvPx0uNhPdcM",
	"cell_status_complete": "_22N-1if6DBPXNyfxeffAEV",
	"header": "_21HDSvPWnB_r3WCOuI-r8G"
};

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spinWritingAssignment = exports.coreCatchUpWritingAssignment = undefined;

var _component = __webpack_require__(800);

var _component2 = _interopRequireDefault(_component);

var _routes = __webpack_require__(801);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var coreCatchUpWritingAssignment = exports.coreCatchUpWritingAssignment = _routes.coreCatchUpWritingAssignment;
var spinWritingAssignment = exports.spinWritingAssignment = _routes.spinWritingAssignment;

exports.default = _component2.default;

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1869);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".z7Cs7CKloiqQ6xQxHs-Ku{line-height:1.78571rem;white-space:pre-line}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"TextEditor_content": "z7Cs7CKloiqQ6xQxHs-Ku"
};

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1871);

var _style2 = _interopRequireDefault(_style);

var _classnames4 = __webpack_require__(7);

var _classnames5 = _interopRequireDefault(_classnames4);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _AddInternalNoteControl = __webpack_require__(67);

var _AddInternalNoteControl2 = _interopRequireDefault(_AddInternalNoteControl);

var _CardActionIcons = __webpack_require__(85);

var _CardActionIcons2 = _interopRequireDefault(_CardActionIcons);

var _UserCard = __webpack_require__(65);

var _UserCard2 = _interopRequireDefault(_UserCard);

var _WritingAssignment = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var COMPLETED = 'CO';
var YES = 'YES';
var NO = 'NO';

var IndividualCard = function (_PureComponent) {
  _inherits(IndividualCard, _PureComponent);

  function IndividualCard() {
    _classCallCheck(this, IndividualCard);

    return _possibleConstructorReturn(this, (IndividualCard.__proto__ || Object.getPrototypeOf(IndividualCard)).apply(this, arguments));
  }

  _createClass(IndividualCard, [{
    key: '_onExpansionButtonClick',
    value: function _onExpansionButtonClick() {
      var isExpand = this.state.isExpand;

      this.setState({
        isExpand: !isExpand
      });
    }
  }, {
    key: '_onEdit',
    value: function _onEdit() {
      this.setState({
        isExpand: true
      });
      this.props.onEdit();
    }
  }, {
    key: '_isCompleted',
    value: function _isCompleted(status) {
      return status === COMPLETED;
    }
  }, {
    key: '_renderEssayHeader',
    value: function _renderEssayHeader() {
      var _this2 = this;

      var _props = this.props,
          writing = _props.writing,
          isEdit = _props.isEdit,
          type = _props.type,
          canEdit = _props.canEdit;
      var name = writing.name,
          status = writing.status;

      var headerInstruction = name + ', ' + type;
      return _react2.default.createElement(
        'div',
        { className: _style2.default.TextEditor_essay_header },
        _react2.default.createElement(
          'h1',
          { className: _style2.default.TextEditor_essay_header_title },
          headerInstruction
        ),
        isEdit || this._isCompleted(status) || !canEdit ? null : _react2.default.createElement(_CardActionIcons2.default, { onEditClick: function onEditClick() {
            return _this2._onEdit();
          },
          hideDeleteIcon: true })
      );
    }
  }, {
    key: '_renderEssay',
    value: function _renderEssay() {
      var _props2 = this.props,
          writing = _props2.writing,
          isEdit = _props2.isEdit;

      var className = (0, _classnames5.default)(_defineProperty({}, _style2.default.TextEditor_essay_scrollable, isEdit));
      return _react2.default.createElement(
        'div',
        { className: _style2.default.TextEditor_essay },
        _react2.default.createElement('p', { className: className
          // eslint-disable-next-line react/no-danger
          , dangerouslySetInnerHTML: this._createMarkUp(writing.essay) })
      );
    }
  }, {
    key: '_renderOption',
    value: function _renderOption(questionNo, checked, type) {
      var _classnames2,
          _this3 = this;

      var isEdit = this.props.isEdit;

      var bgClass = (0, _classnames5.default)(_style2.default.TextEditor_shortAnswer_row_options_radio, (_classnames2 = {}, _defineProperty(_classnames2, _style2.default.__correctSelectBG, checked && type === YES), _defineProperty(_classnames2, _style2.default.__inCorrectSelectBG, checked && type === NO), _defineProperty(_classnames2, _style2.default.__disable, !isEdit), _classnames2));
      var iconClass = (0, _classnames5.default)(_style2.default.__icon, _defineProperty({}, _style2.default.__disable, !isEdit));
      return _react2.default.createElement(
        'div',
        { className: bgClass,
          onClick: function onClick() {
            return isEdit && _this3._onShortAnswersUpdate(questionNo, type === YES);
          } },
        type === YES ? _react2.default.createElement(_omniCommonUi.Icon, { id: 'tick', className: iconClass }) : _react2.default.createElement(_omniCommonUi.Icon, { id: 'cross', className: iconClass })
      );
    }
  }, {
    key: '_renderShortAnswer',
    value: function _renderShortAnswer() {
      var _this4 = this;

      var _props3 = this.props,
          isEdit = _props3.isEdit,
          writing = _props3.writing,
          shortAnswers = _props3.shortAnswers;

      var shortAnswerList = isEdit ? shortAnswers : writing.shortAnswers;

      if (shortAnswerList && shortAnswerList.size > 0) {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.TextEditor_shortAnswer },
          _react2.default.createElement(
            'div',
            { className: (0, _classnames5.default)(_style2.default.TextEditor_shortAnswer_row, _style2.default.TextEditor_shortAnswer_row_header) },
            _react2.default.createElement(
              'div',
              { className: _style2.default.TextEditor_shortAnswer_row_content },
              _react2.default.createElement(
                'h4',
                null,
                'Short Answers'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default.TextEditor_shortAnswer_row_content },
              _react2.default.createElement(
                'h4',
                null,
                'Result'
              )
            )
          ),
          shortAnswerList.map(function (item) {
            return _react2.default.createElement(
              'div',
              { className: _style2.default.TextEditor_shortAnswer_row },
              _react2.default.createElement(
                'div',
                { className: _style2.default.TextEditor_shortAnswer_row_content },
                _react2.default.createElement('h4', { className: _style2.default.TextEditor_shortAnswer_row_question
                  // eslint-disable-next-line react/no-danger
                  , dangerouslySetInnerHTML: _this4._createMarkUp('Q' + item.questionNo + ': ' + item.question) }),
                _react2.default.createElement(
                  'div',
                  { className: _style2.default.TextEditor_shortAnswer_row_answer },
                  item.studentAnswer
                )
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.TextEditor_shortAnswer_row_options },
                _this4._renderOption(item.questionNo, _is_js2.default.boolean(item.isCorrect) && item.isCorrect, YES),
                _this4._renderOption(item.questionNo, _is_js2.default.boolean(item.isCorrect) && !item.isCorrect, NO)
              )
            );
          })
        );
      }
      return null;
    }
  }, {
    key: '_renderComment',
    value: function _renderComment(isShortAnswer) {
      if (this.props.isEdit) {
        return this._renderCommentForm(isShortAnswer);
      }
      return isShortAnswer ? null : this._renderCommentView();
    }
  }, {
    key: '_onShortAnswersUpdate',
    value: function _onShortAnswersUpdate(questionNo, isCorrect) {
      var _props4 = this.props,
          shortAnswers = _props4.shortAnswers,
          isEdit = _props4.isEdit;

      if (!isEdit) return false;
      var result = shortAnswers.map(function (shortAnswer) {
        if (shortAnswer.questionNo === questionNo) {
          return shortAnswer.set('isCorrect', isCorrect);
        }
        return shortAnswer;
      });
      this.props.onShortAnswersUpdate(result);
    }
  }, {
    key: '_createMarkUp',
    value: function _createMarkUp(html) {
      return {
        __html: html
      };
    }
  }, {
    key: '_isSaveButtonDisable',
    value: function _isSaveButtonDisable(type, comment, shortAnswers) {
      if (comment && _is_js2.default.string(comment) && comment.trim()) {
        return false;
      }
      if (_WritingAssignment.accessors.isShortAnswer(type) && shortAnswers && shortAnswers.some(function (_ref) {
        var isCorrect = _ref.isCorrect;
        return _is_js2.default.boolean(isCorrect);
      })) {
        return false;
      }
      return true;
    }
  }, {
    key: '_renderCommentForm',
    value: function _renderCommentForm(isShortAnswer) {
      var _props5 = this.props,
          onSaveComment = _props5.onSaveComment,
          onDiscardComment = _props5.onDiscardComment,
          comment = _props5.comment,
          shortAnswers = _props5.shortAnswers,
          onCommentUpdate = _props5.onCommentUpdate,
          type = _props5.type;

      this._isSaveButtonDisable = this._isSaveButtonDisable.bind(this);
      if (isShortAnswer) {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.TextEditor_comment },
          _react2.default.createElement(
            _omniCommonUi.Button.Container,
            { align: 'right' },
            _react2.default.createElement(
              _omniCommonUi.Button,
              { type: _omniCommonUi.Button.Type.primary,
                disabled: this._isSaveButtonDisable(type, comment, shortAnswers),
                onClick: function onClick() {
                  return onSaveComment();
                } },
              'SAVE'
            ),
            _react2.default.createElement(
              _omniCommonUi.Button,
              { type: _omniCommonUi.Button.Type.default,
                onClick: onDiscardComment },
              'DISCARD'
            )
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: _style2.default.TextEditor_comment },
        _react2.default.createElement(
          'h4',
          null,
          'Teacher\'s feedback'
        ),
        _react2.default.createElement(_AddInternalNoteControl2.default, { text: comment,
          noAutoScroll: _WritingAssignment.accessors.isShortAnswer(type),
          maxCharacters: 2000,
          onChange: function onChange(text) {
            return onCommentUpdate(text);
          } }),
        _react2.default.createElement(
          _omniCommonUi.Button.Container,
          { align: 'right' },
          _react2.default.createElement(
            _omniCommonUi.Button,
            { type: _omniCommonUi.Button.Type.primary,
              disabled: this._isSaveButtonDisable(type, comment, shortAnswers),
              onClick: function onClick() {
                return onSaveComment();
              } },
            'SAVE'
          ),
          _react2.default.createElement(
            _omniCommonUi.Button,
            { type: _omniCommonUi.Button.Type.default,
              onClick: onDiscardComment },
            'DISCARD'
          )
        )
      );
    }
  }, {
    key: '_renderCommentView',
    value: function _renderCommentView() {
      var _props$writing = this.props.writing,
          comment = _props$writing.comment,
          commentBy = _props$writing.commentBy,
          commentDate = _props$writing.commentDate;

      if (_is_js2.default.existy(comment) && comment.length > 0) {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.TextEditor_comment },
          _react2.default.createElement(_UserCard2.default, { id: '' + commentBy,
            dateStr: this._transformDate(commentDate) }),
          _react2.default.createElement(
            'p',
            null,
            comment
          )
        );
      }
      return null;
    }
  }, {
    key: '_transformDate',
    value: function _transformDate(date) {
      if (!date) return '';
      return _omniCommonUi.moment.utc(date).clone().tz(this.props.timeZone).format('YYYY-MM-DD');
    }
  }, {
    key: '_renderSubmitDate',
    value: function _renderSubmitDate(writing) {
      return _react2.default.createElement(
        'aside',
        { className: _style2.default.TextEditor_date },
        'Submitted on ',
        this._transformDate(writing.submitDate)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          writing = _props6.writing,
          type = _props6.type;

      if (_is_js2.default.existy(writing)) {
        return _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(
            _omniCommonUi.PageCard.Heading,
            null,
            this._renderEssayHeader()
          ),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.TextEditor_content_container },
            _WritingAssignment.accessors.isShortAnswer(type) ? this._renderShortAnswer() : this._renderEssay(writing),
            this._renderSubmitDate(writing),
            this._renderComment(_WritingAssignment.accessors.isShortAnswer(type))
          )
        );
      }
      return null;
    }
  }]);

  return IndividualCard;
}(_react.PureComponent);

IndividualCard.propTypes = {
  type: _propTypes2.default.string,
  writing: _propTypes2.default.object,
  isEdit: _propTypes2.default.bool,
  onEdit: _propTypes2.default.func,
  onDiscardComment: _propTypes2.default.func,
  onSaveComment: _propTypes2.default.func,
  comment: _propTypes2.default.string,
  shortAnswers: _propTypes2.default.object,
  onCommentUpdate: _propTypes2.default.func,
  onShortAnswersUpdate: _propTypes2.default.func,
  timeZone: _propTypes2.default.string.isRequired,
  canEdit: _propTypes2.default.bool
};

exports.default = IndividualCard;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1872);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3PMiBasRai3613uzEX4YIL{margin-top:2.14286rem;padding:0 2.14286rem}.aephhM84uLeYDzzxktJeg{border:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:1.42857rem 2.14286rem}._2zS5vxIGl5YTQmkoeD6qy8{padding:0 2.14286rem}._14a03IxPH1bavwGMy37yIf{margin:0;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:600;letter-spacing:.03571rem;line-height:1.28571}._3J5POaygSSEomXfiIIRSnX{color:#a4a4a4}._1hcOPOxQvKlZGZ6-HPqT2u{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;white-space:pre-wrap}._1hcOPOxQvKlZGZ6-HPqT2u,._2d_ULjRBuTynCAKMLENPGW,._3ahsw4ZugxEGrPbGNWPRKr{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._2d_ULjRBuTynCAKMLENPGW{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-color:#dedede;cursor:pointer;height:1.42857rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;width:1.42857rem}._2d_ULjRBuTynCAKMLENPGW.AdiP6eBNo85hF4AmVchKB{cursor:default;-webkit-filter:grayscale(40%);filter:grayscale(40%)}._2d_ULjRBuTynCAKMLENPGW._1QBa5UvrlkivLKrF1tloWl{background-color:#74d17f}._2d_ULjRBuTynCAKMLENPGW._198Ha8SaSR5OIEWPal_mrw{background-color:#de4c4c}._2d_ULjRBuTynCAKMLENPGW ._3IEGVnecLr4aZKdB9XaOJ5{color:#fff;height:.71429rem;width:.71429rem}._2d_ULjRBuTynCAKMLENPGW ._3IEGVnecLr4aZKdB9XaOJ5.AdiP6eBNo85hF4AmVchKB{color:#f2f2f2}._2d_ULjRBuTynCAKMLENPGW+._2d_ULjRBuTynCAKMLENPGW{margin-left:1.42857rem}.aephhM84uLeYDzzxktJeg+.aephhM84uLeYDzzxktJeg{border-top:none}._17FjjHWkttT0vv3lVCZNen{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-basis:100%;-ms-flex-preferred-size:100%;flex-basis:100%;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-right:2.14286rem;margin-top:.71429rem}._11bIo3QUOrKS6iPR_VRcMQ{line-height:1.78571rem;white-space:pre-line}._3kCwztWuKz-8MBBVrmpPDm{padding:0 0 1.42857rem}.NeKqv-j1dtG3dkORPpSxE,.zyHf8-6MmCig4_PXC2c_t{margin:0 2.14286rem}.NeKqv-j1dtG3dkORPpSxE{margin-top:1.42857rem}.zyHf8-6MmCig4_PXC2c_t{white-space:pre-wrap}._27cnMqIp-VXZgk4nzcT_ds{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3JPE4_T5FSVto-PTBQY0VJ{cursor:default;-webkit-box-flex:1;-webkit-flex:1 1 0%;-moz-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;margin:.21429rem 0;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1.14286rem;font-weight:400;letter-spacing:.07143rem;line-height:1.25}.zKWgQeF8UY2TF9DoOTfNF{height:7.14286rem;overflow-y:scroll}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"TextEditor_shortAnswer": "_3PMiBasRai3613uzEX4YIL",
	"TextEditor_shortAnswer_row": "aephhM84uLeYDzzxktJeg",
	"TextEditor_shortAnswer_row_header": "_2zS5vxIGl5YTQmkoeD6qy8",
	"TextEditor_shortAnswer_row_question": "_14a03IxPH1bavwGMy37yIf",
	"TextEditor_shortAnswer_row_answer": "_3J5POaygSSEomXfiIIRSnX",
	"TextEditor_shortAnswer_row_content": "_1hcOPOxQvKlZGZ6-HPqT2u",
	"TextEditor_shortAnswer_row_options": "_3ahsw4ZugxEGrPbGNWPRKr",
	"TextEditor_shortAnswer_row_options_radio": "_2d_ULjRBuTynCAKMLENPGW",
	"__disable": "AdiP6eBNo85hF4AmVchKB",
	"__correctSelectBG": "_1QBa5UvrlkivLKrF1tloWl",
	"__inCorrectSelectBG": "_198Ha8SaSR5OIEWPal_mrw",
	"__icon": "_3IEGVnecLr4aZKdB9XaOJ5",
	"TextEditor_date": "_17FjjHWkttT0vv3lVCZNen",
	"TextEditor_content": "_11bIo3QUOrKS6iPR_VRcMQ",
	"TextEditor_content_container": "_3kCwztWuKz-8MBBVrmpPDm",
	"TextEditor_comment": "NeKqv-j1dtG3dkORPpSxE",
	"TextEditor_essay": "zyHf8-6MmCig4_PXC2c_t",
	"TextEditor_essay_header": "_27cnMqIp-VXZgk4nzcT_ds",
	"TextEditor_essay_header_title": "_3JPE4_T5FSVto-PTBQY0VJ",
	"TextEditor_essay_scrollable": "zKWgQeF8UY2TF9DoOTfNF"
};

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1874);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Api = __webpack_require__(11);

var _Exporter = __webpack_require__(50);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

var _omniCommonUi = __webpack_require__(0);

var _LanguageRadio = __webpack_require__(74);

var _LanguageRadio2 = _interopRequireDefault(_LanguageRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXPORT_MIME_TYPE = 'application/pdf';

var ExportDialog = function (_Component) {
  _inherits(ExportDialog, _Component);

  function ExportDialog() {
    _classCallCheck(this, ExportDialog);

    var _this = _possibleConstructorReturn(this, (ExportDialog.__proto__ || Object.getPrototypeOf(ExportDialog)).call(this));

    _this.state = {
      isExportRequested: false
    };

    _this._onLanguageChanged = _this._onLanguageChanged.bind(_this);
    return _this;
  }

  _createClass(ExportDialog, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ choosedLanguageCode: this.props.languageCode });
    }
  }, {
    key: '_close',
    value: function _close() {
      var _props = this.props,
          buildRoute = _props.buildRoute,
          pushRoute = _props.pushRoute;

      function redirect(param) {
        pushRoute(buildRoute(param));
      }
      redirect({ mode: '' });
    }
  }, {
    key: '_performExport',
    value: function _performExport() {
      var _this2 = this;

      var _props2 = this.props,
          activityId = _props2.activityId,
          groupId = _props2.groupId,
          studentId = _props2.studentId,
          exportName = _props2.exportName;


      if (_is_js2.default.falsy(activityId)) {
        _omniCommonUi.log.error('ExportHandler is not exporting - activityId is not set!');
        return;
      }

      var url = (0, _Api.buildUrl)('/writing-assignment-activities/' + activityId + '/printing?' + ('groupId=' + groupId + '&') + ('studentId=' + studentId + '&') + ('languageCode=' + (this.state.choosedLanguageCode || _Languages2.default.defaultLanguageCode)));

      _Exporter.exporter.get(url, exportName, false, EXPORT_MIME_TYPE).then(function () {
        _this2._close();
      }).catch(function () {
        _this2.setState({ isExportErrorOccurred: true });
      });

      this.setState({ isExportRequested: true });
    }
  }, {
    key: '_onLanguageChanged',
    value: function _onLanguageChanged(languageCode) {
      this.setState({ choosedLanguageCode: languageCode });
    }
  }, {
    key: '_isChecked',
    value: function _isChecked(languageCode) {
      return languageCode === this.state.choosedLanguageCode;
    }
  }, {
    key: '_isDefaultLanguage',
    value: function _isDefaultLanguage() {
      if (!this.props.languageCode) return true;
      return _Languages2.default.defaultLanguageCode === this.props.languageCode;
    }
  }, {
    key: '_renderLanguageRadio',
    value: function _renderLanguageRadio() {
      return _react2.default.createElement(_LanguageRadio2.default, { name: 'language-picker',
        languageCode: this.props.languageCode,
        onChecked: this._onLanguageChanged,
        choosedLanguageCode: this.state.choosedLanguageCode });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (this.state.isExportErrorOccurred) {
        return _react2.default.createElement(_omniCommonUi.ErrorDialog, { isOpen: true,
          onConfirmClick: function onConfirmClick() {
            _this3._close();
          } });
      }

      if (!this._isDefaultLanguage()) {
        return _react2.default.createElement(
          _omniCommonUi.ConfirmDialog,
          { isOpen: true,
            isLoading: this.state.isExportRequested,
            title: 'Choose Language:',
            primaryButtonContent: 'Export',
            secondaryButtonContent: 'Cancel',
            onPrimaryClick: function onPrimaryClick() {
              return _this3._performExport();
            },
            onSecondaryClick: function onSecondaryClick() {
              return _this3._close();
            },
            onRequestClose: function onRequestClose() {
              return _this3._close();
            } },
          _react2.default.createElement(
            'div',
            { className: _style2.default.ExportAllHandler_content },
            _react2.default.createElement(
              'div',
              { className: _style2.default.ExportAllHandler_languageRadio },
              this._renderLanguageRadio()
            )
          )
        );
      }
      // the export starts automatically!
      !this.state.isExportRequested && this._performExport();
      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: true,
          isLoading: true,
          isButtonless: true,
          title: 'Exporting reports, please wait' },
        _react2.default.createElement('div', { className: _style2.default.ExportAllHandler_exportingImmediately })
      );
    }
  }]);

  return ExportDialog;
}(_react.Component);

ExportDialog.propTypes = {
  activityId: _propTypes2.default.string.isRequired,
  groupId: _propTypes2.default.string.isRequired,
  studentId: _propTypes2.default.string.isRequired,
  languageCode: _propTypes2.default.string.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  exportName: _propTypes2.default.string.isRequired
};

exports.default = ExportDialog;

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1875);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1EwnN8bZeE3eJQ4baiqy5t{min-height:4.57143rem}._2g-jKTaVlkcsDH_8YePgGU{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._2g-jKTaVlkcsDH_8YePgGU>p+p{margin-top:0}._3JxHme-8cioFvmbRPyag4f{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:initial}._3JxHme-8cioFvmbRPyag4f>*{margin-top:1.07143rem}._3ZyWCqKszgZgG1Tgim_hev{border-top:.07143rem solid #ccc;display:block;margin:.35714rem 0;width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ExportAllHandler_exportingImmediately": "_1EwnN8bZeE3eJQ4baiqy5t",
	"ExportAllHandler_content": "_2g-jKTaVlkcsDH_8YePgGU",
	"ExportAllHandler_languageRadio": "_3JxHme-8cioFvmbRPyag4f",
	"ExportAllHandler_divider": "_3ZyWCqKszgZgG1Tgim_hev"
};

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1877);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _GroupMembers = __webpack_require__(14);

var _UiState = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentSelect = function (_PureComponent) {
  _inherits(StudentSelect, _PureComponent);

  function StudentSelect(props) {
    _classCallCheck(this, StudentSelect);

    var _this = _possibleConstructorReturn(this, (StudentSelect.__proto__ || Object.getPrototypeOf(StudentSelect)).call(this, props));

    _this._getLinkHrefForValue = function (studentId) {
      return _this.props.buildRoute({ studentId: studentId, mode: '' });
    };
    return _this;
  }

  _createClass(StudentSelect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._buildStudentSelectOptions();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._buildStudentSelectOptions(nextProps);
    }
  }, {
    key: '_buildStudentSelectOptions',
    value: function _buildStudentSelectOptions() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      // cache the result
      if (_is_js2.default.existy(this._studentSelectOptions) && _is_js2.default.existy(this._members) && this._members === props.members) {
        return;
      }
      var members = props.members;

      if (members && members.size > 0) {
        // cache this - do not recreate each time
        this._members = members;
        this._studentSelectOptions = members.map(function (option) {
          var studentGeneralInfo = option.studentGeneralInfo;

          var optionHtml = _react2.default.createElement(
            _omniCommonUi.StudentCard,
            { vertical: true,
              borderless: true,
              backgroundless: true },
            _react2.default.createElement(_omniCommonUi.StudentCard.Profile, { name: studentGeneralInfo.firstName,
              surname: studentGeneralInfo.lastName,
              localName: studentGeneralInfo.localName,
              avatarUrl: studentGeneralInfo.avatarUrl,
              gender: studentGeneralInfo.gender })
          );
          return {
            html: optionHtml,
            value: studentGeneralInfo.id
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentMember = _props.currentMember,
          members = _props.members,
          isHide = _props.isHide;

      if (currentMember && members.size && members.size > 0) {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.StudentSelect },
          _react2.default.createElement(_omniCommonUi.HorizontalSelect, { options: this._studentSelectOptions,
            value: currentMember && currentMember.studentGeneralInfo.id,
            getLinkHrefForValue: this._getLinkHrefForValue,
            isHide: isHide })
        );
      }
      return null;
    }
  }]);

  return StudentSelect;
}(_react.PureComponent);

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      studentId = _ownProps$params.studentId,
      groupId = _ownProps$params.groupId;

  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  return {
    currentMember: _GroupMembers.actions.getMemberById(state, studentId),
    members: members,
    isHide: !_UiState.actions.getShowNavigationBar(state)
  };
}

StudentSelect.propTypes = {
  currentMember: _propTypes2.default.object,
  members: _propTypes2.default.object,
  buildRoute: _propTypes2.default.func,
  isHide: _propTypes2.default.bool
};

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null)(StudentSelect);

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1878);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1ucySh9PcPeE9v-wXrMiZD{background:#f3f5f7;border-bottom:.07143rem solid #ccc;padding:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentSelect": "_1ucySh9PcPeE9v-wXrMiZD"
};

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseSessionNav2 = __webpack_require__(108);

var _BaseSessionNav3 = _interopRequireDefault(_BaseSessionNav2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _UiState = __webpack_require__(30);

var _WritingAssignment = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WritingAssignmentSessionNav = function (_BaseSessionNav) {
  _inherits(WritingAssignmentSessionNav, _BaseSessionNav);

  function WritingAssignmentSessionNav() {
    _classCallCheck(this, WritingAssignmentSessionNav);

    return _possibleConstructorReturn(this, (WritingAssignmentSessionNav.__proto__ || Object.getPrototypeOf(WritingAssignmentSessionNav)).apply(this, arguments));
  }

  _createClass(WritingAssignmentSessionNav, [{
    key: '_hasNext',
    value: function _hasNext() {
      return this.props.hasNext;
    }
  }, {
    key: '_hasPrevious',
    value: function _hasPrevious() {
      return this.props.hasPrevious;
    }
  }, {
    key: '_hasNextUnit',
    value: function _hasNextUnit() {
      return false;
    }
  }, {
    key: '_hasPreviousUnit',
    value: function _hasPreviousUnit() {
      return false;
    }
  }, {
    key: '_getNextUnitText',
    value: function _getNextUnitText() {
      return null;
    }
  }, {
    key: '_getPreviousUnitText',
    value: function _getPreviousUnitText() {
      return null;
    }
  }, {
    key: '_getHeadingText',
    value: function _getHeadingText() {
      return 'Unit ' + this.props.currentLesson.unitNo;
    }
  }, {
    key: '_getAdditionalChildren',
    value: function _getAdditionalChildren() {
      return _react2.default.createElement(
        'h2',
        null,
        'Lesson ',
        this.props.currentLesson.lessonNo
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.currentLesson) {
        return _get(WritingAssignmentSessionNav.prototype.__proto__ || Object.getPrototypeOf(WritingAssignmentSessionNav.prototype), 'render', this).call(this);
      }
      return null;
    }
  }]);

  return WritingAssignmentSessionNav;
}(_BaseSessionNav3.default);

WritingAssignmentSessionNav.propTypes = Object.assign({
  currentLesson: _propTypes2.default.object,
  hasNext: _propTypes2.default.bool,
  hasPrevious: _propTypes2.default.bool,
  previousSessionLinkHref: _propTypes2.default.string,
  nextSessionLinkHref: _propTypes2.default.string,
  isHide: _propTypes2.default.boolean
}, _BaseSessionNav3.default.propTypes);

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      lessonSeq = _ownProps$params.lessonSeq;

  var sessions = _WritingAssignment.accessors.getCoreWritingAssignmentLessons(state, groupId);
  if (sessions) {
    var currentLesson = sessions.find(function (s) {
      return '' + s.seq === '' + lessonSeq;
    });
    var hasNext = Number(lessonSeq) < sessions.size - 1;
    var hasPrevious = Number(lessonSeq) > 0;
    return {
      currentLesson: currentLesson,
      hasNext: hasNext,
      hasPrevious: hasPrevious,
      previousSessionLinkHref: ownProps.buildRoute({
        lessonSeq: Number(lessonSeq) - 1
      }),
      nextSessionLinkHref: ownProps.buildRoute({
        lessonSeq: Number(lessonSeq) + 1
      }),
      isHide: !_UiState.actions.getShowNavigationBar(state)
    };
  }
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null)(WritingAssignmentSessionNav);

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1881);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3QNtEXBrC5CoJLhJruwt-0{padding:1.42857rem}@media only screen and (min-width:640px){._3QNtEXBrC5CoJLhJruwt-0{padding:2.14286rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"WritingAssignment_container": "_3QNtEXBrC5CoJLhJruwt-0"
};

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(803);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(332);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeedback = getFeedback;
exports.getFeebackItems = getFeebackItems;
exports.getItems = getItems;
exports.hasFeedbackSaved = hasFeedbackSaved;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFeedback(state, sessionId, studentId) {
  var id = sessionId + '-' + studentId;
  return state.get('rootReducer').get('feedback').get(id);
}

function getFeebackItems(state, sessionId, studentId) {
  return getItems(getFeedback(state, sessionId, studentId));
}

function getItems(feedback) {
  return feedback && Object.getOwnPropertyNames(feedback.toJSON()).map(function (name) {
    return {
      name: name,
      value: feedback[name]
    };
  });
}

function hasFeedbackSaved(state, sessionId, studentId) {
  return _is_js2.default.existy(getFeedback(state, sessionId, studentId));
}

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = feedbackReducer;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(804);

var _model = __webpack_require__(1885);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function feedbackReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_FEEDBACK_SUCCESS:
      return onSuccess(state, action);
    default:
      return state;
  }
}

function onSuccess(state, _ref) {
  var payload = _ref.payload,
      sessionId = _ref.sessionId,
      studentId = _ref.studentId;

  return state.set(sessionId + '-' + studentId, _model2.default.create(payload));
}

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeedbackRecord = (0, _immutable.Record)({
  strengths: undefined,
  weaknesses: undefined,
  performance: undefined,
  actionPlan: undefined
});

var Feedback = function (_FeedbackRecord) {
  _inherits(Feedback, _FeedbackRecord);

  function Feedback() {
    _classCallCheck(this, Feedback);

    return _possibleConstructorReturn(this, (Feedback.__proto__ || Object.getPrototypeOf(Feedback)).apply(this, arguments));
  }

  return Feedback;
}(FeedbackRecord);

Feedback.create = function (data) {
  return new FeedbackRecord(data);
};

exports.default = Feedback;

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1887);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _GroupMembers = __webpack_require__(14);

var _UiState = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentSelect = function (_PureComponent) {
  _inherits(StudentSelect, _PureComponent);

  function StudentSelect(props) {
    _classCallCheck(this, StudentSelect);

    var _this = _possibleConstructorReturn(this, (StudentSelect.__proto__ || Object.getPrototypeOf(StudentSelect)).call(this, props));

    _this._getLinkHrefForValue = function (studentId) {
      return _this.props.buildRoute({ studentId: studentId, mode: '' });
    };
    return _this;
  }

  _createClass(StudentSelect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._buildStudentSelectOptions();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._buildStudentSelectOptions(nextProps);
    }
  }, {
    key: '_buildStudentSelectOptions',
    value: function _buildStudentSelectOptions() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      // cache the result
      if (_is_js2.default.existy(this._studentSelectOptions) && _is_js2.default.existy(this._members) && this._members === props.members) {
        return;
      }
      var members = props.members;

      if (members && members.size > 0) {
        // cache this - do not recreate each time
        this._members = members;
        this._studentSelectOptions = members.map(function (option) {
          var studentGeneralInfo = option.studentGeneralInfo;

          var optionHtml = _react2.default.createElement(
            _omniCommonUi.StudentCard,
            { vertical: true,
              borderless: true,
              backgroundless: true },
            _react2.default.createElement(_omniCommonUi.StudentCard.Profile, { name: studentGeneralInfo.firstName,
              surname: studentGeneralInfo.lastName,
              localName: studentGeneralInfo.localName,
              avatarUrl: studentGeneralInfo.avatarUrl,
              gender: studentGeneralInfo.gender })
          );
          return {
            html: optionHtml,
            value: studentGeneralInfo.id
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentMember = _props.currentMember,
          members = _props.members,
          isHide = _props.isHide;

      if (currentMember && members.size && members.size > 0) {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.StudentSelect },
          _react2.default.createElement(_omniCommonUi.HorizontalSelect, { options: this._studentSelectOptions,
            value: currentMember && currentMember.studentGeneralInfo.id,
            getLinkHrefForValue: this._getLinkHrefForValue,
            isHide: isHide })
        );
      }
      return null;
    }
  }]);

  return StudentSelect;
}(_react.PureComponent);

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      studentId = _ownProps$params.studentId,
      groupId = _ownProps$params.groupId;

  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  return {
    currentMember: _GroupMembers.actions.getMemberById(state, studentId),
    members: members,
    isHide: !_UiState.actions.getShowNavigationBar(state)
  };
}

StudentSelect.propTypes = {
  currentMember: _propTypes2.default.object,
  members: _propTypes2.default.object,
  buildRoute: _propTypes2.default.func,
  isHide: _propTypes2.default.bool
};

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null)(StudentSelect);

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1888);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3oxgJi_udZj22oeDqvI5sN{background:#f3f5f7;border-bottom:.07143rem solid #ccc;padding:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentSelect": "_3oxgJi_udZj22oeDqvI5sN"
};

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1890);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _CardActionIcons = __webpack_require__(85);

var _CardActionIcons2 = _interopRequireDefault(_CardActionIcons);

var _Feedback = __webpack_require__(217);

var _Note = __webpack_require__(131);

var _Item = __webpack_require__(1892);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FEEDBACK_INSTRUCTION = 'Teacher\'s feedback and suggestions';

var FEEDBACK_ITEMS = [{ label: 'Strengths', code: 'strengths' }, { label: 'Weaknesses', code: 'weaknesses' }, { label: 'Performance', code: 'performance' }, { label: 'Action Plan', code: 'actionPlan' }];

var INTERNAL_NOTE = {
  label: 'Behaviour & Participation'
};

var NOTE_DESCRIPTION = 'Parents and students cannot see Behaviour & Participation';

var Feedback = function (_PureComponent) {
  _inherits(Feedback, _PureComponent);

  function Feedback() {
    _classCallCheck(this, Feedback);

    var _this = _possibleConstructorReturn(this, (Feedback.__proto__ || Object.getPrototypeOf(Feedback)).call(this));

    _this.state = {
      feedback: _this._getInitFeedbackItem(),
      isEditing: false,
      note: ''
    };
    _this._onSaveFeedback = _this._onSaveFeedback.bind(_this);
    _this._onDiscardFeedback = _this._onDiscardFeedback.bind(_this);
    _this._onEdit = _this._onEdit.bind(_this);
    return _this;
  }

  _createClass(Feedback, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setUpData(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._setUpData(nextProps);
    }
  }, {
    key: '_setUpData',
    value: function _setUpData(props) {
      var feedback = props.feedback,
          hasSaved = props.hasSaved,
          note = props.note;

      this.setState({
        feedback: hasSaved ? feedback : this._getInitFeedbackItem(),
        isEditing: !hasSaved,
        note: _is_js2.default.existy(note) ? note.get('content') : ''
      });
    }
  }, {
    key: '_getInitFeedbackItem',
    value: function _getInitFeedbackItem() {
      return FEEDBACK_ITEMS.map(function (item) {
        return {
          name: item.code,
          value: ''
        };
      });
    }
  }, {
    key: '_shouldSaveButtonEnabled',
    value: function _shouldSaveButtonEnabled() {
      return this.state.feedback.reduce(function (pre, cur) {
        return pre && _is_js2.default.string(cur.value) && cur.value.length !== 0;
      }, true);
    }
  }, {
    key: '_onSaveFeedback',
    value: function _onSaveFeedback() {
      var _props = this.props,
          fetchFeedback = _props.fetchFeedback,
          fetchStudentNotes = _props.fetchStudentNotes,
          submitFeedback = _props.submitFeedback,
          sessionPlanId = _props.sessionPlanId,
          studentId = _props.studentId,
          groupId = _props.groupId;

      var payload = this.state.feedback.reduce(function (pre, cur) {
        return Object.assign(pre, _defineProperty({}, cur.name, cur.value));
      }, {});

      Promise.all([submitFeedback(sessionPlanId, studentId, payload), this._submitStudentNote(studentId, {
        groupId: groupId,
        category: _Note.actions.STUDENT_NOTE_CATEGORY_ATTENDANCE,
        content: this.state.note,
        entityId: sessionPlanId
      })]).then(function () {
        fetchFeedback(sessionPlanId, studentId);
        fetchStudentNotes(studentId);
      });
    }
  }, {
    key: '_submitStudentNote',
    value: function _submitStudentNote(studentId, payload) {
      var _props2 = this.props,
          note = _props2.note,
          submitStudentNote = _props2.submitStudentNote;

      if (_is_js2.default.existy(note) && payload.content === note.get('content') || payload.content.length === 0) {
        return;
      }
      var payloadToSubmit = Object.assign(payload, { studentNoteId: _is_js2.default.existy(note) ? note.get('id') : undefined });
      return submitStudentNote(studentId, payloadToSubmit);
    }
  }, {
    key: '_onDiscardFeedback',
    value: function _onDiscardFeedback() {
      var _props3 = this.props,
          feedback = _props3.feedback,
          note = _props3.note;

      if (_is_js2.default.existy(feedback)) {
        this.setState({
          feedback: _is_js2.default.existy(feedback) ? feedback : this._getInitFeedbackItem(),
          note: _is_js2.default.existy(note) ? note.get('content') : '',
          isEditing: false
        });
      }
    }
  }, {
    key: '_onItemChange',
    value: function _onItemChange(val, item) {
      var feedback = this.state.feedback.map(function (feedbackItem) {
        return feedbackItem.name === item ? { name: item, value: val } : feedbackItem;
      });
      this.setState({ feedback: feedback });
    }
  }, {
    key: '_onNoteChange',
    value: function _onNoteChange(val) {
      this.setState({ note: val });
    }
  }, {
    key: '_onEdit',
    value: function _onEdit() {
      this.setState({ isEditing: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var noteClassName = (0, _classnames3.default)(_defineProperty({}, _style2.default.Feedback_content_note, !this.state.isEditing));
      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { outerMargin: true },
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          _react2.default.createElement(
            _omniCommonUi.PageCard,
            null,
            _react2.default.createElement(
              _omniCommonUi.PageCard.Heading,
              { className: _style2.default.Feedback_header },
              _react2.default.createElement(
                'h1',
                { className: _style2.default.Feedback_header_title },
                FEEDBACK_INSTRUCTION
              ),
              this.state.isEditing ? null : _react2.default.createElement(_CardActionIcons2.default, { onEditClick: this._onEdit,
                hideDeleteIcon: true })
            ),
            _react2.default.createElement(
              _omniCommonUi.PageCard.Content,
              { className: _style2.default.Feedback_content },
              this.state.feedback.map(function (item) {
                var feedbackItem = FEEDBACK_ITEMS.find(function (template) {
                  return template.code === item.name;
                });
                return _react2.default.createElement(_Item2.default, { title: feedbackItem.label,
                  isEdit: _this2.state.isEditing,
                  value: item.value,
                  onChange: function onChange(val) {
                    return _this2._onItemChange(val, feedbackItem.code);
                  } });
              }),
              !this.state.isEditing && !_is_js2.default.existy(this.props.note) ? null : _react2.default.createElement(_Item2.default, { isEdit: this.state.isEditing,
                isWithoutBottomLine: true,
                description: NOTE_DESCRIPTION,
                className: noteClassName,
                title: INTERNAL_NOTE.label,
                onChange: function onChange(val) {
                  return _this2._onNoteChange(val);
                },
                value: this.state.note })
            ),
            !this.state.isEditing ? null : _react2.default.createElement(
              _omniCommonUi.Button.Container,
              { align: 'right', className: _style2.default.Feedback_btns },
              _react2.default.createElement(
                _omniCommonUi.Button,
                { type: _omniCommonUi.Button.Type.primary,
                  disabled: !this._shouldSaveButtonEnabled(),
                  onClick: this._onSaveFeedback },
                'SAVE'
              ),
              _react2.default.createElement(
                _omniCommonUi.Button,
                { type: _omniCommonUi.Button.Type.default,
                  onClick: this._onDiscardFeedback },
                'DISCARD'
              )
            )
          )
        )
      );
    }
  }]);

  return Feedback;
}(_react.PureComponent);

function mapDispatchToProps(dispatch) {
  return Object.assign({}, (0, _redux.bindActionCreators)(_Note.actions, dispatch), (0, _redux.bindActionCreators)(_Feedback.actions, dispatch));
}

function mapStateToProps(state, ownProps) {
  var sessionPlanId = ownProps.sessionPlanId,
      studentId = ownProps.studentId,
      mode = ownProps.mode;

  var note = _Note.accessors.getAttendanceNoteByStudentIdAndSessionId(state, studentId, sessionPlanId);
  return {
    sessionPlanId: sessionPlanId,
    studentId: studentId,
    mode: mode,
    feedback: _Feedback.accessors.getFeebackItems(state, sessionPlanId, studentId),
    hasSaved: _Feedback.accessors.hasFeedbackSaved(state, sessionPlanId, studentId),
    note: note
  };
}

Feedback.propTypes = {
  groupId: _propTypes2.default.string,
  sessionPlanId: _propTypes2.default.string,
  studentId: _propTypes2.default.string,
  mode: _propTypes2.default.string,
  feedback: _propTypes2.default.object,
  note: _propTypes2.default.object,
  fetchFeedbackIfNeeded: _propTypes2.default.func,
  fetchFeedback: _propTypes2.default.func,
  fetchStudentNotesIfNeeded: _propTypes2.default.func,
  fetchStudentNotes: _propTypes2.default.func,
  submitFeedback: _propTypes2.default.func,
  submitStudentNote: _propTypes2.default.func,
  hasSaved: _propTypes2.default.bool
};

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(Feedback);

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1891);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1WA_hHZT2LzanZt1pEqOah{padding:0}._19_cgangmnYbtkLyJ1xsIO{background-color:#f3f5f7}._1rbmB9JB-2H8eeRKMngQZ4{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3KbaxUZkS1S5f7m244Nr-J{cursor:default;-webkit-box-flex:1;-webkit-flex:1 1 0%;-moz-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;margin:.21429rem 0;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1.14286rem;font-weight:400;letter-spacing:.07143rem;line-height:1.25}._2JPi_UTNue92TdkwmqBSQI{padding:2.14286rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Feedback_content": "_1WA_hHZT2LzanZt1pEqOah",
	"Feedback_content_note": "_19_cgangmnYbtkLyJ1xsIO",
	"Feedback_header": "_1rbmB9JB-2H8eeRKMngQZ4",
	"Feedback_header_title": "_3KbaxUZkS1S5f7m244Nr-J",
	"Feedback_btns": "_2JPi_UTNue92TdkwmqBSQI"
};

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1893);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_PureComponent) {
  _inherits(Item, _PureComponent);

  function Item() {
    _classCallCheck(this, Item);

    return _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
  }

  _createClass(Item, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isEdit = _props.isEdit,
          title = _props.title,
          value = _props.value,
          _onChange = _props.onChange,
          className = _props.className,
          isWithoutBottomLine = _props.isWithoutBottomLine,
          description = _props.description;

      var itemClassName = (0, _classnames3.default)(_style2.default.FeedbackItem, className, _defineProperty({}, _style2.default.__withoutBottomLine, isWithoutBottomLine));
      return _react2.default.createElement(
        'div',
        { className: itemClassName },
        _react2.default.createElement(
          'h6',
          { className: _style2.default.FeedbackItem_title },
          title
        ),
        isEdit ? _react2.default.createElement(_omniCommonUi.TextArea, { className: _style2.default.FeedbackItem_textarea,
          value: value,
          onChange: function onChange(e) {
            return _onChange(e.target.value);
          } }) : _react2.default.createElement(
          'pre',
          { className: _style2.default.FeedbackItem_view },
          value
        ),
        _is_js2.default.string(description) ? _react2.default.createElement(
          'p',
          { className: _style2.default.FeedbackItem_description },
          description
        ) : null
      );
    }
  }]);

  return Item;
}(_react.PureComponent);

Item.propTypes = {
  description: _propTypes2.default.string,
  isWithoutBottomLine: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  value: _propTypes2.default.string,
  isEdit: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

exports.default = Item;

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1894);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".mWGlwkK_2ECIoP7hOSvmc{border-bottom:.07143rem solid #ccc;padding:2.14286rem}._3jqi_Xm_KUt6hw17MFyQzs{color:#a4a4a4;font-size:.85714rem;letter-spacing:.05714rem;line-height:1rem}._7_4PS_CGmWC-U3JVNo4-f{margin:0;margin-bottom:2.14286rem}._2QVTRPyv_luw2JdycciC0Y{min-height:2.14286rem}._7r2KEsVW2dkTlqf5SsbSP{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif}.mWGlwkK_2ECIoP7hOSvmc.c8q7CjYVD8q7qmolmK_sy{border-bottom:none}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"FeedbackItem": "mWGlwkK_2ECIoP7hOSvmc",
	"FeedbackItem_description": "_3jqi_Xm_KUt6hw17MFyQzs",
	"FeedbackItem_title": "_7_4PS_CGmWC-U3JVNo4-f",
	"FeedbackItem_textarea": "_2QVTRPyv_luw2JdycciC0Y",
	"FeedbackItem_view": "_7r2KEsVW2dkTlqf5SsbSP",
	"__withoutBottomLine": "c8q7CjYVD8q7qmolmK_sy"
};

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _CICCategoryCard = __webpack_require__(675);

var _CICCategoryCard2 = _interopRequireDefault(_CICCategoryCard);

var _NoContentMessage = __webpack_require__(66);

var _NoContentMessage2 = _interopRequireDefault(_NoContentMessage);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _CoveredInClass = __webpack_require__(95);

var _Template = __webpack_require__(166);

var _InternalNotes = __webpack_require__(1896);

var _InternalNotes2 = _interopRequireDefault(_InternalNotes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SAVE = 'save';
var IS_EDITING = 'isEditing';

var GrammarPro = function (_PureComponent) {
  _inherits(GrammarPro, _PureComponent);

  function GrammarPro() {
    _classCallCheck(this, GrammarPro);

    var _this = _possibleConstructorReturn(this, (GrammarPro.__proto__ || Object.getPrototypeOf(GrammarPro)).call(this));

    _this._getModeAndIndex = _this._getModeAndIndex.bind(_this);
    _this.state = {
      activities: []
    };
    return _this;
  }

  _createClass(GrammarPro, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setUpData(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._setUpData(nextProps);
      if (this.props.mode !== nextProps.mode && nextProps.mode === SAVE) {
        var _props = this.props,
            cic = _props.cic,
            push = _props.push,
            buildRouteWithContext = _props.buildRouteWithContext,
            fetchCoveredInClass = _props.fetchCoveredInClass,
            publishCoveredInClass = _props.publishCoveredInClass,
            sessionPlanId = _props.sessionPlanId;


        var activities = this.state.activities.map(function (category) {
          var checkeditems = category.cicCategoryItems.filter(function (item) {
            return item.isChecked;
          });
          return Object.assign(category, {
            cicCategoryItems: checkeditems
          });
        });

        var cicToPublish = Object.assign(cic, {
          cicCategories: activities
        });
        publishCoveredInClass([cicToPublish], sessionPlanId).then(function () {
          fetchCoveredInClass(sessionPlanId).then(function () {
            return push(buildRouteWithContext({ mode: '' }));
          });
        });
      }
    }
  }, {
    key: '_getModeAndIndex',
    value: function _getModeAndIndex() {
      var _props2 = this.props,
          mode = _props2.mode,
          index = _props2.index;

      return { mode: mode, index: index };
    }
  }, {
    key: '_onChangeMode',
    value: function _onChangeMode(modeAndIndex) {
      var mode = modeAndIndex.mode,
          _modeAndIndex$index = modeAndIndex.index,
          index = _modeAndIndex$index === undefined ? '' : _modeAndIndex$index;
      var _props3 = this.props,
          push = _props3.push,
          buildRouteWithContext = _props3.buildRouteWithContext;

      push(buildRouteWithContext({ mode: mode, index: index }));
    }
  }, {
    key: '_onComponentMounted',
    value: function _onComponentMounted(_cmpnt) {
      this.internalNotesPartComponent = _cmpnt;
    }
  }, {
    key: '_onCICItemChanged',
    value: function _onCICItemChanged(categoryId, itemId, value) {
      var activitiesToUpdate = [].concat(_toConsumableArray(this.state.activities));
      var category = activitiesToUpdate.find(function (c) {
        return c.cicCategoryId === categoryId;
      });
      var cicItems = category.cicCategoryItems;
      var itemIndex = cicItems.findIndex(function (item) {
        return item.cicCategoryItemId === itemId;
      });
      var itemUpdated = Object.assign(cicItems[itemIndex], { isChecked: value });
      cicItems[itemIndex] = itemUpdated;
      this.setState({ activities: activitiesToUpdate });
    }
  }, {
    key: '_renderCIC',
    value: function _renderCIC(activities, isEdit) {
      var _this2 = this;

      if (Array.isArray(activities) && activities.length !== 0) {
        return activities.map(function (category) {
          return _react2.default.createElement(
            _omniCommonUi.Grid.Item,
            { xs: 12, sm: 12, md: 6 },
            _react2.default.createElement(_CICCategoryCard2.default, { title: category.cicCategoryName,
              categoriesList: category.cicCategoryItems,
              onItemCheck: function onItemCheck(categoryId, itemId, value) {
                return _this2._onCICItemChanged(categoryId, itemId, value);
              },
              isEdit: isEdit })
          );
        });
      }
      return _react2.default.createElement(_NoContentMessage2.default, { text: 'No new course content was covered.' });
    }
  }, {
    key: '_setUpData',
    value: function _setUpData(props) {
      if (Array.isArray(props.activities)) {
        this.setState({
          activities: props.activities.map(function (category) {
            var cicCategoryItems = category.cicCategoryItems.map(function (item) {
              return Object.assign(item, { cicCategoryId: category.cicCategoryId });
            });
            return Object.assign(category, { cicCategoryItems: cicCategoryItems });
          })
        });
      } else {
        this.setState({ activities: [] });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props4 = this.props,
          sessionPlanId = _props4.sessionPlanId,
          hasSaved = _props4.hasSaved,
          isNotFutureSession = _props4.isNotFutureSession,
          hasEditPriviledge = _props4.hasEditPriviledge;

      var isEdit = _is_js2.default.existy(hasSaved) && !hasSaved && isNotFutureSession && hasEditPriviledge;
      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { outerMargin: true },
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          _react2.default.createElement(_InternalNotes2.default, { sessionPlanId: sessionPlanId,
            onComponentMounted: function onComponentMounted(_cmpnt) {
              return _this3._onComponentMounted(_cmpnt);
            },
            modeAndIndex: this._getModeAndIndex(),
            onChangeMode: function onChangeMode(modeAndIndex) {
              return _this3._onChangeMode(modeAndIndex);
            } }),
          this._renderCIC(this.state.activities, isEdit)
        )
      );
    }
  }]);

  return GrammarPro;
}(_react.PureComponent);

function mapDispatchToProps(dispatch) {
  return Object.assign({}, (0, _redux.bindActionCreators)(_CoveredInClass.actions, dispatch), (0, _redux.bindActionCreators)(_Template.actions, dispatch));
}

function mapStateToProps(state, ownProps) {
  var sessionPlanId = ownProps.sessionPlanId,
      mode = ownProps.mode,
      groupId = ownProps.groupId;

  var hasSaved = _CoveredInClass.accessors.hasSaved(state, sessionPlanId);
  var cics = getCICs(mode, state, sessionPlanId);
  var cic = getCIC(cics);
  var activities = getActivities(cic);
  var isNotFutureSession = _CoveredInClass.accessors.isNotFutureSession(state, { groupId: groupId, sessionPlanId: sessionPlanId });
  var hasEditPriviledge = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.CoveredInClass.MarkAndPublish);
  return { activities: activities, cic: cic, hasSaved: hasSaved, isNotFutureSession: isNotFutureSession, hasEditPriviledge: hasEditPriviledge };
}

function getActivities(cic) {
  if (_is_js2.default.existy(cic)) {
    if (_is_js2.default.existy(cic) && _is_js2.default.existy(cic.cicCategories) && cic.cicCategories.length !== 0) {
      return cic.cicCategories;
    }
  }
}

function getCIC(cics) {
  if (_is_js2.default.existy(cics)) {
    return cics.toList().get(0) && cics.toList().get(0).toJSON();
  }
}

function getCICs(mode, state, sessionPlanId) {
  var hasSaved = _CoveredInClass.accessors.hasSaved(state, sessionPlanId);
  return mode !== IS_EDITING && hasSaved ? _CoveredInClass.accessors.getCoveredInClassObject(state, sessionPlanId) : _CoveredInClass.accessors.getCoveredInClassTemplate(state, sessionPlanId);
}

GrammarPro.propTypes = {
  activities: _propTypes2.default.array,
  cic: _propTypes2.default.object,
  buildRouteWithContext: _propTypes2.default.func,
  publishCoveredInClass: _propTypes2.default.func,
  fetchCoveredInClassIfNeeded: _propTypes2.default.func,
  fetchCoveredInClassTemplateIfNeeded: _propTypes2.default.func,
  fetchCoveredInClass: _propTypes2.default.func,
  mode: _propTypes2.default.string,
  index: _propTypes2.default.string,
  push: _propTypes2.default.func,
  sessionPlanId: _propTypes2.default.string,
  hasSaved: _propTypes2.default.bool,
  isNotFutureSession: _propTypes2.default.bool,
  hasEditPriviledge: _propTypes2.default.bool
};

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(GrammarPro);

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1897);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _InternalNoteView = __webpack_require__(207);

var _InternalNoteView2 = _interopRequireDefault(_InternalNoteView);

var _omniCommonUi = __webpack_require__(0);

var _redux = __webpack_require__(10);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _InternalNotes = __webpack_require__(307);

var _AddInternalNoteControl = __webpack_require__(67);

var _AddInternalNoteControl2 = _interopRequireDefault(_AddInternalNoteControl);

var _Users = __webpack_require__(82);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _routes = __webpack_require__(332);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MESSAGE_DISCARD_FORM = "Are you sure you want to delete this note?";
var NOTE_DESCRIPTION = "Parents and students cannot see Internal notes.";
var CANCEL = "CANCEL";
var DELETE = "DELETE";

var InternalNotesPart = function (_Component) {
  _inherits(InternalNotesPart, _Component);

  function InternalNotesPart(props) {
    _classCallCheck(this, InternalNotesPart);

    var _this = _possibleConstructorReturn(this, (InternalNotesPart.__proto__ || Object.getPrototypeOf(InternalNotesPart)).call(this, props));

    _this.isAutoSaving = false;
    return _this;
  }

  _createClass(InternalNotesPart, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this._fetchData(this.props);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_is_js2.default.function(this.props.onComponentMounted)) {
        return;
      }
      this.props.onComponentMounted(this);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps() {
      this._fetchData(this.props);
    }
  }, {
    key: "_fetchData",
    value: function _fetchData(props) {
      var sessionPlanId = this.props.sessionPlanId;

      if (_is_js2.default.undefined(sessionPlanId)) {
        return;
      }

      props.fetchInternalNotesIfNeeded(sessionPlanId);
    }
  }, {
    key: "_onEditButtonClick",
    value: function _onEditButtonClick(index) {
      _reactGa2.default.event({
        category: "Covered in Class",
        action: 'Clicked "Edit"'
      });

      this.props.onChangeMode({ mode: _routes.Modes.EDIT_NOTES, index: index });
    }
  }, {
    key: "_onDeleteButtonClick",
    value: function _onDeleteButtonClick(index) {
      _reactGa2.default.event({
        category: "Covered in Class",
        action: 'Clicked "Delete"'
      });

      var internalNote = this.props.internalNotes.data[index];
      this.props.deleteInternalNote(this.props.sessionPlanId, index, internalNote);
      this.props.deleteInternalNoteFromServer(this.props.sessionPlanId, internalNote);
    }
  }, {
    key: "_onDeleteIconClick",
    value: function _onDeleteIconClick(index) {
      this.props.onChangeMode({ mode: _routes.Modes.DELETE_NOTES, index: index });
    }
  }, {
    key: "_onEndEditNote",
    value: function _onEndEditNote() {
      this.props.onChangeMode({ mode: "", index: "" });
    }
  }, {
    key: "_onDiscardEditClick",
    value: function _onDiscardEditClick() {
      _reactGa2.default.event({
        category: "Covered in Class",
        action: 'Clicked "Discard"'
      });

      this._onEndEditNote();
    }
  }, {
    key: "_isAddNote",
    value: function _isAddNote() {
      return this.props.modeAndIndex.mode === _routes.Modes.ADD_NOTES;
    }
  }, {
    key: "_isEditNote",
    value: function _isEditNote() {
      return this.props.modeAndIndex.mode === _routes.Modes.EDIT_NOTES;
    }
  }, {
    key: "_isAddingOrEditingNote",
    value: function _isAddingOrEditingNote() {
      return this._isAddNote() || this._isEditNote();
    }
  }, {
    key: "autoSaveNotesIfNeeded",
    value: function autoSaveNotesIfNeeded() {
      if (!this.addInternalNoteControlComponent) return;
      if (!this._isAddingOrEditingNote()) return;

      this.isAutoSaving = true;
      this.addInternalNoteControlComponent.forceSave();
      this.isAutoSaving = false;
    }
  }, {
    key: "_renderNotes",
    value: function _renderNotes() {
      var _this2 = this;

      var _props = this.props,
          state = _props.state,
          internalNotes = _props.internalNotes,
          currentUserId = _props.currentUserId,
          modeAndIndex = _props.modeAndIndex,
          timeZone = _props.timeZone;

      return internalNotes.data.map(function (note, index) {
        var showBottomLine = index + 1 !== internalNotes.data.length || _this2._isAddNote();
        if (parseInt(modeAndIndex.index, 10) === index && _this2._isEditNote()) {
          return _react2.default.createElement(
            "div",
            { className: _style2.default.InternalNotesPart_addNote },
            _react2.default.createElement(_AddInternalNoteControl2.default, {
              ref: function ref(_cmpnt) {
                _this2.addInternalNoteControlComponent = _cmpnt;
              },
              text: note.note,
              onDiscardClick: function onDiscardClick() {
                return _this2._onDiscardEditClick();
              },
              onSaveClick: function onSaveClick(text) {
                return _this2._onSaveNotes(index, text);
              },
              onChange: function onChange() {}
            }),
            showBottomLine && _react2.default.createElement("div", { className: _style2.default.InternalNotesPart_line })
          );
        }
        var canOperate = currentUserId === note.userId && _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.CoveredInClass.AddCommentToInternal);
        var noteViewMode = {
          note: note.note,
          userId: note.userId,
          date: note.updateDateTimeUtc,
          timeZone: timeZone
        };
        return _react2.default.createElement(_InternalNoteView2.default, {
          index: index,
          note: noteViewMode,
          showBottomLine: showBottomLine,
          canOperate: canOperate,
          onEditButtonClick: function onEditButtonClick() {
            return _this2._onEditButtonClick(index);
          },
          onDeleteButtonClick: function onDeleteButtonClick() {
            return _this2._onDeleteIconClick(index);
          }
        });
      });
    }
  }, {
    key: "_onSaveNotes",
    value: function _onSaveNotes(index, text) {
      var isAdding = index < 0;

      _reactGa2.default.event({
        category: "Covered in Class",
        action: 'Clicked "Save"'
      });

      if (!this.isAutoSaving) this._onEndEditNote();

      var newInternalNote = {
        note: text,
        userName: this.props.currentUserName,
        userId: this.props.currentUserId
      };
      if (isAdding) {
        this.props.addInternalNote(this.props.sessionPlanId, newInternalNote);
      } else {
        newInternalNote = this.props.internalNotes.data[index];
        newInternalNote.note = text;
        this.props.editInternalNote(this.props.sessionPlanId, index, newInternalNote);
      }
    }
  }, {
    key: "_renderAddNoteControl",
    value: function _renderAddNoteControl() {
      var _this3 = this;

      if (this._isAddNote()) {
        var index = -1;
        return _react2.default.createElement(
          "div",
          { className: _style2.default.InternalNotesPart_addNote },
          _react2.default.createElement(_AddInternalNoteControl2.default, {
            ref: function ref(_cmpnt) {
              _this3.addInternalNoteControlComponent = _cmpnt;
            },
            noteDescription: NOTE_DESCRIPTION,
            onDiscardClick: function onDiscardClick() {
              return _this3._onEndEditNote();
            },
            onSaveClick: function onSaveClick(text) {
              return _this3._onSaveNotes(index, text);
            },
            onChange: function onChange() {}
          })
        );
      }
    }
  }, {
    key: "_renderConfirmDialog",
    value: function _renderConfirmDialog() {
      var _this4 = this;

      var modeAndIndex = this.props.modeAndIndex;

      if (modeAndIndex.mode !== _routes.Modes.DELETE_NOTES || parseInt(modeAndIndex.index, 10) < 0) {
        return;
      }

      return _react2.default.createElement(_omniCommonUi.ConfirmDialog, {
        isOpen: true,
        content: MESSAGE_DISCARD_FORM,
        primaryButtonContent: CANCEL,
        secondaryButtonContent: DELETE,
        onRequestClose: function onRequestClose() {
          return _this4._onEndEditNote();
        },
        onPrimaryClick: function onPrimaryClick() {
          return _this4._onEndEditNote();
        },
        onSecondaryClick: function onSecondaryClick() {
          _this4._onDeleteButtonClick(modeAndIndex.index);
          _this4._onEndEditNote();
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var internalNotes = this.props.internalNotes;

      if (_is_js2.default.undefined(this.props.sessionPlanId) || _is_js2.default.undefined(internalNotes) || _omniCommonUi.ApiResponseHelper.isLoading(internalNotes) || !_omniCommonUi.ApiResponseHelper.hasSucceeded(internalNotes) || internalNotes.data.length === 0 && !this._isAddNote()) {
        return null;
      }

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: _style2.default.InternalNotesPart },
        _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: "Internal notes" }),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          null,
          this._renderNotes(),
          this._renderAddNoteControl(),
          this._renderConfirmDialog()
        )
      );
    }
  }]);

  return InternalNotesPart;
}(_react.Component);

InternalNotesPart.propTypes = {
  state: _propTypes2.default.object.isRequired,
  modeAndIndex: _propTypes2.default.object.isRequired,
  currentUserId: _propTypes2.default.any,
  currentUserName: _propTypes2.default.string,
  sessionPlanId: _propTypes2.default.string.isRequired,
  internalNotes: _propTypes2.default.object,
  onChangeMode: _propTypes2.default.func,
  fetchInternalNotesIfNeeded: _propTypes2.default.func,
  editInternalNotes: _propTypes2.default.func,
  addInternalNote: _propTypes2.default.func,
  editInternalNote: _propTypes2.default.func,
  deleteInternalNote: _propTypes2.default.func,
  deleteInternalNoteFromServer: _propTypes2.default.func,
  // needed because `ref` from the parent returns connect() :(
  onComponentMounted: _propTypes2.default.func,
  timeZone: _propTypes2.default.string
};

function mapStateToProps(state, ownProps) {
  var internalNotes = state.get("rootReducer").get("internalNotes").get(ownProps.sessionPlanId);
  var currentUserId = _Users.accessors.getCurrentUserId(state);
  currentUserId = currentUserId && parseInt(currentUserId, 10);
  var currentUserName = _Users.accessors.getCurrentUserName(state);
  return {
    state: state,
    internalNotes: internalNotes,
    currentUserId: currentUserId,
    currentUserName: currentUserName,
    timeZone: ownProps.timeZone
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign((0, _redux.bindActionCreators)(_InternalNotes.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(InternalNotesPart);

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1898);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".kZsrWUGCSUQY1QYPQYStw{border-bottom:.07143rem solid #ccc;margin:1.42857rem 0 .71429rem 1.07143rem;-webkit-transition-duration:0ms;-moz-transition-duration:0ms;-o-transition-duration:0ms;transition-duration:0ms}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"InternalNotesPart_addNote": "_1Z0wRRPOxn-Bv9pOGbhsJH",
	"InternalNotesPart_line": "kZsrWUGCSUQY1QYPQYStw"
};

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _routes2 = __webpack_require__(1900);

var _routes3 = _interopRequireDefault(_routes2);

var _component = __webpack_require__(805);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
exports.default = _component2.default;

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _component = __webpack_require__(805);

var _component2 = _interopRequireDefault(_component);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    appBars: {
      sticky: {
        'view-nav': {
          component: _ViewNav2.default,
          order: 3,
          props: {
            hideExpandable: true
          }
        }
      }
    },
    path: 'grammar-pro',
    component: _component2.default,
    canAccess: function canAccess(_ref2) {
      var params = _ref2.params;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.Homework.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.GrammaPro);
    },
    breadcrumbLabels: {
      label: 'Grammar-pro',
      clickable: false
    },
    tab: {
      label: 'grammar-pro',
      order: 13,
      isVisible: function isVisible(params) {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.Homework.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.GrammaPro);
      }
    }
  };
};

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1902);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3XItbwKjX2coP_-V9Gc_Fr{padding:1.42857rem}@media only screen and (min-width:640px){._3XItbwKjX2coP_-V9Gc_Fr{padding:2.14286rem}}._29lZvuDCcyknNi7p2i3bny{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"GrammarPro_wrapper": "_3XItbwKjX2coP_-V9Gc_Fr",
	"GrammarPro_report": "_29lZvuDCcyknNi7p2i3bny"
};

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = grammaPro;

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(1904);

var _model2 = _interopRequireDefault(_model);

var _actions = __webpack_require__(807);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function grammaPro() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_GRAMMA_PRO_SUCCESS:
      return state.set(action.groupId, onSuccess(action.payload));
    default:
      return state;
  }
}

function onSuccess(response) {
  return response.reduce(function (map, item) {
    return map.set('' + item.studentId, _model2.default.create(item));
  }, new _immutable.Map());
}

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(808);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(1905);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(808);

var _model2 = _interopRequireDefault(_model);

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  switch (key) {
    case 'studentId':
      return [key, '' + val];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(809);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1909);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1908);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1B4RE4vquP0Fj23uTUl3Ld{padding:1.42857rem}@media only screen and (min-width:640px){._1B4RE4vquP0Fj23uTUl3Ld{padding:2.14286rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MidtermAndFinalExam_content": "_1B4RE4vquP0Fj23uTUl3Ld"
};

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _ExamRouteVariant = __webpack_require__(591);

var _component = __webpack_require__(809);

var _component2 = _interopRequireDefault(_component);

var _ProgressTestDayView = __webpack_require__(293);

var _ProgressTestCourseView = __webpack_require__(641);

var _ProgressTestRubricView = __webpack_require__(644);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _ProgressTestSessionNav = __webpack_require__(651);

var _ProgressTestSessionNav2 = _interopRequireDefault(_ProgressTestSessionNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAccessable = function isAccessable(state, groupId) {
  var hasPrivilege = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.ProgressTest.View);
  var isTabEnabled = _TabSwitcher2.default.isTabEnabled(state, groupId, _TabSwitcher.TabCodes.MidtermAndFinalExam);
  var progressTestsPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId);
  if (!progressTestsPlan || !progressTestsPlan.data) {
    return hasPrivilege && isTabEnabled;
  }

  var hasMidtermOrFinalExam = progressTestsPlan && progressTestsPlan.data && progressTestsPlan.data.find(function (ptp) {
    return ptp.isUnitQuiz === false;
  });

  return hasPrivilege && isTabEnabled && hasMidtermOrFinalExam;
};

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    appBars: {
      sticky: {
        ptNav: {
          component: _ProgressTestSessionNav2.default,
          props: {
            isUnitQuiz: false
          },
          order: 1
        },
        'view-nav': {
          component: _ViewNav2.default,
          props: {
            showExpandable: true
          },
          order: 3
        }
      }
    },
    path: 'exam',
    component: _component2.default,
    canAccess: function canAccess(_ref2) {
      var params = _ref2.params,
          location = _ref2.location,
          replace = _ref2.replace;

      var state = getState();
      var groupId = params.groupId;

      var variant = (0, _ExamRouteVariant.resolveExamRouteVariant)(state, groupId);
      if (variant) {
        var nextPath = (0, _ExamRouteVariant.rewriteBaseExamPath)(location.pathname, variant.pathSegment);
        replace(nextPath + (location.search || ''));
        return true;
      }

      return isAccessable(state, groupId);
    },
    tab: {
      label: 'M_F Exam',
      order: 7,
      isVisible: function isVisible(params) {
        return isAccessable(getState(), params.groupId);
      }
    },
    breadcrumbLabels: function breadcrumbLabels(props) {
      var _props$params = props.params,
          groupId = _props$params.groupId,
          progressTestIndex = _props$params.progressTestIndex,
          buildRoute = props.buildRoute;

      var currentProps = (0, _component.mapStateToProps)(getState(), props);
      if (!currentProps || !currentProps.currentProgressTestPlan) return;
      return {
        label: currentProps.currentProgressTestPlan.name,
        href: buildRoute('/group/' + groupId + '/exam/' + progressTestIndex + '/course')
      };
    },
    childRoutes: [_ProgressTestDayView.routes, _ProgressTestCourseView.routes, _ProgressTestRubricView.routes]
  };
};

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(810);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1913);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1912);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1PK1rQKpDsC63sW7z9p93U{padding:1.42857rem}@media only screen and (min-width:640px){._1PK1rQKpDsC63sW7z9p93U{padding:2.14286rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MidtermAndFinalExamHFv4_content": "_1PK1rQKpDsC63sW7z9p93U"
};

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _component = __webpack_require__(810);

var _component2 = _interopRequireDefault(_component);

var _ProgressTestDayView = __webpack_require__(293);

var _CourseView = __webpack_require__(1914);

var _RubricView = __webpack_require__(1921);

var _ViewNavHFv = __webpack_require__(1923);

var _ViewNavHFv2 = _interopRequireDefault(_ViewNavHFv);

var _ProgressTestSessionNavHFv = __webpack_require__(1932);

var _ProgressTestSessionNavHFv2 = _interopRequireDefault(_ProgressTestSessionNavHFv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAccessable = function isAccessable(state, groupId) {
  var hasPrivilege = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.ProgressTest.View);
  var isTabEnabled = _TabSwitcher2.default.isTabEnabled(state, groupId, _TabSwitcher.TabCodes.AssessmentHFv4);
  var progressTestsPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId);
  if (!progressTestsPlan || !progressTestsPlan.data) {
    return hasPrivilege && isTabEnabled;
  }

  var hasMidtermOrFinalExam = progressTestsPlan && progressTestsPlan.data && progressTestsPlan.data.find(function (ptp) {
    return ptp.isUnitQuiz === false;
  });

  return hasPrivilege && isTabEnabled && hasMidtermOrFinalExam;
};

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    appBars: {
      sticky: {
        ptNav: {
          component: _ProgressTestSessionNavHFv2.default,
          props: {
            isUnitQuiz: false
          },
          order: 1
        },
        'view-nav': {
          component: _ViewNavHFv2.default,
          props: {
            showExpandable: true
          },
          order: 3
        }
      }
    },
    path: 'exam-hfv4',
    component: _component2.default,
    canAccess: function canAccess(_ref2) {
      var params = _ref2.params;
      return isAccessable(getState(), params.groupId);
    },
    tab: {
      label: 'Assessment',
      order: 9,
      isVisible: function isVisible(params) {
        return isAccessable(getState(), params.groupId);
      }
    },
    breadcrumbLabels: function breadcrumbLabels(props) {
      var _props$params = props.params,
          groupId = _props$params.groupId,
          progressTestIndex = _props$params.progressTestIndex,
          buildRoute = props.buildRoute;

      var currentProps = (0, _component.mapStateToProps)(getState(), props);
      if (!currentProps || !currentProps.currentProgressTestPlan) return;
      return {
        label: currentProps.currentProgressTestPlan.name,
        href: buildRoute('/group/' + groupId + '/exam-hfv4/' + progressTestIndex + '/course')
      };
    },
    childRoutes: [_ProgressTestDayView.routes, _CourseView.routes, _RubricView.routes]
  };
};

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(811);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1920);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1916);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".nBSfXCAizubvbdIjqRT3D{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:.71429rem 1.42857rem}._3BXZV2BY3C-L6EGsWOsmeQ{display:contents}._2NBzH9IVYoe53BL7g2tLa1{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-left:.35714rem}._7iiGP_5zZv1FCHgiLkK-3{overflow:hidden;padding:0}.rGev7hTjY_fg07jmosR3y{border-top:0}._1ifpANVuis1lFCpTFd7u8{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;border:.07143rem solid transparent;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:1.14286rem}._3jLQt7aPv1-AJAPr7nGcyV{margin-left:.35714rem}._1ifpANVuis1lFCpTFd7u8._2WqThrdYfLNsKBCyC7qTKZ{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;height:2.5rem;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-width:6.42857rem;text-transform:lowercase;width:6.42857rem;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:400;letter-spacing:.03571rem;line-height:1.28571}._1ifpANVuis1lFCpTFd7u8._2WqThrdYfLNsKBCyC7qTKZ ._2C4QSmLSacofUOgwxD4eBm,._1ifpANVuis1lFCpTFd7u8._2WqThrdYfLNsKBCyC7qTKZ ._3-ESz6YcbM6VIhNPi4u9Sc{text-align:right}.jjWqRuR2NIKuJJyj6RRTy{display:inline-block}._1eRCRr3W1bxLmIdJ2suD80:hover{color:#0087e6}.dEjdHK1hfNkuLXEotzftq{max-width:14.28571rem}._2KB5onzCfC74ZaUKIDaCYN{max-width:51.42857rem;opacity:1!important}._2KB5onzCfC74ZaUKIDaCYN .rc-tooltip-inner{background-color:#616161;-webkit-border-radius:.57143rem;-moz-border-radius:.57143rem;border-radius:.57143rem;-webkit-box-shadow:0 .28571rem 1.14286rem rgba(0,0,0,.3);-moz-box-shadow:0 .28571rem 1.14286rem rgba(0,0,0,.3);box-shadow:0 .28571rem 1.14286rem rgba(0,0,0,.3);color:#fff;padding:1.71429rem}._2KB5onzCfC74ZaUKIDaCYN .rc-tooltip-arrow{display:none}._3g088la55ls2LZgePY71a3{font-size:1.28571rem;font-weight:700;margin-bottom:1.14286rem}._Nb0Fh98n9MMRXu24p7vb{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;border-top:.07143rem solid hsla(0,0%,100%,.25);display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:1.42857rem;padding:1.14286rem 0}._3g75N8resHaw6_w9qk0CHv{-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;font-size:1rem;font-weight:700;min-width:5rem}.A74GUg2kcOyeWR4pjCU6l{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1}._17NqZKVgtknEAWDaCZPMZ-{font-size:1.07143rem;font-weight:700;margin-bottom:.28571rem}._3c-pAYCEfTP3uQzB_ZqRRb{font-size:.92857rem;line-height:1.6}.bvCqjvL_2nPgdUpjgVZHo{border-top:.07143rem solid hsla(0,0%,100%,.25);font-size:1.07143rem;font-weight:500;margin-top:.57143rem;padding-top:1.42857rem;text-align:center}._1Z5UtyFIsJGwQ8KNHiSZ0L,._3mfDts1rH77Fo41KThZ6N_{cursor:pointer}._1Z5UtyFIsJGwQ8KNHiSZ0L.YnQWcSu13pqOeL5dvLk88{color:#a4a4a4;pointer-events:none}.rxg8iPN6Ngu79-lyZXEh_{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:600;letter-spacing:.03571rem;line-height:1.28571;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;color:inherit;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;font-size:.85714rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;outline:0;text-decoration:none;text-transform:uppercase}._2Bw_SI_gcVzWdowkO9vAGd{margin-left:.71429rem}._1ob0XZK-KtfyRv7NtOPbBH{color:#a4a4a4;pointer-events:none}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ProgressTestCourseView_cardHeader": "nBSfXCAizubvbdIjqRT3D",
	"ProgressTestCourseView_cardHeader_title": "_3BXZV2BY3C-L6EGsWOsmeQ",
	"ProgressTestCourseView_cardHeader_tooltip": "_2NBzH9IVYoe53BL7g2tLa1",
	"ProgressTestCourseView_content": "_7iiGP_5zZv1FCHgiLkK-3",
	"ProgressTestCourseView_expand": "rGev7hTjY_fg07jmosR3y",
	"ProgressTestCourseView_scoreCell": "_1ifpANVuis1lFCpTFd7u8",
	"ProgressTestCourseView_scoreCell_icon": "_3jLQt7aPv1-AJAPr7nGcyV",
	"__isRubric": "_2WqThrdYfLNsKBCyC7qTKZ",
	"EditableScoreCell_currentScore": "_2C4QSmLSacofUOgwxD4eBm",
	"EditableScoreCell_previousScore": "_3-ESz6YcbM6VIhNPi4u9Sc",
	"ProgressTestCourseView_tooltip": "jjWqRuR2NIKuJJyj6RRTy",
	"ProgressTestCourseView_tooltip_icon": "_1eRCRr3W1bxLmIdJ2suD80",
	"ProgressTestCourseView_tooltip_inner": "dEjdHK1hfNkuLXEotzftq",
	"BenchmarkingTooltip_overlay": "_2KB5onzCfC74ZaUKIDaCYN",
	"BenchmarkingTooltip_title": "_3g088la55ls2LZgePY71a3",
	"BenchmarkingTooltip_row": "_Nb0Fh98n9MMRXu24p7vb",
	"BenchmarkingTooltip_range": "_3g75N8resHaw6_w9qk0CHv",
	"BenchmarkingTooltip_content": "A74GUg2kcOyeWR4pjCU6l",
	"BenchmarkingTooltip_category": "_17NqZKVgtknEAWDaCZPMZ-",
	"BenchmarkingTooltip_descriptor": "_3c-pAYCEfTP3uQzB_ZqRRb",
	"BenchmarkingTooltip_footer": "bvCqjvL_2nPgdUpjgVZHo",
	"BenchmarkingTooltip_gotIt": "_3mfDts1rH77Fo41KThZ6N_",
	"GeneralLink": "_1Z5UtyFIsJGwQ8KNHiSZ0L",
	"__disabled": "YnQWcSu13pqOeL5dvLk88",
	"ProgressReportLink": "rxg8iPN6Ngu79-lyZXEh_",
	"ProgressReportLink_icon": "_2Bw_SI_gcVzWdowkO9vAGd",
	"ProgressReportLink_disabled": "_1ob0XZK-KtfyRv7NtOPbBH"
};

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1918);

var _style2 = _interopRequireDefault(_style);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BASE_NUM_REGEX = /^[0-9]$/;
var DECIMAL_NUM_REGEX = /^[0-9.]$/;

var EditableScoreCell = function (_PureComponent) {
  _inherits(EditableScoreCell, _PureComponent);

  function EditableScoreCell() {
    _classCallCheck(this, EditableScoreCell);

    var _this = _possibleConstructorReturn(this, (EditableScoreCell.__proto__ || Object.getPrototypeOf(EditableScoreCell)).call(this));

    _this._onMouseDown = _this._onMouseDown.bind(_this);
    _this._onTouchOrClick = _this._onTouchOrClick.bind(_this);
    _this._onFocus = _this._onFocus.bind(_this);
    _this._onKeyDown = _this._onKeyDown.bind(_this);
    _this._selectTheWholeText = _this._selectTheWholeText.bind(_this);
    return _this;
  }

  _createClass(EditableScoreCell, [{
    key: '_onMouseDown',
    value: function _onMouseDown(ev) {
      if (!this.props.isEditableScore) return;
      ev.preventDefault();
    }
  }, {
    key: '_onTouchOrClick',
    value: function _onTouchOrClick(ev) {
      ev.preventDefault();
      if (!this.props.isEditableScore) return;
      var htmlEl = this.contentEditableComp.htmlEl;

      htmlEl && htmlEl.focus();
    }
  }, {
    key: '_onFocus',
    value: function _onFocus() {
      this._selectTheWholeText();
    }
  }, {
    key: '_onKeyDown',
    value: function _onKeyDown(ev) {
      var _props = this.props,
          score = _props.score,
          fullMark = _props.fullMark,
          allowDecimal = _props.allowDecimal;

      (0, _invariant2.default)(_is_js2.default.number(fullMark), 'fullMark must be numeric');
      (0, _invariant2.default)(_is_js2.default.string(ev.key), 'ev.key must be a string');
      if (ev.key.startsWith('Arrow')) {
        ev.preventDefault();
        ev.stopPropagation();
        return;
      }
      if (ev.ctrlKey || ev.metaKey || ev.key.length !== 1) return true;

      var keyRegex = allowDecimal ? DECIMAL_NUM_REGEX : BASE_NUM_REGEX;
      if (!keyRegex.test(ev.key)) {
        ev.preventDefault();
        return;
      }

      var currentValue = '';
      if (this.contentEditableComp && this.contentEditableComp.htmlEl) {
        currentValue = this.contentEditableComp.htmlEl.textContent || '';
      } else {
        currentValue = _is_js2.default.number(score) || _is_js2.default.string(score) ? score.toString() : '';
      }

      var selection = window.getSelection().toString();
      var newScore = void 0;
      if (selection) {
        newScore = currentValue.replace(selection, ev.key);
      } else {
        newScore = '' + currentValue + ev.key;
      }

      var _newScore$split = newScore.split('.'),
          _newScore$split2 = _slicedToArray(_newScore$split, 2),
          integerPart = _newScore$split2[0],
          _newScore$split2$ = _newScore$split2[1],
          decimalPart = _newScore$split2$ === undefined ? '' : _newScore$split2$;

      if (allowDecimal) {
        if (ev.key === '.' && newScore.split('.').length - 1 > 1) {
          ev.preventDefault();
          return;
        }

        if (integerPart === '' && ev.key === '.') {
          return;
        }

        if (decimalPart.length > 2) {
          ev.preventDefault();
          return;
        }
      }

      if (integerPart.length > 2 || integerPart.startsWith('0') && integerPart.length > 1) {
        ev.preventDefault();
        return;
      }

      var numericValue = Number.parseFloat(newScore);
      console.log(numericValue);
      if (!isNaN(numericValue) && numericValue > fullMark) {
        ev.preventDefault();
      }
    }
  }, {
    key: '_selectTheWholeText',
    value: function _selectTheWholeText() {
      (0, _omniCommonUi.selectElementContents)(this.contentEditableComp.htmlEl);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          className = _props2.className,
          score = _props2.score,
          previousScore = _props2.previousScore,
          isEditableScore = _props2.isEditableScore,
          fullMark = _props2.fullMark,
          onChange = _props2.onChange;
      var showAsPercentage = this.props.showAsPercentage;

      var displayAsPercentage = showAsPercentage && !isEditableScore;
      var isPreviousScoreShown = !isEditableScore && _is_js2.default.number(previousScore) && previousScore !== score;
      var previousScorePart = isPreviousScoreShown ? _react2.default.createElement(
        'div',
        { className: _style2.default.EditableScoreCell_previousScore },
        _react2.default.createElement(
          'span',
          { className: (0, _omniCommonUi.testClass)('previous-score') },
          displayAsPercentage ? Math.round(previousScore * 100 / fullMark) + '%' : previousScore
        ),
        !displayAsPercentage && '/' + fullMark
      ) : null;
      var scoreStyle = {};
      if (score / fullMark < 0.6 && !isEditableScore) {
        scoreStyle = _style2.default.EditableScoreCell_low;
      } else {
        scoreStyle = _style2.default.EditableScoreCell;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames3.default)(scoreStyle, className, _defineProperty({}, _style2.default.__editable, isEditableScore)),
          ref: function ref(_ref2) {
            _this2.outerNode = _ref2;
          },
          onMouseDown: this._onMouseDown,
          onClick: this._onTouchOrClick,
          onTouchStart: this._onTouchOrClick },
        _react2.default.createElement(
          'div',
          { className: _style2.default.EditableScoreCell_currentScore },
          _react2.default.createElement(_omniCommonUi.ContentEditable, { className: (0, _classnames3.default)(_style2.default.EditableScoreCell_currentScore_editor, (0, _omniCommonUi.testClass)('score-editor')),
            ref: function ref(_ref) {
              _this2.contentEditableComp = _ref;
            },
            html: displayAsPercentage && _is_js2.default.number(score) ? Math.round(score * 100 / fullMark) + '%' : _is_js2.default.number(score) ? score.toString() : '',
            disabled: !isEditableScore,
            onFocus: this._onFocus,
            onChange: onChange,
            onKeyDown: this._onKeyDown,
            onMouseDown: this._onMouseDown,
            onClick: this._selectTheWholeText,
            onTouchStart: this._selectTheWholeText }),
          !displayAsPercentage && _react2.default.createElement(
            'span',
            { className: _style2.default.EditableScoreCell_currentScoreFullMark },
            '/',
            fullMark
          )
        ),
        previousScorePart
      );
    }
  }]);

  return EditableScoreCell;
}(_react.PureComponent);

EditableScoreCell.propTypes = {
  className: _propTypes2.default.string,
  score: _propTypes2.default.number,
  previousScore: _propTypes2.default.number,
  fullMark: _propTypes2.default.number.isRequired,
  isEditableScore: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  allowDecimal: _propTypes2.default.bool,
  showAsPercentage: _propTypes2.default.bool
};

EditableScoreCell.defaultProps = {
  className: '',
  score: 0,
  previousScore: null,
  isEditableScore: false,
  onChange: function onChange() {},
  allowDecimal: false,
  showAsPercentage: false
};

exports.default = EditableScoreCell;

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1919);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2Seg5pAJWqrBCTtVNyhQkN{border:.07143rem solid transparent;-webkit-border-radius:.35714rem;-moz-border-radius:.35714rem;border-radius:.35714rem;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-transition:background .3s ease-in-out;-o-transition:background .3s ease-in-out;-moz-transition:background .3s ease-in-out;transition:background .3s ease-in-out;width:6.42857rem;@nest &.__editable &_currentScore_editor{cursor:text}@nest &:not(.__editable) &_currentScore_editor{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}}._3-1Y-DqB2lAS4JGCN5vNCs{background-color:#fbcb22}._2Seg5pAJWqrBCTtVNyhQkN [contentEditable=true]{cursor:text;min-width:.71429rem}._2Seg5pAJWqrBCTtVNyhQkN._2bVcDEscnk2993bYcHQfgb{background-color:#fff;border-color:#ccc;cursor:text;min-height:2.5rem;padding:.35714rem 1.07143rem}._3qm39dkJwX1Qqu_2V2ol-E{display:inline;-webkit-user-select:auto;-moz-user-select:auto;-ms-user-select:auto;user-select:auto}._3XEEftOwUItqB2tBDKAsvm,._36X6jfAZGHjULPsR0AdpUX{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._3XEEftOwUItqB2tBDKAsvm{color:#a4a4a4;font-size:75%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"EditableScoreCell": "_2Seg5pAJWqrBCTtVNyhQkN",
	"EditableScoreCell_low": "_3-1Y-DqB2lAS4JGCN5vNCs",
	"__editable": "_2bVcDEscnk2993bYcHQfgb",
	"EditableScoreCell_currentScore_editor": "_3qm39dkJwX1Qqu_2V2ol-E",
	"EditableScoreCell_previousScore": "_3XEEftOwUItqB2tBDKAsvm",
	"EditableScoreCell_currentScoreFullMark": "_36X6jfAZGHjULPsR0AdpUX"
};

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omniCommonUi = __webpack_require__(0);

var _accessors = __webpack_require__(52);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _component = __webpack_require__(811);

var _component2 = _interopRequireDefault(_component);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PT_VIEWER_NAME = 'Assessment Viewer';
var SHOW_MARK_BUTTON = false;

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: ':progressTestIndex/course(/:mode)',
    view: 'course',
    component: _component2.default,
    sessionNavConfig: {
      setModeOnNavigate: ''
    },
    canAccess: function canAccess(props) {
      if (!_component2.default.isInMarkingRoute(props)) {
        return true;
      }
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressTest.Edit);
    },
    breadcrumbLabels: function breadcrumbLabels(_ref2) {
      var params = _ref2.params;

      if (params.mode === 'edit') return 'Edit';
      return [];
    },
    actionButtons: {
      default: _defineProperty({
        Mark: {
          route: './edit',
          visibleWhen: function visibleWhen(_ref3) {
            var location = _ref3.location,
                params = _ref3.params;

            var isUnitQuiz = (0, _accessors.checkIsUnitQuiz)(location.pathname);
            return SHOW_MARK_BUTTON && _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressTest.Edit) && (0, _accessors.isMarkable)(getState(), params.groupId, Number.parseInt(params.progressTestIndex, 10), isUnitQuiz);
          },
          isPrimary: true
        }
      }, PT_VIEWER_NAME, {
        label: function label() {
          return _omniCommonUi.Config.get('hf4OnlineHomeworkViewerUrl') ? PT_VIEWER_NAME : '';
        },
        newTab: true,
        linkHref: function linkHref(_ref4) {
          var pathname = _ref4.location.pathname,
              _ref4$params = _ref4.params,
              groupId = _ref4$params.groupId,
              progressTestIndex = _ref4$params.progressTestIndex;

          return buildAssessmentViewerUrl(getState(), groupId, progressTestIndex, pathname);
        },
        visibleWhen: function visibleWhen(_ref5) {
          var pathname = _ref5.location.pathname,
              _ref5$params = _ref5.params,
              groupId = _ref5$params.groupId,
              progressTestIndex = _ref5$params.progressTestIndex;

          var state = getState();

          if (_.actions.isSSCourseTypeGroup(state, groupId) || _.actions.isNotTBv3Group(state, groupId)) {
            return false;
          }

          return !!buildAssessmentViewerUrl(state, groupId, progressTestIndex, pathname);
        },
        disableWhen: function disableWhen(_ref6) {
          var pathname = _ref6.location.pathname,
              _ref6$params = _ref6.params,
              groupId = _ref6$params.groupId,
              progressTestIndex = _ref6$params.progressTestIndex;

          return !buildAssessmentViewerUrl(getState(), groupId, progressTestIndex, pathname);
        }
      }),
      edit: {
        Save: {
          isPrimary: true,
          route: '../save'
        },
        Discard: {
          route: '../discard'
        }
      }
    }
  };
};

function getExamType(name) {
  if (name === 'Midterm Exam') return 'midterm';
  if (name === 'Final Exam') return 'final';
  return null;
}

function buildAssessmentViewerUrl(state, groupId, progressTestIndex, pathname) {
  var baseUrl = _omniCommonUi.Config.get('hf4OnlineHomeworkViewerUrl');
  if (!baseUrl) return null;

  var isUnitQuiz = (0, _accessors.checkIsUnitQuiz)(pathname);
  var plan = (0, _accessors.getProgressTestPlanFromIndex)(state, groupId, progressTestIndex, isUnitQuiz);
  if (!plan) return null;

  var examType = getExamType(plan.name);
  if (!examType) return null;

  return baseUrl + '/?type=' + examType + '&groupId=' + groupId;
}

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(300);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1922);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _omniCommonUi = __webpack_require__(0);

var _component = __webpack_require__(300);

var _component2 = _interopRequireDefault(_component);

var _StudentHorizontalSelect = __webpack_require__(650);

var _StudentHorizontalSelect2 = _interopRequireDefault(_StudentHorizontalSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    appBars: {
      sticky: {
        'student-select': {
          component: _StudentHorizontalSelect2.default,
          order: 2
        }
      }
    },
    path: ':progressTestIndex/student/:studentId/skill/:skillIndex(/:mode)',
    view: 'student',
    component: _component2.default,
    sessionNav: {
      noUnitSessionNavigation: true
    },
    canAccess: function canAccess(props) {
      if (!_component2.default.isInMarkingRoute(props)) {
        return true;
      }

      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressTest.Edit);
    },
    breadcrumbLabels: function breadcrumbLabels(props) {
      var mappedProps = (0, _component.mapStateToProps)(getState(), props);
      var currentSkill = mappedProps.currentSkill;
      var params = props.params;

      var segments = [currentSkill && currentSkill.name];
      if (params.mode === 'edit') segments.push('Edit');
      return segments;
    },
    actionButtons: {
      default: {
        Mark: {
          isPrimary: true,
          route: './edit',
          visibleWhen: function visibleWhen(_ref2) {
            var isMarkable = _ref2.isMarkable,
                params = _ref2.params;

            var state = getState();
            var groupId = params.groupId,
                studentId = params.studentId,
                progressTestIndex = params.progressTestIndex;

            var hasPrivilege = _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.ProgressTest.Edit);
            var contentMap = state.get('rootReducer').get('contentMaps').get(groupId).data;
            var currentProgressTestId = contentMap.progressTests.get(progressTestIndex).progressTestId;
            var currentProgressTest = state.get('rootReducer').get('progressTests').get(currentProgressTestId);
            if (currentProgressTest) {
              currentProgressTest = currentProgressTest.data;
            } else {
              return true;
            }
            if (_is_js2.default.not.undefined(currentProgressTest)) {
              var currentStudentResult = currentProgressTest.studentProgressTestResults.get(studentId);
              return hasPrivilege && currentStudentResult.canBeOverwrite && isMarkable;
            }
            return hasPrivilege && isMarkable;
          },
          disableWhen: function disableWhen(_ref3) {
            var _ref3$params = _ref3.params,
                groupId = _ref3$params.groupId,
                progressTestIndex = _ref3$params.progressTestIndex;

            var state = getState();
            var contentMap = state.get('rootReducer').get('contentMaps').get(groupId).data;
            var currentProgressTestId = contentMap.progressTests.get(progressTestIndex).progressTestId;
            var currentProgressTest = state.get('rootReducer').get('progressTests').get(currentProgressTestId);
            if (!currentProgressTest) {
              return true;
            }
            return false;
          }
        }
      },
      edit: {
        Save: {
          isPrimary: true,
          route: '../save'
        },
        Discard: {
          route: '../discard'
        }
      }
    }
  };
};

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewNavHFv4 = exports.fnToValue = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(1924);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _ViewNavBig = __webpack_require__(1926);

var _ViewNavBig2 = _interopRequireDefault(_ViewNavBig);

var _ViewNavSmall = __webpack_require__(1929);

var _ViewNavSmall2 = _interopRequireDefault(_ViewNavSmall);

var _ViewNavButton = __webpack_require__(333);

var _ViewNavButton2 = _interopRequireDefault(_ViewNavButton);

var _ViewNavExtra = __webpack_require__(334);

var _ViewNavExtra2 = _interopRequireDefault(_ViewNavExtra);

var _omniCommonUi = __webpack_require__(0);

var _immutable = __webpack_require__(3);

var _UiState = __webpack_require__(30);

var _classnames3 = __webpack_require__(7);

var _classnames4 = _interopRequireDefault(_classnames3);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EDIT_MODE_MATCH_REGEXP = new RegExp("^edit$", "i");
var HIDE_EXTRA_ICON = true;

var fnToValue = exports.fnToValue = function fnToValue(any, props) {
  if (_is_js2.default.function(any)) {
    return any(props);
  }
  return any;
};

var ViewNavHFv4 = exports.ViewNavHFv4 = function (_Component) {
  _inherits(ViewNavHFv4, _Component);

  function ViewNavHFv4(props) {
    _classCallCheck(this, ViewNavHFv4);

    var _this = _possibleConstructorReturn(this, (ViewNavHFv4.__proto__ || Object.getPrototypeOf(ViewNavHFv4)).call(this, props));

    _this._queryListener = _this._queryListener.bind(_this);
    _this._query = (0, _omniCommonUi.mediaQuery)("(min-width: 639px)");
    _this._setButtonsToDisplay(_this.props);
    _this.state = { big: _this._query.matches };
    return _this;
  }

  _createClass(ViewNavHFv4, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._query.addListener(this._queryListener);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      this._setButtonsToDisplay(props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._query.removeListener(this._queryListener);
    }
  }, {
    key: "_queryListener",
    value: function _queryListener(mql) {
      this.setState({ big: mql.matches });
    }
  }, {
    key: "_setButtonsToDisplay",
    value: function _setButtonsToDisplay(props) {
      var currentRoute = ViewNavHFv4.getCurrentRouteSegment(props);
      var currentModeName = props.params && props.params.mode && props.params.mode.length ? props.params.mode : "default";

      if (EDIT_MODE_MATCH_REGEXP.test(currentModeName)) {
        this._buttons = new _immutable.Map();
        return;
      }

      var actionButtonsMap = {};
      var actionButtonsForMode = void 0;
      if (currentRoute.actionButtons && currentRoute.actionButtons[currentModeName]) {
        actionButtonsForMode = currentRoute.actionButtons[currentModeName];
        Object.assign(actionButtonsMap, actionButtonsForMode);
      }

      var buttonsToDisplay = Object.keys(actionButtonsMap).filter(function (buttonLabel) {
        var buttonDescriptor = actionButtonsMap[buttonLabel];
        try {
          if (_is_js2.default.function(buttonDescriptor.visibleWhen)) {
            if (buttonDescriptor.visibleWhen.length < 2) {
              return buttonDescriptor.visibleWhen(props);
            } else if (!buttonDescriptor.visibleWhen(props.state, props)) {
              return false;
            }
          }
        } catch (err) {
          _omniCommonUi.log.warn("Error in `visibleWhen` in route `" + currentRoute.path + "`", err);
        }
        return true;
      });

      this._buttons = new _immutable.Map(actionButtonsMap).filter(function (v, key) {
        return buttonsToDisplay.indexOf(key) >= 0;
      });
    }
  }, {
    key: "_getIsDisabled",
    value: function _getIsDisabled(buttonDescriptor) {
      var props = this.props;
      try {
        if (_is_js2.default.function(buttonDescriptor.disableWhen)) {
          if (buttonDescriptor.disableWhen.length < 2) {
            return buttonDescriptor.disableWhen(props);
          } else if (buttonDescriptor.disableWhen(props.state, props)) {
            return true;
          }
        }
      } catch (err) {
        var currentRoute = ViewNavHFv4.getCurrentRouteSegment(this.props);
        _omniCommonUi.log.warn("Error in `disableWhen` in route `" + currentRoute.path + "`", err);
      }
      return false;
    }
  }, {
    key: "_getOnClickHandler",
    value: function _getOnClickHandler(buttonDescriptor, buttonLabel) {
      var _this2 = this;

      if (buttonDescriptor.onClick) {
        return function () {
          registerClick();
          return buttonDescriptor.onClick.call(_this2, _this2.props.state, _this2.props);
        };
      }

      return buttonDescriptor.route && function () {
        registerClick();
        return _this2._redirect(fnToValue(buttonDescriptor.route, _this2.props));
      };

      function registerClick() {
        _reactGa2.default.event({
          category: "Navigation",
          action: "Clicked action button",
          label: "Clicked " + buttonLabel + " in the top toolbar"
        });
      }
    }
  }, {
    key: "_redirect",
    value: function _redirect(param) {
      var _props = this.props,
          pushRoute = _props.pushRoute,
          buildRoute = _props.buildRoute;

      pushRoute(buildRoute(param));
    }
  }, {
    key: "_hasButtons",
    value: function _hasButtons() {
      return this._buttons.size > 0;
    }
  }, {
    key: "_hasExtra",
    value: function _hasExtra() {
      var _ref = ViewNavHFv4.getCurrentRouteSegment(this.props) || {},
          settings = _ref.sessionNav;

      if (this.props.showExpandable) {
        return true;
      }
      return this.props.hideExpandable !== true && (!settings || settings.noUnitSessionNavigation !== true);
    }
  }, {
    key: "_renderExpandIcon",
    value: function _renderExpandIcon() {
      var _props2 = this.props,
          showNavigationBar = _props2.showNavigationBar,
          toggleNavigation = _props2.toggleNavigation;


      if (!this._hasExtra() || HIDE_EXTRA_ICON) {
        return null;
      }

      var iconClass = (0, _classnames4.default)(_style2.default.ViewNav_expandIcon, _defineProperty({}, _style2.default.__reverse, showNavigationBar), _defineProperty({}, _style2.default.__sticky, this.state.stickToTop));

      return _react2.default.createElement(
        _ViewNavExtra2.default,
        null,
        _react2.default.createElement(_omniCommonUi.Icon, {
          id: "chevron-fat-down",
          className: iconClass,
          onClick: toggleNavigation
        })
      );
    }
  }, {
    key: "_renderButtons",
    value: function _renderButtons() {
      var _this3 = this;

      return this._buttons.map(function (buttonDescriptor, buttonLabel) {
        var title = _is_js2.default.function(buttonDescriptor.label) ? buttonDescriptor.label(_this3.props) : buttonLabel;
        var className = (0, _omniCommonUi.testClass)("viewnav-button-" + title.replace(/\s+/g, "-").toLowerCase());
        return _react2.default.createElement(_ViewNavButton2.default, {
          key: buttonLabel,
          title: title,
          className: className,
          isPrimary: buttonDescriptor.isPrimary,
          disabled: _this3._getIsDisabled(buttonDescriptor),
          onClick: _this3._getOnClickHandler(buttonDescriptor, buttonLabel),
          newTab: buttonDescriptor.newTab,
          linkHref: fnToValue(buttonDescriptor.linkHref, _this3.props)
        });
      }).toArray();
    }
  }, {
    key: "_renderContent",
    value: function _renderContent() {
      var ViewNavImpl = this.state.big ? _ViewNavBig2.default : _ViewNavSmall2.default;
      return _react2.default.createElement(
        ViewNavImpl,
        null,
        this._renderButtons(),
        this._renderExpandIcon()
      );
    }
  }, {
    key: "render",
    value: function render() {
      var currentRoute = ViewNavHFv4.getCurrentRouteSegment(this.props);
      if (currentRoute && currentRoute.actionButtons && currentRoute.actionButtons.hidden === true) {
        return null;
      }
      if (!this._hasButtons() && !this._hasExtra()) {
        return null;
      }
      var ViewNavImpl = this.state.big ? _ViewNavBig2.default : _ViewNavSmall2.default;
      return _react2.default.createElement(
        ViewNavImpl,
        null,
        this._renderButtons(),
        this._renderExpandIcon()
      );
    }
  }]);

  return ViewNavHFv4;
}(_react.Component);

ViewNavHFv4.getCurrentRouteSegment = function (_ref2) {
  var routes = _ref2.routes;
  return routes ? routes[routes.length - 1] : {};
};

ViewNavHFv4.propTypes = {
  isMarkable: _propTypes2.default.bool,
  state: _propTypes2.default.object,
  routes: _propTypes2.default.array.isRequired,
  location: _propTypes2.default.object.isRequired,
  params: _propTypes2.default.object.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  toggleNavigation: _propTypes2.default.func.isRequired,
  showNavigationBar: _propTypes2.default.bool.isRequired,
  hideExpandable: _propTypes2.default.bool,
  showExpandable: _propTypes2.default.bool
};

function mapStateToProps(state) {
  var showNavigationBar = _UiState.actions.getShowNavigationBar(state);
  return { showNavigationBar: showNavigationBar };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_UiState.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(ViewNavHFv4);

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1925);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._16UHoQYUMOc1g3VJjHUCi_{width:100%}.uL4IOpqIg-32bpgqyGxx_{background-position:50%;background-repeat:no-repeat;-webkit-background-size:contain;-moz-background-size:contain;background-size:contain;content:\"\";cursor:pointer;display:block;font-size:.85714rem;-webkit-transition:-webkit-transform .3s ease-in-out;transition:-webkit-transform .3s ease-in-out;-o-transition:-o-transform .3s ease-in-out;-moz-transition:transform .3s ease-in-out,-moz-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out,-moz-transform .3s ease-in-out,-o-transform .3s ease-in-out}.uL4IOpqIg-32bpgqyGxx_._1yOWJ_ohHaDI9Rv8fdw9Od{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg)}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ViewNav": "_16UHoQYUMOc1g3VJjHUCi_",
	"ViewNav_expandIcon": "uL4IOpqIg-32bpgqyGxx_",
	"__reverse": "_1yOWJ_ohHaDI9Rv8fdw9Od"
};

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(1927);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _ViewNavButton = __webpack_require__(333);

var _ViewNavButton2 = _interopRequireDefault(_ViewNavButton);

var _ViewNavExtra = __webpack_require__(334);

var _ViewNavExtra2 = _interopRequireDefault(_ViewNavExtra);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewNavBig = function ViewNavBig(_ref) {
  var children = _ref.children;

  var childrenArr = _react2.default.Children.toArray(children);
  var className = _style2.default.ViewNavBig;
  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'div',
      { className: (0, _omniCommonUi.testClass)('viewnav-action-buttons') },
      childrenArr.filter(function (child) {
        return child.type === _ViewNavButton2.default;
      })
    ),
    childrenArr.find(function (child) {
      return child.type === _ViewNavExtra2.default;
    })
  );
};

ViewNavBig.propTypes = {
  children: _propTypes2.default.arrayOf(function (arr) {
    return arr.every(function (val) {
      if (_is_js2.default.array(val) && val.every(function (comp) {
        return comp.type === 'ViewNavButton';
      })) return true;
      if (val.type === 'ViewNavButton' || val.type === 'ViewNavExtra') return true;
      return new Error('\'children\' invalid. got ' + val);
    });
  })
};

exports.default = ViewNavBig;

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1928);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2IjtbGVUPpbdg_f7DZpkAF{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:#f3f5f7;border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:3.92857rem;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;overflow:hidden;padding:0;padding-left:1.42857rem;padding-right:1.42857rem}@media only screen and (min-width:640px){._2IjtbGVUPpbdg_f7DZpkAF{padding-left:2.14286rem;padding-right:2.14286rem}}._2IjtbGVUPpbdg_f7DZpkAF button{overflow:hidden;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ViewNavBig": "_2IjtbGVUPpbdg_f7DZpkAF"
};

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1930);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ViewNavButton = __webpack_require__(333);

var _ViewNavButton2 = _interopRequireDefault(_ViewNavButton);

var _ViewNavExtra = __webpack_require__(334);

var _ViewNavExtra2 = _interopRequireDefault(_ViewNavExtra);

var _omniCommonUi = __webpack_require__(0);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewNavSmall = function (_Component) {
  _inherits(ViewNavSmall, _Component);

  function ViewNavSmall(props) {
    _classCallCheck(this, ViewNavSmall);

    var _this = _possibleConstructorReturn(this, (ViewNavSmall.__proto__ || Object.getPrototypeOf(ViewNavSmall)).call(this, props));

    _this.state = { open: false };
    _this._setUp(props);
    return _this;
  }

  _createClass(ViewNavSmall, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(props) {
      this._setUp(props);
    }
  }, {
    key: '_setUp',
    value: function _setUp(props) {
      var childrenArr = _react2.default.Children.toArray(props.children);
      this._buttons = childrenArr.filter(function (child) {
        return child.type === _ViewNavButton2.default;
      });
      this._extra = childrenArr.find(function (child) {
        return child.type === _ViewNavExtra2.default;
      });
    }
  }, {
    key: '_toggleDropdown',
    value: function _toggleDropdown(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.setState({ open: !this.state.open });
    }
  }, {
    key: '_renderDropdown',
    value: function _renderDropdown() {
      var _this2 = this;

      if (this._buttons.length <= 0) {
        return _react2.default.createElement('div', null);
      }

      return _react2.default.createElement(
        _omniCommonUi.DropdownBox.Container,
        { className: _style2.default.ViewNavSmall_container,
          onClickOutside: function onClickOutside() {
            return _this2.setState({ open: false });
          } },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_style2.default.ViewNavSmall_expand, (0, _omniCommonUi.testClass)('viewnav-expand-action-buttons')),
            onClick: function onClick(e) {
              return _this2._toggleDropdown(e);
            } },
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'dots' })
        ),
        _react2.default.createElement(
          _omniCommonUi.DropdownBox,
          { className: (0, _classnames2.default)(_style2.default.ViewNavSmall_dropdown, (0, _omniCommonUi.testClass)('viewnav-action-buttons')),
            open: this.state.open },
          this._buttons.map(function (_ref) {
            var props = _ref.props;
            return _react2.default.createElement(
              _omniCommonUi.DropdownBox.Item,
              { className: _style2.default.ViewNavSmall_item },
              _react2.default.createElement(
                _omniCommonUi.Button,
                _extends({}, props, {
                  className: (0, _classnames2.default)(_style2.default.ViewNavSmall_item_button, props.className) }),
                props.title
              )
            );
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _style2.default.ViewNavSmall },
        this._renderDropdown(),
        this._extra
      );
    }
  }]);

  return ViewNavSmall;
}(_react.Component);

ViewNavSmall.propTypes = {
  children: _propTypes2.default.arrayOf(_ViewNavButton2.default)
};

exports.default = ViewNavSmall;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1931);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._16jS2W7wXHyqTtnibj24yR{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:#f3f5f7;border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:2.85714rem;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0;z-index:500;padding-left:1.42857rem;padding-right:1.42857rem}@media only screen and (min-width:640px){._16jS2W7wXHyqTtnibj24yR{padding-left:2.14286rem;padding-right:2.14286rem}}._2bLZJEHlZIW_xHmXjsDc4v{height:100%;position:relative}._2bLZJEHlZIW_xHmXjsDc4v,.jJ361IrTaWoORz3zrY4n3{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.jJ361IrTaWoORz3zrY4n3{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-color:#0087e6;color:#fff;cursor:pointer;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-left:-1.42857rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:2.85714rem}._2o0sgO8iM_oOueqWNQMa2a{background-color:#f3f5f7;left:-1.42857rem;position:absolute;top:2.85714rem;z-index:500}._2jKkgM3QodZvkrii-Z2N2t{padding:0}._3kyc_zZ25C3aAVLl1LLWhs{background:transparent!important;border:none!important;-webkit-border-radius:0!important;-moz-border-radius:0!important;border-radius:0!important;-webkit-box-shadow:100%!important;-moz-box-shadow:100%!important;box-shadow:100%!important;color:inherit!important;display:block;height:100%!important;min-height:2.5rem!important;min-width:0!important;width:100%!important;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:.85714rem;font-weight:600;letter-spacing:.07143rem;text-transform:uppercase}._2jKkgM3QodZvkrii-Z2N2t>._3kyc_zZ25C3aAVLl1LLWhs{padding:0 1.42857rem!important}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ViewNavSmall": "_16jS2W7wXHyqTtnibj24yR",
	"ViewNavSmall_container": "_2bLZJEHlZIW_xHmXjsDc4v",
	"ViewNavSmall_expand": "jJ361IrTaWoORz3zrY4n3",
	"ViewNavSmall_dropdown": "_2o0sgO8iM_oOueqWNQMa2a",
	"ViewNavSmall_item": "_2jKkgM3QodZvkrii-Z2N2t",
	"ViewNavSmall_item_button": "_3kyc_zZ25C3aAVLl1LLWhs"
};

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _BaseSessionNav2 = __webpack_require__(108);

var _BaseSessionNav3 = _interopRequireDefault(_BaseSessionNav2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _immutable = __webpack_require__(3);

var _accessors = __webpack_require__(52);

var _UiState = __webpack_require__(30);

var _ = __webpack_require__(13);

var _Month = __webpack_require__(211);

var _Weekday = __webpack_require__(697);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressTestSessionNavHFv4 = function (_BaseSessionNav) {
  _inherits(ProgressTestSessionNavHFv4, _BaseSessionNav);

  function ProgressTestSessionNavHFv4() {
    _classCallCheck(this, ProgressTestSessionNavHFv4);

    return _possibleConstructorReturn(this, (ProgressTestSessionNavHFv4.__proto__ || Object.getPrototypeOf(ProgressTestSessionNavHFv4)).apply(this, arguments));
  }

  _createClass(ProgressTestSessionNavHFv4, [{
    key: '_hasNext',
    value: function _hasNext() {
      return this.props.currentProgressTestIndex < this.props.progressTestCount - 1;
    }
  }, {
    key: '_hasPrevious',
    value: function _hasPrevious() {
      return this.props.currentProgressTestIndex > 0;
    }
  }, {
    key: '_hasNextUnit',
    value: function _hasNextUnit() {
      return this.props.currentProgressTestIndex < this.props.progressTestCount - 1;
    }
  }, {
    key: '_hasPreviousUnit',
    value: function _hasPreviousUnit() {
      return this.props.currentProgressTestIndex > 0;
    }
  }, {
    key: '_getHeadingText',
    value: function _getHeadingText() {
      var name = this.props.currentProgressTestName || '';
      if (name === 'Midterm Exam') return 'Midterm';
      if (name === 'Final Exam') return 'Final';
      return name;
    }
  }, {
    key: '_getPreviousUnitText',
    value: function _getPreviousUnitText() {
      return '< UNIT ' + this.props.currentProgressTestIndex;
    }
  }, {
    key: '_getNextUnitText',
    value: function _getNextUnitText() {
      return 'UNIT ' + (this.props.currentProgressTestIndex + 2) + ' >';
    }
  }, {
    key: '_getAdditionalChildren',
    value: function _getAdditionalChildren() {
      return this.props.currentProgressTestSessionTime;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.currentProgressTestId) {
        return _get(ProgressTestSessionNavHFv4.prototype.__proto__ || Object.getPrototypeOf(ProgressTestSessionNavHFv4.prototype), 'render', this).call(this);
      }
      return null;
    }
  }]);

  return ProgressTestSessionNavHFv4;
}(_BaseSessionNav3.default);

ProgressTestSessionNavHFv4.propTypes = Object.assign({
  isSSV3Group: _propTypes2.default.bool,
  currentGroupName: _propTypes2.default.string,
  currentProgressTestName: _propTypes2.default.string,
  currentProgressTestIndex: _propTypes2.default.number.isRequired,
  currentProgressTestId: _propTypes2.default.string,
  currentProgressTestSessionTime: _propTypes2.default.string,
  progressTestCount: _propTypes2.default.number.isRequired,
  onNextClicked: _propTypes2.default.func,
  onPreviousClicked: _propTypes2.default.func,
  getProgressTestPlanFromIndex: _propTypes2.default.func,
  isUnitQuiz: _propTypes2.default.bool.isRequired
}, _BaseSessionNav3.default.propTypes);

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      progressTestIndex = _ownProps$params.progressTestIndex;

  if (!progressTestIndex) return;
  var buildRoute = ownProps.buildRoute,
      routes = ownProps.routes,
      isUnitQuiz = ownProps.isUnitQuiz;

  var group = state.get('rootReducer').get('groups').get(groupId) && state.get('rootReducer').get('groups').get(groupId).data;
  var progressTestsPlans = state.get('rootReducer').get('progressTestsPlan').get(groupId);
  var progressTestsPlan = progressTestsPlans && progressTestsPlans.data && progressTestsPlans.data.filter(function (ptp) {
    return ptp.isUnitQuiz === isUnitQuiz;
  });
  var currentProgressTestPlan = (0, _accessors.getProgressTestPlanFromIndex)(state, groupId, progressTestIndex, isUnitQuiz);
  if (group && progressTestsPlan) {
    var currentRoute = routes[routes.length - 1];
    var progressTestId = currentProgressTestPlan.id;
    var progressTests = state.get('rootReducer').get('progressTests');
    var progressTest = _immutable.Map.isMap(progressTests) && progressTests.get(progressTestId);
    var sessionDateTimeUtc = progressTest && progressTest.data && progressTest.data.progressTestSession && progressTest.data.progressTestSession.get('sessionDateTimeUtc');

    return {
      isSSV3Group: !!_.actions.isSSV3Group(state, groupId),
      currentProgressTestId: progressTestId,
      currentProgressTestName: currentProgressTestPlan.name,
      currentProgressTestSessionTime: formatSessionDate(sessionDateTimeUtc),
      currentGroupName: group.name,
      progressTestCount: progressTestsPlan.size,
      currentProgressTestIndex: progressTestIndex,
      nextSessionLinkHref: getNextProgressTestLinkHref(progressTestIndex, currentRoute, buildRoute),
      previousSessionLinkHref: getNextProgressTestLinkHref(progressTestIndex, currentRoute, buildRoute, true),
      isHide: !_UiState.actions.getShowNavigationBar(state)
    };
  }
}

function formatSessionDate(dateStr) {
  if (!dateStr) return '';
  var d = new Date(dateStr);
  if (isNaN(d.getTime())) return '';
  return (0, _Weekday.getWeekdayAbbr)(d.getDay()) + ', ' + d.getDate() + ' ' + (0, _Month.getMonthAbbr)(d.getMonth()) + ' ' + d.getFullYear();
}

function getNextProgressTestLinkHref(index, currentRoute, buildRoute) {
  var previous = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var progressTestIndex = Number.parseInt(index, 10) + (previous ? -1 : 1);
  var sessionNavConfig = currentRoute.sessionNavConfig;

  var newRouteParams = {
    progressTestIndex: progressTestIndex
  };
  if (_is_js2.default.object(sessionNavConfig) && _is_js2.default.string(sessionNavConfig.setModeOnNavigate)) {
    newRouteParams.mode = sessionNavConfig.setModeOnNavigate;
  }
  var tempRoute = buildRoute(newRouteParams);
  return buildRoute('' + tempRoute);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null)(ProgressTestSessionNavHFv4);

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(812);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1936);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1935);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3HRSqiGDPJsO0nZeu37ZZw{padding:1.42857rem}@media only screen and (min-width:640px){._3HRSqiGDPJsO0nZeu37ZZw{padding:2.14286rem}}.tsds8sPNIETo9ldwGcSaU{background:#f3f5f7;padding:1em;padding-left:1.42857rem;padding-right:1.42857rem}@media only screen and (min-width:640px){.tsds8sPNIETo9ldwGcSaU{padding-left:2.14286rem;padding-right:2.14286rem}}._1ADdjqBNOkh6WLBOybte-S{width:100%}@media only screen and (min-width:480px){._1ADdjqBNOkh6WLBOybte-S{width:20%;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}}._2kIGEhsL3lmcYSeFOKxDve{margin-top:1em}._2kIGEhsL3lmcYSeFOKxDve a:hover ._3PaIZ7kb_fJV4cfXa5qpx2{-webkit-filter:invert(100%);filter:invert(100%)}.vQW8cAS7knColHYNZ5vrF{font-size:1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ProgressReport_content": "_3HRSqiGDPJsO0nZeu37ZZw",
	"ProgressReport_studentDropdown": "tsds8sPNIETo9ldwGcSaU",
	"ProgressReport_studentDropdown_selectedItem": "_1ADdjqBNOkh6WLBOybte-S",
	"ProgressReport_studentDropdown_options": "_2kIGEhsL3lmcYSeFOKxDve",
	"ProgressReport_studentDropdown_options_aside_checkmark": "_3PaIZ7kb_fJV4cfXa5qpx2",
	"ProgressReport_studentDropdown_options_checkmark": "vQW8cAS7knColHYNZ5vrF"
};

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omniCommonUi = __webpack_require__(0);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _DosApprovalList = __webpack_require__(1937);

var _StudentReportView = __webpack_require__(1942);

var _routes = __webpack_require__(819);

var _accessors = __webpack_require__(164);

var _component = __webpack_require__(812);

var _component2 = _interopRequireDefault(_component);

var _ProgressReportListView = __webpack_require__(1970);

var _ProgressReportListView2 = _interopRequireDefault(_ProgressReportListView);

var _ProgressReportSessionNav = __webpack_require__(670);

var _ProgressReportSessionNav2 = _interopRequireDefault(_ProgressReportSessionNav);

var _ViewNav = __webpack_require__(47);

var _ViewNav2 = _interopRequireDefault(_ViewNav);

var _ = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    appBars: {
      sticky: {
        navigation: {
          component: _ProgressReportSessionNav2.default,
          order: 1
        },
        'view-nav': {
          component: _ViewNav2.default,
          order: 3
        }
      }
    },
    path: 'unit-report-hfv4(/:progressReportId)',
    component: _component2.default,
    indexRoute: {
      component: _ProgressReportListView2.default,
      actionButtons: {
        default: (0, _routes.generateActionButtons)(getState),
        'export-all': (0, _routes.generateActionButtons)(getState)
      }
    },
    canAccess: function canAccess(_ref2) {
      var params = _ref2.params;
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.UnitReportHFv4);
    },
    breadcrumbLabels: function breadcrumbLabels(_ref3) {
      var buildRoute = _ref3.buildRoute,
          params = _ref3.params;
      var progressReportId = params.progressReportId,
          groupId = params.groupId;

      var progressReport = (0, _accessors.getProgressReportById)(getState(), progressReportId);
      if (!_is_js2.default.existy(progressReport)) {
        return [];
      }
      return {
        label: progressReport.name,
        href: buildRoute('/group/' + groupId + '/unit-report-hfv4/' + progressReportId)
      };
    },
    tab: {
      label: function label(params) {
        return _.actions.isDisabledReportActions(getState(), params.groupId) ? 'Historical Unit Reports' : 'Unit Reports';
      },
      order: 8,
      isVisible: function isVisible(params) {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.View) && _TabSwitcher2.default.isTabEnabled(getState(), params.groupId, _TabSwitcher.TabCodes.UnitReportHFv4);
      }
    },
    childRoutes: [_DosApprovalList.routes, _StudentReportView.routes, {
      path: ':mode',
      component: _ProgressReportListView2.default,
      actionButtons: {
        default: (0, _routes.generateActionButtons)(getState),
        'export-all': (0, _routes.generateActionButtons)(getState)
      }
    }]
  };
};

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(813);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(1941);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
exports.default = _component2.default;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1939);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _ = __webpack_require__(13);

var _StudentReportSummaries = __webpack_require__(42);

var _ApproveByDos = __webpack_require__(301);

var _RejectByDos = __webpack_require__(655);

var _RejectByDos2 = _interopRequireDefault(_RejectByDos);

var _ProgressTests = __webpack_require__(40);

var _StudentReportComment = __webpack_require__(205);

var _StudentReportComment2 = _interopRequireDefault(_StudentReportComment);

var _GroupMembers = __webpack_require__(14);

var _ArrowLink = __webpack_require__(656);

var _ArrowLink2 = _interopRequireDefault(_ArrowLink);

var _ProgressReportStatus = __webpack_require__(134);

var _ProgressReportStatus2 = _interopRequireDefault(_ProgressReportStatus);

var _AddInternalNoteControl = __webpack_require__(67);

var _AddInternalNoteControl2 = _interopRequireDefault(_AddInternalNoteControl);

var _UserCard = __webpack_require__(65);

var _UserCard2 = _interopRequireDefault(_UserCard);

var _StudentCardProfile = __webpack_require__(84);

var _StudentCardProfile2 = _interopRequireDefault(_StudentCardProfile);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _RejectNotePopup = __webpack_require__(206);

var _RejectNotePopup2 = _interopRequireDefault(_RejectNotePopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DosApprovalCard = function (_Component) {
  _inherits(DosApprovalCard, _Component);

  function DosApprovalCard(props) {
    _classCallCheck(this, DosApprovalCard);

    var _this = _possibleConstructorReturn(this, (DosApprovalCard.__proto__ || Object.getPrototypeOf(DosApprovalCard)).call(this, props));

    _this.state = {
      comments: null,
      isEditingComment: false,
      // the publish button is disabled while publishing
      isPublishButtonDisabled: false,
      // when publish succeeds we don't fetch again - we simply update this.
      isReportStatusPublished: false,
      isSaveAllTriggered: false, // mutex for the save all part
      isReportDetailsExpandedOnMobile: false,
      shouldShowRejectDialog: false
    };
    _this._hideShowRejectDialog = _this._hideShowRejectDialog.bind(_this);
    _this._onExpansionButtonClicked = _this._onExpansionButtonClicked.bind(_this);
    return _this;
  }

  _createClass(DosApprovalCard, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        comments: this.props.studentReport && this.props.studentReport.comments
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var studentReport = _ref.studentReport,
          shouldTriggerSaveAllComments = _ref.shouldTriggerSaveAllComments;
      var _props = this.props,
          progressReportId = _props.progressReportId,
          studentId = _props.studentId,
          submitStudentReportComment = _props.submitStudentReportComment;
      var studentReportId = studentReport.id;

      var comments = this.state.comments;
      if (this.props.studentReport !== studentReport) {
        this.setState({ comments: comments = studentReport && studentReport.comments });
      }
      if (shouldTriggerSaveAllComments && this.state.isEditingComment && !this.state.isSaveAllTriggered) {
        this.setState({ isSaveAllTriggered: true });
        submitStudentReportComment(progressReportId, studentReportId, comments, studentId);
      }
      if (!shouldTriggerSaveAllComments) {
        this.setState({ isSaveAllTriggered: false });
      }
    }
  }, {
    key: '_onExpansionButtonClicked',
    value: function _onExpansionButtonClicked() {
      var isReportDetailsExpandedOnMobile = this.state.isReportDetailsExpandedOnMobile;

      this.setState({
        isReportDetailsExpandedOnMobile: !isReportDetailsExpandedOnMobile
      });
    }
  }, {
    key: '_onEditButtonClicked',
    value: function _onEditButtonClicked() {
      this.setState({ isEditingComment: true });
      _is_js2.default.function(this.props.onEnterEditMode) && this.props.onEnterEditMode();
    }
  }, {
    key: '_onRejectButtonClicked',
    value: function _onRejectButtonClicked() {
      this.setState({ shouldShowRejectDialog: true });
    }
  }, {
    key: '_rejectStudentReport',
    value: function _rejectStudentReport(note) {
      var _this2 = this;

      var _props2 = this.props,
          progressReportId = _props2.progressReportId,
          studentReport = _props2.studentReport,
          studentId = _props2.studentId,
          rejectStudentReport = _props2.rejectStudentReport;

      var studentReportId = studentReport.id;
      rejectStudentReport(note, progressReportId, studentReportId).then(function () {
        return _this2.props.fetchStudentReportSummary(progressReportId, studentId);
      });
    }
  }, {
    key: '_onCommentChanged',
    value: function _onCommentChanged(text) {
      this.setState({ comments: text });
      _is_js2.default.function(this.props.onCommentChanged) && this.props.onCommentChanged(text);
    }
  }, {
    key: '_onDiscardCommentClick',
    value: function _onDiscardCommentClick() {
      var studentReport = this.props.studentReport;

      this.setState({
        isEditingComment: false,
        comments: studentReport && studentReport.comments
      });
      _is_js2.default.function(this.props.onLeaveEditMode) && this.props.onLeaveEditMode();
    }
  }, {
    key: '_onSaveCommentClicked',
    value: function _onSaveCommentClicked(commentText) {
      var _this3 = this;

      var _props3 = this.props,
          progressReportId = _props3.progressReportId,
          studentReport = _props3.studentReport,
          studentId = _props3.studentId,
          submitStudentReportComment = _props3.submitStudentReportComment;
      var studentReportId = studentReport.id;

      submitStudentReportComment(progressReportId, studentReportId, commentText, studentId).then(function () {
        return _this3.props.fetchStudentReportSummary(progressReportId, studentId);
      });
      this.setState({
        isEditingComment: false
      });
      this.props.onLeaveEditMode && this.props.onLeaveEditMode();
    }
  }, {
    key: '_onPublishClicked',
    value: function _onPublishClicked() {
      var _this4 = this;

      var _props4 = this.props,
          progressReportId = _props4.progressReportId,
          studentReport = _props4.studentReport,
          studentId = _props4.studentId,
          approveStudentReport = _props4.approveStudentReport;

      var studentReportId = studentReport.id;
      if (_is_js2.default.not.string(progressReportId) || _is_js2.default.not.string(studentReportId)) {
        return;
      }
      this.setState({ isPublishButtonDisabled: true });
      approveStudentReport(progressReportId, studentReportId).then(function (result) {
        if (Error.isError(result.payload)) {
          _this4.setState({ isPublishButtonDisabled: false });
        } else {
          _this4.setState({ isReportStatusPublished: true });
          _this4.props.fetchStudentReportSummary(progressReportId, studentId);
        }
      }).then(function () {
        var _props5 = _this4.props,
            progressTestPlan = _props5.progressTestPlan,
            groupId = _props5.groupId;

        if (!_is_js2.default.existy(progressTestPlan)) {
          return;
        }
        _this4.props.fetchProgressTest(groupId, progressTestPlan);
      });
    }
  }, {
    key: '_renderComments',
    value: function _renderComments() {
      if (_is_js2.default.not.string(this.state.comments) || _is_js2.default.empty(this.state.comments)) {
        return _react2.default.createElement(
          'div',
          null,
          'This Progress Report does not include comments.'
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          { className: _style2.default.DosApprovalCard_comments_body },
          this.state.comments
        )
      );
    }
  }, {
    key: '_renderCommentsEditor',
    value: function _renderCommentsEditor() {
      var _this5 = this;

      return _react2.default.createElement(_AddInternalNoteControl2.default, { text: this.state.comments,
        maxCharacters: 500,
        onChange: function onChange(text) {
          return _this5._onCommentChanged(text);
        },
        onDiscardClick: function onDiscardClick() {
          return _this5._onDiscardCommentClick();
        },
        onSaveClick: function onSaveClick(text) {
          return _this5._onSaveCommentClicked(text);
        } });
    }
  }, {
    key: '_renderButtons',
    value: function _renderButtons() {
      return _react2.default.createElement(
        _omniCommonUi.Button.Container,
        { className: _style2.default.DosApprovalCard_buttons },
        [this._renderPublishButton(), this._renderRejectButton(), this._renderEditButton()]
      );
    }
  }, {
    key: '_renderEditButton',
    value: function _renderEditButton() {
      var _this6 = this;

      var isReportStatusPublished = this.state.isReportStatusPublished;

      return _react2.default.createElement(
        _omniCommonUi.Button,
        { key: 'edit-button',
          type: _omniCommonUi.Button.Type.default,
          onClick: function onClick() {
            return _this6._onEditButtonClicked();
          },
          disabled: isReportStatusPublished },
        'Edit'
      );
    }
  }, {
    key: '_renderRejectButton',
    value: function _renderRejectButton() {
      var _this7 = this;

      return _react2.default.createElement(
        _omniCommonUi.Button,
        { key: 'reject-button',
          type: _omniCommonUi.Button.Type.default,
          onClick: function onClick() {
            return _this7._onRejectButtonClicked();
          } },
        'Reject'
      );
    }
  }, {
    key: '_renderPublishButton',
    value: function _renderPublishButton() {
      var _this8 = this;

      var _state = this.state,
          isReportStatusPublished = _state.isReportStatusPublished,
          isPublishButtonDisabled = _state.isPublishButtonDisabled;

      var buttonLabel = isReportStatusPublished ? 'Completed' : 'Approve';
      return _react2.default.createElement(
        _omniCommonUi.Button,
        { key: 'publish-button',
          onClick: function onClick() {
            return _this8._onPublishClicked();
          },
          type: _omniCommonUi.Button.Type.primary,
          disabled: isPublishButtonDisabled },
        buttonLabel
      );
    }
  }, {
    key: '_renderRejectDialog',
    value: function _renderRejectDialog() {
      var _this9 = this;

      return this.state.shouldShowRejectDialog && _react2.default.createElement(_RejectNotePopup2.default, { isOpen: true,
        isLoading: this.props.isAnyApiCall,
        onSave: function onSave(note) {
          return _this9._rejectStudentReport(note);
        },
        onCancel: this._hideShowRejectDialog });
    }
  }, {
    key: '_hideShowRejectDialog',
    value: function _hideShowRejectDialog() {
      this.setState({ shouldShowRejectDialog: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          student = _props6.student,
          studentReport = _props6.studentReport,
          progressTest = _props6.progressTest,
          studentProgressTestResult = _props6.studentProgressTestResult,
          timeZone = _props6.timeZone,
          buildRoute = _props6.buildRoute;
      var _state2 = this.state,
          isEditingComment = _state2.isEditingComment,
          isReportStatusPublished = _state2.isReportStatusPublished;


      if (_is_js2.default.undefined(studentReport)) {
        return null;
      }

      var progressTestSkills = progressTest.data.skills;
      var totalScore = studentProgressTestResult.totalScore;
      var percentage = totalScore.percentage,
          skillScorePercentages = totalScore.skillScorePercentages;
      var _studentProgressTestR = studentProgressTestResult.previousTotalScore,
          previousPercentage = _studentProgressTestR.percentage,
          previousSkillScorePercentages = _studentProgressTestR.skillScorePercentages;

      // mimics the backend response string. do not alter

      var localReportStatus = isReportStatusPublished ? _StudentReportSummaries.StudentReportSummary.Status.Completed : studentReport.status;
      var reportLink = './group/' + this.props.groupId + ('/unit-report-hfv4/' + this.props.progressReportId) + ('/student/' + student.studentGeneralInfo.id);

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: _style2.default.DosApprovalCard },
        _react2.default.createElement(
          _omniCommonUi.Grid,
          null,
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12,
                sm: 4,
                className: (0, _classnames3.default)(_style2.default.DosApprovalCard_leftColumn, _defineProperty({}, _style2.default.__expandedOnMobile, this.state.isReportDetailsExpandedOnMobile)) },
              _react2.default.createElement(
                _omniCommonUi.StudentCard,
                { className: _style2.default.DosApprovalCard_student,
                  borderless: true,
                  backgroundless: true,
                  withSeparatorLine: true },
                _react2.default.createElement(_StudentCardProfile2.default, { studentId: student.studentGeneralInfo.id,
                  status: student.status,
                  statusHighlighted: student.isInProduction }),
                _react2.default.createElement(_omniCommonUi.StudentCard.Content, null)
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.DosApprovalCard_status },
                _react2.default.createElement(
                  'strong',
                  { className: _style2.default.DosApprovalCard_status_label },
                  'Report',
                  _react2.default.createElement('br', null),
                  'Status'
                ),
                _react2.default.createElement(_ProgressReportStatus2.default, { status: localReportStatus })
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.DosApprovalCard_scores },
                _react2.default.createElement(
                  'ul',
                  { className: _style2.default.DosApprovalCard_scores_breakdown },
                  _react2.default.createElement(
                    'li',
                    { className: _style2.default.DosApprovalCard_scores_total },
                    'Total Score:\xA0',
                    _react2.default.createElement(
                      'span',
                      { className: _style2.default.DosApprovalCard_scores_percentage },
                      totalScore.isNotApplicable ? 'n/a' : percentage + '%'
                    ),
                    _is_js2.default.number(previousPercentage) && previousPercentage !== percentage ? _react2.default.createElement(
                      'span',
                      { className: (0, _classnames3.default)(_style2.default.DosApprovalCard_scores_percentage, _style2.default.DosApprovalCard_scores_previous) },
                      previousPercentage,
                      '%'
                    ) : null
                  ),
                  progressTestSkills.map(function (skill) {
                    return _react2.default.createElement(
                      'li',
                      { key: skill.skillId },
                      function () {
                        var currentSkillScorePerc = skillScorePercentages.get(skill.skillId);
                        var previousSkillScorePerc = previousSkillScorePercentages.get(skill.skillId);
                        var currentSkillScorePercText = _is_js2.default.number(currentSkillScorePerc) ? currentSkillScorePerc + '%' : '';
                        var output = [_react2.default.createElement(
                          'span',
                          { key: student.studentGeneralInfo.id + '-' + skill.skillId + '-perc',
                            className: _style2.default.DosApprovalCard_scores_percentage },
                          skill.name,
                          ': ',
                          currentSkillScorePercText
                        )];
                        if (_is_js2.default.number(previousSkillScorePerc) && previousSkillScorePerc !== currentSkillScorePerc) {
                          output.push(_react2.default.createElement(
                            'span',
                            { key: student.studentGeneralInfo.id + '-' + skill.skillId + '-prevPerc',
                              className: (0, _classnames3.default)(_style2.default.DosApprovalCard_scores_percentage, _style2.default.DosApprovalCard_scores_previous) },
                            previousSkillScorePerc,
                            '%'
                          ));
                        }
                        return output;
                      }()
                    );
                  })
                ),
                _react2.default.createElement(
                  _ArrowLink2.default,
                  { className: _style2.default.DosApprovalCard_reportLink,
                    to: buildRoute(reportLink) },
                  'Report'
                )
              ),
              _react2.default.createElement(_ExpansionButton2.default, { className: _style2.default.DosApprovalCard_expander,
                isExpand: this.state.isReportDetailsExpandedOnMobile,
                onExpansionButtonClick: this._onExpansionButtonClicked })
            ),
            _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12,
                sm: 8,
                className: _style2.default.DosApprovalCard_rightColumn },
              ' ',
              _react2.default.createElement(
                'div',
                { className: _style2.default.DosApprovalCard_comment },
                _react2.default.createElement(_UserCard2.default, { id: studentReport.commentedByUserId,
                  className: _style2.default.DosApprovalCard_teacher,
                  getLines: function getLines(_ref2) {
                    var user = _ref2.user;
                    return [_react2.default.createElement(
                      'div',
                      { className: _style2.default.DosApprovalCard_teacher_line,
                        key: 'UserCard#item0' },
                      user.firstName,
                      ' ',
                      user.lastName
                    ), _react2.default.createElement(
                      'div',
                      { className: _style2.default.DosApprovalCard_teacher_line,
                        key: 'UserCard#item1' },
                      'Teacher'
                    ), _react2.default.createElement(
                      'div',
                      { className: _style2.default.DosApprovalCard_teacher_line,
                        key: 'UserCard#item2' },
                      _omniCommonUi.moment.utc(studentReport.commentedTimeUtc).clone().tz(timeZone).format('YYYY.MM.DD')
                    )];
                  } }),
                isEditingComment ? this._renderCommentsEditor() : this._renderComments()
              ),
              !isEditingComment && !isReportStatusPublished ? this._renderButtons() : null
            )
          )
        ),
        this._renderRejectDialog()
      );
    }
  }]);

  return DosApprovalCard;
}(_react.Component);

DosApprovalCard.propTypes = {
  fetchStudentReportSummary: _propTypes2.default.func.isRequired,
  groupId: _propTypes2.default.string.isRequired,
  timeZone: _propTypes2.default.string.isRequired,
  approveStudentReport: _propTypes2.default.func.isRequired,
  rejectStudentReport: _propTypes2.default.func.isRequired,
  progressReportId: _propTypes2.default.string.isRequired,
  studentId: _propTypes2.default.string.isRequired,
  studentReport: _propTypes2.default.object,
  progressTest: _propTypes2.default.instanceOf(_omniCommonUi.ApiResponse),
  studentProgressTestResult: _propTypes2.default.object,
  submitStudentReportComment: _propTypes2.default.func,
  student: _propTypes2.default.instanceOf(_GroupMembers.GroupMember),
  approval: _propTypes2.default.instanceOf(_omniCommonUi.ApiResponse),
  location: _propTypes2.default.object.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  shouldTriggerSaveAllComments: _propTypes2.default.bool,
  onEnterEditMode: _propTypes2.default.func.isRequired,
  onLeaveEditMode: _propTypes2.default.func.isRequired,
  onCommentChanged: _propTypes2.default.func,
  progressTestPlan: _propTypes2.default.object,
  isAnyApiCall: _propTypes2.default.boolean,
  fetchProgressTest: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var progressReportId = ownProps.progressReportId,
      studentId = ownProps.studentId,
      groupId = ownProps.groupId;

  var _Group$getCentre = _.actions.getCentre(state, groupId),
      timeZone = _Group$getCentre.timeZone;

  var key = progressReportId + '-' + studentId;
  var studentReport = state.get('rootReducer').get('studentReportSummaries').get('' + progressReportId).data.get('' + studentId);

  var approval = state.get('rootReducer').get('approveByDos').get(key);

  var progressReport = state.get('rootReducer').get('groups').get(groupId).data.get('progressReports').data.get(progressReportId);

  var student = _GroupMembers.actions.getMemberById(state, studentId);
  var progressTest = null;
  var studentProgressTestResult = null;
  var progressTestPlan = null;

  if (progressReport) {
    var reportProgressTestId = progressReport.progressTestId;

    progressTest = state.get('rootReducer').get('progressTests').get(reportProgressTestId);

    studentProgressTestResult = progressTest.data.studentProgressTestResults.get(studentId);

    progressTestPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId).data.find(function (plan) {
      return plan.progressReportId === progressReportId;
    });
  }
  return {
    timeZone: timeZone,
    progressReportId: progressReportId,
    progressTest: progressTest,
    studentReport: studentReport,
    studentProgressTestResult: studentProgressTestResult,
    student: student,
    approval: approval,
    progressTestPlan: progressTestPlan,
    groupId: groupId,
    isAnyApiCall: !!isAnyApiCall(state)
  };
}
function isAnyApiCall(state) {
  return !!(state.get('apiCalls') || new _immutable.List()).filter(function (call, key) {
    return ['PUT', 'POST', 'GET'].some(function (method) {
      return key.startsWith(method);
    });
  }).find(function (call) {
    return _omniCommonUi.ApiCall.State.isLoading(call);
  });
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, (0, _redux.bindActionCreators)(_StudentReportSummaries.actions, dispatch), (0, _redux.bindActionCreators)(_RejectByDos2.default, dispatch), (0, _redux.bindActionCreators)(_ApproveByDos.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTests.actions, dispatch), (0, _redux.bindActionCreators)(_StudentReportComment2.default, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(DosApprovalCard);

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1940);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._36PtIfhuL5_xEhqYy6OSrU{padding:0;padding-bottom:1.42857rem}@media only screen and (min-width:480px){._36PtIfhuL5_xEhqYy6OSrU{background:-webkit-gradient(linear,left top,right top,color-stop(35%,#e8ebef),color-stop(35%,#fbfbfb));background:-webkit-linear-gradient(left,#e8ebef 35%,#fbfbfb 0);background:-moz-linear-gradient(left,#e8ebef 35%,#fbfbfb 35%);background:-o-linear-gradient(left,#e8ebef 35%,#fbfbfb 35%);background:linear-gradient(90deg,#e8ebef 35%,#fbfbfb 0)}}@media only screen and (min-width:640px){._36PtIfhuL5_xEhqYy6OSrU{padding:.57143rem 1.07143rem}}._2wyhvZjTJ8PR0taZ-uzIfk ._1ELuNLrIC2A4RDIUZ5a18J,._2wyhvZjTJ8PR0taZ-uzIfk ._2Wur0umWl0nBDFaahJGdJH{display:none}._2wyhvZjTJ8PR0taZ-uzIfk.ZxxHhZmGLsYL9lSEiqk2S ._1ELuNLrIC2A4RDIUZ5a18J,._2wyhvZjTJ8PR0taZ-uzIfk.ZxxHhZmGLsYL9lSEiqk2S ._2Wur0umWl0nBDFaahJGdJH{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}@media only screen and (min-width:480px){._2wyhvZjTJ8PR0taZ-uzIfk ._1ELuNLrIC2A4RDIUZ5a18J,._2wyhvZjTJ8PR0taZ-uzIfk ._2Wur0umWl0nBDFaahJGdJH{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._2wyhvZjTJ8PR0taZ-uzIfk ._2gxGYM43i7VNbqjOjTvbUp{display:none}}.LRycDOr43wCrj4lQYLPEh{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._1ELuNLrIC2A4RDIUZ5a18J,._2gxGYM43i7VNbqjOjTvbUp,._2Sn1BJERn2SoegSf0SWWmZ,._2Wur0umWl0nBDFaahJGdJH{background:#e8ebef}._2Sn1BJERn2SoegSf0SWWmZ{padding-top:.35714rem}@media only screen and (min-width:480px){._2Sn1BJERn2SoegSf0SWWmZ{background:transparent;padding-top:0}}._1ELuNLrIC2A4RDIUZ5a18J{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-flow:row wrap;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;padding:1.42857rem;padding-bottom:0;padding-top:.71429rem}._1ELuNLrIC2A4RDIUZ5a18J strong{font-weight:600}._2oLhybmbsm_SMC-hj0h306{margin-right:1.42857rem}._2Wur0umWl0nBDFaahJGdJH,.rIHn6a-b-7wvN19-aX3bz{line-height:1.5}._2Wur0umWl0nBDFaahJGdJH{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-left:1.42857rem}@media only screen and (min-width:640px){._2Wur0umWl0nBDFaahJGdJH{border-bottom:none;padding-bottom:0}}._5xCUUBZGPlBtGNILs5tTg{-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;list-style-type:none;margin:0;padding:1.07143rem 0;padding-bottom:.71429rem;white-space:nowrap}._2EChQLnYNaXVpJ5dtg3p4p{color:#a4a4a4;font-weight:400}._2EChQLnYNaXVpJ5dtg3p4p:before{content:\" \"}._2gxGYM43i7VNbqjOjTvbUp{border-bottom:.07143rem solid #ccc;-webkit-box-shadow:0 .07143rem .07143rem 0 #e3e3e3;-moz-box-shadow:0 .07143rem .07143rem 0 #e3e3e3;box-shadow:0 .07143rem .07143rem 0 #e3e3e3;position:relative;text-align:center;top:-.07143rem}._2K_8kLYob3FG09hkKY6VAY{display:none;font-weight:600;-webkit-box-pack:start!important;-webkit-justify-content:flex-start!important;-moz-box-pack:start!important;-ms-flex-pack:start!important;justify-content:flex-start!important;line-height:200%!important;margin-bottom:1.07143rem;text-transform:uppercase}@media only screen and (min-width:480px){._2K_8kLYob3FG09hkKY6VAY{display:block;line-height:150%!important}}._2RARCgUImunh9c6vBcLuZ_{-webkit-box-flex:0;-webkit-flex:0 0 auto;-moz-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;margin-bottom:1.42857rem}._28ea9AmU3LHSjZEDq175jl{margin-bottom:0!important}._28ea9AmU3LHSjZEDq175jl:not(:first-child){color:#a4a4a4;font-size:90%}.rIHn6a-b-7wvN19-aX3bz{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-webkit-flex:1 0 auto;-moz-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:0 1.42857rem}@media only screen and (min-width:480px){.rIHn6a-b-7wvN19-aX3bz{padding-top:1rem}}@media only screen and (min-width:640px){.rIHn6a-b-7wvN19-aX3bz{padding-bottom:1.07143rem;padding-left:2.14286rem}}.rIHn6a-b-7wvN19-aX3bz p:first-child{margin-top:0}._2q295hwx8w_5X8aMkpdfQR{-webkit-align-self:flex-end;-ms-flex-item-align:end;align-self:flex-end;-webkit-box-flex:0;-webkit-flex:0 0 auto;-moz-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding:.57143rem 1.42857rem}@media only screen and (min-width:480px){._2q295hwx8w_5X8aMkpdfQR{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-bottom:1.07143rem;padding-top:.42857rem;white-space:nowrap}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"DosApprovalCard": "_36PtIfhuL5_xEhqYy6OSrU",
	"DosApprovalCard_leftColumn": "_2wyhvZjTJ8PR0taZ-uzIfk",
	"DosApprovalCard_status": "_1ELuNLrIC2A4RDIUZ5a18J",
	"DosApprovalCard_scores": "_2Wur0umWl0nBDFaahJGdJH",
	"__expandedOnMobile": "ZxxHhZmGLsYL9lSEiqk2S",
	"DosApprovalCard_expander": "_2gxGYM43i7VNbqjOjTvbUp",
	"DosApprovalCard_rightColumn": "LRycDOr43wCrj4lQYLPEh",
	"DosApprovalCard_student": "_2Sn1BJERn2SoegSf0SWWmZ",
	"DosApprovalCard_status_label": "_2oLhybmbsm_SMC-hj0h306",
	"DosApprovalCard_comment": "rIHn6a-b-7wvN19-aX3bz",
	"DosApprovalCard_scores_breakdown": "_5xCUUBZGPlBtGNILs5tTg",
	"DosApprovalCard_scores_total": "_3_GHO6yHxbjjPAthxk1fh0",
	"DosApprovalCard_scores_percentage": "MXXxo0EK5qTcCeQvt5aR3",
	"DosApprovalCard_scores_previous": "_2EChQLnYNaXVpJ5dtg3p4p",
	"DosApprovalCard_reportLink": "_2K_8kLYob3FG09hkKY6VAY",
	"DosApprovalCard_teacher": "_2RARCgUImunh9c6vBcLuZ_",
	"DosApprovalCard_teacher_line": "_28ea9AmU3LHSjZEDq175jl",
	"DosApprovalCard_comment_body": "_4z4PL5mUhE-LInjFs8gjp",
	"DosApprovalCard_buttons": "_2q295hwx8w_5X8aMkpdfQR"
};

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(813);

var _component2 = _interopRequireDefault(_component);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: 'dos-approval',
    component: _component2.default,
    canAccess: function canAccess() {
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.ProgressReport.ApproveComment);
    },
    tabs: {
      hidden: true
    },
    sessionNav: {
      hidden: true
    },
    actionButtons: {
      hidden: true
    },
    breadcrumbLabels: 'DOS Approval'
  };
};

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(814);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(818);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
exports.default = _component2.default;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1944);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3ifJFK7cyPtCwUYp45A9Tb{white-space:pre-wrap}._1-Vbe95v5CF1BrZAc8nav2:not(:first-child){margin-left:1.42857rem}._2-IaH79D5650Z66Erza85J,._1109EL2sIGXk1rikWRSQIy{height:100%}._38RF21Shz9-joUe8kxjTF0{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-top:.57143rem}._6yQs0DAvWSVKe7RuClvx8{-webkit-box-flex:1;-webkit-flex:1 1 100%;-moz-box-flex:1;-ms-flex:1 1 100%;flex:1 1 100%;max-width:100%}@media only screen and (min-width:640px){._6yQs0DAvWSVKe7RuClvx8{-webkit-flex-basis:0;-ms-flex-preferred-size:0;flex-basis:0}}._6yQs0DAvWSVKe7RuClvx8:not(:last-child){margin-bottom:1.42857rem}@media only screen and (min-width:640px){._6yQs0DAvWSVKe7RuClvx8:not(:last-child){margin-bottom:0;margin-right:2.14286rem}}._3Rx98_EjkQ_yqfSP38-sg3{margin-left:1.07143rem;padding:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentReportView_unitSummary_body": "_3ifJFK7cyPtCwUYp45A9Tb",
	"StudentReportView_card_icon": "_1-Vbe95v5CF1BrZAc8nav2",
	"StudentReportView_student_card": "_2-IaH79D5650Z66Erza85J",
	"StudentReportView_teachers_card": "_1109EL2sIGXk1rikWRSQIy",
	"StudentReportView_teachers_list": "_38RF21Shz9-joUe8kxjTF0",
	"StudentReportView_teachers_item": "_6yQs0DAvWSVKe7RuClvx8",
	"StudentReportView_teachers_profile": "_3Rx98_EjkQ_yqfSP38-sg3"
};

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"colorNeedsImprovement": "#de4c4c",
	"colorDeveloping": "#f7932d",
	"colorOnTrack": "#74d17f",
	"colorOutstanding": "#74d17f",
	"colorDefault": "#0087e6"
};

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportStudentCard = undefined;

var _style = __webpack_require__(1947);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _ProductionStatus = __webpack_require__(73);

var _ProgressReportStatus = __webpack_require__(134);

var _ProgressReportStatus2 = _interopRequireDefault(_ProgressReportStatus);

var _StudentCardProfile = __webpack_require__(84);

var _StudentCardProfile2 = _interopRequireDefault(_StudentCardProfile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportStudentCard = exports.ReportStudentCard = function ReportStudentCard(props) {
  var SHOW_SUBMITTED_DATE = false;
  var studentGeneralInfo = props.studentGeneralInfo,
      member = props.member,
      reportStatus = props.reportStatus,
      submittedDate = props.submittedDate;

  var status = (0, _ProductionStatus.parseProductionStatus)(member.status);
  var pageCardClassName = (0, _classnames2.default)(_style2.default.ReportStudentCard, (0, _omniCommonUi.testClass)('report-student-card'));
  return _react2.default.createElement(
    _omniCommonUi.PageCard,
    { className: pageCardClassName },
    _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Student' }),
    _react2.default.createElement(
      _omniCommonUi.PageCard.Content,
      { className: _style2.default.ReportStudentCard_content },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_style2.default.ReportStudentCard_content_items, _style2.default.ReportStudentCard_studentInfo) },
        _react2.default.createElement(
          _omniCommonUi.StudentCard,
          { borderless: true, backgroundless: true },
          _react2.default.createElement(_StudentCardProfile2.default, { useLowerLevelPersonComponent: true,
            className: _style2.default.ReportStudentCard_profile,
            withoutBottomPadding: true,
            studentId: studentGeneralInfo.id,
            status: status.fullName,
            statusHighlighted: member.isInProduction })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_style2.default.ReportStudentCard_items, _style2.default.ReportStudentCard_reportStatus) },
        _react2.default.createElement(
          'h2',
          { className: _style2.default.ReportStudentCard_reportStatus_title },
          'Report Status'
        ),
        _react2.default.createElement(_ProgressReportStatus2.default, { status: reportStatus,
          className: _style2.default.ReportStudentCard_reportStatus_status })
      ),
      SHOW_SUBMITTED_DATE && _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_style2.default.ReportStudentCard_items, _style2.default.ReportStudentCard_reportStatus, _style2.default.ReportStudentCard_submittedDate) },
        _react2.default.createElement(
          'h2',
          { className: _style2.default.ReportStudentCard_reportStatus_title },
          'Submitted Date'
        ),
        _react2.default.createElement(
          'p',
          { className: _style2.default.ReportStudentCard_reportStatus_status },
          submittedDate
        )
      )
    )
  );
};

ReportStudentCard.propTypes = {
  studentName: _propTypes2.default.string,
  studentGeneralInfo: _propTypes2.default.object,
  member: _propTypes2.default.object,
  reportStatus: _propTypes2.default.string,
  submittedDate: _propTypes2.default.string,
  hideSubmittedDate: _propTypes2.default.bool
};

exports.default = ReportStudentCard;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1948);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1CLXZRgKwYxZ15o7WHTMji{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:start;-webkit-align-items:flex-start;-moz-box-align:start;-ms-flex-align:start;align-items:flex-start;padding-top:1.42857rem;padding-bottom:.71429rem}._2wCnE7mvJWxOoCkExoDTA9{-webkit-flex-basis:100%;-ms-flex-preferred-size:100%;flex-basis:100%}@media only screen and (min-width:480px){._2wCnE7mvJWxOoCkExoDTA9{-webkit-box-flex:0;-webkit-flex:0 0 14.28571rem;-moz-box-flex:0;-ms-flex:0 0 14.28571rem;flex:0 0 14.28571rem}}._2DR7IaP9MOx8oHyO2HT4AK{-webkit-flex-basis:50%;-ms-flex-preferred-size:50%;flex-basis:50%}@media only screen and (min-width:480px){._2DR7IaP9MOx8oHyO2HT4AK{-webkit-box-flex:0;-webkit-flex:0 0 11.42857rem;-moz-box-flex:0;-ms-flex:0 0 11.42857rem;flex:0 0 11.42857rem}}@media only screen and (min-width:480px){._32N3Z0MedhTDWwupuiC1-L{-webkit-box-flex:0;-webkit-flex:0 0 12.85714rem;-moz-box-flex:0;-ms-flex:0 0 12.85714rem;flex:0 0 12.85714rem}}.nMDJJn--pVtORQikE1Uwd{padding:.57143rem 1.07143rem}._3pS8pkty_zxDYPerGwO1T_{font-size:1.07143rem;font-weight:600;margin:0}._1yKxEijgGf4JGIDexQhgUj{margin-top:.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ReportStudentCard_profile": "_2qoSqtzMb8fxtjXqvuYVnp",
	"ReportStudentCard_content": "_1CLXZRgKwYxZ15o7WHTMji",
	"ReportStudentCard_content_items": "_2wCnE7mvJWxOoCkExoDTA9",
	"ReportStudentCard_items": "_2DR7IaP9MOx8oHyO2HT4AK",
	"ReportStudentCard_submittedDate": "_32N3Z0MedhTDWwupuiC1-L",
	"ReportStudentCard_reportStatus": "nMDJJn--pVtORQikE1Uwd",
	"ReportStudentCard_reportStatus_title": "_3pS8pkty_zxDYPerGwO1T_",
	"ReportStudentCard_reportStatus_status": "_1yKxEijgGf4JGIDexQhgUj"
};

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressTestCard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1950);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _rcTooltip = __webpack_require__(151);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _RadialScoreDisplay = __webpack_require__(1952);

var _RadialScoreDisplay2 = _interopRequireDefault(_RadialScoreDisplay);

var _ScoreBand = __webpack_require__(816);

var _ScoreBand2 = _interopRequireDefault(_ScoreBand);

var _ScoreStar = __webpack_require__(817);

var _ScoreStar2 = _interopRequireDefault(_ScoreStar);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BENCHMARKING_DATA = [{
  range: '0-59%',
  category: 'Needs Improvement',
  descriptor: 'Your child is finding it difficult to understand and use the language and skills taught in this unit. They need extra support to practise key vocabulary and structures and to build confidence in using what they have learned.'
}, {
  range: '60-79%',
  category: 'Developing',
  descriptor: 'Your child is making progress with the language and skills from this unit and is beginning to use them with some success. They are close to meeting expectations but may still need support or reminders to use new vocabulary and structures accurately and consistently.'
}, {
  range: '80-89%',
  category: 'On Track',
  descriptor: 'Your child shows a good understanding of the language and skills taught in this unit and meets the expected learning goals. They can use the key vocabulary and structures independently in familiar activities, with only occasional mistakes.'
}, {
  range: '90-100%',
  category: 'Outstanding',
  descriptor: 'Your child shows an excellent understanding of the language and skills taught in this unit and uses what they have learned confidently and accurately. They apply the unit\'s vocabulary and structures effectively in a range of activities and may use them flexibly or make clear connections with other learning.'
}];

var ProgressTestCard = exports.ProgressTestCard = function (_Component) {
  _inherits(ProgressTestCard, _Component);

  function ProgressTestCard(props) {
    _classCallCheck(this, ProgressTestCard);

    var _this = _possibleConstructorReturn(this, (ProgressTestCard.__proto__ || Object.getPrototypeOf(ProgressTestCard)).call(this, props));

    _this.state = { benchmarkingTooltipVisible: false };
    return _this;
  }

  _createClass(ProgressTestCard, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          publishedDateStr = _props.publishedDateStr,
          name = _props.name,
          percentage = _props.percentage,
          isSSCourseTypeGroup = _props.isSSCourseTypeGroup,
          className = _props.className;

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _classnames2.default)(className, _style2.default.ProgressTestCard) },
        _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Progress' }),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          null,
          _react2.default.createElement(
            'div',
            { className: _style2.default.ProgressTestCard_wrapper },
            isSSCourseTypeGroup ? _react2.default.createElement(_ScoreStar2.default, { currentResult: percentage,
              fullMark: 100 }) : _react2.default.createElement(_RadialScoreDisplay2.default, { className: _style2.default.ProgressTestCard_wrapper_radialScore,
              radius: 40,
              circleStrokeWidth: 5,
              edgeSize: 120,
              forcedTextY: 66,
              unit: 'percent',
              displayText: true,
              formatText: function formatText(value) {
                return value + '%';
              },
              circleStroke: '#e0e0e0',
              progressStroke: '#74d17f',
              value: percentage }),
            _react2.default.createElement(
              'div',
              { className: _style2.default.ProgressTestCard_wrapper_bandInfo },
              _react2.default.createElement(
                'h2',
                { className: _style2.default.ProgressTestCard_wrapper_bandInfo_title },
                'Total Score'
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.ProgressTestCard_wrapper_bandInfo_nameRow },
                _react2.default.createElement(_ScoreBand2.default, { score: percentage, textKey: 'name',
                  className: _style2.default.ProgressTestCard_wrapper_bandInfo_name }),
                _react2.default.createElement(
                  _rcTooltip2.default,
                  {
                    placement: 'right',
                    trigger: ['hover'],
                    destroyPopupOnHide: true,
                    visible: this.state.benchmarkingTooltipVisible,
                    onVisibleChange: function onVisibleChange(visible) {
                      return _this2.setState({ benchmarkingTooltipVisible: visible });
                    },
                    overlayClassName: _style2.default.BenchmarkingTooltip_overlay,
                    overlay: _react2.default.createElement(
                      'div',
                      { className: _style2.default.BenchmarkingTooltip },
                      _react2.default.createElement(
                        'div',
                        { className: _style2.default.BenchmarkingTooltip_title },
                        'Benchmarking'
                      ),
                      BENCHMARKING_DATA.map(function (item, index) {
                        return _react2.default.createElement(
                          'div',
                          { key: index, className: _style2.default.BenchmarkingTooltip_row },
                          _react2.default.createElement(
                            'div',
                            { className: _style2.default.BenchmarkingTooltip_range },
                            item.range
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: _style2.default.BenchmarkingTooltip_content },
                            _react2.default.createElement(
                              'div',
                              { className: _style2.default.BenchmarkingTooltip_category },
                              item.category
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: _style2.default.BenchmarkingTooltip_descriptor },
                              item.descriptor
                            )
                          )
                        );
                      }),
                      _react2.default.createElement(
                        'div',
                        { className: _style2.default.BenchmarkingTooltip_footer },
                        _react2.default.createElement(
                          'span',
                          {
                            className: _style2.default.BenchmarkingTooltip_gotIt,
                            onClick: function onClick() {
                              return _this2.setState({ benchmarkingTooltipVisible: false });
                            } },
                          'Got it'
                        )
                      )
                    ) },
                  _react2.default.createElement(
                    'div',
                    { className: _style2.default.ProgressTestCard_wrapper_bandInfo_icon },
                    _react2.default.createElement(_omniCommonUi.Icon, { id: 'info' })
                  )
                )
              )
            ),
            _react2.default.createElement('div', { className: _style2.default.ProgressTestCard_wrapper_divider }),
            _react2.default.createElement(_ScoreBand2.default, { score: percentage,
              className: _style2.default.ProgressTestCard_wrapper_interpretation })
          )
        )
      );
    }
  }]);

  return ProgressTestCard;
}(_react.Component);

ProgressTestCard.propTypes = {
  className: _propTypes2.default.object,
  publishedDateStr: _propTypes2.default.string,
  name: _propTypes2.default.string,
  percentage: _propTypes2.default.number,
  isSSCourseTypeGroup: _propTypes2.default.bool.isRequired
};

exports.default = ProgressTestCard;

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1951);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2lOcRVPOWro2ma9g8NAw5S{height:100%}.yzJvAF24QOLi-1POHYENW{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;margin-left:-2.14286rem}.HZCk7oh-6ewi4Pkbt-Z93{font-size:1.28571rem;margin-right:1.14286rem}.H6pzNNlkl8lmKOsfFn5lJ,.HZCk7oh-6ewi4Pkbt-Z93{-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0}._3drG4earrOmcoryK0_b_Fv{font-size:1.14286rem;font-weight:600;line-height:1.71429rem;margin:0}._1wIX3j-GQ0Fb9mMgrLezh_{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;margin:.28571rem 0}._2l0IbmJzyTE12h_-reu1au{font-weight:600;margin:0}._31Ks-GuWWPHROBIamafo6T{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:1.14286rem;margin-left:.28571rem;color:var(--colorTextSecondary);cursor:pointer}._3XsXik9AFZoaWJHpRVpdJ8{width:.07143rem;-webkit-align-self:stretch;-ms-flex-item-align:stretch;align-self:stretch;background:#ccc;margin:0 1.71429rem}._1hBcZ2sbt2C0ikA1EH0q68{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;margin:0;line-height:1.6}._1GAQVW6kzskmWYiTYCSssN{max-width:51.42857rem;opacity:1!important}._1GAQVW6kzskmWYiTYCSssN .rc-tooltip-inner{background-color:#616161;-webkit-border-radius:.57143rem;-moz-border-radius:.57143rem;border-radius:.57143rem;-webkit-box-shadow:0 .28571rem 1.14286rem rgba(0,0,0,.3);-moz-box-shadow:0 .28571rem 1.14286rem rgba(0,0,0,.3);box-shadow:0 .28571rem 1.14286rem rgba(0,0,0,.3);color:#fff;padding:1.71429rem}._1GAQVW6kzskmWYiTYCSssN .rc-tooltip-arrow{display:none}._3WRxVSgQP5MndDxyy-iYZs{font-size:1.28571rem;font-weight:700;margin-bottom:1.14286rem}._3LwKF7Hk4E6v_EW9oA2I1s{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;border-top:.07143rem solid hsla(0,0%,100%,.25);display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;gap:1.42857rem;padding:1.14286rem 0}._1C0qbe28H_HxpNxTLvyScy{-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;font-size:1rem;font-weight:700;min-width:5rem}._2UVh_gzBilEqpYulWxuDAI{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1}._3yEz9UxLyPBIaAl3ThK15v{font-size:1.07143rem;font-weight:700;margin-bottom:.28571rem}.vsmxRHSSssRbnL7eMX0lz{font-size:.92857rem;line-height:1.6}._3UPUIS2l0vQlsc5IzxamWR{border-top:.07143rem solid hsla(0,0%,100%,.25);font-size:1.07143rem;font-weight:500;margin-top:.57143rem;padding-top:1.42857rem;text-align:center}._3QVJ7S5fvl7S1UKKi0FXG0{cursor:pointer}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ProgressTestCard": "_2lOcRVPOWro2ma9g8NAw5S",
	"ProgressTestCard_wrapper": "yzJvAF24QOLi-1POHYENW",
	"ProgressTestCard_wrapper_radialScore": "HZCk7oh-6ewi4Pkbt-Z93",
	"ProgressTestCard_wrapper_bandInfo": "H6pzNNlkl8lmKOsfFn5lJ",
	"ProgressTestCard_wrapper_bandInfo_title": "_3drG4earrOmcoryK0_b_Fv",
	"ProgressTestCard_wrapper_bandInfo_nameRow": "_1wIX3j-GQ0Fb9mMgrLezh_",
	"ProgressTestCard_wrapper_bandInfo_name": "_2l0IbmJzyTE12h_-reu1au",
	"ProgressTestCard_wrapper_bandInfo_icon": "_31Ks-GuWWPHROBIamafo6T",
	"ProgressTestCard_wrapper_divider": "_3XsXik9AFZoaWJHpRVpdJ8",
	"ProgressTestCard_wrapper_interpretation": "_1hBcZ2sbt2C0ikA1EH0q68",
	"BenchmarkingTooltip_overlay": "_1GAQVW6kzskmWYiTYCSssN",
	"BenchmarkingTooltip_title": "_3WRxVSgQP5MndDxyy-iYZs",
	"BenchmarkingTooltip_row": "_3LwKF7Hk4E6v_EW9oA2I1s",
	"BenchmarkingTooltip_range": "_1C0qbe28H_HxpNxTLvyScy",
	"BenchmarkingTooltip_content": "_2UVh_gzBilEqpYulWxuDAI",
	"BenchmarkingTooltip_category": "_3yEz9UxLyPBIaAl3ThK15v",
	"BenchmarkingTooltip_descriptor": "vsmxRHSSssRbnL7eMX0lz",
	"BenchmarkingTooltip_footer": "_3UPUIS2l0vQlsc5IzxamWR",
	"BenchmarkingTooltip_gotIt": "_3QVJ7S5fvl7S1UKKi0FXG0"
};

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRadialProgressSansAnimation = __webpack_require__(284);

var _reactRadialProgressSansAnimation2 = _interopRequireDefault(_reactRadialProgressSansAnimation);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hfv4BandColors = __webpack_require__(815);

var _hfv4BandColors2 = _interopRequireDefault(_hfv4BandColors);

var _hfv4ScoreBands = __webpack_require__(110);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadialScoreDisplay = function RadialScoreDisplay(props) {
  var value = _is_js2.default.number(props.percent) ? props.percent : props.value;
  var color = _hfv4BandColors2.default.colorDefault;
  if (_is_js2.default.number(props.percent) || props.unit === 'percent') {
    var band = (0, _hfv4ScoreBands.getHfv4BandForScore)(value);
    if (band) color = band.color;
  }
  return _react2.default.createElement(
    'div',
    { className: props.className },
    _react2.default.createElement(_reactRadialProgressSansAnimation2.default, _extends({}, props, {
      progressStroke: color,
      value: props.percent || props.value }))
  );
};

RadialScoreDisplay.propTypes = {
  unit: _propTypes2.default.string,
  value: _propTypes2.default.number,
  percent: _propTypes2.default.number,
  className: _propTypes2.default.string
};

exports.default = RadialScoreDisplay;

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1954);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2kZX4D7RaXyT3-2ICxatvx{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex}._20qIJBCxzv10qWvaBdkoBE{color:#f5a623}._20qIJBCxzv10qWvaBdkoBE+._20qIJBCxzv10qWvaBdkoBE{margin-left:.35714rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ScoreStar": "_2kZX4D7RaXyT3-2ICxatvx",
	"ScoreStar_starIcon": "_20qIJBCxzv10qWvaBdkoBE"
};

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _SimpleTable = __webpack_require__(133);

var _SimpleTable2 = _interopRequireDefault(_SimpleTable);

var _style = __webpack_require__(1956);

var _style2 = _interopRequireDefault(_style);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverallDevelopmentCard = function (_PureComponent) {
  _inherits(OverallDevelopmentCard, _PureComponent);

  function OverallDevelopmentCard() {
    _classCallCheck(this, OverallDevelopmentCard);

    return _possibleConstructorReturn(this, (OverallDevelopmentCard.__proto__ || Object.getPrototypeOf(OverallDevelopmentCard)).apply(this, arguments));
  }

  _createClass(OverallDevelopmentCard, [{
    key: '_renderHeader',
    value: function _renderHeader(abilities) {
      return _react2.default.createElement(
        _SimpleTable2.default.Header,
        null,
        _react2.default.createElement(
          _SimpleTable2.default.Row,
          null,
          _react2.default.createElement(_SimpleTable2.default.Cell, { columnId: { columnId: 'skill' }, key: 0 }),
          abilities.sort(function (a, b) {
            return b.point - a.point;
          }).map(function (ability) {
            return _react2.default.createElement(
              _SimpleTable2.default.Cell,
              { key: ability.abilityId,
                columnId: { columnId: 'ability', ability: ability } },
              ability.name
            );
          })
        )
      );
    }
  }, {
    key: '_renderBody',
    value: function _renderBody(skillMap, subSkillMap) {
      return _react2.default.createElement(
        _SimpleTable2.default.Body,
        null,
        function (_ref, _ref2) {
          var skillResult = _ref.skillResult;
          var columnId = _ref2.columnId,
              ability = _ref2.ability;

          if (columnId === 'skill') {
            return _react2.default.createElement(
              _SimpleTable2.default.Cell,
              null,
              skillMap.get(skillResult.skillId)
            );
          }

          var items = skillResult.subSkillResults.filter(function (ssr) {
            return ssr.currentResultAbilityId === ability.abilityId;
          }).map(function (ssr) {
            return { uid: ssr.subSkillId, value: subSkillMap.get(ssr.subSkillId) };
          });

          if (items.length === 0) {
            return _react2.default.createElement(_SimpleTable2.default.Cell, null);
          } else if (items.length === 1) {
            return _react2.default.createElement(
              _SimpleTable2.default.Cell,
              null,
              items[0].value
            );
          }

          return _react2.default.createElement(
            _SimpleTable2.default.Cell,
            null,
            _react2.default.createElement(
              'ul',
              null,
              items.map(function (item) {
                return _react2.default.createElement(
                  'li',
                  { key: item.uid, style: { textAlign: 'left' } },
                  item.value
                );
              })
            )
          );
        }
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          skills = _props.skills,
          skillResults = _props.skillResults;


      var skillMap = new Map();
      var subSkillMap = new Map();
      var abilities = skills.get(0).abilities;
      skills.forEach(function (skill) {
        if (!skillMap.has(skill.skillId)) {
          skillMap.set(skill.skillId, skill.name);
        }

        skill.subSkills.forEach(function (subSkill) {
          if (!subSkillMap.has(subSkill.subSkillId)) {
            subSkillMap.set(subSkill.subSkillId, subSkill.name);
          }
        });
      });

      var rows = skillResults.toList().map(function (skillResult) {
        return { skillResult: skillResult };
      });

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _classnames2.default)(className, _style2.default.OverallDevelopmentCard) },
        _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Overall Development' }),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          null,
          _react2.default.createElement(
            _SimpleTable2.default,
            { rows: rows },
            this._renderHeader(abilities),
            this._renderBody(skillMap, subSkillMap)
          )
        )
      );
    }
  }]);

  return OverallDevelopmentCard;
}(_react.PureComponent);

OverallDevelopmentCard.propTypes = {
  className: _propTypes2.default.string,
  skills: _propTypes2.default.object,
  skillResults: _propTypes2.default.object
};

exports.default = OverallDevelopmentCard;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1957);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".aVxcmfrPP_mZdoyPCnBAG{height:100%}.aVxcmfrPP_mZdoyPCnBAG p{margin-bottom:0;margin-top:0}.aVxcmfrPP_mZdoyPCnBAG span{font-weight:700}._2OeCicSmeYNbNGli7w1P4G:first-child{margin-top:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"OverallDevelopmentCard": "aVxcmfrPP_mZdoyPCnBAG",
	"OverallDevelopmentCard_subtitle": "_2OeCicSmeYNbNGli7w1P4G"
};

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomeworkCard = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _style = __webpack_require__(1959);

var _style2 = _interopRequireDefault(_style);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var HomeworkCard = exports.HomeworkCard = function HomeworkCard(props) {
  var className = props.className;
  var averageScorePercentage = props.averageScorePercentage,
      completedAssignments = props.completedAssignments,
      totalAssignments = props.totalAssignments,
      completedPaperBased = props.completedPaperBased,
      totalPaperBased = props.totalPaperBased,
      shouldShowPaperBased = props.shouldShowPaperBased;

  return _react2.default.createElement(
    _omniCommonUi.PageCard,
    { className: (0, _classnames2.default)(className, _style2.default.HomeworkCard) },
    _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Homework' }),
    _react2.default.createElement(
      _omniCommonUi.PageCard.Content,
      null,
      _react2.default.createElement(
        'div',
        { className: _style2.default.HomeworkCard_wrapper },
        _react2.default.createElement(
          'p',
          { className: _style2.default.HomeworkCard_subtitle },
          'Assignments completed'
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.HomeworkCard_dots_wrapper },
          _react2.default.createElement(
            'span',
            { className: _style2.default.HomeworkCard_dots_caption },
            completedAssignments + '/' + totalAssignments
          ),
          totalAssignments <= 10 && _react2.default.createElement(
            'div',
            { className: _style2.default.HomeworkCard_dots },
            [].concat(_toConsumableArray(Array(completedAssignments).keys())).map(function (index) {
              return _react2.default.createElement('span', { key: index,
                className: (0, _classnames2.default)(_style2.default.HomeworkCard_dot, _style2.default.HomeworkCard_dot_filled) });
            }),
            [].concat(_toConsumableArray(Array(totalAssignments - completedAssignments).keys())).map(function (index) {
              return _react2.default.createElement('span', { className: _style2.default.HomeworkCard_dot, key: index });
            })
          )
        ),
        _react2.default.createElement(
          'p',
          { className: _style2.default.HomeworkCard_subtitle },
          'Average score for completed assignments'
        ),
        _react2.default.createElement(
          'span',
          { className: _style2.default.HomeworkCard_avgScorePerc },
          averageScorePercentage || 0,
          '%'
        ),
        shouldShowPaperBased && [_react2.default.createElement(
          'p',
          { className: _style2.default.HomeworkCard_subtitle },
          'Paper-based practice completed'
        ), _react2.default.createElement(
          'div',
          { className: _style2.default.HomeworkCard_dots_wrapper },
          _react2.default.createElement(
            'span',
            { className: _style2.default.HomeworkCard_dots_caption },
            completedPaperBased + '/' + totalPaperBased
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.HomeworkCard_dots },
            [].concat(_toConsumableArray(Array(completedPaperBased).keys())).map(function (index) {
              return _react2.default.createElement('span', { key: index,
                className: (0, _classnames2.default)(_style2.default.HomeworkCard_dot, _style2.default.HomeworkCard_dot_filled) });
            }),
            [].concat(_toConsumableArray(Array(totalPaperBased - completedPaperBased).keys())).map(function (index) {
              return _react2.default.createElement('span', { key: index, className: _style2.default.HomeworkCard_dot });
            })
          )
        )]
      )
    )
  );
};

HomeworkCard.propTypes = {
  averageScorePercentage: _propTypes2.default.number,
  completedAssignments: _propTypes2.default.number,
  totalAssignments: _propTypes2.default.number,
  className: _propTypes2.default.string,
  shouldShowPaperBased: _propTypes2.default.bool.isRequired,
  completedPaperBased: _propTypes2.default.number,
  totalPaperBased: _propTypes2.default.number
};

exports.default = HomeworkCard;

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1960);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2QLdVjZiSnfW1ueW2Fcr5i{height:100%}._2QLdVjZiSnfW1ueW2Fcr5i p{margin-bottom:0;margin-top:0}._2QLdVjZiSnfW1ueW2Fcr5i span{font-weight:700}._1LX7I6H46vp_CFGWEWn3rq:first-child{margin-top:0}._3IsbuNUgAYlfaJ_uUSCQkZ+._1LX7I6H46vp_CFGWEWn3rq,._3njFWk5q9O8ffuxAZSqaRY+._1LX7I6H46vp_CFGWEWn3rq{margin-top:1.42857rem}._3IsbuNUgAYlfaJ_uUSCQkZ{margin-bottom:0}._3b92Vc15AjRe4ZUBzXF1uc{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-left:.71429rem;margin-top:.21429rem;width:14.64286rem}._3b92Vc15AjRe4ZUBzXF1uc,._3njFWk5q9O8ffuxAZSqaRY{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._1ZjkELX8TLelyrIftJYJ6q{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin-right:.71429rem}._1ZjkELX8TLelyrIftJYJ6q,._1ZjkELX8TLelyrIftJYJ6q:before{-webkit-box-flex:0;-moz-box-flex:0;height:.71429rem;width:.71429rem}._1ZjkELX8TLelyrIftJYJ6q:before{background-color:#ccc;border-color:#ccc;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;content:\"\";-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto}._3dk1-2cIV5yBgWuzN4V80D:before{background-color:#0087e6;border-color:#0087e6}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"HomeworkCard": "_2QLdVjZiSnfW1ueW2Fcr5i",
	"HomeworkCard_subtitle": "_1LX7I6H46vp_CFGWEWn3rq",
	"HomeworkCard_dots_wrapper": "_3njFWk5q9O8ffuxAZSqaRY",
	"HomeworkCard_avgScorePerc": "_3IsbuNUgAYlfaJ_uUSCQkZ",
	"HomeworkCard_dots": "_3b92Vc15AjRe4ZUBzXF1uc",
	"HomeworkCard_dot": "_1ZjkELX8TLelyrIftJYJ6q",
	"HomeworkCard_dot_filled": "_3dk1-2cIV5yBgWuzN4V80D"
};

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkillScoreCard = undefined;

var _style = __webpack_require__(1962);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _ScoreStar = __webpack_require__(817);

var _ScoreStar2 = _interopRequireDefault(_ScoreStar);

var _ScoreBand = __webpack_require__(816);

var _ScoreBand2 = _interopRequireDefault(_ScoreBand);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hfv4ScoreBands = __webpack_require__(110);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SkillScoreCard = exports.SkillScoreCard = function SkillScoreCard(_ref) {
  var skillName = _ref.skillName,
      skillDescription = _ref.skillDescription,
      scorePercentage = _ref.scorePercentage,
      studentResultForSkill = _ref.studentResultForSkill,
      isSSCourseTypeGroup = _ref.isSSCourseTypeGroup;

  var band = (0, _hfv4ScoreBands.getHfv4BandForScore)(scorePercentage);
  var bandColorStyle = !isSSCourseTypeGroup && band ? { color: band.color } : undefined;
  var suggestionsElem = null;
  if (studentResultForSkill.suggestions && studentResultForSkill.suggestions.size > 0) {
    suggestionsElem = _react2.default.createElement(
      'div',
      { className: _style2.default.SkillScoreCard_suggestions },
      _react2.default.createElement(
        'h4',
        { className: _style2.default.SkillScoreCard_suggestionsHeading },
        'Suggestions'
      ),
      _react2.default.createElement(
        'ul',
        null,
        studentResultForSkill.suggestions.map(function (suggestion) {
          return _react2.default.createElement(
            'li',
            null,
            suggestion
          );
        })
      )
    );
  }
  return _react2.default.createElement(
    _omniCommonUi.PageCard,
    { className: _style2.default.SkillScoreCard },
    _react2.default.createElement(
      _omniCommonUi.PageCard.Content,
      null,
      _react2.default.createElement(
        'h4',
        { className: _style2.default.SkillScoreCard_heading, style: bandColorStyle },
        _react2.default.createElement(
          'span',
          { className: (0, _omniCommonUi.testClass)('pt-skill') },
          skillName
        ),
        '\xA0',
        !isSSCourseTypeGroup && scorePercentage + '%'
      ),
      _react2.default.createElement(
        'div',
        { className: _style2.default.SkillScoreCard_progressWrapper,
          style: bandColorStyle },
        isSSCourseTypeGroup ? _react2.default.createElement(_ScoreStar2.default, { currentResult: studentResultForSkill.currentResult,
          fullMark: studentResultForSkill.fullMark }) : _react2.default.createElement(_omniCommonUi.ProgressBar, { className: _style2.default.SkillScoreCard_progressBar,
          value: studentResultForSkill.currentResult,
          max: studentResultForSkill.fullMark,
          larger: true,
          rounded: true })
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ScoreBand2.default, { className: _style2.default.SkillScoreCard_scoreBand,
          score: scorePercentage,
          style: bandColorStyle,
          textKey: 'name' }),
        _react2.default.createElement(
          'p',
          { className: _style2.default.SkillScoreCard_description },
          skillDescription
        )
      ),
      suggestionsElem
    )
  );
};

SkillScoreCard.propTypes = {
  skillName: _propTypes2.default.string.isRequired,
  skillDescription: _propTypes2.default.string.isRequired,
  scorePercentage: _propTypes2.default.number.isRequired,
  studentResultForSkill: _propTypes2.default.object.isRequired,
  isSSCourseTypeGroup: _propTypes2.default.bool.isRequired
};

exports.default = SkillScoreCard;

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1963);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".ptiWlrrxDstsj-aq1x6Wd{height:100%}._39ZKdINcKgNbeVk-4UXp94{font-weight:700;margin-top:0;margin-bottom:.71429rem}._2pyqbJFSviH1U1qO2v7gU3{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin:.14286rem 0}._2oYrrHeFMEnqzD4fXnh2rF{-webkit-flex-basis:50%;-ms-flex-preferred-size:50%;flex-basis:50%;height:.21429rem!important}._2oYrrHeFMEnqzD4fXnh2rF,._2oYrrHeFMEnqzD4fXnh2rF>div{-webkit-border-radius:.21429rem!important;-moz-border-radius:.21429rem!important;border-radius:.21429rem!important}._2oYrrHeFMEnqzD4fXnh2rF>div{background-color:currentColor}@media only screen and (min-width:800px){._2oYrrHeFMEnqzD4fXnh2rF{-webkit-flex-basis:50%;-ms-flex-preferred-size:50%;flex-basis:50%}}@media only screen and (min-width:800px){._3LnM_WuyLthRc1IkVqLJOo{margin-right:.71429rem}}._1E-5TLvMkMMTB6ofc_R0OA{font-weight:700;margin-top:.71429rem}._2fdQ6MpONF-SWLRcSpDcQ5{margin-bottom:0}.tVFLJGaknRT9LY15zAPG8{border-top:.07143rem solid #e0e0e0;margin-top:.85714rem;padding-top:.57143rem}._2SrDUF_H17sekcBylMRwdH{font-size:.92857rem;font-weight:400;color:#999;margin-top:0;margin-bottom:.28571rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SkillScoreCard": "ptiWlrrxDstsj-aq1x6Wd",
	"SkillScoreCard_heading": "_39ZKdINcKgNbeVk-4UXp94",
	"SkillScoreCard_progressWrapper": "_2pyqbJFSviH1U1qO2v7gU3",
	"SkillScoreCard_progressBar": "_2oYrrHeFMEnqzD4fXnh2rF",
	"SkillScoreCard_mistakesLink": "_3LnM_WuyLthRc1IkVqLJOo",
	"SkillScoreCard_scoreBand": "_1E-5TLvMkMMTB6ofc_R0OA",
	"SkillScoreCard_description": "_2fdQ6MpONF-SWLRcSpDcQ5",
	"SkillScoreCard_suggestions": "tVFLJGaknRT9LY15zAPG8",
	"SkillScoreCard_suggestionsHeading": "_2SrDUF_H17sekcBylMRwdH"
};

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1965);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Api = __webpack_require__(11);

var _Exporter = __webpack_require__(50);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

var _omniCommonUi = __webpack_require__(0);

var _LanguageRadio = __webpack_require__(74);

var _LanguageRadio2 = _interopRequireDefault(_LanguageRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXPORT_FILENAME = 'Unit Reports.pdf';
var EXPORT_MIME_TYPE = 'application/pdf';

var ExportDialog = function (_Component) {
  _inherits(ExportDialog, _Component);

  function ExportDialog() {
    _classCallCheck(this, ExportDialog);

    var _this = _possibleConstructorReturn(this, (ExportDialog.__proto__ || Object.getPrototypeOf(ExportDialog)).call(this));

    _this.state = {
      isExportRequested: false
    };

    _this._onLanguageChanged = _this._onLanguageChanged.bind(_this);
    return _this;
  }

  _createClass(ExportDialog, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ choosedLanguageCode: this.props.languageCode });
    }
  }, {
    key: '_close',
    value: function _close() {
      var _props = this.props,
          buildRoute = _props.buildRoute,
          pushRoute = _props.pushRoute;

      function redirect(param) {
        pushRoute(buildRoute(param));
      }
      redirect({ mode: '' });
    }
  }, {
    key: '_performExport',
    value: function _performExport() {
      var _this2 = this;

      var _props2 = this.props,
          progressReportId = _props2.progressReportId,
          studentId = _props2.studentId;

      if (_is_js2.default.falsy(progressReportId)) {
        _omniCommonUi.log.error('ExportAllHandler is not exporting - progressReportId is not set!');
        return;
      }

      var url = (0, _Api.buildUrl)('/unit-reports/' + progressReportId + '/students/' + studentId + '/printable-student-reports-pdf?' + ('languageCode=' + (this.state.choosedLanguageCode || _Languages2.default.defaultLanguageCode)));

      _Exporter.exporter.get(url, EXPORT_FILENAME, false, EXPORT_MIME_TYPE).then(function () {
        _this2._close();
      }).catch(function () {
        _this2.setState({ isExportErrorOccurred: true });
      });

      this.setState({ isExportRequested: true });
    }
  }, {
    key: '_onLanguageChanged',
    value: function _onLanguageChanged(languageCode) {
      this.setState({ choosedLanguageCode: languageCode });
    }
  }, {
    key: '_isChecked',
    value: function _isChecked(languageCode) {
      return languageCode === this.state.choosedLanguageCode;
    }
  }, {
    key: '_isDefaultLanguage',
    value: function _isDefaultLanguage() {
      if (!this.props.languageCode) return true;
      return _Languages2.default.defaultLanguageCode === this.props.languageCode;
    }
  }, {
    key: '_renderLanguageRadio',
    value: function _renderLanguageRadio() {
      return _react2.default.createElement(_LanguageRadio2.default, { name: 'language-picker',
        languageCode: this.props.languageCode,
        onChecked: this._onLanguageChanged,
        choosedLanguageCode: this.state.choosedLanguageCode });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (this.state.isExportErrorOccurred) {
        return _react2.default.createElement(_omniCommonUi.ErrorDialog, { isOpen: true,
          onConfirmClick: function onConfirmClick() {
            _this3._close();
          } });
      }

      if (!this._isDefaultLanguage()) {
        return _react2.default.createElement(
          _omniCommonUi.ConfirmDialog,
          { isOpen: true,
            isLoading: this.state.isExportRequested,
            title: 'Choose Language:',
            primaryButtonContent: 'Export',
            secondaryButtonContent: 'Cancel',
            onPrimaryClick: function onPrimaryClick() {
              return _this3._performExport();
            },
            onSecondaryClick: function onSecondaryClick() {
              return _this3._close();
            },
            onRequestClose: function onRequestClose() {
              return _this3._close();
            } },
          _react2.default.createElement(
            'div',
            { className: _style2.default.ExportAllHandler_feedback_content },
            _react2.default.createElement(
              'div',
              { className: _style2.default.ExportAllHandler_feedback_languageRadio },
              this._renderLanguageRadio()
            )
          )
        );
      }
      // the export starts automatically!
      !this.state.isExportRequested && this._performExport();
      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: true,
          isLoading: true,
          isButtonless: true,
          title: 'Exporting reports, please wait' },
        _react2.default.createElement('div', { className: _style2.default.ExportAllHandler_feedback_exportingImmediately })
      );
    }
  }]);

  return ExportDialog;
}(_react.Component);

ExportDialog.propTypes = {
  studentReportSummary: _propTypes2.default.shape({
    filter: _propTypes2.default.func.isRequired
  }).isRequired,
  progressReportId: _propTypes2.default.string.isRequired,
  languageCode: _propTypes2.default.string.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  studentId: _propTypes2.default.func.isRequired
};

exports.default = ExportDialog;

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1966);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".CfO5gG9N3Z27auAl9mc-F{min-height:4.57143rem}._2qdZn5tLzAR1395BO1q5zb{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._2qdZn5tLzAR1395BO1q5zb>p+p{margin-top:0}._30P0auBT727CH1HN3lZeUp{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:initial}._30P0auBT727CH1HN3lZeUp>*{margin-top:1.07143rem}._2lwqa7Vl38bxD82G25S3TD{border-top:.07143rem solid #ccc;display:block;margin:.35714rem 0;width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ExportAllHandler_feedback_exportingImmediately": "CfO5gG9N3Z27auAl9mc-F",
	"ExportAllHandler_feedback_content": "_2qdZn5tLzAR1395BO1q5zb",
	"ExportAllHandler_feedback_languageRadio": "_30P0auBT727CH1HN3lZeUp",
	"ExportAllHandler_feedback_divider": "_2lwqa7Vl38bxD82G25S3TD"
};

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1968);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _GroupMembers = __webpack_require__(14);

var _UiState = __webpack_require__(30);

var _hfv4ScoreBands = __webpack_require__(110);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentSelect = function (_PureComponent) {
  _inherits(StudentSelect, _PureComponent);

  function StudentSelect(props) {
    _classCallCheck(this, StudentSelect);

    var _this = _possibleConstructorReturn(this, (StudentSelect.__proto__ || Object.getPrototypeOf(StudentSelect)).call(this, props));

    _this._getLinkHrefForValue = function (studentId) {
      return _this.props.buildRoute({ studentId: studentId, mode: '' });
    };
    return _this;
  }

  _createClass(StudentSelect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._buildStudentSelectOptions();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._buildStudentSelectOptions(nextProps);
    }
  }, {
    key: '_buildStudentSelectOptions',
    value: function _buildStudentSelectOptions() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var membersInCurrentProgressReport = props.membersInCurrentProgressReport,
          studentScores = props.studentScores;
      // Invalidate cache when either members or scores change

      if (_is_js2.default.existy(this._studentSelectOptions) && _is_js2.default.existy(this._membersInCurrentProgressReport) && this._membersInCurrentProgressReport === membersInCurrentProgressReport && this._studentScores === studentScores) {
        return;
      }

      if (membersInCurrentProgressReport && membersInCurrentProgressReport.size > 0) {
        this._membersInCurrentProgressReport = membersInCurrentProgressReport;
        this._studentScores = studentScores;
        this._studentSelectOptions = membersInCurrentProgressReport.map(function (option) {
          var studentGeneralInfo = option.studentGeneralInfo;

          var scorePercentage = studentScores && studentScores.get('' + studentGeneralInfo.id);
          var band = _is_js2.default.number(scorePercentage) ? (0, _hfv4ScoreBands.getHfv4BandForScore)(scorePercentage) : null;
          var scoreStyle = band ? { color: band.color } : {};
          var optionHtml = _react2.default.createElement(
            _omniCommonUi.StudentCard,
            { vertical: true,
              borderless: true,
              backgroundless: true,
              className: _style2.default.StudentCard_hfv4 },
            _react2.default.createElement(_omniCommonUi.StudentCard.Profile, { name: studentGeneralInfo.firstName,
              surname: studentGeneralInfo.lastName,
              localName: studentGeneralInfo.localName,
              avatarUrl: studentGeneralInfo.avatarUrl,
              gender: studentGeneralInfo.gender }),
            _is_js2.default.number(scorePercentage) && _react2.default.createElement(
              'div',
              { className: _style2.default.StudentSelect_score, style: scoreStyle },
              scorePercentage,
              '%'
            )
          );
          return {
            html: optionHtml,
            value: studentGeneralInfo.id,
            className: _style2.default.StudentSelect_option
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentMember = _props.currentMember,
          membersInCurrentProgressReport = _props.membersInCurrentProgressReport,
          isHide = _props.isHide;

      if (currentMember && membersInCurrentProgressReport.size && membersInCurrentProgressReport.size > 0) {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.StudentSelect },
          _react2.default.createElement(_omniCommonUi.HorizontalSelect, { options: this._studentSelectOptions,
            value: currentMember && currentMember.studentGeneralInfo.id,
            getLinkHrefForValue: this._getLinkHrefForValue,
            isHide: isHide })
        );
      }
      return null;
    }
  }]);

  return StudentSelect;
}(_react.PureComponent);

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      studentId = _ownProps$params.studentId,
      groupId = _ownProps$params.groupId,
      progressReportId = _ownProps$params.progressReportId;

  var studentReportSummaries = state.get('rootReducer').get('studentReportSummaries').get(progressReportId);
  if (studentReportSummaries && studentReportSummaries.data) {
    var studentReportSummariesStudentIds = studentReportSummaries.data.toList().map(function (srs) {
      return srs.studentId;
    });
    var membersInCurrentProgressReport = _GroupMembers.actions.getMembersByGroup(state, groupId).filter(function (_ref) {
      var id = _ref.studentGeneralInfo.id;
      return studentReportSummariesStudentIds.indexOf('' + id) !== -1;
    });

    var studentScores = null;
    try {
      var group = state.get('rootReducer').get('groups').get(groupId).data;
      var progressReportRecord = group.progressReports.data.get(progressReportId);
      if (progressReportRecord) {
        var progressTestId = progressReportRecord.progressTestId;

        var progressTest = state.get('rootReducer').get('progressTests').get(progressTestId);
        if (_omniCommonUi.ApiResponseHelper.hasSucceeded(progressTest)) {
          studentScores = progressTest.data.studentProgressTestResults.map(function (result) {
            return result.totalScore.percentage;
          });
        }
      }
    } catch (e) {}

    return {
      currentMember: _GroupMembers.actions.getMemberById(state, studentId),
      membersInCurrentProgressReport: membersInCurrentProgressReport,
      studentScores: studentScores,
      isHide: !_UiState.actions.getShowNavigationBar(state)
    };
  }
}

StudentSelect.propTypes = {
  currentMember: _propTypes2.default.object,
  membersInCurrentProgressReport: _propTypes2.default.object,
  studentScores: _propTypes2.default.object,
  buildRoute: _propTypes2.default.func,
  isHide: _propTypes2.default.bool
};

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, null)(StudentSelect);

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1969);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1lE1xWaFNLqlqHwwhC_cQE{background:#f3f5f7;border-bottom:.07143rem solid #ccc;padding:0}._1GBZ-YOxrU3_fJjksvRhLv{height:10.57143rem!important}.ZXPobDcpafboKwctMHJQT{font-weight:700;font-size:1rem;text-align:center;color:var(--colorText);margin-top:.14286rem}._3SBG0hu3E2KZpgap-KKKQR{color:#de4c4c}._6ZF4tA7JfcJjZ_FFL8hfb [data-prop=localName]{font-size:.85em}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentSelect": "_1lE1xWaFNLqlqHwwhC_cQE",
	"StudentSelect_option": "_1GBZ-YOxrU3_fJjksvRhLv",
	"StudentSelect_score": "ZXPobDcpafboKwctMHJQT",
	"StudentSelect_score__fail": "_3SBG0hu3E2KZpgap-KKKQR",
	"StudentCard_hfv4": "_6ZF4tA7JfcJjZ_FFL8hfb"
};

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(1971);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(819);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
exports.default = _component2.default;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressReportListView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1972);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _redux = __webpack_require__(10);

var _reactRouterRedux = __webpack_require__(15);

var _reactRouter = __webpack_require__(16);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _omniCommonUi = __webpack_require__(0);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _ProgressReports = __webpack_require__(94);

var _StudentReportSummaries = __webpack_require__(42);

var _GroupMembers = __webpack_require__(14);

var _ProgressReportStatus = __webpack_require__(134);

var _ProgressReportStatus2 = _interopRequireDefault(_ProgressReportStatus);

var _ExportAllHandler = __webpack_require__(1974);

var _ExportAllHandler2 = _interopRequireDefault(_ExportAllHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MARKING = "edit";
var EXPORT_ALL = "export-all";
var EMPTY_HYPHEN = "–";

var COLUMN_SCORE = "total-score";
var COLUMN_COMMENTS = "comments";
var COLUMN_STATUS = "report-status";
var COLUMN_REPORT = "unit-report";

var SHOW_REMAINING_SESSION_MEMBERS = false;

var ProgressReportListView = exports.ProgressReportListView = function (_Component) {
  _inherits(ProgressReportListView, _Component);

  function ProgressReportListView(props) {
    _classCallCheck(this, ProgressReportListView);

    var _this = _possibleConstructorReturn(this, (ProgressReportListView.__proto__ || Object.getPrototypeOf(ProgressReportListView)).call(this, props));

    _this.state = {
      isExpandRemainingMember: true
    };
    return _this;
  }

  _createClass(ProgressReportListView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
    }
  }, {
    key: "routerWillLeave",
    value: function routerWillLeave(nextLocation) {
      var _props = this.props,
          studentReportSummaries = _props.studentReportSummaries,
          currentProgressReportId = _props.currentProgressReportId,
          submitStudentReportSummaryTeacherPublish = _props.submitStudentReportSummaryTeacherPublish,
          buildRoute = _props.buildRoute,
          pushRoute = _props.pushRoute,
          groupId = _props.groupId;

      if (!nextLocation) return;
      if (nextLocation.pathname.endsWith("/publish-all")) {
        var studentReportSummaryIds = studentReportSummaries.toList().filter(function (srs) {
          return srs.status === _StudentReportSummaries.StudentReportSummary.Status.Ready;
        }).map(function (srs) {
          return srs.id;
        });
        submitStudentReportSummaryTeacherPublish(currentProgressReportId, groupId, studentReportSummaryIds);
        pushRoute(buildRoute({ mode: "" }));
      }
    }
  }, {
    key: "_findProgressTestResultsForStudent",
    value: function _findProgressTestResultsForStudent(progressTestResults, studentId) {
      return progressTestResults.find(function (result) {
        return result.studentId === studentId;
      });
    }
  }, {
    key: "_getTotalAsPercentageOrHyphen",
    value: function _getTotalAsPercentageOrHyphen(_ref) {
      var _ref$totalScore = _ref.totalScore,
          totalScore = _ref$totalScore === undefined ? {} : _ref$totalScore;

      if (!_is_js2.default.object(totalScore) || totalScore.isEmpty || totalScore.isNotApplicable) {
        return EMPTY_HYPHEN;
      }
      return (totalScore.percentage || 0) + "%";
    }
  }, {
    key: "_gaLinkClicked",
    value: function _gaLinkClicked() {
      _reactGa2.default.event({
        category: "Progress Reports",
        action: "Clicked link to individual report"
      });
    }
  }, {
    key: "_renderCell",
    value: function _renderCell(member, column) {
      var _this2 = this;

      var _props2 = this.props,
          studentReportSummaries = _props2.studentReportSummaries,
          progressTest = _props2.progressTest;
      var studentId = member.studentGeneralInfo.id;

      var progressTestResults = progressTest.data.studentProgressTestResults;

      var reportSummaryForStudent = studentReportSummaries.find(function (report) {
        return report.studentId === studentId;
      });

      if (!reportSummaryForStudent && column !== COLUMN_REPORT) {
        if (column === COLUMN_STATUS) {
          return _react2.default.createElement(
            "div",
            { className: _style2.default.ProgressReportListView_status },
            EMPTY_HYPHEN
          );
        }
        return EMPTY_HYPHEN;
      }

      var studentProgressTestResults = this._findProgressTestResultsForStudent(progressTestResults, member.studentGeneralInfo.id);
      var progressReportLinkClassName = (0, _classnames2.default)(_style2.default.ProgressReportLink, (0, _omniCommonUi.testClass)("report-link-cell"));

      switch (column) {
        case COLUMN_SCORE:
          return this._getTotalAsPercentageOrHyphen(studentProgressTestResults);
        case COLUMN_COMMENTS:
          return this._renderComments(reportSummaryForStudent.comments);
        case COLUMN_STATUS:
          return _react2.default.createElement(
            "div",
            { className: _style2.default.ProgressReportListView_status },
            _react2.default.createElement(_ProgressReportStatus2.default, {
              className: _style2.default.ProgressReportListView_status_content,
              status: reportSummaryForStudent.status
            })
          );
        case COLUMN_REPORT:
          return _react2.default.createElement(
            _reactRouter.Link,
            {
              className: progressReportLinkClassName,
              to: this.props.buildRoute("./student/" + studentId),
              draggable: false,
              onClick: function onClick() {
                return _this2._gaLinkClicked();
              }
            },
            "Report",
            " ",
            _react2.default.createElement(_omniCommonUi.Icon, { id: "arrow-right", className: _style2.default.ProgressReportLink_icon })
          );
        default:
          throw new Error("Invalid column: " + column);
      }
    }
  }, {
    key: "_renderComments",
    value: function _renderComments(comments) {
      if (!comments) {
        return _react2.default.createElement(
          "span",
          {
            className: (0, _classnames2.default)(_style2.default.ProgressReportListView_comment, _style2.default.__empty)
          },
          EMPTY_HYPHEN
        );
      }

      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        {
          className: _style2.default.ProgressReportListView_comment,
          text: comments
        },
        _react2.default.createElement(
          "span",
          { className: _style2.default.ProgressReportListView_comment_inner },
          comments
        )
      );
    }
  }, {
    key: "_renderExpandButton",
    value: function _renderExpandButton() {
      var _this3 = this;

      var isExpandRemainingMember = this.state.isExpandRemainingMember;


      return _react2.default.createElement(_ExpansionButton2.default, {
        isExpand: isExpandRemainingMember,
        onExpansionButtonClick: function onExpansionButtonClick() {
          return _this3.setState({ isExpandRemainingMember: !isExpandRemainingMember });
        },
        className: _style2.default.ProgressReportListView_expand
      });
    }
  }, {
    key: "_renderURTable",
    value: function _renderURTable(members) {
      var _this4 = this;

      var tip = "";

      if (this.props.courseType.indexOf("SSv3") !== -1) {
        tip = _react2.default.createElement(
          _omniCommonUi.Tooltip,
          {
            text: "Total Score calculated from Can-do Statements",
            placement: "right",
            trigger: ["hover"],
            className: _style2.default.ProgressReportListView_cardHeader_tooltip
          },
          _react2.default.createElement(_omniCommonUi.Icon, { id: "question" })
        );
      }

      return _react2.default.createElement(
        _CourseViewTable2.default,
        { students: members },
        _react2.default.createElement(
          _CourseViewTable2.default.Header,
          null,
          _react2.default.createElement(
            _CourseViewTable2.default.Row,
            null,
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: COLUMN_SCORE },
              "Total Score",
              tip
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: COLUMN_COMMENTS },
              "Comments"
            ),
            _react2.default.createElement(
              _CourseViewTable2.default.Cell,
              { columnId: COLUMN_STATUS },
              "Report Status"
            ),
            _react2.default.createElement(_CourseViewTable2.default.Cell, { columnId: COLUMN_REPORT })
          )
        ),
        _react2.default.createElement(
          _CourseViewTable2.default.Body,
          null,
          function (member, column) {
            return _this4._renderCell(member, column);
          }
        )
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          members = _props3.members,
          studentReportSummaries = _props3.studentReportSummaries,
          currentProgressReportId = _props3.currentProgressReportId,
          languageCode = _props3.languageCode,
          pushRoute = _props3.pushRoute,
          buildRoute = _props3.buildRoute;


      if (!_immutable.List.isList(members) || !studentReportSummaries) {
        return null;
      }

      var isInExportAllRoute = ProgressReportListView.isInExportAllRoute(this.props);

      // disregard reports that are for students not in the list of group members
      var memberStudentIds = members.map(function (member) {
        return member.studentGeneralInfo.id;
      });
      var exportableStudentReportSummaries = studentReportSummaries.filter(function (report) {
        return memberStudentIds.indexOf(report.studentId) !== -1;
      });

      var remainingMembers = [];
      if (this.state.isExpandRemainingMember) {
        remainingMembers = this.props.remainingMembers;
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(
            _omniCommonUi.PageCard.Heading,
            {
              text: "PT Session Members",
              className: _style2.default.ProgressReportListView_cardHeader,
              titleClassName: _style2.default.ProgressReportListView_cardHeader_title
            },
            _react2.default.createElement(
              _omniCommonUi.Tooltip,
              {
                text: "PT Session: Last session of every unit",
                placement: "right",
                trigger: ["hover"],
                className: _style2.default.ProgressReportListView_cardHeader_tooltip
              },
              _react2.default.createElement(_omniCommonUi.Icon, { id: "info" })
            )
          ),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.ProgressReportListView_content },
            this._renderURTable(this.props.ptSessionMembers)
          )
        ),
        SHOW_REMAINING_SESSION_MEMBERS && _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(_omniCommonUi.PageCard.Heading, {
            text: "Remaining Session Members",
            className: _style2.default.ProgressReportListView_cardHeader
          }),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.ProgressReportListView_content },
            this._renderURTable(remainingMembers)
          ),
          this._renderExpandButton()
        ),
        isInExportAllRoute ? _react2.default.createElement(_ExportAllHandler2.default, {
          studentReportSummaries: exportableStudentReportSummaries,
          progressReportId: currentProgressReportId,
          bestCaseReportCount: members.size,
          languageCode: languageCode,
          pushRoute: pushRoute,
          buildRoute: buildRoute
        }) : null
      );
    }
  }]);

  return ProgressReportListView;
}(_react.Component);

ProgressReportListView.isInMarkingRoute = function (props) {
  return props.params && props.params.mode === MARKING;
};

ProgressReportListView.isInExportAllRoute = function (props) {
  return props.params && props.params.mode === EXPORT_ALL;
};

ProgressReportListView.propTypes = {
  members: _propTypes2.default.object.isRequired,
  ptSessionMembers: _propTypes2.default.object.isRequired,
  remainingMembers: _propTypes2.default.object.isRequired,
  currentProgressReportId: _propTypes2.default.string.isRequired,
  progressReports: _propTypes2.default.object.isRequired,
  progressReport: _propTypes2.default.object,
  progressTest: _propTypes2.default.object,
  studentReportSummaries: _propTypes2.default.object,
  languageCode: _propTypes2.default.string,
  courseType: _propTypes2.default.string,
  fetchProgressReport: _propTypes2.default.func.isRequired,
  submitStudentReportSummaryTeacherPublish: _propTypes2.default.func.isRequired,
  params: _propTypes2.default.object.isRequired,
  buildRoute: _propTypes2.default.func,
  pushRoute: _propTypes2.default.func,
  router: _propTypes2.default.any.isRequired,
  routes: _propTypes2.default.array.isRequired,
  route: _propTypes2.default.any.isRequired,
  groupId: _propTypes2.default.string
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  var group = state.get("rootReducer").get("groups").get(groupId).data;
  var progressReports = group.get("progressReports");
  var languageCode = group.get("languageCode");
  var courseTypeLevelCode = group.get("courseTypeLevelCode");
  var courseTypeCode = group.get("courseTypeCode");
  var courseType = courseTypeCode + courseTypeLevelCode;
  var currentProgressReportId = ownProps.params.progressReportId;
  if (!currentProgressReportId) return;
  var studentReportSummaries = state.get("rootReducer").get("studentReportSummaries").get(currentProgressReportId).data;
  var ptSessionStudentIds = studentReportSummaries && studentReportSummaries.filter(function (studentReportSummary) {
    return studentReportSummary.isPTSessionMember;
  }).map(function (studentReportSummary) {
    return studentReportSummary.studentId;
  });
  var remainingStudentIds = studentReportSummaries && studentReportSummaries.filter(function (studentReportSummary) {
    return !studentReportSummary.isPTSessionMember;
  }).map(function (studentReportSummary) {
    return studentReportSummary.studentId;
  });
  var members = _GroupMembers.actions.getMembersByGroup(state, groupId);
  var ptSessionMembers = ptSessionStudentIds && members.filter(function (member) {
    return ptSessionStudentIds.includes(member.studentGeneralInfo.id);
  });
  var remainingMembers = remainingStudentIds && members.filter(function (member) {
    return remainingStudentIds.includes(member.studentGeneralInfo.id);
  });
  var progressReport = progressReports.data.get(currentProgressReportId);
  var currentProgressTestId = progressReport.progressTestId;
  var progressTest = state.get("rootReducer").get("progressTests").get(currentProgressTestId);

  return {
    members: members,
    ptSessionMembers: ptSessionMembers,
    remainingMembers: remainingMembers,
    currentProgressReportId: currentProgressReportId,
    progressReports: progressReports,
    progressReport: progressReport,
    progressTest: progressTest,
    studentReportSummaries: studentReportSummaries,
    groupId: groupId,
    languageCode: languageCode,
    courseType: courseType
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: function pushRoute(path) {
      return dispatch((0, _reactRouterRedux.push)(path));
    } }, (0, _redux.bindActionCreators)(_ProgressReports.actions, dispatch), (0, _redux.bindActionCreators)(_StudentReportSummaries.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(ProgressReportListView));

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1973);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2yamb3opS2_b3AA10V-gTd{border-bottom:0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:.71429rem 1.42857rem}.VVohXBDJln6rZ9kvc9KsK{display:contents}._2vRzyT0_gtRBIW_cahGfng{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-left:.35714rem}._3VvwFfuE3mQc0FtvXC_Ma9{overflow:hidden;padding:0}._2-cxHMXlXQytmQHMHZymp3{border-top:0}._36EHcxVygaDVCYML9uA5Mp{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;max-width:100%;min-width:35vw;position:relative;vertical-align:text-bottom!important;width:100%}._3m_XbAuVql0YyH0I9ZouLM{cursor:help;left:0;max-width:100%;min-width:0;overflow:hidden;position:absolute;text-align:left;-o-text-overflow:ellipsis;text-overflow:ellipsis;top:-webkit-calc(50% - .64286rem);top:-moz-calc(50% - .64286rem);top:calc(50% - .64286rem);white-space:nowrap}._36EHcxVygaDVCYML9uA5Mp.NUBGpTX_H8SRM8UVcWDuX{-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}._1abXal6oPAVAkWOzzENszS{color:inherit;font-size:120%;text-decoration:none}._2IVi7BZ8NQGz1LD7sQOl8e{-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:left;width:100%}._3X76UgjgBcmrrsa09AJ09N{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._30zHo6Io8YcM_AEleDiXkA{text-align:left}.i7qL1Xh59hBQ7U-_qntzp{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:600;letter-spacing:.03571rem;line-height:1.28571;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;color:inherit;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;font-size:.85714rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;outline:0;text-decoration:none;text-transform:uppercase}._11Z_gEGQuNIE2D5RPZlp7-{margin-left:.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ProgressReportListView_cardHeader": "_2yamb3opS2_b3AA10V-gTd",
	"ProgressReportListView_cardHeader_title": "VVohXBDJln6rZ9kvc9KsK",
	"ProgressReportListView_cardHeader_tooltip": "_2vRzyT0_gtRBIW_cahGfng",
	"ProgressReportListView_content": "_3VvwFfuE3mQc0FtvXC_Ma9",
	"ProgressReportListView_expand": "_2-cxHMXlXQytmQHMHZymp3",
	"ProgressReportListView_comment": "_36EHcxVygaDVCYML9uA5Mp",
	"ProgressReportListView_comment_inner": "_3m_XbAuVql0YyH0I9ZouLM",
	"__empty": "NUBGpTX_H8SRM8UVcWDuX",
	"ProgressReportListView_reportLink": "_1abXal6oPAVAkWOzzENszS",
	"ProgressReportListView_status": "_2IVi7BZ8NQGz1LD7sQOl8e",
	"ProgressReportListView_status_content": "_3X76UgjgBcmrrsa09AJ09N",
	"ProgressReportListView_status_header": "_30zHo6Io8YcM_AEleDiXkA",
	"ProgressReportLink": "i7qL1Xh59hBQ7U-_qntzp",
	"ProgressReportLink_icon": "_11Z_gEGQuNIE2D5RPZlp7-"
};

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1975);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Api = __webpack_require__(11);

var _Exporter = __webpack_require__(50);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

var _omniCommonUi = __webpack_require__(0);

var _StudentReportSummaries = __webpack_require__(42);

var _LanguageRadio = __webpack_require__(74);

var _LanguageRadio2 = _interopRequireDefault(_LanguageRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXPORT_FILENAME = 'Unit Reports.pdf';
var EXPORT_MIME_TYPE = 'application/pdf';

var ExportAllHandler = function (_Component) {
  _inherits(ExportAllHandler, _Component);

  function ExportAllHandler() {
    _classCallCheck(this, ExportAllHandler);

    var _this = _possibleConstructorReturn(this, (ExportAllHandler.__proto__ || Object.getPrototypeOf(ExportAllHandler)).call(this));

    _this.state = {
      isExportRequested: false
    };

    _this._onLanguageChanged = _this._onLanguageChanged.bind(_this);
    return _this;
  }

  _createClass(ExportAllHandler, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ choosedLanguageCode: this.props.languageCode });
    }
  }, {
    key: '_close',
    value: function _close() {
      var _props = this.props,
          buildRoute = _props.buildRoute,
          pushRoute = _props.pushRoute;

      function redirect(param) {
        pushRoute(buildRoute(param));
      }
      redirect({ mode: '' });
    }
  }, {
    key: '_performExport',
    value: function _performExport() {
      var _this2 = this;

      var progressReportId = this.props.progressReportId;


      if (_is_js2.default.falsy(progressReportId)) {
        _omniCommonUi.log.error('ExportAllHandler is not exporting - progressReportId is not set!');
        return;
      }

      var url = (0, _Api.buildUrl)('/unit-reports/' + progressReportId + '/printable-student-reports-pdf?' + ('languageCode=' + (this.state.choosedLanguageCode || _Languages2.default.defaultLanguageCode)));

      _Exporter.exporter.get(url, EXPORT_FILENAME, false, EXPORT_MIME_TYPE).then(function () {
        _this2._close();
      }).catch(function () {
        _this2.setState({ isExportErrorOccurred: true });
      });

      this.setState({ isExportRequested: true });
    }
  }, {
    key: '_onLanguageChanged',
    value: function _onLanguageChanged(languageCode) {
      this.setState({ choosedLanguageCode: languageCode });
    }
  }, {
    key: '_isDefaultLanguage',
    value: function _isDefaultLanguage() {
      if (!this.props.languageCode) return true;
      return _Languages2.default.defaultLanguageCode === this.props.languageCode;
    }
  }, {
    key: '_renderLanguageRadio',
    value: function _renderLanguageRadio() {
      return _react2.default.createElement(_LanguageRadio2.default, { name: 'language-picker',
        languageCode: this.props.languageCode,
        onChecked: this._onLanguageChanged,
        choosedLanguageCode: this.state.choosedLanguageCode });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          studentReportSummaries = _props2.studentReportSummaries,
          bestCaseReportCount = _props2.bestCaseReportCount;


      if (this.state.isExportErrorOccurred) {
        return _react2.default.createElement(_omniCommonUi.ErrorDialog, { isOpen: true,
          onConfirmClick: function onConfirmClick() {
            _this3._close();
          } });
      }

      var readyCount = countByStatus(_StudentReportSummaries.StudentReportSummary.Status.Ready);
      var completedCount = countByStatus(_StudentReportSummaries.StudentReportSummary.Status.Completed) + countByStatus(_StudentReportSummaries.StudentReportSummary.Status.Published);
      var missingCount = countByStatus(_StudentReportSummaries.StudentReportSummary.Status.ScoresMissing);
      var awaitingApprovalCount = countByStatus(_StudentReportSummaries.StudentReportSummary.Status.SentToDoS);

      var bestCaseCount = _is_js2.default.number(bestCaseReportCount) ? bestCaseReportCount : studentReportSummaries.size;
      var notAvailableCount = bestCaseCount - (readyCount + completedCount + missingCount + awaitingApprovalCount);
      var willExportCount = readyCount + completedCount + awaitingApprovalCount;
      var willExportWithoutJustificationCount = readyCount + completedCount;

      // no reports are exportable :( (we shouldn't end up here though)
      if (willExportCount <= 0) {
        return _react2.default.createElement(
          _omniCommonUi.ConfirmDialog,
          { isOpen: true,
            title: 'No reports are available',
            primaryButtonContent: 'Close',
            onPrimaryClick: function onPrimaryClick() {
              return _this3._close();
            },
            onRequestClose: function onRequestClose() {
              return _this3._close();
            } },
          _react2.default.createElement(
            'p',
            { className: _style2.default.ExportAllHandler_feedback_noneToExport },
            'There are no reports available to export.'
          )
        );
      }

      // all reports are exportable; no need to display stats.
      if (willExportWithoutJustificationCount === bestCaseCount) {
        if (!this._isDefaultLanguage()) {
          return _react2.default.createElement(
            _omniCommonUi.ConfirmDialog,
            { isOpen: true,
              isLoading: this.state.isExportRequested,
              title: 'Choose Language:',
              primaryButtonContent: 'Export',
              secondaryButtonContent: 'Cancel',
              onPrimaryClick: function onPrimaryClick() {
                return _this3._performExport();
              },
              onSecondaryClick: function onSecondaryClick() {
                return _this3._close();
              },
              onRequestClose: function onRequestClose() {
                return _this3._close();
              } },
            _react2.default.createElement(
              'div',
              { className: _style2.default.ExportAllHandler_feedback_content },
              _react2.default.createElement(
                'div',
                { className: _style2.default.ExportAllHandler_feedback_languageRadio },
                this._renderLanguageRadio()
              )
            )
          );
        }
        // the export starts automatically!
        !this.state.isExportRequested && this._performExport();
        return _react2.default.createElement(
          _omniCommonUi.ConfirmDialog,
          { isOpen: true,
            isLoading: true,
            isButtonless: true,
            title: 'Exporting reports, please wait' },
          _react2.default.createElement('div', { className: _style2.default.ExportAllHandler_feedback_exportingImmediately })
        );
      }

      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: true,
          isLoading: this.state.isExportRequested,
          title: 'Exporting ' + willExportCount + ' of ' + bestCaseCount + ' reports',
          primaryButtonContent: 'Export',
          secondaryButtonContent: 'Cancel',
          onPrimaryClick: function onPrimaryClick() {
            return _this3._performExport();
          },
          onSecondaryClick: function onSecondaryClick() {
            return _this3._close();
          },
          onRequestClose: function onRequestClose() {
            return _this3._close();
          } },
        _react2.default.createElement(
          'div',
          { className: _style2.default.ExportAllHandler_feedback_content },
          notAvailableCount > 0 ? _react2.default.createElement(
            'p',
            { className: _style2.default.ExportAllHandler_feedback_someNotAvailable,
              'data-not-available-count': notAvailableCount },
            notAvailableCount,
            notAvailableCount > 1 ? ' reports are ' : ' report is ',
            'not available'
          ) : null,
          missingCount > 0 ? _react2.default.createElement(
            'p',
            { className: _style2.default.ExportAllHandler_feedback_someMissingScores,
              'data-missing-scores-count': missingCount },
            missingCount,
            missingCount > 1 ? ' reports are ' : ' report is ',
            'missing scores and cannot be exported'
          ) : null,
          awaitingApprovalCount > 0 ? _react2.default.createElement(
            'p',
            { className: _style2.default.ExportAllHandler_feedback_someAwaitingApproval,
              'data-awaiting-approval-count': awaitingApprovalCount },
            awaitingApprovalCount,
            awaitingApprovalCount > 1 ? ' reports are ' : ' report is ',
            'awaiting approval and will be exported without teacher\u2019s comments'
          ) : null,
          !this._isDefaultLanguage() && _react2.default.createElement('div', { className: _style2.default.ExportAllHandler_feedback_divider }),
          !this._isDefaultLanguage() && _react2.default.createElement(
            'div',
            { className: _style2.default.ExportAllHandler_feedback_languageRadio },
            _react2.default.createElement(
              'span',
              null,
              'Choose Language:'
            ),
            this._renderLanguageRadio()
          )
        )
      );

      function countByStatus(status) {
        return studentReportSummaries.filter(function (report) {
          return _is_js2.default.string(report.status) && report.status === status;
        }).size;
      }
    }
  }]);

  return ExportAllHandler;
}(_react.Component);

ExportAllHandler.propTypes = {
  studentReportSummaries: _propTypes2.default.shape({
    filter: _propTypes2.default.func.isRequired
  }).isRequired,
  progressReportId: _propTypes2.default.string.isRequired,
  bestCaseReportCount: _propTypes2.default.number,
  languageCode: _propTypes2.default.string.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired
};

exports.default = ExportAllHandler;

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1976);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".loCC1qVtX0NUgx1GVrsp5{min-height:4.57143rem}._9uBFaF-Jiurcn0CpKEwip{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._9uBFaF-Jiurcn0CpKEwip>p+p{margin-top:0}._1LqL38O7YHAOdbS0aRiPS3{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:initial}._1LqL38O7YHAOdbS0aRiPS3>*{margin-top:1.07143rem}._380CYbvVnV076ltK-f4mn1{border-top:.07143rem solid #ccc;display:block;margin:.35714rem 0;width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ExportAllHandler_feedback_exportingImmediately": "loCC1qVtX0NUgx1GVrsp5",
	"ExportAllHandler_feedback_content": "_9uBFaF-Jiurcn0CpKEwip",
	"ExportAllHandler_feedback_languageRadio": "_1LqL38O7YHAOdbS0aRiPS3",
	"ExportAllHandler_feedback_divider": "_380CYbvVnV076ltK-f4mn1",
	"ExportAllHandler_feedback_noneToExport": "_1_wgi4o9YStV14M4iRujSf",
	"ExportAllHandler_feedback_someNotAvailable": "_3QTnguG07P9sbVW69gUkyb",
	"ExportAllHandler_feedback_someMissingScores": "_1I3mBO5LP_qHtt253McP_l",
	"ExportAllHandler_feedback_someAwaitingApproval": "rVHLrFLzbyKYMFYjePP_7"
};

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BottomButtons = exports.routes = undefined;

var _component = __webpack_require__(820);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(821);

var _routes3 = _interopRequireDefault(_routes2);

var _IndividualDevelopmentPlanDetailView = __webpack_require__(827);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;
var BottomButtons = exports.BottomButtons = _IndividualDevelopmentPlanDetailView.BottomButtons;

exports.default = _component2.default;

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1979);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2iQUQG6dD1Lz25PUMappjk{position:relative;width:100%}._3Bf7dk7muqIAqFSvAiWYiK{width:100%}._3Bf7dk7muqIAqFSvAiWYiK>div>div:first-child{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;width:100%}._3Bf7dk7muqIAqFSvAiWYiK>div>div:first-child>:last-child{margin-left:auto!important}._2iQUQG6dD1Lz25PUMappjk.efX_6E4Jvyy0gJ7TzIIRj ._3Bf7dk7muqIAqFSvAiWYiK .test-viewnav-button-export{display:none!important}._1uJjro4FXkrYN-cK_lpoPS{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;height:100%;left:auto;max-width:none;position:absolute;right:0;top:0;width:auto;z-index:1;padding-left:1.42857rem;padding-right:1.42857rem;padding-left:0}@media only screen and (min-width:640px){._1uJjro4FXkrYN-cK_lpoPS{padding-left:2.14286rem;padding-right:2.14286rem}}.SY-_XY2mvqTI0MzYJB-kc{-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;margin-right:1.42857rem;width:auto}.SY-_XY2mvqTI0MzYJB-kc button:first-child{cursor:not-allowed;opacity:.45;pointer-events:none}._3KYNEFerdkdQWmTQQGZQp5{-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"DetailViewNav": "_2iQUQG6dD1Lz25PUMappjk",
	"DetailViewNav_viewNav": "_3Bf7dk7muqIAqFSvAiWYiK",
	"__withExportLanguage": "efX_6E4Jvyy0gJ7TzIIRj",
	"DetailViewNav_rightCluster": "_1uJjro4FXkrYN-cK_lpoPS",
	"DetailViewNav_languageSwitcher": "SY-_XY2mvqTI0MzYJB-kc",
	"DetailViewNav_exportButton": "_3KYNEFerdkdQWmTQQGZQp5"
};

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(824);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(826);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _routes3.default;

exports.default = _component2.default;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1982);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1hT-WbRb1Nx-USSRCOwf-3{padding:1.42857rem;overflow-x:auto}@media only screen and (min-width:640px){._1hT-WbRb1Nx-USSRCOwf-3{padding:2.14286rem}}._1hT-WbRb1Nx-USSRCOwf-3 th{white-space:nowrap}._2DqWzQdFICtYoDZiXwbriC{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:600;letter-spacing:.03571rem;line-height:1.28571;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;color:inherit;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;font-size:.85714rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;outline:0;text-decoration:none;text-transform:uppercase}.JoBTO_uG4P1xGipQ82JQY{margin-left:.71429rem}._1JurCkvbb_QB9bKOzHfP9r{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;white-space:nowrap}._3aCTyKiO_TIIQOp6KboG-W{margin:0 .28571rem;color:var(--colorTextLight)}._29XTV9UoxX2MU8lEc7PpSL{max-width:none}._29XTV9UoxX2MU8lEc7PpSL .rc-tooltip-inner{white-space:nowrap}._3feSKJz816pKjOOiGSRmwN{max-width:none;opacity:1}._3feSKJz816pKjOOiGSRmwN .rc-tooltip-inner{background-color:#4a4a4a;-webkit-border-radius:.21429rem;-moz-border-radius:.21429rem;border-radius:.21429rem;-webkit-box-shadow:0 .35714rem .71429rem .21429rem rgba(0,0,0,.2);-moz-box-shadow:0 .35714rem .71429rem .21429rem rgba(0,0,0,.2);box-shadow:0 .35714rem .71429rem .21429rem rgba(0,0,0,.2);color:#fff;cursor:default;line-height:1.5;padding:.71429rem;white-space:nowrap}._3feSKJz816pKjOOiGSRmwN.rc-tooltip-placement-bottom .rc-tooltip-arrow,._3feSKJz816pKjOOiGSRmwN.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,._3feSKJz816pKjOOiGSRmwN.rc-tooltip-placement-bottomRight .rc-tooltip-arrow{border-bottom-color:#4a4a4a}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"IndividualDevelopmentPlanListView_content": "_1hT-WbRb1Nx-USSRCOwf-3",
	"IndividualDevelopmentPlanListViewLink": "_2DqWzQdFICtYoDZiXwbriC",
	"IndividualDevelopmentPlanListViewLink_icon": "JoBTO_uG4P1xGipQ82JQY",
	"splitScore": "_1JurCkvbb_QB9bKOzHfP9r",
	"splitScore_divider": "_3aCTyKiO_TIIQOp6KboG-W",
	"splitScore_tooltip": "_29XTV9UoxX2MU8lEc7PpSL",
	"scoreTooltipBase": "_3feSKJz816pKjOOiGSRmwN"
};

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _style = __webpack_require__(1984);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_TITLE = 'Progress Report generation failed';
var DEFAULT_MESSAGE = "The system won't be able to generate a Progress Report until a Unit Quiz result has been recorded in this group.";

var ProgressReportGenerationFailedDialog = function ProgressReportGenerationFailedDialog(_ref) {
  var isOpen = _ref.isOpen,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? DEFAULT_TITLE : _ref$title,
      _ref$message = _ref.message,
      message = _ref$message === undefined ? DEFAULT_MESSAGE : _ref$message,
      _ref$confirmButtonTex = _ref.confirmButtonText,
      confirmButtonText = _ref$confirmButtonTex === undefined ? 'Got it' : _ref$confirmButtonTex,
      onConfirmClick = _ref.onConfirmClick;
  return _react2.default.createElement(
    _omniCommonUi.Dialog,
    {
      isOpen: isOpen,
      className: _style2.default.ProgressReportGenerationFailedDialog_card,
      onRequestClose: function onRequestClose() {
        return onConfirmClick();
      }
    },
    _react2.default.createElement(
      'div',
      { className: _style2.default.ProgressReportGenerationFailedDialog },
      _react2.default.createElement(
        'div',
        { className: _style2.default.ProgressReportGenerationFailedDialog_content },
        _react2.default.createElement(
          'div',
          { className: _style2.default.ProgressReportGenerationFailedDialog_header },
          _react2.default.createElement(
            'span',
            {
              className: _style2.default.ProgressReportGenerationFailedDialog_icon,
              'aria-hidden': 'true'
            },
            _react2.default.createElement(
              'svg',
              { viewBox: '0 0 30 27', xmlns: 'http://www.w3.org/2000/svg' },
              _react2.default.createElement('path', {
                className: _style2.default.ProgressReportGenerationFailedDialog_iconTriangle,
                d: 'M29.2665,25.47 L15.906,0.522 C15.72,0.1995 15.375,0 15,0 C14.6235,0 14.2785,0.1995 14.094,0.522 L0.735,25.47 C0.5535,25.7865 0.5565,26.1765 0.7425,26.49 C0.93,26.8065 1.2705,27 1.6395,27 L28.3605,27 C28.7295,27 29.07,26.8065 29.2575,26.49 C29.4435,26.1765 29.4465,25.7865 29.2665,25.47 Z'
              }),
              _react2.default.createElement('path', {
                className: _style2.default.ProgressReportGenerationFailedDialog_iconExclamation,
                d: 'M16.5,18.75 L13.5,18.75 L13.5,9 L16.5,9 L16.5,18.75 Z M16.5,24 L13.5,24 L13.5,21 L16.5,21 L16.5,24 Z'
              })
            )
          ),
          _react2.default.createElement(
            'span',
            { className: _style2.default.ProgressReportGenerationFailedDialog_title },
            title
          )
        ),
        _react2.default.createElement(
          'p',
          { className: _style2.default.ProgressReportGenerationFailedDialog_message },
          message
        )
      ),
      _react2.default.createElement(
        _omniCommonUi.Button.Container,
        {
          align: 'center',
          className: _style2.default.ProgressReportGenerationFailedDialog_buttonWrapper
        },
        _react2.default.createElement(
          _omniCommonUi.Button,
          {
            type: _omniCommonUi.Button.Type.primary,
            className: _style2.default.ProgressReportGenerationFailedDialog_button,
            onClick: function onClick() {
              return onConfirmClick();
            }
          },
          confirmButtonText
        )
      )
    )
  );
};

ProgressReportGenerationFailedDialog.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  title: _propTypes2.default.string,
  message: _propTypes2.default.string,
  confirmButtonText: _propTypes2.default.string,
  onConfirmClick: _propTypes2.default.func.isRequired
};

exports.default = ProgressReportGenerationFailedDialog;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1985);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1exibAK9VUyrOYaWRafAdV{-webkit-border-radius:.85714rem;-moz-border-radius:.85714rem;border-radius:.85714rem;overflow:hidden}._2aD8IVAsGBYE4Kjfe4h270{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;margin:0 auto;max-width:32rem;padding:1.71429rem;text-align:center;width:100%}._28efUEZ12JXZZ29mBuX0nF{margin:0 auto 1.42857rem;width:28.57143rem}._1DD8WBezAoNWkF32BN2NDN{gap:.57143rem;-ms-flex-pack:center;margin-bottom:.85714rem;overflow:visible}._1DD8WBezAoNWkF32BN2NDN,._3t8UMIuoeDzKfzrsXe3b6A{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;justify-content:center}._3t8UMIuoeDzKfzrsXe3b6A{-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;-webkit-flex-grow:0;-ms-flex-positive:0;flex-grow:0;height:1.42857rem;-ms-flex-pack:center;-webkit-box-ordinal-group:1;-webkit-order:0;-moz-box-ordinal-group:1;-ms-flex-order:0;order:0;width:1.42857rem}._3t8UMIuoeDzKfzrsXe3b6A svg{display:block;height:1.42857rem;width:1.42857rem}.oWKWJr7Dq5tSrWJl3B7cQ{fill:#f2b526}._13jFdRmGtDex2bwdADpW1n{fill:#fff}._3oiRiOlw8-8GFCHq8xdB9w{-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;color:var(--colorTextBase);font-weight:700;line-height:1.42857rem;text-align:left}.nOvwD3ivPpuaD1MKtn1xV{color:var(--colorTextBase);font-size:var(--fontSize-sm);line-height:1.4;margin:0;width:28.57143rem}._1Llita4Xvub7YkeIH7mCBi{margin:0 auto;margin-top:0;width:28.57143rem}.MlZPlc-kJNorHXBb_0u2t{-webkit-border-radius:1.42857rem;-moz-border-radius:1.42857rem;border-radius:1.42857rem;-webkit-box-flex:0;-webkit-flex-grow:0;-moz-box-flex:0;-ms-flex-positive:0;flex-grow:0;height:2.85714rem;max-width:none;min-width:28.57143rem;padding:0 2.28571rem;width:100%}", ""]);

// exports
exports.locals = {
	"ProgressReportGenerationFailedDialog_card": "_1exibAK9VUyrOYaWRafAdV",
	"ProgressReportGenerationFailedDialog": "_2aD8IVAsGBYE4Kjfe4h270",
	"ProgressReportGenerationFailedDialog_content": "_28efUEZ12JXZZ29mBuX0nF",
	"ProgressReportGenerationFailedDialog_header": "_1DD8WBezAoNWkF32BN2NDN",
	"ProgressReportGenerationFailedDialog_icon": "_3t8UMIuoeDzKfzrsXe3b6A",
	"ProgressReportGenerationFailedDialog_iconTriangle": "oWKWJr7Dq5tSrWJl3B7cQ",
	"ProgressReportGenerationFailedDialog_iconExclamation": "_13jFdRmGtDex2bwdADpW1n",
	"ProgressReportGenerationFailedDialog_title": "_3oiRiOlw8-8GFCHq8xdB9w",
	"ProgressReportGenerationFailedDialog_message": "nOvwD3ivPpuaD1MKtn1xV",
	"ProgressReportGenerationFailedDialog_buttonWrapper": "_1Llita4Xvub7YkeIH7mCBi",
	"ProgressReportGenerationFailedDialog_button": "MlZPlc-kJNorHXBb_0u2t"
};

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1987);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Api = __webpack_require__(11);

var _Exporter = __webpack_require__(50);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

var _omniCommonUi = __webpack_require__(0);

var _IndividualDevelopmentPlanStatus = __webpack_require__(68);

var _LanguageRadio = __webpack_require__(74);

var _LanguageRadio2 = _interopRequireDefault(_LanguageRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXPORT_FILENAME = 'Progress Reports.pdf';
var EXPORT_MIME_TYPE = 'application/pdf';

var ExportAllHandler = function (_Component) {
  _inherits(ExportAllHandler, _Component);

  function ExportAllHandler() {
    _classCallCheck(this, ExportAllHandler);

    var _this = _possibleConstructorReturn(this, (ExportAllHandler.__proto__ || Object.getPrototypeOf(ExportAllHandler)).call(this));

    _this.state = {
      isExportRequested: false
    };

    _this._onLanguageChanged = _this._onLanguageChanged.bind(_this);
    return _this;
  }

  _createClass(ExportAllHandler, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ choosedLanguageCode: this.props.languageCode });
    }
  }, {
    key: '_close',
    value: function _close() {
      var _props = this.props,
          buildRoute = _props.buildRoute,
          pushRoute = _props.pushRoute,
          groupId = _props.groupId,
          groupIdpId = _props.groupIdpId;

      pushRoute(buildRoute('/group/' + groupId + '/progress-report/' + groupIdpId));
    }
  }, {
    key: '_performExport',
    value: function _performExport() {
      var _this2 = this;

      var groupIdpId = this.props.groupIdpId;


      if (_is_js2.default.falsy(groupIdpId)) {
        _omniCommonUi.log.error('ExportAllHandler is not exporting - groupIdpId is not set!');
        return;
      }

      var url = (0, _Api.buildUrl)('/group-compulsory-idps/' + groupIdpId + '/printings?' + ('languageCode=' + (this.state.choosedLanguageCode || _Languages2.default.defaultLanguageCode)));

      _Exporter.exporter.get(url, EXPORT_FILENAME, false, EXPORT_MIME_TYPE).then(function () {
        _this2._close();
      }).catch(function () {
        _this2.setState({ isExportErrorOccurred: true });
      });

      this.setState({ isExportRequested: true });
    }
  }, {
    key: '_onLanguageChanged',
    value: function _onLanguageChanged(languageCode) {
      this.setState({ choosedLanguageCode: languageCode });
    }
  }, {
    key: '_isDefaultLanguage',
    value: function _isDefaultLanguage() {
      if (!this.props.languageCode) return true;
      return _Languages2.default.defaultLanguageCode === this.props.languageCode;
    }
  }, {
    key: '_renderLanguageRadio',
    value: function _renderLanguageRadio() {
      return _react2.default.createElement(_LanguageRadio2.default, { name: 'language-picker',
        languageCode: this.props.languageCode,
        onChecked: this._onLanguageChanged,
        choosedLanguageCode: this.state.choosedLanguageCode });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var individualDevelopmentPlanList = this.props.individualDevelopmentPlanList;


      if (this.state.isExportErrorOccurred) {
        return _react2.default.createElement(_omniCommonUi.ErrorDialog, { isOpen: true,
          onConfirmClick: function onConfirmClick() {
            _this3._close();
          } });
      }

      var exportCount = countByStatus(_IndividualDevelopmentPlanStatus.IdpStatus.COMPLETED);
      var bestCaseCount = individualDevelopmentPlanList.size;
      var notAvailableCount = bestCaseCount - exportCount;

      // no reports are exportable :( (we shouldn't end up here though)
      if (exportCount <= 0) {
        return _react2.default.createElement(
          _omniCommonUi.ConfirmDialog,
          { isOpen: true,
            title: 'No reports are available',
            primaryButtonContent: 'Close',
            onPrimaryClick: function onPrimaryClick() {
              return _this3._close();
            },
            onRequestClose: function onRequestClose() {
              return _this3._close();
            } },
          _react2.default.createElement(
            'p',
            { className: _style2.default.ExportAllHandler_feedback_noneToExport },
            'There are no reports available to export.'
          )
        );
      }

      // all reports are exportable; no need to display stats.
      if (exportCount === bestCaseCount) {
        if (!this._isDefaultLanguage()) {
          return _react2.default.createElement(
            _omniCommonUi.ConfirmDialog,
            { isOpen: true,
              isLoading: this.state.isExportRequested,
              title: 'Choose Language:',
              primaryButtonContent: 'Export',
              secondaryButtonContent: 'Cancel',
              onPrimaryClick: function onPrimaryClick() {
                return _this3._performExport();
              },
              onSecondaryClick: function onSecondaryClick() {
                return _this3._close();
              },
              onRequestClose: function onRequestClose() {
                return _this3._close();
              } },
            _react2.default.createElement(
              'div',
              { className: _style2.default.ExportAllHandler_feedback_content },
              _react2.default.createElement(
                'div',
                { className: _style2.default.ExportAllHandler_feedback_languageRadio },
                this._renderLanguageRadio()
              )
            )
          );
        }
        // the export starts automatically!
        !this.state.isExportRequested && this._performExport();
        return _react2.default.createElement(
          _omniCommonUi.ConfirmDialog,
          { isOpen: true,
            isLoading: true,
            isButtonless: true,
            title: 'Exporting reports, please wait' },
          _react2.default.createElement('div', { className: _style2.default.ExportAllHandler_feedback_exportingImmediately })
        );
      }

      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: true,
          isLoading: this.state.isExportRequested,
          title: 'Exporting ' + exportCount + ' of ' + bestCaseCount + ' reports',
          primaryButtonContent: 'Export',
          secondaryButtonContent: 'Cancel',
          onPrimaryClick: function onPrimaryClick() {
            return _this3._performExport();
          },
          onSecondaryClick: function onSecondaryClick() {
            return _this3._close();
          },
          onRequestClose: function onRequestClose() {
            return _this3._close();
          } },
        _react2.default.createElement(
          'div',
          { className: _style2.default.ExportAllHandler_feedback_content },
          notAvailableCount > 0 ? _react2.default.createElement(
            'p',
            { className: _style2.default.ExportAllHandler_feedback_someNotAvailable,
              'data-not-available-count': notAvailableCount },
            notAvailableCount,
            notAvailableCount > 1 ? ' reports are ' : ' report is ',
            'not approved and cannot be exported'
          ) : null,
          !this._isDefaultLanguage() && _react2.default.createElement('div', { className: _style2.default.ExportAllHandler_feedback_divider }),
          !this._isDefaultLanguage() && _react2.default.createElement(
            'div',
            { className: _style2.default.ExportAllHandler_feedback_languageRadio },
            _react2.default.createElement(
              'span',
              null,
              'Choose Language:'
            ),
            this._renderLanguageRadio()
          )
        )
      );

      function countByStatus(status) {
        return individualDevelopmentPlanList.filter(function (report) {
          return _is_js2.default.string(report.status) && report.status.toLowerCase() === status;
        }).size;
      }
    }
  }]);

  return ExportAllHandler;
}(_react.Component);

ExportAllHandler.propTypes = {
  individualDevelopmentPlanList: _propTypes2.default.shape({
    filter: _propTypes2.default.func.isRequired
  }).isRequired,
  groupIdpId: _propTypes2.default.string.isRequired,
  groupId: _propTypes2.default.string.isRequired,
  languageCode: _propTypes2.default.string.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  reportName: _propTypes2.default.string.isRequired
};

exports.default = ExportAllHandler;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1988);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1EkRtQyn5bzLgxC8yYCysv{min-height:4.57143rem}._3gBk3egE_OuXSYIB2WnFTy{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3gBk3egE_OuXSYIB2WnFTy>p+p{margin-top:0}._3lWM1AgmwDyVvwevnDQlqk{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:initial}._3lWM1AgmwDyVvwevnDQlqk>*{margin-top:1.07143rem}._3Hsm9V7UIz424cgQUkEiSa{border-top:.07143rem solid #ccc;display:block;margin:.35714rem 0;width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ExportAllHandler_feedback_exportingImmediately": "_1EkRtQyn5bzLgxC8yYCysv",
	"ExportAllHandler_feedback_content": "_3gBk3egE_OuXSYIB2WnFTy",
	"ExportAllHandler_feedback_languageRadio": "_3lWM1AgmwDyVvwevnDQlqk",
	"ExportAllHandler_feedback_divider": "_3Hsm9V7UIz424cgQUkEiSa"
};

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateHfv4IndividualDevelopmentList = generateHfv4IndividualDevelopmentList;

var _Api = __webpack_require__(11);

var _omniCommonUi = __webpack_require__(0);

var _actions = __webpack_require__(168);

var _generateErrors = __webpack_require__(825);

function generateHfv4IndividualDevelopmentList(groupIdpId) {
  return function (dispatch) {
    var method = 'POST';
    var url = (0, _Api.buildUrl)('/group-compulsory-idps/' + groupIdpId);

    return dispatch(generateIndividualDevelopmentListRequest()).payload.then(function (response) {
      dispatch(generateIndividualDevelopmentListSuccess(response));
      return null;
    }).catch(function (error) {
      dispatch(generateIndividualDevelopmentListFailure(error));
      return error;
    }).then(function (error) {
      dispatch((0, _actions.fetchIndividualDevelopmentPlanList)(groupIdpId));
      return error;
    });

    function generateIndividualDevelopmentListRequest() {
      return _omniCommonUi.ApiCall.createAction({
        type: _actions.GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST,
        payload: (0, _Api.fetch)(url, { method: method }),
        method: method,
        url: url
      });
    }

    function generateIndividualDevelopmentListSuccess(response) {
      return _omniCommonUi.ApiCall.createAction({
        type: _actions.GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS,
        payload: response,
        method: method,
        url: url
      });
    }

    function generateIndividualDevelopmentListFailure(error) {
      return _omniCommonUi.ApiCall.createAction({
        type: _actions.GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE,
        method: method,
        url: url,
        error: error,
        disableDefault: (0, _generateErrors.isNoProgressTestResultsWithinIdpPeriodError)(error)
      });
    }
  };
}

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1991);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _ReadOnlyField = __webpack_require__(336);

var _ReadOnlyField2 = _interopRequireDefault(_ReadOnlyField);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _redux = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FOR_PERIOD = 'For Period';
var NAME = 'Name';
var TEACHER_ONE = 'Teacher 1';
var COURSE = 'Course';
var TEACHER_TWO = 'Teacher 2';
var CENTRE = 'Centre';
var PROGRESS_ADVISOR = 'Progress Advisor';
var START_OF_DAY = 'START_OF_DAY';
var END_OF_DAY = 'END_OF_DAY';
var PERIOD_FROM = 'periodFrom';
var PERIOD_TO = 'periodTo';

var StudentInformation = function (_Component) {
  _inherits(StudentInformation, _Component);

  function StudentInformation(props) {
    _classCallCheck(this, StudentInformation);

    var _this = _possibleConstructorReturn(this, (StudentInformation.__proto__ || Object.getPrototypeOf(StudentInformation)).call(this, props));

    var _this$props$studentIn = _this.props.studentInfo.period,
        start = _this$props$studentIn.start,
        end = _this$props$studentIn.end;

    _this.state = {
      periodFrom: _this._getLocalDateFromMoment(start, START_OF_DAY),
      periodTo: _this._getLocalDateFromMoment(end, END_OF_DAY),
      wasDateChangeMade: false,
      shouldShowConfirmDialog: false
    };
    _this.studentInfoDisplayItems = [];

    _this._onPeriodUpdated = _this._onPeriodUpdated.bind(_this);
    _this._onUpdateClicked = _this._onUpdateClicked.bind(_this);
    return _this;
  }

  _createClass(StudentInformation, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.studentInfo && (props.studentInfo.period.start !== this.props.studentInfo.period.start || props.studentInfo.period.end !== this.props.studentInfo.period.end)) {
        var _props$studentInfo$pe = props.studentInfo.period,
            start = _props$studentInfo$pe.start,
            end = _props$studentInfo$pe.end;

        this.setState({
          periodFrom: this._getLocalDateFromMoment(start, START_OF_DAY),
          periodTo: this._getLocalDateFromMoment(end, END_OF_DAY),
          wasDateChangeMade: false
        });
      }
    }
  }, {
    key: '_getLocalDateFromMoment',
    value: function _getLocalDateFromMoment(date, type) {
      (0, _invariant2.default)(_omniCommonUi.moment.isMoment(date), '<StudentInformation /> can only receive the period as moment object');
      switch (type) {
        case START_OF_DAY:
          return date.clone().tz(this.props.timeZone).startOf('day').toDate();
        case END_OF_DAY:
          return date.clone().tz(this.props.timeZone).endOf('day').toDate();
        default:
          return date.clone().tz(this.props.timeZone).toDate();
      }
    }
  }, {
    key: '_getUtcDateString',
    value: function _getUtcDateString(date) {
      return _omniCommonUi.moment.utc(date).format('YYYY-MM-DDTHH:mm:ss');
    }
  }, {
    key: '_getDisplayDate',
    value: function _getDisplayDate(date) {
      var momentDate = _omniCommonUi.moment.utc(date).clone().tz(this.props.timeZone);
      var year = momentDate.year();
      var month = momentDate.month();
      var day = momentDate.date();
      return new Date(year, month, day);
    }
  }, {
    key: '_renderGridItems',
    value: function _renderGridItems() {
      var _this2 = this;

      return this.studentInfoDisplayItems.map(function (source, index) {
        if (index === 0 && _this2.props.canEdit) return _this2._renderPeriodPickers();
        var size = {};
        size = index === 0 ? { xs: 12, sm: 12, md: 12 } : { xs: 12, sm: 6, md: 3 };
        return _react2.default.createElement(
          _omniCommonUi.Grid.Item,
          { xs: size.xs,
            sm: size.sm,
            md: size.md,
            className: _style2.default.StudentInformation_item,
            key: source.title },
          _react2.default.createElement(_ReadOnlyField2.default, { boardTitle: source.title,
            boardValue: source.value,
            className: source.className,
            hideDivider: source.hideDivider })
        );
      });
    }
  }, {
    key: '_renderConfirmDialog',
    value: function _renderConfirmDialog() {
      var _this3 = this;

      var returnToView = function returnToView() {
        return _this3.setState({ shouldShowConfirmDialog: false });
      };
      var discardUpdate = function discardUpdate() {
        var _props$studentInfo$pe2 = _this3.props.studentInfo.period,
            start = _props$studentInfo$pe2.start,
            end = _props$studentInfo$pe2.end;

        _this3.setState({
          periodFrom: _this3._getLocalDateFromMoment(start, START_OF_DAY),
          periodTo: _this3._getLocalDateFromMoment(end, END_OF_DAY),
          wasDateChangeMade: false
        });
        returnToView();
      };
      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: this.state.shouldShowConfirmDialog,
          primaryButtonContent: 'Update',
          secondaryButtonContent: 'Discard',
          onPrimaryClick: function onPrimaryClick() {
            return _this3._onPeriodUpdated();
          },
          onSecondaryClick: discardUpdate,
          onRequestClose: returnToView },
        _react2.default.createElement(
          'span',
          null,
          'This will update the scores and clear all previous edits.'
        )
      );
    }
  }, {
    key: '_shouldDisableUpdateButton',
    value: function _shouldDisableUpdateButton() {
      return this.props.isInEditMode || !this.state.wasDateChangeMade;
    }
  }, {
    key: '_renderPeriodPickers',
    value: function _renderPeriodPickers() {
      var _this4 = this;

      var _props = this.props,
          groupStartDate = _props.groupStartDate,
          groupEndDate = _props.groupEndDate;
      var _state = this.state,
          periodFrom = _state.periodFrom,
          periodTo = _state.periodTo;

      if (groupStartDate && groupEndDate) {
        var disabledStartDate = this._getLocalDateFromMoment(groupStartDate);
        var periodFromLowerBound = this.props.periodFromMinDate ? this._getLocalDateFromMoment(this.props.periodFromMinDate) : disabledStartDate;
        var disabledEndDate = this._getLocalDateFromMoment(groupEndDate);
        var currentDay = (0, _omniCommonUi.moment)().clone().tz(this.props.timeZone).toDate();
        if (disabledEndDate.getTime() > currentDay.getTime()) disabledEndDate = currentDay;
        return _react2.default.createElement(
          _omniCommonUi.Grid.Item,
          { key: 'calenderPickers',
            xs: 12,
            sm: 12,
            md: 12,
            className: _style2.default.StudentInformation_item },
          _react2.default.createElement(
            'div',
            { className: _style2.default.StudentInformation_periodWrapper },
            _react2.default.createElement(
              'div',
              { className: _style2.default.StudentInformation_periodWrapper_itemContainer },
              _react2.default.createElement(
                'div',
                { className: _style2.default.StudentInformation_periodWrapper_item },
                _react2.default.createElement(
                  'span',
                  { className: _style2.default.StudentInformation_periodWrapper_item_label },
                  'For Period From'
                ),
                _react2.default.createElement(_omniCommonUi.CalendarPicker, { day: this._getDisplayDate(periodFrom),
                  onDateChanged: function onDateChanged(day) {
                    return _this4._onDateChanged(PERIOD_FROM, day);
                  },
                  disabledDayBefore: periodFromLowerBound,
                  disabledDayAfter: periodTo,
                  isValid: true })
              ),
              _react2.default.createElement(
                'div',
                { className: _style2.default.StudentInformation_periodWrapper_item },
                _react2.default.createElement(
                  'span',
                  { className: _style2.default.StudentInformation_periodWrapper_item_label },
                  'To'
                ),
                _react2.default.createElement(_omniCommonUi.CalendarPicker, { day: this._getDisplayDate(periodTo),
                  onDateChanged: function onDateChanged(day) {
                    return _this4._onDateChanged(PERIOD_TO, day);
                  },
                  disabledDayBefore: periodFrom,
                  disabledDayAfter: disabledEndDate,
                  isValid: true })
              ),
              _react2.default.createElement(
                _omniCommonUi.Button,
                { type: _omniCommonUi.Button.Type.primary,
                  onClick: this._onUpdateClicked,
                  className: _style2.default.StudentInformation_button,
                  disabled: this._shouldDisableUpdateButton() },
                'UPDATE'
              )
            )
          )
        );
      }
    }
  }, {
    key: '_onUpdateClicked',
    value: function _onUpdateClicked() {
      this.setState({ shouldShowConfirmDialog: true });
    }
  }, {
    key: '_closeConfirmDialog',
    value: function _closeConfirmDialog() {
      this.setState({ shouldShowConfirmDialog: false });
    }
  }, {
    key: '_onPeriodUpdated',
    value: function _onPeriodUpdated() {
      var period = {
        fromTime: this._getUtcDateString(this.state.periodFrom),
        toTime: this._getUtcDateString(this.state.periodTo)
      };
      this.props.submitIdpPeriod(this.props.idpId, period, this.props.groupIdpId);
      this.setState({ wasDateChangeMade: false });
      this._closeConfirmDialog();
    }
  }, {
    key: '_onDateChanged',
    value: function _onDateChanged(changedType, date) {
      var _setState;

      var startOrEndOfDay = void 0;
      if (changedType === PERIOD_FROM) startOrEndOfDay = START_OF_DAY;
      if (changedType === PERIOD_TO) startOrEndOfDay = END_OF_DAY;
      var periodDate = this._getLocalDateFromMoment(_omniCommonUi.moment.utc(date), startOrEndOfDay);
      this.setState((_setState = {}, _defineProperty(_setState, changedType, periodDate), _defineProperty(_setState, 'wasDateChangeMade', true), _setState));
    }
  }, {
    key: '_prepareStudentInfoDisplayItems',
    value: function _prepareStudentInfoDisplayItems() {
      this.studentInfoDisplayItems = [];
      var _props2 = this.props,
          isExpanded = _props2.isExpanded,
          studentInfo = _props2.studentInfo;

      this.studentInfoDisplayItems.push({
        title: FOR_PERIOD,
        value: studentInfo.forPeriod,
        period: studentInfo.period,
        hideDivider: true
      });
      if (isExpanded) {
        this.studentInfoDisplayItems.push({
          title: NAME,
          value: studentInfo.name,
          hideDivider: true
        });
        this.studentInfoDisplayItems.push({
          title: COURSE,
          value: studentInfo.course,
          hideDivider: true
        });
        this.studentInfoDisplayItems.push({
          title: TEACHER_ONE,
          value: studentInfo.teacherOne,
          hideDivider: true
        });
        this.studentInfoDisplayItems.push({
          title: TEACHER_TWO,
          value: studentInfo.teacherTwo,
          hideDivider: true
        });
        this.studentInfoDisplayItems.push({
          title: CENTRE,
          value: studentInfo.centre,
          hideDivider: true
        });
        this.studentInfoDisplayItems.push({
          title: PROGRESS_ADVISOR,
          value: studentInfo.progressAdvisor,
          hideDivider: true
        });
      }
    }
  }, {
    key: '_renderExpansionButton',
    value: function _renderExpansionButton() {
      var _props3 = this.props,
          isExpanded = _props3.isExpanded,
          onExpandButtonClick = _props3.onExpandButtonClick;

      return _react2.default.createElement(_ExpansionButton2.default, { isExpand: isExpanded,
        onExpansionButtonClick: function onExpansionButtonClick() {
          return onExpandButtonClick();
        } });
    }
  }, {
    key: 'render',
    value: function render() {
      this._prepareStudentInfoDisplayItems.call(this);

      return _react2.default.createElement(
        'div',
        { className: (0, _omniCommonUi.testClass)('student-information') },
        _react2.default.createElement(
          _omniCommonUi.PageCard,
          { className: _style2.default.StudentInformation_container },
          _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Student information' }),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.StudentInformation_content },
            _react2.default.createElement(
              _omniCommonUi.Grid,
              { className: _style2.default.StudentInformation_grid },
              _react2.default.createElement(
                _omniCommonUi.Grid.Group,
                null,
                this._renderGridItems()
              )
            )
          ),
          this._renderExpansionButton()
        ),
        this._renderConfirmDialog()
      );
    }
  }]);

  return StudentInformation;
}(_react.Component);

StudentInformation.propTypes = {
  studentInfo: _propTypes2.default.object.isRequired,
  timeZone: _propTypes2.default.string.isRequired,
  isExpanded: _propTypes2.default.bool.isRequired,
  onExpandButtonClick: _propTypes2.default.func.isRequired,
  submitIdpPeriod: _propTypes2.default.func.isRequired,
  idpId: _propTypes2.default.string.isRequired,
  groupIdpId: _propTypes2.default.string.isRequired,
  groupStartDate: _propTypes2.default.object.isRequired,
  groupEndDate: _propTypes2.default.object.isRequired,
  periodFromMinDate: _propTypes2.default.object,
  isInEditMode: _propTypes2.default.bool.isRequired,
  canEdit: _propTypes2.default.bool
};

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_IndividualDevelopmentPlans.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(null, mapDispatchToProps)(StudentInformation);

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1992);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2tTg_dIq7GRxbMmQDVHMOe{margin:0}._6fzBgdhfoN_kINzmZorD0{margin:0;padding-top:.5em}._3lziJxUJ4vR1Z9AbDjPgbY{margin-top:1.21429rem}._2plXSoH8umKyRYFJGR_52U{float:left}._2plXSoH8umKyRYFJGR_52U:after{background-color:#ccc;content:\"\";display:block;height:.07143rem;left:0;position:absolute;width:100%}._3qLsV_DsaFTpchKICEFp-F{float:left}._3LJdrVMQGrP9nL0STdFjjy{padding-bottom:.35714rem}._1bJecfDVk4SKxUmXyXvzSZ{overflow:hidden;padding-bottom:.71429rem}._1bJecfDVk4SKxUmXyXvzSZ>:not(:last-child){margin-right:1.42857rem}._1iID0MMwrU0SPO9XWli4cj{padding-bottom:0;padding-top:.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentInformation_container": "_24pd8Sk2xiWTYtAgMqLW-V",
	"StudentInformation_grid": "_2tTg_dIq7GRxbMmQDVHMOe",
	"StudentInformation_item": "_6fzBgdhfoN_kINzmZorD0",
	"StudentInformation_button": "_3lziJxUJ4vR1Z9AbDjPgbY",
	"StudentInformation_periodWrapper": "_2plXSoH8umKyRYFJGR_52U",
	"StudentInformation_periodWrapper_item": "_3qLsV_DsaFTpchKICEFp-F",
	"StudentInformation_periodWrapper_item_label": "_3LJdrVMQGrP9nL0STdFjjy",
	"StudentInformation_periodWrapper_itemContainer": "_1bJecfDVk4SKxUmXyXvzSZ",
	"StudentInformation_content": "_1iID0MMwrU0SPO9XWli4cj"
};

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1994);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".gA4cC0vw1fFCPR_7UtEb4{float:left;line-height:1.8;padding-right:1rem;width:100%}.gA4cC0vw1fFCPR_7UtEb4:after{background:#ccc;content:\"\";display:block;height:.07143rem;left:0;position:absolute;width:100%}._3HTjm0YAo1mkGx33qaEd-V:after{display:none}.tBDFerrjes4WBHYRcS3_W{color:#b4b4b4;font-size:.95em;font-weight:400;margin:0}._1v6boB0HUscXFSmn2UTCnG{border-bottom:.07143rem solid transparent;font-size:1rem;margin:0;padding-bottom:.57143rem;white-space:pre-line}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ReadOnlyField_board": "gA4cC0vw1fFCPR_7UtEb4",
	"ReadOnlyField_board___noDivider": "_3HTjm0YAo1mkGx33qaEd-V",
	"ReadOnlyField_h5": "tBDFerrjes4WBHYRcS3_W",
	"ReadOnlyField_p": "_1v6boB0HUscXFSmn2UTCnG"
};

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(829);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _omniCommonUi = __webpack_require__(0);

var _SkillSuggestionCard = __webpack_require__(1997);

var _SkillSuggestionCard2 = _interopRequireDefault(_SkillSuggestionCard);

var _TipsAndUpdatesIcon = __webpack_require__(2006);

var _TipsAndUpdatesIcon2 = _interopRequireDefault(_TipsAndUpdatesIcon);

var _AddInternalNoteControl = __webpack_require__(67);

var _AddInternalNoteControl2 = _interopRequireDefault(_AddInternalNoteControl);

var _UserCard = __webpack_require__(65);

var _UserCard2 = _interopRequireDefault(_UserCard);

var _FeedbackTipsDialog = __webpack_require__(2007);

var _FeedbackTipsDialog2 = _interopRequireDefault(_FeedbackTipsDialog);

var _BottomButtons = __webpack_require__(830);

var _BottomButtons2 = _interopRequireDefault(_BottomButtons);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _routes = __webpack_require__(170);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NUMBER_OF_TOTAL_SKILL_SUGGESTIONS = 3;

var FeedbackSuggestions = function (_Component) {
  _inherits(FeedbackSuggestions, _Component);

  function FeedbackSuggestions(props) {
    _classCallCheck(this, FeedbackSuggestions);

    var _this = _possibleConstructorReturn(this, (FeedbackSuggestions.__proto__ || Object.getPrototypeOf(FeedbackSuggestions)).call(this, props));

    _this.state = {
      wasCommentsEditMade: false,
      commentsPopup: {
        isOpen: false
      }
    };

    _this._onDiscardClick = _this._onDiscardClick.bind(_this);
    _this.onSaveClick = _this.onSaveClick.bind(_this);
    _this._onParticipationChanged = _this._onParticipationChanged.bind(_this);
    return _this;
  }

  _createClass(FeedbackSuggestions, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.isInEditMode) {
        var _props$suggestionsInf = this.props.suggestionsInfo,
            overallSuggestion = _props$suggestionsInf.overallSuggestion,
            participationId = _props$suggestionsInf.participationId,
            skillSuggestions = _props$suggestionsInf.skillSuggestions;

        this._onEditComments(overallSuggestion, participationId, skillSuggestions);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_is_js2.default.function(this.props.onComponentMounted)) {
        return;
      }
      this.props.onComponentMounted(this);
    }
  }, {
    key: "wasCommentsEditMade",
    value: function wasCommentsEditMade() {
      return this.props.isInEditMode && this.state.wasCommentsEditMade;
    }
  }, {
    key: "setWasCommentsEditMade",
    value: function setWasCommentsEditMade(wasCommentsEditMade) {
      if (this.state.wasCommentsEditMade === wasCommentsEditMade) return;
      this.setState({ wasCommentsEditMade: wasCommentsEditMade });
    }
  }, {
    key: "_renderUserAndOverall",
    value: function _renderUserAndOverall() {
      var _props$suggestionsInf2 = this.props.suggestionsInfo,
          teacherId = _props$suggestionsInf2.teacherId,
          suggestedTime = _props$suggestionsInf2.suggestedTime,
          timeZone = _props$suggestionsInf2.timeZone;

      var isSimplified = this.props.suggestionsInfo.isSimplifiedTeacherFeedback;
      var wrapperClass = this.props.shouldShowSuggestions && !isSimplified ? (0, _classnames3.default)(_style2.default.FeedbackSuggestions_overallWrapper, _style2.default._overallBorderBottom) : _style2.default.FeedbackSuggestions_overallWrapper;
      var dateStr = _is_js2.default.existy(suggestedTime) && _is_js2.default.existy(timeZone) ? _omniCommonUi.moment.parseZone(suggestedTime).clone().tz(timeZone).format("YYYY-MM-DD") : "";
      return _react2.default.createElement(
        "div",
        { className: wrapperClass },
        _is_js2.default.number(teacherId) && teacherId !== 0 && _react2.default.createElement(_UserCard2.default, {
          id: teacherId.toString(),
          dateStr: dateStr,
          className: _style2.default.FeedbackSuggestions_userCard
        }),
        _react2.default.createElement(
          "div",
          { className: _style2.default.FeedbackSuggestions_overall },
          _react2.default.createElement(
            "div",
            { className: _style2.default.FeedbackSuggestions_overall_heading },
            "Overall"
          ),
          this._renderOverallContent(),
          this._renderParticipation()
        )
      );
    }
  }, {
    key: "_renderParticipation",
    value: function _renderParticipation() {
      if (this.props.suggestionsInfo.isSimplifiedTeacherFeedback) return;
      if (this.props.participationInfo.size === 0) return;
      var labelClasses = (0, _classnames3.default)(_style2.default.FeedbackSuggestions_subTitle, _defineProperty({}, _style2.default.__grey, !this.props.isInEditMode));
      return _react2.default.createElement(
        "div",
        { className: _style2.default.FeedbackSuggestions_overall_participation },
        _react2.default.createElement(
          "div",
          { className: labelClasses },
          "Participation"
        ),
        this._renderParticipationContent()
      );
    }
  }, {
    key: "_renderParticipationContent",
    value: function _renderParticipationContent() {
      if (this.props.isInEditMode) {
        var selectedParticipationId = this.state.participationId;
        var isMissing = this._isAnyEmpty(selectedParticipationId);
        var options = this.props.participationInfo.toList().toJS().map(function (option) {
          return {
            label: option.name,
            value: parseInt(option.id, 10)
          };
        });
        options.splice(0, 0, {
          label: " ",
          value: 0,
          className: _style2.default.FeedbackSuggestions_select_option
        });
        return _react2.default.createElement(
          _omniCommonUi.Grid,
          null,
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12, sm: 6, md: 6 },
              _react2.default.createElement(
                _omniCommonUi.Form,
                null,
                _react2.default.createElement(_omniCommonUi.Form.Select, {
                  name: "idp-participation",
                  className: isMissing && _style2.default.missing,
                  options: options,
                  value: selectedParticipationId,
                  setValue: this._onParticipationChanged,
                  clearable: false,
                  searchable: false
                })
              )
            )
          )
        );
      }

      var participationId = this.props.suggestionsInfo.participationId || 0;
      var participation = this.props.participationInfo.get(participationId.toString());
      var participationName = participation && participation.name || "–";
      return _react2.default.createElement(
        "div",
        null,
        participationName
      );
    }
  }, {
    key: "_renderOverallContent",
    value: function _renderOverallContent() {
      var _this2 = this;

      if (!this.props.isInEditMode) {
        return _react2.default.createElement(
          "p",
          { className: _style2.default.FeedbackSuggestions_overall_content },
          this.props.suggestionsInfo.overallSuggestion || "–"
        );
      }
      var overallSuggestion = this.state.overallSuggestion;

      return _react2.default.createElement(_AddInternalNoteControl2.default, {
        text: overallSuggestion,
        isMissing: this._isAnyEmpty(overallSuggestion && overallSuggestion.trim()),
        maxCharacters: 1320,
        onChange: function onChange(text) {
          return _this2._onOverallSuggestionChanged(text);
        }
      });
    }
  }, {
    key: "_onOverallSuggestionChanged",
    value: function _onOverallSuggestionChanged(overallSuggestion) {
      this.setWasCommentsEditMade(true);
      this.setState({ overallSuggestion: overallSuggestion });
    }
  }, {
    key: "_onSkillSuggestionChanged",
    value: function _onSkillSuggestionChanged(text, skillIndex) {
      this.setWasCommentsEditMade(true);
      var skillSuggestions = this.state.skillSuggestions.map(function (skillSuggestion, index) {
        if (skillIndex === index) {
          return Object.assign({}, skillSuggestion, { suggestion: text });
        }
        return skillSuggestion;
      });
      this.setState({ skillSuggestions: skillSuggestions });
    }
  }, {
    key: "_onSkillRecommendationChanged",
    value: function _onSkillRecommendationChanged(skillIndex, recommendations) {
      var skillSuggestions = this.state.skillSuggestions.map(function (skillSuggestion, index) {
        if (skillIndex === index) {
          return Object.assign({}, skillSuggestion, {
            selectedRecommendationList: recommendations
          });
        }
        return skillSuggestion;
      });
      this.setState({ skillSuggestions: skillSuggestions });
    }
  }, {
    key: "_onSkillChanged",
    value: function _onSkillChanged(skillIndex, skillId) {
      var skillSuggestions = this.state.skillSuggestions;
      var suggestion = skillSuggestions[skillIndex];
      if (!_is_js2.default.undefined(suggestion) && suggestion.skillId === skillId) {
        return;
      }

      var newSkillSuggestion = void 0;
      if (_is_js2.default.not.empty(skillId) && skillId !== 0) {
        newSkillSuggestion = {
          skillId: skillId,
          suggestion: "",
          isManuallyAdded: true,
          selectedRecommendationList: []
        };
      } else {
        newSkillSuggestion = {
          skillId: 0,
          suggestion: "",
          isManuallyAdded: true,
          selectedRecommendationList: []
        };
      }
      skillSuggestions[skillIndex] = newSkillSuggestion;
      this.setState({ skillSuggestions: skillSuggestions });
      this.setWasCommentsEditMade(true);
    }
  }, {
    key: "_onParticipationChanged",
    value: function _onParticipationChanged(participationId) {
      this.setWasCommentsEditMade(true);
      this.setState({ participationId: participationId });
    }
  }, {
    key: "_renderSkillSuggestions",
    value: function _renderSkillSuggestions() {
      var _this3 = this;

      if (this.props.suggestionsInfo.isSimplifiedTeacherFeedback) return;
      var _props = this.props,
          shouldShowSuggestions = _props.shouldShowSuggestions,
          _props$suggestionsInf3 = _props.suggestionsInfo,
          skillSuggestions = _props$suggestionsInf3.skillSuggestions,
          skillResults = _props$suggestionsInf3.skillResults,
          isInEditMode = _props.isInEditMode;

      if (!shouldShowSuggestions) return;
      var skillOptions = skillResults.toJS();
      var choosenSuggestions = isInEditMode ? new _immutable.List(this.state.skillSuggestions) : skillSuggestions;
      var suggestionCards = choosenSuggestions.map(function (skillSuggestion, index) {
        return _this3._renderSkillSuggestionCard(skillSuggestion, index, skillOptions, choosenSuggestions.filter(function (_, idx) {
          return idx !== index;
        }).map(function (ss) {
          return ss.skillId;
        }).toJS(), skillSuggestion.selectedRecommendationList.size === 0);
      });
      var numberOfManual = NUMBER_OF_TOTAL_SKILL_SUGGESTIONS - suggestionCards.size;
      if (numberOfManual >= 1 && isInEditMode) {
        for (var index = suggestionCards.size; index < NUMBER_OF_TOTAL_SKILL_SUGGESTIONS; index++) {
          suggestionCards = suggestionCards.concat(this._renderSkillSuggestionCard(undefined, index, skillOptions, choosenSuggestions.map(function (ss) {
            return ss.skillId;
          }).toJS()));
        }
      }
      return suggestionCards;
    }
  }, {
    key: "_renderSkillSuggestionCard",
    value: function _renderSkillSuggestionCard(skillSuggestion, index, skillOptions) {
      var _this4 = this;

      var hiddenOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var isMissing = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var _props2 = this.props,
          isInEditMode = _props2.isInEditMode,
          isSSV3Group = _props2.isSSV3Group,
          isSkillSuggestionManualOnly = _props2.isSkillSuggestionManualOnly,
          skillRecommendations = _props2.skillRecommendations;

      var wrapperClass = isInEditMode ? _style2.default.FeedbackSuggestions_skillSuggestionWrapper : (0, _classnames3.default)(_style2.default.FeedbackSuggestions_skillSuggestionWrapper, _style2.default._borderTop);
      var skillSuggestionText = skillSuggestion && isInEditMode && this.state.skillSuggestions[index].suggestion;
      var isManuallyAdded = !skillSuggestion || !!skillSuggestion.isManuallyAdded;
      return _react2.default.createElement(
        "div",
        { key: index, className: wrapperClass },
        _react2.default.createElement(_SkillSuggestionCard2.default, {
          skillSuggestion: skillSuggestion,
          isInEditMode: isInEditMode,
          isSSV3Group: isSSV3Group,
          skillRecommendations: skillRecommendations,
          isMissing: isMissing,
          canEditSkillRecommandation: !isSkillSuggestionManualOnly,
          skillOptions: skillOptions,
          onSkillChanged: function onSkillChanged(skillId) {
            return _this4._onSkillChanged(index, skillId);
          },
          onRecommendationChanged: function onRecommendationChanged(recommendations) {
            return _this4._onSkillRecommendationChanged(index, recommendations);
          },
          isManuallyAdded: isManuallyAdded,
          hiddenOptions: hiddenOptions,
          index: index
        }),
        isInEditMode && _react2.default.createElement(
          "div",
          null,
          isSkillSuggestionManualOnly ? _react2.default.createElement(
            "div",
            { className: _style2.default.FeedbackSuggestions_subTitle },
            "Suggestions"
          ) : _react2.default.createElement(
            "div",
            { className: _style2.default.FeedbackSuggestions_subTitle },
            "Suggestions (optional)"
          ),
          _react2.default.createElement(_AddInternalNoteControl2.default, {
            text: skillSuggestionText,
            maxCharacters: 1320,
            isMissing: isSkillSuggestionManualOnly && skillSuggestion && skillSuggestion.skillId && this._isAnyEmpty(skillSuggestionText && skillSuggestionText.trim()),
            onChange: function onChange(text) {
              return _this4._onSkillSuggestionChanged(text, index);
            },
            textAreaProps: {
              disabled: _is_js2.default.not.existy(skillSuggestion) || skillSuggestion.skillId === 0,
              placeholder: "Type your own action plan here."
            },
            noAutoScroll: true
          })
        )
      );
    }
  }, {
    key: "_onEditComments",
    value: function _onEditComments(overallSuggestion, participationId) {
      var skillSuggestions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      _reactGa2.default.event({
        category: "IDP",
        action: 'Clicked "Edit" feedback and suggestions'
      });
      this.setState({
        overallSuggestion: overallSuggestion || "",
        participationId: participationId || 0,
        skillSuggestions: this._getInitialSkillSuggestions(skillSuggestions)
      });
      this.props.changeMode(_routes.Modes.EDIT_COMMENTS);
    }
  }, {
    key: "_renderTipIcons",
    value: function _renderTipIcons() {
      var _this5 = this;

      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        {
          text: "Tips for giving overall feedback",
          placement: "right",
          trigger: ["hover"],
          className: _style2.default.FeedbackSuggestions_actionButton
        },
        _react2.default.createElement(_TipsAndUpdatesIcon2.default, {
          onClick: function onClick() {
            return _this5.setState({
              commentsPopup: {
                isOpen: true,
                isOpenedbyEdit: false
              }
            });
          }
        })
      );
    }
  }, {
    key: "_renderActionIcons",
    value: function _renderActionIcons() {
      var _this6 = this;

      if (!this.props.canEdit) {
        return null;
      }
      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        {
          text: "Edit",
          placement: "left",
          trigger: ["hover"],
          className: _style2.default.FeedbackSuggestions_actionButton
        },
        _react2.default.createElement(_omniCommonUi.Icon, {
          id: "edit",
          className: (0, _omniCommonUi.testClass)("edit"),
          onClick: function onClick() {
            return _this6.setState({
              commentsPopup: {
                isOpen: true,
                isOpenedbyEdit: true
              }
            });
          }
        })
      );
    }
  }, {
    key: "_onCommentsOKClick",
    value: function _onCommentsOKClick(isOpenedbyEdit) {
      var _props$suggestionsInf4 = this.props.suggestionsInfo,
          overallSuggestion = _props$suggestionsInf4.overallSuggestion,
          participationId = _props$suggestionsInf4.participationId,
          skillSuggestions = _props$suggestionsInf4.skillSuggestions;

      if (isOpenedbyEdit) {
        this._onEditComments(overallSuggestion, participationId, skillSuggestions);
      }
      this.setState({
        commentsPopup: {
          isOpen: false
        }
      });
    }
  }, {
    key: "_renderCommentsPopup",
    value: function _renderCommentsPopup() {
      var _this7 = this;

      var commentsPopup = this.state.commentsPopup;

      return _react2.default.createElement(
        _FeedbackTipsDialog2.default,
        {
          isOpen: commentsPopup.isOpen,
          onOKClick: function onOKClick() {
            return _this7._onCommentsOKClick(commentsPopup.isOpenedbyEdit);
          }
        },
        _react2.default.createElement(
          "h3",
          null,
          "Tips for giving overall feedback and suggestion"
        ),
        _react2.default.createElement(
          "div",
          { className: _style2.default.FeedbackSuggestions_tipsContent },
          _react2.default.createElement(
            "p",
            { className: _style2.default.FeedbackSuggestions_tipsIntro },
            "These guiding principles are intended to help provide constructive feedback and suggestions to parents. Please address at least three of the points below concisely."
          ),
          _react2.default.createElement(
            "ul",
            { className: _style2.default.FeedbackSuggestions_tipsList },
            _react2.default.createElement(
              "li",
              null,
              "Give an example of a favourite activity or an area in which the student demonstrated strong performance during this period."
            ),
            _react2.default.createElement(
              "li",
              null,
              "Identify an area in which the student is experiencing difficulties, and provide a specific example."
            ),
            _react2.default.createElement(
              "li",
              null,
              "Explain what has been done, or will be done, in class to help the student improve in the identified area."
            ),
            _react2.default.createElement(
              "li",
              null,
              "Include any relevant comments or anecdotes about the student\u2019s behaviour and participation in class."
            ),
            _react2.default.createElement(
              "li",
              null,
              "Mention any improvements made since the previous report or in response to concerns raised earlier, and explain how this progress has been achieved."
            )
          )
        )
      );
    }
  }, {
    key: "_getInitialSkillSuggestions",
    value: function _getInitialSkillSuggestions(skillSuggestions) {
      return skillSuggestions.toJS().map(function (skillSuggestion) {
        return {
          skillId: skillSuggestion.skillId,
          suggestion: skillSuggestion.suggestion || "",
          isManuallyAdded: !!skillSuggestion.isManuallyAdded,
          selectedRecommendationList: skillSuggestion.selectedRecommendationList
        };
      });
    }
  }, {
    key: "_onDiscardClick",
    value: function _onDiscardClick() {
      this.setWasCommentsEditMade(false);
      this.props.changeMode("");
    }
  }, {
    key: "onSaveClick",
    value: function onSaveClick() {
      if (this._isSaveDisabled()) return;
      if (this.props.suggestionsInfo.isSimplifiedTeacherFeedback) {
        this.props.submitIdpFeedbackSuggestions(this.props.idpId, { overallSuggestion: this.state.overallSuggestion || "" }, this.props.groupIdpId);
        this._onDiscardClick();
        return;
      }
      var skillSuggestions = void 0;
      if (this.props.shouldShowSuggestions) {
        skillSuggestions = this.state.skillSuggestions.filter(function (skillSuggestion) {
          return _is_js2.default.not.empty(skillSuggestion) && skillSuggestion.skillId !== 0;
        });
      }
      var submittedSuggestions = {
        overallSuggestion: this.state.overallSuggestion || "",
        participationId: this.state.participationId,
        skillSuggestions: skillSuggestions
      };
      this.props.submitIdpFeedbackSuggestions(this.props.idpId, submittedSuggestions, this.props.groupIdpId);
      this._onDiscardClick();
    }
  }, {
    key: "_isSaveDisabled",
    value: function _isSaveDisabled() {
      var overallSuggestion = this.state.overallSuggestion;

      return !overallSuggestion || !overallSuggestion.trim();
    }
  }, {
    key: "_renderSaveAndDiscardButtons",
    value: function _renderSaveAndDiscardButtons() {
      if (!this.props.isInEditMode) return;
      return _react2.default.createElement(_BottomButtons2.default, {
        onSecondaryClick: this._onDiscardClick,
        onPrimaryClick: this.onSaveClick,
        primaryText: "SAVE",
        secondaryText: "DISCARD",
        isPrimaryDisabled: this._isSaveDisabled()
      });
    }
  }, {
    key: "_isAnyEmpty",
    value: function _isAnyEmpty() {
      for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
        fields[_key] = arguments[_key];
      }

      return fields.reduce(function (previous, field) {
        return previous || _is_js2.default.falsy(field) || _is_js2.default.existy(field) && _is_js2.default.empty(field);
      }, false);
    }
  }, {
    key: "_getEmptyHint",
    value: function _getEmptyHint(emptyActions) {
      var hint = "";
      if (emptyActions === 1) {
        hint = emptyActions + " action is missing. Please edit the hightlighted field.";
      } else if (emptyActions > 1) {
        hint = emptyActions + " actions are missing. Please edit the hightlighted fields.";
      }
      return hint;
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          suggestionsInfo = _props3.suggestionsInfo,
          shouldShowSuggestions = _props3.shouldShowSuggestions,
          isSkillSuggestionManualOnly = _props3.isSkillSuggestionManualOnly,
          canEdit = _props3.canEdit;

      var emptyActions = _IndividualDevelopmentPlans.accessors.getEmptyActions(suggestionsInfo, shouldShowSuggestions, isSkillSuggestionManualOnly);
      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        null,
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          { className: _style2.default.FeedbackSuggestions_heading },
          _react2.default.createElement(
            "h1",
            { className: _style2.default.FeedbackSuggestions_headingTitle },
            "Teacher's feedback and suggestions"
          ),
          _react2.default.createElement(
            "div",
            { className: _style2.default.FeedbackSuggestions_tipButton },
            this._renderTipIcons()
          ),
          _react2.default.createElement(
            "div",
            { className: _style2.default.FeedbackSuggestions_headingEnd },
            emptyActions && canEdit ? _react2.default.createElement(
              "div",
              { className: _style2.default.FeedbackSuggestions_header },
              this._getEmptyHint(emptyActions)
            ) : null,
            this._renderActionIcons(this.props.suggestionsInfo)
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.FeedbackSuggestions_content },
          this._renderUserAndOverall(),
          this._renderSkillSuggestions(),
          this._renderSaveAndDiscardButtons(),
          this._renderCommentsPopup()
        )
      );
    }
  }]);

  return FeedbackSuggestions;
}(_react.Component);

FeedbackSuggestions.propTypes = {
  suggestionsInfo: _propTypes2.default.shape().isRequired,
  participationInfo: _propTypes2.default.shape().isRequired,
  isSSV3Group: _propTypes2.default.bool,
  isSkillSuggestionManualOnly: _propTypes2.default.bool,
  isInEditMode: _propTypes2.default.bool.isRequired,
  changeMode: _propTypes2.default.func.isRequired,
  submitIdpFeedbackSuggestions: _propTypes2.default.func.isRequired,
  idpId: _propTypes2.default.string.isRequired,
  groupIdpId: _propTypes2.default.string.isRequired,
  onComponentMounted: _propTypes2.default.func,
  canEdit: _propTypes2.default.bool.isRequired,
  shouldShowSuggestions: _propTypes2.default.bool.isRequired,
  skillRecommendations: _propTypes2.default.shape()
};

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_IndividualDevelopmentPlans.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(null, mapDispatchToProps)(FeedbackSuggestions);

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1jbSYd7a2mu2CAJI2Etrqd{padding:0}._3LaiAObto2VHKMVjBespqw{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}._1BAq5C6DkHN4nj8mdUm0KW{-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;margin:0;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1.14286rem;font-weight:400;letter-spacing:.07143rem;line-height:1.25}._3PD5whBtYWtBlybGmzAmVz{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;margin-left:.35714rem}._1l8Yjlo5XE4AdLUmARIP5L{cursor:pointer;display:block;-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;-webkit-flex-grow:0;-ms-flex-positive:0;flex-grow:0;height:1.14286rem;width:1.14286rem}._1l8Yjlo5XE4AdLUmARIP5L path{fill:currentColor}._1l8Yjlo5XE4AdLUmARIP5L:hover{color:#0087e6}._19Znw9wFSRB4UH0m0ihUUO{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex}._19Znw9wFSRB4UH0m0ihUUO,.Zx3NaSxkPQspOT1o-tPaj{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}.Zx3NaSxkPQspOT1o-tPaj{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;margin-left:auto}.wHfM10XsbFN16YAQ-qo1v{color:#de4c4c;font-style:Italic;margin-right:1.14286rem}._20L7OcrK6VMRe1iimPzZzZ{padding:1.42857rem}@media only screen and (min-width:640px){._20L7OcrK6VMRe1iimPzZzZ{padding:1.42857rem 2.14286rem}}._20L7OcrK6VMRe1iimPzZzZ._38k4hIu0UyMap4ZdmMM6vN{border-bottom:.07143rem solid #ccc}._3N2l6pqIMquj52C3QOgghY{padding:1.42857rem}@media only screen and (min-width:640px){._3N2l6pqIMquj52C3QOgghY{padding:1.42857rem 2.14286rem}}._3N2l6pqIMquj52C3QOgghY._2i8fDojaPgipK3qDGNZs_6+._3N2l6pqIMquj52C3QOgghY._2i8fDojaPgipK3qDGNZs_6{border-top:.07143rem solid #ccc}._18iijaN_zf1Co3pgBXV2P5{padding-bottom:1.07143rem}._2vearRS3N9tqFZurlHEwvI{padding-bottom:.35714rem}._2vearRS3N9tqFZurlHEwvI._3yn8AJ6uqqruwX8-ERIiTt{color:#a4a4a4}._1szHBGpi97WfNP0pRFx0MI{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1.14286rem;font-weight:600;letter-spacing:.07143rem;line-height:1.125;padding-bottom:.71429rem}._27onVv7bljo3_SsdX8VdEN{border-bottom:.07143rem solid transparent;font-size:1rem;margin:0;white-space:pre-line}._27onVv7bljo3_SsdX8VdEN+._1XWV3HooEYVnmsGiMHC8EE{margin-top:.71429rem}._2Tl1fKiZgYk197D0EO8DjM{min-height:2.5rem}.P94JjRlW0Df40jbGt2rQk{margin-bottom:0;max-height:24.28571rem;max-width:100%;overflow-y:auto;width:100%}._10dDdJvWv12xSthwoFe8xq{margin:0 0 1.14286rem}.gXZGjRRQ3uJ9kYdAi7_M2{list-style:none;margin:0;padding:0}.gXZGjRRQ3uJ9kYdAi7_M2 li{line-height:1.35;margin-bottom:.57143rem;padding-left:1rem;position:relative}.gXZGjRRQ3uJ9kYdAi7_M2 li:last-child{margin-bottom:0}.gXZGjRRQ3uJ9kYdAi7_M2 li:before{background-color:#4a4a4a;content:\"\";height:.28571rem;left:0;position:absolute;top:.55em;width:.28571rem}._3ZhC9q4RQX9BbqBxIu6ul>div{border-color:#de4c4c}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"FeedbackSuggestions_container": "_1HyBLl2gVBfF5aMURWB4oj",
	"FeedbackSuggestions_content": "_1jbSYd7a2mu2CAJI2Etrqd",
	"FeedbackSuggestions_heading": "_3LaiAObto2VHKMVjBespqw",
	"FeedbackSuggestions_headingTitle": "_1BAq5C6DkHN4nj8mdUm0KW",
	"FeedbackSuggestions_tipButton": "_3PD5whBtYWtBlybGmzAmVz",
	"FeedbackSuggestions_tipsIcon": "_1l8Yjlo5XE4AdLUmARIP5L",
	"FeedbackSuggestions_actionButton": "_19Znw9wFSRB4UH0m0ihUUO",
	"FeedbackSuggestions_headingEnd": "Zx3NaSxkPQspOT1o-tPaj",
	"FeedbackSuggestions_header": "wHfM10XsbFN16YAQ-qo1v",
	"FeedbackSuggestions_overallWrapper": "_20L7OcrK6VMRe1iimPzZzZ",
	"_overallBorderBottom": "_38k4hIu0UyMap4ZdmMM6vN",
	"FeedbackSuggestions_skillSuggestionWrapper": "_3N2l6pqIMquj52C3QOgghY",
	"_borderTop": "_2i8fDojaPgipK3qDGNZs_6",
	"FeedbackSuggestions_userCard": "_18iijaN_zf1Co3pgBXV2P5",
	"FeedbackSuggestions_subTitle": "_2vearRS3N9tqFZurlHEwvI",
	"__grey": "_3yn8AJ6uqqruwX8-ERIiTt",
	"FeedbackSuggestions_overall_heading": "_1szHBGpi97WfNP0pRFx0MI",
	"FeedbackSuggestions_overall_content": "_27onVv7bljo3_SsdX8VdEN",
	"FeedbackSuggestions_overall_participation": "_1XWV3HooEYVnmsGiMHC8EE",
	"FeedbackSuggestions_select_option": "_2Tl1fKiZgYk197D0EO8DjM",
	"FeedbackSuggestions_tipsContent": "P94JjRlW0Df40jbGt2rQk",
	"FeedbackSuggestions_tipsIntro": "_10dDdJvWv12xSthwoFe8xq",
	"FeedbackSuggestions_tipsList": "gXZGjRRQ3uJ9kYdAi7_M2",
	"missing": "_3ZhC9q4RQX9BbqBxIu6ul"
};

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(1998);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _skillScoreHFv = __webpack_require__(111);

var skillScoreHFv4 = _interopRequireWildcard(_skillScoreHFv);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SkillRecommendation = __webpack_require__(2000);

var _SkillRecommendation2 = _interopRequireDefault(_SkillRecommendation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SkillSuggestionCard = function (_PureComponent) {
  _inherits(SkillSuggestionCard, _PureComponent);

  function SkillSuggestionCard() {
    _classCallCheck(this, SkillSuggestionCard);

    return _possibleConstructorReturn(this, (SkillSuggestionCard.__proto__ || Object.getPrototypeOf(SkillSuggestionCard)).apply(this, arguments));
  }

  _createClass(SkillSuggestionCard, [{
    key: '_judgeValue',
    value: function _judgeValue(boardValue) {
      if (!_is_js2.default.not.undefined(boardValue) || !boardValue || boardValue === '') {
        return '–';
      }
      return boardValue;
    }
  }, {
    key: '_getSkillDescription',
    value: function _getSkillDescription(skillSuggestion, skillOptions) {
      if (!skillSuggestion) return '';
      var selectedOption = skillOptions.find(function (skillOption) {
        return skillOption.skillId === skillSuggestion.skillId;
      });
      return this._formatOptionLabel(selectedOption);
    }
  }, {
    key: '_formatOptionLabel',
    value: function _formatOptionLabel(skillOption) {
      return skillOption.name + ' ' + skillScoreHFv4.formatSkillScore(skillOption);
    }
  }, {
    key: '_convertToSelectOptions',
    value: function _convertToSelectOptions(skillOptions) {
      var _this2 = this;

      var options = skillOptions.filter(function (skillOption) {
        return _is_js2.default.not.inArray(skillOption.skillId, _this2.props.hiddenOptions);
      }).map(function (skillOption) {
        var optionValue = _this2._formatOptionLabel(skillOption);
        return { label: optionValue, value: skillOption.skillId };
      });
      options.splice(0, 0, {
        label: ' ',
        value: 0,
        className: _style2.default.SkillSuggestionCard_select_option
      });
      return options;
    }
  }, {
    key: '_renderSkillResult',
    value: function _renderSkillResult() {
      var _props = this.props,
          skillSuggestion = _props.skillSuggestion,
          skillOptions = _props.skillOptions,
          onSkillChanged = _props.onSkillChanged,
          index = _props.index;

      var classesH5 = (0, _classnames2.default)(_style2.default.SkillSuggestionCard_h5, (0, _omniCommonUi.testClass)('field-title'));
      if (this.props.isInEditMode && this.props.isManuallyAdded && _is_js2.default.not.empty(skillOptions)) {
        var options = this._convertToSelectOptions(skillOptions);
        var selectedValue = skillSuggestion && skillSuggestion.skillId || 0;
        return _react2.default.createElement(
          _omniCommonUi.Form,
          { className: _style2.default.SkillSuggestionCard_skillResult },
          _react2.default.createElement(
            'div',
            { className: _style2.default.SkillSuggestionCard_skillResult_indexLabel },
            'Skill ' + (index + 1) + ' (optional)'
          ),
          _react2.default.createElement(_omniCommonUi.Form.Select, { name: 'suggestion-skill',
            options: options,
            value: selectedValue,
            setValue: onSkillChanged,
            clearable: false,
            searchable: false })
        );
      }
      return _react2.default.createElement(
        'h5',
        { className: classesH5 },
        this._getSkillDescription(skillSuggestion, skillOptions)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var classesBoard = (0, _classnames2.default)(_style2.default.SkillSuggestionCard_board);
      var _props2 = this.props,
          skillSuggestion = _props2.skillSuggestion,
          isMissing = _props2.isMissing,
          canEditSkillRecommandation = _props2.canEditSkillRecommandation;

      return _react2.default.createElement(
        'div',
        { className: classesBoard },
        _react2.default.createElement(
          _omniCommonUi.Grid,
          null,
          _react2.default.createElement(
            _omniCommonUi.Grid.Group,
            null,
            _react2.default.createElement(
              _omniCommonUi.Grid.Item,
              { xs: 12, sm: 6, md: 6, className: _style2.default.SkillSuggestionCard_item },
              this._renderSkillResult()
            )
          )
        ),
        skillSuggestion && _react2.default.createElement(_SkillRecommendation2.default, { skillRecommendations: this.props.skillRecommendations,
          skillId: skillSuggestion.skillId,
          isSSV3Group: this.props.isSSV3Group,
          isInEditMode: this.props.isInEditMode,
          selectedRecommendationItemIds: skillSuggestion.selectedRecommendationList,
          suggestion: this._judgeValue(skillSuggestion.suggestion),
          onRecommendationChanged: this.props.onRecommendationChanged,
          isMissing: isMissing,
          showEditButton: canEditSkillRecommandation })
      );
    }
  }]);

  return SkillSuggestionCard;
}(_react.PureComponent);

exports.default = SkillSuggestionCard;


SkillSuggestionCard.propTypes = {
  skillSuggestion: _propTypes2.default.shape(),
  isSSV3Group: _propTypes2.default.bool,
  isInEditMode: _propTypes2.default.bool.isRequired,
  className: _propTypes2.default.string,
  skillOptions: _propTypes2.default.array,
  onSkillChanged: _propTypes2.default.func,
  onRecommendationChanged: _propTypes2.default.func,
  isManuallyAdded: _propTypes2.default.bool.isRequired,
  isMissing: _propTypes2.default.bool,
  canEditSkillRecommandation: _propTypes2.default.bool,
  index: _propTypes2.default.number.isRequired,
  hiddenOptions: _propTypes2.default.array,
  skillRecommendations: _propTypes2.default.shape()
};

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1999);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1twgmqRFXcztMrashVJqMD{width:100%}._3Hr8h34P63dGPfA8Irbzbt{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1.14286rem;font-weight:600;letter-spacing:.07143rem;line-height:1.125;margin:0;padding-bottom:.71429rem}.hyzlm-bfvFH8l3QrEWTZQ{min-height:2.5rem}@media only screen and (min-width:480px){._29giXtsTqC5AuYTFmuItfE{padding-right:1.42857rem}}@media only screen and (min-width:640px){._29giXtsTqC5AuYTFmuItfE{padding-right:2.14286rem}}._3PYC6C__-LQpyKExhQanFF{padding-bottom:.71429rem}.FiQFW1X490ujeMhA2Bm1N{padding-bottom:1.07143rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SkillSuggestionCard_board": "_1twgmqRFXcztMrashVJqMD",
	"SkillSuggestionCard_h5": "_3Hr8h34P63dGPfA8Irbzbt",
	"SkillSuggestionCard_select_option": "hyzlm-bfvFH8l3QrEWTZQ",
	"SkillSuggestionCard_item": "_29giXtsTqC5AuYTFmuItfE",
	"SkillSuggestionCard_skillResult": "_3PYC6C__-LQpyKExhQanFF",
	"SkillSuggestionCard_skillResult_indexLabel": "FiQFW1X490ujeMhA2Bm1N"
};

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2001);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _react3 = __webpack_require__(213);

var _react4 = _interopRequireDefault(_react3);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SkillRecommendationExpandPanel = __webpack_require__(2003);

var _SkillRecommendationExpandPanel2 = _interopRequireDefault(_SkillRecommendationExpandPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SkillRecommendation = function (_PureComponent) {
  _inherits(SkillRecommendation, _PureComponent);

  function SkillRecommendation() {
    _classCallCheck(this, SkillRecommendation);

    var _this = _possibleConstructorReturn(this, (SkillRecommendation.__proto__ || Object.getPrototypeOf(SkillRecommendation)).call(this));

    _this.state = {
      isDialogOpen: false,
      selectedRecommendationItemIds: []
    };
    _this._checkRecommendationItem = _this._checkRecommendationItem.bind(_this);
    return _this;
  }

  _createClass(SkillRecommendation, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ selectedRecommendationItemIds: this.props.selectedRecommendationItemIds });
    }
  }, {
    key: '_checkRecommendationItem',
    value: function _checkRecommendationItem(id) {
      var selectedRecommendationItemIds = this.state.selectedRecommendationItemIds;

      if (selectedRecommendationItemIds.includes(id)) {
        selectedRecommendationItemIds = selectedRecommendationItemIds.filter(function (selectedId) {
          return selectedId !== id;
        });
      } else {
        selectedRecommendationItemIds = [].concat(_toConsumableArray(selectedRecommendationItemIds), [id]);
      }
      this.setState({ selectedRecommendationItemIds: selectedRecommendationItemIds });
    }
  }, {
    key: '_onOkClick',
    value: function _onOkClick() {
      this.props.onRecommendationChanged(this.state.selectedRecommendationItemIds);
      this.setState({ isDialogOpen: false });
    }
  }, {
    key: '_onCancelClick',
    value: function _onCancelClick() {
      this.setState({
        isDialogOpen: false,
        selectedRecommendationItemIds: this.props.selectedRecommendationItemIds
      });
    }
  }, {
    key: '_onClickEditActionPlan',
    value: function _onClickEditActionPlan() {
      this.setState({
        isDialogOpen: true,
        selectedRecommendationItemIds: this.props.selectedRecommendationItemIds
      });
    }
  }, {
    key: '_renderPopup',
    value: function _renderPopup(recommendationItems) {
      var _this2 = this;

      var recommendationItemsGroupByCategoryName = recommendationItems.groupBy(function (recommendationItem) {
        return recommendationItem.categoryName;
      });
      var selectedRecommendationItemIds = this.state.selectedRecommendationItemIds;

      return _react2.default.createElement(
        _omniCommonUi.Dialog,
        { isOpen: this.state.isDialogOpen,
          className: _style2.default.SkillRecommendation_popup,
          paddingless: true },
        _react2.default.createElement(
          'div',
          { className: _style2.default.SkillRecommendation_popup_content },
          recommendationItemsGroupByCategoryName.map(function (categoryItems) {
            return _react2.default.createElement(_SkillRecommendationExpandPanel2.default, { categoryName: categoryItems.first().categoryName,
              isSSV3Group: _this2.props.isSSV3Group,
              recommendationItems: categoryItems,
              selectedRecommendationItemIds: selectedRecommendationItemIds,
              checkRecommendationItem: _this2._checkRecommendationItem });
          })
        ),
        _react2.default.createElement(
          _omniCommonUi.Button.Container,
          { className: _style2.default.SkillRecommendation_popup_buttons },
          _react2.default.createElement(
            _omniCommonUi.Button,
            { onClick: function onClick() {
                return _this2._onCancelClick();
              } },
            'Cancel'
          ),
          _react2.default.createElement(
            _omniCommonUi.Button,
            { type: _omniCommonUi.Button.Type.primary,
              onClick: function onClick() {
                return _this2._onOkClick();
              } },
            'Ok'
          )
        )
      );
    }
  }, {
    key: '_renderSelectedRecommendationItems',
    value: function _renderSelectedRecommendationItems(recommendationItems, selectedRecommendationItemIds) {
      var selectedrecommendationItems = recommendationItems.filter(function (recommendationItem) {
        return selectedRecommendationItemIds.includes(recommendationItem.id);
      });
      return _react2.default.createElement(
        'div',
        { className: _style2.default.SkillRecommendation_container },
        !this.props.isInEditMode && _react2.default.createElement(
          'div',
          { className: _style2.default.SkillRecommendation_subHeading },
          'Suggestions'
        ),
        selectedrecommendationItems.map(function (selectedrecommendationItem) {
          return _react2.default.createElement(
            'div',
            { key: selectedrecommendationItem.id, className: _style2.default.SkillRecommendation_item },
            _react2.default.createElement(
              _react4.default,
              null,
              selectedrecommendationItem.itemName
            )
          );
        }),
        !this.props.isInEditMode && _react2.default.createElement(
          'div',
          { className: _style2.default.SkillRecommendation_item },
          this.props.suggestion
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          selectedRecommendationItemIds = _props.selectedRecommendationItemIds,
          skillRecommendations = _props.skillRecommendations,
          skillId = _props.skillId,
          isInEditMode = _props.isInEditMode,
          isMissing = _props.isMissing,
          showEditButton = _props.showEditButton;


      if (!skillRecommendations.keySeq().includes('' + skillId)) return null;

      var recommendationItems = skillRecommendations.get('' + skillId).skillRecommendationItems;
      return _react2.default.createElement(
        'div',
        null,
        this._renderSelectedRecommendationItems(recommendationItems, selectedRecommendationItemIds),
        isInEditMode && showEditButton && _react2.default.createElement(
          _omniCommonUi.Button,
          { className: _style2.default.SkillRecommendation_editButton,
            type: isMissing ? _omniCommonUi.Button.Type.wrong : _omniCommonUi.Button.Type.default,
            onClick: function onClick() {
              return _this3._onClickEditActionPlan();
            } },
          'Edit action plan'
        ),
        this._renderPopup(recommendationItems)
      );
    }
  }]);

  return SkillRecommendation;
}(_react.PureComponent);

exports.default = SkillRecommendation;


SkillRecommendation.propTypes = {
  skillRecommendations: _propTypes2.default.shape(),
  skillId: _propTypes2.default.number,
  suggestion: _propTypes2.default.string,
  isSSV3Group: _propTypes2.default.bool,
  isInEditMode: _propTypes2.default.bool.isRequired,
  selectedRecommendationItemIds: _propTypes2.default.oneOfType([_propTypes2.default.shape(), _propTypes2.default.array]),
  onRecommendationChanged: _propTypes2.default.func,
  isMissing: _propTypes2.default.bool,
  showEditButton: _propTypes2.default.bool
};

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2002);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1K4ANMCL94klipKtcsfq2U{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;width:35.71429rem}._3vvfMkt_zff2YRRxEeoBlx{height:28.57143rem;overflow-y:auto}._kGkqR4Nq3Qp9GLlFAaqv{-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-bottom:1.42857rem;padding-right:1.42857rem;padding-top:1.42857rem}._38QEFN9Qlvx-CO24Vq2eE{border-bottom:.07143rem solid transparent;font-size:1rem;line-height:1.5;margin:0}._1ZXe80Eogj6SJh-LzmoGJn{color:#a4a4a4;font-size:.92857rem;line-height:1.38462}._3gIMPdaOmH-SjnwRk2ohrG+._3gIMPdaOmH-SjnwRk2ohrG{margin-top:1.42857rem}._3gIMPdaOmH-SjnwRk2ohrG:first-of-type{margin-top:1.07143rem}.hIqP75n3sVYMNvvRwFmyI{margin-bottom:1.42857rem;margin-top:1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SkillRecommendation_popup": "_1K4ANMCL94klipKtcsfq2U",
	"SkillRecommendation_popup_content": "_3vvfMkt_zff2YRRxEeoBlx",
	"SkillRecommendation_popup_buttons": "_kGkqR4Nq3Qp9GLlFAaqv",
	"SkillRecommendation_container": "_38QEFN9Qlvx-CO24Vq2eE",
	"SkillRecommendation_subHeading": "_1ZXe80Eogj6SJh-LzmoGJn",
	"SkillRecommendation_item": "_3gIMPdaOmH-SjnwRk2ohrG",
	"SkillRecommendation_editButton": "hIqP75n3sVYMNvvRwFmyI"
};

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2004);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _react3 = __webpack_require__(213);

var _react4 = _interopRequireDefault(_react3);

var _omniCommonUi = __webpack_require__(0);

var _Checkbox = __webpack_require__(780);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SkillRecommendationExpandPanel = function (_PureComponent) {
  _inherits(SkillRecommendationExpandPanel, _PureComponent);

  function SkillRecommendationExpandPanel(props) {
    _classCallCheck(this, SkillRecommendationExpandPanel);

    var _this = _possibleConstructorReturn(this, (SkillRecommendationExpandPanel.__proto__ || Object.getPrototypeOf(SkillRecommendationExpandPanel)).call(this, props));

    _this.state = { isExpand: false };
    _this._changeExpandState = _this._changeExpandState.bind(_this);
    return _this;
  }

  _createClass(SkillRecommendationExpandPanel, [{
    key: '_changeExpandState',
    value: function _changeExpandState() {
      this.setState({ isExpand: !this.state.isExpand });
    }
  }, {
    key: '_isChecked',
    value: function _isChecked(recommendationItemId) {
      var selectedRecommendationItemIds = this.props.selectedRecommendationItemIds;

      return selectedRecommendationItemIds.includes(recommendationItemId);
    }
  }, {
    key: '_isDisabled',
    value: function _isDisabled(recommendationItemId) {
      var _props = this.props,
          isSSV3Group = _props.isSSV3Group,
          selectedRecommendationItemIds = _props.selectedRecommendationItemIds;

      return isSSV3Group && selectedRecommendationItemIds.length >= 3 && !selectedRecommendationItemIds.includes(recommendationItemId);
    }
  }, {
    key: '_checkRecommendationItem',
    value: function _checkRecommendationItem(id) {
      this.props.checkRecommendationItem(id);
    }
  }, {
    key: '_renderRecommendationItem',
    value: function _renderRecommendationItem(recommendationItem) {
      var isDisabled = this._isDisabled(recommendationItem.id);
      var checkRecommendationItem = this._checkRecommendationItem.bind(this, recommendationItem.id);
      return _react2.default.createElement(
        'label',
        { htmlFor: recommendationItem.id,
          className: _style2.default.SkillRecommendationExpandPanel_item,
          key: recommendationItem.id },
        _react2.default.createElement(_Checkbox2.default, { id: recommendationItem.id,
          checked: this._isChecked(recommendationItem.id),
          onChange: checkRecommendationItem,
          disabled: isDisabled }),
        _react2.default.createElement(
          _react4.default,
          { disabled: isDisabled },
          recommendationItem.itemName
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          categoryName = _props2.categoryName,
          recommendationItems = _props2.recommendationItems;
      var isExpand = this.state.isExpand;

      var iconClassName = (0, _classnames3.default)(_style2.default.SkillRecommendationExpandPanel_header_arrow, _defineProperty({}, _style2.default.__expanded, isExpand));
      return _react2.default.createElement(
        'div',
        { className: _style2.default.SkillRecommendationExpandPanel_wrapper },
        _react2.default.createElement(
          'div',
          { className: _style2.default.SkillRecommendationExpandPanel_header // eslint-disable-line
            , onClick: this._changeExpandState },
          _react2.default.createElement(
            'label',
            { className: _style2.default.SkillRecommendationExpandPanel_category },
            categoryName
          ),
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'chevron-small-down', className: iconClassName })
        ),
        isExpand && recommendationItems.map(function (recommendationItem) {
          return _this2._renderRecommendationItem(recommendationItem);
        })
      );
    }
  }]);

  return SkillRecommendationExpandPanel;
}(_react.PureComponent);

exports.default = SkillRecommendationExpandPanel;

SkillRecommendationExpandPanel.propTypes = {
  isSSV3Group: _propTypes2.default.bool,
  categoryName: _propTypes2.default.string,
  recommendationItems: _propTypes2.default.shape(),
  checkRecommendationItem: _propTypes2.default.func,
  selectedRecommendationItemIds: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape()])
};

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2005);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._8dQ-jfbsQZVD1Jw-IpnGm{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f3f5f7;border-bottom:.07143rem solid #ccc;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:2.85714rem;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding-left:1.42857rem;padding-right:1.42857rem}._3EDF7SCAWig6fQj2KS0j1N{-webkit-transform:rotate(-90deg);-moz-transform:rotate(-90deg);-ms-transform:rotate(-90deg);-o-transform:rotate(-90deg);transform:rotate(-90deg)}._3EDF7SCAWig6fQj2KS0j1N,._3EDF7SCAWig6fQj2KS0j1N._3LrslU_2I0uFoAcBe1egWO{-webkit-transition-duration:.5s;-moz-transition-duration:.5s;-o-transition-duration:.5s;transition-duration:.5s}._3EDF7SCAWig6fQj2KS0j1N._3LrslU_2I0uFoAcBe1egWO{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}._2IRkisnic1ddhvQHZUfuZb{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:600;letter-spacing:.03571rem;line-height:1.28571}.iUxGw9tzxYbgfYtrx9W5G{border-bottom:.07143rem solid #ccc;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:.71429rem 1.07143rem}.iUxGw9tzxYbgfYtrx9W5G span[disabled]{opacity:.4}.tSdmoyynGuNSFte_6PpzM:last-of-type .iUxGw9tzxYbgfYtrx9W5G:last-of-type{border-bottom:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SkillRecommendationExpandPanel_header": "_8dQ-jfbsQZVD1Jw-IpnGm",
	"SkillRecommendationExpandPanel_header_arrow": "_3EDF7SCAWig6fQj2KS0j1N",
	"__expanded": "_3LrslU_2I0uFoAcBe1egWO",
	"SkillRecommendationExpandPanel_category": "_2IRkisnic1ddhvQHZUfuZb",
	"SkillRecommendationExpandPanel_item": "iUxGw9tzxYbgfYtrx9W5G",
	"SkillRecommendationExpandPanel_wrapper": "tSdmoyynGuNSFte_6PpzM"
};

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(829);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TipsAndUpdatesIcon = function TipsAndUpdatesIcon(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 -960 960 960',
      className: (0, _classnames2.default)(_style2.default.FeedbackSuggestions_tipsIcon, className),
      'aria-hidden': 'true',
      onClick: onClick
    },
    _react2.default.createElement('path', { d: 'm880-560-25-55-55-25 55-25 25-55 25 55 55 25-55 25-25 55ZM760-720l-38-82-82-38 82-38 38-82 38 82 82 38-82 38-38 82ZM303.5-103.5Q280-127 280-160h160q0 33-23.5 56.5T360-80q-33 0-56.5-23.5ZM200-200v-80h320v80H200Zm10-120q-69-41-109.5-110T60-580q0-125 87.5-212.5T360-880q125 0 212.5 87.5T660-580q0 81-40.5 150T510-320H210Zm24-80h252q45-32 69.5-79T580-580q0-92-64-156t-156-64q-92 0-156 64t-64 156q0 54 24.5 101t69.5 79Zm126 0Z' })
  );
};

TipsAndUpdatesIcon.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};

exports.default = TipsAndUpdatesIcon;

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _style = __webpack_require__(2008);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackTipsDialog = function FeedbackTipsDialog(_ref) {
  var isOpen = _ref.isOpen,
      onOKClick = _ref.onOKClick,
      children = _ref.children;
  return _react2.default.createElement(
    _omniCommonUi.Dialog,
    {
      isOpen: isOpen,
      className: _style2.default.FeedbackTipsDialog_card,
      onRequestClose: function onRequestClose() {
        return onOKClick();
      }
    },
    _react2.default.createElement(
      'div',
      { className: _style2.default.FeedbackTipsDialog },
      _react2.default.createElement(
        'div',
        { className: _style2.default.FeedbackTipsDialog_body },
        children
      ),
      _react2.default.createElement(
        _omniCommonUi.Button.Container,
        {
          align: 'center',
          className: _style2.default.FeedbackTipsDialog_buttonWrapper
        },
        _react2.default.createElement(
          _omniCommonUi.Button,
          {
            type: _omniCommonUi.Button.Type.primary,
            className: _style2.default.FeedbackTipsDialog_button,
            onClick: function onClick() {
              return onOKClick();
            }
          },
          'Got It'
        )
      )
    )
  );
};

FeedbackTipsDialog.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  onOKClick: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node
};

exports.default = FeedbackTipsDialog;

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2009);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2JomSItqGXFDnZbmG5vj7L{-webkit-border-radius:.85714rem;-moz-border-radius:.85714rem;border-radius:.85714rem;overflow:hidden}._2rw1gLIT3mi0ZP9AvTg-Ag{margin:0 auto}._2rw1gLIT3mi0ZP9AvTg-Ag,._37zCE1zZ7DS-cy8vXtlRVq{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;max-width:38.57143rem;width:38.57143rem}._37zCE1zZ7DS-cy8vXtlRVq{padding:0 1.14286rem}._37zCE1zZ7DS-cy8vXtlRVq h3{margin:1.14286rem 0;max-width:100%;width:100%}._2lx1UNJ41O-O3O5Jrh_Hx0{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;margin-top:1.42857rem;max-width:38.57143rem;padding:0 1.14286rem;width:38.57143rem}._2rpUm0cKJIJq3B6k_zoLUk{-webkit-border-radius:1.42857rem;-moz-border-radius:1.42857rem;border-radius:1.42857rem;-webkit-box-flex:0;-webkit-flex-grow:0;-moz-box-flex:0;-ms-flex-positive:0;flex-grow:0;height:2.85714rem;margin-bottom:1.42857rem;max-width:none;min-width:0;padding:0;width:100%}", ""]);

// exports
exports.locals = {
	"FeedbackTipsDialog_card": "_2JomSItqGXFDnZbmG5vj7L",
	"FeedbackTipsDialog": "_2rw1gLIT3mi0ZP9AvTg-Ag",
	"FeedbackTipsDialog_body": "_37zCE1zZ7DS-cy8vXtlRVq",
	"FeedbackTipsDialog_buttonWrapper": "_2lx1UNJ41O-O3O5Jrh_Hx0",
	"FeedbackTipsDialog_button": "_2rpUm0cKJIJq3B6k_zoLUk"
};

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2011);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".ITtCUQNY5WZhYPxI2IObp{padding:2.14286rem 2.14286rem 1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"BottomButtons": "ITtCUQNY5WZhYPxI2IObp"
};

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2013);

var _style2 = _interopRequireDefault(_style);

var _style3 = __webpack_require__(2015);

var _style4 = _interopRequireDefault(_style3);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _rcTooltip = __webpack_require__(151);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _redux = __webpack_require__(10);

var _GroupMembers = __webpack_require__(14);

var _immutable = __webpack_require__(3);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _skillScoreHFv = __webpack_require__(111);

var skillScoreHFv4 = _interopRequireWildcard(_skillScoreHFv);

var _ProgressTestsPlan = __webpack_require__(64);

var _ProgressTests = __webpack_require__(40);

var _hfv4ScoreBands = __webpack_require__(110);

var _unitRange = __webpack_require__(831);

var _assessmentScores = __webpack_require__(335);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getScoreBandForScore = function getScoreBandForScore(score) {
  return _hfv4ScoreBands.HFV4_SCORE_BANDS.find(function (band) {
    return score >= band.scorePercentageFrom && score <= band.scorePercentageTo;
  });
};

var SCORE_TOOLTIP_WIDTH = 380;

var ScoreTooltip = function (_PureComponent) {
  _inherits(ScoreTooltip, _PureComponent);

  function ScoreTooltip(props) {
    _classCallCheck(this, ScoreTooltip);

    var _this = _possibleConstructorReturn(this, (ScoreTooltip.__proto__ || Object.getPrototypeOf(ScoreTooltip)).call(this, props));

    _this.state = { placement: 'bottom' };
    _this._onMouseEnter = _this._onMouseEnter.bind(_this);
    _this._onPopupAlign = _this._onPopupAlign.bind(_this);
    return _this;
  }

  _createClass(ScoreTooltip, [{
    key: '_onMouseEnter',
    value: function _onMouseEnter() {
      if (!this._el) return;
      var rect = this._el.getBoundingClientRect();
      var centerX = rect.left + rect.width / 2;
      var halfWidth = SCORE_TOOLTIP_WIDTH / 2;

      var placement = 'bottom';
      if (centerX - halfWidth < 0) {
        placement = 'bottomLeft';
      } else if (centerX + halfWidth > window.innerWidth) {
        placement = 'bottomRight';
      }

      if (placement !== this.state.placement) {
        this.setState({ placement: placement });
      }
    }
  }, {
    key: '_onPopupAlign',
    value: function _onPopupAlign(popupDomNode) {
      var arrowEl = popupDomNode.querySelector('.rc-tooltip-arrow');
      if (!arrowEl || !this._triggerEl) return;
      var popupRect = popupDomNode.getBoundingClientRect();
      var triggerRect = this._triggerEl.getBoundingClientRect();
      var triggerCenterX = triggerRect.left + triggerRect.width / 2;
      var arrowLeft = triggerCenterX - popupRect.left;

      var minArrow = popupRect.width * 0.15;
      var maxArrow = popupRect.width * 0.85;
      if (arrowLeft > maxArrow) {
        var shift = arrowLeft - maxArrow;
        popupDomNode.style.left = (parseFloat(popupDomNode.style.left) || 0) + shift + 'px';
        arrowLeft = maxArrow;
      } else if (arrowLeft < minArrow) {
        var _shift = minArrow - arrowLeft;
        popupDomNode.style.left = (parseFloat(popupDomNode.style.left) || 0) - _shift + 'px';
        arrowLeft = minArrow;
      }
      arrowEl.style.left = arrowLeft + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var overlayClassName = this.props.overlayClassName ? _style4.default.scoreTooltipBase + ' ' + this.props.overlayClassName : _style4.default.scoreTooltipBase;
      return _react2.default.createElement(
        'div',
        { ref: function ref(el) {
            _this2._el = el;
          }, onMouseEnter: this._onMouseEnter },
        _react2.default.createElement(
          _rcTooltip2.default,
          {
            placement: this.state.placement,
            trigger: ['hover'],
            destroyPopupOnHide: true,
            onPopupAlign: this._onPopupAlign,
            overlay: _react2.default.createElement(
              'div',
              null,
              this.props.overlay
            ),
            overlayClassName: overlayClassName
          },
          _react2.default.createElement(
            'div',
            { ref: function ref(el) {
                _this2._triggerEl = el;
              } },
            this.props.children
          )
        )
      );
    }
  }]);

  return ScoreTooltip;
}(_react.PureComponent);

function formatScoreForTooltip(score) {
  return _is_js2.default.number(score) ? score + '%' : '-';
}

function buildStudentScoreTooltipOverlay(_ref) {
  var unitRange = _ref.unitRange,
      scorePercentage = _ref.scorePercentage,
      assessmentScore = _ref.assessmentScore,
      isReport2 = _ref.isReport2,
      hasScore = _ref.hasScore,
      hasAssessment = _ref.hasAssessment;

  if (isReport2 && (hasScore || hasAssessment)) {
    return _react2.default.createElement(
      'span',
      null,
      'Average Score of Unit ',
      unitRange,
      ': ',
      _react2.default.createElement(
        'b',
        null,
        hasScore ? formatScoreForTooltip(scorePercentage) : '-'
      ),
      ' | Assessment Score: ',
      _react2.default.createElement(
        'b',
        null,
        hasAssessment ? formatScoreForTooltip(assessmentScore) : '-'
      )
    );
  }
  if (hasScore) {
    return _react2.default.createElement(
      'span',
      null,
      'Average Score of Unit ',
      unitRange,
      ': ',
      _react2.default.createElement(
        'b',
        null,
        formatScoreForTooltip(scorePercentage)
      )
    );
  }
  return null;
}

var StudentSelect = function (_PureComponent2) {
  _inherits(StudentSelect, _PureComponent2);

  function StudentSelect() {
    _classCallCheck(this, StudentSelect);

    var _this3 = _possibleConstructorReturn(this, (StudentSelect.__proto__ || Object.getPrototypeOf(StudentSelect)).call(this));

    _this3._getLinkHrefForValue = function (studentId) {
      return _this3.props.buildRoute({ studentId: studentId, mode: '' });
    };
    return _this3;
  }

  _createClass(StudentSelect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._buildStudentSelectOptions(this.props);
      this._fetchAssessmentDataIfNeeded(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.membersInCurrentIdp !== nextProps.membersInCurrentIdp || this.props.studentScores !== nextProps.studentScores || this.props.studentAssessmentScores !== nextProps.studentAssessmentScores || this.props.isReport2 !== nextProps.isReport2 || this.props.reportName !== nextProps.reportName || this.props.courseTypeLevelCode !== nextProps.courseTypeLevelCode) {
        this._buildStudentSelectOptions(nextProps);
      }
      this._fetchAssessmentDataIfNeeded(nextProps);
    }
  }, {
    key: '_fetchAssessmentDataIfNeeded',
    value: function _fetchAssessmentDataIfNeeded(props) {
      if (!props.isReport2) return;

      var groupId = props.groupId;

      props.fetchProgressTestPlanIfNeeded(groupId);

      if (props.assessmentPlan && _omniCommonUi.ApiResponseHelper.shouldFetch(props.assessmentProgressTest)) {
        props.fetchProgressTest(groupId, props.assessmentPlan);
      }
    }
  }, {
    key: '_renderScoreContent',
    value: function _renderScoreContent(_ref2) {
      var scorePercentage = _ref2.scorePercentage,
          assessmentScore = _ref2.assessmentScore,
          isReport2 = _ref2.isReport2,
          unitRange = _ref2.unitRange;

      var hasScore = _is_js2.default.number(scorePercentage);
      var hasAssessment = _is_js2.default.number(assessmentScore);
      var showSplit = isReport2 && (hasScore || hasAssessment);

      if (!hasScore && !hasAssessment) {
        return null;
      }

      var band = hasScore ? getScoreBandForScore(scorePercentage) : null;
      var scoreStyle = band ? { color: band.color } : {};
      var scoreDisplay = null;

      if (showSplit) {
        var assessmentBand = hasAssessment ? getScoreBandForScore(assessmentScore) : null;
        var assessmentStyle = assessmentBand ? { color: assessmentBand.color } : {};
        scoreDisplay = _react2.default.createElement(
          'div',
          { className: _style4.default.StudentSelect_score },
          _react2.default.createElement(
            'span',
            { style: scoreStyle },
            hasScore ? scorePercentage + '%' : '-'
          ),
          _react2.default.createElement(
            'span',
            { className: _style4.default.StudentSelect_scoreDivider },
            '|'
          ),
          _react2.default.createElement(
            'span',
            { style: assessmentStyle },
            hasAssessment ? assessmentScore + '%' : '-'
          )
        );
      } else if (hasScore) {
        scoreDisplay = _react2.default.createElement(
          'div',
          { className: _style4.default.StudentSelect_score,
            style: scoreStyle },
          scorePercentage,
          '%'
        );
      }

      var tooltipOverlay = buildStudentScoreTooltipOverlay({
        unitRange: unitRange,
        scorePercentage: scorePercentage,
        assessmentScore: assessmentScore,
        isReport2: isReport2,
        hasScore: hasScore,
        hasAssessment: hasAssessment
      });

      if (!tooltipOverlay) {
        return scoreDisplay;
      }

      return _react2.default.createElement(
        ScoreTooltip,
        { overlay: tooltipOverlay,
          overlayClassName: showSplit ? _style4.default.StudentSelect_scoreTooltip : undefined },
        scoreDisplay
      );
    }
  }, {
    key: '_buildStudentSelectOptions',
    value: function _buildStudentSelectOptions(props) {
      var _this4 = this;

      var membersInCurrentIdp = props.membersInCurrentIdp,
          studentScores = props.studentScores,
          studentAssessmentScores = props.studentAssessmentScores,
          isReport2 = props.isReport2,
          reportName = props.reportName,
          courseTypeLevelCode = props.courseTypeLevelCode;

      var unitRange = (0, _unitRange.getUnitRange)(courseTypeLevelCode, reportName);

      if (membersInCurrentIdp.size > 0) {
        this._studentSelectOptions = membersInCurrentIdp.map(function (option) {
          var studentGeneralInfo = option.studentGeneralInfo;

          var scorePercentage = studentScores && studentScores.get('' + studentGeneralInfo.id);
          var assessmentScore = isReport2 && studentAssessmentScores && studentAssessmentScores.get('' + studentGeneralInfo.id);
          var scoreContent = _this4._renderScoreContent({
            scorePercentage: scorePercentage,
            assessmentScore: assessmentScore,
            isReport2: isReport2,
            unitRange: unitRange
          });

          var optionHtml = _react2.default.createElement(
            _omniCommonUi.StudentCard,
            { className: _style4.default.StudentCard_hfv4,
              vertical: true,
              borderless: true,
              backgroundless: true },
            _react2.default.createElement(_omniCommonUi.StudentCard.Profile, { name: studentGeneralInfo.firstName,
              surname: studentGeneralInfo.lastName,
              localName: studentGeneralInfo.localName,
              avatarUrl: studentGeneralInfo.avatarUrl,
              gender: studentGeneralInfo.gender }),
            scoreContent
          );
          return {
            html: optionHtml,
            value: studentGeneralInfo.id,
            className: _style4.default.StudentSelect_option
          };
        }).toArray();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          membersInCurrentIdp = _props.membersInCurrentIdp,
          currentMember = _props.currentMember;

      if (currentMember && membersInCurrentIdp.size && membersInCurrentIdp.size > 0) {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.IndividualDevelopmentPlan_studentHorizontalSelect },
          _react2.default.createElement(_omniCommonUi.HorizontalSelect, { options: this._studentSelectOptions,
            value: currentMember && currentMember.studentGeneralInfo.id,
            isHide: false,
            getLinkHrefForValue: this._getLinkHrefForValue })
        );
      }
      return null;
    }
  }]);

  return StudentSelect;
}(_react.PureComponent);

function getStudentScores(idpList, idpDetailMap, shouldMergeSpeaking) {
  var studentScores = new _immutable.Map();
  if (!idpList || idpList.size <= 0) return studentScores;

  idpList.forEach(function (idp) {
    var idpDetail = idpDetailMap && idpDetailMap.get('' + idp.id);
    var learningResult = idpDetail && idpDetail.get('learningResult');
    var originSkillResults = learningResult ? learningResult.skillResults : idp.skillResults;
    var skillResults = shouldMergeSpeaking ? skillScoreHFv4.mergeSpeakingSkillResults(originSkillResults) : originSkillResults;

    var scorePercentage = skillScoreHFv4.calculateQuizAverageScore(skillResults);
    if (_is_js2.default.number(scorePercentage)) {
      studentScores = studentScores.set('' + idp.studentId, scorePercentage);
    }
  });
  return studentScores;
}

function mapStateToProps(state, ownProps) {
  var _ownProps$params = ownProps.params,
      groupId = _ownProps$params.groupId,
      groupIdpId = _ownProps$params.groupIdpId,
      studentId = _ownProps$params.studentId;

  var groupIdpList = _IndividualDevelopmentPlans.accessors.getGroupIdpList(state, groupId);
  var idpList = _IndividualDevelopmentPlans.accessors.getIdpList(groupIdpList, groupIdpId);

  var idpStudentIds = new _immutable.List();
  if (idpList && idpList.size > 0) {
    idpStudentIds = idpList.map(function (idp) {
      return idp.studentId;
    });
  }
  var membersInCurrentIdp = _GroupMembers.actions.getMembersByGroup(state, groupId).filter(function (_ref3) {
    var id = _ref3.studentGeneralInfo.id;
    return idpStudentIds.indexOf('' + id) !== -1;
  });
  var currentMember = _GroupMembers.actions.getMemberById(state, studentId);
  var idpDetailMap = state.get('rootReducer').get('individualDevelopmentPlan');

  var reportName = _IndividualDevelopmentPlans.accessors.getReportName(state, groupIdpId);
  var group = state.get('rootReducer').get('groups').get(groupId);
  var courseTypeLevelCode = group && group.get('courseTypeLevelCode');
  var isReport2 = !!(reportName && /2/.test(reportName));

  var studentAssessmentScores = new _immutable.Map();
  var assessmentPlan = null;
  var assessmentProgressTest = null;

  if (isReport2) {
    assessmentPlan = (0, _assessmentScores.getAssessmentPlanFromState)(state, groupId);
    assessmentProgressTest = (0, _assessmentScores.getAssessmentProgressTestFromState)(state, assessmentPlan);

    if (_omniCommonUi.ApiResponseHelper.hasSucceeded(assessmentProgressTest)) {
      studentAssessmentScores = (0, _assessmentScores.getStudentAssessmentScores)(idpList, assessmentProgressTest.data);
    }
  }

  return {
    membersInCurrentIdp: membersInCurrentIdp,
    currentMember: currentMember,
    studentScores: getStudentScores(idpList, idpDetailMap, _IndividualDevelopmentPlans.accessors.isHfv4ProgressReportOneOrTwo(state, groupId, groupIdpId)),
    studentAssessmentScores: studentAssessmentScores,
    isReport2: isReport2,
    reportName: reportName,
    courseTypeLevelCode: courseTypeLevelCode,
    groupId: groupId,
    assessmentPlan: assessmentPlan,
    assessmentProgressTest: assessmentProgressTest
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, (0, _redux.bindActionCreators)(_ProgressTestsPlan.actions, dispatch), (0, _redux.bindActionCreators)(_ProgressTests.actions, dispatch));
}

StudentSelect.propTypes = {
  currentMember: _propTypes2.default.object,
  membersInCurrentIdp: _propTypes2.default.object.isRequired,
  studentScores: _propTypes2.default.object.isRequired,
  studentAssessmentScores: _propTypes2.default.object,
  isReport2: _propTypes2.default.bool,
  reportName: _propTypes2.default.string,
  courseTypeLevelCode: _propTypes2.default.string,
  groupId: _propTypes2.default.string,
  assessmentPlan: _propTypes2.default.object,
  assessmentProgressTest: _propTypes2.default.object,
  fetchProgressTestPlanIfNeeded: _propTypes2.default.func.isRequired,
  fetchProgressTest: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func.isRequired
};

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(StudentSelect);

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2014);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".H_sr8O0rhnwBly2JdPh7M{background:#f3f5f7;border-bottom:.07143rem solid #ccc;padding:0}._1f1Wvtk4f80KOEqAM1lHHJ{height:100%;width:9.28571rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"IndividualDevelopmentPlan_studentHorizontalSelect": "H_sr8O0rhnwBly2JdPh7M",
	"IndividualDevelopmentPlan_studentHorizontalSelect_option": "_1f1Wvtk4f80KOEqAM1lHHJ"
};

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2016);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3_XJlEE5HSrlg_HI9DSRq7{height:10.57143rem!important}._2SWLntVM6lx_WwG4najYFW{color:var(--colorText);font-size:1rem;font-weight:700;margin-top:.14286rem;text-align:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;gap:.42857rem}._3Y3emZIlBKfwc63kFbIu2c{color:#ccc;font-weight:400}._3ojnhPbZYkR81Nwx-U2KVw{max-width:none}._3ojnhPbZYkR81Nwx-U2KVw .rc-tooltip-inner{white-space:nowrap}._2z2bnDUwEjANK6Ojt4O8tQ{max-width:none;opacity:1}._2z2bnDUwEjANK6Ojt4O8tQ .rc-tooltip-inner{background-color:#4a4a4a;-webkit-border-radius:.21429rem;-moz-border-radius:.21429rem;border-radius:.21429rem;-webkit-box-shadow:0 .35714rem .71429rem .21429rem rgba(0,0,0,.2);-moz-box-shadow:0 .35714rem .71429rem .21429rem rgba(0,0,0,.2);box-shadow:0 .35714rem .71429rem .21429rem rgba(0,0,0,.2);color:#fff;cursor:default;line-height:1.5;padding:.71429rem;white-space:nowrap}._2z2bnDUwEjANK6Ojt4O8tQ.rc-tooltip-placement-bottom .rc-tooltip-arrow,._2z2bnDUwEjANK6Ojt4O8tQ.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,._2z2bnDUwEjANK6Ojt4O8tQ.rc-tooltip-placement-bottomRight .rc-tooltip-arrow{border-bottom-color:#4a4a4a}.Fso1pVdQr8pgboVBfboRW [data-prop=localName]{font-size:.85em}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentSelect_option": "_3_XJlEE5HSrlg_HI9DSRq7",
	"StudentSelect_score": "_2SWLntVM6lx_WwG4najYFW",
	"StudentSelect_scoreDivider": "_3Y3emZIlBKfwc63kFbIu2c",
	"StudentSelect_scoreTooltip": "_3ojnhPbZYkR81Nwx-U2KVw",
	"scoreTooltipBase": "_2z2bnDUwEjANK6Ojt4O8tQ",
	"StudentCard_hfv4": "Fso1pVdQr8pgboVBfboRW"
};

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2018);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _skillScoreHFv = __webpack_require__(111);

var _ReadOnlyField = __webpack_require__(336);

var _ReadOnlyField2 = _interopRequireDefault(_ReadOnlyField);

var _unitRange = __webpack_require__(831);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BOOKWORK = 'Bookwork';
var ONLINE = 'Online';
var ATTENDANCE = 'Attendance';
var TOTAL_SCORE = 'Total Score';
var COLUMNS_PER_ROW = 4;
var SKILL_DISPLAY_ORDER = ['Vocabulary', 'Grammar', 'Phonics', 'Reading', 'Listening', 'Writing', 'Speaking', _skillScoreHFv.MERGED_SPEAKING_NAME, 'Speaking 1', 'Speaking 2'];

var ReportCard = function (_Component) {
  _inherits(ReportCard, _Component);

  function ReportCard() {
    _classCallCheck(this, ReportCard);

    return _possibleConstructorReturn(this, (ReportCard.__proto__ || Object.getPrototypeOf(ReportCard)).apply(this, arguments));
  }

  _createClass(ReportCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isExpanded = _props.isExpanded,
          reportCardInfo = _props.reportCardInfo,
          onExpandButtonClick = _props.onExpandButtonClick,
          courseTypeLevelCode = _props.courseTypeLevelCode,
          reportName = _props.reportName;

      var reportCardInfoDisplayItems = [];
      prepareReportCardInfoDisplayItems.call(this);
      var averageScoreHeading = (0, _unitRange.getAverageScoreHeading)(courseTypeLevelCode, reportName);

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _classnames2.default)(_style2.default.ReportCard_container, (0, _omniCommonUi.testClass)('report-card')) },
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          { className: _style2.default.ReportCard_heading },
          _react2.default.createElement(
            'span',
            null,
            'Report card'
          ),
          _react2.default.createElement(
            'span',
            null,
            averageScoreHeading
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.ReportCard_content },
          _react2.default.createElement(
            _omniCommonUi.Grid,
            { className: _style2.default.ReportCard_grid },
            renderTotalScoreRow(),
            _react2.default.createElement(
              _omniCommonUi.Grid.Group,
              null,
              renderGridItems()
            )
          )
        ),
        renderExpansionButton()
      );

      function renderTotalScoreRow() {
        return _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          { className: _style2.default.ReportCard_totalScoreRow },
          _react2.default.createElement(
            _omniCommonUi.Grid.Item,
            { xs: 12,
              sm: 3,
              md: 3,
              className: _style2.default.ReportCard_item },
            _react2.default.createElement(_ReadOnlyField2.default, { boardTitle: TOTAL_SCORE,
              boardValue: reportCardInfo.totalScore,
              hideDivider: true })
          )
        );
      }

      function renderGridItems() {
        return reportCardInfoDisplayItems.map(function (source) {
          var size = { xs: 12, sm: 3, md: 3 };
          return _react2.default.createElement(
            _omniCommonUi.Grid.Item,
            { key: source.title,
              xs: size.xs,
              sm: size.sm,
              md: size.md,
              className: _style2.default.ReportCard_item },
            _react2.default.createElement(_ReadOnlyField2.default, { boardTitle: source.title,
              boardValue: source.value,
              className: source.className,
              hideDivider: true })
          );
        });
      }

      function prepareReportCardInfoDisplayItems() {
        reportCardInfo.skillResults.forEach(function (_ref) {
          var name = _ref.name,
              score = _ref.score;

          reportCardInfoDisplayItems.push({
            title: name,
            value: score
          });
        });

        if (reportCardInfo.homeworkCompletion) {
          reportCardInfoDisplayItems.push({
            title: BOOKWORK,
            value: reportCardInfo.homeworkCompletion
          });
        }
        if (this.props.shouldShowOnline) {
          reportCardInfoDisplayItems.push({
            title: ONLINE,
            value: reportCardInfo.online
          });
        }
        this.props.shouldShowAttendance && reportCardInfoDisplayItems.push({
          title: ATTENDANCE,
          value: reportCardInfo.attendance
        });

        reportCardInfoDisplayItems = sortByDisplayOrder(reportCardInfoDisplayItems);
        reportCardInfoDisplayItems = hideReportCardItemsIfNeeded(reportCardInfoDisplayItems);
      }

      function sortByDisplayOrder(items) {
        if (!items || !items.length) return items;

        var getSortIndex = function getSortIndex(title) {
          var index = SKILL_DISPLAY_ORDER.indexOf(title);
          return index === -1 ? SKILL_DISPLAY_ORDER.length : index;
        };

        return [].concat(_toConsumableArray(items)).sort(function (a, b) {
          return getSortIndex(a.title) - getSortIndex(b.title);
        });
      }

      function hideReportCardItemsIfNeeded(items) {
        if (isExpanded || !items || !items.length > 0) return items;
        return items.slice(0, COLUMNS_PER_ROW);
      }

      function renderExpansionButton() {
        return _react2.default.createElement(_ExpansionButton2.default, { isExpand: isExpanded,
          onExpansionButtonClick: function onExpansionButtonClick() {
            return onExpandButtonClick();
          } });
      }
    }
  }]);

  return ReportCard;
}(_react.Component);

ReportCard.propTypes = {
  reportCardInfo: _propTypes2.default.object.isRequired,
  isExpanded: _propTypes2.default.bool.isRequired,
  onExpandButtonClick: _propTypes2.default.func.isRequired,
  shouldShowAttendance: _propTypes2.default.bool.isRequired,
  shouldShowOnline: _propTypes2.default.bool,
  courseTypeLevelCode: _propTypes2.default.string,
  reportName: _propTypes2.default.string
};

ReportCard.defaultProps = {
  shouldShowOnline: false
};

exports.default = ReportCard;

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2019);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3jZCzfWZOdk73ZT3SZ_5l6{margin:0}._2a3K0z4qkBjHI9rljlO_m{margin:0;padding-top:.5em}._2zIDb9S1yFnTyzHqivvih3{margin-bottom:0}.K7ANuZw3AZP8byVi53AWe{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3sCsjlHZXq7C5B6Au_FRLh{padding-bottom:0;padding-top:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ReportCard_container": "Myv4QAMqt3BM2aQSCho9j",
	"ReportCard_grid": "_3jZCzfWZOdk73ZT3SZ_5l6",
	"ReportCard_item": "_2a3K0z4qkBjHI9rljlO_m",
	"ReportCard_totalScoreRow": "_2zIDb9S1yFnTyzHqivvih3",
	"ReportCard_heading": "K7ANuZw3AZP8byVi53AWe",
	"ReportCard_content": "_3sCsjlHZXq7C5B6Au_FRLh"
};

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2021);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _ReadOnlyField = __webpack_require__(336);

var _ReadOnlyField2 = _interopRequireDefault(_ReadOnlyField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOTAL_SCORE = 'Total Score';
var COLUMNS_PER_ROW = 4;

var AssessmentResultsCard = function (_Component) {
  _inherits(AssessmentResultsCard, _Component);

  function AssessmentResultsCard() {
    _classCallCheck(this, AssessmentResultsCard);

    return _possibleConstructorReturn(this, (AssessmentResultsCard.__proto__ || Object.getPrototypeOf(AssessmentResultsCard)).apply(this, arguments));
  }

  _createClass(AssessmentResultsCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isExpanded = _props.isExpanded,
          assessmentResultsInfo = _props.assessmentResultsInfo,
          onExpandButtonClick = _props.onExpandButtonClick;


      var displayItems = assessmentResultsInfo.skillResults.map(function (_ref) {
        var name = _ref.name,
            score = _ref.score;
        return {
          title: name,
          value: score
        };
      });

      if (!isExpanded && displayItems.length > COLUMNS_PER_ROW) {
        displayItems = displayItems.slice(0, COLUMNS_PER_ROW);
      }

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _classnames2.default)(_style2.default.AssessmentResultsCard_container, (0, _omniCommonUi.testClass)('assessment-results-card')) },
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          { className: _style2.default.AssessmentResultsCard_heading },
          _react2.default.createElement(
            'span',
            null,
            'Assessment results'
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.AssessmentResultsCard_content },
          _react2.default.createElement(
            _omniCommonUi.Grid,
            { className: _style2.default.AssessmentResultsCard_grid },
            _react2.default.createElement(
              _omniCommonUi.Grid.Group,
              { className: _style2.default.AssessmentResultsCard_totalScoreRow },
              _react2.default.createElement(
                _omniCommonUi.Grid.Item,
                { xs: 12,
                  sm: 3,
                  md: 3,
                  className: _style2.default.AssessmentResultsCard_item },
                _react2.default.createElement(_ReadOnlyField2.default, { boardTitle: TOTAL_SCORE,
                  boardValue: assessmentResultsInfo.totalScore,
                  hideDivider: true })
              )
            ),
            _react2.default.createElement(
              _omniCommonUi.Grid.Group,
              null,
              displayItems.map(function (source) {
                return _react2.default.createElement(
                  _omniCommonUi.Grid.Item,
                  { key: source.title,
                    xs: 12,
                    sm: 3,
                    md: 3,
                    className: _style2.default.AssessmentResultsCard_item },
                  _react2.default.createElement(_ReadOnlyField2.default, { boardTitle: source.title,
                    boardValue: source.value,
                    hideDivider: true })
                );
              })
            )
          )
        ),
        _react2.default.createElement(_ExpansionButton2.default, { isExpand: isExpanded,
          onExpansionButtonClick: function onExpansionButtonClick() {
            return onExpandButtonClick();
          } })
      );
    }
  }]);

  return AssessmentResultsCard;
}(_react.Component);

AssessmentResultsCard.propTypes = {
  assessmentResultsInfo: _propTypes2.default.shape({
    totalScore: _propTypes2.default.string.isRequired,
    skillResults: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      name: _propTypes2.default.string.isRequired,
      score: _propTypes2.default.string.isRequired
    })).isRequired
  }).isRequired,
  isExpanded: _propTypes2.default.bool.isRequired,
  onExpandButtonClick: _propTypes2.default.func.isRequired
};

exports.default = AssessmentResultsCard;

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2022);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".HTYlODRvaymQ5iZBEw4am{margin:0}._1Z3nc0t8s5DIC3zGhjsKJR{margin:0;padding-top:.5em}._2yAAFCQQGT5CyHUdhA56md{margin-bottom:0}._7EYjBL41F7RisJm9r95Wv{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._2x14Wkwnp4yBdfdZ6AsP4s{padding-bottom:0;padding-top:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"AssessmentResultsCard_container": "_20LKzJHlh_01Lh-5_7PMio",
	"AssessmentResultsCard_grid": "HTYlODRvaymQ5iZBEw4am",
	"AssessmentResultsCard_item": "_1Z3nc0t8s5DIC3zGhjsKJR",
	"AssessmentResultsCard_totalScoreRow": "_2yAAFCQQGT5CyHUdhA56md",
	"AssessmentResultsCard_heading": "_7EYjBL41F7RisJm9r95Wv",
	"AssessmentResultsCard_content": "_2x14Wkwnp4yBdfdZ6AsP4s"
};

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPeriodFromMinStartTime = getPeriodFromMinStartTime;
function getPeriodFromMinStartTime(state, groupId) {
  var group = state.get('rootReducer').get('groups').get(groupId);
  if (!group || !group.data || !group.data.period) return null;

  return group.data.period.start;
}

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = progressTestOverview;

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _actions = __webpack_require__(833);

function progressTestOverview() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_PROGRESS_TEST_OVERVIEW_SUCCESS:
      return state.set(action.groupId, _omniCommonUi.ApiResponseHelper.create({ data: (0, _immutable.fromJS)(action.payload) }));
    default:
      return state;
  }
}

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2026);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(10);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _CardActionIcons = __webpack_require__(85);

var _CardActionIcons2 = _interopRequireDefault(_CardActionIcons);

var _CardActionButtons = __webpack_require__(215);

var _CardActionButtons2 = _interopRequireDefault(_CardActionButtons);

var _TextInput = __webpack_require__(782);

var _TextInput2 = _interopRequireDefault(_TextInput);

var _StudyPlan = __webpack_require__(328);

var _routes = __webpack_require__(170);

var _Month = __webpack_require__(211);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SHOW_STUDY_PLAN = false;

var StudyPlan = function (_PureComponent) {
  _inherits(StudyPlan, _PureComponent);

  function StudyPlan(props) {
    _classCallCheck(this, StudyPlan);

    var _this = _possibleConstructorReturn(this, (StudyPlan.__proto__ || Object.getPrototypeOf(StudyPlan)).call(this, props));

    _this._onEditClick = _this._onEditClick.bind(_this);
    _this.onSaveClick = _this.onSaveClick.bind(_this);
    _this._onDiscardClick = _this._onDiscardClick.bind(_this);
    _this._onRadioClick = _this._onRadioClick.bind(_this);
    _this.shouldDisableSaveButton = _this.shouldDisableSaveButton.bind(_this);
    _this.setWasEditMade = _this.setWasEditMade.bind(_this);
    _this.wasEditMade = _this.wasEditMade.bind(_this);
    _this.state = { wasEditMade: false };
    return _this;
  }

  _createClass(StudyPlan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          fetchStudyPlanCourseIfNeeded = _props.fetchStudyPlanCourseIfNeeded,
          fetchStudyPlanIfNeeded = _props.fetchStudyPlanIfNeeded,
          idpId = _props.idpId;

      fetchStudyPlanCourseIfNeeded(idpId);
      fetchStudyPlanIfNeeded(idpId);
      this.props.onComponentMounted(this);
      this._onStudyPlanResultUpdate(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._onStudyPlanResultUpdate(nextProps);
    }
  }, {
    key: '_getMonth',
    value: function _getMonth(end) {
      return end.date() <= 15 ? end.month() : end.month() + 1;
    }
  }, {
    key: '_getStudyPlanItem',
    value: function _getStudyPlanItem(studyPlan, index, itemName) {
      if (_immutable.List.isList(studyPlan) && _is_js2.default.existy(studyPlan.get(index))) {
        return studyPlan.get(index)[itemName];
      }
    }
  }, {
    key: '_getStudyPlan',
    value: function _getStudyPlan(studyPlan, period, month) {
      var _this2 = this;

      return new _immutable.List([].concat(_toConsumableArray(Array(period).keys())).map(function (index) {
        return {
          sequence: index,
          coreCourseId: _this2._getStudyPlanItem(studyPlan, index, 'coreCourseId'),
          nonCoreCourseId: _this2._getStudyPlanItem(studyPlan, index, 'nonCoreCourseId'),
          otherOptions: _this2._getStudyPlanItem(studyPlan, index, 'otherOptions'),
          month: _this2._getMonth(month) + index
        };
      }));
    }
  }, {
    key: '_onStudyPlanResultUpdate',
    value: function _onStudyPlanResultUpdate(props) {
      if (this.wasEditMade()) return;
      var studyPlan = props.studyPlan && props.studyPlan.get('result');
      var period = _immutable.List.isList(studyPlan) && studyPlan.size > 0 ? studyPlan.size : 6;
      var end = props.studentInfo.period.end;
      this.setState({
        period: period,
        isStudyPlanInited: false,
        studyPlan: this._getStudyPlan(studyPlan, period, end)
      });
    }
  }, {
    key: '_onEditClick',
    value: function _onEditClick() {
      this.props.changeMode(_routes.Modes.EDIT_STUDY_PLAN);
    }
  }, {
    key: 'onSaveClick',
    value: function onSaveClick() {
      var _this3 = this;

      var _props2 = this.props,
          idpId = _props2.idpId,
          groupIdpId = _props2.groupIdpId,
          publishStudyPlan = _props2.publishStudyPlan;

      var studyPlan = this.state.studyPlan.toArray().map(function (plan) {
        return {
          coreCourseId: plan.coreCourseId,
          nonCoreCourseId: plan.nonCoreCourseId,
          otherOptions: _is_js2.default.undefined(plan.otherOptions) ? undefined : plan.otherOptions.trim() || undefined,
          sequence: plan.sequence
        };
      });
      publishStudyPlan(idpId, studyPlan, groupIdpId).then(function () {
        return _this3._onDiscardClick();
      });
    }
  }, {
    key: '_onDiscardClick',
    value: function _onDiscardClick() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.setWasEditMade(false);
      props.changeMode('');
      this._onStudyPlanResultUpdate(props);
    }
  }, {
    key: '_onRadioClick',
    value: function _onRadioClick() {
      var period = this.state.period === 6 ? 12 : 6;
      var end = this.props.studentInfo.period.end;
      this.setState({
        period: period,
        isStudyPlanInited: false,
        studyPlan: this._getStudyPlan(this.state.studyPlan, period, end)
      });
    }
  }, {
    key: '_onContentChange',
    value: function _onContentChange(sequence, val, itemName) {
      var studyPlan = this.state.studyPlan;

      var index = studyPlan.findIndex(function (plan) {
        return plan.sequence === sequence;
      });
      var result = studyPlan.update(index, function (plan) {
        return Object.assign({}, plan, _defineProperty({}, itemName, val || undefined));
      });
      this.setState({
        studyPlan: result
      });
      this.setWasEditMade(true);
    }
  }, {
    key: '_isEditing',
    value: function _isEditing() {
      return this.props.isInEditMode;
    }
  }, {
    key: '_renderButtons',
    value: function _renderButtons() {
      if (!this._isEditing()) {
        return null;
      }
      return _react2.default.createElement(_CardActionButtons2.default, { className: _style2.default.StudyPlan_buttons,
        isPrimaryDisabled: this.shouldDisableSaveButton(),
        onPrimaryClick: this.onSaveClick,
        onSecondaryClick: this._onDiscardClick });
    }
  }, {
    key: 'shouldDisableSaveButton',
    value: function shouldDisableSaveButton() {
      var studyPlan = this.state.studyPlan;

      return !(_immutable.List.isList(studyPlan) && studyPlan.filter(function (plan) {
        return _is_js2.default.existy(plan.coreCourseId);
      }).size > 0);
    }
  }, {
    key: 'setWasEditMade',
    value: function setWasEditMade(wasEditMade) {
      if (_is_js2.default.not.boolean(wasEditMade)) return;
      this.setState({ wasEditMade: wasEditMade });
    }
  }, {
    key: 'wasEditMade',
    value: function wasEditMade() {
      return this.props.isInEditMode && this.state.wasEditMade;
    }
  }, {
    key: '_renderContent',
    value: function _renderContent() {
      return _react2.default.createElement(
        'div',
        null,
        this._renderTable()
      );
    }
  }, {
    key: '_renderRadio',
    value: function _renderRadio() {
      if (!this._isEditing()) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: _style2.default.StudyPlan_radio },
        _react2.default.createElement(
          'div',
          { className: _style2.default.StudyPlan_radio_item },
          _react2.default.createElement(_omniCommonUi.SolidRadio, { name: 'period',
            id: '6',
            value: '6',
            isChecked: this.state.period === 6,
            onChange: this._onRadioClick }),
          '6 months'
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.StudyPlan_radio_item },
          _react2.default.createElement(_omniCommonUi.SolidRadio, { name: 'period',
            id: '12',
            value: '12',
            isChecked: this.state.period === 12,
            onChange: this._onRadioClick }),
          '12 months'
        )
      );
    }
  }, {
    key: '_renderRow',
    value: function _renderRow(row) {
      return _react2.default.createElement(
        'li',
        { key: row.month },
        _react2.default.createElement(
          'ul',
          { className: _style2.default.StudyPlan_table_row },
          _react2.default.createElement(
            'li',
            null,
            (0, _Month.getMonthName)(row.month)
          ),
          _react2.default.createElement(
            'li',
            null,
            this._renderCourse(row, 'coreCourses')
          ),
          _react2.default.createElement(
            'li',
            null,
            this._renderCourse(row, 'nonCoreCourses')
          ),
          _react2.default.createElement(
            'li',
            null,
            this._renderOtherOptions(row)
          )
        )
      );
    }
  }, {
    key: '_renderCourse',
    value: function _renderCourse(row, itemName) {
      var _this4 = this;

      var idName = itemName === 'coreCourses' ? 'coreCourseId' : 'nonCoreCourseId';
      if (!_immutable.Map.isMap(this.props.studyPlan) || !_immutable.List.isList(this.props.studyPlan.get(itemName))) {
        return null;
      }
      var courses = this.props.studyPlan.get(itemName);
      var courseId = row[idName];
      if (!this._isEditing()) {
        if (_is_js2.default.number(courseId) && courseId > 0) {
          var currentCourse = courses.find(function (course) {
            return course.id === courseId;
          });
          var label = currentCourse && currentCourse.name;
          return _react2.default.createElement(
            'span',
            null,
            label || '-'
          );
        }
        return _react2.default.createElement(
          'span',
          null,
          '-'
        );
      }
      var options = courses.toArray().filter(function (course) {
        return !!course.isActive;
      }).sort(function (c1, c2) {
        return c1.displayOrder - c2.displayOrder;
      }).map(function (course) {
        return {
          label: course.name,
          value: course.id
        };
      });
      options.splice(0, 0, {
        label: ' ',
        value: null,
        className: _style2.default.StudyPlan_select_option
      });
      return _react2.default.createElement(_omniCommonUi.Form.Select, { options: options,
        className: _style2.default.StudyPlan_table_row_select,
        value: courseId,
        name: 'coreCourse',
        setValue: function setValue(val) {
          return _this4._onContentChange(row.sequence, val, idName);
        },
        clearable: false,
        searchable: false });
    }
  }, {
    key: '_renderOtherOptions',
    value: function _renderOtherOptions(row) {
      var _this5 = this;

      if (this._isEditing()) {
        return _react2.default.createElement(_TextInput2.default, { className: _style2.default.StudyPlan_table_row_input,
          value: row.otherOptions,
          maxLength: 100,
          onChange: function onChange(e) {
            return _this5._onContentChange(row.sequence, e.target.value, 'otherOptions');
          } });
      }

      return _react2.default.createElement(
        'span',
        null,
        row.otherOptions || '-'
      );
    }
  }, {
    key: '_renderTable',
    value: function _renderTable() {
      var _this6 = this;

      return _react2.default.createElement(
        'ul',
        { className: _style2.default.StudyPlan_table },
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'ul',
            { className: (0, _classnames2.default)(_style2.default.StudyPlan_table_header, _style2.default.StudyPlan_table_row) },
            _react2.default.createElement('li', null),
            _react2.default.createElement(
              'li',
              null,
              'Core Course'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Non-Core Course (optional)'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Other Options'
            )
          )
        ),
        this.state.studyPlan.map(function (row) {
          return _this6._renderRow(row);
        })
      );
    }
  }, {
    key: '_GenerateByDefault',
    value: function _GenerateByDefault() {
      if (this._isEditing() && !this.wasEditMade() && !this.state.isStudyPlanInited && _is_js2.default.existy(this.props.studyPlan) && _is_js2.default.existy(this.props.studyPlan.get('coreCourses')) && _is_js2.default.existy(this.props.studyPlan.get('result')) && this.props.studyPlan.get('result').size === 0 && this.state.studyPlan.size > 0) {
        var idpPeriod = this.props.studentInfo.period;
        var group = this.props.group;
        var groupPeriod = group.period;
        var courseType = group.groupSummary.courseTypeName;
        var courses = this.props.studyPlan.get('coreCourses');
        var currentCoreCourses = courses.filter(function (course) {
          return course.name.startsWith(courseType);
        }).sortBy(function (course) {
          return course.displayOrder;
        }).delete(0);
        var groupDays = groupPeriod.end.diff(groupPeriod.start, 'days');
        var remainingDays = groupPeriod.end.diff(idpPeriod.end, 'days');
        remainingDays = remainingDays < 0 ? 0 : remainingDays;
        var groupDuration = Math.ceil(groupDays / 30.0);
        var remainingDuration = Math.ceil(remainingDays / 30.0);
        var initedStudyPlan = new _immutable.List();
        this.state.studyPlan.map(function (sp) {
          var coreCourseId = sp.coreCourseId;
          if (remainingDuration > 0 && sp.sequence < remainingDuration) {
            coreCourseId = courses.first().id;
          } else {
            var index = (sp.sequence - remainingDuration) / groupDuration;
            if (index < currentCoreCourses.size) {
              coreCourseId = currentCoreCourses.get(index).id;
            }
          }
          initedStudyPlan = initedStudyPlan.push({
            sequence: sp.sequence,
            coreCourseId: coreCourseId,
            nonCoreCourseId: sp.nonCoreCourseId,
            otherOptions: sp.otherOptions,
            month: sp.month
          });
          return 0;
        });
        this.setState({
          isStudyPlanInited: true,
          studyPlan: initedStudyPlan
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state || !_is_js2.default.existy(this.state.studyPlan)) {
        return null;
      }

      this._GenerateByDefault();

      return SHOW_STUDY_PLAN && _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _omniCommonUi.testClass)('study-plan') },
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          { text: 'Study plan', stackMode: 'horizontal' },
          _react2.default.createElement(_CardActionIcons2.default, { hideEditIcon: !this.props.canEdit,
            onEditClick: this._onEditClick,
            hideDeleteIcon: true })
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.StudyPlan },
          _react2.default.createElement(
            _omniCommonUi.Form,
            null,
            this._renderRadio(),
            this._renderContent(),
            this._renderButtons()
          )
        )
      );
    }
  }]);

  return StudyPlan;
}(_react.PureComponent);

StudyPlan.propTypes = {
  studentInfo: _propTypes2.default.object,
  idpId: _propTypes2.default.string,
  groupIdpId: _propTypes2.default.string,
  fetchStudyPlanIfNeeded: _propTypes2.default.func,
  fetchStudyPlanCourseIfNeeded: _propTypes2.default.func,
  publishStudyPlan: _propTypes2.default.func,
  group: _propTypes2.default.object,
  studyPlan: _propTypes2.default.object,
  changeMode: _propTypes2.default.func.isRequired,
  canEdit: _propTypes2.default.bool,
  isInEditMode: _propTypes2.default.bool,
  onComponentMounted: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.groupId,
      idpId = ownProps.idpId;

  var group = state.get('rootReducer').get('groups').get(groupId).data;
  var studyPlan = state.get('rootReducer').get('studyPlan').get(idpId);
  return {
    group: group,
    studyPlan: studyPlan
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_StudyPlan.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(StudyPlan);

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2027);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".gJg7bwqKTvKs7HoEfy1G2{padding:1.42857rem 0}._3GPdPFtuVHrXveDetzobJb{padding:0 2.14286rem}._1SSODDxBkJXyjuS3Ho1Oh{margin-bottom:.71429rem}._3xBiM1rmI0A9eQXkDiZ6xq{list-style:none;padding-left:0}._2m4rX5d5I7wR_vZoylKH9k{font-weight:700}._2oS8Xm7oRKOLOA_Ggaobnv{border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around;list-style:none;padding:.71429rem 2.14286rem}._2oS8Xm7oRKOLOA_Ggaobnv li{-webkit-flex-basis:40%;-ms-flex-preferred-size:40%;flex-basis:40%}._2oS8Xm7oRKOLOA_Ggaobnv li:first-child{font-weight:700}._2oS8Xm7oRKOLOA_Ggaobnv li:first-child,._2oS8Xm7oRKOLOA_Ggaobnv li:last-child{-webkit-flex-basis:30%;-ms-flex-preferred-size:30%;flex-basis:30%}.ZnX35NDfFxlhHqqgWl57b{width:50%}._2BtZGtVpMrr16gCt7-8sBg{width:65%}.-Yx06fh-Q8Zdwf6fC8YbJ{min-height:2.5rem}._2u7T263FBplqZaGTLUVBzs{padding:0 2.14286rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudyPlan": "gJg7bwqKTvKs7HoEfy1G2",
	"StudyPlan_radio": "_3GPdPFtuVHrXveDetzobJb",
	"StudyPlan_radio_item": "_1SSODDxBkJXyjuS3Ho1Oh",
	"StudyPlan_table": "_3xBiM1rmI0A9eQXkDiZ6xq",
	"StudyPlan_table_header": "_2m4rX5d5I7wR_vZoylKH9k",
	"StudyPlan_table_row": "_2oS8Xm7oRKOLOA_Ggaobnv",
	"StudyPlan_table_row_select": "ZnX35NDfFxlhHqqgWl57b",
	"StudyPlan_table_row_input": "_2BtZGtVpMrr16gCt7-8sBg",
	"StudyPlan_select_option": "-Yx06fh-Q8Zdwf6fC8YbJ",
	"StudyPlan_buttons": "_2u7T263FBplqZaGTLUVBzs"
};

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2029);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(10);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _CardActionIcons = __webpack_require__(85);

var _CardActionIcons2 = _interopRequireDefault(_CardActionIcons);

var _CardActionButtons = __webpack_require__(215);

var _CardActionButtons2 = _interopRequireDefault(_CardActionButtons);

var _ExpansionButton = __webpack_require__(38);

var _ExpansionButton2 = _interopRequireDefault(_ExpansionButton);

var _TableWithExpandablePanel = __webpack_require__(201);

var _TableWithExpandablePanel2 = _interopRequireDefault(_TableWithExpandablePanel);

var _OverallDevelopment = __webpack_require__(329);

var _routes = __webpack_require__(170);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var strengthsInfo = {
  type: 'ST',
  name: 'Strengths',
  maxMarkNumber: 3,
  tooltip: 'This section highlights areas in which your child has consistently performed well.'
};
var improvementsMadeInfo = {
  type: 'IM',
  name: 'Improvement made',
  maxMarkNumber: 3,
  tooltip: 'This section highlights areas in which your child has made noticeable improvement.'
};
var needAttentionInfo = {
  type: 'NA',
  name: 'Need attention',
  maxMarkNumber: 2,
  tooltip: 'This section highlights ares which would benefit from continued attention.'
};
var categoryInfo = {
  ST: strengthsInfo,
  IM: improvementsMadeInfo,
  NA: needAttentionInfo
};

var OverallDevelopment = function (_PureComponent) {
  _inherits(OverallDevelopment, _PureComponent);

  function OverallDevelopment(props) {
    var _isExpandRemainingMem;

    _classCallCheck(this, OverallDevelopment);

    var _this = _possibleConstructorReturn(this, (OverallDevelopment.__proto__ || Object.getPrototypeOf(OverallDevelopment)).call(this, props));

    _this._onEditClick = _this._onEditClick.bind(_this);
    _this.onSaveClick = _this.onSaveClick.bind(_this);
    _this._onDiscardClick = _this._onDiscardClick.bind(_this);
    _this.shouldDisableSaveButton = _this.shouldDisableSaveButton.bind(_this);
    _this.setWasEditMade = _this.setWasEditMade.bind(_this);
    _this.wasEditMade = _this.wasEditMade.bind(_this);
    _this.onItemClick = _this.onItemClick.bind(_this);
    _this.closeMenu = _this.closeMenu.bind(_this);
    _this.state = {
      wasEditMade: false,
      showMenu: undefined,
      isExpandRemainingMember: (_isExpandRemainingMem = {}, _defineProperty(_isExpandRemainingMem, strengthsInfo.type, false), _defineProperty(_isExpandRemainingMem, improvementsMadeInfo.type, false), _defineProperty(_isExpandRemainingMem, needAttentionInfo.type, false), _isExpandRemainingMem)
    };
    return _this;
  }

  _createClass(OverallDevelopment, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          fetchOverallDevelopmentResultIfNeeded = _props.fetchOverallDevelopmentResultIfNeeded,
          fetchOverallDevelopmentTemplateIfNeeded = _props.fetchOverallDevelopmentTemplateIfNeeded,
          idpId = _props.idpId;

      fetchOverallDevelopmentResultIfNeeded(idpId);
      fetchOverallDevelopmentTemplateIfNeeded(idpId);
      this.props.onComponentMounted(this);
      this._onOverallDevelopmentResultUpdate(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._onOverallDevelopmentResultUpdate(nextProps);
    }
  }, {
    key: '_onEditClick',
    value: function _onEditClick() {
      this.props.changeMode(_routes.Modes.EDIT_OVERALL_DEVELOPMENT);
    }
  }, {
    key: '_isEditing',
    value: function _isEditing() {
      return this.props.isInEditMode;
    }
  }, {
    key: 'setWasEditMade',
    value: function setWasEditMade(wasEditMade) {
      if (_is_js2.default.not.boolean(wasEditMade)) return;
      this.setState({ wasEditMade: wasEditMade });
    }
  }, {
    key: 'wasEditMade',
    value: function wasEditMade() {
      return this.props.isInEditMode && this.state.wasEditMade;
    }
  }, {
    key: 'shouldDisableSaveButton',
    value: function shouldDisableSaveButton() {
      var overallDevelopment = this.state.overallDevelopment;

      var template = this.props.overallDevelopment && this.props.overallDevelopment.get('template');
      return !_immutable.List.isList(overallDevelopment) || overallDevelopment.size === 0 || !_is_js2.default.existy(template) || this._isNeededToChoose(strengthsInfo.type, template.strengths) || this._isNeededToChoose(needAttentionInfo.type, template.needAttentions) || this._isNeededToChoose(improvementsMadeInfo.type, template.improvementsModes);
    }
  }, {
    key: '_onOverallDevelopmentResultUpdate',
    value: function _onOverallDevelopmentResultUpdate(props) {
      if (this.wasEditMade()) return;
      var overallDevelopmentResult = props.overallDevelopment && props.overallDevelopment.get('result');
      var items = _is_js2.default.not.existy(overallDevelopmentResult) ? new _immutable.List() : new _immutable.List(overallDevelopmentResult.items.toArray());
      this.setState({
        overallDevelopment: items
      });
    }
  }, {
    key: 'onSaveClick',
    value: function onSaveClick() {
      var _this2 = this;

      var overallDevelopment = this.state.overallDevelopment;
      var _props2 = this.props,
          idpId = _props2.idpId,
          groupIdpId = _props2.groupIdpId,
          saveOverallDevelopment = _props2.saveOverallDevelopment;

      var template = this.props.overallDevelopment.get('template');
      var validResults = overallDevelopment.filter(function (result) {
        return template.strengths.some(function (st) {
          return st.items.some(function (tp) {
            return result.typeCode === strengthsInfo.type && result.unitId === tp.unitId && result.subSkillId === tp.id;
          });
        }) || template.improvementsModes.some(function (st) {
          return st.items.some(function (tp) {
            return result.typeCode === improvementsMadeInfo.type && result.unitId === tp.unitId && result.subSkillId === tp.id;
          });
        }) || template.needAttentions.some(function (st) {
          return st.items.some(function (tp) {
            return result.typeCode === needAttentionInfo.type && result.unitId === tp.unitId && result.subSkillId === tp.id;
          });
        });
      });

      saveOverallDevelopment(idpId, validResults, groupIdpId).then(function () {
        return _this2._onDiscardClick();
      });
    }
  }, {
    key: '_onDiscardClick',
    value: function _onDiscardClick() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.setWasEditMade(false);
      props.changeMode('');
      this._onOverallDevelopmentResultUpdate(props);
    }
  }, {
    key: '_getMenuItemDescription',
    value: function _getMenuItemDescription(ability) {
      if (_is_js2.default.not.existy(ability)) return '';
      if (ability.point === '3') return 'The student can consistently ...';
      if (ability.point === '2') return 'The student can sometimes ...';

      return '';
    }
  }, {
    key: '_getButtonTypeForAbility',
    value: function _getButtonTypeForAbility(originalAbility, currentAbility) {
      var ability = currentAbility === undefined ? originalAbility : currentAbility;
      if (ability.point === '1') return _omniCommonUi.Button.Type.wrong;
      if (ability.point === '3') return _omniCommonUi.Button.Type.correct;
      if (ability.point === '2') return _omniCommonUi.Button.Type.needsAttention;

      return _omniCommonUi.Button.Type.black;
    }
  }, {
    key: '_isItemCurrentlySelected',
    value: function _isItemCurrentlySelected(type, item) {
      var overallDevelopment = this.state.overallDevelopment;

      return overallDevelopment.some(function (development) {
        return type === development.typeCode && development.unitId === item.unitId && development.subSkillId === item.id;
      });
    }
  }, {
    key: 'onItemClick',
    value: function onItemClick(event, skillId, item, type) {
      var _this3 = this;

      event.preventDefault();
      var result = void 0;
      if (_is_js2.default.existy(this.state.showMenu)) result = this.closeMenu();
      var overallDevelopment = this.state.overallDevelopment;

      var index = overallDevelopment.findIndex(function (development) {
        return type === development.typeCode && development.unitId === item.unitId && development.subSkillId === item.id;
      });
      var isShowMenu = index < 0 && type === improvementsMadeInfo.type;
      if (_is_js2.default.not.existy(result)) result = overallDevelopment;
      if (index >= 0) {
        result = result.remove(index);
      } else {
        result = result.push({
          typeCode: type,
          unitId: item.unitId,
          skillId: skillId,
          subSkillId: item.id,
          originalAbilityId: item.abilityId,
          improvedAbilityId: undefined
        });
      }
      this.setState({
        overallDevelopment: result,
        showMenu: isShowMenu ? { unitId: item.unitId, itemId: item.id } : undefined
      }, function () {
        isShowMenu ? document.addEventListener('click', _this3.closeMenu) : undefined;
      });
      this.setWasEditMade(true);
    }
  }, {
    key: 'closeMenu',
    value: function closeMenu() {
      var _this4 = this;

      var _state = this.state,
          overallDevelopment = _state.overallDevelopment,
          showMenu = _state.showMenu;

      var results = overallDevelopment;
      var index = results.findIndex(function (result) {
        return result.typeCode === 'IM' && result.subSkillId === showMenu.itemId && result.unitId === showMenu.unitId;
      });
      var currentResult = results.get(index);
      if (_is_js2.default.existy(currentResult) && _is_js2.default.not.existy(currentResult.ImprovedAbilityId)) {
        results = results.remove(index);
      }

      this.setState({
        showMenu: undefined,
        overallDevelopment: results
      }, function () {
        document.removeEventListener('click', _this4.closeMenu);
      });

      return results;
    }
  }, {
    key: '_onItemMarked',
    value: function _onItemMarked(skillId, item, ability, type) {
      var _this5 = this;

      var overallDevelopment = this.state.overallDevelopment;

      var index = overallDevelopment.findIndex(function (development) {
        return type === development.typeCode && development.unitId === item.unitId && development.subSkillId === item.id;
      });
      var result = overallDevelopment;
      if (index >= 0) {
        result = result.remove(index);
      }

      result = result.push({
        typeCode: type,
        unitId: item.unitId,
        skillId: skillId,
        subSkillId: item.id,
        originalAbilityId: item.abilityId,
        improvedAbilityId: ability.id
      });

      this.setState({
        overallDevelopment: result,
        showMenu: undefined
      }, function () {
        document.removeEventListener('click', _this5.closeMenu);
      });
    }
  }, {
    key: '_isEditItemDisabled',
    value: function _isEditItemDisabled(type, item) {
      var overallDevelopment = this.state.overallDevelopment;

      var maxMarkNumber = categoryInfo[type].maxMarkNumber;
      var selectedResults = type === improvementsMadeInfo.type ? overallDevelopment.filter(function (result) {
        return type === result.typeCode && _is_js2.default.existy(result.improvedAbilityId);
      }) : overallDevelopment.filter(function (result) {
        return type === result.typeCode;
      });
      var isSelectedInCurrentArea = selectedResults.some(function (result) {
        return result.unitId === item.unitId && result.subSkillId === item.id;
      });
      var isSelectedInOtherArea = overallDevelopment.some(function (od) {
        return od.typeCode !== type && od.unitId === item.unitId && od.subSkillId === item.id;
      });

      return isSelectedInOtherArea || !isSelectedInCurrentArea && selectedResults.size >= maxMarkNumber;
    }
  }, {
    key: '_renderCell',
    value: function _renderCell(type, skillTemplate, column, results) {
      var _this6 = this;

      var items = skillTemplate.items.filter(function (item) {
        return item.unitId === column;
      });
      return _react2.default.createElement(
        'div',
        { className: _style2.default.OverallDevelopment_editCard_cell },
        items.size === 0 ? null : items.map(function (item) {
          var originalAbility = skillTemplate.abilities.filter(function (ability) {
            return ability.id === item.abilityId;
          }).first();
          var itemResult = results.filter(function (result) {
            return result.unitId === item.unitId && result.subSkillId === item.id;
          }).first();
          var currentAbility = itemResult && skillTemplate.abilities.filter(function (ability) {
            return itemResult.improvedAbilityId === ability.id;
          }).first();

          return _react2.default.createElement(
            'div',
            { className: _style2.default.OverallDevelopment_editCard_cell_item },
            _react2.default.createElement(
              _omniCommonUi.Button,
              { type: _this6._getButtonTypeForAbility(originalAbility, currentAbility),
                className: _this6._isItemCurrentlySelected(type, item) && _style2.default.__buttonActived,
                block: true,
                disabled: _this6._isEditItemDisabled(type, item),
                onClickActiveClassRemoveDelay: 0,
                active: _this6._isItemCurrentlySelected(type, item),
                onClick: function onClick(event) {
                  return _this6.onItemClick(event, skillTemplate.id, item, type);
                } },
              _react2.default.createElement(
                'span',
                null,
                item.name
              )
            ),
            type === 'IM' && _is_js2.default.existy(_this6.state.showMenu) && _this6.state.showMenu.itemId === item.id && _this6.state.showMenu.unitId === item.unitId && _react2.default.createElement(
              'div',
              { className: _style2.default.OverallDevelopment_editCard_cell_menu },
              skillTemplate.abilities.filter(function (ability) {
                return ability.point > originalAbility.point;
              }).map(function (ability) {
                return _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    _omniCommonUi.Button,
                    { type: _this6._getButtonTypeForAbility(ability),
                      block: true,
                      onClick: function onClick() {
                        return _this6._onItemMarked(skillTemplate.id, item, ability, type);
                      } },
                    _react2.default.createElement(
                      'span',
                      null,
                      _this6._getMenuItemDescription(ability)
                    ),
                    _react2.default.createElement(_omniCommonUi.Icon, { id: _this6._getIconIdByAbility(ability),
                      className: _this6._getIconClassNameByAbility(ability) })
                  )
                );
              })
            )
          );
        })
      );
    }
  }, {
    key: '_renderExpandButton',
    value: function _renderExpandButton(type) {
      var _this7 = this;

      var isExpandRemainingMember = this.state.isExpandRemainingMember;


      return _react2.default.createElement(_ExpansionButton2.default, { isExpand: isExpandRemainingMember[type],
        onExpansionButtonClick: function onExpansionButtonClick() {
          var copy = _extends({}, isExpandRemainingMember);
          copy[type] = !copy[type];
          _this7.setState({ isExpandRemainingMember: copy });
        },
        className: _style2.default.OverallDevelopment_editCard_expand });
    }
  }, {
    key: '_renderTable',
    value: function _renderTable(type, skillTemplates, results, units) {
      var _this8 = this;

      return _react2.default.createElement(
        _TableWithExpandablePanel2.default,
        { rows: skillTemplates,
          onlyRowDivider: false },
        _react2.default.createElement(
          _TableWithExpandablePanel2.default.Panel,
          null,
          _react2.default.createElement(
            _TableWithExpandablePanel2.default.Header,
            null,
            _react2.default.createElement(_TableWithExpandablePanel2.default.Cell, { columnId: 'skill-name' })
          ),
          _react2.default.createElement(
            _TableWithExpandablePanel2.default.Body,
            null,
            function (skillTemplate, columnId) {
              switch (columnId) {
                case 'skill-name':
                  return _react2.default.createElement(
                    'span',
                    null,
                    skillTemplate.name
                  );
                default:
                  throw new Error('Invalid column ' + columnId);
              }
            }
          )
        ),
        _react2.default.createElement(
          _TableWithExpandablePanel2.default.Header,
          null,
          _react2.default.createElement(
            _TableWithExpandablePanel2.default.Row,
            null,
            units.sortBy(function (unit) {
              return unit.name;
            }).reverse().map(function (unit) {
              return _react2.default.createElement(
                _TableWithExpandablePanel2.default.Cell,
                { key: unit.id, columnId: unit.id, small: true },
                _react2.default.createElement(
                  'div',
                  { className: _style2.default.OverallDevelopment_table_header },
                  unit.name
                )
              );
            })
          )
        ),
        _react2.default.createElement(
          _TableWithExpandablePanel2.default.Body,
          null,
          function (skillTemplate, column) {
            return _this8._renderCell(type, skillTemplate, column, results);
          }
        )
      );
    }
  }, {
    key: '_getIconIdByAbility',
    value: function _getIconIdByAbility(ability) {
      if (_is_js2.default.not.existy(ability)) return '';
      if (ability.point === '3') return 'happy';else if (ability.point === '2') return 'smile';

      return 'unhappy';
    }
  }, {
    key: '_getIconClassNameByAbility',
    value: function _getIconClassNameByAbility(ability) {
      if (_is_js2.default.not.existy(ability)) return undefined;
      if (ability.point === '3') return _style2.default.OverallDevelopment_happyIcon;
      if (ability.point === '2') return _style2.default.OverallDevelopment_smileIcon;
      if (ability.point === '1') return _style2.default.OverallDevelopment_unhappyIcon;

      return undefined;
    }
  }, {
    key: '_getIconIdByType',
    value: function _getIconIdByType(type) {
      if (type === strengthsInfo.type) return 'happy';
      if (type === needAttentionInfo.type) return 'unhappy';

      return '';
    }
  }, {
    key: '_getIconClassNameByType',
    value: function _getIconClassNameByType(type) {
      if (type === strengthsInfo.type) return _style2.default.OverallDevelopment_happyIcon;
      if (type === needAttentionInfo.type) return _style2.default.OverallDevelopment_unhappyIcon;

      return undefined;
    }
  }, {
    key: '_renderViewSkillItem',
    value: function _renderViewSkillItem(type, item, result, abilities) {
      var originalAbility = abilities.filter(function (a) {
        return a.id === result.originalAbilityId;
      }).first();
      var improvedAbility = abilities.filter(function (a) {
        return a.id === result.improvedAbilityId;
      }).first();
      return _react2.default.createElement(
        'div',
        { className: _style2.default.OverallDevelopment_viewCard_item },
        _react2.default.createElement(
          _omniCommonUi.Button,
          { type: _omniCommonUi.Button.Type.black,
            block: false,
            disabled: true,
            onClickActiveClassRemoveDelay: 0 },
          _react2.default.createElement(
            'span',
            null,
            item.name
          )
        ),
        type === improvementsMadeInfo.type && _is_js2.default.existy(result) && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_omniCommonUi.Icon, { id: this._getIconIdByAbility(originalAbility),
            className: this._getIconClassNameByAbility(originalAbility) }),
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'chevron-small-right' }),
          _react2.default.createElement(_omniCommonUi.Icon, { id: this._getIconIdByAbility(improvedAbility),
            className: this._getIconClassNameByAbility(improvedAbility) })
        )
      );
    }
  }, {
    key: '_renderViewContent',
    value: function _renderViewContent(type, skillTemplates, results) {
      var _this9 = this;

      var categoryResults = results.filter(function (result) {
        return result.typeCode === type;
      });
      if (!(_immutable.List.isList(skillTemplates) && skillTemplates.size > 0 && categoryResults.size > 0)) return null;

      return _react2.default.createElement(
        'div',
        { className: _style2.default.OverallDevelopment_viewCard },
        _react2.default.createElement(
          'h1',
          null,
          categoryInfo[type].name
        ),
        _react2.default.createElement(_omniCommonUi.Icon, { id: this._getIconIdByType(type), className: this._getIconClassNameByType(type) }),
        skillTemplates.map(function (skillTemplate) {
          var items = skillTemplate.items.filter(function (i) {
            return categoryResults.some(function (r) {
              return r.unitId === i.unitId && r.subSkillId === i.id;
            });
          });
          if (items.size === 0) return null;
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h2',
              null,
              skillTemplate.name
            ),
            _react2.default.createElement(
              'div',
              null,
              items.map(function (item) {
                var result = categoryResults.filter(function (cr) {
                  return cr.unitId === item.unitId && cr.subSkillId === item.id;
                }).first();
                return _this9._renderViewSkillItem(type, item, result, skillTemplate.abilities);
              })
            )
          );
        })
      );
    }
  }, {
    key: '_isNeededToChoose',
    value: function _isNeededToChoose(type, skillTemplates) {
      if (skillTemplates.size === 0) return false;

      var overallDevelopment = this.state.overallDevelopment;

      var categoryResults = overallDevelopment.filter(function (r) {
        return r.typeCode === type;
      });

      var hasCanMarkedItems = skillTemplates.some(function (template) {
        return template.items.filter(function (item) {
          return !overallDevelopment.some(function (od) {
            return od.typeCode !== type && od.unitId === item.unitId && od.subSkillId === item.id;
          });
        }).size > 0;
      });

      if (hasCanMarkedItems) {
        return categoryResults.size === 0 || improvementsMadeInfo.type === type && !categoryResults.some(function (r) {
          return _is_js2.default.existy(r.improvedAbilityId);
        });
      }

      return false;
    }
  }, {
    key: '_renderEditContent',
    value: function _renderEditContent(type, skillTemplates, results, units) {
      var categoryResults = results.filter(function (result) {
        return result.typeCode === type;
      });
      if (!(_immutable.List.isList(skillTemplates) && skillTemplates.size > 0)) return null;
      var defaultDisplayNumber = 1;
      var displayedTemplates = skillTemplates.filter(function (_, index) {
        return index < defaultDisplayNumber;
      });
      if (this.state.isExpandRemainingMember[type]) {
        displayedTemplates = skillTemplates;
      }

      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: _style2.default.OverallDevelopment_editCard },
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          { text: categoryInfo[type].name + ' ' + categoryResults.size + '/' + categoryInfo[type].maxMarkNumber,
            className: _style2.default.OverallDevelopment_editCard_header,
            titleClassName: _style2.default.OverallDevelopment_editCard_title },
          _react2.default.createElement(
            _omniCommonUi.Tooltip,
            { text: categoryInfo[type].tooltip,
              placement: 'right',
              trigger: ['hover'],
              className: _style2.default.OverallDevelopment_editCard_tooltip },
            _react2.default.createElement(_omniCommonUi.Icon, { id: 'question' })
          ),
          this._isNeededToChoose(type, skillTemplates) && _react2.default.createElement(
            'span',
            null,
            'Choose at least one item.'
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.OverallDevelopment_editCard_content },
          this._renderTable(type, displayedTemplates, categoryResults, units)
        ),
        this._renderExpandButton(type)
      );
    }
  }, {
    key: '_renderContent',
    value: function _renderContent() {
      var template = this.props.overallDevelopment && this.props.overallDevelopment.get('template');
      var overallDevelopment = this.state.overallDevelopment;

      if (_is_js2.default.not.existy(template) || _is_js2.default.not.existy(overallDevelopment)) return null;
      var units = template.units;
      if (!this._isEditing()) {
        return _react2.default.createElement(
          'div',
          null,
          this._renderViewContent(strengthsInfo.type, template.strengths, overallDevelopment),
          overallDevelopment.size > 0 && template.strengths.size > 0 && template.improvementsModes.size > 0 && _react2.default.createElement('div', { className: _style2.default.OverallDevelopment_separatorLine }),
          this._renderViewContent(improvementsMadeInfo.type, template.improvementsModes, overallDevelopment),
          overallDevelopment.size > 0 && template.needAttentions.size > 0 && template.improvementsModes.size > 0 && _react2.default.createElement('div', { className: _style2.default.OverallDevelopment_separatorLine }),
          this._renderViewContent(needAttentionInfo.type, template.needAttentions, overallDevelopment)
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        this._renderEditContent(strengthsInfo.type, template.strengths, overallDevelopment, units),
        this._renderEditContent(improvementsMadeInfo.type, template.improvementsModes, overallDevelopment, units),
        this._renderEditContent(needAttentionInfo.type, template.needAttentions, overallDevelopment, units)
      );
    }
  }, {
    key: '_renderButtons',
    value: function _renderButtons() {
      if (!this._isEditing()) {
        return null;
      }
      return _react2.default.createElement(_CardActionButtons2.default, { className: _style2.default.OverallDevelopment_buttons,
        isPrimaryDisabled: this.shouldDisableSaveButton(),
        onPrimaryClick: this.onSaveClick,
        onSecondaryClick: this._onDiscardClick });
    }
  }, {
    key: '_renderEmptyHint',
    value: function _renderEmptyHint() {
      if (this.props.isInEditMode) return null;

      var overallDevelopment = this.state.overallDevelopment;

      var template = this.props.overallDevelopment && this.props.overallDevelopment.get('template');
      if (!_immutable.List.isList(overallDevelopment) || !_is_js2.default.existy(template)) {
        return null;
      }

      var emptyActionsNumber = 0;
      if (this._isNeededToChoose(strengthsInfo.type, template.strengths)) {
        emptyActionsNumber += 1;
      }
      if (this._isNeededToChoose(needAttentionInfo.type, template.needAttentions)) {
        emptyActionsNumber += 1;
      }
      if (this._isNeededToChoose(improvementsMadeInfo.type, template.improvementsModes)) {
        emptyActionsNumber += 1;
      }

      if (emptyActionsNumber === 0) return null;

      var hint = '';
      if (emptyActionsNumber === 1) {
        hint = emptyActionsNumber + ' action is missing.';
      } else if (emptyActionsNumber > 1) {
        hint = emptyActionsNumber + ' actions are missing.';
      }

      return _react2.default.createElement(
        'div',
        { className: _style2.default.OverallDevelopment_HeaderHint },
        hint
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state || !_is_js2.default.existy(this.state.overallDevelopment)) {
        return null;
      }
      return _react2.default.createElement(
        _omniCommonUi.PageCard,
        { className: (0, _omniCommonUi.testClass)('overall-development') },
        _react2.default.createElement(
          _omniCommonUi.PageCard.Heading,
          { text: 'Overall development', stackMode: 'horizontal' },
          this._renderEmptyHint(),
          _react2.default.createElement(_CardActionIcons2.default, { hideEditIcon: !this.props.canEdit,
            onEditClick: this._onEditClick,
            hideDeleteIcon: true })
        ),
        _react2.default.createElement(
          _omniCommonUi.PageCard.Content,
          { className: _style2.default.OverallDevelopment },
          this._renderContent(),
          this._renderButtons()
        )
      );
    }
  }]);

  return OverallDevelopment;
}(_react.PureComponent);

OverallDevelopment.propTypes = {
  studentInfo: _propTypes2.default.object,
  idpId: _propTypes2.default.string,
  groupIdpId: _propTypes2.default.string,
  saveOverallDevelopment: _propTypes2.default.func,
  fetchOverallDevelopmentResultIfNeeded: _propTypes2.default.func,
  fetchOverallDevelopmentTemplateIfNeeded: _propTypes2.default.func,
  overallDevelopment: _propTypes2.default.object,
  changeMode: _propTypes2.default.func.isRequired,
  canEdit: _propTypes2.default.bool,
  isInEditMode: _propTypes2.default.bool,
  onComponentMounted: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var idpId = ownProps.idpId;

  var overallDevelopment = state.get('rootReducer').get('overallDevelopment').get(idpId);
  return {
    overallDevelopment: overallDevelopment
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_OverallDevelopment.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(OverallDevelopment);

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2030);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2zMo46J3MXLC8lq67K-oSf{padding:1.42857rem 0}._2zMo46J3MXLC8lq67K-oSf .iScrollIndicator{background-color:rgba(0,0,0,.2)!important;opacity:1}._2klEGLRv8tEE1c4_Nw_bkb{color:#de4c4c;font-style:Italic;margin-right:1.14286rem}._2HIE8K5eefLFyGkhQC_5b8{-webkit-box-shadow:0;-moz-box-shadow:0;box-shadow:0}._2Pk-hBHXcVSWj9G2az1BYy{border-bottom:0}._2Pk-hBHXcVSWj9G2az1BYy span{color:#de4c4c;font-style:Italic;position:absolute;right:2.14286rem;top:.92857rem}._2NhS9qqao8zWAOfWEMunhe{display:inline-block;-webkit-box-flex:initial;-webkit-flex:initial;-moz-box-flex:initial;-ms-flex:initial;flex:initial;vertical-align:middle}._2t42ejIfsv9WgqbFhFQViW{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-left:.35714rem;vertical-align:middle}._1YvmfwIueTrk_YnpAILACb{padding:0}._1wwrhzaWWliKUQnmIpnNf3{border-top:0;margin-bottom:1rem}._2dpMhSm9WDw4nYtEBf6pW8{left:50%;max-width:35.71429rem;min-width:21.42857rem;padding-bottom:.71429rem;position:relative}._3qgMiEWpsGAlYCyJcMfs4L{padding-top:.71429rem;position:relative;right:50%}._3qgMiEWpsGAlYCyJcMfs4L button{font-weight:400;text-align:left}._3qgMiEWpsGAlYCyJcMfs4L button:hover:not([disabled]):not(._175c_tVK8iOzucB_QSOUER){opacity:.8}._3qgMiEWpsGAlYCyJcMfs4L span{text-transform:none;white-space:normal}._29FlwYg_DdLv1U8JFrMvn4{background:#e5e5e5;bottom:2.5rem;position:absolute;width:100%;z-index:999}._29FlwYg_DdLv1U8JFrMvn4 button{font-weight:400;margin-bottom:.35714rem;text-align:left;text-transform:none}._29FlwYg_DdLv1U8JFrMvn4 button span{vertical-align:middle}._29FlwYg_DdLv1U8JFrMvn4 button i{float:right}._2ZcmR_Iz2KkRE08bw54nMB{padding:0 2.14286rem}._2ZcmR_Iz2KkRE08bw54nMB h1{display:inline-block;font-size:1.14286rem;font-weight:700;margin-right:.35714rem}._2ZcmR_Iz2KkRE08bw54nMB h2{font-size:1.14286rem;font-weight:700;margin-bottom:0}._2IwebGidqv8GAW6mMH2lLc{display:inline-block;margin:.71429rem 1.42857rem 0 0}._2IwebGidqv8GAW6mMH2lLc button{font-weight:400;text-align:left;vertical-align:middle;width:21.42857rem}._2IwebGidqv8GAW6mMH2lLc button[disabled]{opacity:1}._2IwebGidqv8GAW6mMH2lLc button span{text-transform:none;white-space:normal}._2IwebGidqv8GAW6mMH2lLc div{display:inline-block;margin-left:.71429rem}._2IwebGidqv8GAW6mMH2lLc i{display:inline-block;vertical-align:middle}._2v_CCoa1Jj4KUKGaGNP-AR{color:#50f173}.cdr0zBCava0zkRX0wthnB{color:#fc0}.hGJDVvph1pBDcxDOIMbfm{color:#e2476f}._2v_CCoa1Jj4KUKGaGNP-AR,.cdr0zBCava0zkRX0wthnB,.hGJDVvph1pBDcxDOIMbfm{display:inline-block;vertical-align:middle}._2v_CCoa1Jj4KUKGaGNP-AR svg,.cdr0zBCava0zkRX0wthnB svg,.hGJDVvph1pBDcxDOIMbfm svg{height:1.42857rem;width:1.42857rem}._2FNedBbEvb39g9bq8CtQiO{border-bottom:.07143rem solid #ccc;margin:2.14286rem 0 .71429rem}._3fZeSIhaMXiED7KjBxabeZ{padding:0 2.14286rem}._3tskaCBJ-LuZ5A5fVQsBSu{height:5.71429rem;line-height:5.71429rem}._175c_tVK8iOzucB_QSOUER{color:#fff}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"OverallDevelopment": "_2zMo46J3MXLC8lq67K-oSf",
	"OverallDevelopment_HeaderHint": "_2klEGLRv8tEE1c4_Nw_bkb",
	"OverallDevelopment_editCard": "_2HIE8K5eefLFyGkhQC_5b8",
	"OverallDevelopment_editCard_header": "_2Pk-hBHXcVSWj9G2az1BYy",
	"OverallDevelopment_editCard_title": "_2NhS9qqao8zWAOfWEMunhe",
	"OverallDevelopment_editCard_tooltip": "_2t42ejIfsv9WgqbFhFQViW",
	"OverallDevelopment_editCard_content": "_1YvmfwIueTrk_YnpAILACb",
	"OverallDevelopment_editCard_expand": "_1wwrhzaWWliKUQnmIpnNf3",
	"OverallDevelopment_editCard_cell": "_2dpMhSm9WDw4nYtEBf6pW8",
	"OverallDevelopment_editCard_cell_item": "_3qgMiEWpsGAlYCyJcMfs4L",
	"__buttonActived": "_175c_tVK8iOzucB_QSOUER",
	"OverallDevelopment_editCard_cell_menu": "_29FlwYg_DdLv1U8JFrMvn4",
	"OverallDevelopment_viewCard": "_2ZcmR_Iz2KkRE08bw54nMB",
	"OverallDevelopment_viewCard_item": "_2IwebGidqv8GAW6mMH2lLc",
	"OverallDevelopment_happyIcon": "_2v_CCoa1Jj4KUKGaGNP-AR",
	"OverallDevelopment_smileIcon": "cdr0zBCava0zkRX0wthnB",
	"OverallDevelopment_unhappyIcon": "hGJDVvph1pBDcxDOIMbfm",
	"OverallDevelopment_separatorLine": "_2FNedBbEvb39g9bq8CtQiO",
	"OverallDevelopment_buttons": "_3fZeSIhaMXiED7KjBxabeZ",
	"OverallDevelopment_table_header": "_3tskaCBJ-LuZ5A5fVQsBSu"
};

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2032);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Api = __webpack_require__(11);

var _Exporter = __webpack_require__(50);

var _Languages = __webpack_require__(48);

var _Languages2 = _interopRequireDefault(_Languages);

var _omniCommonUi = __webpack_require__(0);

var _IndividualDevelopmentPlanStatus = __webpack_require__(68);

var _IndividualDevelopmentPlanStatus2 = _interopRequireDefault(_IndividualDevelopmentPlanStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXPORT_MIME_TYPE = 'application/pdf';
var DEFAULT_PROGRESS_REPORT_NAME = 'PR';

var LANGUAGE_OPTIONS = [{ code: _Languages2.default.defaultLanguageCode, id: 'language-picker-en' }, { code: 'zh-CN', id: 'language-picker-zh' }, { code: 'id-ID', id: 'language-picker-id', label: 'Bahasa' }, { code: 'vi-VN', id: 'language-picker-vi' }];

function isCompletedStatus(idpStatus) {
  return (idpStatus || '').toLowerCase() === _IndividualDevelopmentPlanStatus.IdpStatus.COMPLETED.toLowerCase();
}

function buildExportFilename(_ref) {
  var studentId = _ref.studentId,
      reportName = _ref.reportName,
      idpStatus = _ref.idpStatus;

  var reportNumberMatch = (reportName || '').match(/(\d+)/);
  var progressReportName = reportNumberMatch ? 'PR' + reportNumberMatch[1] : DEFAULT_PROGRESS_REPORT_NAME;
  var isCompleted = isCompletedStatus(idpStatus);
  var previewSuffix = isCompleted ? '' : '-preview';
  return studentId + '_' + progressReportName + previewSuffix + '.pdf';
}

var ExportDialog = function (_Component) {
  _inherits(ExportDialog, _Component);

  function ExportDialog() {
    _classCallCheck(this, ExportDialog);

    var _this = _possibleConstructorReturn(this, (ExportDialog.__proto__ || Object.getPrototypeOf(ExportDialog)).call(this));

    _this.state = {
      isExportRequested: false,
      choosedLanguageCode: _Languages2.default.defaultLanguageCode
    };
    _this._exportStarted = false;

    _this._performExport = _this._performExport.bind(_this);
    return _this;
  }

  _createClass(ExportDialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.fetchIdpCheck && this.props.idpId) {
        this.props.fetchIdpCheck(this.props.idpId);
      }
    }
  }, {
    key: '_close',
    value: function _close() {
      var _props = this.props,
          buildRoute = _props.buildRoute,
          pushRoute = _props.pushRoute;

      function redirect(param) {
        pushRoute(buildRoute(param));
      }
      redirect({ mode: '' });
    }
  }, {
    key: '_performExport',
    value: function _performExport() {
      var _this2 = this;

      if (this._exportStarted || this.state.isExportRequested) {
        return;
      }

      var _props2 = this.props,
          idpId = _props2.idpId,
          studentId = _props2.studentId,
          reportName = _props2.reportName,
          idpStatus = _props2.idpStatus;


      if (_is_js2.default.falsy(idpId)) {
        _omniCommonUi.log.error('ExportAllHandler is not exporting - idpId is not set!');
        return;
      }

      this._exportStarted = true;
      this.setState({ isExportRequested: true });

      var endpoint = isCompletedStatus(idpStatus) ? 'progress-report-published' : 'progress-report-preview';
      var url = (0, _Api.buildUrl)('/student-idps/' + idpId + '/' + endpoint + '?languageCode=' + (this.state.choosedLanguageCode || _Languages2.default.defaultLanguageCode));

      _Exporter.exporter.get(url, buildExportFilename({ studentId: studentId, reportName: reportName, idpStatus: idpStatus }), false, EXPORT_MIME_TYPE).then(function () {
        _this2._close();
      }).catch(function () {
        _this2.setState({ isExportErrorOccurred: true });
      });
    }
  }, {
    key: '_renderMissingInformation',
    value: function _renderMissingInformation() {
      var missingInformation = this.props.missingInformation;

      if (!missingInformation || missingInformation.length === 0) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: _style2.default.ExportDialog_missing },
        _react2.default.createElement(
          'p',
          { className: _style2.default.ExportDialog_missingIntro },
          'Information is still missing:'
        ),
        _react2.default.createElement(
          'ul',
          { className: _style2.default.ExportDialog_missingList },
          missingInformation.map(function (item) {
            return _react2.default.createElement(
              'li',
              { key: item },
              item
            );
          })
        )
      );
    }
  }, {
    key: '_renderLanguageOptions',
    value: function _renderLanguageOptions() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { className: _style2.default.ExportDialog_language },
        _react2.default.createElement(
          'p',
          { className: _style2.default.ExportDialog_languageLabel },
          'Language'
        ),
        LANGUAGE_OPTIONS.map(function (_ref2) {
          var code = _ref2.code,
              id = _ref2.id,
              label = _ref2.label;

          var isDefault = code === _Languages2.default.defaultLanguageCode;
          return _react2.default.createElement(
            'div',
            { key: code,
              className: (0, _classnames3.default)(_style2.default.ExportDialog_languageOption, _defineProperty({}, _style2.default.__disabled, !isDefault)) },
            _react2.default.createElement(_omniCommonUi.SolidRadio, { name: 'language-picker',
              id: id,
              value: code,
              isChecked: _this3.state.choosedLanguageCode === code,
              onChange: function onChange() {} }),
            label || _Languages2.default.getDisplayName(code)
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      if (this.state.isExportErrorOccurred) {
        return _react2.default.createElement(_omniCommonUi.ErrorDialog, { isOpen: true,
          onConfirmClick: function onConfirmClick() {
            _this4._close();
          } });
      }

      if (this.state.isExportRequested) {
        return _react2.default.createElement(
          _omniCommonUi.ConfirmDialog,
          { isOpen: true,
            isLoading: true,
            isButtonless: true,
            title: 'Exporting reports, please wait' },
          _react2.default.createElement('div', { className: _style2.default.ExportDialog_exportingImmediately })
        );
      }

      var idpStatus = this.props.idpStatus;


      return _react2.default.createElement(
        _omniCommonUi.Dialog,
        { isOpen: true,
          className: _style2.default.ExportDialog_card,
          onRequestClose: function onRequestClose() {
            return _this4._close();
          } },
        _react2.default.createElement(
          'div',
          { className: _style2.default.ExportDialog },
          _react2.default.createElement(
            'div',
            { className: _style2.default.ExportDialog_header },
            _react2.default.createElement(
              'div',
              { className: _style2.default.ExportDialog_title },
              'Export Progress Report'
            ),
            idpStatus && _react2.default.createElement(_IndividualDevelopmentPlanStatus2.default, { status: idpStatus,
              className: _style2.default.ExportDialog_status })
          ),
          this._renderMissingInformation(),
          this._renderLanguageOptions(),
          _react2.default.createElement(
            _omniCommonUi.Button.Container,
            { className: _style2.default.ExportDialog_buttons },
            _react2.default.createElement(
              _omniCommonUi.Button,
              { autoWidth: true,
                type: _omniCommonUi.Button.Type.default,
                className: _style2.default.ExportDialog_button,
                onClick: function onClick() {
                  return _this4._close();
                } },
              'Cancel'
            ),
            _react2.default.createElement(
              _omniCommonUi.Button,
              { autoWidth: true,
                type: _omniCommonUi.Button.Type.primary,
                className: _style2.default.ExportDialog_button,
                onClick: this._performExport },
              'Export'
            )
          )
        )
      );
    }
  }]);

  return ExportDialog;
}(_react.Component);

ExportDialog.propTypes = {
  idpId: _propTypes2.default.string.isRequired,
  studentId: _propTypes2.default.string.isRequired,
  languageCode: _propTypes2.default.string,
  buildRoute: _propTypes2.default.func.isRequired,
  pushRoute: _propTypes2.default.func.isRequired,
  reportName: _propTypes2.default.string,
  idpStatus: _propTypes2.default.string,
  missingInformation: _propTypes2.default.arrayOf(_propTypes2.default.string),
  fetchIdpCheck: _propTypes2.default.func
};

exports.default = ExportDialog;

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2033);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3f0_0vsPkMykPFPWLOR8A1{-webkit-border-radius:.85714rem;-moz-border-radius:.85714rem;border-radius:.85714rem;max-width:38.57143rem;overflow:hidden;width:38.57143rem}._2M1awpC8oNzZrIU2_ENzEP{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:2.28571rem;width:100%}._1jGPOJE1ypjU9iWHs-mTLT,._2M1awpC8oNzZrIU2_ENzEP{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._1jGPOJE1ypjU9iWHs-mTLT{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-bottom:1.71429rem}._1jGPOJE1ypjU9iWHs-mTLT>*+*{margin-left:.57143rem}._2LsjD7mtQO58V_bWnQYh0H{color:#4a4a4a;font-size:1.125em;font-weight:600}._364_TmeIDuluF-kYs72Wdw{-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0}._2DC7_leL_BGPhSQ8XqwFPf{color:#de4c4c;font-size:1.125em;line-height:1.4;margin-bottom:1.71429rem}._1-nRW5NQGx7Ict5lzaGbCK{margin:0}._3QEbVlIdYwyVA4iN29DRlf{list-style:disc;margin:0;padding-left:1.92857rem}._3QEbVlIdYwyVA4iN29DRlf>li{margin:0}.iNeRm--FrkwINUD7ioFsm{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:initial}._2fg6UVrt-Re9Zo4Agu7Y5r{color:#747474;font-size:.875em;line-height:1.4;margin:0 0 1.14286rem}._17sjLVftSDhE1NeFzVspQ-{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._17sjLVftSDhE1NeFzVspQ->*+*{margin-left:.57143rem}._17sjLVftSDhE1NeFzVspQ-+._17sjLVftSDhE1NeFzVspQ-{margin-top:1.14286rem}._17sjLVftSDhE1NeFzVspQ-.sMNjNz_4MIoCaDf_k_1Dw{cursor:not-allowed;opacity:.45;pointer-events:none}._1XAFtEh1I-VA8MrXwOxaDz{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-top:2.85714rem}._1uxBZALaCZh3kYp_8Dgaz2{-webkit-border-radius:1.42857rem;-moz-border-radius:1.42857rem;border-radius:1.42857rem;-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;-webkit-flex-grow:0;-ms-flex-positive:0;flex-grow:0;height:2.85714rem;max-width:none;min-width:14.28571rem;width:14.28571rem}._1BZvRQ5JsAwd0-scxMpQCy{min-height:4.57143rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ExportDialog_card": "_3f0_0vsPkMykPFPWLOR8A1",
	"ExportDialog": "_2M1awpC8oNzZrIU2_ENzEP",
	"ExportDialog_header": "_1jGPOJE1ypjU9iWHs-mTLT",
	"ExportDialog_title": "_2LsjD7mtQO58V_bWnQYh0H",
	"ExportDialog_status": "_364_TmeIDuluF-kYs72Wdw",
	"ExportDialog_missing": "_2DC7_leL_BGPhSQ8XqwFPf",
	"ExportDialog_missingIntro": "_1-nRW5NQGx7Ict5lzaGbCK",
	"ExportDialog_missingList": "_3QEbVlIdYwyVA4iN29DRlf",
	"ExportDialog_language": "iNeRm--FrkwINUD7ioFsm",
	"ExportDialog_languageLabel": "_2fg6UVrt-Re9Zo4Agu7Y5r",
	"ExportDialog_languageOption": "_17sjLVftSDhE1NeFzVspQ-",
	"__disabled": "sMNjNz_4MIoCaDf_k_1Dw",
	"ExportDialog_buttons": "_1XAFtEh1I-VA8MrXwOxaDz",
	"ExportDialog_button": "_1uxBZALaCZh3kYp_8Dgaz2",
	"ExportDialog_exportingImmediately": "_1BZvRQ5JsAwd0-scxMpQCy"
};

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _style = __webpack_require__(2035);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubmitConfirmDialog = function SubmitConfirmDialog(_ref) {
  var isOpen = _ref.isOpen,
      groupName = _ref.groupName,
      onConfirmClick = _ref.onConfirmClick,
      onCancelClick = _ref.onCancelClick;
  return _react2.default.createElement(
    _omniCommonUi.Dialog,
    {
      isOpen: isOpen,
      className: _style2.default.SubmitConfirmDialog_card,
      onRequestClose: function onRequestClose() {
        return onCancelClick();
      }
    },
    _react2.default.createElement(
      'div',
      { className: _style2.default.SubmitConfirmDialog },
      _react2.default.createElement(
        'div',
        { className: _style2.default.SubmitConfirmDialog_title },
        'Submit Progress Report'
      ),
      _react2.default.createElement(
        'p',
        { className: _style2.default.SubmitConfirmDialog_groupName },
        groupName
      ),
      _react2.default.createElement(
        'p',
        { className: _style2.default.SubmitConfirmDialog_message },
        'Progress Report will be submitted to the DoS for review and then published on the parent portal and mini-program.'
      ),
      _react2.default.createElement(
        _omniCommonUi.Button.Container,
        { className: _style2.default.SubmitConfirmDialog_buttons },
        _react2.default.createElement(
          _omniCommonUi.Button,
          {
            autoWidth: true,
            type: _omniCommonUi.Button.Type.default,
            className: _style2.default.SubmitConfirmDialog_button,
            onClick: function onClick() {
              return onCancelClick();
            }
          },
          'Cancel'
        ),
        _react2.default.createElement(
          _omniCommonUi.Button,
          {
            autoWidth: true,
            type: _omniCommonUi.Button.Type.primary,
            className: _style2.default.SubmitConfirmDialog_button,
            onClick: function onClick() {
              return onConfirmClick();
            }
          },
          'Confirm'
        )
      )
    )
  );
};

SubmitConfirmDialog.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  groupName: _propTypes2.default.string,
  onConfirmClick: _propTypes2.default.func.isRequired,
  onCancelClick: _propTypes2.default.func.isRequired
};

exports.default = SubmitConfirmDialog;

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2036);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1EF8Bkbh0IfPzPcvdsBeXF{-webkit-border-radius:.85714rem;-moz-border-radius:.85714rem;border-radius:.85714rem;height:16.78571rem;max-height:16.78571rem;max-width:31.42857rem;overflow:hidden;width:31.42857rem}._2Ed_rnpwUHaxRAsZEQ7hf3{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;padding:1.71429rem 2.14286rem 2.14286rem;width:100%}._2PkMqPqGteeWISF9oI1UoH{color:#4a4a4a;font-size:1.125em;font-weight:600;margin-bottom:.85714rem}._1L1t59O6P2oxqnmeOfyXbX{color:#3b9dd9;font-weight:600;margin:0 0 .85714rem}._3RgUBWoJNkvPkes6VE5aF7{color:#4a4a4a;-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;line-height:inherit;margin:0}._2XU1HocU3WKIZueLRs023T{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;gap:1.14286rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:2.14286rem}._3-9xhGUiIcQiDz9bPFpTr7{-webkit-border-radius:1.42857rem;-moz-border-radius:1.42857rem;border-radius:1.42857rem;-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;-webkit-flex-grow:0;-ms-flex-positive:0;flex-grow:0;height:2.5rem;max-width:none;min-width:11.42857rem;width:11.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SubmitConfirmDialog_card": "_1EF8Bkbh0IfPzPcvdsBeXF",
	"SubmitConfirmDialog": "_2Ed_rnpwUHaxRAsZEQ7hf3",
	"SubmitConfirmDialog_title": "_2PkMqPqGteeWISF9oI1UoH",
	"SubmitConfirmDialog_groupName": "_1L1t59O6P2oxqnmeOfyXbX",
	"SubmitConfirmDialog_message": "_3RgUBWoJNkvPkes6VE5aF7",
	"SubmitConfirmDialog_buttons": "_2XU1HocU3WKIZueLRs023T",
	"SubmitConfirmDialog_button": "_3-9xhGUiIcQiDz9bPFpTr7"
};

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omniCommonUi = __webpack_require__(0);

var _style = __webpack_require__(2038);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubmitSuccessDialog = function SubmitSuccessDialog(_ref) {
  var isOpen = _ref.isOpen,
      groupName = _ref.groupName,
      onCloseClick = _ref.onCloseClick;
  return _react2.default.createElement(
    _omniCommonUi.Dialog,
    {
      isOpen: isOpen,
      className: _style2.default.SubmitSuccessDialog_card,
      onRequestClose: function onRequestClose() {
        return onCloseClick();
      }
    },
    _react2.default.createElement(
      'div',
      { className: _style2.default.SubmitSuccessDialog },
      _react2.default.createElement(
        'div',
        { className: _style2.default.SubmitSuccessDialog_header },
        _react2.default.createElement(_omniCommonUi.Icon, { id: 'success', className: _style2.default.SubmitSuccessDialog_icon }),
        _react2.default.createElement(
          'div',
          { className: _style2.default.SubmitSuccessDialog_title },
          'Done'
        )
      ),
      _react2.default.createElement(
        'p',
        { className: _style2.default.SubmitSuccessDialog_groupName },
        groupName
      ),
      _react2.default.createElement(
        'p',
        { className: _style2.default.SubmitSuccessDialog_message },
        'Progress Report is submitted.'
      ),
      _react2.default.createElement(
        _omniCommonUi.Button.Container,
        { className: _style2.default.SubmitSuccessDialog_buttons },
        _react2.default.createElement(
          _omniCommonUi.Button,
          {
            type: _omniCommonUi.Button.Type.primary,
            className: _style2.default.SubmitSuccessDialog_button,
            onClick: function onClick() {
              return onCloseClick();
            }
          },
          'Close'
        )
      )
    )
  );
};

SubmitSuccessDialog.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  groupName: _propTypes2.default.string,
  onCloseClick: _propTypes2.default.func.isRequired
};

exports.default = SubmitSuccessDialog;

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2039);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2FHLTCgVNLhTsEqVDnrXiL{-webkit-border-radius:.85714rem;-moz-border-radius:.85714rem;border-radius:.85714rem;height:14.28571rem;max-height:14.28571rem;max-width:31.42857rem;overflow:hidden;width:31.42857rem}.OoBE7tjgtzulxEFF69L7m{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;padding:1.71429rem 2.14286rem 2.14286rem;width:100%}._3N6Ss-LS6Fc30SLRnms7bc,.OoBE7tjgtzulxEFF69L7m{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._3N6Ss-LS6Fc30SLRnms7bc{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;gap:.57143rem;margin-bottom:.85714rem}.Qjr4sZrDYFWAg42i1QJDI{color:#55b554;-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0}.Qjr4sZrDYFWAg42i1QJDI,.Qjr4sZrDYFWAg42i1QJDI svg{height:1.42857rem;width:1.42857rem}._1k_GkLtpdtrET52hjPuN2q{color:#4a4a4a;font-size:1.125em;font-weight:600}._2w7-uCXrhjlGQS5MgysBV4{color:#3b9dd9;font-weight:600;margin:0 0 .85714rem}._19cwiH9lEdT7K2Y_7Oy_z4{color:#4a4a4a;-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;line-height:inherit;margin:0}.DoZxT1ijoqlXLZVuQz_55{-webkit-align-self:stretch;-ms-flex-item-align:stretch;align-self:stretch;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;margin-top:2.14286rem;width:100%}._3Q0tUFOshv1fDL3Daif1El{-webkit-border-radius:1.42857rem;-moz-border-radius:1.42857rem;border-radius:1.42857rem;-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;height:2.5rem;max-width:none;min-width:0;width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SubmitSuccessDialog_card": "_2FHLTCgVNLhTsEqVDnrXiL",
	"SubmitSuccessDialog": "OoBE7tjgtzulxEFF69L7m",
	"SubmitSuccessDialog_header": "_3N6Ss-LS6Fc30SLRnms7bc",
	"SubmitSuccessDialog_icon": "Qjr4sZrDYFWAg42i1QJDI",
	"SubmitSuccessDialog_title": "_1k_GkLtpdtrET52hjPuN2q",
	"SubmitSuccessDialog_groupName": "_2w7-uCXrhjlGQS5MgysBV4",
	"SubmitSuccessDialog_message": "_19cwiH9lEdT7K2Y_7Oy_z4",
	"SubmitSuccessDialog_buttons": "DoZxT1ijoqlXLZVuQz_55",
	"SubmitSuccessDialog_button": "_3Q0tUFOshv1fDL3Daif1El"
};

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2041);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".QKpkKgMdCMjQrBSEgtwYn{color:#3b9dd9;font-weight:600;margin:0 0 .85714rem}._1NiHW4iXHBffOKOrn5yluJ{margin:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"submitConfirmDialog_groupName": "QKpkKgMdCMjQrBSEgtwYn",
	"submitConfirmDialog_message": "_1NiHW4iXHBffOKOrn5yluJ"
};

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(834);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(835);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _component2.default;
var routes = exports.routes = _routes3.default;

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2044);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2zp4MF3zozdIifGMLyd9Sx{padding-left:.35714rem}@media only screen and (min-width:640px){._2zp4MF3zozdIifGMLyd9Sx{padding-left:1.07143rem}}._2uz3bmTYzbzsJ8xPBji58g{padding-left:0;padding-right:0}._1uoxCgrQBAsqcmxHZ1DgEe{padding:0 1.42857rem}@media only screen and (min-width:640px){._1uoxCgrQBAsqcmxHZ1DgEe{padding:0 2.14286rem}}._2hiDFb7Zy28KHuKbqvg-xi{margin-top:1.42857rem;padding:0 1.42857rem;padding-bottom:1.42857rem}@media only screen and (min-width:640px){._2hiDFb7Zy28KHuKbqvg-xi{padding:0 2.14286rem;padding-bottom:1.42857rem}}._2hiDFb7Zy28KHuKbqvg-xi .vwglvmseh3Jsm4f4zYU_K{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:.92857rem;font-weight:400;letter-spacing:.03571rem;line-height:1.15385;color:#a4a4a4;margin-bottom:.71429rem}._2hiDFb7Zy28KHuKbqvg-xi .vwglvmseh3Jsm4f4zYU_K.b5373HpA6OPdAnSmTunAv{color:#4a4a4a}.I31Th3BVj7UF0yKRknOeo{border-top:.07143rem solid #ccc;padding:1.42857rem}@media only screen and (min-width:640px){.I31Th3BVj7UF0yKRknOeo{padding:1.42857rem 2.14286rem}}.I31Th3BVj7UF0yKRknOeo .ixwldCxyaeUZWLbZGSnWs{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:.92857rem;font-weight:400;letter-spacing:.03571rem;line-height:1.15385;color:#a4a4a4;margin-bottom:.71429rem}.I31Th3BVj7UF0yKRknOeo .ixwldCxyaeUZWLbZGSnWs.b5373HpA6OPdAnSmTunAv{color:#4a4a4a}._2p2N5qE0WgGTA6vISUlrKP{padding:.71429rem 1.42857rem 0}@media only screen and (min-width:640px){._2p2N5qE0WgGTA6vISUlrKP{padding:.71429rem 2.14286rem 0}}._3BRLx174B-E09xM1nfH45v{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:600;letter-spacing:.03571rem;line-height:1.28571;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;color:inherit;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;line-height:1.71429;outline:0;text-decoration:none;text-transform:uppercase}._2kX82FnlU4jQasiZoZinZW{margin-left:.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"IndividualDevelopmentPlanApprovalView_pageHeading": "_2zp4MF3zozdIifGMLyd9Sx",
	"IndividualDevelopmentPlanApprovalView_pageContent": "_2uz3bmTYzbzsJ8xPBji58g",
	"IndividualDevelopmentPlanApprovalView_userInfo": "_1uoxCgrQBAsqcmxHZ1DgEe",
	"IndividualDevelopmentPlanApprovalView_overall": "_2hiDFb7Zy28KHuKbqvg-xi",
	"_overallTitle": "vwglvmseh3Jsm4f4zYU_K",
	"__noGray": "b5373HpA6OPdAnSmTunAv",
	"IndividualDevelopmentPlanApprovalView_suggestionCard": "I31Th3BVj7UF0yKRknOeo",
	"_suggestionTitle": "ixwldCxyaeUZWLbZGSnWs",
	"IndividualDevelopmentPlanApprovalView_bottomButtons": "_2p2N5qE0WgGTA6vISUlrKP",
	"IndividualDevelopmentPlanApprovalViewLink": "_3BRLx174B-E09xM1nfH45v",
	"IndividualDevelopmentPlanApprovalViewLink_icon": "_2kX82FnlU4jQasiZoZinZW"
};

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserInfo = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2046);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _omniCommonUi = __webpack_require__(0);

var _Users = __webpack_require__(82);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserInfo = exports.UserInfo = function (_Component) {
  _inherits(UserInfo, _Component);

  function UserInfo() {
    _classCallCheck(this, UserInfo);

    return _possibleConstructorReturn(this, (UserInfo.__proto__ || Object.getPrototypeOf(UserInfo)).apply(this, arguments));
  }

  _createClass(UserInfo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setUp(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this._setUp(props);
    }
  }, {
    key: '_setUp',
    value: function _setUp(props) {
      if (_is_js2.default.not.empty(props.id)) {
        props.fetchUserIfNeeded(props.id);
      }
    }
  }, {
    key: '_renderDate',
    value: function _renderDate(dateStr) {
      if (_is_js2.default.existy(dateStr)) {
        return _react2.default.createElement(
          'div',
          { className: _style2.default.UserInfo_date },
          dateStr
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          dateStr = _props.dateStr;

      if (!user) return null;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(this.props.className) },
        _react2.default.createElement(
          'div',
          { className: _style2.default.UserInfo_name },
          user.firstName + ' ' + user.lastName + '\'s Comment'
        ),
        this._renderDate(dateStr)
      );
    }
  }]);

  return UserInfo;
}(_react.Component);

UserInfo.propTypes = {
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  fetchUserIfNeeded: _propTypes2.default.func,
  isLoading: _propTypes2.default.bool,
  user: _propTypes2.default.shape(),
  dateStr: _propTypes2.default.string
};

function mapStateToProps(state, ownProps) {
  return {
    user: _Users.accessors.getUserByUserId(state, ownProps.id)
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_Users.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(UserInfo);

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2047);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2cfXIhQW4zPaDxIdbj5M9x{font-size:.92857rem;line-height:1.15385;color:#a4a4a4;line-height:1.53846}._2cfXIhQW4zPaDxIdbj5M9x,.AJ7pUzf3nlopE6F6kBUZR{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-weight:400;letter-spacing:.03571rem}.AJ7pUzf3nlopE6F6kBUZR{font-size:1rem;line-height:1.07143;line-height:1.42857}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"UserInfo_date": "_2cfXIhQW4zPaDxIdbj5M9x",
	"UserInfo_name": "AJ7pUzf3nlopE6F6kBUZR"
};

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ketScoreRoutes = exports.ketMockExamRoutes = undefined;

var _component = __webpack_require__(337);

var _component2 = _interopRequireDefault(_component);

var _routes = __webpack_require__(2053);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ketMockExamRoutes = _routes.ketMockExamRoutes;
exports.ketScoreRoutes = _routes.ketScoreRoutes;
exports.default = _component2.default;

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2050);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2klMmOCbxyaeb27ac91YxC{width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"KetExam_content": "_2klMmOCbxyaeb27ac91YxC"
};

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = ketExams;

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _actions = __webpack_require__(836);

var _model = __webpack_require__(338);

var _model2 = _interopRequireDefault(_model);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = new _immutable.Map({
  plans: new _immutable.Map(), // key: groupId
  exams: new _immutable.Map() // key: ketExamId
});

function ketExams() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _actions.FETCH_KET_EXAMS_PLAN_REQUEST:
      return state.setIn(['plans', action.groupId], _omniCommonUi.ApiResponseHelper.create({
        loading: true
      }));
    case _actions.FETCH_KET_EXAMS_PLAN_SUCCESS:
      return state.setIn(['plans', action.groupId], _omniCommonUi.ApiResponseHelper.create(_immutable2.default.fromJS((action.payload || []).map(function (exam) {
        return _extends({}, exam, {
          ketExamId: '' + exam.ketExamId
        });
      }))));
    case _actions.FETCH_KET_EXAMS_PLAN_FAILURE:
      return state.setIn(['plans', action.groupId], _omniCommonUi.ApiResponseHelper.create(action.error));
    case _actions.FETCH_KET_EXAM_REQUEST:
      return state.setIn(['exams', action.ketExamId], _omniCommonUi.ApiResponseHelper.create({
        loading: true
      }));
    case _actions.FETCH_KET_EXAM_SUCCESS:
      return state.setIn(['exams', action.ketExamId], _omniCommonUi.ApiResponseHelper.create(_model2.default.create(Object.assign({}, action.payload, {
        ketExamId: action.ketExamId,
        groupId: action.groupId
      }))));
    case _actions.FETCH_KET_EXAM_FAILURE:
      return state.setIn(['exams', action.ketExamId], _omniCommonUi.ApiResponseHelper.create(action.error));
    default:
      return state;
  }
}

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKetExamsPlan = getKetExamsPlan;
exports.getKetExam = getKetExam;
exports.getKetExamPlanByType = getKetExamPlanByType;
exports.mapMarkToScale = mapMarkToScale;
exports.mapScaleToBanding = mapScaleToBanding;
exports.computeOverallScore = computeOverallScore;
exports.isFailBanding = isFailBanding;
exports.formatGradeBanding = formatGradeBanding;

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _model = __webpack_require__(338);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getKetExamsPlan(state, groupId) {
  return state.get('rootReducer').get('ketExams').get('plans').get(groupId);
}

function getKetExam(state, ketExamId) {
  return state.get('rootReducer').get('ketExams').get('exams').get(ketExamId);
}

function getKetExamPlanByType(state, groupId, examType, mockIndex) {
  var plans = getKetExamsPlan(state, groupId);
  if (!plans || !plans.data || plans.loading || plans.error) return undefined;
  return plans.data.find(function (exam) {
    if (exam.get('examType') !== examType) return false;
    if (examType !== _model.KET_EXAM_TYPE_MOCK) return true;
    return '' + exam.get('mockIndex') === '' + mockIndex;
  });
}

function mapMarkToScale(skill, mark) {
  if (!skill || !_is_js2.default.number(mark)) return undefined;
  var band = skill.markToScaleMappings.find(function (mapping) {
    return mapping.get('mark') === mark;
  });
  return band ? band.get('scale') : undefined;
}

function mapScaleToBanding(scaleBandings, scale) {
  if (!scaleBandings || !_is_js2.default.number(scale)) return undefined;
  var band = scaleBandings.find(function (mapping) {
    return scale >= mapping.get('scaleFrom') && scale <= mapping.get('scaleTo');
  });
  if (!band) return undefined;
  return { grade: band.get('grade'), level: band.get('cefrLevel') };
}

function computeOverallScore(scales) {
  var validScales = (scales || []).filter(function (scale) {
    return _is_js2.default.number(scale);
  });
  if (validScales.length === 0) return undefined;
  return Math.floor(validScales.reduce(function (sum, scale) {
    return sum + scale;
  }, 0) / validScales.length);
}

function isFailBanding(grade) {
  return ('' + (grade || '')).toLowerCase() === 'fail';
}

function formatGradeBanding(grade, level) {
  if (isFailBanding(grade)) return 'Fail';
  if (_is_js2.default.existy(grade)) return 'Grade ' + grade + ' - Level ' + level;
  if (_is_js2.default.existy(level)) return 'Level ' + level;
  return '';
}

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ketScoreRoutes = exports.ketMockExamRoutes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _TabSwitcher = __webpack_require__(25);

var _TabSwitcher2 = _interopRequireDefault(_TabSwitcher);

var _KetExams = __webpack_require__(171);

var _component = __webpack_require__(337);

var _component2 = _interopRequireDefault(_component);

var _ListView = __webpack_require__(2054);

var _ListView2 = _interopRequireDefault(_ListView);

var _MarkView = __webpack_require__(2058);

var _MarkView2 = _interopRequireDefault(_MarkView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAccessable = function isAccessable(state, groupId, tabCode) {
  return _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.ProgressTest.View) && _TabSwitcher2.default.isTabEnabled(state, groupId, tabCode);
};

var mockExamSecondLevelTabs = function mockExamSecondLevelTabs(_ref) {
  var push = _ref.push,
      params = _ref.params,
      buildRoute = _ref.buildRoute;
  var groupId = params.groupId,
      mockIndex = params.mockIndex;

  var activeIndex = mockIndex || _component.DEFAULT_MOCK_INDEX;
  var tabs = [];

  var _loop = function _loop(index) {
    tabs.push({
      text: 'MOCK EXAM ' + index,
      onClick: function onClick() {
        return push(buildRoute('/group/' + groupId + '/ket-exam/' + index));
      },
      isActive: '' + activeIndex === '' + index
    });
  };

  for (var index = 1; index <= _component.MOCK_EXAM_COUNT; index += 1) {
    _loop(index);
  }
  return tabs;
};

var createKetExamRoutes = function createKetExamRoutes(_ref2) {
  var getState = _ref2.getState,
      examType = _ref2.examType,
      path = _ref2.path,
      tabCode = _ref2.tabCode,
      label = _ref2.label,
      order = _ref2.order;
  return _extends({
    path: path,
    component: _component2.default,
    examType: examType,
    canAccess: function canAccess(_ref3) {
      var params = _ref3.params;
      return isAccessable(getState(), params.groupId, tabCode);
    },
    tab: {
      label: label,
      order: order,
      isVisible: function isVisible(params) {
        return isAccessable(getState(), params.groupId, tabCode);
      }
    }
  }, examType === _KetExams.KET_EXAM_TYPE_MOCK ? { secondLevelTabs: mockExamSecondLevelTabs } : {}, {
    indexRoute: {
      component: _ListView2.default
    },
    childRoutes: examType === _KetExams.KET_EXAM_TYPE_MOCK ? [{ path: ':mockIndex', component: _ListView2.default }, { path: ':mockIndex/student/:studentId', component: _MarkView2.default }] : [{ path: 'student/:studentId', component: _MarkView2.default }]
  });
};

var ketMockExamRoutes = exports.ketMockExamRoutes = function ketMockExamRoutes(_ref4) {
  var getState = _ref4.getState;
  return createKetExamRoutes({
    getState: getState,
    examType: _KetExams.KET_EXAM_TYPE_MOCK,
    path: 'ket-exam',
    tabCode: _TabSwitcher.TabCodes.KETMockExam,
    label: 'Exam',
    order: 1
  });
};

var ketScoreRoutes = exports.ketScoreRoutes = function ketScoreRoutes(_ref5) {
  var getState = _ref5.getState;
  return createKetExamRoutes({
    getState: getState,
    examType: _KetExams.KET_EXAM_TYPE_REAL,
    path: 'ket-score',
    tabCode: _TabSwitcher.TabCodes.KETScore,
    label: 'KET RESULTS',
    order: 2
  });
};

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(2055);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _component2.default;

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KetExamListView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(2056);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(16);

var _classnames3 = __webpack_require__(7);

var _classnames4 = _interopRequireDefault(_classnames3);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _CourseViewTable = __webpack_require__(32);

var _CourseViewTable2 = _interopRequireDefault(_CourseViewTable);

var _GroupMembers = __webpack_require__(14);

var _KetExams = __webpack_require__(171);

var _component = __webpack_require__(337);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EMPTY_HYPHEN = '-';
var NO_MATCH_SLASH = '/';

var FINAL_SCORE_COLUMN = 'ket-final-score';
var MARKED_BY_COLUMN = 'ket-marked-by';
var MARK_SCORE_COLUMN = 'ket-mark-score';
var MOCK_COLUMN_PREFIX = 'ket-mock-';

var KetExamListView = exports.KetExamListView = function (_Component) {
  _inherits(KetExamListView, _Component);

  function KetExamListView() {
    _classCallCheck(this, KetExamListView);

    return _possibleConstructorReturn(this, (KetExamListView.__proto__ || Object.getPrototypeOf(KetExamListView)).apply(this, arguments));
  }

  _createClass(KetExamListView, [{
    key: '_getMarkRoute',
    value: function _getMarkRoute(studentId) {
      var _props = this.props,
          _props$params = _props.params,
          groupId = _props$params.groupId,
          mockIndex = _props$params.mockIndex,
          examType = _props.examType,
          buildRoute = _props.buildRoute;

      if (examType === _KetExams.KET_EXAM_TYPE_MOCK) {
        return buildRoute('/group/' + groupId + '/ket-exam/' + (mockIndex || '1') + '/student/' + studentId);
      }
      return buildRoute('/group/' + groupId + '/ket-score/student/' + studentId);
    }
  }, {
    key: '_renderSkillCell',
    value: function _renderSkillCell(result, skill) {
      var skillResult = result && result.skillResults.get(skill.skillId);
      var mark = skillResult && skillResult.get('mark');
      var scale = skillResult && skillResult.get('scale');
      if (!_is_js2.default.number(mark)) {
        return _react2.default.createElement(
          'span',
          null,
          EMPTY_HYPHEN
        );
      }
      if (!_is_js2.default.number(scale)) {
        return _react2.default.createElement(
          _omniCommonUi.Tooltip,
          { text: 'Marks ' + mark + ' = ' + NO_MATCH_SLASH,
            placement: 'top',
            trigger: ['hover'] },
          _react2.default.createElement(
            'span',
            { className: (0, _classnames4.default)(_style2.default.KetExamListView_score, _style2.default.__fail) },
            NO_MATCH_SLASH
          )
        );
      }

      var isFail = _KetExams.accessors.isFailBanding(skillResult.get('grade'));
      var content = _react2.default.createElement(
        'span',
        { className: (0, _classnames4.default)(_style2.default.KetExamListView_score, _defineProperty({}, _style2.default.__fail, isFail)) },
        scale
      );
      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        { text: 'Marks ' + mark + ' = Cambridge English Scale ' + scale,
          placement: 'top',
          trigger: ['hover'] },
        content
      );
    }
  }, {
    key: '_renderFinalScoreCell',
    value: function _renderFinalScoreCell(result, exam) {
      if (!exam || !exam.data) {
        return _react2.default.createElement(
          'span',
          null,
          EMPTY_HYPHEN
        );
      }
      var skills = exam.data.skills;
      var allMarked = skills.every(function (skill) {
        var skillResult = result && result.skillResults.get(skill.skillId);
        return skillResult && _is_js2.default.number(skillResult.get('mark'));
      });
      if (!allMarked) {
        return _react2.default.createElement(
          'span',
          null,
          EMPTY_HYPHEN
        );
      }

      var scales = skills.map(function (skill) {
        var skillResult = result.skillResults.get(skill.skillId);
        var scale = skillResult && skillResult.get('scale');
        return _is_js2.default.number(scale) ? scale : 0;
      }).toArray();
      var finalScore = _KetExams.accessors.computeOverallScore(scales);
      if (!_is_js2.default.number(finalScore)) {
        return _react2.default.createElement(
          'span',
          null,
          EMPTY_HYPHEN
        );
      }

      var banding = _KetExams.accessors.mapScaleToBanding(exam.data.scaleBandings, finalScore);
      var isFail = banding && _KetExams.accessors.isFailBanding(banding.grade);
      var content = _react2.default.createElement(
        'span',
        { className: (0, _classnames4.default)(_style2.default.KetExamListView_score, _defineProperty({}, _style2.default.__fail, isFail)) },
        finalScore
      );
      if (!banding) return content;
      var bandingText = _KetExams.accessors.formatGradeBanding(banding.grade, banding.level);
      return _react2.default.createElement(
        _omniCommonUi.Tooltip,
        { text: 'Passtype: ' + bandingText,
          placement: 'top',
          trigger: ['hover'] },
        content
      );
    }
  }, {
    key: '_renderMarkScoreCell',
    value: function _renderMarkScoreCell(student) {
      var examType = this.props.examType;

      var label = examType === _KetExams.KET_EXAM_TYPE_REAL ? 'Record Score' : 'Mark Score';
      return _react2.default.createElement(
        _reactRouter.Link,
        { to: this._getMarkRoute(student.studentGeneralInfo.id),
          className: (0, _classnames4.default)(_style2.default.KetExamListView_markLink, (0, _omniCommonUi.testClass)('ket-mark-score-link')) },
        _react2.default.createElement(
          'span',
          null,
          label
        ),
        _react2.default.createElement(_omniCommonUi.Icon, { id: 'arrow-right', className: _style2.default.KetExamListView_markLink_icon })
      );
    }
  }, {
    key: '_renderMockExamCell',
    value: function _renderMockExamCell(student, mockIndex) {
      var mockExams = this.props.mockExams;

      var mockExam = (mockExams || []).find(function (item) {
        return item.mockIndex === mockIndex;
      });
      var mockExamData = mockExam && mockExam.exam;
      if (!mockExamData || !mockExamData.data) {
        return _react2.default.createElement(
          'span',
          null,
          EMPTY_HYPHEN
        );
      }
      var result = mockExamData.data.studentResults.get('' + student.studentGeneralInfo.id);
      return this._renderFinalScoreCell(result, mockExamData);
    }
  }, {
    key: '_renderCell',
    value: function _renderCell(student, columnId) {
      var exam = this.props.exam;

      var studentId = student.studentGeneralInfo.id;
      var result = exam.data.studentResults.get('' + studentId);

      if (typeof columnId === 'string' && columnId.indexOf(MOCK_COLUMN_PREFIX) === 0) {
        var mockIndex = Number.parseInt(columnId.slice(MOCK_COLUMN_PREFIX.length), 10);
        return this._renderMockExamCell(student, mockIndex);
      }

      switch (columnId) {
        case FINAL_SCORE_COLUMN:
          return this._renderFinalScoreCell(result, exam);
        case MARKED_BY_COLUMN:
          return _react2.default.createElement(
            'span',
            null,
            result && result.markedBy || EMPTY_HYPHEN
          );
        case MARK_SCORE_COLUMN:
          return this._renderMarkScoreCell(student);
        default:
          {
            var skill = exam.data.skills.find(function (examSkill) {
              return examSkill.skillId === columnId;
            });
            return this._renderSkillCell(result, skill);
          }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          exam = _props2.exam,
          members = _props2.members,
          canMark = _props2.canMark,
          examType = _props2.examType;

      if (!exam || !exam.data || !_immutable.List.isList(members)) return null;

      var isReal = examType === _KetExams.KET_EXAM_TYPE_REAL;
      var finalScoreLabel = isReal ? 'KET Score' : 'Final Score';
      var markedByLabel = isReal ? 'Record by' : 'Marked by';

      var skills = exam.data.skills.sortBy(function (skill) {
        return skill.orderingSequence;
      });

      var leadingColumns = isReal ? Array.from({ length: _component.MOCK_EXAM_COUNT }, function (unused, offset) {
        return offset + 1;
      }).map(function (index) {
        return _react2.default.createElement(
          _CourseViewTable2.default.Cell,
          { key: '' + MOCK_COLUMN_PREFIX + index,
            columnId: '' + MOCK_COLUMN_PREFIX + index,
            small: true },
          'Mock Exam ' + index
        );
      }) : skills.map(function (skill) {
        return _react2.default.createElement(
          _CourseViewTable2.default.Cell,
          { key: skill.skillId,
            columnId: skill.skillId,
            small: true },
          skill.name
        );
      });

      return _react2.default.createElement(
        'div',
        { className: _style2.default.KetExamListView },
        _react2.default.createElement(
          _omniCommonUi.PageCard,
          null,
          _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: exam.data.name || 'Students',
            className: _style2.default.KetExamListView_cardHeader }),
          _react2.default.createElement(
            _omniCommonUi.PageCard.Content,
            { className: _style2.default.KetExamListView_content },
            _react2.default.createElement(
              _CourseViewTable2.default,
              { students: members, onlyRowDivider: true },
              _react2.default.createElement(
                _CourseViewTable2.default.Header,
                null,
                _react2.default.createElement(
                  _CourseViewTable2.default.Row,
                  null,
                  leadingColumns,
                  _react2.default.createElement(
                    _CourseViewTable2.default.Cell,
                    { columnId: FINAL_SCORE_COLUMN, small: true },
                    finalScoreLabel
                  ),
                  _react2.default.createElement(
                    _CourseViewTable2.default.Cell,
                    { columnId: MARKED_BY_COLUMN, small: true },
                    markedByLabel
                  ),
                  canMark && _react2.default.createElement(
                    _CourseViewTable2.default.Cell,
                    { columnId: MARK_SCORE_COLUMN, small: true },
                    _react2.default.createElement('span', { className: (0, _omniCommonUi.testClass)('ket-mark-score-header') })
                  )
                )
              ),
              _react2.default.createElement(
                _CourseViewTable2.default.Body,
                null,
                function (student, columnId) {
                  return _this2._renderCell(student, columnId);
                }
              )
            )
          )
        )
      );
    }
  }]);

  return KetExamListView;
}(_react.Component);

KetExamListView.propTypes = {
  params: _propTypes2.default.object.isRequired,
  examType: _propTypes2.default.string,
  exam: _propTypes2.default.object,
  mockExams: _propTypes2.default.array,
  members: _propTypes2.default.object,
  canMark: _propTypes2.default.bool,
  buildRoute: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  return {
    members: _GroupMembers.actions.getMembersByGroup(state, groupId),
    canMark: _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.ProgressTest.Edit)
  };
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps)(KetExamListView);

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2057);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1uvIE2wMQBKcdqPES8hluN{padding:1.42857rem}@media only screen and (min-width:640px){._1uvIE2wMQBKcdqPES8hluN{padding:2.14286rem}}._2Snp2GEgh2MHG_P__V_Ew8{padding-bottom:0}._2WRR1-ItKWOY_lC_Khd9IR{padding:0}.ssRBAgBULI_r-Kbx1L13V.YMS4osIaAW1sS8pSzTYAy{color:#de4c4c}._32HiQsMKNJgfHJtTA_s6if{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;color:#0087e6;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;text-decoration:none;white-space:nowrap}._1TvQiWh6RJ6z26pg3hHhNo{height:1rem;margin-left:.42857rem;width:1rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"KetExamListView": "_1uvIE2wMQBKcdqPES8hluN",
	"KetExamListView_cardHeader": "_2Snp2GEgh2MHG_P__V_Ew8",
	"KetExamListView_content": "_2WRR1-ItKWOY_lC_Khd9IR",
	"KetExamListView_score": "ssRBAgBULI_r-Kbx1L13V",
	"__fail": "YMS4osIaAW1sS8pSzTYAy",
	"KetExamListView_markLink": "_32HiQsMKNJgfHJtTA_s6if",
	"KetExamListView_markLink_icon": "_1TvQiWh6RJ6z26pg3hHhNo"
};

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(2059);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _component2.default;

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KetExamMarkView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(837);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(10);

var _classnames4 = __webpack_require__(7);

var _classnames5 = _interopRequireDefault(_classnames4);

var _immutable = __webpack_require__(3);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _GroupMembers = __webpack_require__(14);

var _KetExams = __webpack_require__(171);

var _MarkInput = __webpack_require__(2061);

var _MarkInput2 = _interopRequireDefault(_MarkInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EMPTY_HYPHEN = '-';
var NO_MATCH_SLASH = '/';
var INTEGER_PATTERN = /^\d+$/;

var KetExamMarkView = exports.KetExamMarkView = function (_Component) {
  _inherits(KetExamMarkView, _Component);

  function KetExamMarkView(props) {
    _classCallCheck(this, KetExamMarkView);

    var _this = _possibleConstructorReturn(this, (KetExamMarkView.__proto__ || Object.getPrototypeOf(KetExamMarkView)).call(this, props));

    _this.state = {
      marks: new _immutable.Map(),
      isSaving: false
    };

    _this._onSave = _this._onSave.bind(_this);
    _this._getLinkHrefForValue = _this._getLinkHrefForValue.bind(_this);
    return _this;
  }

  _createClass(KetExamMarkView, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._initMarks(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var studentChanged = nextProps.params.studentId !== this.props.params.studentId;
      var examChanged = this._getExamData(nextProps) !== this._getExamData(this.props);
      if (studentChanged || examChanged) {
        this._initMarks(nextProps);
      }
    }
  }, {
    key: '_getExamData',
    value: function _getExamData() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var exam = props.exam;

      return exam && exam.data;
    }
  }, {
    key: '_initMarks',
    value: function _initMarks(props) {
      var examData = this._getExamData(props);
      if (!examData) {
        this.setState({ marks: new _immutable.Map() });
        return;
      }
      var result = examData.studentResults.get('' + props.params.studentId);
      var marks = new _immutable.Map(examData.skills.map(function (skill) {
        var skillResult = result && result.skillResults.get(skill.skillId);
        var mark = skillResult && skillResult.get('mark');
        return [skill.skillId, _is_js2.default.number(mark) ? '' + mark : ''];
      }));
      this.setState({ marks: marks });
    }
  }, {
    key: '_getMarkRoute',
    value: function _getMarkRoute(studentId) {
      var _props = this.props,
          _props$params = _props.params,
          groupId = _props$params.groupId,
          mockIndex = _props$params.mockIndex,
          examType = _props.examType,
          buildRoute = _props.buildRoute;

      if (examType === _KetExams.KET_EXAM_TYPE_MOCK) {
        return buildRoute('/group/' + groupId + '/ket-exam/' + (mockIndex || '1') + '/student/' + studentId);
      }
      return buildRoute('/group/' + groupId + '/ket-score/student/' + studentId);
    }
  }, {
    key: '_getLinkHrefForValue',
    value: function _getLinkHrefForValue(studentId) {
      return this._getMarkRoute(studentId);
    }
  }, {
    key: '_getParsedMark',
    value: function _getParsedMark(skill) {
      var markText = this.state.marks.get(skill.skillId);
      if (!INTEGER_PATTERN.test(markText || '')) return undefined;
      return Number.parseInt(markText, 10);
    }
  }, {
    key: '_computeSkillDerived',
    value: function _computeSkillDerived(skill) {
      var examData = this._getExamData();
      var mark = this._getParsedMark(skill);
      var scale = _KetExams.accessors.mapMarkToScale(skill, mark);
      var banding = _KetExams.accessors.mapScaleToBanding(examData.scaleBandings, scale);
      return { mark: mark, scale: scale, banding: banding };
    }
  }, {
    key: '_computeOverallDerived',
    value: function _computeOverallDerived(skills) {
      var _this2 = this;

      var examData = this._getExamData();
      var scales = skills.map(function (skill) {
        var _computeSkillDerived2 = _this2._computeSkillDerived(skill),
            scale = _computeSkillDerived2.scale;

        return _is_js2.default.number(scale) ? scale : 0;
      }).toArray();
      var overallScore = _KetExams.accessors.computeOverallScore(scales);
      var overallBanding = _KetExams.accessors.mapScaleToBanding(examData.scaleBandings, overallScore);
      return { overallScore: overallScore, overallBanding: overallBanding };
    }
  }, {
    key: '_areAllMarksFilled',
    value: function _areAllMarksFilled(skills) {
      var _this3 = this;

      return skills.every(function (skill) {
        return _is_js2.default.number(_this3._getParsedMark(skill));
      });
    }
  }, {
    key: '_onMarkChange',
    value: function _onMarkChange(skill, value) {
      this.setState(function (_ref) {
        var marks = _ref.marks;
        return { marks: marks.set(skill.skillId, value) };
      });
    }
  }, {
    key: '_onSave',
    value: function _onSave() {
      var _this4 = this;

      var _props2 = this.props,
          _props2$params = _props2.params,
          groupId = _props2$params.groupId,
          studentId = _props2$params.studentId,
          currentExamPlan = _props2.currentExamPlan;

      var examData = this._getExamData();
      var skillMarks = examData.skills.map(function (skill) {
        return {
          skillId: skill.skillId,
          mark: _this4._getParsedMark(skill)
        };
      }).toArray();

      this.setState({ isSaving: true });
      this.props.submitKetExamResult(groupId, currentExamPlan.get('ketExamId'), studentId, skillMarks).then(function () {
        return _this4.setState({ isSaving: false });
      }).catch(function () {
        return _this4.setState({ isSaving: false });
      });
    }
  }, {
    key: '_renderStudentSelect',
    value: function _renderStudentSelect() {
      var _props3 = this.props,
          members = _props3.members,
          studentId = _props3.params.studentId;

      var examData = this._getExamData();
      var options = members.map(function (member) {
        var studentGeneralInfo = member.studentGeneralInfo;

        var result = examData.studentResults.get('' + studentGeneralInfo.id);
        var hasFinalScore = result && _is_js2.default.number(result.finalScore);
        var finalScore = hasFinalScore ? result.finalScore : EMPTY_HYPHEN;
        var banding = hasFinalScore ? _KetExams.accessors.mapScaleToBanding(examData.scaleBandings, result.finalScore) : undefined;
        var isFail = banding && _KetExams.accessors.isFailBanding(banding.grade);
        var html = _react2.default.createElement(
          _omniCommonUi.StudentCard,
          { vertical: true, borderless: true, backgroundless: true },
          _react2.default.createElement(_omniCommonUi.StudentCard.Profile, { name: studentGeneralInfo.firstName,
            surname: studentGeneralInfo.lastName,
            localName: studentGeneralInfo.localName,
            avatarUrl: studentGeneralInfo.avatarUrl,
            gender: studentGeneralInfo.gender }),
          _react2.default.createElement(
            _omniCommonUi.StudentCard.Content,
            null,
            _react2.default.createElement(
              _omniCommonUi.Card.Content,
              { className: (0, _classnames5.default)(_style2.default.KetExamMarkView_studentSelect_score, _defineProperty({}, _style2.default.__fail, isFail)) },
              finalScore
            )
          )
        );
        return {
          html: html,
          value: studentGeneralInfo.id,
          className: _style2.default.KetExamMarkView_studentSelect_option
        };
      });

      return _react2.default.createElement(
        'div',
        { className: _style2.default.KetExamMarkView_studentSelect },
        _react2.default.createElement(_omniCommonUi.HorizontalSelect, { options: options,
          value: studentId,
          getLinkHrefForValue: this._getLinkHrefForValue })
      );
    }
  }, {
    key: '_renderSkillColumn',
    value: function _renderSkillColumn(skill) {
      var _this5 = this;

      var _computeSkillDerived3 = this._computeSkillDerived(skill),
          mark = _computeSkillDerived3.mark,
          scale = _computeSkillDerived3.scale,
          banding = _computeSkillDerived3.banding;

      var hasMark = _is_js2.default.number(mark);
      var scaleText = EMPTY_HYPHEN;
      if (_is_js2.default.number(scale)) {
        scaleText = '' + scale;
      } else if (hasMark) {
        scaleText = NO_MATCH_SLASH;
      }
      var bandingText = EMPTY_HYPHEN;
      if (banding) {
        bandingText = _KetExams.accessors.formatGradeBanding(banding.grade, banding.level);
      } else if (hasMark) {
        bandingText = NO_MATCH_SLASH;
      }
      var isFail = banding && _KetExams.accessors.isFailBanding(banding.grade);

      return _react2.default.createElement(
        'div',
        { key: skill.skillId, className: _style2.default.KetExamMarkView_skill },
        _react2.default.createElement(
          'div',
          { className: _style2.default.KetExamMarkView_skill_name },
          skill.name
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.KetExamMarkView_skill_field },
          _react2.default.createElement(
            'div',
            { className: _style2.default.KetExamMarkView_skill_field_label },
            'Marks'
          ),
          _react2.default.createElement(_MarkInput2.default, { value: this.state.marks.get(skill.skillId) || '',
            maxMark: skill.maxMark,
            onChange: function onChange(value) {
              return _this5._onMarkChange(skill, value);
            } })
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.KetExamMarkView_skill_field },
          _react2.default.createElement(
            'div',
            { className: _style2.default.KetExamMarkView_skill_field_label },
            'Cambridge English Scale'
          ),
          _react2.default.createElement('input', { type: 'text',
            readOnly: true,
            className: _style2.default.KetExamMarkView_readonlyInput,
            value: scaleText })
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.KetExamMarkView_skill_field },
          _react2.default.createElement(
            'div',
            { className: _style2.default.KetExamMarkView_skill_field_label },
            'Grade Banding'
          ),
          _react2.default.createElement('input', { type: 'text',
            readOnly: true,
            className: (0, _classnames5.default)(_style2.default.KetExamMarkView_readonlyInput, _defineProperty({}, _style2.default.__fail, isFail)),
            value: bandingText })
        )
      );
    }
  }, {
    key: '_renderSummary',
    value: function _renderSummary(skills) {
      var allMarksFilled = this._areAllMarksFilled(skills);
      var canSave = allMarksFilled && !this.state.isSaving;

      var _ref2 = allMarksFilled ? this._computeOverallDerived(skills) : {},
          overallScore = _ref2.overallScore,
          overallBanding = _ref2.overallBanding;

      var resultText = EMPTY_HYPHEN;
      if (overallBanding) {
        resultText = _is_js2.default.existy(overallBanding.grade) ? overallBanding.grade : NO_MATCH_SLASH;
      }
      var isOverallFail = overallBanding && _KetExams.accessors.isFailBanding(overallBanding.grade);

      return _react2.default.createElement(
        'div',
        { className: _style2.default.KetExamMarkView_summary },
        _react2.default.createElement(
          'div',
          { className: _style2.default.KetExamMarkView_summary_fields },
          _react2.default.createElement(
            'div',
            { className: _style2.default.KetExamMarkView_summary_item },
            _react2.default.createElement(
              'div',
              { className: _style2.default.KetExamMarkView_summary_item_label },
              'Result'
            ),
            _react2.default.createElement('input', { type: 'text',
              readOnly: true,
              className: _style2.default.KetExamMarkView_summary_item_input,
              value: resultText })
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.KetExamMarkView_summary_item },
            _react2.default.createElement(
              'div',
              { className: _style2.default.KetExamMarkView_summary_item_label },
              'Overall Score'
            ),
            _react2.default.createElement('input', { type: 'text',
              readOnly: true,
              className: (0, _classnames5.default)(_style2.default.KetExamMarkView_summary_item_input, _defineProperty({}, _style2.default.__fail, isOverallFail)),
              value: _is_js2.default.number(overallScore) ? '' + overallScore : EMPTY_HYPHEN })
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.KetExamMarkView_summary_item },
            _react2.default.createElement(
              'div',
              { className: _style2.default.KetExamMarkView_summary_item_label },
              'CEFR Level'
            ),
            _react2.default.createElement('input', { type: 'text',
              readOnly: true,
              className: _style2.default.KetExamMarkView_summary_item_input,
              value: overallBanding && overallBanding.level || EMPTY_HYPHEN })
          )
        ),
        _react2.default.createElement(
          _omniCommonUi.Button,
          { className: (0, _classnames5.default)(_style2.default.KetExamMarkView_summary_save, (0, _omniCommonUi.testClass)('ket-save-button')),
            disabled: !canSave,
            onClick: this._onSave },
          'Save'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var members = this.props.members;

      var examData = this._getExamData();
      if (!examData || !_immutable.List.isList(members) || members.size === 0) return null;

      var skills = examData.skills.sortBy(function (skill) {
        return skill.orderingSequence;
      });

      return _react2.default.createElement(
        'div',
        { className: _style2.default.KetExamMarkView },
        this._renderStudentSelect(),
        _react2.default.createElement(
          'div',
          { className: _style2.default.KetExamMarkView_panel },
          _react2.default.createElement(
            _omniCommonUi.PageCard,
            null,
            _react2.default.createElement(_omniCommonUi.PageCard.Heading, { text: 'Mark Scores' }),
            _react2.default.createElement(
              _omniCommonUi.PageCard.Content,
              null,
              _react2.default.createElement(
                'div',
                { className: _style2.default.KetExamMarkView_skills },
                skills.map(function (skill) {
                  return _this6._renderSkillColumn(skill);
                })
              ),
              this._renderSummary(skills)
            )
          )
        )
      );
    }
  }]);

  return KetExamMarkView;
}(_react.Component);

KetExamMarkView.propTypes = {
  params: _propTypes2.default.object.isRequired,
  examType: _propTypes2.default.string,
  exam: _propTypes2.default.object,
  currentExamPlan: _propTypes2.default.object,
  members: _propTypes2.default.object,
  buildRoute: _propTypes2.default.func.isRequired,
  submitKetExamResult: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;

  return {
    members: _GroupMembers.actions.getMembersByGroup(state, groupId)
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_KetExams.actions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(KetExamMarkView);

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._19Mrh6rPpz7IIElBqrIZYW{background:#f3f5f7;border-bottom:.07143rem solid #ccc;padding:0}._3THuZaNQ9z68ZGDqqzc8wo{height:10.71429rem;width:10.71429rem}.i9eALSd6sk8gkv_xLlFcr{color:#4a4a4a;font-size:125%;font-weight:600;letter-spacing:.07143rem;margin-bottom:.14286rem;padding:0;text-align:center}.i9eALSd6sk8gkv_xLlFcr._2OZSHH-AqTHpXKKhTpEhT1{color:#de4c4c}._2I-G7LgxhJEOP-B8lfFrvA{padding:1.42857rem}@media only screen and (min-width:640px){._2I-G7LgxhJEOP-B8lfFrvA{padding:2.14286rem}}.lq7jldh-mlBmK9AGfDg80{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.F6GbOg3KtNFW7ZSAWvybJ{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;min-width:12.85714rem;padding:1.14286rem}._9y1seOuvok-cPyB7Sydxq{font-size:110%;font-weight:600;margin-bottom:.85714rem}.y_oLIbFQDyGaBAEANTeMr{margin-bottom:.85714rem}._3kfwBrYKYgrvMGimuSGdEz{color:#a4a4a4;font-size:85%;margin-bottom:.28571rem}._1UkAStc0x_gtPTb6UyaQi5,._3BDr5-6XCu3sUXuO5zOh6Q{border:.07143rem solid #ccc;-webkit-border-radius:.35714rem;-moz-border-radius:.35714rem;border-radius:.35714rem;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;padding:.42857rem .71429rem;width:100%}._3BDr5-6XCu3sUXuO5zOh6Q{background:#f3f5f7;color:#4a4a4a;cursor:default}._3BDr5-6XCu3sUXuO5zOh6Q._2OZSHH-AqTHpXKKhTpEhT1{color:#de4c4c}._3y5wltAM2hJhDlHuQtZ_-k{-webkit-box-align:end;-webkit-align-items:flex-end;-moz-box-align:end;-ms-flex-align:end;align-items:flex-end;border-top:.07143rem solid #ccc;padding:1.14286rem}._3NqgXr6KfILJ6v0Yo7NRst,._3y5wltAM2hJhDlHuQtZ_-k{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._1R_p4xYtW3q18Nqrj-vy0o{margin-right:1.71429rem}._38i2d9QpQA6ZQH2wRmHVUw{color:#a4a4a4;font-size:85%;margin-bottom:.28571rem}._3UCt3ee5EPmDv-lm0tipH3{background:#f3f5f7;border:.07143rem solid #ccc;-webkit-border-radius:.35714rem;-moz-border-radius:.35714rem;border-radius:.35714rem;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;color:#4a4a4a;cursor:default;font-weight:600;min-width:10rem;padding:.42857rem .71429rem}._3UCt3ee5EPmDv-lm0tipH3._2OZSHH-AqTHpXKKhTpEhT1{color:#de4c4c}._2iQsfJtG0gVFtPTaCLcHDy{margin-left:auto}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"KetExamMarkView_studentSelect": "_19Mrh6rPpz7IIElBqrIZYW",
	"KetExamMarkView_studentSelect_option": "_3THuZaNQ9z68ZGDqqzc8wo",
	"KetExamMarkView_studentSelect_score": "i9eALSd6sk8gkv_xLlFcr",
	"__fail": "_2OZSHH-AqTHpXKKhTpEhT1",
	"KetExamMarkView_panel": "_2I-G7LgxhJEOP-B8lfFrvA",
	"KetExamMarkView_skills": "lq7jldh-mlBmK9AGfDg80",
	"KetExamMarkView_skill": "F6GbOg3KtNFW7ZSAWvybJ",
	"KetExamMarkView_skill_name": "_9y1seOuvok-cPyB7Sydxq",
	"KetExamMarkView_skill_field": "y_oLIbFQDyGaBAEANTeMr",
	"KetExamMarkView_skill_field_label": "_3kfwBrYKYgrvMGimuSGdEz",
	"KetExamMarkView_markInput": "_1UkAStc0x_gtPTb6UyaQi5",
	"KetExamMarkView_readonlyInput": "_3BDr5-6XCu3sUXuO5zOh6Q",
	"KetExamMarkView_summary": "_3y5wltAM2hJhDlHuQtZ_-k",
	"KetExamMarkView_summary_fields": "_3NqgXr6KfILJ6v0Yo7NRst",
	"KetExamMarkView_summary_item": "_1R_p4xYtW3q18Nqrj-vy0o",
	"KetExamMarkView_summary_item_label": "_38i2d9QpQA6ZQH2wRmHVUw",
	"KetExamMarkView_summary_item_input": "_3UCt3ee5EPmDv-lm0tipH3",
	"KetExamMarkView_summary_save": "_2iQsfJtG0gVFtPTaCLcHDy"
};

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(837);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INTEGER_PATTERN = /^\d+$/;

var MarkInput = function (_Component) {
  _inherits(MarkInput, _Component);

  function MarkInput(props) {
    _classCallCheck(this, MarkInput);

    var _this = _possibleConstructorReturn(this, (MarkInput.__proto__ || Object.getPrototypeOf(MarkInput)).call(this, props));

    _this._onChange = _this._onChange.bind(_this);
    return _this;
  }

  _createClass(MarkInput, [{
    key: '_onChange',
    value: function _onChange(event) {
      var value = event.target.value;
      var _props = this.props,
          maxMark = _props.maxMark,
          onChange = _props.onChange;

      if (value === '') {
        onChange(value);
        return;
      }
      if (!INTEGER_PATTERN.test(value)) return;
      if (_is_js2.default.number(maxMark) && Number.parseInt(value, 10) > maxMark) return;
      onChange(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var value = this.props.value;

      return _react2.default.createElement('input', { type: 'text',
        className: (0, _classnames2.default)(_style2.default.KetExamMarkView_markInput, (0, _omniCommonUi.testClass)('ket-mark-input')),
        value: value,
        onChange: this._onChange });
    }
  }]);

  return MarkInput;
}(_react.Component);

exports.default = MarkInput;


MarkInput.propTypes = {
  value: _propTypes2.default.string.isRequired,
  maxMark: _propTypes2.default.number,
  onChange: _propTypes2.default.func.isRequired
};

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2063);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _GroupStatus = __webpack_require__(2065);

var _GroupStatus2 = _interopRequireDefault(_GroupStatus);

var _SessionCourseSwitch = __webpack_require__(2066);

var _SessionCourseSwitch2 = _interopRequireDefault(_SessionCourseSwitch);

var _omniCommonUi = __webpack_require__(0);

var _UiState = __webpack_require__(30);

var _ = __webpack_require__(13);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _accessors = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GroupInfoBar = function (_Component) {
  _inherits(GroupInfoBar, _Component);

  function GroupInfoBar(props) {
    _classCallCheck(this, GroupInfoBar);

    var _this = _possibleConstructorReturn(this, (GroupInfoBar.__proto__ || Object.getPrototypeOf(GroupInfoBar)).call(this, props));

    _this._setSessionCourseSwitchMode = _this._setSessionCourseSwitchMode.bind(_this);
    _this._syncGroupInfo = _this._syncGroupInfo.bind(_this);
    _this.state = {
      shouldPopupDialog: false
    };
    return _this;
  }

  _createClass(GroupInfoBar, [{
    key: '_setSessionCourseSwitchMode',
    value: function _setSessionCourseSwitchMode(viewMode) {
      this.props.toggleViewMode(viewMode || (this.props.viewMode !== 'day' ? 'day' : 'course'));
    }
  }, {
    key: '_syncGroupInfo',
    value: function _syncGroupInfo() {
      var _this2 = this;

      var group = this.props.group;
      this.props.syncGroupInfo(group.id).then(function () {
        return _this2._toggleConfirmDialog(true);
      });
    }
  }, {
    key: '_syncGroupConfirmDialog',
    value: function _syncGroupConfirmDialog() {
      var _this3 = this;

      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        { isOpen: this.state.shouldPopupDialog,
          primaryButtonContent: 'Ok',
          onPrimaryClick: function onPrimaryClick() {
            return _this3._toggleConfirmDialog(false);
          } },
        _react2.default.createElement(
          'span',
          null,
          'Get latest information after several seconds.'
        )
      );
    }
  }, {
    key: '_toggleConfirmDialog',
    value: function _toggleConfirmDialog(isDialogShow) {
      this.setState({ shouldPopupDialog: isDialogShow });
    }
  }, {
    key: '_renderGroupExternalLink',
    value: function _renderGroupExternalLink() {
      var group = this.props.group;
      var groupUrl = group.groupExternalUrl;

      return _react2.default.createElement(
        'a',
        { className: _style2.default.GroupInfoBar_info_scheduling, href: groupUrl, target: '_blank' },
        _react2.default.createElement(
          _omniCommonUi.Button,
          null,
          group.isFromOdin ? 'Odin+' : 'Scheduling'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          group = _props.group,
          params = _props.params,
          routes = _props.routes,
          push = _props.push,
          buildRoute = _props.buildRoute,
          viewMode = _props.viewMode,
          isMidtermOrFinalExamExist = _props.isMidtermOrFinalExamExist;


      if (!group) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: _style2.default.GroupInfoBar },
        _react2.default.createElement(
          'div',
          { className: _style2.default.GroupInfoBar_wrap },
          _react2.default.createElement(
            'div',
            { className: _style2.default.GroupInfoBar_wrap_section },
            _react2.default.createElement(
              'div',
              { className: _style2.default.GroupInfoBar_info },
              _react2.default.createElement(
                'span',
                { className: _style2.default.GroupInfoBar_info_summary },
                group.name,
                ' | ',
                group.number
              ),
              this._renderGroupExternalLink(),
              _react2.default.createElement(
                _omniCommonUi.Button,
                { className: _style2.default.GroupInfoBar_info_refresh,
                  onClick: this._syncGroupInfo },
                'Refresh'
              )
            ),
            _react2.default.createElement(_GroupStatus2.default, { status: group.status }),
            _react2.default.createElement('span', { style: { marginRight: '10px' } }),
            isMidtermOrFinalExamExist && _react2.default.createElement(_omniCommonUi.ColourLabel, { text: 'MT/F', colour: '#8e4cc8' })
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.GroupInfoBar_wrap_section },
            _react2.default.createElement(_SessionCourseSwitch2.default, { params: params,
              toggle: this._setSessionCourseSwitchMode,
              viewMode: viewMode,
              routes: routes,
              redirect: push,
              buildRoute: buildRoute })
          )
        ),
        this._syncGroupConfirmDialog()
      );
    }
  }]);

  return GroupInfoBar;
}(_react.Component);

GroupInfoBar.propTypes = {
  group: _propTypes2.default.shape({
    name: _propTypes2.default.string,
    number: _propTypes2.default.string,
    status: _propTypes2.default.string,
    isFromOdin: _propTypes2.default.bool,
    groupExternalUrl: _propTypes2.default.string
  }),
  params: _propTypes2.default.shape({}),
  location: _propTypes2.default.shape({}),
  routes: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  push: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  toggleViewMode: _propTypes2.default.func.isRequired,
  viewMode: _propTypes2.default.string,
  syncGroupInfo: _propTypes2.default.func.isRequired,
  groupId: _propTypes2.default.string,
  isMidtermOrFinalExamExist: _propTypes2.default.bool
};

function mapStateToProps(state, ownProps) {
  var groupId = ownProps.params.groupId;
  var viewMode = _UiState.actions.getViewMode(state);
  var group = state.get('rootReducer').get('groups').get(groupId);
  var isMidtermOrFinalExamExist = (0, _accessors.hasMidtermOrFinalExam)(state, groupId);

  return {
    viewMode: viewMode,
    groupId: groupId,
    group: group && group.data,
    isMidtermOrFinalExamExist: isMidtermOrFinalExamExist
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, (0, _redux.bindActionCreators)(_UiState.actions, dispatch), (0, _redux.bindActionCreators)(_.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(GroupInfoBar);

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2064);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3WICDZBHuxqSAsaCpteEtt{background-color:#f3f5f7}.CLFuAjgx9nBU4rPKWT4eS{padding:1.42857rem;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}@media only screen and (min-width:640px){.CLFuAjgx9nBU4rPKWT4eS{padding:1.42857rem 2.14286rem}}.okNxuYQTwwb5hK2pxE2l0:first-child{-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;overflow:hidden}.okNxuYQTwwb5hK2pxE2l0:last-child{-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0}._1k4cxMfMy_v3DJC1KMBL9C{font-size:1.28571rem;margin-bottom:.5rem;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}._2sX_-xRbSG1ai1g19MFCAX+._2wbfnuqxbe1qqFy2RoGC9e,._2wbfnuqxbe1qqFy2RoGC9e+._1NwZxsPwPf2GtR2xvHJkfW{margin-left:1.28571rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"GroupInfoBar": "_3WICDZBHuxqSAsaCpteEtt",
	"GroupInfoBar_wrap": "CLFuAjgx9nBU4rPKWT4eS",
	"GroupInfoBar_wrap_section": "okNxuYQTwwb5hK2pxE2l0",
	"GroupInfoBar_info": "_1k4cxMfMy_v3DJC1KMBL9C",
	"GroupInfoBar_info_summary": "_2sX_-xRbSG1ai1g19MFCAX",
	"GroupInfoBar_info_scheduling": "_2wbfnuqxbe1qqFy2RoGC9e",
	"GroupInfoBar_info_refresh": "_1NwZxsPwPf2GtR2xvHJkfW"
};

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _status = __webpack_require__(196);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupStatus = function GroupStatus(props) {
  var status = props.status,
      initial = props.initial;

  var colour = (0, _status.isActive)(status) ? '#74d17f' : '#de4c4c';
  return _react2.default.createElement(_omniCommonUi.ColourLabel, { text: status, initial: initial, colour: colour });
};

GroupStatus.propTypes = {
  status: _propTypes2.default.string,
  initial: _propTypes2.default.string
};

exports.default = GroupStatus;

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2067);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames3 = __webpack_require__(7);

var _classnames4 = _interopRequireDefault(_classnames3);

var _reactGa = __webpack_require__(24);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MARKING = "edit";

var ViewSwitch = function ViewSwitch(props) {
  var params = props.params,
      routes = props.routes,
      redirect = props.redirect,
      buildRoute = props.buildRoute,
      toggle = props.toggle,
      viewMode = props.viewMode;

  if (!shouldShow()) {
    return null;
  }

  var currentRoute = routes[routes.length - 1];
  var isMarking = params && params.mode === MARKING;
  var prefix = isMarking ? "../" : "";
  var isCourseView = currentRoute.view === "course" || viewMode === "course";

  if (!props.viewMode) {
    initSessionSwitchMode(currentRoute.view);
  }
  if (!viewMode) return null;

  var onContainerClick = isCourseView ? buildOnClick(prefix + "../day") : buildOnClick(prefix + "../course");

  var sessionClasses = (0, _classnames4.default)(_style2.default.ViewSwitch_item, _style2.default.__session, (0, _omniCommonUi.testClass)("view-switch-session"), _defineProperty({}, _style2.default.__selected, !isCourseView));
  var courseClasses = (0, _classnames4.default)(_style2.default.ViewSwitch_item, _style2.default.__course, (0, _omniCommonUi.testClass)("view-switch-course"), _defineProperty({}, _style2.default.__selected, isCourseView));

  return _react2.default.createElement(
    "div",
    { className: _style2.default.ViewSwitch, onClick: onContainerClick },
    _react2.default.createElement(
      "div",
      { className: sessionClasses },
      _react2.default.createElement(_omniCommonUi.Icon, { id: "toggle-session", className: _style2.default.ViewSwitch_icon })
    ),
    _react2.default.createElement(
      "div",
      { className: courseClasses },
      _react2.default.createElement(_omniCommonUi.Icon, { id: "toggle-course", className: _style2.default.ViewSwitch_icon })
    )
  );

  function buildOnClick(redirectUrl) {
    return function () {
      _reactGa2.default.event({
        category: "Navigation",
        action: "Clicked session/course switch"
      });

      toggle();
      redirect(buildRoute(redirectUrl));
    };
  }

  function shouldShow() {
    var config = new _immutable.List(routes).findLast(function (_ref) {
      var showSessionCourseSwitch = _ref.showSessionCourseSwitch;
      return _is_js2.default.function(showSessionCourseSwitch) || _is_js2.default.boolean(showSessionCourseSwitch);
    });
    if (!config) {
      return false;
    }

    if (_is_js2.default.function(config.showSessionCourseSwitch)) {
      return config.showSessionCourseSwitch(props);
    }

    return config.showSessionCourseSwitch === true;
  }

  function initSessionSwitchMode() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "day";

    props.toggle(mode);
  }
};

ViewSwitch.propTypes = {
  params: _propTypes2.default.shape({ mode: _propTypes2.default.string }),
  routes: _propTypes2.default.arrayOf(_propTypes2.default.shape({ view: _propTypes2.default.string })),
  redirect: _propTypes2.default.func.isRequired,
  buildRoute: _propTypes2.default.func.isRequired,
  toggle: _propTypes2.default.func.isRequired,
  viewMode: _propTypes2.default.string
};

exports.default = ViewSwitch;

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2068);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2StbQ3Vy04VM-R7kwOwYl{border:.07143rem solid #0087e6;-webkit-border-radius:1.25rem;-moz-border-radius:1.25rem;border-radius:1.25rem;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:2.5rem;margin-left:1.42857rem;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:.85714rem;font-weight:600;letter-spacing:.07143rem;text-transform:uppercase}._2StbQ3Vy04VM-R7kwOwYl:hover:not([disabled]){border-color:#026cb6;-webkit-box-shadow:0 .07143rem .14286rem .07143rem #ccc;-moz-box-shadow:0 .07143rem .14286rem .07143rem #ccc;box-shadow:0 .07143rem .14286rem .07143rem #ccc;color:#ccc}._2StbQ3Vy04VM-R7kwOwYl:hover:not([disabled]) ._2WoICQos0bH9IPuW2jAudZ{color:#026cb6}._2StbQ3Vy04VM-R7kwOwYl:hover:not([disabled]) ._2WoICQos0bH9IPuW2jAudZ.DW0WjdRI0grFsTE7bzsy3{background-color:#026cb6;color:#fff}._2WoICQos0bH9IPuW2jAudZ{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-border-radius:1.25rem;-moz-border-radius:1.25rem;border-radius:1.25rem;color:#0087e6;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-size:1.07143rem;height:100%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;width:2.5rem}._2WoICQos0bH9IPuW2jAudZ.DW0WjdRI0grFsTE7bzsy3{background-color:#0087e6;color:#fff}@media only screen and (min-width:480px){._2SQpJLPHbHMWz0M5cqKIYx{display:none}._2WoICQos0bH9IPuW2jAudZ{font-size:inherit;padding:.71429rem;text-transform:uppercase;width:auto}._2WoICQos0bH9IPuW2jAudZ._15vmaCsFJqC1uq5DdQ8So-:after{color:inherit;content:\"Session\"}._2WoICQos0bH9IPuW2jAudZ._2BWVU8Fg8xMuPCHHmgNC74:after{color:inherit;content:\"Course\"}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ViewSwitch": "_2StbQ3Vy04VM-R7kwOwYl",
	"ViewSwitch_item": "_2WoICQos0bH9IPuW2jAudZ",
	"__selected": "DW0WjdRI0grFsTE7bzsy3",
	"ViewSwitch_icon": "_2SQpJLPHbHMWz0M5cqKIYx",
	"__session": "_15vmaCsFJqC1uq5DdQ8So-",
	"__course": "_2BWVU8Fg8xMuPCHHmgNC74"
};

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = groups;

var _actions = __webpack_require__(158);

var _actions2 = __webpack_require__(159);

var _actions3 = __webpack_require__(292);

var _reducer = __webpack_require__(593);

var _reducer2 = __webpack_require__(639);

var _omniCommonUi = __webpack_require__(0);

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(838);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function groups() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_GROUP_REQUEST:
      return state.set(action.id, _omniCommonUi.ApiResponseHelper.create({ loading: true }));
    case _actions.FETCH_GROUP_SUCCESS:
      return onSuccess(state, action, action.payload);
    case _actions.FETCH_GROUP_FAILURE:
      return state.set(action.id, _omniCommonUi.ApiResponseHelper.create(new Error(action.error)));
    case _actions2.FETCH_SESSION_PLANS_REQUEST:
    case _actions2.FETCH_SESSION_PLANS_SUCCESS:
    case _actions2.FETCH_SESSION_PLANS_FAILURE:
      return state.update(action.groupId, function (group) {
        return group.update('data', function (data) {
          return data.update('sessionPlans', function (sessionPlans) {
            return (0, _reducer.updateGroupSessionPlansAttribute)(sessionPlans, action);
          });
        });
      });
    case _actions3.FETCH_PROGRESS_REPORTS_REQUEST:
    case _actions3.FETCH_PROGRESS_REPORTS_SUCCESS:
    case _actions3.FETCH_PROGRESS_REPORTS_FAILURE:
      return state.update(action.groupId, function (group) {
        return group.update('data', function (data) {
          return data.update('progressReports', function (progressReports) {
            return (0, _reducer2.updateGroupProgressReportsAttribute)(progressReports, action);
          });
        });
      });
    default:
      return state;
  }
}

function onSuccess(state, action, apiGroup) {
  var newGroup = _model2.default.create(Object.assign({}, apiGroup, {
    closedTime: apiGroup.closedDatetime,
    currentSessionId: apiGroup.currentSessionPlanId,
    // stringify ids
    id: '' + apiGroup.id,
    centreId: '' + apiGroup.centreId
  }));

  return state.set(action.id, _omniCommonUi.ApiResponseHelper.create(newGroup));
}

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(2071);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupSummary = _model2.default;

exports.default = GroupSummary;

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _SessionSchedule = __webpack_require__(839);

var _SessionSchedule2 = _interopRequireDefault(_SessionSchedule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GroupSummaryRecord = _immutable2.default.Record({
  id: undefined,
  name: undefined,
  courseTypeName: undefined,
  code: undefined,
  status: undefined,
  mainTeacherName: undefined,
  coTeacherName: undefined,
  pa: undefined,
  teacherAssistant: undefined,
  sessionSchedules: new _immutable.List()
});

var GroupSummary = function (_GroupSummaryRecord) {
  _inherits(GroupSummary, _GroupSummaryRecord);

  function GroupSummary() {
    _classCallCheck(this, GroupSummary);

    return _possibleConstructorReturn(this, (GroupSummary.__proto__ || Object.getPrototypeOf(GroupSummary)).apply(this, arguments));
  }

  return GroupSummary;
}(GroupSummaryRecord);

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      seq = _ref2[1];

  if (!seq) return [key, seq];
  switch (key) {
    case 'sessionSchedules':
      return [key, new _immutable.List(seq.map(_SessionSchedule2.default.create))];
    default:
      return [key, _immutable2.default.fromJS(seq)];
  }
};

GroupSummary.create = function (data) {
  return new GroupSummary(data).mapEntries(reviver);
};

exports.default = GroupSummary;

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SessionScheduleRecord = (0, _immutable.Record)({
  id: undefined,
  period: undefined
});

var SessionSchedule = function (_SessionScheduleRecor) {
  _inherits(SessionSchedule, _SessionScheduleRecor);

  function SessionSchedule() {
    _classCallCheck(this, SessionSchedule);

    return _possibleConstructorReturn(this, (SessionSchedule.__proto__ || Object.getPrototypeOf(SessionSchedule)).apply(this, arguments));
  }

  return SessionSchedule;
}(SessionScheduleRecord);

exports.default = SessionSchedule;

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = undefined;

var _ = __webpack_require__(839);

var _2 = _interopRequireDefault(_);

var _Interval = __webpack_require__(81);

var _Interval2 = _interopRequireDefault(_Interval);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var create = exports.create = function create(data) {
  return new _2.default(data).update('period', function (duration) {
    return updateValue(duration);
  });
};

exports.default = create;


function updateValue(value) {
  if (_is_js2.default.undefined(value)) {
    return undefined;
  }

  return _Interval2.default.create(value);
}

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = exports.UserDashboard = undefined;

var _component = __webpack_require__(840);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(2075);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserDashboard = exports.UserDashboard = _component2.default;
var routes = exports.routes = _routes3.default;

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(840);

var _component2 = _interopRequireDefault(_component);

var _MyTasks = __webpack_require__(841);

var _MyTasks2 = _interopRequireDefault(_MyTasks);

var _TeacherTasks = __webpack_require__(2089);

var _AcademicInfo = __webpack_require__(2093);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  component: _component2.default,
  indexRoute: {
    component: _MyTasks2.default
  },
  tab: {
    label: 'My Tasks',
    order: 0
  },
  childRoutes: [_TeacherTasks.routes, _AcademicInfo.routes]
};

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyTasks = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _TaskProgressCard = __webpack_require__(842);

var _TaskProgressCard2 = _interopRequireDefault(_TaskProgressCard);

var _redux = __webpack_require__(10);

var _Tasks = __webpack_require__(339);

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _TableView = __webpack_require__(59);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TaskFilter = __webpack_require__(846);

var _TaskFilter2 = _interopRequireDefault(_TaskFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MyTasks = exports.MyTasks = function (_Component) {
  _inherits(MyTasks, _Component);

  function MyTasks(props) {
    _classCallCheck(this, MyTasks);

    var _this = _possibleConstructorReturn(this, (MyTasks.__proto__ || Object.getPrototypeOf(MyTasks)).call(this, props));

    _this.state = {
      filterParams: {
        pageSize: _this.props.location.query.pageSize || 10,
        pageNumber: _this.props.location.query.pageNumber || 1,
        sortBy: _this.props.location.query.sortBy || 'generatedTime',
        sortType: _this.props.location.query.sortType || 'Descending'
      },
      taskFilter: false,
      shouldPopupDialog: false
    };
    return _this;
  }

  _createClass(MyTasks, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._fetchTasks();
      this._fetchTaskStatistics();
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(newProps, newState) {
      if (newState.filterParams === this.state.filterParams) {
        return;
      }

      this._fetchTasks(newState.filterParams);
      this._fetchTaskStatistics();
    }
  }, {
    key: '_onCancelTaskButtonClick',
    value: function _onCancelTaskButtonClick(taskId) {
      this._toggleConfirmDialog(true, taskId);
    }
  }, {
    key: '_toggleConfirmDialog',
    value: function _toggleConfirmDialog(isDialogShow, taskId) {
      this.setState({
        shouldPopupDialog: isDialogShow,
        currentTaskId: '' + taskId
      });
    }
  }, {
    key: '_onDiscardClicked',
    value: function _onDiscardClicked() {
      this._toggleConfirmDialog(false);
    }
  }, {
    key: '_onSaveButtonClicked',
    value: function _onSaveButtonClicked() {
      var _this2 = this;

      var currentTaskId = this.state.currentTaskId;
      if (currentTaskId) {
        this.props.cancelTask(currentTaskId).then(function () {
          return _this2._toggleConfirmDialog(false);
        }).then(function () {
          return _this2._fetchTasks(_this2.state.filterParams);
        });
      }
    }
  }, {
    key: '_renderConfirmDialog',
    value: function _renderConfirmDialog() {
      var _this3 = this;

      return _react2.default.createElement(
        _omniCommonUi.ConfirmDialog,
        {
          isOpen: this.state.shouldPopupDialog,
          primaryButtonContent: 'Yes',
          secondaryButtonContent: 'No',
          onPrimaryClick: function onPrimaryClick() {
            return _this3._onSaveButtonClicked();
          },
          onSecondaryClick: function onSecondaryClick() {
            return _this3._onDiscardClicked();
          },
          onRequestClose: function onRequestClose() {
            return _this3._onDiscardClicked();
          }
        },
        _react2.default.createElement(
          'span',
          null,
          'This task will be deleted from task owner\'s task list.'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'span',
          null,
          'Are you sure you want to cancel this task.'
        )
      );
    }
  }, {
    key: '_renderStatisticCard',
    value: function _renderStatisticCard() {
      var taskCounts = this.props.taskStatisticResult.taskStatistics || [];
      var sinceTime = this.props.taskStatisticResult.statisticFromDateTime || '';
      return _react2.default.createElement(_TaskProgressCard2.default, {
        cardTitle: 'My Tasks Completion',
        className: (0, _omniCommonUi.testClass)('my-tasks-completion'),
        tasksCounts: taskCounts,
        sinceTime: sinceTime
      });
    }
  }, {
    key: '_handleOnFilterChange',
    value: function _handleOnFilterChange(filterParams) {
      this.setState({ filterParams: filterParams });
    }
  }, {
    key: '_fetchTasks',
    value: function _fetchTasks() {
      var filterParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.filterParams;
      var taskFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.taskFilter;

      var filter = _extends({}, filterParams, { taskFilter: taskFilter });
      this.props.fetchTasks(filter);
    }
  }, {
    key: '_fetchTaskStatistics',
    value: function _fetchTaskStatistics() {
      var taskFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.taskFilter;

      this.props.fetchTaskStatistics('my-tasks', taskFilter);
    }
  }, {
    key: '_handleOnTaskFilterChange',
    value: function _handleOnTaskFilterChange(taskFilter) {
      this.setState({ taskFilter: taskFilter });
      this._fetchTasks(this.state.filterParams, taskFilter);
      this._fetchTaskStatistics(taskFilter);
    }
  }, {
    key: '_renderTableRow',
    value: function _renderTableRow(row) {
      var _this4 = this;

      var hasCancelTaskPrivilege = this.props.hasCancelTaskPrivilege;


      return _react2.default.createElement(
        _TableView.TableViewTr,
        null,
        _react2.default.createElement(_TableView.TextTd, { text: _Tasks.accessors.getTaskSubject(row.subject) }),
        _react2.default.createElement(_TableView.StatusTd, { text: row.statusName }),
        _react2.default.createElement(_TableView.TextTd, { text: row.itemsAffected }),
        _react2.default.createElement(_TableView.TextTd, { text: row.details }),
        _react2.default.createElement(_TableView.TextTd, { text: row.dueDate }),
        hasCancelTaskPrivilege && _react2.default.createElement(_TableView.ButtonTd, {
          text: 'Cancel',
          onButtonClick: function onButtonClick() {
            return _this4._onCancelTaskButtonClick(row.id);
          }
        }),
        _react2.default.createElement(_TableView.DetailLinkTd, { url: row.redirectUrl })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          taskFitlerResult = _props.taskFitlerResult,
          hasCancelTaskPrivilege = _props.hasCancelTaskPrivilege;


      if (!_omniCommonUi.ApiResponseHelper.hasSucceeded(taskFitlerResult)) {
        return null;
      }

      var data = taskFitlerResult.data;

      var headers = [{ key: 'subject', text: 'Subject', sortable: true }, { key: 'statusName', text: 'Status', sortable: true }, { key: 'itemsAffected', text: 'Items Affected', sortable: true }, { key: 'description', text: 'Details', sortable: true }, { key: 'dueDateTimeUtc', text: 'Due Date', sortable: true }, { key: 'link', text: '', sortable: false }];
      hasCancelTaskPrivilege && headers.splice(-1, 0, { key: 'CancelButton', text: '', sortable: false });

      return _react2.default.createElement(
        _omniCommonUi.Grid,
        { outerMargin: true },
        _react2.default.createElement(
          _omniCommonUi.Grid.Group,
          null,
          _react2.default.createElement(
            _omniCommonUi.Grid.Item,
            null,
            _react2.default.createElement(_TaskFilter2.default, {
              value: this.state.taskFilter,
              handleFilterChange: function handleFilterChange(val) {
                return _this5._handleOnTaskFilterChange(val);
              }
            })
          ),
          _react2.default.createElement(
            _omniCommonUi.Grid.Item,
            null,
            this._renderStatisticCard()
          ),
          _react2.default.createElement(
            _omniCommonUi.Grid.Item,
            null,
            _react2.default.createElement(_TableView.TableView, {
              tableTitle: 'My Tasks',
              className: (0, _omniCommonUi.testClass)('my-tasks'),
              noResultsString: 'You have no tasks.',
              totalRecords: data.totalRecords,
              source: data.tasks,
              headers: headers,
              pageable: true,
              query: this.state.filterParams,
              renderTableRow: function renderTableRow(row) {
                return _this5._renderTableRow(row);
              },
              onFilterChange: function onFilterChange(query) {
                return _this5._handleOnFilterChange(query);
              }
            })
          ),
          this._renderConfirmDialog()
        )
      );
    }
  }]);

  return MyTasks;
}(_react.Component);

MyTasks.propTypes = {
  taskFitlerResult: _propTypes2.default.object,
  router: _propTypes2.default.object,
  location: _propTypes2.default.object,
  fetchTasks: _propTypes2.default.func,
  taskStatisticResult: _propTypes2.default.object,
  fetchTaskStatistics: _propTypes2.default.func,
  hasCancelTaskPrivilege: _propTypes2.default.bool,
  cancelTask: _propTypes2.default.func
};

function mapStateToProps(state) {
  var taskFitlerResult = state.get('rootReducer').get('taskFitlerResult');
  var taskStatisticResult = state.get('rootReducer').get('taskStatisticResult');
  return {
    taskFitlerResult: taskFitlerResult,
    taskStatisticResult: taskStatisticResult,
    hasCancelTaskPrivilege: _omniCommonUi.PrivilegeChecker.hasPrivilege(state, _Privileges2.default.GroupTask.CancelGroupTask)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, (0, _redux.bindActionCreators)(_Tasks.actions, dispatch), (0, _redux.bindActionCreators)(_Tasks.taskStatisticActions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(MyTasks);

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2078);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2mEoGyJZAX7YwaIYflc1Kr{width:100%}._3SkIW2hCpC7c_80UZ-6qEp{overflow:hidden}._3CcKB7uHoW4-Mg03MAWIBt{float:right;font-size:1.28571rem;font-weight:400;letter-spacing:normal;margin:.21429rem 0;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}._2uXrs-lLW1vVM5UZjFG-3X{display:none;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%}@media only screen and (min-width:640px){._2uXrs-lLW1vVM5UZjFG-3X._24hj4V2I7gzygB027oKaV2{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}}@media only screen and (min-width:480px){._2uXrs-lLW1vVM5UZjFG-3X.LJBjvtQZfbEO1L3JEt2SE{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}}@media only screen and (min-width:640px){._2uXrs-lLW1vVM5UZjFG-3X.LJBjvtQZfbEO1L3JEt2SE{display:none}}._2uXrs-lLW1vVM5UZjFG-3X._3kXOWIBZlvYhOC6f_FgHC3{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}@media only screen and (min-width:480px){._2uXrs-lLW1vVM5UZjFG-3X._3kXOWIBZlvYhOC6f_FgHC3{display:none}}._1m4FFddz1rmjiljvpb1srz{text-align:center}._3icrLNC6C3SA8otY0Qg6C8{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;overflow:hidden;padding-left:0;padding-right:0}._3icrLNC6C3SA8otY0Qg6C8:after,._3icrLNC6C3SA8otY0Qg6C8:before{content:\"\";-webkit-flex-shrink:1;-ms-flex-negative:1;flex-shrink:1;width:1.42857rem}@media only screen and (min-width:480px){._3icrLNC6C3SA8otY0Qg6C8:after,._3icrLNC6C3SA8otY0Qg6C8:before{width:2.14286rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"TaskProgressCard": "_2mEoGyJZAX7YwaIYflc1Kr",
	"TaskProgressCard_title": "_3SkIW2hCpC7c_80UZ-6qEp",
	"TaskProgressCard_title_time": "_3CcKB7uHoW4-Mg03MAWIBt",
	"TaskProgressCard_radialContainer": "_2uXrs-lLW1vVM5UZjFG-3X",
	"__md": "_24hj4V2I7gzygB027oKaV2",
	"__sm": "LJBjvtQZfbEO1L3JEt2SE",
	"__xs": "_3kXOWIBZlvYhOC6f_FgHC3",
	"TaskProgressCard_svgContainer": "_1m4FFddz1rmjiljvpb1srz",
	"TaskProgressCard_pageCardContent": "_3icrLNC6C3SA8otY0Qg6C8"
};

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = taskFitlerResult;
exports.dosTaskFilterResult = dosTaskFilterResult;
exports.taskOwnersResult = taskOwnersResult;
exports.taskCentres = taskCentres;
exports.taskTypes = taskTypes;

var _actions = __webpack_require__(843);

var _TaskCentre = __webpack_require__(2080);

var _TaskCentre2 = _interopRequireDefault(_TaskCentre);

var _TaskType = __webpack_require__(2082);

var _TaskType2 = _interopRequireDefault(_TaskType);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _lodash = __webpack_require__(570);

var _lodash2 = _interopRequireDefault(_lodash);

var _CourseType = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function taskFitlerResult() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_TASKS_SUCCESS:
      return onSuccess(action);
    case _actions.FETCH_TASKS_FAILURE:
      return _omniCommonUi.ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}

function dosTaskFilterResult() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_DOS_TASKS_SUCCESS:
      return onSuccess(action);
    case _actions.FETCH_DOS_TASKS_FAILURE:
      return _omniCommonUi.ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}

function taskOwnersResult() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_TASK_OWNERS_SUCCESS:
      return onTaskOwnerSuccess(action);
    case _actions.FETCH_TASK_OWNERS_FAILURE:
      return _omniCommonUi.ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}

function taskCentres() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.List();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_TASK_CENTRES_SUCCESS:
      return new _immutable.List(action.payload.map(function (taskCentre) {
        return new _TaskCentre2.default(taskCentre);
      }));
    default:
      return state;
  }
}

function taskTypes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.List();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_TASK_TYPES_SUCCESS:
      return new _immutable.List(action.payload.map(function (taskType) {
        return new _TaskType2.default(taskType);
      }));
    default:
      return state;
  }
}

function onSuccess(action) {
  var tasks = [];
  action.payload.tasks.map(function (task) {
    var timeZone = task.timeZone;
    var dueDateUtc = _omniCommonUi.moment.utc(task.dueDate);
    var dueDate = timeZone ? dueDateUtc.clone().tz(timeZone) : dueDateUtc.clone().local();
    var now = timeZone ? (0, _omniCommonUi.moment)().tz(timeZone) : (0, _omniCommonUi.moment)().local();
    var displayDueDate = dueDate.format('YYYY-MM-DD');
    if (dueDate - now.endOf('day') >= 0 && now.endOf('day').add(1, 'day') - dueDate >= 0) {
      displayDueDate = 'Tomorrow';
    } else if (dueDate - now.startOf('day') >= 0 && now.endOf('day') - dueDate >= 0) {
      displayDueDate = 'Today';
    }
    var redirectUrl = '';
    var owner = '';

    if (task.firstName && task.lastName) {
      owner = task.firstName + ' ' + task.lastName;
    } else if (task.firstName) {
      owner = task.firstName;
    } else if (task.lastName) {
      owner = task.lastName;
    }

    /*
      MarkAttendance            MA
      CoverInClass              CIC
      ProgressTest              PT
      UnitReport                UR
      UnitReportApproval        URA
      ProgressReport            PR
      LevelReportApproval       LRA
      AssignHomework            AH
      MarkPaperBaseHomework     MPBH
    */

    var actionLinks = sanitiseActionLinks(task.actionLinks ? JSON.parse(task.actionLinks) : {});
    if (task.taskTypeCode === 'MA') {
      redirectUrl = '/group/' + actionLinks.groupId + '/attendance/session/' + actionLinks.sessionId;
    } else if (task.taskTypeCode === 'CIC') {
      redirectUrl = '/group/' + actionLinks.groupId + '/session/' + actionLinks.sessionId + '/covered-in-class';
    } else if (task.taskTypeCode === 'PT' || task.taskTypeCode === 'PTWS') {
      redirectUrl = '/group/' + actionLinks.groupId + '/progress-test/' + [actionLinks.progressTestIndex - 1] + '/course';
    } else if (actionLinks.progressTestType === 'MIDTERM_FINAL') {
      var examBasePath = (0, _CourseType.getExamBasePath)(task);
      redirectUrl = '/group/' + actionLinks.groupId + '/' + examBasePath + '/' + [actionLinks.progressTestIndex - 1] + '/course';
    } else if (task.taskTypeCode === 'UR') {
      var unitReportPath = (0, _CourseType.getUnitReportBasePath)(task);
      redirectUrl = '/group/' + actionLinks.groupId + '/' + unitReportPath + '/' + actionLinks.unitReportId;
    } else if (task.taskTypeCode === 'URA') {
      var _unitReportPath = (0, _CourseType.getUnitReportBasePath)(task);
      redirectUrl = '/group/' + actionLinks.groupId + '/' + _unitReportPath + '/' + actionLinks.unitReportId + '/dos-approval';
    } else if (task.taskTypeCode === 'PR') {
      var progressReportPath = (0, _CourseType.getProgressReportBasePath)(task);
      redirectUrl = '/group/' + actionLinks.groupId + '/' + progressReportPath + '/' + actionLinks.groupCompulsoryIdpId;
    } else if (task.taskTypeCode === 'LRA') {
      var _progressReportPath = (0, _CourseType.getProgressReportBasePath)(task);
      redirectUrl = '/group/' + actionLinks.groupId + '/' + _progressReportPath + '/' + actionLinks.groupCompulsoryIdpId + '/dos-approval';
    } else if (task.taskTypeCode === 'AH') {
      redirectUrl = '/group/' + actionLinks.groupId + '/assign-homework/session/' + actionLinks.sessionId;
    } else if (task.taskTypeCode === 'MPBH') {
      redirectUrl = '/group/' + actionLinks.groupId + '/homework/session/' + actionLinks.sessionId + '/paper-based/day';
    }

    var newTask = Object.assign({}, task, { dueDate: displayDueDate, redirectUrl: redirectUrl, owner: owner, actionLinks: actionLinks });

    tasks.push(newTask);
    return true;
  });
  return _omniCommonUi.ApiResponseHelper.create(Object.assign({}, action.payload, { tasks: tasks }));
}

function onTaskOwnerSuccess(action) {
  var taskOwners = [];
  action.payload.map(function (owner) {
    taskOwners.push({
      name: owner.firstName + ' ' + owner.lastName,
      id: owner.id
    });
    return false;
  });

  return { data: taskOwners };
}

function sanitiseActionLinks(actionLinks) {
  return Object.getOwnPropertyNames(actionLinks).reduce(function (newActionLinks, prop) {
    return Object.assign(newActionLinks, _defineProperty({}, (0, _lodash2.default)(prop), actionLinks[prop]));
  }, {});
}

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(2081);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskCentreRecord = _immutable2.default.Record({
  id: undefined,
  name: undefined
});

var TaskCentre = function (_TaskCentreRecord) {
  _inherits(TaskCentre, _TaskCentreRecord);

  function TaskCentre() {
    _classCallCheck(this, TaskCentre);

    return _possibleConstructorReturn(this, (TaskCentre.__proto__ || Object.getPrototypeOf(TaskCentre)).apply(this, arguments));
  }

  return TaskCentre;
}(TaskCentreRecord);

exports.default = TaskCentre;

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(2083);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskTypeRecord = _immutable2.default.Record({
  code: undefined,
  name: undefined,
  isValid: undefined,
  description: undefined
});

var TaskType = function (_TaskTypeRecord) {
  _inherits(TaskType, _TaskTypeRecord);

  function TaskType() {
    _classCallCheck(this, TaskType);

    return _possibleConstructorReturn(this, (TaskType.__proto__ || Object.getPrototypeOf(TaskType)).apply(this, arguments));
  }

  return TaskType;
}(TaskTypeRecord);

exports.default = TaskType;

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTaskSubject = getTaskSubject;
exports.getTaskLink = getTaskLink;
function getTaskSubject(subject) {
  if (subject === 'Assign Practice') {
    return 'At Home Review';
  }

  return subject;
}

function getTaskLink(taskType, params) {
  console.log(taskType);
  console.log(params);
}

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = exports.reducer = undefined;

var _reducer2 = __webpack_require__(2086);

var _reducer3 = _interopRequireDefault(_reducer2);

var _model = __webpack_require__(845);

var _model2 = _interopRequireDefault(_model);

var _actions2 = __webpack_require__(844);

var _actions = _interopRequireWildcard(_actions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _model2.default;
var reducer = exports.reducer = _reducer3.default;
var actions = exports.actions = _actions;

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = taskStatisticResult;

var _actions = __webpack_require__(844);

var _immutable = __webpack_require__(3);

var _omniCommonUi = __webpack_require__(0);

var _model = __webpack_require__(845);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function taskStatisticResult() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map({});
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_TASK_STATISTIC_SUCCESS:
      return onSuccess(action);
    case _actions.FETCH_TASK_STATISTIC_FAILURE:
      return _omniCommonUi.ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}

function onSuccess(action) {
  var taskStatistics = [];
  var result = {
    CO: {
      status: 'Completed',
      percentage: 0,
      count: 0
    },
    PE: {
      status: 'Pending',
      percentage: 0,
      count: 0
    },
    OD: {
      status: 'Overdue',
      percentage: 0,
      count: 0
    },
    EX: {
      status: 'Expired',
      percentage: 0,
      count: 0
    }
  };

  var statisticFromDateTime = action.payload.statisticFromDateTime ? (0, _omniCommonUi.moment)(action.payload.statisticFromDateTime).format('YYYY-MM-DD') : '';

  if (action.payload.taskStatistics) {
    action.payload.taskStatistics.map(function (statistic) {
      taskStatistics.push(_model2.default.create(statistic));
      return false;
    });
  }

  var totalCount = taskStatistics.length === 0 ? 0 : taskStatistics.reduce(function (before, next) {
    var newCount = before.taskCount + next.taskCount;
    return Object.assign({}, next, { taskCount: newCount });
  }).taskCount;

  if (totalCount > 0) {
    taskStatistics.map(function (taskStatistic) {
      result[taskStatistic.taskStatusCode].percentage = taskStatistic.taskCount / totalCount * 100;
      result[taskStatistic.taskStatusCode].count = taskStatistic.taskCount;

      return false;
    });
  }
  return { taskStatistics: Object.values(result), statisticFromDateTime: statisticFromDateTime };
}

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2088);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1dPnOmcN3P4-J0LJRcD2sO{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;width:100%}._15oQAa4nRfUvID1FuJffCH{min-width:11.42857rem}._13DIqebgOCNPq4LhfLxciY{font-weight:600}._1dPnOmcN3P4-J0LJRcD2sO label{font-weight:600;margin-left:1.07143rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Filter": "_1dPnOmcN3P4-J0LJRcD2sO",
	"Filter_select": "_15oQAa4nRfUvID1FuJffCH",
	"Filter_label": "_13DIqebgOCNPq4LhfLxciY"
};

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(847);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(2092);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _component2.default;
var routes = exports.routes = _routes3.default;

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2091);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3uJ-H2kZQiNliBrVCZ9rJO+._3uJ-H2kZQiNliBrVCZ9rJO{margin-left:1.42857rem}._1uEiM8v56w_pQfZSVY4lIx{height:5.78571rem;max-width:50rem;width:100%}._1uEiM8v56w_pQfZSVY4lIx form{display:none;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}@media only screen and (min-width:480px){._1uEiM8v56w_pQfZSVY4lIx form{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}}._1ljQZyZK25cdVtVyjrcG7O{width:32%}._2zPuxHPYeF9s3dCbHjrGKm{font-weight:600;padding-bottom:.35714rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"TeacherTasks_inputSelect": "_3uJ-H2kZQiNliBrVCZ9rJO",
	"TeacherTasks_filters": "_1uEiM8v56w_pQfZSVY4lIx",
	"TeacherTasks_filters_field": "_1ljQZyZK25cdVtVyjrcG7O",
	"TeacherTasks_filters_field_label": "_2zPuxHPYeF9s3dCbHjrGKm"
};

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omniCommonUi = __webpack_require__(0);

var _Privileges = __webpack_require__(12);

var _Privileges2 = _interopRequireDefault(_Privileges);

var _component = __webpack_require__(847);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var getState = _ref.getState;
  return {
    path: '/staff-tasks',
    component: _component2.default,
    tab: {
      label: 'Staff Tasks',
      order: 1,
      isVisible: function isVisible() {
        return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.GroupDashboard.ViewStaffTasksInformation);
      }
    },
    canAccess: function canAccess() {
      return _omniCommonUi.PrivilegeChecker.hasPrivilege(getState(), _Privileges2.default.GroupDashboard.ViewStaffTasksInformation);
    }
  };
};

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(848);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(340);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _component2.default;
var routes = exports.routes = _routes3.default;

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _component = __webpack_require__(849);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(2114);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _component2.default;
var routes = exports.routes = _routes3.default;

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2096);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".jUH3QAM1M-ACTrqCCdIE_{padding:0}._3svjE24-JT3QqlGhxXY1AV{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-size:1.07143rem}._3svjE24-JT3QqlGhxXY1AV._7LGCoj9HhTNJR5bzqIaXC{color:#a4a4a4}._3svjE24-JT3QqlGhxXY1AV,.QUmwBOH0l49Ri3fKgpl1h{padding:.71429rem 1.42857rem}@media only screen and (min-width:640px){._3svjE24-JT3QqlGhxXY1AV,.QUmwBOH0l49Ri3fKgpl1h{padding:.71429rem 2.14286rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"AcademicInfoGroups_cardContent": "jUH3QAM1M-ACTrqCCdIE_",
	"AcademicInfoGroups_cardContent_info": "_3svjE24-JT3QqlGhxXY1AV",
	"__empty": "_7LGCoj9HhTNJR5bzqIaXC",
	"AcademicInfoGroups_cardContent_badge": "QUmwBOH0l49Ri3fKgpl1h"
};

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = academicInfoGroups;
exports.academicInfoConcernsStudentSkills = academicInfoConcernsStudentSkills;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(850);

var _AcademicInfoGroup = __webpack_require__(2098);

var _AcademicInfoGroup2 = _interopRequireDefault(_AcademicInfoGroup);

var _ConcernsStudentSkill = __webpack_require__(2100);

var _ConcernsStudentSkill2 = _interopRequireDefault(_ConcernsStudentSkill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function academicInfoGroups() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.List();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_ACADEMIC_INFO_GROUP_LIST_SUCCESS:
      return onAcademicInfoGroupListSuccess(state, action);
    default:
      return state;
  }

  function onAcademicInfoGroupListSuccess() {
    var newGroupList = new _immutable.List(action.payload.map(function (academicInfoGroup) {
      return _AcademicInfoGroup2.default.create(Object.assign(academicInfoGroup, { isTodayGroup: !action.isAllGroups }));
    }));

    if (state.size === 0) return newGroupList;

    var allGroups = void 0;
    var todayGroups = void 0;
    if (action.isAllGroups) {
      allGroups = newGroupList;
      todayGroups = state;
    } else {
      allGroups = state;
      todayGroups = newGroupList;
    }
    return allGroups.map(function (group) {
      var matchedGroup = todayGroups.find(function (todayGroup) {
        return todayGroup.id === group.id;
      });
      return matchedGroup || group;
    });
  }
}

function academicInfoConcernsStudentSkills() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.List();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_SUCCESS:
      return new _immutable.List(action.payload.map(function (studentSkill) {
        return _ConcernsStudentSkill2.default.create(studentSkill);
      }));
    default:
      return state;
  }
}

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(851);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(2099);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(851);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'id':
      return [key, '' + val]; // stringify
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(852);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(2101);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _model = __webpack_require__(852);

var _model2 = _interopRequireDefault(_model);

var _StudentGeneralInfo = __webpack_require__(2102);

var _StudentGeneralInfo2 = _interopRequireDefault(_StudentGeneralInfo);

var _SkillScore = __webpack_require__(2104);

var _SkillScore2 = _interopRequireDefault(_SkillScore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'groupId':
    case 'groupCode':
      return [key, '' + val]; // stringify
    case 'studentGeneralInfo':
      return [key, _StudentGeneralInfo2.default.create(val)];
    case 'skillScores':
      return [key, new _immutable.List(val.map(function (skillScore) {
        return _SkillScore2.default.create(skillScore);
      }))];
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(853);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(2103);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(853);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'id':
    case 'studentNumber':
      return [key, '' + val]; // stringify
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _model = __webpack_require__(854);

var _model2 = _interopRequireDefault(_model);

var _create = __webpack_require__(2105);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_model2.default.create = _create2.default;

exports.default = _model2.default;

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _model = __webpack_require__(854);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'skillId':
      return [key, '' + val]; // stringify
    default:
      return [key, val];
  }
};

var create = function create(data) {
  return new _model2.default(data).mapEntries(reviver);
};

exports.default = create;

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = academicInfoSummary;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(856);

var _model = __webpack_require__(2107);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function academicInfoSummary() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  switch (action.type) {
    case _actions.FETCH_ACADEMIC_INFO_SUMMARY_SUCCESS:
      {
        var model = new _model2.default(action.payload);
        return state.set('' + model.groupId, model);
      }
    default:
      return state;
  }
}

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AcademicInfoSummaryRecord = _immutable2.default.Record({
  groupId: undefined,
  studentNumberWithLowerPTScore: undefined,
  studentNumberWithLowerSkillScore: undefined,
  progressTestAverageScore: undefined
});

var AcademicInfoSummary = function (_AcademicInfoSummaryR) {
  _inherits(AcademicInfoSummary, _AcademicInfoSummaryR);

  function AcademicInfoSummary() {
    _classCallCheck(this, AcademicInfoSummary);

    return _possibleConstructorReturn(this, (AcademicInfoSummary.__proto__ || Object.getPrototypeOf(AcademicInfoSummary)).apply(this, arguments));
  }

  return AcademicInfoSummary;
}(AcademicInfoSummaryRecord);

exports.default = AcademicInfoSummary;

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2109);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _type = __webpack_require__(857);

var _type2 = _interopRequireDefault(_type);

var _AcademicOverviewBadge = __webpack_require__(2111);

var _AcademicOverviewBadge2 = _interopRequireDefault(_AcademicOverviewBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverviewBadge = function (_PureComponent) {
  _inherits(OverviewBadge, _PureComponent);

  function OverviewBadge() {
    _classCallCheck(this, OverviewBadge);

    return _possibleConstructorReturn(this, (OverviewBadge.__proto__ || Object.getPrototypeOf(OverviewBadge)).apply(this, arguments));
  }

  _createClass(OverviewBadge, [{
    key: '_renderAcademicOverviewBadge',
    value: function _renderAcademicOverviewBadge(category, num) {
      if (_is_js2.default.existy(num) && num !== 0) {
        var categoryText = category + '%';
        return _react2.default.createElement(_AcademicOverviewBadge2.default, { type: _type2.default.WARNING,
          text: categoryText,
          number: num });
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)(_style2.default.OverviewBadge, this.props.className);
      if (_is_js2.default.falsy(this.props.studentNumberWithLowerPTScore) && _is_js2.default.falsy(this.props.studentNumberWithLowerSkillScore)) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: className },
        this._renderAcademicOverviewBadge('PT', this.props.studentNumberWithLowerPTScore),
        this._renderAcademicOverviewBadge('SKILL', this.props.studentNumberWithLowerSkillScore)
      );
    }
  }]);

  return OverviewBadge;
}(_react.PureComponent);

OverviewBadge.propTypes = {
  studentNumberWithLowerPTScore: _propTypes2.default.number,
  studentNumberWithLowerSkillScore: _propTypes2.default.number,
  className: _propTypes2.default.string
};

exports.default = OverviewBadge;

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2110);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2WDj_4eCdkGUAOTdZMWwla{border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"OverviewBadge": "_2WDj_4eCdkGUAOTdZMWwla"
};

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2112);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _type = __webpack_require__(857);

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AcademicOverviewBadge = function (_PureComponent) {
  _inherits(AcademicOverviewBadge, _PureComponent);

  function AcademicOverviewBadge() {
    _classCallCheck(this, AcademicOverviewBadge);

    return _possibleConstructorReturn(this, (AcademicOverviewBadge.__proto__ || Object.getPrototypeOf(AcademicOverviewBadge)).apply(this, arguments));
  }

  _createClass(AcademicOverviewBadge, [{
    key: '_getClassName',
    value: function _getClassName(className) {
      switch (this.props.type) {
        case _type2.default.WARNING:
          return (0, _classnames2.default)(className, _style2.default.__warning);
        case _type2.default.INFO:
          return (0, _classnames2.default)(className, _style2.default.__info);
        default:
          return className;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this._getClassName(_style2.default.AcademicOverviewBadge) },
        _react2.default.createElement(
          'div',
          { className: this._getClassName(_style2.default.AcademicOverviewBadge_info) },
          _react2.default.createElement(
            'span',
            null,
            this.props.text
          ),
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'arrow-down', className: _style2.default.AcademicOverviewBadge_icon })
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.AcademicOverviewBadge_profile },
          _react2.default.createElement(
            'span',
            null,
            this.props.number
          ),
          _react2.default.createElement(_omniCommonUi.Icon, { id: 'toggle-session', className: _style2.default.AcademicOverviewBadge_icon })
        )
      );
    }
  }]);

  return AcademicOverviewBadge;
}(_react.PureComponent);

AcademicOverviewBadge.propTypes = {
  className: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(Object.values(_type2.default)),
  number: _propTypes2.default.number,
  text: _propTypes2.default.string
};

exports.default = AcademicOverviewBadge;

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2113);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".nxQKARsB3pJUXVj3W3xEx{border:.07143rem solid #174361;-webkit-border-radius:.35714rem;-moz-border-radius:.35714rem;border-radius:.35714rem;font-size:.85714rem;margin-right:.71429rem;padding:.21429rem}._3As9ckad6lw60UZ8T7zyQP,.V5AjpnjaYhOv1d2qSR2bm{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex}._3As9ckad6lw60UZ8T7zyQP{border-right:.07143rem solid #174361;padding:.5rem .35714rem .5rem .71429rem}._3As9ckad6lw60UZ8T7zyQP._3k5ZKNo5gWN-ryE_367tS5{border-color:#de4c4c}._3As9ckad6lw60UZ8T7zyQP._29vwlZR4t8V2sMlFNDG0L6{color:#174361}.V5AjpnjaYhOv1d2qSR2bm{padding:.5rem .71429rem .5rem .35714rem}.A-7c0U9WcPjvx2WoJ1LVl{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-left:.35714rem}.nxQKARsB3pJUXVj3W3xEx._3k5ZKNo5gWN-ryE_367tS5{border-color:#de4c4c;color:#de4c4c}.nxQKARsB3pJUXVj3W3xEx._29vwlZR4t8V2sMlFNDG0L6{border-color:#174361;color:#174361}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"AcademicOverviewBadge": "nxQKARsB3pJUXVj3W3xEx",
	"AcademicOverviewBadge_info": "_3As9ckad6lw60UZ8T7zyQP",
	"AcademicOverviewBadge_profile": "V5AjpnjaYhOv1d2qSR2bm",
	"__warning": "_3k5ZKNo5gWN-ryE_367tS5",
	"__info": "_29vwlZR4t8V2sMlFNDG0L6",
	"AcademicOverviewBadge_icon": "A-7c0U9WcPjvx2WoJ1LVl"
};

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(849);

var _component2 = _interopRequireDefault(_component);

var _routes = __webpack_require__(340);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return {
    path: '(' + _routes.TODAY + ')(' + _routes.ALL_GROUPS + ')',
    component: _component2.default
  };
};

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = exports.Concerns = undefined;

var _component = __webpack_require__(858);

var _component2 = _interopRequireDefault(_component);

var _routes2 = __webpack_require__(2118);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Concerns = exports.Concerns = _component2.default;
var routes = exports.routes = _routes3.default;

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2117);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._2V8rMrXVs4j-_Vu7khTB8p{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1.14286rem;font-weight:400;letter-spacing:.07143rem;line-height:1.25}._2V8rMrXVs4j-_Vu7khTB8p div{vertical-align:middle}._3EiGYGRu5F8UlEGbSxobbt{margin:0 .35714rem}._1UEXYitCixRB_WUgdCesni{font-size:1.28571rem;margin-left:1.07143rem;min-width:0;padding:0 .57143rem;vertical-align:inherit}._3-sCi-DvovjR6x1d6ZNEle{border-top:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Concerns_filters": "_2V8rMrXVs4j-_Vu7khTB8p",
	"Concerns_filters_input": "_3EiGYGRu5F8UlEGbSxobbt",
	"Concerns_filters_button": "_1UEXYitCixRB_WUgdCesni",
	"Concerns_expansionButton": "_3-sCi-DvovjR6x1d6ZNEle"
};

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(858);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'concerns',
  component: _component2.default
};

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2120);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._30nLB5BugFVSzXOoLBhdQr{padding-left:1.42857rem;padding-right:1.42857rem;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}@media only screen and (min-width:640px){._30nLB5BugFVSzXOoLBhdQr{padding-left:2.14286rem;padding-right:2.14286rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Student": "_30nLB5BugFVSzXOoLBhdQr"
};

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(860);

var _component2 = _interopRequireDefault(_component);

var _StudentInfoBar = __webpack_require__(2122);

var _StudentInfoBar2 = _interopRequireDefault(_StudentInfoBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return {
    path: 'student/:studentId',
    component: _component2.default,
    appBars: {
      preSticky: {
        'student-info': {
          component: _StudentInfoBar2.default,
          order: 1
        }
      }
    },
    breadcrumbLabels: {
      label: ' ',
      backLinkHref: '/'
    },
    tabs: {
      hidden: true
    }
  };
};

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentInfoBar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mapStateToProps = mapStateToProps;

var _style = __webpack_require__(2123);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(10);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _accessors = __webpack_require__(197);

var studentAccessors = _interopRequireWildcard(_accessors);

var _actions = __webpack_require__(198);

var studentActions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StudentInfoBar = exports.StudentInfoBar = function (_PureComponent) {
  _inherits(StudentInfoBar, _PureComponent);

  function StudentInfoBar() {
    _classCallCheck(this, StudentInfoBar);

    return _possibleConstructorReturn(this, (StudentInfoBar.__proto__ || Object.getPrototypeOf(StudentInfoBar)).apply(this, arguments));
  }

  _createClass(StudentInfoBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.fetchStudentIfNeeded(this.props.studentId);
    }
  }, {
    key: 'render',
    value: function render() {
      var student = this.props.student;

      if (!_is_js2.default.existy(student)) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: _style2.default.StudentInfoBar },
        _react2.default.createElement(
          _omniCommonUi.StudentCard,
          { borderless: true, backgroundless: true },
          _react2.default.createElement(_omniCommonUi.StudentCard.Profile, { className: _style2.default.ReportStudentCard_profile,
            withoutBottomPadding: true,
            name: student.firstName,
            surname: student.lastName,
            avatarUrl: student.avatarUrl,
            localName: student.localName,
            gender: student.gender })
        )
      );
    }
  }]);

  return StudentInfoBar;
}(_react.PureComponent);

StudentInfoBar.propTypes = {
  studentId: _propTypes2.default.string,
  student: _propTypes2.default.object,
  fetchStudentIfNeeded: _propTypes2.default.func
};

function mapStateToProps(state, ownProps) {
  var studentId = '' + ownProps.params.studentId;
  var student = studentAccessors.getStudentById(state, studentId);
  return {
    studentId: studentId,
    student: student
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(studentActions, dispatch);
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(StudentInfoBar);

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2124);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3uikvoKIzIutINPV1aEp59{padding-left:1.42857rem;padding-right:1.42857rem;background-color:#f3f5f7;border-bottom:.07143rem solid #ccc;padding-left:.35714rem}@media only screen and (min-width:640px){._3uikvoKIzIutINPV1aEp59{padding-left:2.14286rem;padding-right:2.14286rem;padding-left:1.07143rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentInfoBar": "_3uikvoKIzIutINPV1aEp59"
};

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = student;

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(194);

var _actions2 = __webpack_require__(198);

var _model = __webpack_require__(2126);

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function student() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments[1];

  var newState = state;
  var studentModel = void 0;
  switch (action.type) {
    case _actions.FETCH_GROUP_MEMBERS_SUCCESS:
      action.payload.forEach(function (member) {
        if (!member.studentGeneralInfo) return;
        studentModel = _model2.default.create(member.studentGeneralInfo);
        if (newState.has(studentModel.id)) return;
        newState = newState.set(studentModel.id, studentModel);
      });
      return newState;
    case _actions2.FETCH_STUDENT_SUCCESS:
      studentModel = _model2.default.create(action.payload);
      if (newState.has(studentModel.id)) return;
      return state.set(studentModel.id, studentModel);
    default:
      return state;
  }
}

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__(3);

var _immutable2 = _interopRequireDefault(_immutable);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var reviver = function reviver(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];

  if (!val) return [key, val];
  switch (key) {
    case 'id':
      return [key, '' + val];
    case 'gender':
      return [key, _omniCommonUi.Gender.parse(val)];
    default:
      return [key, _immutable2.default.fromJS(val)];
  }
};

var StudentRecord = (0, _immutable.Record)({
  avatarUrl: undefined,
  id: undefined,
  firstName: undefined,
  lastName: undefined,
  gender: undefined,
  studentNumber: undefined,
  localName: undefined
});

var Student = function (_StudentRecord) {
  _inherits(Student, _StudentRecord);

  function Student() {
    _classCallCheck(this, Student);

    return _possibleConstructorReturn(this, (Student.__proto__ || Object.getPrototypeOf(Student)).apply(this, arguments));
  }

  _createClass(Student, null, [{
    key: 'create',
    value: function create(data) {
      return new Student(data).mapEntries(reviver);
    }
  }]);

  return Student;
}(StudentRecord);

exports.default = Student;

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2128);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./main.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./main.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a"
};

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2130);

var _style2 = _interopRequireDefault(_style);

var _style3 = __webpack_require__(861);

var _style4 = _interopRequireDefault(_style3);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _SubNav = __webpack_require__(2133);

var _SubNav2 = _interopRequireDefault(_SubNav);

var _Tabs = __webpack_require__(2136);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TabNavBuilder = __webpack_require__(2137);

var _TabNavBuilder2 = _interopRequireDefault(_TabNavBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TABS_SCROLL_TO_ELEMENT = { // passed to iScroll's scrollToElement
  selector: '.' + _style4.default.__active,
  duration: 300,
  easing: { style: 'ease-in-out' }
};

var TabNav = function (_PureComponent) {
  _inherits(TabNav, _PureComponent);

  function TabNav(props) {
    _classCallCheck(this, TabNav);

    var _this = _possibleConstructorReturn(this, (TabNav.__proto__ || Object.getPrototypeOf(TabNav)).call(this, props));

    _this._buildTabs(props);
    return _this;
  }

  _createClass(TabNav, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      this._buildTabs(nextProps);
    }
  }, {
    key: '_getCurrentRouteSegment',
    value: function _getCurrentRouteSegment(routes) {
      return routes && routes[routes.length - 1];
    }
  }, {
    key: '_buildTabs',
    value: function _buildTabs(props) {
      var routes = props.routes,
          params = props.params;

      if (_is_js2.default.not.array(routes) || !routes.length) {
        this._tabs = null;
      }

      this._tabs = _TabNavBuilder2.default.buildNavItemsForRoutes(routes, params).map(function (item) {
        return _TabNavBuilder2.default.convertNavItemToTabItem(item, routes);
      });
    }
  }, {
    key: '_shouldRender',
    value: function _shouldRender() {
      var routes = this.props.routes;

      var currentRoute = this._getCurrentRouteSegment(routes);
      if (currentRoute && currentRoute.tabs && currentRoute.tabs.hidden === true) {
        return false;
      }

      return true;
    }
  }, {
    key: '_renderSecondLevelTabs',
    value: function _renderSecondLevelTabs() {
      var config = this.props.routes.find(function (route) {
        return _is_js2.default.function(route.secondLevelTabs);
      });
      if (!config) {
        return null;
      }
      var items = config.secondLevelTabs(this.props);

      return _is_js2.default.not.empty(items) && _react2.default.createElement(_SubNav2.default, { items: items });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this._shouldRender()) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: _style2.default.TabNav },
        _react2.default.createElement(
          'div',
          { className: _style2.default.TabNav_tabs_wrap },
          _react2.default.createElement(
            _omniCommonUi.HorizontalScroll,
            { innerClassName: _style2.default.TabNav_tabs_scroller,
              scrollToElement: TABS_SCROLL_TO_ELEMENT },
            _react2.default.createElement(_Tabs2.default, { className: _style2.default.TabNav_tabs, items: this._tabs })
          )
        ),
        this._renderSecondLevelTabs()
      );
    }
  }]);

  return TabNav;
}(_react.PureComponent);

TabNav.Tabs = _Tabs2.default;

TabNav.propTypes = {
  params: _propTypes2.default.shape({}),
  routes: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
};

exports.default = TabNav;

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2131);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3wCTZ10xyEN3-z5fY6-fQ-{background-color:#f3f5f7}._3qAvx8bnBX8O9aP5LrFFEU{display:inline-block!important}._2_0d2KpkoEQn2XcaO8AwxB{padding-left:1.42857rem;padding-right:1.42857rem;-webkit-box-shadow:0 .07143rem .21429rem #bbb;-moz-box-shadow:0 .07143rem .21429rem #bbb;box-shadow:0 .07143rem .21429rem #bbb;overflow:hidden;position:relative}@media only screen and (min-width:640px){._2_0d2KpkoEQn2XcaO8AwxB{padding-left:2.14286rem;padding-right:2.14286rem}}._2_0d2KpkoEQn2XcaO8AwxB:after,._2_0d2KpkoEQn2XcaO8AwxB:before{content:\"\";display:block;height:3.57143rem;pointer-events:none;position:absolute;top:0;width:1.42857rem;z-index:1}@media only screen and (min-width:640px){._2_0d2KpkoEQn2XcaO8AwxB:after,._2_0d2KpkoEQn2XcaO8AwxB:before{width:2.14286rem}}._2_0d2KpkoEQn2XcaO8AwxB:before{background:-webkit-gradient(linear,left top,right top,from(#f3f5f7),to(rgba(243,245,247,0)));background:-webkit-linear-gradient(left,#f3f5f7,rgba(243,245,247,0));background:-moz-linear-gradient(left,#f3f5f7,rgba(243,245,247,0));background:-o-linear-gradient(left,#f3f5f7,rgba(243,245,247,0));background:linear-gradient(90deg,#f3f5f7,rgba(243,245,247,0));left:0}._2_0d2KpkoEQn2XcaO8AwxB:after{background:-webkit-gradient(linear,right top,left top,from(#f3f5f7),to(rgba(243,245,247,0)));background:-webkit-linear-gradient(right,#f3f5f7,rgba(243,245,247,0));background:-moz-linear-gradient(right,#f3f5f7,rgba(243,245,247,0));background:-o-linear-gradient(right,#f3f5f7,rgba(243,245,247,0));background:linear-gradient(-90deg,#f3f5f7,rgba(243,245,247,0));right:0}._2HYGzAkAb32dXCCSegZlzn{cursor:default!important;max-height:3.57143rem;overflow:visible!important;text-align:center;will-change:auto!important}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"TabNav": "_3wCTZ10xyEN3-z5fY6-fQ-",
	"TabNav_tabs": "_3qAvx8bnBX8O9aP5LrFFEU",
	"TabNav_tabs_wrap": "_2_0d2KpkoEQn2XcaO8AwxB",
	"TabNav_tabs_scroller": "_2HYGzAkAb32dXCCSegZlzn"
};

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1niK_szfal6UGsoNqCZM_2{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;overflow:hidden;text-transform:uppercase;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1niK_szfal6UGsoNqCZM_2,._2LMcseBdNIy-pjFoQ9646B{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;height:3.57143rem}._2LMcseBdNIy-pjFoQ9646B{margin:0;padding:0;white-space:nowrap}._36d3MdImfkMm-T1fSHVhN8{border-bottom:.42857rem solid transparent;cursor:pointer;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-weight:600;height:3.57143rem;letter-spacing:.03571rem;list-style:none;margin:0 .71429rem;outline:0;padding:.71429rem .14286rem;padding-bottom:0;padding-top:0}.qSvffi6LC2BR6n6vSIiHQ{cursor:not-allowed}._36d3MdImfkMm-T1fSHVhN8>a,._36d3MdImfkMm-T1fSHVhN8>span{outline:0;padding-top:1.07143rem;text-decoration:none}._36d3MdImfkMm-T1fSHVhN8:first-child{margin-left:0}._36d3MdImfkMm-T1fSHVhN8:last-child{margin-right:0}._36d3MdImfkMm-T1fSHVhN8.Gf8h7JvJlVAOQEsAH4Sz3{border-bottom-color:#0087e6}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Tabs": "_1niK_szfal6UGsoNqCZM_2",
	"Tabs_mainContent": "_2LMcseBdNIy-pjFoQ9646B",
	"Tabs_mainContent_item": "_36d3MdImfkMm-T1fSHVhN8",
	"Tabs_mainContent_item_disabled": "qSvffi6LC2BR6n6vSIiHQ",
	"__active": "Gf8h7JvJlVAOQEsAH4Sz3"
};

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2134);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _classnames3 = __webpack_require__(7);

var _classnames4 = _interopRequireDefault(_classnames3);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SubNav = function SubNav(props) {
  if (!props.items) return null;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames4.default)(_style2.default.SubNav, props.className) },
    _react2.default.createElement(
      'ul',
      { className: _style2.default.SubNav_mainContent },
      props.items.map(function (item) {
        var linkTitle = item.text && item.text.replace(/\s+|'|&/g, '');
        var className = (0, _classnames4.default)(_style2.default.SubNav_mainContent_item, (0, _omniCommonUi.testClass)(linkTitle + '-link'), _defineProperty({}, _style2.default.__active, item.isActive));
        var pureTextClassName = (0, _classnames4.default)(_defineProperty({}, _style2.default.SubNav_mainContent_item_disabled, item.isDisabled));
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        return _react2.default.createElement(
          'li',
          { key: item.text,
            className: className,
            onClick: function onClick() {
              return item.onClick && item.onClick();
            } },
          item.href ? _react2.default.createElement(
            _reactRouter.Link,
            { to: item.href,
              draggable: false },
            item.text
          ) : _react2.default.createElement(
            'span',
            { className: pureTextClassName },
            item.text
          )
        );
      })
    )
  );
};

SubNav.propTypes = {
  className: _propTypes2.default.string,
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    isActive: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool
  }))
};

exports.default = SubNav;

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2135);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._3LMXd1urv7iV7XYqxKS86I{border-bottom:.07143rem solid #ccc;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;overflow:hidden;text-transform:uppercase;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1hC3KqEyqDCyCjNkSYvusE,._3LMXd1urv7iV7XYqxKS86I{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}._1hC3KqEyqDCyCjNkSYvusE{margin:0;padding:.5rem 2.14286rem;white-space:nowrap;width:100%}._2WEboNvH57KYgavor5517e{cursor:pointer;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:.85714rem;font-weight:600;height:1.28571rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;letter-spacing:.06429rem;list-style:none;width:100%}.LlYDG6S6qzL0I3IQ81AUa{cursor:not-allowed}._2WEboNvH57KYgavor5517e>a,._2WEboNvH57KYgavor5517e>span{-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;text-decoration:none}._2WEboNvH57KYgavor5517e:first-child{margin-left:0}._2WEboNvH57KYgavor5517e:last-child{margin-right:0}._2WEboNvH57KYgavor5517e._1FLGNkvWzy-e-2KGIBVqtF{color:#0087e6}._2WEboNvH57KYgavor5517e+._2WEboNvH57KYgavor5517e{border-left:.07143rem solid #ccc}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SubNav": "_3LMXd1urv7iV7XYqxKS86I",
	"SubNav_mainContent": "_1hC3KqEyqDCyCjNkSYvusE",
	"SubNav_mainContent_item": "_2WEboNvH57KYgavor5517e",
	"SubNav_mainContent_item_disabled": "LlYDG6S6qzL0I3IQ81AUa",
	"__active": "_1FLGNkvWzy-e-2KGIBVqtF"
};

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = undefined;

var _style = __webpack_require__(861);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _classnames3 = __webpack_require__(7);

var _classnames4 = _interopRequireDefault(_classnames3);

var _omniCommonUi = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TAB_ITEM_ONCLICK_KEY = Symbol('Tabs#onClick');
var DRAG_DELTA_PX = 20;

var startMouseX = 0;

var wasLeftMouseButtonPressed = function wasLeftMouseButtonPressed() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.event;

  var button = e.which || e.button;
  return button === 1;
};

var onMouseDown = function onMouseDown() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!wasLeftMouseButtonPressed(e.nativeEvent)) return;
  startMouseX = e.screenX;
};

var onClick = function onClick(item) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var movement = Math.abs(startMouseX - e.screenX);
  if (startMouseX && movement > DRAG_DELTA_PX) {
    // x-axis drag happened; block click
    e.preventDefault();
    return false;
  }
  item.onClick && item.onClick(e);
};

var Tab = exports.Tab = function Tab(props) {
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames4.default)(_style2.default.Tabs, props.className) },
    _react2.default.createElement(
      'ul',
      { className: _style2.default.Tabs_mainContent },
      props.items.map(function (item) {
        var linkTitle = item.text && item.text.replace(/\s+|'|&/g, '');
        var className = (0, _classnames4.default)(_style2.default.Tabs_mainContent_item, (0, _omniCommonUi.testClass)(linkTitle + '-link'), _defineProperty({}, _style2.default.__active, item.isActive));
        var pureTextClassName = (0, _classnames4.default)(_defineProperty({}, _style2.default.Tabs_mainContent_item_disabled, item.isDisabled));
        if (!item[TAB_ITEM_ONCLICK_KEY]) {
          item[TAB_ITEM_ONCLICK_KEY] = onClick.bind(null, item); // eslint-disable-line
        }
        return _react2.default.createElement(
          'li',
          { key: item.text,
            className: className },
          item.href ? _react2.default.createElement(
            _reactRouter.Link,
            { to: item.href,
              draggable: false,
              onMouseDown: onMouseDown,
              onClick: item[TAB_ITEM_ONCLICK_KEY] },
            item.text
          ) : _react2.default.createElement(
            'span',
            { className: pureTextClassName,
              onClick: item[TAB_ITEM_ONCLICK_KEY] },
            item.text
          )
        );
      })
    )
  );
};

Tab.propTypes = {
  className: _propTypes2.default.string,
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    isActive: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool
  }))
};

exports.default = (0, _recompose.pure)(Tab);

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabNavBuilder = exports.NAV_TAB_DESCRIPTOR_SYMB = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _is_js = __webpack_require__(6);

var _is_js2 = _interopRequireDefault(_is_js);

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _immutable = __webpack_require__(3);

var _reactRouter = __webpack_require__(16);

var _omniCommonUi = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ALWAYS_APPLIED_PARAMS = { mode: '' };
var NAV_TAB_DESCRIPTOR_SYMB = exports.NAV_TAB_DESCRIPTOR_SYMB = Symbol('TabNavBuilder#NAV_TAB_DESCRIPTOR');

var TabNavBuilder = exports.TabNavBuilder = {
  convertNavItemToTabItem: function convertNavItemToTabItem(navItem, routes) {
    return _extends({}, navItem, {
      text: navItem.label,
      isActive: function () {
        var deepestRouteWithGroupNavTab = routes.concat().reverse().find(function (route) {
          return _is_js2.default.object(route.tab);
        });
        return _is_js2.default.object(deepestRouteWithGroupNavTab) && deepestRouteWithGroupNavTab.tab === navItem[NAV_TAB_DESCRIPTOR_SYMB];
      }()
    });
  },
  buildTabItemsForRoutes: function buildTabItemsForRoutes(routes, baseParams) {
    return TabNavBuilder.buildNavItemsForRoutes(routes, baseParams).map(function (descriptor) {
      return TabNavBuilder.convertNavItemToTabItem(descriptor, routes);
    });
  },
  buildNavItemsForRoutes: function buildNavItemsForRoutes(routes) {
    var baseParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    (0, _invariant2.default)(_is_js2.default.array(routes), 'routes must be an array');
    (0, _invariant2.default)(_is_js2.default.object(baseParams), 'baseParams must be an object');

    var buildRouteHref = function buildRouteHref(routeSegments) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var paths = routeSegments.filter(function (route) {
        return _is_js2.default.string(route.path);
      }).map(function (route) {
        return route.path;
      });

      // ensure that paths start with a '/'
      var path = paths.join('/');
      if (path.charAt(0) !== '/') {
        path = '/' + path;
      }

      try {
        return (0, _reactRouter.formatPattern)(path, _extends({}, ALWAYS_APPLIED_PARAMS, params)).replace(/(.+)\/$/, '$1');
      } catch (e) {
        _omniCommonUi.log.warn('Unable to format path pattern for GroupNav item. Returning null link href.', e);
        return null;
      }
    };

    var findGroupNavTabDescriptors = function findGroupNavTabDescriptors(currentRoute) {
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var descriptors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      var currentPath = path.concat([currentRoute]);

      if (_is_js2.default.object(currentRoute) && _is_js2.default.object(currentRoute.tab)) {
        var tab = currentRoute.tab;

        // tab sanity checks

        (0, _invariant2.default)(_is_js2.default.undefined(tab.params) || _is_js2.default.function(tab.params), 'tab.params must be undefined or a function');

        var tabLabel = '';
        if (_is_js2.default.string(tab.label)) {
          tabLabel = tab.label;
        } else if (_is_js2.default.function(tab.label)) {
          tabLabel = tab.label(baseParams);
        }
        var isItemVisible = _is_js2.default.not.function(tab.isVisible) || tab.isVisible(baseParams);

        if (isItemVisible || opts.disableInsteadOfHide) {
          var _descriptors$push;

          var paramsFn = tab.params || function (params) {
            return params;
          };
          var queryFn = tab.query || function () {
            return null;
          };
          var nowParams = _extends({}, baseParams);
          var href = buildRouteHref(currentPath, paramsFn(nowParams));
          var query = queryFn(nowParams);

          descriptors.push((_descriptors$push = {}, _defineProperty(_descriptors$push, NAV_TAB_DESCRIPTOR_SYMB, tab), _defineProperty(_descriptors$push, 'label', tabLabel), _defineProperty(_descriptors$push, 'order', tab.order), _defineProperty(_descriptors$push, 'href', _is_js2.default.null(href) ? null : href + (_is_js2.default.string(query) ? '?' + query : '')), _defineProperty(_descriptors$push, 'isDisabled', _is_js2.default.null(href) || !!opts.disableInsteadOfHide && !isItemVisible), _descriptors$push));
        }
      }

      if (_is_js2.default.object(currentRoute) && _is_js2.default.array(currentRoute.childRoutes)) {
        currentRoute.childRoutes.forEach(function (route) {
          return findGroupNavTabDescriptors(route, currentPath, descriptors);
        });
      }

      return new _immutable.List(descriptors).sortBy(function (d) {
        return d.order;
      }).toArray();
    };

    var firstTabConfigIndex = routes.findIndex(function (routeItem) {
      return _is_js2.default.object(routeItem.tab);
    });
    return findGroupNavTabDescriptors(routes[firstTabConfigIndex], routes.slice(0, firstTabConfigIndex));
  }
};

exports.default = TabNavBuilder;

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Group = __webpack_require__(13);

var _GroupMembers = __webpack_require__(14);

var _ProgressTests = __webpack_require__(40);

var _ProgressReports = __webpack_require__(94);

var _StudentReportSummaries = __webpack_require__(42);

var _ApproveByDos = __webpack_require__(301);

var _SessionPlans = __webpack_require__(44);

var _GroupPerformance = __webpack_require__(607);

var _SessionsAttendance = __webpack_require__(161);

var _CourseProgress = __webpack_require__(604);

var _CoveredInClass = __webpack_require__(95);

var _Template = __webpack_require__(166);

var _CategoryTemplate = __webpack_require__(306);

var _InternalNotes = __webpack_require__(307);

var _ScoreBand = __webpack_require__(165);

var _Language = __webpack_require__(2139);

var _OnlineHomework = __webpack_require__(208);

var _StudentTasks = __webpack_require__(310);

var _TotalPoint = __webpack_require__(715);

var _OnlineUsage = __webpack_require__(727);

var _ApiError = __webpack_require__(596);

var _Units = __webpack_require__(281);

var _Mentor = __webpack_require__(711);

var _ProgressTestsPlan = __webpack_require__(64);

var _ProgressTestOverview = __webpack_require__(832);

var _Users = __webpack_require__(82);

var _Centre = __webpack_require__(282);

var _Content = __webpack_require__(742);

var _ViewLink = __webpack_require__(643);

var _UiState = __webpack_require__(30);

var _Tasks = __webpack_require__(339);

var _Homework = __webpack_require__(137);

var _Personalised = __webpack_require__(136);

var _HFUsage = __webpack_require__(718);

var _AttendanceHistory = __webpack_require__(616);

var _PaperBasedHomework = __webpack_require__(135);

var _Content2 = __webpack_require__(752);

var _Template2 = __webpack_require__(750);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _StudyPlan = __webpack_require__(328);

var _OverallDevelopment = __webpack_require__(329);

var _AcademicInfo = __webpack_require__(341);

var _Summary = __webpack_require__(855);

var _Student = __webpack_require__(859);

var _SkillRecommendation = __webpack_require__(325);

var _Notifications = __webpack_require__(862);

var _Note = __webpack_require__(131);

var _Types = __webpack_require__(212);

var _PracticePlay = __webpack_require__(723);

var _UnlockHomework = __webpack_require__(755);

var _WritingAssignment = __webpack_require__(86);

var _GrammaPro = __webpack_require__(806);

var _Feedback = __webpack_require__(217);

var _UnitQuiz = __webpack_require__(701);

var _Reader = __webpack_require__(731);

var _Vocabulary = __webpack_require__(735);

var _RAv2Cic = __webpack_require__(309);

var _RAv2HomeworkResultSummary = __webpack_require__(613);

var _RAv2HomeworkResultDetail = __webpack_require__(694);

var _HF4Homework = __webpack_require__(686);

var _GroupLessonAwards = __webpack_require__(690);

var _KetExams = __webpack_require__(171);

var _UnitResources = __webpack_require__(699);

exports.default = {
  groups: _Group.reducer,
  groupMembers: _GroupMembers.reducer,
  groupPerformance: _GroupPerformance.reducer,
  sessionPlans: _SessionPlans.reducer,
  sessionsAttendance: _SessionsAttendance.reducer,
  progressTests: _ProgressTests.reducer,
  progressReports: _ProgressReports.reducer,
  ketExams: _KetExams.reducer,
  studentReportSummaries: _StudentReportSummaries.reducer,
  courseProgress: _CourseProgress.reducer,
  coveredInClassContent: _CoveredInClass.reducer,
  internalNotes: _InternalNotes.reducer,
  approveByDos: _ApproveByDos.reducer,
  scoreBand: _ScoreBand.reducer,
  language: _Language.reducer,
  onlineHomework: _OnlineHomework.reducer,
  studentTasks: _StudentTasks.reducer,
  apiError: _ApiError.reducer,
  unit: _Units.reducer,
  mentor: _Mentor.reducer,
  progressTestsPlan: _ProgressTestsPlan.reducer,
  progressTestOverview: _ProgressTestOverview.reducer,
  user: _Users.reducer,
  centres: _Centre.reducer,
  onlineHomeworkContent: _Content.reducer,
  progressTestViewLink: _ViewLink.reducer,
  uiState: _UiState.reducer,
  taskFitlerResult: _Tasks.reducer,
  dosTaskFilterResult: _Tasks.dosTaskFilterResult,
  taskOwnersResult: _Tasks.taskOwnersResult,
  taskCentres: _Tasks.taskCentres,
  taskTypes: _Tasks.taskTypes,
  homework: _Homework.reducer,
  personalisedHomework: _Personalised.reducer,
  taskStatisticResult: _Tasks.taskStatisticResult,
  attendanceHistory: _AttendanceHistory.reducer,
  paperBasedHomework: _PaperBasedHomework.reducer,
  homeworkContent: _Content2.reducer,
  individualDevelopmentPlanList: _IndividualDevelopmentPlans.individualDevelopmentPlanList,
  individualDevelopmentPlan: _IndividualDevelopmentPlans.individualDevelopmentPlan,
  idpApprovalList: _IndividualDevelopmentPlans.idpApprovalList,
  idpParticipation: _IndividualDevelopmentPlans.idpParticipation,
  studyPlan: _StudyPlan.reducer,
  overallDevelopment: _OverallDevelopment.reducer,
  academicInfoGroups: _AcademicInfo.reducer,
  academicInfoConcernsStudentSkills: _AcademicInfo.academicInfoConcernsStudentSkills,
  academicInfoSummary: _Summary.reducer,
  student: _Student.reducer,
  notifications: _Notifications.reducer,
  studentNotes: _Note.reducer,
  homeworkTypes: _Types.reducer,
  practicePlay: _PracticePlay.reducer,
  onlineUsage: _OnlineUsage.reducer,
  skillRecommendation: _SkillRecommendation.reducer,
  coveredInClassTemplate: _Template.reducer,
  homeworkTemplate: _Template2.reducer,
  unlockHomework: _UnlockHomework.reducer,
  spinWritingAssignment: _WritingAssignment.spinReducer,
  coreWritingAssignment: _WritingAssignment.coreReducer,
  studentTotalPoints: _TotalPoint.reducer,
  essay: _WritingAssignment.essayReducer,
  shortAnswer: _WritingAssignment.shortAnswerReducer,
  grammaPro: _GrammaPro.reducer,
  feedback: _Feedback.reducer,
  unitQuizResult: _UnitQuiz.reducer,
  onlineHomeworkHFUsage: _HFUsage.reducer,
  cicCategoryTemplate: _CategoryTemplate.reducer,
  reader: _Reader.reducer,
  vocabulary: _Vocabulary.reducer,
  rav2Cic: _RAv2Cic.reducer,
  rav2HomeworkResultSummary: _RAv2HomeworkResultSummary.reducer,
  rav2HomeworkResultDetail: _RAv2HomeworkResultDetail.reducer,
  hf4Homework: _HF4Homework.reducer,
  groupLessonAwards: _GroupLessonAwards.reducer,
  unitResources: _UnitResources.reducer
};

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _reducer2 = __webpack_require__(2140);

var _reducer3 = _interopRequireDefault(_reducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reducer = exports.reducer = _reducer3.default; /* eslint import/prefer-default-export: "off" */

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = language;
function language() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en-US';
  return state;
}

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = notifications;

var _invariant = __webpack_require__(23);

var _invariant2 = _interopRequireDefault(_invariant);

var _immutable = __webpack_require__(3);

var _actions = __webpack_require__(863);

var _create = __webpack_require__(2142);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function notifications() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.OrderedMap({});
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload,
      notificationIds = action.notificationIds;

  switch (type) {
    case _actions.SUBMIT_MARK_NOTIFICATIONS_READ_SUCCESS:
      return onMarkAsReadSuccess(notificationIds, state);
    case _actions.FETCH_NOTIFICATIONS_SUCCESS:
      return onFetchNotificationsSuccess(payload);
    default:
      return state;
  }
}

function onFetchNotificationsSuccess(payload) {
  (0, _invariant2.default)(Array.isArray(payload), 'payload must be an array');
  var newState = new _immutable.OrderedMap({}); // flush out the data once get new notification
  payload.forEach(function (item) {
    var notification = (0, _create2.default)(item);
    newState = newState.set('' + item.id, notification);
  });
  return newState.sortBy(function (n) {
    return n.moment.valueOf();
  }).reverse();
}

function onMarkAsReadSuccess(notificationIds, state) {
  var newState = state;
  notificationIds.forEach(function (id) {
    newState = newState.delete(id);
  });
  return newState;
}

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _omniCommonUi = __webpack_require__(0);

var _NotificationCalloutSlide = __webpack_require__(2143);

var _NotificationCalloutSlide2 = _interopRequireDefault(_NotificationCalloutSlide);

var _accessors = __webpack_require__(864);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reviveCommonNotification = function reviveCommonNotification(_ref) {
  var noteId = _ref.noteId,
      studentName = _ref.studentName,
      category = _ref.category,
      notedDateTimeUtc = _ref.notedDateTimeUtc,
      dosName = _ref.dosName;

  var blurb = studentName + ' has a new ' + category + ' note';
  if ((0, _accessors.isUnitReport)(category)) {
    blurb = 'Note from ' + dosName + ': Problem with Unit Report (depending what is rejected)';
  } else if ((0, _accessors.isProgressReport)(category)) {
    blurb = 'Note from ' + dosName + ': Problem with Progress Report (depending what is rejected)';
  }

  return {
    blurb: blurb,
    moment: _omniCommonUi.moment.utc(notedDateTimeUtc),
    getNotificationViewNode: function getNotificationViewNode(tray) {
      return _react2.default.createElement(_NotificationCalloutSlide2.default, { noteId: '' + noteId,
        category: category,
        notificationsTray: tray });
    }
  };
};

var create = function create(data) {
  return _omniCommonUi.Notification.create(reviveCommonNotification(data));
};

exports.default = create;

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2144);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(16);

var _redux = __webpack_require__(10);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _omniCommonUi = __webpack_require__(0);

var _actions = __webpack_require__(199);

var studentNoteActions = _interopRequireWildcard(_actions);

var _UserCard = __webpack_require__(65);

var _UserCard2 = _interopRequireDefault(_UserCard);

var _StudentCardProfile = __webpack_require__(84);

var _StudentCardProfile2 = _interopRequireDefault(_StudentCardProfile);

var _Notifications = __webpack_require__(862);

var _IndividualDevelopmentPlans = __webpack_require__(28);

var _StudentReportSummaries = __webpack_require__(42);

var _CourseType = __webpack_require__(193);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotificationCalloutSlide = function (_Component) {
  _inherits(NotificationCalloutSlide, _Component);

  function NotificationCalloutSlide() {
    _classCallCheck(this, NotificationCalloutSlide);

    var _this = _possibleConstructorReturn(this, (NotificationCalloutSlide.__proto__ || Object.getPrototypeOf(NotificationCalloutSlide)).call(this));

    _this._onLinkClicked = _this._onLinkClicked.bind(_this);
    return _this;
  }

  _createClass(NotificationCalloutSlide, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._loadIfNeeded(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this._loadIfNeeded(props);
      if (props.notification !== this.props.notification && props.notification) {
        var isUnitReport = props.isUnitReport,
            isProgressReport = props.isProgressReport,
            idpId = props.idpId;
        var _props$notification = props.notification,
            entityId = _props$notification.entityId,
            studentId = _props$notification.studentId;

        if (isUnitReport && entityId && studentId) {
          this.props.fetchStudentReportSummary('' + entityId, studentId);
        } else if (isProgressReport && idpId) {
          this.props.fetchIdpLearningResult(idpId);
        }
      }
    }
  }, {
    key: '_loadIfNeeded',
    value: function _loadIfNeeded(_ref) {
      var noteId = _ref.noteId;

      this.props.fetchSingleStudentNoteIfNeeded(noteId);
    }
  }, {
    key: '_onLinkClicked',
    value: function _onLinkClicked() {
      if (!this.props.notificationsTray) return;
      this.props.notificationsTray.close();
    }
  }, {
    key: '_buildURL',
    value: function _buildURL() {
      var _props = this.props,
          buildRoute = _props.buildRoute,
          _props$notification2 = _props.notification,
          notification = _props$notification2 === undefined ? {} : _props$notification2,
          isUnitReport = _props.isUnitReport,
          isProgressReport = _props.isProgressReport;
      var fullCourseTypeLevelCode = notification.fullCourseTypeLevelCode;

      if (isUnitReport) {
        var unitReportPath = (0, _CourseType.getUnitReportBasePath)({ fullCourseTypeLevelCode: fullCourseTypeLevelCode });
        return buildRoute('/group/' + notification.groupId + '/' + unitReportPath + '/' + notification.entityId + '/student/' + notification.studentId);
      } else if (isProgressReport) {
        var progressReportPath = (0, _CourseType.getProgressReportBasePath)({ fullCourseTypeLevelCode: fullCourseTypeLevelCode });
        return buildRoute('/group/' + notification.groupId + '/' + progressReportPath + '/' + notification.entityId + '/student/' + notification.studentId);
      }
      return buildRoute('/student/' + notification.studentId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          notification = _props2.notification,
          isLoading = _props2.isLoading,
          isFailed = _props2.isFailed;


      if (isFailed) {
        return _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_style2.default.NotificationCalloutSlide, _style2.default.__error) },
          _react2.default.createElement(
            'h1',
            null,
            _react2.default.createElement(_omniCommonUi.Icon, { id: 'cross-circle' })
          ),
          _react2.default.createElement(
            'p',
            null,
            'Omni could not load this content.'
          )
        );
      }
      var isStudent = notification && !_Notifications.accessors.isUnitReport(notification.category) && !_Notifications.accessors.isProgressReport(notification.category);

      return _react2.default.createElement(
        'div',
        { className: _style2.default.NotificationCalloutSlide },
        _react2.default.createElement(_omniCommonUi.PageLoadingSpinner, { isAbsolutePositioned: true, isHidden: !isLoading }),
        notification ? _react2.default.createElement(
          'div',
          null,
          isStudent ? _react2.default.createElement(_StudentCardProfile2.default, { useLowerLevelPersonComponent: true,
            className: _style2.default.NotificationCalloutSlide_studentProfile,
            studentId: notification.studentId,
            name: notification.studentName }) : _react2.default.createElement(_UserCard2.default, { id: notification.notedByUserId }),
          _react2.default.createElement(
            'p',
            { className: (0, _omniCommonUi.testClass)('notification-content') },
            notification.content
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { className: _style2.default.NotificationCalloutSlide_openLink,
                to: function to() {
                  return _this2._buildURL();
                },
                onClick: this._onLinkClicked },
              'Open'
            ),
            _react2.default.createElement(
              'span',
              { className: _style2.default.NotificationCalloutSlide_timestamp },
              '\xA0\u2022 ',
              _omniCommonUi.moment.utc(notification.notedDateTimeUtc).fromNow()
            )
          )
        ) : null
      );
    }
  }]);

  return NotificationCalloutSlide;
}(_react.Component);

NotificationCalloutSlide.propTypes = {
  noteId: _propTypes2.default.string,
  category: _propTypes2.default.string,
  notificationsTray: _propTypes2.default.shape({
    close: _propTypes2.default.func.isRequired
  }),
  notification: _propTypes2.default.object,
  fetchSingleStudentNoteIfNeeded: _propTypes2.default.func,
  buildRoute: _propTypes2.default.func,
  fetchIdpLearningResult: _propTypes2.default.func,
  fetchStudentReportSummary: _propTypes2.default.func,
  isUnitReport: _propTypes2.default.bool,
  isProgressReport: _propTypes2.default.bool,
  idpId: _propTypes2.default.string,
  isLoading: _propTypes2.default.bool,
  isFailed: _propTypes2.default.bool
};

function mapStateToProps(state, _ref2) {
  var noteId = _ref2.noteId;

  var callState = studentNoteActions.getApiCallState(state, noteId);
  var notification = state.get('rootReducer').get('studentNotes').get('' + noteId);

  var _ref3 = notification || {},
      category = _ref3.category,
      entityId = _ref3.entityId,
      studentId = _ref3.studentId;

  var isProgressReport = category && _Notifications.accessors.isProgressReport(category);
  var isUnitReport = category && _Notifications.accessors.isUnitReport(category);
  var idpId = void 0;
  if (isProgressReport) {
    idpId = _IndividualDevelopmentPlans.accessors.getIdpId(state, '' + entityId, studentId);
  }
  return {
    idpId: idpId,
    notification: notification,
    isProgressReport: isProgressReport,
    isUnitReport: isUnitReport,
    isLoading: _omniCommonUi.ApiCall.State.isValue(callState) && _omniCommonUi.ApiCall.State.isLoading(callState),
    isFailed: _omniCommonUi.ApiCall.State.isValue(callState) && _omniCommonUi.ApiCall.State.hasFailed(callState)
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({}, (0, _redux.bindActionCreators)(studentNoteActions, dispatch), (0, _redux.bindActionCreators)(_IndividualDevelopmentPlans.actions, dispatch), (0, _redux.bindActionCreators)(_StudentReportSummaries.actions, dispatch));
}

exports.default = (0, _omniCommonUi.connect)(mapStateToProps, mapDispatchToProps)(NotificationCalloutSlide);

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2145);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "._1dQuWULbj7cpE4ASoRKHvJ{height:100%;overflow-y:auto;padding:1.42857rem}._2k7X2omx_xLiIw4PPzpMfq{padding:0}._3tEwYnPx4cTB84SMrTEbmx{color:#0087e6;font-weight:600;text-decoration:none}._3JGJ1K9ORHOTIGToGY0JIc{color:#a4a4a4;display:inline}._1dQuWULbj7cpE4ASoRKHvJ._1NIlCBC33BUyP1ekNLpR6A{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;cursor:default;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font-size:100%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"NotificationCalloutSlide": "_1dQuWULbj7cpE4ASoRKHvJ",
	"NotificationCalloutSlide_studentProfile": "_2k7X2omx_xLiIw4PPzpMfq",
	"NotificationCalloutSlide_openLink": "_3tEwYnPx4cTB84SMrTEbmx",
	"NotificationCalloutSlide_timestamp": "_3JGJ1K9ORHOTIGToGY0JIc",
	"__error": "_1NIlCBC33BUyP1ekNLpR6A"
};

/***/ })
],[893]);


// WEBPACK FOOTER //
// app.4e521c51aa6526c37780.js